/*
 * Copyright (c) 2017 by Julian Feder, julian.feder@yahoo.de
 *
 * This product includes software developed at
 * The Apache Software Foundation (http://www.apache.org/).
 */

(function() {
    'use strict';

    angular
        .module('askApp', [
            'ngStorage',
            'tmh.dynamicLocale',
            'pascalprecht.translate',
            'ngResource',
            'ngCookies',
            'ngAria',
            'ngCacheBuster',
            'ngFileUpload',
            'ui.bootstrap',
            'ui.bootstrap.datetimepicker',
            'ui.router',
            'infinite-scroll',
            'ds.objectDiff',
            'summernote',
            'uiSwitch',
            'bootstrapLightbox',
            'ngNumberPicker',
            'vcRecaptcha',
            'angulartics',
            'mm.iban',
            'angulartics.google.analytics',
            'mwl.calendar',
            'ngAnimate',
            'datepickerMultiSelect',
            'angular-loading-bar',
            'dndLists'
            // jhipster-needle-angularjs-add-module JHipster will add new module here
        ])
        .run(run);

    run.$inject = ['stateHandler', 'translationHandler'];

    function run(stateHandler, translationHandler) {
        stateHandler.initialize();
        translationHandler.initialize();
    }
})();

/*
 * Copyright (c) 2017 by Julian Feder, julian.feder@yahoo.de
 *
 * This product includes software developed at
 * The Apache Software Foundation (http://www.apache.org/).
 */

(function () {
    'use strict';

    angular
        .module('askApp')
        .factory('User', User);

    User.$inject = ['$resource'];

    function User ($resource) {
        var service = $resource('api/users/:login', {}, {
            'query': {method: 'GET', isArray: true},
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    data = angular.fromJson(data);
                    return data;
                }
            },
            'save': { method:'POST' },
            'update': { method:'PUT' },
            'delete':{ method:'DELETE'}
        });

        return service;
    }
})();

/*
 * Copyright (c) 2017 by Julian Feder, julian.feder@yahoo.de
 *
 * This product includes software developed at
 * The Apache Software Foundation (http://www.apache.org/).
 */

(function() {
    'use strict';

    angular
        .module('askApp')
        .factory('ProfileService', ProfileService);

    ProfileService.$inject = ['$http'];

    function ProfileService($http) {

        var dataPromise;

        var service = {
            getProfileInfo : getProfileInfo
        };

        return service;

        function getProfileInfo() {
            if (angular.isUndefined(dataPromise)) {
                dataPromise = $http.get('api/profile-info').then(function(result) {
                    if (result.data.activeProfiles) {
                        var response = {};
                        response.activeProfiles = result.data.activeProfiles;
                        response.ribbonEnv = result.data.ribbonEnv;
                        response.activityPointValue = result.data.activityPointValue;
                        response.anualMembershipFee = result.data.anualMembershipFee;
                        response.welcomeMembershipFeeStudent = result.data.welcomeMembershipFeeStudent;
                        response.welcomeMembershipFeeStudentNormal = result.data.welcomeMembershipFeeStudentNormal;
                        response.inProduction = result.data.activeProfiles.indexOf("prod") !== -1;
                        response.swaggerEnabled = result.data.activeProfiles.indexOf("swagger") !== -1;
                        return response;
                    }
                });
            }
            return dataPromise;
        }
    }
})();

/*
 * Copyright (c) 2017 by Julian Feder, julian.feder@yahoo.de
 *
 * This product includes software developed at
 * The Apache Software Foundation (http://www.apache.org/).
 */

(function() {
    'use strict';

    angular
        .module('askApp')
        .directive('pageRibbon', pageRibbon);

    pageRibbon.$inject = ['ProfileService', '$rootScope', '$translate'];

    function pageRibbon(ProfileService, $rootScope, $translate) {
        var directive = {
            replace : true,
            restrict : 'AE',
            template : '<div class="ribbon hidden"><a href="" data-translate="global.ribbon.{{ribbonEnv}}">{{ribbonEnv}}</a></div>',
            link : linkFunc
        };

        return directive;

        function linkFunc(scope, element, attrs) {
            ProfileService.getProfileInfo().then(function(response) {
                if (false && response.ribbonEnv) {
                    scope.ribbonEnv = response.ribbonEnv;
                    element.addClass(response.ribbonEnv);
                    element.removeClass('hidden');
                }
            });
        }
    }
})();

/*
 * Copyright (c) 2017 by Julian Feder, julian.feder@yahoo.de
 *
 * This product includes software developed at
 * The Apache Software Foundation (http://www.apache.org/).
 */

(function() {
    'use strict';

    angular
        .module('askApp')
        .factory('AccountProfileService', AccountProfileService);

    AccountProfileService.$inject = ['$resource', 'DateUtils'];

    function AccountProfileService ($resource, DateUtils) {
        var service = $resource('api/member/profile', {}, {
            'get': { method: 'GET', params: {}, isArray: false,
                interceptor: {
                    response: function(response) {
                        // expose response
                        response.data.isafDate = DateUtils.convertLocalDateFromServer(response.data.isafDate);
                        response.data.idExpirationDate = DateUtils.convertLocalDateFromServer(response.data.idExpirationDate);
                        return response;
                    }
                }
            }
        });

        return service;
    }
})();

/*
 * Copyright (c) 2017 by Julian Feder, julian.feder@yahoo.de
 *
 * This product includes software developed at
 * The Apache Software Foundation (http://www.apache.org/).
 */

(function() {
    'use strict';

    angular
        .module('askApp')
        .factory('PrincipalProfile', PrincipalProfile);

    PrincipalProfile.$inject = ['$q', 'JhiTrackerService', 'AccountProfileService'];

    function PrincipalProfile ($q, JhiTrackerService, AccountProfileService) {
        var _identity;

        var service = {
            identity: identity
        };

        return service;

        function identity (force) {
            var deferred = $q.defer();

            if (force === true) {
                _identity = undefined;
            }

            // check and see if we have retrieved the identity data from the server.
            // if we have, reuse it by immediately resolving
            if (angular.isDefined(_identity)) {
                deferred.resolve(_identity);

                return deferred.promise;
            }

            // retrieve the identity data from the server, update the identity object, and then resolve.
            AccountProfileService.get().$promise
                .then(getAccountThen)
                .catch(getAccountCatch);

            return deferred.promise;

            function getAccountThen (account) {
                _identity = account.data;
                deferred.resolve(_identity);
                //todo tracker
                //JhiTrackerService.connect();
            }

            function getAccountCatch () {
                _identity = null;
                deferred.resolve(_identity);
            }
        }
    }
})();

/*
 * Copyright (c) 2020 by Felix Heim, felix-heim@web.de
 *
 * This product includes software developed at
 * The Apache Software Foundation (http://www.apache.org/).
 */

(function() {
    'use strict';

    angular
        .module('askApp')
        .directive('preventEnterSubmit', preventEnterSubmit);

    function preventEnterSubmit() {
        return {
            restrict: 'A',
            link: function (scope, el, attrs) {
                el.bind('keydown', function (event) {
                    if (13 === event.which) {
                        event.preventDefault(); // Doesn't work at all
                        window.stop(); // Works in all browsers but IE...
                        document.execCommand('Stop'); // Works in IE
                        return false; // Don't even know why it's here. Does nothing.
                    }
                });
            }
        };
    }
})();


/*
Prevent in whole JS (put in controller)
angular.element(document).ready(function () {
    angular.element(window).keydown(function () {
        if(event.keyCode === 13) {
            event.preventDefault();
            return false;
        }
    });
});

Alternative (with shift support)
function (scope, elem, attrs) {
    elem.bind('keydown', function(event) {
         var code = event.keyCode || event.which;
         if (code === 13) {
               if (!event.shiftKey) {
                    event.preventDefault();
                    scope.$apply(attrs.enterSubmit);
               }
         }
    });
}
*/

/*
 * Copyright (c) 2017 by Julian Feder, julian.feder@yahoo.de
 *
 * This product includes software developed at
 * The Apache Software Foundation (http://www.apache.org/).
 */

(function() {
    'use strict';

    angular
        .module('askApp')
        .factory('Sessions', Sessions);

    Sessions.$inject = ['$resource'];

    function Sessions ($resource) {
        return $resource('api/account/sessions/:series', {}, {
            'getAll': { method: 'GET', isArray: true}
        });
    }
})();

/*
 * Copyright (c) 2017 by Julian Feder, julian.feder@yahoo.de
 *
 * This product includes software developed at
 * The Apache Software Foundation (http://www.apache.org/).
 */

(function () {
    'use strict';

    angular
        .module('askApp')
        .factory('Register', Register);

    Register.$inject = ['$resource'];

    function Register ($resource) {
        return $resource('api/register', {}, {});
    }
})();

/*
 * Copyright (c) 2017 by Julian Feder, julian.feder@yahoo.de
 *
 * This product includes software developed at
 * The Apache Software Foundation (http://www.apache.org/).
 */

(function() {
    'use strict';

    angular
        .module('askApp')
        .factory('Principal', Principal);

    Principal.$inject = ['$q', 'Account', 'JhiTrackerService'];

    function Principal ($q, Account, JhiTrackerService) {
        var _identity,
            _authenticated = false;

        var service = {
            authenticate: authenticate,
            hasAnyAuthority: hasAnyAuthority,
            hasAuthority: hasAuthority,
            identity: identity,
            isAuthenticated: isAuthenticated,
            isIdentityResolved: isIdentityResolved
        };

        return service;

        function authenticate (identity) {
            _identity = identity;
            _authenticated = identity !== null;
        }

        function hasAnyAuthority (authorities) {
            if (!_authenticated || !_identity || !_identity.authorities) {
                return false;
            }

            for (var i = 0; i < authorities.length; i++) {
                if (_identity.authorities.indexOf(authorities[i]) !== -1) {
                    return true;
                }
            }

            return false;
        }

        function hasAuthority (authority) {
            if (!_authenticated) {
                return $q.when(false);
            }

            return this.identity().then(function(_id) {
                return _id.authorities && _id.authorities.indexOf(authority) !== -1;
            }, function(){
                return false;
            });
        }

        function identity (force) {
            var deferred = $q.defer();

            if (force === true) {
                _identity = undefined;
            }

            // check and see if we have retrieved the identity data from the server.
            // if we have, reuse it by immediately resolving
            if (angular.isDefined(_identity)) {
                deferred.resolve(_identity);

                return deferred.promise;
            }

            // retrieve the identity data from the server, update the identity object, and then resolve.
            Account.get().$promise
                .then(getAccountThen)
                .catch(getAccountCatch);

            return deferred.promise;

            function getAccountThen (account) {
                _identity = account.data;
                _authenticated = true;
                deferred.resolve(_identity);
                //todo tracker
                //JhiTrackerService.connect();
            }

            function getAccountCatch () {
                _identity = null;
                _authenticated = false;
                deferred.resolve(_identity);
            }
        }

        function isAuthenticated () {
            return _authenticated;
        }

        function isIdentityResolved () {
            return angular.isDefined(_identity);
        }
    }
})();

/*
 * Copyright (c) 2017 by Julian Feder, julian.feder@yahoo.de
 *
 * This product includes software developed at
 * The Apache Software Foundation (http://www.apache.org/).
 */

(function() {
    'use strict';

    angular
        .module('askApp')
        .factory('PasswordResetInit', PasswordResetInit);

    PasswordResetInit.$inject = ['$resource'];

    function PasswordResetInit($resource) {
        var service = $resource('api/account/reset_password/init', {}, {});

        return service;
    }
})();

/*
 * Copyright (c) 2017 by Julian Feder, julian.feder@yahoo.de
 *
 * This product includes software developed at
 * The Apache Software Foundation (http://www.apache.org/).
 */

(function() {
    'use strict';

    angular
        .module('askApp')
        .factory('PasswordResetFinish', PasswordResetFinish);

    PasswordResetFinish.$inject = ['$resource'];

    function PasswordResetFinish($resource) {
        var service = $resource('api/account/reset_password/finish', {}, {});

        return service;
    }
})();

/*
 * Copyright (c) 2017 by Julian Feder, julian.feder@yahoo.de
 *
 * This product includes software developed at
 * The Apache Software Foundation (http://www.apache.org/).
 */

(function() {
    'use strict';

    angular
        .module('askApp')
        .factory('Password', Password);

    Password.$inject = ['$resource'];

    function Password($resource) {
        var service = $resource('api/account/change_password', {}, {});

        return service;
    }
})();

/*
 * Copyright (c) 2017 by Julian Feder, julian.feder@yahoo.de
 *
 * This product includes software developed at
 * The Apache Software Foundation (http://www.apache.org/).
 */

(function() {
    'use strict';

    angular
        .module('askApp')
        .directive('hasAuthority', hasAuthority);

    hasAuthority.$inject = ['Principal'];

    function hasAuthority(Principal) {
        var directive = {
            restrict: 'A',
            link: linkFunc
        };

        return directive;

        function linkFunc(scope, element, attrs) {
            var authority = attrs.hasAuthority.replace(/\s+/g, '');

            var setVisible = function () {
                    element.removeClass('hidden');
                },
                setHidden = function () {
                    element.addClass('hidden');
                },
                defineVisibility = function (reset) {

                    if (reset) {
                        setVisible();
                    }

                    Principal.hasAuthority(authority)
                        .then(function (result) {
                            if (result) {
                                setVisible();
                            } else {
                                setHidden();
                            }
                        });
                };

            if (authority.length > 0) {
                defineVisibility(true);

                scope.$watch(function() {
                    return Principal.isAuthenticated();
                }, function() {
                    defineVisibility(true);
                });
            }
        }
    }
})();

/*
 * Copyright (c) 2017 by Julian Feder, julian.feder@yahoo.de
 *
 * This product includes software developed at
 * The Apache Software Foundation (http://www.apache.org/).
 */

(function() {
    'use strict';

    angular
        .module('askApp')
        .directive('hasAnyAuthority', hasAnyAuthority);

    hasAnyAuthority.$inject = ['Principal'];

    function hasAnyAuthority(Principal) {
        var directive = {
            restrict: 'A',
            link: linkFunc
        };

        return directive;

        function linkFunc(scope, element, attrs) {
            var authorities = attrs.hasAnyAuthority.replace(/\s+/g, '').split(',');

            var setVisible = function () {
                    element.removeClass('hidden');
                },
                setHidden = function () {
                    element.addClass('hidden');
                },
                defineVisibility = function (reset) {
                    var result;
                    if (reset) {
                        setVisible();
                    }

                    result = Principal.hasAnyAuthority(authorities);
                    if (result) {
                        setVisible();
                    } else {
                        setHidden();
                    }
                };

            if (authorities.length > 0) {
                defineVisibility(true);

                scope.$watch(function() {
                    return Principal.isAuthenticated();
                }, function() {
                    defineVisibility(true);
                });
            }
        }
    }
})();

/*
 * Copyright (c) 2017 by Julian Feder, julian.feder@yahoo.de
 *
 * This product includes software developed at
 * The Apache Software Foundation (http://www.apache.org/).
 */

(function() {
    'use strict';

    angular
        .module('askApp')
        .factory('AuthServerProvider', AuthServerProvider);

    AuthServerProvider.$inject = ['$http', '$localStorage' , 'JhiTrackerService'];

    function AuthServerProvider ($http, $localStorage , JhiTrackerService) {
        var service = {
            getToken: getToken,
            hasValidToken: hasValidToken,
            login: login,
            logout: logout
        };

        return service;

        function getToken () {
            var token = $localStorage.authenticationToken;
            return token;
        }

        function hasValidToken () {
            var token = this.getToken();
            return !!token;
        }

        function login (credentials) {
            var data = 'j_username=' + encodeURIComponent(credentials.username) +
                '&j_password=' + encodeURIComponent(credentials.password) +
                '&remember-me=' + credentials.rememberMe + '&submit=Login';

            return $http.post('api/authentication', data, {
                headers: {
                    'Content-Type': 'application/x-www-form-urlencoded'
                }
            }).then(function (response) {
                return response.data;
            });
        }

        function logout () {
            //JhiTrackerService.disconnect();
            // logout from the server
            $http.post('api/logout').then(function (response) {
                delete $localStorage.authenticationToken;
                // to get a new csrf token call the api
                $http.get('api/account');
                return response.data;
            });

        }
    }
})();

/*
 * Copyright (c) 2017 by Julian Feder, julian.feder@yahoo.de
 *
 * This product includes software developed at
 * The Apache Software Foundation (http://www.apache.org/).
 */

(function() {
    'use strict';

    angular
        .module('askApp')
        .factory('Auth', Auth);

    Auth.$inject = ['$rootScope', '$state', '$sessionStorage', '$q', '$translate', 'Principal', 'AuthServerProvider', 'Account', 'AccountProfileService', 'LoginService', 'Register', 'Activate', 'Password', 'PasswordResetInit', 'PasswordResetFinish', 'JhiTrackerService', 'PrincipalProfile'];

    function Auth ($rootScope, $state, $sessionStorage, $q, $translate, Principal, AuthServerProvider, Account, AccountProfileService, LoginService, Register, Activate, Password, PasswordResetInit, PasswordResetFinish, JhiTrackerService, PrincipalProfile) {
        var service = {
            activateAccount: activateAccount,
            authorize: authorize,
            changePassword: changePassword,
            createAccount: createAccount,
            getPreviousState: getPreviousState,
            login: login,
            logout: logout,
            resetPasswordFinish: resetPasswordFinish,
            resetPasswordInit: resetPasswordInit,
            resetPreviousState: resetPreviousState,
            storePreviousState: storePreviousState,
            updateAccount: updateAccount,
            updateProfile: updateProfile
        };

        return service;

        function activateAccount (key, callback) {
            var cb = callback || angular.noop;

            return Activate.get(key,
                function (response) {
                    return cb(response);
                },
                function (err) {
                    return cb(err);
                }.bind(this)).$promise;
        }

        function authorize (force) {
            var authReturn = Principal.identity(force).then(authThen);

            return authReturn;

            function authThen () {

                var isAuthenticated = Principal.isAuthenticated();

                if (isAuthenticated) {

                    /**
                     * load profile data after reload
                     */
                    PrincipalProfile.identity(force).then(function(profile) {
                        //console.log(profile);
                    });
                }

                // an authenticated user can't access to login and register pages
                if (isAuthenticated && $rootScope.toState.parent === 'account' && ($rootScope.toState.name === 'login' || $rootScope.toState.name === 'register')) {
                    $state.go('home');
                }

                // recover and clear previousState after external login redirect (e.g. oauth2)
                if (isAuthenticated && !$rootScope.fromState.name && getPreviousState()) {
                    var previousState = getPreviousState();
                    resetPreviousState();
                    $state.go(previousState.name, previousState.params);
                }

                if ($rootScope.toState.data.authorities && $rootScope.toState.data.authorities.length > 0 && !Principal.hasAnyAuthority($rootScope.toState.data.authorities)) {
                    if (isAuthenticated) {
                        // user is signed in but not authorized for desired state
                        $state.go('accessdenied');
                    }
                    else {
                        // user is not authenticated. stow the state they wanted before you
                        // send them to the login service, so you can return them when you're done
                        storePreviousState($rootScope.toState.name, $rootScope.toStateParams);

                        // now, send them to the signin state so they can log in
                        $state.go('accessdenied').then(function() {
                            LoginService.open();
                        });
                    }
                }
            }
        }

        function changePassword (newPassword, callback) {
            var cb = callback || angular.noop;

            return Password.save(newPassword, function () {
                return cb();
            }, function (err) {
                return cb(err);
            }).$promise;
        }

        function createAccount (account, callback) {
            var cb = callback || angular.noop;

            return Register.save(account,
                function () {
                    return cb(account);
                },
                function (err) {
                    this.logout();
                    return cb(err);
                }.bind(this)).$promise;
        }

        function login (credentials, callback) {
            var cb = callback || angular.noop;
            var deferred = $q.defer();

            AuthServerProvider.login(credentials)
                .then(loginThen)
                .catch(function (err) {
                    this.logout();
                    deferred.reject(err);
                    return cb(err);
                }.bind(this));

            function loginThen (data) {
                Principal.identity(true).then(function(account) {
                    // After the login the language will be changed to
                    // the language selected by the user during his registration
                    if (account!== null) {
                        $translate.use(account.langKey).then(function () {
                            $translate.refresh();
                        });

                        /**
                         * load profile data after login
                         */
                        PrincipalProfile.identity(true).then(function(profile) {
                            //console.log(profile);
                        });
                    }
                    //todo tracker
                    //JhiTrackerService.sendActivity();
                    deferred.resolve(data);
                });
                return cb();
            }

            return deferred.promise;
        }


        function logout () {
            AuthServerProvider.logout();
            Principal.authenticate(null);
        }

        function resetPasswordFinish (keyAndPassword, callback) {
            var cb = callback || angular.noop;

            return PasswordResetFinish.save(keyAndPassword, function () {
                return cb();
            }, function (err) {
                return cb(err);
            }).$promise;
        }

        function resetPasswordInit (mail, callback) {
            var cb = callback || angular.noop;

            return PasswordResetInit.save(mail, function() {
                return cb();
            }, function (err) {
                return cb(err);
            }).$promise;
        }

        function updateAccount (account, callback) {
            var cb = callback || angular.noop;

            return Account.save(account,
                function () {
                    return cb(account);
                },
                function (err) {
                    return cb(err);
                }.bind(this)).$promise;
        }

        /**
         * Function to update the own profile, added from julian
         * @param account
         * @param callback
         * @returns {*|Function}
         */
        function updateProfile (account, callback) {
            var cb = callback || angular.noop;

            return AccountProfileService.save(account,
                function () {
                    return cb(account);
                },
                function (err) {
                    return cb(err);
                }.bind(this)).$promise;
        }

        function getPreviousState() {
            var previousState = $sessionStorage.previousState;
            return previousState;
        }

        function resetPreviousState() {
            delete $sessionStorage.previousState;
        }

        function storePreviousState(previousStateName, previousStateParams) {
            var previousState = { "name": previousStateName, "params": previousStateParams };
            $sessionStorage.previousState = previousState;
        }
    }
})();

/*
 * Copyright (c) 2017 by Julian Feder, julian.feder@yahoo.de
 *
 * This product includes software developed at
 * The Apache Software Foundation (http://www.apache.org/).
 */

(function() {
    'use strict';

    angular
        .module('askApp')
        .factory('Activate', Activate);

    Activate.$inject = ['$resource'];

    function Activate ($resource) {
        var service = $resource('api/activate', {}, {
            'get': { method: 'GET', params: {}, isArray: false}
        });

        return service;
    }
})();

/*
 * Copyright (c) 2017 by Julian Feder, julian.feder@yahoo.de
 *
 * This product includes software developed at
 * The Apache Software Foundation (http://www.apache.org/).
 */

(function() {
    'use strict';

    angular
        .module('askApp')
        .factory('Account', Account);

    Account.$inject = ['$resource'];

    function Account ($resource) {
        var service = $resource('api/account', {}, {
            'get': { method: 'GET', params: {}, isArray: false,
                interceptor: {
                    response: function(response) {
                        // expose response
                        return response;
                    }
                }
            }
        });

        return service;
    }
})();

/*
 * Copyright (c) 2017 by Julian Feder, julian.feder@yahoo.de
 *
 * This product includes software developed at
 * The Apache Software Foundation (http://www.apache.org/).
 */

(function() {
    'use strict';
    angular
        .module('askApp')
        .factory('SbfTimeSlotMember', SbfTimeSlotMember);

    SbfTimeSlotMember.$inject = ['$resource', 'DateUtils'];

    function SbfTimeSlotMember ($resource, DateUtils) {
        var resourceUrl =  'api/member/sbf-time-slots/:id';

        return $resource(resourceUrl, {}, {
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                        data.fromTime = DateUtils.convertDateTimeFromServer(data.fromTime);
                        data.toTime = DateUtils.convertDateTimeFromServer(data.toTime);
                    }
                    return data;
                }
            }
        });
    }
})();

/*
 * Copyright (c) 2017 by Julian Feder, julian.feder@yahoo.de
 *
 * This product includes software developed at
 * The Apache Software Foundation (http://www.apache.org/).
 */

(function() {
    'use strict';

    angular
        .module('askApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
        .state('member.projects', {
            parent: 'member',
            url: '/member/projects/{type}',
            data: {
                authorities: ['ROLE_USER'],
                pageTitle: 'askApp.booking.home.title2'
            },
            views: {
                'content@': {
                    templateUrl: 'app/member/projects/projects.html',
                    controller: 'ProjectsMemberController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate,$translatePartialLoader) {
                    $translatePartialLoader.addPart('home');
                    $translatePartialLoader.addPart('booking');
                    $translatePartialLoader.addPart('enumBookingStatusType');
                    $translatePartialLoader.addPart('enumSksPracticalLocation');
                    $translatePartialLoader.addPart('sbfTimeSlot');
                    $translatePartialLoader.addPart('booking');
                    return $translate.refresh();
                }]
            }
        })
        .state('project.book', {
            parent: 'member.projects',
            url: '/book/{id}',
            data: {
                authorities: ['ROLE_USER']
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate,$translatePartialLoader) {
                    $translatePartialLoader.addPart('enumClothingSize');
                    $translatePartialLoader.addPart('enumCountry');
                    return $translate.refresh();
                }]
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/member/projects/booking-dialog.html',
                    controller: 'MemberBookingDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'md',
                    resolve: {
                        entity: ['ProjectBooking', function(ProjectBooking) {
                            return ProjectBooking.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('member.projects', null, { reload: 'member.projects' });
                }, function() {
                    $state.go('member.projects');
                });
            }]
        })
        .state('book-sbf-slot', {
            parent: 'member.projects',
            url: '/bookSbf/{id}',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/member/projects/book-sbf-slot-dialog.html',
                    controller: 'BookSbfSlotDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'md',
                    resolve: {
                        entity: ['SbfTimeSlotMember', function(SbfTimeSlotMember) {
                            return SbfTimeSlotMember.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('member.projects', null, { reload: 'member.projects' });
                }, function() {
                    $state.go('^');
                });
            }]
        });
    }
})();

/*
 * Copyright (c) 2017 by Julian Feder, julian.feder@yahoo.de
 *
 * This product includes software developed at
 * The Apache Software Foundation (http://www.apache.org/).
 */

(function() {
    'use strict';

    angular
        .module('askApp')
        .controller('ProjectsMemberController', ProjectsMemberController);

    ProjectsMemberController.$inject = ['$scope', 'Lightbox', '$sce', '$http', '$stateParams', '$state', 'DateUtils', 'calendarConfig', 'moment'];

    function ProjectsMemberController ($scope, Lightbox, $sce, $http, $stateParams, $state, DateUtils, calendarConfig, moment) {
        var vm = this;
        vm.type = $stateParams.type;
        vm.setType = setType;
        vm.today = new Date().toISOString().split('T')[0];

        calendarConfig.i18nStrings.weekNumber = 'KW {week}';
        moment.locale("de", {
            week: {
                dow: 1
            }
        });

        vm.events = [];
        vm.overview = [];
        vm.placesToBook = false;
        getSbfTimeSlotsToBook();

        function getSbfTimeSlotsToBook() {
            return $http.get('api/member/sbf-time-slots/', {}).then(function(response) {
                var data = response.data.slots;
                var events = response.data.events;
                for(var i = 0; i < events.length; i++) {
                    for(var u = 0; u < events[i].slots.length; u++) {
                        events[i].slots[u].fromTime = DateUtils.convertDateTimeFromServer(events[i].slots[u].fromTime);
                        events[i].slots[u].toTime = DateUtils.convertDateTimeFromServer(events[i].slots[u].toTime);
                    }
                    events[i].untilDate = DateUtils.convertLocalDateFromServer(events[i].untilDate);
                    if (events[i].placesToBook > 0) {
                        vm.placesToBook = true;
                    }
                }

                vm.overview = events;
                vm.events = [];

                for(var i = 0; i < data.length; i++) {
                    data[i].fromTime = DateUtils.convertDateTimeFromServer(data[i].fromTime);
                    data[i].toTime = DateUtils.convertDateTimeFromServer(data[i].toTime);
                    var primaryColor = null;
                    var secondaryColor = null;
                    var freePlaces = data[i].freePlaces;
                    var booked = data[i].booked;

                    if(!booked) {
                        if(freePlaces === 0) {
                            freePlaces = "Ausgebucht";
                            primaryColor = '#d9534f';
                            secondaryColor = '#d9534f';
                        } else if(freePlaces === 1){
                            freePlaces = 1 + " freier Platz";
                            primaryColor = '#f0ad4e';
                            secondaryColor = '#f0ad4e';
                        } else {
                            freePlaces = freePlaces + " freie Plätze";
                            primaryColor = '#5cb85c';
                            secondaryColor = '#5cb85c';
                        }
                    } else {
                        freePlaces = "Bereits von dir gebucht";
                        primaryColor = '#d9534f';
                        secondaryColor = '#d9534f';
                    }

                    var event = {
                        title: data[i].project + " | " + freePlaces,
                        id: data[i].id,
                        startsAt: data[i].fromTime,
                        endsAt: data[i].toTime,
                        color: {
                            primary: primaryColor,
                            secondary: secondaryColor
                        }
                    };
                    vm.events.push(event);
                }
            });
        }

        vm.calendarView = 'month';
        vm.viewDate = new Date();

        vm.sbfClicked = function(event) {
            $state.go('book-sbf-slot', {'id': event.id});
        };

        loadAll();

        function loadAll () {
            $http.get('api/member/projects/', {params:{
                type: $stateParams.type
            }}).then(function(response) {
                vm.projects = response.data;
            });
        }

        $scope.renderHtml = function(code) {
            return $sce.trustAsHtml(code);
        };

        $scope.openLightboxModal = function(index, image) {
            var images = [{'url': image}];
            Lightbox.openModal(images, index);
        };

        function setType(type) {
            $state.go('member.projects', {
                type: type
            });
        }
    }
})();

/*
 * Copyright (c) 2017 by Julian Feder, julian.feder@yahoo.de
 *
 * This product includes software developed at
 * The Apache Software Foundation (http://www.apache.org/).
 */

(function() {
    'use strict';
    angular
        .module('askApp')
        .factory('ProjectBooking', ProjectBooking);

    ProjectBooking.$inject = ['$resource', 'DateUtils'];

    function ProjectBooking ($resource, DateUtils) {
        var resourceUrl =  'api/member/projects/book/:id';

        return $resource(resourceUrl, {}, {
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                    }
                    return data;
                }
            }
        });
    }
})();

/*
 * Copyright (c) 2017 by Julian Feder, julian.feder@yahoo.de
 *
 * This product includes software developed at
 * The Apache Software Foundation (http://www.apache.org/).
 */

(function() {
    'use strict';

    angular
        .module('askApp')
        .controller('MemberBookingDialogController', MemberBookingDialogController);

    MemberBookingDialogController.$inject = ['$timeout', '$scope', '$state', '$uibModalInstance', 'ProfileService', '$http', '$sce', 'AlertService', 'entity'];

    function MemberBookingDialogController ($timeout, $scope, $state, $uibModalInstance, ProfileService, $http, $sce, AlertService, entity) {
        var vm = this;

        $scope.status = {
            descriptionOpen: false,
            conditionsOpen: false
        };

        vm.project = entity;
        vm.booking = {};
        vm.booking.projectID = vm.project.id;
        vm.booking.points = 0;
        vm.booking.individualPrice = vm.project.individualPriceBoolean;
        vm.booking.sksTheoryAvailable = false;
        vm.dataValid = vm.project.checkWeight && vm.project.checkClothingSize && vm.project.checkShoeSize && vm.project.checkNationality && vm.project.checkBirthplace && vm.project.checkCountryOfBirth && vm.project.checkIDNumber;
        vm.clear = clear;
        vm.save = save;
        vm.addData = addData;
        vm.pointsPicked = pointsPicked;
        vm.setIndividualPrice = setIndividualPrice;
        var activityPointValue;
        var originPrice = vm.project.price;

        ProfileService.getProfileInfo().then(function(response) {
            activityPointValue = response.activityPointValue;
            calcMaxPoints();
            vm.pointsPicked();
        });

        function setIndividualPrice() {
            if(vm.booking.individualPrice) {
                vm.project.price = vm.project.individualPrice;
            } else {
                vm.project.price = originPrice;
            }
            calcMaxPoints();
            vm.pointsPicked();
        }

        function calcMaxPoints () {
            var points = Math.floor(vm.project.price / activityPointValue);
            $scope.maxPoints = Math.min(vm.project.availableActivityPoints, points);
        }

        $timeout(function () {
            angular.element('.form-group:eq(0)>input').focus();
        });

        function pointsPicked () {
            var pointsValue = vm.booking.points * activityPointValue;
            $scope.price = vm.project.price - pointsValue;
            $scope.prepayment = Math.max(vm.project.prepayment - pointsValue, 0);
        }

        function addData () {
            $state.go('member.personal.additional');
            $uibModalInstance.dismiss('cancel');
        }

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function save () {
            vm.isSaving = true;
            $http.post('api/member/bookings/', vm.booking).then(function(response) {
                vm.error = null;
                vm.isSaving = false;
                AlertService.success('Du hast dich erfolgreich für das Projekt <b>' + vm.project.name + '</b> angemeldet.');
                $uibModalInstance.close(response);
                vm.isSaving = false;
            }, function(error) {
                vm.isSaving = false;
            });
        }

        $scope.renderHtml = function(code) {
            return $sce.trustAsHtml(code);
        };
    }
})();

/*
 * Copyright (c) 2017 by Julian Feder, julian.feder@yahoo.de
 *
 * This product includes software developed at
 * The Apache Software Foundation (http://www.apache.org/).
 */

(function() {
    'use strict';

    angular
        .module('askApp')
        .controller('BookSbfSlotDialogController', BookSbfSlotDialogController);

    BookSbfSlotDialogController.$inject = ['$timeout', '$scope', '$http', '$uibModalInstance', 'entity', 'AlertService', '$filter'];

    function BookSbfSlotDialogController ($timeout, $scope, $http, $uibModalInstance, entity, AlertService, $filter) {
        var vm = this;

        vm.sbfTimeSlot = entity;
        vm.clear = clear;
        vm.datePickerOpenStatus = {};
        vm.openCalendar = openCalendar;
        vm.save = save;

        $timeout(function (){
            angular.element('.form-group:eq(1)>input').focus();
        });

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function save () {
            vm.isSaving = true;

            $http.post('api/member/sbf-time-slots/book', {
                id: vm.sbfTimeSlot.id,
                comment: "test"
            }).then(onSaveSuccess, onSaveError);
        }

        function onSaveSuccess (result) {
            $scope.$emit('askApp:sbfTimeSlotUpdate', result);
            $uibModalInstance.close(result);
            vm.isSaving = false;
            AlertService.success('Du hast dich erfolgreich für den Termin am <b>' + $filter('date')(vm.sbfTimeSlot.fromTime, "dd.MM.yyyy") + '</b> um <b>' + $filter('date')(vm.sbfTimeSlot.fromTime, "HH:mm") + ' Uhr</b> angemeldet.');
        }

        function onSaveError () {
            vm.isSaving = false;
        }

        vm.datePickerOpenStatus.fromTime = false;
        vm.datePickerOpenStatus.toTime = false;

        function openCalendar (date) {
            vm.datePickerOpenStatus[date] = true;
        }
    }
})();

/*
 * Copyright (c) 2017 by Julian Feder, julian.feder@yahoo.de
 *
 * This product includes software developed at
 * The Apache Software Foundation (http://www.apache.org/).
 */

(function() {
    'use strict';

    angular
        .module('askApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
        .state('member.personal.student', {
            parent: 'member.personal',
            url: '/member/personal/student',
            data: {
                authorities: ['ROLE_USER'],
                pageTitle: 'global.menu.member.student'
            },
            views: {
                'personal@member.personal': {
                    templateUrl: 'app/member/personal/student/student.html',
                    controller: 'StudentController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('profile');
                    $translatePartialLoader.addPart('global');
                    $translatePartialLoader.addPart('settings');
                    $translatePartialLoader.addPart('register');
                    return $translate.refresh();
                }]
            }
        })
    }

})();

/*
 * Copyright (c) 2017 by Julian Feder, julian.feder@yahoo.de
 *
 * This product includes software developed at
 * The Apache Software Foundation (http://www.apache.org/).
 */

(function() {
    'use strict';

    angular
        .module('askApp')
        .controller('StudentController', StudentController);

    StudentController.$inject = ['DateUtils', '$scope', 'DataUtils', '$translate', 'AlertService', '$http'];

    function StudentController (DateUtils, $scope, DataUtils, $translate, AlertService, $http) {

        var vm = this;

        vm.profile = null;
        vm.save = save;
        vm.errorWrongFormat = null;
        vm.errorMaxUploadSize = null;
        vm.byteSize = DataUtils.byteSize;
        vm.openFile = DataUtils.openFile;
        vm.fileSize = null;
        vm.fileIsNew = false;
        vm.university = null;
        vm.oldUniversity = null;

        loadImmatriculation();

        function loadImmatriculation() {
            $http.get('api/member/immatriculation/', {}).then(function(response) {
                vm.profile = response.data;
                DateUtils.convertLocalDateFromServer(vm.profile.matriculationDate);
                var difference_ms = Math.abs(new Date() - DateUtils.convertLocalDateFromServer(vm.profile.matriculationDate));
                var ONE_DAY = 1000 * 60 * 60 * 24;
                vm.daysLeft = 365 - Math.floor(difference_ms / ONE_DAY);
                vm.university = !!vm.profile.university;
                vm.fileIsNew = false;
                vm.oldUniversity = vm.profile.university;
            });
        }


        function save () {
            vm.isSaving = true;
            if (!vm.university && !vm.profile.isStudent) {
                vm.profile.university = null;
            }
            $http.post('api/member/immatriculation/', vm.profile).then(function(response) {
                vm.error = null;
                vm.isSaving = false;
                vm.fileIsNew = false;
                loadImmatriculation();
                AlertService.success($translate.instant('global.messages.update.alert'));
            }, function(error) {
                vm.isSaving = false;
                vm.error = 'ERROR';
            });
        }

        vm.setMatriculationCertificate = function ($file, profile) {
            if ($file) {
                if ($file.type !== 'application/pdf') {
                    vm.errorWrongFormat = true;
                } else {
                    DataUtils.toBase64($file, function(base64Data) {
                        vm.fileSize = vm.byteSize(base64Data).replace(/\s/g, '').replace('bytes', '');
                        if (vm.fileSize > 2097152) {
                            $scope.$apply(function() {
                                vm.errorMaxUploadSize = true;
                            });
                        } else {
                            $scope.$apply(function() {
                                profile.matriculationCertificate = base64Data;
                                profile.matriculationCertificateContentType = $file.type;
                                vm.fileIsNew = true;
                                vm.errorWrongFormat = false;
                                vm.errorMaxUploadSize = false;
                            });
                        }
                    });
                }
            }
        };
    }
})();

/*
 * Copyright (c) 2017 by Julian Feder, julian.feder@yahoo.de
 *
 * This product includes software developed at
 * The Apache Software Foundation (http://www.apache.org/).
 */

(function() {
    'use strict';

    angular
        .module('askApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
        .state('member.personal.profile', {
            parent: 'member.personal',
            url: '/member/personal/profile',
            data: {
                authorities: ['ROLE_USER'],
                pageTitle: 'global.menu.member.stamm'
            },
            views: {
                'personal@member.personal': {
                    templateUrl: 'app/member/personal/profile/profile.html',
                    controller: 'PersonalProfileController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('profile');
                    $translatePartialLoader.addPart('enumCountry');
                    $translatePartialLoader.addPart('global');
                    $translatePartialLoader.addPart('settings');
                    $translatePartialLoader.addPart('enumMemberStatus');
                    return $translate.refresh();
                }]
            }
        })
    }

})();

/*
 * Copyright (c) 2017 by Julian Feder, julian.feder@yahoo.de
 *
 * This product includes software developed at
 * The Apache Software Foundation (http://www.apache.org/).
 */

(function() {
    'use strict';

    angular
        .module('askApp')
        .controller('PersonalProfileController', PersonalProfileController);

    PersonalProfileController.$inject = ['PrincipalProfile', 'Auth', 'JhiLanguageService', '$translate', 'AlertService'];

    function PersonalProfileController (PrincipalProfile, Auth, JhiLanguageService, $translate, AlertService) {

        var vm = this;

        vm.profile = null;
        vm.save = save;

        PrincipalProfile.identity(true).then(function(profile) {
            vm.profile = profile;
        });

        function save () {
            vm.isSaving = true;
            if (vm.profile.nickname) {
                vm.profile.nickname = vm.profile.nickname.trim();
            }
            if (vm.profile.nickname === vm.profile.user.firstName || vm.profile.nickname === "") {
                vm.profile.nickname = null;
            }
            Auth.updateProfile(vm.profile).then(function() {
                vm.error = null;
                vm.isSaving = false;
                PrincipalProfile.identity(true).then(function(profile) {
                    vm.profile = profile;
                });
                JhiLanguageService.getCurrent().then(function(current) {
                    if (vm.profile.user.langKey !== current) {
                        $translate.use(vm.profile.user.langKey);
                    }
                });
                AlertService.success($translate.instant('global.messages.update.alert'));
            }).catch(function() {
                vm.isSaving = false;
                vm.error = 'ERROR';
            });
        }
    }
})();

/*
 * Copyright (c) 2017 by Julian Feder, julian.feder@yahoo.de
 *
 * This product includes software developed at
 * The Apache Software Foundation (http://www.apache.org/).
 */

(function() {
    'use strict';

    angular
        .module('askApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider.state('member.personal', {
            abstract: true,
            parent: 'member',
            views: {
                'content@': {
                    templateUrl: 'app/member/personal/personalNavbar.html',
                    controller: 'PersonalNavbarController',
                    controllerAs: 'vm'
                }
            }
        });
    }
})();

/*
 * Copyright (c) 2017 by Julian Feder, julian.feder@yahoo.de
 *
 * This product includes software developed at
 * The Apache Software Foundation (http://www.apache.org/).
 */

(function() {
    'use strict';

    angular
        .module('askApp')
        .controller('PersonalNavbarController', PersonalNavbarController);

    PersonalNavbarController.$inject = ['PrincipalProfile'];

    function PersonalNavbarController (PrincipalProfile) {
        var vm = this;

        PrincipalProfile.identity(true).then(function(profile) {
            vm.profile = profile;
        });
    }
})();

/*
 * Copyright (c) 2017 by Julian Feder, julian.feder@yahoo.de
 *
 * This product includes software developed at
 * The Apache Software Foundation (http://www.apache.org/).
 */

(function() {
    'use strict';

    angular
        .module('askApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
        .state('member.personal.payment', {
            parent: 'member.personal',
            url: '/member/personal/payment',
            data: {
                authorities: ['ROLE_USER'],
                pageTitle: 'global.menu.member.payment'
            },
            views: {
                'personal@member.personal': {
                    templateUrl: 'app/member/personal/payment/payment.html',
                    controller: 'MemberPaymentController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('profile');
                    $translatePartialLoader.addPart('enumCountry');
                    $translatePartialLoader.addPart('global');
                    $translatePartialLoader.addPart('settings');
                    return $translate.refresh();
                }]
            }
        })
    }

})();

/*
 * Copyright (c) 2017 by Julian Feder, julian.feder@yahoo.de
 *
 * This product includes software developed at
 * The Apache Software Foundation (http://www.apache.org/).
 */

(function() {
    'use strict';

    angular
        .module('askApp')
        .controller('MemberPaymentController', MemberPaymentController);

    MemberPaymentController.$inject = ['PrincipalProfile', '$http', 'AlertService', '$translate', '$state'];

    function MemberPaymentController (PrincipalProfile, $http, AlertService, $translate, $state) {

        var vm = this;

        vm.profile = null;
        vm.ibanInput = null;
        vm.bicInput = null;
        vm.save = save;

        PrincipalProfile.identity(true).then(function(profile) {
            vm.profile = profile;
        });

        vm.truncateBancAccountHolder = function() {
            vm.profile.bankAccountHolder = null;
        };

        function save () {
            vm.isSaving = true;
            if(vm.profile.isUsingSepa === true) {
                if(vm.profile.isDeviatedHolder === false) {
                    vm.profile.bankAccountHolder = vm.profile.user.firstName + ' ' + vm.profile.user.lastName;
                }
            }
            var bancaccount = {
                id: vm.profile.user.id,
                bankAccountHolder: vm.profile.bankAccountHolder,
                iban: vm.ibanInput,
                bic: vm.bicInput,
                isDeviatedHolder: vm.profile.isDeviatedHolder,
                isUsingSepa: vm.profile.isUsingSepa
            };
            $http.post('api/member/bancaccount/', bancaccount).then(function(response) {
                vm.error = null;
                vm.isSaving = false;
                $state.reload();
                AlertService.success($translate.instant('global.messages.update.alert'));
            }, function(error) {
                vm.isSaving = false;
                vm.error = 'ERROR';
                if (error.status === 400 && error.data === 'bic') {
                    AlertService.error('global.messages.error.bic');
                }
                if (error.status === 400 && error.data === 'iban') {
                    AlertService.error('global.messages.error.iban');
                }
            });
        }
    }
})();

/*
 * Copyright (c) 2017 by Julian Feder, julian.feder@yahoo.de
 *
 * This product includes software developed at
 * The Apache Software Foundation (http://www.apache.org/).
 */

(function() {
    'use strict';

    angular
        .module('askApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
        .state('member.personal.password', {
            parent: 'member.personal',
            url: '/member/personal/password',
            data: {
                authorities: ['ROLE_USER'],
                pageTitle: 'global.menu.member.password'
            },
            views: {
                'personal@member.personal': {
                    templateUrl: 'app/member/personal/password/password.html',
                    controller: 'PasswordController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('profile');
                    $translatePartialLoader.addPart('enumCountry');
                    $translatePartialLoader.addPart('global');
                    $translatePartialLoader.addPart('password');
                    return $translate.refresh();
                }]
            }
        })
    }

})();

/*
 * Copyright (c) 2017 by Julian Feder, julian.feder@yahoo.de
 *
 * This product includes software developed at
 * The Apache Software Foundation (http://www.apache.org/).
 */

(function() {
    'use strict';

    angular
        .module('askApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
        .state('member.personal.certificates', {
            parent: 'member.personal',
            url: '/member/personal/certificates',
            data: {
                authorities: ['ROLE_USER'],
                pageTitle: 'global.menu.member.zusatz'
            },
            views: {
                'personal@member.personal': {
                    templateUrl: 'app/member/personal/certificates/certificates.html',
                    controller: 'PersonalCertificatesController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('profile');
                    $translatePartialLoader.addPart('enumCountry');
                    $translatePartialLoader.addPart('global');
                    $translatePartialLoader.addPart('settings');
                    $translatePartialLoader.addPart('enumClothingSize');
                    $translatePartialLoader.addPart('enumIDType');
                    return $translate.refresh();
                }]
            }
        })
    }

})();

/*
 * Copyright (c) 2017 by Julian Feder, julian.feder@yahoo.de
 *
 * This product includes software developed at
 * The Apache Software Foundation (http://www.apache.org/).
 */

(function() {
    'use strict';

    angular
        .module('askApp')
        .controller('PersonalCertificatesController', PersonalCertificatesController);

    PersonalCertificatesController.$inject = ['PrincipalProfile', 'Auth', 'AlertService', '$translate', 'DateUtils'];

    function PersonalCertificatesController (PrincipalProfile, Auth, AlertService, $translate, DateUtils) {

        var vm = this;
        vm.openCalendar = openCalendar;
        vm.datePickerOpenStatus = {};
        vm.isafChange = isafChange;

        vm.profile = null;
        vm.save = save;

        PrincipalProfile.identity(true).then(function(profile) {
            vm.profile = profile;
        });

        function save () {
            vm.isSaving = true;
            var profile = angular.copy(vm.profile);
            profile.isafDate = DateUtils.convertLocalDateToServer(profile.isafDate);
            Auth.updateProfile(profile).then(function() {
                vm.error = null;
                vm.isSaving = false;
                PrincipalProfile.identity(true).then(function(profile) {
                    vm.profile = profile;
                });
                AlertService.success($translate.instant('global.messages.update.alert'));
            }).catch(function() {
                vm.isSaving = false;
                vm.error = 'ERROR';
            });
        }

        function openCalendar (date) {
            vm.datePickerOpenStatus[date] = true;
        }

        function isafChange() {
            if(vm.profile.isaf === "") {
                vm.profile.isafDate = "";
            }
        }
    }
})();

/*
 * Copyright (c) 2017 by Julian Feder, julian.feder@yahoo.de
 *
 * This product includes software developed at
 * The Apache Software Foundation (http://www.apache.org/).
 */

(function() {
    'use strict';

    angular
        .module('askApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
        .state('member.personal.address', {
            parent: 'member.personal',
            url: '/member/personal/address',
            data: {
                authorities: ['ROLE_USER'],
                pageTitle: 'global.menu.member.address'
            },
            views: {
                'personal@member.personal': {
                    templateUrl: 'app/member/personal/address/address.html',
                    controller: 'AddressController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('profile');
                    $translatePartialLoader.addPart('enumCountry');
                    $translatePartialLoader.addPart('global');
                    return $translate.refresh();
                }]
            }
        })
    }

})();

/*
 * Copyright (c) 2017 by Julian Feder, julian.feder@yahoo.de
 *
 * This product includes software developed at
 * The Apache Software Foundation (http://www.apache.org/).
 */

(function() {
    'use strict';

    angular
        .module('askApp')
        .controller('AddressController', AddressController);

    AddressController.$inject = ['PrincipalProfile', 'Auth', 'AlertService', '$translate'];

    function AddressController (PrincipalProfile, Auth, AlertService, $translate) {

        var vm = this;

        vm.profile = null;
        vm.save = save;

        PrincipalProfile.identity(true).then(function(profile) {
            vm.profile = profile;
        });

        function save () {
            vm.isSaving = true;
            Auth.updateProfile(vm.profile).then(function() {
                vm.error = null;
                vm.isSaving = false;
                PrincipalProfile.identity(true).then(function(profile) {
                    vm.profile = profile;
                });
                AlertService.success($translate.instant('global.messages.update.alert'));
            }).catch(function() {
                vm.isSaving = false;
                vm.error = 'ERROR';
            });
        }
    }
})();

/*
 * Copyright (c) 2017 by Julian Feder, julian.feder@yahoo.de
 *
 * This product includes software developed at
 * The Apache Software Foundation (http://www.apache.org/).
 */

(function() {
    'use strict';

    angular
        .module('askApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
        .state('member.personal.additional', {
            parent: 'member.personal',
            url: '/member/personal/additional',
            data: {
                authorities: ['ROLE_USER'],
                pageTitle: 'global.menu.member.zusatz'
            },
            views: {
                'personal@member.personal': {
                    templateUrl: 'app/member/personal/additional/additional.html',
                    controller: 'PersonalAdditionalController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('profile');
                    $translatePartialLoader.addPart('enumCountry');
                    $translatePartialLoader.addPart('global');
                    $translatePartialLoader.addPart('settings');
                    $translatePartialLoader.addPart('enumClothingSize');
                    $translatePartialLoader.addPart('enumIDType');
                    return $translate.refresh();
                }]
            }
        })
    }

})();

/*
 * Copyright (c) 2017 by Julian Feder, julian.feder@yahoo.de
 *
 * This product includes software developed at
 * The Apache Software Foundation (http://www.apache.org/).
 */

(function() {
    'use strict';

    angular
        .module('askApp')
        .controller('PersonalAdditionalController', PersonalAdditionalController);

    PersonalAdditionalController.$inject = ['PrincipalProfile', 'Auth', 'AlertService', '$translate', 'DateUtils'];

    function PersonalAdditionalController (PrincipalProfile, Auth, AlertService, $translate, DateUtils) {

        var vm = this;

        vm.profile = null;
        vm.save = save;
        vm.idTypeChange = idTypeChange;
        vm.openCalendar = openCalendar;
        vm.datePickerOpenStatus = {};
        vm.datePickerOpenStatus.idExpirationDate = false;

        vm.tomorrow = new Date();
        vm.tomorrow.setDate(vm.tomorrow.getDate() + 1);
        vm.startDate = new Date();
        vm.startDate.setMonth(vm.startDate.getMonth() + 2);
        vm.idDateOptions = {
            minDate: vm.tomorrow,
            initDate: vm.startDate
        };

        PrincipalProfile.identity(true).then(function(profile) {
            vm.profile = profile;
        });

        function openCalendar (date) {
            vm.datePickerOpenStatus[date] = true;
        }

        function save () {
            vm.isSaving = true;
            if(vm.profile.weight === "") {
                vm.profile.weight = null;
            }
            if(vm.profile.clothingSize === "") {
                vm.profile.clothingSize = null;
            }
            if(vm.profile.shoeSize === "") {
                vm.profile.shoeSize = null;
            }
            if(vm.profile.nationality === "") {
                vm.profile.nationality = null;
            }
            if(vm.profile.countryOfBirth === "") {
                vm.profile.countryOfBirth = null;
            }
            if(vm.profile.idType === "") {
                vm.profile.idType = null;
            }
            if(vm.profile.isaf === "") {
                vm.profile.isaf = null;
            }
            var profile = angular.copy(vm.profile);
            profile.idExpirationDate = DateUtils.convertLocalDateToServer(profile.idExpirationDate);
            Auth.updateProfile(profile).then(function() {
                vm.error = null;
                vm.isSaving = false;
                PrincipalProfile.identity(true).then(function(profile) {
                    vm.profile = profile;
                });
                AlertService.success($translate.instant('global.messages.update.alert'));
            }).catch(function() {
                vm.isSaving = false;
                vm.error = 'ERROR';
            });
        }

        function idTypeChange() {
            if(vm.profile.idType === "") {
                vm.profile.idNumber = "";
                vm.profile.idExpirationDate = "";
            }
        }
    }
})();

/*
 * Copyright (c) 2017 by Julian Feder, julian.feder@yahoo.de
 *
 * This product includes software developed at
 * The Apache Software Foundation (http://www.apache.org/).
 */

(function() {
    'use strict';

    angular
        .module('askApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider.state('member', {
            abstract: true,
            parent: 'app'
        });
    }
})();

/*
 * Copyright (c) 2017 by Julian Feder, julian.feder@yahoo.de
 *
 * This product includes software developed at
 * The Apache Software Foundation (http://www.apache.org/).
 */

(function() {
    'use strict';

    angular
        .module('askApp')
        .controller('FullMemberDialogController',FullMemberDialogController);

    FullMemberDialogController.$inject = ['$scope', '$uibModalInstance', 'ProfileService', 'DataUtils', '$http', '$rootScope', '$state', 'Principal'];

    function FullMemberDialogController($scope, $uibModalInstance, ProfileService, DataUtils, $http, $rootScope, $state, Principal) {
        var vm = this;
        vm.becomeMember = becomeMember;
        vm.clear = clear;
        vm.calcToPay = calcToPay;
        vm.profile = {};
        vm.profile.isStudent = false;
        vm.errorWrongFormat = null;
        vm.errorMaxUploadSize = null;
        vm.byteSize = DataUtils.byteSize;
        vm.openFile = DataUtils.openFile;
        vm.fileSize = null;
        vm.welcomeFee = null;
        vm.anualFee = null;
        vm.toPay = null;
        vm.isSaving = null;
        vm.errorIban = null;
        vm.errorBic = null;
        vm.showFreeYear = false;
        vm.university = false;

        init();

        function init() {
            var d = new Date();
            var n = d.getMonth();
            if(n === 10 || n === 11) {
                vm.showFreeYear = true;
            }
            Principal.identity().then(function(account) {
                vm.account = account;
            });
            vm.calcToPay();
        }

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function becomeMember () {
            vm.isSaving = true;
            if(vm.profile.isUsingSepa === true) {
                if(vm.profile.isDeviatedHolder === false) {
                    vm.profile.bankAccountHolder = vm.account.firstName + ' ' + vm.account.lastName;
                }
            } else {
                vm.profile.bankAccountHolder = null;
                vm.profile.iban = null;
                vm.profile.bic = null;
                vm.profile.isDeviatedHolder = false;
            }
            if (!vm.university && !vm.profile.isStudent) {
                vm.profile.university = null;
            }
            $http.post('/api/member/become/', vm.profile, null).then(onSaveSuccess, onSaveError);
        }

        function onSaveSuccess (result) {
            vm.isSaving = false;
            $rootScope.$broadcast('becomeMember');
            $state.go($state.current, {}, {reload: true});
            $uibModalInstance.close();
        }

        function onSaveError (response) {
            vm.isSaving = false;
            if (response.status === 400 && response.data === 'bic') {
                vm.errorBic = 'ERROR';
            } else if (response.status === 400 && response.data === 'iban') {
                vm.errorIban = 'ERROR';
            } else {
                vm.error = 'ERROR';
            }
            //$uibModalInstance.close();
        }

        vm.truncateUpload = function() {
            vm.profile.matriculationCertificate = null;
            vm.profile.matriculationCertificateContentType = null;
            vm.errorWrongFormat = false;
            vm.errorMaxUploadSize = false;
        };

        vm.setMatriculationCertificate = function ($file, profile) {
            if ($file) {
                if ($file.type !== 'application/pdf') {
                    vm.errorWrongFormat = true;
                } else {
                    DataUtils.toBase64($file, function(base64Data) {
                        vm.fileSize = vm.byteSize(base64Data).replace(/\s/g, '').replace('bytes', '');
                        if (vm.fileSize > 2097152) {
                            $scope.$apply(function() {
                                vm.errorMaxUploadSize = true;
                            });
                        } else {
                            $scope.$apply(function() {
                                profile.matriculationCertificate = base64Data;
                                profile.matriculationCertificateContentType = $file.type;
                                vm.errorWrongFormat = false;
                                vm.errorMaxUploadSize = false;
                            });
                        }
                    });
                }
            }
        };

        function calcToPay () {
            ProfileService.getProfileInfo().then(function(response) {
                vm.welcomeFeeStudent = response.welcomeMembershipFeeStudent;
                vm.welcomeFeeNormal = response.welcomeMembershipFeeStudentNormal;
                vm.welcomeFee = vm.profile.isStudent ? vm.welcomeFeeStudent : vm.welcomeFeeNormal;
                vm.anualFee = response.anualMembershipFee;
                vm.toPay = vm.welcomeFee + vm.anualFee;
            });
        }

        vm.truncateBancAccount = function() {
            vm.profile.iban = null;
            vm.profile.bic = null;
            vm.profile.bankAccountHolder = null;
            vm.profile.isDeviatedHolder = false;
        };

        vm.truncateBancAccountHolder = function() {
            vm.profile.bankAccountHolder = null;
        };
    }
})();

/*
 * Copyright (c) 2017 by Julian Feder, julian.feder@yahoo.de
 *
 * This product includes software developed at
 * The Apache Software Foundation (http://www.apache.org/).
 */

(function() {
    'use strict';

    angular
        .module('askApp')
        .factory('FullMemberService', FullMemberService);

    FullMemberService.$inject = ['$uibModal'];

    function FullMemberService ($uibModal) {
        var service = {
            open: open
        };

        var modalInstance = null;
        var resetModal = function () {
            modalInstance = null;
        };

        return service;

        function open () {
            if (modalInstance !== null) return;
            modalInstance = $uibModal.open({
                animation: true,
                templateUrl: 'app/member/full_member/full-member-dialog.html',
                controller: 'FullMemberDialogController',
                controllerAs: 'vm',
                resolve: {
                    translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                        $translatePartialLoader.addPart('login');
                        $translatePartialLoader.addPart('register');
                        $translatePartialLoader.addPart('profile');
                        return $translate.refresh();
                    }]
                }
            });
            modalInstance.result.then(
                resetModal,
                resetModal
            );
        }
    }
})();

/*
 * Copyright (c) 2020 by Felix Heim, felix-heim@web.de
 *
 * This product includes software developed at
 * The Apache Software Foundation (http://www.apache.org/).
 */

(function() {
    'use strict';

    angular
        .module('askApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
        .state('member.dinghy-events', {
            parent: 'member',
            url: '/member/dinghy-events',
            data: {
                authorities: ['ROLE_USER'],
                pageTitle: 'askApp.booking.home.title2'
            },
            views: {
                'content@': {
                    templateUrl: 'app/member/dinghy-events/dinghy-events.html',
                    controller: 'DinghyEventsMemberController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate,$translatePartialLoader) {
                    $translatePartialLoader.addPart('home');
                    $translatePartialLoader.addPart('booking');
                    $translatePartialLoader.addPart('dinghyBooking');
                    $translatePartialLoader.addPart('dinghyEvent');
                    $translatePartialLoader.addPart('enumBookingStatusType');
                    $translatePartialLoader.addPart('enumDinghyEventType');
                    return $translate.refresh();
                }]
            }
        })
        .state('member.dinghy-events.book', {
            parent: 'member.dinghy-events',
            url: '/book/{id}',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/member/dinghy-events/dinghy-booking-dialog.html',
                    controller: 'MemberDinghyBookingDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'md',
                    resolve: {
                        entity: ['DinghyBookingMember', function(DinghyBookingMember) {
                            return DinghyBookingMember.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('member.dinghy-events', null, { reload: 'member.dinghy-events' });
                }, function() {
                    $state.go('member.dinghy-events');
                });
            }]
        })
        .state('member.dinghy-events.change', {
            parent: 'member.dinghy-events',
            url: '/change/{id}',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/member/dinghy-events/dinghy-booking-change-dialog.html',
                    controller: 'MemberDinghyBookingChangeController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'md',
                    resolve: {
                        entity: ['DinghyBookingDetailMember', function(DinghyBookingDetailMember) {
                            return DinghyBookingDetailMember.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function(result) {
                    $state.go('member.dinghy-events', null, { reload: 'member.dinghy-events' });
                }, function() {
                    $state.go('member.dinghy-events');
                });
            }]
        })
        .state('member.dinghy-events.detail', {
            parent: 'member.dinghy-events',
            url: '/detail/{id}',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/member/dinghy-events/dinghy-booking-detail-dialog.html',
                    controller: 'MemberDinghyBookingDetailDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'md',
                    resolve: {
                        entity: ['DinghyBookingDetailMember', function(DinghyBookingDetailMember) {
                            return DinghyBookingDetailMember.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('member.dinghy-events', null, { reload: 'member.dinghy-events' });
                }, function() {
                    $state.go('member.dinghy-events');
                });
            }]
        });
    }
})();

/*
 * Copyright (c) 2020 by Felix Heim, felix-heim@web.de
 *
 * This product includes software developed at
 * The Apache Software Foundation (http://www.apache.org/).
 */

(function() {
    'use strict';

    angular
        .module('askApp')
        .controller('DinghyEventsMemberController', DinghyEventsMemberController);

    DinghyEventsMemberController.$inject = ['$scope', '$sce', '$http', '$state', 'DateUtils', 'calendarConfig', 'moment', '$filter', 'PrincipalProfile'];

    function DinghyEventsMemberController ($scope, $sce, $http, $state, DateUtils, calendarConfig, moment, $filter, PrincipalProfile) {
        var $translate = $filter('translate');
        var vm = this;
        vm.today = new Date().toISOString().split('T')[0];

        calendarConfig.i18nStrings.weekNumber = 'KW {week}';
        moment.locale("de", {
            week: {
                dow: 1
            }
        });

        vm.dinghyEvents = [];
        vm.calendarEvents = [];

        vm.calendarView = 'month';
        vm.viewDate = new Date();

        vm.calendarEventClicked = function(event) {
            $state.go(event.isBooked || !event.isActive || event.freePlaces <= 0 ? 'member.dinghy-events.detail' : 'member.dinghy-events.book', {'id': event.id});
        };

        PrincipalProfile.identity(false).then(function(profile) {
            vm.currentProfile = profile;
            loadAll();
        });

        const redColor = '#d9534f';
        const yellowColor = '#f0ad4e';
        const greenColor = '#5cb85c';
        const blueColor = '#5bc0de';
        const noPlacesColor = 'darkgrey';
        const leisureColor = '#0000ff';
        const regattaColor = '#ff00ff';
        const trainingColor = '#7F007F';
        const engagementColor = '#3fff00';
        function loadAll () {
            $http.get('api/member/dinghy-events/').then(function(response) {
                var calendarEvents = response.data.calendarEvents;
                var bookedEvents = response.data.bookedEvents;

                for(var index = 0; index < bookedEvents.length; index++) {
                    bookedEvents[index].fromDate = DateUtils.convertDateTimeFromServer(bookedEvents[index].fromDate);
                    bookedEvents[index].untilDate = DateUtils.convertDateTimeFromServer(bookedEvents[index].untilDate);
                }
                vm.dinghyEvents = bookedEvents;

                // process calendar events
                vm.calendarEvents = [];
                for(var index = 0; index < calendarEvents.length; index++) {
                    calendarEvents[index].fromDate = DateUtils.convertDateTimeFromServer(calendarEvents[index].fromDate);
                    calendarEvents[index].untilDate = DateUtils.convertDateTimeFromServer(calendarEvents[index].untilDate);

                    var primaryColor = null;
                    var secondaryColor = null;
                    var freePlaces = calendarEvents[index].freePlaces;
                    var freePlacesString = "";
                    var isBooked = calendarEvents[index].bookingStatus !== null;

                    if(freePlaces === 0) {
                        freePlacesString = "Ausgebucht";
                        primaryColor = secondaryColor = noPlacesColor;
                    } else if(freePlaces === -1) {
                        freePlacesString = "Warteliste";
                    } else if(freePlaces === 1) {
                        freePlacesString = 1 + " freier Platz";
                    } else {
                        freePlacesString = freePlaces + " freie Plätze";
                    }
                    var godparentIcon = '';
                    if(calendarEvents[index].godparentId === vm.currentProfile.id) {
                        godparentIcon = '<span class="glyphicon glyphicon-tower"></span> ';
                    }
                    if (isBooked) {
                        // Use color indicating the booking status
                        freePlacesString += " | " + $translate('askApp.EnumBookingStatusType.' + calendarEvents[index].bookingStatus);
                        switch (calendarEvents[index].bookingStatus) {
                            case "angemeldet":
                                primaryColor = secondaryColor = calendarEvents[index].canceled ? redColor : calendarEvents[index].godparentId !== null ? greenColor : yellowColor;
                                break;
                            case "warteliste":
                                primaryColor = secondaryColor = calendarEvents[index].canceled ? redColor : yellowColor;
                                break;
                            case "abgelehnt":
                            case "zurueckgetreten":
                                primaryColor = secondaryColor = redColor;
                                break;
                        }
                    } else if (freePlaces !== 0) {
                        // Use Event Type to define the color
                        switch (calendarEvents[index].type) {
                            case "leisure":
                                primaryColor = secondaryColor = leisureColor;
                                break;
                            case "regatta":
                                primaryColor = secondaryColor = regattaColor;
                                break;
                            case "training":
                                primaryColor = secondaryColor = trainingColor;
                                break;
                            case "engagement":
                                primaryColor = secondaryColor = engagementColor;
                                break;
                        }
                    }

                    var event = {
                        title: godparentIcon + calendarEvents[index].name + " | " + freePlacesString,
                        id: calendarEvents[index].id,
                        isBooked: isBooked,
                        freePlaces: freePlaces,
                        isActive: calendarEvents[index].active,
                        startsAt: calendarEvents[index].fromDate,
                        endsAt: calendarEvents[index].untilDate,
                        color: {
                            primary: primaryColor,
                            secondary: secondaryColor
                        },
                        actions: [{
                            label: "<i class='glyphicon glyphicon-eye-open'></i>",
                            cssClass: "brightLink",
                            onClick: function(args) {
                                $state.go('member.dinghy-events.detail', {'id': args.calendarEvent.id});
                            }
                        }]
                    };
                    vm.calendarEvents.push(event);
                }
            });
        }

        $scope.renderHtml = function(code) {
            return $sce.trustAsHtml(code);
        };

        var trusted = {};
        $scope.getPopoverContent = function(content) {
            return trusted[content] || (trusted[content] = $sce.trustAsHtml(content));
        }
    }
})();

/*
 * Copyright (c) 2020 by Felix Heim, felix-heim@web.de
 *
 * This product includes software developed at
 * The Apache Software Foundation (http://www.apache.org/).
 */

(function() {
    'use strict';

    angular
        .module('askApp')
        .controller('MemberDinghyBookingDialogController', MemberDinghyBookingDialogController);

    MemberDinghyBookingDialogController.$inject = ['$timeout', '$scope', '$state', '$uibModalInstance', 'ProfileService', '$http', '$sce', 'AlertService', 'entity', '$filter'];

    function MemberDinghyBookingDialogController ($timeout, $scope, $state, $uibModalInstance, ProfileService, $http, $sce, AlertService, entity, $filter) {
        var vm = this;

        $scope.status = {
            descriptionOpen: true,
            conditionsOpen: false
        };

        vm.dinghyEvent = entity;
        vm.booking = {};
        vm.booking.id = vm.dinghyEvent.id;
        // Activity Points
        vm.booking.pointCount = 0;
        vm.booking.individualQuestionAnswer = null;

        vm.clear = clear;
        vm.save = save;
        vm.pointsPicked = pointsPicked;

        var activityPointValue;
        ProfileService.getProfileInfo().then(function(response) {
            activityPointValue = response.activityPointValue;
            calcMaxPoints();
            vm.pointsPicked();
        });

        function calcMaxPoints () {
            var maxPointsToUse = Math.floor(vm.dinghyEvent.price / activityPointValue);
            $scope.maxPointCount = Math.min(vm.dinghyEvent.availableActivityPoints, maxPointsToUse);
        }

        $timeout(function () {
            angular.element('.form-group:eq(0)>input').focus();
        });

        function pointsPicked () {
            $scope.price = vm.dinghyEvent.price - (vm.booking.pointCount * activityPointValue);
        }

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function save () {
            vm.isSaving = true;
            $http.post('api/member/dinghy-bookings/', vm.booking).then(function(response) {
                vm.error = null;
                AlertService.success('Du hast dich erfolgreich für das Event <b>' + vm.dinghyEvent.name + '</b> angemeldet.');
                $uibModalInstance.close(response);
                vm.isSaving = false;
            }, function() {
                vm.isSaving = false;
            });
        }

        $scope.renderHtml = function(code) {
            return $sce.trustAsHtml(code);
        };

        var trusted = {};
        $scope.getPopoverContent = function(content) {
            return trusted[content] || (trusted[content] = $sce.trustAsHtml(content));
        }
    }
})();

/*
 * Copyright (c) 2020 by Felix Heim, felix-heim@web.de
 *
 * This product includes software developed at
 * The Apache Software Foundation (http://www.apache.org/).
 */

(function() {
    'use strict';

    angular
        .module('askApp')
        .controller('MemberDinghyBookingDetailDialogController', MemberDinghyBookingDetailDialogController);

    MemberDinghyBookingDetailDialogController.$inject = ['$timeout', '$scope', '$state', '$uibModalInstance', 'ProfileService', '$http', '$sce', 'AlertService', 'entity', '$filter'];

    function MemberDinghyBookingDetailDialogController ($timeout, $scope, $state, $uibModalInstance, ProfileService, $http, $sce, AlertService, entity, $filter) {
        var vm = this;

        vm.dinghyEvent = entity;
        vm.booking = {};
        vm.booking.id = vm.dinghyEvent.bookingId;
        vm.booking.bookingStatus = vm.dinghyEvent.bookingStatus;
        vm.booking.dinghy = vm.dinghyEvent.bookedDinghy;
        vm.booking.commentDinghy = vm.dinghyEvent.commentDinghy;
        var editDateCheck = new Date();
        editDateCheck.setDate(editDateCheck.getDate() - 1);
        vm.disableEdit = vm.booking.bookingStatus === 'abgelehnt' || vm.dinghyEvent.fromDate < editDateCheck || vm.dinghyEvent.closed;

        $scope.status = {
            descriptionOpen: vm.booking.id == null,
            conditionsOpen: false,
            editOpen: false
        };

        vm.clear = clear;
        vm.save = save;

        $timeout(function () {
            angular.element('.form-group:eq(0)>input').focus();
        });

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function save () {
            vm.isSaving = true;
            $http.put('api/member/dinghy-bookings/', vm.booking).then(function(response) {
                vm.error = null;
                $uibModalInstance.close(response);
                vm.isSaving = false;
            }, function() {
                vm.isSaving = false;
            });
        }

        $scope.getChangeState = function() {
            return $state.includes('member.dinghy-events') ? "member.dinghy-events.change({id: vm.dinghyEvent.id})" : "member.dinghy-booking.change({id: vm.dinghyEvent.id})";
        }

        $scope.renderHtml = function(code) {
            return $sce.trustAsHtml(code);
        };

        var trusted = {};
        $scope.getPopoverContent = function(content) {
            return trusted[content] || (trusted[content] = $sce.trustAsHtml(content));
        }
    }
})();

/*
 * Copyright (c) 2020 by Felix Heim, felix-heim@web.de
 *
 * This product includes software developed at
 * The Apache Software Foundation (http://www.apache.org/).
 */

(function() {
    'use strict';
    angular
        .module('askApp')
        .factory('DinghyBookingDetailMember', DinghyBookingDetailMember);

    DinghyBookingDetailMember.$inject = ['$resource', 'DateUtils'];

    function DinghyBookingDetailMember ($resource, DateUtils) {
        var resourceUrl =  'api/member/dinghy-bookings/:id';

        return $resource(resourceUrl, {}, {
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                        data.fromDate = DateUtils.convertDateTimeFromServer(data.fromDate);
                        data.untilDate = DateUtils.convertDateTimeFromServer(data.untilDate);
                    }
                    return data;
                }
            }
        });
    }
})();

/*
 * Copyright (c) 2020 by Felix Heim, felix-heim@web.de
 *
 * This product includes software developed at
 * The Apache Software Foundation (http://www.apache.org/).
 */

(function() {
    'use strict';

    angular
        .module('askApp')
        .controller('MemberDinghyBookingChangeController', MemberDinghyBookingChangeController);

    MemberDinghyBookingChangeController.$inject = ['$timeout', '$scope', '$state', '$uibModalInstance', 'ProfileService', '$http', '$sce', 'AlertService', 'entity'];

    function MemberDinghyBookingChangeController ($timeout, $scope, $state, $uibModalInstance, ProfileService, $http, $sce, AlertService, entity) {
        var vm = this;

        vm.dinghyEvent = entity;
        vm.booking = {};
        vm.booking.id = vm.dinghyEvent.bookingId;
        vm.oldBookingStatus = vm.dinghyEvent.bookingStatus;
        vm.booking.bookingStatus = vm.oldBookingStatus === 'zurueckgetreten' ? 'angemeldet' : 'zurueckgetreten';
        vm.isCancel = vm.booking.bookingStatus !== 'angemeldet'
        vm.booking.dinghy = vm.dinghyEvent.bookedDinghy;
        vm.booking.commentDinghy = vm.dinghyEvent.commentDinghy;
        var editDateCheck = new Date();
        editDateCheck.setDate(editDateCheck.getDate() - 1);
        if (vm.oldBookingStatus === 'abgelehnt' || vm.dinghyEvent.fromDate < editDateCheck) {
            clear();
        }

        vm.clear = clear;
        vm.save = save;

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function save () {
            vm.isSaving = true;
            $http.put('api/member/dinghy-bookings/', vm.booking).then(function(response) {
                vm.error = null;
                $uibModalInstance.close(response);
                vm.isSaving = false;
            }, function() {
                vm.isSaving = false;
            });
        }
    }
})();

/*
 * Copyright (c) 2020 by Felix Heim, felix-heim@web.de
 *
 * This product includes software developed at
 * The Apache Software Foundation (http://www.apache.org/).
 */

(function() {
    'use strict';
    angular
        .module('askApp')
        .factory('DinghyBookingMember', DinghyBookingMember);

    DinghyBookingMember.$inject = ['$resource', 'DateUtils'];

    function DinghyBookingMember ($resource, DateUtils) {
        var resourceUrl =  'api/member/dinghy-events/:id';

        return $resource(resourceUrl, {}, {
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                        data.fromDate = DateUtils.convertDateTimeFromServer(data.fromDate);
                        data.untilDate = DateUtils.convertDateTimeFromServer(data.untilDate);
                    }
                    return data;
                }
            }
        });
    }
})();

/*
 * Copyright (c) 2020 by Felix Heim, felix-heim@web.de
 *
 * This product includes software developed at
 * The Apache Software Foundation (http://www.apache.org/).
 */

(function() {
    'use strict';

    angular
        .module('askApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
        .state('member.dinghy-booking', {
            parent: 'member',
            url: '/member/dinghy-booking?archive',
            data: {
                authorities: ['ROLE_USER'],
                pageTitle: 'askApp.booking.home.title3'
            },
            views: {
                'content@': {
                    templateUrl: 'app/member/dinghy-booking/dinghy-bookings.html',
                    controller: 'MemberDinghyBookingController',
                    controllerAs: 'vm'
                }
            },
            params: {
                archive: {
                    value: 'false',
                    squash: true
                }
            },
            resolve: {
                pagingParams: ['$stateParams', function ($stateParams) {
                    return {
                        archive: $stateParams.archive
                    };
                }],
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('dinghyBooking');
                    $translatePartialLoader.addPart('dinghyEvent');
                    $translatePartialLoader.addPart('dept');
                    $translatePartialLoader.addPart('enumDinghyEventType');
                    $translatePartialLoader.addPart('enumBookingStatusType');
                    $translatePartialLoader.addPart('enumDeptStatus');
                    return $translate.refresh();
                }]
            }
        })
        .state('member.dinghy-booking.book', {
            parent: 'member.dinghy-booking',
            url: '/book/{id}',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/member/dinghy-events/dinghy-booking-dialog.html',
                    controller: 'MemberDinghyBookingDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'md',
                    resolve: {
                        entity: ['DinghyBookingMember', function(DinghyBookingMember) {
                            return DinghyBookingMember.get({id : $stateParams.id}).$promise;
                        }],
                        translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                            $translatePartialLoader.addPart('booking');
                            return $translate.refresh();
                        }]
                    }
                }).result.then(function() {
                    $state.go('member.dinghy-booking', null, { reload: 'member.dinghy-booking' });
                }, function() {
                    $state.go('member.dinghy-booking');
                });
            }]
        })
        .state('member.dinghy-booking.change', {
            parent: 'member.dinghy-booking',
            url: '/change/{id}',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/member/dinghy-events/dinghy-booking-change-dialog.html',
                    controller: 'MemberDinghyBookingChangeController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'md',
                    resolve: {
                        entity: ['DinghyBookingDetailMember', function(DinghyBookingDetailMember) {
                            return DinghyBookingDetailMember.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function(result) {
                    $state.go('member.dinghy-booking', null, { reload: 'member.dinghy-booking' });
                }, function() {
                    $state.go('member.dinghy-booking');
                });
            }]
        })
        .state('member.dinghy-booking.detail', {
            parent: 'member.dinghy-booking',
            url: '/detail/{id}',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/member/dinghy-events/dinghy-booking-detail-dialog.html',
                    controller: 'MemberDinghyBookingDetailDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'md',
                    resolve: {
                        entity: ['DinghyBookingDetailMember', function(DinghyBookingDetailMember) {
                            return DinghyBookingDetailMember.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('member.dinghy-booking', null, { reload: 'member.dinghy-booking' });
                }, function() {
                    $state.go('member.dinghy-booking');
                });
            }]
        });
    }
})();

/*
 * Copyright (c) 2020 by Felix Heim, felix-heim@web.de
 *
 * This product includes software developed at
 * The Apache Software Foundation (http://www.apache.org/).
 */

(function() {
    'use strict';
    angular
        .module('askApp')
        .factory('MemberDinghyBooking', MemberDinghyBooking);

    MemberDinghyBooking.$inject = ['$resource'];

    function MemberDinghyBooking ($resource) {
        var resourceUrl =  'api/member/dinghy-bookings';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true},
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                        data.bookingDate = DateUtils.convertDateTimeFromServer(data.bookingDate);
                        data.fromDate = DateUtils.convertDateTimeFromServer(data.fromDate);
                    }
                    return data;
                }
            }
        });
    }
})();

/*
 * Copyright (c) 2020 by Felix Heim, felix-heim@web.de
 *
 * This product includes software developed at
 * The Apache Software Foundation (http://www.apache.org/).
 */

(function() {
    'use strict';

    angular
        .module('askApp')
        .controller('MemberDinghyBookingController', MemberDinghyBookingController);

    MemberDinghyBookingController.$inject = ['$state', 'MemberDinghyBooking', 'ParseLinks', 'AlertService', 'paginationConstants', 'pagingParams', '$scope'];

    function MemberDinghyBookingController($state, MemberDinghyBooking, ParseLinks, AlertService, paginationConstants, pagingParams, $scope) {

        var vm = this;

        vm.loadPage = loadPage;
        vm.transition = transition;
        vm.loadAll = loadAll;

        vm.setArchive = setArchive;
        vm.archive = pagingParams.archive;

        loadAll();

        function loadAll () {
            MemberDinghyBooking.query({
                archive: vm.archive
            }, onSuccess, onError);
            function onSuccess(data) {
                vm.bookings = data;
            }
            function onError(error) {
                AlertService.error(error.data.message);
            }
        }

        function loadPage(page) {
            vm.page = page;
            vm.transition();
        }

        function transition() {
            $state.transitionTo($state.$current, {
                archive: vm.archive
            });
        }

        function setArchive(archive) {
            vm.archive = archive;
            vm.transition();
        }

        $scope.getEditOrBookState = function(booking) {
            return booking.bookingStatus == null && booking.priceNet == -1 ? "member.dinghy-events.book({id: booking.eventId})" : "member.dinghy-booking.detail({id: booking.eventId})";
        }
    }
})();

/*
 * Copyright (c) 2017 by Julian Feder, julian.feder@yahoo.de
 *
 * This product includes software developed at
 * The Apache Software Foundation (http://www.apache.org/).
 */

(function() {
    'use strict';

    angular
        .module('askApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
        .state('member.booking', {
            parent: 'member',
            url: '/member/booking?page&sort&search&query',
            data: {
                authorities: ['ROLE_USER'],
                pageTitle: 'askApp.booking.home.title3'
            },
            views: {
                'content@': {
                    templateUrl: 'app/member/booking/bookings.html',
                    controller: 'MemberBookingController',
                    controllerAs: 'vm'
                }
            },
            params: {
                page: {
                    value: '1',
                    squash: true
                },
                sort: {
                    value: 'date,desc',
                    squash: true
                },
                search: null
            },
            resolve: {
                pagingParams: ['$stateParams', 'PaginationUtil', function ($stateParams, PaginationUtil) {
                    return {
                        page: PaginationUtil.parsePage($stateParams.page),
                        sort: $stateParams.sort,
                        predicate: PaginationUtil.parsePredicate($stateParams.sort),
                        ascending: PaginationUtil.parseAscending($stateParams.sort),
                        search: $stateParams.search,
                        select: $stateParams.select
                    };
                }],
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('booking');
                    $translatePartialLoader.addPart('enumBookingStatusType');
                    $translatePartialLoader.addPart('enumDeptStatus');
                    $translatePartialLoader.addPart('global');
                    $translatePartialLoader.addPart('dept');
                    return $translate.refresh();
                }]
            }
        });
    }
})();

/*
 * Copyright (c) 2017 by Julian Feder, julian.feder@yahoo.de
 *
 * This product includes software developed at
 * The Apache Software Foundation (http://www.apache.org/).
 */

(function() {
    'use strict';
    angular
        .module('askApp')
        .factory('MemberBooking', MemberBooking);

    MemberBooking.$inject = ['$resource'];

    function MemberBooking ($resource) {
        var resourceUrl =  'api/member/bookings';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true},
            'update': {
                method: 'PUT',
                transformRequest: function (data) {
                    var copy = angular.copy(data);
                    return angular.toJson(copy);
                }
            }
        });
    }
})();

/*
 * Copyright (c) 2017 by Julian Feder, julian.feder@yahoo.de
 *
 * This product includes software developed at
 * The Apache Software Foundation (http://www.apache.org/).
 */

(function() {
    'use strict';

    angular
        .module('askApp')
        .controller('MemberBookingController', MemberBookingController);

    MemberBookingController.$inject = ['$state', 'MemberBooking', 'BoardBookingSearch', 'ParseLinks', 'AlertService', 'paginationConstants', 'pagingParams', '$stateParams', '$http'];

    function MemberBookingController($state, MemberBooking, BoardBookingSearch, ParseLinks, AlertService, paginationConstants, pagingParams, $stateParams, $http) {

        var vm = this;

        vm.loadPage = loadPage;
        vm.predicate = pagingParams.predicate;
        vm.reverse = pagingParams.ascending;
        vm.transition = transition;
        vm.itemsPerPage = paginationConstants.itemsPerPage;
        vm.loadAll = loadAll;
        vm.updateBooking = updateBooking;

        loadAll();

        function loadAll () {
            MemberBooking.query({
                page: pagingParams.page - 1,
                size: vm.itemsPerPage,
                sort: sort()
            }, onSuccess, onError);
            function sort() {
                var sorting = vm.reverse ? 'asc' : 'desc';
                var result = [vm.predicate + ',' + sorting];
                if (vm.predicate !== 'id') {
                    result.push('id,' + sorting);
                }
                return result;
            }
            function onSuccess(data, headers) {
                vm.links = ParseLinks.parse(headers('link'));
                vm.totalItems = headers('X-Total-Count');
                vm.queryCount = vm.totalItems;
                vm.bookings = data;
                vm.page = pagingParams.page;
            }
            function onError(error) {
                AlertService.error(error.data.message);
            }
        }

        function loadPage(page) {
            vm.page = page;
            vm.transition();
        }

        function transition() {
            $state.transitionTo($state.$current, {
                page: vm.page,
                sort: vm.predicate + ',' + (vm.reverse ? 'asc' : 'desc'),
                search: vm.currentSearch,
                select: vm.select
            });
        }

        function updateBooking(bookingID, sksTheoryAvailable) {
            var booking = {};
            booking.id = bookingID;
            booking.sksTheoryAvailable = sksTheoryAvailable;
            MemberBooking.update(booking, function(result) {
                console.log(result);
                loadAll();
            }, function () {
                console.log("error");
            });
        }
    }
})();

/*
 * Copyright (c) 2017 by Julian Feder, julian.feder@yahoo.de
 *
 * This product includes software developed at
 * The Apache Software Foundation (http://www.apache.org/).
 */

(function() {
    'use strict';

    angular
        .module('askApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
        .state('member.activities', {
            parent: 'member',
            url: '/member/activities?page&sort&search&query',
            data: {
                authorities: ['ROLE_USER'],
                pageTitle: 'askApp.activities.home.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/member/activities/activities.html',
                    controller: 'ActivitiesMemberController',
                    controllerAs: 'vm'
                }
            },
            params: {
                page: {
                    value: '1',
                    squash: true
                },
                sort: {
                    value: 'activitiesDate,desc',
                    squash: true
                },
                query: {
                    value: 'useable',
                    squash: true
                }
            },
            resolve: {
                pagingParams: ['$stateParams', 'PaginationUtil', function ($stateParams, PaginationUtil) {
                    return {
                        page: PaginationUtil.parsePage($stateParams.page),
                        sort: $stateParams.sort,
                        predicate: PaginationUtil.parsePredicate($stateParams.sort),
                        ascending: PaginationUtil.parseAscending($stateParams.sort),
                        query: $stateParams.query
                    };
                }],
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('activities');
                    $translatePartialLoader.addPart('enumCategoryActivity');
                    $translatePartialLoader.addPart('global');
                    return $translate.refresh();
                }]
            }
        })
    }

})();

/*
 * Copyright (c) 2017 by Julian Feder, julian.feder@yahoo.de
 *
 * This product includes software developed at
 * The Apache Software Foundation (http://www.apache.org/).
 */

(function() {
    'use strict';
    angular
        .module('askApp')
        .factory('ActivitiesMember', ActivitiesMember);

    ActivitiesMember.$inject = ['$resource'];

    function ActivitiesMember ($resource) {
        var resourceUrl =  'api/member/activities/:id';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true}
        });
    }
})();

/*
 * Copyright (c) 2017 by Julian Feder, julian.feder@yahoo.de
 *
 * This product includes software developed at
 * The Apache Software Foundation (http://www.apache.org/).
 */

(function() {
    'use strict';

    angular
        .module('askApp')
        .controller('ActivitiesMemberController', ActivitiesMemberController);

    ActivitiesMemberController.$inject = ['$state', 'ActivitiesMember', 'ParseLinks', 'AlertService', 'paginationConstants', 'pagingParams', '$stateParams'];

    function ActivitiesMemberController($state, ActivitiesMember, ParseLinks, AlertService, paginationConstants, pagingParams, $stateParams) {

        var vm = this;

        vm.loadPage = loadPage;
        vm.predicate = pagingParams.predicate;
        vm.reverse = pagingParams.ascending;
        vm.transition = transition;
        vm.itemsPerPage = paginationConstants.itemsPerPage;
        vm.clear = clear;
        vm.loadAll = loadAll;
        vm.setQuery = setQuery;
        vm.query = pagingParams.query;

        loadAll();

        function setQuery(query) {
            vm.query = query;
            vm.transition();
        }

        function loadAll () {
            ActivitiesMember.query({
                page: pagingParams.page - 1,
                size: vm.itemsPerPage,
                sort: sort(),
                select: $stateParams.query
            }, onSuccess, onError);
            function sort() {
                var sorting = vm.reverse ? 'asc' : 'desc';
                var result = [vm.predicate + ',' + sorting];
                if (vm.predicate !== 'id') {
                    result.push('id,' + sorting);
                }
                return result;
            }
            function onSuccess(data, headers) {
                vm.links = ParseLinks.parse(headers('link'));
                vm.totalItems = headers('X-Total-Count');
                vm.queryCount = vm.totalItems;
                vm.activities = data;
                vm.page = pagingParams.page;
            }
            function onError(error) {
                AlertService.error(error.data.message);
            }
        }

        function loadPage(page) {
            vm.page = page;
            vm.transition();
        }

        function transition() {
            $state.transitionTo($state.$current, {
                page: vm.page,
                sort: vm.predicate + ',' + (vm.reverse ? 'asc' : 'desc'),
                search: vm.currentSearch,
                query: vm.query
            });
        }

        function clear() {
            vm.links = null;
            vm.page = 1;
            vm.predicate = 'activitiesDate';
            vm.reverse = false;
            vm.currentSearch = null;
            vm.transition();
        }
    }
})();

/*
 * Copyright (c) 2017 by Julian Feder, julian.feder@yahoo.de
 *
 * This product includes software developed at
 * The Apache Software Foundation (http://www.apache.org/).
 */

(function() {
    'use strict';

    angular
        .module('askApp')
        .controller('NavbarController', NavbarController);

    NavbarController.$inject = ['$rootScope', '$scope', '$state', 'Auth', 'Principal', 'ProfileService', 'LoginService', 'PrincipalProfile', 'FullMemberService', 'calendarEventTitle', 'calendarDateFilter', '$filter'];

    function NavbarController ($rootScope, $scope, $state, Auth, Principal, ProfileService, LoginService, PrincipalProfile, FullMemberService, calendarEventTitle, calendarDateFilter, $filter) {
        var vm = this;

        vm.isNavbarCollapsed = true;
        vm.isAuthenticated = Principal.isAuthenticated;

        ProfileService.getProfileInfo().then(function(response) {
            vm.inProduction = response.inProduction;
            vm.swaggerEnabled = response.swaggerEnabled;
        });

        reloadPrincipalProfile();

        $scope.$on('authenticationSuccess', function(events, args){
            reloadPrincipalProfile();
        });

        $scope.$on('becomeMember', function(events, args){
            reloadPrincipalProfile();
        });

        function reloadPrincipalProfile() {
            if(vm.isAuthenticated()) {
                PrincipalProfile.identity(true).then(function(profile) {
                    vm.profile = profile;
                });
            }
        }

        vm.login = login;
        vm.fullMember = fullMember;
        vm.logout = logout;
        vm.toggleNavbar = toggleNavbar;
        vm.collapseNavbar = collapseNavbar;
        vm.$state = $state;

        function login() {
            collapseNavbar();
            LoginService.open();
        }

        function fullMember() {
            collapseNavbar();
            FullMemberService.open();
        }

        function logout() {
            collapseNavbar();
            Auth.logout();
            $state.go('home');
        }

        function toggleNavbar() {
            vm.isNavbarCollapsed = !vm.isNavbarCollapsed;
        }

        function collapseNavbar() {
            vm.isNavbarCollapsed = true;
        }

        calendarEventTitle.monthView = function(event) {
            if (event.allDay) {
                return event.title;
            }
            var fromDate = new Date(event.startsAt).setHours(0, 0, 0, 0);
            var untilDate = new Date(event.endsAt).setHours(0, 0, 0, 0);
            if (fromDate !== untilDate) {
                if (event.startsAt.getFullYear() === event.endsAt.getFullYear()) {
                    return event.title + ' (' + $filter('date')(event.startsAt, 'dd.MM. HH:mm') + ' - ' + $filter('date')(event.endsAt, 'dd.MM. HH:mm') + ')';
                } else {
                    return event.title + ' (' + $filter('date')(event.startsAt, 'dd.MM.yy HH:mm') + ' - ' + $filter('date')(event.endsAt, 'dd.MM.yy HH:mm') + ')';
                }
            }
            return event.title + ' (' + calendarDateFilter(event.startsAt, 'time', true) + ')';
            // if (event.startsAt === event.endsAt) {
            //     return event.title + ' (' + calendarDateFilter(event.startsAt, 'time', true) + ')';
            // } else {
            //     return event.title + ' (' + calendarDateFilter(event.startsAt, 'time', true) + '-' + calendarDateFilter(event.endsAt, 'time', true) + ')';
            // }
        }

        calendarEventTitle.monthViewTooltip = function(event) {
            if (event.allDay) {
                return event.title;
            }
            var fromDate = new Date(event.startsAt).setHours(0, 0, 0, 0);
            var untilDate = new Date(event.endsAt).setHours(0, 0, 0, 0);
            if (fromDate !== untilDate) {
                if (event.startsAt.getFullYear() === event.endsAt.getFullYear()) {
                    return $filter('date')(event.startsAt, 'dd.MM. HH:mm') + ' - ' + $filter('date')(event.endsAt, 'dd.MM. HH:mm') + ' - ' + event.title;
                } else {
                    return $filter('date')(event.startsAt, 'dd.MM.yy HH:mm') + ' - ' + $filter('date')(event.endsAt, 'dd.MM.yy HH:mm') + ' - ' + event.title;
                }
            }
            return calendarDateFilter(event.startsAt, 'time', true) + ' - ' + event.title;
        }
    }
})();

/*
 * Copyright (c) 2017 by Julian Feder, julian.feder@yahoo.de
 *
 * This product includes software developed at
 * The Apache Software Foundation (http://www.apache.org/).
 */

(function() {
    'use strict';

    angular
        .module('askApp')
        .directive('activeMenu', activeMenu);

    activeMenu.$inject = ['$translate', '$locale', 'tmhDynamicLocale'];

    function activeMenu($translate, $locale, tmhDynamicLocale) {
        var directive = {
            restrict: 'A',
            link: linkFunc
        };

        return directive;

        function linkFunc(scope, element, attrs) {
            var language = attrs.activeMenu;

            scope.$watch(function() {
                return $translate.use();
            }, function(selectedLanguage) {
                if (language === selectedLanguage) {
                    tmhDynamicLocale.set(language);
                    element.addClass('active');
                } else {
                    element.removeClass('active');
                }
            });
        }
    }
})();

/*
 * Copyright (c) 2017 by Julian Feder, julian.feder@yahoo.de
 *
 * This product includes software developed at
 * The Apache Software Foundation (http://www.apache.org/).
 */

(function() {
    'use strict';

    angular
        .module('askApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
            .state('error', {
                parent: 'app',
                url: '/error',
                data: {
                    authorities: [],
                    pageTitle: 'error.title'
                },
                views: {
                    'content@': {
                        templateUrl: 'app/layouts/error/error.html'
                    }
                },
                resolve: {
                    translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                        $translatePartialLoader.addPart('error');
                        return $translate.refresh();
                    }]
                }
            })
            .state('accessdenied', {
                parent: 'app',
                url: '/accessdenied',
                data: {
                    authorities: []
                },
                views: {
                    'content@': {
                        templateUrl: 'app/layouts/error/accessdenied.html'
                    }
                },
                resolve: {
                    translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                        $translatePartialLoader.addPart('error');
                        return $translate.refresh();
                    }]
                }
            });
    }
})();

/*
 * Copyright (c) 2019 by Felix Heim, felix-heim@web.de
 *
 * This product includes software developed at
 * The Apache Software Foundation (http://www.apache.org/).
 */

(function() {
    'use strict';

    angular
        .module('askApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider.state('privacy', {
            parent: 'app',
            url: '/privacy',
            data: {
                authorities: [],
                pageTitle: "home.privacy.title"
            },
            views: {
                'content@': {
                    templateUrl: 'app/home/privacy.html',
                    controller: 'PrivacyController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate,$translatePartialLoader) {
                    $translatePartialLoader.addPart('home');
                    return $translate.refresh();
                }]
            }
        });
    }
})();

/*
 * Copyright (c) 2019 by Felix Heim, felix-heim@web.de
 *
 * This product includes software developed at
 * The Apache Software Foundation (http://www.apache.org/).
 */

(function() {
    'use strict';

    angular
        .module('askApp')
        .controller('PrivacyController', PrivacyController);

    PrivacyController.$inject = ['$scope'];

    function PrivacyController ($scope) {
        var vm = this;
    }
})();

/*
 * Copyright (c) 2017 by Julian Feder, julian.feder@yahoo.de
 *
 * This product includes software developed at
 * The Apache Software Foundation (http://www.apache.org/).
 */

(function() {
    'use strict';

    angular
        .module('askApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider.state('home', {
            parent: 'app',
            url: '/',
            data: {
                authorities: []
            },
            views: {
                'content@': {
                    templateUrl: 'app/home/home.html',
                    controller: 'HomeController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate,$translatePartialLoader) {
                    $translatePartialLoader.addPart('home');
                    $translatePartialLoader.addPart('register');
                    $translatePartialLoader.addPart('profile');
                    $translatePartialLoader.addPart('settings');
                    $translatePartialLoader.addPart('enumGender');
                    $translatePartialLoader.addPart('enumCountry');
                    return $translate.refresh();
                }]
            }
        });
    }
})();

/*
 * Copyright (c) 2017 by Julian Feder, julian.feder@yahoo.de
 *
 * This product includes software developed at
 * The Apache Software Foundation (http://www.apache.org/).
 */

(function() {
    'use strict';

    angular
        .module('askApp')
        .controller('HomeController', HomeController);

    HomeController.$inject = ['$scope', 'Principal', 'LoginService', '$state', 'PrincipalProfile', '$http', 'AlertService'];

    function HomeController ($scope, Principal, LoginService, $state, PrincipalProfile, $http, AlertService) {
        var vm = this;

        vm.account = null;
        vm.isAuthenticated = null;
        vm.login = LoginService.open;
        vm.register = register;
        vm.limited = true;
        vm.initLimit = 3;
        vm.limit = vm.initLimit;
        vm.dataExport = dataExport;
        $scope.$on('authenticationSuccess', function() {
            getAccount();
        });

        getAccount();

        function getAccount() {
            Principal.identity().then(function(account) {
                vm.account = account;
                vm.isAuthenticated = Principal.isAuthenticated;
                if(vm.isAuthenticated()) {
                    PrincipalProfile.identity(true).then(function(profile) {
                        vm.profile = profile;
                    });
                    getInstructorOverview();
                    getSksTripSkipperOverview();
                }
            });
        }

        function register () {
            $state.go('register');
        }

        function getInstructorOverview() {
            $http.get('api/member/sbf-time-slots/overview/', {}).then(function(response) {
                vm.instructorOverview = response.data;
            });
        }

        function getSksTripSkipperOverview() {
            $http.get('api/member/projects/sksTrip/', {}).then(function(response) {
                vm.sksSkipperOverview = response.data;
            });
        }

        vm.toggleLimit = function() {
            vm.limited = !vm.limited;
            if(vm.limited) {
                vm.limit = vm.initLimit;
            } else {
                vm.limit = vm.instructorOverview.length;
            }
        };

        function dataExport(projectId) {
            vm.isSaving = true;
            $http.get('api/member/projects/sksTrip/export/', {params: {
                    projectId: projectId
                }}).then(function(response) {
                vm.isSaving = false;
                AlertService.success("Der Export wurde erfolgreich durchgeführt und an deine E-Mail Adresse geschickt.");
            });
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('askApp')
        .controller('SkipperLevelHolderDialogController', SkipperLevelHolderDialogController);

    SkipperLevelHolderDialogController.$inject = ['$timeout', '$scope', '$stateParams', '$uibModalInstance', 'entity', 'SkipperLevelHolder'];

    function SkipperLevelHolderDialogController ($timeout, $scope, $stateParams, $uibModalInstance, entity, SkipperLevelHolder) {
        var vm = this;

        vm.skipperLevelHolder = entity;
        vm.clear = clear;
        vm.save = save;

        $timeout(function (){
            angular.element('.form-group:eq(1)>input').focus();
        });

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function save () {
            vm.isSaving = true;
            if (vm.skipperLevelHolder.id !== null) {
                SkipperLevelHolder.update(vm.skipperLevelHolder, onSaveSuccess, onSaveError);
            } else {
                SkipperLevelHolder.save(vm.skipperLevelHolder, onSaveSuccess, onSaveError);
            }
        }

        function onSaveSuccess (result) {
            $scope.$emit('askApp:skipperLevelHolderUpdate', result);
            $uibModalInstance.close(result);
            vm.isSaving = false;
        }

        function onSaveError () {
            vm.isSaving = false;
        }


    }
})();

(function() {
    'use strict';

    angular
        .module('askApp')
        .controller('SkipperLevelHolderDetailController', SkipperLevelHolderDetailController);

    SkipperLevelHolderDetailController.$inject = ['$scope', '$rootScope', '$stateParams', 'previousState', 'entity', 'SkipperLevelHolder'];

    function SkipperLevelHolderDetailController($scope, $rootScope, $stateParams, previousState, entity, SkipperLevelHolder) {
        var vm = this;

        vm.skipperLevelHolder = entity;
        vm.previousState = previousState.name;

        var unsubscribe = $rootScope.$on('askApp:skipperLevelHolderUpdate', function(event, result) {
            vm.skipperLevelHolder = result;
        });
        $scope.$on('$destroy', unsubscribe);
    }
})();

(function() {
    'use strict';

    angular
        .module('askApp')
        .controller('SkipperLevelHolderDeleteController',SkipperLevelHolderDeleteController);

    SkipperLevelHolderDeleteController.$inject = ['$uibModalInstance', 'entity', 'SkipperLevelHolder'];

    function SkipperLevelHolderDeleteController($uibModalInstance, entity, SkipperLevelHolder) {
        var vm = this;

        vm.skipperLevelHolder = entity;
        vm.clear = clear;
        vm.confirmDelete = confirmDelete;

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function confirmDelete (id) {
            SkipperLevelHolder.delete({id: id},
                function () {
                    $uibModalInstance.close(true);
                });
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('askApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
        .state('skipper-level-holder', {
            parent: 'entity',
            url: '/skipper-level-holder',
            data: {
                authorities: ['ROLE_ADMIN'],
                pageTitle: 'askApp.skipperLevelHolder.home.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/skipper-level-holder/skipper-level-holders.html',
                    controller: 'SkipperLevelHolderController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('skipperLevelHolder');
                    $translatePartialLoader.addPart('enumSkipperLevel');
                    $translatePartialLoader.addPart('global');
                    return $translate.refresh();
                }]
            }
        })
        .state('skipper-level-holder-detail', {
            parent: 'skipper-level-holder',
            url: '/skipper-level-holder/{id}',
            data: {
                authorities: ['ROLE_ADMIN'],
                pageTitle: 'askApp.skipperLevelHolder.detail.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/skipper-level-holder/skipper-level-holder-detail.html',
                    controller: 'SkipperLevelHolderDetailController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('skipperLevelHolder');
                    $translatePartialLoader.addPart('enumSkipperLevel');
                    return $translate.refresh();
                }],
                entity: ['$stateParams', 'SkipperLevelHolder', function($stateParams, SkipperLevelHolder) {
                    return SkipperLevelHolder.get({id : $stateParams.id}).$promise;
                }],
                previousState: ["$state", function ($state) {
                    var currentStateData = {
                        name: $state.current.name || 'skipper-level-holder',
                        params: $state.params,
                        url: $state.href($state.current.name, $state.params)
                    };
                    return currentStateData;
                }]
            }
        })
        .state('skipper-level-holder-detail.edit', {
            parent: 'skipper-level-holder-detail',
            url: '/detail/edit',
            data: {
                authorities: ['ROLE_ADMIN']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/skipper-level-holder/skipper-level-holder-dialog.html',
                    controller: 'SkipperLevelHolderDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: ['SkipperLevelHolder', function(SkipperLevelHolder) {
                            return SkipperLevelHolder.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('^', {}, { reload: false });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('skipper-level-holder.new', {
            parent: 'skipper-level-holder',
            url: '/new',
            data: {
                authorities: ['ROLE_ADMIN']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/skipper-level-holder/skipper-level-holder-dialog.html',
                    controller: 'SkipperLevelHolderDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: function () {
                            return {
                                skipperLevel: null,
                                id: null
                            };
                        }
                    }
                }).result.then(function() {
                    $state.go('skipper-level-holder', null, { reload: 'skipper-level-holder' });
                }, function() {
                    $state.go('skipper-level-holder');
                });
            }]
        })
        .state('skipper-level-holder.edit', {
            parent: 'skipper-level-holder',
            url: '/{id}/edit',
            data: {
                authorities: ['ROLE_ADMIN']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/skipper-level-holder/skipper-level-holder-dialog.html',
                    controller: 'SkipperLevelHolderDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: ['SkipperLevelHolder', function(SkipperLevelHolder) {
                            return SkipperLevelHolder.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('skipper-level-holder', null, { reload: 'skipper-level-holder' });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('skipper-level-holder.delete', {
            parent: 'skipper-level-holder',
            url: '/{id}/delete',
            data: {
                authorities: ['ROLE_ADMIN']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/skipper-level-holder/skipper-level-holder-delete-dialog.html',
                    controller: 'SkipperLevelHolderDeleteController',
                    controllerAs: 'vm',
                    size: 'md',
                    resolve: {
                        entity: ['SkipperLevelHolder', function(SkipperLevelHolder) {
                            return SkipperLevelHolder.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('skipper-level-holder', null, { reload: 'skipper-level-holder' });
                }, function() {
                    $state.go('^');
                });
            }]
        });
    }

})();

(function() {
    'use strict';
    angular
        .module('askApp')
        .factory('SkipperLevelHolder', SkipperLevelHolder);

    SkipperLevelHolder.$inject = ['$resource'];

    function SkipperLevelHolder ($resource) {
        var resourceUrl =  'api/skipper-level-holders/:id';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true},
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                    }
                    return data;
                }
            },
            'update': { method:'PUT' }
        });
    }
})();

(function() {
    'use strict';

    angular
        .module('askApp')
        .factory('SkipperLevelHolderSearch', SkipperLevelHolderSearch);

    SkipperLevelHolderSearch.$inject = ['$resource'];

    function SkipperLevelHolderSearch($resource) {
        var resourceUrl =  'api/_search/skipper-level-holders/:id';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true}
        });
    }
})();

(function() {
    'use strict';

    angular
        .module('askApp')
        .controller('SkipperLevelHolderController', SkipperLevelHolderController);

    SkipperLevelHolderController.$inject = ['SkipperLevelHolder', 'SkipperLevelHolderSearch'];

    function SkipperLevelHolderController(SkipperLevelHolder, SkipperLevelHolderSearch) {

        var vm = this;

        vm.skipperLevelHolders = [];
        vm.clear = clear;
        vm.search = search;
        vm.loadAll = loadAll;

        loadAll();

        function loadAll() {
            SkipperLevelHolder.query(function(result) {
                vm.skipperLevelHolders = result;
                vm.searchQuery = null;
            });
        }

        function search() {
            if (!vm.searchQuery) {
                return vm.loadAll();
            }
            SkipperLevelHolderSearch.query({query: vm.searchQuery}, function(result) {
                vm.skipperLevelHolders = result;
                vm.currentSearch = vm.searchQuery;
            });
        }

        function clear() {
            vm.searchQuery = null;
            loadAll();
        }    }
})();

/*
 * Copyright (c) 2017 by Julian Feder, julian.feder@yahoo.de
 *
 * This product includes software developed at
 * The Apache Software Foundation (http://www.apache.org/).
 */

(function() {
    'use strict';

    angular
        .module('askApp')
        .controller('ProjectDialogController', ProjectDialogController);

    ProjectDialogController.$inject = ['$timeout', '$scope', '$stateParams', '$uibModalInstance', 'DataUtils', 'entity', 'Project', 'Booking', 'Profile', 'SbfTimeSlot', 'Authority'];

    function ProjectDialogController ($timeout, $scope, $stateParams, $uibModalInstance, DataUtils, entity, Project, Booking, Profile, SbfTimeSlot, Authority) {
        var vm = this;

        vm.project = entity;
        vm.clear = clear;
        vm.datePickerOpenStatus = {};
        vm.openCalendar = openCalendar;
        vm.byteSize = DataUtils.byteSize;
        vm.openFile = DataUtils.openFile;
        vm.save = save;
        vm.bookings = Booking.query();
        vm.profiles = Profile.query();
        vm.sbftimeslots = SbfTimeSlot.query();
        vm.authorities = Authority.query();
        vm.projects = Project.query();

        $timeout(function (){
            angular.element('.form-group:eq(1)>input').focus();
        });

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function save () {
            vm.isSaving = true;
            if (vm.project.id !== null) {
                Project.update(vm.project, onSaveSuccess, onSaveError);
            } else {
                Project.save(vm.project, onSaveSuccess, onSaveError);
            }
        }

        function onSaveSuccess (result) {
            $scope.$emit('askApp:projectUpdate', result);
            $uibModalInstance.close(result);
            vm.isSaving = false;
        }

        function onSaveError () {
            vm.isSaving = false;
        }

        vm.datePickerOpenStatus.fromDate = false;
        vm.datePickerOpenStatus.untilDate = false;

        vm.setImage = function ($file, project) {
            if ($file && $file.$error === 'pattern') {
                return;
            }
            if ($file) {
                DataUtils.toBase64($file, function(base64Data) {
                    $scope.$apply(function() {
                        project.image = base64Data;
                        project.imageContentType = $file.type;
                    });
                });
            }
        };

        function openCalendar (date) {
            vm.datePickerOpenStatus[date] = true;
        }
    }
})();

/*
 * Copyright (c) 2017 by Julian Feder, julian.feder@yahoo.de
 *
 * This product includes software developed at
 * The Apache Software Foundation (http://www.apache.org/).
 */

(function() {
    'use strict';

    angular
        .module('askApp')
        .controller('ProjectDetailController', ProjectDetailController);

    ProjectDetailController.$inject = ['$scope', '$rootScope', '$stateParams', 'previousState', 'DataUtils', 'entity', 'Project', 'Booking', 'Profile', 'SbfTimeSlot', 'Authority'];

    function ProjectDetailController($scope, $rootScope, $stateParams, previousState, DataUtils, entity, Project, Booking, Profile, SbfTimeSlot, Authority) {
        var vm = this;

        vm.project = entity;
        vm.previousState = previousState.name;
        vm.byteSize = DataUtils.byteSize;
        vm.openFile = DataUtils.openFile;

        var unsubscribe = $rootScope.$on('askApp:projectUpdate', function(event, result) {
            vm.project = result;
        });
        $scope.$on('$destroy', unsubscribe);
    }
})();

/*
 * Copyright (c) 2017 by Julian Feder, julian.feder@yahoo.de
 *
 * This product includes software developed at
 * The Apache Software Foundation (http://www.apache.org/).
 */

(function() {
    'use strict';

    angular
        .module('askApp')
        .controller('ProjectDeleteController',ProjectDeleteController);

    ProjectDeleteController.$inject = ['$uibModalInstance', 'entity', 'Project'];

    function ProjectDeleteController($uibModalInstance, entity, Project) {
        var vm = this;

        vm.project = entity;
        vm.clear = clear;
        vm.confirmDelete = confirmDelete;

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function confirmDelete (id) {
            Project.delete({id: id},
                function () {
                    $uibModalInstance.close(true);
                });
        }
    }
})();

/*
 * Copyright (c) 2017 by Julian Feder, julian.feder@yahoo.de
 *
 * This product includes software developed at
 * The Apache Software Foundation (http://www.apache.org/).
 */

(function() {
    'use strict';

    angular
        .module('askApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
        .state('project', {
            parent: 'entity',
            url: '/project?page&sort&search',
            data: {
                authorities: ['ROLE_ADMIN'],
                pageTitle: 'askApp.project.home.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/project/projects.html',
                    controller: 'ProjectController',
                    controllerAs: 'vm'
                }
            },
            params: {
                page: {
                    value: '1',
                    squash: true
                },
                sort: {
                    value: 'id,asc',
                    squash: true
                },
                search: null
            },
            resolve: {
                pagingParams: ['$stateParams', 'PaginationUtil', function ($stateParams, PaginationUtil) {
                    return {
                        page: PaginationUtil.parsePage($stateParams.page),
                        sort: $stateParams.sort,
                        predicate: PaginationUtil.parsePredicate($stateParams.sort),
                        ascending: PaginationUtil.parseAscending($stateParams.sort),
                        search: $stateParams.search
                    };
                }],
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('project');
                    $translatePartialLoader.addPart('enumProjectType');
                    $translatePartialLoader.addPart('enumSksPracticalLocation');
                    $translatePartialLoader.addPart('global');
                    return $translate.refresh();
                }]
            }
        })
        .state('project-detail', {
            parent: 'project',
            url: '/project/{id}',
            data: {
                authorities: ['ROLE_ADMIN'],
                pageTitle: 'askApp.project.detail.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/project/project-detail.html',
                    controller: 'ProjectDetailController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('project');
                    $translatePartialLoader.addPart('enumProjectType');
                    $translatePartialLoader.addPart('enumSksPracticalLocation');
                    return $translate.refresh();
                }],
                entity: ['$stateParams', 'Project', function($stateParams, Project) {
                    return Project.get({id : $stateParams.id}).$promise;
                }],
                previousState: ["$state", function ($state) {
                    var currentStateData = {
                        name: $state.current.name || 'project',
                        params: $state.params,
                        url: $state.href($state.current.name, $state.params)
                    };
                    return currentStateData;
                }]
            }
        })
        .state('project-detail.edit', {
            parent: 'project-detail',
            url: '/detail/edit',
            data: {
                authorities: ['ROLE_ADMIN']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/project/project-dialog.html',
                    controller: 'ProjectDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: ['Project', function(Project) {
                            return Project.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('^', {}, { reload: false });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('project.new', {
            parent: 'project',
            url: '/new',
            data: {
                authorities: ['ROLE_ADMIN']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/project/project-dialog.html',
                    controller: 'ProjectDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: function () {
                            return {
                                name: null,
                                fromDate: null,
                                untilDate: null,
                                places: null,
                                identifier: null,
                                description: null,
                                conditions: null,
                                notes: null,
                                normalPrice: null,
                                studentPrice: null,
                                guestPrice: null,
                                individualPrice: null,
                                prepayment: null,
                                type: null,
                                sksPracticalLocation: null,
                                visible: null,
                                closed: null,
                                guest: null,
                                image: null,
                                imageContentType: null,
                                weight: null,
                                clothingSize: null,
                                shoeSize: null,
                                nationality: null,
                                countryOfBirth: null,
                                birthplace: null,
                                idNumber: null,
                                active: null,
                                checkRegisterDate: null,
                                queue: null,
                                activityPoints: null,
                                email: null,
                                booked: null,
                                individualField: null,
                                additionalBookable: null,
                                sbfSlotsMax: null,
                                id: null
                            };
                        }
                    }
                }).result.then(function() {
                    $state.go('project', null, { reload: 'project' });
                }, function() {
                    $state.go('project');
                });
            }]
        })
        .state('project.edit', {
            parent: 'project',
            url: '/{id}/edit',
            data: {
                authorities: ['ROLE_ADMIN']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/project/project-dialog.html',
                    controller: 'ProjectDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: ['Project', function(Project) {
                            return Project.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('project', null, { reload: 'project' });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('project.delete', {
            parent: 'project',
            url: '/{id}/delete',
            data: {
                authorities: ['ROLE_ADMIN']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/project/project-delete-dialog.html',
                    controller: 'ProjectDeleteController',
                    controllerAs: 'vm',
                    size: 'md',
                    resolve: {
                        entity: ['Project', function(Project) {
                            return Project.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('project', null, { reload: 'project' });
                }, function() {
                    $state.go('^');
                });
            }]
        });
    }

})();

/*
 * Copyright (c) 2017 by Julian Feder, julian.feder@yahoo.de
 *
 * This product includes software developed at
 * The Apache Software Foundation (http://www.apache.org/).
 */

(function() {
    'use strict';
    angular
        .module('askApp')
        .factory('Project', Project);

    Project.$inject = ['$resource', 'DateUtils'];

    function Project ($resource, DateUtils) {
        var resourceUrl =  'api/projects/:id';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true},
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                        data.fromDate = DateUtils.convertLocalDateFromServer(data.fromDate);
                        data.untilDate = DateUtils.convertLocalDateFromServer(data.untilDate);
                    }
                    return data;
                }
            },
            'update': {
                method: 'PUT',
                transformRequest: function (data) {
                    var copy = angular.copy(data);
                    copy.fromDate = DateUtils.convertLocalDateToServer(copy.fromDate);
                    copy.untilDate = DateUtils.convertLocalDateToServer(copy.untilDate);
                    return angular.toJson(copy);
                }
            },
            'save': {
                method: 'POST',
                transformRequest: function (data) {
                    var copy = angular.copy(data);
                    copy.fromDate = DateUtils.convertLocalDateToServer(copy.fromDate);
                    copy.untilDate = DateUtils.convertLocalDateToServer(copy.untilDate);
                    return angular.toJson(copy);
                }
            }
        });
    }
})();

/*
 * Copyright (c) 2017 by Julian Feder, julian.feder@yahoo.de
 *
 * This product includes software developed at
 * The Apache Software Foundation (http://www.apache.org/).
 */

(function() {
    'use strict';

    angular
        .module('askApp')
        .factory('ProjectSearch', ProjectSearch);

    ProjectSearch.$inject = ['$resource'];

    function ProjectSearch($resource) {
        var resourceUrl =  'api/_search/projects/:id';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true}
        });
    }
})();

/*
 * Copyright (c) 2017 by Julian Feder, julian.feder@yahoo.de
 *
 * This product includes software developed at
 * The Apache Software Foundation (http://www.apache.org/).
 */

(function() {
    'use strict';

    angular
        .module('askApp')
        .controller('ProjectController', ProjectController);

    ProjectController.$inject = ['$state', 'DataUtils', 'Project', 'ProjectSearch', 'ParseLinks', 'AlertService', 'paginationConstants', 'pagingParams'];

    function ProjectController($state, DataUtils, Project, ProjectSearch, ParseLinks, AlertService, paginationConstants, pagingParams) {

        var vm = this;

        vm.loadPage = loadPage;
        vm.predicate = pagingParams.predicate;
        vm.reverse = pagingParams.ascending;
        vm.transition = transition;
        vm.itemsPerPage = paginationConstants.itemsPerPage;
        vm.clear = clear;
        vm.search = search;
        vm.loadAll = loadAll;
        vm.searchQuery = pagingParams.search;
        vm.currentSearch = pagingParams.search;
        vm.openFile = DataUtils.openFile;
        vm.byteSize = DataUtils.byteSize;

        loadAll();

        function loadAll () {
            if (pagingParams.search) {
                ProjectSearch.query({
                    query: pagingParams.search,
                    page: pagingParams.page - 1,
                    size: vm.itemsPerPage,
                    sort: sort()
                }, onSuccess, onError);
            } else {
                Project.query({
                    page: pagingParams.page - 1,
                    size: vm.itemsPerPage,
                    sort: sort()
                }, onSuccess, onError);
            }
            function sort() {
                var result = [vm.predicate + ',' + (vm.reverse ? 'asc' : 'desc')];
                if (vm.predicate !== 'id') {
                    result.push('id');
                }
                return result;
            }
            function onSuccess(data, headers) {
                vm.links = ParseLinks.parse(headers('link'));
                vm.totalItems = headers('X-Total-Count');
                vm.queryCount = vm.totalItems;
                vm.projects = data;
                vm.page = pagingParams.page;
            }
            function onError(error) {
                AlertService.error(error.data.message);
            }
        }

        function loadPage(page) {
            vm.page = page;
            vm.transition();
        }

        function transition() {
            $state.transitionTo($state.$current, {
                page: vm.page,
                sort: vm.predicate + ',' + (vm.reverse ? 'asc' : 'desc'),
                search: vm.currentSearch
            });
        }

        function search(searchQuery) {
            if (!searchQuery){
                return vm.clear();
            }
            vm.links = null;
            vm.page = 1;
            vm.predicate = '_score';
            vm.reverse = false;
            vm.currentSearch = searchQuery;
            vm.transition();
        }

        function clear() {
            vm.links = null;
            vm.page = 1;
            vm.predicate = 'id';
            vm.reverse = true;
            vm.currentSearch = null;
            vm.transition();
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('askApp')
        .controller('ProfileDialogController', ProfileDialogController);

    ProfileDialogController.$inject = ['$timeout', '$scope', '$stateParams', '$uibModalInstance', '$q', 'DataUtils', 'entity', 'Profile', 'User', 'SkipperLevelHolder'];

    function ProfileDialogController ($timeout, $scope, $stateParams, $uibModalInstance, $q, DataUtils, entity, Profile, User, SkipperLevelHolder) {
        var vm = this;

        vm.profile = entity;
        vm.clear = clear;
        vm.datePickerOpenStatus = {};
        vm.openCalendar = openCalendar;
        vm.byteSize = DataUtils.byteSize;
        vm.openFile = DataUtils.openFile;
        vm.save = save;
        vm.users = User.query();
        vm.skipperlevelholders = SkipperLevelHolder.query();

        $timeout(function (){
            angular.element('.form-group:eq(1)>input').focus();
        });

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function save () {
            vm.isSaving = true;
            if (vm.profile.id !== null) {
                Profile.update(vm.profile, onSaveSuccess, onSaveError);
            } else {
                Profile.save(vm.profile, onSaveSuccess, onSaveError);
            }
        }

        function onSaveSuccess (result) {
            $scope.$emit('askApp:profileUpdate', result);
            $uibModalInstance.close(result);
            vm.isSaving = false;
        }

        function onSaveError () {
            vm.isSaving = false;
        }

        vm.datePickerOpenStatus.birthdate = false;
        vm.datePickerOpenStatus.expelledDate = false;

        vm.setMatriculationCertificate = function ($file, profile) {
            if ($file) {
                DataUtils.toBase64($file, function(base64Data) {
                    $scope.$apply(function() {
                        profile.matriculationCertificate = base64Data;
                        profile.matriculationCertificateContentType = $file.type;
                    });
                });
            }
        };
        vm.datePickerOpenStatus.matriculationDate = false;
        vm.datePickerOpenStatus.idExpirationDate = false;
        vm.datePickerOpenStatus.lastLogin = false;
        vm.datePickerOpenStatus.fullMemberDate = false;
        vm.datePickerOpenStatus.isafDate = false;

        vm.setImage = function ($file, profile) {
            if ($file && $file.$error === 'pattern') {
                return;
            }
            if ($file) {
                DataUtils.toBase64($file, function(base64Data) {
                    $scope.$apply(function() {
                        profile.image = base64Data;
                        profile.imageContentType = $file.type;
                    });
                });
            }
        };

        function openCalendar (date) {
            vm.datePickerOpenStatus[date] = true;
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('askApp')
        .controller('ProfileDetailController', ProfileDetailController);

    ProfileDetailController.$inject = ['$scope', '$rootScope', '$stateParams', 'previousState', 'DataUtils', 'entity', 'Profile', 'User', 'SkipperLevelHolder'];

    function ProfileDetailController($scope, $rootScope, $stateParams, previousState, DataUtils, entity, Profile, User, SkipperLevelHolder) {
        var vm = this;

        vm.profile = entity;
        vm.previousState = previousState.name;
        vm.byteSize = DataUtils.byteSize;
        vm.openFile = DataUtils.openFile;

        var unsubscribe = $rootScope.$on('askApp:profileUpdate', function(event, result) {
            vm.profile = result;
        });
        $scope.$on('$destroy', unsubscribe);
    }
})();

(function() {
    'use strict';

    angular
        .module('askApp')
        .controller('ProfileDeleteController',ProfileDeleteController);

    ProfileDeleteController.$inject = ['$uibModalInstance', 'entity', 'Profile'];

    function ProfileDeleteController($uibModalInstance, entity, Profile) {
        var vm = this;

        vm.profile = entity;
        vm.clear = clear;
        vm.confirmDelete = confirmDelete;

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function confirmDelete (id) {
            Profile.delete({id: id},
                function () {
                    $uibModalInstance.close(true);
                });
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('askApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
        .state('profile', {
            parent: 'entity',
            url: '/profile?page&sort&search',
            data: {
                authorities: ['ROLE_ADMIN'],
                pageTitle: 'askApp.profile.home.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/profile/profiles.html',
                    controller: 'ProfileController',
                    controllerAs: 'vm'
                }
            },
            params: {
                page: {
                    value: '1',
                    squash: true
                },
                sort: {
                    value: 'id,asc',
                    squash: true
                },
                search: null
            },
            resolve: {
                pagingParams: ['$stateParams', 'PaginationUtil', function ($stateParams, PaginationUtil) {
                    return {
                        page: PaginationUtil.parsePage($stateParams.page),
                        sort: $stateParams.sort,
                        predicate: PaginationUtil.parsePredicate($stateParams.sort),
                        ascending: PaginationUtil.parseAscending($stateParams.sort),
                        search: $stateParams.search
                    };
                }],
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('profile');
                    $translatePartialLoader.addPart('enumCountry');
                    $translatePartialLoader.addPart('enumClothingSize');
                    $translatePartialLoader.addPart('enumCountry');
                    $translatePartialLoader.addPart('enumCountry');
                    $translatePartialLoader.addPart('enumGender');
                    $translatePartialLoader.addPart('enumMemberStatus');
                    $translatePartialLoader.addPart('enumIDType');
                    $translatePartialLoader.addPart('global');
                    return $translate.refresh();
                }]
            }
        })
        .state('profile-detail', {
            parent: 'profile',
            url: '/profile/{id}',
            data: {
                authorities: ['ROLE_ADMIN'],
                pageTitle: 'askApp.profile.detail.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/profile/profile-detail.html',
                    controller: 'ProfileDetailController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('profile');
                    $translatePartialLoader.addPart('enumCountry');
                    $translatePartialLoader.addPart('enumClothingSize');
                    $translatePartialLoader.addPart('enumCountry');
                    $translatePartialLoader.addPart('enumCountry');
                    $translatePartialLoader.addPart('enumGender');
                    $translatePartialLoader.addPart('enumMemberStatus');
                    $translatePartialLoader.addPart('enumIDType');
                    return $translate.refresh();
                }],
                entity: ['$stateParams', 'Profile', function($stateParams, Profile) {
                    return Profile.get({id : $stateParams.id}).$promise;
                }],
                previousState: ["$state", function ($state) {
                    var currentStateData = {
                        name: $state.current.name || 'profile',
                        params: $state.params,
                        url: $state.href($state.current.name, $state.params)
                    };
                    return currentStateData;
                }]
            }
        })
        .state('profile-detail.edit', {
            parent: 'profile-detail',
            url: '/detail/edit',
            data: {
                authorities: ['ROLE_ADMIN']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/profile/profile-dialog.html',
                    controller: 'ProfileDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: ['Profile', function(Profile) {
                            return Profile.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('^', {}, { reload: false });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('profile.new', {
            parent: 'profile',
            url: '/new',
            data: {
                authorities: ['ROLE_ADMIN']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/profile/profile-dialog.html',
                    controller: 'ProfileDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: function () {
                            return {
                                nickname: null,
                                street: null,
                                city: null,
                                country: null,
                                postcode: null,
                                weight: null,
                                clothingSize: null,
                                shoeSize: null,
                                nationality: null,
                                birthplace: null,
                                countryOfBirth: null,
                                phone: null,
                                gender: null,
                                birthdate: null,
                                isStudent: null,
                                isVerified: null,
                                memberStatus: null,
                                expelledDate: null,
                                university: null,
                                matriculationCertificate: null,
                                matriculationCertificateContentType: null,
                                matriculationDate: null,
                                isUsingSepa: null,
                                bankAccountHolder: null,
                                iban: null,
                                bic: null,
                                isDeviatedHolder: null,
                                emailBackup: null,
                                idNumber: null,
                                idExpirationDate: null,
                                idType: null,
                                lastLogin: null,
                                fullMemberDate: null,
                                commentBoard: null,
                                commentSkipper: null,
                                wantsMembershipTermination: null,
                                wantsNewsletter: null,
                                sbfBinnen: null,
                                sbfSee: null,
                                sks: null,
                                sss: null,
                                shs: null,
                                ubi: null,
                                src: null,
                                lrc: null,
                                bsp: null,
                                fkn: null,
                                isaf: null,
                                isafDate: null,
                                image: null,
                                imageContentType: null,
                                id: null
                            };
                        }
                    }
                }).result.then(function() {
                    $state.go('profile', null, { reload: 'profile' });
                }, function() {
                    $state.go('profile');
                });
            }]
        })
        .state('profile.edit', {
            parent: 'profile',
            url: '/{id}/edit',
            data: {
                authorities: ['ROLE_ADMIN']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/profile/profile-dialog.html',
                    controller: 'ProfileDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: ['Profile', function(Profile) {
                            return Profile.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('profile', null, { reload: 'profile' });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('profile.delete', {
            parent: 'profile',
            url: '/{id}/delete',
            data: {
                authorities: ['ROLE_ADMIN']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/profile/profile-delete-dialog.html',
                    controller: 'ProfileDeleteController',
                    controllerAs: 'vm',
                    size: 'md',
                    resolve: {
                        entity: ['Profile', function(Profile) {
                            return Profile.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('profile', null, { reload: 'profile' });
                }, function() {
                    $state.go('^');
                });
            }]
        });
    }

})();

(function() {
    'use strict';
    angular
        .module('askApp')
        .factory('Profile', Profile);

    Profile.$inject = ['$resource', 'DateUtils'];

    function Profile ($resource, DateUtils) {
        var resourceUrl =  'api/profiles/:id';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true},
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                        data.birthdate = DateUtils.convertLocalDateFromServer(data.birthdate);
                        data.expelledDate = DateUtils.convertLocalDateFromServer(data.expelledDate);
                        data.matriculationDate = DateUtils.convertLocalDateFromServer(data.matriculationDate);
                        data.idExpirationDate = DateUtils.convertLocalDateFromServer(data.idExpirationDate);
                        data.lastLogin = DateUtils.convertLocalDateFromServer(data.lastLogin);
                        data.fullMemberDate = DateUtils.convertLocalDateFromServer(data.fullMemberDate);
                        data.isafDate = DateUtils.convertLocalDateFromServer(data.isafDate);
                    }
                    return data;
                }
            },
            'update': {
                method: 'PUT',
                transformRequest: function (data) {
                    var copy = angular.copy(data);
                    copy.birthdate = DateUtils.convertLocalDateToServer(copy.birthdate);
                    copy.expelledDate = DateUtils.convertLocalDateToServer(copy.expelledDate);
                    copy.matriculationDate = DateUtils.convertLocalDateToServer(copy.matriculationDate);
                    copy.idExpirationDate = DateUtils.convertLocalDateToServer(copy.idExpirationDate);
                    copy.lastLogin = DateUtils.convertLocalDateToServer(copy.lastLogin);
                    copy.fullMemberDate = DateUtils.convertLocalDateToServer(copy.fullMemberDate);
                    copy.isafDate = DateUtils.convertLocalDateToServer(copy.isafDate);
                    return angular.toJson(copy);
                }
            },
            'save': {
                method: 'POST',
                transformRequest: function (data) {
                    var copy = angular.copy(data);
                    copy.birthdate = DateUtils.convertLocalDateToServer(copy.birthdate);
                    copy.expelledDate = DateUtils.convertLocalDateToServer(copy.expelledDate);
                    copy.matriculationDate = DateUtils.convertLocalDateToServer(copy.matriculationDate);
                    copy.idExpirationDate = DateUtils.convertLocalDateToServer(copy.idExpirationDate);
                    copy.lastLogin = DateUtils.convertLocalDateToServer(copy.lastLogin);
                    copy.fullMemberDate = DateUtils.convertLocalDateToServer(copy.fullMemberDate);
                    copy.isafDate = DateUtils.convertLocalDateToServer(copy.isafDate);
                    return angular.toJson(copy);
                }
            }
        });
    }
})();

(function() {
    'use strict';

    angular
        .module('askApp')
        .factory('ProfileSearch', ProfileSearch);

    ProfileSearch.$inject = ['$resource'];

    function ProfileSearch($resource) {
        var resourceUrl =  'api/_search/profiles/:id';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true}
        });
    }
})();

(function() {
    'use strict';

    angular
        .module('askApp')
        .controller('ProfileController', ProfileController);

    ProfileController.$inject = ['$state', 'DataUtils', 'Profile', 'ProfileSearch', 'ParseLinks', 'AlertService', 'paginationConstants', 'pagingParams'];

    function ProfileController($state, DataUtils, Profile, ProfileSearch, ParseLinks, AlertService, paginationConstants, pagingParams) {

        var vm = this;

        vm.loadPage = loadPage;
        vm.predicate = pagingParams.predicate;
        vm.reverse = pagingParams.ascending;
        vm.transition = transition;
        vm.itemsPerPage = paginationConstants.itemsPerPage;
        vm.clear = clear;
        vm.search = search;
        vm.loadAll = loadAll;
        vm.searchQuery = pagingParams.search;
        vm.currentSearch = pagingParams.search;
        vm.openFile = DataUtils.openFile;
        vm.byteSize = DataUtils.byteSize;

        loadAll();

        function loadAll () {
            if (pagingParams.search) {
                ProfileSearch.query({
                    query: pagingParams.search,
                    page: pagingParams.page - 1,
                    size: vm.itemsPerPage,
                    sort: sort()
                }, onSuccess, onError);
            } else {
                Profile.query({
                    page: pagingParams.page - 1,
                    size: vm.itemsPerPage,
                    sort: sort()
                }, onSuccess, onError);
            }
            function sort() {
                var result = [vm.predicate + ',' + (vm.reverse ? 'asc' : 'desc')];
                if (vm.predicate !== 'id') {
                    result.push('id');
                }
                return result;
            }
            function onSuccess(data, headers) {
                vm.links = ParseLinks.parse(headers('link'));
                vm.totalItems = headers('X-Total-Count');
                vm.queryCount = vm.totalItems;
                vm.profiles = data;
                vm.page = pagingParams.page;
            }
            function onError(error) {
                AlertService.error(error.data.message);
            }
        }

        function loadPage(page) {
            vm.page = page;
            vm.transition();
        }

        function transition() {
            $state.transitionTo($state.$current, {
                page: vm.page,
                sort: vm.predicate + ',' + (vm.reverse ? 'asc' : 'desc'),
                search: vm.currentSearch
            });
        }

        function search(searchQuery) {
            if (!searchQuery){
                return vm.clear();
            }
            vm.links = null;
            vm.page = 1;
            vm.predicate = '_score';
            vm.reverse = false;
            vm.currentSearch = searchQuery;
            vm.transition();
        }

        function clear() {
            vm.links = null;
            vm.page = 1;
            vm.predicate = 'id';
            vm.reverse = true;
            vm.currentSearch = null;
            vm.transition();
        }
    }
})();

/*
 * Copyright (c) 2017 by Julian Feder, julian.feder@yahoo.de
 *
 * This product includes software developed at
 * The Apache Software Foundation (http://www.apache.org/).
 */

(function() {
    'use strict';

    angular
        .module('askApp')
        .controller('PaymentDialogController', PaymentDialogController);

    PaymentDialogController.$inject = ['$timeout', '$scope', '$stateParams', '$uibModalInstance', 'entity', 'Payment', 'Dept', 'Project', 'DinghyEvent'];

    function PaymentDialogController ($timeout, $scope, $stateParams, $uibModalInstance, entity, Payment, Dept, Project, DinghyEvent) {
        var vm = this;

        vm.payment = entity;
        vm.clear = clear;
        vm.datePickerOpenStatus = {};
        vm.openCalendar = openCalendar;
        vm.save = save;
        vm.depts = Dept.query();
        vm.projects = Project.query();
        vm.dinghyevents = DinghyEvent.query();
        vm.payments = Payment.query();

        $timeout(function (){
            angular.element('.form-group:eq(1)>input').focus();
        });

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function save () {
            vm.isSaving = true;
            if (vm.payment.id !== null) {
                Payment.update(vm.payment, onSaveSuccess, onSaveError);
            } else {
                Payment.save(vm.payment, onSaveSuccess, onSaveError);
            }
        }

        function onSaveSuccess (result) {
            $scope.$emit('askApp:paymentUpdate', result);
            $uibModalInstance.close(result);
            vm.isSaving = false;
        }

        function onSaveError () {
            vm.isSaving = false;
        }

        vm.datePickerOpenStatus.date = false;

        function openCalendar (date) {
            vm.datePickerOpenStatus[date] = true;
        }
    }
})();

/*
 * Copyright (c) 2017 by Julian Feder, julian.feder@yahoo.de
 *
 * This product includes software developed at
 * The Apache Software Foundation (http://www.apache.org/).
 */

(function() {
    'use strict';

    angular
        .module('askApp')
        .controller('PaymentDetailController', PaymentDetailController);

    PaymentDetailController.$inject = ['$scope', '$rootScope', '$stateParams', 'previousState', 'entity', 'Payment', 'Dept', 'Project', 'DinghyEvent'];

    function PaymentDetailController($scope, $rootScope, $stateParams, previousState, entity, Payment, Dept, Project, DinghyEvent) {
        var vm = this;

        vm.payment = entity;
        vm.previousState = previousState.name;

        var unsubscribe = $rootScope.$on('askApp:paymentUpdate', function(event, result) {
            vm.payment = result;
        });
        $scope.$on('$destroy', unsubscribe);
    }
})();

/*
 * Copyright (c) 2017 by Julian Feder, julian.feder@yahoo.de
 *
 * This product includes software developed at
 * The Apache Software Foundation (http://www.apache.org/).
 */

(function() {
    'use strict';

    angular
        .module('askApp')
        .controller('PaymentDeleteController',PaymentDeleteController);

    PaymentDeleteController.$inject = ['$uibModalInstance', 'entity', 'Payment'];

    function PaymentDeleteController($uibModalInstance, entity, Payment) {
        var vm = this;

        vm.payment = entity;
        vm.clear = clear;
        vm.confirmDelete = confirmDelete;

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function confirmDelete (id) {
            Payment.delete({id: id},
                function () {
                    $uibModalInstance.close(true);
                });
        }
    }
})();

/*
 * Copyright (c) 2017 by Julian Feder, julian.feder@yahoo.de
 *
 * This product includes software developed at
 * The Apache Software Foundation (http://www.apache.org/).
 */

(function() {
    'use strict';

    angular
        .module('askApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
        .state('payment', {
            parent: 'entity',
            url: '/payment?page&sort&search',
            data: {
                authorities: ['ROLE_ADMIN'],
                pageTitle: 'askApp.payment.home.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/payment/payments.html',
                    controller: 'PaymentController',
                    controllerAs: 'vm'
                }
            },
            params: {
                page: {
                    value: '1',
                    squash: true
                },
                sort: {
                    value: 'id,desc',
                    squash: true
                },
                search: null
            },
            resolve: {
                pagingParams: ['$stateParams', 'PaginationUtil', function ($stateParams, PaginationUtil) {
                    return {
                        page: PaginationUtil.parsePage($stateParams.page),
                        sort: $stateParams.sort,
                        predicate: PaginationUtil.parsePredicate($stateParams.sort),
                        ascending: PaginationUtil.parseAscending($stateParams.sort),
                        search: $stateParams.search
                    };
                }],
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('payment');
                    $translatePartialLoader.addPart('enumPaymentType');
                    $translatePartialLoader.addPart('enumPaymentCategory');
                    $translatePartialLoader.addPart('global');
                    return $translate.refresh();
                }]
            }
        })
        .state('payment-detail', {
            parent: 'payment',
            url: '/payment/{id}',
            data: {
                authorities: ['ROLE_ADMIN'],
                pageTitle: 'askApp.payment.detail.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/payment/payment-detail.html',
                    controller: 'PaymentDetailController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('payment');
                    $translatePartialLoader.addPart('enumPaymentType');
                    $translatePartialLoader.addPart('enumPaymentCategory');
                    return $translate.refresh();
                }],
                entity: ['$stateParams', 'Payment', function($stateParams, Payment) {
                    return Payment.get({id : $stateParams.id}).$promise;
                }],
                previousState: ["$state", function ($state) {
                    var currentStateData = {
                        name: $state.current.name || 'payment',
                        params: $state.params,
                        url: $state.href($state.current.name, $state.params)
                    };
                    return currentStateData;
                }]
            }
        })
        .state('payment-detail.edit', {
            parent: 'payment-detail',
            url: '/detail/edit',
            data: {
                authorities: ['ROLE_ADMIN']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/payment/payment-dialog.html',
                    controller: 'PaymentDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: ['Payment', function(Payment) {
                            return Payment.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('^', {}, { reload: false });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('payment.new', {
            parent: 'payment',
            url: '/new',
            data: {
                authorities: ['ROLE_ADMIN']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/payment/payment-dialog.html',
                    controller: 'PaymentDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: function () {
                            return {
                                revenueID: null,
                                date: null,
                                amount: null,
                                name: null,
                                type: null,
                                reference: null,
                                comment: null,
                                matchReference: null,
                                category: null,
                                id: null
                            };
                        }
                    }
                }).result.then(function() {
                    $state.go('payment', null, { reload: 'payment' });
                }, function() {
                    $state.go('payment');
                });
            }]
        })
        .state('payment.edit', {
            parent: 'payment',
            url: '/{id}/edit',
            data: {
                authorities: ['ROLE_ADMIN']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/payment/payment-dialog.html',
                    controller: 'PaymentDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: ['Payment', function(Payment) {
                            return Payment.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('payment', null, { reload: 'payment' });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('payment.delete', {
            parent: 'payment',
            url: '/{id}/delete',
            data: {
                authorities: ['ROLE_ADMIN']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/payment/payment-delete-dialog.html',
                    controller: 'PaymentDeleteController',
                    controllerAs: 'vm',
                    size: 'md',
                    resolve: {
                        entity: ['Payment', function(Payment) {
                            return Payment.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('payment', null, { reload: 'payment' });
                }, function() {
                    $state.go('^');
                });
            }]
        });
    }

})();

/*
 * Copyright (c) 2017 by Julian Feder, julian.feder@yahoo.de
 *
 * This product includes software developed at
 * The Apache Software Foundation (http://www.apache.org/).
 */

(function() {
    'use strict';
    angular
        .module('askApp')
        .factory('Payment', Payment);

    Payment.$inject = ['$resource', 'DateUtils'];

    function Payment ($resource, DateUtils) {
        var resourceUrl =  'api/payments/:id';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true},
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                        data.date = DateUtils.convertLocalDateFromServer(data.date);
                    }
                    return data;
                }
            },
            'update': {
                method: 'PUT',
                transformRequest: function (data) {
                    var copy = angular.copy(data);
                    copy.date = DateUtils.convertLocalDateToServer(copy.date);
                    return angular.toJson(copy);
                }
            },
            'save': {
                method: 'POST',
                transformRequest: function (data) {
                    var copy = angular.copy(data);
                    copy.date = DateUtils.convertLocalDateToServer(copy.date);
                    return angular.toJson(copy);
                }
            }
        });
    }
})();

/*
 * Copyright (c) 2017 by Julian Feder, julian.feder@yahoo.de
 *
 * This product includes software developed at
 * The Apache Software Foundation (http://www.apache.org/).
 */

(function() {
    'use strict';

    angular
        .module('askApp')
        .factory('PaymentSearch', PaymentSearch);

    PaymentSearch.$inject = ['$resource'];

    function PaymentSearch($resource) {
        var resourceUrl =  'api/_search/payments/:id';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true}
        });
    }
})();

/*
 * Copyright (c) 2017 by Julian Feder, julian.feder@yahoo.de
 *
 * This product includes software developed at
 * The Apache Software Foundation (http://www.apache.org/).
 */

(function() {
    'use strict';

    angular
        .module('askApp')
        .controller('PaymentController', PaymentController);

    PaymentController.$inject = ['$state', 'Payment', 'PaymentSearch', 'ParseLinks', 'AlertService', 'paginationConstants', 'pagingParams'];

    function PaymentController($state, Payment, PaymentSearch, ParseLinks, AlertService, paginationConstants, pagingParams) {

        var vm = this;

        vm.loadPage = loadPage;
        vm.predicate = pagingParams.predicate;
        vm.reverse = pagingParams.ascending;
        vm.transition = transition;
        vm.itemsPerPage = paginationConstants.itemsPerPage;
        vm.clear = clear;
        vm.search = search;
        vm.loadAll = loadAll;
        vm.searchQuery = pagingParams.search;
        vm.currentSearch = pagingParams.search;

        loadAll();

        function loadAll () {
            if (pagingParams.search) {
                PaymentSearch.query({
                    query: pagingParams.search,
                    page: pagingParams.page - 1,
                    size: vm.itemsPerPage,
                    sort: sort()
                }, onSuccess, onError);
            } else {
                Payment.query({
                    page: pagingParams.page - 1,
                    size: vm.itemsPerPage,
                    sort: sort()
                }, onSuccess, onError);
            }
            function sort() {
                var result = [vm.predicate + ',' + (vm.reverse ? 'asc' : 'desc')];
                if (vm.predicate !== 'id') {
                    result.push('id');
                }
                return result;
            }
            function onSuccess(data, headers) {
                vm.links = ParseLinks.parse(headers('link'));
                vm.totalItems = headers('X-Total-Count');
                vm.queryCount = vm.totalItems;
                vm.payments = data;
                vm.page = pagingParams.page;
            }
            function onError(error) {
                AlertService.error(error.data.message);
            }
        }

        function loadPage(page) {
            vm.page = page;
            vm.transition();
        }

        function transition() {
            $state.transitionTo($state.$current, {
                page: vm.page,
                sort: vm.predicate + ',' + (vm.reverse ? 'asc' : 'desc'),
                search: vm.currentSearch
            });
        }

        function search(searchQuery) {
            if (!searchQuery){
                return vm.clear();
            }
            vm.links = null;
            vm.page = 1;
            vm.predicate = '_score';
            vm.reverse = false;
            vm.currentSearch = searchQuery;
            vm.transition();
        }

        function clear() {
            vm.links = null;
            vm.page = 1;
            vm.predicate = 'id';
            vm.reverse = true;
            vm.currentSearch = null;
            vm.transition();
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('askApp')
        .controller('MembershipFeeDialogController', MembershipFeeDialogController);

    MembershipFeeDialogController.$inject = ['$timeout', '$scope', '$stateParams', '$uibModalInstance', '$q', 'entity', 'MembershipFee', 'Profile', 'Dept'];

    function MembershipFeeDialogController ($timeout, $scope, $stateParams, $uibModalInstance, $q, entity, MembershipFee, Profile, Dept) {
        var vm = this;

        vm.membershipFee = entity;
        vm.clear = clear;
        vm.datePickerOpenStatus = {};
        vm.openCalendar = openCalendar;
        vm.save = save;
        vm.profiles = Profile.query();
        vm.depts = Dept.query({filter: 'membershipfee-is-null'});
        $q.all([vm.membershipFee.$promise, vm.depts.$promise]).then(function() {
            if (!vm.membershipFee.dept || !vm.membershipFee.dept.id) {
                return $q.reject();
            }
            return Dept.get({id : vm.membershipFee.dept.id}).$promise;
        }).then(function(dept) {
            vm.depts.push(dept);
        });

        $timeout(function (){
            angular.element('.form-group:eq(1)>input').focus();
        });

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function save () {
            vm.isSaving = true;
            if (vm.membershipFee.id !== null) {
                MembershipFee.update(vm.membershipFee, onSaveSuccess, onSaveError);
            } else {
                MembershipFee.save(vm.membershipFee, onSaveSuccess, onSaveError);
            }
        }

        function onSaveSuccess (result) {
            $scope.$emit('askApp:membershipFeeUpdate', result);
            $uibModalInstance.close(result);
            vm.isSaving = false;
        }

        function onSaveError () {
            vm.isSaving = false;
        }

        vm.datePickerOpenStatus.year = false;

        function openCalendar (date) {
            vm.datePickerOpenStatus[date] = true;
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('askApp')
        .controller('MembershipFeeDetailController', MembershipFeeDetailController);

    MembershipFeeDetailController.$inject = ['$scope', '$rootScope', '$stateParams', 'previousState', 'entity', 'MembershipFee', 'Profile', 'Dept'];

    function MembershipFeeDetailController($scope, $rootScope, $stateParams, previousState, entity, MembershipFee, Profile, Dept) {
        var vm = this;

        vm.membershipFee = entity;
        vm.previousState = previousState.name;

        var unsubscribe = $rootScope.$on('askApp:membershipFeeUpdate', function(event, result) {
            vm.membershipFee = result;
        });
        $scope.$on('$destroy', unsubscribe);
    }
})();

(function() {
    'use strict';

    angular
        .module('askApp')
        .controller('MembershipFeeDeleteController',MembershipFeeDeleteController);

    MembershipFeeDeleteController.$inject = ['$uibModalInstance', 'entity', 'MembershipFee'];

    function MembershipFeeDeleteController($uibModalInstance, entity, MembershipFee) {
        var vm = this;

        vm.membershipFee = entity;
        vm.clear = clear;
        vm.confirmDelete = confirmDelete;

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function confirmDelete (id) {
            MembershipFee.delete({id: id},
                function () {
                    $uibModalInstance.close(true);
                });
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('askApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
        .state('membership-fee', {
            parent: 'entity',
            url: '/membership-fee?page&sort&search',
            data: {
                authorities: ['ROLE_ADMIN'],
                pageTitle: 'askApp.membershipFee.home.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/membership-fee/membership-fees.html',
                    controller: 'MembershipFeeController',
                    controllerAs: 'vm'
                }
            },
            params: {
                page: {
                    value: '1',
                    squash: true
                },
                sort: {
                    value: 'id,asc',
                    squash: true
                },
                search: null
            },
            resolve: {
                pagingParams: ['$stateParams', 'PaginationUtil', function ($stateParams, PaginationUtil) {
                    return {
                        page: PaginationUtil.parsePage($stateParams.page),
                        sort: $stateParams.sort,
                        predicate: PaginationUtil.parsePredicate($stateParams.sort),
                        ascending: PaginationUtil.parseAscending($stateParams.sort),
                        search: $stateParams.search
                    };
                }],
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('membershipFee');
                    $translatePartialLoader.addPart('enumMembershipFeeType');
                    $translatePartialLoader.addPart('global');
                    return $translate.refresh();
                }]
            }
        })
        .state('membership-fee-detail', {
            parent: 'membership-fee',
            url: '/membership-fee/{id}',
            data: {
                authorities: ['ROLE_ADMIN'],
                pageTitle: 'askApp.membershipFee.detail.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/membership-fee/membership-fee-detail.html',
                    controller: 'MembershipFeeDetailController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('membershipFee');
                    $translatePartialLoader.addPart('enumMembershipFeeType');
                    return $translate.refresh();
                }],
                entity: ['$stateParams', 'MembershipFee', function($stateParams, MembershipFee) {
                    return MembershipFee.get({id : $stateParams.id}).$promise;
                }],
                previousState: ["$state", function ($state) {
                    var currentStateData = {
                        name: $state.current.name || 'membership-fee',
                        params: $state.params,
                        url: $state.href($state.current.name, $state.params)
                    };
                    return currentStateData;
                }]
            }
        })
        .state('membership-fee-detail.edit', {
            parent: 'membership-fee-detail',
            url: '/detail/edit',
            data: {
                authorities: ['ROLE_ADMIN']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/membership-fee/membership-fee-dialog.html',
                    controller: 'MembershipFeeDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: ['MembershipFee', function(MembershipFee) {
                            return MembershipFee.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('^', {}, { reload: false });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('membership-fee.new', {
            parent: 'membership-fee',
            url: '/new',
            data: {
                authorities: ['ROLE_ADMIN']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/membership-fee/membership-fee-dialog.html',
                    controller: 'MembershipFeeDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: function () {
                            return {
                                year: null,
                                price: null,
                                type: null,
                                id: null
                            };
                        }
                    }
                }).result.then(function() {
                    $state.go('membership-fee', null, { reload: 'membership-fee' });
                }, function() {
                    $state.go('membership-fee');
                });
            }]
        })
        .state('membership-fee.edit', {
            parent: 'membership-fee',
            url: '/{id}/edit',
            data: {
                authorities: ['ROLE_ADMIN']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/membership-fee/membership-fee-dialog.html',
                    controller: 'MembershipFeeDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: ['MembershipFee', function(MembershipFee) {
                            return MembershipFee.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('membership-fee', null, { reload: 'membership-fee' });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('membership-fee.delete', {
            parent: 'membership-fee',
            url: '/{id}/delete',
            data: {
                authorities: ['ROLE_ADMIN']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/membership-fee/membership-fee-delete-dialog.html',
                    controller: 'MembershipFeeDeleteController',
                    controllerAs: 'vm',
                    size: 'md',
                    resolve: {
                        entity: ['MembershipFee', function(MembershipFee) {
                            return MembershipFee.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('membership-fee', null, { reload: 'membership-fee' });
                }, function() {
                    $state.go('^');
                });
            }]
        });
    }

})();

(function() {
    'use strict';
    angular
        .module('askApp')
        .factory('MembershipFee', MembershipFee);

    MembershipFee.$inject = ['$resource', 'DateUtils'];

    function MembershipFee ($resource, DateUtils) {
        var resourceUrl =  'api/membership-fees/:id';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true},
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                        data.year = DateUtils.convertLocalDateFromServer(data.year);
                    }
                    return data;
                }
            },
            'update': {
                method: 'PUT',
                transformRequest: function (data) {
                    var copy = angular.copy(data);
                    copy.year = DateUtils.convertLocalDateToServer(copy.year);
                    return angular.toJson(copy);
                }
            },
            'save': {
                method: 'POST',
                transformRequest: function (data) {
                    var copy = angular.copy(data);
                    copy.year = DateUtils.convertLocalDateToServer(copy.year);
                    return angular.toJson(copy);
                }
            }
        });
    }
})();

(function() {
    'use strict';

    angular
        .module('askApp')
        .factory('MembershipFeeSearch', MembershipFeeSearch);

    MembershipFeeSearch.$inject = ['$resource'];

    function MembershipFeeSearch($resource) {
        var resourceUrl =  'api/_search/membership-fees/:id';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true}
        });
    }
})();

(function() {
    'use strict';

    angular
        .module('askApp')
        .controller('MembershipFeeController', MembershipFeeController);

    MembershipFeeController.$inject = ['$state', 'MembershipFee', 'MembershipFeeSearch', 'ParseLinks', 'AlertService', 'paginationConstants', 'pagingParams'];

    function MembershipFeeController($state, MembershipFee, MembershipFeeSearch, ParseLinks, AlertService, paginationConstants, pagingParams) {

        var vm = this;

        vm.loadPage = loadPage;
        vm.predicate = pagingParams.predicate;
        vm.reverse = pagingParams.ascending;
        vm.transition = transition;
        vm.itemsPerPage = paginationConstants.itemsPerPage;
        vm.clear = clear;
        vm.search = search;
        vm.loadAll = loadAll;
        vm.searchQuery = pagingParams.search;
        vm.currentSearch = pagingParams.search;

        loadAll();

        function loadAll () {
            if (pagingParams.search) {
                MembershipFeeSearch.query({
                    query: pagingParams.search,
                    page: pagingParams.page - 1,
                    size: vm.itemsPerPage,
                    sort: sort()
                }, onSuccess, onError);
            } else {
                MembershipFee.query({
                    page: pagingParams.page - 1,
                    size: vm.itemsPerPage,
                    sort: sort()
                }, onSuccess, onError);
            }
            function sort() {
                var result = [vm.predicate + ',' + (vm.reverse ? 'asc' : 'desc')];
                if (vm.predicate !== 'id') {
                    result.push('id');
                }
                return result;
            }
            function onSuccess(data, headers) {
                vm.links = ParseLinks.parse(headers('link'));
                vm.totalItems = headers('X-Total-Count');
                vm.queryCount = vm.totalItems;
                vm.membershipFees = data;
                vm.page = pagingParams.page;
            }
            function onError(error) {
                AlertService.error(error.data.message);
            }
        }

        function loadPage(page) {
            vm.page = page;
            vm.transition();
        }

        function transition() {
            $state.transitionTo($state.$current, {
                page: vm.page,
                sort: vm.predicate + ',' + (vm.reverse ? 'asc' : 'desc'),
                search: vm.currentSearch
            });
        }

        function search(searchQuery) {
            if (!searchQuery){
                return vm.clear();
            }
            vm.links = null;
            vm.page = 1;
            vm.predicate = '_score';
            vm.reverse = false;
            vm.currentSearch = searchQuery;
            vm.transition();
        }

        function clear() {
            vm.links = null;
            vm.page = 1;
            vm.predicate = 'id';
            vm.reverse = true;
            vm.currentSearch = null;
            vm.transition();
        }
    }
})();

/*
 * Copyright (c) 2017 by Julian Feder, julian.feder@yahoo.de
 *
 * This product includes software developed at
 * The Apache Software Foundation (http://www.apache.org/).
 */

(function() {
    'use strict';

    angular
        .module('askApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider.state('entity', {
            abstract: true,
            parent: 'app'
        });
    }
})();

(function() {
    'use strict';

    angular
        .module('askApp')
        .controller('DinghyEventDialogController', DinghyEventDialogController);

    DinghyEventDialogController.$inject = ['$timeout', '$scope', '$stateParams', '$uibModalInstance', 'entity', 'DinghyEvent', 'Profile', 'Dinghy'];

    function DinghyEventDialogController ($timeout, $scope, $stateParams, $uibModalInstance, entity, DinghyEvent, Profile, Dinghy) {
        var vm = this;

        vm.dinghyEvent = entity;
        vm.clear = clear;
        vm.datePickerOpenStatus = {};
        vm.openCalendar = openCalendar;
        vm.save = save;
        vm.profiles = Profile.query();
        vm.dinghies = Dinghy.query();

        $timeout(function (){
            angular.element('.form-group:eq(1)>input').focus();
        });

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function save () {
            vm.isSaving = true;
            if (vm.dinghyEvent.id !== null) {
                DinghyEvent.update(vm.dinghyEvent, onSaveSuccess, onSaveError);
            } else {
                DinghyEvent.save(vm.dinghyEvent, onSaveSuccess, onSaveError);
            }
        }

        function onSaveSuccess (result) {
            $scope.$emit('askApp:dinghyEventUpdate', result);
            $uibModalInstance.close(result);
            vm.isSaving = false;
        }

        function onSaveError () {
            vm.isSaving = false;
        }

        vm.datePickerOpenStatus.fromDate = false;
        vm.datePickerOpenStatus.untilDate = false;

        function openCalendar (date) {
            vm.datePickerOpenStatus[date] = true;
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('askApp')
        .controller('DinghyEventDetailController', DinghyEventDetailController);

    DinghyEventDetailController.$inject = ['$scope', '$rootScope', '$stateParams', 'previousState', 'entity', 'DinghyEvent', 'Profile', 'Dinghy'];

    function DinghyEventDetailController($scope, $rootScope, $stateParams, previousState, entity, DinghyEvent, Profile, Dinghy) {
        var vm = this;

        vm.dinghyEvent = entity;
        vm.previousState = previousState.name;

        var unsubscribe = $rootScope.$on('askApp:dinghyEventUpdate', function(event, result) {
            vm.dinghyEvent = result;
        });
        $scope.$on('$destroy', unsubscribe);
    }
})();

(function() {
    'use strict';

    angular
        .module('askApp')
        .controller('DinghyEventDeleteController',DinghyEventDeleteController);

    DinghyEventDeleteController.$inject = ['$uibModalInstance', 'entity', 'DinghyEvent'];

    function DinghyEventDeleteController($uibModalInstance, entity, DinghyEvent) {
        var vm = this;

        vm.dinghyEvent = entity;
        vm.clear = clear;
        vm.confirmDelete = confirmDelete;

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function confirmDelete (id) {
            DinghyEvent.delete({id: id},
                function () {
                    $uibModalInstance.close(true);
                });
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('askApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
        .state('dinghy-event', {
            parent: 'entity',
            url: '/dinghy-event?page&sort&search',
            data: {
                authorities: ['ROLE_ADMIN'],
                pageTitle: 'askApp.dinghyEvent.home.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/dinghy-event/dinghy-events.html',
                    controller: 'DinghyEventController',
                    controllerAs: 'vm'
                }
            },
            params: {
                page: {
                    value: '1',
                    squash: true
                },
                sort: {
                    value: 'id,asc',
                    squash: true
                },
                search: null
            },
            resolve: {
                pagingParams: ['$stateParams', 'PaginationUtil', function ($stateParams, PaginationUtil) {
                    return {
                        page: PaginationUtil.parsePage($stateParams.page),
                        sort: $stateParams.sort,
                        predicate: PaginationUtil.parsePredicate($stateParams.sort),
                        ascending: PaginationUtil.parseAscending($stateParams.sort),
                        search: $stateParams.search
                    };
                }],
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('dinghyEvent');
                    $translatePartialLoader.addPart('enumDinghyEventType');
                    $translatePartialLoader.addPart('global');
                    return $translate.refresh();
                }]
            }
        })
        .state('dinghy-event-detail', {
            parent: 'dinghy-event',
            url: '/dinghy-event/{id}',
            data: {
                authorities: ['ROLE_ADMIN'],
                pageTitle: 'askApp.dinghyEvent.detail.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/dinghy-event/dinghy-event-detail.html',
                    controller: 'DinghyEventDetailController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('dinghyEvent');
                    $translatePartialLoader.addPart('enumDinghyEventType');
                    return $translate.refresh();
                }],
                entity: ['$stateParams', 'DinghyEvent', function($stateParams, DinghyEvent) {
                    return DinghyEvent.get({id : $stateParams.id}).$promise;
                }],
                previousState: ["$state", function ($state) {
                    var currentStateData = {
                        name: $state.current.name || 'dinghy-event',
                        params: $state.params,
                        url: $state.href($state.current.name, $state.params)
                    };
                    return currentStateData;
                }]
            }
        })
        .state('dinghy-event-detail.edit', {
            parent: 'dinghy-event-detail',
            url: '/detail/edit',
            data: {
                authorities: ['ROLE_ADMIN']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/dinghy-event/dinghy-event-dialog.html',
                    controller: 'DinghyEventDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: ['DinghyEvent', function(DinghyEvent) {
                            return DinghyEvent.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('^', {}, { reload: false });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('dinghy-event.new', {
            parent: 'dinghy-event',
            url: '/new',
            data: {
                authorities: ['ROLE_ADMIN']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/dinghy-event/dinghy-event-dialog.html',
                    controller: 'DinghyEventDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: function () {
                            return {
                                name: null,
                                type: null,
                                fromDate: null,
                                untilDate: null,
                                contactEmail: null,
                                placeCount: null,
                                location: null,
                                identifier: null,
                                normalPrice: null,
                                studentPrice: null,
                                guestPrice: null,
                                description: null,
                                conditions: null,
                                notes: null,
                                visible: false,
                                active: false,
                                closed: false,
                                canceled: false,
                                allowGuests: false,
                                allowQueue: false,
                                individualQuestion: null,
                                uid: null,
                                version: null,
                                id: null
                            };
                        }
                    }
                }).result.then(function() {
                    $state.go('dinghy-event', null, { reload: 'dinghy-event' });
                }, function() {
                    $state.go('dinghy-event');
                });
            }]
        })
        .state('dinghy-event.edit', {
            parent: 'dinghy-event',
            url: '/{id}/edit',
            data: {
                authorities: ['ROLE_ADMIN']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/dinghy-event/dinghy-event-dialog.html',
                    controller: 'DinghyEventDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: ['DinghyEvent', function(DinghyEvent) {
                            return DinghyEvent.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('dinghy-event', null, { reload: 'dinghy-event' });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('dinghy-event.delete', {
            parent: 'dinghy-event',
            url: '/{id}/delete',
            data: {
                authorities: ['ROLE_ADMIN']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/dinghy-event/dinghy-event-delete-dialog.html',
                    controller: 'DinghyEventDeleteController',
                    controllerAs: 'vm',
                    size: 'md',
                    resolve: {
                        entity: ['DinghyEvent', function(DinghyEvent) {
                            return DinghyEvent.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('dinghy-event', null, { reload: 'dinghy-event' });
                }, function() {
                    $state.go('^');
                });
            }]
        });
    }

})();

(function() {
    'use strict';
    angular
        .module('askApp')
        .factory('DinghyEvent', DinghyEvent);

    DinghyEvent.$inject = ['$resource', 'DateUtils'];

    function DinghyEvent ($resource, DateUtils) {
        var resourceUrl =  'api/dinghy-events/:id';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true},
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                        data.fromDate = DateUtils.convertDateTimeFromServer(data.fromDate);
                        data.untilDate = DateUtils.convertDateTimeFromServer(data.untilDate);
                    }
                    return data;
                }
            },
            'update': { method:'PUT' }
        });
    }
})();

(function() {
    'use strict';

    angular
        .module('askApp')
        .factory('DinghyEventSearch', DinghyEventSearch);

    DinghyEventSearch.$inject = ['$resource'];

    function DinghyEventSearch($resource) {
        var resourceUrl =  'api/_search/dinghy-events/:id';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true}
        });
    }
})();

(function() {
    'use strict';

    angular
        .module('askApp')
        .controller('DinghyEventController', DinghyEventController);

    DinghyEventController.$inject = ['$state', 'DinghyEvent', 'DinghyEventSearch', 'ParseLinks', 'AlertService', 'paginationConstants', 'pagingParams'];

    function DinghyEventController($state, DinghyEvent, DinghyEventSearch, ParseLinks, AlertService, paginationConstants, pagingParams) {

        var vm = this;

        vm.loadPage = loadPage;
        vm.predicate = pagingParams.predicate;
        vm.reverse = pagingParams.ascending;
        vm.transition = transition;
        vm.itemsPerPage = paginationConstants.itemsPerPage;
        vm.clear = clear;
        vm.search = search;
        vm.loadAll = loadAll;
        vm.searchQuery = pagingParams.search;
        vm.currentSearch = pagingParams.search;

        loadAll();

        function loadAll () {
            if (pagingParams.search) {
                DinghyEventSearch.query({
                    query: pagingParams.search,
                    page: pagingParams.page - 1,
                    size: vm.itemsPerPage,
                    sort: sort()
                }, onSuccess, onError);
            } else {
                DinghyEvent.query({
                    page: pagingParams.page - 1,
                    size: vm.itemsPerPage,
                    sort: sort()
                }, onSuccess, onError);
            }
            function sort() {
                var result = [vm.predicate + ',' + (vm.reverse ? 'asc' : 'desc')];
                if (vm.predicate !== 'id') {
                    result.push('id');
                }
                return result;
            }
            function onSuccess(data, headers) {
                vm.links = ParseLinks.parse(headers('link'));
                vm.totalItems = headers('X-Total-Count');
                vm.queryCount = vm.totalItems;
                vm.dinghyEvents = data;
                vm.page = pagingParams.page;
            }
            function onError(error) {
                AlertService.error(error.data.message);
            }
        }

        function loadPage(page) {
            vm.page = page;
            vm.transition();
        }

        function transition() {
            $state.transitionTo($state.$current, {
                page: vm.page,
                sort: vm.predicate + ',' + (vm.reverse ? 'asc' : 'desc'),
                search: vm.currentSearch
            });
        }

        function search(searchQuery) {
            if (!searchQuery){
                return vm.clear();
            }
            vm.links = null;
            vm.page = 1;
            vm.predicate = '_score';
            vm.reverse = false;
            vm.currentSearch = searchQuery;
            vm.transition();
        }

        function clear() {
            vm.links = null;
            vm.page = 1;
            vm.predicate = 'id';
            vm.reverse = true;
            vm.currentSearch = null;
            vm.transition();
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('askApp')
        .controller('DinghyBookingDialogController', DinghyBookingDialogController);

    DinghyBookingDialogController.$inject = ['$timeout', '$scope', '$stateParams', '$uibModalInstance', '$q', 'entity', 'DinghyBooking', 'DinghyEvent', 'Profile', 'Dept', 'Dinghy'];

    function DinghyBookingDialogController ($timeout, $scope, $stateParams, $uibModalInstance, $q, entity, DinghyBooking, DinghyEvent, Profile, Dept, Dinghy) {
        var vm = this;

        vm.dinghyBooking = entity;
        vm.clear = clear;
        vm.datePickerOpenStatus = {};
        vm.openCalendar = openCalendar;
        vm.save = save;
        vm.dinghyevents = DinghyEvent.query();
        vm.profiles = Profile.query();
        vm.depts = Dept.query({filter: 'dinghybooking-is-null'});
        $q.all([vm.dinghyBooking.$promise, vm.depts.$promise]).then(function() {
            if (!vm.dinghyBooking.dept || !vm.dinghyBooking.dept.id) {
                return $q.reject();
            }
            return Dept.get({id : vm.dinghyBooking.dept.id}).$promise;
        }).then(function(dept) {
            vm.depts.push(dept);
        });
        vm.dinghies = Dinghy.query();

        $timeout(function (){
            angular.element('.form-group:eq(1)>input').focus();
        });

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function save () {
            vm.isSaving = true;
            if (vm.dinghyBooking.id !== null) {
                DinghyBooking.update(vm.dinghyBooking, onSaveSuccess, onSaveError);
            } else {
                DinghyBooking.save(vm.dinghyBooking, onSaveSuccess, onSaveError);
            }
        }

        function onSaveSuccess (result) {
            $scope.$emit('askApp:dinghyBookingUpdate', result);
            $uibModalInstance.close(result);
            vm.isSaving = false;
        }

        function onSaveError () {
            vm.isSaving = false;
        }

        vm.datePickerOpenStatus.bookingDate = false;
        vm.datePickerOpenStatus.validationDate = false;

        function openCalendar (date) {
            vm.datePickerOpenStatus[date] = true;
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('askApp')
        .controller('DinghyBookingDetailController', DinghyBookingDetailController);

    DinghyBookingDetailController.$inject = ['$scope', '$rootScope', '$stateParams', 'previousState', 'entity', 'DinghyBooking', 'DinghyEvent', 'Profile', 'Dept', 'Dinghy'];

    function DinghyBookingDetailController($scope, $rootScope, $stateParams, previousState, entity, DinghyBooking, DinghyEvent, Profile, Dept, Dinghy) {
        var vm = this;

        vm.dinghyBooking = entity;
        vm.previousState = previousState.name;

        var unsubscribe = $rootScope.$on('askApp:dinghyBookingUpdate', function(event, result) {
            vm.dinghyBooking = result;
        });
        $scope.$on('$destroy', unsubscribe);
    }
})();

(function() {
    'use strict';

    angular
        .module('askApp')
        .controller('DinghyBookingDeleteController',DinghyBookingDeleteController);

    DinghyBookingDeleteController.$inject = ['$uibModalInstance', 'entity', 'DinghyBooking'];

    function DinghyBookingDeleteController($uibModalInstance, entity, DinghyBooking) {
        var vm = this;

        vm.dinghyBooking = entity;
        vm.clear = clear;
        vm.confirmDelete = confirmDelete;

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function confirmDelete (id) {
            DinghyBooking.delete({id: id},
                function () {
                    $uibModalInstance.close(true);
                });
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('askApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
        .state('dinghy-booking', {
            parent: 'entity',
            url: '/dinghy-booking?page&sort&search',
            data: {
                authorities: ['ROLE_ADMIN'],
                pageTitle: 'askApp.dinghyBooking.home.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/dinghy-booking/dinghy-bookings.html',
                    controller: 'DinghyBookingController',
                    controllerAs: 'vm'
                }
            },
            params: {
                page: {
                    value: '1',
                    squash: true
                },
                sort: {
                    value: 'id,asc',
                    squash: true
                },
                search: null
            },
            resolve: {
                pagingParams: ['$stateParams', 'PaginationUtil', function ($stateParams, PaginationUtil) {
                    return {
                        page: PaginationUtil.parsePage($stateParams.page),
                        sort: $stateParams.sort,
                        predicate: PaginationUtil.parsePredicate($stateParams.sort),
                        ascending: PaginationUtil.parseAscending($stateParams.sort),
                        search: $stateParams.search
                    };
                }],
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('dinghyBooking');
                    $translatePartialLoader.addPart('enumBookingStatusType');
                    $translatePartialLoader.addPart('global');
                    return $translate.refresh();
                }]
            }
        })
        .state('dinghy-booking-detail', {
            parent: 'dinghy-booking',
            url: '/dinghy-booking/{id}',
            data: {
                authorities: ['ROLE_ADMIN'],
                pageTitle: 'askApp.dinghyBooking.detail.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/dinghy-booking/dinghy-booking-detail.html',
                    controller: 'DinghyBookingDetailController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('dinghyBooking');
                    $translatePartialLoader.addPart('enumBookingStatusType');
                    return $translate.refresh();
                }],
                entity: ['$stateParams', 'DinghyBooking', function($stateParams, DinghyBooking) {
                    return DinghyBooking.get({id : $stateParams.id}).$promise;
                }],
                previousState: ["$state", function ($state) {
                    var currentStateData = {
                        name: $state.current.name || 'dinghy-booking',
                        params: $state.params,
                        url: $state.href($state.current.name, $state.params)
                    };
                    return currentStateData;
                }]
            }
        })
        .state('dinghy-booking-detail.edit', {
            parent: 'dinghy-booking-detail',
            url: '/detail/edit',
            data: {
                authorities: ['ROLE_ADMIN']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/dinghy-booking/dinghy-booking-dialog.html',
                    controller: 'DinghyBookingDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: ['DinghyBooking', function(DinghyBooking) {
                            return DinghyBooking.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('^', {}, { reload: false });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('dinghy-booking.new', {
            parent: 'dinghy-booking',
            url: '/new',
            data: {
                authorities: ['ROLE_ADMIN']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/dinghy-booking/dinghy-booking-dialog.html',
                    controller: 'DinghyBookingDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: function () {
                            return {
                                bookingDate: null,
                                price: null,
                                bookingStatus: null,
                                comment: null,
                                individualQuestionAnswer: null,
                                commentDinghy: null,
                                firstName: null,
                                lastName: null,
                                email: null,
                                validationDate: null,
                                id: null
                            };
                        }
                    }
                }).result.then(function() {
                    $state.go('dinghy-booking', null, { reload: 'dinghy-booking' });
                }, function() {
                    $state.go('dinghy-booking');
                });
            }]
        })
        .state('dinghy-booking.edit', {
            parent: 'dinghy-booking',
            url: '/{id}/edit',
            data: {
                authorities: ['ROLE_ADMIN']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/dinghy-booking/dinghy-booking-dialog.html',
                    controller: 'DinghyBookingDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: ['DinghyBooking', function(DinghyBooking) {
                            return DinghyBooking.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('dinghy-booking', null, { reload: 'dinghy-booking' });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('dinghy-booking.delete', {
            parent: 'dinghy-booking',
            url: '/{id}/delete',
            data: {
                authorities: ['ROLE_ADMIN']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/dinghy-booking/dinghy-booking-delete-dialog.html',
                    controller: 'DinghyBookingDeleteController',
                    controllerAs: 'vm',
                    size: 'md',
                    resolve: {
                        entity: ['DinghyBooking', function(DinghyBooking) {
                            return DinghyBooking.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('dinghy-booking', null, { reload: 'dinghy-booking' });
                }, function() {
                    $state.go('^');
                });
            }]
        });
    }

})();

(function() {
    'use strict';
    angular
        .module('askApp')
        .factory('DinghyBooking', DinghyBooking);

    DinghyBooking.$inject = ['$resource', 'DateUtils'];

    function DinghyBooking ($resource, DateUtils) {
        var resourceUrl =  'api/dinghy-bookings/:id';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true},
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                        data.bookingDate = DateUtils.convertDateTimeFromServer(data.bookingDate);
                        data.validationDate = DateUtils.convertDateTimeFromServer(data.validationDate);
                    }
                    return data;
                }
            },
            'update': { method:'PUT' }
        });
    }
})();

(function() {
    'use strict';

    angular
        .module('askApp')
        .factory('DinghyBookingSearch', DinghyBookingSearch);

    DinghyBookingSearch.$inject = ['$resource'];

    function DinghyBookingSearch($resource) {
        var resourceUrl =  'api/_search/dinghy-bookings/:id';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true}
        });
    }
})();

(function() {
    'use strict';

    angular
        .module('askApp')
        .controller('DinghyBookingController', DinghyBookingController);

    DinghyBookingController.$inject = ['$state', 'DinghyBooking', 'DinghyBookingSearch', 'ParseLinks', 'AlertService', 'paginationConstants', 'pagingParams'];

    function DinghyBookingController($state, DinghyBooking, DinghyBookingSearch, ParseLinks, AlertService, paginationConstants, pagingParams) {

        var vm = this;

        vm.loadPage = loadPage;
        vm.predicate = pagingParams.predicate;
        vm.reverse = pagingParams.ascending;
        vm.transition = transition;
        vm.itemsPerPage = paginationConstants.itemsPerPage;
        vm.clear = clear;
        vm.search = search;
        vm.loadAll = loadAll;
        vm.searchQuery = pagingParams.search;
        vm.currentSearch = pagingParams.search;

        loadAll();

        function loadAll () {
            if (pagingParams.search) {
                DinghyBookingSearch.query({
                    query: pagingParams.search,
                    page: pagingParams.page - 1,
                    size: vm.itemsPerPage,
                    sort: sort()
                }, onSuccess, onError);
            } else {
                DinghyBooking.query({
                    page: pagingParams.page - 1,
                    size: vm.itemsPerPage,
                    sort: sort()
                }, onSuccess, onError);
            }
            function sort() {
                var result = [vm.predicate + ',' + (vm.reverse ? 'asc' : 'desc')];
                if (vm.predicate !== 'id') {
                    result.push('id');
                }
                return result;
            }
            function onSuccess(data, headers) {
                vm.links = ParseLinks.parse(headers('link'));
                vm.totalItems = headers('X-Total-Count');
                vm.queryCount = vm.totalItems;
                vm.dinghyBookings = data;
                vm.page = pagingParams.page;
            }
            function onError(error) {
                AlertService.error(error.data.message);
            }
        }

        function loadPage(page) {
            vm.page = page;
            vm.transition();
        }

        function transition() {
            $state.transitionTo($state.$current, {
                page: vm.page,
                sort: vm.predicate + ',' + (vm.reverse ? 'asc' : 'desc'),
                search: vm.currentSearch
            });
        }

        function search(searchQuery) {
            if (!searchQuery){
                return vm.clear();
            }
            vm.links = null;
            vm.page = 1;
            vm.predicate = '_score';
            vm.reverse = false;
            vm.currentSearch = searchQuery;
            vm.transition();
        }

        function clear() {
            vm.links = null;
            vm.page = 1;
            vm.predicate = 'id';
            vm.reverse = true;
            vm.currentSearch = null;
            vm.transition();
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('askApp')
        .controller('DinghyDialogController', DinghyDialogController);

    DinghyDialogController.$inject = ['$timeout', '$scope', '$stateParams', '$uibModalInstance', 'entity', 'Dinghy'];

    function DinghyDialogController ($timeout, $scope, $stateParams, $uibModalInstance, entity, Dinghy) {
        var vm = this;

        vm.dinghy = entity;
        vm.clear = clear;
        vm.datePickerOpenStatus = {};
        vm.openCalendar = openCalendar;
        vm.save = save;

        $timeout(function (){
            angular.element('.form-group:eq(1)>input').focus();
        });

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function save () {
            vm.isSaving = true;
            if (vm.dinghy.id !== null) {
                Dinghy.update(vm.dinghy, onSaveSuccess, onSaveError);
            } else {
                Dinghy.save(vm.dinghy, onSaveSuccess, onSaveError);
            }
        }

        function onSaveSuccess (result) {
            $scope.$emit('askApp:dinghyUpdate', result);
            $uibModalInstance.close(result);
            vm.isSaving = false;
        }

        function onSaveError () {
            vm.isSaving = false;
        }

        vm.datePickerOpenStatus.dateDeactivated = false;

        function openCalendar (date) {
            vm.datePickerOpenStatus[date] = true;
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('askApp')
        .controller('DinghyDetailController', DinghyDetailController);

    DinghyDetailController.$inject = ['$scope', '$rootScope', '$stateParams', 'previousState', 'entity', 'Dinghy'];

    function DinghyDetailController($scope, $rootScope, $stateParams, previousState, entity, Dinghy) {
        var vm = this;

        vm.dinghy = entity;
        vm.previousState = previousState.name;

        var unsubscribe = $rootScope.$on('askApp:dinghyUpdate', function(event, result) {
            vm.dinghy = result;
        });
        $scope.$on('$destroy', unsubscribe);
    }
})();

(function() {
    'use strict';

    angular
        .module('askApp')
        .controller('DinghyDeleteController',DinghyDeleteController);

    DinghyDeleteController.$inject = ['$uibModalInstance', 'entity', 'Dinghy'];

    function DinghyDeleteController($uibModalInstance, entity, Dinghy) {
        var vm = this;

        vm.dinghy = entity;
        vm.clear = clear;
        vm.confirmDelete = confirmDelete;

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function confirmDelete (id) {
            Dinghy.delete({id: id},
                function () {
                    $uibModalInstance.close(true);
                });
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('askApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
        .state('dinghy', {
            parent: 'entity',
            url: '/dinghy?page&sort&search',
            data: {
                authorities: ['ROLE_ADMIN'],
                pageTitle: 'askApp.dinghy.home.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/dinghy/dinghies.html',
                    controller: 'DinghyController',
                    controllerAs: 'vm'
                }
            },
            params: {
                page: {
                    value: '1',
                    squash: true
                },
                sort: {
                    value: 'id,asc',
                    squash: true
                },
                search: null
            },
            resolve: {
                pagingParams: ['$stateParams', 'PaginationUtil', function ($stateParams, PaginationUtil) {
                    return {
                        page: PaginationUtil.parsePage($stateParams.page),
                        sort: $stateParams.sort,
                        predicate: PaginationUtil.parsePredicate($stateParams.sort),
                        ascending: PaginationUtil.parseAscending($stateParams.sort),
                        search: $stateParams.search
                    };
                }],
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('dinghy');
                    $translatePartialLoader.addPart('global');
                    return $translate.refresh();
                }]
            }
        })
        .state('dinghy-detail', {
            parent: 'dinghy',
            url: '/dinghy/{id}',
            data: {
                authorities: ['ROLE_ADMIN'],
                pageTitle: 'askApp.dinghy.detail.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/dinghy/dinghy-detail.html',
                    controller: 'DinghyDetailController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('dinghy');
                    return $translate.refresh();
                }],
                entity: ['$stateParams', 'Dinghy', function($stateParams, Dinghy) {
                    return Dinghy.get({id : $stateParams.id}).$promise;
                }],
                previousState: ["$state", function ($state) {
                    var currentStateData = {
                        name: $state.current.name || 'dinghy',
                        params: $state.params,
                        url: $state.href($state.current.name, $state.params)
                    };
                    return currentStateData;
                }]
            }
        })
        .state('dinghy-detail.edit', {
            parent: 'dinghy-detail',
            url: '/detail/edit',
            data: {
                authorities: ['ROLE_ADMIN']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/dinghy/dinghy-dialog.html',
                    controller: 'DinghyDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: ['Dinghy', function(Dinghy) {
                            return Dinghy.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('^', {}, { reload: false });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('dinghy.new', {
            parent: 'dinghy',
            url: '/new',
            data: {
                authorities: ['ROLE_ADMIN']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/dinghy/dinghy-dialog.html',
                    controller: 'DinghyDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: function () {
                            return {
                                name: null,
                                description: null,
                                comment: null,
                                available: false,
                                type: null,
                                active: false,
                                dateDeactivated: null,
                                id: null
                            };
                        }
                    }
                }).result.then(function() {
                    $state.go('dinghy', null, { reload: 'dinghy' });
                }, function() {
                    $state.go('dinghy');
                });
            }]
        })
        .state('dinghy.edit', {
            parent: 'dinghy',
            url: '/{id}/edit',
            data: {
                authorities: ['ROLE_ADMIN']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/dinghy/dinghy-dialog.html',
                    controller: 'DinghyDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: ['Dinghy', function(Dinghy) {
                            return Dinghy.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('dinghy', null, { reload: 'dinghy' });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('dinghy.delete', {
            parent: 'dinghy',
            url: '/{id}/delete',
            data: {
                authorities: ['ROLE_ADMIN']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/dinghy/dinghy-delete-dialog.html',
                    controller: 'DinghyDeleteController',
                    controllerAs: 'vm',
                    size: 'md',
                    resolve: {
                        entity: ['Dinghy', function(Dinghy) {
                            return Dinghy.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('dinghy', null, { reload: 'dinghy' });
                }, function() {
                    $state.go('^');
                });
            }]
        });
    }

})();

(function() {
    'use strict';
    angular
        .module('askApp')
        .factory('Dinghy', Dinghy);

    Dinghy.$inject = ['$resource', 'DateUtils'];

    function Dinghy ($resource, DateUtils) {
        var resourceUrl =  'api/dinghies/:id';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true},
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                        data.dateDeactivated = DateUtils.convertLocalDateFromServer(data.dateDeactivated);
                    }
                    return data;
                }
            },
            'update': {
                method: 'PUT',
                transformRequest: function (data) {
                    var copy = angular.copy(data);
                    copy.dateDeactivated = DateUtils.convertLocalDateToServer(copy.dateDeactivated);
                    return angular.toJson(copy);
                }
            },
            'save': {
                method: 'POST',
                transformRequest: function (data) {
                    var copy = angular.copy(data);
                    copy.dateDeactivated = DateUtils.convertLocalDateToServer(copy.dateDeactivated);
                    return angular.toJson(copy);
                }
            }
        });
    }
})();

(function() {
    'use strict';

    angular
        .module('askApp')
        .factory('DinghySearch', DinghySearch);

    DinghySearch.$inject = ['$resource'];

    function DinghySearch($resource) {
        var resourceUrl =  'api/_search/dinghies/:id';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true}
        });
    }
})();

(function() {
    'use strict';

    angular
        .module('askApp')
        .controller('DinghyController', DinghyController);

    DinghyController.$inject = ['$state', 'Dinghy', 'DinghySearch', 'ParseLinks', 'AlertService', 'paginationConstants', 'pagingParams'];

    function DinghyController($state, Dinghy, DinghySearch, ParseLinks, AlertService, paginationConstants, pagingParams) {

        var vm = this;

        vm.loadPage = loadPage;
        vm.predicate = pagingParams.predicate;
        vm.reverse = pagingParams.ascending;
        vm.transition = transition;
        vm.itemsPerPage = paginationConstants.itemsPerPage;
        vm.clear = clear;
        vm.search = search;
        vm.loadAll = loadAll;
        vm.searchQuery = pagingParams.search;
        vm.currentSearch = pagingParams.search;

        loadAll();

        function loadAll () {
            if (pagingParams.search) {
                DinghySearch.query({
                    query: pagingParams.search,
                    page: pagingParams.page - 1,
                    size: vm.itemsPerPage,
                    sort: sort()
                }, onSuccess, onError);
            } else {
                Dinghy.query({
                    page: pagingParams.page - 1,
                    size: vm.itemsPerPage,
                    sort: sort()
                }, onSuccess, onError);
            }
            function sort() {
                var result = [vm.predicate + ',' + (vm.reverse ? 'asc' : 'desc')];
                if (vm.predicate !== 'id') {
                    result.push('id');
                }
                return result;
            }
            function onSuccess(data, headers) {
                vm.links = ParseLinks.parse(headers('link'));
                vm.totalItems = headers('X-Total-Count');
                vm.queryCount = vm.totalItems;
                vm.dinghies = data;
                vm.page = pagingParams.page;
            }
            function onError(error) {
                AlertService.error(error.data.message);
            }
        }

        function loadPage(page) {
            vm.page = page;
            vm.transition();
        }

        function transition() {
            $state.transitionTo($state.$current, {
                page: vm.page,
                sort: vm.predicate + ',' + (vm.reverse ? 'asc' : 'desc'),
                search: vm.currentSearch
            });
        }

        function search(searchQuery) {
            if (!searchQuery){
                return vm.clear();
            }
            vm.links = null;
            vm.page = 1;
            vm.predicate = '_score';
            vm.reverse = false;
            vm.currentSearch = searchQuery;
            vm.transition();
        }

        function clear() {
            vm.links = null;
            vm.page = 1;
            vm.predicate = 'id';
            vm.reverse = true;
            vm.currentSearch = null;
            vm.transition();
        }
    }
})();

/*
 * Copyright (c) 2017 by Julian Feder, julian.feder@yahoo.de
 *
 * This product includes software developed at
 * The Apache Software Foundation (http://www.apache.org/).
 */

(function() {
    'use strict';

    angular
        .module('askApp')
        .controller('DeptDialogController', DeptDialogController);

    DeptDialogController.$inject = ['$timeout', '$scope', '$stateParams', '$uibModalInstance', 'entity', 'Dept', 'Profile', 'Payment', 'Booking', 'Activities', 'Project', 'DinghyEvent'];

    function DeptDialogController ($timeout, $scope, $stateParams, $uibModalInstance, entity, Dept, Profile, Payment, Booking, Activities, Project, DinghyEvent) {
        var vm = this;

        vm.dept = entity;
        vm.clear = clear;
        vm.datePickerOpenStatus = {};
        vm.openCalendar = openCalendar;
        vm.save = save;
        vm.profiles = Profile.query();
        vm.payments = Payment.query();
        vm.bookings = Booking.query();
        vm.activities = Activities.query();
        vm.projects = Project.query();
        vm.dinghyevents = DinghyEvent.query();

        $timeout(function (){
            angular.element('.form-group:eq(1)>input').focus();
        });

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function save () {
            vm.isSaving = true;
            if (vm.dept.id !== null) {
                Dept.update(vm.dept, onSaveSuccess, onSaveError);
            } else {
                Dept.save(vm.dept, onSaveSuccess, onSaveError);
            }
        }

        function onSaveSuccess (result) {
            $scope.$emit('askApp:deptUpdate', result);
            $uibModalInstance.close(result);
            vm.isSaving = false;
        }

        function onSaveError () {
            vm.isSaving = false;
        }

        vm.datePickerOpenStatus.date = false;

        function openCalendar (date) {
            vm.datePickerOpenStatus[date] = true;
        }
    }
})();

/*
 * Copyright (c) 2017 by Julian Feder, julian.feder@yahoo.de
 *
 * This product includes software developed at
 * The Apache Software Foundation (http://www.apache.org/).
 */

(function() {
    'use strict';

    angular
        .module('askApp')
        .controller('DeptDetailController', DeptDetailController);

    DeptDetailController.$inject = ['$scope', '$rootScope', '$stateParams', 'previousState', 'entity', 'Dept', 'Profile', 'Payment', 'Booking', 'Activities', 'Project', 'DinghyEvent'];

    function DeptDetailController($scope, $rootScope, $stateParams, previousState, entity, Dept, Profile, Payment, Booking, Activities, Project, DinghyEvent) {
        var vm = this;

        vm.dept = entity;
        vm.previousState = previousState.name;

        var unsubscribe = $rootScope.$on('askApp:deptUpdate', function(event, result) {
            vm.dept = result;
        });
        $scope.$on('$destroy', unsubscribe);
    }
})();

/*
 * Copyright (c) 2017 by Julian Feder, julian.feder@yahoo.de
 *
 * This product includes software developed at
 * The Apache Software Foundation (http://www.apache.org/).
 */

(function() {
    'use strict';

    angular
        .module('askApp')
        .controller('DeptDeleteController',DeptDeleteController);

    DeptDeleteController.$inject = ['$uibModalInstance', 'entity', 'Dept'];

    function DeptDeleteController($uibModalInstance, entity, Dept) {
        var vm = this;

        vm.dept = entity;
        vm.clear = clear;
        vm.confirmDelete = confirmDelete;

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function confirmDelete (id) {
            Dept.delete({id: id},
                function () {
                    $uibModalInstance.close(true);
                });
        }
    }
})();

/*
 * Copyright (c) 2017 by Julian Feder, julian.feder@yahoo.de
 *
 * This product includes software developed at
 * The Apache Software Foundation (http://www.apache.org/).
 */

(function() {
    'use strict';

    angular
        .module('askApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
        .state('dept', {
            parent: 'entity',
            url: '/dept?page&sort&search',
            data: {
                authorities: ['ROLE_ADMIN'],
                pageTitle: 'askApp.dept.home.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/dept/depts.html',
                    controller: 'DeptController',
                    controllerAs: 'vm'
                }
            },
            params: {
                page: {
                    value: '1',
                    squash: true
                },
                sort: {
                    value: 'id,asc',
                    squash: true
                },
                search: null
            },
            resolve: {
                pagingParams: ['$stateParams', 'PaginationUtil', function ($stateParams, PaginationUtil) {
                    return {
                        page: PaginationUtil.parsePage($stateParams.page),
                        sort: $stateParams.sort,
                        predicate: PaginationUtil.parsePredicate($stateParams.sort),
                        ascending: PaginationUtil.parseAscending($stateParams.sort),
                        search: $stateParams.search
                    };
                }],
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('dept');
                    $translatePartialLoader.addPart('enumDeptStatus');
                    $translatePartialLoader.addPart('global');
                    return $translate.refresh();
                }]
            }
        })
        .state('dept-detail', {
            parent: 'dept',
            url: '/dept/{id}',
            data: {
                authorities: ['ROLE_ADMIN'],
                pageTitle: 'askApp.dept.detail.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/dept/dept-detail.html',
                    controller: 'DeptDetailController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('dept');
                    $translatePartialLoader.addPart('enumDeptStatus');
                    return $translate.refresh();
                }],
                entity: ['$stateParams', 'Dept', function($stateParams, Dept) {
                    return Dept.get({id : $stateParams.id}).$promise;
                }],
                previousState: ["$state", function ($state) {
                    var currentStateData = {
                        name: $state.current.name || 'dept',
                        params: $state.params,
                        url: $state.href($state.current.name, $state.params)
                    };
                    return currentStateData;
                }]
            }
        })
        .state('dept-detail.edit', {
            parent: 'dept-detail',
            url: '/detail/edit',
            data: {
                authorities: ['ROLE_ADMIN']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/dept/dept-dialog.html',
                    controller: 'DeptDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: ['Dept', function(Dept) {
                            return Dept.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('^', {}, { reload: false });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('dept.new', {
            parent: 'dept',
            url: '/new',
            data: {
                authorities: ['ROLE_ADMIN']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/dept/dept-dialog.html',
                    controller: 'DeptDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: function () {
                            return {
                                reference: null,
                                date: null,
                                amount: null,
                                comment: null,
                                sepa: null,
                                paymentStatus: null,
                                id: null
                            };
                        }
                    }
                }).result.then(function() {
                    $state.go('dept', null, { reload: 'dept' });
                }, function() {
                    $state.go('dept');
                });
            }]
        })
        .state('dept.edit', {
            parent: 'dept',
            url: '/{id}/edit',
            data: {
                authorities: ['ROLE_ADMIN']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/dept/dept-dialog.html',
                    controller: 'DeptDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: ['Dept', function(Dept) {
                            return Dept.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('dept', null, { reload: 'dept' });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('dept.delete', {
            parent: 'dept',
            url: '/{id}/delete',
            data: {
                authorities: ['ROLE_ADMIN']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/dept/dept-delete-dialog.html',
                    controller: 'DeptDeleteController',
                    controllerAs: 'vm',
                    size: 'md',
                    resolve: {
                        entity: ['Dept', function(Dept) {
                            return Dept.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('dept', null, { reload: 'dept' });
                }, function() {
                    $state.go('^');
                });
            }]
        });
    }

})();

/*
 * Copyright (c) 2017 by Julian Feder, julian.feder@yahoo.de
 *
 * This product includes software developed at
 * The Apache Software Foundation (http://www.apache.org/).
 */

(function() {
    'use strict';
    angular
        .module('askApp')
        .factory('Dept', Dept);

    Dept.$inject = ['$resource', 'DateUtils'];

    function Dept ($resource, DateUtils) {
        var resourceUrl =  'api/depts/:id';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true},
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                        data.date = DateUtils.convertLocalDateFromServer(data.date);
                    }
                    return data;
                }
            },
            'update': {
                method: 'PUT',
                transformRequest: function (data) {
                    var copy = angular.copy(data);
                    copy.date = DateUtils.convertLocalDateToServer(copy.date);
                    return angular.toJson(copy);
                }
            },
            'save': {
                method: 'POST',
                transformRequest: function (data) {
                    var copy = angular.copy(data);
                    copy.date = DateUtils.convertLocalDateToServer(copy.date);
                    return angular.toJson(copy);
                }
            }
        });
    }
})();

/*
 * Copyright (c) 2017 by Julian Feder, julian.feder@yahoo.de
 *
 * This product includes software developed at
 * The Apache Software Foundation (http://www.apache.org/).
 */

(function() {
    'use strict';

    angular
        .module('askApp')
        .factory('DeptSearch', DeptSearch);

    DeptSearch.$inject = ['$resource'];

    function DeptSearch($resource) {
        var resourceUrl =  'api/_search/depts/:id';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true}
        });
    }
})();

/*
 * Copyright (c) 2017 by Julian Feder, julian.feder@yahoo.de
 *
 * This product includes software developed at
 * The Apache Software Foundation (http://www.apache.org/).
 */

(function() {
    'use strict';

    angular
        .module('askApp')
        .controller('DeptController', DeptController);

    DeptController.$inject = ['$state', 'Dept', 'DeptSearch', 'ParseLinks', 'AlertService', 'paginationConstants', 'pagingParams'];

    function DeptController($state, Dept, DeptSearch, ParseLinks, AlertService, paginationConstants, pagingParams) {

        var vm = this;

        vm.loadPage = loadPage;
        vm.predicate = pagingParams.predicate;
        vm.reverse = pagingParams.ascending;
        vm.transition = transition;
        vm.itemsPerPage = paginationConstants.itemsPerPage;
        vm.clear = clear;
        vm.search = search;
        vm.loadAll = loadAll;
        vm.searchQuery = pagingParams.search;
        vm.currentSearch = pagingParams.search;

        loadAll();

        function loadAll () {
            if (pagingParams.search) {
                DeptSearch.query({
                    query: pagingParams.search,
                    page: pagingParams.page - 1,
                    size: vm.itemsPerPage,
                    sort: sort()
                }, onSuccess, onError);
            } else {
                Dept.query({
                    page: pagingParams.page - 1,
                    size: vm.itemsPerPage,
                    sort: sort()
                }, onSuccess, onError);
            }
            function sort() {
                var result = [vm.predicate + ',' + (vm.reverse ? 'asc' : 'desc')];
                if (vm.predicate !== 'id') {
                    result.push('id');
                }
                return result;
            }
            function onSuccess(data, headers) {
                vm.links = ParseLinks.parse(headers('link'));
                vm.totalItems = headers('X-Total-Count');
                vm.queryCount = vm.totalItems;
                vm.depts = data;
                vm.page = pagingParams.page;
            }
            function onError(error) {
                AlertService.error(error.data.message);
            }
        }

        function loadPage(page) {
            vm.page = page;
            vm.transition();
        }

        function transition() {
            $state.transitionTo($state.$current, {
                page: vm.page,
                sort: vm.predicate + ',' + (vm.reverse ? 'asc' : 'desc'),
                search: vm.currentSearch
            });
        }

        function search(searchQuery) {
            if (!searchQuery){
                return vm.clear();
            }
            vm.links = null;
            vm.page = 1;
            vm.predicate = '_score';
            vm.reverse = false;
            vm.currentSearch = searchQuery;
            vm.transition();
        }

        function clear() {
            vm.links = null;
            vm.page = 1;
            vm.predicate = 'id';
            vm.reverse = true;
            vm.currentSearch = null;
            vm.transition();
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('askApp')
        .controller('ContentDialogController', ContentDialogController);

    ContentDialogController.$inject = ['$timeout', '$scope', '$stateParams', '$uibModalInstance', 'entity', 'Content'];

    function ContentDialogController ($timeout, $scope, $stateParams, $uibModalInstance, entity, Content) {
        var vm = this;

        vm.content = entity;
        vm.clear = clear;
        vm.save = save;

        $timeout(function (){
            angular.element('.form-group:eq(1)>input').focus();
        });

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function save () {
            vm.isSaving = true;
            if (vm.content.id !== null) {
                Content.update(vm.content, onSaveSuccess, onSaveError);
            } else {
                Content.save(vm.content, onSaveSuccess, onSaveError);
            }
        }

        function onSaveSuccess (result) {
            $scope.$emit('askApp:contentUpdate', result);
            $uibModalInstance.close(result);
            vm.isSaving = false;
        }

        function onSaveError () {
            vm.isSaving = false;
        }


    }
})();

(function() {
    'use strict';

    angular
        .module('askApp')
        .controller('ContentDetailController', ContentDetailController);

    ContentDetailController.$inject = ['$scope', '$rootScope', '$stateParams', 'previousState', 'entity', 'Content'];

    function ContentDetailController($scope, $rootScope, $stateParams, previousState, entity, Content) {
        var vm = this;

        vm.content = entity;
        vm.previousState = previousState.name;

        var unsubscribe = $rootScope.$on('askApp:contentUpdate', function(event, result) {
            vm.content = result;
        });
        $scope.$on('$destroy', unsubscribe);
    }
})();

(function() {
    'use strict';

    angular
        .module('askApp')
        .controller('ContentDeleteController',ContentDeleteController);

    ContentDeleteController.$inject = ['$uibModalInstance', 'entity', 'Content'];

    function ContentDeleteController($uibModalInstance, entity, Content) {
        var vm = this;

        vm.content = entity;
        vm.clear = clear;
        vm.confirmDelete = confirmDelete;

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function confirmDelete (id) {
            Content.delete({id: id},
                function () {
                    $uibModalInstance.close(true);
                });
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('askApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
        .state('content', {
            parent: 'entity',
            url: '/content?page&sort&search',
            data: {
                authorities: ['ROLE_ADMIN'],
                pageTitle: 'askApp.content.home.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/content/contents.html',
                    controller: 'ContentController',
                    controllerAs: 'vm'
                }
            },
            params: {
                page: {
                    value: '1',
                    squash: true
                },
                sort: {
                    value: 'id,asc',
                    squash: true
                },
                search: null
            },
            resolve: {
                pagingParams: ['$stateParams', 'PaginationUtil', function ($stateParams, PaginationUtil) {
                    return {
                        page: PaginationUtil.parsePage($stateParams.page),
                        sort: $stateParams.sort,
                        predicate: PaginationUtil.parsePredicate($stateParams.sort),
                        ascending: PaginationUtil.parseAscending($stateParams.sort),
                        search: $stateParams.search
                    };
                }],
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('content');
                    $translatePartialLoader.addPart('enumContentAccess');
                    $translatePartialLoader.addPart('global');
                    return $translate.refresh();
                }]
            }
        })
        .state('content-detail', {
            parent: 'content',
            url: '/content/{id}',
            data: {
                authorities: ['ROLE_ADMIN'],
                pageTitle: 'askApp.content.detail.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/content/content-detail.html',
                    controller: 'ContentDetailController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('content');
                    $translatePartialLoader.addPart('enumContentAccess');
                    return $translate.refresh();
                }],
                entity: ['$stateParams', 'Content', function($stateParams, Content) {
                    return Content.get({id : $stateParams.id}).$promise;
                }],
                previousState: ["$state", function ($state) {
                    var currentStateData = {
                        name: $state.current.name || 'content',
                        params: $state.params,
                        url: $state.href($state.current.name, $state.params)
                    };
                    return currentStateData;
                }]
            }
        })
        .state('content-detail.edit', {
            parent: 'content-detail',
            url: '/detail/edit',
            data: {
                authorities: ['ROLE_ADMIN']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/content/content-dialog.html',
                    controller: 'ContentDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: ['Content', function(Content) {
                            return Content.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('^', {}, { reload: false });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('content.new', {
            parent: 'content',
            url: '/new',
            data: {
                authorities: ['ROLE_ADMIN']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/content/content-dialog.html',
                    controller: 'ContentDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: function () {
                            return {
                                text: null,
                                access: null,
                                id: null
                            };
                        }
                    }
                }).result.then(function() {
                    $state.go('content', null, { reload: 'content' });
                }, function() {
                    $state.go('content');
                });
            }]
        })
        .state('content.edit', {
            parent: 'content',
            url: '/{id}/edit',
            data: {
                authorities: ['ROLE_ADMIN']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/content/content-dialog.html',
                    controller: 'ContentDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: ['Content', function(Content) {
                            return Content.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('content', null, { reload: 'content' });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('content.delete', {
            parent: 'content',
            url: '/{id}/delete',
            data: {
                authorities: ['ROLE_ADMIN']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/content/content-delete-dialog.html',
                    controller: 'ContentDeleteController',
                    controllerAs: 'vm',
                    size: 'md',
                    resolve: {
                        entity: ['Content', function(Content) {
                            return Content.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('content', null, { reload: 'content' });
                }, function() {
                    $state.go('^');
                });
            }]
        });
    }

})();

(function() {
    'use strict';

    angular
        .module('askApp')
        .controller('ContentController', ContentController);

    ContentController.$inject = ['$state', 'Content', 'ContentSearch', 'ParseLinks', 'AlertService', 'paginationConstants', 'pagingParams'];

    function ContentController($state, Content, ContentSearch, ParseLinks, AlertService, paginationConstants, pagingParams) {

        var vm = this;

        vm.loadPage = loadPage;
        vm.predicate = pagingParams.predicate;
        vm.reverse = pagingParams.ascending;
        vm.transition = transition;
        vm.itemsPerPage = paginationConstants.itemsPerPage;
        vm.clear = clear;
        vm.search = search;
        vm.loadAll = loadAll;
        vm.searchQuery = pagingParams.search;
        vm.currentSearch = pagingParams.search;

        loadAll();

        function loadAll () {
            if (pagingParams.search) {
                ContentSearch.query({
                    query: pagingParams.search,
                    page: pagingParams.page - 1,
                    size: vm.itemsPerPage,
                    sort: sort()
                }, onSuccess, onError);
            } else {
                Content.query({
                    page: pagingParams.page - 1,
                    size: vm.itemsPerPage,
                    sort: sort()
                }, onSuccess, onError);
            }
            function sort() {
                var result = [vm.predicate + ',' + (vm.reverse ? 'asc' : 'desc')];
                if (vm.predicate !== 'id') {
                    result.push('id');
                }
                return result;
            }
            function onSuccess(data, headers) {
                vm.links = ParseLinks.parse(headers('link'));
                vm.totalItems = headers('X-Total-Count');
                vm.queryCount = vm.totalItems;
                vm.contents = data;
                vm.page = pagingParams.page;
            }
            function onError(error) {
                AlertService.error(error.data.message);
            }
        }

        function loadPage(page) {
            vm.page = page;
            vm.transition();
        }

        function transition() {
            $state.transitionTo($state.$current, {
                page: vm.page,
                sort: vm.predicate + ',' + (vm.reverse ? 'asc' : 'desc'),
                search: vm.currentSearch
            });
        }

        function search(searchQuery) {
            if (!searchQuery){
                return vm.clear();
            }
            vm.links = null;
            vm.page = 1;
            vm.predicate = '_score';
            vm.reverse = false;
            vm.currentSearch = searchQuery;
            vm.transition();
        }

        function clear() {
            vm.links = null;
            vm.page = 1;
            vm.predicate = 'id';
            vm.reverse = true;
            vm.currentSearch = null;
            vm.transition();
        }
    }
})();

/*
 * Copyright (c) 2017 by Julian Feder, julian.feder@yahoo.de
 *
 * This product includes software developed at
 * The Apache Software Foundation (http://www.apache.org/).
 */

(function() {
    'use strict';

    angular
        .module('askApp')
        .controller('BookingDialogController', BookingDialogController);

    BookingDialogController.$inject = ['$timeout', '$scope', '$stateParams', '$uibModalInstance', '$q', 'entity', 'Booking', 'Project', 'Profile', 'SbfTimeSlot', 'Dept', 'Crew'];

    function BookingDialogController ($timeout, $scope, $stateParams, $uibModalInstance, $q, entity, Booking, Project, Profile, SbfTimeSlot, Dept, Crew) {
        var vm = this;

        vm.booking = entity;
        vm.clear = clear;
        vm.datePickerOpenStatus = {};
        vm.openCalendar = openCalendar;
        vm.save = save;
        vm.projects = Project.query();
        vm.profiles = Profile.query();
        vm.sbftimeslots = SbfTimeSlot.query();
        vm.depts = Dept.query({filter: 'booking-is-null'});
        $q.all([vm.booking.$promise, vm.depts.$promise]).then(function() {
            if (!vm.booking.dept || !vm.booking.dept.id) {
                return $q.reject();
            }
            return Dept.get({id : vm.booking.dept.id}).$promise;
        }).then(function(dept) {
            vm.depts.push(dept);
        });
        vm.crews = Crew.query();

        $timeout(function (){
            angular.element('.form-group:eq(1)>input').focus();
        });

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function save () {
            vm.isSaving = true;
            if (vm.booking.id !== null) {
                Booking.update(vm.booking, onSaveSuccess, onSaveError);
            } else {
                Booking.save(vm.booking, onSaveSuccess, onSaveError);
            }
        }

        function onSaveSuccess (result) {
            $scope.$emit('askApp:bookingUpdate', result);
            $uibModalInstance.close(result);
            vm.isSaving = false;
        }

        function onSaveError () {
            vm.isSaving = false;
        }

        vm.datePickerOpenStatus.date = false;

        function openCalendar (date) {
            vm.datePickerOpenStatus[date] = true;
        }
    }
})();

/*
 * Copyright (c) 2017 by Julian Feder, julian.feder@yahoo.de
 *
 * This product includes software developed at
 * The Apache Software Foundation (http://www.apache.org/).
 */

(function() {
    'use strict';

    angular
        .module('askApp')
        .controller('BookingDetailController', BookingDetailController);

    BookingDetailController.$inject = ['$scope', '$rootScope', '$stateParams', 'previousState', 'entity', 'Booking', 'Project', 'Profile', 'SbfTimeSlot', 'Dept', 'Crew'];

    function BookingDetailController($scope, $rootScope, $stateParams, previousState, entity, Booking, Project, Profile, SbfTimeSlot, Dept, Crew) {
        var vm = this;

        vm.booking = entity;
        vm.previousState = previousState.name;

        var unsubscribe = $rootScope.$on('askApp:bookingUpdate', function(event, result) {
            vm.booking = result;
        });
        $scope.$on('$destroy', unsubscribe);
    }
})();

/*
 * Copyright (c) 2017 by Julian Feder, julian.feder@yahoo.de
 *
 * This product includes software developed at
 * The Apache Software Foundation (http://www.apache.org/).
 */

(function() {
    'use strict';

    angular
        .module('askApp')
        .controller('BookingDeleteController',BookingDeleteController);

    BookingDeleteController.$inject = ['$uibModalInstance', 'entity', 'Booking'];

    function BookingDeleteController($uibModalInstance, entity, Booking) {
        var vm = this;

        vm.booking = entity;
        vm.clear = clear;
        vm.confirmDelete = confirmDelete;

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function confirmDelete (id) {
            Booking.delete({id: id},
                function () {
                    $uibModalInstance.close(true);
                });
        }
    }
})();

/*
 * Copyright (c) 2017 by Julian Feder, julian.feder@yahoo.de
 *
 * This product includes software developed at
 * The Apache Software Foundation (http://www.apache.org/).
 */

(function() {
    'use strict';

    angular
        .module('askApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
        .state('booking', {
            parent: 'entity',
            url: '/booking?page&sort&search',
            data: {
                authorities: ['ROLE_ADMIN'],
                pageTitle: 'askApp.booking.home.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/booking/bookings.html',
                    controller: 'BookingController',
                    controllerAs: 'vm'
                }
            },
            params: {
                page: {
                    value: '1',
                    squash: true
                },
                sort: {
                    value: 'id,asc',
                    squash: true
                },
                search: null
            },
            resolve: {
                pagingParams: ['$stateParams', 'PaginationUtil', function ($stateParams, PaginationUtil) {
                    return {
                        page: PaginationUtil.parsePage($stateParams.page),
                        sort: $stateParams.sort,
                        predicate: PaginationUtil.parsePredicate($stateParams.sort),
                        ascending: PaginationUtil.parseAscending($stateParams.sort),
                        search: $stateParams.search
                    };
                }],
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('booking');
                    $translatePartialLoader.addPart('enumBookingStatusType');
                    $translatePartialLoader.addPart('global');
                    return $translate.refresh();
                }]
            }
        })
        .state('booking-detail', {
            parent: 'booking',
            url: '/booking/{id}',
            data: {
                authorities: ['ROLE_ADMIN'],
                pageTitle: 'askApp.booking.detail.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/booking/booking-detail.html',
                    controller: 'BookingDetailController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('booking');
                    $translatePartialLoader.addPart('enumBookingStatusType');
                    return $translate.refresh();
                }],
                entity: ['$stateParams', 'Booking', function($stateParams, Booking) {
                    return Booking.get({id : $stateParams.id}).$promise;
                }],
                previousState: ["$state", function ($state) {
                    var currentStateData = {
                        name: $state.current.name || 'booking',
                        params: $state.params,
                        url: $state.href($state.current.name, $state.params)
                    };
                    return currentStateData;
                }]
            }
        })
        .state('booking-detail.edit', {
            parent: 'booking-detail',
            url: '/detail/edit',
            data: {
                authorities: ['ROLE_ADMIN']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/booking/booking-dialog.html',
                    controller: 'BookingDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: ['Booking', function(Booking) {
                            return Booking.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('^', {}, { reload: false });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('booking.new', {
            parent: 'booking',
            url: '/new',
            data: {
                authorities: ['ROLE_ADMIN']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/booking/booking-dialog.html',
                    controller: 'BookingDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: function () {
                            return {
                                date: null,
                                price: null,
                                status: null,
                                comment: null,
                                individualField: null,
                                crewPosition: null,
                                sksTheoryAvailable: null,
                                sbfSlotsMax: null,
                                id: null
                            };
                        }
                    }
                }).result.then(function() {
                    $state.go('booking', null, { reload: 'booking' });
                }, function() {
                    $state.go('booking');
                });
            }]
        })
        .state('booking.edit', {
            parent: 'booking',
            url: '/{id}/edit',
            data: {
                authorities: ['ROLE_ADMIN']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/booking/booking-dialog.html',
                    controller: 'BookingDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: ['Booking', function(Booking) {
                            return Booking.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('booking', null, { reload: 'booking' });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('booking.delete', {
            parent: 'booking',
            url: '/{id}/delete',
            data: {
                authorities: ['ROLE_ADMIN']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/booking/booking-delete-dialog.html',
                    controller: 'BookingDeleteController',
                    controllerAs: 'vm',
                    size: 'md',
                    resolve: {
                        entity: ['Booking', function(Booking) {
                            return Booking.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('booking', null, { reload: 'booking' });
                }, function() {
                    $state.go('^');
                });
            }]
        });
    }

})();

/*
 * Copyright (c) 2017 by Julian Feder, julian.feder@yahoo.de
 *
 * This product includes software developed at
 * The Apache Software Foundation (http://www.apache.org/).
 */

(function() {
    'use strict';
    angular
        .module('askApp')
        .factory('Booking', Booking);

    Booking.$inject = ['$resource', 'DateUtils'];

    function Booking ($resource, DateUtils) {
        var resourceUrl =  'api/bookings/:id';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true},
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                        data.date = DateUtils.convertLocalDateFromServer(data.date);
                    }
                    return data;
                }
            },
            'update': {
                method: 'PUT',
                transformRequest: function (data) {
                    var copy = angular.copy(data);
                    copy.date = DateUtils.convertLocalDateToServer(copy.date);
                    return angular.toJson(copy);
                }
            },
            'save': {
                method: 'POST',
                transformRequest: function (data) {
                    var copy = angular.copy(data);
                    copy.date = DateUtils.convertLocalDateToServer(copy.date);
                    return angular.toJson(copy);
                }
            }
        });
    }
})();

/*
 * Copyright (c) 2017 by Julian Feder, julian.feder@yahoo.de
 *
 * This product includes software developed at
 * The Apache Software Foundation (http://www.apache.org/).
 */

(function() {
    'use strict';

    angular
        .module('askApp')
        .factory('BookingSearch', BookingSearch);

    BookingSearch.$inject = ['$resource'];

    function BookingSearch($resource) {
        var resourceUrl =  'api/_search/bookings/:id';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true}
        });
    }
})();

/*
 * Copyright (c) 2017 by Julian Feder, julian.feder@yahoo.de
 *
 * This product includes software developed at
 * The Apache Software Foundation (http://www.apache.org/).
 */

(function() {
    'use strict';

    angular
        .module('askApp')
        .controller('BookingController', BookingController);

    BookingController.$inject = ['$state', 'Booking', 'BookingSearch', 'ParseLinks', 'AlertService', 'paginationConstants', 'pagingParams'];

    function BookingController($state, Booking, BookingSearch, ParseLinks, AlertService, paginationConstants, pagingParams) {

        var vm = this;

        vm.loadPage = loadPage;
        vm.predicate = pagingParams.predicate;
        vm.reverse = pagingParams.ascending;
        vm.transition = transition;
        vm.itemsPerPage = paginationConstants.itemsPerPage;
        vm.clear = clear;
        vm.search = search;
        vm.loadAll = loadAll;
        vm.searchQuery = pagingParams.search;
        vm.currentSearch = pagingParams.search;

        loadAll();

        function loadAll () {
            if (pagingParams.search) {
                BookingSearch.query({
                    query: pagingParams.search,
                    page: pagingParams.page - 1,
                    size: vm.itemsPerPage,
                    sort: sort()
                }, onSuccess, onError);
            } else {
                Booking.query({
                    page: pagingParams.page - 1,
                    size: vm.itemsPerPage,
                    sort: sort()
                }, onSuccess, onError);
            }
            function sort() {
                var result = [vm.predicate + ',' + (vm.reverse ? 'asc' : 'desc')];
                if (vm.predicate !== 'id') {
                    result.push('id');
                }
                return result;
            }
            function onSuccess(data, headers) {
                vm.links = ParseLinks.parse(headers('link'));
                vm.totalItems = headers('X-Total-Count');
                vm.queryCount = vm.totalItems;
                vm.bookings = data;
                vm.page = pagingParams.page;
            }
            function onError(error) {
                AlertService.error(error.data.message);
            }
        }

        function loadPage(page) {
            vm.page = page;
            vm.transition();
        }

        function transition() {
            $state.transitionTo($state.$current, {
                page: vm.page,
                sort: vm.predicate + ',' + (vm.reverse ? 'asc' : 'desc'),
                search: vm.currentSearch
            });
        }

        function search(searchQuery) {
            if (!searchQuery){
                return vm.clear();
            }
            vm.links = null;
            vm.page = 1;
            vm.predicate = '_score';
            vm.reverse = false;
            vm.currentSearch = searchQuery;
            vm.transition();
        }

        function clear() {
            vm.links = null;
            vm.page = 1;
            vm.predicate = 'id';
            vm.reverse = true;
            vm.currentSearch = null;
            vm.transition();
        }
    }
})();

/*
 * Copyright (c) 2017 by Julian Feder, julian.feder@yahoo.de
 *
 * This product includes software developed at
 * The Apache Software Foundation (http://www.apache.org/).
 */

(function() {
    'use strict';

    angular
        .module('askApp')
        .controller('ActivitiesDialogController', ActivitiesDialogController);

    ActivitiesDialogController.$inject = ['$timeout', '$scope', '$stateParams', '$uibModalInstance', 'entity', 'Activities', 'Profile', 'Booking'];

    function ActivitiesDialogController ($timeout, $scope, $stateParams, $uibModalInstance, entity, Activities, Profile, Booking) {
        var vm = this;

        vm.activities = entity;
        vm.clear = clear;
        vm.datePickerOpenStatus = {};
        vm.openCalendar = openCalendar;
        vm.save = save;
        vm.profiles = Profile.query();
        vm.bookings = Booking.query();

        $timeout(function (){
            angular.element('.form-group:eq(1)>input').focus();
        });

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function save () {
            vm.isSaving = true;
            if (vm.activities.id !== null) {
                Activities.update(vm.activities, onSaveSuccess, onSaveError);
            } else {
                Activities.save(vm.activities, onSaveSuccess, onSaveError);
            }
        }

        function onSaveSuccess (result) {
            $scope.$emit('askApp:activitiesUpdate', result);
            $uibModalInstance.close(result);
            vm.isSaving = false;
        }

        function onSaveError () {
            vm.isSaving = false;
        }

        vm.datePickerOpenStatus.activitiesDate = false;
        vm.datePickerOpenStatus.validFrom = false;

        function openCalendar (date) {
            vm.datePickerOpenStatus[date] = true;
        }
    }
})();

/*
 * Copyright (c) 2017 by Julian Feder, julian.feder@yahoo.de
 *
 * This product includes software developed at
 * The Apache Software Foundation (http://www.apache.org/).
 */

(function() {
    'use strict';

    angular
        .module('askApp')
        .controller('ActivitiesDetailController', ActivitiesDetailController);

    ActivitiesDetailController.$inject = ['$scope', '$rootScope', '$stateParams', 'previousState', 'entity', 'Activities', 'Profile', 'Booking'];

    function ActivitiesDetailController($scope, $rootScope, $stateParams, previousState, entity, Activities, Profile, Booking) {
        var vm = this;

        vm.activities = entity;
        vm.previousState = previousState.name;

        var unsubscribe = $rootScope.$on('askApp:activitiesUpdate', function(event, result) {
            vm.activities = result;
        });
        $scope.$on('$destroy', unsubscribe);
    }
})();

/*
 * Copyright (c) 2017 by Julian Feder, julian.feder@yahoo.de
 *
 * This product includes software developed at
 * The Apache Software Foundation (http://www.apache.org/).
 */

(function() {
    'use strict';

    angular
        .module('askApp')
        .controller('ActivitiesDeleteController',ActivitiesDeleteController);

    ActivitiesDeleteController.$inject = ['$uibModalInstance', 'entity', 'Activities'];

    function ActivitiesDeleteController($uibModalInstance, entity, Activities) {
        var vm = this;

        vm.activities = entity;
        vm.clear = clear;
        vm.confirmDelete = confirmDelete;

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function confirmDelete (id) {
            Activities.delete({id: id},
                function () {
                    $uibModalInstance.close(true);
                });
        }
    }
})();

/*
 * Copyright (c) 2017 by Julian Feder, julian.feder@yahoo.de
 *
 * This product includes software developed at
 * The Apache Software Foundation (http://www.apache.org/).
 */

(function() {
    'use strict';

    angular
        .module('askApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
        .state('activities', {
            parent: 'entity',
            url: '/activities?page&sort&search',
            data: {
                authorities: ['ROLE_ADMIN'],
                pageTitle: 'askApp.activities.home.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/activities/activities.html',
                    controller: 'ActivitiesController',
                    controllerAs: 'vm'
                }
            },
            params: {
                page: {
                    value: '1',
                    squash: true
                },
                sort: {
                    value: 'id,asc',
                    squash: true
                },
                search: null
            },
            resolve: {
                pagingParams: ['$stateParams', 'PaginationUtil', function ($stateParams, PaginationUtil) {
                    return {
                        page: PaginationUtil.parsePage($stateParams.page),
                        sort: $stateParams.sort,
                        predicate: PaginationUtil.parsePredicate($stateParams.sort),
                        ascending: PaginationUtil.parseAscending($stateParams.sort),
                        search: $stateParams.search
                    };
                }],
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('activities');
                    $translatePartialLoader.addPart('enumCategoryActivity');
                    $translatePartialLoader.addPart('global');
                    return $translate.refresh();
                }]
            }
        })
        .state('activities-detail', {
            parent: 'activities',
            url: '/activities/{id}',
            data: {
                authorities: ['ROLE_ADMIN'],
                pageTitle: 'askApp.activities.detail.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/activities/activities-detail.html',
                    controller: 'ActivitiesDetailController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('activities');
                    $translatePartialLoader.addPart('enumCategoryActivity');
                    return $translate.refresh();
                }],
                entity: ['$stateParams', 'Activities', function($stateParams, Activities) {
                    return Activities.get({id : $stateParams.id}).$promise;
                }],
                previousState: ["$state", function ($state) {
                    var currentStateData = {
                        name: $state.current.name || 'activities',
                        params: $state.params,
                        url: $state.href($state.current.name, $state.params)
                    };
                    return currentStateData;
                }]
            }
        })
        .state('activities-detail.edit', {
            parent: 'activities-detail',
            url: '/detail/edit',
            data: {
                authorities: ['ROLE_ADMIN']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/activities/activities-dialog.html',
                    controller: 'ActivitiesDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: ['Activities', function(Activities) {
                            return Activities.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('^', {}, { reload: false });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('activities.new', {
            parent: 'activities',
            url: '/new',
            data: {
                authorities: ['ROLE_ADMIN']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/activities/activities-dialog.html',
                    controller: 'ActivitiesDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: function () {
                            return {
                                activitiesDate: null,
                                validFrom: null,
                                category: null,
                                id: null
                            };
                        }
                    }
                }).result.then(function() {
                    $state.go('activities', null, { reload: 'activities' });
                }, function() {
                    $state.go('activities');
                });
            }]
        })
        .state('activities.edit', {
            parent: 'activities',
            url: '/{id}/edit',
            data: {
                authorities: ['ROLE_ADMIN']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/activities/activities-dialog.html',
                    controller: 'ActivitiesDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: ['Activities', function(Activities) {
                            return Activities.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('activities', null, { reload: 'activities' });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('activities.delete', {
            parent: 'activities',
            url: '/{id}/delete',
            data: {
                authorities: ['ROLE_ADMIN']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/activities/activities-delete-dialog.html',
                    controller: 'ActivitiesDeleteController',
                    controllerAs: 'vm',
                    size: 'md',
                    resolve: {
                        entity: ['Activities', function(Activities) {
                            return Activities.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('activities', null, { reload: 'activities' });
                }, function() {
                    $state.go('^');
                });
            }]
        });
    }

})();

/*
 * Copyright (c) 2017 by Julian Feder, julian.feder@yahoo.de
 *
 * This product includes software developed at
 * The Apache Software Foundation (http://www.apache.org/).
 */

(function() {
    'use strict';
    angular
        .module('askApp')
        .factory('Activities', Activities);

    Activities.$inject = ['$resource', 'DateUtils'];

    function Activities ($resource, DateUtils) {
        var resourceUrl =  'api/activities/:id';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true},
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                        data.activitiesDate = DateUtils.convertLocalDateFromServer(data.activitiesDate);
                        data.validFrom = DateUtils.convertLocalDateFromServer(data.validFrom);
                    }
                    return data;
                }
            },
            'update': {
                method: 'PUT',
                transformRequest: function (data) {
                    var copy = angular.copy(data);
                    copy.activitiesDate = DateUtils.convertLocalDateToServer(copy.activitiesDate);
                    copy.validFrom = DateUtils.convertLocalDateToServer(copy.validFrom);
                    return angular.toJson(copy);
                }
            },
            'save': {
                method: 'POST',
                transformRequest: function (data) {
                    var copy = angular.copy(data);
                    copy.activitiesDate = DateUtils.convertLocalDateToServer(copy.activitiesDate);
                    copy.validFrom = DateUtils.convertLocalDateToServer(copy.validFrom);
                    return angular.toJson(copy);
                }
            }
        });
    }
})();

/*
 * Copyright (c) 2017 by Julian Feder, julian.feder@yahoo.de
 *
 * This product includes software developed at
 * The Apache Software Foundation (http://www.apache.org/).
 */

(function() {
    'use strict';

    angular
        .module('askApp')
        .factory('ActivitiesSearch', ActivitiesSearch);

    ActivitiesSearch.$inject = ['$resource'];

    function ActivitiesSearch($resource) {
        var resourceUrl =  'api/_search/activities/:id';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true}
        });
    }
})();

/*
 * Copyright (c) 2017 by Julian Feder, julian.feder@yahoo.de
 *
 * This product includes software developed at
 * The Apache Software Foundation (http://www.apache.org/).
 */

(function() {
    'use strict';

    angular
        .module('askApp')
        .controller('ActivitiesController', ActivitiesController);

    ActivitiesController.$inject = ['$state', 'Activities', 'ActivitiesSearch', 'ParseLinks', 'AlertService', 'paginationConstants', 'pagingParams'];

    function ActivitiesController($state, Activities, ActivitiesSearch, ParseLinks, AlertService, paginationConstants, pagingParams) {

        var vm = this;

        vm.loadPage = loadPage;
        vm.predicate = pagingParams.predicate;
        vm.reverse = pagingParams.ascending;
        vm.transition = transition;
        vm.itemsPerPage = paginationConstants.itemsPerPage;
        vm.clear = clear;
        vm.search = search;
        vm.loadAll = loadAll;
        vm.searchQuery = pagingParams.search;
        vm.currentSearch = pagingParams.search;

        loadAll();

        function loadAll () {
            if (pagingParams.search) {
                ActivitiesSearch.query({
                    query: pagingParams.search,
                    page: pagingParams.page - 1,
                    size: vm.itemsPerPage,
                    sort: sort()
                }, onSuccess, onError);
            } else {
                Activities.query({
                    page: pagingParams.page - 1,
                    size: vm.itemsPerPage,
                    sort: sort(),
                    profileID: ''
                }, onSuccess, onError);
            }
            function sort() {
                var result = [vm.predicate + ',' + (vm.reverse ? 'asc' : 'desc')];
                if (vm.predicate !== 'id') {
                    result.push('id');
                }
                return result;
            }
            function onSuccess(data, headers) {
                vm.links = ParseLinks.parse(headers('link'));
                vm.totalItems = headers('X-Total-Count');
                vm.queryCount = vm.totalItems;
                vm.activities = data;
                vm.page = pagingParams.page;
            }
            function onError(error) {
                AlertService.error(error.data.message);
            }
        }

        function loadPage(page) {
            vm.page = page;
            vm.transition();
        }

        function transition() {
            $state.transitionTo($state.$current, {
                page: vm.page,
                sort: vm.predicate + ',' + (vm.reverse ? 'asc' : 'desc'),
                search: vm.currentSearch
            });
        }

        function search(searchQuery) {
            if (!searchQuery){
                return vm.clear();
            }
            vm.links = null;
            vm.page = 1;
            vm.predicate = '_score';
            vm.reverse = false;
            vm.currentSearch = searchQuery;
            vm.transition();
        }

        function clear() {
            vm.links = null;
            vm.page = 1;
            vm.predicate = 'id';
            vm.reverse = true;
            vm.currentSearch = null;
            vm.transition();
        }
    }
})();

/*
 * Copyright (c) 2017 by Julian Feder, julian.feder@yahoo.de
 *
 * This product includes software developed at
 * The Apache Software Foundation (http://www.apache.org/).
 */

(function() {
    'use strict';

    angular
        .module('askApp')
        .filter('words', words);

    function words() {
        return wordsFilter;

        function wordsFilter(input, words) {
            if (isNaN(words)) {
                return input;
            }
            if (words <= 0) {
                return '';
            }
            if (input) {
                var inputWords = input.split(/\s+/);
                if (inputWords.length > words) {
                    input = inputWords.slice(0, words).join(' ') + '...';
                }
            }
            return input;
        }
    }
})();

/*
 * Copyright (c) 2017 by Julian Feder, julian.feder@yahoo.de
 *
 * This product includes software developed at
 * The Apache Software Foundation (http://www.apache.org/).
 */

(function() {
    'use strict';

    angular
        .module('askApp')
        .filter('characters', characters);

    function characters () {
        return charactersFilter;

        function charactersFilter(input, chars, breakOnWord) {
            if (isNaN(chars)) {
                return input;
            }
            if (chars <= 0) {
                return '';
            }
            if (input && input.length > chars) {
                input = input.substring(0, chars);

                if (!breakOnWord) {
                    var lastspace = input.lastIndexOf(' ');
                    // Get last space
                    if (lastspace !== -1) {
                        input = input.substr(0, lastspace);
                    }
                } else {
                    while (input.charAt(input.length-1) === ' ') {
                        input = input.substr(0, input.length - 1);
                    }
                }
                return input + '...';
            }
            return input;
        }
    }
})();

/*
 * Copyright (c) 2017 by Julian Feder, julian.feder@yahoo.de
 *
 * This product includes software developed at
 * The Apache Software Foundation (http://www.apache.org/).
 */

(function() {
    'use strict';

    angular
        .module('askApp')
        .directive('jhSortBy', jhSortBy);

    function jhSortBy() {
        var directive = {
            restrict: 'A',
            scope: false,
            require: '^jhSort',
            link: linkFunc
        };

        return directive;

        function linkFunc(scope, element, attrs, parentCtrl) {
            element.bind('click', function () {
                parentCtrl.sort(attrs.jhSortBy);
            });
        }
    }
})();

/*
 * Copyright (c) 2017 by Julian Feder, julian.feder@yahoo.de
 *
 * This product includes software developed at
 * The Apache Software Foundation (http://www.apache.org/).
 */

(function() {
    'use strict';

    angular
        .module('askApp')
        .directive('jhSort', jhSort);

    function jhSort () {
        var directive = {
            restrict: 'A',
            scope: {
                predicate: '=jhSort',
                ascending: '=',
                callback: '&'
            },
            controller: SortController,
            controllerAs: 'vm',
            bindToController: true
        };

        return directive;
    }

    SortController.$inject = ['$scope', '$element'];

    function SortController ($scope, $element) {
        var vm = this;

        vm.applyClass = applyClass;
        vm.resetClasses = resetClasses;
        vm.sort = sort;
        vm.triggerApply = triggerApply;

        $scope.$watchGroup(['vm.predicate', 'vm.ascending'], vm.triggerApply);
        vm.triggerApply();

        function applyClass (element) {
            var thisIcon = element.find('span.glyphicon'),
                sortIcon = 'glyphicon-sort',
                sortAsc = 'glyphicon-sort-by-attributes',
                sortDesc = 'glyphicon-sort-by-attributes-alt',
                remove = sortIcon + ' ' + sortDesc,
                add = sortAsc;
            if (!vm.ascending) {
                remove = sortIcon + ' ' + sortAsc;
                add = sortDesc;
            }
            vm.resetClasses();
            thisIcon.removeClass(remove);
            thisIcon.addClass(add);
        }

        function resetClasses () {
            var allThIcons = $element.find('span.glyphicon'),
                sortIcon = 'glyphicon-sort',
                sortAsc = 'glyphicon-sort-by-attributes',
                sortDesc = 'glyphicon-sort-by-attributes-alt';
            allThIcons.removeClass(sortAsc + ' ' + sortDesc);
            allThIcons.addClass(sortIcon);
        }

        function sort (field) {
            if (field !== vm.predicate) {
                vm.ascending = true;
            } else {
                vm.ascending = !vm.ascending;
            }
            vm.predicate = field;
            $scope.$apply();
            vm.callback();
        }

        function triggerApply (values)  {
            vm.resetClasses();
            if (values && values[0] !== '_score') {
                vm.applyClass($element.find('th[jh-sort-by=\'' + values[0] + '\']'));
            }
        }
    }
})();

/*
 * Copyright (c) 2017 by Julian Feder, julian.feder@yahoo.de
 *
 * This product includes software developed at
 * The Apache Software Foundation (http://www.apache.org/).
 */

(function(){
    'use strict';

    angular
        .module('askApp')
        .factory('ParseLinks', ParseLinks);

    function ParseLinks () {

        var service = {
            parse : parse
        };

        return service;

        function parse(header) {
            if (header.length === 0) {
                throw new Error('input must not be of zero length');
            }

            // Split parts by comma
            var parts = header.split(',');
            var links = {};
            // Parse each part into a named link
            angular.forEach(parts, function(p) {
                var section = p.split('>;');
                if (section.length !== 2) {
                    throw new Error('section could not be split on ">;"');
                }
                var url = section[0].replace(/<(.*)/, '$1').trim();
                var queryString = {};
                url.replace(
                    new RegExp('([^?=&]+)(=([^&]*))?', 'g'),
                    function($0, $1, $2, $3) { queryString[$1] = $3; }
                );
                var page = queryString.page;
                if (angular.isString(page)) {
                    page = parseInt(page);
                }
                var name = section[1].replace(/rel="(.*)"/, '$1').trim();
                links[name] = page;
            });
            return links;
        }
    }
})();

/*
 * Copyright (c) 2017 by Julian Feder, julian.feder@yahoo.de
 *
 * This product includes software developed at
 * The Apache Software Foundation (http://www.apache.org/).
 */

(function () {
    'use strict';

    angular
        .module('askApp')
        .factory('PaginationUtil', PaginationUtil);

    function PaginationUtil () {

        var service = {
            parseAscending : parseAscending,
            parsePage : parsePage,
            parsePredicate : parsePredicate
        };

        return service;

        function parseAscending (sort) {
            var sortArray = sort.split(',');
            if (sortArray.length > 1){
                return sort.split(',').slice(-1)[0] === 'asc';
            } else {
                // default to true if no sort defined
                return true;
            }
        }

        // query params are strings, and need to be parsed
        function parsePage (page) {
            return parseInt(page);
        }

        // sort can be in the format `id,asc` or `id`
        function parsePredicate (sort) {
            var sortArray = sort.split(',');
            if (sortArray.length > 1){
                sortArray.pop();
            }
            return sortArray.join(',');
        }
    }
})();

/*
 * Copyright (c) 2017 by Julian Feder, julian.feder@yahoo.de
 *
 * This product includes software developed at
 * The Apache Software Foundation (http://www.apache.org/).
 */

(function() {
    'use strict';

    var jhiItemCount = {
        template: '<div class="info">' +
                    'Showing {{(($ctrl.page - 1) * $ctrl.itemsPerPage) == 0 ? 1 : (($ctrl.page - 1) * $ctrl.itemsPerPage + 1)}} - ' +
                    '{{($ctrl.page * $ctrl.itemsPerPage) < $ctrl.queryCount ? ($ctrl.page * $ctrl.itemsPerPage) : $ctrl.queryCount}} ' +
                    'of {{$ctrl.queryCount}} items.' +
                '</div>',
        bindings: {
            page: '<',
            queryCount: '<total',
            itemsPerPage: '<'
        }
    };

    angular
        .module('askApp')
        .component('jhiItemCount', jhiItemCount);
})();

/*
The MIT License (MIT)

Copyright (c) 2014 Gregory McGee

Permission is hereby granted, free of charge, to any person obtaining a copy
of this software and associated documentation files (the "Software"), to deal
in the Software without restriction, including without limitation the rights
to use, copy, modify, merge, publish, distribute, sublicense, and/or sell
copies of the Software, and to permit persons to whom the Software is
furnished to do so, subject to the following conditions:

The above copyright notice and this permission notice shall be included in all
copies or substantial portions of the Software.

THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN THE
SOFTWARE.
*/

(function (angular) {
    'use strict';

    angular.module('datepickerMultiSelect', ['ui.bootstrap'])
        .filter('gmISODate', function() {
            return function(date) {
                var m = moment(date);
                return m.format()
            }
        })
        .config(['$provide', '$injector', function ($provide, $injector) {

            var useUTC = false;

            // extending datepicker (access to attributes and app scope through $parent)
            var datepickerDelegate = function ($delegate, $filter) {
                var directive = $delegate[0];

                // Override compile
                var link = directive.link;

                directive.compile = function () {
                    return function (scope, element, attrs, ctrls) {
                        link.apply(this, arguments);

                        scope.selectedDates = [];
                        scope.selectRange;

                        scope.$parent.$watchCollection(attrs.multiSelect, function (newVal) {
                            scope.selectedDates = newVal || [];
                        });

                        attrs.$observe('selectRange', function (newVal) {
                            scope.selectRange = !!newVal && newVal !== "false";
                        });

                        var ngModelCtrl = ctrls[1];

                        ngModelCtrl.$viewChangeListeners.push(function() {
                            var newVal = scope.$parent.$eval(attrs.ngModel);
                            if(!newVal)
                                return;

                            var dateVal = Date.parse($filter('gmISODate')(newVal)), //useUTC ? new Date(newVal).setUTCHours(0, 0, 0, 0) : new Date(newVal).setHours(0, 0, 0, 0),
                                selectedDates = scope.selectedDates;

                            if (scope.selectRange) {
                                // reset range
                                if (!selectedDates.length || selectedDates.length > 1 || selectedDates[0] == dateVal)
                                    return selectedDates.splice(0, selectedDates.length, dateVal);

                                selectedDates.push(dateVal);

                                var tempVal = Math.min.apply(null, selectedDates);
                                var maxVal = Math.max.apply(null, selectedDates);

                                // Start on the next day to prevent duplicating the	first date
                                tempVal += 1000 * 60 * 60 * 24;
                                while (tempVal < maxVal) {
                                    selectedDates.push(tempVal);

                                    // Set a day ahead after pushing to prevent duplicating last date
                                    tempVal += 1000 * 60 * 60 * 24;
                                }
                            } else {
                                if (selectedDates.indexOf(dateVal) < 0) {
                                    selectedDates.push(dateVal);
                                } else {
                                    selectedDates.splice(selectedDates.indexOf(dateVal), 1);
                                }
                            }
                        });
                    };
                };

                return $delegate;
            };

            if ($injector.has('datepickerDirective'))
                $provide.decorator('datepickerDirective', ['$delegate', '$filter', datepickerDelegate]);

            if ($injector.has('uibDatepickerDirective'))
                $provide.decorator('uibDatepickerDirective', ['$delegate', '$filter', datepickerDelegate]);

            // extending daypicker (access to day and datepicker scope through $parent)
            var daypickerDelegate = function ($delegate, $filter) {
                var directive = $delegate[0];

                // Override compile
                var link = directive.link;

                directive.compile = function () {
                    return function (scope, element, attrs, ctrls) {
                        link.apply(this, arguments);

                        scope.$parent.$watchCollection('selectedDates', update);

                        /*
                            Fires when date is selected or when month is changed.
                            UI bootstrap versions before 0.14.0 had just one controller DatepickerController,
                            now they have UibDatepickerController, UibDaypickerController and DatepickerController
                            see more on https://github.com/angular-ui/bootstrap/commit/44354f67e55c571df28b09e26a314a845a3b7397?diff=split#diff-6240fc17e068eaeef7095937a1d63eaeL251
                            and https://github.com/angular-ui/bootstrap/commit/44354f67e55c571df28b09e26a314a845a3b7397?diff=split#diff-6240fc17e068eaeef7095937a1d63eaeR462
                        */
                        var ctrl = angular.isArray(ctrls) ? ctrls[0] : ctrls;
                        scope.$watch(function () {
                            return ctrl.activeDate.getTime();
                        }, update);

                        function update() {
                            angular.forEach(scope.rows, function (row) {
                                angular.forEach(row, function (day) {
                                    day.selected = scope.selectedDates.indexOf(Date.parse($filter('gmISODate')(day.date))) > -1;
                                });
                            });
                        }
                    };
                };

                return $delegate;
            };

            if ($injector.has('daypickerDirective'))
                $provide.decorator('daypickerDirective', ['$delegate', '$filter', daypickerDelegate]);

            if ($injector.has('uibDaypickerDirective'))
                $provide.decorator('uibDaypickerDirective', ['$delegate', '$filter', daypickerDelegate]);
        }]);
})(window.angular);

/*
 * Copyright (c) 2017 by Julian Feder, julian.feder@yahoo.de
 *
 * This product includes software developed at
 * The Apache Software Foundation (http://www.apache.org/).
 */

(function() {
    'use strict';

    angular
        .module('askApp')
        .factory('DateUtils', DateUtils);

    DateUtils.$inject = ['$filter'];

    function DateUtils($filter) {

        var service = {
            convertDateTimeFromServer: convertDateTimeFromServer,
            convertLocalDateFromServer: convertLocalDateFromServer,
            convertLocalDateToServer: convertLocalDateToServer,
            dateformat: dateformat
        };

        return service;

        function convertDateTimeFromServer(date) {
            if (date) {
                return new Date(date);
            } else {
                return null;
            }
        }

        function convertLocalDateFromServer(date) {
            if (date) {
                var dateString = date.split('-');
                return new Date(dateString[0], dateString[1] - 1, dateString[2]);
            }
            return null;
        }

        function convertLocalDateToServer(date) {
            if (date) {
                return $filter('date')(date, 'yyyy-MM-dd');
            } else {
                return null;
            }
        }

        function dateformat() {
            return 'yyyy-MM-dd';
        }
    }

})();

/*
 * Copyright (c) 2017 by Julian Feder, julian.feder@yahoo.de
 *
 * This product includes software developed at
 * The Apache Software Foundation (http://www.apache.org/).
 */

(function() {
    'use strict';

    angular
        .module('askApp')
        .factory('DataUtils', DataUtils);

    DataUtils.$inject = ['$window'];

    function DataUtils ($window) {

        var service = {
            abbreviate: abbreviate,
            byteSize: byteSize,
            openFile: openFile,
            toBase64: toBase64
        };

        return service;

        function abbreviate (text) {
            if (!angular.isString(text)) {
                return '';
            }
            if (text.length < 30) {
                return text;
            }
            return text ? (text.substring(0, 15) + '...' + text.slice(-10)) : '';
        }

        function byteSize (base64String) {
            if (!angular.isString(base64String)) {
                return '';
            }

            function endsWith(suffix, str) {
                return str.indexOf(suffix, str.length - suffix.length) !== -1;
            }

            function paddingSize(base64String) {
                if (endsWith('==', base64String)) {
                    return 2;
                }
                if (endsWith('=', base64String)) {
                    return 1;
                }
                return 0;
            }

            function size(base64String) {
                return base64String.length / 4 * 3 - paddingSize(base64String);
            }

            function formatAsBytes(size) {
                return size.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ' ') + ' bytes';
            }

            return formatAsBytes(size(base64String));
        }

        function openFile (type, data) {
            //$window.open('data:' + type + ';base64,' + data, '_blank', 'height=300,width=400');
            var fileURL = 'data:' + type + ';base64,' + data;
            var win = window.open();
            win.document.write(
                '<iframe src="' + fileURL + '" frameborder="0" style="border:0; top:0px; left:0px; bottom:0px; right:0px; width:100%; height:100%; margin: 0; padding: 0; overflow: hidden; position: absolute;" allowfullscreen></iframe>');
        }


        function toBase64 (file, cb) {
            var fileReader = new FileReader();
            fileReader.readAsDataURL(file);
            fileReader.onload = function (e) {
                var base64Data = e.target.result.substr(e.target.result.indexOf('base64,') + 'base64,'.length);
                cb(base64Data);
            };
        }
    }
})();

/*
 * Copyright (c) 2017 by Julian Feder, julian.feder@yahoo.de
 *
 * This product includes software developed at
 * The Apache Software Foundation (http://www.apache.org/).
 */

(function() {
    'use strict';

    angular
        .module('askApp')
        .filter('capitalize', capitalize);

    function capitalize() {
        return capitalizeFilter;

        function capitalizeFilter (input) {
            if (input !== null) {
                input = input.toLowerCase();
                input = input.substring(0, 1).toUpperCase() + input.substring(1);
            }
            return input;
        }
    }
})();

/*
 * Copyright (c) 2017 by Julian Feder, julian.feder@yahoo.de
 *
 * This product includes software developed at
 * The Apache Software Foundation (http://www.apache.org/).
 */

(function() {
    /*jshint bitwise: false*/
    'use strict';

    angular
        .module('askApp')
        .factory('Base64', Base64);

    function Base64 () {
        var keyStr = 'ABCDEFGHIJKLMNOP' +
            'QRSTUVWXYZabcdef' +
            'ghijklmnopqrstuv' +
            'wxyz0123456789+/' +
            '=';

        var service = {
            decode : decode,
            encode : encode
        };

        return service;

        function encode (input) {
            var output = '',
                chr1, chr2, chr3,
                enc1, enc2, enc3, enc4,
                i = 0;

            while (i < input.length) {
                chr1 = input.charCodeAt(i++);
                chr2 = input.charCodeAt(i++);
                chr3 = input.charCodeAt(i++);

                enc1 = chr1 >> 2;
                enc2 = ((chr1 & 3) << 4) | (chr2 >> 4);
                enc3 = ((chr2 & 15) << 2) | (chr3 >> 6);
                enc4 = chr3 & 63;

                if (isNaN(chr2)) {
                    enc3 = enc4 = 64;
                } else if (isNaN(chr3)) {
                    enc4 = 64;
                }

                output = output +
                    keyStr.charAt(enc1) +
                    keyStr.charAt(enc2) +
                    keyStr.charAt(enc3) +
                    keyStr.charAt(enc4);
            }

            return output;
        }

        function decode (input) {
            var output = '',
                chr1, chr2, chr3,
                enc1, enc2, enc3, enc4,
                i = 0;

            // remove all characters that are not A-Z, a-z, 0-9, +, /, or =
            input = input.replace(/[^A-Za-z0-9\+\/\=]/g, '');

            while (i < input.length) {
                enc1 = keyStr.indexOf(input.charAt(i++));
                enc2 = keyStr.indexOf(input.charAt(i++));
                enc3 = keyStr.indexOf(input.charAt(i++));
                enc4 = keyStr.indexOf(input.charAt(i++));

                chr1 = (enc1 << 2) | (enc2 >> 4);
                chr2 = ((enc2 & 15) << 4) | (enc3 >> 2);
                chr3 = ((enc3 & 3) << 6) | enc4;

                output = output + String.fromCharCode(chr1);

                if (enc3 !== 64) {
                    output = output + String.fromCharCode(chr2);
                }
                if (enc4 !== 64) {
                    output = output + String.fromCharCode(chr3);
                }
            }

            return output;
        }
    }
})();

/*
 * Copyright (c) 2017 by Julian Feder, julian.feder@yahoo.de
 *
 * This product includes software developed at
 * The Apache Software Foundation (http://www.apache.org/).
 */

(function() {
    'use strict';

    angular
        .module('askApp')
        .factory('LoginService', LoginService);

    LoginService.$inject = ['$uibModal'];

    function LoginService ($uibModal) {
        var service = {
            open: open
        };

        var modalInstance = null;
        var resetModal = function () {
            modalInstance = null;
        };

        return service;

        function open () {
            if (modalInstance !== null) return;
            modalInstance = $uibModal.open({
                animation: true,
                templateUrl: 'app/components/login/login.html',
                controller: 'LoginController',
                controllerAs: 'vm',
                resolve: {
                    translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                        $translatePartialLoader.addPart('login');
                        return $translate.refresh();
                    }]
                }
            });
            modalInstance.result.then(
                resetModal,
                resetModal
            );
        }
    }
})();

/*
 * Copyright (c) 2017 by Julian Feder, julian.feder@yahoo.de
 *
 * This product includes software developed at
 * The Apache Software Foundation (http://www.apache.org/).
 */

(function() {
    'use strict';

    angular
        .module('askApp')
        .controller('LoginController', LoginController);

    LoginController.$inject = ['$rootScope', '$state', '$timeout', 'Auth', '$uibModalInstance'];

    function LoginController ($rootScope, $state, $timeout, Auth, $uibModalInstance) {
        var vm = this;

        vm.authenticationError = false;
        vm.cancel = cancel;
        vm.credentials = {};
        vm.login = login;
        vm.password = null;
        vm.register = register;
        vm.rememberMe = true;
        vm.requestResetPassword = requestResetPassword;
        vm.username = null;

        $timeout(function (){angular.element('#email').focus();});

        function cancel () {
            vm.credentials = {
                username: null,
                password: null,
                rememberMe: true
            };
            vm.authenticationError = false;
            $uibModalInstance.dismiss('cancel');
        }

        function login (event) {
            event.preventDefault();
            Auth.login({
                username: vm.username,
                password: vm.password,
                rememberMe: vm.rememberMe
            }).then(function () {
                vm.authenticationError = false;
                $uibModalInstance.close();

                if ($state.current.name === 'register' || $state.current.name === 'activate' ||
                    $state.current.name === 'finishReset' || $state.current.name === 'requestReset') {
                    $state.go('home');
                }

                $rootScope.$broadcast('authenticationSuccess');

                // previousState was set in the authExpiredInterceptor before being redirected to login modal.
                // since login is successful, go to stored previousState and clear previousState
                if (Auth.getPreviousState()) {
                    var previousState = Auth.getPreviousState();
                    Auth.resetPreviousState();
                    $state.go(previousState.name, previousState.params);
                }
            }).catch(function () {
                vm.authenticationError = true;
            });
        }

        function register () {
            $uibModalInstance.dismiss('cancel');
            $state.go('register');
        }

        function requestResetPassword () {
            $uibModalInstance.dismiss('cancel');
            $state.go('requestReset');
        }
    }
})();

/*
 * Copyright (c) 2017 by Julian Feder, julian.feder@yahoo.de
 *
 * This product includes software developed at
 * The Apache Software Foundation (http://www.apache.org/).
 */

(function () {
    'use strict';

    angular
        .module('askApp')
        .factory('JhiLanguageService', JhiLanguageService);

    JhiLanguageService.$inject = ['$q', '$http', '$translate', 'LANGUAGES'];

    function JhiLanguageService ($q, $http, $translate, LANGUAGES) {
        var service = {
            getAll: getAll,
            getCurrent: getCurrent
        };

        return service;

        function getAll () {
            var deferred = $q.defer();
            deferred.resolve(LANGUAGES);
            return deferred.promise;
        }

        function getCurrent () {
            var deferred = $q.defer();
            var language = $translate.storage().get('NG_TRANSLATE_LANG_KEY');

            deferred.resolve(language);

            return deferred.promise;
        }
    }
})();

/*
 * Copyright (c) 2017 by Julian Feder, julian.feder@yahoo.de
 *
 * This product includes software developed at
 * The Apache Software Foundation (http://www.apache.org/).
 */

(function() {
    'use strict';

    angular
        .module('askApp')
        .filter('findLanguageFromKey', findLanguageFromKey);

    function findLanguageFromKey() {
        return findLanguageFromKeyFilter;

        function findLanguageFromKeyFilter(lang) {
            return {
                'ca': 'Català',
                'cs': 'Český',
                'da': 'Dansk',
                'de': 'Deutsch',
                'el': 'Ελληνικά',
                'en': 'English',
                'es': 'Español',
                'et': 'Eesti',
                'fr': 'Français',
                'gl': 'Galego',
                'hu': 'Magyar',
                'hi': 'हिंदी',
                'hy': 'Հայերեն',
                'it': 'Italiano',
                'ja': '日本語',
                'ko': '한국어',
                'mr': 'मराठी',
                'nl': 'Nederlands',
                'pl': 'Polski',
                'pt-br': 'Português (Brasil)',
                'pt-pt': 'Português',
                'ro': 'Română',
                'ru': 'Русский',
                'sk': 'Slovenský',
                'sr': 'Srpski',
                'sv': 'Svenska',
                'ta': 'தமிழ்',
                'th': 'ไทย',
                'tr': 'Türkçe',
                'vi': 'Tiếng Việt',
                'zh-cn': '中文（简体）',
                'zh-tw': '繁體中文'
            }[lang];
        }
    }
})();

/*
 * Copyright (c) 2017 by Julian Feder, julian.feder@yahoo.de
 *
 * This product includes software developed at
 * The Apache Software Foundation (http://www.apache.org/).
 */

(function() {
    'use strict';

    angular
        .module('askApp')
        .controller('JhiLanguageController', JhiLanguageController);

    JhiLanguageController.$inject = ['$translate', 'JhiLanguageService', 'tmhDynamicLocale'];

    function JhiLanguageController ($translate, JhiLanguageService, tmhDynamicLocale) {
        var vm = this;

        vm.changeLanguage = changeLanguage;
        vm.languages = null;

        JhiLanguageService.getAll().then(function (languages) {
            vm.languages = languages;
        });

        function changeLanguage (languageKey) {
            $translate.use(languageKey);
            tmhDynamicLocale.set(languageKey);
        }
    }
})();

/*
 * Copyright (c) 2017 by Julian Feder, julian.feder@yahoo.de
 *
 * This product includes software developed at
 * The Apache Software Foundation (http://www.apache.org/).
 */

(function () {
    'use strict';

    angular
        .module('askApp')

        /*
         Languages codes are ISO_639-1 codes, see http://en.wikipedia.org/wiki/List_of_ISO_639-1_codes
         They are written in English to avoid character encoding issues (not a perfect solution)
         */
        .constant('LANGUAGES', [
            'de',
            'en'
            // jhipster-needle-i18n-language-constant - JHipster will add/remove languages in this array
        ]
    );
})();

/*
 * Copyright (c) 2017 by Julian Feder, julian.feder@yahoo.de
 *
 * This product includes software developed at
 * The Apache Software Foundation (http://www.apache.org/).
 */

(function() {
    'use strict';

    angular
        .module('askApp')
        .directive('showValidation', showValidation);

    function showValidation () {
        var directive = {
            restrict: 'A',
            require: 'form',
            link: linkFunc
        };

        return directive;

        function linkFunc (scope, element, attrs, formCtrl) {
            element.find('.form-group').each(function() {
                var $formGroup = angular.element(this);
                var $inputs = $formGroup.find('input[ng-model],textarea[ng-model],select[ng-model]');

                if ($inputs.length > 0) {
                    $inputs.each(function() {
                        var $input = angular.element(this);
                        var inputName = $input.attr('name');
                        scope.$watch(function() {
                            return formCtrl[inputName].$invalid && formCtrl[inputName].$dirty;
                        }, function(isInvalid) {
                            $formGroup.toggleClass('has-error', isInvalid);
                        });
                    });
                }
            });
        }
    }
})();

/*
 * Copyright (c) 2017 by Julian Feder, julian.feder@yahoo.de
 *
 * This product includes software developed at
 * The Apache Software Foundation (http://www.apache.org/).
 */

(function() {
    'use strict';

    angular
        .module('askApp')
        .constant('paginationConstants', {
            'itemsPerPage': 20,
            'all': 999
        });
})();

/*
 * Copyright (c) 2017 by Julian Feder, julian.feder@yahoo.de
 *
 * This product includes software developed at
 * The Apache Software Foundation (http://www.apache.org/).
 */

(function() {
    'use strict';

    angular
        .module('askApp')
        .directive('minbytes', minbytes);

    function minbytes () {
        var directive = {
            restrict: 'A',
            require: '?ngModel',
            link: linkFunc
        };

        return directive;

        function linkFunc (scope, element, attrs, ngModel) {
            if (!ngModel) {
                return;
            }

            ngModel.$validators.minbytes = function (modelValue) {
                return ngModel.$isEmpty(modelValue) || numberOfBytes(modelValue) >= attrs.minbytes;
            };
        }

        function endsWith(suffix, str) {
            return str.indexOf(suffix, str.length - suffix.length) !== -1;
        }

        function paddingSize(base64String) {
            if (endsWith('==', base64String)) {
                return 2;
            }
            if (endsWith('=', base64String)) {
                return 1;
            }
            return 0;
        }

        function numberOfBytes(base64String) {
            return base64String.length / 4 * 3 - paddingSize(base64String);
        }
    }
})();

/*
 * Copyright (c) 2017 by Julian Feder, julian.feder@yahoo.de
 *
 * This product includes software developed at
 * The Apache Software Foundation (http://www.apache.org/).
 */

(function() {
    'use strict';

    angular
        .module('askApp')
        .directive('maxbytes', maxbytes);

    function maxbytes () {
        var directive = {
            restrict: 'A',
            require: '?ngModel',
            link: linkFunc
        };

        return directive;

        function linkFunc (scope, element, attrs, ngModel) {
            if (!ngModel) {
                return;
            }

            ngModel.$validators.maxbytes = function (modelValue) {
                return ngModel.$isEmpty(modelValue) || numberOfBytes(modelValue) <= attrs.maxbytes;
            };
        }

        function endsWith(suffix, str) {
            return str.indexOf(suffix, str.length - suffix.length) !== -1;
        }

        function paddingSize(base64String) {
            if (endsWith('==', base64String)) {
                return 2;
            }
            if (endsWith('=', base64String)) {
                return 1;
            }
            return 0;
        }

        function numberOfBytes(base64String) {
            return base64String.length / 4 * 3 - paddingSize(base64String);
        }
    }

})();

/*
 * Copyright (c) 2017 by Julian Feder, julian.feder@yahoo.de
 *
 * This product includes software developed at
 * The Apache Software Foundation (http://www.apache.org/).
 */

(function() {
    'use strict';

    var contentCms = {
        template: '<span ng-bind-html="text"></span>',
        bindings: { identifier: '@' },
        controller: contentCmsController
    };

    angular
        .module('askApp')
        .component('contentCms', contentCms);

    contentCmsController.$inject = ['Content', '$sce', '$scope'];

    function contentCmsController(Content, $sce, $scope) {
        var vm = this;
        this.$onInit = function () {
            Content.get({id: vm.identifier}, onSuccess, onError);

            function onSuccess(data) {
                $scope.text = $sce.trustAsHtml(data.text);
            }
            function onError(error) {
                //console.log(error);
            }
        }
    }
})();


(function() {
    'use strict';

    angular
        .module('askApp')
        .directive('loadScript', function() {
            return function(scope, element, attrs) {
                angular.element('<script src="http://www.marinetraffic.com/js/embed.js"></script>').appendTo(element);
            }
        });
})();

/*
 * Copyright (c) 2017 by Julian Feder, julian.feder@yahoo.de
 *
 * This product includes software developed at
 * The Apache Software Foundation (http://www.apache.org/).
 */

(function() {
    'use strict';

    var jhiAlertError = {
        template: '<div class="alerts" ng-cloak="" role="alert">' +
                        '<div ng-repeat="alert in $ctrl.alerts" ng-class="[alert.position, {\'toast\': alert.toast}]">' +
                            '<uib-alert ng-cloak="" type="{{alert.type}}" close="alert.close($ctrl.alerts)"><pre>{{ alert.msg }}</pre></uib-alert>' +
                        '</div>' +
                  '</div>',
        controller: jhiAlertErrorController
    };

    angular
        .module('askApp')
        .component('jhiAlertError', jhiAlertError);

    jhiAlertErrorController.$inject = ['$scope', 'AlertService', '$rootScope', '$translate'];

    function jhiAlertErrorController ($scope, AlertService, $rootScope, $translate) {
        var vm = this;

        vm.alerts = [];

        function addErrorAlert (message, key, data) {
            key = key ? key : message;
            vm.alerts.push(
                AlertService.add(
                    {
                        type: 'danger',
                        msg: key,
                        params: data,
                        timeout: 5000,
                        toast: AlertService.isToast(),
                        scoped: true
                    },
                    vm.alerts
                )
            );
        }

        var cleanHttpErrorListener = $rootScope.$on('askApp.httpError', function (event, httpResponse) {
            var i;
            event.stopPropagation();
            switch (httpResponse.status) {
            // connection refused, server not reachable
            case 0:
                addErrorAlert('Server not reachable','error.server.not.reachable');
                break;

            case 400:
                var headers = Object.keys(httpResponse.headers()).filter(function (header) {
                    return header.indexOf('app-error', header.length - 'app-error'.length) !== -1 || header.indexOf('app-params', header.length - 'app-params'.length) !== -1;
                }).sort();
                var errorHeader = httpResponse.headers(headers[0]);
                var entityKey = httpResponse.headers(headers[1]);
                if (errorHeader) {
                    var entityName = $translate.instant('global.menu.entities.' + entityKey);
                    addErrorAlert(errorHeader, errorHeader, {entityName: entityName});
                } else if (httpResponse.data && httpResponse.data.fieldErrors) {
                    for (i = 0; i < httpResponse.data.fieldErrors.length; i++) {
                        var fieldError = httpResponse.data.fieldErrors[i];
                        // convert 'something[14].other[4].id' to 'something[].other[].id' so translations can be written to it
                        var convertedField = fieldError.field.replace(/\[\d*\]/g, '[]');
                        var fieldName = $translate.instant('askApp.' + fieldError.objectName + '.' + convertedField);
                        addErrorAlert('Field ' + fieldName + ' cannot be empty', 'error.' + fieldError.message, {fieldName: fieldName});
                    }
                } else if (httpResponse.data && httpResponse.data.message) {
                    addErrorAlert(httpResponse.data.message, httpResponse.data.message, httpResponse.data);
                } else {
                    addErrorAlert(httpResponse.data);
                }
                break;

            case 404:
                addErrorAlert('Not found','error.url.not.found');
                break;

            default:
                if (httpResponse.data && httpResponse.data.message) {
                    addErrorAlert(httpResponse.data.message);
                } else {
                    addErrorAlert(angular.toJson(httpResponse));
                }
            }
        });

        $scope.$on('$destroy', function () {
            if(angular.isDefined(cleanHttpErrorListener) && cleanHttpErrorListener !== null){
                cleanHttpErrorListener();
                vm.alerts = [];
            }
        });
    }
})();

/*
 * Copyright (c) 2017 by Julian Feder, julian.feder@yahoo.de
 *
 * This product includes software developed at
 * The Apache Software Foundation (http://www.apache.org/).
 */

(function() {
    'use strict';

    angular
        .module('askApp')
        .provider('AlertService', AlertService);

    function AlertService () {
        this.toast = false;
        /*jshint validthis: true */
        this.$get = getService;

        this.showAsToast = function(isToast) {
            this.toast = isToast;
        };

        getService.$inject = ['$timeout', '$sce', '$translate'];

        function getService ($timeout, $sce,$translate) {
            var toast = this.toast,
                alertId = 0, // unique id for each alert. Starts from 0.
                alerts = [],
                timeout = 5000; // default timeout

            return {
                factory: factory,
                isToast: isToast,
                add: addAlert,
                closeAlert: closeAlert,
                closeAlertByIndex: closeAlertByIndex,
                clear: clear,
                get: get,
                success: success,
                error: error,
                info: info,
                warning : warning
            };

            function isToast() {
                return toast;
            }

            function clear() {
                alerts = [];
            }

            function get() {
                return alerts;
            }

            function success(msg, params, position) {
                return this.add({
                    type: 'success',
                    msg: msg,
                    params: params,
                    timeout: timeout,
                    toast: toast,
                    position: position
                });
            }

            function error(msg, params, position) {
                return this.add({
                    type: 'danger',
                    msg: msg,
                    params: params,
                    timeout: timeout,
                    toast: toast,
                    position: position
                });
            }

            function warning(msg, params, position) {
                return this.add({
                    type: 'warning',
                    msg: msg,
                    params: params,
                    timeout: timeout,
                    toast: toast,
                    position: position
                });
            }

            function info(msg, params, position) {
                return this.add({
                    type: 'info',
                    msg: msg,
                    params: params,
                    timeout: timeout,
                    toast: toast,
                    position: position
                });
            }

            function factory(alertOptions) {
                var alert = {
                    type: alertOptions.type,
                    msg: $sce.trustAsHtml(alertOptions.msg),
                    id: alertOptions.alertId,
                    timeout: alertOptions.timeout,
                    toast: alertOptions.toast,
                    position: alertOptions.position ? alertOptions.position : 'top right',
                    scoped: alertOptions.scoped,
                    close: function (alerts) {
                        return closeAlert(this.id, alerts);
                    }
                };
                if(!alert.scoped) {
                    alerts.push(alert);
                }
                return alert;
            }

            function addAlert(alertOptions, extAlerts) {
                alertOptions.alertId = alertId++;
                alertOptions.msg = $translate.instant(alertOptions.msg, alertOptions.params);
                var that = this;
                var alert = this.factory(alertOptions);
                if (alertOptions.timeout && alertOptions.timeout > 0) {
                    $timeout(function () {
                        that.closeAlert(alertOptions.alertId, extAlerts);
                    }, alertOptions.timeout);
                }
                return alert;
            }

            function closeAlert(id, extAlerts) {
                var thisAlerts = extAlerts ? extAlerts : alerts;
                return closeAlertByIndex(thisAlerts.map(function(e) { return e.id; }).indexOf(id), thisAlerts);
            }

            function closeAlertByIndex(index, thisAlerts) {
                return thisAlerts.splice(index, 1);
            }
        }
    }
})();

/*
 * Copyright (c) 2017 by Julian Feder, julian.feder@yahoo.de
 *
 * This product includes software developed at
 * The Apache Software Foundation (http://www.apache.org/).
 */

(function() {
    'use strict';

    var jhiAlert = {
        template: '<div class="alerts" ng-cloak="" role="alert">' +
                        '<div ng-repeat="alert in $ctrl.alerts" ng-class="[alert.position, {\'toast\': alert.toast}]">' +
                            '<uib-alert ng-cloak="" type="{{alert.type}}" close="alert.close($ctrl.alerts)"><pre ng-bind-html="alert.msg"></pre></uib-alert>' +
                        '</div>' +
                  '</div>',
        controller: jhiAlertController
    };

    angular
        .module('askApp')
        .component('jhiAlert', jhiAlert);

    jhiAlertController.$inject = ['$scope', 'AlertService'];

    function jhiAlertController($scope, AlertService) {
        var vm = this;

        vm.alerts = AlertService.get();
        $scope.$on('$destroy', function () {
            vm.alerts = [];
        });
    }
})();

/*
 * Copyright (c) 2019 by Felix Heim, felix-heim@web.de
 *
 * This product includes software developed at
 * The Apache Software Foundation (http://www.apache.org/).
 */

(function() {
    'use strict';

    angular
        .module('askApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
        .state('board.statistics', {
            parent: 'board',
            url: '/board/statistics',
            data: {
                authorities: ['ROLE_BOARD'],
                pageTitle: 'askApp.memberManagement.statistics.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/board/statistics/statistics.html',
                    controller: 'StatisticsController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('member-management');
                    $translatePartialLoader.addPart('enumMemberStatus');
                    $translatePartialLoader.addPart('global');
                    return $translate.refresh();
                }]
            }
        })
        .state('manager-project-detail', {
            parent: 'board.statistics',
            url: '/manager/{id}',
            data: {
                authorities: ['ROLE_USER'],
                pageTitle: 'askApp.memberManagement.statistics.project.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/board/statistics/manager-project-overview.html',
                    controller: 'ManagerProjectOverviewController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                entity: ['$stateParams', 'MemberManagement', function($stateParams, MemberManagement) {
                    return MemberManagement.get({id : $stateParams.id}).$promise;
                }],
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('enumProjectType');
                    $translatePartialLoader.addPart('member-management');
                    $translatePartialLoader.addPart('global');
                    $translatePartialLoader.addPart('project');
                    return $translate.refresh();
                }]
            }
        });
    }
})();

/*
 * Copyright (c) 2019 by Felix Heim, felix-heim@web.de
 *
 * This product includes software developed at
 * The Apache Software Foundation (http://www.apache.org/).
 */

(function() {
    'use strict';

    angular
        .module('askApp')
        .controller('StatisticsController', StatisticsController);

    StatisticsController.$inject = ['DateUtils', 'Principal', 'ParseLinks', '$http', 'AlertService', '$state', 'calendarConfig', 'moment'];

    function StatisticsController(DateUtils, Principal, ParseLinks, $http, AlertService, $state, calendarConfig, moment) {
        var vm = this;
        vm.viewChanged = viewChanged;
        vm.birthdates = [];
        vm.birthdatesList = [];
        for(var i = 0; i < 12; i++) {
            vm.birthdatesList.push([]);
        }
        vm.birthdateView = 'month';
        vm.birthdateDate = new Date();

        calendarConfig.i18nStrings.weekNumber = 'KW {week}';
        moment.locale("de", {
            week: {
                dow: 1
            }
        });

        viewChanged();
        getManagerOverview();


        vm.birthdayClicked = function(birthday) {
            $state.go('member-management-detail', {'id': birthday.id});
        };

        function getBirthdays(month) {
            if (vm.birthdatesList[month].length !== 0) {
                setViewToMonth(month);
                return;
            }
            $http.get('api/board/statistics/birthday/' + (month + 1), {}).then(function(response) {
                var data = response.data;

                for(var i = 0; i < data.length; i++) {
                    data[i].birthdate = DateUtils.convertDateTimeFromServer(data[i].birthdate);
                    var fromTime = angular.copy(data[i].birthdate);
                    fromTime.setFullYear(new Date().getFullYear());
                    fromTime.setHours(0);
                    var age = fromTime.getFullYear() - data[i].birthdate.getFullYear();

                    for(var offset = -1; offset <= 1; offset++) {
                        var displayAge = age + offset;
                        if(displayAge < 0) {
                            continue;
                        }
                        if(displayAge === 0) {
                            displayAge = "*";
                        }

                        var startDateCopy = angular.copy(fromTime);
                        var birthday = {
                            title: data[i].firstName + " " + data[i].lastName + (data[i].nickname ? (' &quot;' + data[i].nickname + '&quot;') : ('')) + " (" + displayAge + ")",
                            id: data[i].id,
                            startsAt: new Date(startDateCopy.setFullYear(fromTime.getFullYear() + offset)),
                            allDay: true,
                            color: {
                                primary: "#ffffff",
                                secondary: "#ffffff"
                            }
                        };
                        vm.birthdatesList[month].push(birthday);
                    }
                }
                setViewToMonth(month);
            });
        }

        function setViewToMonth(month) {
            vm.birthdates = vm.birthdatesList[month];
        }

        function viewChanged() {
            getBirthdays(vm.birthdateDate.getMonth());
        }

        function getManagerOverview() {
            $http.get('api/board/profiles/manager/overview', {}).then(function(response) {
                vm.managerOverview = response.data;
            });
        }

        Principal.identity().then(function(account) {
            vm.currentAccount = account;
        });
    }
})();

/*
 * Copyright (c) 2017 by Julian Feder, julian.feder@yahoo.de
 *
 * This product includes software developed at
 * The Apache Software Foundation (http://www.apache.org/).
 */

(function() {
    'use strict';

    angular
        .module('askApp')
        .controller('ManagerProjectOverviewController', ManagerProjectOverviewController);

    ManagerProjectOverviewController.$inject = ['$timeout', '$scope', '$http', 'entity'];

    function ManagerProjectOverviewController ($timeout, $scope, $http, entity) {
        var vm = this;
        console.log(entity);
        vm.profile = entity;
        vm.projects = [];
        loadAll();

        function loadAll() {
            $http.get('api/board/profiles/manager/' + vm.profile.id, {}).then(function (response) {
                vm.projects = response.data;
            });
        }
    }
})();

/*
 * Copyright (c) 2021 by Felix Heim, felix-heim@web.de
 *
 * This product includes software developed at
 * The Apache Software Foundation (http://www.apache.org/).
 */

(function() {
    'use strict';

    angular
        .module('askApp')
        .controller('SkipperDialogSendMailController', SkipperDialogSendMailController);

    SkipperDialogSendMailController.$inject = ['$uibModalInstance', 'AlertService', '$scope', '$http', 'pagingParams', 'skipperLevels'];

    function SkipperDialogSendMailController ($uibModalInstance, AlertService, $scope, $http, pagingParams, skipperLevels) {

        var vm = this;
        vm.allLevels = skipperLevels.data;
        vm.matchAny = pagingParams.matchAny;
        vm.clear = clear;
        vm.action = action;
        vm.sendMail = {
            startId: 0,
            matchAny: vm.matchAny,
            levels: pagingParams.loadQuery ? null : pagingParams.levels.join(',')
        };

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        vm.options = {
            toolbar: [
                ['style', ['bold', 'italic', 'underline', 'clear']],
                ['textsize', ['fontsize']],
                ['fontclr', ['color']],
                ['alignment', ['ul', 'ol']],
                ['view', ['codeview']]
            ]
        };

        function action(action) {
            vm.sendMail.action = action;
            vm.sendMail.query = pagingParams.loadQuery ? $scope.$parent.skipperObj.query : null;
            vm.isSaving = true;
            $http.post('api/board/skipper/mail/', vm.sendMail).then(function(response) {
                vm.isSaving = false;
                if(action !== "test") {
                    $uibModalInstance.dismiss('cancel');
                }
            });
        }
    }
})();

/*
 * Copyright (c) 2021 by Felix Heim, felix-heim@web.de
 *
 * This product includes software developed at
 * The Apache Software Foundation (http://www.apache.org/).
 */

(function() {
    'use strict';

    angular
        .module('askApp')
        .controller('BoardSkipperDialogController', BoardSkipperDialogController);

    BoardSkipperDialogController.$inject = ['skipperLevels', '$timeout', '$scope', '$sce', '$stateParams', '$uibModalInstance', 'entity', 'Skipper', 'Principal'];

    function BoardSkipperDialogController (skipperLevels, $timeout, $scope, $sce, $stateParams, $uibModalInstance, entity, Skipper, Principal) {
        var vm = this;

        vm.skipper = entity;
        vm.skipperLevels = skipperLevels.data;
        vm.skipperLevelsSelected = [];
        for (var index = 0; index < vm.skipperLevels.length; index++) {
            vm.skipperLevelsSelected.push(vm.skipper.skipperLevels.includes(vm.skipperLevels[index]));
        }

        vm.isSkipperManager = false;
        Principal.hasAuthority('ROLE_SKIPPER_MANAGER').then(function (result) {
            vm.isSkipperManager = result;
        });

        vm.clear = clear;
        vm.save = save;

        vm.options = {
            toolbar: [
                ['style', ['bold', 'italic', 'underline', 'clear']],
                ['textsize', ['fontsize']],
                ['fontclr', ['color']],
                ['alignment', ['ul', 'ol']],
                ['view', ['codeview']]
            ]
        };

        $timeout(function (){
            angular.element('.form-group:eq(1)>input').focus();
        });

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function save () {
            vm.isSaving = true;
            vm.skipper.skipperLevels = [];
            for (var index = 0; index < vm.skipperLevels.length; index++) {
                if (vm.skipperLevelsSelected[index]) {
                    vm.skipper.skipperLevels.push(vm.skipperLevels[index]);
                }
            }
            Skipper.update(vm.skipper, onSaveSuccess, onSaveError);
        }

        function onSaveSuccess (result) {
            $scope.$emit('askApp:skipperUpdate', result);
            $uibModalInstance.close(result);
            vm.isSaving = false;
        }

        function onSaveError () {
            vm.isSaving = false;
        }

        $scope.renderHtml = function(code) {
            return $sce.trustAsHtml(code);
        };
    }
})();

/*
 * Copyright (c) 2021 by Felix Heim, felix-heim@web.de
 *
 * This product includes software developed at
 * The Apache Software Foundation (http://www.apache.org/).
 */

(function() {
    'use strict';

    angular
        .module('askApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
        .state('board.skipper-parent', {
            // use a parent state to cache the levels etc.
            parent: 'board',
            url: '/board',
            data: {
                authorities: ['ROLE_SKIPPER_MANAGER', 'ROLE_BOARD', 'ROLE_BOAT']
            },
            resolve: {
                skipperLevels: ['$http', function($http) {
                    return $http.get('api/board/skipper-level-holders/list');
                }],
                currentProfile: ['PrincipalProfile', function(PrincipalProfile) {
                    return PrincipalProfile.identity(false);
                }],
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('skipper');
                    $translatePartialLoader.addPart('member-management');
                    $translatePartialLoader.addPart('enumSkipperLevel');
                    return $translate.refresh();
                }]
            }
        })
        .state('board.skipper', {
            parent: 'board.skipper-parent',
            url: '/skipper?page&pageSize&sort&matchAny&levels&query&loadQuery',
            data: {
                authorities: ['ROLE_SKIPPER_MANAGER', 'ROLE_BOARD', 'ROLE_BOAT'],
                pageTitle: 'askApp.skipper.home.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/board/skipper/skippers.html',
                    controller: 'BoardSkipperController',
                    controllerAs: 'vm'
                }
            },
            params: {
                page: {
                    value: '1',
                    squash: true
                },
                sort: {
                    value: 'id,asc',
                    squash: true
                },
                matchAny: {
                    value: 'true',
                    squash: true
                },
                levels: {
                    value: '',
                    squash: true
                },
                pageSize: {
                    value: '20',
                    squash: true
                },
                filterOpen: {
                    value: false,
                    squash: true
                },
                query: {
                    value: '',
                    squash: true
                },
                loadQuery: {
                    value: 'false',
                    squash: true
                },
                queryOpen: {
                    value: false,
                    squash: true
                },
                queryInfoOpen: {
                    value: false,
                    squash: true
                }
            },
            resolve: {
                pagingParams: ['$stateParams', 'PaginationUtil', function ($stateParams, PaginationUtil) {
                    return {
                        page: PaginationUtil.parsePage($stateParams.page),
                        sort: $stateParams.sort,
                        predicate: PaginationUtil.parsePredicate($stateParams.sort),
                        ascending: PaginationUtil.parseAscending($stateParams.sort),
                        matchAny: $stateParams.matchAny === 'true',
                        levels: $stateParams.levels.split(','),
                        pageSize: $stateParams.pageSize,
                        filterOpen: $stateParams.filterOpen,
                        query: $stateParams.query,
                        loadQuery: $stateParams.loadQuery === 'true',
                        queryOpen: $stateParams.queryOpen,
                        queryInfoOpen: $stateParams.queryInfoOpen
                    };
                }]
            }
        })
        .state('board.skipper.edit', {
            parent: 'board.skipper',
            url: '/{id}/edit',
            data: {
                authorities: ['ROLE_SKIPPER_MANAGER', 'ROLE_BOARD', 'ROLE_BOAT']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', 'skipperLevels', function($stateParams, $state, $uibModal, skipperLevels) {
                $uibModal.open({
                    templateUrl: 'app/board/skipper/skipper-dialog.html',
                    controller: 'BoardSkipperDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                            $translatePartialLoader.addPart('profile');
                            return $translate.refresh();
                        }],
                        skipperLevels: skipperLevels,
                        entity: ['Skipper', function(Skipper) {
                            return Skipper.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('board.skipper', null, { reload: 'board.skipper' });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('board.skipper.mail', {
            parent: 'board.skipper',
            url: '/mail',
            data: {
                authorities: ['ROLE_SKIPPER_MANAGER', 'ROLE_BOARD', 'ROLE_BOAT']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', 'pagingParams', 'skipperLevels', function($stateParams, $state, $uibModal, pagingParams, skipperLevels) {
                $uibModal.open({
                    templateUrl: 'app/board/skipper/skipper-send-mail.html',
                    controller: 'SkipperDialogSendMailController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        pagingParams: pagingParams,
                        skipperLevels: skipperLevels
                    }
                }).result.then(function() {
                    $state.go('board.skipper', null, { reload: 'board.skipper' });
                }, function() {
                    $state.go('^');
                });
            }]
        });
    }

})();

(function() {
    'use strict';
    angular
        .module('askApp')
        .factory('Skipper', Skipper);

    Skipper.$inject = ['$resource'];

    function Skipper ($resource) {
        var resourceUrl =  'api/board/skippers/:id';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true},
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                    }
                    return data;
                }
            },
            'update': { method:'PUT' }
        });
    }
})();

/*
 * Copyright (c) 2021 by Felix Heim, felix-heim@web.de
 *
 * This product includes software developed at
 * The Apache Software Foundation (http://www.apache.org/).
 */

(function() {
    'use strict';

    angular
        .module('askApp')
        .controller('BoardSkipperController', BoardSkipperController);

    BoardSkipperController.$inject = ['skipperLevels', '$scope', '$rootScope', '$state', 'Skipper', 'ParseLinks', 'AlertService', 'paginationConstants', 'pagingParams', 'Principal'];

    function BoardSkipperController(skipperLevels, $scope, $rootScope, $state, Skipper, ParseLinks, AlertService, paginationConstants, pagingParams, Principal) {

        var vm = this;

        $rootScope.skipperObj = {};
        $rootScope.skipperObj.query = null;

        vm.loadPage = loadPage;
        vm.predicate = pagingParams.predicate;
        vm.reverse = pagingParams.ascending;
        vm.transition = transition;
        vm.pageSize = pagingParams.pageSize === 'all' ? paginationConstants.all : pagingParams.pageSize;
        vm.itemsPerPage = vm.pageSize;
        vm.allItems = paginationConstants.all;
        vm.loadAll = loadAll;
        vm.matchAny = pagingParams.matchAny;
        vm.levels = pagingParams.levels;
        vm.query = pagingParams.query;
        vm.loadQuery = pagingParams.loadQuery;
        vm.anySelected = anySelected;
        vm.selectAll = selectAll;
        vm.selectNone = selectNone;
        vm.transitionToQuery = transitionToQuery;
        vm.transitionToLevels = transitionToLevels;
        vm.copyFilterToQuery = copyFilterToQuery;

        vm.supportedOperators = {
            "(": "LEFT_PARENTHESIS",
            ")": "RIGHT_PARENTHESIS",
            "!": "NOT",
            "not": "NOT",
            "&": "AND",
            "&&": "AND",
            "and": "AND",
            "und": "AND",
            "|": "OR",
            "||": "OR",
            "or": "OR",
            "oder": "OR"
        };
        vm.memberValues = {
            "probe": "Probemitglieder",
            "voll": "Vollmitglieder",
            "member": "Alle Mitglieder (Probe & Voll)",
            "mitglied": "Alle Mitglieder (Probe & Voll)",
            "guest": "Gastmitglieder",
            "gast": "Gastmitglieder",
            "student": "Studenten"
        }
        vm.skipperLevelValues = {
            "candidate": "candidate",
            "Skipperanwärter": "candidate",
            "Anwärter": "candidate",
            "Skipperanwaerter": "candidate",
            "Anwaerter": "candidate",
            "Pre": "candidate",
            "Cand.": "candidate",
            "Cand": "candidate",
            "flottille": "flottille",
            "Flotte": "flottille",
            "vacation": "vacation",
            "Urlaub": "vacation",
            "askew": "askew",
            "sks_co": "sks_co",
            "SKS Co-Skipper": "sks_co",
            "SKS Coskipper": "sks_co",
            "SKS Co": "sks_co",
            "SKSCo": "sks_co",
            "Co": "sks_co",
            "Co-Skipper": "sks_co",
            "Coskipper": "sks_co",
            "sks": "sks",
            "sks_plus": "sks_plus",
            "SKS+": "sks_plus",
            "SKSPlus": "sks_plus",
            "sss": "sss",
            "regatta_beginner": "regatta_beginner",
            "regattabeginner": "regatta_beginner",
            "Einsteiger Regatta": "regatta_beginner",
            "RegBeg": "regatta_beginner",
            "regatta_normal": "regatta_normal",
            "regattanormal": "regatta_normal",
            "Regatta": "regatta_normal",
            "RegNor": "regatta_normal",
            "regatta_advanced": "regatta_advanced",
            "regattaadvanced": "regatta_advanced",
            "Fortgeschrittenen Regatta": "regatta_advanced",
            "RegAdv": "regatta_advanced",
            "regatta_expert": "regatta_expert",
            "regattaexpert": "regatta_expert",
            "Experten Regatta": "regatta_expert",
            "RegExp": "regatta_expert"
        }

        vm.resultingQuery = "";
        vm.error = null;

        vm.skipperLevels = skipperLevels.data;
        vm.skipperLevelsSelected = [];
        for (var index = 0; index < vm.skipperLevels.length; index++) {
            vm.skipperLevelsSelected.push(vm.levels.length === 0 || vm.levels[0] === "" || vm.levels.includes(vm.skipperLevels[index]));
        }

        vm.isBoard = false;
        Principal.hasAuthority('ROLE_BOARD').then(function (result) {
            vm.isBoard = result;
        });
        vm.isSkipperManager = false;
        Principal.hasAuthority('ROLE_SKIPPER_MANAGER').then(function (result) {
            vm.isSkipperManager = result;
        });

        loadAll();

        $scope.status = {
            filterOpen: pagingParams.filterOpen,
            queryOpen: pagingParams.queryOpen,
            queryInfoOpen: pagingParams.queryInfoOpen
        };

        function getLevelsArray() {
            var levels = [];
            if (vm.skipperLevels.length === 0) {
                levels = vm.levels;
            } else {
                for (var index = 0; index < vm.skipperLevelsSelected.length; index++) {
                    if (vm.skipperLevelsSelected[index]) {
                        levels.push(vm.skipperLevels[index]);
                    }
                }
            }
            return levels;
        }

        function getLevels() {
            var levels = getLevelsArray();
            if (levels.length === vm.skipperLevels.length) {
                levels = [];
            }
            return levels.join(',');
        }

        function loadAll () {
            vm.error = null;
            Skipper.query({
                page: pagingParams.page - 1,
                size: vm.pageSize,
                sort: sort(),
                matchAny: vm.matchAny,
                levels: vm.loadQuery ? null : getLevels(),
                query: vm.loadQuery ? vm.query : null
            }, onSuccess, onError);
            function sort() {
                var sorting = vm.reverse ? 'asc' : 'desc';
                var result = [vm.predicate + ',' + sorting];
                if (vm.predicate !== 'id') {
                    result.push('id,' + sorting);
                }
                return result;
            }
            function onSuccess(data, headers) {
                vm.links = ParseLinks.parse(headers('link'));
                vm.totalItems = headers('X-Total-Count');
                vm.resultingQuery = headers('Resulting-Query');
                $rootScope.skipperObj.query = vm.resultingQuery;
                vm.queryCount = vm.totalItems;
                vm.skippers = data;
                vm.page = pagingParams.page;
            }
            function onError(error) {
                if (vm.loadQuery) {
                    vm.error = error.headers('Error-Message');
                    $scope.status.queryOpen = true;
                    AlertService.error(vm.error);
                } else {
                    AlertService.error(error.data.message);
                }
            }
        }

        function anySelected() {
            for (var index = 0; index < vm.skipperLevelsSelected.length; index++) {
                if (vm.skipperLevelsSelected[index]) {
                    return true;
                }
            }
            return false;
        }

        function loadPage(page) {
            vm.page = page;
            vm.transition();
        }

        function transition() {
            $state.transitionTo($state.$current, {
                page: vm.page,
                pageSize: vm.pageSize === vm.allItems ? 'all' : vm.pageSize,
                sort: vm.predicate + ',' + (vm.reverse ? 'asc' : 'desc'),
                matchAny: vm.matchAny,
                levels: getLevels(),
                query: vm.query,
                loadQuery: vm.loadQuery,
                filterOpen: $scope.status.filterOpen,
                queryOpen: $scope.status.queryOpen
            });
        }

        function setLevelsSelected(value) {
            for (var index = 0; index < vm.skipperLevelsSelected.length; index++) {
                vm.skipperLevelsSelected[index] = value;
            }
        }

        function selectAll() {
            setLevelsSelected(true);
        }

        function selectNone() {
            setLevelsSelected(false);
        }

        function transitionToQuery() {
            vm.loadQuery = true;
            transition();
        }

        function transitionToLevels() {
            vm.loadQuery = false;
            transition();
        }

        function copyFilterToQuery() {
            var connection = vm.matchAny ? " | " : " & ";
            var levels = getLevelsArray();
            vm.query = levels.length === vm.skipperLevels.length && vm.matchAny ? "all" : levels.join(connection);
        }
    }
})();

/*
 * Copyright (c) 2017 by Julian Feder, julian.feder@yahoo.de
 *
 * This product includes software developed at
 * The Apache Software Foundation (http://www.apache.org/).
 */

(function() {
    'use strict';

    angular
        .module('askApp')
        .controller('ProjectDialogController', ProjectDialogController);

    ProjectDialogController.$inject = ['$timeout', '$scope', '$stateParams', '$q', '$uibModalInstance', 'DataUtils', 'entity', 'ProjectBoard', 'PrincipalProfile', '$http', 'Principal'];

    function ProjectDialogController ($timeout, $scope, $stateParams ,$q, $uibModalInstance, DataUtils, entity, ProjectBoard, PrincipalProfile, $http, Principal) {
        var vm = this;

        vm.project = entity;
        vm.isBoard = false;

        Principal.hasAuthority('ROLE_BOARD').then(function (result) {
            vm.isBoard = result;
        });

        vm.isInstructorProject = false;
        vm.isBoatProject = false;
        vm.wasActive = vm.project.active;
        vm.wasVisible = vm.project.visible;

        if (vm.wasActive || vm.wasVisible) {
            if (vm.project.authorizedGroupsString.includes('ROLE_INSTRUCTOR')) {
                Principal.hasAuthority('ROLE_INSTRUCTOR').then(function (result) {
                    vm.isInstructorProject = result;
                });
            }
            if (vm.project.authorizedGroupsString.includes('ROLE_BOAT')) {
                Principal.hasAuthority('ROLE_BOAT').then(function (result) {
                    vm.isBoatProject = result;
                });
            }
        }

        vm.authorities = [
            'ROLE_INSTRUCTOR',
            'ROLE_BOAT',
            'ROLE_SKS_PLUS',
            'ROLE_SKIPPER',
            'ROLE_SKIPPER_CANDIDATE',
            'ROLE_SKIPPER_ASKEW',
            'ROLE_SAILOR_COUNCIL',
            'ROLE_DINGHY',
            'ROLE_UNIVERSITY_GROUP'
        ];
        vm.newType = $stateParams.type;
        if (entity.id == null && vm.newType !== null) {
            PrincipalProfile.identity().then(function(profile) {
                vm.project.profile = profile;
            });
            if (vm.newType === 'boat') {
                vm.project.authorizedGroupsString = [vm.authorities[1]];
            }
            else if (vm.newType === 'instructor') {
                vm.project.authorizedGroupsString = [vm.authorities[0]];
            }
            else if (vm.newType === 'boatInstructor') {
                vm.project.authorizedGroupsString = [vm.authorities[0], vm.authorities[1]];
            }
        }
        vm.clear = clear;
        vm.datePickerOpenStatus = {};
        vm.openCalendar = openCalendar;
        vm.byteSize = DataUtils.byteSize;
        vm.openFile = DataUtils.openFile;
        vm.save = save;
        vm.getUser = getUser;
        vm.getProject = getProject;
        vm.replaceYear = replaceYear;
        vm.selectFromDate = selectFromDate;
        vm.resetGuestPrice = resetGuestPrice;
        vm.disableFilter = false;

         function selectFromDate () {
            $scope.options = {
                minDate: new Date(vm.project.fromDate),
                initDate: new Date(vm.project.fromDate)
            };
            vm.replaceYear();
        }

        $timeout(function (){
            angular.element('.form-group:eq(1)>input').focus();
        });

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function save () {
            vm.isSaving = true;

            if(vm.project.dependingProject === "") {
                vm.project.dependingProject = null;
            }

            if (vm.project.id !== null) {
                if (vm.project.closed) {
                    vm.project.active = false;
                    vm.project.visible = false;
                }
                ProjectBoard.update(vm.project, onSaveSuccess, onSaveError);
            } else {
                if (vm.project.type === 'interest') {
                    vm.project.identifier = "interest";
                    vm.project.normalPrice = 0;
                    vm.project.studentPrice = 0;
                }
                if (vm.project.type !== 'sbfPractical') {
                    vm.project.sbfSlotsMax = null;
                }
                ProjectBoard.save(vm.project, onSaveSuccess, onSaveError);
            }
        }

        function onSaveSuccess (result) {
            $scope.$emit('askApp:projectUpdate', result);
            $uibModalInstance.close(result);
            vm.isSaving = false;
        }

        function onSaveError () {
            vm.isSaving = false;
        }

        vm.datePickerOpenStatus.fromDate = false;
        vm.datePickerOpenStatus.untilDate = false;

        vm.setImage = function ($file, project) {
            if ($file && $file.$error === 'pattern') {
                return;
            }
            if($file) {
                createImage(URL.createObjectURL($file)).then(function(image) {
                    var file = resize(image, $file.type).split(',');
                    project.image = file[1];
                    project.imageContentType = $file.type;
                });
            }
        };

        function openCalendar (date) {
            vm.datePickerOpenStatus[date] = true;
        }

        vm.options = {
            toolbar: [
                ['style', ['bold', 'italic', 'underline', 'clear']],
                ['fontclr', ['color']],
                ['alignment', ['ul', 'ol']],
                ['view', ['codeview']]
            ]
        };

        var createImage = function(src) {
            var defer = $q.defer();
            var img = new Image();
            img.onload = function() {
                defer.resolve(img);
            };
            img.src = src;
            return defer.promise;
        };

        var resize = function(image, type) {
            var mainCanvas;
            mainCanvas = document.createElement("canvas");

            var ratioX = 1000 / image.width;
            var ratioY = 1000 / image.height;
            var ratio = Math.min(ratioX, ratioY);

            var newWidth = image.width * ratio;
            var newHeight = image.height * ratio;

            mainCanvas.width = newWidth;
            mainCanvas.height = newHeight;
            var ctx = mainCanvas.getContext("2d");
            ctx.drawImage(image, 0, 0, newWidth, newHeight);
            return mainCanvas.toDataURL(type);
        };

        function getUser(val) {
            return $http.get('api/_search/profiles_guest/', {
                params: {
                    query: val
                }
            }).then(function(response){
                return response.data.map(function(item) {
                    return item;
                });
            });
        }

        function getProject(val) {
            return $http.get('api/_search/projectsnotclosed/', {
                params: {
                    query: val
                }
            }).then(function(response){
                return response.data.map(function(item) {
                    return item;
                });
            });
        }

        function replaceYear() {
            var replaceYear = vm.project.fromDate.getFullYear();
            var replaceYearTwoDigit = replaceYear.toString().substr(-2);
            vm.project.identifier = vm.project.identifier.replace(replaceYear, '').replace(replaceYearTwoDigit, '');
        }

        function resetGuestPrice() {
            vm.project.guestPrice = null;
        }

        $http.get('api/board/profiles/manager/').then(function(response) {
            vm.allManagers = response.data;
        });
    }
})();

/*
 * Copyright (c) 2017 by Julian Feder, julian.feder@yahoo.de
 *
 * This product includes software developed at
 * The Apache Software Foundation (http://www.apache.org/).
 */

(function() {
    'use strict';

    angular
        .module('askApp')
        .controller('ProjectDeleteController',ProjectDeleteController);

    ProjectDeleteController.$inject = ['$uibModalInstance', 'entity', 'ProjectBoard'];

    function ProjectDeleteController($uibModalInstance, entity, ProjectBoard) {
        var vm = this;

        vm.project = entity;
        vm.clear = clear;
        vm.confirmDelete = confirmDelete;

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function confirmDelete (id) {
            ProjectBoard.delete({id: id},
                function () {
                    $uibModalInstance.close(true);
                });
        }
    }
})();

/*
 * Copyright (c) 2021 by Felix Heim, felix-heim@web.de
 *
 * This product includes software developed at
 * The Apache Software Foundation (http://www.apache.org/).
 */

(function() {
    'use strict';
    angular
        .module('askApp')
        .factory('ProjectActive', ProjectActive);

    ProjectActive.$inject = ['$resource', 'DateUtils'];

    function ProjectActive ($resource, DateUtils) {
        var resourceUrl =  'api/board/projects/active';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true},
            'get': {
                method: 'GET',
                isArray: true,
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                        for(var index = 0; index < data.length; index++) {
                            data[index].fromDate = DateUtils.convertLocalDateFromServer(data[index].fromDate);
                            data[index].untilDate = DateUtils.convertLocalDateFromServer(data[index].untilDate);
                        }
                    }
                    return data;
                }
            }
        });
    }
})();

/*
 * Copyright (c) 2017 by Julian Feder, julian.feder@yahoo.de
 *
 * This product includes software developed at
 * The Apache Software Foundation (http://www.apache.org/).
 */

(function() {
    'use strict';

    angular
        .module('askApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
        .state('board.project', {
            parent: 'board',
            url: '/board/projects?pageP&sortP&searchP&archiveP&typeP',
            data: {
                authorities: ['ROLE_BOARD','ROLE_MANAGER'],
                pageTitle: 'askApp.project.home.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/board/project/projects.html',
                    controller: 'ProjectBoardController',
                    controllerAs: 'vm'
                }
            },
            params: {
                pageP: {
                    value: '1',
                    squash: true
                },
                sortP: {
                    value: 'fromDate,desc',
                    squash: true
                },
                archiveP: {
                    value: 'false',
                    squash: true
                },
                typeP: {
                    value: 'all',
                    squash: true
                },
                searchP: null
            },
            resolve: {
                pagingParams: ['$stateParams', 'PaginationUtil', function ($stateParams, PaginationUtil) {
                    return {
                        pageP: PaginationUtil.parsePage($stateParams.pageP),
                        sortP: $stateParams.sortP,
                        predicateP: PaginationUtil.parsePredicate($stateParams.sortP),
                        ascendingP: PaginationUtil.parseAscending($stateParams.sortP),
                        searchP: $stateParams.searchP,
                        archiveP: $stateParams.archiveP,
                        typeP: $stateParams.typeP
                    };
                }],
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('project');
                    $translatePartialLoader.addPart('enumProjectType');
                    $translatePartialLoader.addPart('enumSksPracticalLocation');
                    $translatePartialLoader.addPart('enumBookingStatusType');
                    $translatePartialLoader.addPart('global');
                    return $translate.refresh();
                }]
            }
        })
        .state('board.project.new', {
            parent: 'board.project',
            url: '/new',
            params: {
              type: null
            },
            data: {
                authorities: ['ROLE_BOARD','ROLE_MANAGER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/board/project/project-dialog.html',
                    controller: 'ProjectDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: function () {
                            var isBoat = $stateParams.type !== null && $stateParams.type.startsWith('boat');
                            return {
                                name: null,
                                email: null,
                                guestprice: null,
                                prepayment: null,
                                fromDate: null,
                                untilDate: null,
                                places: null,
                                identifier: null,
                                description: null,
                                conditions: null,
                                mailText: null,
                                normalPrice: null,
                                studentPrice: null,
                                type: null,
                                active: false,
                                visible: false,
                                closed: false,
                                queue: true,
                                activityPoints: true,
                                checkRegisterDate: false,
                                guest: false,
                                image: null,
                                imageContentType: null,
                                sepa: false,
                                weight: false,
                                clothingSize: false,
                                shoeSize: false,
                                nationality: isBoat,
                                countryOfBirth: isBoat,
                                birthplace: isBoat,
                                idNumber: isBoat,
                                booked: false,
                                id: null,
                                dependingProject: null,
                                individualField: null,
                                additionalBookable: false,
                                sbfSlotsMax: 2,
                                sksPracticalLocation: null
                            };
                        }
                    }
                }).result.then(function() {
                    $state.go('board.project', null, { reload: 'board.project' });
                }, function() {
                    $state.go('board.project');
                });
            }]
        })
        .state('board.project.delete', {
            parent: 'board.project',
            url: '/{id}/delete',
            data: {
                authorities: ['ROLE_BOARD']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/board/project/project-delete-dialog.html',
                    controller: 'ProjectDeleteController',
                    controllerAs: 'vm',
                    size: 'md',
                    resolve: {
                        entity: ['Project', function(Project) {
                            return Project.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('board.project', null, { reload: 'board.project' });
                }, function() {
                    $state.go('^');
                });
            }]
        });
    }

})();

/*
 * Copyright (c) 2017 by Julian Feder, julian.feder@yahoo.de
 *
 * This product includes software developed at
 * The Apache Software Foundation (http://www.apache.org/).
 */

(function() {
    'use strict';
    angular
        .module('askApp')
        .factory('ProjectBoard', ProjectBoard);

    ProjectBoard.$inject = ['$resource', 'DateUtils'];

    function ProjectBoard ($resource, DateUtils) {
        var resourceUrl =  'api/projects/:id';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true},
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                        data.fromDate = DateUtils.convertLocalDateFromServer(data.fromDate);
                        data.untilDate = DateUtils.convertLocalDateFromServer(data.untilDate);
                    }
                    return data;
                }
            },
            'update': {
                method: 'PUT',
                transformRequest: function (data) {
                    var copy = angular.copy(data);
                    copy.fromDate = DateUtils.convertLocalDateToServer(copy.fromDate);
                    copy.untilDate = DateUtils.convertLocalDateToServer(copy.untilDate);
                    return angular.toJson(copy);
                }
            },
            'save': {
                method: 'POST',
                transformRequest: function (data) {
                    var copy = angular.copy(data);
                    copy.fromDate = DateUtils.convertLocalDateToServer(copy.fromDate);
                    copy.untilDate = DateUtils.convertLocalDateToServer(copy.untilDate);
                    return angular.toJson(copy);
                }
            }
        });
    }
})();

/*
 * Copyright (c) 2017 by Julian Feder, julian.feder@yahoo.de
 *
 * This product includes software developed at
 * The Apache Software Foundation (http://www.apache.org/).
 */

(function() {
    'use strict';

    angular
        .module('askApp')
        .factory('ProjectSearch', ProjectSearch);

    ProjectSearch.$inject = ['$resource'];

    function ProjectSearch($resource) {
        var resourceUrl =  'api/_search/projects/:id';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true}
        });
    }
})();

/*
 * Copyright (c) 2017 by Julian Feder, julian.feder@yahoo.de
 *
 * This product includes software developed at
 * The Apache Software Foundation (http://www.apache.org/).
 */

(function() {
    'use strict';

    angular
        .module('askApp')
        .controller('ProjectBoardController', ProjectBoardController);

    ProjectBoardController.$inject = ['$state', 'Principal', 'DataUtils', 'ProjectBoard', 'ProjectSearch', 'ParseLinks', 'AlertService', 'paginationConstants', 'pagingParams', '$stateParams'];

    function ProjectBoardController($state, Principal, DataUtils, ProjectBoard, ProjectSearch, ParseLinks, AlertService, paginationConstants, pagingParams, $stateParams) {

        var vm = this;

        vm.isBoard = false;
        Principal.hasAuthority('ROLE_BOARD').then(function (result) {
            vm.isBoard = result;
            vm.allowArchive = Principal.hasAnyAuthority(['ROLE_INSTRUCTOR', 'ROLE_BOAT']) || vm.isBoard;
            updateShowTypes();
        });
        vm.allowArchive = false;
        vm.loadPage = loadPage;
        vm.predicate = pagingParams.predicateP;
        vm.reverse = pagingParams.ascendingP;
        vm.transition = transition;
        vm.itemsPerPage = paginationConstants.itemsPerPage;
        vm.clear = clear;
        vm.search = search;
        vm.loadAll = loadAll;
        vm.searchQuery = pagingParams.searchP;
        vm.currentSearch = pagingParams.searchP;
        vm.openFile = DataUtils.openFile;
        vm.byteSize = DataUtils.byteSize;
        vm.setType = setType;
        vm.setArchive = setArchive;
        vm.archive = pagingParams.archiveP;
        vm.type = pagingParams.typeP;
        vm.projects = [];

        loadAll();
        updateShowTypes();

        function updateShowTypes() {
            vm.showTypes = vm.isBoard || vm.type !== 'all' || vm.totalItems > vm.itemsPerPage || vm.currentSearch !== null;
            vm.showNavigation = vm.showTypes || vm.allowArchive;
        }

        function setType(type) {
            vm.page = 1;
            vm.type = type;
            vm.transition();
        }

        function setArchive(archive) {
            vm.page = 1;
            vm.archive = archive;
            vm.transition();
        }

        function loadAll () {
            if (pagingParams.searchP) {
                ProjectSearch.query({
                    query: pagingParams.searchP,
                    page: pagingParams.pageP - 1,
                    size: vm.itemsPerPage,
                    sort: sort()
                }, onSuccess, onError);
            } else {
                ProjectBoard.query({
                    page: pagingParams.pageP - 1,
                    size: vm.itemsPerPage,
                    sort: sort(),
                    archive: $stateParams.archiveP,
                    type: $stateParams.typeP
                }, onSuccess, onError);
            }
            function sort() {
                var sorting = vm.reverse ? 'asc' : 'desc';
                var result = [vm.predicate + ',' + sorting];
                if (vm.predicate !== 'id') {
                    result.push('id,' + sorting);
                }
                return result;
            }
            function onSuccess(data, headers) {
                vm.links = ParseLinks.parse(headers('link'));
                vm.totalItems = headers('X-Total-Count');
                vm.queryCount = vm.totalItems;
                vm.projects = data;
                vm.page = pagingParams.pageP;
                updateShowTypes();
            }
            function onError(error) {
                AlertService.error(error.data.message);
            }
        }

        function loadPage(page) {
            vm.page = page;
            vm.transition();
        }

        function transition() {
            $state.transitionTo($state.$current, {
                pageP: vm.page,
                sortP: vm.predicate + ',' + (vm.reverse ? 'asc' : 'desc'),
                searchP: vm.currentSearch,
                archiveP: vm.archive,
                typeP: vm.type
            });
        }

        function search(searchQuery) {
            if (!searchQuery){
                return vm.clear();
            }
            vm.links = null;
            vm.page = 1;
            vm.predicate = '_score';
            vm.reverse = false;
            vm.currentSearch = searchQuery;
            vm.transition();
        }

        function clear() {
            vm.links = null;
            vm.page = 1;
            vm.predicate = 'fromDate';
            vm.reverse = false;
            vm.currentSearch = null;
            vm.transition();
        }
    }
})();

/*
 * Copyright (c) 2017 by Julian Feder, julian.feder@yahoo.de
 *
 * This product includes software developed at
 * The Apache Software Foundation (http://www.apache.org/).
 */

(function() {
    'use strict';

    angular
        .module('askApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
        .state('board.project-detail.sks-overview', {
            parent: 'board.project-detail',
            url: '/sks-overview',
            data: {
                authorities: ['ROLE_BOARD','ROLE_MANAGER'],
                pageTitle: 'askApp.project.detail.title4'
            },
            views: {
                'projectDetail@board.project-detail': {
                    templateUrl: 'app/board/project/detail/sks-overview/sks-overview.html',
                    controller: 'SksOverviewController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('project');
                    $translatePartialLoader.addPart('enumProjectType');
                    $translatePartialLoader.addPart('booking');
                    $translatePartialLoader.addPart('enumBookingStatusType');
                    $translatePartialLoader.addPart('enumDeptStatus');
                    $translatePartialLoader.addPart('dept');
                    $translatePartialLoader.addPart('global');
                    return $translate.refresh();
                }]
            }
        })
    }
})();

/*
 * Copyright (c) 2017 by Julian Feder, julian.feder@yahoo.de
 *
 * This product includes software developed at
 * The Apache Software Foundation (http://www.apache.org/).
 */

(function() {
    'use strict';

    angular
        .module('askApp')
        .controller('SksOverviewController', SksOverviewController);

    SksOverviewController.$inject = ['$http', 'entity', 'DateUtils', '$location', '$window'];

    function SksOverviewController($http, entity, DateUtils, $location, $window) {
        var vm = this;
        vm.project = entity;
        vm.toggled = true;
        vm.from = angular.copy(vm.project.fromDate).setMonth(0, 1);
        vm.to = angular.copy(vm.project.untilDate).setMonth(11, 31);
        vm.accordionArray = [];
        vm.toggleAccordion = toggleAccordion;
        vm.goTo = goTo;
        vm.dataExport = dataExport;

        getOverview();

        function getOverview() {
            $http.get('api/board/sks/overview/', {
                params: {
                    projectId: entity.id,
                    from: DateUtils.convertLocalDateToServer(vm.from),
                    to: DateUtils.convertLocalDateToServer(vm.to)
                }
            }).then(function(response) {
                response.data.fromDate = DateUtils.convertLocalDateFromServer(response.data.fromDate);
                response.data.untilDate = DateUtils.convertLocalDateFromServer(response.data.untilDate);
                vm.sksOverview = response.data;
                vm.accordionArray = new Array(response.data.length);
                vm.accordionArray.fill(vm.toggled);
            });
        }

        function toggleAccordion() {
            vm.accordionArray = vm.accordionArray.map(function(x) {
                return !vm.toggled;
            });
            vm.toggled = !vm.toggled;
        }

        function goTo(id) {
            var url = $location.protocol() + "://" + location.host + "/#/board/projects/project/" + id + "/home";
            $window.open(url, "_self");
        }

        function dataExport() {
            vm.isSaving = true;
            $http.get('api/board/sks/export/', {
                params: {
                    projectId: entity.id,
                    from: DateUtils.convertLocalDateToServer(vm.from),
                    to: DateUtils.convertLocalDateToServer(vm.to)
                }
            }).then(function (response) {
                vm.isSaving = false;
                AlertService.success("Der Export wurde erfolgreich durchgeführt und an deine E-Mail Adresse geschickt.");
            });
        }
    }
})();

/*
 * Copyright (c) 2017 by Julian Feder, julian.feder@yahoo.de
 *
 * This product includes software developed at
 * The Apache Software Foundation (http://www.apache.org/).
 */

(function() {
    'use strict';

    angular
        .module('askApp')
        .controller('SbfTimeSlotDialogController', SbfTimeSlotDialogController);

    SbfTimeSlotDialogController.$inject = ['$timeout', '$scope', '$stateParams', '$uibModalInstance', 'entity', 'entityProject', 'SbfTimeSlot', 'Profile', '$http', 'ProjectDetailBooking'];

    function SbfTimeSlotDialogController ($timeout, $scope, $stateParams, $uibModalInstance, entity, entityProject, SbfTimeSlot, Profile, $http, ProjectDetailBooking) {
        var vm = this;
        vm.sbfTimeSlot = entity;
        vm.sbfTimeSlot.project = {id:$stateParams.id};
        vm.clear = clear;
        vm.datePickerOpenStatus = {};
        vm.openCalendar = openCalendar;
        vm.save = save;
        vm.slotDuration = [1, 30];
        vm.isExam = false;

        $scope.selectFromDate = function() {
            vm.isExam = false;
            if(!vm.sbfTimeSlot.fromTime) {
                return;
            }
            var defaultEndTime = angular.copy(vm.sbfTimeSlot.fromTime);
            defaultEndTime.setHours(defaultEndTime.getHours() + vm.slotDuration[0]);
            defaultEndTime.setMinutes(defaultEndTime.getMinutes() + vm.slotDuration[1]);
            vm.sbfTimeSlot.toTime = defaultEndTime;
            $scope.options = {
                minDate: new Date(vm.sbfTimeSlot.fromTime),
                initDate: new Date(defaultEndTime)
            };

            vm.isExam = vm.sbfTimeSlot.fromTime > entityProject.untilDate;
            if (vm.sbfTimeSlot.fromTime && vm.isExam && !vm.sbfTimeSlot.instructor) {
                vm.sbfTimeSlot.instructor = vm.profileExaminer;
            }
        };

        ProjectDetailBooking.query({
                page: 0,
                size: 999,
                sort: ["profile.user.lastName,asc", "profile.user.firstName,asc"],
                projectID: $stateParams.id
            }, function(data) {
                vm.profiles = data;
            }, function() {
        });

        vm.getUser = getUser;

        vm.profileExaminer = null;
        getExaminer();
        function getExaminer() {
            return $http.get('api/member/examiner', {}).then(function(response){
                vm.profileExaminer = response.data;
            });
        }

        $timeout(function (){
            angular.element('.form-group:eq(1)>input').focus();
        });

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function save () {
            vm.isSaving = true;
            if (vm.sbfTimeSlot.id !== null) {
                SbfTimeSlot.update(vm.sbfTimeSlot, onSaveSuccess, onSaveError);
            } else {
                SbfTimeSlot.save(vm.sbfTimeSlot, onSaveSuccess, onSaveError);
            }
        }

        function onSaveSuccess (result) {
            $scope.$emit('askApp:sbfTimeSlotUpdate', result);
            $uibModalInstance.close(result);
            vm.isSaving = false;
        }

        function onSaveError () {
            vm.isSaving = false;
        }

        vm.datePickerOpenStatus.fromTime = false;
        vm.datePickerOpenStatus.toTime = false;

        function openCalendar (date) {
            vm.datePickerOpenStatus[date] = true;
        }

        function getUser(val) {
            return $http.get('api/_search/profiles_guest/', {
                params: {
                    query: val
                }
            }).then(function(response){
                return response.data.map(function(item) {
                    return item;
                });
            });
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('askApp')
        .controller('SbfTimeSlotDeleteController',SbfTimeSlotDeleteController);

    SbfTimeSlotDeleteController.$inject = ['$uibModalInstance', 'entity', 'SbfTimeSlot'];

    function SbfTimeSlotDeleteController($uibModalInstance, entity, SbfTimeSlot) {
        var vm = this;

        vm.sbfTimeSlot = entity;
        vm.nickname = vm.sbfTimeSlot.instructor.nickname ? " \"" + vm.sbfTimeSlot.instructor.nickname + "\"" : "";
        vm.sbfTimeSlot.amount = 1;
        vm.sbfTimeSlot.freeParticipants = false;
        vm.clear = clear;
        vm.confirmDelete = confirmDelete;

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function confirmDelete (id) {
            SbfTimeSlot.delete({
                    id: id,
                    amount: vm.sbfTimeSlot.amount,
                    freeParticipants: vm.sbfTimeSlot.freeParticipants
                },
                function () {
                    $uibModalInstance.close(true);
                });
        }
    }
})();

/*
 * Copyright (c) 2017 by Julian Feder, julian.feder@yahoo.de
 *
 * This product includes software developed at
 * The Apache Software Foundation (http://www.apache.org/).
 */

(function() {
    'use strict';

    angular
        .module('askApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
        .state('board.project-detail.sbf-time-slot', {
            parent: 'board.project-detail',
            url: '/sbf-time-slot?page&sort&search',
            data: {
                authorities: ['ROLE_USER'],
                pageTitle: 'askApp.sbfTimeSlot.home.title'
            },
            views: {
                'projectDetail@board.project-detail': {
                    templateUrl: 'app/board/project/detail/sbf-time-slot/sbf-time-slots.html',
                    controller: 'SbfTimeSlotController',
                    controllerAs: 'vm'
                }
            },
            params: {
                page: {
                    value: '1',
                    squash: true
                },
                sort: {
                    value: 'fromTime,asc',
                    squash: true
                },
                search: null
            },
            resolve: {
                pagingParams: ['$stateParams', 'PaginationUtil', function ($stateParams, PaginationUtil) {
                    return {
                        page: PaginationUtil.parsePage($stateParams.page),
                        sort: $stateParams.sort,
                        predicate: PaginationUtil.parsePredicate($stateParams.sort),
                        ascending: PaginationUtil.parseAscending($stateParams.sort),
                        search: $stateParams.search
                    };
                }],
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('sbfTimeSlot');
                    $translatePartialLoader.addPart('global');
                    return $translate.refresh();
                }]
            }
        })
        .state('board.project-detail.sbf-time-slot.new', {
            parent: 'board.project-detail.sbf-time-slot',
            url: '/new',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', 'entity', function($stateParams, $state, $uibModal, entity) {
                $uibModal.open({
                    templateUrl: 'app/board/project/detail/sbf-time-slot/sbf-time-slot-dialog.html',
                    controller: 'SbfTimeSlotDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'md',
                    resolve: {
                        entity: function () {
                            return {
                                amount: 1,
                                fromTime: null,
                                toTime: null,
                                maxParticipants: 2,
                                id: null
                            };
                        },
                        entityProject: entity
                    }
                }).result.then(function() {
                    $state.go('board.project-detail.sbf-time-slot', null, { reload: 'board.project-detail.sbf-time-slot' });
                }, function() {
                    $state.go('board.project-detail.sbf-time-slot');
                });
            }]
        })
        .state('board.project-detail.sbf-time-slot.edit', {
            parent: 'board.project-detail.sbf-time-slot',
            url: '/{sbfId}/edit',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', 'entity', function($stateParams, $state, $uibModal, entity) {
                $uibModal.open({
                    templateUrl: 'app/board/project/detail/sbf-time-slot/sbf-time-slot-dialog.html',
                    controller: 'SbfTimeSlotDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'md',
                    resolve: {
                        entity: ['SbfTimeSlot', function(SbfTimeSlot) {
                            return SbfTimeSlot.get({id : $stateParams.sbfId}).$promise;
                        }],
                        entityProject: entity
                    }
                }).result.then(function() {
                    $state.go('board.project-detail.sbf-time-slot', null, { reload: 'board.project-detail.sbf-time-slot' });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('board.project-detail.sbf-time-slot.delete', {
            parent: 'board.project-detail.sbf-time-slot',
            url: '/{sbfId}/delete',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/board/project/detail/sbf-time-slot/sbf-time-slot-delete-dialog.html',
                    controller: 'SbfTimeSlotDeleteController',
                    controllerAs: 'vm',
                    size: 'md',
                    resolve: {
                        entity: ['SbfTimeSlot', function(SbfTimeSlot) {
                            return SbfTimeSlot.get({id : $stateParams.sbfId}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('board.project-detail.sbf-time-slot', null, { reload: 'board.project-detail.sbf-time-slot' });
                }, function() {
                    $state.go('^');
                });
            }]
        });
    }

})();

(function() {
    'use strict';
    angular
        .module('askApp')
        .factory('SbfTimeSlot', SbfTimeSlot);

    SbfTimeSlot.$inject = ['$resource', 'DateUtils'];

    function SbfTimeSlot ($resource, DateUtils) {
        var resourceUrl =  'api/sbf-time-slots/:id';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true},
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                        data.fromTime = DateUtils.convertDateTimeFromServer(data.fromTime);
                        data.toTime = DateUtils.convertDateTimeFromServer(data.toTime);
                    }
                    return data;
                }
            },
            'update': { method:'PUT' }
        });
    }
})();

(function() {
    'use strict';

    angular
        .module('askApp')
        .factory('SbfTimeSlotSearch', SbfTimeSlotSearch);

    SbfTimeSlotSearch.$inject = ['$resource'];

    function SbfTimeSlotSearch($resource) {
        var resourceUrl =  'api/_search/sbf-time-slots/:id';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true}
        });
    }
})();

(function() {
    'use strict';

    angular
        .module('askApp')
        .controller('SbfTimeSlotController', SbfTimeSlotController);

    SbfTimeSlotController.$inject = ['$state', 'SbfTimeSlot', 'SbfTimeSlotSearch', 'ParseLinks', 'AlertService', 'paginationConstants', 'pagingParams', '$stateParams', 'entity', 'DateUtils'];

    function SbfTimeSlotController($state, SbfTimeSlot, SbfTimeSlotSearch, ParseLinks, AlertService, paginationConstants, pagingParams, $stateParams, entity, DateUtils) {

        var vm = this;

        vm.project = entity;
        vm.loadPage = loadPage;
        vm.predicate = pagingParams.predicate;
        vm.reverse = pagingParams.ascending;
        vm.transition = transition;
        vm.itemsPerPage = paginationConstants.itemsPerPage;
        vm.clear = clear;
        vm.search = search;
        vm.loadAll = loadAll;
        vm.searchQuery = pagingParams.search;
        vm.currentSearch = pagingParams.search;

        loadAll();

        function loadAll () {
            if (pagingParams.search) {
                SbfTimeSlotSearch.query({
                    query: pagingParams.search,
                    page: pagingParams.page - 1,
                    size: vm.itemsPerPage,
                    sort: sort(),
                    projectID: $stateParams.id
                }, onSuccess, onError);
            } else {
                SbfTimeSlot.query({
                    page: pagingParams.page - 1,
                    size: vm.itemsPerPage,
                    sort: sort(),
                    projectID: $stateParams.id
                }, onSuccess, onError);
            }
            function sort() {
                var result = [vm.predicate + ',' + (vm.reverse ? 'asc' : 'desc')];
                if (vm.predicate !== 'fromTime') {
                    result.push('fromTime');
                }
                return result;
            }
            function onSuccess(data, headers) {
                vm.links = ParseLinks.parse(headers('link'));
                vm.totalItems = headers('X-Total-Count');
                vm.queryCount = vm.totalItems;
                vm.sbfTimeSlots = data;
                vm.page = pagingParams.page;

                for(var i = 0; i < vm.sbfTimeSlots.length; i++) {
                    vm.sbfTimeSlots[i].fromTime = DateUtils.convertDateTimeFromServer(vm.sbfTimeSlots[i].fromTime);
                    vm.sbfTimeSlots[i].toTime = DateUtils.convertDateTimeFromServer(vm.sbfTimeSlots[i].toTime);
                }
            }
            function onError(error) {
                AlertService.error(error.data.message);
            }
        }

        function loadPage(page) {
            vm.page = page;
            vm.transition();
        }

        function transition() {
            $state.transitionTo($state.$current, {
                page: vm.page,
                sort: vm.predicate + ',' + (vm.reverse ? 'asc' : 'desc'),
                search: vm.currentSearch,
                id: $stateParams.id
            });
        }

        function search(searchQuery) {
            if (!searchQuery){
                return vm.clear();
            }
            vm.links = null;
            vm.page = 1;
            vm.predicate = '_score';
            vm.reverse = false;
            vm.currentSearch = searchQuery;
            vm.transition();
        }

        function clear() {
            vm.links = null;
            vm.page = 1;
            vm.predicate = 'fromTime';
            vm.reverse = true;
            vm.currentSearch = null;
            vm.transition();
        }
    }
})();

/*
 * Copyright (c) 2017 by Julian Feder, julian.feder@yahoo.de
 *
 * This product includes software developed at
 * The Apache Software Foundation (http://www.apache.org/).
 */

(function() {
    'use strict';

    angular
        .module('askApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
        .state('board.project-detail.sbf-overview', {
            parent: 'board.project-detail',
            url: '/sbf-overview',
            data: {
                authorities: ['ROLE_BOARD','ROLE_MANAGER'],
                pageTitle: 'askApp.project.detail.title3'
            },
            views: {
                'projectDetail@board.project-detail': {
                    templateUrl: 'app/board/project/detail/sbf-overview/sbf-overview.html',
                    controller: 'SbfOverviewController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('project');
                    $translatePartialLoader.addPart('enumProjectType');
                    return $translate.refresh();
                }]
            }
        })
    }
})();

/*
 * Copyright (c) 2017 by Julian Feder, julian.feder@yahoo.de
 *
 * This product includes software developed at
 * The Apache Software Foundation (http://www.apache.org/).
 */

(function() {
    'use strict';

    angular
        .module('askApp')
        .controller('SbfOverviewController', SbfOverviewController);

    SbfOverviewController.$inject = ['$http', 'entity', 'DateUtils'];

    function SbfOverviewController($http, entity, DateUtils) {
        var vm = this;
        vm.project = entity;
        vm.selectAll = false;
        vm.toggle = toggle;
        vm.dataExport = dataExport;

        getOverview();

        function getOverview() {
            $http.get('api/board/sbf-time-slots/overview/', {
                params: {
                    projectId: entity.id,
                    selectAll: vm.selectAll
                }
            }).then(function(response) {
                vm.sbfOverview = response.data;

                for(var i = 0; i < vm.sbfOverview.length; i++) {
                    vm.sbfOverview[i].fromTime = DateUtils.convertDateTimeFromServer(vm.sbfOverview[i].fromTime);
                    vm.sbfOverview[i].toTime = DateUtils.convertDateTimeFromServer(vm.sbfOverview[i].toTime);
                }
            });
        }

        function dataExport() {
            vm.isSaving = true;
            $http.get('api/sbf-time-slots/export/', {
                params: {
                    projectId: entity.id
                }
            }).then(function (response) {
                vm.isSaving = false;
                AlertService.success("Der Export wurde erfolgreich durchgeführt und an deine E-Mail Adresse geschickt.");
            });
        }

        function toggle() {
            vm.selectAll = !vm.selectAll;
            getOverview();
        }
    }
})();

/*
 * Copyright (c) 2017 by Julian Feder, julian.feder@yahoo.de
 *
 * This product includes software developed at
 * The Apache Software Foundation (http://www.apache.org/).
 */

(function() {
    'use strict';

    angular
        .module('askApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider.state('board.project-detail', {
            parent: 'board.project',
            url: '/project/{id}',
            views: {
                'content@': {
                    templateUrl: 'app/board/project/detail/projectDetailNavbar.html',
                    controller: 'ProjectDetailNavController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                entity: ['$stateParams', 'Project', function($stateParams, Project) {
                    return Project.get({id : $stateParams.id}).$promise;
                }]
            }
        });
    }
})();

/*
 * Copyright (c) 2017 by Julian Feder, julian.feder@yahoo.de
 *
 * This product includes software developed at
 * The Apache Software Foundation (http://www.apache.org/).
 */

(function() {
    'use strict';

    angular
        .module('askApp')
        .controller('ProjectDetailNavController', ProjectDetailNavController);

    ProjectDetailNavController.$inject = ['$stateParams', 'entity'];

    function ProjectDetailNavController($stateParams, entity) {
        var vm = this;
        vm.id = $stateParams.id;
        vm.project = entity;
    }
})();

/*
 * Copyright (c) 2021 by Felix Heim, felix-heim@web.de
 *
 * This product includes software developed at
 * The Apache Software Foundation (http://www.apache.org/).
 */

(function() {
    'use strict';

    angular
        .module('askApp')
        .controller('ProjectPaymentDialogController', ProjectPaymentDialogController);

    ProjectPaymentDialogController.$inject = ['$timeout', '$scope', '$uibModalInstance', 'entity', 'entityProject', 'BoardPayment', 'DateUtils', '$http'];

    function ProjectPaymentDialogController ($timeout, $scope, $uibModalInstance, entity, entityProject, BoardPayment, DateUtils, $http) {
        var vm = this;

        if (entityProject.closed) {
            $timeout(function() {
                clear();
            });
        }
        vm.payment = entity;
        vm.maxAmount = vm.payment.amount;
        if (vm.payment.parent !== null) {
            vm.maxAmount = vm.payment.amount + vm.payment.parent.amount;
        }
        vm.clear = clear;
        vm.save = save;
        vm.getDept = getDept;
        vm.copyPayment = copyPayment;
        vm.amountEditable = false;

        $timeout(function (){
            angular.element('.form-group:eq(2)>input').focus();
        });

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function save () {
            vm.isSaving = true;
            if(vm.payment.dept == "") {
                vm.payment.dept = null;
            }
            if(vm.payment.category == "") {
                vm.payment.category = null;
            }
            BoardPayment.update(vm.payment, onSaveSuccess, onSaveError);
        }

        function onSaveSuccess (result) {
            $scope.$emit('askApp:paymentUpdate', result);
            $uibModalInstance.close(result);
            vm.isSaving = false;
        }

        function onSaveError () {
            vm.isSaving = false;
        }

        function getDept(val) {
            return $http.get('api/_search/depts/', {
                params: {
                    query: val,
                    projectId: vm.payment.project.id
                }
            }).then(function(response){
                return response.data.map(function(item) {
                    return item;
                });
            });
        }

        function copyPayment() {
            $http.get('/api/payments/duplicate/', {
                params: {
                    paymentId: vm.payment.id
                }
            }).then(onSaveSuccess, onSaveError);
        }
    }
})();

/*
 * Copyright (c) 2021 by Felix Heim, felix-heim@web.de
 *
 * This product includes software developed at
 * The Apache Software Foundation (http://www.apache.org/).
 */

(function() {
    'use strict';

    angular
        .module('askApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
        .state('board.project-detail.payments', {
            parent: 'board.project-detail',
            url: '/payments?type',
            data: {
                authorities: ['ROLE_BOARD','ROLE_MANAGER', 'ROLE_FINANCE'],
                pageTitle: 'askApp.project.payment.title'
            },
            views: {
                'projectDetail@board.project-detail': {
                    templateUrl: 'app/board/project/detail/payments/payments.html',
                    controller: 'ProjectPaymentsController',
                    controllerAs: 'vm'
                }
            },
            params: {
                type: {
                    value: 'all',
                    squash: true
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('payment');
                    $translatePartialLoader.addPart('project');
                    $translatePartialLoader.addPart('enumPaymentCategory');
                    return $translate.refresh();
                }]
            }
        })
        .state('board.project-detail.payments.edit', {
            parent: 'board.project-detail.payments',
            url: '/{paymentId}/edit',
            data: {
                authorities: ['ROLE_FINANCE']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', 'entity', function($stateParams, $state, $uibModal, entity) {
                $uibModal.open({
                    templateUrl: 'app/board/project/detail/payments/payment-dialog.html',
                    controller: 'ProjectPaymentDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'md',
                    resolve: {
                        entity: ['BoardPayment', function(BoardPayment) {
                            return BoardPayment.get({id : $stateParams.paymentId}).$promise;
                        }],
                        entityProject: entity
                    }
                }).result.then(function() {
                    $state.go('board.project-detail.payments', null, { reload: 'board.project-detail.payments' });
                }, function() {
                    $state.go('^');
                });
            }]
        });
    }
})();

/*
 * Copyright (c) 2021 by Felix Heim, felix-heim@web.de
 *
 * This product includes software developed at
 * The Apache Software Foundation (http://www.apache.org/).
 */

(function () {
    'use strict';

    angular
        .module('askApp')
        .controller('ProjectPaymentsController', ProjectPaymentsController);

    ProjectPaymentsController.$inject = ['entity', '$state', '$http', '$stateParams', 'DateUtils'];

    function ProjectPaymentsController(entity, $state, $http, $stateParams, DateUtils) {
        var vm = this;
        vm.project = entity;
        vm.type = $stateParams.type;

        vm.setType = setType;
        vm.dataExport = dataExport;
        vm.abs = abs;
        vm.transition = transition;
        vm.payments = [];
        vm.sumNegative = 0;
        vm.sumPositive = 0;
        vm.totalSum = 0;

        $http.get('api/board/projects/payments', {
            params: {
                projectId: entity.id,
                type: vm.type
            }
        }).then(function (response) {
            vm.payments = response.data;
            for (var index = 0; index < vm.payments.length; index++) {
                if (vm.payments[index].amount < 0) {
                    vm.sumNegative += vm.payments[index].amount;
                } else {
                    vm.sumPositive += vm.payments[index].amount;
                }
                vm.payments[index].date = DateUtils.convertLocalDateToServer(vm.payments[index].date);
            }
            vm.totalSum = vm.sumNegative + vm.sumPositive;
        });

        // could be replaced with vm.project.bookedPlaces but this way it gets refreshed every time (not only with project reload)
        $http.get('api/board/bookings/summary', {
            params: {
                projectID: entity.id
            }
        }).then(function (response) {
            vm.status = response.data;
            vm.validPlaces = vm.status.countAngemeldet + vm.status.countWarteliste;
            vm.freePlaces = vm.project.places - vm.validPlaces
        });

        function setType(type) {
            vm.type = type;
            vm.transition();
        }

        function transition() {
            $state.transitionTo($state.$current, {
                id: $stateParams.id,
                type: vm.type
            });
        }

        function dataExport() {
            vm.isSaving = true;
            $http.get('api/board/projects/export/', {
                params: {
                    projectId: $stateParams.id
                }
            }).then(function (response) {
                vm.isSaving = false;
                AlertService.success("Der Export wurde erfolgreich durchgeführt und an deine E-Mail Adresse geschickt.");
            }).catch(function () {
                vm.isSaving = false;
            });
        }

        function abs(data) {
            return Math.abs(data);
        }
    }
})();

/*
 * Copyright (c) 2017 by Julian Feder, julian.feder@yahoo.de
 *
 * This product includes software developed at
 * The Apache Software Foundation (http://www.apache.org/).
 */

(function() {
    'use strict';

    angular
        .module('askApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
        .state('board.project-detail.notes', {
            parent: 'board.project-detail',
            url: '/notes',
            data: {
                authorities: ['ROLE_BOARD','ROLE_MANAGER'],
                pageTitle: 'askApp.project.detail.title2'
            },
            views: {
                'projectDetail@board.project-detail': {
                    templateUrl: 'app/board/project/detail/notes/project-detail-notes.html',
                    controller: 'ProjectDetailNotesController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('project');
                    $translatePartialLoader.addPart('enumProjectType');
                    return $translate.refresh();
                }],
                previousState: ["$state", function ($state) {
                    var currentStateData = {
                        name: $state.current.name || 'board.project',
                        params: $state.params,
                        url: $state.href($state.current.name, $state.params)
                    };
                    return currentStateData;
                }]
            }
        });
    }
})();

/*
 * Copyright (c) 2017 by Julian Feder, julian.feder@yahoo.de
 *
 * This product includes software developed at
 * The Apache Software Foundation (http://www.apache.org/).
 */

(function() {
    'use strict';

    angular
        .module('askApp')
        .controller('ProjectDetailNotesController', ProjectDetailNotesController);

    ProjectDetailNotesController.$inject = ['entity', '$http'];

    function ProjectDetailNotesController(entity, $http) {
        var vm = this;
        vm.project = entity;
        vm.save = save;

        function save() {
            vm.isSaving = true;
            var projectNotesDTO = {
                id: vm.project.id,
                notes: vm.project.notes
            };
            $http.post('/api/projects/notes/', projectNotesDTO, null).then(onSaveSuccess, onSaveError);
        }

        function onSaveSuccess (result) {
            vm.isSaving = false;
        }

        function onSaveError () {
            vm.isSaving = false;
        }

        vm.options = {
            toolbar: [
                ['style', ['bold', 'italic', 'underline', 'clear']],
                ['textsize', ['fontsize']],
                ['fontclr', ['color']],
                ['alignment', ['ul', 'ol']],
                ['view', ['codeview']]
            ]
        };
    }
})();

/*
 * Copyright (c) 2017 by Julian Feder, julian.feder@yahoo.de
 *
 * This product includes software developed at
 * The Apache Software Foundation (http://www.apache.org/).
 */

(function() {
    'use strict';

    angular
        .module('askApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
        .state('board.project-detail.newsletter', {
            parent: 'board.project-detail',
            url: '/newsletter',
            data: {
                authorities: ['ROLE_BOARD','ROLE_MANAGER'],
                pageTitle: 'askApp.project.detail.title5'
            },
            views: {
                'projectDetail@board.project-detail': {
                    templateUrl: 'app/board/project/detail/newsletter/project-detail-newsletter.html',
                    controller: 'ProjectDetailNewsletterController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('project');
                    $translatePartialLoader.addPart('enumProjectType');
                    $translatePartialLoader.addPart('member-management');
                    return $translate.refresh();
                }],
                previousState: ["$state", function ($state) {
                    var currentStateData = {
                        name: $state.current.name || 'board.project',
                        params: $state.params,
                        url: $state.href($state.current.name, $state.params)
                    };
                    return currentStateData;
                }]
            }
        });
    }
})();

/*
 * Copyright (c) 2017 by Julian Feder, julian.feder@yahoo.de
 *
 * This product includes software developed at
 * The Apache Software Foundation (http://www.apache.org/).
 */

(function() {
    'use strict';

    angular
        .module('askApp')
        .controller('ProjectDetailNewsletterController', ProjectDetailNewsletterController);

    ProjectDetailNewsletterController.$inject = ['entity', '$http', 'Principal'];

    function ProjectDetailNewsletterController(entity, $http, Principal) {
        var vm = this;
        vm.project = entity;
        vm.contactMail = vm.project.contactMail !== null ? vm.project.contactMail : vm.project.profile.user.email;
        vm.action = action;
        vm.sendMail = {startId: 0, projectID: entity.id};
        vm.projectType = entity.type;

        Principal.identity().then(function(account) {
            vm.currentAccount = account;
        });

        vm.options = {
            toolbar: [
                ['style', ['bold', 'italic', 'underline', 'clear']],
                ['textsize', ['fontsize']],
                ['fontclr', ['color']],
                ['alignment', ['ul', 'ol']],
                ['view', ['codeview']]
            ]
        };

        function action(action) {
            vm.sendMail.action = action;
            vm.isSaving = true;
            $http.post('api/board/projects/mail/', vm.sendMail).then(function(response) {
                vm.isSaving = false;
            });
        }
    }
})();

/*
 * Copyright (c) 2017 by Julian Feder, julian.feder@yahoo.de
 *
 * This product includes software developed at
 * The Apache Software Foundation (http://www.apache.org/).
 */

(function() {
    'use strict';

    angular
        .module('askApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
        .state('board.project-detail.home', {
            parent: 'board.project-detail',
            url: '/home',
            data: {
                authorities: ['ROLE_BOARD','ROLE_MANAGER'],
                pageTitle: 'askApp.project.detail.title2'
            },
            views: {
                'projectDetail@board.project-detail': {
                    templateUrl: 'app/board/project/detail/home/project-detail-home.html',
                    controller: 'ProjectDetailHomeController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('project');
                    $translatePartialLoader.addPart('enumProjectType');
                    $translatePartialLoader.addPart('enumSksPracticalLocation');
                    $translatePartialLoader.addPart('enumBookingStatusType');
                    return $translate.refresh();
                }],
                previousState: ["$state", function ($state) {
                    return {
                        name: $state.current.name || 'board.project',
                        params: $state.params,
                        url: $state.href($state.current.name, $state.params)
                    };
                }]
            }
        })
        .state('board.project-detail.edit', {
            parent: 'board.project-detail.home',
            url: '/detail/edit',
            data: {
                authorities: ['ROLE_BOARD', 'ROLE_MANAGER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/board/project/project-dialog.html',
                    controller: 'ProjectDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: ['Project', function(Project) {
                            return Project.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('^', {}, { reload: true });
                }, function() {
                    $state.go('^');
                });
            }]
        })
    }
})();

/*
 * Copyright (c) 2020 by Felix Heim, felix-heim@web.de
 *
 * This product includes software developed at
 * The Apache Software Foundation (http://www.apache.org/).
 */

(function() {
    'use strict';

    angular
        .module('askApp')
        .controller('ProjectDetailHomeController', ProjectDetailHomeController);

    ProjectDetailHomeController.$inject = ['$scope', '$rootScope', '$sce', '$state', 'previousState', 'DataUtils', 'entity', 'ProjectBoard', '$window', '$location', 'AlertService', 'Lightbox'];

    function ProjectDetailHomeController($scope, $rootScope, $sce, $state, previousState, DataUtils, entity, ProjectBoard, $window, $location, AlertService, Lightbox) {
        var vm = this;
        vm.goTo = goTo;

        vm.project = entity;
        vm.validPlaces = vm.project.bookedPlaces.countAngemeldet + vm.project.bookedPlaces.countWarteliste;
        vm.freePlaces = vm.project.places - vm.validPlaces;
        vm.previousState = previousState.name;
        vm.byteSize = DataUtils.byteSize;
        vm.bookUrl =  $location.protocol() + "://" + location.host + "/" + $state.href("project.book", {id: vm.project.id, type: vm.project.type});

        var clipboardBookUrl = new ClipboardJS(document.getElementById("copyUrlButton"));
        clipboardBookUrl.on('success', function(e) {
            $scope.$apply(function() {
                AlertService.success("Anmeldelink wurde in die Zwischenablage kopiert.");
            });
            e.clearSelection();
        });

        clipboardBookUrl.on('error', function(e) {
            $scope.$apply(function() {
                AlertService.error("Anmeldelink konnte nicht kopiert werden.");
            });
        });

        var unsubscribe = $rootScope.$on('askApp:projectUpdate', function(event, result) {
            vm.project = result;
            vm.validPlaces = vm.project.bookedPlaces.countAngemeldet + vm.project.bookedPlaces.countWarteliste;
            vm.freePlaces = vm.project.places - vm.validPlaces;
        });

        $scope.renderHtml = function(code) {
            return $sce.trustAsHtml(code);
        };

        $scope.openLightboxModal = function(index, image) {
            var images = [{'url': image}];
            Lightbox.openModal(images, index);
        };

        $scope.$on('$destroy', unsubscribe);

        function goTo(url) {
            $window.open(url, "_blank");
        }
    }
})();

/*
 * Copyright (c) 2021 by Felix Heim, felix-heim@web.de
 *
 * This product includes software developed at
 * The Apache Software Foundation (http://www.apache.org/).
 */

(function() {
    'use strict';

    angular
        .module('askApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
        .state('board.project-detail.depts', {
            parent: 'board.project-detail',
            url: '/depts',
            data: {
                authorities: ['ROLE_BOARD','ROLE_MANAGER', 'ROLE_FINANCE'],
                pageTitle: 'askApp.project.dept.title'
            },
            views: {
                'projectDetail@board.project-detail': {
                    templateUrl: 'app/board/project/detail/depts/depts.html',
                    controller: 'ProjectDeptsController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('dept');
                    $translatePartialLoader.addPart('project');
                    $translatePartialLoader.addPart('enumDeptStatus');
                    $translatePartialLoader.addPart('enumMemberStatus');
                    $translatePartialLoader.addPart('enumPaymentCategory');
                    return $translate.refresh();
                }]
            }
        })
        .state('board.project-detail.depts.edit-dept', {
            parent: 'board.project-detail.depts',
            url: '/{deptId}/edit',
            data: {
                authorities: ['ROLE_FINANCE']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/board/dept/dept-dialog.html',
                    controller: 'BoardDeptDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'md',
                    resolve: {
                        translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                            $translatePartialLoader.addPart('booking');
                            $translatePartialLoader.addPart('payment');
                            $translatePartialLoader.addPart('enumPaymentCategory');
                            return $translate.refresh();
                        }],
                        entity: ['Dept', function(Dept) {
                            return Dept.get({id : $stateParams.deptId}).$promise;
                        }],
                        entityProfile: null,
                        entityProject: null,
                        entityDinghyEvent: null
                    }
                }).result.then(function() {
                    $state.go('board.project-detail.depts', null, { reload: 'board.project-detail' });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('board.project-detail.depts.new-dept', {
            parent: 'board.project-detail.depts',
            url: '/new/{userId}',
            data: {
                authorities: ['ROLE_FINANCE']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', 'entity', function($stateParams, $state, $uibModal, entity) {
                $uibModal.open({
                    templateUrl: 'app/board/dept/dept-dialog.html',
                    controller: 'BoardDeptDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'md',
                    resolve: {
                        translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                            $translatePartialLoader.addPart('booking');
                            $translatePartialLoader.addPart('payment');
                            $translatePartialLoader.addPart('enumPaymentCategory');
                            return $translate.refresh();
                        }],
                        entity: function () {
                            return {
                                date: new Date(),
                                reference: null,
                                pointValue: 0,
                                amount: null,
                                comment: null,
                                category: "",
                                sepa: null,
                                paymentStatus: null,
                                id: null
                            };
                        },
                        entityProfile: ['MemberManagement', function(MemberManagement) {
                            return MemberManagement.get({id: $stateParams.userId}).$promise;
                        }],
                        entityProject: entity,
                        entityDinghyEvent: null
                    }
                }).result.then(function() {
                    $state.go('board.project-detail.depts', null, { reload: 'board.project-detail' });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('board.project-detail.depts.new-dept-project', {
            parent: 'board.project-detail.depts',
            url: '/new',
            data: {
                authorities: ['ROLE_FINANCE']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', 'entity', function($stateParams, $state, $uibModal, entity) {
                $uibModal.open({
                    templateUrl: 'app/board/dept/dept-dialog.html',
                    controller: 'BoardDeptDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'md',
                    resolve: {
                        translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                            $translatePartialLoader.addPart('booking');
                            $translatePartialLoader.addPart('payment');
                            $translatePartialLoader.addPart('enumPaymentCategory');
                            return $translate.refresh();
                        }],
                        entity: function () {
                            return {
                                date: new Date(),
                                reference: null,
                                pointValue: 0,
                                amount: null,
                                comment: null,
                                category: "",
                                sepa: null,
                                paymentStatus: null,
                                id: null
                            };
                        },
                        entityProfile: null,
                        entityProject: entity,
                        entityDinghyEvent: null
                    }
                }).result.then(function() {
                    $state.go('board.project-detail.depts', null, { reload: 'board.project-detail' });
                }, function() {
                    $state.go('^');
                });
            }]
        });
    }
})();

/*
 * Copyright (c) 2021 by Felix Heim, felix-heim@web.de
 *
 * This product includes software developed at
 * The Apache Software Foundation (http://www.apache.org/).
 */

(function () {
    'use strict';

    angular
        .module('askApp')
        .controller('ProjectDeptsController', ProjectDeptsController);

    ProjectDeptsController.$inject = ['entity', '$state', '$http', '$stateParams'];

    function ProjectDeptsController(entity, $state, $http, $stateParams) {
        var vm = this;
        vm.project = entity;

        vm.dataExport = dataExport;
        vm.abs = abs;
        vm.depts = [];

        $http.get('api/board/projects/depts', {
            params: {
                projectId: entity.id
            }
        }).then(function (response) {
            vm.depts = response.data;
        });

        // could be replaced with vm.project.bookedPlaces but this way it gets refreshed every time (not only with project reload)
        $http.get('api/board/bookings/summary', {
            params: {
                projectID: entity.id
            }
        }).then(function (response) {
            vm.status = response.data;
            vm.validPlaces = vm.status.countAngemeldet + vm.status.countWarteliste;
            vm.freePlaces = vm.project.places - vm.validPlaces
        });

        function dataExport() {
            vm.isSaving = true;
            $http.get('api/board/projects/export/', {
                params: {
                    projectId: $stateParams.id
                }
            }).then(function (response) {
                vm.isSaving = false;
                AlertService.success("Der Export wurde erfolgreich durchgeführt und an deine E-Mail Adresse geschickt.");
            }).catch(function () {
                vm.isSaving = false;
            });
        }

        function abs(data) {
            return Math.abs(data);
        }
    }
})();

/*
 * Copyright (c) 2018 by Felix Heim, felix.heim@web.de
 *
 * This product includes software developed at
 * The Apache Software Foundation (http://www.apache.org/).
 */

(function() {
    'use strict';

    angular
        .module('askApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
        .state('board.project-detail.crew', {
            parent: 'board.project-detail',
            url: '/crew',
            data: {
                authorities: ['ROLE_BOARD','ROLE_MANAGER'],
                pageTitle: 'askApp.crew.home.title'
            },
            views: {
                'projectDetail@board.project-detail': {
                    templateUrl: 'app/board/project/detail/crew/crew.html',
                    controller: 'CrewController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('crew');
                    $translatePartialLoader.addPart('enumProjectType');
                    return $translate.refresh();
                }],
                viewParams : [function() {
                    return {
                        type: 'crew'
                    };
                }]
            }
        })
        .state('board.project-detail.crew.edit-booking', {
            parent: 'board.project-detail.crew',
            url: '/{bookingId}/edit',
            data: {
                authorities: ['ROLE_BOARD','ROLE_MANAGER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', 'entity', function($stateParams, $state, $uibModal, entity) {
                $uibModal.open({
                    templateUrl: 'app/board/project/detail/bookings/booking-dialog.html',
                    controller: 'ProjectDetailBookingDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'md',
                    resolve: {
                        entity2: ['ProjectDetailBooking', function(ProjectDetailBooking) {
                            return ProjectDetailBooking.get({id : $stateParams.bookingId}).$promise;
                        }],
                        entity: entity
                    }
                }).result.then(function() {
                    $state.go('board.project-detail.crew', null, { reload: 'board.project-detail.crew' });
                }, function() {
                    $state.go('^');
                });
            }],
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('booking');
                    return $translate.refresh();
                }]
            }
        })
        .state('board.project-detail.nausys', {
            parent: 'board.project-detail.crew',
            url: '/nausys',
            data: {
                authorities: ['ROLE_BOARD','ROLE_MANAGER'],
                pageTitle: 'askApp.crew.home.title'
            },
            views: {
                'projectDetail@board.project-detail': {
                    templateUrl: 'app/board/project/detail/crew/crew.html',
                    controller: 'CrewController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('crew');
                    $translatePartialLoader.addPart('enumProjectType');
                    return $translate.refresh();
                }],
                viewParams : [function() {
                    return {
                        type: 'nausys'
                    };
                }]
            }
        })
        .state('board.project-detail.bm', {
            parent: 'board.project-detail.crew',
            url: '/bm',
            data: {
                authorities: ['ROLE_BOARD','ROLE_MANAGER'],
                pageTitle: 'askApp.crew.home.title'
            },
            views: {
                'projectDetail@board.project-detail': {
                    templateUrl: 'app/board/project/detail/crew/crew.html',
                    controller: 'CrewController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('crew');
                    $translatePartialLoader.addPart('enumProjectType');
                    return $translate.refresh();
                }],
                viewParams : [function() {
                    return {
                        type: 'bm'
                    };
                }]
            }
        })
    }
})();

(function() {
    'use strict';
    angular
        .module('askApp')
        .factory('Crew', Crew);

    Crew.$inject = ['$resource'];

    function Crew ($resource) {
        var resourceUrl =  'api/crews/:id';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true},
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                    }
                    return data;
                }
            },
            'update': { method:'PUT' }
        });
    }
})();

/*
 * Copyright (c) 2018-2019 by Felix Heim, felix.heim@web.de
 *
 * This product includes software developed at
 * The Apache Software Foundation (http://www.apache.org/).
 */

(function() {
    'use strict';

    angular
        .module('askApp')
        .controller('CrewController', CrewController);

    CrewController.$inject = ['$http', 'entity', 'Crew', '$scope', '$window', 'AlertService', 'viewParams'];

    function CrewController($http, entity, Crew, $scope, $window, AlertService, $viewParams) {
        var vm = this;
        vm.project = entity;
        vm.type = $viewParams.type;
        vm.goTo = goTo;
        vm.createNew = createNew;
        vm.deleteCrew = deleteCrew;
        vm.deleteFromCrew = deleteFromCrew;
        vm.insertedInCrew = insertedInCrew;
        vm.deleteFromWithoutCrew = deleteFromWithoutCrew;
        vm.insertedIntoWithout = insertedIntoWithout;
        vm.dataExport = dataExport;
        vm.saveNausys = saveNausys;
        vm.exportToOnlineCrewlist = exportToOnlineCrewlist;

        vm.isCollapsed = false;
        vm.toggleAccordion = toggleAccordion;

        getCrews();
        getBookingsWithoutCrew();

        function getCrews() {
            vm.isSaving = true;
            $http.get('api/crews', {
                params: {
                    projectId: entity.id
                }
            }).then(function (response) {
                vm.crews = response.data;
                for(var i = 0; i < vm.crews.length; i++) {
                    vm.crews[i].isCollapsed = false;
                }
                vm.isSaving = false;
            });
        }

        function getBookingsWithoutCrew() {
            $http.get('api/crews/bookings', {
                params: {
                    projectId: entity.id
                }
            }).then(function (response) {
                vm.bookingsWithoutCrew = response.data;
            });
        }

        function goTo(url) {
            if (vm.type === 'nausys') {
                $window.open("https://crew.nausys.com/" + url + "/", "_blank");
            } else if (vm.type === 'bm'){
                $window.open("https://www.booking-manager.com/cbm/servlet/cbm?" + url, "_blank");
            }
        }

        function createNew() {
            vm.isSaving = true;
            $http.post('api/crews', {
                id: null,
                project: entity
            }).then(function (response) {
                vm.isSaving = false;
                var newCrew = response.data;
                newCrew.members = [];
                newCrew.isCollapsed = false;
                vm.crews.push(newCrew);
            });
        }

        function deleteCrew(id, index) {
            vm.crews.splice(index, 1);
            Crew.delete({id: id});
        }

        function deleteFromCrew(index, crewIndex) {
            // fires after insert
            vm.crews[crewIndex].members.splice(index, 1);
        }

        function insertedInCrew(index, crewIndex) {
            var crew = vm.crews[crewIndex];
            Crew.update(crew, function (response) {
                vm.crews[crewIndex] = response;
            });
        }

        function deleteFromWithoutCrew(member) {
            vm.bookingsWithoutCrew.splice(vm.bookingsWithoutCrew.indexOf(member), 1);
        }

        function insertedIntoWithout(index) {
            Crew.update({
                id: null,
                project: entity.id,
                members: [vm.bookingsWithoutCrew[index]]
            });
        }

        function dataExport() {
            vm.isSaving = true;
            $http.get('api/crews/export/', {
                params: {
                    projectId: entity.id
                }
            }).then(function (response) {
                vm.isSaving = false;
                AlertService.success("Der Export wurde erfolgreich durchgeführt und an deine E-Mail Adresse geschickt.");
            });
        }

        $scope.dragoverCallback = function (event, index, external, type) {
            //console.log(event.path[1]);
            //var ul = event.path[1];
            //$(ul).find('.dndPlaceholder2').hide();

            return true;
        };

        function saveNausys(crew) {
            vm.isSaving = true;
            var crewCopy = angular.copy(crew);
            crewCopy.members = [];
            $http.post('api/crews/nausys/', crewCopy).then(function (response) {
                vm.error = null;
                vm.isSaving = false;
            }, function (error) {
                vm.isSaving = false;
                vm.error = 'ERROR';
            });
        }

        function exportToOnlineCrewlist(crew) {
            vm.isSaving = true;
            $http.get('api/crews/' + vm.type + '/export/', {
                params: {
                    crewId: crew.id
                }
            }).then(function (response) {
                vm.error = null;
                vm.isSaving = false;
            }).catch(function (error) {
                vm.isSaving = false;
                vm.error = 'ERROR';
            });
        }

        function toggleAccordion() {
            vm.isCollapsed = !vm.isCollapsed;
            for(var i = 0; i < vm.crews.length; i++) {
                vm.crews[i].isCollapsed = vm.isCollapsed;
            }
        }
    }
})();

/*
 * Copyright (c) 2017 by Julian Feder, julian.feder@yahoo.de
 *
 * This product includes software developed at
 * The Apache Software Foundation (http://www.apache.org/).
 */

(function() {
    'use strict';

    angular
        .module('askApp')
        .controller('ProjectDetailBookingDialogController', ProjectDetailBookingDialogController);

    ProjectDetailBookingDialogController.$inject = ['$timeout', '$scope', '$uibModalInstance', 'entity', 'entity2', 'ProjectDetailBooking'];

    function ProjectDetailBookingDialogController ($timeout, $scope, $uibModalInstance, entity, entity2, ProjectDetailBooking) {
        var vm = this;

        vm.booking = entity2;
        vm.nickname = vm.booking.nickname ? " \"" + vm.booking.nickname + "\"" : "";
        vm.booking.oldStatus = vm.booking.status;
        vm.booking.oldIndividualPrice = vm.booking.individualPrice;
        vm.booking.nonIndividual = !vm.booking.individualPrice;
        vm.project = entity;
        vm.clear = clear;
        vm.datePickerOpenStatus = {};
        vm.openCalendar = openCalendar;
        vm.save = save;

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function save () {
            vm.isSaving = true;
            vm.booking.individualPrice = !vm.booking.nonIndividual;
            ProjectDetailBooking.update(vm.booking, onSaveSuccess, onSaveError);
        }

        function onSaveSuccess (result) {
            $scope.$emit('askApp:bookingUpdate', result);
            $uibModalInstance.close(result);
            vm.isSaving = false;
        }

        function onSaveError () {
            vm.isSaving = false;
        }

        vm.datePickerOpenStatus.date = false;

        function openCalendar (date) {
            vm.datePickerOpenStatus[date] = true;
        }
    }
})();

/*
 * Copyright (c) 2017 by Julian Feder, julian.feder@yahoo.de
 *
 * This product includes software developed at
 * The Apache Software Foundation (http://www.apache.org/).
 */

(function() {
    'use strict';

    angular
        .module('askApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
        .state('board.project-detail.booking', {
            parent: 'board.project-detail',
            url: '/booking?page&sort&search',
            data: {
                authorities: ['ROLE_BOARD','ROLE_MANAGER'],
                pageTitle: 'askApp.booking.home.title3'
            },
            views: {
                'projectDetail@board.project-detail': {
                    templateUrl: 'app/board/project/detail/bookings/bookings.html',
                    controller: 'ProjectDetailBookingController',
                    controllerAs: 'vm'
                }
            },
            params: {
                page: {
                    value: '1',
                    squash: true
                },
                sort: {
                    value: 'id,desc',
                    squash: true
                },
                search: null
            },
            resolve: {
                pagingParams: ['$stateParams', 'PaginationUtil', function ($stateParams, PaginationUtil) {
                    return {
                        page: PaginationUtil.parsePage($stateParams.page),
                        sort: $stateParams.sort,
                        predicate: PaginationUtil.parsePredicate($stateParams.sort),
                        ascending: PaginationUtil.parseAscending($stateParams.sort),
                        search: $stateParams.search
                    };
                }],
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('booking');
                    $translatePartialLoader.addPart('enumBookingStatusType');
                    $translatePartialLoader.addPart('enumDeptStatus');
                    $translatePartialLoader.addPart('dept');
                    $translatePartialLoader.addPart('global');
                    return $translate.refresh();
                }]
            }
        })
        .state('board.project-detail.booking.edit', {
            parent: 'board.project-detail.booking',
            url: '/{id2}/edit',
            data: {
                authorities: ['ROLE_BOARD','ROLE_MANAGER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', 'entity', function($stateParams, $state, $uibModal, entity) {
                $uibModal.open({
                    templateUrl: 'app/board/project/detail/bookings/booking-dialog.html',
                    controller: 'ProjectDetailBookingDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'md',
                    resolve: {
                        entity2: ['ProjectDetailBooking', function(ProjectDetailBooking) {
                            return ProjectDetailBooking.get({id : $stateParams.id2}).$promise;
                        }],
                        entity: entity
                    }
                }).result.then(function() {
                    $state.go('board.project-detail.booking', null, { reload: 'board.project-detail' });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('board.project-detail.booking.edit-dept', {
            parent: 'board.project-detail.booking',
            url: '/dept/{deptId}/edit',
            data: {
                authorities: ['ROLE_FINANCE']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/board/dept/dept-dialog.html',
                    controller: 'BoardDeptDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'md',
                    resolve: {
                        translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                            $translatePartialLoader.addPart('payment');
                            $translatePartialLoader.addPart('enumPaymentCategory');
                            return $translate.refresh();
                        }],
                        entity: ['Dept', function(Dept) {
                            return Dept.get({id : $stateParams.deptId}).$promise;
                        }],
                        entityProfile: null,
                        entityProject: null,
                        entityDinghyEvent: null
                    }
                }).result.then(function() {
                    $state.go('board.project-detail.booking', null, { reload: 'board.project-detail' });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('board.project-detail.booking.new-dept', {
            parent: 'board.project-detail.booking',
            url: '/dept/new/{userId}',
            data: {
                authorities: ['ROLE_FINANCE']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', 'entity', function($stateParams, $state, $uibModal, entity) {
                $uibModal.open({
                    templateUrl: 'app/board/dept/dept-dialog.html',
                    controller: 'BoardDeptDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'md',
                    resolve: {
                        translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                            $translatePartialLoader.addPart('payment');
                            $translatePartialLoader.addPart('enumPaymentCategory');
                            return $translate.refresh();
                        }],
                        entity: function () {
                            return {
                                date: new Date(),
                                reference: null,
                                pointValue: 0,
                                amount: null,
                                comment: null,
                                category: "",
                                sepa: null,
                                paymentStatus: null,
                                id: null
                            };
                        },
                        entityProfile: ['MemberManagement', function(MemberManagement) {
                            return MemberManagement.get({id: $stateParams.userId}).$promise;
                        }],
                        entityProject: entity,
                        entityDinghyEvent: null
                    }
                }).result.then(function() {
                    $state.go('board.project-detail.booking', null, { reload: 'board.project-detail' });
                }, function() {
                    $state.go('^');
                });
            }]
        });
    }
})();

/*
 * Copyright (c) 2017 by Julian Feder, julian.feder@yahoo.de
 *
 * This product includes software developed at
 * The Apache Software Foundation (http://www.apache.org/).
 */

(function() {
    'use strict';
    angular
        .module('askApp')
        .factory('ProjectDetailBooking', ProjectDetailBooking);

    ProjectDetailBooking.$inject = ['$resource', 'DateUtils'];

    function ProjectDetailBooking ($resource, DateUtils) {
        var resourceUrl =  'api/board/bookings/:id';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true},
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                        data.date = DateUtils.convertLocalDateFromServer(data.date);
                    }
                    return data;
                }
            },
            'update': {
                method: 'PUT',
                transformRequest: function (data) {
                    var copy = angular.copy(data);
                    copy.date = DateUtils.convertLocalDateToServer(copy.date);
                    return angular.toJson(copy);
                }
            },
            'save': {
                method: 'POST',
                transformRequest: function (data) {
                    var copy = angular.copy(data);
                    copy.date = DateUtils.convertLocalDateToServer(copy.date);
                    return angular.toJson(copy);
                }
            }
        });
    }
})();

/*
 * Copyright (c) 2017 by Julian Feder, julian.feder@yahoo.de
 *
 * This product includes software developed at
 * The Apache Software Foundation (http://www.apache.org/).
 */

(function() {
    'use strict';

    angular
        .module('askApp')
        .controller('ProjectDetailBookingController', ProjectDetailBookingController);

    ProjectDetailBookingController.$inject = ['$state', 'ProjectDetailBooking', 'BookingSearch', 'ParseLinks', 'AlertService', 'paginationConstants', 'pagingParams', '$stateParams', 'entity', '$http', 'DateUtils'];

    function ProjectDetailBookingController($state, ProjectDetailBooking, BookingSearch, ParseLinks, AlertService, paginationConstants, pagingParams, $stateParams, entity, $http, DateUtils) {

        var vm = this;

        vm.loadPage = loadPage;
        vm.predicate = pagingParams.predicate;
        vm.reverse = pagingParams.ascending;
        vm.transition = transition;
        vm.itemsPerPage = paginationConstants.itemsPerPage;
        vm.clear = clear;
        vm.search = search;
        vm.loadAll = loadAll;
        vm.searchQuery = pagingParams.search;
        vm.currentSearch = pagingParams.search;
        vm.project = entity;
        vm.dataExport = dataExport;

        loadAll();

        function loadAll () {
            if (pagingParams.search) {
                BookingSearch.query({
                    query: pagingParams.search,
                    page: pagingParams.page - 1,
                    size: vm.itemsPerPage,
                    sort: sort()
                }, onSuccess, onError);
            } else {
                ProjectDetailBooking.query({
                    page: pagingParams.page - 1,
                    size: vm.itemsPerPage,
                    sort: sort(),
                    projectID: $stateParams.id
                }, onSuccess, onError);
            }

            // could be replaced with vm.project.bookedPlaces but this way it get's refreshed every time (not only with project reload)
            $http.get('api/board/bookings/summary', {
                params: {
                    projectID: entity.id
                }
            }).then(function(response) {
                vm.status = response.data;
                vm.validPlaces = vm.status.countAngemeldet + vm.status.countWarteliste;
                vm.freePlaces = vm.project.places - vm.validPlaces
            });

            function sort() {
                var sorting = vm.reverse ? 'asc' : 'desc';
                var result = [vm.predicate + ',' + sorting];
                if (vm.predicate !== 'id') {
                    result.push('id,' + sorting);
                }
                return result;
            }
            function onSuccess(data, headers) {
                vm.links = ParseLinks.parse(headers('link'));
                vm.totalItems = headers('X-Total-Count');
                vm.queryCount = vm.totalItems;
                vm.bookings = data;
                vm.page = pagingParams.page;
                for(var i = 0; i < vm.bookings.length; i++) {
                    for(var u = 0; u < vm.bookings[i].sbfTimeSlots.length; u++) {
                        vm.bookings[i].sbfTimeSlots[u].fromTime = DateUtils.convertDateTimeFromServer(vm.bookings[i].sbfTimeSlots[u].fromTime);
                        vm.bookings[i].sbfTimeSlots[u].toTime = DateUtils.convertDateTimeFromServer(vm.bookings[i].sbfTimeSlots[u].toTime);
                    }
                }
                //console.log(vm.bookings);
            }
            function onError(error) {
                AlertService.error(error.data.message);
            }
        }

        function loadPage(page) {
            vm.page = page;
            vm.transition();
        }

        function transition() {
            $state.transitionTo($state.$current, {
                page: vm.page,
                sort: vm.predicate + ',' + (vm.reverse ? 'asc' : 'desc'),
                search: vm.currentSearch,
                id: $stateParams.id
            });
        }

        function search(searchQuery) {
            if (!searchQuery){
                return vm.clear();
            }
            vm.links = null;
            vm.page = 1;
            vm.predicate = '_score';
            vm.reverse = false;
            vm.currentSearch = searchQuery;
            vm.transition();
        }

        function clear() {
            vm.links = null;
            vm.page = 1;
            vm.predicate = 'id';
            vm.reverse = true;
            vm.currentSearch = null;
            vm.transition();
        }

        function dataExport() {
            vm.isSaving = true;
            $http.get('api/board/bookings/export/', {params:{
                projectID: $stateParams.id
            }}).then(function(response) {
                vm.isSaving = false;
                AlertService.success("Der Export wurde erfolgreich durchgeführt und an deine E-Mail Adresse geschickt.");
            });
        }
    }
})();

/*
 * Copyright (c) 2017 by Julian Feder, julian.feder@yahoo.de
 *
 * This product includes software developed at
 * The Apache Software Foundation (http://www.apache.org/).
 */

(function() {
    'use strict';

    angular
        .module('askApp')
        .controller('BoardPaymentDialogController', BoardPaymentDialogController);

    BoardPaymentDialogController.$inject = ['$timeout', '$scope', '$uibModalInstance', 'entity', 'BoardPayment', 'DateUtils', '$http', 'ProjectActive', 'DinghyEventActive'];

    function BoardPaymentDialogController ($timeout, $scope, $uibModalInstance, entity, BoardPayment, DateUtils, $http, ProjectActive, DinghyEventActive) {
        var vm = this;

        vm.payment = entity;
        vm.maxAmount = vm.payment.amount;
        if (vm.payment.parent !== null) {
            vm.maxAmount = vm.payment.amount + vm.payment.parent.amount;
        }
        vm.clear = clear;
        vm.save = save;
        vm.getDept = getDept;
        vm.copyPayment = copyPayment;
        vm.amountEditable = false;
        vm.projects = [vm.payment.project];
        vm.dinghyEvents = [vm.payment.dinghyEvent];
        vm.relationClosed = (vm.payment.project && vm.payment.project.closed) || (vm.payment.dinghyEvent && vm.payment.dinghyEvent.closed)

        if (!vm.relationClosed) {
            getProjects();
            getDinghyEvents();
        }

        $timeout(function (){
            angular.element('.form-group:eq(2)>input').focus();
        });

        function getProjects() {
            ProjectActive.get({userId: null}, function(data) {
                vm.projects = data;
            });
        }

        function getDinghyEvents() {
            DinghyEventActive.get({userId: null}, function(data) {
                vm.dinghyEvents = data;
            });
        }

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function save () {
            vm.isSaving = true;
            if(vm.payment.dept == "") {
                vm.payment.dept = null;
            }
            if(vm.payment.category == "") {
                vm.payment.category = null;
            }
            BoardPayment.update(vm.payment, onSaveSuccess, onSaveError);
        }

        function onSaveSuccess (result) {
            $scope.$emit('askApp:paymentUpdate', result);
            $uibModalInstance.close(result);
            vm.isSaving = false;
        }

        function onSaveError () {
            vm.isSaving = false;
        }

        function getDept(val) {
            return $http.get('api/_search/depts/', {
                params: {
                    query: val
                }
            }).then(function(response){
                return response.data.map(function(item) {
                    return item;
                });
            });
        }

        function copyPayment() {
            $http.get('/api/payments/duplicate/', {
                params: {
                    paymentId: vm.payment.id
                }
            }).then(onSaveSuccess, onSaveError);
        }
    }
})();

/*
 * Copyright (c) 2017 by Julian Feder, julian.feder@yahoo.de
 *
 * This product includes software developed at
 * The Apache Software Foundation (http://www.apache.org/).
 */

(function() {
    'use strict';

    angular
        .module('askApp')
        .controller('BoardPaymentDeleteController',BoardPaymentDeleteController);

    BoardPaymentDeleteController.$inject = ['$uibModalInstance', 'entity', 'BoardPayment'];

    function BoardPaymentDeleteController($uibModalInstance, entity, BoardPayment) {
        var vm = this;

        vm.payment = entity;
        vm.clear = clear;
        vm.confirmDelete = confirmDelete;

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function confirmDelete (id) {
            BoardPayment.delete({id: id},
                function () {
                    $uibModalInstance.close(true);
                });
        }
    }
})();

/*
 * Copyright (c) 2017 by Julian Feder, julian.feder@yahoo.de
 *
 * This product includes software developed at
 * The Apache Software Foundation (http://www.apache.org/).
 */

(function() {
    'use strict';

    angular
        .module('askApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
        .state('board.payment', {
            parent: 'board',
            url: '/board/payment?page&sort&search',
            data: {
                authorities: ['ROLE_FINANCE'],
                pageTitle: 'askApp.payment.home.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/board/payment/payments.html',
                    controller: 'BoardPaymentController',
                    controllerAs: 'vm'
                }
            },
            params: {
                page: {
                    value: '1',
                    squash: true
                },
                sort: {
                    value: 'date,desc',
                    squash: true
                },
                search: null
            },
            resolve: {
                pagingParams: ['$stateParams', 'PaginationUtil', function ($stateParams, PaginationUtil) {
                    return {
                        page: PaginationUtil.parsePage($stateParams.page),
                        sort: $stateParams.sort,
                        predicate: PaginationUtil.parsePredicate($stateParams.sort),
                        ascending: PaginationUtil.parseAscending($stateParams.sort),
                        search: $stateParams.search
                    };
                }],
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('payment');
                    $translatePartialLoader.addPart('enumPaymentType');
                    $translatePartialLoader.addPart('enumPaymentCategory');
                    $translatePartialLoader.addPart('global');
                    return $translate.refresh();
                }]
            }
        })
        .state('board.payment.edit', {
            parent: 'board.payment',
            url: '/{id}/edit',
            data: {
                authorities: ['ROLE_FINANCE']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/board/payment/payment-dialog.html',
                    controller: 'BoardPaymentDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'md',
                    resolve: {
                        entity: ['BoardPayment', function(BoardPayment) {
                            return BoardPayment.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('board.payment', null, { reload: 'board.payment' });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('board.payment.delete', {
            parent: 'board.payment',
            url: '/{id}/delete',
            data: {
                authorities: ['ROLE_FINANCE']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/board/payment/payment-delete-dialog.html',
                    controller: 'BoardPaymentDeleteController',
                    controllerAs: 'vm',
                    size: 'md',
                    resolve: {
                        entity: ['BoardPayment', function(BoardPayment) {
                            return BoardPayment.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('board.payment', null, { reload: 'board.payment' });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('board.payment.dept-edit', {
            parent: 'board.payment',
            url: '/dept/{deptId}/edit',
            data: {
                authorities: ['ROLE_FINANCE']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function ($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/board/dept/dept-dialog.html',
                    controller: 'BoardDeptDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'md',
                    resolve: {
                        translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                            $translatePartialLoader.addPart('dept');
                            $translatePartialLoader.addPart('booking');
                            $translatePartialLoader.addPart('enumPaymentCategory');
                            return $translate.refresh();
                        }],
                        entity: ['Dept', function (Dept) {
                            return Dept.get({id: $stateParams.deptId}).$promise;
                        }],
                        entityProfile: null,
                        entityProject: null,
                        entityDinghyEvent: null
                    }
                }).result.then(function () {
                    $state.go('board.payment', null, {reload: 'board.payment'});
                }, function () {
                    $state.go('^');
                });
            }]
        });
    }

})();

/*
 * Copyright (c) 2017 by Julian Feder, julian.feder@yahoo.de
 *
 * This product includes software developed at
 * The Apache Software Foundation (http://www.apache.org/).
 */

(function() {
    'use strict';
    angular
        .module('askApp')
        .factory('BoardPayment', BoardPayment);

    BoardPayment.$inject = ['$resource', 'DateUtils'];

    function BoardPayment ($resource, DateUtils) {
        var resourceUrl =  'api/board/payments/:id';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true},
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                        data.date = DateUtils.convertLocalDateFromServer(data.date);
                    }
                    if (data.project) {
                        data.project.fromDate = DateUtils.convertLocalDateFromServer(data.project.fromDate);
                        data.project.untilDate = DateUtils.convertLocalDateFromServer(data.project.untilDate);
                    }
                    if (data.dinghyEvent) {
                        data.dinghyEvent.fromDate = DateUtils.convertDateTimeFromServer(data.dinghyEvent.fromDate);
                        data.dinghyEvent.untilDate = DateUtils.convertDateTimeFromServer(data.dinghyEvent.untilDate);
                    }
                    return data;
                }
            },
            'update': {
                method: 'PUT',
                transformRequest: function (data) {
                    var copy = angular.copy(data);
                    copy.date = DateUtils.convertLocalDateToServer(copy.date);
                    if (copy.project) {
                        copy.project.fromDate = DateUtils.convertLocalDateToServer(copy.project.fromDate);
                        copy.project.untilDate = DateUtils.convertLocalDateToServer(copy.project.untilDate);
                    }
                    return angular.toJson(copy);
                }
            },
            'save': {
                method: 'POST',
                transformRequest: function (data) {
                    var copy = angular.copy(data);
                    copy.date = DateUtils.convertLocalDateToServer(copy.date);
                    if (copy.project) {
                        copy.project.fromDate = DateUtils.convertLocalDateToServer(copy.project.fromDate);
                        copy.project.untilDate = DateUtils.convertLocalDateToServer(copy.project.untilDate);
                    }
                    return angular.toJson(copy);
                }
            }
        });
    }
})();

/*
 * Copyright (c) 2017 by Julian Feder, julian.feder@yahoo.de
 *
 * This product includes software developed at
 * The Apache Software Foundation (http://www.apache.org/).
 */

(function() {
    'use strict';

    angular
        .module('askApp')
        .factory('PaymentSearch', PaymentSearch);

    PaymentSearch.$inject = ['$resource'];

    function PaymentSearch($resource) {
        var resourceUrl =  'api/_search/payments/:id';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true}
        });
    }
})();

/*
 * Copyright (c) 2017 by Julian Feder, julian.feder@yahoo.de
 *
 * This product includes software developed at
 * The Apache Software Foundation (http://www.apache.org/).
 */

(function() {
    'use strict';

    angular
        .module('askApp')
        .controller('BoardPaymentController', BoardPaymentController);

    BoardPaymentController.$inject = ['$state', 'BoardPayment', 'PaymentSearch', 'ParseLinks', 'AlertService', 'paginationConstants', 'pagingParams'];

    function BoardPaymentController($state, BoardPayment, PaymentSearch, ParseLinks, AlertService, paginationConstants, pagingParams) {

        var vm = this;

        vm.loadPage = loadPage;
        vm.predicate = pagingParams.predicate;
        vm.reverse = pagingParams.ascending;
        vm.transition = transition;
        vm.itemsPerPage = paginationConstants.itemsPerPage;
        vm.clear = clear;
        vm.search = search;
        vm.loadAll = loadAll;
        vm.searchQuery = pagingParams.search;
        vm.currentSearch = pagingParams.search;

        loadAll();

        function loadAll () {
            if (pagingParams.search) {
                PaymentSearch.query({
                    query: pagingParams.search,
                    page: pagingParams.page - 1,
                    size: vm.itemsPerPage,
                    sort: sort()
                }, onSuccess, onError);
            } else {
                BoardPayment.query({
                    page: pagingParams.page - 1,
                    size: vm.itemsPerPage,
                    sort: sort()
                }, onSuccess, onError);
            }
            function sort() {
                var sorting = vm.reverse ? 'asc' : 'desc';
                var result = [vm.predicate + ',' + sorting];
                if (vm.predicate !== 'id') {
                    result.push('id,' + sorting);
                }
                return result;
            }
            function onSuccess(data, headers) {
                vm.links = ParseLinks.parse(headers('link'));
                vm.totalItems = headers('X-Total-Count');
                vm.queryCount = vm.totalItems;
                vm.payments = data;
                vm.page = pagingParams.page;
            }
            function onError(error) {
                AlertService.error(error.data.message);
            }
        }

        function loadPage(page) {
            vm.page = page;
            vm.transition();
        }

        function transition() {
            $state.transitionTo($state.$current, {
                page: vm.page,
                sort: vm.predicate + ',' + (vm.reverse ? 'asc' : 'desc'),
                search: vm.currentSearch
            });
        }

        function search(searchQuery) {
            if (!searchQuery){
                return vm.clear();
            }
            vm.links = null;
            vm.page = 1;
            vm.predicate = 'date';
            vm.reverse = false;
            vm.currentSearch = searchQuery;
            vm.transition();
        }

        function clear() {
            vm.links = null;
            vm.page = 1;
            vm.predicate = 'date';
            vm.reverse = false;
            vm.currentSearch = null;
            vm.transition();
        }
    }
})();

/*
 * Copyright (c) 2017 by Julian Feder, julian.feder@yahoo.de
 *
 * This product includes software developed at
 * The Apache Software Foundation (http://www.apache.org/).
 */

(function() {
    'use strict';

    angular
        .module('askApp')
        .controller('BoardMembershipFeeDialogController', BoardMembershipFeeDialogController);

    BoardMembershipFeeDialogController.$inject = ['$timeout', '$scope', 'DateUtils', '$uibModalInstance', 'entity', '$http', 'AlertService'];

    function BoardMembershipFeeDialogController ($timeout, $scope, DateUtils, $uibModalInstance, entity, $http, AlertService) {
        var vm = this;

        vm.membershipFee = entity;
        vm.clear = clear;
        vm.datePickerOpenStatus = {};
        vm.openCalendar = openCalendar;
        vm.save = save;

        $timeout(function (){
            angular.element('.form-group:eq(1)>input').focus();
        });

        $scope.dateOptions = {
            formatYear: 'yyyy',
            startingDay: 1,
            minMode: 'year'
        };

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function save () {
            vm.isSaving = true;
            $http.get('api/membership-fees/create/', {
                params: {
                    year: DateUtils.convertLocalDateToServer(vm.membershipFee.year)
                }
            }).then(function(response){
                AlertService.success("Es wurden " + response.headers('totalAdded') + " Mitgliedsbeiträge eingezogen.");
                $uibModalInstance.close(response);
                vm.isSaving = false;
            }).catch(function(){
                vm.isSaving = false;
            });
        }
        vm.datePickerOpenStatus.year = false;

        function openCalendar (date) {
            vm.datePickerOpenStatus[date] = true;
        }
    }
})();

/*
 * Copyright (c) 2017 by Julian Feder, julian.feder@yahoo.de
 *
 * This product includes software developed at
 * The Apache Software Foundation (http://www.apache.org/).
 */

(function() {
    'use strict';

    angular
        .module('askApp')
        .controller('BoardMembershipFeeDeleteController',BoardMembershipFeeDeleteController);

    BoardMembershipFeeDeleteController.$inject = ['$uibModalInstance', 'entity', 'MembershipFee'];

    function BoardMembershipFeeDeleteController($uibModalInstance, entity, MembershipFee) {
        var vm = this;

        vm.membershipFee = entity;
        vm.clear = clear;
        vm.confirmDelete = confirmDelete;

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function confirmDelete (id) {
            MembershipFee.delete({id: id},
                function () {
                    $uibModalInstance.close(true);
                });
        }
    }
})();

/*
 * Copyright (c) 2017 by Julian Feder, julian.feder@yahoo.de
 *
 * This product includes software developed at
 * The Apache Software Foundation (http://www.apache.org/).
 */

(function() {
    'use strict';

    angular
        .module('askApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
        .state('board.membership-fee', {
            parent: 'board',
            url: '/board/{select}/membership-fee?page&sort&search',
            data: {
                authorities: ['ROLE_BOARD'],
                pageTitle: 'askApp.membershipFee.home.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/board/membership-fee/membership-fees.html',
                    controller: 'BoardMembershipFeeController',
                    controllerAs: 'vm'
                }
            },
            params: {
                page: {
                    value: '1',
                    squash: true
                },
                sort: {
                    value: 'year,desc',
                    squash: true
                },
                search: null
            },
            resolve: {
                pagingParams: ['$stateParams', 'PaginationUtil', function ($stateParams, PaginationUtil) {
                    return {
                        page: PaginationUtil.parsePage($stateParams.page),
                        sort: $stateParams.sort,
                        predicate: PaginationUtil.parsePredicate($stateParams.sort),
                        ascending: PaginationUtil.parseAscending($stateParams.sort),
                        search: $stateParams.search,
                        select: $stateParams.select
                    };
                }],
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('membershipFee');
                    $translatePartialLoader.addPart('enumMembershipFeeType');
                    $translatePartialLoader.addPart('global');
                    $translatePartialLoader.addPart('dept');
                    $translatePartialLoader.addPart('enumDeptStatus');
                    $translatePartialLoader.addPart('member-management');
                    return $translate.refresh();
                }],
                entity: ['$stateParams', 'MemberManagement', function($stateParams, MemberManagement) {
                    if($stateParams.select) {
                        return MemberManagement.get({id : $stateParams.select}).$promise;
                    }
                    return null;
                }]
            }
        })
        .state('board.membership-fee.new', {
            parent: 'board.membership-fee',
            url: '/new',
            data: {
                authorities: ['ROLE_BOARD']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/board/membership-fee/membership-fee-dialog.html',
                    controller: 'BoardMembershipFeeDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'md',
                    resolve: {
                        entity: function () {
                            return {
                                year: null,
                                price: null,
                                type: null,
                                id: null
                            };
                        }
                    }
                }).result.then(function() {
                    $state.go('board.membership-fee', null, { reload: 'board.membership-fee' });
                }, function() {
                    $state.go('board.membership-fee');
                });
            }]
        })
        .state('board.membership-fee.delete', {
            parent: 'board.membership-fee',
            url: '/{id}/delete',
            data: {
                authorities: ['ROLE_BOARD']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/board/membership-fee/membership-fee-delete-dialog.html',
                    controller: 'BoardMembershipFeeDeleteController',
                    controllerAs: 'vm',
                    size: 'md',
                    resolve: {
                        entity: ['MembershipFee', function(MembershipFee) {
                            return MembershipFee.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('board.membership-fee', null, { reload: 'board.membership-fee' });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('board.membership-fee.dept-edit', {
            parent: 'board.membership-fee',
            url: '/dept/{deptId}/edit',
            data: {
                authorities: ['ROLE_FINANCE']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/board/dept/dept-dialog.html',
                    controller: 'BoardDeptDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'md',
                    resolve: {
                        translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                            $translatePartialLoader.addPart('payment');
                            $translatePartialLoader.addPart('booking');
                            $translatePartialLoader.addPart('enumPaymentCategory');
                            return $translate.refresh();
                        }],
                        entity: ['Dept', function(Dept) {
                            return Dept.get({id : $stateParams.deptId}).$promise;
                        }],
                        entityProfile: null,
                        entityProject: null,
                        entityDinghyEvent: null
                    }
                }).result.then(function() {
                    $state.go('board.membership-fee', null, { reload: 'board.membership-fee' });
                }, function() {
                    $state.go('^');
                });
            }]
        });
    }

})();

(function() {
    'use strict';
    angular
        .module('askApp')
        .factory('MembershipFee', MembershipFee);

    MembershipFee.$inject = ['$resource', 'DateUtils'];

    function MembershipFee ($resource, DateUtils) {
        var resourceUrl =  'api/membership-fees/:id';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true},
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                        data.year = DateUtils.convertLocalDateFromServer(data.year);
                    }
                    return data;
                }
            },
            'update': {
                method: 'PUT',
                transformRequest: function (data) {
                    var copy = angular.copy(data);
                    copy.year = DateUtils.convertLocalDateToServer(copy.year);
                    return angular.toJson(copy);
                }
            },
            'save': {
                method: 'POST',
                transformRequest: function (data) {
                    var copy = angular.copy(data);
                    copy.year = DateUtils.convertLocalDateToServer(copy.year);
                    return angular.toJson(copy);
                }
            }
        });
    }
})();

(function() {
    'use strict';

    angular
        .module('askApp')
        .factory('MembershipFeeSearch', MembershipFeeSearch);

    MembershipFeeSearch.$inject = ['$resource'];

    function MembershipFeeSearch($resource) {
        var resourceUrl =  'api/_search/membership-fees/:id';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true}
        });
    }
})();

/*
 * Copyright (c) 2017 by Julian Feder, julian.feder@yahoo.de
 *
 * This product includes software developed at
 * The Apache Software Foundation (http://www.apache.org/).
 */

(function() {
    'use strict';

    angular
        .module('askApp')
        .controller('BoardMembershipFeeController', BoardMembershipFeeController);

    BoardMembershipFeeController.$inject = ['$state', 'MembershipFee', 'MembershipFeeSearch', 'ParseLinks', 'AlertService', 'paginationConstants', 'pagingParams', '$http', 'entity', '$stateParams'];

    function BoardMembershipFeeController($state, MembershipFee, MembershipFeeSearch, ParseLinks, AlertService, paginationConstants, pagingParams, $http, entity, $stateParams) {

        var vm = this;

        vm.loadPage = loadPage;
        vm.predicate = pagingParams.predicate;
        vm.reverse = pagingParams.ascending;
        vm.transition = transition;
        vm.itemsPerPage = paginationConstants.itemsPerPage;
        vm.clear = clear;
        vm.search = search;
        vm.loadAll = loadAll;
        vm.getUser = getUser;
        vm.searchQuery = pagingParams.search;
        vm.currentSearch = pagingParams.search;
        vm.select = pagingParams.select;
        vm.selected = null;
        vm.selectUser = selectUser;

        loadAll();

        function loadAll () {
            if(entity != null) {
                vm.selected = entity.user.firstName + " " + entity.user.lastName + (entity.nickname ? (' "' + entity.nickname + '"') : (''));
            }
            if (pagingParams.search) {
                MembershipFeeSearch.query({
                    query: pagingParams.search,
                    page: pagingParams.page - 1,
                    size: vm.itemsPerPage,
                    sort: sort()
                }, onSuccess, onError);
            } else {
                MembershipFee.query({
                    page: pagingParams.page - 1,
                    size: vm.itemsPerPage,
                    sort: sort(),
                    profileID: $stateParams.select
                }, onSuccess, onError);
            }
            function sort() {
                var sorting = vm.reverse ? 'asc' : 'desc';
                var result = [vm.predicate + ',' + sorting];
                if (vm.predicate === 'dept.paymentStatus') {
                    result.push('dept.sepa');
                }
                if (vm.predicate !== 'id') {
                    result.push('id,' + sorting);
                }
                return result;
            }
            function onSuccess(data, headers) {
                vm.links = ParseLinks.parse(headers('link'));
                vm.totalItems = headers('X-Total-Count');
                vm.queryCount = vm.totalItems;
                vm.membershipFees = data;
                vm.page = pagingParams.page;
            }
            function onError(error) {
                AlertService.error(error.data.message);
            }
        }

        function loadPage(page) {
            vm.page = page;
            vm.transition();
        }

        function transition() {
            $state.transitionTo($state.$current, {
                page: vm.page,
                sort: vm.predicate + ',' + (vm.reverse ? 'asc' : 'desc'),
                search: vm.currentSearch,
                select: vm.select
            });
        }

        function search(searchQuery) {
            if (!searchQuery){
                return vm.clear();
            }
            vm.links = null;
            vm.page = 1;
            vm.predicate = '_score';
            vm.reverse = false;
            vm.currentSearch = searchQuery;
            vm.select = null;
            vm.transition();
        }

        function clear() {
            vm.links = null;
            vm.page = 1;
            vm.predicate = 'year';
            vm.reverse = false;
            vm.currentSearch = null;
            vm.select = null;
            vm.transition();
        }

        function getUser(val) {
            return $http.get('api/_search/profiles/', {
                params: {
                    query: val
                }
            }).then(function(response){
                return response.data.map(function(item) {
                    return item;
                });
            });
        }

        function selectUser(item, model) {
            vm.select = model.id;
            vm.transition();
        }
    }
})();

/*
 * Copyright (c) 2017 by Julian Feder, julian.feder@yahoo.de
 *
 * This product includes software developed at
 * The Apache Software Foundation (http://www.apache.org/).
 */

(function() {
    'use strict';

    angular
        .module('askApp')
        .controller('MemberManagementDialogSendMailController', MemberManagementDialogSendMailController);

    MemberManagementDialogSendMailController.$inject = ['$uibModalInstance', 'AlertService', '$http'];

    function MemberManagementDialogSendMailController ($uibModalInstance, AlertService, $http) {

        var vm = this;
        vm.clear = clear;
        vm.action = action;
        vm.sendMail = {startId: 0};

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        vm.options = {
            toolbar: [
                ['style', ['bold', 'italic', 'underline', 'clear']],
                ['textsize', ['fontsize']],
                ['fontclr', ['color']],
                ['alignment', ['ul', 'ol']],
                ['view', ['codeview']]
            ]
        };

        function action(action) {
            vm.sendMail.action = action;
            vm.isSaving = true;
            $http.post('api/board/profiles/mail/', vm.sendMail).then(function(response) {
                vm.isSaving = false;
                if(action !== "test") {
                    $uibModalInstance.dismiss('cancel');
                }
            });
        }
    }
})();

/*
 * Copyright (c) 2017 by Julian Feder, julian.feder@yahoo.de
 *
 * This product includes software developed at
 * The Apache Software Foundation (http://www.apache.org/).
 */

(function() {
    'use strict';

    angular
        .module('askApp')
        .controller('MemberManagementDialogEditMemberStatusController', MemberManagementDialogEditMemberStatusController);

    MemberManagementDialogEditMemberStatusController.$inject = ['$uibModalInstance', 'profile', 'MemberManagement', 'AlertService'];

    function MemberManagementDialogEditMemberStatusController ($uibModalInstance, profile, MemberManagement, AlertService) {
        var vm = this;

        vm.member = profile;
        vm.clear = clear;
        vm.setMember = setMember;

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function setMember(memberStatus) {
            vm.isSaving = true;
            var copy = angular.copy(profile);
            copy.memberStatus = memberStatus;
            MemberManagement.update(copy,
                function () {
                    AlertService.success("Mitglied " + profile.user.login + " wurde erfolgreich aktualisiert.");
                    $uibModalInstance.close();
                    vm.isSaving = false;
                },
                function (error) {
                    if (error.status === 400 && error.data === 'mail already in use') {
                        AlertService.error("E-Mail ist bereits registriert. Mitglied " + profile.user.login + " kann nicht reaktiviert werden.");
                    }

                    if (error.status === 400 && error.data === 'offene_forderungen') {
                        AlertService.error("Es gibt offene Forderungen. Status kann nicht geändert werden.");
                    }

                    vm.isSaving = false;
                }
            );
        }
    }
})();

/*
 * Copyright (c) 2017 by Julian Feder, julian.feder@yahoo.de
 *
 * This product includes software developed at
 * The Apache Software Foundation (http://www.apache.org/).
 */

(function() {
    'use strict';

    angular
        .module('askApp')
        .controller('MemberManagementDialogController', MemberManagementDialogController);

    MemberManagementDialogController.$inject = ['$timeout', '$scope', '$stateParams', '$uibModalInstance', 'AlertService', 'DataUtils', 'entity', 'MemberManagement', 'User'];

    function MemberManagementDialogController ($timeout, $scope, $stateParams, $uibModalInstance, AlertService, DataUtils, entity, MemberManagement, User) {
        var vm = this;

        vm.member = entity;
        vm.clear = clear;
        vm.datePickerOpenStatus = {};
        vm.openCalendar = openCalendar;
        vm.byteSize = DataUtils.byteSize;
        vm.openFile = DataUtils.openFile;
        vm.save = save;
        vm.users = User.query();

        $timeout(function (){
            angular.element('.form-group:eq(0)>input').focus();
        });

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function save () {
            vm.isSaving = true;
            MemberManagement.update(vm.member, onSaveSuccess, onSaveError);
        }

        function onSaveSuccess (result) {
            //$scope.$emit('askApp:profileUpdate', MemberManagement.get({id : vm.member.id}));
            AlertService.success("Mitglied " + vm.member.user.login + " wurde erfolgreich aktualisiert.");
            $uibModalInstance.close(result);
            vm.isSaving = false;
        }

        function onSaveError () {
            vm.isSaving = false;
        }

        vm.datePickerOpenStatus.birthdate = false;

        vm.setMatriculationCertificate = function ($file, profile) {
            if ($file) {
                DataUtils.toBase64($file, function(base64Data) {
                    $scope.$apply(function() {
                        profile.matriculationCertificate = base64Data;
                        profile.matriculationCertificateContentType = $file.type;
                    });
                });
            }
        };

        function openCalendar (date) {
            vm.datePickerOpenStatus[date] = true;
        }
    }
})();

/*
 * Copyright (c) 2017 by Julian Feder, julian.feder@yahoo.de
 *
 * This product includes software developed at
 * The Apache Software Foundation (http://www.apache.org/).
 */

(function() {
    'use strict';

    angular
        .module('askApp')
        .controller('MemberManagementDetailController', MemberManagementDetailController);

    MemberManagementDetailController.$inject = ['ActivitiesBoard', '$scope', '$rootScope', 'Principal', 'previousState', 'DataUtils', 'entity', '$state', 'MemberManagement', '$http'];

    function MemberManagementDetailController(ActivitiesBoard, $scope, $rootScope, Principal, previousState, DataUtils, entity, $state, MemberManagement, $http) {
        var vm = this;

        vm.member = entity;
        vm.byteSize = DataUtils.byteSize;
        vm.openFile = DataUtils.openFile;
        vm.goBack = goBack;
        vm.setVerified = setVerified;
        vm.exportContact = exportContact;
        vm.university = !!vm.member.university;
        vm.save = save;

        function save() {
            vm.isSaving = true;
            var projectNotesDTO = {
                id: vm.member.id,
                notes: vm.member.commentBoard
            };
            $http.post('/api/board/profiles/comment-board', projectNotesDTO).then(onSaveSuccess, onSaveError);
        }

        function onSaveSuccess (result) {
            vm.isSaving = false;
        }

        function onSaveError () {
            vm.isSaving = false;
        }

        function goBack() {
            $state.go(previousState.name, previousState.params)
        }

        Principal.identity().then(function(account) {
            vm.currentAccount = account;
        });

        function setVerified () {
            vm.isVerifying = true;
            var member = angular.copy(vm.member);
            member.isVerified = true;
            MemberManagement.update(member, function () {
                $state.go('member-management-detail', null, { reload: 'member-management-detail' });
                vm.isVerifying = false;
            }, function () {
                vm.isVerifying = false;
            });
        }

        function exportContact() {
            vm.isExporting = true;
            $http.get('api/board/profiles/export/', {
                params: {
                    id: entity.id
                }
            }).then(function (response) {
                vm.isExporting = false;
                AlertService.success("Der Export wurde erfolgreich durchgeführt und an deine E-Mail Adresse geschickt.");
            });
        }

        vm.options = {
            toolbar: [
                ['style', ['bold', 'italic', 'underline', 'clear']],
                ['textsize', ['fontsize']],
                ['fontclr', ['color']],
                ['alignment', ['ul', 'ol']],
                ['view', ['codeview']]
            ]
        };

        /*
        var unsubscribe = $rootScope.$on('askApp:profileUpdate', function(event, result) {

            vm.member = result;
        });
        $scope.$on('$destroy', unsubscribe);*/
    }
})();

/*
 * Copyright (c) 2017 by Julian Feder, julian.feder@yahoo.de
 *
 * This product includes software developed at
 * The Apache Software Foundation (http://www.apache.org/).
 */

(function() {
    'use strict';

    angular
        .module('askApp')
        .controller('MemberManagementDeleteController', MemberManagementDeleteController);

    MemberManagementDeleteController.$inject = ['$uibModalInstance', 'entity', 'MemberManagement'];

    function MemberManagementDeleteController($uibModalInstance, entity, MemberManagement) {
        var vm = this;

        vm.profile = entity;
        vm.clear = clear;
        vm.confirmDelete = confirmDelete;

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function confirmDelete (id) {
            MemberManagement.delete({id: id},
                function () {
                    $uibModalInstance.close(true);
                });
        }
    }
})();

/*
 * Copyright (c) 2018 by Felix Heim, felix-heim@web.de
 *
 * This product includes software developed at
 * The Apache Software Foundation (http://www.apache.org/).
 */

(function() {
    'use strict';

    angular
        .module('askApp')
        .controller('MemberManagementDeleteCertificateController', MemberManagementDeleteCertificateController);

    MemberManagementDeleteCertificateController.$inject = ['$uibModalInstance', 'entity', 'MemberManagement'];

    function MemberManagementDeleteCertificateController($uibModalInstance, entity, MemberManagement) {
        var vm = this;

        vm.profile = entity;
        vm.clear = clear;
        vm.confirmDelete = confirmDelete;

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function confirmDelete () {
            vm.profile.matriculationCertificateContentType = null;
            MemberManagement.update(vm.profile,
                function () {
                    $uibModalInstance.close(true);
                });
        }
    }
})();

/*
 * Copyright (c) 2017 by Julian Feder, julian.feder@yahoo.de
 *
 * This product includes software developed at
 * The Apache Software Foundation (http://www.apache.org/).
 */

(function() {
    'use strict';

    angular
        .module('askApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
        .state('member-management', {
            parent: 'board',
            url: '/board/members?page&sort&search&select',
            data: {
                authorities: ['ROLE_BOARD'],
                pageTitle: 'askApp.memberManagement.home.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/board/member-management/member-management.html',
                    controller: 'MemberManagementController',
                    controllerAs: 'vm'
                }
            },
            params: {
                page: {
                    value: '1',
                    squash: true
                },
                sort: {
                    value: 'user.createdDate,desc',
                    squash: true
                },
                select: {
                    value: 'voll',
                    squash: true
                }
            },
            resolve: {
                pagingParams: ['$stateParams', 'PaginationUtil', function ($stateParams, PaginationUtil) {
                    return {
                        page: PaginationUtil.parsePage($stateParams.page),
                        sort: $stateParams.sort,
                        predicate: PaginationUtil.parsePredicate($stateParams.sort),
                        ascending: PaginationUtil.parseAscending($stateParams.sort),
                        search: $stateParams.search,
                        select: $stateParams.select
                    };
                }],
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('member-management');
                    $translatePartialLoader.addPart('enumMemberStatus');
                    $translatePartialLoader.addPart('global');
                    return $translate.refresh();
                }]
            }
        })
        .state('member-management-detail', {
            parent: 'member-management',
            url: '/member/{id}',
            data: {
                authorities: ['ROLE_BOARD'],
                pageTitle: 'askApp.memberManagement.detail.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/board/member-management/member-management-detail.html',
                    controller: 'MemberManagementDetailController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('profile');
                    $translatePartialLoader.addPart('enumCountry');
                    $translatePartialLoader.addPart('enumClothingSize');
                    $translatePartialLoader.addPart('enumGender');
                    $translatePartialLoader.addPart('enumMemberStatus');
                    $translatePartialLoader.addPart('activities');
                    $translatePartialLoader.addPart('enumCategoryActivity');
                    $translatePartialLoader.addPart('enumIDType');
                    $translatePartialLoader.addPart('settings');
                    return $translate.refresh();
                }],
                entity: ['$stateParams', 'MemberManagement', function($stateParams, MemberManagement) {
                    return MemberManagement.get({id : $stateParams.id}).$promise;
                }],
                previousState: ["$state", function ($state) {
                    var currentStateData = {
                        name: $state.current.name || 'member-management',
                        params: $state.params,
                        url: $state.href($state.current.name, $state.params)
                    };
                    return currentStateData;
                }]
            }
        })
        .state('member-management-detail.edit', {
            parent: 'member-management-detail',
            url: '/edit',
            data: {
                authorities: ['ROLE_BOARD']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/board/member-management/member-management-dialog.html',
                    controller: 'MemberManagementDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'md',
                    resolve: {
                        entity: ['MemberManagement', function(MemberManagement) {
                            return MemberManagement.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('^', {}, { reload: true });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('member-management.edit', {
            parent: 'member-management',
            url: '/board/member/{id}/edit',
            data: {
                authorities: ['ROLE_BOARD']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/board/member-management/member-management-edit-member-status.html',
                    controller: 'MemberManagementDialogEditMemberStatusController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'md',
                    resolve: {
                        profile: ['MemberManagement', function(MemberManagement) {
                            return MemberManagement.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('member-management', null, { reload: 'member-management' });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('member-management.mail', {
            parent: 'member-management',
            url: '/mail',
            data: {
                authorities: ['ROLE_BOARD']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/board/member-management/member-management-send-mail.html',
                    controller: 'MemberManagementDialogSendMailController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg'
                }).result.then(function() {
                    $state.go('member-management', null, { reload: 'member-management' });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('member-management.delete', {
            parent: 'member-management-detail',
            url: '/delete',
            data: {
                authorities: ['ROLE_BOARD']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/board/member-management/member-management-delete-dialog.html',
                    controller: 'MemberManagementDeleteController',
                    controllerAs: 'vm',
                    size: 'md',
                    resolve: {
                        entity: ['MemberManagement', function(MemberManagement) {
                            return MemberManagement.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('member-management', null, { reload: 'member-management' });
                }, function() {
                    $state.go('^');
                });
            }]
        }).state('member-management-detail.delete-certificate', {
            parent: 'member-management-detail',
            url: '/certificate/delete',
            data: {
                authorities: ['ROLE_BOARD']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/board/member-management/member-management-delete-certificate-dialog.html',
                    controller: 'MemberManagementDeleteCertificateController',
                    controllerAs: 'vm',
                    size: 'md',
                    resolve: {
                        entity: ['MemberManagement', function(MemberManagement) {
                            return MemberManagement.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('member-management-detail', null, { reload: 'member-management-detail' });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('member-management-detail.new-dept', {
            parent: 'member-management-detail',
            url: '/dept/new',
            data: {
                authorities: ['ROLE_FINANCE']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', 'entity', function($stateParams, $state, $uibModal, entity) {
                $uibModal.open({
                    templateUrl: 'app/board/dept/dept-dialog.html',
                    controller: 'BoardDeptDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'md',
                    resolve: {
                        translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                            $translatePartialLoader.addPart('booking');
                            $translatePartialLoader.addPart('dept');
                            $translatePartialLoader.addPart('payment');
                            $translatePartialLoader.addPart('enumPaymentCategory');
                            return $translate.refresh();
                        }],
                        entity: function () {
                            return {
                                date: new Date(),
                                reference: null,
                                pointValue: 0,
                                amount: null,
                                comment: null,
                                category: "",
                                sepa: null,
                                paymentStatus: null,
                                id: null
                            };
                        },
                        entityProfile: entity,
                        entityProject: null,
                        entityDinghyEvent: null
                    }
                }).result.then(function() {
                    $state.go('board.dept', {select: $stateParams.id});
                }, function() {
                    $state.go('^');
                });
            }]
        });
    }

})();

/*
 * Copyright (c) 2017 by Julian Feder, julian.feder@yahoo.de
 *
 * This product includes software developed at
 * The Apache Software Foundation (http://www.apache.org/).
 */

(function() {
    'use strict';
    angular
        .module('askApp')
        .factory('MemberManagement', MemberManagement);

    MemberManagement.$inject = ['$resource', 'DateUtils'];

    function MemberManagement ($resource, DateUtils) {
        var resourceUrl =  'api/board/profiles/:id';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true},
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                        data.birthdate = DateUtils.convertLocalDateFromServer(data.birthdate);
                    }
                    return data;
                }
            },
            'update': {
                method: 'PUT',
                transformRequest: function (data) {
                    var copy = angular.copy(data);
                    copy.birthdate = DateUtils.convertLocalDateToServer(copy.birthdate);
                    return angular.toJson(copy);
                }
            },
            'save': {
                method: 'POST',
                transformRequest: function (data) {
                    var copy = angular.copy(data);
                    copy.birthdate = DateUtils.convertLocalDateToServer(copy.birthdate);
                    return angular.toJson(copy);
                }
            }
        });
    }
})();

/*
 * Copyright (c) 2017 by Julian Feder, julian.feder@yahoo.de
 *
 * This product includes software developed at
 * The Apache Software Foundation (http://www.apache.org/).
 */

(function() {
    'use strict';

    angular
        .module('askApp')
        .factory('MemberManagementSearch', MemberManagementSearch);

    MemberManagementSearch.$inject = ['$resource'];

    function MemberManagementSearch($resource) {
        var resourceUrl =  'api/_search/profiles_guest/:id';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true}
        });
    }
})();

/*
 * Copyright (c) 2017 by Julian Feder, julian.feder@yahoo.de
 *
 * This product includes software developed at
 * The Apache Software Foundation (http://www.apache.org/).
 */

(function() {
    'use strict';

    angular
        .module('askApp')
        .controller('MemberManagementController', MemberManagementController);

    MemberManagementController.$inject = ['DataUtils', 'MemberManagement', 'MemberManagementSearch', 'Principal', 'paginationConstants', 'pagingParams', 'ParseLinks', 'AlertService', '$state'];

    function MemberManagementController(DataUtils, MemberManagement, MemberManagementSearch, Principal, paginationConstants, pagingParams, ParseLinks, AlertService, $state) {

        var vm = this;

        vm.members = [];
        vm.openFile = DataUtils.openFile;
        vm.byteSize = DataUtils.byteSize;
        vm.currentAccount = null;
        vm.totalItems = null;
        vm.itemsPerPage = paginationConstants.itemsPerPage;
        vm.predicate = pagingParams.predicate;
        vm.reverse = pagingParams.ascending;
        vm.currentSearch = null;
        vm.clear = clear;
        vm.search = search;
        vm.loadAll = loadAll;
        vm.setVerified = setVerified;
        vm.loadPage = loadPage;
        vm.transition = transition;
        vm.setSelect = setSelect;
        vm.setActive = setActive;
        vm.searchQuery = pagingParams.search;
        vm.currentSearch = pagingParams.search;
        vm.select = pagingParams.select;

        if (vm.currentSearch == null) {
            vm.selectIsMember = vm.select === 'voll' || vm.select === 'probe' || vm.select === 'gast';
        } else {
            vm.selectIsMember = !vm.currentSearch.toLowerCase().startsWith("aus_");
        }

        loadAll();

        function setSelect(select) {
            vm.select = select;
            vm.transition();
        }

        function setActive (profile, activated) {
            profile.user.activated = activated;
            MemberManagement.update(profile, function () {
                loadAll();
                AlertService.success("Mitglied " + profile.user.login + " wurde erfolgreich aktualisiert.");
            });
        }

        function setVerified (profile, isVerified) {
            profile.isVerified = isVerified;
            MemberManagement.update(profile, function () {
                loadAll();
                AlertService.success("Mitglied " + profile.user.login + " wurde erfolgreich aktualisiert.");
            });
        }

        function loadAll () {
            if (pagingParams.search) {
                MemberManagementSearch.query({
                    query: pagingParams.search,
                    page: pagingParams.page - 1,
                    size: vm.itemsPerPage,
                    sort: sort()
                }, onSuccess, onError);
            } else {
                MemberManagement.query({
                    page: pagingParams.page - 1,
                    size: vm.itemsPerPage,
                    sort: sort(),
                    select: pagingParams.select
                }, onSuccess, onError);
            }
            function sort() {
                var sorting = vm.reverse ? 'asc' : 'desc';
                var result = [vm.predicate + ',' + sorting];
                if (vm.predicate !== 'id') {
                    result.push('id,' + sorting);
                }
                return result;
            }
            function onSuccess(data, headers) {
                vm.links = ParseLinks.parse(headers('link'));
                vm.totalItems = headers('X-Total-Count');
                vm.queryCount = vm.totalItems;
                vm.members = data;
                vm.page = pagingParams.page;
            }
            function onError(error) {
                AlertService.error(error.data.message);
            }
        }

        function loadPage(page) {
            vm.page = page;
            vm.transition();
        }

        function transition() {
            $state.transitionTo($state.$current, {
                page: vm.page,
                sort: vm.predicate + ',' + (vm.reverse ? 'asc' : 'desc'),
                search: vm.currentSearch,
                select: vm.select
            });
        }

        function search(searchQuery) {
            if (!searchQuery){
                return vm.clear();
            }
            vm.links = null;
            vm.page = 1;
            vm.predicate = '_score';
            vm.reverse = false;
            vm.currentSearch = searchQuery;
            vm.transition();
        }

        function clear() {
            vm.links = null;
            vm.page = 1;
            vm.predicate = 'user.id';
            vm.reverse = false;
            vm.currentSearch = null;
            vm.transition();
        }

        Principal.identity().then(function(account) {
            vm.currentAccount = account;
        });
    }
})();

/*
 * Copyright (c) 2021 by Felix Heim, felix-heim@web.de
 *
 * This product includes software developed at
 * The Apache Software Foundation (http://www.apache.org/).
 */

(function() {
    'use strict';

    angular
        .module('askApp')
        .controller('MemberExitDialogController', MemberExitDialogController);

    MemberExitDialogController.$inject = ['$scope', '$uibModalInstance', '$stateParams', '$http', 'DateUtils'];

    function MemberExitDialogController($scope, $uibModalInstance, $stateParams, $http, DateUtils) {
        var vm = this;

        vm.mode = $stateParams.mode;
        vm.membersArray = $stateParams.members;
        vm.members = [];
        vm.exitDate = new Date();
        vm.clear = clear;
        vm.processExits = processExits;
        vm.datePickerOpenStatus = {};
        vm.openCalendar = openCalendar;

        $scope.options = {
            initDate: new Date()
        };

        loadAll();

        function loadAll() {
            $http.get('api/board/profiles/exit/process', {
                params: {
                    mode: vm.mode,
                    members: vm.membersArray
                }
            }).then(function(response) {
                vm.members = response.data;
            });
        }

        function clear() {
            $uibModalInstance.dismiss('cancel');
        }

        function processExits() {
            vm.isSaving = true;
            $http.put('api/board/profiles/exit/process', {}, {
                params: {
                    mode: vm.mode,
                    members: vm.membersArray,
                    exitDate: DateUtils.convertLocalDateToServer(vm.exitDate)
                }
            }).then(onSuccess, onError);
        }

        function onSuccess(result) {
            vm.isSaving = false;
            $uibModalInstance.close(result);
        }

        function onError () {
            vm.isSaving = false;
        }


        function openCalendar (date) {
            vm.datePickerOpenStatus[date] = true;
        }
    }
})();

/*
 * Copyright (c) 2021 by Felix Heim, felix-heim@web.de
 *
 * This product includes software developed at
 * The Apache Software Foundation (http://www.apache.org/).
 */

(function() {
    'use strict';

    angular
        .module('askApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
        .state('member-management.exit', {
            parent: 'member-management',
            url: '/exit?mode',
            data: {
                authorities: ['ROLE_BOARD'],
                pageTitle: 'askApp.memberManagement.exit.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/board/member-management/member-exit.html',
                    controller: 'MemberExitController',
                    controllerAs: 'vm'
                }
            },
            params: {
                mode: {
                    value: '',
                    squash: false
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('member-management');
                    return $translate.refresh();
                }]
            }
        })
        .state('member-management.exit.process', {
            parent: 'member-management.exit',
            url: '/process?members',
            data: {
                authorities: ['ROLE_BOARD']
            },
            params: {
                members: {
                    value: '',
                    squash: false
                }
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/board/member-management/member-exit-dialog.html',
                    controller: 'MemberExitDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg'
                }).result.then(function() {
                    $state.go('^', {}, { reload: true });
                }, function() {
                    $state.go('^');
                });
            }]
        });
    }

})();

/*
 * Copyright (c) 2021 by Felix Heim, felix-heim@web.de
 *
 * This product includes software developed at
 * The Apache Software Foundation (http://www.apache.org/).
 */

(function() {
    'use strict';

    angular
        .module('askApp')
        .controller('MemberExitController', MemberExitController);

    MemberExitController.$inject = ['$scope', '$state', '$stateParams', '$http'];

    function MemberExitController($scope, $state, $stateParams, $http) {
        var vm = this;

        vm.guestExitYear = new Date().getFullYear() - 3;
        vm.mode = $stateParams.mode;
        vm.members = [];
        vm.membersValid = 0;
        vm.membersInvalid = 0;
        vm.membersSelectedCount = 0;
        vm.processCurrentSelection = processCurrentSelection;
        vm.canProcess = canProcess;
        vm.updateProcessCount = updateProcessCount;

        loadAll();

        function loadAll() {
            $http.get('api/board/profiles/exit', {
                params: {
                    mode: vm.mode
                }
            }).then(function(response) {
                vm.members = response.data;
                for(var index = 0; index < vm.members.length; index++) {
                    vm.members[index].processMember = vm.members[index].criteria.summary;
                    if (vm.members[index].processMember) {
                        vm.membersSelectedCount++;
                    }
                }
                vm.membersValid = vm.membersSelectedCount;
                vm.membersInvalid = vm.members.length -  vm.membersValid;
            });
        }

        function processCurrentSelection() {
            var members = [];
            for(var index = 0; index < vm.members.length; index++) {
                if (vm.members[index].processMember) {
                    members.push(vm.members[index].id);
                }
            }
            $state.transitionTo('member-management.exit.process', {
                mode: vm.mode,
                members: members.join(",")
            });
        }

        function canProcess() {
            return vm.membersSelectedCount > 0;
        }

        function updateProcessCount(value) {
            if (value) {
                vm.membersSelectedCount++;
            } else {
                vm.membersSelectedCount--;
            }
        }
    }
})();

/*
 * Copyright (c) 2020 by Felix Heim, felix-heim@web.de
 *
 * This product includes software developed at
 * The Apache Software Foundation (http://www.apache.org/).
 */

(function() {
    'use strict';

    angular
        .module('askApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
        .state('board.dinghy.presence-parent', {
            // use a parent state to cache the dinghies etc.
            parent: 'board.dinghy',
            data: {
                authorities: ['ROLE_BOARD', 'ROLE_DINGHY']
            },
            resolve: {
                currentProfile: ['PrincipalProfile', function(PrincipalProfile) {
                    return PrincipalProfile.identity(false);
                }]
            }
        })
        .state('board.dinghy.presence', {
            parent: 'board.dinghy.presence-parent',
            url: '/presence?fromDate?untilDate',
            data: {
                authorities: ['ROLE_BOARD', 'ROLE_DINGHY'],
                pageTitle: 'askApp.dinghy.detail.title'
            },
            views: {
                'dinghy@board.dinghy': {
                    templateUrl: 'app/board/dinghy/presence/presence.html',
                    controller: 'DinghyPresenceController',
                    controllerAs: 'vm'
                }
            },
            params: {
                fromDate: {
                    value: null,
                    squash: true
                },
                untilDate: {
                    value: null,
                    squash: true
                }
            },
            resolve: {
                pagingParams: ['$stateParams', function ($stateParams) {
                    return {
                        fromDate: $stateParams.fromDate,
                        untilDate: $stateParams.untilDate
                    };
                }],
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('dinghy');
                    $translatePartialLoader.addPart('dinghyEvent');
                    $translatePartialLoader.addPart('enumDinghyEventType');
                    return $translate.refresh();
                }]
            }
        });
    }
})();

/*
 * Copyright (c) 2020 by Felix Heim, felix-heim@web.de
 *
 * This product includes software developed at
 * The Apache Software Foundation (http://www.apache.org/).
 */

(function() {
    'use strict';

    angular
        .module('askApp')
        .controller('DinghyPresenceController', DinghyPresenceController);

    DinghyPresenceController.$inject = ['currentProfile', '$state', '$scope','$sce', 'DinghyBoard', 'ParseLinks', 'AlertService', 'pagingParams', '$http', 'DateUtils', 'Principal'];

    function DinghyPresenceController(currentProfile, $state, $scope, $sce, DinghyBoard, ParseLinks, AlertService, pagingParams, $http, DateUtils, Principal) {
        var vm = this;

        vm.isBoard = false;
        Principal.hasAuthority('ROLE_BOARD').then(function (result) {
            vm.isBoard = result;
        });

        vm.fromDate = pagingParams.fromDate;
        vm.untilDate = pagingParams.untilDate;
        vm.year = new Date().getFullYear();

        vm.currentProfile = currentProfile;

        vm.datePickerOpenStatus = {};
        vm.datePickerOpenStatus.fromDate = false;
        vm.datePickerOpenStatus.untilDate = false;
        vm.openCalendar = openCalendar;
        function openCalendar (date) {
            vm.datePickerOpenStatus[date] = true;
        }

        vm.transition = transition;
        vm.selectDateRange = selectDateRange;
        vm.updateDateSelection = updateDateSelection;
        vm.selectFromDate = selectFromDate;
        vm.loadAll = loadAll;
        vm.reverseOrder = reverseOrder;

        if (vm.fromDate == null && vm.untilDate == null) {
            // default case --> show passed
            vm.fromDate = getNewYear();
            vm.untilDate = getToday();
            vm.reversed = true;
        } else {
            if (vm.fromDate == null) {
                vm.fromDate = getToday();
            } else {
                vm.fromDate = DateUtils.convertLocalDateFromServer(vm.fromDate);
            }
            if (vm.untilDate == null) {
                vm.untilDate = getToday();
            } else {
                vm.untilDate = DateUtils.convertLocalDateFromServer(vm.untilDate);
            }
            var fromDate = angular.copy(vm.fromDate);
            fromDate.setHours(0, 0, 0, 0);
            var untilDate = angular.copy(vm.untilDate);
            untilDate.setHours(0, 0, 0, 0);
            untilDate.setDate(untilDate.getDate() + 1);
            var midDate = new Date((fromDate.getTime() + untilDate.getTime()) / 2);
            var now = new Date();
            vm.reversed = now.getTime() > midDate.getTime();
        }
        updateDateSelection();

        vm.dinghyEvents = [];
        loadAll();

        function loadAll () {
            $http.get('api/board/dinghy-events/presence', {
                params: {
                    fromDate: DateUtils.convertLocalDateToServer(vm.fromDate),
                    untilDate: DateUtils.convertLocalDateToServer(vm.untilDate)
                }
            }).then(function(response) {
                vm.dinghyEvents = response.data;
                if (vm.reversed) {
                    vm.dinghyEvents.reverse();
                }

            });
        }

        function selectFromDate() {
            $scope.options = {
                minDate: new Date(vm.fromDate),
            };
        }

        function updateDateSelection() {
            if (vm.fromDate == null || vm.untilDate == null) {
                vm.dateSelection = 'custom';
                return;
            }
            vm.selectFromDate();
            var today = getToday();
            var newYear = getNewYear();
            var silvester = getSilvester();

            if (newYear.getTime() === vm.fromDate.getTime()
            && silvester.getTime() === vm.untilDate.getTime()) {
                vm.dateSelection = 'year';
                return;
            }
            if (newYear.getTime() === vm.fromDate.getTime()
                && today.getTime() === vm.untilDate.getTime()) {
                vm.dateSelection = 'passed';
                return;
            }
            if (today.getTime() === vm.fromDate.getTime()
                && silvester.getTime() === vm.untilDate.getTime()) {
                vm.dateSelection = 'future';
                return;
            }
            vm.dateSelection = 'custom';
        }

        function transition() {
            if (vm.fromDate == null || vm.untilDate == null) {
                return;
            }
            var newUntilDate = getDateForServer(getUntilDate());
            var newFromDate = getFromDate();
            if (newUntilDate == null && newFromDate.getTime() === getNewYear().getTime()) {
                newFromDate = null;
            } else if (newFromDate.getTime() === getToday().getTime() && newUntilDate === null) {
                newFromDate = DateUtils.convertLocalDateToServer(newFromDate)
            } else {
                newFromDate = getDateForServer(newFromDate);
            }

            // currently does not reload :/
            $state.transitionTo($state.$current, {
                fromDate: newFromDate,
                untilDate: newUntilDate
            }, {reload: true});
        }

        function getDateForServer(date) {
            if (date.getTime() === getToday().getTime()) {
                return null;
            }
            return DateUtils.convertLocalDateToServer(date);
        }

        function getFromDate() {
            switch (vm.dateSelection) {
                case 'year':
                case 'passed':
                    return getNewYear();
                case 'future':
                    return getToday();
            }
            return vm.fromDate;
        }

        function getUntilDate() {
            switch (vm.dateSelection) {
                case 'year':
                case 'future':
                    return getSilvester();
                case 'passed':
                    return getToday();
            }
            return vm.untilDate;
        }

        function getToday() {
            var today = new Date();
            today.setHours(0, 0, 0, 0);
            return today;
        }

        function getNewYear() {
            var newYear = getToday();
            // Range 0-11 and 1-31
            newYear.setMonth(0, 1);
            return newYear;
        }

        function getSilvester() {
            var silvester = getToday();
            // Range 0-11 and 1-31
            silvester.setMonth(11, 31);
            return silvester;
        }

        function selectDateRange(namedRange) {
            if (namedRange === vm.dateSelection) {
                return;
            }
            var validOptions = ['year', 'future', 'passed'];
            if (validOptions.includes(namedRange)) {
                vm.dateSelection = namedRange;
                vm.fromDate = getFromDate();
                vm.untilDate = getUntilDate();
                vm.transition();
            }
        }

        function reverseOrder() {
            vm.reversed = !vm.reversed;
            vm.dinghyEvents = vm.dinghyEvents.reverse();
        }

        var trusted = {};
        $scope.getPopoverContent = function(content) {
            return trusted[content] || (trusted[content] = $sce.trustAsHtml(content));
        }
    }
})();

/*
 * Copyright (c) 2020 by Felix Heim, felix-heim@web.de
 *
 * This product includes software developed at
 * The Apache Software Foundation (http://www.apache.org/).
 */

(function() {
    'use strict';

    angular
        .module('askApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
        .state('board.dinghy.plan-parent', {
            // use a parent state to cache the dinghies etc.
            parent: 'board.dinghy',
            data: {
                authorities: ['ROLE_BOARD', 'ROLE_DINGHY']
            },
            resolve: {
                dinghies: ['DinghyBoard', function(DinghyBoard) {
                    return DinghyBoard.query({
                        size: 99,
                        active: true,
                        sort: ['type,asc', 'id']
                    }).$promise;
                }],
                availableYears: ['$http', function($http) {
                    return $http.get('api/board/dinghies/years');
                }],
                currentProfile: ['PrincipalProfile', function(PrincipalProfile) {
                    return PrincipalProfile.identity(false);
                }],
            }
        })
        .state('board.dinghy.plan', {
            parent: 'board.dinghy.plan-parent',
            url: '/plan?timeFilter?dinghyIds',
            data: {
                authorities: ['ROLE_BOARD', 'ROLE_DINGHY'],
                pageTitle: 'askApp.dinghy.detail.title'
            },
            views: {
                'dinghy@board.dinghy': {
                    templateUrl: 'app/board/dinghy/plan/dinghy-plan.html',
                    controller: 'DinghyPlanController',
                    controllerAs: 'vm'
                }
            },
            params: {
                timeFilter: {
                    value: 'active',
                    squash: true
                },
                dinghyIds: {
                    value: '0',
                    squash: true
                }
            },
            resolve: {
                pagingParams: ['$stateParams', function ($stateParams) {
                    return {
                        timeFilter: $stateParams.timeFilter,
                        dinghyIds: $stateParams.dinghyIds.split(',')
                    };
                }],
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('dinghy');
                    $translatePartialLoader.addPart('dinghyEvent');
                    $translatePartialLoader.addPart('enumDinghyEventType');
                    return $translate.refresh();
                }]
            }
        });
    }
})();

/*
 * Copyright (c) 2020 by Felix Heim, felix-heim@web.de
 *
 * This product includes software developed at
 * The Apache Software Foundation (http://www.apache.org/).
 */

(function() {
    'use strict';

    angular
        .module('askApp')
        .controller('DinghyPlanController', DinghyPlanController);

    DinghyPlanController.$inject = ['dinghies', 'availableYears', 'currentProfile', '$state', '$scope','$sce', 'DinghyBoard', 'ParseLinks', 'AlertService', 'pagingParams', '$http', 'PrincipalProfile'];

    function DinghyPlanController(dinghies, availableYears, currentProfile, $state, $scope, $sce, DinghyBoard, ParseLinks, AlertService, pagingParams, $http, PrincipalProfile) {
        var vm = this;

        vm.timeFilter = pagingParams.timeFilter;
        vm.year = vm.timeFilter === 'active' || vm.timeFilter === 'archive' ? null : parseInt(vm.timeFilter);
        vm.dinghyIds = pagingParams.dinghyIds;

        vm.transition = transition;
        vm.loadAll = loadAll;
        vm.setFilter = setFilter;
        vm.anySelected = anySelected;
        vm.selectAll = selectAll;
        vm.selectNone = selectNone;
        vm.dinghies = dinghies;
        // set active states
        for (var index = 0; index < vm.dinghies.length; index++) {
            vm.dinghies[index].isSelected = vm.dinghyIds.includes('' + vm.dinghies[index].id) || vm.dinghyIds.length === 0 || vm.dinghyIds[0] == 0;
        }
        vm.availableYears = availableYears.data;
        vm.currentProfile = currentProfile;
        vm.dinghyEvents = [];

        loadAll();

        function loadAll () {
            $http.get('api/board/dinghies/overview', {
                params: {
                    timeFilter: vm.timeFilter,
                    dinghyIds: getDinghyIds()
                }
            }).then(function(response) {
                vm.dinghyEvents = response.data;
            });
        }

        function transition() {
            $state.transitionTo($state.$current, {
                timeFilter: vm.timeFilter,
                dinghyIds: getDinghyIds()
            });
        }

        function getDinghyIds() {
            var dinghyIds =  [];
            if (vm.dinghies.length === 0) {
                dinghyIds = vm.dinghyIds;
            } else {
                for (var index = 0; index < vm.dinghies.length; index++) {
                    if (vm.dinghies[index].isSelected) {
                        dinghyIds.push(vm.dinghies[index].id);
                    }
                }
            }
            if (dinghyIds.length === vm.dinghies.length) {
                dinghyIds = [0];
            }
            return dinghyIds.join(',');
        }

        function setFilter(filter) {
            vm.timeFilter = filter;
            vm.transition();
        }

        function anySelected() {
            for (var index = 0; index < vm.dinghies.length; index++) {
                if (vm.dinghies[index].isSelected) {
                    return true;
                }
            }
            return false;
        }

        function selectDinghy(value) {
            for (var index = 0; index < vm.dinghies.length; index++) {
                vm.dinghies[index].isSelected = value;
            }
        }

        function selectAll() {
            selectDinghy(true);
        }

        function selectNone() {
            selectDinghy(false);
        }
    }
})();

/*
 * Copyright (c) 2023 by Felix Heim, felix-heim@web.de
 *
 * This product includes software developed at
 * The Apache Software Foundation (http://www.apache.org/).
 */

(function() {
    'use strict';

    angular
        .module('askApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
        .state('board.dinghy.newsletter', {
            parent: 'board.dinghy',
            url: '/newsletter',
            data: {
                authorities: ['ROLE_DINGHY', 'ROLE_BOARD'],
                pageTitle: 'askApp.dinghy.newsletter.title'
            },
            views: {
                'dinghy@board.dinghy': {
                    templateUrl: 'app/board/dinghy/newsletter/dinghy-newsletter.html',
                    controller: 'DinghyNewsletterController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('project');
                    $translatePartialLoader.addPart('dinghy');
                    $translatePartialLoader.addPart('member-management');
                    return $translate.refresh();
                }]
            }
        });
    }
})();

/*
 * Copyright (c) 2023 by Felix Heim, felix-heim@web.de
 *
 * This product includes software developed at
 * The Apache Software Foundation (http://www.apache.org/).
 */

(function() {
    'use strict';

    angular
        .module('askApp')
        .controller('DinghyNewsletterController', DinghyNewsletterController);

    DinghyNewsletterController.$inject = ['$http', 'Principal'];

    function DinghyNewsletterController($http, Principal) {
        var vm = this;
        vm.action = action;
        vm.sendMail = {
            startId: 0
        };
        vm.year = new Date().getFullYear();

        Principal.identity().then(function(account) {
            vm.currentAccount = account;
        });

        vm.options = {
            toolbar: [
                ['style', ['bold', 'italic', 'underline', 'clear']],
                ['textsize', ['fontsize']],
                ['fontclr', ['color']],
                ['alignment', ['ul', 'ol']],
                ['view', ['codeview']]
            ]
        };

        function action(action) {
            vm.sendMail.action = action;
            vm.isSaving = true;
            $http.post('api/board/dinghy-events/presence-newsletter/', vm.sendMail).then(function() {
                vm.isSaving = false;
            });
        }
    }
})();

/*
 * Copyright (c) 2020 by Felix Heim, felix-heim@web.de
 *
 * This product includes software developed at
 * The Apache Software Foundation (http://www.apache.org/).
 */

(function() {
    'use strict';

    angular
        .module('askApp')
        .controller('DinghyEventBoardDialogController', DinghyEventBoardDialogController);

    DinghyEventBoardDialogController.$inject = ['$timeout', '$scope', '$stateParams', '$uibModalInstance', 'entity', '$filter', 'DinghyEventBoard', 'Profile', 'DinghyBoard', '$http', 'Content'];

    function DinghyEventBoardDialogController ($timeout, $scope, $stateParams, $uibModalInstance, entity, $filter, DinghyEventBoard, Profile, DinghyBoard, $http, Content) {
        var $translate = $filter('translate');
        var vm = this;

        vm.dinghyEvent = entity;
        vm.clear = clear;
        vm.datePickerOpenStatus = {};
        vm.openCalendar = openCalendar;
        vm.save = save;
        vm.dinghies = [];
        vm.allGodparents = [];
        vm.hadGodparent = vm.dinghyEvent.godparent != null;
        if (vm.dinghyEvent.id !== null) {
            vm.oldCanceled = vm.dinghyEvent.canceled;
            vm.oldName = vm.dinghyEvent.name;
            vm.oldFromDate = vm.dinghyEvent.fromDate;
            vm.oldUntilDate = vm.dinghyEvent.untilDate;
            vm.oldDescription = vm.dinghyEvent.description;
            vm.oldLocation = vm.dinghyEvent.location;
            vm.oldGodparent = vm.dinghyEvent.godparent;
        }
        $http.get('api/board/profiles/dinghy/').then(function(response) {
            vm.allGodparents = response.data;
        });
        $http.get('api/board/dinghy-events/default-mail').then(function(response) {
            vm.defaultMail = response.data.value;
        });
        if (vm.dinghyEvent.id === null) {
            $http.get('api/board/dinghy-events/home-location').then(function(response) {
                vm.dinghyEvent.location = response.data.value;
            });
        }

        vm.showBulkCreateOptions = false;
        vm.activeFromDate = null;
        vm.additionalFromDates = [];

        vm.checkFromDate = function () {
            // return true on invalid --> can't submit anyway
            return !vm.dinghyEvent.id || !vm.dinghyEvent.fromDate || vm.dinghyEvent.fromDate.getTime() === vm.oldFromDate.getTime() || (vm.oldCanceled && vm.dinghyEvent.canceled);
        }

        vm.checkUntilDate = function () {
            // return true on invalid --> can't submit anyway
            return !vm.dinghyEvent.id || !vm.dinghyEvent.untilDate || vm.dinghyEvent.untilDate.getTime() === vm.oldUntilDate.getTime() || (vm.oldCanceled && vm.dinghyEvent.canceled);
        }

        const priceTypes = ['regatta', 'training'];

        vm.typeChanged = typeChanged;
        vm.dateChanged = dateChanged;
        vm.hasPrices = hasPrices;
        vm.replaceYear = replaceYear;
        vm.loadAvailableDinghies = loadAvailableDinghies;
        vm.initBulkCreate = initBulkCreate;
        vm.removeSelectedDate = removeSelectedDate;
        vm.formIsDirty = formIsDirty;

        if(vm.dinghyEvent.id) {
            loadAvailableDinghies();
        }

        $timeout(function (){
            document.getElementById('field_type').focus();
        });

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function save () {
            vm.dinghyEvent.name = vm.dinghyEvent.name.trim();
            vm.dinghyEvent.location = vm.dinghyEvent.location.trim();
            vm.isSaving = true;
            if (vm.dinghyEvent.id !== null) {
                DinghyEventBoard.update(vm.dinghyEvent, onSaveSuccess, onSaveError);
            } else {
                DinghyEventBoard.save({
                    'dinghyEvent': vm.dinghyEvent,
                    'additionalFromDates': vm.additionalFromDates
                }, onSaveSuccess, onSaveError);
            }
        }

        function onSaveSuccess (result) {
            $scope.$emit('askApp:dinghyEventUpdate', result);
            $uibModalInstance.close(result);
            vm.isSaving = false;
        }

        function onSaveError () {
            vm.isSaving = false;
        }

        vm.datePickerOpenStatus.fromDate = false;
        vm.datePickerOpenStatus.untilDate = false;

        function openCalendar (date) {
            vm.datePickerOpenStatus[date] = true;
        }

        vm.options = {
            toolbar: [
                ['style', ['bold', 'italic', 'underline', 'clear']],
                ['textsize', ['fontsize']],
                ['fontclr', ['color']],
                ['alignment', ['ul', 'ol']],
                ['view', ['codeview']]
            ]
        };

        function typeChanged () {
            setIdentifier();
            loadConditions();
            dateChanged();

            // convenient closed form expression to check for leisure or engagement
            vm.allowGuests = !hasPrices();
        }

        function setIdentifier () {
            vm.dinghyEvent.identifier = $translate('askApp.dinghyEvent.identifierType.' + vm.dinghyEvent.type);
        }

        function loadConditions () {
            Content.get({id : getConditionId()}, function (data){
                vm.dinghyEvent.conditions = data.text;
            });
        }

        function getConditionId () {
            switch (vm.dinghyEvent.type) {
                case 'leisure':
                    return 31;
                case 'regatta':
                    return 32;
                case 'training':
                    return 33;
                case 'engagement':
                    return 34;
                default:
                    throw new Error('unknown event type!');
            }
        }

        function loadAvailableDinghies() {
            if (vm.dinghyEvent.fromDate == null || vm.dinghyEvent.untilDate == null) {
                return;
            }
            $timeout(function () {
                DinghyBoard.query({
                    size: 99,
                    eventId: vm.dinghyEvent.id,
                    fromDate: vm.dinghyEvent.fromDate,
                    untilDate: vm.dinghyEvent.untilDate,
                    sort: ['type,asc', 'id']
                }, function(data) {
                    vm.dinghies = data;
                });
            });
        }

        function dateChanged () {
            var newUntilDate;
            switch (vm.dinghyEvent.type) {
                case 'leisure':
                    if (vm.dinghyEvent.fromDate == null) {
                        return;
                    }
                    if (vm.dinghyEvent.untilDate && vm.dinghyEvent.fromDate < vm.dinghyEvent.untilDate) {
                        newUntilDate = angular.copy(vm.dinghyEvent.untilDate);
                        newUntilDate.setDate(vm.dinghyEvent.fromDate.getDate());
                        newUntilDate.setMonth(vm.dinghyEvent.fromDate.getMonth());
                        newUntilDate.setFullYear(vm.dinghyEvent.fromDate.getFullYear());
                        vm.dinghyEvent.untilDate = newUntilDate;
                    } else {
                        newUntilDate = angular.copy(vm.dinghyEvent.fromDate);
                        newUntilDate.setHours(23);
                    }
                    vm.dinghyEvent.untilDate = newUntilDate;
                    break;
                case 'engagement':
                    if (vm.dinghyEvent.fromDate == null) {
                        return;
                    }
                    if (vm.dinghyEvent.untilDate && vm.dinghyEvent.fromDate < vm.dinghyEvent.untilDate) {
                        newUntilDate = angular.copy(vm.dinghyEvent.untilDate);
                        newUntilDate.setDate(vm.dinghyEvent.fromDate.getDate());
                        newUntilDate.setMonth(vm.dinghyEvent.fromDate.getMonth());
                        newUntilDate.setFullYear(vm.dinghyEvent.fromDate.getFullYear());
                        vm.dinghyEvent.untilDate = newUntilDate;
                    } else {
                        newUntilDate = angular.copy(vm.dinghyEvent.fromDate);
                        newUntilDate.setHours(vm.dinghyEvent.fromDate.getHours() + 4);
                    }
                    vm.dinghyEvent.untilDate = newUntilDate;
                    break;
                case 'regatta':
                case 'training':
                default:
                    break;
            }

            loadAvailableDinghies();

            if(vm.dinghyEvent.fromDate != null) {
                $scope.untilDateOptions = {
                    minDate: new Date(vm.dinghyEvent.fromDate),
                    initDate: new Date(vm.dinghyEvent.fromDate)
                };
                vm.replaceYear();
            }
        }

        function hasPrices() {
            return priceTypes.includes(vm.dinghyEvent.type);
        }

        function replaceYear() {
            if (vm.dinghyEvent.identifier == null) {
                return;
            }
            var replaceYear = vm.dinghyEvent.fromDate.getFullYear();
            var replaceYearTwoDigit = replaceYear.toString().substr(-2);
            vm.dinghyEvent.identifier = vm.dinghyEvent.identifier.replace(replaceYear, '').replace(replaceYearTwoDigit, '');
        }

        function initBulkCreate() {
            vm.showBulkCreateOptions = true;
            vm.activeFromDate = new Date(vm.dinghyEvent.fromDate).setHours(0, 0, 0, 0)
            vm.additionalFromDates.push(vm.activeFromDate);
        }

        function removeSelectedDate (date) {
            vm.additionalFromDates.splice(vm.additionalFromDates.indexOf(date), 1);
        }

        function formIsDirty() {
            return vm.dinghyEvent.id &&
                (vm.oldCanceled !== vm.dinghyEvent.canceled
                || vm.oldName !== vm.dinghyEvent.name
                || vm.oldFromDate !== vm.dinghyEvent.fromDate
                || vm.oldUntilDate !== vm.dinghyEvent.untilDate
                || vm.oldDescription !== vm.dinghyEvent.description
                || vm.oldLocation !== vm.dinghyEvent.location
                || vm.oldGodparent !== vm.dinghyEvent.godparent
                );
        }
    }
})();

/*
 * Copyright (c) 2020 by Felix Heim, felix-heim@web.de
 *
 * This product includes software developed at
 * The Apache Software Foundation (http://www.apache.org/).
 */

(function() {
    'use strict';

    angular
        .module('askApp')
        .controller('DinghyEventBoardDeleteController', DinghyEventBoardDeleteController);

    DinghyEventBoardDeleteController.$inject = ['$uibModalInstance', 'entity', 'DinghyEventBoard'];

    function DinghyEventBoardDeleteController($uibModalInstance, entity, DinghyEventBoard) {
        var vm = this;

        vm.dinghyEvent = entity;
        vm.clear = clear;
        vm.confirmDelete = confirmDelete;

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function confirmDelete (id) {
            DinghyEventBoard.delete({id: id},
                function () {
                    $uibModalInstance.close(true);
                });
        }
    }
})();

/*
 * Copyright (c) 2020 by Felix Heim, felix-heim@web.de
 *
 * This product includes software developed at
 * The Apache Software Foundation (http://www.apache.org/).
 */

(function() {
    'use strict';

    angular
        .module('askApp')
        .controller('DinghyEventBoardCancelController', DinghyEventBoardCancelController);

    DinghyEventBoardCancelController.$inject = ['$uibModalInstance', 'entity', '$http', '$timeout'];

    function DinghyEventBoardCancelController($uibModalInstance, entity, $http, $timeout) {
        var vm = this;

        vm.dinghyEvent = entity;
        if (vm.dinghyEvent.canceled) {
            $timeout(function () {
                clear();
            });
        }
        vm.clear = clear;
        vm.confirmCancel = confirmCancel;

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function confirmCancel () {
            vm.eventCanceled = {
                id: vm.dinghyEvent.id,
                managerComment: vm.managerComment
            }
            $http.post('api/board/dinghy-events/cancel/', vm.eventCanceled).then(function() {
                $uibModalInstance.close(true);
            });
        }
    }
})();

/*
 * Copyright (c) 2020 by Felix Heim, felix-heim@web.de
 *
 * This product includes software developed at
 * The Apache Software Foundation (http://www.apache.org/).
 */

(function() {
    'use strict';

    angular
        .module('askApp')
        .controller('DinghyEventAssignController', DinghyEventAssignController);

    DinghyEventAssignController.$inject = ['$uibModalInstance', 'entity', 'PrincipalProfile', '$http'];

    function DinghyEventAssignController($uibModalInstance, entity, PrincipalProfile, $http) {
        var vm = this;

        vm.dinghyEvent = entity;
        vm.initialGodparent = vm.dinghyEvent.godparent;
        vm.currentProfile = null;
        vm.clear = clear;
        vm.confirmAssign = confirmAssign;

        PrincipalProfile.identity(false).then(function(profile) {
            vm.currentProfile = profile;
        });

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function confirmAssign () {
            vm.dinghyEvent.godparent = vm.currentProfile;
            vm.eventAssigned = {
                id: vm.dinghyEvent.id,
                contactEmail: vm.dinghyEvent.contactEmail,
                managerComment: vm.managerComment,
                godparent: vm.currentProfile
            }
            $http.post('api/board/dinghy-events/assign/', vm.eventAssigned).then(function() {
                $uibModalInstance.close(true);
            });
        }
    }
})();

/*
 * Copyright (c) 2021 by Felix Heim, felix-heim@web.de
 *
 * This product includes software developed at
 * The Apache Software Foundation (http://www.apache.org/).
 */

(function() {
    'use strict';
    angular
        .module('askApp')
        .factory('DinghyEventActive', DinghyEventActive);

    DinghyEventActive.$inject = ['$resource', 'DateUtils'];

    function DinghyEventActive ($resource, DateUtils) {
        var resourceUrl =  'api/board/dinghy-events/active';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true},
            'get': {
                method: 'GET',
                isArray: true,
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                        for(var index = 0; index < data.length; index++) {
                            data[index].fromDate = new Date(DateUtils.convertLocalDateFromServer(data[index].fromDate));
                            data[index].untilDate = new Date(DateUtils.convertLocalDateFromServer(data[index].untilDate));
                        }
                    }
                    return data;
                }
            }
        });
    }
})();

/*
 * Copyright (c) 2020 by Felix Heim, felix-heim@web.de
 *
 * This product includes software developed at
 * The Apache Software Foundation (http://www.apache.org/).
 */

(function() {
    'use strict';

    angular
        .module('askApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
        .state('board.dinghy.event', {
            parent: 'board.dinghy',
            url: '/event?pageE&sortE&searchE&archiveE&typeE',
            data: {
                authorities: ['ROLE_BOARD','ROLE_DINGHY'],
                pageTitle: 'askApp.dinghyEvent.detail.title'
            },
            views: {
                'dinghy@board.dinghy': {
                    templateUrl: 'app/board/dinghy/event/dinghy-events.html',
                    controller: 'DinghyEventBoardController',
                    controllerAs: 'vm'
                }
            },
            params: {
                pageE: {
                    value: '1',
                    squash: true
                },
                sortE: {
                    value: 'fromDate,asc',
                    squash: true
                },
                archiveE: {
                    value: 'false',
                    squash: true
                },
                typeE: {
                    value: 'all',
                    squash: true
                },
                searchP: null
            },
            resolve: {
                pagingParams: ['$stateParams', 'PaginationUtil', function ($stateParams, PaginationUtil) {
                    return {
                        pageE: PaginationUtil.parsePage($stateParams.pageE),
                        sortE: $stateParams.sortE,
                        predicateE: PaginationUtil.parsePredicate($stateParams.sortE),
                        ascendingE: PaginationUtil.parseAscending($stateParams.sortE),
                        searchE: $stateParams.searchE,
                        archiveE: $stateParams.archiveE,
                        typeE: $stateParams.typeE
                    };
                }],
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('dinghy');
                    $translatePartialLoader.addPart('dinghyEvent');
                    $translatePartialLoader.addPart('project');
                    $translatePartialLoader.addPart('enumProjectType');
                    $translatePartialLoader.addPart('enumDinghyEventType');
                    $translatePartialLoader.addPart('enumBookingStatusType');
                    return $translate.refresh();
                }]
            }
        })
        .state('board.dinghy.event.new', {
            parent: 'board.dinghy.event',
            url: '/new',
            data: {
                authorities: ['ROLE_BOARD', 'ROLE_DINGHY'],
                pageTitle: 'askApp.dinghyEvent.home.createLabel'
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/board/dinghy/event/dinghy-event-dialog.html',
                    controller: 'DinghyEventBoardDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: function () {
                            return {
                                name: null,
                                type: null,
                                fromDate: null,
                                untilDate: null,
                                contactEmail: null,
                                placeCount: null,
                                location: null,
                                identifier: 'jollensegeln',
                                normalPrice: null,
                                studentPrice: null,
                                guestPrice: null,
                                description: null,
                                conditions: null,
                                notes: null,
                                visible: false,
                                active: false,
                                closed: false,
                                canceled: false,
                                allowGuests: true,
                                allowQueue: true,
                                individualQuestion: null,
                                id: null
                            };
                        }
                    }
                }).result.then(function() {
                    $state.go('board.dinghy.event', null, { reload: 'board.dinghy.event' });
                }, function() {
                    $state.go('board.dinghy.event');
                });
            }]
        })
        .state('board.dinghy.event.self-assign', {
            parent: 'board.dinghy.event',
            url: '/self-assign/{id}',
            data: {
                authorities: ['ROLE_DINGHY']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/board/dinghy/event/dinghy-event-assign-dialog.html',
                    controller: 'DinghyEventAssignController',
                    controllerAs: 'vm',
                    size: 'md',
                    resolve: {
                        entity: ['DinghyEventBoard', function(DinghyEventBoard) {
                            return DinghyEventBoard.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('board.dinghy.event', null, { reload: 'board.dinghy.event' });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('board.dinghy.event.cancel', {
            parent: 'board.dinghy.event',
            url: '/{id}/cancel',
            data: {
                authorities: ['ROLE_BOARD', 'ROLE_DINGHY']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/board/dinghy/event/dinghy-event-cancel-dialog.html',
                    controller: 'DinghyEventBoardCancelController',
                    controllerAs: 'vm',
                    size: 'md',
                    resolve: {
                        entity: ['DinghyEventBoard', function(DinghyEventBoard) {
                            return DinghyEventBoard.get({id : $stateParams.id}).$promise;
                        }],
                        translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                            $translatePartialLoader.addPart('booking');
                            return $translate.refresh();
                        }]
                    }
                }).result.then(function() {
                    $state.go('board.dinghy.event', null, { reload: 'board.dinghy.event' });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('board.dinghy.event.delete', {
            parent: 'board.dinghy.event',
            url: '/{id}/delete',
            data: {
                authorities: ['ROLE_BOARD', 'ROLE_DINGHY'],
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/board/dinghy/event/dinghy-event-delete-dialog.html',
                    controller: 'DinghyEventBoardDeleteController',
                    controllerAs: 'vm',
                    size: 'md',
                    resolve: {
                        entity: ['DinghyEventBoard', function(DinghyEventBoard) {
                            return DinghyEventBoard.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('board.dinghy.event', null, { reload: 'board.dinghy.event' });
                }, function() {
                    $state.go('^');
                });
            }]
        });
    }
})();

/*
 * Copyright (c) 2020 by Felix Heim, felix-heim@web.de
 *
 * This product includes software developed at
 * The Apache Software Foundation (http://www.apache.org/).
 */

(function() {
    'use strict';
    angular
        .module('askApp')
        .factory('DinghyEventBoard', DinghyEventBoard);

    DinghyEventBoard.$inject = ['$resource', 'DateUtils'];

    function DinghyEventBoard ($resource, DateUtils) {
        var resourceUrl =  'api/board/dinghy-events/:id';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true},
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                        data.fromDate = DateUtils.convertDateTimeFromServer(data.fromDate);
                        data.untilDate = DateUtils.convertDateTimeFromServer(data.untilDate);
                    }
                    return data;
                }
            },
            'update': { method:'PUT' },
            'save': {
                method: 'POST',
                transformRequest: function (data) {
                    var copy = angular.copy(data);
                    if (copy.additionalFromDates) {
                        for(var i = 0; i < copy.additionalFromDates.length; i++) {
                            copy.additionalFromDates[i] = DateUtils.convertLocalDateToServer(copy.additionalFromDates[i]);
                        }
                    }
                    return angular.toJson(copy);
                }
            }
        });
    }
})();

/*
 * Copyright (c) 2020 by Felix Heim, felix-heim@web.de
 *
 * This product includes software developed at
 * The Apache Software Foundation (http://www.apache.org/).
 */

(function() {
    'use strict';

    angular
        .module('askApp')
        .controller('DinghyEventBoardController', DinghyEventBoardController);

    DinghyEventBoardController.$inject = ['$state', 'Principal', 'DinghyEventBoard', 'DinghyEventSearch', 'ParseLinks', 'AlertService', 'paginationConstants', 'pagingParams', '$stateParams', '$timeout'];

    function DinghyEventBoardController($state, Principal, DinghyEventBoard, DinghyEventSearch, ParseLinks, AlertService, paginationConstants, pagingParams, $stateParams, $timeout) {

        var vm = this;

        vm.isBoard = false;
        Principal.hasAuthority('ROLE_BOARD').then(function (result) {
            vm.isBoard = result;
        });
        vm.isDinghy = false;
        Principal.hasAuthority('ROLE_DINGHY').then(function (result) {
            vm.isDinghy = result;
        });
        vm.dinghyEventTypes = ['all', 'without_godparent', 'personal', 'leisure', 'regatta', 'training', 'engagement', 'local'];
        vm.loadPage = loadPage;
        vm.predicate = pagingParams.predicateE;
        vm.reverse = pagingParams.ascendingE;
        vm.transition = transition;
        vm.itemsPerPage = paginationConstants.itemsPerPage;
        vm.clear = clear;
        vm.search = search;
        vm.loadAll = loadAll;
        vm.searchQuery = pagingParams.searchE;
        vm.currentSearch = pagingParams.searchE;
        vm.setType = setType;
        vm.setArchive = setArchive;
        vm.archive = pagingParams.archiveE;
        vm.type = pagingParams.typeE;
        vm.events = [];

        if (vm.predicate.startsWith('godparent') && (vm.type === 'personal' || vm.type === 'without_godparent')) {
            vm.predicate = 'fromDate';
            vm.reverse = true;
            $timeout(function() {
                vm.transition();
            });
        } else {
            loadAll();
        }

        function setType(type) {
            vm.page = 1;
            vm.type = type;
            vm.transition();
        }

        function setArchive(archive) {
            vm.page = 1;
            vm.archive = archive;
            vm.transition();
        }

        function loadAll () {
            if (pagingParams.searchE) {
                DinghyEventSearch.query({
                    query: pagingParams.searchE,
                    page: pagingParams.pageE - 1,
                    size: vm.itemsPerPage,
                    sort: sort()
                }, onSuccess, onError);
            } else {
                DinghyEventBoard.query({
                    page: pagingParams.pageE - 1,
                    size: vm.itemsPerPage,
                    sort: sort(),
                    archive: $stateParams.archiveE,
                    type: $stateParams.typeE
                }, onSuccess, onError);
            }
            function sort() {
                var sorting = vm.reverse ? 'asc' : 'desc';
                var result = [vm.predicate + ',' + sorting];
                if (vm.predicate !== 'id') {
                    result.push('id,' + sorting);
                }
                return result;
            }
            function onSuccess(data, headers) {
                vm.links = ParseLinks.parse(headers('link'));
                vm.totalItems = headers('X-Total-Count');
                vm.queryCount = vm.totalItems;
                vm.events = data;
                vm.page = pagingParams.pageE;
                if (vm.events.length === 0 && vm.predicate.startsWith('godparent')) {
                    vm.predicate = 'fromDate';
                    vm.reverse = true;
                    vm.transition();
                }
            }
            function onError(error) {
                AlertService.error(error.data.message);
            }
        }

        function loadPage(page) {
            vm.page = page;
            vm.transition();
        }

        function transition() {
            $state.transitionTo($state.$current, {
                pageE: vm.page,
                sortE: vm.predicate + ',' + (vm.reverse ? 'asc' : 'desc'),
                searchE: vm.currentSearch,
                archiveE: vm.archive,
                typeE: vm.type
            });
        }

        function search(searchQuery) {
            if (!searchQuery){
                return vm.clear();
            }
            vm.links = null;
            vm.page = 1;
            vm.predicate = '_score';
            vm.reverse = false;
            vm.currentSearch = searchQuery;
            vm.transition();
        }

        function clear() {
            vm.links = null;
            vm.page = 1;
            vm.predicate = 'fromDate';
            vm.reverse = false;
            vm.currentSearch = null;
            vm.transition();
        }
    }
})();

/*
 * Copyright (c) 2021 by Felix Heim, felix-heim@web.de
 *
 * This product includes software developed at
 * The Apache Software Foundation (http://www.apache.org/).
 */

(function() {
    'use strict';

    angular
        .module('askApp')
        .controller('DinghyEventPaymentDialogController', DinghyEventPaymentDialogController);

    DinghyEventPaymentDialogController.$inject = ['$timeout', '$scope', '$uibModalInstance', 'entity', 'entityDinghyEvent', 'BoardPayment', 'DateUtils', '$http'];

    function DinghyEventPaymentDialogController ($timeout, $scope, $uibModalInstance, entity, entityDinghyEvent, BoardPayment, DateUtils, $http) {
        var vm = this;

        if (entityDinghyEvent.closed) {
            $timeout(function() {
                clear();
            });
        }
        vm.payment = entity;
        vm.maxAmount = vm.payment.amount;
        if (vm.payment.parent !== null) {
            vm.maxAmount = vm.payment.amount + vm.payment.parent.amount;
        }
        vm.clear = clear;
        vm.save = save;
        vm.getDept = getDept;
        vm.copyPayment = copyPayment;
        vm.amountEditable = false;

        $timeout(function (){
            angular.element('.form-group:eq(2)>input').focus();
        });

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function save () {
            vm.isSaving = true;
            if(vm.payment.dept == "") {
                vm.payment.dept = null;
            }
            if(vm.payment.category == "") {
                vm.payment.category = null;
            }
            BoardPayment.update(vm.payment, onSaveSuccess, onSaveError);
        }

        function onSaveSuccess (result) {
            $scope.$emit('askApp:paymentUpdate', result);
            $uibModalInstance.close(result);
            vm.isSaving = false;
        }

        function onSaveError () {
            vm.isSaving = false;
        }

        function getDept(val) {
            return $http.get('api/_search/depts/', {
                params: {
                    query: val,
                    dinghyEventId: vm.payment.dinghyEvent.id
                }
            }).then(function(response){
                return response.data.map(function(item) {
                    return item;
                });
            });
        }

        function copyPayment() {
            $http.get('/api/payments/duplicate/', {
                params: {
                    paymentId: vm.payment.id
                }
            }).then(onSaveSuccess, onSaveError);
        }
    }
})();

/*
 * Copyright (c) 2021 by Felix Heim, felix-heim@web.de
 *
 * This product includes software developed at
 * The Apache Software Foundation (http://www.apache.org/).
 */

(function() {
    'use strict';

    angular
        .module('askApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
        .state('board.dinghy.event.detail.payments', {
            parent: 'board.dinghy.event.detail',
            url: '/payments?type',
            data: {
                authorities: ['ROLE_BOARD','ROLE_MANAGER', 'ROLE_FINANCE'],
                pageTitle: 'askApp.project.payment.title'
            },
            views: {
                'dinghyDetail@board.dinghy.event.detail': {
                    templateUrl: 'app/board/dinghy/event/detail/payments/payments.html',
                    controller: 'DinghyEventPaymentsController',
                    controllerAs: 'vm'
                }
            },
            params: {
                type: {
                    value: 'all',
                    squash: true
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('payment');
                    $translatePartialLoader.addPart('enumPaymentCategory');
                    return $translate.refresh();
                }]
            }
        })
        .state('board.dinghy.event.detail.payments.edit', {
            parent: 'board.dinghy.event.detail.payments',
            url: '/{paymentId}/edit',
            data: {
                authorities: ['ROLE_FINANCE']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', 'entity', function($stateParams, $state, $uibModal, entity) {
                $uibModal.open({
                    templateUrl: 'app/board/dinghy/event/detail/payments/payment-dialog.html',
                    controller: 'DinghyEventPaymentDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'md',
                    resolve: {
                        entity: ['BoardPayment', function(BoardPayment) {
                            return BoardPayment.get({id : $stateParams.paymentId}).$promise;
                        }],
                        entityDinghyEvent: entity
                    }
                }).result.then(function() {
                    $state.go('board.dinghy.event.detail.payments', null, { reload: 'board.dinghy.event.detail.payments' });
                }, function() {
                    $state.go('^');
                });
            }]
        });
    }
})();

/*
 * Copyright (c) 2021 by Felix Heim, felix-heim@web.de
 *
 * This product includes software developed at
 * The Apache Software Foundation (http://www.apache.org/).
 */

(function () {
    'use strict';

    angular
        .module('askApp')
        .controller('DinghyEventPaymentsController', DinghyEventPaymentsController);

    DinghyEventPaymentsController.$inject = ['entity', '$state', '$http', '$stateParams', 'DateUtils'];

    function DinghyEventPaymentsController(entity, $state, $http, $stateParams, DateUtils) {
        var vm = this;
        vm.dinghyEvent = entity;
        vm.type = $stateParams.type;

        vm.setType = setType;
        vm.dataExport = dataExport;
        vm.abs = abs;
        vm.transition = transition;
        vm.payments = [];
        vm.sumNegative = 0;
        vm.sumPositive = 0;
        vm.totalSum = 0;

        $http.get('api/board/dinghy-events/payments', {
            params: {
                eventId: entity.id,
                type: vm.type
            }
        }).then(function (response) {
            vm.payments = response.data;
            for (var index = 0; index < vm.payments.length; index++) {
                if (vm.payments[index].amount < 0) {
                    vm.sumNegative += vm.payments[index].amount;
                } else {
                    vm.sumPositive += vm.payments[index].amount;
                }
                vm.payments[index].date = DateUtils.convertLocalDateToServer(vm.payments[index].date);
            }
            vm.totalSum = vm.sumNegative + vm.sumPositive;
        });

        // could be replaced with vm.dinghyEvent.bookedPlaces but this way it gets refreshed every time (not only with event reload)
        $http.get('api/board/dinghy-bookings/summary', {
            params: {
                eventId: entity.id
            }
        }).then(function(response) {
            vm.status = response.data;
            vm.validPlaces = vm.status.countAngemeldet + vm.status.countWarteliste;
            vm.freePlaces = vm.dinghyEvent.placeCount - vm.validPlaces;
        });

        function setType(type) {
            vm.type = type;
            vm.transition();
        }

        function transition() {
            $state.transitionTo($state.$current, {
                id: $stateParams.id,
                type: vm.type
            });
        }

        function dataExport() {
            vm.isSaving = true;
            $http.get('api/board/dinghy-events/export/', {
                params: {
                    eventId: $stateParams.id
                }
            }).then(function (response) {
                vm.isSaving = false;
                AlertService.success("Der Export wurde erfolgreich durchgeführt und an deine E-Mail Adresse geschickt.");
            }).catch(function () {
                vm.isSaving = false;
            });
        }

        function abs(data) {
            return Math.abs(data);
        }
    }
})();

/*
 * Copyright (c) 2020 by Felix Heim, felix-heim@web.de
 *
 * This product includes software developed at
 * The Apache Software Foundation (http://www.apache.org/).
 */

(function() {
    'use strict';

    angular
        .module('askApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
        .state('board.dinghy.event.detail.overview', {
            parent: 'board.dinghy.event.detail',
            url: '/home',
            data: {
                authorities: ['ROLE_BOARD','ROLE_DINGHY'],
                pageTitle: 'askApp.dinghyEvent.detail.homeTitle'
            },
            views: {
                'dinghyDetail@board.dinghy.event.detail': {
                    templateUrl: 'app/board/dinghy/event/detail/overview/dinghy-event-overview.html',
                    controller: 'DinghyEventOverviewController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('dinghy');
                    $translatePartialLoader.addPart('dinghyEvent');
                    $translatePartialLoader.addPart('enumBookingStatusType');
                    return $translate.refresh();
                }]
            }
        })
        .state('board.dinghy.event.detail.delete', {
            parent: 'board.dinghy.event.detail.overview',
            url: '/delete',
            data: {
                authorities: ['ROLE_BOARD', 'ROLE_DINGHY']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/board/dinghy/event/dinghy-event-delete-dialog.html',
                    controller: 'DinghyEventBoardDeleteController',
                    controllerAs: 'vm',
                    size: 'md',
                    resolve: {
                        entity: ['DinghyEventBoard', function(DinghyEventBoard) {
                            return DinghyEventBoard.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('board.dinghy.event', null, { reload: 'board.dinghy.event' });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('board.dinghy.event.detail.self-assign', {
            parent: 'board.dinghy.event.detail.overview',
            url: '/self-assign',
            data: {
                authorities: ['ROLE_DINGHY']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/board/dinghy/event/dinghy-event-assign-dialog.html',
                    controller: 'DinghyEventAssignController',
                    controllerAs: 'vm',
                    size: 'md',
                    resolve: {
                        entity: ['DinghyEventBoard', function(DinghyEventBoard) {
                            return DinghyEventBoard.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('board.dinghy.event.detail.overview', null, { reload: 'board.dinghy.event.detail' });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('board.dinghy.event.detail.cancel', {
            parent: 'board.dinghy.event.detail.overview',
            url: '/cancel',
            data: {
                authorities: ['ROLE_BOARD', 'ROLE_DINGHY']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/board/dinghy/event/dinghy-event-cancel-dialog.html',
                    controller: 'DinghyEventBoardCancelController',
                    controllerAs: 'vm',
                    size: 'md',
                    resolve: {
                        entity: ['DinghyEventBoard', function(DinghyEventBoard) {
                            return DinghyEventBoard.get({id : $stateParams.id}).$promise;
                        }],
                        translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                            $translatePartialLoader.addPart('booking');
                            return $translate.refresh();
                        }]
                    }
                }).result.then(function() {
                    $state.go('board.dinghy.event.detail.overview', null, { reload: 'board.dinghy.event.detail' });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('board.dinghy.event.detail.edit', {
            parent: 'board.dinghy.event.detail.overview',
            url: '/edit',
            data: {
                authorities: ['ROLE_BOARD', 'ROLE_DINGHY']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/board/dinghy/event/dinghy-event-dialog.html',
                    controller: 'DinghyEventBoardDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: ['DinghyEventBoard', function(DinghyEventBoard) {
                            return DinghyEventBoard.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('^', {}, { reload: true });
                }, function() {
                    $state.go('^');
                });
            }]
        });
    }
})();

/*
 * Copyright (c) 2020 by Felix Heim, felix-heim@web.de
 *
 * This product includes software developed at
 * The Apache Software Foundation (http://www.apache.org/).
 */

(function() {
    'use strict';

    angular
        .module('askApp')
        .controller('DinghyEventOverviewController', DinghyEventOverviewController);

    DinghyEventOverviewController.$inject = ['$scope', '$rootScope', '$sce', 'entity', '$state', '$window', '$location', 'AlertService', 'Principal'];

    function DinghyEventOverviewController($scope, $rootScope, $sce, entity, $state, $window, $location, AlertService, Principal) {
        var vm = this;
        vm.goTo = goTo;

        vm.dinghyEvent = entity;
        vm.validPlaces = vm.dinghyEvent.bookedPlaces.countAngemeldet + vm.dinghyEvent.bookedPlaces.countWarteliste;
        vm.bookUrl =  $location.protocol() + "://" + location.host + "/" + $state.href("member.dinghy-events.book", {id: vm.dinghyEvent.id});

        vm.isBoard = false;
        Principal.hasAuthority('ROLE_BOARD').then(function (result) {
            vm.isBoard = result;
        });
        vm.isDinghy = false;
        Principal.hasAuthority('ROLE_DINGHY').then(function (result) {
            vm.isDinghy = result;
        });

        var clipboardBookUrl = new ClipboardJS(document.getElementById("copyUrlButton"));
        clipboardBookUrl.on('success', function(e) {
            $scope.$apply(function() {
                AlertService.success("Anmeldelink wurde in die Zwischenablage kopiert.");
            });
            e.clearSelection();
        });
        clipboardBookUrl.on('error', function(e) {
            $scope.$apply(function() {
                AlertService.error("Anmeldelink konnte nicht kopiert werden.");
            });
        });

        var unsubscribe = $rootScope.$on('askApp:dinghyEventUpdate', function(event, result) {
            vm.dinghyEvent = result;
            vm.validPlaces = vm.dinghyEvent.bookedPlaces.countAngemeldet + vm.dinghyEvent.bookedPlaces.countWarteliste;
        });

        $scope.renderHtml = function(code) {
            return $sce.trustAsHtml(code);
        };

        $scope.$on('$destroy', unsubscribe);

        function goTo(url) {
            $window.open(url, "_blank");
        }
    }
})();

/*
 * Copyright (c) 2017 by Julian Feder, julian.feder@yahoo.de
 *
 * This product includes software developed at
 * The Apache Software Foundation (http://www.apache.org/).
 */

(function() {
    'use strict';

    angular
        .module('askApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
        .state('board.dinghy.event.detail.notes', {
            parent: 'board.dinghy.event.detail',
            url: '/notes',
            data: {
                authorities: ['ROLE_DINGHY', 'ROLE_BOARD'],
                pageTitle: 'askApp.dinghyEvent.detail.notesTitle'
            },
            views: {
                'dinghyDetail@board.dinghy.event.detail': {
                    templateUrl: 'app/board/dinghy/event/detail/notes/dinghy-event-notes.html',
                    controller: 'DinghyEventNotesController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('dinghy');
                    $translatePartialLoader.addPart('dinghyEvent');
                    return $translate.refresh();
                }]
            }
        });
    }
})();

/*
 * Copyright (c) 2017 by Julian Feder, julian.feder@yahoo.de
 *
 * This product includes software developed at
 * The Apache Software Foundation (http://www.apache.org/).
 */

(function() {
    'use strict';

    angular
        .module('askApp')
        .controller('DinghyEventNotesController', DinghyEventNotesController);

    DinghyEventNotesController.$inject = ['entity', '$http'];

    function DinghyEventNotesController(entity, $http) {
        var vm = this;
        vm.dinghyEvent = entity;
        vm.save = save;

        function save() {
            vm.isSaving = true;
            var projectNotesDTO = {
                id: vm.dinghyEvent.id,
                notes: vm.dinghyEvent.notes
            };
            $http.post('/api/board/dinghy-events/notes/', projectNotesDTO, null).then(onSaveSuccess, onSaveError);
        }

        function onSaveSuccess (result) {
            vm.isSaving = false;
        }

        function onSaveError () {
            vm.isSaving = false;
        }

        vm.options = {
            toolbar: [
                ['style', ['bold', 'italic', 'underline', 'clear']],
                ['textsize', ['fontsize']],
                ['fontclr', ['color']],
                ['alignment', ['ul', 'ol']],
                ['view', ['codeview']]
            ]
        };
    }
})();

/*
 * Copyright (c) 2017 by Julian Feder, julian.feder@yahoo.de
 *
 * This product includes software developed at
 * The Apache Software Foundation (http://www.apache.org/).
 */

(function() {
    'use strict';

    angular
        .module('askApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
        .state('board.dinghy.event.detail.newsletter', {
            parent: 'board.dinghy.event.detail',
            url: '/newsletter',
            data: {
                authorities: ['ROLE_DINGHY', 'ROLE_BOARD'],
                pageTitle: 'askApp.dinghyEvent.detail.newsletterTitle'
            },
            views: {
                'dinghyDetail@board.dinghy.event.detail': {
                    templateUrl: 'app/board/dinghy/event/detail/newsletter/dinghy-event-newsletter.html',
                    controller: 'DinghyEventNewsletterController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('project');
                    $translatePartialLoader.addPart('dinghy');
                    $translatePartialLoader.addPart('dinghyEvent');
                    $translatePartialLoader.addPart('member-management');
                    return $translate.refresh();
                }]
            }
        });
    }
})();

/*
 * Copyright (c) 2017 by Julian Feder, julian.feder@yahoo.de
 *
 * This product includes software developed at
 * The Apache Software Foundation (http://www.apache.org/).
 */

(function() {
    'use strict';

    angular
        .module('askApp')
        .controller('DinghyEventNewsletterController', DinghyEventNewsletterController);

    DinghyEventNewsletterController.$inject = ['entity', '$http', 'Principal'];

    function DinghyEventNewsletterController(entity, $http, Principal) {
        var vm = this;
        vm.dinghyEvent = entity;
        vm.contactMail = vm.dinghyEvent.contactEmailResolved;
        vm.action = action;
        vm.sendMail = {startId: 0, projectID: entity.id};
        vm.dinghyEventType = vm.dinghyEvent.type;

        Principal.identity().then(function(account) {
            vm.currentAccount = account;
        });

        vm.options = {
            toolbar: [
                ['style', ['bold', 'italic', 'underline', 'clear']],
                ['textsize', ['fontsize']],
                ['fontclr', ['color']],
                ['alignment', ['ul', 'ol']],
                ['view', ['codeview']]
            ]
        };

        function action(action) {
            vm.sendMail.action = action;
            vm.isSaving = true;
            $http.post('api/board/dinghy-events/mail/', vm.sendMail).then(function() {
                vm.isSaving = false;
            });
        }
    }
})();

/*
 * Copyright (c) 2020 by Felix Heim, felix-heim@web.de
 *
 * This product includes software developed at
 * The Apache Software Foundation (http://www.apache.org/).
 */

(function() {
    'use strict';

    angular
        .module('askApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
        .state('board.dinghy.event.detail', {
            parent: 'board.dinghy.event',
            url: '/detail/{id}',
            views: {
                'content@': {
                    templateUrl: 'app/board/dinghy/event/detail/dinghyEventNavbar.html',
                    controller: 'DinghyEventNavController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                entity: ['$stateParams', 'DinghyEventBoard', function($stateParams, DinghyEventBoard) {
                    return DinghyEventBoard.get({id : $stateParams.id}).$promise;
                }]
            }
        });
    }
})();

/*
 * Copyright (c) 2020 by Felix Heim, felix-heim@web.de
 *
 * This product includes software developed at
 * The Apache Software Foundation (http://www.apache.org/).
 */

(function() {
    'use strict';

    angular
        .module('askApp')
        .controller('DinghyEventNavController', DinghyEventNavController);

    DinghyEventNavController.$inject = ['$stateParams', 'entity'];

    function DinghyEventNavController($stateParams, entity) {
        var vm = this;
        vm.id = $stateParams.id;
        vm.dinghyEvent = entity;
    }
})();

/*
 * Copyright (c) 2021 by Felix Heim, felix-heim@web.de
 *
 * This product includes software developed at
 * The Apache Software Foundation (http://www.apache.org/).
 */

(function() {
    'use strict';

    angular
        .module('askApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
        .state('board.dinghy.event.detail.depts', {
            parent: 'board.dinghy.event.detail',
            url: '/depts',
            data: {
                authorities: ['ROLE_BOARD','ROLE_MANAGER', 'ROLE_FINANCE'],
                pageTitle: 'askApp.project.dept.title'
            },
            views: {
                'dinghyDetail@board.dinghy.event.detail': {
                    templateUrl: 'app/board/dinghy/event/detail/depts/depts.html',
                    controller: 'DinghyEventDeptsController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('dept');
                    $translatePartialLoader.addPart('enumDeptStatus');
                    $translatePartialLoader.addPart('enumMemberStatus');
                    $translatePartialLoader.addPart('enumPaymentCategory');
                    return $translate.refresh();
                }]
            }
        })
        .state('board.dinghy.event.detail.depts.edit-dept', {
            parent: 'board.dinghy.event.detail.depts',
            url: '/{deptId}/edit',
            data: {
                authorities: ['ROLE_FINANCE']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/board/dept/dept-dialog.html',
                    controller: 'BoardDeptDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'md',
                    resolve: {
                        translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                            $translatePartialLoader.addPart('booking');
                            $translatePartialLoader.addPart('payment');
                            $translatePartialLoader.addPart('enumPaymentCategory');
                            return $translate.refresh();
                        }],
                        entity: ['Dept', function(Dept) {
                            return Dept.get({id : $stateParams.deptId}).$promise;
                        }],
                        entityProfile: null,
                        entityProject: null,
                        entityDinghyEvent: null
                    }
                }).result.then(function() {
                    $state.go('board.dinghy.event.detail.depts', null, { reload: 'board.dinghy.event.detail' });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('board.dinghy.event.detail.depts.new-dept', {
            parent: 'board.dinghy.event.detail.depts',
            url: '/new/{userId}',
            data: {
                authorities: ['ROLE_FINANCE']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', 'entity', function($stateParams, $state, $uibModal, entity) {
                $uibModal.open({
                    templateUrl: 'app/board/dept/dept-dialog.html',
                    controller: 'BoardDeptDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'md',
                    resolve: {
                        translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                            $translatePartialLoader.addPart('booking');
                            $translatePartialLoader.addPart('payment');
                            $translatePartialLoader.addPart('enumPaymentCategory');
                            return $translate.refresh();
                        }],
                        entity: function () {
                            return {
                                date: new Date(),
                                reference: null,
                                pointValue: 0,
                                amount: null,
                                comment: null,
                                category: "",
                                sepa: null,
                                paymentStatus: null,
                                id: null
                            };
                        },
                        entityProfile: ['MemberManagement', function(MemberManagement) {
                            return MemberManagement.get({id: $stateParams.userId}).$promise;
                        }],
                        entityProject: null,
                        entityDinghyEvent: entity
                    }
                }).result.then(function() {
                    $state.go('board.dinghy.event.detail.depts', null, { reload: 'board.dinghy.event.detail' });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('board.dinghy.event.detail.depts.new-dept-event', {
            parent: 'board.dinghy.event.detail.depts',
            url: '/new',
            data: {
                authorities: ['ROLE_FINANCE']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', 'entity', function($stateParams, $state, $uibModal, entity) {
                $uibModal.open({
                    templateUrl: 'app/board/dept/dept-dialog.html',
                    controller: 'BoardDeptDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'md',
                    resolve: {
                        translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                            $translatePartialLoader.addPart('booking');
                            $translatePartialLoader.addPart('payment');
                            $translatePartialLoader.addPart('enumPaymentCategory');
                            return $translate.refresh();
                        }],
                        entity: function () {
                            return {
                                date: new Date(),
                                reference: null,
                                pointValue: 0,
                                amount: null,
                                comment: null,
                                category: "",
                                sepa: null,
                                paymentStatus: null,
                                id: null
                            };
                        },
                        entityProfile: null,
                        entityProject: null,
                        entityDinghyEvent: entity
                    }
                }).result.then(function() {
                    $state.go('board.dinghy.event.detail.depts', null, { reload: 'board.dinghy.event.detail' });
                }, function() {
                    $state.go('^');
                });
            }]
        });
    }
})();

/*
 * Copyright (c) 2021 by Felix Heim, felix-heim@web.de
 *
 * This product includes software developed at
 * The Apache Software Foundation (http://www.apache.org/).
 */

(function () {
    'use strict';

    angular
        .module('askApp')
        .controller('DinghyEventDeptsController', DinghyEventDeptsController);

    DinghyEventDeptsController.$inject = ['entity', '$state', '$http', '$stateParams'];

    function DinghyEventDeptsController(entity, $state, $http, $stateParams) {
        var vm = this;
        vm.dinghyEvent = entity;

        vm.dataExport = dataExport;
        vm.abs = abs;
        vm.depts = [];

        $http.get('api/board/dinghy-events/depts', {
            params: {
                eventId: entity.id
            }
        }).then(function (response) {
            vm.depts = response.data;
        });

        // could be replaced with vm.dinghyEvent.bookedPlaces but this way it gets refreshed every time (not only with event reload)
        $http.get('api/board/dinghy-bookings/summary', {
            params: {
                eventId: entity.id
            }
        }).then(function(response) {
            vm.status = response.data;
            vm.validPlaces = vm.status.countAngemeldet + vm.status.countWarteliste;
            vm.freePlaces = vm.dinghyEvent.placeCount - vm.validPlaces;
        });

        function dataExport() {
            vm.isSaving = true;
            $http.get('api/board/dinghy-events/export/', {
                params: {
                    eventId: $stateParams.id
                }
            }).then(function (response) {
                vm.isSaving = false;
                AlertService.success("Der Export wurde erfolgreich durchgeführt und an deine E-Mail Adresse geschickt.");
            }).catch(function () {
                vm.isSaving = false;
            });
        }

        function abs(data) {
            return Math.abs(data);
        }
    }
})();

/*
 * Copyright (c) 2020 by Felix Heim, felix-heim@web.de
 *
 * This product includes software developed at
 * The Apache Software Foundation (http://www.apache.org/).
 */

(function() {
    'use strict';

    angular
        .module('askApp')
        .controller('DinghyEventDetailBookingDialogController', DinghyEventDetailBookingDialogController);

    DinghyEventDetailBookingDialogController.$inject = ['$timeout', '$scope', '$uibModalInstance', 'entity', 'entityBooking', 'DinghyDetailBooking'];

    function DinghyEventDetailBookingDialogController ($timeout, $scope, $uibModalInstance, entity, entityBooking, DinghyDetailBooking) {
        var vm = this;

        vm.dinghyEvent = entity;
        vm.booking = entityBooking;
        vm.nickname = vm.booking.profile.nickname ? " \"" + vm.booking.profile.nickname + "\"" : "";
        vm.isNewBooking = vm.booking.bookingStatus == null;
        if (!vm.isNewBooking) {
            vm.oldBookingStatus = vm.booking.bookingStatus;
            vm.booking.sendNotificationMail = true;
        }
        vm.clear = clear;
        vm.save = save;

        if (vm.isNewBooking
            && (vm.dinghyEvent.canceled || vm.dinghyEvent.closed || !vm.dinghyEvent.active || !vm.dinghyEvent.allowGuests || (vm.dinghyEvent.guestPrice && vm.dinghyEvent.guestPrice > 0))) {
            // same check as for the new button
            // ng-if="vm.allowGuests && (!vm.dinghyEvent.guestPrice || vm.dinghyEvent.guestPrice == 0)"
            // ng-disabled="vm.isSaving || vm.dinghyEvent.canceled || vm.dinghyEvent.closed || !vm.dinghyEvent.active"
            $timeout(function() {
                clear();
            });
        }

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function save () {
            vm.isSaving = true;
            if (vm.isNewBooking) {
                DinghyDetailBooking.save(vm.booking, onSaveSuccess, onSaveError);
            } else {
                DinghyDetailBooking.update(vm.booking, onSaveSuccess, onSaveError);
            }
        }

        function onSaveSuccess (result) {
            if (vm.isNewBooking) {
                $scope.$emit('askApp:dinghyBookingUpdate', result);
            } else {
                $scope.$emit('askApp:dinghyBookingCreate', result);
            }
            $uibModalInstance.close(result);
            vm.isSaving = false;
        }

        function onSaveError () {
            vm.isSaving = false;
        }
    }
})();

/*
 * Copyright (c) 2020 by Felix Heim, felix-heim@web.de
 *
 * This product includes software developed at
 * The Apache Software Foundation (http://www.apache.org/).
 */

(function() {
    'use strict';

    angular
        .module('askApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
        .state('board.dinghy.event.detail.booking', {
            parent: 'board.dinghy.event.detail',
            url: '/booking?page&sort&search',
            data: {
                authorities: ['ROLE_BOARD','ROLE_DINGHY'],
                pageTitle: 'askApp.booking.home.title3'
            },
            views: {
                'dinghyDetail@board.dinghy.event.detail': {
                    templateUrl: 'app/board/dinghy/event/detail/bookings/dinghy-bookings.html',
                    controller: 'DinghyEventDetailBookingController',
                    controllerAs: 'vm'
                }
            },
            params: {
                page: {
                    value: '1',
                    squash: true
                },
                sort: {
                    value: 'validationDate,desc',
                    squash: true
                },
                search: null
            },
            resolve: {
                pagingParams: ['$stateParams', 'PaginationUtil', function ($stateParams, PaginationUtil) {
                    return {
                        page: PaginationUtil.parsePage($stateParams.page),
                        sort: $stateParams.sort,
                        predicate: PaginationUtil.parsePredicate($stateParams.sort),
                        ascending: PaginationUtil.parseAscending($stateParams.sort),
                        search: $stateParams.search
                    };
                }],
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('dept');
                    $translatePartialLoader.addPart('booking');
                    $translatePartialLoader.addPart('dinghy');
                    $translatePartialLoader.addPart('dinghyBooking');
                    $translatePartialLoader.addPart('enumDeptStatus');
                    $translatePartialLoader.addPart('enumBookingStatusType');
                    return $translate.refresh();
                }]
            }
        })
        .state('board.dinghy.event.detail.booking.edit', {
            parent: 'board.dinghy.event.detail.booking',
            url: '/{idBooking}/edit',
            data: {
                authorities: ['ROLE_BOARD','ROLE_DINGHY']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', 'entity', function($stateParams, $state, $uibModal, entity) {
                $uibModal.open({
                    templateUrl: 'app/board/dinghy/event/detail/bookings/dinghy-booking-dialog.html',
                    controller: 'DinghyEventDetailBookingDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'md',
                    resolve: {
                        entityBooking: ['DinghyDetailBooking', function(DinghyDetailBooking) {
                            return DinghyDetailBooking.get({id : $stateParams.idBooking}).$promise;
                        }],
                        entity: entity,
                        translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                            $translatePartialLoader.addPart('settings');
                            return $translate.refresh();
                        }]
                    }
                }).result.then(function() {
                    $state.go('board.dinghy.event.detail.booking', null, { reload: 'board.dinghy.event.detail' });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('board.dinghy.event.detail.booking.new', {
            parent: 'board.dinghy.event.detail.booking',
            url: '/new',
            data: {
                authorities: ['ROLE_BOARD','ROLE_DINGHY']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', 'entity', function($stateParams, $state, $uibModal, entity) {
                $uibModal.open({
                    templateUrl: 'app/board/dinghy/event/detail/bookings/dinghy-booking-dialog.html',
                    controller: 'DinghyEventDetailBookingDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'md',
                    resolve: {
                        entity: entity,
                        entityBooking: function () {
                            return {
                                id: entity.id,
                                bookingStatus: null,
                                comment: null,
                                individualQuestionAnswer: null,
                                dingy: null,
                                commentDinghy: null,
                                profile: {
                                    id: null,
                                    firstName: "",
                                    lastName: "",
                                    mail: "",
                                    phone: null
                                }
                            };
                        },
                        translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                            $translatePartialLoader.addPart('settings');
                            return $translate.refresh();
                        }]
                    }
                }).result.then(function() {
                    $state.go('board.dinghy.event.detail.booking', null, { reload: 'board.dinghy.event.detail' });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('board.dinghy.event.detail.booking.delete', {
            parent: 'board.dinghy.event.detail.booking',
            url: '/{idBooking}/delete',
            data: {
                authorities: ['ROLE_BOARD','ROLE_DINGHY']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/board/dinghy/bookings/dinghy-booking-delete-dialog.html',
                    controller: 'BoardDinghyBookingDeleteController',
                    controllerAs: 'vm',
                    size: 'md',
                    resolve: {
                        entity: ['BoardDinghyBooking', function(BoardDinghyBooking) {
                            return BoardDinghyBooking.get({id : $stateParams.idBooking}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('board.dinghy.event.detail.booking', null, { reload: 'board.dinghy.event.detail' });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('board.dinghy.event.detail.booking.edit-dept', {
            parent: 'board.dinghy.event.detail.booking',
            url: '/dept/{deptId}/edit',
            data: {
                authorities: ['ROLE_FINANCE']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/board/dept/dept-dialog.html',
                    controller: 'BoardDeptDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'md',
                    resolve: {
                        translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                            $translatePartialLoader.addPart('payment');
                            $translatePartialLoader.addPart('enumPaymentCategory');
                            return $translate.refresh();
                        }],
                        entity: ['Dept', function(Dept) {
                            return Dept.get({id : $stateParams.deptId}).$promise;
                        }],
                        entityProfile: null,
                        entityProject: null,
                        entityDinghyEvent: null
                    }
                }).result.then(function() {
                    $state.go('board.dinghy.event.detail.booking', null, { reload: 'board.dinghy.event.detail' });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('board.dinghy.event.detail.booking.new-dept', {
            parent: 'board.dinghy.event.detail.booking',
            url: '/dept/new/{userId}',
            data: {
                authorities: ['ROLE_FINANCE']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', 'entity', function($stateParams, $state, $uibModal, entity) {
                $uibModal.open({
                    templateUrl: 'app/board/dept/dept-dialog.html',
                    controller: 'BoardDeptDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'md',
                    resolve: {
                        translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                            $translatePartialLoader.addPart('payment');
                            $translatePartialLoader.addPart('enumPaymentCategory');
                            return $translate.refresh();
                        }],
                        entity: function () {
                            return {
                                date: new Date(),
                                reference: null,
                                pointValue: 0,
                                amount: null,
                                comment: null,
                                category: "",
                                sepa: null,
                                paymentStatus: null,
                                id: null
                            };
                        },
                        entityProfile: ['MemberManagement', function(MemberManagement) {
                            return MemberManagement.get({id: $stateParams.userId}).$promise;
                        }],
                        entityProject: null,
                        entityDinghyEvent: entity
                    }
                }).result.then(function() {
                    $state.go('board.dinghy.event.detail.booking', null, { reload: 'board.dinghy.event.detail' });
                }, function() {
                    $state.go('^');
                });
            }]
        });
    }
})();

/*
 * Copyright (c) 2020 by Felix Heim, felix-heim@web.de
 *
 * This product includes software developed at
 * The Apache Software Foundation (http://www.apache.org/).
 */

(function() {
    'use strict';
    angular
        .module('askApp')
        .factory('DinghyDetailBooking', DinghyDetailBooking);

    DinghyDetailBooking.$inject = ['$resource', 'DateUtils'];

    function DinghyDetailBooking ($resource, DateUtils) {
        var resourceUrl =  'api/board/dinghy-bookings/detail/:id';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true},
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                        data.bookingDate = DateUtils.convertDateTimeFromServer(data.bookingDate);
                    }
                    return data;
                }
            },
            'update': { method: 'PUT' }
        });
    }
})();

/*
 * Copyright (c) 2020 by Felix Heim, felix-heim@web.de
 *
 * This product includes software developed at
 * The Apache Software Foundation (http://www.apache.org/).
 */

(function() {
    'use strict';

    angular
        .module('askApp')
        .controller('DinghyEventDetailBookingController', DinghyEventDetailBookingController);

    DinghyEventDetailBookingController.$inject = ['$state', 'DinghyDetailBooking', 'BookingSearch', 'ParseLinks', 'AlertService', 'paginationConstants', 'pagingParams', '$stateParams', 'entity', '$http', 'Principal'];

    function DinghyEventDetailBookingController($state, DinghyDetailBooking, BookingSearch, ParseLinks, AlertService, paginationConstants, pagingParams, $stateParams, entity, $http, Principal) {

        var vm = this;

        vm.isBoard = false;
        Principal.hasAuthority('ROLE_BOARD').then(function (result) {
            vm.isBoard = result;
        });

        vm.loadPage = loadPage;
        vm.predicate = pagingParams.predicate;
        vm.reverse = pagingParams.ascending;
        vm.transition = transition;
        vm.itemsPerPage = paginationConstants.itemsPerPage;
        vm.clear = clear;
        vm.search = search;
        vm.loadAll = loadAll;
        vm.searchQuery = pagingParams.search;
        vm.currentSearch = pagingParams.search;
        vm.dinghyEvent = entity;
        vm.dataExport = dataExport;
        vm.refresh = refresh;

        loadAll();

        function loadAll () {
            DinghyDetailBooking.query({
                page: pagingParams.page - 1,
                size: vm.itemsPerPage,
                sort: sort(),
                eventId: $stateParams.id
            }, onSuccess, onError);

            // could be replaced with vm.dinghyEvent.bookedPlaces but this way it gets refreshed every time (not only with event reload)
            $http.get('api/board/dinghy-bookings/summary', {
                params: {
                    eventId: entity.id
                }
            }).then(function(response) {
                vm.status = response.data;
                vm.validPlaces = vm.status.countAngemeldet + vm.status.countWarteliste;
                vm.freePlaces = vm.dinghyEvent.placeCount - vm.validPlaces;
            });

            function sort() {
                var sorting = vm.reverse ? 'asc' : 'desc';
                var result = [vm.predicate + ',' + sorting];
                if (vm.predicate !== 'id') {
                    result.push('id,' + sorting);
                }
                return result;
            }
            function onSuccess(data, headers) {
                vm.links = ParseLinks.parse(headers('link'));
                vm.totalItems = headers('X-Total-Count');
                vm.queryCount = vm.totalItems;
                vm.bookings = data;
                vm.page = pagingParams.page;
                //console.log(vm.bookings);
            }
            function onError(error) {
                AlertService.error(error.data.message);
            }
        }

        function loadPage(page) {
            vm.page = page;
            vm.transition();
        }

        function transition() {
            $state.transitionTo($state.$current, {
                page: vm.page,
                sort: vm.predicate + ',' + (vm.reverse ? 'asc' : 'desc'),
                search: vm.currentSearch,
                id: $stateParams.id
            });
        }

        function search(searchQuery) {
            if (!searchQuery){
                return vm.clear();
            }
            vm.links = null;
            vm.page = 1;
            vm.predicate = '_score';
            vm.reverse = false;
            vm.currentSearch = searchQuery;
            vm.transition();
        }

        function clear() {
            vm.links = null;
            vm.page = 1;
            vm.predicate = 'id';
            vm.reverse = true;
            vm.currentSearch = null;
            vm.transition();
        }

        function refresh() {
            vm.isSaving = true;
            $state.go($state.current, null, {reload: $state.current.parent});
            // loadAll();
            // vm.isSaving = false;
        }

        function dataExport() {
            vm.isSaving = true;
            $http.get('api/board/dinghy-bookings/export/', {params:{
                eventId: $stateParams.id
            }}).then(function(response) {
                vm.isSaving = false;
                AlertService.success("Der Export wurde erfolgreich durchgeführt und an deine E-Mail Adresse geschickt.");
            });
        }
    }
})();

/*
 * Copyright (c) 2020 by Felix Heim, felix-heim@web.de
 *
 * This product includes software developed at
 * The Apache Software Foundation (http://www.apache.org/).
 */

(function() {
    'use strict';

    angular
        .module('askApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider.state('board.dinghy', {
            parent: 'board',
            url: '/board/dinghy',
            views: {
                'content@': {
                    templateUrl: 'app/board/dinghy/dinghyNavbar.html',
                    controller: 'DinghyNavController',
                    controllerAs: 'vm'
                }
            }
        });
    }
})();

/*
 * Copyright (c) 2020 by Felix Heim, felix-heim@web.de
 *
 * This product includes software developed at
 * The Apache Software Foundation (http://www.apache.org/).
 */

(function() {
    'use strict';

    angular
        .module('askApp')
        .controller('DinghyNavController', DinghyNavController);

    DinghyNavController.$inject = ['$stateParams', '$scope', '$state'];

    function DinghyNavController($stateParams, $scope, $state) {
        var vm = this;
        vm.id = $stateParams.id;
        vm.$state = $state;
        $scope.currentObj = {};
        $scope.currentObj.name = null;

        vm.states = [['board.dinghy.event', 'askApp.dinghy.event.title'],
                    ['board.dinghy.booking', 'askApp.dinghy.bookings.title'],
                    ['board.dinghy.dinghy','askApp.dinghy.detail.title'],
                    ['board.dinghy.dinghy.new','askApp.dinghy.home.createLabel'],
                    ['board.dinghy.presence', 'askApp.dinghy.presence.title'],
                    ['board.dinghy.plan', 'askApp.dinghy.plan.title'],
                    ['board.dinghy.newsletter', 'askApp.dinghy.newsletter.title']];
    }
})();

/*
 * Copyright (c) 2020 by Felix Heim, felix-heim@web.de
 *
 * This product includes software developed at
 * The Apache Software Foundation (http://www.apache.org/).
 */

(function() {
    'use strict';

    angular
        .module('askApp')
        .controller('DinghyDetailBoardController', DinghyDetailBoardController);

    DinghyDetailBoardController.$inject = ['$timeout', '$scope', '$state', '$stateParams', 'entity', 'DinghyBoard', 'Principal'];

    function DinghyDetailBoardController ($timeout, $scope, $state, $stateParams, entity, DinghyBoard, Principal) {
        var vm = this;

        vm.dinghy = entity;
        vm.wasActive = vm.dinghy.active;
        vm.dinghyName = vm.dinghy.name;
        $scope.currentObj.name = vm.dinghy.name;
        vm.save = save;
        vm.clear = clear;

        vm.isBoard = false;
        Principal.hasAuthority('ROLE_BOARD').then(function (result) {
            vm.isBoard = result;
        });

        $timeout(function (){
            angular.element('.form-group:eq(1)>input').focus();
        });

        function clear () {
            $state.go('board.dinghy.dinghy');
        }

        function save () {
            vm.isSaving = true;
            if (vm.dinghy.id !== null) {
                DinghyBoard.update(vm.dinghy, onSaveSuccess, onSaveError);
            } else {
                DinghyBoard.save(vm.dinghy, onSaveSuccess, onSaveError);
            }
        }

        function onSaveSuccess (result) {
            $scope.$emit('askApp:dinghyUpdate', result);
            // console.log(result.id);
            $state.go('board.dinghy.dinghy.edit', {id: result.id}, { reload: 'board.dinghy.dinghy' });
            vm.isSaving = false;
        }

        function onSaveError () {
            vm.isSaving = false;
        }

        // summernote editor config
        vm.options = {
            toolbar: [
                ['style', ['bold', 'italic', 'underline', 'clear']],
                ['textsize', ['fontsize']],
                ['fontclr', ['color']],
                ['alignment', ['ul', 'ol']],
                ['view', ['codeview']]
            ]
        };

    }
})();

/*
 * Copyright (c) 2020 by Felix Heim, felix-heim@web.de
 *
 * This product includes software developed at
 * The Apache Software Foundation (http://www.apache.org/).
 */

(function() {
    'use strict';

    angular
        .module('askApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
        .state('board.dinghy.dinghy', {
            parent: 'board.dinghy',
            url: '/dinghies?sort',
            data: {
                authorities: ['ROLE_BOARD', 'ROLE_DINGHY'],
                pageTitle: 'askApp.dinghy.detail.title'
            },
            views: {
                'dinghy@board.dinghy': {
                    templateUrl: 'app/board/dinghy/dinghy/dinghies.html',
                    controller: 'DinghyBoardController',
                    controllerAs: 'vm'
                }
            },
            params: {
                sort: {
                    value: 'type,asc',
                    squash: true
                }
            },
            resolve: {
                pagingParams: ['$stateParams', 'PaginationUtil', function ($stateParams, PaginationUtil) {
                    return {
                        page: 1,
                        sort: $stateParams.sort,
                        predicate: PaginationUtil.parsePredicate($stateParams.sort),
                        ascending: PaginationUtil.parseAscending($stateParams.sort),
                        search: null
                    };
                }],
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('dinghy');
                    $translatePartialLoader.addPart('global');
                    return $translate.refresh();
                }]
            }
        })
        .state('board.dinghy.dinghy.new', {
            parent: 'board.dinghy.dinghy',
            url: '/new',
            data: {
                authorities: ['ROLE_BOARD'],
                pageTitle: 'askApp.dinghy.home.createLabel'
            },
            views: {
                'dinghyDetail@board.dinghy.dinghy': {
                    templateUrl: 'app/board/dinghy/dinghy/dinghy-detail.html',
                    controller: 'DinghyDetailBoardController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('dinghy');
                    $translatePartialLoader.addPart('global');
                    return $translate.refresh();
                }],
                entity: function () {
                    return {
                        name: null,
                        description: null,
                        comment: null,
                        available: true,
                        type: null,
                        active: true,
                        dateDeactivated: null,
                        id: null
                    };
                }
            }
        })
        .state('board.dinghy.dinghy.edit', {
            parent: 'board.dinghy.dinghy',
            url: '/{id}/edit',
            data: {
                authorities: ['ROLE_BOARD', 'ROLE_DINGHY'],
                pageTitle: 'askApp.dinghy.home.editLabel'
            },
            views: {
                'dinghyDetail@board.dinghy.dinghy': {
                    templateUrl: 'app/board/dinghy/dinghy/dinghy-detail.html',
                    controller: 'DinghyDetailBoardController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('dinghy');
                    $translatePartialLoader.addPart('global');
                    return $translate.refresh();
                }],
                entity: ['$stateParams', 'DinghyBoard', function($stateParams, DinghyBoard) {
                    return DinghyBoard.get({id : $stateParams.id}).$promise;
                }]
            }
        });
    }
})();

/*
 * Copyright (c) 2020 by Felix Heim, felix-heim@web.de
 *
 * This product includes software developed at
 * The Apache Software Foundation (http://www.apache.org/).
 */

(function() {
    'use strict';
    angular
        .module('askApp')
        .factory('DinghyBoard', DinghyBoard);

    DinghyBoard.$inject = ['$resource', 'DateUtils'];

    function DinghyBoard ($resource, DateUtils) {
        var resourceUrl =  'api/board/dinghies/:id';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true},
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                        data.dateDeactivated = DateUtils.convertLocalDateFromServer(data.dateDeactivated);
                    }
                    return data;
                }
            },
            'update': {
                method: 'PUT',
                transformRequest: function (data) {
                    var copy = angular.copy(data);
                    copy.dateDeactivated = DateUtils.convertLocalDateToServer(copy.dateDeactivated);
                    return angular.toJson(copy);
                }
            },
            'save': {
                method: 'POST',
                transformRequest: function (data) {
                    var copy = angular.copy(data);
                    copy.dateDeactivated = DateUtils.convertLocalDateToServer(copy.dateDeactivated);
                    return angular.toJson(copy);
                }
            }
        });
    }
})();


/*
 * Copyright (c) 2020 by Felix Heim, felix-heim@web.de
 *
 * This product includes software developed at
 * The Apache Software Foundation (http://www.apache.org/).
 */

(function() {
    'use strict';

    angular
        .module('askApp')
        .controller('DinghyBoardController', DinghyBoardController);

    DinghyBoardController.$inject = ['$state', '$scope','$sce', 'DinghyBoard', 'ParseLinks', 'AlertService', 'pagingParams'];

    function DinghyBoardController($state, $scope, $sce, DinghyBoard, ParseLinks, AlertService, pagingParams) {
        var vm = this;

        vm.predicate = pagingParams.predicate;
        vm.reverse = pagingParams.ascending;
        vm.transition = transition;
        vm.itemsPerPage = 99;
        vm.loadAll = loadAll;
        vm.dinghies = [];
        vm.dinghies_inactive = [];

        loadAll();

        function loadAll () {
            DinghyBoard.query({
                page: pagingParams.page - 1,
                size: vm.itemsPerPage,
                sort: sort(),
                active: true
            }, function (result) {
                vm.dinghies = result;
            }, onError);
            DinghyBoard.query({
                page: pagingParams.page - 1,
                size: vm.itemsPerPage,
                sort: ['dateDeactivated,desc'],
                active: false
            }, function (result) {
                vm.dinghies_inactive = result;
            }, onError);
        }

        function sort() {
            var sorting = vm.reverse ? 'asc' : 'desc';
            var result = [vm.predicate + ',' + sorting];
            if (vm.predicate !== 'type') {
                result.push('type,' + sorting)
            }
            if (vm.predicate !== 'id') {
                result.push('id,' + sorting);
            }
            return result;
        }

        function onError(error) {
            AlertService.error(error.data.message);
        }

        function transition() {
            $state.transitionTo($state.$current, {
                page: vm.page,
                sort: vm.predicate + ',' + (vm.reverse ? 'asc' : 'desc'),
                search: null
            });
        }

        var trusted = {};
        $scope.getPopoverContent = function(content) {
            return trusted[content] || (trusted[content] = $sce.trustAsHtml(content));
        }

    }
})();

/*
 * Copyright (c) 2021 by Felix Heim, felix-heim@web.de
 *
 * This product includes software developed at
 * The Apache Software Foundation (http://www.apache.org/).
 */

(function() {
    'use strict';
    angular
        .module('askApp')
        .factory('MemberManagementDinghy', MemberManagementDinghy);

    MemberManagementDinghy.$inject = ['$resource', 'DateUtils'];

    function MemberManagementDinghy ($resource, DateUtils) {
        var resourceUrl =  'api/board/profiles/dinghy/:id';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true},
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                        data.birthdate = DateUtils.convertLocalDateFromServer(data.birthdate);
                    }
                    return data;
                }
            }
        });
    }
})();

/*
 * Copyright (c) 2020 by Felix Heim, felix-heim@web.de
 *
 * This product includes software developed at
 * The Apache Software Foundation (http://www.apache.org/).
 */

(function() {
    'use strict';

    angular
        .module('askApp')
        .controller('BoardDinghyBookingDialogController', BoardDinghyBookingDialogController);

    BoardDinghyBookingDialogController.$inject = ['$timeout', '$scope', '$uibModalInstance', 'entity', 'BoardDinghyBooking'];

    function BoardDinghyBookingDialogController ($timeout, $scope, $uibModalInstance, entity, BoardDinghyBooking) {
        var vm = this;

        vm.booking = entity;
        vm.nickname = vm.booking.profile.nickname ? " \"" + vm.booking.profile.nickname + "\"" : "";
        vm.oldBookingStatus = vm.booking.bookingStatus;
        vm.booking.sendNotificationMail = true;
        vm.clear = clear;
        vm.save = save;

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function save () {
            vm.isSaving = true;
            BoardDinghyBooking.update(vm.booking, onSaveSuccess, onSaveError);
        }

        function onSaveSuccess (result) {
            if (vm.isNewBooking) {
                $scope.$emit('askApp:dinghyBookingUpdate', result);
            } else {
                $scope.$emit('askApp:dinghyBookingCreate', result);
            }
            $uibModalInstance.close(result);
            vm.isSaving = false;
        }

        function onSaveError () {
            vm.isSaving = false;
        }
    }
})();

/*
 * Copyright (c) 2020 by Felix Heim, felix-heim@web.de
 *
 * This product includes software developed at
 * The Apache Software Foundation (http://www.apache.org/).
 */

(function() {
    'use strict';

    angular
        .module('askApp')
        .controller('BoardDinghyBookingDeleteController', BoardDinghyBookingDeleteController);

    BoardDinghyBookingDeleteController.$inject = ['$uibModalInstance', 'entity', 'BoardDinghyBooking'];

    function BoardDinghyBookingDeleteController($uibModalInstance, entity, BoardDinghyBooking) {
        var vm = this;

        vm.booking = entity;
        vm.nickname = vm.booking.profile.nickname ? " \"" + vm.booking.profile.nickname + "\"" : "";
        vm.clear = clear;
        vm.confirmDelete = confirmDelete;

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function confirmDelete (id) {
            BoardDinghyBooking.delete({id: id},
                function () {
                    $uibModalInstance.close(true);
                });
        }
    }
})();

/*
 * Copyright (c) 2020 by Felix Heim, felix-heim@web.de
 *
 * This product includes software developed at
 * The Apache Software Foundation (http://www.apache.org/).
 */

(function() {
    'use strict';

    angular
        .module('askApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
        .state('board.dinghy.booking', {
            parent: 'board.dinghy',
            url: '/{select}/booking?page&sort&search',
            data: {
                authorities: ['ROLE_BOARD','ROLE_DINGHY'],
                pageTitle: 'askApp.dinghyBooking.home.title'
            },
            views: {
                'dinghy@board.dinghy': {
                    templateUrl: 'app/board/dinghy/bookings/dinghy-bookings.html',
                    controller: 'BoardDinghyBookingController',
                    controllerAs: 'vm'
                }
            },
            params: {
                page: {
                    value: '1',
                    squash: true
                },
                sort: {
                    value: 'validationDate,desc',
                    squash: true
                },
                search: null
            },
            resolve: {
                pagingParams: ['$stateParams', 'PaginationUtil', function ($stateParams, PaginationUtil) {
                    return {
                        page: PaginationUtil.parsePage($stateParams.page),
                        sort: $stateParams.sort,
                        predicate: PaginationUtil.parsePredicate($stateParams.sort),
                        ascending: PaginationUtil.parseAscending($stateParams.sort),
                        search: $stateParams.search,
                        select: $stateParams.select
                    };
                }],
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('dept');
                    $translatePartialLoader.addPart('booking');
                    $translatePartialLoader.addPart('dinghy');
                    $translatePartialLoader.addPart('dinghyBooking');
                    $translatePartialLoader.addPart('enumDeptStatus');
                    $translatePartialLoader.addPart('enumBookingStatusType');
                    $translatePartialLoader.addPart('enumDinghyEventType');
                    return $translate.refresh();
                }],
                entity: ['$stateParams', 'MemberManagementDinghy', function($stateParams, MemberManagementDinghy) {
                    if($stateParams.select) {
                        return MemberManagementDinghy.get({id : $stateParams.select}).$promise;
                    }
                    return null;
                }]
            }
        })
        .state('board.dinghy.booking.edit', {
            parent: 'board.dinghy.booking',
            url: '/{id}/edit',
            data: {
                authorities: ['ROLE_BOARD','ROLE_DINGHY']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/board/dinghy/bookings/dinghy-booking-dialog.html',
                    controller: 'BoardDinghyBookingDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'md',
                    resolve: {
                        entity: ['BoardDinghyBooking', function(BoardDinghyBooking) {
                            return BoardDinghyBooking.get({id : $stateParams.id}).$promise;
                        }],
                        translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                            $translatePartialLoader.addPart('settings');
                            return $translate.refresh();
                        }]
                    }
                }).result.then(function() {
                    $state.go('board.dinghy.booking', null, { reload: 'board.dinghy.booking' });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('board.dinghy.booking.delete', {
            parent: 'board.dinghy.booking',
            url: '/{id}/delete',
            data: {
                authorities: ['ROLE_BOARD','ROLE_DINGHY']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/board/dinghy/bookings/dinghy-booking-delete-dialog.html',
                    controller: 'BoardDinghyBookingDeleteController',
                    controllerAs: 'vm',
                    size: 'md',
                    resolve: {
                        entity: ['BoardDinghyBooking', function(BoardDinghyBooking) {
                            return BoardDinghyBooking.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('board.dinghy.booking', null, { reload: 'board.dinghy.booking' });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('board.dinghy.booking.edit-dept', {
            parent: 'board.dinghy.booking',
            url: '/dept/{deptId}/edit',
            data: {
                authorities: ['ROLE_FINANCE']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/board/dept/dept-dialog.html',
                    controller: 'BoardDeptDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'md',
                    resolve: {
                        translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                            $translatePartialLoader.addPart('payment');
                            $translatePartialLoader.addPart('enumPaymentCategory');
                            return $translate.refresh();
                        }],
                        entity: ['Dept', function(Dept) {
                            return Dept.get({id : $stateParams.deptId}).$promise;
                        }],
                        entityProfile: null,
                        entityProject: null,
                        entityDinghyEvent: null
                    }
                }).result.then(function() {
                    $state.go('board.dinghy.booking', null, { reload: 'board.dinghy.booking' });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('board.dinghy.booking.new-dept', {
            parent: 'board.dinghy.booking',
            url: '/dept/new/{eventId}/{userId}',
            data: {
                authorities: ['ROLE_FINANCE']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/board/dept/dept-dialog.html',
                    controller: 'BoardDeptDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'md',
                    resolve: {
                        translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                            $translatePartialLoader.addPart('payment');
                            $translatePartialLoader.addPart('enumPaymentCategory');
                            return $translate.refresh();
                        }],
                        entity: function () {
                            return {
                                date: new Date(),
                                reference: null,
                                pointValue: 0,
                                amount: null,
                                comment: null,
                                category: "",
                                sepa: null,
                                paymentStatus: null,
                                id: null
                            };
                        },
                        entityProfile: ['MemberManagement', function(MemberManagement) {
                            return MemberManagement.get({id: $stateParams.userId}).$promise;
                        }],
                        entityProject: null,
                        entityDinghyEvent: ['DinghyEventBoard', function(DinghyEventBoard) {
                            return DinghyEventBoard.get({id: $stateParams.eventId}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('board.dinghy.booking', null, { reload: 'board.dinghy.booking' });
                }, function() {
                    $state.go('^');
                });
            }]
        });
    }

})();

/*
 * Copyright (c) 2020 by Felix Heim, felix-heim@web.de
 *
 * This product includes software developed at
 * The Apache Software Foundation (http://www.apache.org/).
 */

(function() {
    'use strict';
    angular
        .module('askApp')
        .factory('BoardDinghyBooking', BoardDinghyBooking);

    BoardDinghyBooking.$inject = ['$resource', 'DateUtils'];

    function BoardDinghyBooking ($resource, DateUtils) {
        var resourceUrl =  'api/board/dinghy-bookings/:id';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true},
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                        data.bookingDate = DateUtils.convertDateTimeFromServer(data.bookingDate);
                    }
                    return data;
                }
            },
            'update': { method:'PUT' }
        });
    }
})();

/*
 * Copyright (c) 2020 by Felix Heim, felix-heim@web.de
 *
 * This product includes software developed at
 * The Apache Software Foundation (http://www.apache.org/).
 */

(function() {
    'use strict';

    angular
        .module('askApp')
        .factory('BoardDinghyBookingSearch', BoardDinghyBookingSearch);

    BoardDinghyBookingSearch.$inject = ['$resource'];

    function BoardDinghyBookingSearch($resource) {
        var resourceUrl =  'api/_search/board/dinghy-bookings/:id';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true}
        });
    }
})();

/*
 * Copyright (c) 2020 by Felix Heim, felix-heim@web.de
 *
 * This product includes software developed at
 * The Apache Software Foundation (http://www.apache.org/).
 */

(function() {
    'use strict';
    angular
        .module('askApp')
        .factory('BoardDetailDinghyBooking', BoardDetailDinghyBooking);

    BoardDetailDinghyBooking.$inject = ['$resource', 'DateUtils'];

    function BoardDetailDinghyBooking ($resource, DateUtils) {
        var resourceUrl =  'api/board/dinghy-bookings/detail/:id';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true},
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                        data.bookingDate = DateUtils.convertDateTimeFromServer(data.bookingDate);
                    }
                    return data;
                }
            },
            'update': { method:'PUT' }
        });
    }
})();

/*
 * Copyright (c) 2020 by Felix Heim, felix-heim@web.de
 *
 * This product includes software developed at
 * The Apache Software Foundation (http://www.apache.org/).
 */

(function() {
    'use strict';

    angular
        .module('askApp')
        .controller('BoardDinghyBookingController', BoardDinghyBookingController);

    BoardDinghyBookingController.$inject = ['$state', 'BoardDinghyBooking', 'BoardDinghyBookingSearch', 'ParseLinks', 'AlertService', 'paginationConstants', 'pagingParams', 'entity', '$stateParams', '$http', 'Principal'];

    function BoardDinghyBookingController($state, BoardDinghyBooking, BoardDinghyBookingSearch, ParseLinks, AlertService, paginationConstants, pagingParams, entity, $stateParams, $http, Principal) {

        var vm = this;

        vm.isBoard = false;
        Principal.hasAuthority('ROLE_BOARD').then(function (result) {
            vm.isBoard = result;
        });

        vm.loadPage = loadPage;
        vm.predicate = pagingParams.predicate;
        vm.reverse = pagingParams.ascending;
        vm.transition = transition;
        vm.itemsPerPage = paginationConstants.itemsPerPage;
        vm.clear = clear;
        vm.search = search;
        vm.loadAll = loadAll;
        vm.getUser = getUser;
        vm.searchQuery = pagingParams.search;
        vm.currentSearch = pagingParams.search;
        vm.select = pagingParams.select;
        vm.selected = null;
        vm.selectUser = selectUser;
        vm.refresh = refresh;

        loadAll();

        function loadAll () {
            if(entity != null) {
                vm.selected = entity.user.firstName + " " + entity.user.lastName + (entity.nickname ? (' "' + entity.nickname + '"') : (''));
            }
            if (pagingParams.search) {
                BoardDinghyBookingSearch.query({
                    query: pagingParams.search,
                    page: pagingParams.page - 1,
                    size: vm.itemsPerPage,
                    sort: sort()
                }, onSuccess, onError);
            } else {
                BoardDinghyBooking.query({
                    page: pagingParams.page - 1,
                    size: vm.itemsPerPage,
                    sort: sort(),
                    profileId: $stateParams.select
                }, onSuccess, onError);
            }
            function sort() {
                var sorting = vm.reverse ? 'asc' : 'desc';
                var result = [vm.predicate + ',' + sorting];
                if (vm.predicate !== 'id') {
                    result.push('id,' + sorting);
                }
                return result;
            }
            function onSuccess(data, headers) {
                vm.links = ParseLinks.parse(headers('link'));
                vm.totalItems = headers('X-Total-Count');
                vm.queryCount = vm.totalItems;
                vm.bookings = data;
                vm.page = pagingParams.page;
                vm.isSaving = false;
            }
            function onError(error) {
                AlertService.error(error.data.message);
                vm.isSaving = false;
            }
        }

        function loadPage(page) {
            vm.page = page;
            vm.transition();
        }

        function transition() {
            $state.transitionTo($state.$current, {
                page: vm.page,
                sort: vm.predicate + ',' + (vm.reverse ? 'asc' : 'desc'),
                search: vm.currentSearch,
                select: vm.select
            });
        }

        function search(searchQuery) {
            if (!searchQuery){
                return vm.clear();
            }
            vm.links = null;
            vm.page = 1;
            vm.predicate = '_score';
            vm.reverse = false;
            vm.currentSearch = searchQuery;
            vm.select = null;
            vm.transition();
        }

        function clear() {
            vm.links = null;
            vm.page = 1;
            vm.predicate = 'id';
            vm.reverse = false;
            vm.currentSearch = null;
            vm.select = null;
            vm.transition();
        }

        function refresh() {
            vm.isSaving = true;
            loadAll();
        }

        function getUser(val) {
            return $http.get('api/_search/profiles_dinghy/', {
                params: {
                    query: val
                }
            }).then(function(response){
                return response.data.map(function(item) {
                    return item;
                });
            });
        }

        function selectUser(item, model) {
            vm.select = model.id;
            vm.transition();
        }
    }
})();

/*
 * Copyright (c) 2017 by Julian Feder, julian.feder@yahoo.de
 *
 * This product includes software developed at
 * The Apache Software Foundation (http://www.apache.org/).
 */

(function () {
    'use strict';

    angular
        .module('askApp')
        .controller('BoardDeptDialogController', BoardDeptDialogController);

    BoardDeptDialogController.$inject = ['$timeout', '$scope', '$stateParams', '$uibModalInstance', 'entity', '$http', 'Dept', 'entityProfile', 'entityProject', 'entityDinghyEvent', 'ProjectActive', 'DinghyEventActive', 'MemberManagement'];

    function BoardDeptDialogController($timeout, $scope, $stateParams, $uibModalInstance, entity, $http, Dept, entityProfile, entityProject, entityDinghyEvent, ProjectActive, DinghyEventActive, MemberManagement) {
        var vm = this;

        vm.dept = entity;
        vm.entityProfile = entityProfile;
        vm.profilePresent = entityProfile != null || vm.dept.profile != null;
        vm.relationClosed = false;
        vm.relationPresent = false;
        vm.hasCrews = false;
        if (vm.dept.id) {
            vm.dept.oldAmount = vm.dept.amount;
            vm.dept.oldApCount = vm.dept.apCount;
            vm.dept.availableActivityPoints += vm.dept.apCount;
            vm.projects = vm.dept.project ? [vm.dept.project] : [];
            vm.dinghyEvents = vm.dept.dinghyEvent ? [vm.dept.dinghyEvent] : [];
            vm.relationClosed = (vm.dept.project && vm.dept.project.closed) || (vm.dept.dinghyEvent && vm.dept.dinghyEvent.closed);
        } else {
            if (entityProject !== null) {
                vm.dept.project = entityProject;
                vm.projects = [vm.dept.project];
                vm.relationClosed = vm.dept.project.closed;
                vm.relationPresent = true;
                vm.hasCrews = vm.dept.project.type === 'event';
            }
            if (entityDinghyEvent !== null) {
                vm.dept.dinghyEvent = entityDinghyEvent;
                vm.dinghyEvents = [vm.dept.dinghyEvent];
                vm.relationClosed = vm.dept.dinghyEvent.closed;
                vm.relationPresent = true;
            }
            if (vm.relationClosed) {
                $timeout(function () {
                    clear();
                });
            }
            vm.dept.profile = vm.entityProfile;
            vm.dept.availableActivityPoints = 0;
        }
        vm.nickname = vm.dept.profile && vm.dept.profile.nickname ? " \"" + vm.dept.profile.nickname + "\"" : "";

        if (!vm.relationClosed && vm.entityProfile != null) {
            getProjects();
            getDinghyEvents();
        }
        if (entityProfile == null && vm.dept.profile != null) {
            MemberManagement.get({id: vm.dept.profile.id}, function (result) {
                vm.entityProfile = result;
                if (!vm.relationClosed) {
                    getProjects();
                    getDinghyEvents();
                }
            });
        }
        if (!vm.profilePresent) {
            vm.sortByCrew = false;
            vm.selectSingle = true;
            vm.profiles = [];
            if (entityProject !== null) {
                loadProfilesProject();
            } else {
                loadProfilesDinghyEvent();
            }
        }

        vm.clear = clear;
        vm.save = save;
        vm.onChange = onChange;
        vm.pointsPicked = pointsPicked;
        vm.getNewBookingSorting = getNewBookingSorting;

        onChange();

        $timeout(function () {
            angular.element('.form-group:eq(1)>input').focus();
        });

        function getProjects() {
            ProjectActive.get({userId: vm.entityProfile.user.id}, function (data) {
                vm.projects = data;
            });
        }

        function getDinghyEvents() {
            DinghyEventActive.get({userId: vm.entityProfile.user.id}, function (data) {
                vm.dinghyEvents = data;
            });
        }

        function loadProfilesProject() {
            $http.get('api/board/bookings/dept', {
                params: {
                    projectID: entityProject.id
                }
            }).then(function (response) {
                vm.profiles = response.data;
                for (var i = 0; i < vm.profiles.length; i++) {
                    vm.profiles[i].nickname = vm.profiles[i].nickname ? " \"" + vm.profiles[i].nickname + "\"" : "";
                }
            });
        }

        function loadProfilesDinghyEvent() {
            $http.get('api/board/dinghy-bookings/dept', {
                params: {
                    eventId: entityDinghyEvent.id
                }
            }).then(function (response) {
                vm.profiles = response.data;
                for (var i = 0; i < vm.profiles.length; i++) {
                    vm.profiles[i].nickname = vm.profiles[i].nickname ? " \"" + vm.profiles[i].nickname + "\"" : "";
                }
            });
        }

        function pointsPicked() {
            vm.dept.apCount = Math.min($scope.maxPoints, vm.dept.apCount);
            onChange();
        }

        function calcMaxPoints() {
            var points = Math.floor(vm.dept.amount / vm.dept.pointValue);
            $scope.maxPoints = Math.min(vm.dept.availableActivityPoints, points);
        }

        function clear() {
            $uibModalInstance.dismiss('cancel');
        }

        function save() {
            pointsPicked();
            vm.isSaving = true;
            if (vm.dept.id) {
                Dept.update(vm.dept, onSaveSuccess, onSaveError);
            } else {
                if (vm.category != null && vm.category !== "") {
                    vm.dept.reference = vm.category;
                }
                if (!vm.profilePresent) {
                    if (vm.selectSingle) {
                        vm.profilesToCreate = [];
                    } else {
                        vm.profile = null;
                    }
                }
                Dept.save(vm.dept, onSaveSuccess, onSaveError);
            }
        }

        function onSaveSuccess(result) {
            $scope.$emit('askApp:deptUpdate', result);
            $uibModalInstance.close(result);
            vm.isSaving = false;
        }

        function onSaveError() {
            vm.isSaving = false;
        }

        function onChange() {
            calcMaxPoints();
            vm.dept.apValue = vm.dept.apCount * vm.dept.pointValue;
            $scope.toPay = vm.dept.amount - vm.dept.apValue;
            $scope.diff = vm.dept.payed - $scope.toPay;

            if (vm.dept.id && $.isNumeric(vm.dept.amount)) {
                $('#preCalc').show();
            } else {
                $('#preCalc').hide();
            }
        }

        function getNewBookingSorting() {
            return vm.sortByCrew ? "crewSorting" : "bookingId";
        }
    }
})();

/*
 * Copyright (c) 2017 by Julian Feder, julian.feder@yahoo.de
 *
 * This product includes software developed at
 * The Apache Software Foundation (http://www.apache.org/).
 */

(function() {
    'use strict';

    angular
        .module('askApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
        .state('board.dept', {
            parent: 'board',
            url: '/board/{select}/dept?page&sort&search',
            data: {
                authorities: ['ROLE_FINANCE'],
                pageTitle: 'askApp.dept.home.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/board/dept/depts.html',
                    controller: 'BoardDeptController',
                    controllerAs: 'vm'
                }
            },
            params: {
                page: {
                    value: '1',
                    squash: true
                },
                sort: {
                    value: 'date,desc',
                    squash: true
                },
                search: null
            },
            resolve: {
                pagingParams: ['$stateParams', 'PaginationUtil', function ($stateParams, PaginationUtil) {
                    return {
                        page: PaginationUtil.parsePage($stateParams.page),
                        sort: $stateParams.sort,
                        predicate: PaginationUtil.parsePredicate($stateParams.sort),
                        ascending: PaginationUtil.parseAscending($stateParams.sort),
                        search: $stateParams.search,
                        select: $stateParams.select
                    };
                }],
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('dept');
                    $translatePartialLoader.addPart('booking');
                    $translatePartialLoader.addPart('enumDeptStatus');
                    $translatePartialLoader.addPart('global');
                    $translatePartialLoader.addPart('member-management');
                    $translatePartialLoader.addPart('enumMemberStatus');
                    return $translate.refresh();
                }],
                entityProfile: ['$stateParams', 'MemberManagement', function($stateParams, MemberManagement) {
                    if($stateParams.select) {
                        return MemberManagement.get({id : $stateParams.select}).$promise;
                    }
                    return null;
                }]
            }
        })
        .state('board.dept.edit', {
            parent: 'board.dept',
            url: '/{id}/edit',
            data: {
                authorities: ['ROLE_FINANCE']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', 'entityProfile', function($stateParams, $state, $uibModal, entityProfile) {
                $uibModal.open({
                    templateUrl: 'app/board/dept/dept-dialog.html',
                    controller: 'BoardDeptDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'md',
                    resolve: {
                        translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                            $translatePartialLoader.addPart('payment');
                            $translatePartialLoader.addPart('enumPaymentCategory');
                            return $translate.refresh();
                        }],
                        entity: ['Dept', function(Dept) {
                            return Dept.get({id : $stateParams.id}).$promise;
                        }],
                        entityProfile: entityProfile,
                        entityProject: null,
                        entityDinghyEvent: null
                    }
                }).result.then(function() {
                    $state.go('board.dept', null, { reload: 'board.dept' });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('board.dept.new', {
            parent: 'board.dept',
            url: '/new',
            data: {
                authorities: ['ROLE_FINANCE']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', 'entityProfile', function($stateParams, $state, $uibModal, entityProfile) {
                $uibModal.open({
                    templateUrl: 'app/board/dept/dept-dialog.html',
                    controller: 'BoardDeptDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'md',
                    resolve: {
                        translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                            $translatePartialLoader.addPart('payment');
                            $translatePartialLoader.addPart('enumPaymentCategory');
                            return $translate.refresh();
                        }],
                        entity: function () {
                            return {
                                date: new Date(),
                                reference: null,
                                pointValue: 0,
                                amount: null,
                                comment: null,
                                category: "",
                                sepa: null,
                                paymentStatus: null,
                                id: null
                            };
                        },
                        entityProfile: entityProfile,
                        entityProject: null,
                        entityDinghyEvent: null
                    }
                }).result.then(function() {
                    $state.go('board.dept', null, { reload: 'board.dept' });
                }, function() {
                    $state.go('^');
                });
            }]
        });
    }
})();

/*
 * Copyright (c) 2017 by Julian Feder, julian.feder@yahoo.de
 *
 * This product includes software developed at
 * The Apache Software Foundation (http://www.apache.org/).
 */

(function() {
    'use strict';
    angular
        .module('askApp')
        .factory('Dept', Dept);

    Dept.$inject = ['$resource', 'DateUtils'];

    function Dept ($resource, DateUtils) {
        var resourceUrl =  'api/depts/:id';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true},
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                        data.date = DateUtils.convertLocalDateFromServer(data.date);
                    }
                    return data;
                }
            },
            'update': {
                method: 'PUT',
                transformRequest: function (data) {
                    var copy = angular.copy(data);
                    copy.date = DateUtils.convertLocalDateToServer(copy.date);
                    return angular.toJson(copy);
                }
            },
            'save': {
                method: 'POST',
                transformRequest: function (data) {
                    var copy = angular.copy(data);
                    copy.date = DateUtils.convertLocalDateToServer(copy.date);
                    return angular.toJson(copy);
                }
            }
        });
    }
})();

/*
 * Copyright (c) 2017 by Julian Feder, julian.feder@yahoo.de
 *
 * This product includes software developed at
 * The Apache Software Foundation (http://www.apache.org/).
 */

(function() {
    'use strict';

    angular
        .module('askApp')
        .factory('DeptSearch', DeptSearch);

    DeptSearch.$inject = ['$resource'];

    function DeptSearch($resource) {
        var resourceUrl =  'api/_search/depts/:id';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true}
        });
    }
})();

/*
 * Copyright (c) 2017 by Julian Feder, julian.feder@yahoo.de
 *
 * This product includes software developed at
 * The Apache Software Foundation (http://www.apache.org/).
 */

(function() {
    'use strict';

    angular
        .module('askApp')
        .controller('BoardDeptController', BoardDeptController);

    BoardDeptController.$inject = ['$state', 'Dept', 'DeptSearch', 'ParseLinks', 'AlertService', 'paginationConstants', 'pagingParams', 'entityProfile', '$http', '$stateParams'];

    function BoardDeptController($state, Dept, DeptSearch, ParseLinks, AlertService, paginationConstants, pagingParams, entityProfile, $http, $stateParams) {

        var vm = this;

        vm.loadPage = loadPage;
        vm.predicate = pagingParams.predicate;
        vm.reverse = pagingParams.ascending;
        vm.transition = transition;
        vm.itemsPerPage = paginationConstants.itemsPerPage;
        vm.clear = clear;
        vm.search = search;
        vm.loadAll = loadAll;
        vm.getUser = getUser;
        vm.searchQuery = pagingParams.search;
        vm.currentSearch = pagingParams.search;
        vm.select = pagingParams.select;
        vm.selected = null;
        vm.selectUser = selectUser;

        loadAll();

        function loadAll () {
            if(entityProfile != null) {
                vm.selected = entityProfile.user.firstName + " " + entityProfile.user.lastName + (entityProfile.nickname ? (' "' + entityProfile.nickname + '"') : (''));
                vm.userQuery = vm.selected;
                vm.userId = entityProfile.user.id;
            }
            if (pagingParams.search) {
                DeptSearch.query({
                    query: pagingParams.search,
                    page: pagingParams.page - 1,
                    size: vm.itemsPerPage,
                    sort: sort()
                }, onSuccess, onError);
            } else {
                Dept.query({
                    page: pagingParams.page - 1,
                    size: vm.itemsPerPage,
                    sort: sort(),
                    profileID: $stateParams.select
                }, onSuccess, onError);
            }
            function sort() {
                var sorting = vm.reverse ? 'asc' : 'desc';
                var result = [vm.predicate + ',' + sorting];
                if (vm.predicate !== 'id') {
                    result.push('id,' + sorting);
                }
                return result;
            }
            function onSuccess(data, headers) {
                vm.links = ParseLinks.parse(headers('link'));
                vm.totalItems = headers('X-Total-Count');
                vm.queryCount = vm.totalItems;
                vm.depts = data;
                vm.page = pagingParams.page;
            }
            function onError(error) {
                AlertService.error(error.data.message);
            }
        }

        function loadPage(page) {
            vm.page = page;
            vm.transition();
        }

        function transition() {
            $state.transitionTo($state.$current, {
                page: vm.page,
                sort: vm.predicate + ',' + (vm.reverse ? 'asc' : 'desc'),
                search: vm.currentSearch,
                select: vm.select
            });
        }

        function search(searchQuery) {
            if (!searchQuery){
                return vm.clear();
            }
            vm.links = null;
            vm.page = 1;
            vm.predicate = '_score';
            vm.reverse = false;
            vm.currentSearch = searchQuery;
            vm.select = null;
            vm.transition();
        }

        function clear() {
            vm.links = null;
            vm.page = 1;
            vm.predicate = 'date';
            vm.reverse = false;
            vm.currentSearch = null;
            vm.select = null;
            vm.transition();
        }

        function getUser(val) {
            return $http.get('api/_search/profiles_guest/', {
                params: {
                    query: val
                }
            }).then(function(response){
                return response.data.map(function(item) {
                    return item;
                });
            });
        }

        function selectUser(item, model) {
            vm.select = model.id;
            vm.transition();
        }
    }
})();

/*
 * Copyright (c) 2017 by Julian Feder, julian.feder@yahoo.de
 *
 * This product includes software developed at
 * The Apache Software Foundation (http://www.apache.org/).
 */

(function() {
    'use strict';

    angular
        .module('askApp')
        .controller('BoardContentDialogController', BoardContentDialogController);

    BoardContentDialogController.$inject = ['$timeout', '$scope', '$stateParams', '$uibModalInstance', 'entity', 'Content'];

    function BoardContentDialogController ($timeout, $scope, $stateParams, $uibModalInstance, entity, Content) {
        var vm = this;

        vm.content = entity;
        vm.clear = clear;
        vm.save = save;

        vm.options = {
            toolbar: [
                ['style', ['bold', 'italic', 'underline', 'clear']],
                ['textsize', ['fontsize']],
                ['fontclr', ['color']],
                ['alignment', ['ul', 'ol']],
                ['view', ['codeview']]
            ]
        };

        $timeout(function (){
            angular.element('.form-group:eq(1)>input').focus();
        });

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function save () {
            vm.isSaving = true;
            if (vm.content.id !== null) {
                Content.update(vm.content, onSaveSuccess, onSaveError);
            } else {
                Content.save(vm.content, onSaveSuccess, onSaveError);
            }
        }

        function onSaveSuccess (result) {
            $scope.$emit('askApp:contentUpdate', result);
            $uibModalInstance.close(result);
            vm.isSaving = false;
        }

        function onSaveError () {
            vm.isSaving = false;
        }


    }
})();

/*
 * Copyright (c) 2017 by Julian Feder, julian.feder@yahoo.de
 *
 * This product includes software developed at
 * The Apache Software Foundation (http://www.apache.org/).
 */

(function() {
    'use strict';

    angular
        .module('askApp')
        .controller('BoardContentDeleteController',BoardContentDeleteController);

    BoardContentDeleteController.$inject = ['$uibModalInstance', 'entity', 'Content'];

    function BoardContentDeleteController($uibModalInstance, entity, Content) {
        var vm = this;

        vm.content = entity;
        vm.clear = clear;
        vm.confirmDelete = confirmDelete;

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function confirmDelete (id) {
            Content.delete({id: id},
                function () {
                    $uibModalInstance.close(true);
                });
        }
    }
})();

/*
 * Copyright (c) 2017 by Julian Feder, julian.feder@yahoo.de
 *
 * This product includes software developed at
 * The Apache Software Foundation (http://www.apache.org/).
 */

(function() {
    'use strict';

    angular
        .module('askApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
        .state('board.content', {
            parent: 'board',
            url: '/board/content?page&sort&search',
            data: {
                authorities: ['ROLE_USER'],
                pageTitle: 'askApp.content.home.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/board/content/contents.html',
                    controller: 'BoardContentController',
                    controllerAs: 'vm'
                }
            },
            params: {
                page: {
                    value: '1',
                    squash: true
                },
                sort: {
                    value: 'id,asc',
                    squash: true
                },
                search: null
            },
            resolve: {
                pagingParams: ['$stateParams', 'PaginationUtil', function ($stateParams, PaginationUtil) {
                    return {
                        page: PaginationUtil.parsePage($stateParams.page),
                        sort: $stateParams.sort,
                        predicate: PaginationUtil.parsePredicate($stateParams.sort),
                        ascending: PaginationUtil.parseAscending($stateParams.sort),
                        search: $stateParams.search
                    };
                }],
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('content');
                    $translatePartialLoader.addPart('enumContentAccess');
                    $translatePartialLoader.addPart('global');
                    return $translate.refresh();
                }]
            }
        })
        .state('board.content.new', {
            parent: 'board.content',
            url: '/new',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/board/content/content-dialog.html',
                    controller: 'BoardContentDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: function () {
                            return {
                                text: null,
                                access: null,
                                id: null
                            };
                        }
                    }
                }).result.then(function() {
                    $state.go('board.content', null, { reload: 'board.content' });
                }, function() {
                    $state.go('board.content');
                });
            }]
        })
        .state('board.content.edit', {
            parent: 'board.content',
            url: '/{id}/edit',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/board/content/content-dialog.html',
                    controller: 'BoardContentDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: ['Content', function(Content) {
                            return Content.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('board.content', null, { reload: 'board.content' });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('board.content.delete', {
            parent: 'board.content',
            url: '/{id}/delete',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/board/content/content-delete-dialog.html',
                    controller: 'BoardContentDeleteController',
                    controllerAs: 'vm',
                    size: 'md',
                    resolve: {
                        entity: ['Content', function(Content) {
                            return Content.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('board.content', null, { reload: 'board.content' });
                }, function() {
                    $state.go('^');
                });
            }]
        });
    }

})();

(function() {
    'use strict';
    angular
        .module('askApp')
        .factory('Content', Content);

    Content.$inject = ['$resource'];

    function Content ($resource) {
        var resourceUrl =  'api/contents/:id';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true},
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                    }
                    return data;
                }
            },
            'update': { method:'PUT' }
        });
    }
})();

(function() {
    'use strict';

    angular
        .module('askApp')
        .factory('ContentSearch', ContentSearch);

    ContentSearch.$inject = ['$resource'];

    function ContentSearch($resource) {
        var resourceUrl =  'api/_search/contents/:id';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true}
        });
    }
})();

/*
 * Copyright (c) 2017 by Julian Feder, julian.feder@yahoo.de
 *
 * This product includes software developed at
 * The Apache Software Foundation (http://www.apache.org/).
 */

(function() {
    'use strict';

    angular
        .module('askApp')
        .controller('BoardContentController', BoardContentController);

    BoardContentController.$inject = ['$state', 'Content', 'ContentSearch', 'ParseLinks', 'AlertService', 'paginationConstants', 'pagingParams'];

    function BoardContentController($state, Content, ContentSearch, ParseLinks, AlertService, paginationConstants, pagingParams) {

        var vm = this;

        vm.loadPage = loadPage;
        vm.predicate = pagingParams.predicate;
        vm.reverse = pagingParams.ascending;
        vm.transition = transition;
        vm.itemsPerPage = paginationConstants.itemsPerPage;
        vm.clear = clear;
        vm.search = search;
        vm.loadAll = loadAll;
        vm.searchQuery = pagingParams.search;
        vm.currentSearch = pagingParams.search;

        loadAll();

        function loadAll () {
            if (pagingParams.search) {
                ContentSearch.query({
                    query: pagingParams.search,
                    page: pagingParams.page - 1,
                    size: vm.itemsPerPage,
                    sort: sort()
                }, onSuccess, onError);
            } else {
                Content.query({
                    page: pagingParams.page - 1,
                    size: vm.itemsPerPage,
                    sort: sort()
                }, onSuccess, onError);
            }
            function sort() {
                var sorting = vm.reverse ? 'asc' : 'desc';
                var result = [vm.predicate + ',' + sorting];
                if (vm.predicate !== 'id') {
                    result.push('id,' + sorting);
                }
                return result;
            }
            function onSuccess(data, headers) {
                vm.links = ParseLinks.parse(headers('link'));
                vm.totalItems = headers('X-Total-Count');
                vm.queryCount = vm.totalItems;
                vm.contents = data;
                vm.page = pagingParams.page;
            }
            function onError(error) {
                AlertService.error(error.data.message);
            }
        }

        function loadPage(page) {
            vm.page = page;
            vm.transition();
        }

        function transition() {
            $state.transitionTo($state.$current, {
                page: vm.page,
                sort: vm.predicate + ',' + (vm.reverse ? 'asc' : 'desc'),
                search: vm.currentSearch
            });
        }

        function search(searchQuery) {
            if (!searchQuery){
                return vm.clear();
            }
            vm.links = null;
            vm.page = 1;
            vm.predicate = '_score';
            vm.reverse = false;
            vm.currentSearch = searchQuery;
            vm.transition();
        }

        function clear() {
            vm.links = null;
            vm.page = 1;
            vm.predicate = 'id';
            vm.reverse = true;
            vm.currentSearch = null;
            vm.transition();
        }
    }
})();

/*
 * Copyright (c) 2017 by Julian Feder, julian.feder@yahoo.de
 *
 * This product includes software developed at
 * The Apache Software Foundation (http://www.apache.org/).
 */

(function() {
    'use strict';

    angular
        .module('askApp')
        .controller('BoardBookingDialogController', BoardBookingDialogController);

    BoardBookingDialogController.$inject = ['$timeout', '$scope', '$uibModalInstance', 'entity', 'ProjectDetailBooking'];

    function BoardBookingDialogController ($timeout, $scope, $uibModalInstance, entity, ProjectDetailBooking) {
        var vm = this;

        vm.booking = entity;
        vm.nickname = vm.booking.profile.nickname ? " \"" + vm.booking.profile.nickname + "\"" : "";
        vm.booking.oldStatus = vm.booking.status;
        vm.booking.individualPrice = vm.booking.dept.priceCategory === "individual";
        vm.booking.oldIndividualPrice = vm.booking.individualPrice;
        vm.booking.nonIndividual = !vm.booking.individualPrice;
        vm.clear = clear;
        vm.datePickerOpenStatus = {};
        vm.openCalendar = openCalendar;
        vm.save = save;

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function save () {
            vm.isSaving = true;
            vm.booking.individualPrice = !vm.booking.nonIndividual;
            ProjectDetailBooking.update(vm.booking, onSaveSuccess, onSaveError);
        }

        function onSaveSuccess (result) {
            $scope.$emit('askApp:bookingUpdate', result);
            $uibModalInstance.close(result);
            vm.isSaving = false;
        }

        function onSaveError () {
            vm.isSaving = false;
        }

        vm.datePickerOpenStatus.date = false;

        function openCalendar (date) {
            vm.datePickerOpenStatus[date] = true;
        }
    }
})();

/*
 * Copyright (c) 2017 by Julian Feder, julian.feder@yahoo.de
 *
 * This product includes software developed at
 * The Apache Software Foundation (http://www.apache.org/).
 */

(function() {
    'use strict';

    angular
        .module('askApp')
        .controller('BoardBookingDeleteController', BoardBookingDeleteController);

    BoardBookingDeleteController.$inject = ['$uibModalInstance', 'entity', 'Booking'];

    function BoardBookingDeleteController($uibModalInstance, entity, Booking) {
        var vm = this;

        vm.booking = entity;
        vm.nickname = vm.booking.profile.nickname ? " \"" + vm.booking.profile.nickname + "\"" : "";
        vm.clear = clear;
        vm.confirmDelete = confirmDelete;

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function confirmDelete (id) {
            Booking.delete({id: id},
                function () {
                    $uibModalInstance.close(true);
                });
        }
    }
})();

/*
 * Copyright (c) 2017 by Julian Feder, julian.feder@yahoo.de
 *
 * This product includes software developed at
 * The Apache Software Foundation (http://www.apache.org/).
 */

(function() {
    'use strict';

    angular
        .module('askApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
        .state('board.booking', {
            parent: 'board',
            url: '/board/{select}/booking?page&sort&search',
            data: {
                authorities: ['ROLE_BOARD'],
                pageTitle: 'askApp.booking.home.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/board/booking/bookings.html',
                    controller: 'BoardBookingController',
                    controllerAs: 'vm'
                }
            },
            params: {
                page: {
                    value: '1',
                    squash: true
                },
                sort: {
                    value: 'id,desc',
                    squash: true
                },
                search: null
            },
            resolve: {
                pagingParams: ['$stateParams', 'PaginationUtil', function ($stateParams, PaginationUtil) {
                    return {
                        page: PaginationUtil.parsePage($stateParams.page),
                        sort: $stateParams.sort,
                        predicate: PaginationUtil.parsePredicate($stateParams.sort),
                        ascending: PaginationUtil.parseAscending($stateParams.sort),
                        search: $stateParams.search,
                        select: $stateParams.select
                    };
                }],
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('booking');
                    $translatePartialLoader.addPart('enumBookingStatusType');
                    $translatePartialLoader.addPart('enumDeptStatus');
                    $translatePartialLoader.addPart('global');
                    $translatePartialLoader.addPart('dept');
                    return $translate.refresh();
                }],
                entity: ['$stateParams', 'MemberManagement', function($stateParams, MemberManagement) {
                    if($stateParams.select) {
                        return MemberManagement.get({id : $stateParams.select}).$promise;
                    }
                    return null;
                }]
            }
        })
        .state('board.booking.edit', {
            parent: 'board.booking',
            url: '/{id}/edit',
            data: {
                authorities: ['ROLE_BOARD']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/board/booking/booking-dialog.html',
                    controller: 'BoardBookingDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'md',
                    resolve: {
                        entity: ['Booking', function(Booking) {
                            return Booking.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('board.booking', null, { reload: 'board.booking' });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('board.booking.delete', {
            parent: 'board.booking',
            url: '/{id}/delete',
            data: {
                authorities: ['ROLE_BOARD']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/board/booking/booking-delete-dialog.html',
                    controller: 'BoardBookingDeleteController',
                    controllerAs: 'vm',
                    size: 'md',
                    resolve: {
                        entity: ['Booking', function(Booking) {
                            return Booking.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('board.booking', null, { reload: 'board.booking' });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('board.booking.edit-dept', {
            parent: 'board.booking',
            url: '/dept/{deptId}/edit',
            data: {
                authorities: ['ROLE_FINANCE']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/board/dept/dept-dialog.html',
                    controller: 'BoardDeptDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'md',
                    resolve: {
                        translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                            $translatePartialLoader.addPart('payment');
                            $translatePartialLoader.addPart('enumPaymentCategory');
                            return $translate.refresh();
                        }],
                        entity: ['Dept', function(Dept) {
                            return Dept.get({id : $stateParams.deptId}).$promise;
                        }],
                        entityProfile: null,
                        entityProject: null,
                        entityDinghyEvent: null
                    }
                }).result.then(function() {
                    $state.go('board.booking', null, { reload: 'board.booking' });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('board.booking.new-dept', {
            parent: 'board.booking',
            url: '/dept/new/{projectId}/{userId}',
            data: {
                authorities: ['ROLE_FINANCE']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/board/dept/dept-dialog.html',
                    controller: 'BoardDeptDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'md',
                    resolve: {
                        translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                            $translatePartialLoader.addPart('payment');
                            $translatePartialLoader.addPart('enumPaymentCategory');
                            return $translate.refresh();
                        }],
                        entity: function () {
                            return {
                                date: new Date(),
                                reference: null,
                                pointValue: 0,
                                amount: null,
                                comment: null,
                                category: "",
                                sepa: null,
                                paymentStatus: null,
                                id: null
                            };
                        },
                        entityProfile: ['MemberManagement', function(MemberManagement) {
                            return MemberManagement.get({id: $stateParams.userId}).$promise;
                        }],
                        entityProject:  ['Project', function(Project) {
                            return Project.get({id: $stateParams.projectId}).$promise;
                        }],
                        entityDinghyEvent: null
                    }
                }).result.then(function() {
                    $state.go('board.booking', null, { reload: 'board.booking' });
                }, function() {
                    $state.go('^');
                });
            }]
        });
    }

})();

/*
 * Copyright (c) 2017 by Julian Feder, julian.feder@yahoo.de
 *
 * This product includes software developed at
 * The Apache Software Foundation (http://www.apache.org/).
 */

(function() {
    'use strict';
    angular
        .module('askApp')
        .factory('BoardBooking', BoardBooking);

    BoardBooking.$inject = ['$resource', 'DateUtils'];

    function BoardBooking ($resource, DateUtils) {
        var resourceUrl =  'api/bookings/:id';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true},
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                        data.date = DateUtils.convertLocalDateFromServer(data.date);
                    }
                    return data;
                }
            },
            'update': {
                method: 'PUT',
                transformRequest: function (data) {
                    var copy = angular.copy(data);
                    copy.date = DateUtils.convertLocalDateToServer(copy.date);
                    return angular.toJson(copy);
                }
            },
            'save': {
                method: 'POST',
                transformRequest: function (data) {
                    var copy = angular.copy(data);
                    copy.date = DateUtils.convertLocalDateToServer(copy.date);
                    return angular.toJson(copy);
                }
            }
        });
    }
})();

/*
 * Copyright (c) 2017 by Julian Feder, julian.feder@yahoo.de
 *
 * This product includes software developed at
 * The Apache Software Foundation (http://www.apache.org/).
 */

(function() {
    'use strict';

    angular
        .module('askApp')
        .factory('BoardBookingSearch', BoardBookingSearch);

    BoardBookingSearch.$inject = ['$resource'];

    function BoardBookingSearch($resource) {
        var resourceUrl =  'api/_search/bookings/:id';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true}
        });
    }
})();

/*
 * Copyright (c) 2017 by Julian Feder, julian.feder@yahoo.de
 *
 * This product includes software developed at
 * The Apache Software Foundation (http://www.apache.org/).
 */

(function() {
    'use strict';

    angular
        .module('askApp')
        .controller('BoardBookingController', BoardBookingController);

    BoardBookingController.$inject = ['$state', 'BoardBooking', 'BoardBookingSearch', 'ParseLinks', 'AlertService', 'paginationConstants', 'pagingParams', 'entity', '$stateParams', '$http'];

    function BoardBookingController($state, BoardBooking, BoardBookingSearch, ParseLinks, AlertService, paginationConstants, pagingParams, entity, $stateParams, $http) {

        var vm = this;

        vm.loadPage = loadPage;
        vm.predicate = pagingParams.predicate;
        vm.reverse = pagingParams.ascending;
        vm.transition = transition;
        vm.itemsPerPage = paginationConstants.itemsPerPage;
        vm.clear = clear;
        vm.search = search;
        vm.loadAll = loadAll;
        vm.getUser = getUser;
        vm.searchQuery = pagingParams.search;
        vm.currentSearch = pagingParams.search;
        vm.select = pagingParams.select;
        vm.selected = null;
        vm.selectUser = selectUser;

        loadAll();

        function loadAll () {
            if(entity != null) {
                vm.selected = entity.user.firstName + " " + entity.user.lastName + (entity.nickname ? (' "' + entity.nickname + '"') : (''));
            }
            if (pagingParams.search) {
                BoardBookingSearch.query({
                    query: pagingParams.search,
                    page: pagingParams.page - 1,
                    size: vm.itemsPerPage,
                    sort: sort()
                }, onSuccess, onError);
            } else {
                BoardBooking.query({
                    page: pagingParams.page - 1,
                    size: vm.itemsPerPage,
                    sort: sort(),
                    profileID: $stateParams.select
                }, onSuccess, onError);
            }
            function sort() {
                var sorting = vm.reverse ? 'asc' : 'desc';
                var result = [vm.predicate + ',' + sorting];
                if (vm.predicate !== 'id') {
                    result.push('id,' + sorting);
                }
                return result;
            }
            function onSuccess(data, headers) {
                vm.links = ParseLinks.parse(headers('link'));
                vm.totalItems = headers('X-Total-Count');
                vm.queryCount = vm.totalItems;
                vm.bookings = data;
                vm.page = pagingParams.page;
            }
            function onError(error) {
                AlertService.error(error.data.message);
            }
        }

        function loadPage(page) {
            vm.page = page;
            vm.transition();
        }

        function transition() {
            $state.transitionTo($state.$current, {
                page: vm.page,
                sort: vm.predicate + ',' + (vm.reverse ? 'asc' : 'desc'),
                search: vm.currentSearch,
                select: vm.select
            });
        }

        function search(searchQuery) {
            if (!searchQuery){
                return vm.clear();
            }
            vm.links = null;
            vm.page = 1;
            vm.predicate = '_score';
            vm.reverse = false;
            vm.currentSearch = searchQuery;
            vm.select = null;
            vm.transition();
        }

        function clear() {
            vm.links = null;
            vm.page = 1;
            vm.predicate = 'id';
            vm.reverse = false;
            vm.currentSearch = null;
            vm.select = null;
            vm.transition();
        }

        function getUser(val) {
            return $http.get('api/_search/profiles_guest/', {
                params: {
                    query: val
                }
            }).then(function(response){
                return response.data.map(function(item) {
                    return item;
                });
            });
        }

        function selectUser(item, model) {
            vm.select = model.id;
            vm.transition();
        }
    }
})();

/*
 * Copyright (c) 2017 by Julian Feder, julian.feder@yahoo.de
 *
 * This product includes software developed at
 * The Apache Software Foundation (http://www.apache.org/).
 */

(function() {
    'use strict';

    angular
        .module('askApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider.state('board', {
            abstract: true,
            parent: 'app'
        });
    }
})();

/*
 * Copyright (c) 2017 by Julian Feder, julian.feder@yahoo.de
 *
 * This product includes software developed at
 * The Apache Software Foundation (http://www.apache.org/).
 */

(function() {
    'use strict';

    angular
        .module('askApp')
        .controller('ActivitiesBoardDialogController', ActivitiesBoardDialogController);

    ActivitiesBoardDialogController.$inject = ['$timeout', '$scope', '$stateParams', '$uibModalInstance', 'entity', 'ActivitiesBoard', 'MemberManagement', '$http'];

    function ActivitiesBoardDialogController ($timeout, $scope, $stateParams, $uibModalInstance, entity, ActivitiesBoard, MemberManagement, $http) {
        var vm = this;

        vm.activities = entity;
        vm.clear = clear;
        vm.datePickerOpenStatus = {};
        vm.openCalendar = openCalendar;
        vm.save = save;
        $scope.removeBooking = false;
        vm.getUser = getUser;

        if($stateParams.user) {
            MemberManagement.get({id : $stateParams.user}, function(result) {
                vm.activities.profile = result;
            });
        }

        $timeout(function (){
            angular.element('.form-group:eq(0)>input').focus();
        });

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function save () {
            vm.isSaving = true;
            if (vm.activities.id !== null) {
                ActivitiesBoard.update(vm.activities, onSaveSuccess, onSaveError);
            } else {
                ActivitiesBoard.save(vm.activities, onSaveSuccess, onSaveError);
            }
        }

        function onSaveSuccess (result) {
            $scope.$emit('askApp:activitiesUpdate', result);
            $uibModalInstance.close(result);
            vm.isSaving = false;
        }

        function onSaveError () {
            vm.isSaving = false;
        }

        vm.datePickerOpenStatus.activitiesDate = false;
        vm.datePickerOpenStatus.validFrom = false;

        function openCalendar (date) {
            vm.datePickerOpenStatus[date] = true;
        }

        function getUser(val) {
            return $http.get('api/_search/profiles/', {
                params: {
                    query: val
                }
            }).then(function(response){
                return response.data.map(function(item) {
                    return item;
                });
            });
        }
    }
})();

/*
 * Copyright (c) 2017 by Julian Feder, julian.feder@yahoo.de
 *
 * This product includes software developed at
 * The Apache Software Foundation (http://www.apache.org/).
 */

(function() {
    'use strict';

    angular
        .module('askApp')
        .controller('ActivitiesBoardDeleteController',ActivitiesBoardDeleteController);

    ActivitiesBoardDeleteController.$inject = ['$uibModalInstance', 'entity', 'Activities'];

    function ActivitiesBoardDeleteController($uibModalInstance, entity, Activities) {
        var vm = this;

        vm.activities = entity;
        vm.clear = clear;
        vm.confirmDelete = confirmDelete;

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function confirmDelete (id) {
            Activities.delete({id: id},
                function () {
                    $uibModalInstance.close(true);
                });
        }
    }
})();

/*
 * Copyright (c) 2017 by Julian Feder, julian.feder@yahoo.de
 *
 * This product includes software developed at
 * The Apache Software Foundation (http://www.apache.org/).
 */

(function() {
    'use strict';

    angular
        .module('askApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
        .state('board.activities', {
            parent: 'board',
            url: '/board/{select}/activities?page&sort&search&query',
            data: {
                authorities: ['ROLE_BOARD'],
                pageTitle: 'askApp.activities.home.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/board/activities/activities.html',
                    controller: 'ActivitiesBoardController',
                    controllerAs: 'vm'
                }
            },
            params: {
                page: {
                    value: '1',
                    squash: true
                },
                sort: {
                    value: 'activitiesDate,desc',
                    squash: true
                },
                query: {
                    value: 'useable',
                    squash: true
                },
                search: null
            },
            resolve: {
                pagingParams: ['$stateParams', 'PaginationUtil', function ($stateParams, PaginationUtil) {
                    return {
                        page: PaginationUtil.parsePage($stateParams.page),
                        sort: $stateParams.sort,
                        predicate: PaginationUtil.parsePredicate($stateParams.sort),
                        ascending: PaginationUtil.parseAscending($stateParams.sort),
                        search: $stateParams.search,
                        select: $stateParams.select,
                        query: $stateParams.query
                    };
                }],
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('activities');
                    $translatePartialLoader.addPart('enumCategoryActivity');
                    $translatePartialLoader.addPart('global');
                    return $translate.refresh();
                }],
                entity: ['$stateParams', 'MemberManagement', function($stateParams, MemberManagement) {
                    if($stateParams.select) {
                        return MemberManagement.get({id : $stateParams.select}).$promise;
                    }
                    return null;
                }]
            }
        })
        .state('board.activities.new', {
            parent: 'board.activities',
            url: '/new/{user}',
            data: {
                authorities: ['ROLE_BOARD']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/board/activities/activities-dialog.html',
                    controller: 'ActivitiesBoardDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'md',
                    resolve: {
                        entity: ['MemberManagement', function(MemberManagement) {
                            return {
                                activitiesDate: null,
                                validFrom: null,
                                category: null,
                                id: null
                            };
                        }]
                    }
                }).result.then(function() {
                    $state.go('board.activities', null, { reload: 'board.activities' });
                }, function() {
                    $state.go('board.activities');
                });
            }]
        })
         .state('board.activities.edit', {
            parent: 'board.activities',
            url: '/{id}/edit',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/board/activities/activities-dialog.html',
                    controller: 'ActivitiesBoardDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'md',
                    resolve: {
                        entity: ['Activities', function(Activities) {
                            return Activities.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('board.activities', null, { reload: 'board.activities' });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('board.activities.delete', {
            parent: 'board.activities',
            url: '/{id}/delete',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/board/activities/activities-delete-dialog.html',
                    controller: 'ActivitiesBoardDeleteController',
                    controllerAs: 'vm',
                    size: 'md',
                    resolve: {
                        entity: ['Activities', function(Activities) {
                            return Activities.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('board.activities', null, { reload: 'board.activities' });
                }, function() {
                    $state.go('^');
                });
            }]
        });
    }

})();

/*
 * Copyright (c) 2017 by Julian Feder, julian.feder@yahoo.de
 *
 * This product includes software developed at
 * The Apache Software Foundation (http://www.apache.org/).
 */

(function() {
    'use strict';
    angular
        .module('askApp')
        .factory('ActivitiesBoard', ActivitiesBoard);

    ActivitiesBoard.$inject = ['$resource', 'DateUtils'];

    function ActivitiesBoard ($resource, DateUtils) {
        var resourceUrl =  'api/activities/:id';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true},
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                        data.activitiesDate = DateUtils.convertLocalDateFromServer(data.activitiesDate);
                        data.validFrom = DateUtils.convertLocalDateFromServer(data.validFrom);
                    }
                    return data;
                }
            },
            'update': {
                method: 'PUT',
                transformRequest: function (data) {
                    var copy = angular.copy(data);
                    copy.activitiesDate = DateUtils.convertLocalDateToServer(copy.activitiesDate);
                    copy.validFrom = DateUtils.convertLocalDateToServer(copy.validFrom);
                    return angular.toJson(copy);
                }
            },
            'save': {
                method: 'POST',
                transformRequest: function (data) {
                    var copy = angular.copy(data);
                    copy.activitiesDate = DateUtils.convertLocalDateToServer(copy.activitiesDate);
                    copy.validFrom = DateUtils.convertLocalDateToServer(copy.validFrom);
                    return angular.toJson(copy);
                }
            }
        });
    }
})();

/*
 * Copyright (c) 2017 by Julian Feder, julian.feder@yahoo.de
 *
 * This product includes software developed at
 * The Apache Software Foundation (http://www.apache.org/).
 */

(function() {
    'use strict';

    angular
        .module('askApp')
        .factory('ActivitiesSearch', ActivitiesSearch);

    ActivitiesSearch.$inject = ['$resource'];

    function ActivitiesSearch($resource) {
        var resourceUrl =  'api/_search/activities/:id';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true}
        });
    }
})();

/*
 * Copyright (c) 2017 by Julian Feder, julian.feder@yahoo.de
 *
 * This product includes software developed at
 * The Apache Software Foundation (http://www.apache.org/).
 */

(function() {
    'use strict';

    angular
        .module('askApp')
        .controller('ActivitiesBoardController', ActivitiesBoardController);

    ActivitiesBoardController.$inject = ['$http', '$stateParams', '$state', 'ActivitiesBoard', 'ActivitiesSearch', 'ParseLinks', 'AlertService', 'paginationConstants', 'pagingParams', 'entity'];

    function ActivitiesBoardController($http, $stateParams, $state, ActivitiesBoard, ActivitiesSearch, ParseLinks, AlertService, paginationConstants, pagingParams, entity) {

        var vm = this;

        vm.loadPage = loadPage;
        vm.predicate = pagingParams.predicate;
        vm.reverse = pagingParams.ascending;
        vm.transition = transition;
        vm.itemsPerPage = paginationConstants.itemsPerPage;
        vm.clear = clear;
        vm.search = search;
        vm.loadAll = loadAll;
        vm.getUser = getUser;
        vm.searchQuery = pagingParams.search;
        vm.currentSearch = pagingParams.search;
        vm.select = pagingParams.select;
        vm.selected = null;
        vm.selectUser = selectUser;
        vm.setQuery = setQuery;
        vm.query = pagingParams.query;

        loadAll();

        function setQuery(query) {
            vm.query = query;
            vm.transition();
        }

        function loadAll () {
            if(entity != null) {
                vm.selected = entity.user.firstName + " " + entity.user.lastName + (entity.nickname ? (' "' + entity.nickname + '"') : (''));
            }
            if (pagingParams.search) {
                ActivitiesSearch.query({
                    query: pagingParams.search,
                    page: pagingParams.page - 1,
                    size: vm.itemsPerPage,
                    sort: sort()
                }, onSuccess, onError);
            } else {
                ActivitiesBoard.query({
                    page: pagingParams.page - 1,
                    size: vm.itemsPerPage,
                    sort: sort(),
                    profileID: $stateParams.select,
                    select: $stateParams.query
                }, onSuccess, onError);
            }
            function sort() {
                var sorting = vm.reverse ? 'asc' : 'desc';
                var result = [vm.predicate + ',' + sorting];
                if (vm.predicate !== 'id') {
                    result.push('id,' + sorting);
                }
                return result;
            }
            function onSuccess(data, headers) {
                vm.links = ParseLinks.parse(headers('link'));
                vm.totalItems = headers('X-Total-Count');
                vm.queryCount = vm.totalItems;
                vm.activities = data;
                vm.page = pagingParams.page;
            }
            function onError(error) {
                AlertService.error(error.data.message);
            }
        }

        function loadPage(page) {
            vm.page = page;
            vm.transition();
        }

        function transition() {
            $state.transitionTo($state.$current, {
                page: vm.page,
                sort: vm.predicate + ',' + (vm.reverse ? 'asc' : 'desc'),
                search: vm.currentSearch,
                select: vm.select,
                query: vm.query
            });
        }

        function search(searchQuery) {
            if (!searchQuery){
                return vm.clear();
            }
            vm.links = null;
            vm.page = 1;
            vm.predicate = '_score';
            vm.reverse = false;
            vm.currentSearch = searchQuery;
            vm.select = null;
            vm.transition();
        }

        function clear() {
            vm.links = null;
            vm.page = 1;
            vm.predicate = 'activitiesDate';
            vm.reverse = false;
            vm.currentSearch = null;
            vm.select = null;
            vm.transition();
        }

        function getUser(val) {
            return $http.get('api/_search/profiles/', {
                params: {
                    query: val
                }
            }).then(function(response){
                return response.data.map(function(item) {
                    return item;
                });
            });
        }

        function selectUser(item, model) {
            vm.select = model.id;
            vm.transition();
        }
    }
})();

/*
 * Copyright (c) 2017 by Julian Feder, julian.feder@yahoo.de
 *
 * This product includes software developed at
 * The Apache Software Foundation (http://www.apache.org/).
 */

(function() {
    'use strict';

    angular
        .module('askApp')
        .factory('notificationInterceptor', notificationInterceptor);

    notificationInterceptor.$inject = ['$q', 'AlertService'];

    function notificationInterceptor ($q, AlertService) {
        var service = {
            response: response
        };

        return service;

        function response (response) {
            var headers = Object.keys(response.headers()).filter(function (header) {
                return header.indexOf('app-alert', header.length - 'app-alert'.length) !== -1 || header.indexOf('app-params', header.length - 'app-params'.length) !== -1;
            }).sort();
            var alertKey = response.headers(headers[0]);
            if (angular.isString(alertKey)) {
                AlertService.success(alertKey, { param : response.headers(headers[1])});
            }
            return response;
        }
    }
})();

/*
 * Copyright (c) 2017 by Julian Feder, julian.feder@yahoo.de
 *
 * This product includes software developed at
 * The Apache Software Foundation (http://www.apache.org/).
 */

(function() {
    'use strict';

    angular
        .module('askApp')
        .factory('errorHandlerInterceptor', errorHandlerInterceptor);

    errorHandlerInterceptor.$inject = ['$q', '$rootScope'];

    function errorHandlerInterceptor ($q, $rootScope) {
        var service = {
            responseError: responseError
        };

        return service;

        function responseError (response) {
            if (!(response.status === 401 && (response.data === '' || (response.data.path && response.data.path.indexOf('/api/account') === 0 )))) {
                $rootScope.$emit('askApp.httpError', response);
            }
            return $q.reject(response);
        }
    }
})();

/*
 * Copyright (c) 2017 by Julian Feder, julian.feder@yahoo.de
 *
 * This product includes software developed at
 * The Apache Software Foundation (http://www.apache.org/).
 */

(function() {
    'use strict';

    angular
        .module('askApp')
        .factory('authExpiredInterceptor', authExpiredInterceptor);

    authExpiredInterceptor.$inject = ['$rootScope', '$q', '$injector'];

    function authExpiredInterceptor($rootScope, $q, $injector) {
        var service = {
            responseError: responseError
        };

        return service;

        function responseError(response) {
            // If we have an unauthorized request we redirect to the login page
            // Don't do this check on the account API to avoid infinite loop
            if (response.status === 401 && angular.isDefined(response.data.path) && response.data.path.indexOf('/api/account') === -1) {
                var Auth = $injector.get('Auth');
                var to = $rootScope.toState;
                var params = $rootScope.toStateParams;
                Auth.logout();
                if (to.name !== 'accessdenied') {
                    Auth.storePreviousState(to.name, params);
                }
                var LoginService = $injector.get('LoginService');
                LoginService.open();
            }
            return $q.reject(response);
        }
    }
})();

/*
 * Copyright (c) 2017 by Julian Feder, julian.feder@yahoo.de
 *
 * This product includes software developed at
 * The Apache Software Foundation (http://www.apache.org/).
 */

(function() {
    'use strict';

    angular
        .module('askApp')
        .factory('translationHandler', translationHandler);

    translationHandler.$inject = ['$rootScope', '$window', '$state', '$translate'];

    function translationHandler($rootScope, $window, $state, $translate) {
        return {
            initialize: initialize,
            updateTitle: updateTitle
        };

        function initialize() {
            // if the current translation changes, update the window title
            var translateChangeSuccess = $rootScope.$on('$translateChangeSuccess', function() {
                updateTitle();
            });

            $rootScope.$on('$destroy', function () {
                if(angular.isDefined(translateChangeSuccess) && translateChangeSuccess !== null){
                    translateChangeSuccess();
                }
            });
        }

        // update the window title using params in the following
        // precedence
        // 1. titleKey parameter
        // 2. $state.$current.data.pageTitle (current state page title)
        // 3. 'global.title'
        function updateTitle(titleKey) {
            if (!titleKey && $state.$current.data && $state.$current.data.pageTitle) {
                titleKey = $state.$current.data.pageTitle;
            }
            $translate(titleKey || 'global.title').then(function (title) {
                $window.document.title = title;
            });
        }
    }
})();

/*
 * Copyright (c) 2017 by Julian Feder, julian.feder@yahoo.de
 *
 * This product includes software developed at
 * The Apache Software Foundation (http://www.apache.org/).
 */

(function() {
    'use strict';

    angular
        .module('askApp')
        .factory('stateHandler', stateHandler);

    stateHandler.$inject = ['$rootScope', '$state', '$sessionStorage', '$translate', 'JhiLanguageService', 'translationHandler', '$window',
        'Auth', 'Principal', 'VERSION'];

    function stateHandler($rootScope, $state, $sessionStorage, $translate, JhiLanguageService, translationHandler, $window,
        Auth, Principal, VERSION) {
        return {
            initialize: initialize
        };

        function initialize() {
            $rootScope.VERSION = VERSION;

            var stateChangeStart = $rootScope.$on('$stateChangeStart', function (event, toState, toStateParams, fromState) {
                $rootScope.toState = toState;
                $rootScope.toStateParams = toStateParams;
                $rootScope.fromState = fromState;

                // Redirect to a state with an external URL (http://stackoverflow.com/a/30221248/1098564)
                if (toState.external) {
                    event.preventDefault();
                    $window.open(toState.url, '_self');
                }

                if (Principal.isIdentityResolved()) {
                    Auth.authorize();
                }

                // Update the language
                JhiLanguageService.getCurrent().then(function (language) {
                    $translate.use(language);
                });
            });

            var stateChangeSuccess = $rootScope.$on('$stateChangeSuccess',  function(event, toState, toParams, fromState, fromParams) {
                var titleKey = 'global.title' ;

                // Set the page title key to the one configured in state or use default one
                if (toState.data.pageTitle) {
                    titleKey = toState.data.pageTitle;
                }
                translationHandler.updateTitle(titleKey);
            });

            $rootScope.$on('$destroy', function () {
                if(angular.isDefined(stateChangeStart) && stateChangeStart !== null){
                    stateChangeStart();
                }
                if(angular.isDefined(stateChangeSuccess) && stateChangeSuccess !== null){
                    stateChangeSuccess();
                }
            });
        }
    }
})();

/*
 * Copyright (c) 2017 by Julian Feder, julian.feder@yahoo.de
 *
 * This product includes software developed at
 * The Apache Software Foundation (http://www.apache.org/).
 */

(function() {
    'use strict';

    angular
        .module('askApp')
        .config(paginationConfig);

    paginationConfig.$inject = ['uibPaginationConfig', 'paginationConstants'];

    function paginationConfig(uibPaginationConfig, paginationConstants) {
        uibPaginationConfig.itemsPerPage = paginationConstants.itemsPerPage;
        uibPaginationConfig.maxSize = 20;
        uibPaginationConfig.boundaryLinks = true;
        uibPaginationConfig.firstText = '«';
        uibPaginationConfig.previousText = '‹';
        uibPaginationConfig.nextText = '›';
        uibPaginationConfig.lastText = '»';
    }
})();

/*
 * Copyright (c) 2017 by Julian Feder, julian.feder@yahoo.de
 *
 * This product includes software developed at
 * The Apache Software Foundation (http://www.apache.org/).
 */

(function () {
    'use strict';

    angular
        .module('askApp')
        .config(pagerConfig);

    pagerConfig.$inject = ['uibPagerConfig', 'paginationConstants'];

    function pagerConfig(uibPagerConfig, paginationConstants) {
        uibPagerConfig.itemsPerPage = paginationConstants.itemsPerPage;
        uibPagerConfig.previousText = '«';
        uibPagerConfig.nextText = '»';
    }
})();

/*
 * Copyright (c) 2017 by Julian Feder, julian.feder@yahoo.de
 *
 * This product includes software developed at
 * The Apache Software Foundation (http://www.apache.org/).
 */

(function() {
    'use strict';

    angular
        .module('askApp')
        .factory('translationStorageProvider', translationStorageProvider);

    translationStorageProvider.$inject = ['$cookies', '$log', 'LANGUAGES'];

    function translationStorageProvider($cookies, $log, LANGUAGES) {
        return {
            get: get,
            put: put
        };

        function get(name) {
            if (LANGUAGES.indexOf($cookies.getObject(name)) === -1) {
                $log.info('Resetting invalid cookie language "' + $cookies.getObject(name) + '" to preferred language "de"');
                $cookies.putObject(name, 'de');
            }
            return $cookies.getObject(name);
        }

        function put(name, value) {
            $cookies.putObject(name, value);
        }
    }
})();

/*
 * Copyright (c) 2017 by Julian Feder, julian.feder@yahoo.de
 *
 * This product includes software developed at
 * The Apache Software Foundation (http://www.apache.org/).
 */

(function() {
    'use strict';

    angular
        .module('askApp')
        .config(translationConfig);

    translationConfig.$inject = ['$translateProvider', 'tmhDynamicLocaleProvider'];

    function translationConfig($translateProvider, tmhDynamicLocaleProvider) {
        // Initialize angular-translate
        $translateProvider.useLoader('$translatePartialLoader', {
            urlTemplate: 'i18n/{lang}/{part}.json'
        });

        $translateProvider.preferredLanguage('de');
        $translateProvider.useStorage('translationStorageProvider');
        $translateProvider.useSanitizeValueStrategy('escaped');
        $translateProvider.addInterpolation('$translateMessageFormatInterpolation');

        tmhDynamicLocaleProvider.localeLocationPattern('i18n/angular-locale_{{locale}}.js');
        tmhDynamicLocaleProvider.useCookieStorage();
        tmhDynamicLocaleProvider.storageKey('NG_TRANSLATE_LANG_KEY');
    }
})();

/*
 * Copyright (c) 2017 by Julian Feder, julian.feder@yahoo.de
 *
 * This product includes software developed at
 * The Apache Software Foundation (http://www.apache.org/).
 */

(function() {
    'use strict';

    angular
        .module('askApp')
        .config(localStorageConfig);

    localStorageConfig.$inject = ['$localStorageProvider', '$sessionStorageProvider'];

    function localStorageConfig($localStorageProvider, $sessionStorageProvider) {
        $localStorageProvider.setKeyPrefix('jhi-');
        $sessionStorageProvider.setKeyPrefix('jhi-');
    }
})();

/*
 * Copyright (c) 2017 by Julian Feder, julian.feder@yahoo.de
 *
 * This product includes software developed at
 * The Apache Software Foundation (http://www.apache.org/).
 */

(function() {
    'use strict';

    angular
        .module('askApp')
        .config(httpConfig);

    httpConfig.$inject = ['$urlRouterProvider', '$httpProvider', 'httpRequestInterceptorCacheBusterProvider', '$urlMatcherFactoryProvider'];

    function httpConfig($urlRouterProvider, $httpProvider, httpRequestInterceptorCacheBusterProvider, $urlMatcherFactoryProvider) {
        //Cache everything except rest api requests
        httpRequestInterceptorCacheBusterProvider.setMatchlist([/.*api.*/, /.*protected.*/], true);

        $urlRouterProvider.otherwise('/');

        $httpProvider.interceptors.push('errorHandlerInterceptor');
        $httpProvider.interceptors.push('authExpiredInterceptor');
        $httpProvider.interceptors.push('notificationInterceptor');
        // jhipster-needle-angularjs-add-interceptor JHipster will add new application http interceptor here

        $urlMatcherFactoryProvider.type('boolean', {
            name : 'boolean',
            decode: function(val) { return val === true || val === 'true'; },
            encode: function(val) { return val ? 1 : 0; },
            equals: function(a, b) { return this.is(a) && a === b; },
            is: function(val) { return [true,false,0,1].indexOf(val) >= 0; },
            pattern: /bool|true|0|1/
        });
    }
})();

/*
 * Copyright (c) 2017 by Julian Feder, julian.feder@yahoo.de
 *
 * This product includes software developed at
 * The Apache Software Foundation (http://www.apache.org/).
 */

(function() {
    'use strict';

    angular
        .module('askApp')
        .config(compileServiceConfig);

    compileServiceConfig.$inject = ['$compileProvider','DEBUG_INFO_ENABLED'];

    function compileServiceConfig($compileProvider,DEBUG_INFO_ENABLED) {
        // disable debug data on prod profile to improve performance
        $compileProvider.debugInfoEnabled(DEBUG_INFO_ENABLED);

        /*
        If you wish to debug an application with this information
        then you should open up a debug console in the browser
        then call this method directly in this console:

		angular.reloadWithDebugInfo();
		*/
    }
})();

/*
 * Copyright (c) 2017 by Julian Feder, julian.feder@yahoo.de
 *
 * This product includes software developed at
 * The Apache Software Foundation (http://www.apache.org/).
 */

(function() {
    'use strict';

    angular
        .module('askApp')
        .config(alertServiceConfig);

    alertServiceConfig.$inject = ['AlertServiceProvider'];

    function alertServiceConfig(AlertServiceProvider) {
        // set below to true to make alerts look like toast
        AlertServiceProvider.showAsToast(false);
    }
})();

/*
 * Copyright (c) 2017 by Julian Feder, julian.feder@yahoo.de
 *
 * This product includes software developed at
 * The Apache Software Foundation (http://www.apache.org/).
 */

(function() {
    'use strict';

    angular
        .module('askApp')
        .config(stateConfig)
        .config(['$locationProvider', function($locationProvider) {
            $locationProvider.hashPrefix('');
        }]);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider.state('app', {
            abstract: true,
            views: {
                'navbar@': {
                    templateUrl: 'app/layouts/navbar/navbar.html',
                    controller: 'NavbarController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                authorize: ['Auth',
                    function (Auth) {
                        return Auth.authorize();
                    }
                ],
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('global');
                }]
            }
        });
    }
})();

(function () {
    'use strict';
    // DO NOT EDIT THIS FILE, EDIT THE GULP TASK NGCONSTANT SETTINGS INSTEAD WHICH GENERATES THIS FILE
    angular
        .module('askApp')
        .constant('VERSION', "1.12.3")
        .constant('DEBUG_INFO_ENABLED', false)
;
})();

/*
 * Copyright (c) 2017 by Julian Feder, julian.feder@yahoo.de
 *
 * This product includes software developed at
 * The Apache Software Foundation (http://www.apache.org/).
 */

(function() {
    'use strict';

    angular
        .module('askApp')
        .controller('UserManagementDialogController',UserManagementDialogController);

    UserManagementDialogController.$inject = ['$stateParams', '$uibModalInstance', 'entity', 'User', 'JhiLanguageService'];

    function UserManagementDialogController ($stateParams, $uibModalInstance, entity, User, JhiLanguageService) {
        var vm = this;

        vm.authorities = [
            'ROLE_USER',
            'ROLE_ADMIN',
            'ROLE_BOARD',
            'ROLE_FINANCE',
            'ROLE_MANAGER',
            'ROLE_DINGHY',
            'ROLE_SKIPPER',
            'ROLE_SKIPPER_CANDIDATE',
            'ROLE_SKIPPER_ASKEW',
            'ROLE_SKIPPER_MANAGER',
            'ROLE_INSTRUCTOR',
            'ROLE_SKS_PLUS',
            'ROLE_SAILOR_COUNCIL',
            'ROLE_BOAT',
            'ROLE_CLOUD',
            'ROLE_UNIVERSITY_GROUP',
            'ROLE_IT'
        ];
        vm.clear = clear;
        vm.languages = null;
        vm.save = save;
        vm.user = entity;


        JhiLanguageService.getAll().then(function (languages) {
            vm.languages = languages;
        });

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function onSaveSuccess (result) {
            vm.isSaving = false;
            $uibModalInstance.close(result);
        }

        function onSaveError () {
            vm.isSaving = false;
        }

        function save () {
            vm.isSaving = true;
            if (vm.user.id !== null) {
                User.update(vm.user, onSaveSuccess, onSaveError);
            } else {
                //User.save(vm.user, onSaveSuccess, onSaveError);
            }
        }
    }
})();

/*
 * Copyright (c) 2017 by Julian Feder, julian.feder@yahoo.de
 *
 * This product includes software developed at
 * The Apache Software Foundation (http://www.apache.org/).
 */

(function() {
    'use strict';

    angular
        .module('askApp')
        .controller('UserManagementDetailController', UserManagementDetailController);

    UserManagementDetailController.$inject = ['$stateParams', 'User'];

    function UserManagementDetailController($stateParams, User) {
        var vm = this;

        vm.load = load;
        vm.user = {};

        vm.load($stateParams.login);

        function load(login) {
            User.get({login: login}, function(result) {
                vm.user = result;
            });
        }
    }
})();

/*
 * Copyright (c) 2017 by Julian Feder, julian.feder@yahoo.de
 *
 * This product includes software developed at
 * The Apache Software Foundation (http://www.apache.org/).
 */

(function() {
    'use strict';

    angular
        .module('askApp')
        .controller('UserManagementDeleteController', UserManagementDeleteController);

    UserManagementDeleteController.$inject = ['$uibModalInstance', 'entity', 'User'];

    function UserManagementDeleteController ($uibModalInstance, entity, User) {
        var vm = this;

        vm.user = entity;
        vm.clear = clear;
        vm.confirmDelete = confirmDelete;

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function confirmDelete (login) {
            User.delete({login: login},
                function () {
                    $uibModalInstance.close(true);
                });
        }
    }
})();

/*
 * Copyright (c) 2017 by Julian Feder, julian.feder@yahoo.de
 *
 * This product includes software developed at
 * The Apache Software Foundation (http://www.apache.org/).
 */

(function() {
    'use strict';

    angular
        .module('askApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
        .state('user-management', {
            parent: 'admin',
            url: '/user-management?page&search&sort',
            data: {
                authorities: ['ROLE_ADMIN'],
                pageTitle: 'userManagement.home.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/admin/user-management/user-management.html',
                    controller: 'UserManagementController',
                    controllerAs: 'vm'
                }
            },            params: {
                page: {
                    value: '1',
                    squash: true
                },
                sort: {
                    value: 'id,asc',
                    squash: true
                }
            },
            resolve: {
                pagingParams: ['$stateParams', 'PaginationUtil', function ($stateParams, PaginationUtil) {
                    return {
                        page: PaginationUtil.parsePage($stateParams.page),
                        sort: $stateParams.sort,
                        predicate: PaginationUtil.parsePredicate($stateParams.sort),
                        ascending: PaginationUtil.parseAscending($stateParams.sort),
                        search: $stateParams.search
                    };
                }],
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('user-management');
                    $translatePartialLoader.addPart('member-management');
                    return $translate.refresh();
                }]

            }
        })
        .state('user-management.edit', {
            url: '/{login}/edit',
            data: {
                authorities: ['ROLE_ADMIN']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/admin/user-management/user-management-dialog.html',
                    controller: 'UserManagementDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: ['User', function(User) {
                            return User.get({login : $stateParams.login});
                        }]
                    }
                }).result.then(function() {
                    $state.go('user-management', null, { reload: true });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('user-management-detail', {
            parent: 'user-management',
            url: '/{login}',
            data: {
                authorities: ['ROLE_ADMIN'],
                pageTitle: 'user-management.detail.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/admin/user-management/user-management-detail.html',
                    controller: 'UserManagementDetailController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('user-management');
                    return $translate.refresh();
                }]
            }
        })
        .state('user-management.delete', {
            url: '/{login}/delete',
            data: {
                authorities: ['ROLE_ADMIN']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/admin/user-management/user-management-delete-dialog.html',
                    controller: 'UserManagementDeleteController',
                    controllerAs: 'vm',
                    size: 'md',
                    resolve: {
                        entity: ['User', function(User) {
                            return User.get({login : $stateParams.login});
                        }]
                    }
                }).result.then(function() {
                    $state.go('user-management', null, { reload: true });
                }, function() {
                    $state.go('^');
                });
            }]
        });
    }
})();

/*
 * Copyright (c) 2019 by Felix Heim, felix@ask-ev.de
 *
 * This product includes software developed at
 * The Apache Software Foundation (http://www.apache.org/).
 */

(function() {
    'use strict';

    angular
        .module('askApp')
        .factory('UserManagementSearch', UserManagementSearch);

    UserManagementSearch.$inject = ['$resource'];

    function UserManagementSearch($resource) {
        var resourceUrl =  'api/_search/users/:id';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true}
        });
    }
})();

/*
 * Copyright (c) 2017 by Julian Feder, julian.feder@yahoo.de
 *
 * This product includes software developed at
 * The Apache Software Foundation (http://www.apache.org/).
 */

(function() {
    'use strict';

    angular
        .module('askApp')
        .controller('UserManagementController', UserManagementController);

    UserManagementController.$inject = ['Principal', 'User', 'UserManagementSearch', 'ParseLinks', 'AlertService', '$state', 'pagingParams', 'paginationConstants', 'JhiLanguageService'];

    function UserManagementController(Principal, User, UserManagementSearch, ParseLinks, AlertService, $state, pagingParams, paginationConstants, JhiLanguageService) {
        var vm = this;

        vm.currentAccount = null;
        vm.languages = null;
        vm.search = search;
        vm.loadAll = loadAll;
        vm.setActive = setActive;
        vm.users = [];
        vm.page = 1;
        vm.totalItems = null;
        vm.clear = clear;
        vm.links = null;
        vm.loadPage = loadPage;
        vm.predicate = pagingParams.predicate;
        vm.reverse = pagingParams.ascending;
        vm.itemsPerPage = paginationConstants.itemsPerPage;
        vm.transition = transition;
        vm.searchQuery = pagingParams.search;
        vm.currentSearch = pagingParams.search;

        vm.loadAll();

        JhiLanguageService.getAll().then(function (languages) {
            vm.languages = languages;
        });

        Principal.identity().then(function(account) {
            vm.currentAccount = account;
        });

        function setActive (user, isActivated) {
            user.activated = isActivated;
            User.update(user, function () {
                vm.loadAll();
                vm.clear();
            });
        }

        function loadAll () {
            if (pagingParams.search) {
                UserManagementSearch.query({
                    query: pagingParams.search,
                    page: pagingParams.page - 1,
                    size: vm.itemsPerPage,
                    sort: sort()
                }, onSuccess, onError);
            } else {
                User.query({
                    page: pagingParams.page - 1,
                    size: vm.itemsPerPage,
                    sort: sort()
                }, onSuccess, onError);
            }
        }

        function onSuccess(data, headers) {
            vm.links = ParseLinks.parse(headers('link'));
            vm.totalItems = headers('X-Total-Count');
            vm.queryCount = vm.totalItems;
            vm.page = pagingParams.page;
            vm.users = data;
        }

        function onError(error) {
            AlertService.error(error.data.message);
        }

        function clear () {
            vm.links = null;
            vm.page = 1;
            vm.predicate = 'id';
            vm.reverse = false;
            vm.currentSearch = null;
            vm.transition();
        }

        function sort () {
            var sorting = vm.reverse ? 'asc' : 'desc';
            var result = [vm.predicate + ',' + sorting];
            if (vm.predicate !== 'id') {
                result.push('id,' + sorting);
            }
            return result;
        }

        function loadPage (page) {
            vm.page = page;
            vm.transition();
        }

        function transition () {
            $state.transitionTo($state.$current, {
                page: vm.page,
                sort: vm.predicate + ',' + (vm.reverse ? 'asc' : 'desc'),
                search: vm.currentSearch
            });
        }

        function search(searchQuery) {
            if (!searchQuery){
                return vm.clear();
            }
            vm.links = null;
            vm.page = 1;
            vm.predicate = '_score';
            vm.reverse = false;
            vm.currentSearch = searchQuery;
            vm.transition();
        }
    }
})();

/*
 * Copyright (c) 2017 by Julian Feder, julian.feder@yahoo.de
 *
 * This product includes software developed at
 * The Apache Software Foundation (http://www.apache.org/).
 */

(function() {
    'use strict';

    angular
        .module('askApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider.state('jhi-tracker', {
            parent: 'admin',
            url: '/tracker',
            data: {
                authorities: ['ROLE_ADMIN'],
                pageTitle: 'tracker.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/admin/tracker/tracker.html',
                    controller: 'JhiTrackerController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('tracker');
                    return $translate.refresh();
                }]
            },
            onEnter: ['JhiTrackerService', function(JhiTrackerService) {
                JhiTrackerService.subscribe();
            }],
            onExit: ['JhiTrackerService', function(JhiTrackerService) {
                JhiTrackerService.unsubscribe();
            }]
        });
    }
})();

/*
 * Copyright (c) 2017 by Julian Feder, julian.feder@yahoo.de
 *
 * This product includes software developed at
 * The Apache Software Foundation (http://www.apache.org/).
 */

(function() {
    'use strict';
    /* globals SockJS, Stomp */

    angular
        .module('askApp')
        .factory('JhiTrackerService', JhiTrackerService);

    JhiTrackerService.$inject = ['$rootScope', '$window', '$cookies', '$http', '$q'];

    function JhiTrackerService ($rootScope, $window, $cookies, $http, $q) {
        var stompClient = null;
        var subscriber = null;
        var listener = $q.defer();
        var connected = $q.defer();
        var alreadyConnectedOnce = false;

        var service = {
            connect: connect,
            disconnect: disconnect,
            receive: receive,
            sendActivity: sendActivity,
            subscribe: subscribe,
            unsubscribe: unsubscribe
        };

        return service;

        function connect () {
            //building absolute path so that websocket doesn't fail when deploying with a context path
            var loc = $window.location;
            var url = '//' + loc.host + loc.pathname + 'websocket/tracker';
            var socket = new SockJS(url);
            stompClient = Stomp.over(socket);
            var stateChangeStart;
            var headers = {};
            headers[$http.defaults.xsrfHeaderName] = $cookies.get($http.defaults.xsrfCookieName);
            stompClient.connect(headers, function() {
                connected.resolve('success');
                sendActivity();
                if (!alreadyConnectedOnce) {
                    stateChangeStart = $rootScope.$on('$stateChangeStart', function () {
                        sendActivity();
                    });
                    alreadyConnectedOnce = true;
                }
            });
            $rootScope.$on('$destroy', function () {
                if(angular.isDefined(stateChangeStart) && stateChangeStart !== null){
                    stateChangeStart();
                }
            });
        }

        function disconnect () {
            if (stompClient !== null) {
                stompClient.disconnect();
                stompClient = null;
            }
        }

        function receive () {
            return listener.promise;
        }

        function sendActivity() {
            if (stompClient !== null && stompClient.connected) {
                stompClient
                    .send('/topic/activity',
                    {},
                    angular.toJson({'page': $rootScope.toState.name}));
            }
        }

        function subscribe () {
            connected.promise.then(function() {
                subscriber = stompClient.subscribe('/topic/tracker', function(data) {
                    listener.notify(angular.fromJson(data.body));
                });
            }, null, null);
        }

        function unsubscribe () {
            if (subscriber !== null) {
                subscriber.unsubscribe();
            }
            listener = $q.defer();
        }
    }
})();

/*
 * Copyright (c) 2017 by Julian Feder, julian.feder@yahoo.de
 *
 * This product includes software developed at
 * The Apache Software Foundation (http://www.apache.org/).
 */

(function () {
    'use strict';

    angular
        .module('askApp')
        .controller('JhiTrackerController', JhiTrackerController);

    JhiTrackerController.$inject = ['$cookies', '$http', 'JhiTrackerService'];

    function JhiTrackerController ($cookies, $http, JhiTrackerService) {
        // This controller uses a Websocket connection to receive user activities in real-time.
        var vm = this;

        vm.activities = [];

        JhiTrackerService.receive().then(null, null, function(activity) {
            showActivity(activity);
        });

        function showActivity(activity) {
            var existingActivity = false;
            for (var index = 0; index < vm.activities.length; index++) {
                if(vm.activities[index].sessionId === activity.sessionId) {
                    existingActivity = true;
                    if (activity.page === 'logout') {
                        vm.activities.splice(index, 1);
                    } else {
                        vm.activities[index] = activity;
                    }
                }
            }
            if (!existingActivity && (activity.page !== 'logout')) {
                vm.activities.push(activity);
            }
        }

    }
})();

/*
 * Copyright (c) 2017 by Julian Feder, julian.feder@yahoo.de
 *
 * This product includes software developed at
 * The Apache Software Foundation (http://www.apache.org/).
 */

(function() {
    'use strict';

    angular
        .module('askApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider.state('jhi-metrics', {
            parent: 'admin',
            url: '/metrics',
            data: {
                authorities: ['ROLE_ADMIN'],
                pageTitle: 'metrics.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/admin/metrics/metrics.html',
                    controller: 'JhiMetricsMonitoringController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('metrics');
                    return $translate.refresh();
                }]
            }
        });
    }
})();

/*
 * Copyright (c) 2017 by Julian Feder, julian.feder@yahoo.de
 *
 * This product includes software developed at
 * The Apache Software Foundation (http://www.apache.org/).
 */

(function() {
    'use strict';

    angular
        .module('askApp')
        .factory('JhiMetricsService', JhiMetricsService);

    JhiMetricsService.$inject = ['$rootScope', '$http'];

    function JhiMetricsService ($rootScope, $http) {
        var service = {
            getMetrics: getMetrics,
            threadDump: threadDump
        };

        return service;

        function getMetrics () {
            return $http.get('management/metrics').then(function (response) {
                return response.data;
            });
        }

        function threadDump () {
            return $http.get('management/dump').then(function (response) {
                return response.data;
            });
        }
    }
})();

/*
 * Copyright (c) 2017 by Julian Feder, julian.feder@yahoo.de
 *
 * This product includes software developed at
 * The Apache Software Foundation (http://www.apache.org/).
 */

(function() {
    'use strict';

    angular
        .module('askApp')
        .controller('JhiMetricsMonitoringModalController', JhiMetricsMonitoringModalController);

    JhiMetricsMonitoringModalController.$inject = ['$uibModalInstance', 'threadDump'];

    function JhiMetricsMonitoringModalController ($uibModalInstance, threadDump) {
        var vm = this;

        vm.cancel = cancel;
        vm.getLabelClass = getLabelClass;
        vm.threadDump = threadDump;
        vm.threadDumpAll = 0;
        vm.threadDumpBlocked = 0;
        vm.threadDumpRunnable = 0;
        vm.threadDumpTimedWaiting = 0;
        vm.threadDumpWaiting = 0;

        angular.forEach(threadDump, function(value) {
            if (value.threadState === 'RUNNABLE') {
                vm.threadDumpRunnable += 1;
            } else if (value.threadState === 'WAITING') {
                vm.threadDumpWaiting += 1;
            } else if (value.threadState === 'TIMED_WAITING') {
                vm.threadDumpTimedWaiting += 1;
            } else if (value.threadState === 'BLOCKED') {
                vm.threadDumpBlocked += 1;
            }
        });

        vm.threadDumpAll = vm.threadDumpRunnable + vm.threadDumpWaiting +
            vm.threadDumpTimedWaiting + vm.threadDumpBlocked;

        function cancel () {
            $uibModalInstance.dismiss('cancel');
        }

        function getLabelClass (threadState) {
            if (threadState === 'RUNNABLE') {
                return 'label-success';
            } else if (threadState === 'WAITING') {
                return 'label-info';
            } else if (threadState === 'TIMED_WAITING') {
                return 'label-warning';
            } else if (threadState === 'BLOCKED') {
                return 'label-danger';
            }
        }
    }
})();

/*
 * Copyright (c) 2017 by Julian Feder, julian.feder@yahoo.de
 *
 * This product includes software developed at
 * The Apache Software Foundation (http://www.apache.org/).
 */

(function() {
    'use strict';

    angular
        .module('askApp')
        .controller('JhiMetricsMonitoringController', JhiMetricsMonitoringController);

    JhiMetricsMonitoringController.$inject = ['$scope','JhiMetricsService', '$uibModal'];

    function JhiMetricsMonitoringController ($scope, JhiMetricsService, $uibModal) {
        var vm = this;

        vm.metrics = {};
        vm.refresh = refresh;
        vm.refreshThreadDumpData = refreshThreadDumpData;
        vm.servicesStats = {};
        vm.updatingMetrics = true;

        vm.refresh();

        $scope.$watch('vm.metrics', function (newValue) {
            vm.servicesStats = {};
            angular.forEach(newValue.timers, function (value, key) {
                if (key.indexOf('web.rest') !== -1 || key.indexOf('service') !== -1) {
                    vm.servicesStats[key] = value;
                }
            });

        });

        function refresh () {
            vm.updatingMetrics = true;
            JhiMetricsService.getMetrics().then(function (promise) {
                vm.metrics = promise;
                vm.updatingMetrics = false;
            }, function (promise) {
                vm.metrics = promise.data;
                vm.updatingMetrics = false;
            });
        }

        function refreshThreadDumpData () {
            JhiMetricsService.threadDump().then(function(data) {
                $uibModal.open({
                    templateUrl: 'app/admin/metrics/metrics.modal.html',
                    controller: 'JhiMetricsMonitoringModalController',
                    controllerAs: 'vm',
                    size: 'lg',
                    resolve: {
                        threadDump: function() {
                            return data;
                        }

                    }
                });
            });
        }


    }
})();

/*
 * Copyright (c) 2017 by Julian Feder, julian.feder@yahoo.de
 *
 * This product includes software developed at
 * The Apache Software Foundation (http://www.apache.org/).
 */

(function() {
    'use strict';

    angular
        .module('askApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider.state('logs', {
            parent: 'admin',
            url: '/logs',
            data: {
                authorities: ['ROLE_ADMIN'],
                pageTitle: 'logs.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/admin/logs/logs.html',
                    controller: 'LogsController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('logs');
                    return $translate.refresh();
                }]
            }
        });
    }
})();

/*
 * Copyright (c) 2017 by Julian Feder, julian.feder@yahoo.de
 *
 * This product includes software developed at
 * The Apache Software Foundation (http://www.apache.org/).
 */

(function() {
    'use strict';

    angular
        .module('askApp')
        .factory('LogsService', LogsService);

    LogsService.$inject = ['$resource'];

    function LogsService ($resource) {
        var service = $resource('management/logs', {}, {
            'findAll': { method: 'GET', isArray: true},
            'changeLevel': { method: 'PUT'}
        });

        return service;
    }
})();

/*
 * Copyright (c) 2017 by Julian Feder, julian.feder@yahoo.de
 *
 * This product includes software developed at
 * The Apache Software Foundation (http://www.apache.org/).
 */

(function() {
    'use strict';

    angular
        .module('askApp')
        .controller('LogsController', LogsController);

    LogsController.$inject = ['LogsService'];

    function LogsController (LogsService) {
        var vm = this;

        vm.changeLevel = changeLevel;
        vm.loggers = LogsService.findAll();

        function changeLevel (name, level) {
            LogsService.changeLevel({name: name, level: level}, function () {
                vm.loggers = LogsService.findAll();
            });
        }
    }
})();

/*
 * Copyright (c) 2017 by Julian Feder, julian.feder@yahoo.de
 *
 * This product includes software developed at
 * The Apache Software Foundation (http://www.apache.org/).
 */

(function() {
    'use strict';

    angular
        .module('askApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider.state('jhi-health', {
            parent: 'admin',
            url: '/health',
            data: {
                authorities: ['ROLE_ADMIN'],
                pageTitle: 'health.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/admin/health/health.html',
                    controller: 'JhiHealthCheckController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('health');
                    return $translate.refresh();
                }]
            }
        });
    }
})();

/*
 * Copyright (c) 2017 by Julian Feder, julian.feder@yahoo.de
 *
 * This product includes software developed at
 * The Apache Software Foundation (http://www.apache.org/).
 */

(function() {
    'use strict';

    angular
        .module('askApp')
        .factory('JhiHealthService', JhiHealthService);

    JhiHealthService.$inject = ['$rootScope', '$http'];

    function JhiHealthService ($rootScope, $http) {
        var separator = '.';
        var service = {
            checkHealth: checkHealth,
            transformHealthData: transformHealthData,
            getBaseName: getBaseName,
            getSubSystemName: getSubSystemName
        };

        return service;

        function checkHealth () {
            return $http.get('management/health').then(function (response) {
                return response.data;
            });
        }

        function transformHealthData (data) {
            var response = [];
            flattenHealthData(response, null, data);
            return response;
        }

        function getBaseName (name) {
            if (name) {
                var split = name.split('.');
                return split[0];
            }
        }

        function getSubSystemName (name) {
            if (name) {
                var split = name.split('.');
                split.splice(0, 1);
                var remainder = split.join('.');
                return remainder ? ' - ' + remainder : '';
            }
        }

        /* private methods */
        function flattenHealthData (result, path, data) {
            angular.forEach(data, function (value, key) {
                if (isHealthObject(value)) {
                    if (hasSubSystem(value)) {
                        addHealthObject(result, false, value, getModuleName(path, key));
                        flattenHealthData(result, getModuleName(path, key), value);
                    } else {
                        addHealthObject(result, true, value, getModuleName(path, key));
                    }
                }
            });
            return result;
        }

        function addHealthObject (result, isLeaf, healthObject, name) {

            var healthData = {
                'name': name
            };
            var details = {};
            var hasDetails = false;

            angular.forEach(healthObject, function (value, key) {
                if (key === 'status' || key === 'error') {
                    healthData[key] = value;
                } else {
                    if (!isHealthObject(value)) {
                        details[key] = value;
                        hasDetails = true;
                    }
                }
            });

            // Add the of the details
            if (hasDetails) {
                angular.extend(healthData, { 'details': details});
            }

            // Only add nodes if they provide additional information
            if (isLeaf || hasDetails || healthData.error) {
                result.push(healthData);
            }
            return healthData;
        }

        function getModuleName (path, name) {
            var result;
            if (path && name) {
                result = path + separator + name;
            }  else if (path) {
                result = path;
            } else if (name) {
                result = name;
            } else {
                result = '';
            }
            return result;
        }

        function hasSubSystem (healthObject) {
            var result = false;
            angular.forEach(healthObject, function (value) {
                if (value && value.status) {
                    result = true;
                }
            });
            return result;
        }

        function isHealthObject (healthObject) {
            var result = false;
            angular.forEach(healthObject, function (value, key) {
                if (key === 'status') {
                    result = true;
                }
            });
            return result;
        }

    }
})();

/*
 * Copyright (c) 2017 by Julian Feder, julian.feder@yahoo.de
 *
 * This product includes software developed at
 * The Apache Software Foundation (http://www.apache.org/).
 */

(function() {
    'use strict';

    angular.module('askApp')
        .controller('HealthModalController', HealthModalController);

    HealthModalController.$inject = ['$uibModalInstance', 'currentHealth', 'baseName', 'subSystemName'];

    function HealthModalController ($uibModalInstance, currentHealth, baseName, subSystemName) {
        var vm = this;

        vm.cancel = cancel;
        vm.currentHealth = currentHealth;
        vm.baseName = baseName;
        vm.subSystemName = subSystemName;

        function cancel() {
            $uibModalInstance.dismiss('cancel');
        }
    }
})();

/*
 * Copyright (c) 2017 by Julian Feder, julian.feder@yahoo.de
 *
 * This product includes software developed at
 * The Apache Software Foundation (http://www.apache.org/).
 */

(function() {
    'use strict';

    angular
        .module('askApp')
        .controller('JhiHealthCheckController', JhiHealthCheckController);

    JhiHealthCheckController.$inject = ['JhiHealthService', '$uibModal'];

    function JhiHealthCheckController (JhiHealthService, $uibModal) {
        var vm = this;

        vm.updatingHealth = true;
        vm.getLabelClass = getLabelClass;
        vm.refresh = refresh;
        vm.showHealth = showHealth;
        vm.baseName = JhiHealthService.getBaseName;
        vm.subSystemName = JhiHealthService.getSubSystemName;

        vm.refresh();

        function getLabelClass (statusState) {
            if (statusState === 'UP') {
                return 'label-success';
            } else {
                return 'label-danger';
            }
        }

        function refresh () {
            vm.updatingHealth = true;
            JhiHealthService.checkHealth().then(function (response) {
                vm.healthData = JhiHealthService.transformHealthData(response);
                vm.updatingHealth = false;
            }, function (response) {
                vm.healthData =  JhiHealthService.transformHealthData(response.data);
                vm.updatingHealth = false;
            });
        }

        function showHealth (health) {
            $uibModal.open({
                templateUrl: 'app/admin/health/health.modal.html',
                controller: 'HealthModalController',
                controllerAs: 'vm',
                size: 'lg',
                resolve: {
                    currentHealth: function() {
                        return health;
                    },
                    baseName: function() {
                        return vm.baseName;
                    },
                    subSystemName: function() {
                        return vm.subSystemName;
                    }

                }
            });
        }

    }
})();

/*
 * Copyright (c) 2017 by Julian Feder, julian.feder@yahoo.de
 *
 * This product includes software developed at
 * The Apache Software Foundation (http://www.apache.org/).
 */

(function() {
    'use strict';

    angular
        .module('askApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider.state('entity-audit', {
            parent: 'admin',
            url: '/entity-audits',
            data: {
                authorities: ['ROLE_ADMIN'],
                pageTitle: 'Audits'
            },
            views: {
                'content@': {
                    templateUrl: 'app/admin/entity-audit/entity-audits.html',
                    controller: 'EntityAuditController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('entity-audit');
                    $translatePartialLoader.addPart('global');
                    return $translate.refresh();
                }]
            }
        });
    }
})();

/*
 * Copyright (c) 2017 by Julian Feder, julian.feder@yahoo.de
 *
 * This product includes software developed at
 * The Apache Software Foundation (http://www.apache.org/).
 */

(function() {
    'use strict';

    angular
        .module('askApp')
        .factory('EntityAuditService', EntityAuditService);

    EntityAuditService.$inject = ['$http'];

    function EntityAuditService ($http) {

        var service = {
            findAllAudited: findAllAudited,
            findByEntity: findByEntity,
            getPrevVersion: getPrevVersion
        };

        return service;

        function findAllAudited() {
            return $http.get('api/audits/entity/all').then(function (response) {
                return response.data;
            });
        }

        function findByEntity(entityType, limit) {
            return $http.get('api/audits/entity/changes', {
                params: {
                    entityType: entityType,
                    limit: limit
                }
            }).then(function (response) {
                return response.data;
            });
        }

        function getPrevVersion(qualifiedName, entityId, commitVersion) {
            return $http.get('api/audits/entity/changes/version/previous', {
                params: {
                    qualifiedName: qualifiedName,
                    entityId: entityId,
                    commitVersion: commitVersion
                }
            }).then(function (response) {
                return response.data;
            });
        }
    }
})();

/*
 * Copyright (c) 2017 by Julian Feder, julian.feder@yahoo.de
 *
 * This product includes software developed at
 * The Apache Software Foundation (http://www.apache.org/).
 */

(function() {
    'use strict';

    angular
        .module('askApp')
        .controller('AuditDetailModalCtrl', AuditDetailModalCtrl);

    AuditDetailModalCtrl.$inject = ['$scope', '$uibModalInstance', 'ObjectDiff', 'diff', 'audit'];

    function AuditDetailModalCtrl($scope, $uibModalInstance, ObjectDiff, diff, audit) {
        var vm = this;

        vm.diffValue = ObjectDiff.toJsonView(diff);
        vm.diffValueChanges = ObjectDiff.toJsonDiffView(diff);
        vm.audit = audit;
        vm.cancel = cancel;

        function cancel() {
            $uibModalInstance.dismiss('cancel');
        };
    };
})();

/*
 * Copyright (c) 2017 by Julian Feder, julian.feder@yahoo.de
 *
 * This product includes software developed at
 * The Apache Software Foundation (http://www.apache.org/).
 */

(function() {
    'use strict';

    angular
        .module('askApp')
        .controller('EntityAuditController', EntityAuditController);

    EntityAuditController.$inject = ['$scope', '$filter', '$uibModal', 'EntityAuditService', 'AlertService', 'ObjectDiff'];

    function EntityAuditController ($scope, $filter, $uibModal, EntityAuditService, AlertService, ObjectDiff) {
        var vm = this;

        vm.entities = [];
        vm.audits = [];
        vm.limits = [25, 50, 100, 200, 500, 1000];
        vm.limit = 25;
        vm.loading = false;
        vm.loadChanges = loadChanges;
        vm.findAllAudited = findAllAudited;
        vm.getEntityName = getEntityName;
        vm.format = format;
        vm.isObject = isObject;
        vm.isDate = isDate;
        vm.openChange = openChange;

        vm.findAllAudited();

        function findAllAudited() {
            EntityAuditService.findAllAudited().then(function (data) {
                vm.entities = data;
            });
        }

        function loadChanges() {
            vm.loading = true;
            var entityType = vm.qualifiedName;
            EntityAuditService.findByEntity(entityType, vm.limit).then(function (data) {
                vm.audits = data.map(function(it){
                    it.entityValue = JSON.parse(it.entityValue);
                    return it;
                });
                vm.loading = false;
            }, function(){
                vm.loading = false;
            });
        };

        function getEntityName(qualifiedName) {
            if (qualifiedName) {
                var splits = qualifiedName.split(".");
                return splits[splits.length - 1];
            }
            else return null;
        };

        function format(val){
            if(val)
                return ObjectDiff.objToJsonView(val);
            else return '';
        };

        function isObject(val){
            return (val && (typeof val) == 'object');
        };

        function isDate(key){
            return (key && key.indexOf("Date") != -1);
        };

        function openChange(audit){

            if(audit.commitVersion < 2){
                AlertService.warning("entityAudit.result.firstAuditEntry");

            } else {
                EntityAuditService.getPrevVersion(audit.entityType, audit.entityId, audit.commitVersion).then(function (data) {
                    var previousVersion = JSON.parse(data.entityValue),
                        currentVersion = audit.entityValue;
                    // enable below to have the dates formatted
                    //previousVersion = convertDates(previousVersion);
                    //currentVersion = convertDates(currentVersion);
                    var diff = ObjectDiff.diffOwnProperties(previousVersion, currentVersion);

                    $uibModal.open({
                        templateUrl: 'app/admin/entity-audit/entity-audit.detail.html',
                        controller: 'AuditDetailModalCtrl',
                        controllerAs: 'vm',
                        size: 'lg',
                        resolve: {
                            diff: function () {
                                return diff;
                            },
                            audit: function () {
                                return audit;
                            }
                        }
                    });
                });
            }
        };

        function convertDates(obj) {
            for(var key in obj) {
                if (obj.hasOwnProperty(key) && obj[key]) {
                    if (key.indexOf("Date") != -1 && (obj[key] instanceof Date || Object.prototype.toString.call(obj[key]) === '[object Date]' || (new Date(obj[key]) !== "Invalid Date" && !isNaN(new Date(obj[key]))))) {
                        obj[key] = $filter('date')(obj[key]);
                    }
                }
            }
            return obj;
        }

    }
})();

(function () {
    'use strict';

    angular
        .module('askApp')
        .controller('ElasticsearchReindexDialogController', ElasticsearchReindexDialogController);

    ElasticsearchReindexDialogController.$inject = ['$uibModalInstance', 'ElasticsearchReindex'];

    function ElasticsearchReindexDialogController($uibModalInstance, ElasticsearchReindex) {
        var vm = this;

        vm.clear = clear;
        vm.confirmReindex = confirmReindex;

        function clear() {
            $uibModalInstance.dismiss('cancel');
        }

        function confirmReindex() {
            ElasticsearchReindex.reindex(function () {
                $uibModalInstance.close(true);
            });
        }
    }
})();

(function () {
    'use strict';

    angular
        .module('askApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider.state('elasticsearch-reindex', {
            parent: 'admin',
            url: '/elasticsearch-reindex',
            data: {
                authorities: ['ROLE_ADMIN'],
                pageTitle: 'elasticsearch.reindex.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/admin/elasticsearch-reindex/elasticsearch-reindex.html',
                    controller: 'ElasticsearchReindexController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('elasticsearch-reindex');
                    $translatePartialLoader.addPart('global');
                    return $translate.refresh();
                }]
            }
        }).state('elasticsearch-reindex.dialog', {
            parent: 'elasticsearch-reindex',
            data: {
                authorities: ['ROLE_ADMIN']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function ($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/admin/elasticsearch-reindex/elasticsearch-reindex-dialog.html',
                    controller: 'ElasticsearchReindexDialogController',
                    controllerAs: 'vm',
                    size: 'sm'
                }).result.finally(function () {
                    $state.go('^');
                });
            }]
        });
    }
})();

(function () {
    'use strict';

    angular
        .module('askApp')
        .factory('ElasticsearchReindex', ElasticsearchReindex);

    ElasticsearchReindex.$inject = ['$resource'];

    function ElasticsearchReindex($resource) {
        var service = $resource('api/elasticsearch/index', {}, {
            'reindex': {method: 'POST'}
        });

        return service;
    }
})();

(function () {
    'use strict';

    angular
        .module('askApp')
        .controller('ElasticsearchReindexController', ElasticsearchReindexController);

    ElasticsearchReindexController.$inject = [];

    function ElasticsearchReindexController() {
    }
})();

/*
 * Copyright (c) 2017 by Julian Feder, julian.feder@yahoo.de
 *
 * This product includes software developed at
 * The Apache Software Foundation (http://www.apache.org/).
 */

(function() {
    'use strict';

    angular
        .module('askApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig ($stateProvider) {
        $stateProvider.state('docs', {
            parent: 'admin',
            url: '/docs',
            data: {
                authorities: ['ROLE_ADMIN'],
                pageTitle: 'global.menu.admin.apidocs'
            },
            views: {
                'content@': {
                    templateUrl: 'app/admin/docs/docs.html'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', function ($translate) {
                    return $translate.refresh();
                }]
            }
        });
    }
})();

/*
 * Copyright (c) 2017 by Julian Feder, julian.feder@yahoo.de
 *
 * This product includes software developed at
 * The Apache Software Foundation (http://www.apache.org/).
 */

(function() {
    'use strict';

    angular
        .module('askApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider.state('jhi-configuration', {
            parent: 'admin',
            url: '/configuration',
            data: {
                authorities: ['ROLE_ADMIN'],
                pageTitle: 'configuration.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/admin/configuration/configuration.html',
                    controller: 'JhiConfigurationController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('configuration');
                    return $translate.refresh();
                }]
            }
        });
    }
})();

/*
 * Copyright (c) 2017 by Julian Feder, julian.feder@yahoo.de
 *
 * This product includes software developed at
 * The Apache Software Foundation (http://www.apache.org/).
 */

(function() {
    'use strict';

    angular
        .module('askApp')
        .factory('JhiConfigurationService', JhiConfigurationService);

    JhiConfigurationService.$inject = ['$filter', '$http'];

    function JhiConfigurationService ($filter, $http) {
        var service = {
            get: get,
            getEnv: getEnv
        };

        return service;

        function get () {
            return $http.get('management/configprops').then(getConfigPropsComplete);

            function getConfigPropsComplete (response) {
                var properties = [];
                angular.forEach(response.data, function (data) {
                    properties.push(data);
                });
                var orderBy = $filter('orderBy');
                return orderBy(properties, 'prefix');
            }
        }

        function getEnv () {
            return $http.get('management/env').then(getEnvComplete);

            function getEnvComplete (response) {
                var properties = {};
                angular.forEach(response.data, function (val,key) {
                    var vals = [];
                    angular.forEach(val, function (v,k) {
                        vals.push({ key:k, val:v });
                    });
                    properties[key] = vals;
                });
                return properties;
            }
        }
    }
})();

/*
 * Copyright (c) 2017 by Julian Feder, julian.feder@yahoo.de
 *
 * This product includes software developed at
 * The Apache Software Foundation (http://www.apache.org/).
 */

(function() {
    'use strict';

    angular
        .module('askApp')
        .controller('JhiConfigurationController', JhiConfigurationController);

    JhiConfigurationController.$inject = ['$filter','JhiConfigurationService'];

    function JhiConfigurationController (filter,JhiConfigurationService) {
        var vm = this;

        vm.allConfiguration = null;
        vm.configuration = null;

        JhiConfigurationService.get().then(function(configuration) {
            vm.configuration = configuration;
        });
        JhiConfigurationService.getEnv().then(function (configuration) {
            vm.allConfiguration = configuration;
        });
    }
})();

/*
 * Copyright (c) 2017 by Julian Feder, julian.feder@yahoo.de
 *
 * This product includes software developed at
 * The Apache Software Foundation (http://www.apache.org/).
 */

(function() {
    'use strict';

    angular
        .module('askApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider.state('audits', {
            parent: 'admin',
            url: '/audits',
            data: {
                authorities: ['ROLE_ADMIN'],
                pageTitle: 'audits.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/admin/audits/audits.html',
                    controller: 'AuditsController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('audits');
                    return $translate.refresh();
                }]
            }
        });
    }
})();

/*
 * Copyright (c) 2017 by Julian Feder, julian.feder@yahoo.de
 *
 * This product includes software developed at
 * The Apache Software Foundation (http://www.apache.org/).
 */

(function() {
    'use strict';

    angular
        .module('askApp')
        .factory('AuditsService', AuditsService);

    AuditsService.$inject = ['$resource'];

    function AuditsService ($resource) {
        var service = $resource('management/audits/:id', {}, {
            'get': {
                method: 'GET',
                isArray: true
            },
            'query': {
                method: 'GET',
                isArray: true,
                params: {fromDate: null, toDate: null}
            }
        });

        return service;
    }
})();

/*
 * Copyright (c) 2017 by Julian Feder, julian.feder@yahoo.de
 *
 * This product includes software developed at
 * The Apache Software Foundation (http://www.apache.org/).
 */

(function() {
    'use strict';

    angular
        .module('askApp')
        .controller('AuditsController', AuditsController);

    AuditsController.$inject = ['$filter', 'AuditsService', 'ParseLinks'];

    function AuditsController ($filter, AuditsService, ParseLinks) {
        var vm = this;

        vm.audits = null;
        vm.fromDate = null;
        vm.links = null;
        vm.loadPage = loadPage;
        vm.onChangeDate = onChangeDate;
        vm.page = 1;
        vm.previousMonth = previousMonth;
        vm.toDate = null;
        vm.today = today;
        vm.totalItems = null;

        vm.today();
        vm.previousMonth();
        vm.onChangeDate();

        function onChangeDate () {
            var dateFormat = 'yyyy-MM-dd';
            var fromDate = $filter('date')(vm.fromDate, dateFormat);
            var toDate = $filter('date')(vm.toDate, dateFormat);

            AuditsService.query({page: vm.page -1, size: 20, fromDate: fromDate, toDate: toDate}, function(result, headers){
                vm.audits = result;
                vm.links = ParseLinks.parse(headers('link'));
                vm.totalItems = headers('X-Total-Count');
            });
        }

        // Date picker configuration
        function today () {
            // Today + 1 day - needed if the current day must be included
            var today = new Date();
            vm.toDate = new Date(today.getFullYear(), today.getMonth(), today.getDate() + 1);
        }

        function previousMonth () {
            var fromDate = new Date();
            if (fromDate.getMonth() === 0) {
                fromDate = new Date(fromDate.getFullYear() - 1, 11, fromDate.getDate());
            } else {
                fromDate = new Date(fromDate.getFullYear(), fromDate.getMonth() - 1, fromDate.getDate());
            }

            vm.fromDate = fromDate;
        }

        function loadPage (page) {
            vm.page = page;
            vm.onChangeDate();
        }
    }
})();

/*
 * Copyright (c) 2017 by Julian Feder, julian.feder@yahoo.de
 *
 * This product includes software developed at
 * The Apache Software Foundation (http://www.apache.org/).
 */

(function () {
    'use strict';

    angular
        .module('askApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig ($stateProvider) {
        $stateProvider.state('admin', {
            abstract: true,
            parent: 'app'
        });
    }
})();

/*
 * Copyright (c) 2017 by Julian Feder, julian.feder@yahoo.de
 *
 * This product includes software developed at
 * The Apache Software Foundation (http://www.apache.org/).
 */

(function() {
    'use strict';

    angular
        .module('askApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider.state('settings', {
            parent: 'account',
            url: '/settings',
            data: {
                authorities: ['ROLE_USER'],
                pageTitle: 'global.menu.account.settings'
            },
            views: {
                'content@': {
                    templateUrl: 'app/account/settings/settings.html',
                    controller: 'SettingsController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('settings');
                    return $translate.refresh();
                }]
            }
        });
    }
})();

/*
 * Copyright (c) 2017 by Julian Feder, julian.feder@yahoo.de
 *
 * This product includes software developed at
 * The Apache Software Foundation (http://www.apache.org/).
 */

(function() {
    'use strict';

    angular
        .module('askApp')
        .controller('SettingsController', SettingsController);

    SettingsController.$inject = ['Principal', 'Auth', 'JhiLanguageService', '$translate'];

    function SettingsController (Principal, Auth, JhiLanguageService, $translate) {
        var vm = this;

        vm.error = null;
        vm.save = save;
        vm.settingsAccount = null;
        vm.success = null;

        /**
         * Store the "settings account" in a separate variable, and not in the shared "account" variable.
         */
        var copyAccount = function (account) {
            return {
                activated: account.activated,
                email: account.email,
                firstName: account.firstName,
                langKey: account.langKey,
                lastName: account.lastName,
                login: account.login
            };
        };

        Principal.identity().then(function(account) {
            vm.settingsAccount = copyAccount(account);
        });

        function save () {
            Auth.updateAccount(vm.settingsAccount).then(function() {
                vm.error = null;
                vm.success = 'OK';
                Principal.identity(true).then(function(account) {
                    vm.settingsAccount = copyAccount(account);
                });
                JhiLanguageService.getCurrent().then(function(current) {
                    if (vm.settingsAccount.langKey !== current) {
                        $translate.use(vm.settingsAccount.langKey);
                    }
                });
            }).catch(function() {
                vm.success = null;
                vm.error = 'ERROR';
            });
        }
    }
})();

/*
 * Copyright (c) 2017 by Julian Feder, julian.feder@yahoo.de
 *
 * This product includes software developed at
 * The Apache Software Foundation (http://www.apache.org/).
 */

(function() {
    'use strict';

    angular
        .module('askApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider.state('sessions', {
            parent: 'account',
            url: '/sessions',
            data: {
                authorities: ['ROLE_USER'],
                pageTitle: 'global.menu.account.sessions'
            },
            views: {
                'content@': {
                    templateUrl: 'app/account/sessions/sessions.html',
                    controller: 'SessionsController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('sessions');
                    return $translate.refresh();
                }]
            }
        });
    }
})();

/*
 * Copyright (c) 2017 by Julian Feder, julian.feder@yahoo.de
 *
 * This product includes software developed at
 * The Apache Software Foundation (http://www.apache.org/).
 */

(function() {
    'use strict';

    angular
        .module('askApp')
        .controller('SessionsController', SessionsController);

    SessionsController.$inject = ['Sessions', 'Principal'];

    function SessionsController (Sessions, Principal) {
        var vm = this;

        vm.account = null;
        vm.error = null;
        vm.invalidate = invalidate;
        vm.sessions = Sessions.getAll();
        vm.success = null;


        Principal.identity().then(function(account) {
            vm.account = account;
        });

        function invalidate (series) {
            Sessions.delete({series: encodeURIComponent(series)},
                function () {
                    vm.error = null;
                    vm.success = 'OK';
                    vm.sessions = Sessions.getAll();
                },
                function () {
                    vm.success = null;
                    vm.error = 'ERROR';
                });
        }
    }
})();

/*
 * Copyright (c) 2017 by Julian Feder, julian.feder@yahoo.de
 *
 * This product includes software developed at
 * The Apache Software Foundation (http://www.apache.org/).
 */

(function() {
    'use strict';

    angular
        .module('askApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider.state('requestReset', {
            parent: 'account',
            url: '/reset/request',
            data: {
                authorities: []
            },
            views: {
                'content@': {
                    templateUrl: 'app/account/reset/request/reset.request.html',
                    controller: 'RequestResetController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('reset');
                    return $translate.refresh();
                }]
            }
        });
    }
})();

/*
 * Copyright (c) 2017 by Julian Feder, julian.feder@yahoo.de
 *
 * This product includes software developed at
 * The Apache Software Foundation (http://www.apache.org/).
 */

(function() {
    'use strict';

    angular
        .module('askApp')
        .controller('RequestResetController', RequestResetController);

    RequestResetController.$inject = ['$timeout', 'Auth'];

    function RequestResetController ($timeout, Auth) {
        var vm = this;

        vm.error = null;
        vm.errorEmailNotExists = null;
        vm.requestReset = requestReset;
        vm.resetAccount = {};
        vm.success = null;

        $timeout(function (){angular.element('#email').focus();});

        function requestReset () {

            vm.error = null;
            vm.errorEmailNotExists = null;

            Auth.resetPasswordInit(vm.resetAccount.email).then(function () {
                vm.success = 'OK';
            }).catch(function (response) {
                vm.success = null;
                if (response.status === 400 && response.data === 'email address not registered') {
                    vm.errorEmailNotExists = 'ERROR';
                } else {
                    vm.error = 'ERROR';
                }
            });
        }
    }
})();

/*
 * Copyright (c) 2017 by Julian Feder, julian.feder@yahoo.de
 *
 * This product includes software developed at
 * The Apache Software Foundation (http://www.apache.org/).
 */

(function() {
    'use strict';

    angular
        .module('askApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider.state('finishReset', {
            parent: 'account',
            url: '/reset/finish?key',
            data: {
                authorities: []
            },
            views: {
                'content@': {
                    templateUrl: 'app/account/reset/finish/reset.finish.html',
                    controller: 'ResetFinishController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('reset');
                    return $translate.refresh();
                }]
            }
        });
    }
})();

/*
 * Copyright (c) 2017 by Julian Feder, julian.feder@yahoo.de
 *
 * This product includes software developed at
 * The Apache Software Foundation (http://www.apache.org/).
 */

(function() {
    'use strict';

    angular
        .module('askApp')
        .controller('ResetFinishController', ResetFinishController);

    ResetFinishController.$inject = ['$stateParams', '$timeout', 'Auth', 'LoginService'];

    function ResetFinishController ($stateParams, $timeout, Auth, LoginService) {
        var vm = this;

        vm.keyMissing = angular.isUndefined($stateParams.key);
        vm.confirmPassword = null;
        vm.doNotMatch = null;
        vm.error = null;
        vm.finishReset = finishReset;
        vm.login = LoginService.open;
        vm.resetAccount = {};
        vm.success = null;

        $timeout(function (){angular.element('#password').focus();});

        function finishReset() {
            vm.doNotMatch = null;
            vm.error = null;
            if (vm.resetAccount.password !== vm.confirmPassword) {
                vm.doNotMatch = 'ERROR';
            } else {
                Auth.resetPasswordFinish({key: $stateParams.key, newPassword: vm.resetAccount.password}).then(function () {
                    vm.success = 'OK';
                }).catch(function () {
                    vm.success = null;
                    vm.error = 'ERROR';
                });
            }
        }
    }
})();

/*
 * Copyright (c) 2017 by Julian Feder, julian.feder@yahoo.de
 *
 * This product includes software developed at
 * The Apache Software Foundation (http://www.apache.org/).
 */

(function() {
    'use strict';

    angular
        .module('askApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider.state('register', {
            parent: 'account',
            url: '/register',
            data: {
                authorities: [],
                pageTitle: 'register.title2'
            },
            views: {
                'content@': {
                    templateUrl: 'app/account/register/register.html',
                    controller: 'RegisterController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('register');
                    $translatePartialLoader.addPart('profile');
                    $translatePartialLoader.addPart('settings');
                    $translatePartialLoader.addPart('enumGender');
                    $translatePartialLoader.addPart('enumCountry');
                    return $translate.refresh();
                }]
            }
        });
    }
})();

/*
 * Copyright (c) 2017 by Julian Feder, julian.feder@yahoo.de
 *
 * This product includes software developed at
 * The Apache Software Foundation (http://www.apache.org/).
 */

(function() {
    'use strict';

    angular
        .module('askApp')
        .controller('RegisterController', RegisterController);


    RegisterController.$inject = ['$state','$translate', '$timeout', 'Auth', 'LoginService', 'DataUtils', '$scope', 'ProfileService', 'DateUtils'];

    function RegisterController ($state, $translate, $timeout, Auth, LoginService, DataUtils, $scope, ProfileService, DateUtils) {
        var vm = this;

        vm.doNotMatch = null;
        vm.error = null;
        vm.errorUserExists = null;
        vm.errorIban = null;
        vm.errorBic = null;
        vm.errorWrongFormat = null;
        vm.errorMaxUploadSize = null;
        vm.login = LoginService.open;
        vm.register = register;
        vm.registerAccount = {};
        vm.success = null;
        vm.openCalendar = openCalendar;
        vm.datePickerOpenStatus = {};
        vm.byteSize = DataUtils.byteSize;
        vm.openFile = DataUtils.openFile;
        vm.fileSize = null;
        vm.registerAccount.captcha = null;
        $scope.$state = $state;
        vm.welcomeFee = null;
        vm.anualFee = null;
        vm.toPay = null;
        vm.calcToPay = calcToPay;
        vm.showFreeYear = false;
        vm.selectMemberStatus = selectMemberStatus;
        vm.university = false;

        $timeout(function (){angular.element('#firstName').focus();});

        init();

        function init() {
            var d = new Date();
            var n = d.getMonth();
            if(n === 10 || n === 11) {
                vm.showFreeYear = true;
            }
            vm.calcToPay();
        }

        function calcToPay() {
            ProfileService.getProfileInfo().then(function(response) {
                vm.welcomeFeeStudent = response.welcomeMembershipFeeStudent;
                vm.welcomeFeeNormal = response.welcomeMembershipFeeStudentNormal;
                vm.welcomeFee = vm.registerAccount.profile.isStudent ? vm.welcomeFeeStudent : vm.welcomeFeeNormal;
                vm.anualFee = response.anualMembershipFee;
                vm.toPay = vm.welcomeFee + vm.anualFee;
            });
        }

        function register () {
            if (vm.registerAccount.password !== vm.confirmPassword) {
                vm.doNotMatch = 'ERROR';
            } else if(vm.registerAccount.captcha === null) {
                console.log("captcha?");
            } else {
                vm.registerAccount.langKey = $translate.use();
                vm.doNotMatch = null;
                vm.error = null;
                vm.errorUserExists = null;
                vm.errorEmailExists = null;
                vm.errorBic = null;
                vm.errorIban = null;
                if (vm.registerAccount.profile.nickname) {
                    vm.registerAccount.profile.nickname = vm.registerAccount.profile.nickname.trim();
                }
                if (vm.registerAccount.profile.nickname === vm.registerAccount.firstName) {
                    vm.registerAccount.profile.nickname = null;
                }
                if (!vm.university && !vm.registerAccount.profile.isStudent) {
                    vm.registerAccount.profile.university = null;
                }
                if (vm.registerAccount.profile.isUsingSepa === true) {
                    if(vm.registerAccount.profile.isDeviatedHolder === false) {
                        vm.registerAccount.profile.bankAccountHolder = vm.registerAccount.firstName + ' ' + vm.registerAccount.lastName;
                    }
                } else {
                    vm.registerAccount.profile.bankAccountHolder = null;
                    vm.registerAccount.profile.iban = null;
                    vm.registerAccount.profile.bic = null;
                    vm.registerAccount.profile.isDeviatedHolder = false;
                }

                var copy = angular.copy(vm.registerAccount);
                copy.profile.birthdate = DateUtils.convertLocalDateToServer(copy.profile.birthdate);

                Auth.createAccount(copy).then(function () {
                    vm.success = 'OK';
                }).catch(function (response) {
                    vm.success = null;
                    if (response.status === 400 && response.data === 'login already in use') {
                        vm.errorUserExists = 'ERROR';
                    } else if (response.status === 400 && response.data === 'email address already in use') {
                        vm.errorEmailExists = 'ERROR';
                    } else if (response.status === 400 && response.data === 'bic') {
                        vm.errorBic = 'ERROR';
                    } else if (response.status === 400 && response.data === 'iban') {
                        vm.errorIban = 'ERROR';
                    } else {
                        vm.error = 'ERROR';
                    }
                });
            }
        }

        vm.datePickerOpenStatus.birthdate = false;

        vm.truncateUpload = function() {
            vm.registerAccount.profile.matriculationCertificate = null;
            vm.registerAccount.profile.matriculationCertificateContentType = null;
            vm.errorWrongFormat = false;
            vm.errorMaxUploadSize = false;
        };

        vm.truncateBancAccount = function() {
            vm.registerAccount.profile.iban = null;
            vm.registerAccount.profile.bic = null;
            vm.registerAccount.profile.bankAccountHolder = null;
            vm.registerAccount.profile.isDeviatedHolder = false;
        };

        vm.truncateBancAccountHolder = function() {
            vm.registerAccount.profile.bankAccountHolder = null;
        };

        vm.setMatriculationCertificate = function ($file, profile) {
            if ($file) {
                if ($file.type !== 'application/pdf') {
                    vm.errorWrongFormat = true;
                } else {
                    DataUtils.toBase64($file, function(base64Data) {
                        vm.fileSize = vm.byteSize(base64Data).replace(/\s/g, '').replace('bytes', '');
                        if (vm.fileSize > 2097152) {
                            $scope.$apply(function() {
                                vm.errorMaxUploadSize = true;
                            });
                        } else {
                            $scope.$apply(function() {
                                profile.matriculationCertificate = base64Data;
                                profile.matriculationCertificateContentType = $file.type;
                                vm.errorWrongFormat = false;
                                vm.errorMaxUploadSize = false;
                            });
                        }
                    });
                }
            }
        };

        function openCalendar (date) {
            vm.datePickerOpenStatus[date] = true;
        }

        $scope.setResponse = function (response) {
            // send the `response` to your server for verification.
            console.log(response);
            vm.registerAccount.captcha = response;
        };

        $scope.cbExpiration = function() {
            // reset the 'response' object that is on scope
            console.log("expired");
            vm.registerAccount.captcha = null;
        };

        function selectMemberStatus() {
            if(vm.registerAccount.profile.memberStatus === 'gast') {
                vm.registerAccount.profile.isUsingSepa = false;
                vm.registerAccount.profile.isStudent = false;
            } else {
                vm.registerAccount.profile.isUsingSepa = true;
                vm.registerAccount.profile.isStudent = false;
            }
        }
    }
})();

/*
 * Copyright (c) 2017 by Julian Feder, julian.feder@yahoo.de
 *
 * This product includes software developed at
 * The Apache Software Foundation (http://www.apache.org/).
 */

/* globals $ */
(function() {
    'use strict';

    angular
        .module('askApp')
        .directive('passwordStrengthBar', passwordStrengthBar);

    function passwordStrengthBar () {
        var directive = {
            replace: true,
            restrict: 'E',
            template: '<div id="strength">' +
                '<small data-translate="global.messages.validate.newpassword.strength">Password strength:</small>' +
                '<ul id="strengthBar">' +
                '<li class="point"></li><li class="point"></li><li class="point"></li><li class="point"></li><li class="point"></li>' +
                '</ul>' +
                '</div>',
            scope: {
                passwordToCheck: '='
            },
            link: linkFunc
        };

        return directive;

        /* private helper methods*/

        function linkFunc(scope, iElement) {
            var strength = {
                colors: ['#F00', '#F90', '#FF0', '#9F0', '#0F0'],
                mesureStrength: function (p) {

                    var _force = 0;
                    var _regex = /[$-/:-?{-~!"^_`\[\]]/g; // "

                    var _lowerLetters = /[a-z]+/.test(p);
                    var _upperLetters = /[A-Z]+/.test(p);
                    var _numbers = /[0-9]+/.test(p);
                    var _symbols = _regex.test(p);

                    var _flags = [_lowerLetters, _upperLetters, _numbers, _symbols];
                    var _passedMatches = $.grep(_flags, function (el) {
                        return el === true;
                    }).length;

                    _force += 2 * p.length + ((p.length >= 10) ? 1 : 0);
                    _force += _passedMatches * 10;

                    // penalty (short password)
                    _force = (p.length <= 6) ? Math.min(_force, 10) : _force;

                    // penalty (poor variety of characters)
                    _force = (_passedMatches === 1) ? Math.min(_force, 10) : _force;
                    _force = (_passedMatches === 2) ? Math.min(_force, 20) : _force;
                    _force = (_passedMatches === 3) ? Math.min(_force, 40) : _force;

                    return _force;

                },
                getColor: function (s) {

                    var idx;
                    if (s <= 10) {
                        idx = 0;
                    }
                    else if (s <= 20) {
                        idx = 1;
                    }
                    else if (s <= 30) {
                        idx = 2;
                    }
                    else if (s <= 40) {
                        idx = 3;
                    }
                    else {
                        idx = 4;
                    }

                    return { idx: idx + 1, col: this.colors[idx] };
                }
            };
            scope.$watch('passwordToCheck', function (password) {
                if (password) {
                    var c = strength.getColor(strength.mesureStrength(password));
                    iElement.removeClass('ng-hide');
                    iElement.find('ul').children('li')
                        .css({ 'background-color': '#DDD' })
                        .slice(0, c.idx)
                        .css({ 'background-color': c.col });
                }
            });
        }
    }
})();

/*
 * Copyright (c) 2017 by Julian Feder, julian.feder@yahoo.de
 *
 * This product includes software developed at
 * The Apache Software Foundation (http://www.apache.org/).
 */

(function() {
    'use strict';

    angular
        .module('askApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider.state('password', {
            parent: 'account',
            url: '/password',
            data: {
                authorities: ['ROLE_USER'],
                pageTitle: 'global.menu.account.password'
            },
            views: {
                'content@': {
                    templateUrl: 'app/account/password/password.html',
                    controller: 'PasswordController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('password');
                    return $translate.refresh();
                }]
            }
        });
    }
})();

/*
 * Copyright (c) 2017 by Julian Feder, julian.feder@yahoo.de
 *
 * This product includes software developed at
 * The Apache Software Foundation (http://www.apache.org/).
 */

(function() {
    'use strict';

    angular
        .module('askApp')
        .controller('PasswordController', PasswordController);

    PasswordController.$inject = ['Auth', 'Principal'];

    function PasswordController (Auth, Principal) {
        var vm = this;

        vm.changePassword = changePassword;
        vm.doNotMatch = null;
        vm.error = null;
        vm.success = null;

        Principal.identity().then(function(account) {
            vm.account = account;
        });

        function changePassword () {
            if (vm.password !== vm.confirmPassword) {
                vm.error = null;
                vm.success = null;
                vm.doNotMatch = 'ERROR';
            } else {
                vm.doNotMatch = null;
                Auth.changePassword(vm.password).then(function () {
                    vm.error = null;
                    vm.success = 'OK';
                }).catch(function () {
                    vm.success = null;
                    vm.error = 'ERROR';
                });
            }
        }
    }
})();

/*
 * Copyright (c) 2017 by Julian Feder, julian.feder@yahoo.de
 *
 * This product includes software developed at
 * The Apache Software Foundation (http://www.apache.org/).
 */

(function() {
    'use strict';

    angular
        .module('askApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider.state('activate', {
            parent: 'account',
            url: '/activate?key',
            data: {
                authorities: [],
                pageTitle: 'activate.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/account/activate/activate.html',
                    controller: 'ActivationController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('activate');
                    return $translate.refresh();
                }]
            }
        });
    }
})();

/*
 * Copyright (c) 2017 by Julian Feder, julian.feder@yahoo.de
 *
 * This product includes software developed at
 * The Apache Software Foundation (http://www.apache.org/).
 */

(function() {
    'use strict';

    angular
        .module('askApp')
        .controller('ActivationController', ActivationController);

    ActivationController.$inject = ['$stateParams', 'Auth', 'LoginService', '$scope', '$state'];

    function ActivationController ($stateParams, Auth, LoginService, $scope, $state) {
        var vm = this;
        $scope.$state = $state;

        Auth.activateAccount({key: $stateParams.key}).then(function () {
            vm.error = null;
            vm.success = 'OK';
        }).catch(function () {
            vm.success = null;
            vm.error = 'ERROR';
        });

        vm.login = LoginService.open;
    }
})();

/*
 * Copyright (c) 2017 by Julian Feder, julian.feder@yahoo.de
 *
 * This product includes software developed at
 * The Apache Software Foundation (http://www.apache.org/).
 */

(function() {
    'use strict';

    angular
        .module('askApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider.state('account', {
            abstract: true,
            parent: 'app'
        });
    }
})();
(function(){angular.module('askApp').run(['$templateCache', function($templateCache) {$templateCache.put('app/home/home.html','<!--\n  ~ Copyright (c) 2017 by Julian Feder, julian.feder@yahoo.de\n  ~\n  ~ This product includes software developed at\n  ~ The Apache Software Foundation (http://www.apache.org/).\n  --><div ng-cloak><div ng-switch="vm.isAuthenticated()"><div class="row row-no-padding"><div class="col-md-8"><div ng-switch-when="false"><div class="panel panel-default"><div class="panel-body"><h2 data-translate="home.title">Welcome, Java Hipster!</h2><content-cms identifier="4"></content-cms></div></div></div><div ng-switch-when="true"><div class="panel panel-default"><div class="panel-heading"><h3 class="panel-title" ng-if="vm.profile.nickname">Ahoi {{vm.profile.nickname}}!</h3><h3 class="panel-title" ng-if="!vm.profile.nickname">Ahoi {{vm.account.firstName}}!</h3></div><div class="panel-body"><content-cms identifier="16" ng-show="vm.profile.memberStatus == \'probe\' || vm.profile.memberStatus == \'voll\'"></content-cms><content-cms identifier="25" ng-show="vm.profile.memberStatus == \'gast\'"></content-cms></div></div><div class="panel panel-default" ng-show="vm.sksSkipperOverview.length > 0"><div class="panel-heading"><h3 class="panel-title">Deine aktuellen SKS-T\xF6rns</h3></div><div class="panel-body"><jhi-alert></jhi-alert><div ng-repeat="sksTrip in vm.sksSkipperOverview track by $index"><h5><button class="btn btn-primary float-right" ng-click="vm.dataExport(sksTrip.id)" ng-disabled="sksTrip.participants.length == 0 || vm.isSaving" analytics-on analytics-event="SKS Teilnehmer exportiert"><span class="glyphicon glyphicon-export"></span> <span class="hidden-xs-down">Daten exportieren</span></button> <span class="glyphicon glyphicon-calendar" aria-hidden="true"></span> {{sksTrip.fromDate | date:"EEEE, dd.MM.yyyy"}} Uhr - {{sksTrip.untilDate | date:"EEEE, dd.MM.yyyy"}} Uhr ({{sksTrip.name}})<!--<span ng-show="sksTrip.booked" class="label label-success">Schiff ist gebucht</span>\n                                    <span ng-show="!sksTrip.booked" class="label label-danger">Schiff wurde noch nicht gebucht</span>--></h5><span ng-show="sksTrip.participants.length == 0" class="label label-danger">Bisher keine Anmeldungen</span><div ng-repeat="participant in sksTrip.participants"><ul style="margin-left: 0"><li>{{participant.firstName}} {{participant.lastName}} | <a href="tel:{{participant.phone}}">{{participant.phone}}</a> | <a href="mailto:{{participant.mail}}">{{participant.mail}}</a></li></ul></div><hr ng-hide="$last"></div></div></div><div class="panel panel-default" ng-show="vm.instructorOverview.length > 0"><div class="panel-heading"><h3 class="panel-title">Deine aktuellen Ausbildungstermine</h3></div><div class="panel-body"><div ng-repeat="slot in vm.instructorOverview | limitTo:vm.limit track by $index"><h5><span class="glyphicon glyphicon-calendar" aria-hidden="true"></span> {{slot.fromTime | date:"EEEE, dd.MM.yyyy HH:mm"}} Uhr - {{slot.toTime | date:"HH:mm"}} Uhr ({{slot.projectName}}) <span class="glyphicon glyphicon-chevron-left" ng-show="slot.instructorNameBefore" aria-hidden="true" popover-trigger="mouseenter" popover-title="Vorheriger Ausbilder" uib-popover-template="\'popover-partialBefore.html\'" style="cursor: pointer"></span> <span class="glyphicon glyphicon-chevron-right" ng-show="slot.instructorNameAfter" aria-hidden="true" popover-trigger="mouseenter" popover-title="N\xE4chster Ausbilder" uib-popover-template="\'popover-partialAfter.html\'" style="cursor: pointer"></span></h5><span ng-show="slot.participants.length == 0" class="label label-danger">Bisher keine Anmeldungen</span><div ng-repeat="participant in slot.participants"><ul style="margin-left: 0"><li>{{participant.firstName}} {{participant.lastName}} | <a href="tel:{{participant.phone}}">{{participant.phone}}</a> | <a href="mailto:{{participant.mail}}">{{participant.mail}}</a></li></ul></div><hr ng-hide="$last"></div></div><div style="text-align: center; padding: 3px; background-color: #f5f5f5; border-top: solid 1px #ddd" ng-show="vm.instructorOverview.length > vm.initLimit"><a ng-click="vm.toggleLimit()"><span ng-show="vm.limited" class="small nounderline">Alle Termine anzeigen</span> <span ng-show="!vm.limited" class="small nounderline">Weniger Termine anzeigen</span></a></div></div><uib-accordion close-others="true"><div><div uib-accordion-group class="panel-default" style="margin-bottom: 10px" is-open="status.open5"><div uib-accordion-heading><i class="glyphicon" ng-class="{\'glyphicon-chevron-down\': status.open5, \'glyphicon-chevron-right\': !status.open5}"></i> Wo ist unsere askew?</div><div class="row"><div class="col-md-12"><iframe name="marinetraffic" id="marinetraffic" width="100%" height="450" scrolling="no" frameborder="0" src="https://www.marinetraffic.com/en/ais/embed/zoom:5/centery:36/centerx:23/maptype:1/shownames:false/mmsi:211786400/shipid:0/fleet:/fleet_id:/vtypes:/showmenu:/remember:false">Browser does not support embedded objects.&lt;br/&gt;Visit directly &lt;a href="http://www.marinetraffic.com/"&gt;www.marinetraffic.com&lt;/a&gt;</iframe></div></div></div></div><div ng-show="vm.profile.full == true"><div uib-accordion-group class="panel-default" style="margin-bottom: 10px" is-open="status.open2"><div uib-accordion-heading><i class="glyphicon" ng-class="{\'glyphicon-chevron-down\': status.open2, \'glyphicon-chevron-right\': !status.open2}"></i> Praktisches zum Segeln</div><div class="row"><div class="col-md-12"><content-cms identifier="18"></content-cms></div></div></div></div><div ng-show="vm.profile.full == true"><div uib-accordion-group class="panel-default" style="margin-bottom: 10px" is-open="status.open4"><div uib-accordion-heading><i class="glyphicon" ng-class="{\'glyphicon-chevron-down\': status.open4, \'glyphicon-chevron-right\': !status.open4}"></i> Wichtige Regelungen</div><div class="row"><div class="col-md-12"><content-cms identifier="20"></content-cms></div></div></div></div><div ng-show="vm.profile.full == true"><div uib-accordion-group class="panel-default" style="margin-bottom: 10px" is-open="status.open"><div uib-accordion-heading><i class="glyphicon" ng-class="{\'glyphicon-chevron-down\': status.open, \'glyphicon-chevron-right\': !status.open}"></i> Protokolle der vergangenen Jahreshauptversammlungen</div><div class="row"><div class="col-md-12"><content-cms identifier="17"></content-cms></div></div></div></div><div ng-show="vm.profile.full == true"><div uib-accordion-group class="panel-default" style="margin-bottom: 10px" is-open="status.open3"><div uib-accordion-heading><i class="glyphicon" ng-class="{\'glyphicon-chevron-down\': status.open3, \'glyphicon-chevron-right\': !status.open3}"></i> Satzung und Ordnungsverzeichnis</div><div class="row"><div class="col-md-12"><content-cms identifier="19"></content-cms></div></div></div></div></uib-accordion></div></div><div class="col-md-4" ng-switch-when="true"><div class="panel panel-default"><div class="panel-heading"><h3 class="panel-title">Instagram</h3></div><div class="panel-body"><iframe width="100%" height="670" style="border:none;overflow:scroll" scrolling="no" frameborder="0" allowtransparency="true" src="https://b8194d9f57ca43dda6957f92b3814590.elf.site"></iframe></div></div></div></div></div></div><script type="text/ng-template" id="popover-partialBefore.html"><div>\n        {{slot.instructorNameBefore}} | {{slot.instructorPhoneBefore}}\n    </div></script><script type="text/ng-template" id="popover-partialAfter.html"><div>\n        {{slot.instructorNameAfter}} | {{slot.instructorPhoneAfter}}\n    </div></script>');
$templateCache.put('app/home/privacy.html','<!--\n  ~ Copyright (c) 2019 by Felix Heim, felix-heim@web.de\n  ~\n  ~ This product includes software developed at\n  ~ The Apache Software Foundation (http://www.apache.org/).\n  --><div ng-cloak><div class="row row-no-padding"><div class="col-md-12"><jhi-alert></jhi-alert><div class="panel panel-default"><div class="panel-body"><h2><strong>Allgemeine Hinweise zum Datenschutz</strong></h2><p>Die folgenden Hinweise geben einen einfachen \xDCberblick dar\xFCber, was mit Ihren personenbezogenen Daten passiert, wenn Sie unsere Vereinsportal nutzen. Personenbezogene Daten sind alle Daten, mit denen Sie pers\xF6nlich identifiziert werden k\xF6nnen. Die Nutzung unseres Vereinsportals ist ohne Angaben personenbezogener Daten nicht m\xF6glich. Zur Nutzung des Portals muss ein (Gast-)mitgliedsantrag gestellt werden. Die dabei ben\xF6tigten personenbezogenen Daten werden nach der Datenschutzrichtline des Vereins ben\xF6tigt, gespeichert und verwendet. Diese ist vor Beitritt in den Verein einsehbar. Der Umgang mit allen weiteren Daten und eine&nbsp;usf\xFChrliche Informationen zum Thema Datenschutz entnehmen Sie unserer unter diesem Text aufgef\xFChrten Datenschutzerkl\xE4rung.</p><h2><strong>Datenerfassung auf unserer Website</strong></h2><h4><strong>Wer ist verantwortlich f\xFCr die Datenerfassung auf dieser Website?</strong></h4><p>Die Datenverarbeitung auf dieser Website erfolgt durch die Akademische Segelgruppe Karlsruhe&nbsp;e.V.&nbsp;</p><h4><strong>Wie erfassen wir Ihre Daten?</strong></h4><p>Ihre Daten werden zum einen dadurch erhoben, dass Sie uns diese mitteilen. Hierbei handelt es sich, um das Ausf\xFCllen eines&nbsp;(Gast-)mitgliedsantrages.</p><p>Andere Daten werden automatisch beim Besuch der Website durch unsere IT-Systeme erfasst. Das sind vor allem technische Daten (z.B. Internetbrowser, Betriebssystem oder Uhrzeit des Seitenaufrufs). Die Erfassung dieser Daten erfolgt automatisch, sobald Sie unsere Website betreten.</p><h4><strong>Wof\xFCr nutzen wir Ihre Daten?</strong></h4><p>Ein Teil der Daten wird erhoben, um eine fehlerfreie Bereitstellung der Website zu gew\xE4hrleisten. Andere Daten k\xF6nnen zur Analyse Ihres Nutzerverhaltens verwendet werden.</p><h4><strong>Welche Rechte haben Sie bez\xFCglich Ihrer Daten?</strong></h4><p>Sie haben jederzeit das Recht unentgeltlich Auskunft \xFCber Herkunft, Empf\xE4nger und Zweck Ihrer gespeicherten personenbezogenen Daten zu erhalten. Sie haben au\xDFerdem ein Recht, die Berichtigung, Sperrung oder L\xF6schung dieser Daten zu verlangen. Hierzu sowie zu weiteren Fragen zum Thema Datenschutz k\xF6nnen Sie sich jederzeit an unseren Datenschutzbeauftragten wenden. Des Weiteren steht Ihnen ein Beschwerderecht bei der zust\xE4ndigen Aufsichtsbeh\xF6rde zu.</p><h2><strong>Allgemeine Hinweise und Pflichtinformationen</strong></h2><h4><strong>Datenschutz</strong></h4><p>Die Betreiber dieser Seiten nehmen den Schutz Ihrer pers\xF6nlichen Daten sehr ernst. Wir behandeln Ihre personenbezogenen Daten vertraulich und entsprechend der gesetzlichen Datenschutzvorschriften sowie dieser Datenschutzerkl\xE4rung.</p><p>Wenn Sie diese Website benutzen, werden verschiedene personenbezogene Daten erhoben. Personenbezogene Daten sind Daten, mit denen Sie pers\xF6nlich identifiziert werden k\xF6nnen. Die vorliegende Datenschutzerkl\xE4rung erl\xE4utert, welche Daten wir erheben und wof\xFCr wir sie nutzen. Sie erl\xE4utert auch, wie und zu welchem Zweck das geschieht.</p><p>Wir weisen darauf hin, dass die Daten\xFCbertragung im Internet (z.B. bei der Kommunikation per E-Mail) Sicherheitsl\xFCcken aufweisen kann. Ein l\xFCckenloser Schutz der Daten vor dem Zugriff durch Dritte ist nicht m\xF6glich.</p><h4><strong>Widerruf Ihrer Einwilligung zur Datenverarbeitung</strong></h4><p>Viele Datenverarbeitungsvorg\xE4nge sind nur mit Ihrer ausdr\xFCcklichen Einwilligung m\xF6glich. Sie k\xF6nnen eine bereits erteilte Einwilligung jederzeit widerrufen. Dazu reicht eine formlose Mitteilung per E-Mail an uns. Die Rechtm\xE4\xDFigkeit der bis zum Widerruf erfolgten Datenverarbeitung bleibt vom Widerruf unber\xFChrt.</p><h4><strong>Beschwerderecht bei der zust\xE4ndigen Aufsichtsbeh\xF6rde</strong></h4><p>Im Falle datenschutzrechtlicher Verst\xF6\xDFe steht dem Betroffenen ein Beschwerderecht bei der zust\xE4ndigen Aufsichtsbeh\xF6rde zu. Zust\xE4ndige Aufsichtsbeh\xF6rde in datenschutzrechtlichen Fragen ist der Landesdatenschutzbeauftragte des Bundeslandes, in dem unser Unternehmen seinen Sitz hat. Eine Liste der Datenschutzbeauftragten sowie deren Kontaktdaten k\xF6nnen folgendem Link entnommen werden:&nbsp;<a href="https://www.bfdi.bund.de/DE/Infothek/Anschriften_Links/anschriften_links-node.html" rel="nofollow" target="_blank">https://www.bfdi.bund.de/DE/Infothek/Anschriften_Links/anschriften_links-node.html</a>.</p><h4><strong>Recht auf Daten\xFCbertragbarkeit</strong></h4><p>Sie haben das Recht, Daten, die wir auf Grundlage Ihrer Einwilligung oder in Erf\xFCllung eines Vertrags automatisiert verarbeiten, an sich oder an einen Dritten in einem g\xE4ngigen, maschinenlesbaren Format aush\xE4ndigen zu lassen. Sofern Sie die direkte \xDCbertragung der Daten an einen anderen Verantwortlichen verlangen, erfolgt dies nur, soweit es technisch machbar ist.</p><h4><strong>SSL- bzw. TLS-Verschl\xFCsselung</strong></h4><p>Diese Seite nutzt aus Sicherheitsgr\xFCnden und zum Schutz der \xDCbertragung vertraulicher Inhalte, wie zum Beispiel Bestellungen oder Anfragen, die Sie an uns als Seitenbetreiber senden, eine SSL-bzw. TLS-Verschl\xFCsselung. Eine verschl\xFCsselte Verbindung erkennen Sie daran, dass die Adresszeile des Browsers von \u201Chttp://\u201D auf \u201Chttps://\u201D wechselt und an dem Schloss-Symbol in Ihrer Browserzeile.</p><p>Wenn die SSL- bzw. TLS-Verschl\xFCsselung aktiviert ist, k\xF6nnen die Daten, die Sie an uns \xFCbermitteln, nicht von Dritten mitgelesen werden.</p><h4><strong>Auskunft, Sperrung, L\xF6schung</strong></h4><p>Sie haben im Rahmen der geltenden gesetzlichen Bestimmungen jederzeit das Recht auf unentgeltliche Auskunft \xFCber Ihre gespeicherten personenbezogenen Daten, deren Herkunft und Empf\xE4nger und den Zweck der Datenverarbeitung und ggf. ein Recht auf Berichtigung, Sperrung oder L\xF6schung dieser Daten. Hierzu sowie zu weiteren Fragen zum Thema personenbezogene Daten k\xF6nnen Sie sich jederzeit unter der im Impressum angegebenen Adresse an uns wenden.</p><h4><strong>Widerspruch gegen Werbe-Mails</strong></h4><p>Der Nutzung von im Rahmen der Impressumspflicht ver\xF6ffentlichten Kontaktdaten zur \xDCbersendung von nicht ausdr\xFCcklich angeforderter Werbung und Informationsmaterialien wird hiermit widersprochen. Die Betreiber der Seiten behalten sich ausdr\xFCcklich rechtliche Schritte im Falle der unverlangten Zusendung von Werbeinformationen, etwa durch Spam-E-Mails, vor.</p><h2><strong>Datenerfassung \xFCber unser Portal</strong></h2><h4><strong>Cookies</strong></h4><p>Die Internetseiten verwenden teilweise so genannte Cookies. Cookies richten auf Ihrem Rechner keinen Schaden an und enthalten keine Viren. Cookies dienen dazu, unser Angebot nutzerfreundlicher, effektiver und sicherer zu machen. Cookies sind kleine Textdateien, die auf Ihrem Rechner abgelegt werden und die Ihr Browser speichert.</p><p>Die meisten der von uns verwendeten Cookies sind so genannte \u201CSession-Cookies\u201D. Sie werden nach Ende Ihres Besuchs automatisch gel\xF6scht. Andere Cookies bleiben auf Ihrem Endger\xE4t gespeichert bis Sie diese l\xF6schen. Diese Cookies erm\xF6glichen es uns, Ihren Browser beim n\xE4chsten Besuch wiederzuerkennen.</p><p>Sie k\xF6nnen Ihren Browser so einstellen, dass Sie \xFCber das Setzen von Cookies informiert werden und Cookies nur im Einzelfall erlauben, die Annahme von Cookies f\xFCr bestimmte F\xE4lle oder generell ausschlie\xDFen sowie das automatische L\xF6schen der Cookies beim Schlie\xDFen des Browser aktivieren. Bei der Deaktivierung von Cookies kann die Funktionalit\xE4t dieser Website eingeschr\xE4nkt sein.</p><p>Cookies, die zur Durchf\xFChrung des elektronischen Kommunikationsvorgangs oder zur Bereitstellung bestimmter, von Ihnen erw\xFCnschter Funktionen (z.B. Warenkorbfunktion) erforderlich sind, werden auf Grundlage von Art. 6 Abs. 1 lit. f DSGVO gespeichert. Der Websitebetreiber hat ein berechtigtes Interesse an der Speicherung von Cookies zur technisch fehlerfreien und optimierten Bereitstellung seiner Dienste. Soweit andere Cookies (z.B. Cookies zur Analyse Ihres Surfverhaltens) gespeichert werden, werden diese in dieser Datenschutzerkl\xE4rung gesondert behandelt.</p><h4><strong>Instagram Plugin via Elfsight Instagram Feed CC</strong></h4><p>Auf unseren Seiten sind Funktionen des Dienstes Instagram eingebunden. Diese Funktionen werden angeboten durch die Instagram Inc., 1601 Willow Road, Menlo Park, CA 94025, USA integriert.</p><p>Das Plugin Elfsight Instagram Feed CC l\xE4dt die Bilder direkt von Instagram. Alle weiteren Daten werden serverseitig gesammelt und zwischengespeichert. Wenn Sie als Besucher unserer Website die Inhalte laden, werden diese f\xFCr den Instagram Feed aus dem Cache von Elfsight geladen. F\xFCr diese Daten-Anfrage werden keine pers\xF6nlichen Daten gesammelt.</p><p>Weitere Informationen zum Datenschutz von Elfsight finden Sie unter:&nbsp;<a href="https://elfsight.com/privacy-policy/" target="_blank">https://elfsight.com/privacy-policy/</a>.</p><p>Weitere Informationen zur Datenschutzerkl\xE4rung von Instagram:&nbsp;<a href="https://instagram.com/about/legal/privacy/" target="_blank">https://instagram.com/about/legal/privacy/</a>.</p><h4><strong>Datenschutzerkl\xE4rung f\xFCr die Nutzung von Google Analytics</strong></h4><p>Diese Website benutzt Google Analytics, einen Webanalysedienst der Google Inc. (\u201EGoogle\u201C). Google Analytics verwendet sog. \u201ECookies\u201C, Textdateien, die auf Ihrem Computer gespeichert werden und die eine Analyse der Benutzung der Website durch Sie erm\xF6glichen. Die durch den Cookie erzeugten Informationen \xFCber Ihre Benutzung dieser Website werden in der Regel an einen Server von Google in den USA \xFCbertragen und dort gespeichert.</p><p>Im Falle der Aktivierung der IP-Anonymisierung auf dieser Webseite, wird Ihre IP-Adresse von Google jedoch innerhalb von Mitgliedstaaten der Europ\xE4ischen Union oder in anderen Vertragsstaaten des Abkommens \xFCber den Europ\xE4ischen Wirtschaftsraum zuvor gek\xFCrzt. Nur in Ausnahmef\xE4llen wird die volle IP-Adresse an einen Server von Google in den USA \xFCbertragen und dort gek\xFCrzt. Im Auftrag des Betreibers dieser Website wird Google diese Informationen benutzen, um Ihre Nutzung der Website auszuwerten, um Reports \xFCber die Websiteaktivit\xE4ten zusammenzustellen und um weitere mit der Websitenutzung und der Internetnutzung verbundene Dienstleistungen gegen\xFCber dem Websitebetreiber zu erbringenDie im Rahmen von Google Analytics von Ihrem Browser \xFCbermittelte IP-Adresse wird nicht mit anderen Daten von Google zusammengef\xFChrt.</p><p>Sie k\xF6nnen die Speicherung der Cookies durch eine entsprechende Einstellung Ihrer Browser-Software verhindern; wir weisen Sie jedoch darauf hin, dass Sie in diesem Fall gegebenenfalls nicht s\xE4mtliche Funktionen dieser Website vollumf\xE4nglich werden nutzen k\xF6nnen. Sie k\xF6nnen dar\xFCber hinaus die Erfassung der durch das Cookie erzeugten und auf Ihre Nutzung der Website bezogenen Daten (inkl. Ihrer IP-Adresse) an Google sowie die Verarbeitung dieser Daten durch Google verhindern, indem sie das unter dem folgenden Link verf\xFCgbare Browser-Plugin herunterladen und installieren&nbsp;<a href="https://tools.google.com/dlpage/gaoptout?hl=de" target="_blank">https://tools.google.com/dlpage/gaoptout?hl=de</a>.</p><h4><strong>Server-Log-Dateien</strong></h4><p>Der Provider der Seiten erhebt und speichert automatisch Informationen in so genannten Server-Log-Dateien, die Ihr Browser automatisch an uns \xFCbermittelt. Dies sind:</p><ul><li>Browsertyp und Browserversion</li><li>verwendetes Betriebssystem</li><li>Referrer URL</li><li>Hostname des zugreifenden Rechners</li><li>Uhrzeit der Serveranfrage</li><li>IP-Adresse</li></ul><p>Eine Zusammenf\xFChrung dieser Daten mit anderen Datenquellen wird nicht vorgenommen.</p><p>Grundlage f\xFCr die Datenverarbeitung ist Art. 6 Abs. 1 lit. b DSGVO, der die Verarbeitung von Daten zur Erf\xFCllung eines Vertrags oder vorvertraglicher Ma\xDFnahmen gestattet.</p><h4><strong>Verarbeiten von Daten (Kunden- und Vertragsdaten)</strong></h4><p>Wir erheben, verarbeiten und nutzen personenbezogene Daten nur, soweit sie f\xFCr die Begr\xFCndung, inhaltliche Ausgestaltung oder \xC4nderung des Rechtsverh\xE4ltnisses erforderlich sind (Bestandsdaten). Dies erfolgt auf Grundlage von Art. 6 Abs. 1 lit. b DSGVO, der die Verarbeitung von Daten zur Erf\xFCllung eines Vertrags oder vorvertraglicher Ma\xDFnahmen gestattet. Personenbezogene Daten \xFCber die Inanspruchnahme unserer Internetseiten (Nutzungsdaten) erheben, verarbeiten und nutzen wir nur, soweit dies erforderlich ist, um dem Nutzer die Inanspruchnahme des Dienstes zu erm\xF6glichen oder abzurechnen.</p><p>Die erhobenen Kundendaten werden nach Abschluss des Auftrags oder Beendigung der Gesch\xE4ftsbeziehung gel\xF6scht. Gesetzliche Aufbewahrungsfristen bleiben unber\xFChrt.</p><h4><strong>Daten\xFCbermittlung bei Vertragsschluss f\xFCr Dienstleistungen und digitale Inhalte</strong></h4><p>Wir \xFCbermitteln personenbezogene Daten an Dritte nur dann, wenn dies im Rahmen der Vertragsabwicklung notwendig ist, etwa an das mit der Zahlungsabwicklung beauftragte Kreditinstitut.</p><p>Eine weitergehende \xDCbermittlung der Daten erfolgt nicht bzw. nur dann, wenn Sie der \xDCbermittlung ausdr\xFCcklich zugestimmt haben. Eine Weitergabe Ihrer Daten an Dritte ohne ausdr\xFCckliche Einwilligung, etwa zu Zwecken der Werbung, erfolgt nicht.</p><p>Grundlage f\xFCr die Datenverarbeitung ist Art. 6 Abs. 1 lit. b DSGVO, der die Verarbeitung von Daten zur Erf\xFCllung eines Vertrags oder vorvertraglicher Ma\xDFnahmen gestattet.</p><p>Quelle:&nbsp;<a href="https://www.anwaltinfos.de/muster-disclaimer.html" rel="nofollow" target="_blank">Disclaimer</a>&nbsp;von&nbsp;<a href="https://www.disclaimer.de/" rel="nofollow" target="_blank">www.disclaimer.de</a>,&nbsp;<a href="http://oberhausen.newsweb.de/" rel="nofollow" target="_blank">Nachrichten Oberhausen</a>,&nbsp;<a href="https://www.anwaltinfos.de/rechtsanwalt/dortmund/Baurecht-Architektenrecht.html" rel="nofollow" target="_blank">Rechtsanwalt Baurecht Dortmund</a></p></div></div></div></div></div>');
$templateCache.put('app/account/activate/activate.html','<!--\n  ~ Copyright (c) 2017 by Julian Feder, julian.feder@yahoo.de\n  ~\n  ~ This product includes software developed at\n  ~ The Apache Software Foundation (http://www.apache.org/).\n  --><div><div class="row row-no-padding"><div class="col-md-6 col-md-offset-3"><div class="panel panel-default"><div class="panel-heading"><h3 class="panel-title" data-translate="activate.title">Activation</h3></div><div class="panel-body"><div class="alert alert-success" ng-show="vm.success" data-translate="activate.messages.success" translate-compile><strong>Your user has been activated.</strong> Please <a class="alert-link" href="" ng-click="vm.login()">sign in</a>.</div><div class="alert alert-danger" ng-show="vm.error" data-translate="activate.messages.error"><strong>Your user could not be activated.</strong> Please use the registration form to sign up.</div></div></div></div></div></div>');
$templateCache.put('app/account/password/password.html','<!--\n  ~ Copyright (c) 2017 by Julian Feder, julian.feder@yahoo.de\n  ~\n  ~ This product includes software developed at\n  ~ The Apache Software Foundation (http://www.apache.org/).\n  --><div><div class="row row-no-padding"><div class="col-md-6 col-md-offset-3"><h2 data-translate="password.title" translate-values="{username: \'{{vm.account.login}}\'}">Password for [<b>{{vm.account.login}}</b>]</h2><div class="alert alert-success" ng-show="vm.success" data-translate="password.messages.success"><strong>Password changed!</strong></div><div class="alert alert-danger" ng-show="vm.error" data-translate="password.messages.error"><strong>An error has occurred!</strong> The password could not be changed.</div><div class="alert alert-danger" ng-show="vm.doNotMatch" data-translate="global.messages.error.dontmatch">The password and its confirmation do not match!</div><form name="form" role="form" novalidate ng-submit="vm.changePassword()" show-validation><div class="form-group"><label class="control-label" for="password" data-translate="global.form.newpassword">New password</label><input type="password" class="form-control" id="password" name="password" placeholder="{{\'global.form.newpassword.placeholder\' | translate}}" ng-model="vm.password" ng-minlength="4" ng-maxlength="50" required><div ng-show="form.password.$dirty && form.password.$invalid"><p class="help-block" ng-show="form.password.$error.required" data-translate="global.messages.validate.newpassword.required">Your password is required.</p><p class="help-block" ng-show="form.password.$error.minlength" data-translate="global.messages.validate.newpassword.minlength">Your password is required to be at least 4 characters.</p><p class="help-block" ng-show="form.password.$error.maxlength" data-translate="global.messages.validate.newpassword.maxlength">Your password cannot be longer than 50 characters.</p></div><password-strength-bar password-to-check="vm.password"></password-strength-bar></div><div class="form-group"><label class="control-label" for="confirmPassword" data-translate="global.form.confirmpassword">New password confirmation</label><input type="password" class="form-control" id="confirmPassword" name="confirmPassword" placeholder="{{\'global.form.confirmpassword.placeholder\' | translate}}" ng-model="vm.confirmPassword" ng-minlength="4" ng-maxlength="50" required><div ng-show="form.confirmPassword.$dirty && form.confirmPassword.$invalid"><p class="help-block" ng-show="form.confirmPassword.$error.required" data-translate="global.messages.validate.confirmpassword.required">Your confirmation password is required.</p><p class="help-block" ng-show="form.confirmPassword.$error.minlength" data-translate="global.messages.validate.confirmpassword.minlength">Your confirmation password is required to be at least 4 characters.</p><p class="help-block" ng-show="form.confirmPassword.$error.maxlength" data-translate="global.messages.validate.confirmpassword.maxlength">Your confirmation password cannot be longer than 50 characters.</p></div></div><button type="submit" ng-disabled="form.$invalid" class="btn btn-primary" data-translate="password.form.button">Save</button></form></div></div></div>');
$templateCache.put('app/account/register/register.html','<!--\n  ~ Copyright (c) 2017 by Julian Feder, julian.feder@yahoo.de\n  ~\n  ~ This product includes software developed at\n  ~ The Apache Software Foundation (http://www.apache.org/).\n  --><div><div class="row row-no-padding"><div class="col-md-6 col-md-offset-3"><div class="panel panel-default"><div class="panel-body"><h2 data-translate="register.title">Registration</h2><div><div class="alert alert-success" ng-show="vm.success" data-translate="register.messages.success"><strong>Registration saved!</strong> Please check your email for confirmation.</div><div class="alert alert-danger" ng-show="vm.error" data-translate="register.messages.error.fail"><strong>Registration failed!</strong> Please try again later.</div><div class="alert alert-danger" ng-show="vm.errorUserExists" data-translate="register.messages.error.userexists"><strong>Login name already registered!</strong> Please choose another one.</div><div class="alert alert-danger" ng-show="vm.errorEmailExists" data-translate="register.messages.error.emailexists"><strong>Email is already in use!</strong> Please choose another one.</div><div class="alert alert-danger" ng-show="vm.doNotMatch" data-translate="global.messages.error.dontmatch">The password and its confirmation do not match!</div><div class="alert alert-danger" ng-show="vm.errorIban" data-translate="global.messages.error.iban">bic error</div><div class="alert alert-danger" ng-show="vm.errorBic" data-translate="global.messages.error.bic">iban error</div></div><form ng-show="!vm.success" name="form" role="form" novalidate ng-submit="vm.register()" show-validation><div class="form-group" ng-init="vm.registerAccount.profile.memberStatus = \'probe\'"><div class="btn-group btn-group-justified"><label class="btn btn-default" ng-click="vm.selectMemberStatus()" ng-model="vm.registerAccount.profile.memberStatus" uib-btn-radio="\'probe\'"><span data-translate="global.form.button.normal">normal</span></label><label class="btn btn-default" ng-click="vm.selectMemberStatus()" ng-model="vm.registerAccount.profile.memberStatus" uib-btn-radio="\'gast\'"><span data-translate="global.form.button.guest">guest</span></label></div></div><div class="form-group"><div class="alert alert-info" ng-show="vm.registerAccount.profile.memberStatus == \'gast\'">Du hast Interesse am Segeln und willst es einfach mal ausprobieren? Dann melde dich jetzt als Gastmitglied an und komme bei unserer j\xE4hrlichen Flottille oder unserem Bodenseetraining mit, um das Segeln und unseren Verein kennenzulernen. Solltest du Fragen haben, melde ich unter <a href="mailto:vorstand@ask-ev.de">vorstand@ask-ev.de</a> bei uns.</div></div><h3 data-translate="global.form.personal.heading">Pers\xF6nliche Daten</h3><!--------------------><!----- Firstname ----><!--------------------><div class="form-group"><label class="control-label" for="firstName" data-translate="settings.form.firstname">First Name</label><input type="text" class="form-control" id="firstName" name="firstName" placeholder="{{\'settings.form.firstname.placeholder\' | translate}}" ng-model="vm.registerAccount.firstName" ng-minlength="1" ng-maxlength="50" required maxlength="50"><div ng-show="form.firstName.$dirty && form.firstName.$invalid"><p class="help-block" ng-show="form.firstName.$error.required" data-translate="settings.messages.validate.firstname.required">Your first name is required.</p><p class="help-block" ng-show="form.firstName.$error.minlength" data-translate="settings.messages.validate.firstname.minlength">Your first name is required to be at least 1 character.</p><p class="help-block" ng-show="form.firstName.$error.maxlength" data-translate="settings.messages.validate.firstname.maxlength">Your first name cannot be longer than 50 characters.</p></div></div><!--------------------><!----- Lastname -----><!--------------------><div class="form-group"><label class="control-label" for="lastName" data-translate="settings.form.lastname">Last Name</label><input type="text" class="form-control" id="lastName" name="lastName" placeholder="{{\'settings.form.lastname.placeholder\' | translate}}" ng-model="vm.registerAccount.lastName" ng-minlength="1" ng-maxlength="50" required maxlength="50"><div ng-show="form.lastName.$dirty && form.lastName.$invalid"><p class="help-block" ng-show="form.lastName.$error.required" data-translate="settings.messages.validate.lastname.required">Your last name is required.</p><p class="help-block" ng-show="form.lastName.$error.minlength" data-translate="settings.messages.validate.lastname.minlength">Your last name is required to be at least 1 character.</p><p class="help-block" ng-show="form.lastName.$error.maxlength" data-translate="settings.messages.validate.lastname.maxlength">Your last name cannot be longer than 50 characters.</p></div></div><!--------------------><!----- Nickname ----><!--------------------><div class="form-group"><label class="control-label" for="nickname" data-translate="askApp.profile.nickname.hint">Nickname</label><input type="text" class="form-control" id="nickname" name="nickname" placeholder="{{\'askApp.profile.nickname.placeholder\' | translate: {nickname: vm.registerAccount.firstName} }}" ng-model="vm.registerAccount.profile.nickname"></div><!--------------------><!----- Birthdate ----><!--------------------><div class="form-group"><label class="control-label" data-translate="askApp.profile.birthdate" for="field_birthdate">Birthdate</label><div class="input-group"><input id="field_birthdate" type="text" class="form-control" name="birthdate" uib-datepicker-popup="{{\'dd.MM.yyyy\'}}" ng-model="vm.registerAccount.profile.birthdate" is-open="vm.datePickerOpenStatus.birthdate" placeholder="{{\'askApp.profile.birthdate.placeholder\' | translate}}" required> <span class="input-group-btn"><button type="button" class="btn btn-default" ng-click="vm.openCalendar(\'birthdate\')"><i class="glyphicon glyphicon-calendar"></i></button></span></div><div ng-show="form.birthdate.$dirty && form.birthdate.$invalid"><p class="help-block" ng-show="form.birthdate.$error.required" data-translate="entity.validation.required">This field is required.</p></div></div><!--------------------><!------- Phone ------><!--------------------><div class="form-group"><label class="control-label" data-translate="askApp.profile.phone" for="field_phone">Phone</label><input type="text" class="form-control" name="phone" id="field_phone" ng-model="vm.registerAccount.profile.phone" required ng-minlength="5" ng-maxlength="16" maxlength="16" placeholder="{{\'askApp.profile.phone.placeholder\' | translate}}" pattern="^\\+[1-9]\\d{1,16}$"><div ng-show="form.phone.$dirty && form.phone.$invalid"><p class="help-block" ng-show="form.phone.$error.required" data-translate="entity.validation.required">This field is required.</p><p class="help-block" ng-show="form.phone.$error.pattern" data-translate="entity.validation.invalid">Your mobile phone does not math the E.164 format for phone numbers.</p><p class="help-block" ng-show="form.phone.$error.minlength" data-translate="entity.validation.minlength" translate-value-min="5">Your mobile phone is required to be at least 5 characters.</p><p class="help-block" ng-show="form.phone.$error.maxlength" data-translate="entity.validation.maxlength" translate-value-max="15">Your mobile phone cannot be longer than 15 characters.</p></div></div><!--------------------><!-------- Mail ------><!--------------------><div class="form-group"><label class="control-label" for="email" data-translate="global.form.email">Email</label><input type="email" class="form-control" id="email" name="email" placeholder="{{\'global.form.email.placeholder\' | translate}}" ng-model="vm.registerAccount.email" ng-minlength="5" ng-maxlength="50" required maxlength="50"><div ng-show="form.email.$dirty && form.email.$invalid"><p class="help-block" ng-show="form.email.$error.required" data-translate="global.messages.validate.email.required">Your email is required.</p><p class="help-block" ng-show="form.email.$error.email" data-translate="global.messages.validate.email.invalid">Your email is invalid.</p><p class="help-block" ng-show="form.email.$error.minlength" data-translate="global.messages.validate.email.minlength">Your email is required to be at least 5 characters.</p><p class="help-block" ng-show="form.email.$error.maxlength" data-translate="global.messages.validate.email.maxlength">Your email cannot be longer than 50 characters.</p></div></div><!--------------------><!---- Mail repeat ---><!--------------------><div class="form-group"><label class="control-label" for="email_repeat" data-translate="global.form.email.repeat">Email</label><input type="email" class="form-control" id="email_repeat" name="email_repeat" placeholder="{{\'global.form.email.repeat.placeholder\' | translate}}" ng-model="vm.registerAccount.email_repeat" ng-pattern="vm.registerAccount.email" ng-minlength="5" ng-maxlength="50" required maxlength="50"><div ng-show="form.email_repeat.$dirty && form.email_repeat.$invalid"><p class="help-block" ng-show="form.email_repeat.$error.required" data-translate="global.messages.validate.email.required">Your email is required.</p><p class="help-block" ng-show="form.email_repeat.$error.pattern" data-translate="global.messages.validate.email.identical">Your email is invalid.</p></div></div><!--------------------><!------ Gender ------><!--------------------><div class="form-group"><label class="control-label" data-translate="askApp.profile.gender" for="field_gender">Gender</label><select class="form-control" name="gender" ng-model="vm.registerAccount.profile.gender" id="field_gender" required><option value="M" data-translate="askApp.EnumGender.M">M</option><option value="W" data-translate="askApp.EnumGender.W">W</option></select><div ng-show="form.gender.$dirty && form.gender.$invalid"><p class="help-block" ng-show="form.gender.$error.required" data-translate="entity.validation.required">This field is required.</p></div></div><!--------------------><!---- Student -------><!--------------------><div ng-show="vm.registerAccount.profile.memberStatus == \'probe\'"><div class="form-group" ng-init="vm.registerAccount.profile.isStudent = false" id="isStudent"><label class="control-label" for="isStudent" data-translate="global.form.isStudent">Student?</label><div class="btn-group btn-group-justified"><label class="btn btn-default" ng-model="vm.registerAccount.profile.isStudent" ng-click="vm.truncateUpload(); vm.calcToPay()" uib-btn-radio="false"><span data-translate="global.form.button.no">Nein</span></label><label class="btn btn-default" ng-model="vm.registerAccount.profile.isStudent" ng-click="vm.calcToPay()" uib-btn-radio="true"><span data-translate="global.form.button.yes">Ja</span></label></div></div><div class="alert alert-danger" ng-show="vm.registerAccount.profile.isStudent">Auf die Gew&auml;hrung der Studentischen Aufnahmegeb&uuml;hr ({{vm.welcomeFeeStudent}}\u20AC statt {{vm.welcomeFeeNormal}}\u20AC) haben nur <b>Vollzeitstudenten</b> mit g&uuml;ltiger Immatrikulationsbescheinigung bis zu einem Alter von <b>25 Jahren</b> Anspruch. &Uuml;ber studentische F&ouml;rderungen dar&uuml;ber hinaus entscheidet der Vorstand. Der Vorstand beh&auml;lt sich insbesondere das Recht vor, in diesem Fall den Studentenstatus nachtr&auml;glich abzuerkennen, wodurch auch die regul&auml;re Aufnahmegeb&uuml;hr f&auml;llig wird.</div><!---------------------><!-- Immatriculation --><!---------------------><div class="form-group" ng-show="vm.registerAccount.profile.isStudent == true"><div class="form-group" ngf-drop ngf-change="vm.setMatriculationCertificate($file, vm.registerAccount.profile)"><label class="control-label" data-translate="global.form.matriculationCertificate" for="field_matriculationCertificate">Matriculation Certificate</label><div><div ng-if="vm.registerAccount.profile.matriculationCertificate" class="help-block clearfix"><a ng-click="vm.openFile(vm.registerAccount.profile.matriculationCertificateContentType, vm.registerAccount.profile.matriculationCertificate)"><span class="glyphicon glyphicon-file" aria-hidden="true" style="font-size: 50px"></span><!--<i class="fa fa-file-pdf-o fa-3x" aria-hidden="true"></i>--></a><!--<span class="pull-left">{{vm.registerAccount.profile.matriculationCertificateContentType}}, {{vm.byteSize(vm.registerAccount.profile.matriculationCertificate)}}</span>--> <button type="button" ng-click="vm.registerAccount.profile.matriculationCertificate=null;vm.registerAccount.profile.matriculationCertificateContentType=null;" class="btn btn-default btn-xs pull-right"><span class="glyphicon glyphicon-remove"></span></button></div><button type="button" ngf-select class="btn btn-default btn-block" ngf-change="vm.setMatriculationCertificate($file, vm.registerAccount.profile)" data-translate="global.form.addMatriculationCertificate">Add blob</button><div><p class="help-block" ng-show="vm.errorWrongFormat && vm.registerAccount.profile.isStudent == true" data-translate="register.messages.error.wrongformat" style="color:#a94442">This field is required.</p><p class="help-block" ng-show="vm.errorMaxUploadSize && vm.registerAccount.profile.isStudent == true" data-translate="register.messages.error.maxuploadsize" style="color:#a94442"><strong>Max. 2MB allowed!</strong> Please decrease file size.</p><p class="help-block" ng-show="!vm.registerAccount.profile.matriculationCertificate && vm.registerAccount.profile.isStudent == true" data-translate="register.messages.error.matriculationRequired" style="color:#a94442"><strong>Max. 2MB allowed!</strong> Please decrease file size.</p></div></div><input type="hidden" class="form-control" name="matriculationCertificate" id="field_matriculationCertificate" ng-required="vm.registerAccount.profile.isStudent == true" ng-model="vm.registerAccount.profile.matriculationCertificate"> <input type="hidden" class="form-control" name="matriculationCertificateContentType" id="field_matriculationCertificateContentType" ng-required="vm.registerAccount.profile.isStudent == true" ng-model="vm.registerAccount.profile.matriculationCertificateContentType"></div></div><!--------------------><!---- university ----><!--------------------><div class="form-group" ng-show="!vm.registerAccount.profile.isStudent" ng-init="vm.registerAccount.profile.university = null"><label class="control-label" data-translate="askApp.profile.label.university">Warst du mal an einer Uni</label><div class="btn-group btn-group-justified"><label class="btn btn-default" ng-model="vm.university" uib-btn-radio="false" tabindex="0"><span data-translate="global.form.button.no">Nein</span></label><label class="btn btn-default" ng-model="vm.university" uib-btn-radio="true" tabindex="0"><span data-translate="global.form.button.yes">Ja</span></label></div></div><div class="form-group" ng-show="vm.university == true || vm.registerAccount.profile.isStudent"><label class="control-label" data-translate="askApp.profile.university.university" ng-show="!vm.registerAccount.profile.isStudent" for="field_university">Hochschule</label><label class="control-label" data-translate="askApp.profile.university.universityStudent" ng-show="vm.registerAccount.profile.isStudent" for="field_university">Hochschule</label><input type="text" class="form-control" name="university" id="field_university" ng-model="vm.registerAccount.profile.university" ng-required="vm.university || vm.registerAccount.profile.isStudent" placeholder="{{\'askApp.profile.university.placeholder\' | translate}}"><div ng-show="editForm.university.$invalid"><p class="help-block" ng-show="editForm.university.$error.required" data-translate="entity.validation.required">This field is required.</p></div></div></div><h3 data-translate="global.form.address.heading">Adresse</h3><!--------------------><!------ Street ------><!--------------------><div class="form-group"><label class="control-label" data-translate="askApp.profile.street" for="field_street">Street</label><input type="text" class="form-control" name="street" id="field_street" ng-model="vm.registerAccount.profile.street" placeholder="{{\'askApp.profile.street.placeholder\' | translate}}" ng-minlength="1" ng-maxlength="50" required maxlength="50"><div ng-show="form.street.$dirty && form.street.$invalid"><p class="help-block" ng-show="form.street.$error.required" data-translate="entity.validation.required">This field is required.</p><p class="help-block" ng-show="form.street.$error.minlength" data-translate="entity.validation.minlength" translate-value-min="1">Your mobile phone is required to be at least 1 characters.</p><p class="help-block" ng-show="form.street.$error.maxlength" data-translate="entity.validation.maxlength" translate-value-max="50">Your mobile phone cannot be longer than 50 characters.</p></div></div><!--------------------><!---- Postcode ------><!--------------------><div class="form-group"><label class="control-label" data-translate="askApp.profile.postcode" for="field_postcode">Postcode</label><input type="text" class="form-control" name="postcode" id="field_postcode" ng-model="vm.registerAccount.profile.postcode" placeholder="{{\'askApp.profile.postcode.placeholder\' | translate}}" ng-minlength="3" ng-maxlength="6" required maxlength="6" pattern="\\d{3,6}"><div ng-show="form.postcode.$dirty && form.postcode.$invalid"><p class="help-block" ng-show="form.postcode.$error.required" data-translate="entity.validation.required">This field is required.</p><p class="help-block" ng-show="form.postcode.$error.pattern" data-translate="entity.validation.invalid">Not a valid postcode.</p><p class="help-block" ng-show="form.postcode.$error.minlength" data-translate="entity.validation.minlength" translate-value-min="3">Your mobile phone is required to be at least 1 characters.</p><p class="help-block" ng-show="form.postcode.$error.maxlength" data-translate="entity.validation.maxlength" translate-value-max="6">Your mobile phone cannot be longer than 50 characters.</p></div></div><!--------------------><!-------- City ------><!--------------------><div class="form-group"><label class="control-label" data-translate="askApp.profile.city" for="field_city">City</label><input type="text" class="form-control" name="city" id="field_city" ng-model="vm.registerAccount.profile.city" placeholder="{{\'askApp.profile.city.placeholder\' | translate}}" ng-minlength="1" ng-maxlength="50" maxlength="50" required><div ng-show="form.city.$dirty && form.city.$invalid"><p class="help-block" ng-show="form.city.$error.required" data-translate="entity.validation.required">This field is required.</p><p class="help-block" ng-show="form.city.$error.minlength" data-translate="entity.validation.minlength" translate-value-min="1">This field is required to be at least 1 characters.</p><p class="help-block" ng-show="form.city.$error.maxlength" data-translate="entity.validation.maxlength" translate-value-max="50">This field cannot be longer than 50 characters.</p></div></div><!--------------------><!------ Country -----><!--------------------><div class="form-group"><label class="control-label" data-translate="askApp.profile.country" for="field_country">Country</label><select class="form-control" name="country" ng-model="vm.registerAccount.profile.country" ng-init="vm.registerAccount.profile.country = \'DE\'" id="field_country" required><option value="AF" data-translate="askApp.EnumCountry.AF">AF</option><option value="EG" data-translate="askApp.EnumCountry.EG">EG</option><option value="AL" data-translate="askApp.EnumCountry.AL">AL</option><option value="DZ" data-translate="askApp.EnumCountry.DZ">DZ</option><option value="AD" data-translate="askApp.EnumCountry.AD">AD</option><option value="AO" data-translate="askApp.EnumCountry.AO">AO</option><option value="AI" data-translate="askApp.EnumCountry.AI">AI</option><option value="AQ" data-translate="askApp.EnumCountry.AQ">AQ</option><option value="AG" data-translate="askApp.EnumCountry.AG">AG</option><option value="GQ" data-translate="askApp.EnumCountry.GQ">GQ</option><option value="AR" data-translate="askApp.EnumCountry.AR">AR</option><option value="AM" data-translate="askApp.EnumCountry.AM">AM</option><option value="AW" data-translate="askApp.EnumCountry.AW">AW</option><option value="AZ" data-translate="askApp.EnumCountry.AZ">AZ</option><option value="ET" data-translate="askApp.EnumCountry.ET">ET</option><option value="AU" data-translate="askApp.EnumCountry.AU">AU</option><option value="BS" data-translate="askApp.EnumCountry.BS">BS</option><option value="BH" data-translate="askApp.EnumCountry.BH">BH</option><option value="BD" data-translate="askApp.EnumCountry.BD">BD</option><option value="BB" data-translate="askApp.EnumCountry.BB">BB</option><option value="BE" data-translate="askApp.EnumCountry.BE">BE</option><option value="BZ" data-translate="askApp.EnumCountry.BZ">BZ</option><option value="BJ" data-translate="askApp.EnumCountry.BJ">BJ</option><option value="BM" data-translate="askApp.EnumCountry.BM">BM</option><option value="BT" data-translate="askApp.EnumCountry.BT">BT</option><option value="MM" data-translate="askApp.EnumCountry.MM">MM</option><option value="BO" data-translate="askApp.EnumCountry.BO">BO</option><option value="BA" data-translate="askApp.EnumCountry.BA">BA</option><option value="BW" data-translate="askApp.EnumCountry.BW">BW</option><option value="BV" data-translate="askApp.EnumCountry.BV">BV</option><option value="BR" data-translate="askApp.EnumCountry.BR">BR</option><option value="IO" data-translate="askApp.EnumCountry.IO">IO</option><option value="BN" data-translate="askApp.EnumCountry.BN">BN</option><option value="BG" data-translate="askApp.EnumCountry.BG">BG</option><option value="BF" data-translate="askApp.EnumCountry.BF">BF</option><option value="BI" data-translate="askApp.EnumCountry.BI">BI</option><option value="CL" data-translate="askApp.EnumCountry.CL">CL</option><option value="CN" data-translate="askApp.EnumCountry.CN">CN</option><option value="CX" data-translate="askApp.EnumCountry.CX">CX</option><option value="CK" data-translate="askApp.EnumCountry.CK">CK</option><option value="CR" data-translate="askApp.EnumCountry.CR">CR</option><option value="DK" data-translate="askApp.EnumCountry.DK">DK</option><option value="DE" data-translate="askApp.EnumCountry.DE">DE</option><option value="DJ" data-translate="askApp.EnumCountry.DJ">DJ</option><option value="DM" data-translate="askApp.EnumCountry.DM">DM</option><option value="DO" data-translate="askApp.EnumCountry.DO">DO</option><option value="EC" data-translate="askApp.EnumCountry.EC">EC</option><option value="SV" data-translate="askApp.EnumCountry.SV">SV</option><option value="CI" data-translate="askApp.EnumCountry.CI">CI</option><option value="ER" data-translate="askApp.EnumCountry.ER">ER</option><option value="EE" data-translate="askApp.EnumCountry.EE">EE</option><option value="FK" data-translate="askApp.EnumCountry.FK">FK</option><option value="FO" data-translate="askApp.EnumCountry.FO">FO</option><option value="FJ" data-translate="askApp.EnumCountry.FJ">FJ</option><option value="FI" data-translate="askApp.EnumCountry.FI">FI</option><option value="FR" data-translate="askApp.EnumCountry.FR">FR</option><option value="GF" data-translate="askApp.EnumCountry.GF">GF</option><option value="PF" data-translate="askApp.EnumCountry.PF">PF</option><option value="TF" data-translate="askApp.EnumCountry.TF">TF</option><option value="GA" data-translate="askApp.EnumCountry.GA">GA</option><option value="GM" data-translate="askApp.EnumCountry.GM">GM</option><option value="GE" data-translate="askApp.EnumCountry.GE">GE</option><option value="GH" data-translate="askApp.EnumCountry.GH">GH</option><option value="GI" data-translate="askApp.EnumCountry.GI">GI</option><option value="GD" data-translate="askApp.EnumCountry.GD">GD</option><option value="GR" data-translate="askApp.EnumCountry.GR">GR</option><option value="GL" data-translate="askApp.EnumCountry.GL">GL</option><option value="UK" data-translate="askApp.EnumCountry.UK">UK</option><option value="GB" data-translate="askApp.EnumCountry.GB">GB</option><option value="GP" data-translate="askApp.EnumCountry.GP">GP</option><option value="GU" data-translate="askApp.EnumCountry.GU">GU</option><option value="GT" data-translate="askApp.EnumCountry.GT">GT</option><option value="GN" data-translate="askApp.EnumCountry.GN">GN</option><option value="GW" data-translate="askApp.EnumCountry.GW">GW</option><option value="GY" data-translate="askApp.EnumCountry.GY">GY</option><option value="HT" data-translate="askApp.EnumCountry.HT">HT</option><option value="HM" data-translate="askApp.EnumCountry.HM">HM</option><option value="HN" data-translate="askApp.EnumCountry.HN">HN</option><option value="HK" data-translate="askApp.EnumCountry.HK">HK</option><option value="IN" data-translate="askApp.EnumCountry.IN">IN</option><option value="ID" data-translate="askApp.EnumCountry.ID">ID</option><option value="IQ" data-translate="askApp.EnumCountry.IQ">IQ</option><option value="IR" data-translate="askApp.EnumCountry.IR">IR</option><option value="IE" data-translate="askApp.EnumCountry.IE">IE</option><option value="IS" data-translate="askApp.EnumCountry.IS">IS</option><option value="IL" data-translate="askApp.EnumCountry.IL">IL</option><option value="IT" data-translate="askApp.EnumCountry.IT">IT</option><option value="JM" data-translate="askApp.EnumCountry.JM">JM</option><option value="JP" data-translate="askApp.EnumCountry.JP">JP</option><option value="YE" data-translate="askApp.EnumCountry.YE">YE</option><option value="JO" data-translate="askApp.EnumCountry.JO">JO</option><option value="YU" data-translate="askApp.EnumCountry.YU">YU</option><option value="KY" data-translate="askApp.EnumCountry.KY">KY</option><option value="KH" data-translate="askApp.EnumCountry.KH">KH</option><option value="CM" data-translate="askApp.EnumCountry.CM">CM</option><option value="CA" data-translate="askApp.EnumCountry.CA">CA</option><option value="CV" data-translate="askApp.EnumCountry.CV">CV</option><option value="KZ" data-translate="askApp.EnumCountry.KZ">KZ</option><option value="KE" data-translate="askApp.EnumCountry.KE">KE</option><option value="KG" data-translate="askApp.EnumCountry.KG">KG</option><option value="KI" data-translate="askApp.EnumCountry.KI">KI</option><option value="CC" data-translate="askApp.EnumCountry.CC">CC</option><option value="CO" data-translate="askApp.EnumCountry.CO">CO</option><option value="KM" data-translate="askApp.EnumCountry.KM">KM</option><option value="CG" data-translate="askApp.EnumCountry.CG">CG</option><option value="CD" data-translate="askApp.EnumCountry.CD">CD</option><option value="HR" data-translate="askApp.EnumCountry.HR">HR</option><option value="CU" data-translate="askApp.EnumCountry.CU">CU</option><option value="KW" data-translate="askApp.EnumCountry.KW">KW</option><option value="LA" data-translate="askApp.EnumCountry.LA">LA</option><option value="LS" data-translate="askApp.EnumCountry.LS">LS</option><option value="LV" data-translate="askApp.EnumCountry.LV">LV</option><option value="LB" data-translate="askApp.EnumCountry.LB">LB</option><option value="LR" data-translate="askApp.EnumCountry.LR">LR</option><option value="LY" data-translate="askApp.EnumCountry.LY">LY</option><option value="LI" data-translate="askApp.EnumCountry.LI">LI</option><option value="LT" data-translate="askApp.EnumCountry.LT">LT</option><option value="LU" data-translate="askApp.EnumCountry.LU">LU</option><option value="MO" data-translate="askApp.EnumCountry.MO">MO</option><option value="MG" data-translate="askApp.EnumCountry.MG">MG</option><option value="MW" data-translate="askApp.EnumCountry.MW">MW</option><option value="MY" data-translate="askApp.EnumCountry.MY">MY</option><option value="MV" data-translate="askApp.EnumCountry.MV">MV</option><option value="ML" data-translate="askApp.EnumCountry.ML">ML</option><option value="MT" data-translate="askApp.EnumCountry.MT">MT</option><option value="MP" data-translate="askApp.EnumCountry.MP">MP</option><option value="MA" data-translate="askApp.EnumCountry.MA">MA</option><option value="MH" data-translate="askApp.EnumCountry.MH">MH</option><option value="MQ" data-translate="askApp.EnumCountry.MQ">MQ</option><option value="MR" data-translate="askApp.EnumCountry.MR">MR</option><option value="MU" data-translate="askApp.EnumCountry.MU">MU</option><option value="YT" data-translate="askApp.EnumCountry.YT">YT</option><option value="MK" data-translate="askApp.EnumCountry.MK">MK</option><option value="MX" data-translate="askApp.EnumCountry.MX">MX</option><option value="FM" data-translate="askApp.EnumCountry.FM">FM</option><option value="MZ" data-translate="askApp.EnumCountry.MZ">MZ</option><option value="MD" data-translate="askApp.EnumCountry.MD">MD</option><option value="MC" data-translate="askApp.EnumCountry.MC">MC</option><option value="MN" data-translate="askApp.EnumCountry.MN">MN</option><option value="MS" data-translate="askApp.EnumCountry.MS">MS</option><option value="NA" data-translate="askApp.EnumCountry.NA">NA</option><option value="NR" data-translate="askApp.EnumCountry.NR">NR</option><option value="NP" data-translate="askApp.EnumCountry.NP">NP</option><option value="NC" data-translate="askApp.EnumCountry.NC">NC</option><option value="NZ" data-translate="askApp.EnumCountry.NZ">NZ</option><option value="NI" data-translate="askApp.EnumCountry.NI">NI</option><option value="NL" data-translate="askApp.EnumCountry.NL">NL</option><option value="AN" data-translate="askApp.EnumCountry.AN">AN</option><option value="NE" data-translate="askApp.EnumCountry.NE">NE</option><option value="NG" data-translate="askApp.EnumCountry.NG">NG</option><option value="NU" data-translate="askApp.EnumCountry.NU">NU</option><option value="KP" data-translate="askApp.EnumCountry.KP">KP</option><option value="NF" data-translate="askApp.EnumCountry.NF">NF</option><option value="NO" data-translate="askApp.EnumCountry.NO">NO</option><option value="OM" data-translate="askApp.EnumCountry.OM">OM</option><option value="AT" data-translate="askApp.EnumCountry.AT">AT</option><option value="PK" data-translate="askApp.EnumCountry.PK">PK</option><option value="PS" data-translate="askApp.EnumCountry.PS">PS</option><option value="PW" data-translate="askApp.EnumCountry.PW">PW</option><option value="PA" data-translate="askApp.EnumCountry.PA">PA</option><option value="PG" data-translate="askApp.EnumCountry.PG">PG</option><option value="PY" data-translate="askApp.EnumCountry.PY">PY</option><option value="PE" data-translate="askApp.EnumCountry.PE">PE</option><option value="PH" data-translate="askApp.EnumCountry.PH">PH</option><option value="PN" data-translate="askApp.EnumCountry.PN">PN</option><option value="PL" data-translate="askApp.EnumCountry.PL">PL</option><option value="PT" data-translate="askApp.EnumCountry.PT">PT</option><option value="PR" data-translate="askApp.EnumCountry.PR">PR</option><option value="QA" data-translate="askApp.EnumCountry.QA">QA</option><option value="RE" data-translate="askApp.EnumCountry.RE">RE</option><option value="RW" data-translate="askApp.EnumCountry.RW">RW</option><option value="RO" data-translate="askApp.EnumCountry.RO">RO</option><option value="RU" data-translate="askApp.EnumCountry.RU">RU</option><option value="LC" data-translate="askApp.EnumCountry.LC">LC</option><option value="ZM" data-translate="askApp.EnumCountry.ZM">ZM</option><option value="AS" data-translate="askApp.EnumCountry.AS">AS</option><option value="WS" data-translate="askApp.EnumCountry.WS">WS</option><option value="SM" data-translate="askApp.EnumCountry.SM">SM</option><option value="ST" data-translate="askApp.EnumCountry.ST">ST</option><option value="SA" data-translate="askApp.EnumCountry.SA">SA</option><option value="SE" data-translate="askApp.EnumCountry.SE">SE</option><option value="CH" data-translate="askApp.EnumCountry.CH">CH</option><option value="SN" data-translate="askApp.EnumCountry.SN">SN</option><option value="SC" data-translate="askApp.EnumCountry.SC">SC</option><option value="SL" data-translate="askApp.EnumCountry.SL">SL</option><option value="SG" data-translate="askApp.EnumCountry.SG">SG</option><option value="SK" data-translate="askApp.EnumCountry.SK">SK</option><option value="SI" data-translate="askApp.EnumCountry.SI">SI</option><option value="SB" data-translate="askApp.EnumCountry.SB">SB</option><option value="SO" data-translate="askApp.EnumCountry.SO">SO</option><option value="GS" data-translate="askApp.EnumCountry.GS">GS</option><option value="ES" data-translate="askApp.EnumCountry.ES">ES</option><option value="LK" data-translate="askApp.EnumCountry.LK">LK</option><option value="SH" data-translate="askApp.EnumCountry.SH">SH</option><option value="KN" data-translate="askApp.EnumCountry.KN">KN</option><option value="PM" data-translate="askApp.EnumCountry.PM">PM</option><option value="VC" data-translate="askApp.EnumCountry.VC">VC</option><option value="KR" data-translate="askApp.EnumCountry.KR">KR</option><option value="ZA" data-translate="askApp.EnumCountry.ZA">ZA</option><option value="SD" data-translate="askApp.EnumCountry.SD">SD</option><option value="SR" data-translate="askApp.EnumCountry.SR">SR</option><option value="SJ" data-translate="askApp.EnumCountry.SJ">SJ</option><option value="SZ" data-translate="askApp.EnumCountry.SZ">SZ</option><option value="SY" data-translate="askApp.EnumCountry.SY">SY</option><option value="TJ" data-translate="askApp.EnumCountry.TJ">TJ</option><option value="TW" data-translate="askApp.EnumCountry.TW">TW</option><option value="TZ" data-translate="askApp.EnumCountry.TZ">TZ</option><option value="TH" data-translate="askApp.EnumCountry.TH">TH</option><option value="TP" data-translate="askApp.EnumCountry.TP">TP</option><option value="TG" data-translate="askApp.EnumCountry.TG">TG</option><option value="TK" data-translate="askApp.EnumCountry.TK">TK</option><option value="TO" data-translate="askApp.EnumCountry.TO">TO</option><option value="TT" data-translate="askApp.EnumCountry.TT">TT</option><option value="TD" data-translate="askApp.EnumCountry.TD">TD</option><option value="CZ" data-translate="askApp.EnumCountry.CZ">CZ</option><option value="TN" data-translate="askApp.EnumCountry.TN">TN</option><option value="TR" data-translate="askApp.EnumCountry.TR">TR</option><option value="TM" data-translate="askApp.EnumCountry.TM">TM</option><option value="TC" data-translate="askApp.EnumCountry.TC">TC</option><option value="TV" data-translate="askApp.EnumCountry.TV">TV</option><option value="UG" data-translate="askApp.EnumCountry.UG">UG</option><option value="UA" data-translate="askApp.EnumCountry.UA">UA</option><option value="HU" data-translate="askApp.EnumCountry.HU">HU</option><option value="UY" data-translate="askApp.EnumCountry.UY">UY</option><option value="UZ" data-translate="askApp.EnumCountry.UZ">UZ</option><option value="VU" data-translate="askApp.EnumCountry.VU">VU</option><option value="VA" data-translate="askApp.EnumCountry.VA">VA</option><option value="VE" data-translate="askApp.EnumCountry.VE">VE</option><option value="AE" data-translate="askApp.EnumCountry.AE">AE</option><option value="US" data-translate="askApp.EnumCountry.US">US</option><option value="VN" data-translate="askApp.EnumCountry.VN">VN</option><option value="VG" data-translate="askApp.EnumCountry.VG">VG</option><option value="VI" data-translate="askApp.EnumCountry.VI">VI</option><option value="WF" data-translate="askApp.EnumCountry.WF">WF</option><option value="BY" data-translate="askApp.EnumCountry.BY">BY</option><option value="EH" data-translate="askApp.EnumCountry.EH">EH</option><option value="CF" data-translate="askApp.EnumCountry.CF">CF</option><option value="ZW" data-translate="askApp.EnumCountry.ZW">ZW</option><option value="CY" data-translate="askApp.EnumCountry.CY">CY</option></select><div ng-show="form.country.$invalid"><p class="help-block" ng-show="form.country.$dirty && form.country.$error.required" data-translate="entity.validation.required">This field is required.</p></div></div><div ng-show="vm.registerAccount.profile.memberStatus == \'probe\'"><h3 data-translate="global.form.pay.heading">Zahlungsmittel</h3><!--------------------><!-- is using sepa ---><!--------------------><div class="form-group"><div class="btn-group btn-group-justified" ng-init="vm.registerAccount.profile.isUsingSepa = true"><label class="btn btn-default" ng-model="vm.registerAccount.profile.isUsingSepa" ng-click="vm.truncateBancAccount(); vm.calcToPay()" uib-btn-radio="false"><span data-translate="global.form.button.transfer">per &Uuml;berweisung</span></label><label class="btn btn-default" ng-model="vm.registerAccount.profile.isUsingSepa" ng-click="vm.calcToPay()" uib-btn-radio="true"><span data-translate="global.form.button.direct">per Lastschrift</span></label></div></div><div class="alert alert-info" ng-show="vm.registerAccount.profile.isUsingSepa == false">Die Aufnahmegeb\xFChr betr\xE4gt einmalig {{vm.welcomeFee}}\u20AC. Der j\xE4hrliche Mitgliedsbeitrag betr\xE4gt {{vm.anualFee}}\u20AC. Nach der Anmeldung erh\xE4ltst du per E-Mail eine Zahlungsaufforderung in H\xF6he von <b>{{vm.toPay}}\u20AC</b>.</div><h3 ng-show="vm.registerAccount.profile.isUsingSepa == true" data-translate="global.form.account.heading">Kontodaten</h3><!--------------------><!------ iban --------><!--------------------><div class="form-group" ng-show="vm.registerAccount.profile.isUsingSepa == true"><label class="control-label" data-translate="askApp.profile.iban" for="field_iban">Iban</label><input type="text" class="form-control" name="iban" id="field_iban" ng-model="vm.registerAccount.profile.iban" ng-iban ng-minlength="18" ng-maxlength="30" maxlength="30" ng-required="vm.registerAccount.profile.isUsingSepa == true" placeholder="{{\'askApp.profile.iban.placeholder\' | translate}}"><div ng-show="form.iban.$dirty && form.iban.$invalid"><p class="help-block" ng-show="form.iban.$error.required" data-translate="entity.validation.required">This field is required.</p><p class="help-block" ng-show="form.iban.$error.ngIban" data-translate="entity.validation.invalid">Not a valid IBAN.</p><p class="help-block" ng-show="form.iban.$error.minlength" data-translate="entity.validation.minlength" translate-value-min="18">Your IBAN is required to be at least 18 characters.</p><p class="help-block" ng-show="form.iban.$error.maxlength" data-translate="entity.validation.maxlength" translate-value-max="30">Your IBAN cannot be longer than 30 characters.</p></div></div><!--------------------><!------ bic ---------><!--------------------><div class="form-group" ng-show="vm.registerAccount.profile.isUsingSepa == true"><label class="control-label" data-translate="askApp.profile.bic" for="field_bic">Bic</label><input type="text" class="form-control" name="bic" id="field_bic" ng-model="vm.registerAccount.profile.bic" ng-minlength="8" ng-maxlength="11" maxlength="11" ng-required="vm.registerAccount.profile.isUsingSepa == true" pattern="([a-zA-Z]{4}[a-zA-Z]{2}[a-zA-Z0-9]{2}([a-zA-Z0-9]{3})?)" placeholder="{{\'askApp.profile.bic.placeholder\' | translate}}"><div ng-show="form.bic.$dirty && form.bic.$invalid"><p class="help-block" ng-show="form.bic.$error.required" data-translate="entity.validation.required">This field is required.</p><p class="help-block" ng-show="form.bic.$error.pattern" data-translate="entity.validation.invalid">Not a valid IBAN.</p><p class="help-block" ng-show="form.bic.$error.minlength" data-translate="entity.validation.minlength" translate-value-min="8">Your IBAN is required to be at least 8 characters.</p><p class="help-block" ng-show="form.bic.$error.maxlength" data-translate="entity.validation.maxlength" translate-value-max="11">Your IBAN cannot be longer than 11 characters.</p></div></div><!----------------------><!-- banc account hol --><!----------------------><div class="form-group" ng-show="vm.registerAccount.profile.isUsingSepa == true"><label class="control-label" for="bankAccountHolder.deviated" data-translate="global.form.bankAccountHolder.deviated">Deviated</label><div class="btn-group btn-group-justified" ng-init="vm.registerAccount.profile.isDeviatedHolder = false" id="bankAccountHolder.deviated"><label class="btn btn-default" ng-model="vm.registerAccount.profile.isDeviatedHolder" ng-click="vm.truncateBancAccountHolder()" uib-btn-radio="false"><span data-translate="global.form.button.no">Nein</span></label><label class="btn btn-default" ng-model="vm.registerAccount.profile.isDeviatedHolder" ng-click="vm.truncateBancAccountHolder()" uib-btn-radio="true"><span data-translate="global.form.button.yes">Ja</span></label></div></div><div class="form-group" ng-show="vm.registerAccount.profile.isUsingSepa == true"><label class="control-label" data-translate="askApp.profile.bankAccountHolder" for="field_bankAccountHolder">Bank Account Holder</label><input type="text" class="form-control" name="bankAccountHolder" id="field_bankAccountHolder" ng-model="vm.registerAccount.profile.bankAccountHolder" placeholder="{{vm.registerAccount.firstName + \' \' + vm.registerAccount.lastName}}" ng-disabled="vm.registerAccount.profile.isDeviatedHolder == false" ng-required="vm.registerAccount.profile.isDeviatedHolder == true" ng-minlength="1" ng-maxlength="100" maxlength="100"><div ng-show="form.bankAccountHolder.$dirty && form.bankAccountHolder.$invalid"><p class="help-block" ng-show="form.bankAccountHolder.$error.required" data-translate="entity.validation.required">This field is required.</p><p class="help-block" ng-show="form.bankAccountHolder.$error.minlength" data-translate="entity.validation.minlength" translate-value-min="1">Your mobile phone is required to be at least 1 characters.</p><p class="help-block" ng-show="form.bankAccountHolder.$error.maxlength" data-translate="entity.validation.maxlength" translate-value-max="100">Your mobile phone cannot be longer than 100 characters.</p></div><br><div class="alert alert-info">Die Aufnahmegeb\xFChr betr\xE4gt einmalig {{vm.welcomeFee}}\u20AC. Der j\xE4hrliche Mitgliedsbeitrag betr\xE4gt {{vm.anualFee}}\u20AC. Insgesamt werden <b>{{vm.toPay}}\u20AC</b> von deinem Konto abgebucht. Der j\xE4hrliche Mitgliedsbeitrag wird immer zum Jahresende von deinem Konto eingezogen.</div></div><div class="alert alert-success" ng-show="vm.showFreeYear">Wenn du nach dem <b>1. November</b> des Jahres beitrittst, schenken wir dir den Mitgliedsbeitrag f&uuml;r das Folgejahr.</div></div><h3>Passwort</h3><!--------------------><!------ password ----><!--------------------><div class="form-group"><label class="control-label" for="password" data-translate="global.form.newpassword">New password</label><input type="password" class="form-control" id="password" name="password" placeholder="{{\'global.form.newpassword.placeholder\' | translate}}" ng-model="vm.registerAccount.password" ng-minlength="4" ng-maxlength="50" required><div ng-show="form.password.$dirty && form.password.$invalid"><p class="help-block" ng-show="form.password.$error.required" data-translate="global.messages.validate.newpassword.required">Your password is required.</p><p class="help-block" ng-show="form.password.$error.minlength" data-translate="global.messages.validate.newpassword.minlength">Your password is required to be at least 4 characters.</p><p class="help-block" ng-show="form.password.$error.maxlength" data-translate="global.messages.validate.newpassword.maxlength">Your password cannot be longer than 50 characters.</p></div><password-strength-bar password-to-check="vm.registerAccount.password"></password-strength-bar></div><!---------------------><!-- password repeat --><!---------------------><div class="form-group"><label class="control-label" for="confirmPassword" data-translate="global.form.confirmpassword">New password confirmation</label><input type="password" class="form-control" id="confirmPassword" name="confirmPassword" placeholder="{{\'global.form.confirmpassword.placeholder\' | translate}}" ng-model="vm.confirmPassword" ng-minlength="4" ng-maxlength="50" required><div ng-show="form.confirmPassword.$dirty && form.confirmPassword.$invalid"><p class="help-block" ng-show="form.confirmPassword.$error.required" data-translate="global.messages.validate.confirmpassword.required">Your confirmation password is required.</p><p class="help-block" ng-show="form.confirmPassword.$error.minlength" data-translate="global.messages.validate.confirmpassword.minlength">Your confirmation password is required to be at least 4 characters.</p><p class="help-block" ng-show="form.confirmPassword.$error.maxlength" data-translate="global.messages.validate.confirmpassword.maxlength">Your confirmation password cannot be longer than 50 characters.</p></div></div><!---------------------><!-- Data Protection --><!---------------------><h3>Datenschutz</h3><div class="form-group"><p>Ich akzeptiere, dass die Akademische Segelgruppe Karlsruhe e.V. meine Daten f&uuml;r meine Mitgliedschaft gem&auml;&szlig; ihrer <a href="https://ask-ev.de/admin/kcfinder/upload/files/Datenschutzrichtlinie.pdf" target="_blank">Datenschutzrichtlinie</a> speichert und verarbeitet und akzpetiere ebenjene.</p><switch id="gdpr" ng-model="vm.registerAccount.gdpr" class="green"></switch></div><h3>Captcha</h3><div vc-recaptcha key="\'6Ld5dioUAAAAAIszmTdhAJIgXIMAKd5I2Lj2q8wo\'" on-success="setResponse(response)" on-expire="cbExpiration()" style="margin-bottom: 10px"></div><!-----------------------><!-- 2 year membership --><!-----------------------><div class="alert alert-info" ng-show="vm.registerAccount.profile.memberStatus == \'probe\'">Jedes Mitglied kann gem\xE4\xDF Satzung fr\xFChestens zum Ende des dem Eintritt folgenden Kalenderjahres k\xFCndigen.</div><!--------------------><!---- submit --------><!--------------------> <button type="submit" ng-disabled="form.$invalid || !vm.registerAccount.gdpr" class="btn btn-primary" data-translate="register.form.button">Register</button></form><div><div class="alert alert-danger" ng-show="vm.error" data-translate="register.messages.error.fail"><strong>Registration failed!</strong> Please try again later.</div><div class="alert alert-danger" ng-show="vm.errorUserExists" data-translate="register.messages.error.userexists"><strong>Login name already registered!</strong> Please choose another one.</div><div class="alert alert-danger" ng-show="vm.errorEmailExists" data-translate="register.messages.error.emailexists"><strong>Email is already in use!</strong> Please choose another one.</div><div class="alert alert-danger" ng-show="vm.doNotMatch" data-translate="global.messages.error.dontmatch">The password and its confirmation do not match!</div><div class="alert alert-danger" ng-show="vm.errorIban" data-translate="global.messages.error.iban">bic error</div><div class="alert alert-danger" ng-show="vm.errorBic" data-translate="global.messages.error.bic">iban error</div></div></div></div></div></div></div>');
$templateCache.put('app/account/settings/settings.html','<!--\n  ~ Copyright (c) 2017 by Julian Feder, julian.feder@yahoo.de\n  ~\n  ~ This product includes software developed at\n  ~ The Apache Software Foundation (http://www.apache.org/).\n  --><div><div class="row row-no-padding"><div class="col-md-8 col-md-offset-2"><h2 data-translate="settings.title" translate-values="{username: \'{{vm.settingsAccount.login}}\'}">User settings for [<b>{{vm.settingsAccount.login}}</b>]</h2><div class="alert alert-success" ng-show="vm.success" data-translate="settings.messages.success"><strong>Settings saved!</strong></div><jhi-alert-error></jhi-alert-error><form name="form" role="form" novalidate ng-submit="vm.save()" show-validation><div class="form-group"><label class="control-label" for="firstName" data-translate="settings.form.firstname">First Name</label><input type="text" class="form-control" id="firstName" name="firstName" placeholder="{{\'settings.form.firstname.placeholder\' | translate}}" ng-model="vm.settingsAccount.firstName" ng-minlength="1" ng-maxlength="50" required maxlength="50"><div ng-show="form.firstName.$dirty && form.firstName.$invalid"><p class="help-block" ng-show="form.firstName.$error.required" data-translate="settings.messages.validate.firstname.required">Your first name is required.</p><p class="help-block" ng-show="form.firstName.$error.minlength" data-translate="settings.messages.validate.firstname.minlength">Your first name is required to be at least 1 character.</p><p class="help-block" ng-show="form.firstName.$error.maxlength" data-translate="settings.messages.validate.firstname.maxlength">Your first name cannot be longer than 50 characters.</p></div></div><div class="form-group"><label class="control-label" for="lastName" data-translate="settings.form.lastname">Last Name</label><input type="text" class="form-control" id="lastName" name="lastName" placeholder="{{\'settings.form.lastname.placeholder\' | translate}}" ng-model="vm.settingsAccount.lastName" ng-minlength="1" ng-maxlength="50" required maxlength="50"><div ng-show="form.lastName.$dirty && form.lastName.$invalid"><p class="help-block" ng-show="form.lastName.$error.required" data-translate="settings.messages.validate.lastname.required">Your last name is required.</p><p class="help-block" ng-show="form.lastName.$error.minlength" data-translate="settings.messages.validate.lastname.minlength">Your last name is required to be at least 1 character.</p><p class="help-block" ng-show="form.lastName.$error.maxlength" data-translate="settings.messages.validate.lastname.maxlength">Your last name cannot be longer than 50 characters.</p></div></div><div class="form-group"><label class="control-label" for="email" data-translate="global.form.email">Email</label><input type="email" class="form-control" id="email" name="email" placeholder="{{\'global.form.email.placeholder\' | translate}}" ng-model="vm.settingsAccount.email" ng-minlength="5" ng-maxlength="100" required maxlength="100"><div ng-show="form.email.$dirty && form.email.$invalid"><p class="help-block" ng-show="form.email.$error.required" data-translate="global.messages.validate.email.required">Your email is required.</p><p class="help-block" ng-show="form.email.$error.email" data-translate="global.messages.validate.email.invalid">Your email is invalid.</p><p class="help-block" ng-show="form.email.$error.minlength" data-translate="global.messages.validate.email.minlength">Your email is required to be at least 5 characters.</p><p class="help-block" ng-show="form.email.$error.maxlength" data-translate="global.messages.validate.email.maxlength">Your email cannot be longer than 100 characters.</p></div></div><div class="form-group"><label for="langKey" data-translate="settings.form.language">Language</label><select id="langKey" name="langKey" class="form-control" ng-model="vm.settingsAccount.langKey" ng-controller="JhiLanguageController as languageVm" ng-options="code as (code | findLanguageFromKey) for code in languageVm.languages"></select></div><button type="submit" ng-disabled="form.$invalid" class="btn btn-primary" data-translate="settings.form.button">Save</button></form></div></div></div>');
$templateCache.put('app/account/sessions/sessions.html','<!--\n  ~ Copyright (c) 2017 by Julian Feder, julian.feder@yahoo.de\n  ~\n  ~ This product includes software developed at\n  ~ The Apache Software Foundation (http://www.apache.org/).\n  --><div><h2 data-translate="sessions.title" translate-values="{username: \'{{vm.account.login}}\'}">Active sessions for [<b>{{vm.account.login}}</b>]</h2><div class="alert alert-success" ng-show="vm.success" data-translate="sessions.messages.success"><strong>Session invalidated!</strong></div><div class="alert alert-danger" ng-show="vm.error" data-translate="sessions.messages.error"><strong>An error has occured!</strong> The session could not be invalidated.</div><div class="table-responsive"><table class="table table-striped"><thead><tr><th data-translate="sessions.table.ipaddress">IP Address</th><th data-translate="sessions.table.useragent">User agent</th><th data-translate="sessions.table.date">Date</th><th></th></tr></thead><tbody><tr ng-repeat="session in vm.sessions"><td>{{session.ipAddress}}</td><td>{{session.userAgent}}</td><td>{{session.tokenDate | date:\'longDate\'}}</td><td><button type="submit" class="btn btn-primary" ng-click="vm.invalidate(session.series)" data-translate="sessions.table.button">Invalidate</button></td></tr></tbody></table></div></div>');
$templateCache.put('app/admin/audits/audits.html','<!--\n  ~ Copyright (c) 2017 by Julian Feder, julian.feder@yahoo.de\n  ~\n  ~ This product includes software developed at\n  ~ The Apache Software Foundation (http://www.apache.org/).\n  --><div><h2 data-translate="audits.title">Audits</h2><div class="row"><div class="col-md-5"><h4 data-translate="audits.filter.title">Filter by date</h4><p class="input-group"><span class="input-group-addon" data-translate="audits.filter.from">from</span> <input type="date" class="input-sm form-control" name="start" ng-model="vm.fromDate" ng-change="vm.onChangeDate()" required> <span class="input-group-addon" data-translate="audits.filter.to">to</span> <input type="date" class="input-sm form-control" name="end" ng-model="vm.toDate" ng-change="vm.onChangeDate()" required></p></div></div><table class="table table-condensed table-striped table-bordered table-responsive"><thead><tr><th ng-click="predicate = \'timestamp\'; reverse=!reverse"><span data-translate="audits.table.header.date">Date</span></th><th ng-click="predicate = \'principal\'; reverse=!reverse"><span data-translate="audits.table.header.principal">User</span></th><th ng-click="predicate = \'type\'; reverse=!reverse"><span data-translate="audits.table.header.status">State</span></th><th ng-click="predicate = \'data.message\'; reverse=!reverse"><span data-translate="audits.table.header.data">Extra data</span></th></tr></thead><tr ng-repeat="audit in vm.audits | filter:filter | orderBy:predicate:reverse" ng-hide="audit.filtered"><td><span>{{audit.timestamp| date:\'medium\'}}</span></td><td><small>{{audit.principal}}</small></td><td>{{audit.type}}</td><td><span ng-show="audit.data.message">{{audit.data.message}}</span> <span ng-show="audit.data.remoteAddress"><span data-translate="audits.table.data.remoteAddress">Remote Address</span> {{audit.data.remoteAddress}}</span></td></tr></table><div class="text-center"><uib-pagination class="pagination-sm" total-items="vm.totalItems" ng-model="vm.page" ng-change="vm.loadPage(vm.page)"></uib-pagination></div></div>');
$templateCache.put('app/admin/configuration/configuration.html','<!--\n  ~ Copyright (c) 2017 by Julian Feder, julian.feder@yahoo.de\n  ~\n  ~ This product includes software developed at\n  ~ The Apache Software Foundation (http://www.apache.org/).\n  --><div><h2 data-translate="configuration.title">Configuration</h2><span data-translate="configuration.filter">Filter (by prefix)</span> <input type="text" ng-model="filter" class="form-control"><label ng-hide="filteredConfig.length == 0">Spring configuration</label><table class="table table-condensed table-striped table-bordered table-responsive" style="table-layout:fixed" ng-hide="filteredConfig.length == 0"><thead><tr><th ng-click="predicate = \'prefix\'; reverse=!reverse" class="col-sm-4"><span data-translate="configuration.table.prefix">Prefix</span></th><th data-translate="configuration.table.properties" class="col-sm-8">Properties</th></tr></thead><tr ng-repeat="entry in filtered = (vm.configuration | filter:filter | orderBy:predicate:reverse)"><td><span>{{entry.prefix}}</span></td><td><div class="row" ng-repeat="(key, value) in entry.properties"><div class="col-md-4">{{key}}</div><div class="col-md-8"><span class="pull-right label label-default break">{{value}}</span></div></div></td></tr></table><div ng-repeat="(key, value) in vm.allConfiguration"><label ng-hide="filtered.length == 0"><span>{{key}}</span></label><table class="table table-condensed table-striped table-bordered table-responsive" style="table-layout:fixed" ng-hide="filtered.length == 0"><thead><tr><th class="col-sm-4">Property</th><th class="col-sm-8">Value</th></tr></thead><tbody><tr ng-repeat="item in filtered = (value | filter:filter)"><td class="break">{{item.key}}</td><td class="break"><span class="pull-right label label-default break">{{item.val}}</span></td></tr></tbody></table></div></div>');
$templateCache.put('app/admin/docs/docs.html','<!--\n  ~ Copyright (c) 2017 by Julian Feder, julian.feder@yahoo.de\n  ~\n  ~ This product includes software developed at\n  ~ The Apache Software Foundation (http://www.apache.org/).\n  --><iframe src="swagger-ui/index.html" frameborder="0" marginheight="0" marginwidth="0" width="100%" height="900" scrolling="auto" target="_top" title="Swagger UI"></iframe>');
$templateCache.put('app/admin/elasticsearch-reindex/elasticsearch-reindex-dialog.html','<form name="reindexForm" ng-submit="vm.confirmReindex()"><div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()">&times;</button><h4 class="modal-title" data-translate="elasticsearch.reindex.dialog.title">Confirm reindex operation</h4></div><div class="modal-body"><jhi-alert-error></jhi-alert-error><p data-translate="elasticsearch.reindex.dialog.question">Are you sure you want to reindex Elasticsearch? This could take a while!</p></div><div class="modal-footer"><button type="button" class="btn btn-default" data-dismiss="modal" ng-click="vm.clear()"><span class="glyphicon glyphicon-ban-circle"></span>&nbsp; <span data-translate="elasticsearch.reindex.dialog.cancel">Cancel</span></button> <button type="submit" class="btn btn-danger"><span class="glyphicon glyphicon-exclamation-sign"></span>&nbsp; <span data-translate="elasticsearch.reindex.dialog.confirm">Reindex</span></button></div></form>');
$templateCache.put('app/admin/elasticsearch-reindex/elasticsearch-reindex.html','<div class="clearfix"><h1 data-translate="elasticsearch.reindex.title">Reindex Elasticsearch</h1><jhi-alert></jhi-alert><p data-translate="elasticsearch.reindex.instructions1">This will send a request to reindex all data from your primary datasource into Elasticsearch. This will fix missing data and mapping issues, however you will lose any ES data and mapping that was defined outside of your application. This request will return immediately and the reindexing will run in the background. You will see "Elasticsearch: Successfully performed reindexing" in your logs when this is complete.</p><p data-translate="elasticsearch.reindex.instructions2">This can take a long time and is susceptible to concurrency issues so it should be performed when the number of users is low.</p><button type="button" class="btn btn-primary pull-right" ui-sref="elasticsearch-reindex.dialog"><span class="glyphicon glyphicon-exclamation-sign"></span> <span data-translate="elasticsearch.reindex.go">Go</span></button></div>');
$templateCache.put('app/admin/entity-audit/entity-audit.detail.html','<!--\n  ~ Copyright (c) 2017 by Julian Feder, julian.feder@yahoo.de\n  ~\n  ~ This product includes software developed at\n  ~ The Apache Software Foundation (http://www.apache.org/).\n  --><div class="modal-header"><button aria-label="{{ \'entityAudit.detail.close\' | translate }}" data-dismiss="modal" class="close" type="button" ng-click="vm.cancel()"><span aria-hidden="true">&times;</span></button><h4 class="modal-title" data-translate="entityAudit.detail.title">Audit Details</h4></div><div class="modal-body pad"><div><strong data-translate="entityAudit.detail.action" translate-value-action="{{vm.audit.action}}">{{vm.audit.action}} action was performed on below data</strong><br><br><del class="diff diff-key" data-translate="entityAudit.detail.old">Old/Removed value</del> &nbsp; <ins class="diff diff-key" data-translate="entityAudit.detail.new">New/Added value</ins></div><br><label data-translate="entityAudit.detail.changedFields">Changed Fields</label><pre id="resultChanges" ng-bind-html="vm.diffValueChanges"></pre><label data-translate="entityAudit.detail.allFields">All Fields</label><pre id="result" ng-bind-html="vm.diffValue"></pre></div><div class="modal-footer"><button data-dismiss="modal" class="btn btn-default" type="button" ng-click="vm.cancel()" data-translate="entityAudit.detail.done">Done</button></div>');
$templateCache.put('app/admin/entity-audit/entity-audits.html','<!--\n  ~ Copyright (c) 2017 by Julian Feder, julian.feder@yahoo.de\n  ~\n  ~ This product includes software developed at\n  ~ The Apache Software Foundation (http://www.apache.org/).\n  --><div ng-cloak class="pad"><div class="row"><h3 class="col-sm-12" data-translate="entityAudit.home.title">Entity Audits</h3></div><jhi-alert></jhi-alert><div class="row"><div class="col-md-12 pad"><h4 data-translate="entityAudit.home.filter">Filter</h4><form name="auditForm" role="form" novalidate show-validation><div class="row"><div class="col-md-8 form-group"><label data-translate="entityAudit.home.entityOrTable">Entity/Table</label><select class="input-sm form-control" name="qualifiedName" id="qualifiedName" required ng-options="vm.getEntityName(entity) for entity in vm.entities" ng-model="vm.qualifiedName"></select><div ng-show="auditForm.qualifiedName.$invalid"><p class="help-block" ng-show="auditForm.qualifiedName.$error.required" data-translate="entity.validation.required">This field is required</p></div></div><div class="col-md-4 form-group"><label data-translate="entityAudit.home.limitTo">Limit to</label><select class="input-sm form-control" name="limit" id="limit" required ng-options="option for option in vm.limits" ng-model="vm.limit"></select></div></div><div class="row pad"><button ng-disabled="auditForm.$invalid" class="btn btn-primary pull-right" ng-click="vm.loadChanges()"><i class="glyphicon glyphicon-import"></i>&nbsp; {{\'entityAudit.home.loadChangeList\' | translate}}</button></div></form></div></div><div ng-show="!vm.loading"><div class="table-responsive" ng-if="vm.audits.length > 0"><p ng-if="vm.qualifiedName" data-translate="entityAudit.result.showInfo" translate-value-limit="{{vm.limit}}" translate-value-entity="{{vm.getEntityName(vm.qualifiedName)}}">Last <strong>{{vm.limit}}</strong> Changes for <strong>{{vm.getEntityName(vm.qualifiedName)}}</strong></p><form class="form-inline"><div class="form-group"><label for="searchField" data-translate="entityAudit.result.searchFieldLabel">Filter:</label><input type="text" class="form-control" id="searchField" ng-model="filter.$" placeholder="{{ \'entityAudit.result.globalFilter\' | translate }}"></div><div class="form-group"><input type="text" class="form-control" id="searchFieldEntityId" ng-model="filter.entityId" placeholder="{{ \'entityAudit.result.entityIdFilter\' | translate }}"></div></form><table class="table table-bordered table-hover table-striped"><thead><tr><th data-translate="entityAudit.result.tableHeader.entityId">Entity Id</th><th data-translate="entityAudit.result.tableHeader.action">Action</th><th data-translate="entityAudit.result.tableHeader.version">Version</th><th data-translate="entityAudit.result.tableHeader.value">Value</th><th data-translate="entityAudit.result.tableHeader.modifiedDate">Modified Date</th><th data-translate="entityAudit.result.tableHeader.modifiedBy">Modified By</th><th><i class="glyphicon glyphicon-eye-open"></i></th></tr></thead><tbody><tr ng-repeat="audit in vm.audits | filter:filter"><td>{{audit.entityId}}</td><td>{{audit.action}}</td><td>{{audit.commitVersion}}</td><td><pre class="audit-obj" ng-bind-html="vm.format(audit.entityValue)"></pre></td><!-- comment above line and uncomment below to have Table view of value --><!--td class="no-pad">\n                        <div class="audit-obj">\n                            <table class="table table-bordered table-hover no-margin">\n                                <tr>\n                                    <th data-translate="entityAudit.result.tableBody.field">Field</th>\n                                    <th data-translate="entityAudit.result.tableBody.value">Value</th>\n                                </tr>\n                                <tr ng-repeat="(k,v) in audit.entityValue" ng-if="!vm.isObject(v)">\n                                    <td>{{k}}</td>\n                                    <td>\n                                        <span ng-if="vm.isDate(k)">{{v | date:\'medium\'}}</span>\n                                        <span ng-if="!vm.isDate(k)">{{v}}</span>\n                                    </td>\n                                </tr>\n                            </table>\n                        </div>\n                    </td--><td>{{audit.modifiedDate | date:\'medium\'}}</td><td>{{audit.modifiedBy}}</td><td><button type="button" ng-click="vm.openChange(audit)" uib-tooltip="{{ \'entityAudit.result.tableBody.viewDetails\' | translate }}" uib-tooltip-placement="auto" class="btn btn-info btn-xs"><i class="glyphicon glyphicon-eye-open"></i></button></td></tr></tbody></table></div><p ng-if="vm.displayedChanges.length == 0" data-translate="entityAudit.result.noDataFound">No Data found for the filters</p></div></div>');
$templateCache.put('app/admin/health/health.html','<!--\n  ~ Copyright (c) 2017 by Julian Feder, julian.feder@yahoo.de\n  ~\n  ~ This product includes software developed at\n  ~ The Apache Software Foundation (http://www.apache.org/).\n  --><div><h2 data-translate="health.title">Health Checks</h2><p><button type="button" class="btn btn-primary" ng-click="vm.refresh()"><span class="glyphicon glyphicon-refresh"></span>&nbsp;<span data-translate="health.refresh.button">Refresh</span></button></p><table id="healthCheck" class="table table-striped"><thead><tr><th class="col-md-7" data-translate="health.table.service">Service Name</th><th class="col-md-2 text-center" data-translate="health.table.status">Status</th><th class="col-md-2 text-center" data-translate="health.details.details">Details</th></tr></thead><tbody><tr ng-repeat="health in vm.healthData"><td>{{\'health.indicator.\' + vm.baseName(health.name) | translate}} {{vm.subSystemName(health.name)}}</td><td class="text-center"><span class="label" ng-class="vm.getLabelClass(health.status)">{{\'health.status.\' + health.status | translate}}</span></td><td class="text-center"><a class="hand" ng-click="vm.showHealth(health)" ng-show="health.details || health.error"><i class="glyphicon glyphicon-eye-open"></i></a></td></tr></tbody></table></div>');
$templateCache.put('app/admin/health/health.modal.html','<!--\n  ~ Copyright (c) 2017 by Julian Feder, julian.feder@yahoo.de\n  ~\n  ~ This product includes software developed at\n  ~ The Apache Software Foundation (http://www.apache.org/).\n  --><div class="modal-header"><button aria-label="Close" data-dismiss="modal" class="close" type="button" ng-click="vm.cancel()"><span aria-hidden="true">&times;</span></button><h4 class="modal-title" id="showHealthLabel">{{\'health.indicator.\' + vm.baseName(vm.currentHealth.name) | translate}} {{vm.subSystemName(vm.currentHealth.name)}}</h4></div><div class="modal-body pad"><div ng-show="vm.currentHealth.details"><h4 data-translate="health.details.properties">Properties</h4><table class="table table-striped"><thead><tr><th class="col-md-6 text-left" data-translate="health.details.name">Name</th><th class="col-md-6 text-left" data-translate="health.details.value">Value</th></tr></thead><tbody><tr ng-repeat="(k,v) in vm.currentHealth.details"><td class="col-md-6 text-left">{{k}}</td><td class="col-md-6 text-left">{{v}}</td></tr></tbody></table></div><div ng-show="vm.currentHealth.error"><h4 data-translate="health.details.error">Error</h4><pre>{{vm.currentHealth.error}}</pre></div></div><div class="modal-footer"><button data-dismiss="modal" class="btn btn-default pull-left" type="button" ng-click="vm.cancel()">Done</button></div>');
$templateCache.put('app/admin/logs/logs.html','<!--\n  ~ Copyright (c) 2017 by Julian Feder, julian.feder@yahoo.de\n  ~\n  ~ This product includes software developed at\n  ~ The Apache Software Foundation (http://www.apache.org/).\n  --><div class="table-responsive"><h2 data-translate="logs.title">Logs</h2><p data-translate="logs.nbloggers" translate-values="{total: \'{{ vm.loggers.length }}\'}">There are {{ vm.loggers.length }} loggers.</p><span data-translate="logs.filter">Filter</span> <input type="text" ng-model="filter" class="form-control"><table class="table table-condensed table-striped table-bordered"><thead><tr title="click to order"><th ng-click="predicate = \'name\'; reverse=!reverse"><span data-translate="logs.table.name">Name</span></th><th ng-click="predicate = \'level\'; reverse=!reverse"><span data-translate="logs.table.level">Level</span></th></tr></thead><tr ng-repeat="logger in vm.loggers | filter:filter | orderBy:predicate:reverse"><td><small>{{logger.name | characters:140}}</small></td><td><button ng-click="vm.changeLevel(logger.name, \'TRACE\')" ng-class="(logger.level==\'TRACE\') ? \'btn-danger\' : \'btn-default\'" class="btn btn-default btn-xs">TRACE</button> <button ng-click="vm.changeLevel(logger.name, \'DEBUG\')" ng-class="(logger.level==\'DEBUG\') ? \'btn-warning\' : \'btn-default\'" class="btn btn-default btn-xs">DEBUG</button> <button ng-click="vm.changeLevel(logger.name, \'INFO\')" ng-class="(logger.level==\'INFO\') ? \'btn-info\' : \'btn-default\'" class="btn btn-default btn-xs">INFO</button> <button ng-click="vm.changeLevel(logger.name, \'WARN\')" ng-class="(logger.level==\'WARN\') ? \'btn-success\' : \'btn-default\'" class="btn btn-default btn-xs">WARN</button> <button ng-click="vm.changeLevel(logger.name, \'ERROR\')" ng-class="(logger.level==\'ERROR\') ? \'btn-primary\' : \'btn-default\'" class="btn btn-default btn-xs">ERROR</button></td></tr></table></div>');
$templateCache.put('app/admin/metrics/metrics.html','<!--\n  ~ Copyright (c) 2017 by Julian Feder, julian.feder@yahoo.de\n  ~\n  ~ This product includes software developed at\n  ~ The Apache Software Foundation (http://www.apache.org/).\n  --><div><h2 data-translate="metrics.title">Application Metrics</h2><p><button type="button" class="btn btn-primary" ng-click="vm.refresh()"><span class="glyphicon glyphicon-refresh"></span>&nbsp;<span data-translate="metrics.refresh.button">Refresh</span></button></p><h3 data-translate="metrics.jvm.title">JVM Metrics</h3><div class="row" ng-hide="vm.updatingMetrics"><div class="col-md-4"><b data-translate="metrics.jvm.memory.title">Memory</b><p><span data-translate="metrics.jvm.memory.total">Total Memory</span> ({{vm.metrics.gauges[\'jvm.memory.total.used\'].value / 1000000 | number:0}}M / {{vm.metrics.gauges[\'jvm.memory.total.max\'].value / 1000000 | number:0}}M)</p><uib-progressbar min="0" max="vm.metrics.gauges[\'jvm.memory.total.max\'].value" value="vm.metrics.gauges[\'jvm.memory.total.used\'].value" class="progress-striped active" type="success"><span>{{vm.metrics.gauges[\'jvm.memory.total.used\'].value * 100 / vm.metrics.gauges[\'jvm.memory.total.max\'].value | number:0}}%</span></uib-progressbar><p><span data-translate="metrics.jvm.memory.heap">Heap Memory</span> ({{vm.metrics.gauges[\'jvm.memory.heap.used\'].value / 1000000 | number:0}}M / {{vm.metrics.gauges[\'jvm.memory.heap.max\'].value / 1000000 | number:0}}M)</p><uib-progressbar min="0" max="vm.metrics.gauges[\'jvm.memory.heap.max\'].value" value="vm.metrics.gauges[\'jvm.memory.heap.used\'].value" class="progress-striped active" type="success"><span>{{vm.metrics.gauges[\'jvm.memory.heap.used\'].value * 100 / vm.metrics.gauges[\'jvm.memory.heap.max\'].value | number:0}}%</span></uib-progressbar><p><span data-translate="metrics.jvm.memory.nonheap">Non-Heap Memory</span> ({{vm.metrics.gauges[\'jvm.memory.non-heap.used\'].value / 1000000 | number:0}}M / {{vm.metrics.gauges[\'jvm.memory.non-heap.committed\'].value / 1000000 | number:0}}M)</p><uib-progressbar min="0" max="vm.metrics.gauges[\'jvm.memory.non-heap.committed\'].value" value="vm.metrics.gauges[\'jvm.memory.non-heap.used\'].value" class="progress-striped active" type="success"><span>{{vm.metrics.gauges[\'jvm.memory.non-heap.used\'].value * 100 / vm.metrics.gauges[\'jvm.memory.non-heap.committed\'].value | number:0}}%</span></uib-progressbar></div><div class="col-md-4"><b data-translate="metrics.jvm.threads.title">Threads</b> (Total: {{vm.metrics.gauges[\'jvm.threads.count\'].value}}) <a class="hand" ng-click="vm.refreshThreadDumpData()" data-toggle="modal" data-target="#threadDump"><i class="glyphicon glyphicon-eye-open"></i></a><p><span data-translate="metrics.jvm.threads.runnable">Runnable</span> {{vm.metrics.gauges[\'jvm.threads.runnable.count\'].value}}</p><uib-progressbar min="0" value="vm.metrics.gauges[\'jvm.threads.runnable.count\'].value" max="vm.metrics.gauges[\'jvm.threads.count\'].value" class="progress-striped active" type="success"><span>{{vm.metrics.gauges[\'jvm.threads.runnable.count\'].value * 100 / vm.metrics.gauges[\'jvm.threads.count\'].value | number:0}}%</span></uib-progressbar><p><span data-translate="metrics.jvm.threads.timedwaiting">Timed Waiting</span> ({{vm.metrics.gauges[\'jvm.threads.timed_waiting.count\'].value}})</p><uib-progressbar min="0" value="vm.metrics.gauges[\'jvm.threads.timed_waiting.count\'].value" max="vm.metrics.gauges[\'jvm.threads.count\'].value" class="progress-striped active" type="warning"><span>{{vm.metrics.gauges[\'jvm.threads.timed_waiting.count\'].value * 100 / vm.metrics.gauges[\'jvm.threads.count\'].value | number:0}}%</span></uib-progressbar><p><span data-translate="metrics.jvm.threads.waiting">Waiting</span> ({{vm.metrics.gauges[\'jvm.threads.waiting.count\'].value}})</p><uib-progressbar min="0" value="vm.metrics.gauges[\'jvm.threads.waiting.count\'].value" max="vm.metrics.gauges[\'jvm.threads.count\'].value" class="progress-striped active" type="warning"><span>{{vm.metrics.gauges[\'jvm.threads.waiting.count\'].value * 100 / vm.metrics.gauges[\'jvm.threads.count\'].value | number:0}}%</span></uib-progressbar><p><span data-translate="metrics.jvm.threads.blocked">Blocked</span> ({{vm.metrics.gauges[\'jvm.threads.blocked.count\'].value}})</p><uib-progressbar min="0" value="vm.metrics.gauges[\'jvm.threads.blocked.count\'].value" max="vm.metrics.gauges[\'jvm.threads.count\'].value" class="progress-striped active" type="success"><span>{{vm.metrics.gauges[\'jvm.threads.blocked.count\'].value * 100 / vm.metrics.gauges[\'jvm.threads.count\'].value | number:0}}%</span></uib-progressbar></div><div class="col-md-4"><b data-translate="metrics.jvm.gc.title">Garbage collections</b><div class="row"><div class="col-md-9" data-translate="metrics.jvm.gc.marksweepcount">Mark Sweep count</div><div class="col-md-3 text-right">{{vm.metrics.gauges[\'jvm.garbage.PS-MarkSweep.count\'].value}}</div></div><div class="row"><div class="col-md-9" data-translate="metrics.jvm.gc.marksweeptime">Mark Sweep time</div><div class="col-md-3 text-right">{{vm.metrics.gauges[\'jvm.garbage.PS-MarkSweep.time\'].value}}ms</div></div><div class="row"><div class="col-md-9" data-translate="metrics.jvm.gc.scavengecount">Scavenge count</div><div class="col-md-3 text-right">{{vm.metrics.gauges[\'jvm.garbage.PS-Scavenge.count\'].value}}</div></div><div class="row"><div class="col-md-9" data-translate="metrics.jvm.gc.scavengetime">Scavenge time</div><div class="col-md-3 text-right">{{vm.metrics.gauges[\'jvm.garbage.PS-Scavenge.time\'].value}}ms</div></div></div></div><div class="well well-lg" ng-show="vm.updatingMetrics" data-translate="metrics.updating">Updating...</div><h3 data-translate="metrics.jvm.http.title">HTTP requests (events per second)</h3><p><span data-translate="metrics.jvm.http.active">Active requests</span> <b>{{vm.metrics.counters[\'com.codahale.metrics.servlet.InstrumentedFilter.activeRequests\'].count | number:0}}</b> - <span data-translate="metrics.jvm.http.total">Total requests</span> <b>{{vm.metrics.timers[\'com.codahale.metrics.servlet.InstrumentedFilter.requests\'].count | number:0}}</b></p><div class="table-responsive"><table class="table table-striped"><thead><tr><th data-translate="metrics.jvm.http.table.code">Code</th><th data-translate="metrics.jvm.http.table.count">Count</th><th class="text-right" data-translate="metrics.jvm.http.table.mean">Mean</th><th class="text-right"><span data-translate="metrics.jvm.http.table.average">Average</span> (1 min)</th><th class="text-right"><span data-translate="metrics.jvm.http.table.average">Average</span> (5 min)</th><th class="text-right"><span data-translate="metrics.jvm.http.table.average">Average</span> (15 min)</th></tr></thead><tbody><tr><td data-translate="metrics.jvm.http.code.ok">OK</td><td><uib-progressbar min="0" max="vm.metrics.timers[\'com.codahale.metrics.servlet.InstrumentedFilter.requests\'].count" value="vm.metrics.meters[\'com.codahale.metrics.servlet.InstrumentedFilter.responseCodes.ok\'].count" class="progress-striped active" type="success"><span>{{vm.metrics.meters[\'com.codahale.metrics.servlet.InstrumentedFilter.responseCodes.ok\'].count}}</span></uib-progressbar></td><td class="text-right">{{vm.metrics.meters[\'com.codahale.metrics.servlet.InstrumentedFilter.responseCodes.ok\'].mean_rate | number:2}}</td><td class="text-right">{{vm.metrics.meters[\'com.codahale.metrics.servlet.InstrumentedFilter.responseCodes.ok\'].m1_rate | number:2}}</td><td class="text-right">{{vm.metrics.meters[\'com.codahale.metrics.servlet.InstrumentedFilter.responseCodes.ok\'].m5_rate | number:2}}</td><td class="text-right">{{vm.metrics.meters[\'com.codahale.metrics.servlet.InstrumentedFilter.responseCodes.ok\'].m15_rate | number:2}}</td></tr><tr><td data-translate="metrics.jvm.http.code.notfound">Not Found</td><td><uib-progressbar min="0" max="vm.metrics.timers[\'com.codahale.metrics.servlet.InstrumentedFilter.requests\'].count" value="vm.metrics.meters[\'com.codahale.metrics.servlet.InstrumentedFilter.responseCodes.notFound\'].count" class="progress-striped active" type="success"><span>{{vm.metrics.meters[\'com.codahale.metrics.servlet.InstrumentedFilter.responseCodes.notFound\'].count}}</span></uib-progressbar></td><td class="text-right">{{vm.metrics.meters[\'com.codahale.metrics.servlet.InstrumentedFilter.responseCodes.notFound\'].mean_rate | number:2}}</td><td class="text-right">{{vm.metrics.meters[\'com.codahale.metrics.servlet.InstrumentedFilter.responseCodes.notFound\'].m1_rate | number:2}}</td><td class="text-right">{{vm.metrics.meters[\'com.codahale.metrics.servlet.InstrumentedFilter.responseCodes.notFound\'].m5_rate | number:2}}</td><td class="text-right">{{vm.metrics.meters[\'com.codahale.metrics.servlet.InstrumentedFilter.responseCodes.notFound\'].m15_rate | number:2}}</td></tr><tr><td data-translate="metrics.jvm.http.code.servererror">Server error</td><td><uib-progressbar min="0" max="vm.metrics.timers[\'com.codahale.metrics.servlet.InstrumentedFilter.requests\'].count" value="vm.metrics.meters[\'com.codahale.metrics.servlet.InstrumentedFilter.responseCodes.serverError\'].count" class="progress-striped active" type="success"><span>{{vm.metrics.meters[\'com.codahale.metrics.servlet.InstrumentedFilter.responseCodes.serverError\'].count}}</span></uib-progressbar></td><td class="text-right">{{vm.metrics.meters[\'com.codahale.metrics.servlet.InstrumentedFilter.responseCodes.serverError\'].mean_rate | number:2}}</td><td class="text-right">{{vm.metrics.meters[\'com.codahale.metrics.servlet.InstrumentedFilter.responseCodes.serverError\'].m1_rate | number:2}}</td><td class="text-right">{{vm.metrics.meters[\'com.codahale.metrics.servlet.InstrumentedFilter.responseCodes.serverError\'].m5_rate | number:2}}</td><td class="text-right">{{vm.metrics.meters[\'com.codahale.metrics.servlet.InstrumentedFilter.responseCodes.serverError\'].m15_rate | number:2}}</td></tr></tbody></table></div><h3 data-translate="metrics.servicesstats.title">Services statistics (time in millisecond)</h3><div class="table-responsive"><table class="table table-striped"><thead><tr><th data-translate="metrics.servicesstats.table.name">Service name</th><th class="text-right" data-translate="metrics.servicesstats.table.count">Count</th><th class="text-right" data-translate="metrics.servicesstats.table.mean">Mean</th><th class="text-right" data-translate="metrics.servicesstats.table.min">Min</th><th class="text-right" data-translate="metrics.servicesstats.table.p50">p50</th><th class="text-right" data-translate="metrics.servicesstats.table.p75">p75</th><th class="text-right" data-translate="metrics.servicesstats.table.p95">p95</th><th class="text-right" data-translate="metrics.servicesstats.table.p99">p99</th><th class="text-right" data-translate="metrics.servicesstats.table.max">Max</th></tr></thead><tbody><tr ng-repeat="(k, v) in vm.servicesStats"><td>{{k}}</td><td class="text-right">{{v.count}}</td><td class="text-right">{{v.mean * 1000 | number:0}}</td><td class="text-right">{{v.min * 1000 | number:0}}</td><td class="text-right">{{v.p50 * 1000 | number:0}}</td><td class="text-right">{{v.p75 * 1000 | number:0}}</td><td class="text-right">{{v.p95 * 1000 | number:0}}</td><td class="text-right">{{v.p99 * 1000 | number:0}}</td><td class="text-right">{{v.max * 1000 | number:0}}</td></tr></tbody></table></div><h3 data-translate="metrics.datasource.title" ng-show="vm.metrics.gauges[\'HikariPool-1.pool.TotalConnections\'].value > 0">DataSource statistics (time in millisecond)</h3><div class="table-responsive" ng-show="vm.metrics.gauges[\'HikariPool-1.pool.TotalConnections\'].value > 0"><table class="table table-striped"><thead><tr><th><span data-translate="metrics.datasource.usage">Usage</span> ({{vm.metrics.gauges[\'HikariPool-1.pool.ActiveConnections\'].value}} / {{vm.metrics.gauges[\'HikariPool-1.pool.TotalConnections\'].value}})</th><th class="text-right" data-translate="metrics.datasource.count">Count</th><th class="text-right" data-translate="metrics.datasource.mean">Mean</th><th class="text-right" data-translate="metrics.datasource.min">Min</th><th class="text-right" data-translate="metrics.datasource.p50">p50</th><th class="text-right" data-translate="metrics.datasource.p75">p75</th><th class="text-right" data-translate="metrics.datasource.p95">p95</th><th class="text-right" data-translate="metrics.datasource.p99">p99</th><th class="text-right" data-translate="metrics.datasource.max">Max</th></tr></thead><tbody><tr><td><div class="progress progress-striped"><uib-progressbar min="0" max="vm.metrics.gauges[\'HikariPool-1.pool.TotalConnections\'].value" value="vm.metrics.gauges[\'HikariPool-1.pool.ActiveConnections\'].value" class="progress-striped active" type="success"><span>{{vm.metrics.gauges[\'HikariPool-1.pool.ActiveConnections\'].value * 100 / vm.metrics.gauges[\'HikariPool-1.pool.TotalConnections\'].value | number:0}}%</span></uib-progressbar></div></td><td class="text-right">{{vm.metrics.histograms[\'HikariPool-1.pool.Usage\'].count}}</td><td class="text-right">{{vm.metrics.histograms[\'HikariPool-1.pool.Usage\'].mean | number:2}}</td><td class="text-right">{{vm.metrics.histograms[\'HikariPool-1.pool.Usage\'].min | number:2}}</td><td class="text-right">{{vm.metrics.histograms[\'HikariPool-1.pool.Usage\'].p50 | number:2}}</td><td class="text-right">{{vm.metrics.histograms[\'HikariPool-1.pool.Usage\'].p75 | number:2}}</td><td class="text-right">{{vm.metrics.histograms[\'HikariPool-1.pool.Usage\'].p95 | number:2}}</td><td class="text-right">{{vm.metrics.histograms[\'HikariPool-1.pool.Usage\'].p99 | number:2}}</td><td class="text-right">{{vm.metrics.histograms[\'HikariPool-1.pool.Usage\'].max | number:2}}</td></tr></tbody></table></div></div>');
$templateCache.put('app/admin/metrics/metrics.modal.html','<!--\n  ~ Copyright (c) 2017 by Julian Feder, julian.feder@yahoo.de\n  ~\n  ~ This product includes software developed at\n  ~ The Apache Software Foundation (http://www.apache.org/).\n  --><!-- Modal used to display the threads dump --><div class="modal-header"><button type="button" class="close" ng-click="vm.cancel()">&times;</button><h4 class="modal-title" data-translate="metrics.jvm.threads.dump.title">Threads dump</h4></div><div class="modal-body pad"><span class="label label-primary" ng-click="threadDumpFilter = {}">All&nbsp;<span class="badge">{{vm.threadDumpAll}}</span></span>&nbsp; <span class="label label-success" ng-click="threadDumpFilter = {threadState: \'RUNNABLE\'}">Runnable&nbsp;<span class="badge">{{vm.threadDumpRunnable}}</span></span>&nbsp; <span class="label label-info" ng-click="threadDumpFilter = {threadState: \'WAITING\'}">Waiting&nbsp;<span class="badge">{{vm.threadDumpWaiting}}</span></span>&nbsp; <span class="label label-warning" ng-click="threadDumpFilter = {threadState: \'TIMED_WAITING\'}">Timed Waiting&nbsp;<span class="badge">{{vm.threadDumpTimedWaiting}}</span></span>&nbsp; <span class="label label-danger" ng-click="threadDumpFilter = {threadState: \'BLOCKED\'}">Blocked&nbsp;<span class="badge">{{vm.threadDumpBlocked}}</span></span>&nbsp;<div class="voffset2">&nbsp;</div>Filter <input type="text" ng-model="threadDumpFilter" class="form-control"><div class="row pad" ng-repeat="(k, v) in vm.threadDump | filter:threadDumpFilter"><h5><span class="label" ng-class="vm.getLabelClass(v.threadState)">{{v.threadState}}</span>&nbsp;{{v.threadName}} (ID {{v.threadId}}) <a ng-click="show = !show"><span ng-show="!show" data-translate="metrics.jvm.threads.dump.show">Show StackTrace</span> <span ng-show="show" data-translate="metrics.jvm.threads.dump.hide">Hide StackTrace</span></a></h5><div class="well" ng-show="show"><div ng-repeat="(stK, stV) in v.stackTrace">{{stV.className}}.{{stV.methodName}}({{stV.fileName}}:{{stV.lineNumber}}) <span class="voffset1"></span></div></div><table class="table table-condensed"><thead><tr><th class="text-right" data-translate="metrics.jvm.threads.dump.blockedtime">Blocked Time</th><th class="text-right" data-translate="metrics.jvm.threads.dump.blockedcount">Blocked Count</th><th class="text-right" data-translate="metrics.jvm.threads.dump.waitedtime">Waited Time</th><th class="text-right" data-translate="metrics.jvm.threads.dump.waitedcount">Waited Count</th><th data-translate="metrics.jvm.threads.dump.lockname">Lock Name</th></tr></thead><tbody><tr><td>{{v.blockedTime}}</td><td>{{v.blockedCount}}</td><td>{{v.waitedTime}}</td><td>{{v.waitedCount}}</td><td>{{v.lockName}}</td></tr></tbody></table></div></div><div class="modal-footer"><button type="button" class="btn btn-default pull-left" data-dismiss="modal" ng-click="vm.cancel()">Done</button></div>');
$templateCache.put('app/admin/tracker/tracker.html','<!--\n  ~ Copyright (c) 2017 by Julian Feder, julian.feder@yahoo.de\n  ~\n  ~ This product includes software developed at\n  ~ The Apache Software Foundation (http://www.apache.org/).\n  --><div><h2 data-translate="tracker.title">Real-time user activities</h2><div class="table-responsive"><table class="table table-striped"><thead><tr><th data-translate="tracker.table.userlogin">User</th><th data-translate="tracker.table.ipaddress">IP Address</th><th data-translate="tracker.table.page">Current page</th><th data-translate="tracker.table.time">Time</th><th></th></tr></thead><tbody><tr ng-repeat="activity in vm.activities"><td>{{activity.userLogin}}</td><td>{{activity.ipAddress}}</td><td>{{activity.page}}</td><td>{{activity.time}}</td></tr></tbody></table></div></div>');
$templateCache.put('app/admin/user-management/user-management-delete-dialog.html','<!--\n  ~ Copyright (c) 2017 by Julian Feder, julian.feder@yahoo.de\n  ~\n  ~ This product includes software developed at\n  ~ The Apache Software Foundation (http://www.apache.org/).\n  --><form name="deleteForm" ng-submit="vm.confirmDelete(vm.user.login)"><div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()">&times;</button><h4 class="modal-title" data-translate="entity.delete.title">Confirm delete operation</h4></div><div class="modal-body"><jhi-alert-error></jhi-alert-error><p data-translate="userManagement.delete.question" translate-values="{login: \'{{vm.user.login}}\'}">Are you sure you want to delete this User?</p></div><div class="modal-footer"><button type="button" class="btn btn-default" data-dismiss="modal" ng-click="vm.clear()"><span class="glyphicon glyphicon-ban-circle"></span>&nbsp;<span data-translate="entity.action.cancel">Cancel</span></button> <button type="submit" class="btn btn-danger"><span class="glyphicon glyphicon-remove-circle"></span>&nbsp;<span data-translate="entity.action.delete">Delete</span></button></div></form>');
$templateCache.put('app/admin/user-management/user-management-detail.html','<!--\n  ~ Copyright (c) 2017 by Julian Feder, julian.feder@yahoo.de\n  ~\n  ~ This product includes software developed at\n  ~ The Apache Software Foundation (http://www.apache.org/).\n  --><div><h2><span data-translate="userManagement.detail.title">User</span> [<b>{{vm.user.login}}</b>]</h2><dl class="dl-horizontal jh-entity-details"><dt><span data-translate="userManagement.login">Login</span></dt><dd><span>{{vm.user.login}}</span> <span class="label label-danger" ng-show="!vm.user.activated" data-translate="userManagement.deactivated">Deactivated</span> <span class="label label-success" ng-show="vm.user.activated" data-translate="userManagement.activated">Activated</span></dd><dt><span data-translate="userManagement.firstName">First Name</span></dt><dd>{{vm.user.firstName}}</dd><dt><span data-translate="userManagement.lastName">Last Name</span></dt><dd>{{vm.user.lastName}}</dd><dt><span data-translate="userManagement.email">Email</span></dt><dd>{{vm.user.email}}</dd><dt><span data-translate="userManagement.langKey">Lang Key</span></dt><dd>{{vm.user.langKey}}</dd><dt><span data-translate="userManagement.createdBy">Created By</span></dt><dd>{{vm.user.createdBy}}</dd><dt><span data-translate="userManagement.createdDate">Created Date</span></dt><dd>{{vm.user.createdDate | date:\'dd/MM/yy HH:mm\' }}</dd><dt><span data-translate="userManagement.lastModifiedBy">Last Modified By</span></dt><dd>{{vm.user.lastModifiedBy}}</dd><dt><span data-translate="userManagement.lastModifiedDate">Last Modified Date</span></dt><dd>{{vm.user.lastModifiedDate | date:\'dd/MM/yy HH:mm\'}}</dd><dt><span data-translate="userManagement.profiles">Profiles</span></dt><dd><ul class="list-unstyled"><li ng-repeat="authority in vm.user.authorities"><span class="label label-info">{{authority}}</span></li></ul></dd></dl><button type="submit" ui-sref="user-management" class="btn btn-info"><span class="glyphicon glyphicon-arrow-left"></span>&nbsp;<span data-translate="entity.action.back"> Back</span></button></div>');
$templateCache.put('app/admin/user-management/user-management-dialog.html','<!--\n  ~ Copyright (c) 2017 by Julian Feder, julian.feder@yahoo.de\n  ~\n  ~ This product includes software developed at\n  ~ The Apache Software Foundation (http://www.apache.org/).\n  --><form name="editForm" role="form" novalidate ng-submit="vm.save()" show-validation><div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()">&times;</button><h4 class="modal-title" id="myUserLabel" data-translate="userManagement.home.createOrEditLabel">Create or edit a User</h4></div><div class="modal-body"><jhi-alert-error></jhi-alert-error><div class="form-group"><label data-translate="global.field.id">ID</label><input type="text" class="form-control" name="id" ng-model="vm.user.id" readonly="readonly"></div><div class="form-group"><label class="control-label" data-translate="userManagement.login">Login</label><input type="text" class="form-control" name="login" ng-model="vm.user.login" ng-required="vm.user.id == null" ng-minlength="1" ng-maxlength="50" ng-pattern="/^[_\'.@A-Za-z0-9-]*$/"><div ng-show="editForm.login.$invalid"><p class="help-block" ng-show="editForm.login.$error.required" data-translate="entity.validation.required">This field is required.</p><p class="help-block" ng-show="editForm.login.$error.maxlength" data-translate="entity.validation.maxlength" translate-value-max="50">This field cannot be longer than 50 characters.</p></div></div><div class="form-group"><label class="control-label" data-translate="userManagement.firstName">First Name</label><input type="text" class="form-control" name="firstName" ng-model="vm.user.firstName" ng-maxlength="50"><div ng-show="editForm.firstName.$invalid"><p class="help-block" ng-show="editForm.firstName.$error.maxlength" data-translate="entity.validation.maxlength" translate-value-max="50">This field cannot be longer than 50 characters.</p></div></div><div class="form-group"><label data-translate="userManagement.lastName">Last Name</label><input type="text" class="form-control" name="lastName" ng-model="vm.user.lastName" ng-maxlength="50"><div ng-show="editForm.lastName.$invalid"><p class="help-block" ng-show="editForm.lastName.$error.maxlength" data-translate="entity.validation.maxlength" translate-value-max="50">This field cannot be longer than 50 characters.</p></div></div><div class="form-group"><label class="control-label" data-translate="userManagement.email">Email</label><input type="email" class="form-control" name="email" ng-model="vm.user.email" required ng-maxlength="100"><div ng-show="editForm.email.$invalid"><p class="help-block" ng-show="editForm.email.$error.required" data-translate="entity.validation.required">This field is required.</p><p class="help-block" ng-show="editForm.email.$error.maxlength" data-translate="entity.validation.maxlength" translate-value-max="100">This field cannot be longer than 100 characters.</p><p class="help-block" ng-show="editForm.email.$error.email" data-translate="global.messages.validate.email.invalid">Your email is invalid.</p></div></div><div class="form-group"><label for="activated"><input ng-disabled="vm.user.id === null" type="checkbox" id="activated" name="activated" ng-model="vm.user.activated"> <span data-translate="userManagement.activated">Activated</span></label></div><div class="form-group"><label data-translate="userManagement.langKey">Lang Key</label><select class="form-control" name="langKey" ng-model="vm.user.langKey" ng-options="language as language for language in vm.languages track by language"></select></div><div class="form-group"><label data-translate="userManagement.profiles">Profiles</label><select class="form-control" multiple="multiple" name="authority" ng-model="vm.user.authorities" size="10" ng-options="authority for authority in vm.authorities"></select></div></div><div class="modal-footer"><button type="button" class="btn btn-default" data-dismiss="modal" ng-click="vm.clear()"><span class="glyphicon glyphicon-ban-circle"></span>&nbsp;<span data-translate="entity.action.cancel">Cancel</span></button> <button type="submit" ng-disabled="editForm.$invalid || vm.isSaving" class="btn btn-primary"><span class="glyphicon glyphicon-save"></span>&nbsp;<span data-translate="entity.action.save">Save</span></button></div></form>');
$templateCache.put('app/admin/user-management/user-management.html','<!--\n  ~ Copyright (c) 2017 by Julian Feder, julian.feder@yahoo.de\n  ~\n  ~ This product includes software developed at\n  ~ The Apache Software Foundation (http://www.apache.org/).\n  --><div><h2 data-translate="userManagement.home.title">Users</h2><jhi-alert></jhi-alert><div class="row"><div class="col-md-4"><form name="searchForm" class="form-inline"><div class="input-group pull-right"><input type="text" class="form-control" ng-model="vm.searchQuery" id="searchQuery" placeholder="{{ \'askApp.memberManagement.home.search\' | translate }}"> <span class="input-group-btn width-min"><button class="btn btn-info" ng-click="vm.search(vm.searchQuery)"><span class="glyphicon glyphicon-search"></span></button> </span><span class="input-group-btn width-min" ng-if="vm.currentSearch"><button class="btn btn-info" ng-click="vm.clear()"><span class="glyphicon glyphicon-trash"></span></button></span></div></form><!--\n          <button class="btn btn-primary" ui-sref="user-management.new">\n              <span class="glyphicon glyphicon-flash"></span> <span data-translate="userManagement.home.createLabel">Create a new User</span>\n          </button>--></div></div><div class="table-responsive"><table class="jh-table table table-striped"><thead><tr jh-sort="vm.predicate" ascending="vm.reverse" callback="vm.transition()"><th jh-sort-by="id"><span data-translate="global.field.id">ID</span><span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="login"><span data-translate="userManagement.login">Login</span> <span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="email"><span data-translate="userManagement.email">Email</span> <span class="glyphicon glyphicon-sort"></span></th><th></th><th jh-sort-by="langKey"><span data-translate="userManagement.langKey">Lang Key</span> <span class="glyphicon glyphicon-sort"></span></th><th><span data-translate="userManagement.profiles">Profiles</span></th><th jh-sort-by="createdDate"><span data-translate="userManagement.createdDate">Created Date</span> <span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="lastModifiedBy"><span data-translate="userManagement.lastModifiedBy">Last Modified By</span> <span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="lastModifiedDate"><span data-translate="userManagement.lastModifiedDate">Last Modified Date</span> <span class="glyphicon glyphicon-sort"></span></th><th></th></tr></thead><tbody><tr ng-repeat="user in vm.users track by user.id"><td><a ui-sref="user-management-detail({login:user.login})">{{user.id}}</a></td><td>{{user.login}}</td><td>{{user.email}}</td><td><button class="btn btn-danger btn-xs" ng-click="vm.setActive(user, true)" ng-show="!user.activated" data-translate="userManagement.deactivated">Deactivated</button> <button class="btn btn-success btn-xs" ng-click="vm.setActive(user, false)" ng-show="user.activated" ng-disabled="vm.currentAccount.login==user.login" data-translate="userManagement.activated">Activated</button></td><td>{{user.langKey}}</td><td><div ng-repeat="authority in user.authorities"><span class="label label-info">{{ authority }}</span></div></td><td>{{user.createdDate | date:\'dd/MM/yy HH:mm\'}}</td><td>{{user.lastModifiedBy}}</td><td>{{user.lastModifiedDate | date:\'dd/MM/yy HH:mm\'}}</td><td class="text-right"><div class="btn-group flex-btn-group-container"><button type="submit" ui-sref="user-management-detail({login:user.login})" class="btn btn-info btn-sm"><span class="glyphicon glyphicon-eye-open"></span></button> <button type="submit" ui-sref="user-management.edit({login:user.login})" class="btn btn-primary btn-sm"><span class="glyphicon glyphicon-pencil"></span></button> <button type="submit" ui-sref="user-management.delete({login:user.login})" class="btn btn-danger btn-sm" ng-disabled="vm.currentAccount.login==user.login"><span class="glyphicon glyphicon-remove-circle"></span></button></div></td></tr></tbody></table></div><div class="text-center"><jhi-item-count page="vm.page" total="vm.queryCount" items-per-page="vm.itemsPerPage"></jhi-item-count><uib-pagination class="pagination-sm" total-items="vm.totalItems" ng-model="vm.page" ng-change="vm.transition()"></uib-pagination></div></div>');
$templateCache.put('app/board/activities/activities-delete-dialog.html','<!--\n  ~ Copyright (c) 2017 by Julian Feder, julian.feder@yahoo.de\n  ~\n  ~ This product includes software developed at\n  ~ The Apache Software Foundation (http://www.apache.org/).\n  --><form name="deleteForm" ng-submit="vm.confirmDelete(vm.activities.id)"><div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()">&times;</button><h4 class="modal-title" data-translate="entity.delete.title">Confirm delete operation</h4></div><div class="modal-body"><jhi-alert-error></jhi-alert-error><p data-translate="askApp.activities.delete.question" translate-values="{id: \'{{vm.activities.id}}\'}">Are you sure you want to delete this Activities?</p></div><div class="modal-footer"><button type="button" class="btn btn-default" data-dismiss="modal" ng-click="vm.clear()"><span class="glyphicon glyphicon-ban-circle"></span>&nbsp;<span data-translate="entity.action.cancel">Cancel</span></button> <button type="submit" ng-disabled="deleteForm.$invalid" class="btn btn-danger"><span class="glyphicon glyphicon-remove-circle"></span>&nbsp;<span data-translate="entity.action.delete">Delete</span></button></div></form>');
$templateCache.put('app/board/activities/activities-dialog.html','<!--\n  ~ Copyright (c) 2017 by Julian Feder, julian.feder@yahoo.de\n  ~\n  ~ This product includes software developed at\n  ~ The Apache Software Foundation (http://www.apache.org/).\n  --><form name="editForm" role="form" novalidate ng-submit="vm.save()" show-validation><div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()">&times;</button><h4 class="modal-title" id="myActivitiesLabel" data-translate="askApp.activities.home.createLabel" ng-show="vm.activities.id == null">Create or edit a Activities</h4><h4 class="modal-title" id="myActivitiesLabel" data-translate="askApp.activities.home.editLabel" ng-show="vm.activities.id != null">Create or edit a Activities</h4></div><div class="modal-body"><jhi-alert-error></jhi-alert-error><!--\n        <div class="form-group" ng-show="vm.activities.id">\n            <label for="id" data-translate="global.field.id">ID</label>\n            <input type="text" class="form-control" id="id" name="id"\n                    ng-model="vm.activities.id" readonly />\n        </div>--><div class="form-group" ng-show="vm.activities.id == null"><label class="control-label" data-translate="askApp.activities.amount" for="field_weight">Amount</label><input type="number" class="form-control" name="weight" id="field_weight" ng-model="vm.activities.amount" placeholder="{{\'askApp.activities.amount\' | translate}}" min="1" max="10" ng-init="vm.activities.amount = 1"><div ng-show="editForm.weight.$invalid"><p class="help-block" ng-show="editForm.weight.$error.min" data-translate="entity.validation.min" translate-value-min="1">This field should be at least 0.</p><p class="help-block" ng-show="editForm.weight.$error.max" data-translate="entity.validation.max" translate-value-max="10">This field cannot be more than 200.</p><p class="help-block" ng-show="editForm.weight.$error.number" data-translate="entity.validation.number">This field should be a number.</p></div></div><div class="form-group"><label class="control-label" data-translate="askApp.activities.activitiesDate" for="field_activitiesDate">Activities Date</label><div class="input-group"><input id="field_activitiesDate" type="text" class="form-control" name="activitiesDate" uib-datepicker-popup="{{\'dd.MM.yyyy\'}}" ng-model="vm.activities.activitiesDate" is-open="vm.datePickerOpenStatus.activitiesDate" required ng-disabled="vm.activities.booking != null"> <span class="input-group-btn"><button type="button" class="btn btn-default" ng-click="vm.openCalendar(\'activitiesDate\')" ng-disabled="vm.activities.booking != null"><i class="glyphicon glyphicon-calendar"></i></button></span></div><div ng-show="editForm.activitiesDate.$invalid"><p class="help-block" ng-show="editForm.activitiesDate.$error.required" data-translate="entity.validation.required">This field is required.</p></div></div><div class="form-group"><label class="control-label" data-translate="askApp.activities.category" for="field_category">Category</label><select class="form-control" name="category" ng-model="vm.activities.category" id="field_category" required><option value="AMT" data-translate="askApp.EnumCategoryActivity.AMT">AMT</option><option value="AUSBILDUNG" data-translate="askApp.EnumCategoryActivity.AUSBILDUNG">AUSBILDUNG</option><option value="EVENT" data-translate="askApp.EnumCategoryActivity.EVENT">EVENT</option><option value="MARKETING" data-translate="askApp.EnumCategoryActivity.MARKETING">MARKETING</option><option value="SONSTIGES" data-translate="askApp.EnumCategoryActivity.SONSTIGES">SONSTIGES</option></select><div ng-show="editForm.category.$invalid"><p class="help-block" ng-show="editForm.category.$error.required" data-translate="entity.validation.required">This field is required.</p></div></div><div class="form-group" ng-show="vm.activities.id == null"><label class="control-label" data-translate="askApp.activities.profile" for="field_profile">Type</label><input type="text" ng-model="vm.activities.profile" placeholder="Suche Mitglied" uib-typeahead="profile as (profile.user.firstName + \' \' + profile.user.lastName) for profile in vm.getUser($viewValue)" typeahead-loading="loadingLocations" typeahead-no-results="noResults" name="profile" id="field_profile" required class="form-control" autocomplete="off"><div ng-show="editForm.profile.$invalid"><p class="help-block" ng-show="editForm.profile.$error.required" data-translate="entity.validation.required">This field is required.</p></div></div><div class="form-group"><label class="control-label" data-translate="askApp.activities.comment" for="field_comment">Comment</label><input type="text" class="form-control" name="comment" id="field_comment" ng-model="vm.activities.comment"></div><!--<div class="form-group" ng-show="vm.activities.id == null">\n            <label data-translate="askApp.activities.profile" for="field_profile">Profile</label>\n            <select class="form-control" id="field_profile" name="profile" ng-model="vm.activities.profile" ng-options="profile as (profile.user.firstName + \' \' + profile.user.lastName ) for profile in vm.profiles track by profile.id" required>\n            </select>\n            <div ng-show="editForm.profile.$invalid">\n                <p class="help-block"\n                    ng-show="editForm.profile.$error.required" data-translate="entity.validation.required">\n                    This field is required.\n                </p>\n            </div>\n        </div>--><!--\n        <div ng-show="vm.activities.booking != null">\n            <div class="alert alert-danger" role="alert"><b>Achtung!</b> Bist du dir sicher, dass du das Projekt \xE4ndern oder entfernen m\xF6chtest?</div>\n            <switch id="field_visible" ng-model="removeBooking" class="green"></switch>\n        </div>\n        <div class="form-group" ng-show="vm.activities.booking != null">\n            <label data-translate="askApp.activities.booking" for="field_booking">Booking</label>\n            <select class="form-control" id="field_booking" name="booking" ng-model="vm.activities.booking" ng-disabled="!removeBooking" ng-options="booking as booking.project.name for booking in vm.bookings track by booking.id">\n                <option value=""></option>\n            </select>\n        </div>--></div><div class="modal-footer"><button type="button" class="btn btn-default" data-dismiss="modal" ng-click="vm.clear()"><span class="glyphicon glyphicon-ban-circle"></span>&nbsp;<span data-translate="entity.action.cancel">Cancel</span></button> <button type="submit" ng-disabled="editForm.$invalid || vm.isSaving" class="btn btn-primary"><span class="glyphicon glyphicon-save"></span>&nbsp;<span data-translate="entity.action.save">Save</span></button></div></form>');
$templateCache.put('app/board/activities/activities.html','<!--\n  ~ Copyright (c) 2017 by Julian Feder, julian.feder@yahoo.de\n  ~\n  ~ This product includes software developed at\n  ~ The Apache Software Foundation (http://www.apache.org/).\n  --><div><div class="row row-no-padding"><div class="col-xs-12"><div class="panel panel-default"><div class="panel-heading"><h3 class="panel-title" data-translate="askApp.activities.home.title">Activities</h3></div><div class="panel-body"><jhi-alert></jhi-alert><div class="container-fluid"><div class="row"><div class="col-xs-12 col-md-6 no-padding-left"><div class="btn-group"><button type="submit" ng-click="vm.currentSearch == null && vm.setQuery(\'useable\')" class="btn btn-default btn-md" ng-class="{active: vm.query == \'useable\' && vm.currentSearch == null && !vm.select}" ng-disabled="vm.currentSearch != null || vm.select"><span class="hidden-sm-down">G\xFCltig</span></button> <button type="submit" ng-click="vm.currentSearch == null && vm.setQuery(\'used\')" class="btn btn-default btn-md" ng-class="{active: vm.query == \'used\' && vm.currentSearch == null && !vm.select}" ng-disabled="vm.currentSearch != null || vm.select"><span class="hidden-sm-down">Eingel\xF6st</span></button> <button type="submit" ng-click="vm.currentSearch == null && vm.setQuery(\'unuseable\')" class="btn btn-default btn-md" ng-class="{active: vm.query == \'unuseable\' && vm.currentSearch == null && !vm.select}" ng-disabled="vm.currentSearch != null || vm.select"><span class="hidden-sm-down">Ung\xFCltig</span></button></div></div><div class="col-xs-6 col-md-3 no-padding-right no-padding-left row-margin-top"><input type="text" ng-model="vm.selected" placeholder="Suche Mitglied" uib-typeahead="profile as (profile.user.firstName + \' \' + profile.user.lastName + (profile.nickname ? (\' &quot;\' + profile.nickname + \'&quot;\') : (\'\'))) for profile in vm.getUser($viewValue)" typeahead-loading="loadingLocations" typeahead-no-results="noResults" typeahead-on-select="vm.selectUser($item, $model, $label, $event)" ng-disabled="vm.currentSearch != null" autocomplete="off" class="form-control" autocomplete="off"></div><div class="col-xs-6 col-md-3 no-padding-right row-margin-top"><form name="searchForm" class="form-inline"><div class="input-group pull-right"><input type="text" class="form-control" ng-model="vm.searchQuery" id="searchQuery" placeholder="{{ \'askApp.activities.home.search\' | translate }}"> <span class="input-group-btn width-min"><button class="btn btn-info" ng-click="vm.search(vm.searchQuery)"><span class="glyphicon glyphicon-search"></span></button> </span><span class="input-group-btn width-min" ng-if="vm.currentSearch || vm.select"><button class="btn btn-info" ng-click="vm.clear()"><span class="glyphicon glyphicon-trash"></span></button></span></div></form></div></div><br><div class="row"><div class="col-xs-12 no-padding-left"><button class="btn btn-primary" ui-sref="board.activities.new({user:vm.select})"><span class="glyphicon glyphicon-plus"></span> <span class="hidden-xs-down" data-translate="askApp.activities.home.createLabel">Create new Activities</span></button></div></div></div><br><div class="alert alert-info" role="alert" ng-show="vm.activities.length == 0"><b>Keine Daten vorhanden!</b> \xC4ndere die Suchanfrage oder die Auswahlkategorie.</div><div class="table-responsive" ng-show="vm.activities.length != 0"><table class="jh-table table table-striped"><thead><tr jh-sort="vm.predicate" ascending="vm.reverse" callback="vm.transition()"><th jh-sort-by="activitiesDate"><span data-translate="askApp.activities.activitiesDate">Activities Date</span> <span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="profile.id"><span data-translate="askApp.activities.profile">Profile</span> <span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="validFrom"><span data-translate="askApp.activities.validFrom">Valid From</span> <span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="validUntil"><span data-translate="askApp.activities.validUntil">Valid until</span> <span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="category"><span data-translate="askApp.activities.category">Category</span> <span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="comment"><span data-translate="askApp.activities.comment">Comment</span> <span class="glyphicon glyphicon-sort"></span></th><th ng-show="vm.query == \'used\' || vm.currentSearch || vm.select"><span data-translate="askApp.activities.redeemed">eingel\xF6st</span></th><th ng-show="vm.query == \'used\' || vm.currentSearch || vm.select"><span data-translate="askApp.activities.redeemedDate">eingel\xF6st</span></th><th></th></tr></thead><tbody><tr ng-repeat="activities in vm.activities track by activities.id"><td>{{activities.activitiesDate | date:\'mediumDate\'}}</td><td><a ui-sref="member-management-detail({id:activities.profile.id})">{{activities.profile.user.firstName}} {{activities.profile.user.lastName}}</a> <span ng-if="activities.profile.nickname" class="glyphicon glyphicon-info-sign" aria-hidden="true" popover-trigger="mouseenter" uib-popover="{{activities.profile.nickname}}" style="cursor: pointer"></span></td><td>{{activities.validFrom | date:\'mediumDate\'}}</td><td>{{activities.validUntil | date:\'mediumDate\'}}</td><td><span class="label label-info" data-translate="{{\'askApp.EnumCategoryActivity.\' + activities.category}}">{{activities.category}}</span></td><td style="text-align: center"><span style="cursor: pointer" class="glyphicon glyphicon-comment" aria-hidden="true" uib-popover="{{activities.comment}}" popover-trigger="mouseenter" ng-show="activities.comment"></span> <span class="glyphicon glyphicon-remove" aria-hidden="true" ng-show="!activities.comment"></span></td><td ng-show="activities.redeemed && (vm.query == \'used\' || vm.currentSearch || vm.query)">{{activities.redeemed | limitTo:15}}{{activities.redeemed.length > 15 ? \'...\' : \'\'}} <span class="glyphicon glyphicon-info-sign" aria-hidden="true" uib-popover="{{activities.redeemed}}" popover-trigger="mouseenter" style="cursor: pointer" ng-show="activities.redeemed.length > 15"></span></td><td style="text-align: center" ng-show="!activities.dept.relation && (vm.query == \'used\' || vm.currentSearch || vm.select)"><span class="glyphicon glyphicon-remove" aria-hidden="true"></span></td><td ng-show="activities.redeemedDate && (vm.query == \'used\' || vm.currentSearch || vm.query)">{{activities.redeemedDate | date:\'mediumDate\'}}</td><td style="text-align: center" ng-show="!activities.dept.relation && (vm.query == \'used\' || vm.currentSearch || vm.select)"><span class="glyphicon glyphicon-remove" aria-hidden="true"></span></td><td class="text-right"><div class="btn-group flex-btn-group-container"><button type="submit" ui-sref="board.activities.edit({id:activities.id})" class="btn btn-primary btn-xs"><span class="glyphicon glyphicon-pencil"></span></button> <button type="submit" ui-sref="board.activities.delete({id:activities.id})" class="btn btn-danger btn-xs" ng-disabled="activities.dept != null"><span class="glyphicon glyphicon-remove-circle"></span></button></div></td></tr></tbody></table></div></div></div><div class="text-center" ng-show="vm.activities.length != 0"><jhi-item-count page="vm.page" total="vm.queryCount" items-per-page="vm.itemsPerPage"></jhi-item-count><uib-pagination class="pagination-sm" total-items="vm.totalItems" items-per-page="vm.itemsPerPage" ng-model="vm.page" ng-change="vm.transition()"></uib-pagination></div></div></div></div>');
$templateCache.put('app/board/booking/booking-delete-dialog.html','<!--\n  ~ Copyright (c) 2017 by Julian Feder, julian.feder@yahoo.de\n  ~\n  ~ This product includes software developed at\n  ~ The Apache Software Foundation (http://www.apache.org/).\n  --><form name="deleteForm" ng-submit="vm.confirmDelete(vm.booking.id)"><div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()">&times;</button><h4 class="modal-title" data-translate="entity.delete.title">Confirm delete operation</h4></div><div class="modal-body"><jhi-alert-error></jhi-alert-error><p data-translate="askApp.booking.delete.question" translate-value-id="{{vm.booking.id}}" translate-value-first-name="{{vm.booking.profile.user.firstName}}" translate-value-last-name="{{vm.booking.profile.user.lastName}}" translate-value-nickname="{{vm.nickname}}" translate-value-project-name="{{vm.booking.project.name}}">Are you sure you want to delete this Booking?</p></div><div class="modal-footer"><button type="button" class="btn btn-default" data-dismiss="modal" ng-click="vm.clear()"><span class="glyphicon glyphicon-ban-circle"></span>&nbsp;<span data-translate="entity.action.cancel">Cancel</span></button> <button type="submit" ng-disabled="deleteForm.$invalid" class="btn btn-danger"><span class="glyphicon glyphicon-remove-circle"></span>&nbsp;<span data-translate="entity.action.delete">Delete</span></button></div></form>');
$templateCache.put('app/board/booking/booking-dialog.html','<!--\n  ~ Copyright (c) 2017 by Julian Feder, julian.feder@yahoo.de\n  ~\n  ~ This product includes software developed at\n  ~ The Apache Software Foundation (http://www.apache.org/).\n  --><form name="editForm" role="form" novalidate ng-submit="vm.save()" show-validation><div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()">&times;</button><h4 class="modal-title" id="myBookingLabel" data-translate="askApp.booking.home.editLabel" translate-value-first-name="{{vm.booking.profile.user.firstName}}" translate-value-last-name="{{vm.booking.profile.user.lastName}}" translate-value-project-name="{{vm.booking.project.name}}" translate-value-nickname="{{vm.nickname}}">Create or edit a Booking</h4></div><div class="modal-body"><jhi-alert-error></jhi-alert-error><div class="form-group" ng-init="vm.booking.sendNotificationMail = true"><label class="control-label" data-translate="askApp.booking.status" for="field_status">Status</label><select class="form-control" name="status" ng-model="vm.booking.status" id="field_status"><option value="angemeldet" data-translate="askApp.EnumBookingStatusType.angemeldet">angemeldet</option><option value="warteliste" data-translate="askApp.EnumBookingStatusType.warteliste">warteliste</option><option value="abgelehnt" data-translate="askApp.EnumBookingStatusType.abgelehnt">abgelehnt</option><option value="zurueckgetreten" data-translate="askApp.EnumBookingStatusType.zurueckgetreten">zurueckgetreten</option></select></div><div ng-show="vm.booking.project.type == \'sksTrip\' && (vm.booking.status === \'angemeldet\' || vm.booking.status === \'warteliste\')"><label class="control-label">Teilnahme an SKS-Pr\xFCfung? (&Auml;ndert auch den zugeh\xF6rigen Preis!)</label><br><switch ng-model="vm.booking.nonIndividual" class="green"></switch></div><div ng-show="vm.booking.status != vm.booking.oldStatus || vm.booking.nonIndividual === vm.booking.oldIndividualPrice"><label class="control-label">Mitglied per E-Mail \xFCber die Status\xE4nderung informieren</label><br><switch ng-model="vm.booking.sendNotificationMail" class="green"></switch><div class="form-group" ng-show="vm.booking.sendNotificationMail"><label class="control-label" data-translate="askApp.booking.managerComment" for="field_managerComment">Comment</label><input type="text" class="form-control" name="managerComment" id="field_managerComment" ng-model="vm.booking.managerComment" ng-maxlength="250"><div ng-show="editForm.managerComment.$dirty && editForm.managerComment.$invalid"><p class="help-block" ng-show="editForm.managerComment.$error.maxlength" data-translate="entity.validation.maxlength" translate-value-max="250">This field cannot be longer than 250 characters.</p></div></div></div><div class="alert alert-info" data-translate="askApp.booking.infoStatusChange"></div><div class="form-group" ng-if="vm.booking.project.type == \'sbfPractical\'"><label class="control-label" data-translate="askApp.booking.sbfSlotsMax" for="field_sbfSlotsMax">Sbf Slot Count</label><input type="number" class="form-control" name="sbfSlotsMax" id="field_sbfSlotsMax" ng-model="vm.booking.sbfSlotsMax" ng-required="vm.booking.project.type == \'sbfPractical\'" min="0" max="10"><div ng-show="editForm.sbfSlotsMax.$invalid"><p class="help-block" ng-show="editForm.sbfSlotsMax.$error.required" data-translate="entity.validation.required">This field is required.</p><p class="help-block" ng-show="editForm.sbfSlotsMax.$error.number" data-translate="entity.validation.number">This field should be a number.</p><p class="help-block" ng-show="editForm.sbfSlotsMax.$error.min" data-translate="entity.validation.min" translate-value-min="0">This field should be at least 1.</p><p class="help-block" ng-show="editForm.sbfSlotsMax.$error.max" data-translate="entity.validation.max" translate-value-max="10">This field cannot be more than 30.</p></div></div><div class="form-group"><label class="control-label" data-translate="askApp.booking.comment" for="field_comment">Comment</label><input type="text" class="form-control" name="comment" id="field_comment" ng-model="vm.booking.comment" ng-maxlength="250"><div ng-show="editForm.comment.$dirty && editForm.comment.$invalid"><p class="help-block" ng-show="editForm.comment.$error.maxlength" data-translate="entity.validation.maxlength" translate-value-max="250">This field cannot be longer than 250 characters.</p></div></div><div class="form-group" ng-show="vm.booking.project.individualField !== null"><label class="control-label" for="field_individualField">{{vm.booking.project.individualField}}</label><input type="text" class="form-control" name="individualField" id="field_individualField" ng-model="vm.booking.individualField" ng-maxlength="250"><div ng-show="editForm.individualField.$dirty && editForm.individualField.$invalid"><p class="help-block" ng-show="editForm.individualField.$error.maxlength" data-translate="entity.validation.maxlength" translate-value-max="250">This field cannot be longer than 250 characters.</p></div></div></div><div class="modal-footer"><button type="button" class="btn btn-default" data-dismiss="modal" ng-click="vm.clear()"><span class="glyphicon glyphicon-ban-circle"></span>&nbsp;<span data-translate="entity.action.cancel">Cancel</span></button> <button type="submit" ng-disabled="editForm.$invalid || vm.isSaving" class="btn btn-primary"><span class="glyphicon glyphicon-save"></span>&nbsp;<span data-translate="entity.action.save">Save</span></button></div></form>');
$templateCache.put('app/board/booking/bookings.html','<!--\n  ~ Copyright (c) 2017 by Julian Feder, julian.feder@yahoo.de\n  ~\n  ~ This product includes software developed at\n  ~ The Apache Software Foundation (http://www.apache.org/).\n  --><div><div class="row row-no-padding"><div class="col-xs-12"><div class="panel panel-default"><div class="panel-heading"><h3 class="panel-title" data-translate="askApp.booking.home.title">Bookings</h3></div><div class="panel-body"><jhi-alert></jhi-alert><div class="container-fluid"><div class="row"><div class="col-xs-0 col-md-6 no-padding-left"></div><div class="col-xs-6 col-md-3 no-padding-right no-padding-left"><input type="text" ng-model="vm.selected" placeholder="Suche Mitglied" uib-typeahead="profile as (profile.user.firstName + \' \' + profile.user.lastName + (profile.nickname ? (\' &quot;\' + profile.nickname + \'&quot;\') : (\'\'))) for profile in vm.getUser($viewValue)" typeahead-loading="loadingLocations" typeahead-no-results="noResults" typeahead-on-select="vm.selectUser($item, $model, $label, $event)" ng-disabled="vm.currentSearch != null" class="form-control" autocomplete="off"></div><div class="col-xs-6 col-md-3 no-padding-right"><form name="searchForm" class="form-inline"><div class="input-group pull-right"><input type="text" class="form-control" ng-model="vm.searchQuery" id="searchQuery" placeholder="{{ \'askApp.booking.home.search\' | translate }}"> <span class="input-group-btn width-min"><button class="btn btn-info" ng-click="vm.search(vm.searchQuery)"><span class="glyphicon glyphicon-search"></span></button> </span><span class="input-group-btn width-min" ng-if="vm.currentSearch || vm.select"><button class="btn btn-info" ng-click="vm.clear()"><span class="glyphicon glyphicon-trash"></span></button></span></div></form></div></div></div><br><div class="alert alert-info" role="alert" ng-show="vm.bookings.length == 0"><b>Keine Daten vorhanden!</b> F\xFCr diese Auswahl existieren keine Buchungen.</div><div class="table-responsive" ng-show="vm.bookings.length > 0"><table class="jh-table table table-striped"><thead><tr jh-sort="vm.predicate" ascending="vm.reverse" callback="vm.transition()"><th jh-sort-by="id"><span data-translate="askApp.booking.date">Date</span> <span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="profile.user.firstName"><span>Mitglied</span> <span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="status"><span>Status</span> <span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="price"><span>Preis</span> <span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="dept.paymentStatus"><span>Bezahlstatus</span> <span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="comment"><span>Kommentar</span> <span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="project.id"><span data-translate="askApp.booking.project">Project</span> <span class="glyphicon glyphicon-sort"></span></th><th></th></tr></thead><tbody><tr ng-repeat="booking in vm.bookings track by booking.id"><td>{{booking.date | date:\'mediumDate\'}}</td><td><a ui-sref="member-management-detail({id:booking.profile.id})">{{booking.profile.user.firstName}} {{booking.profile.user.lastName}}</a> <span ng-if="booking.profile.nickname" class="glyphicon glyphicon-info-sign" aria-hidden="true" popover-trigger="mouseenter" uib-popover="{{booking.profile.nickname}}" style="cursor: pointer"></span></td><td><span class="label label-success" data-translate="{{\'askApp.EnumBookingStatusType.\' + booking.status}}" ng-show="booking.status == \'angemeldet\'">{{booking.status}}</span> <span class="label label-danger" data-translate="{{\'askApp.EnumBookingStatusType.\' + booking.status}}" ng-show="booking.status == \'zurueckgetreten\'">{{booking.status}}</span> <span class="label label-danger" data-translate="{{\'askApp.EnumBookingStatusType.\' + booking.status}}" ng-show="booking.status == \'abgelehnt\'">{{booking.status}}</span> <span class="label label-warning" data-translate="{{\'askApp.EnumBookingStatusType.\' + booking.status}}" ng-show="booking.status == \'warteliste\'">{{booking.status}}</span></td><td ng-show="booking.projectType === \'interest\'" colspan="2"><span class="label label-info">Interessensbekundung</span></td><td ng-hide="booking.projectType === \'interest\'">{{booking.price | number:2}}\u20AC</td><td ng-hide="booking.projectType === \'interest\'"><span class="label label-danger" data-translate="{{\'askApp.EnumDeptStatus.\' + booking.dept.paymentStatus}}" ng-show="booking.dept.paymentStatus == \'pending\'">{{booking.dept.paymentStatus}}</span> <span class="label label-success" data-translate="{{\'askApp.EnumDeptStatus.\' + booking.dept.paymentStatus}}" ng-show="booking.dept.paymentStatus == \'payed\'">{{booking.dept.paymentStatus}}</span> <span class="label label-warning" data-translate="{{\'askApp.EnumDeptStatus.\' + booking.dept.paymentStatus}}" ng-show="booking.dept.paymentStatus == \'partial\'">{{booking.dept.paymentStatus}}</span> <span class="label label-warning" data-translate="{{\'askApp.EnumDeptStatus.\' + booking.dept.paymentStatus}}" ng-show="booking.dept.paymentStatus == \'prePayed\'">{{booking.dept.paymentStatus}}</span> <span class="label label-danger" data-translate="{{\'askApp.EnumDeptStatus.\' + booking.dept.paymentStatus}}" ng-show="booking.dept.paymentStatus == \'payedToMuch\'">{{booking.dept.paymentStatus}}</span> <span class="glyphicon glyphicon-info-sign" aria-hidden="true" popover-trigger="mouseenter" popover-title="Forderung" uib-popover-template="\'popover-partial.html\'" style="cursor: pointer"></span> <a ui-sref="board.booking.edit-dept({deptId: booking.dept.id})" has-authority="ROLE_FINANCE"><span class="glyphicon glyphicon-pencil"></span></a> <a ui-sref="board.booking.new-dept({projectId: booking.projectId, userId: booking.profile.id})" has-authority="ROLE_FINANCE" ng-if="!booking.projectClosed"><span class="glyphicon glyphicon-plus"></span></a></td><td style="text-align: center"><span style="cursor: pointer" class="glyphicon glyphicon-comment" aria-hidden="true" uib-popover="{{booking.comment}}" popover-trigger="mouseenter" ng-show="booking.comment" popover-append-to-body="true"></span> <span class="glyphicon glyphicon-remove" aria-hidden="true" ng-show="!booking.comment"></span> <span class="glyphicon glyphicon-comment" ng-show="booking.individualFieldAnswer" aria-hidden="true" popover-trigger="mouseenter" popover-title="{{booking.individualFieldQuestion}}" uib-popover-template="\'popover-partial2.html\'" style="cursor: pointer" popover-append-to-body="true"></span> <span class="glyphicon glyphicon-remove" aria-hidden="true" ng-show="!booking.individualFieldAnswer && booking.individualFieldQuestion"></span></td><td><a ui-sref="board.project-detail.home({id:booking.projectId})">{{booking.projectName | limitTo: 25}}{{booking.projectName.length > 25 ? \'...\' : \'\'}}</a> <span class="glyphicon glyphicon-info-sign" aria-hidden="true" uib-popover="{{booking.projectName}}" popover-trigger="mouseenter" style="cursor: pointer" ng-show="booking.projectName.length > 25"></span></td><td class="text-right"><div class="btn-group flex-btn-group-container"><button type="submit" ui-sref="board.booking.edit({id:booking.id})" class="btn btn-primary btn-xs"><span class="glyphicon glyphicon-pencil"></span></button> <button type="submit" ui-sref="board.booking.delete({id:booking.id})" ng-disabled="booking.deptsAvailable == true" class="btn btn-danger btn-xs"><span class="glyphicon glyphicon-remove-circle"></span></button></div></td></tr></tbody></table></div></div></div><div class="text-center" ng-show="vm.bookings.length > 0"><jhi-item-count page="vm.page" total="vm.queryCount" items-per-page="vm.itemsPerPage"></jhi-item-count><uib-pagination class="pagination-sm" total-items="vm.totalItems" items-per-page="vm.itemsPerPage" ng-model="vm.page" ng-change="vm.transition()"></uib-pagination></div></div></div></div><script type="text/ng-template" id="popover-partial2.html"><span>\n        {{booking.individualFieldAnswer}}\n    </span></script><script type="text/ng-template" id="popover-partial.html"><div class="form-group">\n        <table>\n            <tr>\n                <td>Betrag:</td>\n                <td>{{booking.dept.amount | number:2}}\u20AC</td>\n            </tr>\n            <tr>\n                <td style="width: 150px;">Aktivit\xE4tenpunkte:</td>\n                <td>{{booking.dept.apCount}}</td>\n            </tr>\n            <tr>\n                <td>Soll:</td>\n                <td>{{booking.dept.priceNet | number:2}}\u20AC</td>\n            </tr>\n            <tr ng-repeat="payment in booking.dept.payments">\n                <td>{{payment.date | date:\'dd.MM.yyyy\'}}:</td>\n                <td>{{payment.amount | number:2}}\u20AC</td>\n            </tr>\n            <tr>\n                <td>Ist:</td>\n                <td>{{booking.dept.payed | number:2}}\u20AC</td>\n            </tr>\n            <tr>\n                <td colspan="2">\n                    <hr>\n                </td>\n            </tr>\n            <tr>\n                <td><span data-translate="askApp.dept.toPay">Saldo</span>:</td>\n                <td><b>{{booking.dept.toPay | number:2}}\u20AC</b></td>\n            </tr>\n        </table>\n    </div></script>');
$templateCache.put('app/board/content/content-delete-dialog.html','<form name="deleteForm" ng-submit="vm.confirmDelete(vm.content.id)"><div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()">&times;</button><h4 class="modal-title" data-translate="entity.delete.title">Confirm delete operation</h4></div><div class="modal-body"><jhi-alert-error></jhi-alert-error><p data-translate="askApp.content.delete.question" translate-values="{id: \'{{vm.content.id}}\'}">Are you sure you want to delete this Content?</p></div><div class="modal-footer"><button type="button" class="btn btn-default" data-dismiss="modal" ng-click="vm.clear()"><span class="glyphicon glyphicon-ban-circle"></span>&nbsp;<span data-translate="entity.action.cancel">Cancel</span></button> <button type="submit" ng-disabled="deleteForm.$invalid" class="btn btn-danger"><span class="glyphicon glyphicon-remove-circle"></span>&nbsp;<span data-translate="entity.action.delete">Delete</span></button></div></form>');
$templateCache.put('app/board/content/content-dialog.html','<form name="editForm" role="form" novalidate ng-submit="vm.save()" show-validation><div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()">&times;</button><h4 class="modal-title" id="myContentLabel" data-translate="askApp.content.home.createOrEditLabel">Create or edit a Content</h4></div><div class="modal-body"><jhi-alert-error></jhi-alert-error><div class="form-group" ng-show="vm.content.id"><label for="id" data-translate="global.field.id">ID</label><input type="text" class="form-control" id="id" name="id" ng-model="vm.content.id" readonly="readonly"></div><div class="form-group"><label class="control-label" data-translate="askApp.content.text" for="field_text">Text</label><!--<input type="text" class="form-control" name="text" id="field_text"\n                    ng-model="vm.content.text"\n                    required/--><summernote config="vm.options" ng-model="vm.content.text" id="field_text" class="form-control" name="text" required></summernote><div ng-show="editForm.text.$invalid"><p class="help-block" ng-show="editForm.text.$error.required" data-translate="entity.validation.required">This field is required.</p></div></div><div class="form-group"><label class="control-label" data-translate="askApp.content.access" for="field_access">Access</label><select class="form-control" name="access" ng-model="vm.content.access" id="field_access" required><option value="extern" data-translate="askApp.EnumContentAccess.extern">extern</option><option value="intern" data-translate="askApp.EnumContentAccess.intern">intern</option></select><div ng-show="editForm.access.$invalid"><p class="help-block" ng-show="editForm.access.$error.required" data-translate="entity.validation.required">This field is required.</p></div></div></div><div class="modal-footer"><button type="button" class="btn btn-default" data-dismiss="modal" ng-click="vm.clear()"><span class="glyphicon glyphicon-ban-circle"></span>&nbsp;<span data-translate="entity.action.cancel">Cancel</span></button> <button type="submit" ng-disabled="editForm.$invalid || vm.isSaving" class="btn btn-primary"><span class="glyphicon glyphicon-save"></span>&nbsp;<span data-translate="entity.action.save">Save</span></button></div></form>');
$templateCache.put('app/board/content/contents.html','<!--\n  ~ Copyright (c) 2017 by Julian Feder, julian.feder@yahoo.de\n  ~\n  ~ This product includes software developed at\n  ~ The Apache Software Foundation (http://www.apache.org/).\n  --><div><div class="row row-no-padding"><div class="col-xs-12"><div class="panel panel-default"><div class="panel-heading"><h3 class="panel-title" data-translate="askApp.content.home.title">Contents</h3></div><div class="panel-body"><jhi-alert></jhi-alert><div class="container-fluid"><div class="row"><div class="col-xs-12 col-md-8 no-padding-left"><button class="btn btn-primary" ui-sref="board.content.new"><span class="glyphicon glyphicon-plus"></span> <span class="hidden-xs-down" data-translate="askApp.content.home.createLabel">Create new Content</span></button></div><div class="col-xs-12 col-md-4 no-padding-right no-padding-left row-margin-top"><form name="searchForm" class="form-inline"><div class="input-group pull-right"><input type="text" class="form-control" ng-model="vm.searchQuery" id="searchQuery" placeholder="{{ \'askApp.content.home.search\' | translate }}"> <span class="input-group-btn width-min"><button class="btn btn-info" ng-click="vm.search(vm.searchQuery)"><span class="glyphicon glyphicon-search"></span></button> </span><span class="input-group-btn width-min" ng-if="vm.currentSearch"><button class="btn btn-info" ng-click="vm.clear()"><span class="glyphicon glyphicon-trash"></span></button></span></div></form></div></div></div><br><div class="table-responsive"><table class="jh-table table table-striped"><thead><tr jh-sort="vm.predicate" ascending="vm.reverse" callback="vm.transition()"><th jh-sort-by="id"><span data-translate="global.field.id">ID</span> <span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="text"><span data-translate="askApp.content.text">Text</span> <span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="access"><span data-translate="askApp.content.access">Access</span> <span class="glyphicon glyphicon-sort"></span></th><th></th></tr></thead><tbody><tr ng-repeat="content in vm.contents track by content.id"><td>{{content.id}}</td><td>{{content.text}}</td><td data-translate="{{\'askApp.EnumContentAccess.\' + content.access}}">{{content.access}}</td><td class="text-right"><div class="btn-group flex-btn-group-container"><button type="submit" ui-sref="board.content.edit({id:content.id})" class="btn btn-primary btn-xs"><span class="glyphicon glyphicon-pencil"></span></button><!--<button type="submit"\n                                                ui-sref="board.content.delete({id:content.id})"\n                                                class="btn btn-danger btn-xs">\n                                            <span class="glyphicon glyphicon-remove-circle"></span>\n                                            <span class="hidden-sm-down" data-translate="entity.action.delete"></span>\n                                        </button>--></div></td></tr></tbody></table></div></div></div><div class="text-center"><jhi-item-count page="vm.page" total="vm.queryCount" items-per-page="vm.itemsPerPage"></jhi-item-count><uib-pagination class="pagination-sm" total-items="vm.totalItems" items-per-page="vm.itemsPerPage" ng-model="vm.page" ng-change="vm.transition()"></uib-pagination></div></div></div></div>');
$templateCache.put('app/board/dept/dept-dialog.html','<!--\n  ~ Copyright (c) 2017 by Julian Feder, julian.feder@yahoo.de\n  ~\n  ~ This product includes software developed at\n  ~ The Apache Software Foundation (http://www.apache.org/).\n  --><form name="editForm" role="form" novalidate ng-submit="vm.save()" show-validation><div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()">&times;</button><h4 class="modal-title" id="myDeptLabelEdit" data-translate="askApp.dept.home.editLabel" ng-if="vm.dept.id" translate-value-first-name="{{vm.dept.profile.user.firstName}}" translate-value-last-name="{{vm.dept.profile.user.lastName}}" translate-value-relation="{{vm.dept.relation}}" translate-value-nickname="{{vm.nickname}}">Create or edit a Dept</h4><h4 class="modal-title" id="myDeptLabelNew" data-translate="askApp.dept.user.createOrEditLabel" ng-if="!vm.dept.id && vm.profilePresent" translate-value-first-name="{{vm.entityProfile.user.firstName}}" translate-value-last-name="{{vm.entityProfile.user.lastName}}" translate-value-nickname="{{vm.nickname}}">Create or edit a Dept</h4><h4 class="modal-title" id="myDeptLabelNewNoProfile" data-translate="askApp.dept.user.createLabelProject" ng-if="!vm.dept.id && !vm.profilePresent" translate-value-project-name="{{vm.dept.project ? vm.dept.project.name : vm.dept.dinghyEvent.name}}">Create or edit a Dept</h4></div><div class="modal-body"><jhi-alert-error></jhi-alert-error><div ng-if="!vm.profilePresent"><div class="form-group" id="selectType"><label class="control-label" for="selectType"></label><div class="btn-group btn-group-justified"><label class="btn btn-default" ng-model="vm.selectSingle" uib-btn-radio="true"><span data-translate="askApp.dept.select.single">single</span></label><label class="btn btn-default" ng-model="vm.selectSingle" uib-btn-radio="false"><span data-translate="askApp.dept.select.bulk">bulk</span></label></div></div><div class="form-group" id="sortByCrew" ng-if="vm.hasCrews"><label class="control-label" for="sortByCrew" data-translate="askApp.dept.sort.title">Student?</label><div class="btn-group btn-group-justified"><label class="btn btn-default" ng-model="vm.sortByCrew" uib-btn-radio="false"><span data-translate="askApp.dept.sort.booking">booking</span></label><label class="btn btn-default" ng-model="vm.sortByCrew" uib-btn-radio="true"><span data-translate="askApp.dept.sort.crew">crew</span></label></div></div><div class="form-group" ng-if="vm.selectSingle"><label class="control-label" data-translate="askApp.dept.member" for="field_profile">Profile</label><select class="form-control" id="field_profile" name="profile" ng-model="vm.dept.profile" ng-options="profile as\n                            vm.sortByCrew\n                            ? ((profile.crewSorting < 999 * 999 ? profile.crewPosition == 0 ? \'Skipper: \' : \'[\' + (profile.crewPosition + 1) + \']: \' : \'\') + (profile.crewSorting >= 999 * 999 ? \'Ohne Crew: \' : \'\') + profile.firstName + \' \' + profile.lastName + profile.nickname + \' // \' + (\'askApp.EnumBookingStatusType.\' + profile.status | translate) + \' // \' + \'Zus&auml;tzliche Forderungen: \' + profile.deptCount)\n                            : (profile.firstName + \' \' + profile.lastName + profile.nickname + \' // \' + (\'askApp.EnumBookingStatusType.\' + profile.status | translate) + \' // \' + \'Zus&auml;tzliche Forderungen: \' + profile.deptCount)\n                            for profile in vm.profiles | orderBy: vm.getNewBookingSorting()" required><option value=""></option></select></div><div class="form-group" ng-if="!vm.selectSingle"><label class="control-label" data-translate="askApp.dept.member_multiple" for="field_profiles">Profile</label><select class="form-control" id="field_profiles" multiple="multiple" size="10" name="profilesToCreate" ng-model="vm.dept.profilesToCreate" ng-options="profile as\n                            vm.sortByCrew\n                            ? ((profile.crewSorting < 999 * 999 ? profile.crewPosition == 0 ? \'Skipper: \' : \'[\' + (profile.crewPosition + 1) + \']: \' : \'\') + (profile.crewSorting >= 999 * 999 ? \'Ohne Crew: \' : \'\') + profile.firstName + \' \' + profile.lastName + profile.nickname + \' // \' + (\'askApp.EnumBookingStatusType.\' + profile.status | translate) + \' // \' + \'Zus&auml;tzliche Forderungen: \' + profile.deptCount)\n                            : (profile.firstName + \' \' + profile.lastName + profile.nickname + \' // \' + (\'askApp.EnumBookingStatusType.\' + profile.status | translate) + \' // \' + \'Zus&auml;tzliche Forderungen: \' + profile.deptCount)\n                            for profile in vm.profiles | orderBy: vm.getNewBookingSorting()" required></select></div></div><div class="form-group"><label class="control-label" data-translate="askApp.dept.amount" for="field_amount">Amount</label><div class="input-group"><span class="input-group-addon"><span class="glyphicon glyphicon-euro"></span> </span><input type="number" class="form-control" name="amount" id="field_amount" ng-model="vm.dept.amount" ng-change="vm.onChange()" required></div><div ng-show="editForm.amount.$invalid"><p class="help-block" ng-show="editForm.amount.$error.required" data-translate="entity.validation.required">This field is required.</p><p class="help-block" ng-show="editForm.amount.$error.number" data-translate="entity.validation.number">This field should be a number.</p></div></div><div class="form-group" ng-show="vm.dept.availableActivityPoints > 0"><label class="control-label">Aktivit\xE4tenpunkte</label><div style="width: 100px"><h-number value="vm.dept.apCount" min="0" step="1" change="vm.pointsPicked()"></h-number></div></div><div class="form-group" ng-if="!vm.dept.dinghyEvent"><label data-translate="askApp.payment.project" for="field_project">Project</label><select class="form-control" id="field_project" name="project" ng-model="vm.dept.project" ng-options="project as (project.name + \' // \' + (project.fromDate | date:mediumDate) + \' - \' + (project.untilDate | date:mediumDate) + (vm.relationClosed || !vm.profilePresent ? \'\' : \' // Buchung: \' + (project.bookingExists ? \'JA\' : \'Nein\'))) for project in vm.projects track by project.id" ng-disabled="vm.dept.id || vm.relationPresent"><option value=""></option></select></div><div class="form-group" ng-if="!vm.dept.project"><label data-translate="askApp.payment.dinghyEvent" for="field_dinghyEvent">Dinghy Event</label><select class="form-control" id="field_dinghyEvent" name="dinghyEvent" ng-model="vm.dept.dinghyEvent" ng-options="dinghyEvent as (dinghyEvent.name + \' // \' + (dinghyEvent.fromDate | date:mediumDate) + \' - \' + (dinghyEvent.untilDate | date:mediumDate) + (vm.relationClosed || !vm.profilePresent ? \'\' : \' // Buchung: \' + (dinghyEvent.bookingExists ? \'JA\' : \'Nein\'))) for dinghyEvent in vm.dinghyEvents track by dinghyEvent.id" ng-disabled="vm.dept.id || vm.relationPresent"><option value=""></option></select></div><div class="form-group" ng-if="vm.dept.id"><label data-translate="askApp.dept.priceCategory" class="control-label" for="field_priceCategory"></label><select class="form-control" name="priceCategory" ng-model="vm.dept.priceCategory" id="field_priceCategory" ng-required="!vm.dept.reference" disabled="disabled"><option value=""></option><option value="gast">Gast</option><option value="student">Student</option><option value="normal">Normal</option><option value="individual">Individuell</option></select></div><div class="form-group" ng-if="!vm.dept.id" ng-show="!vm.dept.reference || (vm.isSaving && vm.category)"><label class="control-label" for="field_category"><span data-translate="askApp.payment.category"></span> / <span data-translate="askApp.dept.reference"></span></label><select class="form-control" name="category" ng-model="vm.category" id="field_category" ng-required="!vm.dept.reference"><option value=""></option><option value="Teilnahmebeitrag" data-translate="askApp.EnumPaymentCategory.Teilnahmebeitrag">Teilnahmebeitrag</option><option value="Charter" data-translate="askApp.EnumPaymentCategory.Charter">Charter</option><option value="Meldegeld" data-translate="askApp.EnumPaymentCategory.Meldegeld">Meldegeld</option><option value="Pruefungsgebuehr" data-translate="askApp.EnumPaymentCategory.Pruefungsgebuehr">Pruefungsgebuehr</option><option value="Kautionversicherung" data-translate="askApp.EnumPaymentCategory.Kautionversicherung">Kautionversicherung</option><option value="Unterkunft" data-translate="askApp.EnumPaymentCategory.Unterkunft">Unterkunft</option><option value="Skipperhaftpflicht" data-translate="askApp.EnumPaymentCategory.Skipperhaftpflicht">Skipperhaftpflicht</option><option value="Uebungsleiterverguetung" data-translate="askApp.EnumPaymentCategory.Uebungsleiterverguetung">Uebungsleiterverguetung</option><option value="Bordkassenzuschuss" data-translate="askApp.EnumPaymentCategory.Bordkassenzuschuss">Bordkassenzuschuss</option><option value="Merch" data-translate="askApp.EnumPaymentCategory.Merch">Merch</option><option value="Verpflegung" data-translate="askApp.EnumPaymentCategory.Verpflegung">Verpflegung</option><option value="StadtmobilP" data-translate="askApp.EnumPaymentCategory.StadtmobilP">StadtmobilP</option><option value="StadtmobilTN" data-translate="askApp.EnumPaymentCategory.StadtmobilTN">StadtmobilTN</option><option value="Druckkosten" data-translate="askApp.EnumPaymentCategory.Druckkosten">Druckkosten</option><option value="Sonstiges" data-translate="askApp.EnumPaymentCategory.Sonstiges">Sonstiges</option></select><div ng-show="editForm.category.$invalid"><p class="help-block" ng-show="editForm.category.$error.required" data-translate="entity.validation.required">This field is required.</p></div></div><div class="form-group" ng-if="!vm.dept.id" ng-show="!vm.category"><label class="control-label" for="field_reference">ODER: <span data-translate="askApp.dept.reference"></span></label><input type="text" class="form-control" name="reference" id="field_reference" ng-model="vm.dept.reference" ng-required="!vm.category" ng-pattern="/^[a-zA-Z0-9\\+\\-\\.\\(\\)]+$/"><div ng-show="editForm.reference.$invalid"><p class="help-block" ng-show="editForm.reference.$error.required" data-translate="entity.validation.required">This field is required.</p><p class="help-block" ng-show="editForm.reference.$error.pattern">Ung&uuml;ltige Zeichen. Erlaubt: Buchstaben, Zahlen, +, -, ., ( und )</p></div></div><div ng-show="!vm.dept.id || diff < 0 && (vm.dept.amount != vm.dept.oldAmount || vm.dept.apCount != vm.dept.oldApCount)"><div class="form-group"><label class="control-label" data-translate="askApp.booking.managerComment" for="field_managerComment">Comment</label><input type="text" class="form-control" name="managerComment" id="field_managerComment" ng-model="vm.dept.managerComment" ng-maxlength="250"><div ng-show="editForm.managerComment.$dirty && editForm.managerComment.$invalid"><p class="help-block" ng-show="editForm.managerComment.$error.maxlength" data-translate="entity.validation.maxlength" translate-value-max="250">This field cannot be longer than 250 characters.</p></div></div></div><div class="form-group" ng-if="vm.dept.id"><div id="preCalc" style="border: 1px solid #ccc; padding: 6px 12px; border-radius: 4px; display: inline-block"><table><tr style="color: #8c8c8c"><td>Referenz:</td><td>{{vm.dept.reference}}</td></tr><tr style="color: #8c8c8c"><td>Originalpreis:</td><td>{{vm.dept.originalPrice | number:2}}\u20AC</td></tr><tr><td>Betrag:</td><td>{{vm.dept.amount | number:2}}\u20AC</td></tr><tr style="color: #8c8c8c"><td style="width: 150px">Aktivit\xE4tenpunkte:</td><td>{{vm.dept.apCount}}</td></tr><tr style="color: #8c8c8c"><td>Soll:</td><td>{{toPay | number:2}}\u20AC</td></tr><tr ng-repeat="payment in vm.dept.payments"><td>{{payment.date | date:\'dd.MM.yyyy\'}}:</td><td>{{payment.amount | number:2}}\u20AC</td></tr><tr style="color: #8c8c8c"><td>Ist:</td><td>{{vm.dept.payed | number:2}}\u20AC</td></tr><tr><td colspan="2"><hr></td></tr><tr><td><span data-translate="askApp.dept.toPay">Saldo</span>:</td><td><b>{{diff | number:2}}\u20AC</b></td></tr></table></div></div><div class="form-group" ng-if="vm.dept.id"><div class="alert alert-warning"><b>Achtung!</b> Wenn der Betrag <b>ge\xE4ndert</b> wird und der <span data-translate="askApp.dept.toPay">Saldo</span> negativ ist, wird automatisch eine Zahlungsaufforderung an das Mitglied geschickt.</div></div><div class="form-group"><label class="control-label" data-translate="askApp.dept.comment" for="field_comment">Comment</label><input type="text" class="form-control" name="comment" id="field_comment" ng-model="vm.dept.comment"></div></div><div class="modal-footer"><button type="button" class="btn btn-default" data-dismiss="modal" ng-click="vm.clear()"><span class="glyphicon glyphicon-ban-circle"></span>&nbsp;<span data-translate="entity.action.cancel">Cancel</span></button> <button type="submit" ng-disabled="editForm.$invalid || vm.isSaving" class="btn btn-primary"><span class="glyphicon glyphicon-save"></span>&nbsp;<span data-translate="entity.action.save">Save</span></button></div></form>');
$templateCache.put('app/board/dept/depts.html','<!--\n  ~ Copyright (c) 2017 by Julian Feder, julian.feder@yahoo.de\n  ~\n  ~ This product includes software developed at\n  ~ The Apache Software Foundation (http://www.apache.org/).\n  --><div><div class="row row-no-padding"><div class="col-xs-12"><div class="panel panel-default"><div class="panel-heading"><h3 class="panel-title" data-translate="askApp.dept.home.title">Debts</h3></div><div class="panel-body"><jhi-alert></jhi-alert><div class="container-fluid"><div class="row"><div class="col-xs-12 col-md-6 no-padding-left"><button class="btn btn-primary" ui-sref="board.dept.new" ng-if="vm.select"><span class="glyphicon glyphicon-plus"></span> <span class="hidden-xs-down" data-translate="askApp.dept.user.createLabel">Create new Dept </span>&#32;({{vm.selected}})</button></div><div class="col-xs-6 col-md-3 no-padding-right no-padding-left"><input type="text" ng-model="vm.userQuery" placeholder="Suche Mitglied" uib-typeahead="profile as (profile.user.firstName + \' \' + profile.user.lastName + (profile.nickname ? (\' &quot;\' + profile.nickname + \'&quot;\') : (\'\'))) for profile in vm.getUser($viewValue)" typeahead-loading="loadingLocations" typeahead-no-results="noResults" typeahead-on-select="vm.selectUser($item, $model, $label, $event)" ng-disabled="vm.currentSearch != null" class="form-control" autocomplete="off"></div><div class="col-xs-6 col-md-3 no-padding-right"><form name="searchForm" class="form-inline"><div class="input-group pull-right"><input type="text" class="form-control" ng-model="vm.searchQuery" id="searchQuery" placeholder="{{ \'askApp.dept.home.search\' | translate }}"> <span class="input-group-btn width-min"><button class="btn btn-info" ng-click="vm.search(vm.searchQuery)"><span class="glyphicon glyphicon-search"></span></button> </span><span class="input-group-btn width-min" ng-if="vm.currentSearch || vm.select"><button class="btn btn-info" ng-click="vm.clear()"><span class="glyphicon glyphicon-trash"></span></button></span></div></form></div></div></div><br><div class="alert alert-info" role="alert" ng-show="vm.depts.length == 0"><b>Keine Daten vorhanden!</b> F\xFCr diese Auswahl existieren keine Forderungen.</div><div class="table-responsive" ng-show="vm.depts.length > 0"><table class="jh-table table table-striped"><thead><tr jh-sort="vm.predicate" ascending="vm.reverse" callback="vm.transition()"><th jh-sort-by="date"><span data-translate="askApp.dept.date">Date</span> <span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="profile.user.firstName"><span>Mitglied</span> <span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="profile.memberStatus"><span>Status</span> <span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="sepa"><span>SEPA</span> <span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="reference"><span data-translate="askApp.dept.reference">Reference</span> <span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="amount"><span data-translate="askApp.dept.amount">Amount</span> <span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="paymentStatus"><span data-translate="askApp.dept.paymentStatus">Payment Status</span> <span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="comment"><span data-translate="askApp.dept.comment">Kommentar</span> <span class="glyphicon glyphicon-sort"></span></th><th><span>Referenz</span></th><th></th></tr></thead><tbody><tr ng-repeat="dept in vm.depts track by dept.id"><td>{{dept.date | date:\'mediumDate\'}}</td><td><a ui-sref="member-management-detail({id:dept.profile.id})">{{dept.profile.user.firstName}} {{dept.profile.user.lastName}}</a> <span ng-if="dept.profile.nickname" class="glyphicon glyphicon-info-sign" aria-hidden="true" popover-trigger="mouseenter" uib-popover="{{dept.profile.nickname}}" style="cursor: pointer"></span></td><td><span class="label label-info" data-translate="{{\'askApp.EnumMemberStatus.\' + dept.profile.memberStatus}}">Status</span></td><td ng-hide="dept.projectType === \'interest\'"><span ng-show="dept.sepa" class="label label-success" data-translate="askApp.memberManagement.isFullMember">Ja</span> <span ng-show="!dept.sepa" class="label label-danger" data-translate="askApp.memberManagement.isNotFullMember">Nein</span></td><td ng-show="dept.projectType === \'interest\'" colspan="4"><span class="label label-info">Interessensbekundung</span></td><td ng-hide="dept.projectType === \'interest\'"><span class="label label-info" popover-trigger="mouseenter" popover-title="Verwendungszweck" uib-popover-template="\'popover-partial-2.html\'" style="cursor: pointer">{{dept.reference | limitTo:5}}{{dept.reference.length > 5 ? \'...\' : \'\'}}</span></td><td ng-hide="dept.projectType === \'interest\'">{{dept.amount | number:2}}\u20AC</td><td ng-hide="dept.projectType === \'interest\'"><span class="label label-danger" data-translate="{{\'askApp.EnumDeptStatus.\' + dept.paymentStatus}}" ng-show="dept.paymentStatus == \'pending\'">{{dept.paymentStatus}}</span> <span class="label label-success" data-translate="{{\'askApp.EnumDeptStatus.\' + dept.paymentStatus}}" ng-show="dept.paymentStatus == \'payed\'">{{dept.paymentStatus}}</span> <span class="label label-warning" data-translate="{{\'askApp.EnumDeptStatus.\' + dept.paymentStatus}}" ng-show="dept.paymentStatus == \'partial\'">{{dept.paymentStatus}}</span> <span class="label label-warning" data-translate="{{\'askApp.EnumDeptStatus.\' + dept.paymentStatus}}" ng-show="dept.paymentStatus == \'prePayed\'">{{dept.paymentStatus}}</span> <span class="label label-danger" data-translate="{{\'askApp.EnumDeptStatus.\' + dept.paymentStatus}}" ng-show="dept.paymentStatus == \'payedToMuch\'">{{dept.paymentStatus}}</span> <span class="glyphicon glyphicon-info-sign" aria-hidden="true" popover-trigger="mouseenter" popover-title="Forderung" uib-popover-template="\'popover-partial.html\'" style="cursor: pointer"></span></td><td style="text-align: center"><span style="cursor: pointer" class="glyphicon glyphicon-comment" aria-hidden="true" uib-popover="{{dept.comment}}" popover-trigger="mouseenter" ng-show="dept.comment"></span> <span class="glyphicon glyphicon-remove" aria-hidden="true" ng-show="!dept.comment"></span></td><td>{{dept.relation | limitTo: 25}}{{dept.relation.length > 25 ? \'...\' : \'\'}} <span class="glyphicon glyphicon-info-sign" aria-hidden="true" uib-popover="{{dept.relation}}" popover-trigger="mouseenter" style="cursor: pointer" ng-show="dept.relation.length > 25"></span></td><td class="text-right"><div class="btn-group flex-btn-group-container"><button type="submit" ui-sref="board.dept.edit({id:dept.id})" class="btn btn-primary btn-xs"><span class="glyphicon glyphicon-pencil"></span></button></div></td></tr></tbody></table></div></div></div><div class="text-center" ng-show="vm.depts.length > 0"><jhi-item-count page="vm.page" total="vm.queryCount" items-per-page="vm.itemsPerPage"></jhi-item-count><uib-pagination class="pagination-sm" total-items="vm.totalItems" items-per-page="vm.itemsPerPage" ng-model="vm.page" ng-change="vm.transition()"></uib-pagination></div></div></div></div><script type="text/ng-template" id="popover-partial.html"><div class="form-group">\n        <table>\n            <tr>\n                <td>Betrag:</td>\n                <td>{{dept.amount | number:2}}\u20AC</td>\n            </tr>\n            <tr>\n                <td style="width: 150px;">Aktivit\xE4tenpunkte:</td>\n                <td>{{dept.apCount}}</td>\n            </tr>\n            <tr>\n                <td>Soll:</td>\n                <td>{{dept.priceNet | number:2}}\u20AC</td>\n            </tr>\n            <tr ng-repeat="payment in dept.payments">\n                <td>{{payment.date | date:\'dd.MM.yyyy\'}}:</td>\n                <td>{{payment.amount | number:2}}\u20AC</td>\n            </tr>\n            <tr>\n                <td>Ist:</td>\n                <td>{{dept.payed | number:2}}\u20AC</td>\n            </tr>\n            <tr>\n                <td colspan="2">\n                    <hr>\n                </td>\n            </tr>\n            <tr>\n                <td><span data-translate="askApp.dept.toPay">Saldo</span>:</td>\n                <td><b>{{dept.toPay | number:2}}\u20AC</b></td>\n            </tr>\n        </table>\n    </div></script><script type="text/ng-template" id="popover-partial-2.html"><div class="form-group">\n        <span class="label label-info">{{dept.reference}}</span>\n    </div></script>');
$templateCache.put('app/board/dinghy/dinghyNavbar.html','<!--\n  ~ Copyright (c) 2020 by Felix Heim, felix-heim@web.de\n  ~\n  ~ This product includes software developed at\n  ~ The Apache Software Foundation (http://www.apache.org/).\n  --><div><div class="row row-no-padding"><div class="col-md-12"><ol class="breadcrumb"><li><span data-translate="global.menu.board.dinghy">Dingy</span></li><li ng-repeat="subState in vm.states" ng-show="vm.$state.includes(subState[0])" ng-class="{active: vm.$state.current.name === subState[0]}"><a ng-show="vm.$state.current.name !== subState[0]" ui-sref="{{subState[0]}}" data-translate="{{subState[1]}}"></a><span ng-show="vm.$state.current.name === subState[0]" data-translate="{{subState[1]}}"></span></li><li class="active" ng-show="currentObj.name && vm.$state.includes(\'board.dinghy.dinghy.edit\')">{{currentObj.name}}</li></ol></div></div><div class="row row-no-padding"><div class="col-md-2"><div class="panel panel-default"><ul class="nav nav-pills nav-stacked" style="margin: 0"><li role="presentation" ui-sref-active="active"><a ui-sref="board.dinghy.event" data-translate="askApp.dinghy.event.title">events</a></li><li role="presentation" ui-sref-active="active"><a ui-sref="board.dinghy.booking" data-translate="askApp.dinghy.bookings.title">bookings</a></li><li role="presentation" ui-sref-active="active"><a ui-sref="board.dinghy.dinghy" data-translate="askApp.dinghy.detail.title">dinghy</a></li><li role="presentation" ui-sref-active="active"><a ui-sref="board.dinghy.plan" data-translate="askApp.dinghy.plan.title">plan</a></li><li role="presentation" ui-sref-active="active"><a ui-sref="board.dinghy.presence" data-translate="askApp.dinghy.presence.title">presence</a></li><li role="presentation" ui-sref-active="active"><a ui-sref="board.dinghy.newsletter" data-translate="askApp.dinghy.newsletter.title">newsletter</a></li></ul></div></div><div class="col-md-10" ui-view="dinghy"></div></div></div>');
$templateCache.put('app/board/member-management/member-exit-dialog.html','<!--\n  ~ Copyright (c) 2021 by Felix Heim, felix-heim@web.de\n  ~\n  ~ This product includes software developed at\n  ~ The Apache Software Foundation (http://www.apache.org/).\n  --><form name="editForm" role="form" novalidate ng-submit="vm.processExits()" show-validation><div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()">&times;</button><h4 class="modal-title" id="skipperEditLabel"><span data-translate="{{\'askApp.memberManagement.exit.process.title_\' + vm.mode}}">Exists</span></h4></div><div class="modal-body"><jhi-alert-error></jhi-alert-error><table><tbody><tr ng-repeat="member in vm.members track by member.id"><td>{{member.user.login}}</td><td>&nbsp;|&nbsp; <span ng-show="member.student">Student</span> <span ng-show="!member.student">Kein Student</span></td><td>&nbsp;|&nbsp; {{member.user.firstName}} {{member.user.lastName}} <span ng-if="member.nickname">"{{member.nickname}}"</span></td><td>&nbsp;|&nbsp; <span data-translate="{{\'askApp.EnumMemberStatus.\' + member.memberStatus}}"></span></td></tr></tbody></table><p ng-if="vm.members.length > 0">Anzahl Austritte: {{vm.members.length}}</p><div class="form-group"><label class="control-label" for="field_exitDate">Austrittsdatum</label><div class="input-group"><input id="field_exitDate" type="text" class="form-control" name="exitDate" uib-datepicker-popup="{{\'dd.MM.yyyy\'}}" ng-model="vm.exitDate" is-open="vm.datePickerOpenStatus.exitDate" required> <span class="input-group-btn"><button type="button" class="btn btn-default" ng-click="vm.openCalendar(\'exitDate\')"><i class="glyphicon glyphicon-calendar"></i></button></span></div><div ng-show="editForm.exitDate.$invalid"><p class="help-block" ng-show="editForm.exitDate.$error.required" data-translate="entity.validation.required">This field is required.</p></div></div></div><div class="modal-footer"><button type="button" class="btn btn-default" data-dismiss="modal" ng-click="vm.clear()"><span class="glyphicon glyphicon-ban-circle"></span>&nbsp;<span data-translate="entity.action.cancel">Cancel</span></button> <button type="submit" ng-disabled="editForm.$invalid || vm.isSaving || vm.members.length == 0" class="btn btn-danger"><span class="glyphicon glyphicon-remove"></span>&nbsp;<span ng-if="vm.mode == \'fee\'" data-translate="askApp.memberManagement.button.expell">Ausschlie\xDFen</span><span ng-if="vm.mode != \'fee\'" data-translate="askApp.memberManagement.button.leaved">Austreten</span></button></div></form>');
$templateCache.put('app/board/member-management/member-exit.html','<!--\n  ~ Copyright (c) 2021 by Felix Heim, felix-heim@web.de\n  ~\n  ~ This product includes software developed at\n  ~ The Apache Software Foundation (http://www.apache.org/).\n  --><div><div class="row row-no-padding"><div class="col-md-12"><ol class="breadcrumb"><li><a ui-sref="member-management">Mitgliederverwaltung</a></li><li class="active">Austritte</li></ol><jhi-alert></jhi-alert></div></div><div class="row row-no-padding"><div class="col-xs-12"><div class="panel panel-default"><div class="panel-heading"><h3 class="panel-title" data-translate="{{\'askApp.memberManagement.exit.title_\' + vm.mode}}" translate-value-year="{{vm.guestExitYear}}"></h3></div><div class="panel-body"><jhi-alert></jhi-alert><div class="alert alert-info" role="alert" ng-show="vm.members.length == 0"><b>Keine Daten vorhanden!</b> W\xE4hle eine andere Kategorie.</div><div class="table-responsive" ng-show="vm.members.length > 0"><table class="jh-table table table-striped"><thead><tr jh-sort="vm.predicate" ascending="vm.reverse" callback="vm.transition()"><th><span data-translate="askApp.memberManagement.memberNumber">Mitgliedsnummer</span></th><th><span data-translate="askApp.memberManagement.student">Student</span></th><th><span data-translate="askApp.memberManagement.firstName">Vorname</span></th><th><span data-translate="askApp.memberManagement.lastName">Nachname</span></th><th><span data-translate="askApp.memberManagement.memberStatus">memberStatus</span></th><th><span data-translate="askApp.memberManagement.criteria">criteria</span></th><th>Austritt?</th><th></th></tr></thead><tbody><tr ng-repeat="member in vm.members track by member.id"><td><span class="label label-info">{{member.user.login}}</span></td><td><span ng-show="member.student" class="label label-info" data-translate="askApp.memberManagement.isFullMember">Ja</span> <span ng-show="!member.student" class="label label-info" data-translate="askApp.memberManagement.isNotFullMember">Nein</span></td><td>{{member.user.firstName}} <span ng-if="member.nickname" class="glyphicon glyphicon-info-sign" aria-hidden="true" popover-trigger="mouseenter" uib-popover="{{member.nickname}}" style="cursor: pointer"></span></td><td>{{member.user.lastName}}</td><td><span class="label label-info btn-xs" data-translate="{{\'askApp.EnumMemberStatus.\' + member.memberStatus}}"></span></td><td><span ng-if="member.criteria.summary"><span class="glyphicon glyphicon-ok-sign" style="color: #5cb85c; font-size: 23px"></span> <span data-translate="askApp.memberManagement.exit.criteria.ok"></span> </span><span ng-if="!member.criteria.summary"><span ng-if="!member.criteria.depts"><span class="glyphicon glyphicon-remove-sign" style="color: #d9534f; font-size: 18px"></span> <a ui-sref="board.dept({select: member.id})"><span data-translate="askApp.memberManagement.exit.criteria.depts"></span></a><br></span><span ng-if="!member.criteria.bookings"><span class="glyphicon glyphicon-remove-sign" style="color: #d9534f; font-size: 18px"></span> <a ui-sref="board.booking({select: member.id})"><span data-translate="askApp.memberManagement.exit.criteria.bookings"></span></a><br></span><span ng-if="!member.criteria.dinghyBookings"><span class="glyphicon glyphicon-remove-sign" style="color: #d9534f; font-size: 18px"></span> <a ui-sref="board.dinghy.booking({select: member.id})"><span data-translate="askApp.memberManagement.exit.criteria.dinghyBookings"></span></a><br></span><span ng-if="!member.criteria.membershipFees"><span class="glyphicon glyphicon-remove-sign" style="color: #d9534f; font-size: 18px"></span> <a ui-sref="board.membership-fee({select: member.id})"><span data-translate="askApp.memberManagement.exit.criteria.membershipFees"></span></a><br></span><span ng-if="!member.criteria.projectAccess"><span class="glyphicon glyphicon-remove-sign" style="color: #d9534f; font-size: 18px"></span> <a ui-sref="manager-project-detail({id: member.id})"><span data-translate="askApp.memberManagement.exit.criteria.projectAccess"></span></a><br></span><span ng-if="!member.criteria.godparent"><span class="glyphicon glyphicon-remove-sign" style="color: #d9534f; font-size: 18px"></span> <a href="https://go.rocket.chat/room?host=chat.ask-ev.de&rid=felix.heim.ask1104&path=direct%2Ffelix.heim.ask1104" target="_blank"><span data-translate="askApp.memberManagement.exit.criteria.godparent"></span></a><br></span><span ng-if="!member.criteria.sbfSeeInstructor"><span class="glyphicon glyphicon-remove-sign" style="color: #d9534f; font-size: 18px"></span> <a ui-sref="board.project({typeP: \'sbfPractical\'})"><span data-translate="askApp.memberManagement.exit.criteria.sbfSeeInstructor"></span></a><br></span><span ng-if="!member.criteria.skipper"><span class="glyphicon glyphicon-remove-sign" style="color: #d9534f; font-size: 18px"></span> <a ui-sref="board.project({typeP: \'sksTrip\'})"><span data-translate="askApp.memberManagement.exit.criteria.skipper"></span></a><br></span></span></td><td><switch ng-if="member.criteria.summary" ng-model="member.processMember" class="green small-switch" ng-change="vm.updateProcessCount(member.processMember)"></switch><span ng-if="!member.criteria.summary" class="glyphicon glyphicon-remove-sign" style="color: #d9534f; font-size: 23px"></span></td><td class="text-right"><button type="submit" ui-sref="member-management-detail({id:member.id})" class="btn btn-info btn-xs"><span class="glyphicon glyphicon-eye-open"></span></button></td></tr></tbody></table></div><div class="modal-footer no-padding-bottom" ng-if="vm.members.length > 0"><div class="row"><div class="col-xs-1 col-sm-4 col-md-5 col-lg-6"></div><div class="col-xs-11 col-sm-5 col-md-4 col-lg-3 no-padding-right no-padding-left" style="text-align: left"><span class="label label-success">Kriterien erf\xFCllt:&nbsp;{{vm.membersValid}}</span> <span class="label label-danger">Kriterien nicht erf\xFCllt:&nbsp;{{vm.membersInvalid}}</span><br><span class="label label-info">Anzahl ausgew&auml;hlt:&nbsp;{{vm.membersSelectedCount}}</span> <span class="label label-info">Gesamt:&nbsp;{{vm.membersValid + vm.membersInvalid}}</span></div><div class="col-xs-12 col-sm-3 no-padding-left row-margin-top-xs"><button class="btn btn-primary" ng-click="vm.processCurrentSelection()" ng-disabled="!vm.canProcess()"><span class="hidden-xs-down" data-translate="askApp.memberManagement.exit.processAction">Process Exits</span></button></div></div></div></div></div></div></div></div>');
$templateCache.put('app/board/member-management/member-management-delete-certificate-dialog.html','<!--\n  ~ Copyright (c) 2018 by Felix Heim, felix-heim@web.de\n  ~\n  ~ This product includes software developed at\n  ~ The Apache Software Foundation (http://www.apache.org/).\n  --><form name="deleteForm" ng-submit="vm.confirmDelete()"><div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()">&times;</button><h4 class="modal-title" data-translate="entity.delete.title">Confirm delete operation</h4></div><div class="modal-body"><jhi-alert-error></jhi-alert-error><p data-translate="askApp.profile.delete-certificate.question" translate-value-first-name="{{vm.profile.user.firstName}}" translate-value-last-name="{{vm.profile.user.lastName}}">Are you sure you want to delete this Certificate?</p></div><div class="modal-footer"><button type="button" class="btn btn-default" data-dismiss="modal" ng-click="vm.clear()"><span class="glyphicon glyphicon-ban-circle"></span>&nbsp;<span data-translate="entity.action.cancel">Cancel</span></button> <button type="submit" ng-disabled="deleteForm.$invalid" class="btn btn-danger"><span class="glyphicon glyphicon-remove-circle"></span>&nbsp;<span data-translate="entity.action.delete">Delete</span></button></div></form>');
$templateCache.put('app/board/member-management/member-management-delete-dialog.html','<!--\n  ~ Copyright (c) 2017 by Julian Feder, julian.feder@yahoo.de\n  ~\n  ~ This product includes software developed at\n  ~ The Apache Software Foundation (http://www.apache.org/).\n  --><form name="deleteForm" ng-submit="vm.confirmDelete(vm.profile.id)"><div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()">&times;</button><h4 class="modal-title" data-translate="entity.delete.title">Confirm delete operation</h4></div><div class="modal-body"><jhi-alert-error></jhi-alert-error><p data-translate="askApp.profile.delete.question" translate-values="{id: \'{{vm.profile.id}}\'}">Are you sure you want to delete this Profile?</p></div><div class="modal-footer"><button type="button" class="btn btn-default" data-dismiss="modal" ng-click="vm.clear()"><span class="glyphicon glyphicon-ban-circle"></span>&nbsp;<span data-translate="entity.action.cancel">Cancel</span></button> <button type="submit" ng-disabled="deleteForm.$invalid" class="btn btn-danger"><span class="glyphicon glyphicon-remove-circle"></span>&nbsp;<span data-translate="entity.action.delete">Delete</span></button></div></form>');
$templateCache.put('app/board/member-management/member-management-detail.html','<!--\n  ~ Copyright (c) 2017 by Julian Feder, julian.feder@yahoo.de\n  ~\n  ~ This product includes software developed at\n  ~ The Apache Software Foundation (http://www.apache.org/).\n  --><div><div class="row row-no-padding"><div class="col-md-12"><ol class="breadcrumb"><li><a ui-sref="member-management">Mitgliederverwaltung</a></li><li class="active">{{vm.member.user.firstName}} {{vm.member.user.lastName}}<span ng-if="vm.member.nickname"> "{{vm.member.nickname}}"</span></li></ol><jhi-alert></jhi-alert></div></div><div class="member-management-detail-table"><div class="row row-no-padding"><div class="col-md-6"><div class="panel panel-default"><div class="panel-heading"><h3 class="panel-title">Stammdaten</h3></div><div class="panel-body"><table class="table no-border"><tr><td><b>Mitgliedsnummer</b></td><td><span class="label label-info">{{vm.member.user.login}}</span></td></tr><tr><td><b>Vorname</b></td><td>{{vm.member.user.firstName}}</td></tr><tr><td><b>Spitzname</b></td><td><span ng-if="vm.member.nickname">{{vm.member.nickname}}</span> <span ng-if="!vm.member.nickname" class="label label-danger">keine Angabe</span></td></tr><tr><td><b>Nachname</b></td><td>{{vm.member.user.lastName}}</td></tr><tr><td><b>Geschlecht</b></td><td data-translate="{{\'askApp.EnumGender.\' + vm.member.gender}}">M\xE4nnlich</td></tr><tr><td><b>Geburtsdatum</b></td><td>{{vm.member.birthdate | date:\'mediumDate\'}}</td></tr><tr><td><b>Handynummer</b></td><td><a href="tel:{{vm.member.phone}}">{{vm.member.phone}}</a></td></tr><tr><td><b>E-Mail Adresse</b></td><td ng-if="!(vm.member.memberStatus == \'ausgetreten\' || vm.member.memberStatus == \'ausgeschlossen\' || vm.member.memberStatus == \'ex_gast\')"><a href="mailto:{{vm.member.user.email}}">{{vm.member.user.email}}</a></td><td ng-if="vm.member.memberStatus == \'ausgetreten\' || vm.member.memberStatus == \'ausgeschlossen\' || vm.member.memberStatus == \'ex_gast\'"><a href="mailto:{{vm.member.emailBackup}}">{{vm.member.emailBackup}}</a></td></tr></table></div></div><div class="panel panel-default"><div class="panel-heading"><h3 class="panel-title">Adresse</h3></div><div class="panel-body"><table class="table no-border"><tr><td><b>Stra\xDFe & Hausnummer</b></td><td>{{vm.member.street}}</td></tr><tr><td><b>Postleitzahl</b></td><td>{{vm.member.postcode}}</td></tr><tr><td><b>Stadt</b></td><td>{{vm.member.city}}</td></tr><tr><td><b>Land</b></td><td data-translate="askApp.EnumCountry.{{vm.member.country}}"></td></tr></table></div></div><div class="panel panel-default"><div class="panel-heading"><h3 class="panel-title">Zusatzdaten</h3></div><div class="panel-body"><table class="table no-border"><tr><td><b>Gewicht</b></td><td ng-if="!vm.member.weight"><span class="label label-danger">keine Angabe</span></td><td ng-if="vm.member.weight">{{vm.member.weight}}</td></tr><tr><td><b>T-Shirt Gr\xF6\xDFe</b></td><td ng-if="vm.member.clothingSize != null" data-translate="askApp.EnumClothingSize.{{vm.member.clothingSize}}"></td><td ng-if="vm.member.clothingSize == null"><span class="label label-danger">keine Angabe</span></td></tr><tr><td><b>Schuhgr\xF6\xDFe (EU)</b></td><td ng-if="vm.member.shoeSize">{{vm.member.shoeSize}}</td><td ng-if="!vm.member.shoeSize"><span class="label label-danger">keine Angabe</span></td></tr><tr><td><b>Nationalit\xE4t</b></td><td ng-if="vm.member.nationality != null" data-translate="askApp.EnumCountry.{{vm.member.nationality}}"></td><td ng-if="vm.member.nationality == null"><span class="label label-danger">keine Angabe</span></td></tr><tr><td><b>Geburtsort</b></td><td ng-if="vm.member.birthplace">{{vm.member.birthplace}}</td><td ng-if="!vm.member.birthplace"><span class="label label-danger">keine Angabe</span></td></tr><tr><td><b>Geburtsland</b></td><td ng-if="vm.member.countryOfBirth != null" data-translate="askApp.EnumCountry.{{vm.member.countryOfBirth}}"></td><td ng-if="vm.member.countryOfBirth == null"><span class="label label-danger">keine Angabe</span></td></tr><tr><td><b>Ausweisdokument</b></td><td ng-if="vm.member.idType != null"><span class="label label-info" data-translate="askApp.EnumIDType.{{vm.member.idType}}">Bankeinzug</span></td><td ng-if="vm.member.idType == null"><span class="label label-danger">keine Angabe</span></td></tr><tr ng-show="vm.member.idType"><td><b>Ausweisnummer</b></td><td ng-if="vm.member.idNumber">{{vm.member.idNumber}}</td></tr><tr ng-show="vm.member.idType"><td><b>Ablaufdatum</b></td><td ng-if="vm.member.idExpirationDate">{{vm.member.idExpirationDate | date:"mediumDate"}}</td></tr></table></div></div><div class="panel panel-default"><div class="panel-heading"><h3 class="panel-title">Kommentar</h3></div><div class="panel-body"><summernote config="vm.options" ng-model="vm.member.commentBoard" ng-change="vm.save()"></summernote></div></div></div><div class="col-md-6"><div class="panel panel-default"><div class="panel-heading"><h3 class="panel-title">Zertifikate</h3></div><div class="panel-body"><table class="table no-border"><tr><td><b>SBF-Binnen</b></td><td ng-if="!vm.member.sbfBinnen"><span class="label label-danger">keine Angabe</span></td><td ng-if="vm.member.sbfBinnen">{{vm.member.sbfBinnen}}</td></tr><tr><td><b>BSP</b></td><td ng-if="!vm.member.bsp"><span class="label label-danger">keine Angabe</span></td><td ng-if="vm.member.bsp">{{vm.member.bsp}}</td></tr><tr><td><b>SBF-See</b></td><td ng-if="!vm.member.sbfSee"><span class="label label-danger">keine Angabe</span></td><td ng-if="vm.member.sbfSee">{{vm.member.sbfSee}}</td></tr><tr><td><b>SKS</b></td><td ng-if="!vm.member.sks"><span class="label label-danger">keine Angabe</span></td><td ng-if="vm.member.sks">{{vm.member.sks}}</td></tr><tr><td><b>SSS</b></td><td ng-if="!vm.member.sss"><span class="label label-danger">keine Angabe</span></td><td ng-if="vm.member.sss">{{vm.member.sss}}</td></tr><tr><td><b>SHS</b></td><td ng-if="!vm.member.shs"><span class="label label-danger">keine Angabe</span></td><td ng-if="vm.member.shs">{{vm.member.shs}}</td></tr><tr><td><b>UBI</b></td><td ng-if="!vm.member.ubi"><span class="label label-danger">keine Angabe</span></td><td ng-if="vm.member.ubi">{{vm.member.ubi}}</td></tr><tr><td><b>SRC</b></td><td ng-if="!vm.member.src"><span class="label label-danger">keine Angabe</span></td><td ng-if="vm.member.src">{{vm.member.src}}</td></tr><tr><td><b>LRC</b></td><td ng-if="!vm.member.lrc"><span class="label label-danger">keine Angabe</span></td><td ng-if="vm.member.lrc">{{vm.member.lrc}}</td></tr><tr><td><b>FKN</b></td><td ng-if="!vm.member.fkn"><span class="label label-danger">keine Angabe</span></td><td ng-if="vm.member.fkn">{{vm.member.fkn}}</td></tr><tr><td><b>ISAF</b></td><td ng-if="!vm.member.isaf"><span class="label label-danger">keine Angabe</span></td><td ng-if="vm.member.isaf">{{vm.member.isaf}}</td></tr><tr ng-show="vm.member.isaf"><td><b>ISAF Ausstellungsdatum</b></td><td ng-if="!vm.member.isafDate"><span class="label label-danger">keine Angabe</span></td><td ng-if="vm.member.isafDate">{{vm.member.isafDate | date:"mediumDate"}}</td></tr></table></div></div><div class="panel panel-default" ng-show="vm.member.memberStatus == \'probe\' || vm.member.memberStatus == \'voll\'"><div class="panel-heading"><h3 class="panel-title">Studentenstatus</h3></div><div class="panel-body"><table class="table no-border"><tr><td><b>Status</b></td><td><span class="label label-success" ng-show="vm.member.isStudent">Student</span> <span class="label label-danger" ng-show="!vm.member.isStudent">kein Student</span></td></tr><tr ng-show="vm.member.isStudent"><td><b>Immatrikulationsbescheinigung</b></td><td><div ng-if="vm.member.matriculationCertificate" class="help-block clearfix"><a ng-click="vm.openFile(vm.member.matriculationCertificateContentType, vm.member.matriculationCertificate)"><span class="glyphicon glyphicon-file" aria-hidden="true" style="font-size: 50px"></span><!--<i class="fa fa-file-pdf-o fa-3x" aria-hidden="true"></i>--></a><!--{{vm.member.matriculationCertificateContentType}}, {{vm.byteSize(vm.member.matriculationCertificate)}}--></div></td></tr><tr ng-show="vm.member.isStudent"><td><b>Datum</b></td><td>{{vm.member.matriculationDate | date:"mediumDate"}}</td></tr><tr ng-show="vm.member.isStudent && vm.currentAccount.login !== vm.member.user.login"><td align="right"><button type="submit" ng-click="vm.setVerified()" ng-hide="vm.member.isVerified" ng-disabled="vm.isVerifying" class="btn btn-success btn-sm"><span class="glyphicon glyphicon-ok-circle"></span> <span class="hidden-sm-down">Best\xE4tigen</span></button></td><td><button type="submit" ui-sref="member-management-detail.delete-certificate({id:vm.member.id})" class="btn btn-danger btn-sm"><span class="glyphicon glyphicon-remove-circle"></span> <span class="hidden-sm-down" data-translate="entity.action.delete"></span></button></td></tr><tr><td><b>Hochschule</b></td><td><span ng-if="vm.university">{{vm.member.university}}</span> <span ng-if="!vm.university" class="label label-danger">keine Hochschule</span></td></tr></table></div></div><div class="panel panel-default" ng-show="vm.member.memberStatus == \'probe\' || vm.member.memberStatus == \'voll\'"><div class="panel-heading"><h3 class="panel-title">Zahlungsmittel</h3></div><div class="panel-body"><table class="table no-border"><tr><td><b>Zahlungsart</b></td><td><span class="label label-info" ng-show="vm.member.isUsingSepa">Bankeinzug</span> <span class="label label-info" ng-show="!vm.member.isUsingSepa">\xDCberweisung</span></td></tr><tr ng-show="vm.member.isUsingSepa"><td><b>IBAN</b></td><td>{{vm.member.ibanHidden}}</td></tr><tr ng-show="vm.member.isUsingSepa"><td><b>BIC</b></td><td>{{vm.member.bicHidden}}</td></tr><tr ng-show="vm.member.isUsingSepa"><td><b>Kontoinhaber</b></td><td>{{vm.member.bankAccountHolder}}</td></tr></table></div></div><div class="panel panel-default"><div class="panel-heading"><h3 class="panel-title">Intern</h3></div><div class="panel-body"><table class="table no-border"><tr><td><b>Status</b></td><td><span class="label label-info" data-translate="{{\'askApp.EnumMemberStatus.\' + vm.member.memberStatus}}">Ja</span></td></tr><tr ng-show="vm.member.memberStatus == \'probe\' || vm.member.memberStatus == \'gast\' || vm.member.memberStatus == \'voll\'"><td><b>\xDCberpr\xFCft</b></td><td><span class="label label-success" ng-show="vm.member.isVerified">Ja</span> <span class="label label-danger" ng-show="!vm.member.isVerified">Nein</span></td></tr><tr ng-show="vm.member.memberStatus == \'probe\' || vm.member.memberStatus == \'gast\' || vm.member.memberStatus == \'voll\'"><td><b>Aktiv</b></td><td><span class="label label-success" ng-show="vm.member.user.activated">Ja</span> <span class="label label-danger" ng-show="!vm.member.user.activated">Nein</span></td></tr><tr><td><b>Registriert am</b></td><td><span>{{vm.member.user.createdDate | date: mediumdate}}</span></td></tr><tr ng-show="vm.member.fullMemberDate"><td><b>Vollwertig seit</b></td><td><span>{{vm.member.fullMemberDate | date: mediumdate}}</span></td></tr><tr ng-show="vm.member.expelledDate"><td><b>Verlassen am</b></td><td><span>{{vm.member.expelledDate | date: mediumdate}}</span></td></tr><tr ng-show="vm.member.lastLogin"><td><b>Letzter Login</b></td><td><span>{{vm.member.lastLogin | date: mediumdate}}</span></td></tr><tr ng-if="vm.member.memberStatus == \'probe\' || vm.member.memberStatus == \'voll\'"><td><b>Rundmail</b></td><td><span class="label label-success" ng-show="vm.member.wantsNewsletter">Ja</span> <span class="label label-danger" ng-show="!vm.member.wantsNewsletter">Nein</span></td></tr><tr ng-if="vm.member.memberStatus == \'probe\' || vm.member.memberStatus == \'voll\'"><td><b>Austrittswunsch</b></td><td><span class="label label-success" ng-show="vm.member.wantsMembershipTermination">Ja</span> <span class="label label-danger" ng-show="!vm.member.wantsMembershipTermination">Nein</span></td></tr></table></div></div></div></div></div><div class="row row-no-padding"><div class="col-md-12"><button type="submit" ng-click="vm.goBack()" class="btn btn-info"><span class="glyphicon glyphicon-arrow-left"></span>&nbsp;<span data-translate="entity.action.back"> Back</span></button> <button class="btn btn-primary" ui-sref="board.activities({select:vm.member.id})" ng-disabled="vm.member.memberStatus == \'gast\'"><span class="hidden-xs-down">Aktivit\xE4tenpunkte</span></button> <button class="btn btn-primary" ui-sref="board.booking({select:vm.member.id})"><span class="hidden-xs-down">Projektbuchungen</span></button> <button class="btn btn-primary" ui-sref="board.dinghy.booking({select:vm.member.id})"><span class="hidden-xs-down">Jollenbuchungen</span></button> <button class="btn btn-primary" ui-sref="board.membership-fee({select:vm.member.id})" ng-disabled="vm.member.memberStatus == \'gast\'"><span class="hidden-xs-down">Mitgliedsbeitr\xE4ge</span></button> <button class="btn btn-primary" ui-sref="board.dept({select:vm.member.id})" has-authority="ROLE_FINANCE"><span class="hidden-xs-down">Forderungen</span></button> <button class="btn btn-primary" ng-click="vm.exportContact()"><span class="hidden-xs-down">Export</span></button> <button class="btn btn-primary" ui-sref="member-management-detail.new-dept"><span class="glyphicon glyphicon-plus"></span> <span class="hidden-xs-down">Forderung</span></button> <button type="button" ui-sref="member-management-detail.edit({id:vm.member.id})" class="btn btn-primary" ng-disabled="vm.member.memberStatus == \'ausgeschlossen\' || vm.member.memberStatus == \'ausgetreten\' || vm.member.memberStatus == \'ex_gast\' || vm.currentAccount.login==vm.member.user.login"><span class="glyphicon glyphicon-pencil"></span> <span class="hidden-sm-down" data-translate="entity.action.edit">Edit</span></button> <button type="button" ui-sref="member-management.delete({id:vm.member.id})" class="btn btn-danger" ng-disabled="vm.currentAccount.login==vm.member.user.login"><span class="glyphicon glyphicon-remove-circle"></span></button></div></div></div>');
$templateCache.put('app/board/member-management/member-management-dialog.html','<!--\n  ~ Copyright (c) 2017 by Julian Feder, julian.feder@yahoo.de\n  ~\n  ~ This product includes software developed at\n  ~ The Apache Software Foundation (http://www.apache.org/).\n  --><form name="form" role="form" novalidate ng-submit="vm.save()" show-validation><div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()">&times;</button><h4 class="modal-title" id="myProfileLabel" data-translate="askApp.memberManagement.home.editLabel">Create or edit a Profile</h4></div><div class="modal-body"><jhi-alert-error></jhi-alert-error><!--------------------><!----- Firstname ----><!--------------------><div class="form-group"><label class="control-label" for="firstName" data-translate="settings.form.firstname">First Name</label><input type="text" class="form-control" id="firstName" name="firstName" placeholder="{{\'settings.form.firstname.placeholder\' | translate}}" ng-model="vm.member.user.firstName" ng-minlength="1" ng-maxlength="50" required maxlength="50"><div ng-show="form.firstName.$dirty && form.firstName.$invalid"><p class="help-block" ng-show="form.firstName.$error.required" data-translate="entity.validation.required">This field is required.</p><p class="help-block" ng-show="form.firstName.$error.minlength" data-translate="entity.validation.minlength" translate-value-min="1">Your mobile phone is required to be at least 1 characters.</p><p class="help-block" ng-show="form.firstName.$error.maxlength" data-translate="entity.validation.maxlength" translate-value-max="50">Your mobile phone cannot be longer than 50 characters.</p></div></div><!--------------------><!----- Nickname ----><!--------------------><div class="form-group"><label class="control-label" for="nickname" data-translate="askApp.profile.nickname.hint">Nickname</label><input type="text" class="form-control" id="nickname" name="nickname" placeholder="{{\'askApp.profile.nickname.placeholder\' | translate: {nickname: vm.member.user.firstName} }}" ng-model="vm.member.nickname"></div><!--------------------><!----- Lastname -----><!--------------------><div class="form-group"><label class="control-label" for="lastName" data-translate="settings.form.lastname">Last Name</label><input type="text" class="form-control" id="lastName" name="lastName" placeholder="{{\'settings.form.lastname.placeholder\' | translate}}" ng-model="vm.member.user.lastName" ng-minlength="1" ng-maxlength="50" required maxlength="50"><div ng-show="form.lastName.$dirty && form.lastName.$invalid"><p class="help-block" ng-show="form.lastName.$error.required" data-translate="entity.validation.required">This field is required.</p><p class="help-block" ng-show="form.lastName.$error.minlength" data-translate="entity.validation.minlength" translate-value-min="1">Your mobile phone is required to be at least 1 characters.</p><p class="help-block" ng-show="form.lastName.$error.maxlength" data-translate="entity.validation.maxlength" translate-value-max="50">Your mobile phone cannot be longer than 50 characters.</p></div></div><!--------------------><!----- Birthdate ----><!--------------------><div class="form-group"><label class="control-label" data-translate="askApp.profile.birthdate" for="field_birthdate">Birthdate</label><div class="input-group"><input id="field_birthdate" type="text" class="form-control" name="birthdate" uib-datepicker-popup="{{\'dd.MM.yyyy\'}}" ng-model="vm.member.birthdate" is-open="vm.datePickerOpenStatus.birthdate" placeholder="{{\'askApp.profile.birthdate.placeholder\' | translate}}" required> <span class="input-group-btn"><button type="button" class="btn btn-default" ng-click="vm.openCalendar(\'birthdate\')"><i class="glyphicon glyphicon-calendar"></i></button></span></div><div ng-show="form.birthdate.$dirty && form.birthdate.$invalid"><p class="help-block" ng-show="form.birthdate.$error.required" data-translate="entity.validation.required">This field is required.</p></div></div><!--------------------><!------- Phone ------><!--------------------><div class="form-group"><label class="control-label" data-translate="askApp.profile.phone" for="field_phone">Phone</label><input type="text" class="form-control" name="phone" id="field_phone" ng-model="vm.member.phone" required ng-minlength="5" ng-maxlength="16" maxlength="16" placeholder="{{\'askApp.profile.phone.placeholder\' | translate}}" pattern="^\\+[1-9]\\d{1,16}$"><div ng-show="form.phone.$dirty && form.phone.$invalid"><p class="help-block" ng-show="form.phone.$error.required" data-translate="entity.validation.required">This field is required.</p><p class="help-block" ng-show="form.phone.$error.pattern" data-translate="entity.validation.invalid">Your mobile phone does not math the E.164 format for phone numbers.</p><p class="help-block" ng-show="form.phone.$error.minlength" data-translate="entity.validation.minlength" translate-value-min="5">Your mobile phone is required to be at least 5 characters.</p><p class="help-block" ng-show="form.phone.$error.maxlength" data-translate="entity.validation.maxlength" translate-value-min="15">Your mobile phone cannot be longer than 15 characters.</p></div></div><!--------------------><!-------- Mail ------><!--------------------><div class="form-group"><label class="control-label" for="email" data-translate="global.form.email">Email</label><input type="email" class="form-control" id="email" name="email" placeholder="{{\'global.form.email.placeholder\' | translate}}" ng-model="vm.member.user.email" ng-minlength="5" ng-maxlength="50" required maxlength="50"><div ng-show="form.email.$dirty && form.email.$invalid"><p class="help-block" ng-show="form.email.$error.required" data-translate="entity.validation.required">This field is required.</p><p class="help-block" ng-show="form.email.$error.email" data-translate="entity.validation.invalid">Your mobile phone does not math the E.164 format for phone numbers.</p><p class="help-block" ng-show="form.email.$error.minlength" data-translate="entity.validation.minlength" translate-value-min="5">Your mobile phone is required to be at least 5 characters.</p><p class="help-block" ng-show="form.email.$error.maxlength" data-translate="entity.validation.maxlength" translate-value-min="50">Your mobile phone cannot be longer than 15 characters.</p></div></div><!-----------------------><!-- Wants Termination --><!-----------------------><div class="form-group" ng-if="vm.member.memberStatus == \'probe\' || vm.member.memberStatus == \'voll\'"><label class="control-label">Will austreten?</label><br><switch ng-model="vm.member.wantsMembershipTermination" class="green"></switch></div><!----------------------><!-- Wants Newsletter --><!----------------------><div class="form-group" ng-if="vm.member.memberStatus == \'probe\' || vm.member.memberStatus == \'voll\'" ng-show="vm.member.wantsMembershipTermination"><label class="control-label">Bekommt Rundmail?</label><br><switch ng-model="vm.member.wantsNewsletter" class="green"></switch></div></div><div class="modal-footer"><button type="button" class="btn btn-default" data-dismiss="modal" ng-click="vm.clear()"><span class="glyphicon glyphicon-ban-circle"></span>&nbsp;<span data-translate="entity.action.cancel">Cancel</span></button> <button type="submit" ng-disabled="editForm.$invalid || vm.isSaving" class="btn btn-primary"><span class="glyphicon glyphicon-save"></span>&nbsp;<span data-translate="entity.action.save">Save</span></button></div></form>');
$templateCache.put('app/board/member-management/member-management-edit-member-status.html','<!--\n  ~ Copyright (c) 2017 by Julian Feder, julian.feder@yahoo.de\n  ~\n  ~ This product includes software developed at\n  ~ The Apache Software Foundation (http://www.apache.org/).\n  --><div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()">&times;</button><h4 class="modal-title" id="myProfileLabel" data-translate="askApp.memberManagement.home.editIsMember">Create or edit a Profile</h4></div><div class="modal-body"><jhi-alert></jhi-alert><div class="alert alert-warning" role="alert"><b>Achtung!</b> M\xF6chtest du den Mitgliedschaftsstatus von <b>{{vm.member.user.firstName}} {{vm.member.user.lastName}}</b> wirklich \xE4ndern?</div><div class="alert alert-warning" role="alert" ng-show="vm.member.memberStatus == \'probe\' || vm.member.memberStatus == \'voll\'"><b>Achtung!</b> Wenn der Status auf <b>Ausgetreten</b> bzw. <b>Ausgeschlossen</b> ge\xE4ndert wird, werden offene Mitgliedsbeitr\xE4ge samt Forderung gel\xF6scht.</div><div class="alert alert-warning" role="alert" ng-show="vm.member.memberStatus == \'ausgeschlossen\' || vm.member.memberStatus == \'ausgetreten\'"><b>Achtung!</b> Das Mitglied erh\xE4lt eine Zahlungsaufforderung f\xFCr den Mitgliedsbeitrag per E-Mail.</div><div class="alert alert-warning" role="alert" ng-show="vm.member.memberStatus == \'gast\'"><b>Achtung!</b> Diese Funktion muss vom Mitglied selbst durchgef\xFChrt werden (Studentenstatus & SEPA).</div><span ng-show="vm.member.memberStatus == \'ausgeschlossen\' || vm.member.memberStatus == \'ausgetreten\'"><label class="control-label" data-translate="askApp.memberManagement.button.student">Student</label><br><switch ng-model="vm.member.isStudent" class="green"></switch></span></div><div class="modal-footer"><button type="button" class="btn btn-default" data-dismiss="modal" ng-click="vm.clear()"><span class="glyphicon glyphicon-ban-circle"></span>&nbsp;<span data-translate="entity.action.cancel">Cancel</span></button> <button ng-show="vm.member.memberStatus == \'probe\' || vm.member.memberStatus == \'voll\'" type="submit" ng-disabled="vm.isSaving" class="btn btn-danger" ng-click="vm.setMember(\'ausgeschlossen\')"><span data-translate="askApp.memberManagement.button.expell">Ausschlie\xDFen</span></button> <button ng-show="vm.member.memberStatus == \'probe\' || vm.member.memberStatus == \'voll\'" type="submit" ng-disabled="vm.isSaving" class="btn btn-danger" ng-click="vm.setMember(\'ausgetreten\')"><span data-translate="askApp.memberManagement.button.leaved">Austreten</span></button> <button ng-show="vm.member.memberStatus == \'ausgeschlossen\' || vm.member.memberStatus == \'ausgetreten\'" type="submit" ng-disabled="vm.isSaving" class="btn btn-success" ng-click="vm.setMember(\'probe\')"><span data-translate="askApp.memberManagement.button.reactivate">Wiederherstellen</span></button> <button ng-show="vm.member.memberStatus == \'probe\'" type="submit" ng-disabled="vm.isSaving" class="btn btn-success" ng-click="vm.setMember(\'voll\')"><span data-translate="askApp.memberManagement.button.full">Vollwertig</span></button><!--<button ng-show="vm.member.memberStatus == \'gast\'" type="submit" ng-disabled="vm.isSaving" class="btn btn-success" ng-click="vm.setMember(\'probe\')">\n        <span data-translate="askApp.memberManagement.button.reactivate">Vollwertig</span>\n    </button>--></div>');
$templateCache.put('app/board/member-management/member-management-send-mail.html','<!--\n  ~ Copyright (c) 2017 by Julian Feder, julian.feder@yahoo.de\n  ~\n  ~ This product includes software developed at\n  ~ The Apache Software Foundation (http://www.apache.org/).\n  --><form name="editForm" role="form" novalidate show-validation><div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()">&times;</button><h4 class="modal-title" id="myProfileLabel" data-translate="askApp.memberManagement.mail.title">Create or edit a Profile</h4></div><div class="modal-body"><jhi-alert></jhi-alert><div class="form-group" ng-init="vm.sendMail.selection = \'alle\'"><label class="control-label" data-translate="askApp.memberManagement.mail.selection">Description</label><div class="btn-group btn-group-justified"><label class="btn btn-default" ng-model="vm.sendMail.selection" uib-btn-radio="\'alle\'"><span data-translate="askApp.memberManagement.mail.alle">normal</span></label><label class="btn btn-default" ng-model="vm.sendMail.selection" uib-btn-radio="\'voll\'"><span data-translate="askApp.memberManagement.mail.voll">guest</span></label><label class="btn btn-default" ng-model="vm.sendMail.selection" uib-btn-radio="\'probe\'"><span data-translate="askApp.memberManagement.mail.probe">guest</span></label><label class="btn btn-default" ng-model="vm.sendMail.selection" uib-btn-radio="\'student\'"><span data-translate="askApp.memberManagement.mail.student">guest</span></label><label class="btn btn-default" ng-model="vm.sendMail.selection" uib-btn-radio="\'gast\'"><span data-translate="askApp.memberManagement.mail.gast">guest</span></label><label class="btn btn-default" ng-model="vm.sendMail.selection" uib-btn-radio="\'manager\'"><span data-translate="askApp.memberManagement.mail.manager">manager</span></label></div></div><div class="form-group"><label class="control-label" data-translate="askApp.memberManagement.mail.subject">Description</label><input type="text" class="form-control" ng-model="vm.sendMail.subject" name="subject" required><div ng-show="editForm.subject.$invalid"><p class="help-block" ng-show="editForm.subject.$error.required" data-translate="entity.validation.required">This field is required.</p></div></div><div class="form-group"><label class="control-label" data-translate="askApp.memberManagement.mail.startId">Start Id</label><input type="number" class="form-control" ng-model="vm.sendMail.startId" name="startId" required><div ng-show="editForm.startId.$invalid"><p class="help-block" ng-show="editForm.startId.$error.required" data-translate="entity.validation.required">This field is required.</p></div></div><div class="alert alert-info" role="alert">Die <b>Mail</b> wird <b>individuell</b> an alle Adressaten verschickt. Eine <b>Begr&uuml;&szlig;ung</b> ist daher <b>nicht n\xF6tig.</b><br>Au&szlig;erdem kannst Du die <b>E-Mail</b> in der <b>Du-Form</b> verfassen.<br>Du kannst &uuml;ber den Button <b>"Test E-Mail"</b> auch eine <b>Probemail an Dich</b> selbst senden.</div><div class="form-group"><label class="control-label" data-translate="askApp.memberManagement.mail.text">Description</label><summernote config="vm.options" ng-model="vm.sendMail.text" id="field_description"></summernote></div></div><div class="modal-footer"><button type="button" class="btn btn-default" data-dismiss="modal" ng-click="vm.clear()"><span class="glyphicon glyphicon-ban-circle"></span>&nbsp;<span data-translate="entity.action.cancel">Cancel</span></button> <button type="submit" ng-disabled="vm.isSaving || editForm.$invalid" class="btn btn-danger" ng-click="vm.action(\'send\')"><span data-translate="askApp.memberManagement.mail.sendMail">Ausschlie\xDFen</span></button> <button type="submit" ng-disabled="vm.isSaving || editForm.$invalid" class="btn btn-info" ng-click="vm.action(\'test\')"><span data-translate="askApp.memberManagement.mail.testMail">Ausschlie\xDFen</span></button></div></form>');
$templateCache.put('app/board/member-management/member-management.html','<!--\n  ~ Copyright (c) 2017 by Julian Feder, julian.feder@yahoo.de\n  ~\n  ~ This product includes software developed at\n  ~ The Apache Software Foundation (http://www.apache.org/).\n  --><div><div class="row row-no-padding"><div class="col-xs-12"><div class="panel panel-default"><div class="panel-heading"><h3 class="panel-title" data-translate="askApp.memberManagement.home.title"></h3></div><div class="panel-body"><jhi-alert></jhi-alert><div class="container-fluid"><div class="row"><div class="col-xs-12 col-md-8 no-padding-left"><div class="btn-group"><button type="submit" ng-click="vm.currentSearch == null && vm.setSelect(\'voll\')" class="btn btn-default btn-md" ng-class="{active: vm.select == \'voll\' && vm.currentSearch == null}" ng-disabled="vm.currentSearch != null"><span class="hidden-sm-down">Mitglieder</span></button> <button type="submit" ng-click="vm.currentSearch == null && vm.setSelect(\'probe\')" class="btn btn-default btn-md" ng-class="{active: vm.select == \'probe\' && vm.currentSearch == null}" ng-disabled="vm.currentSearch != null"><span class="hidden-sm-down">Probe</span></button> <button type="submit" ng-click="vm.currentSearch == null && vm.setSelect(\'gast\')" class="btn btn-default btn-md" ng-class="{active: vm.select == \'gast\' && vm.currentSearch == null}" ng-disabled="vm.currentSearch != null"><span class="hidden-sm-down">G\xE4ste</span></button> <button type="submit" ng-click="vm.currentSearch == null && vm.setSelect(\'ausgeschlossen\')" class="btn btn-default btn-md" ng-class="{active: vm.select == \'ausgeschlossen\' && vm.currentSearch == null}" ng-disabled="vm.currentSearch != null"><span class="hidden-sm-down">Ausgeschlossen</span></button> <button type="submit" ng-click="vm.currentSearch == null && vm.setSelect(\'ausgetreten\')" class="btn btn-default btn-md" ng-class="{active: vm.select == \'ausgetreten\' && vm.currentSearch == null}" ng-disabled="vm.currentSearch != null"><span class="hidden-sm-down">Ausgetreten</span></button> <button type="submit" ng-click="vm.currentSearch == null && vm.setSelect(\'ex_gast\')" class="btn btn-default btn-md" ng-class="{active: vm.select == \'ex_gast\' && vm.currentSearch == null}" ng-disabled="vm.currentSearch != null"><span class="hidden-sm-down">Ex G\xE4ste</span></button></div></div><div class="col-xs-12 col-md-4 no-padding-right no-padding-left row-margin-top"><form name="searchForm" class="form-inline"><div class="input-group pull-right"><input type="text" class="form-control" ng-model="vm.searchQuery" id="searchQuery" placeholder="{{ \'askApp.memberManagement.home.search\' | translate }}"> <span class="input-group-btn width-min"><button class="btn btn-info" ng-click="vm.search(vm.searchQuery)"><span class="glyphicon glyphicon-search"></span></button> </span><span class="input-group-btn width-min" ng-if="vm.currentSearch"><button class="btn btn-info" ng-click="vm.clear()"><span class="glyphicon glyphicon-trash"></span></button></span></div></form></div></div><br><div class="row"><div class="col-xs-12 col-sm-3 no-padding-left"><button class="btn btn-primary" ui-sref="member-management.mail"><span class="glyphicon glyphicon-envelope"></span> <span class="hidden-xs-down" data-translate="askApp.memberManagement.mail.title">Send Mail</span></button></div><div class="col-xs-12 col-sm-9 no-padding-right no-padding-left row-margin-top-xs"><div class="btn-group pull-right"><button type="submit" ui-sref="member-management.exit({mode:\'guest\'})" class="btn btn-primary btn-md">Austritte G\xE4ste</button> <button type="submit" ui-sref="member-management.exit({mode:\'fee\'})" class="btn btn-primary btn-md">Austritte Beitr\xE4ge</button> <button type="submit" ui-sref="member-management.exit({mode:\'termination\'})" class="btn btn-primary btn-md">Austritte K\xFCndigung</button></div></div></div></div><br><div class="alert alert-info" role="alert" ng-show="vm.members.length == 0 && vm.currentSearch == null"><b>Keine Daten vorhanden!</b> W\xE4hle eine andere Kategorie.</div><div class="alert alert-info" role="alert" ng-show="vm.members.length == 0 && vm.currentSearch != null"><b>Keine Daten vorhanden!</b> \xC4ndere deine Suchanfrage.</div><div class="table-responsive" ng-show="vm.members.length > 0"><table class="jh-table table table-striped"><thead><tr jh-sort="vm.predicate" ascending="vm.reverse" callback="vm.transition()"><th jh-sort-by="user.id"><span data-translate="askApp.memberManagement.memberNumber">Mitgliedsnummer</span> <span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="isStudent"><span data-translate="askApp.memberManagement.student">Student</span> <span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="user.firstName"><span data-translate="askApp.memberManagement.firstName">Vorname</span> <span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="user.lastName"><span data-translate="askApp.memberManagement.lastName">Nachname</span> <span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="birthdate"><span data-translate="askApp.memberManagement.birthdate">Geburtsdatum</span> <span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="user.createdDate" ng-show="vm.selectIsMember"><span data-translate="askApp.memberManagement.createdDate">Mitglied seit</span> <span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="expelledDate" ng-show="!vm.selectIsMember"><span data-translate="askApp.memberManagement.expelledDate">Verlssaen am</span> <span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="memberStatus"><span data-translate="askApp.memberManagement.memberStatus">memberStatus</span><span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="isVerified" ng-show="vm.selectIsMember"><span data-translate="askApp.memberManagement.dataCheck">Datencheck</span><span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="user.activated" ng-show="vm.selectIsMember"><span data-translate="askApp.memberManagement.active">Active</span><span class="glyphicon glyphicon-sort"></span></th><th></th></tr></thead><tbody><tr ng-repeat="member in vm.members track by member.id"><td><span class="label label-info">{{member.user.login}}</span></td><td><span ng-show="member.isStudent" class="label label-info" data-translate="askApp.memberManagement.isFullMember">Ja</span> <span ng-show="!member.isStudent" class="label label-info" data-translate="askApp.memberManagement.isNotFullMember">Nein</span></td><td>{{member.user.firstName}} <span ng-if="member.nickname" class="glyphicon glyphicon-info-sign" aria-hidden="true" popover-trigger="mouseenter" uib-popover="{{member.nickname}}" style="cursor: pointer"></span></td><td>{{member.user.lastName}}</td><td>{{member.birthdate | date:\'mediumDate\'}}</td><td ng-show="vm.selectIsMember">{{member.user.createdDate | date:\'mediumDate\'}}</td><td ng-show="!vm.selectIsMember">{{member.expelledDate | date: mediumdate}}</td><td><button class="btn btn-info btn-xs" ui-sref="member-management.edit({id:member.id})" class="btn btn-primary" ng-disabled="vm.currentAccount.login==member.user.login" data-translate="{{\'askApp.EnumMemberStatus.\' + member.memberStatus}}"></button></td><td ng-show="vm.selectIsMember"><button class="btn btn-danger btn-xs" ng-click="vm.setVerified(member, true)" ng-show="!member.isVerified" ng-disabled="vm.currentAccount.login==member.user.login" data-translate="askApp.memberManagement.notVerified">Deactivated</button> <button class="btn btn-success btn-xs" ng-click="vm.setVerified(member, false)" ng-show="member.isVerified" ng-disabled="vm.currentAccount.login==member.user.login" data-translate="askApp.memberManagement.verified">Activated</button></td><td ng-show="vm.selectIsMember"><button class="btn btn-danger btn-xs" ng-click="vm.setActive(member, true)" ng-show="!member.user.activated" ng-disabled="vm.currentAccount.login==member.user.login" data-translate="askApp.memberManagement.isNotActive">Deactivated</button> <button class="btn btn-success btn-xs" ng-click="vm.setActive(member, false)" ng-show="member.user.activated" ng-disabled="vm.currentAccount.login==member.user.login" data-translate="askApp.memberManagement.isActive">Activated</button></td><td class="text-right"><div class="btn-group flex-btn-group-container"><button type="submit" ui-sref="member-management-detail({id:member.id})" class="btn btn-info btn-xs"><span class="glyphicon glyphicon-eye-open"></span></button></div></td></tr></tbody></table></div></div></div><div class="text-center" ng-show="vm.members.length > 0"><jhi-item-count page="vm.page" total="vm.queryCount" items-per-page="vm.itemsPerPage"></jhi-item-count><uib-pagination class="pagination-sm" total-items="vm.totalItems" ng-model="vm.page" ng-change="vm.transition()"></uib-pagination></div></div></div></div>');
$templateCache.put('app/board/membership-fee/membership-fee-delete-dialog.html','<form name="deleteForm" ng-submit="vm.confirmDelete(vm.membershipFee.id)"><div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()">&times;</button><h4 class="modal-title" data-translate="entity.delete.title">Confirm delete operation</h4></div><div class="modal-body"><jhi-alert-error></jhi-alert-error><p data-translate="askApp.membershipFee.delete.question" translate-values="{id: \'{{vm.membershipFee.id}}\'}">Are you sure you want to delete this Membership Fee?</p></div><div class="modal-footer"><button type="button" class="btn btn-default" data-dismiss="modal" ng-click="vm.clear()"><span class="glyphicon glyphicon-ban-circle"></span>&nbsp;<span data-translate="entity.action.cancel">Cancel</span></button> <button type="submit" ng-disabled="deleteForm.$invalid" class="btn btn-danger"><span class="glyphicon glyphicon-remove-circle"></span>&nbsp;<span data-translate="entity.action.delete">Delete</span></button></div></form>');
$templateCache.put('app/board/membership-fee/membership-fee-dialog.html','<!--\n  ~ Copyright (c) 2017 by Julian Feder, julian.feder@yahoo.de\n  ~\n  ~ This product includes software developed at\n  ~ The Apache Software Foundation (http://www.apache.org/).\n  --><form name="editForm" role="form" novalidate ng-submit="vm.save()" show-validation><div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()">&times;</button><h4 class="modal-title" id="myMembershipFeeLabel" data-translate="askApp.membershipFee.home.createOrEditLabel">Create or edit a Membership Fee</h4></div><div class="modal-body"><jhi-alert-error></jhi-alert-error><div class="form-group"><label class="control-label" data-translate="askApp.membershipFee.year" for="field_year">Year</label><div class="input-group"><input id="field_year" type="text" class="form-control" name="year" uib-datepicker-popup="yyyy" ng-model="vm.membershipFee.year" is-open="vm.datePickerOpenStatus.year" datepicker-mode="\'year\'" datepicker-options="{minMode: \'year\'}" required> <span class="input-group-btn"><button type="button" class="btn btn-default" ng-click="vm.openCalendar(\'year\')"><i class="glyphicon glyphicon-calendar"></i></button></span></div><div ng-show="editForm.year.$invalid"><p class="help-block" ng-show="editForm.year.$error.required" data-translate="entity.validation.required">This field is required.</p></div></div><div class="alert alert-warning"><b>Achtung!</b> Du bist dabei an jedes Mitglied eine Zahlungsaufforderung f\xFCr den Mitgliedsbeitrag zu schicken.</div></div><div class="modal-footer"><button type="button" class="btn btn-default" data-dismiss="modal" ng-click="vm.clear()"><span class="glyphicon glyphicon-ban-circle"></span>&nbsp;<span data-translate="entity.action.cancel">Cancel</span></button> <button type="submit" ng-disabled="editForm.$invalid || vm.isSaving" class="btn btn-primary"><span class="glyphicon glyphicon-save"></span>&nbsp;<span data-translate="askApp.membershipFee.einziehen">Save</span></button></div></form>');
$templateCache.put('app/board/membership-fee/membership-fees.html','<!--\n  ~ Copyright (c) 2017 by Julian Feder, julian.feder@yahoo.de\n  ~\n  ~ This product includes software developed at\n  ~ The Apache Software Foundation (http://www.apache.org/).\n  --><div><div class="row row-no-padding"><div class="col-xs-12"><div class="panel panel-default"><div class="panel-heading"><h3 class="panel-title" data-translate="askApp.membershipFee.home.title">Membership Fees</h3></div><div class="panel-body"><jhi-alert></jhi-alert><div class="container-fluid"><div class="row"><div class="col-xs-12 col-md-6 no-padding-left"><button class="btn btn-primary" ui-sref="board.membership-fee.new"><span class="glyphicon glyphicon-plus"></span> <span class="hidden-xs-down" data-translate="askApp.membershipFee.home.createLabel">Create new Membership Fee</span></button></div><div class="col-xs-6 col-md-3 no-padding-right no-padding-left row-margin-top"><input type="text" ng-model="vm.selected" placeholder="Suche Mitglied" uib-typeahead="profile as (profile.user.firstName + \' \' + profile.user.lastName + (profile.nickname ? (\' &quot;\' + profile.nickname + \'&quot;\') : (\'\'))) for profile in vm.getUser($viewValue)" typeahead-loading="loadingLocations" typeahead-no-results="noResults" typeahead-on-select="vm.selectUser($item, $model, $label, $event)" ng-disabled="vm.currentSearch != null" class="form-control" autocomplete="off"></div><div class="col-xs-6 col-md-3 no-padding-right row-margin-top"><form name="searchForm" class="form-inline"><div class="input-group pull-right"><input type="text" class="form-control" ng-model="vm.searchQuery" id="searchQuery" placeholder="{{ \'askApp.membershipFee.home.search\' | translate }}"> <span class="input-group-btn width-min"><button class="btn btn-info" ng-click="vm.search(vm.searchQuery)"><span class="glyphicon glyphicon-search"></span></button> </span><span class="input-group-btn width-min" ng-if="vm.currentSearch || vm.select"><button class="btn btn-info" ng-click="vm.clear()"><span class="glyphicon glyphicon-trash"></span></button></span></div></form></div></div></div><br><div class="alert alert-info" role="alert" ng-show="vm.membershipFees.length == 0"><b>Keine Daten vorhanden!</b> F\xFCr diese Auswahl existieren keine Mitgliedsbeitr\xE4ge.</div><div class="table-responsive" ng-show="vm.membershipFees.length > 0"><table class="jh-table table table-striped"><thead><tr jh-sort="vm.predicate" ascending="vm.reverse" callback="vm.transition()"><th jh-sort-by="year"><span data-translate="askApp.membershipFee.year">Year</span> <span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="profile.user.firstName"><span data-translate="askApp.membershipFee.profile">Profile</span> <span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="type"><span data-translate="askApp.membershipFee.type">Type</span> <span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="dept.sepa"><span>SEPA</span> <span class="glyphicon glyphicon-sort"></span></th><th><span data-translate="askApp.dept.reference">Reference</span></th><th jh-sort-by="price"><span data-translate="askApp.membershipFee.price">Price</span> <span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="dept.paymentStatus"><span>Bezahlstatus</span> <span class="glyphicon glyphicon-sort"></span></th><th></th></tr></thead><tbody><tr ng-repeat="membershipFee in vm.membershipFees track by membershipFee.id"><td>{{membershipFee.year | date:\'yyyy\'}}</td><td><a ui-sref="member-management-detail({id:membershipFee.profile.id})">{{membershipFee.profile.user.firstName}} {{membershipFee.profile.user.lastName}}</a> <span ng-if="membershipFee.profile.nickname" class="glyphicon glyphicon-info-sign" aria-hidden="true" popover-trigger="mouseenter" uib-popover="{{membershipFee.profile.nickname}}" style="cursor: pointer"></span></td><td><span class="label label-info" data-translate="{{\'askApp.EnumMembershipFeeType.\' + membershipFee.type}}">{{membershipFee.type}}</span></td><td><span ng-show="membershipFee.dept.sepa" class="label label-success" data-translate="askApp.memberManagement.isFullMember">Ja</span> <span ng-show="!membershipFee.dept.sepa" class="label label-danger" data-translate="askApp.memberManagement.isNotFullMember">Nein</span></td><td><span class="label label-info" popover-trigger="mouseenter" popover-title="Verwendungszweck" uib-popover-template="\'popover-partial-2.html\'" style="cursor: pointer">{{membershipFee.dept.reference | limitTo:5}}{{membershipFee.dept.reference.length > 5 ? \'...\' : \'\'}}</span></td><td>{{membershipFee.price | number:2}}\u20AC</td><td><span class="label label-danger" data-translate="{{\'askApp.EnumDeptStatus.\' + membershipFee.dept.paymentStatus}}" ng-show="membershipFee.dept.paymentStatus == \'pending\'">{{membershipFee.dept.paymentStatus}}</span> <span class="label label-success" data-translate="{{\'askApp.EnumDeptStatus.\' + membershipFee.dept.paymentStatus}}" ng-show="membershipFee.dept.paymentStatus == \'payed\'">{{membershipFee.dept.paymentStatus}}</span> <span class="label label-warning" data-translate="{{\'askApp.EnumDeptStatus.\' + membershipFee.dept.paymentStatus}}" ng-show="membershipFee.dept.paymentStatus == \'partial\'">{{membershipFee.dept.paymentStatus}}</span> <span class="label label-danger" data-translate="{{\'askApp.EnumDeptStatus.\' + membershipFee.dept.paymentStatus}}" ng-show="membershipFee.dept.paymentStatus == \'payedToMuch\'">{{membershipFee.dept.paymentStatus}}</span> <span class="glyphicon glyphicon-info-sign" aria-hidden="true" popover-trigger="mouseenter" popover-title="Forderung" uib-popover-template="\'popover-partial.html\'" style="cursor: pointer"></span> <a ui-sref="board.membership-fee.dept-edit({deptId:membershipFee.dept.id})" has-authority="ROLE_FINANCE"><span class="glyphicon glyphicon-pencil"></span></a></td><td class="text-right"><div class="btn-group flex-btn-group-container"><button type="submit" ui-sref="board.membership-fee.delete({id:membershipFee.id})" ng-disabled="membershipFee.deptsAvailable == true" class="btn btn-danger btn-xs"><span class="glyphicon glyphicon-remove-circle"></span></button></div></td></tr></tbody></table></div></div></div><div class="text-center" ng-show="vm.membershipFees.length > 0"><jhi-item-count page="vm.page" total="vm.queryCount" items-per-page="vm.itemsPerPage"></jhi-item-count><uib-pagination class="pagination-sm" total-items="vm.totalItems" items-per-page="vm.itemsPerPage" ng-model="vm.page" ng-change="vm.transition()"></uib-pagination></div></div></div></div><script type="text/ng-template" id="popover-partial.html"><div class="form-group">\n        <table>\n            <tr>\n                <td style="width: 150px;">Betrag:</td>\n                <td>{{membershipFee.dept.amount | number:2}}\u20AC</td>\n            </tr>\n            <tr>\n                <td>Soll:</td>\n                <td>{{membershipFee.dept.priceNet | number:2}}\u20AC</td>\n            </tr>\n            <!-- Adapt to DTO with Payments -->\n            <tr ng-repeat="payment in membershipFee.dept.payments">\n                <td>{{payment.date | date:\'dd.MM.yyyy\'}}:</td>\n                <td>{{payment.amount | number:2}}\u20AC</td>\n            </tr>\n            <tr>\n                <td>Ist:</td>\n                <td>{{membershipFee.dept.payed | number:2}}\u20AC</td>\n            </tr>\n            <tr>\n                <td colspan="2">\n                    <hr>\n                </td>\n            </tr>\n            <tr>\n                <td><span data-translate="askApp.dept.toPay">Saldo</span>:</td>\n                <td><b>{{membershipFee.dept.toPay | number:2}}\u20AC</b></td>\n            </tr>\n        </table>\n    </div></script><script type="text/ng-template" id="popover-partial-2.html"><div class="form-group">\n        <span class="label label-info">{{membershipFee.dept.reference}}</span>\n    </div></script>');
$templateCache.put('app/board/payment/payment-delete-dialog.html','<!--\n  ~ Copyright (c) 2017 by Julian Feder, julian.feder@yahoo.de\n  ~\n  ~ This product includes software developed at\n  ~ The Apache Software Foundation (http://www.apache.org/).\n  --><form name="deleteForm" ng-submit="vm.confirmDelete(vm.payment.id)"><div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()">&times;</button><h4 class="modal-title" data-translate="entity.delete.title">Confirm delete operation</h4></div><div class="modal-body"><jhi-alert-error></jhi-alert-error><p data-translate="askApp.payment.delete.question" translate-values="{id: \'{{vm.payment.id}}\'}">Are you sure you want to delete this Payment?</p></div><div class="modal-footer"><button type="button" class="btn btn-default" data-dismiss="modal" ng-click="vm.clear()"><span class="glyphicon glyphicon-ban-circle"></span>&nbsp;<span data-translate="entity.action.cancel">Cancel</span></button> <button type="submit" ng-disabled="deleteForm.$invalid" class="btn btn-danger"><span class="glyphicon glyphicon-remove-circle"></span>&nbsp;<span data-translate="entity.action.delete">Delete</span></button></div></form>');
$templateCache.put('app/board/payment/payment-dialog.html','<!--\n  ~ Copyright (c) 2017 by Julian Feder, julian.feder@yahoo.de\n  ~\n  ~ This product includes software developed at\n  ~ The Apache Software Foundation (http://www.apache.org/).\n  --><form name="editForm" role="form" novalidate ng-submit="vm.save()" show-validation><div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()">&times;</button><h4 class="modal-title" id="myPaymentLabel" data-translate="askApp.payment.home.editLabel" translate-value-name="{{vm.payment.name}}" translate-value-date="{{vm.payment.date | date:\'dd.MM.yyyy\'}}">Create or edit a Payment</h4></div><div class="modal-body"><jhi-alert-error></jhi-alert-error><div class="form-group"><label class="control-label" data-translate="askApp.payment.revenueID" for="field_revenueID">Revenue ID</label><input type="text" class="form-control" name="revenueID" id="field_revenueID" ng-model="vm.payment.id" required readonly="readonly"></div><div class="form-group" ng-if="vm.payment.parent !== null"><label class="control-label" data-translate="askApp.payment.parent">Parent</label><div><a ui-sref="board.payment.edit({id:vm.payment.parent.id})" ng-click="$close()"><span data-translate="askApp.payment.home.parentLabel" translate-value-name="{{vm.payment.parent.name}}" translate-value-date="{{vm.payment.parent.date | date:\'dd.MM.yyyy\'}}"></span>,&nbsp;<span data-translate="askApp.payment.amount"></span>:&nbsp;{{vm.payment.parent.amount | number: 2}}&nbsp;&euro;</a></div></div><div class="form-group"><label class="control-label" data-translate="askApp.payment.amount" for="field_amount">Amount</label><input type="number" class="form-control" name="amount" id="field_amount" ng-model="vm.payment.amount" ng-disabled="!vm.amountEditable"><!--min="-{{vm.maxAmount}}"\n                   max="{{vm.maxAmount}}"--><div ng-show="editForm.amount.$invalid"><p class="help-block" ng-show="editForm.amount.$error.required" data-translate="entity.validation.required">This field is required.</p><p class="help-block" ng-show="editForm.amount.$error.number" data-translate="entity.validation.number">This field should be a number.</p><p class="help-block" ng-show="editForm.amount.$error.max" data-translate="entity.validation.max" translate-value-max="{{vm.maxAmount}}">This field should be at least 0.</p></div></div><div class="form-group" ng-if="vm.payment.parent !== null"><label class="control-label" data-translate="askApp.payment.amountEditable" for="field_closed">Amount Editable</label><br><switch id="field_closed" ng-model="vm.amountEditable" class="green"></switch></div><div class="form-group"><label class="control-label" data-translate="askApp.payment.reference" for="field_reference">reference</label><input type="text" class="form-control" name="reference" id="field_reference" ng-model="vm.payment.reference" readonly="readonly"></div><div class="form-group"><label class="control-label" data-translate="askApp.payment.category" for="field_category">Category</label><select class="form-control" name="category" ng-model="vm.payment.category" id="field_category"><option value=""></option><option value="Teilnahmebeitrag" data-translate="askApp.EnumPaymentCategory.Teilnahmebeitrag">Teilnahmebeitrag</option><option value="Charter" data-translate="askApp.EnumPaymentCategory.Charter">Charter</option><option value="Meldegeld" data-translate="askApp.EnumPaymentCategory.Meldegeld">Meldegeld</option><option value="Pruefungsgebuehr" data-translate="askApp.EnumPaymentCategory.Pruefungsgebuehr">Pruefungsgebuehr</option><option value="Kautionversicherung" data-translate="askApp.EnumPaymentCategory.Kautionversicherung">Kautionversicherung</option><option value="Unterkunft" data-translate="askApp.EnumPaymentCategory.Unterkunft">Unterkunft</option><option value="Skipperhaftpflicht" data-translate="askApp.EnumPaymentCategory.Skipperhaftpflicht">Skipperhaftpflicht</option><option value="Uebungsleiterverguetung" data-translate="askApp.EnumPaymentCategory.Uebungsleiterverguetung">Uebungsleiterverguetung</option><option value="Bordkassenzuschuss" data-translate="askApp.EnumPaymentCategory.Bordkassenzuschuss">Bordkassenzuschuss</option><option value="Merch" data-translate="askApp.EnumPaymentCategory.Merch">Merch</option><option value="Verpflegung" data-translate="askApp.EnumPaymentCategory.Verpflegung">Verpflegung</option><option value="StadtmobilP" data-translate="askApp.EnumPaymentCategory.StadtmobilP">StadtmobilP</option><option value="StadtmobilTN" data-translate="askApp.EnumPaymentCategory.StadtmobilTN">StadtmobilTN</option><option value="Druckkosten" data-translate="askApp.EnumPaymentCategory.Druckkosten">Druckkosten</option><option value="Sonstiges" data-translate="askApp.EnumPaymentCategory.Sonstiges">Sonstiges</option></select></div><div class="form-group" ng-if="!vm.payment.dinghyEvent"><label data-translate="askApp.payment.project" for="field_project">Project</label><select class="form-control" id="field_project" name="project" ng-model="vm.payment.project" ng-options="project as (project.name + \' // \' + (project.fromDate | date:mediumDate) + \' - \' + (project.untilDate | date:mediumDate)) for project in vm.projects track by project.id" ng-disabled="vm.payment.dept || vm.relationClosed"><option value=""></option></select></div><div class="form-group" ng-if="!vm.payment.project"><label data-translate="askApp.payment.dinghyEvent" for="field_dinghyEvent">Dinghy Event</label><select class="form-control" id="field_dinghyEvent" name="dinghyEvent" ng-model="vm.payment.dinghyEvent" ng-options="dinghyEvent as (dinghyEvent.name + \' // \' + (dinghyEvent.fromDate | date:mediumDate) + \' - \' + (dinghyEvent.untilDate | date:mediumDate)) for dinghyEvent in vm.dinghyEvents track by dinghyEvent.id" ng-disabled="vm.payment.dept || vm.relationClosed"><option value=""></option></select></div><div class="form-group"><label class="control-label" data-translate="askApp.payment.comment" for="field_comment">Comment</label><input type="text" class="form-control" name="comment" id="field_comment" ng-model="vm.payment.comment"></div><div class="form-group"><label class="control-label" data-translate="askApp.payment.dept" for="field_dept">Dept</label><input type="text" ng-model="vm.payment.dept" placeholder="Suche Forderung" id="field_dept" uib-typeahead="dept as (dept.reference + \' // \' + dept.profile.user.firstName + \' \' + dept.profile.user.lastName + (dept.profile.nickname ? (\' &quot;\' + dept.profile.nickname + \'&quot;\') : (\'\')) + \' // \' + dept.relation + \' // \' + (dept.amount | number:2) + \'\u20AC\' + \' // \' + (dept.date | date:mediumDate)) for dept in vm.getDept($viewValue)" typeahead-loading="loadingLocations" typeahead-no-results="noResults" class="form-control" autocomplete="off"></div></div><div class="modal-footer"><button type="button" class="btn btn-default" data-dismiss="modal" ng-click="vm.clear()"><span class="glyphicon glyphicon-ban-circle"></span>&nbsp;<span data-translate="entity.action.cancel">Cancel</span></button> <button type="button" ng-disabled="vm.isSaving" ng-if="vm.payment.type !== \'KOPIE\'" class="btn btn-warning" ng-click="vm.copyPayment()"><span class="glyphicon glyphicon-copy"></span>&nbsp;Kopieren</button> <button type="submit" ng-disabled="editForm.$invalid || vm.isSaving" class="btn btn-primary"><span class="glyphicon glyphicon-save"></span>&nbsp;<span data-translate="entity.action.save">Save</span></button></div></form>');
$templateCache.put('app/board/payment/payments.html','<!--\n  ~ Copyright (c) 2017 by Julian Feder, julian.feder@yahoo.de\n  ~\n  ~ This product includes software developed at\n  ~ The Apache Software Foundation (http://www.apache.org/).\n  --><div><div class="row row-no-padding"><div class="col-xs-12"><div class="panel panel-default"><div class="panel-heading"><h3 class="panel-title" data-translate="askApp.payment.home.title">Payments</h3></div><div class="panel-body"><jhi-alert></jhi-alert><div class="container-fluid"><div class="row"><div class="col-xs-0 col-md-8 no-padding-left"><!----></div><div class="col-xs-12 col-md-4 no-padding-right no-padding-left"><form name="searchForm" class="form-inline"><div class="input-group pull-right"><input type="text" class="form-control" ng-model="vm.searchQuery" id="searchQuery" placeholder="{{ \'askApp.payment.home.search\' | translate }}"> <span class="input-group-btn width-min"><button class="btn btn-info" ng-click="vm.search(vm.searchQuery)"><span class="glyphicon glyphicon-search"></span></button> </span><span class="input-group-btn width-min" ng-if="vm.currentSearch"><button class="btn btn-info" ng-click="vm.clear()"><span class="glyphicon glyphicon-trash"></span></button></span></div></form></div></div></div><br><div class="alert alert-info" role="alert" ng-show="vm.payments.length == 0"><b>Keine Daten vorhanden!</b> \xC4ndere die Suchanfrage oder die Auswahlkategorie.</div><div class="table-responsive" ng-show="vm.payments.length != 0"><table class="jh-table table table-striped"><thead><tr jh-sort="vm.predicate" ascending="vm.reverse" callback="vm.transition()"><th jh-sort-by="date"><span data-translate="askApp.payment.date">Date</span> <span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="name"><span data-translate="askApp.payment.name">Name</span> <span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="amount"><span data-translate="askApp.payment.amount">Amount</span> <span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="type"><span data-translate="askApp.payment.type">Type</span> <span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="reference"><span data-translate="askApp.payment.reference">Reference</span> <span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="matchReference"><span data-translate="askApp.payment.matchReference">Match Reference</span> <span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="dept.id"><span data-translate="askApp.payment.dept">Dept</span> <span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="comment"><span data-translate="askApp.payment.comment">Comment</span> <span class="glyphicon glyphicon-sort"></span></th><th><span data-translate="askApp.payment.project">Project</span></th><th></th></tr></thead><tbody><tr ng-repeat="payment in vm.payments track by payment.id"><td>{{payment.date | date:\'mediumDate\'}}</td><td>{{payment.name | limitTo: 15}}{{payment.name.length > 15 ? \'...\' : \'\'}} <span class="glyphicon glyphicon-info-sign" aria-hidden="true" uib-popover="{{payment.name}}" popover-trigger="mouseenter" style="cursor: pointer" ng-show="payment.name.length > 15"></span></td><td ng-show="payment.amount < 0"><span class="label label-danger">{{payment.amount | number:2}}\u20AC</span></td><td ng-show="payment.amount > 0"><span class="label label-success">{{payment.amount | number:2}}\u20AC</span></td><td ng-show="payment.amount == 0"><span class="label label-warning">{{payment.amount | number:2}}\u20AC</span></td><td><span class="label label-info" data-translate="{{\'askApp.EnumPaymentType.\' + payment.type}}">{{payment.type}}</span></td><td style="text-align: center"><span style="cursor: pointer" class="glyphicon glyphicon-comment" aria-hidden="true" uib-popover="{{payment.reference}}" popover-trigger="mouseenter"></span></td><td style="text-align: center"><span style="cursor: pointer" class="glyphicon glyphicon-comment" aria-hidden="true" uib-popover="{{payment.matchReference}}" popover-trigger="mouseenter" ng-show="payment.matchReference"></span> <span class="glyphicon glyphicon-remove" aria-hidden="true" ng-show="!payment.matchReference"></span></td><td ng-show="payment.deptReference"><a ui-sref="board.payment.dept-edit({deptId:payment.deptId})">{{payment.deptReference | limitTo:15}}{{payment.deptReference.length > 15 ? \'...\' : \'\'}}</a> <span class="glyphicon glyphicon-info-sign" aria-hidden="true" uib-popover="{{payment.deptReference}}" popover-trigger="mouseenter" style="cursor: pointer" ng-show="payment.deptReference.length > 15"></span></td><td ng-show="!payment.deptReference" style="text-align: center"><span class="glyphicon glyphicon-remove" aria-hidden="true"></span></td><td style="text-align: center"><span style="cursor: pointer" class="glyphicon glyphicon-comment" aria-hidden="true" uib-popover="{{payment.comment}}" popover-trigger="mouseenter" ng-show="payment.comment"></span> <span class="glyphicon glyphicon-remove" aria-hidden="true" ng-show="!payment.comment"></span></td><td ng-show="payment.projectId !== null || payment.dinghyEventId !== null"><span ng-if="payment.projectId !== null"><a ui-sref="board.project-detail.home({id:payment.projectId})">{{payment.projectName | limitTo:15}}{{payment.projectName.length > 15 ? \'...\' : \'\'}}</a> <span class="glyphicon glyphicon-info-sign" aria-hidden="true" uib-popover="{{payment.projectName}}" popover-trigger="mouseenter" style="cursor: pointer" ng-show="payment.projectName.length > 15"></span> </span><span ng-if="payment.dinghyEventId !== null"><a ui-sref="board.dinghy.event.detail.overview({id:payment.dinghyEventId})">{{payment.dinghyEventName | limitTo:15}}{{payment.dinghyEventName.length > 15 ? \'...\' : \'\'}}</a> <span class="glyphicon glyphicon-info-sign" aria-hidden="true" uib-popover="{{payment.dinghyEventName}}" popover-trigger="mouseenter" style="cursor: pointer" ng-show="payment.dinghyEventName.length > 15"></span></span></td><td style="text-align: center" ng-show="payment.projectId === null && payment.dinghyEventId === null"><span class="glyphicon glyphicon-remove" aria-hidden="true"></span></td><td class="text-right"><div class="btn-group flex-btn-group-container"><button type="submit" ui-sref="board.payment.edit({id:payment.id})" class="btn btn-primary btn-xs"><span class="glyphicon glyphicon-pencil"></span></button> <button type="submit" ui-sref="board.payment.delete({id:payment.id})" ng-disabled="payment.type != \'KOPIE\'" class="btn btn-danger btn-xs"><span class="glyphicon glyphicon-remove-circle"></span></button></div></td></tr></tbody></table></div></div></div><div class="text-center" ng-show="vm.payments.length != 0"><jhi-item-count page="vm.page" total="vm.queryCount" items-per-page="vm.itemsPerPage"></jhi-item-count><uib-pagination class="pagination-sm" total-items="vm.totalItems" items-per-page="vm.itemsPerPage" ng-model="vm.page" ng-change="vm.transition()"></uib-pagination></div></div></div></div>');
$templateCache.put('app/board/project/project-delete-dialog.html','<!--\n  ~ Copyright (c) 2017 by Julian Feder, julian.feder@yahoo.de\n  ~\n  ~ This product includes software developed at\n  ~ The Apache Software Foundation (http://www.apache.org/).\n  --><form name="deleteForm" ng-submit="vm.confirmDelete(vm.project.id)"><div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()">&times;</button><h4 class="modal-title" data-translate="entity.delete.title">Confirm delete operation</h4></div><div class="modal-body"><jhi-alert-error></jhi-alert-error><p data-translate="askApp.project.delete.question" translate-values="{id: \'{{vm.project.id}}\'}">Are you sure you want to delete this Project?</p></div><div class="modal-footer"><button type="button" class="btn btn-default" data-dismiss="modal" ng-click="vm.clear()"><span class="glyphicon glyphicon-ban-circle"></span>&nbsp;<span data-translate="entity.action.cancel">Cancel</span></button> <button type="submit" ng-disabled="deleteForm.$invalid" class="btn btn-danger"><span class="glyphicon glyphicon-remove-circle"></span>&nbsp;<span data-translate="entity.action.delete">Delete</span></button></div></form>');
$templateCache.put('app/board/project/project-dialog.html','<!--\n  ~ Copyright (c) 2017 by Julian Feder, julian.feder@yahoo.de\n  ~\n  ~ This product includes software developed at\n  ~ The Apache Software Foundation (http://www.apache.org/).\n  --><form name="editForm" role="form" novalidate ng-submit="vm.save()" show-validation><div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()">&times;</button><h4 class="modal-title" id="myProjectLabelNew" data-translate="askApp.project.home.createLabel" ng-show="!vm.project.id && vm.newType === null">Create or edit a Project</h4><h4 class="modal-title" id="myProjectLabelNewBoat" data-translate="askApp.project.home.createBoatLabel" ng-show="!vm.project.id && vm.newType === \'boat\'">Create or edit a Project</h4><h4 class="modal-title" id="myProjectLabelNewInstructor" data-translate="askApp.project.home.createInstructorLabel" ng-show="!vm.project.id && vm.newType === \'instructor\'">Create or edit a Project</h4><h4 class="modal-title" id="myProjectLabelNewBoatInstructor" data-translate="askApp.project.home.createBoatInstructorLabel" ng-show="!vm.project.id && vm.newType === \'boatInstructor\'">Create or edit a Project</h4><h4 class="modal-title" id="myProjectLabelEdit" data-translate="askApp.project.home.editLabel" ng-show="vm.project.id">Create or edit a Project</h4></div><div class="modal-body"><jhi-alert-error></jhi-alert-error><div class="form-group"><label class="control-label" data-translate="askApp.project.type" for="field_type">Type</label><select class="form-control" name="type" ng-model="vm.project.type" id="field_type" required ng-disabled="vm.project.id"><option ng-if="vm.project.id || vm.newType === null || vm.newType === \'boat\' || vm.newType === \'boatInstructor\'" value="event" data-translate="askApp.EnumProjectType.event">event</option><option ng-if="vm.project.id || vm.newType === null || vm.newType === \'instructor\' || vm.newType === \'boatInstructor\'" value="course" data-translate="askApp.EnumProjectType.course">course</option><option ng-if="vm.project.id || vm.newType === null || vm.newType === \'instructor\' || vm.newType === \'boatInstructor\'" value="sbfPractical" data-translate="askApp.EnumProjectType.sbfPractical">sbfPractical</option><option ng-if="vm.project.id || vm.newType === null || vm.newType === \'instructor\' || vm.newType === \'boatInstructor\'" value="sksTrip" data-translate="askApp.EnumProjectType.sksTrip">sksTrip</option><option value="interest" data-translate="askApp.EnumProjectType.interest">interest</option><option ng-if="vm.project.id || vm.newType === null" value="merchandise" data-translate="askApp.EnumProjectType.merchandise">merchandise</option></select><div ng-show="editForm.type.$invalid"><p class="help-block" ng-show="editForm.type.$error.required" data-translate="entity.validation.required">This field is required.</p></div></div><div class="form-group" ng-show="vm.project.type == \'sksTrip\'"><label class="control-label" data-translate="askApp.project.sksPracticalLocation" for="field_sksPracticalLocation">Type</label><select class="form-control" name="sksPracticalLocation" ng-model="vm.project.sksPracticalLocation" id="field_sksPracticalLocation" ng-required="vm.project.type == \'sksTrip\'"><option value="elba" data-translate="askApp.EnumSksPracticalLocation.elba">elba</option><option value="mallorca" data-translate="askApp.EnumSksPracticalLocation.mallorca">mallorca</option><option value="portoroz" data-translate="askApp.EnumSksPracticalLocation.portoroz">portoroz</option><option value="izola" data-translate="askApp.EnumSksPracticalLocation.izola">izola</option><option value="suedfrankreich" data-translate="askApp.EnumSksPracticalLocation.suedfrankreich">suedfrankreich</option><option value="kroatienIstrien" data-translate="askApp.EnumSksPracticalLocation.kroatienIstrien">kroatienIstrien</option><option value="athen" data-translate="askApp.EnumSksPracticalLocation.athen">athen</option><option value="lavrio" data-translate="askApp.EnumSksPracticalLocation.lavrio">lavrio</option><option value="heiligenhafen" data-translate="askApp.EnumSksPracticalLocation.heiligenhafen">heiligenhafen</option><option value="gluecksburg" data-translate="askApp.EnumSksPracticalLocation.gluecksburg">gluecksburg</option><option value="kanaren" data-translate="askApp.EnumSksPracticalLocation.kanaren">kanaren</option></select><div ng-show="editForm.sksPracticalLocation.$invalid"><p class="help-block" ng-show="editForm.sksPracticalLocation.$error.required" data-translate="entity.validation.required">This field is required.</p></div></div><div class="form-group"><label class="control-label" data-translate="askApp.project.name" for="field_name">Name</label><input type="text" class="form-control" name="name" id="field_name" ng-model="vm.project.name" required ng-minlength="3" ng-maxlength="50"><div ng-show="editForm.name.$invalid"><p class="help-block" ng-show="editForm.name.$error.required" data-translate="entity.validation.required">This field is required.</p><p class="help-block" ng-show="editForm.name.$error.minlength" data-translate="entity.validation.minlength" translate-value-min="3">This field is required to be at least 3 characters.</p><p class="help-block" ng-show="editForm.name.$error.maxlength" data-translate="entity.validation.maxlength" translate-value-max="50">This field cannot be longer than 50 characters.</p></div></div><div class="form-group"><label class="control-label" data-translate="askApp.project.fromDate" for="field_fromDate">From Date</label><div class="input-group"><input id="field_fromDate" type="text" class="form-control" name="fromDate" uib-datepicker-popup="{{\'dd.MM.yyyy\'}}" ng-model="vm.project.fromDate" is-open="vm.datePickerOpenStatus.fromDate" ng-change="vm.selectFromDate()" required> <span class="input-group-btn"><button type="button" class="btn btn-default" ng-click="vm.openCalendar(\'fromDate\')"><i class="glyphicon glyphicon-calendar"></i></button></span></div><div ng-show="editForm.fromDate.$invalid"><p class="help-block" ng-show="editForm.fromDate.$error.required" data-translate="entity.validation.required">This field is required.</p></div></div><div class="form-group"><label class="control-label" data-translate="askApp.project.untilDate" for="field_untilDate">Until Date</label><div class="input-group"><input id="field_untilDate" type="text" class="form-control" name="untilDate" uib-datepicker-popup="{{\'dd.MM.yyyy\'}}" datepicker-options="options" ng-model="vm.project.untilDate" is-open="vm.datePickerOpenStatus.untilDate" required> <span class="input-group-btn"><button type="button" class="btn btn-default" ng-click="vm.openCalendar(\'untilDate\')"><i class="glyphicon glyphicon-calendar"></i></button></span></div><div ng-show="editForm.untilDate.$invalid"><p class="help-block" ng-show="editForm.untilDate.$error.required" data-translate="entity.validation.required">This field is required.</p></div></div><div class="form-group"><label class="control-label" data-translate="askApp.project.places" for="field_places">Places</label><input type="number" class="form-control" name="places" id="field_places" ng-model="vm.project.places" required><div ng-show="editForm.places.$invalid"><p class="help-block" ng-show="editForm.places.$error.required" data-translate="entity.validation.required">This field is required.</p><p class="help-block" ng-show="editForm.places.$error.number" data-translate="entity.validation.number">This field should be a number.</p></div></div><div class="form-group" ng-if="vm.project.type == \'sbfPractical\'"><label class="control-label" data-translate="askApp.project.sbfSlotsMax" for="field_sbfSlotsMax">Sbf Slot Count</label><input type="number" class="form-control" name="sbfSlotsMax" id="field_sbfSlotsMax" ng-model="vm.project.sbfSlotsMax" ng-required="vm.project.type == \'sbfPractical\'" min="0" max="10"><div ng-show="editForm.sbfSlotsMax.$invalid"><p class="help-block" ng-show="editForm.sbfSlotsMax.$error.required" data-translate="entity.validation.required">This field is required.</p><p class="help-block" ng-show="editForm.sbfSlotsMax.$error.number" data-translate="entity.validation.number">This field should be a number.</p><p class="help-block" ng-show="editForm.sbfSlotsMax.$error.min" data-translate="entity.validation.min" translate-value-min="0">This field should be at least 1.</p><p class="help-block" ng-show="editForm.sbfSlotsMax.$error.max" data-translate="entity.validation.max" translate-value-max="10">This field cannot be more than 30.</p></div></div><div class="form-group" ng-show="vm.project.type !== \'interest\'"><label class="control-label" data-translate="askApp.project.identifier" for="field_identifier">Identifier</label><input type="text" class="form-control" name="identifier" id="field_identifier" ng-model="vm.project.identifier" ng-pattern="/^[a-zA-Z0-9\\+\\-\\.\\(\\)]+$/" ng-change="vm.replaceYear()" ng-required="vm.project.type !== \'interest\'"><div ng-show="editForm.identifier.$invalid"><p class="help-block" ng-show="editForm.identifier.$error.required" data-translate="entity.validation.required">This field is required.</p><p class="help-block" ng-show="editForm.identifier.$error.pattern">Ung&uuml;ltige Zeichen. Erlaubt: Buchstaben, Zahlen, +, -, ., ( und )</p></div></div><div class="form-group" ng-show="vm.project.type !== \'interest\'"><label class="control-label" data-translate="askApp.project.normalPrice" for="field_normalPrice">Normal Price</label><input type="number" class="form-control" name="normalPrice" id="field_normalPrice" ng-model="vm.project.normalPrice" ng-required="vm.project.type !== \'interest\'"><div ng-show="editForm.normalPrice.$invalid"><p class="help-block" ng-show="editForm.normalPrice.$error.required" data-translate="entity.validation.required">This field is required.</p><p class="help-block" ng-show="editForm.normalPrice.$error.number" data-translate="entity.validation.number">This field should be a number.</p></div></div><div class="form-group" ng-show="vm.project.type !== \'interest\'"><label class="control-label" data-translate="askApp.project.studentPrice" for="field_studentPrice">Student Price</label><input type="number" class="form-control" name="studentPrice" id="field_studentPrice" ng-model="vm.project.studentPrice" min="0" max="{{vm.project.normalPrice}}" ng-required="vm.project.type !== \'interest\'"><div ng-show="editForm.studentPrice.$invalid"><p class="help-block" ng-show="editForm.studentPrice.$error.required" data-translate="entity.validation.required">This field is required.</p><p class="help-block" ng-show="editForm.studentPrice.$error.number" data-translate="entity.validation.number">This field should be a number.</p><p class="help-block" ng-show="editForm.studentPrice.$error.min" data-translate="entity.validation.min" translate-value-min="0">This field should be at least 0.</p><p class="help-block" ng-show="editForm.studentPrice.$error.max" data-translate="entity.validation.max" translate-value-max="{{vm.project.normalPrice}}">This field cannot be more than 200.</p></div></div><div class="form-group" ng-show="vm.project.type == \'sksTrip\'"><label class="control-label" data-translate="askApp.project.individualPrice" for="field_individualPrice">Individual Price</label><input type="number" class="form-control" name="individualPrice" id="field_individualPrice" ng-required="vm.project.type == \'sksTrip\'" ng-model="vm.project.individualPrice"><div ng-show="editForm.individualPrice.$invalid"><p class="help-block" ng-show="editForm.individualPrice.$error.required" data-translate="entity.validation.required">This field is required.</p><p class="help-block" ng-show="editForm.individualPrice.$error.number" data-translate="entity.validation.number">This field should be a number.</p></div></div><div class="form-group" ng-show="vm.project.type == \'event\'"><label class="control-label" data-translate="askApp.project.guest">Guest</label><br><switch id="field_guest" ng-model="vm.project.guest" class="green" ng-change="vm.resetGuestPrice()"></switch></div><div class="form-group" ng-show="vm.project.guest == true"><label class="control-label" data-translate="askApp.project.guestPrice" for="field_guestPrice">Guest Price</label><input type="number" class="form-control" name="guestPrice" id="field_guestPrice" min="{{vm.project.normalPrice}}" ng-required="vm.project.guest == true" ng-model="vm.project.guestPrice"><div ng-show="editForm.guestPrice.$invalid"><p class="help-block" ng-show="editForm.guestPrice.$error.required" data-translate="entity.validation.required">This field is required.</p><p class="help-block" ng-show="editForm.guestPrice.$error.number" data-translate="entity.validation.number">This field should be a number.</p><p class="help-block" ng-show="editForm.guestPrice.$error.min" data-translate="entity.validation.min" translate-value-min="{{vm.project.normalPrice}}">This field should be at least 0.</p></div></div><div class="form-group" ng-show="vm.project.id != null && vm.project.type !== \'interest\'"><div class="alert alert-warning"><b>Achtung!</b> Bei einer Preis\xE4nderung werden die Forderungsbetr\xE4ge aller bisherigen Anmeldungen (Angemeldet & Warteliste) ebenfalls angepasst und das Mitglied \xFCber die Preis\xE4nderung informiert. Zuvor manuell angepasste Forderungen werden nicht angepasst.</div></div><div class="form-group" ng-show="vm.project.type !== \'merchandise\' && vm.project.type !== \'interest\'"><label class="control-label" data-translate="askApp.project.prepayment" for="field_prepayment">Prepayment</label><input type="number" class="form-control" name="prepayment" id="field_prepayment" ng-model="vm.project.prepayment" min="1" max="{{vm.project.studentPrice}}" ng-disabled="vm.project.id"><div ng-show="editForm.prepayment.$invalid"><p class="help-block" ng-show="editForm.prepayment.$error.required" data-translate="entity.validation.required">This field is required.</p><p class="help-block" ng-show="editForm.prepayment.$error.number" data-translate="entity.validation.number">This field should be a number.</p><p class="help-block" ng-show="editForm.prepayment.$error.min" data-translate="entity.validation.min" translate-value-min="1">This field should be at least 0.</p><p class="help-block" ng-show="editForm.prepayment.$error.max" data-translate="entity.validation.max" translate-value-max="{{vm.project.studentPrice}}">This field cannot be more than 200.</p></div></div><div class="form-group" ng-show="vm.project.id == null && vm.project.type !== \'interest\'"><div class="alert alert-warning"><b>Achtung!</b> Die Anzahlung kann nach Projekterstellung nicht mehr ge\xE4ndert werden. Sie kann entweder leer gelassen werden oder muss positiv sein!<br>Faustregel: ~100\u20AC / Woche</div></div><div class="form-group"><label class="control-label" data-translate="askApp.project.dependingProject" for="field_depending_project">Type</label><input type="text" ng-model="vm.project.dependingProject" placeholder="Suche Projekt" uib-typeahead="project as (project.name) for project in vm.getProject($viewValue)" typeahead-loading="loadingLocations" typeahead-no-results="noResults" name="dependingProject" id="field_depending_project" class="form-control" autocomplete="off"></div><div class="form-group" has-authority="ROLE_BOARD"><label class="control-label" data-translate="askApp.project.profile" for="field_profile">Type</label><input type="text" ng-model="vm.project.profile" placeholder="Suche Mitglied" uib-typeahead="profile as (profile.user.firstName + \' \' + profile.user.lastName + (profile.nickname ? (\' &quot;\' + profile.nickname + \'&quot;\') : (\'\'))) for profile in vm.getUser($viewValue)" typeahead-loading="loadingLocations" typeahead-no-results="noResults" name="profile" id="field_profile" required class="form-control" autocomplete="off"><div ng-show="editForm.profile.$invalid"><p class="help-block" ng-show="editForm.profile.$error.required" data-translate="entity.validation.required">This field is required.</p></div></div><div class="form-group" has-authority="ROLE_BOARD"><label data-translate="askApp.project.authorizedMembers" for="field_manager">Authorized Members</label><!-- oldFilter: | filter: (vm.project.profile != null || \'\') && {id: \'!\' + vm.project.profile.id} --><select class="form-control" id="field_manager" multiple="multiple" size="10" name="manager" ng-model="vm.project.authorizedMembers" ng-options="profile as (profile.user.firstName + \' \' + profile.user.lastName + (profile.nickname ? (\' &quot;\' + profile.nickname + \'&quot;\') : (\'\'))) for profile in vm.allManagers track by profile.id"></select></div><div class="form-group" has-authority="ROLE_BOARD"><label data-translate="askApp.project.authorizedGroups" for="field_groups">Authorized Groups</label><select class="form-control" id="field_groups" multiple="multiple" size="10" name="groups" ng-model="vm.project.authorizedGroupsString" ng-options="authority as (\'global.authority.\' + authority) | translate for authority in vm.authorities"></select></div><div class="form-group"><label class="control-label" for="email" data-translate="askApp.project.email">Email</label><input type="email" class="form-control" id="email" name="email" placeholder="{{vm.project.profile.user.email}}" ng-model="vm.project.email" ng-minlength="5" ng-maxlength="50" maxlength="50"><div ng-show="editForm.email.$dirty && editForm.email.$invalid"><p class="help-block" ng-show="editForm.email.$error.email" data-translate="entity.validation.invalid">Your email is invalid.</p><p class="help-block" ng-show="editForm.email.$error.required" data-translate="entity.validation.required">This field is required.</p><p class="help-block" ng-show="editForm.email.$error.minlength" data-translate="entity.validation.minlength" translate-value-min="5">This field is required to be at least 3 characters.</p><p class="help-block" ng-show="editForm.email.$error.maxlength" data-translate="entity.validation.maxlength" translate-value-max="50">This field cannot be longer than 50 characters.</p></div></div><div class="form-group" ng-show="vm.project.type == \'sksTrip\'"><label class="control-label" data-translate="askApp.project.skipper" for="field_skipper">Type</label><input type="text" ng-model="vm.project.skipper" placeholder="Suche Mitglied" uib-typeahead="profile as (profile.user.firstName + \' \' + profile.user.lastName + (profile.nickname ? (\' &quot;\' + profile.nickname + \'&quot;\') : (\'\'))) for profile in vm.getUser($viewValue)" typeahead-loading="loadingLocations" typeahead-no-results="noResults" name="skipper" id="field_skipper" ng-required="vm.project.type == \'sksTrip\'" class="form-control" autocomplete="off"><div ng-show="editForm.skipper.$invalid"><p class="help-block" ng-show="editForm.skipper.$error.required" data-translate="entity.validation.required">This field is required.</p></div></div><div class="form-group" ngf-drop ngf-change="vm.setImage($file, vm.project)" ngf-pattern="\'image/*\'"><img id="outputImage"><label class="control-label" data-translate="askApp.project.image" for="field_image">Image</label><div><img data-ng-src="{{\'data:\' + vm.project.imageContentType + \';base64,\' + vm.project.image}}" style="max-height: 100px" ng-if="vm.project.image" alt="project image"><div ng-if="vm.project.image" class="help-block clearfix"><span class="pull-left">{{vm.project.imageContentType}}, {{vm.byteSize(vm.project.image)}}</span> <button type="button" ng-click="vm.project.image=null;vm.project.imageContentType=null;" class="btn btn-default btn-xs pull-right"><span class="glyphicon glyphicon-remove"></span></button></div><button type="button" ngf-select class="btn btn-default btn-block" ngf-change="vm.setImage($file, vm.project)" accept="image/*" data-translate="entity.action.addimage">Add image</button></div><input type="hidden" class="form-control" name="image" id="field_image" ng-model="vm.project.image"> <input type="hidden" class="form-control" name="imageContentType" id="field_imageContentType" ng-model="vm.project.imageContentType"></div><div class="form-group"><label class="control-label" data-translate="askApp.project.active">Active</label><br><switch id="field_active" ng-model="vm.project.active" class="green" disabled="!vm.isBoard && !(vm.wasActive && (vm.isInstructorProject || vm.isBoatProject))"></switch></div><div class="form-group"><label class="control-label" data-translate="askApp.project.visible">Visible</label><br><switch id="field_visible" ng-model="vm.project.visible" class="green" disabled="!vm.isBoard && !((vm.wasVisible || vm.wasActive)  && (vm.isInstructorProject || vm.isBoatProject))"></switch></div><div class="form-group" ng-if="vm.project.type == \'sbfPractical\'"><label class="control-label" data-translate="{{\'askApp.project.additionalBookableOptions.\' + vm.project.type}}" for="field_additionalBookable">Additional Bookable</label><br><switch id="field_additionalBookable" ng-model="vm.project.additionalBookable" class="green"></switch></div><div class="form-group" ng-show="vm.project.type !== \'merchandise\' && vm.project.type !== \'interest\'"><label class="control-label" data-translate="askApp.project.checkRegisterDate">checkRegisterDate</label><br><switch id="field_registerDate" ng-model="vm.project.checkRegisterDate" class="green"></switch></div><div class="form-group"><label class="control-label" data-translate="askApp.project.queue">queue</label><br><switch id="field_queue" ng-model="vm.project.queue" class="green"></switch></div><div class="form-group" ng-show="vm.project.type !== \'merchandise\' && vm.project.type !== \'interest\'"><label class="control-label" data-translate="askApp.project.activityPoints">activityPoints</label><br><switch id="field_activityPoints" ng-model="vm.project.activityPoints" class="green"></switch></div><div class="form-group" ng-show="vm.project.type == \'sksTrip\'"><label class="control-label" data-translate="askApp.project.booked">Booked</label><br><switch id="field_booked" ng-model="vm.project.booked" class="green"></switch></div><div class="form-group" has-authority="ROLE_BOARD"><label class="control-label" data-translate="askApp.project.closed">Closed</label><br><switch id="field_closed" ng-model="vm.project.closed" class="green"></switch></div><div class="form-group"><label class="control-label" data-translate="askApp.project.individualField" for="field_individualField">individualField</label><input type="text" class="form-control" name="name" id="field_individualField" ng-model="vm.project.individualField"></div><div class="form-group"><label class="control-label" data-translate="askApp.project.description">Description</label><summernote config="vm.options" ng-model="vm.project.description" id="field_description"></summernote></div><div class="form-group"><label class="control-label" data-translate="askApp.project.conditions">Conditions</label><summernote config="vm.options" ng-model="vm.project.conditions" id="field_conditions"></summernote></div><div class="form-group"><label class="control-label" data-translate="askApp.project.optional.weight">Weight</label><br><switch id="field_weight" ng-model="vm.project.weight" class="green"></switch></div><div class="form-group"><label class="control-label" data-translate="askApp.project.optional.clothingSize">Clothing Size</label><br><switch id="field_clothingSize" ng-model="vm.project.clothingSize" class="green"></switch></div><div class="form-group"><label class="control-label" data-translate="askApp.project.optional.shoeSize">Shoe Size</label><br><switch id="field_shoeSize" ng-model="vm.project.shoeSize" class="green"></switch></div><div class="form-group"><label class="control-label" data-translate="askApp.project.optional.nationality">Nationality</label><br><switch id="field_nationality" ng-model="vm.project.nationality" class="green"></switch></div><div class="form-group"><label class="control-label" data-translate="askApp.project.optional.birthplace">Birthplace</label><br><switch id="field_birthplace" ng-model="vm.project.birthplace" class="green"></switch></div><div class="form-group"><label class="control-label" data-translate="askApp.project.optional.countryOfBirth">Country Of Birth</label><br><switch id="field_countryOfBirth" ng-model="vm.project.countryOfBirth" class="green"></switch></div><div class="form-group"><label class="control-label" data-translate="askApp.project.optional.idNumber">Id Number</label><br><switch id="field_idNumber" ng-model="vm.project.idNumber" class="green"></switch></div></div><div class="modal-footer"><button type="button" class="btn btn-default" data-dismiss="modal" ng-click="vm.clear()"><span class="glyphicon glyphicon-ban-circle"></span>&nbsp;<span data-translate="entity.action.cancel">Cancel</span></button> <button type="submit" ng-disabled="editForm.$invalid || vm.isSaving" class="btn btn-primary"><span class="glyphicon glyphicon-save"></span>&nbsp;<span data-translate="entity.action.save">Save</span></button></div></form>');
$templateCache.put('app/board/project/projects.html','<!--\n  ~ Copyright (c) 2017 by Julian Feder, julian.feder@yahoo.de\n  ~\n  ~ This product includes software developed at\n  ~ The Apache Software Foundation (http://www.apache.org/).\n  --><div><div class="row row-no-padding"><div class="col-xs-12"><div class="panel panel-default"><div class="panel-heading"><h3 class="panel-title" data-translate="askApp.project.home.title">Projects</h3></div><div class="panel-body"><jhi-alert></jhi-alert><div class="container-fluid" ng-show="vm.showNavigation"><div class="row"><div class="col-xs-12 col-md-3 no-padding-left" ng-show="vm.allowArchive"><div class="btn-group"><button type="submit" ng-click="vm.currentSearch == null && vm.setArchive(\'false\')" class="btn btn-default btn-md" ng-class="{active: vm.archive == \'false\' && vm.currentSearch == null}" ng-disabled="vm.currentSearch != null || vm.select"><span class="hidden-sm-down">Aktive Projekte</span></button> <button type="submit" ng-click="vm.currentSearch == null && vm.setArchive(\'true\')" class="btn btn-default btn-md" ng-class="{active: vm.archive == \'true\' && vm.currentSearch == null}" ng-disabled="vm.currentSearch != null || vm.select"><span class="hidden-sm-down">Archiv</span></button></div></div><div class="col-xs-12 col-md-9 no-padding-left row-margin-top no-padding-right" ng-show="vm.showTypes"><div class="btn-group pull-right"><button type="submit" ng-click="vm.currentSearch == null && vm.setType(\'all\')" class="btn btn-default btn-md" ng-class="{active: vm.type == \'all\' && vm.currentSearch == null}" ng-disabled="vm.currentSearch != null || vm.select"><span class="hidden-sm-down">Alle</span></button> <button type="submit" ng-click="vm.currentSearch == null && vm.setType(\'event\')" class="btn btn-default btn-md" ng-class="{active: vm.type == \'event\' && vm.currentSearch == null}" ng-disabled="vm.currentSearch != null || vm.select"><span class="hidden-sm-down">Event</span></button> <button type="submit" ng-click="vm.currentSearch == null && vm.setType(\'interest\')" class="btn btn-default btn-md" ng-class="{active: vm.type == \'interest\' && vm.currentSearch == null}" ng-disabled="vm.currentSearch != null || vm.select"><span class="hidden-sm-down">Interessensbekundung</span></button> <button type="submit" ng-click="vm.currentSearch == null && vm.setType(\'course\')" class="btn btn-default btn-md" ng-class="{active: vm.type == \'course\' && vm.currentSearch == null}" ng-disabled="vm.currentSearch != null || vm.select"><span class="hidden-sm-down">Kurs</span></button> <button type="submit" ng-click="vm.currentSearch == null && vm.setType(\'sbfPractical\')" class="btn btn-default btn-md" ng-class="{active: vm.type == \'sbfPractical\' && vm.currentSearch == null}" ng-disabled="vm.currentSearch != null || vm.select"><span class="hidden-sm-down">SBF-See Praxis</span></button> <button type="submit" ng-click="vm.currentSearch == null && vm.setType(\'sksTrip\')" class="btn btn-default btn-md" ng-class="{active: vm.type == \'sksTrip\' && vm.currentSearch == null}" ng-disabled="vm.currentSearch != null || vm.select"><span class="hidden-sm-down">SKS T\xF6rn</span></button> <button type="submit" ng-click="vm.currentSearch == null && vm.setType(\'merchandise\')" class="btn btn-default btn-md" ng-class="{active: vm.type == \'merchandise\' && vm.currentSearch == null}" ng-disabled="vm.currentSearch != null || vm.select"><span class="hidden-sm-down">Merchandise</span></button></div></div></div><div class="row" has-authority="ROLE_BOARD"><br><div class="col-xs-12 col-md-8 no-padding-left"><button class="btn btn-primary" ui-sref="board.project.new"><span class="glyphicon glyphicon-plus"></span> <span class="hidden-xs-down" data-translate="askApp.project.home.createLabel">Create new Project</span></button></div><div class="col-xs-12 col-md-4 no-padding-right no-padding-left row-margin-top" ng-show="vm.isBoard"><form name="searchForm" class="form-inline"><div class="input-group pull-right"><input type="text" class="form-control" ng-model="vm.searchQuery" id="searchQuery" placeholder="{{ \'askApp.project.home.search\' | translate }}"> <span class="input-group-btn width-min"><button class="btn btn-info" ng-click="vm.search(vm.searchQuery)"><span class="glyphicon glyphicon-search"></span></button> </span><span class="input-group-btn width-min" ng-if="vm.currentSearch"><button class="btn btn-info" ng-click="vm.clear()"><span class="glyphicon glyphicon-trash"></span></button></span></div></form></div></div><div class="row" has-any-authority="ROLE_BOAT,ROLE_INSTRUCTOR,ROLE_BOARD"><br><div class="col-xs-12 col-md-3 no-padding-left" has-any-authority="ROLE_BOAT,ROLE_BOARD"><button class="btn btn-primary" ui-sref="board.project.new({type:\'boat\'})"><span class="glyphicon glyphicon-plus"></span> <span class="hidden-xs-down" data-translate="askApp.project.home.createBoatLabel">Create new Project Boat</span></button></div><div class="col-xs-12 col-md-3 no-padding-left" has-any-authority="ROLE_INSTRUCTOR,ROLE_BOARD"><button class="btn btn-primary" ui-sref="board.project.new({type: \'instructor\'})"><span class="glyphicon glyphicon-plus"></span> <span class="hidden-xs-down" data-translate="askApp.project.home.createInstructorLabel">Create new Project Instructor</span></button></div><div class="col-xs-12 col-md-3 no-padding-left" has-any-authority="ROLE_INSTRUCTOR,ROLE_BOARD"><div has-an-authority="ROLE_BOAT,ROLE_BOARD"><button class="btn btn-primary" ui-sref="board.project.new({type: \'boatInstructor\'})"><span class="glyphicon glyphicon-plus"></span> <span class="hidden-xs-down" data-translate="askApp.project.home.createBoatInstructorLabel">Create new Project Boat Instructor</span></button></div></div></div><br></div><div class="alert alert-info" role="alert" ng-show="vm.projects.length == 0"><b>Keine Daten vorhanden!</b> Es existieren keine Projekte in dieser Auswahl.</div><div class="table-responsive" ng-show="vm.projects.length > 0"><table class="jh-table table table-striped"><thead><tr jh-sort="vm.predicate" ascending="vm.reverse" callback="vm.transition()"><th jh-sort-by="fromDate"><span data-translate="askApp.project.fromDate">From Date</span> <span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="untilDate"><span data-translate="askApp.project.untilDate">Until Date</span> <span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="name"><span data-translate="askApp.project.name">Name</span> <span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="type"><span data-translate="askApp.project.type">Type</span> <span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="profile.user.firstName"><span data-translate="askApp.project.profile">Until Date</span> <span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="active"><span data-translate="askApp.project.active">Active</span> <span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="visible"><span data-translate="askApp.project.visible">Visible</span> <span class="glyphicon glyphicon-sort"></span></th><th><span data-translate="askApp.project.status"></span></th><th></th></tr></thead><tbody><tr ng-repeat="project in vm.projects track by project.id"><td>{{project.fromDate | date:\'mediumDate\'}}</td><td>{{project.untilDate | date:\'mediumDate\'}}</td><td><a ui-sref="board.project-detail.home({id:project.id})">{{project.name}}</a></td><td><span class="label label-info" data-translate="{{\'askApp.EnumProjectType.\' + project.type}}">{{project.type}}</span></td><td><span has-authority="ROLE_BOARD"><a ui-sref="member-management-detail({id:project.profile.id})">{{project.profile.user.firstName}} {{project.profile.user.lastName}}</a></span> <span has-authority="ROLE_MANAGER">{{project.profile.user.firstName}} {{project.profile.user.lastName}}</span> <span ng-if="project.profile.nickname" class="glyphicon glyphicon-info-sign" aria-hidden="true" popover-trigger="mouseenter" uib-popover="{{project.profile.nickname}}" style="cursor: pointer"></span></td><td><span class="label label-success" ng-show="project.active" ng-class="{transparencyReduction: project.closed}">Ja</span> <span class="label label-danger" ng-show="!project.active" ng-class="{transparencyReduction: project.closed}">Nein</span></td><td><span class="label label-success" ng-show="project.visible" ng-class="{transparencyReduction: project.closed}">Ja</span> <span class="label label-danger" ng-show="!project.visible" ng-class="{transparencyReduction: project.closed}">Nein</span></td><td><span class="label label-info">{{project.bookedPlaces.countAngemeldet + project.bookedPlaces.countWarteliste}} / {{project.places}}</span> <span class="glyphicon glyphicon-info-sign" aria-hidden="true" popover-trigger="mouseenter" popover-title="Buchungsstatus" uib-popover-template="\'popover-partial.html\'" style="cursor: pointer"></span></td><td class="text-right"><div class="btn-group flex-btn-group-container" has-authority="ROLE_BOARD"><button type="submit" ui-sref="board.project-detail.home({id:project.id})" class="btn btn-info btn-xs"><span class="glyphicon glyphicon-eye-open"></span></button> <button type="submit" ui-sref="board.project.delete({id:project.id})" class="btn btn-danger btn-xs" ng-disabled="project.hasRelations == true"><span class="glyphicon glyphicon-remove-circle"></span></button></div><div class="btn-group flex-btn-group-container" has-authority="ROLE_MANAGER"><button type="submit" ui-sref="board.project-detail.home({id:project.id})" class="btn btn-info btn-xs"><span class="glyphicon glyphicon-eye-open"></span></button></div></td></tr></tbody></table></div></div></div><div class="text-center" ng-show="vm.projects.length > 0"><jhi-item-count page="vm.page" total="vm.queryCount" items-per-page="vm.itemsPerPage"></jhi-item-count><uib-pagination class="pagination-sm" total-items="vm.totalItems" items-per-page="vm.itemsPerPage" ng-model="vm.page" ng-change="vm.transition()"></uib-pagination></div></div></div></div><script type="text/ng-template" id="popover-partial.html"><div>\n        <span class="label label-success" style="width: 100%;"><span data-translate="askApp.EnumBookingStatusType.angemeldet"></span>:&nbsp;{{project.bookedPlaces.countAngemeldet}}</span>\n        <br>\n        <span class="label label-danger"><span data-translate="askApp.EnumBookingStatusType.zurueckgetreten"></span>:&nbsp;{{project.bookedPlaces.countZurueckgetreten}}</span>\n        <br>\n        <span class="label label-danger"><span data-translate="askApp.EnumBookingStatusType.abgelehnt"></span>:&nbsp;{{project.bookedPlaces.countAbgelehnt}}</span>\n        <br>\n        <span class="label label-warning"><span data-translate="askApp.EnumBookingStatusType.warteliste"></span>:&nbsp;{{project.bookedPlaces.countWarteliste}}</span>\n        <br>\n        <span class="label label-info">Pl\xE4tze:&nbsp;{{project.places}}</span>\n        <br>\n        <span class="label label-info">G\xFCltige&nbsp;Anmeldungen:&nbsp;{{project.bookedPlaces.countAngemeldet + project.bookedPlaces.countWarteliste}}</span>\n        <br>\n        <span class="label label-info" ng-show="project.freePlaces >= 0">Freie&nbsp;Pl\xE4tze:&nbsp;{{project.freePlaces}}</span>\n        <span class="label label-info" ng-show="project.freePlaces < 0">&Uuml;berbuchte&nbsp;Pl\xE4tze:&nbsp;{{-project.freePlaces}}</span>\n    </div></script>');
$templateCache.put('app/board/skipper/skipper-dialog.html','<!--\n  ~ Copyright (c) 2021 by Felix Heim, felix-heim@web.de\n  ~\n  ~ This product includes software developed at\n  ~ The Apache Software Foundation (http://www.apache.org/).\n  --><form name="editForm" role="form" novalidate ng-submit="vm.save()" show-validation><div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()">&times;</button><h4 class="modal-title" id="skipperEditLabel"><span data-translate="askApp.skipper.home.createOrEditLabel" translate-value-first-name="{{vm.skipper.firstName}}" translate-value-last-name="{{vm.skipper.lastName}}">Edit a Skipper</span> <span ng-if="vm.skipper.memberStatus === \'gast\'" class="label label-info">[G]</span></h4></div><div class="modal-body"><jhi-alert-error></jhi-alert-error><!---------------------><!------ E-Mail -------><!---------------------><div class="form-group"><label class="control-label" data-translate="global.form.email">Email</label><p><a href="mailto:{{vm.skipper.email}}">{{vm.skipper.email}}</a></p></div><!---------------------><!------- Phone -------><!---------------------><div class="form-group"><label class="control-label" data-translate="askApp.profile.phone">Phone</label><p><a href="tel:{{vm.skipper.phone}}">{{vm.skipper.phone}}</a></p></div><!---------------------><!-- Skipper Levels ---><!---------------------><div ng-if="vm.isSkipperManager" class="form-group" ng-repeat="level in vm.skipperLevels"><label class="control-label" data-translate="{{\'askApp.EnumSkipperLevel.\' + level}}" for="{{\'field_\' + level}}">Level</label><br><switch ng-model="vm.skipperLevelsSelected[$index]" class="green small-switch" id="{{\'field_\' + level}}"></switch></div><div ng-if="!vm.isSkipperManager" class="form-group"><label class="control-label">Level</label><br><span ng-repeat="level in vm.skipperLevels"><span ng-if="vm.skipperLevelsSelected[$index]" class="glyphicon glyphicon-ok-sign" style="color: #5cb85c; font-size: 18px"></span> <span ng-if="!vm.skipperLevelsSelected[$index]" class="glyphicon glyphicon-remove-sign" style="color: #d9534f; font-size: 18px"></span> <span data-translate="{{\'askApp.EnumSkipperLevel.\' + level}}"></span><br ng-if="!$last"></span></div><!---------------------><!-- Comment Skipper --><!---------------------><div class="form-group"><label class="control-label" data-translate="askApp.profile.commentSkipper" for="field_commentSkipper">Text</label><summernote ng-if="vm.isSkipperManager" config="vm.options" ng-model="vm.skipper.commentSkipper" id="field_commentSkipper" class="form-control" name="commentSkipper"></summernote><div ng-if="!vm.isSkipperManager" class="panel panel-default" style="margin: 0"><div class="panel-body"><div class="text-justify" ng-bind-html="renderHtml(vm.skipper.commentSkipper)"></div></div></div></div></div><div class="modal-footer"><button type="button" class="btn btn-default" data-dismiss="modal" ng-click="vm.clear()"><span class="glyphicon glyphicon-ban-circle"></span>&nbsp;<span data-translate="entity.action.cancel">Cancel</span></button> <button type="submit" ng-disabled="editForm.$invalid || vm.isSaving" ng-if="vm.isSkipperManager" class="btn btn-primary"><span class="glyphicon glyphicon-save"></span>&nbsp;<span data-translate="entity.action.save">Save</span></button></div></form>');
$templateCache.put('app/board/skipper/skipper-send-mail.html','<!--\n  ~ Copyright (c) 2021 by Felix Heim, felix-heim@web.de\n  ~\n  ~ This product includes software developed at\n  ~ The Apache Software Foundation (http://www.apache.org/).\n  --><form name="editForm" role="form" novalidate show-validation><div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()">&times;</button><h4 class="modal-title" id="myProfileLabel" data-translate="askApp.skipper.mail.title">Send Mail</h4></div><div class="modal-body"><jhi-alert></jhi-alert><div class="form-group"><label class="control-label" data-translate="askApp.skipper.mail.filter">Filter</label><br>{{$parent.skipperObj.query}}</div><div class="form-group"><label class="control-label" data-translate="askApp.skipper.mail.filter_logic">Filter</label><br><span ng-repeat="token in $parent.skipperObj.query.replaceAll(\'(\', \'( \').replaceAll(\')\', \' )\').replaceAll(\'!\', \'! \').split(\' \') track by $index"><span ng-if="token !== \'&\' &&  token !== \'|\' &&  token !== \'!\'"><span ng-if="vm.allLevels.includes(token)" class="label label-info" data-translate="{{\'askApp.EnumSkipperLevel.\' + token + \'.short\'}}"></span> <span ng-if="!vm.allLevels.includes(token)" class="label" ng-class="(token === \'(\' || token === \')\') ? \'label-success\' : \'label-info\'">{{token}}</span> </span><span ng-if="token === \'&\'" class="label label-warning">&wedge;</span> <span ng-if="token === \'|\'" class="label label-warning">&vee;</span> <span ng-if="token === \'!\'" class="label label-danger">&not;</span> <span ng-if="!$last">&#32;</span></span></div><div class="form-group"><label class="control-label" data-translate="askApp.skipper.mail.subject" for="field_subject">Description</label><input type="text" class="form-control" ng-model="vm.sendMail.subject" name="subject" id="field_subject" required><div ng-show="editForm.subject.$invalid"><p class="help-block" ng-show="editForm.subject.$error.required" data-translate="entity.validation.required">This field is required.</p></div></div><div class="alert alert-info" role="alert">Die <b>Mail</b> wird <b>individuell</b> an alle Adressaten verschickt. Eine <b>Begr&uuml;&szlig;ung</b> ist daher <b>nicht n\xF6tig.</b><br>Au&szlig;erdem kannst Du die <b>E-Mail</b> in der <b>Du-Form</b> verfassen.<br>Du kannst &uuml;ber den Button <b>"Test E-Mail"</b> auch eine <b>Probemail an Dich</b> selbst senden.</div><div class="form-group"><label class="control-label" data-translate="askApp.skipper.mail.text">Description</label><summernote config="vm.options" ng-model="vm.sendMail.text" id="field_description"></summernote></div></div><div class="modal-footer"><button type="button" class="btn btn-default" data-dismiss="modal" ng-click="vm.clear()"><span class="glyphicon glyphicon-ban-circle"></span>&nbsp;<span data-translate="entity.action.cancel">Cancel</span></button> <button type="submit" ng-disabled="vm.isSaving || editForm.$invalid" class="btn btn-danger" ng-click="vm.action(\'send\')"><span data-translate="askApp.skipper.mail.sendMail">Ausschlie\xDFen</span></button> <button type="submit" ng-disabled="vm.isSaving || editForm.$invalid" class="btn btn-info" ng-click="vm.action(\'test\')"><span data-translate="askApp.skipper.mail.testMail">Ausschlie\xDFen</span></button></div></form>');
$templateCache.put('app/board/skipper/skippers.html','<!--\n  ~ Copyright (c) 2021 by Felix Heim, felix-heim@web.de\n  ~\n  ~ This product includes software developed at\n  ~ The Apache Software Foundation (http://www.apache.org/).\n  --><div><div class="row row-no-padding"><div class="col-xs-12"><div class="panel panel-default"><div class="panel-heading"><h3 class="panel-title" data-translate="askApp.skipper.home.title">Skipper</h3></div><div class="panel-body"><jhi-alert></jhi-alert><div style="margin-bottom: 10px"><button type="button" class="btn btn-default" ng-click="status.filterOpen = !status.filterOpen"><span class="glyphicon" ng-class="{\'glyphicon-chevron-down\': status.filterOpen, \'glyphicon-chevron-right\': !status.filterOpen}"></span> Filter</button> <button type="button" class="btn btn-default" ng-click="status.queryOpen = !status.queryOpen"><span class="glyphicon" ng-class="{\'glyphicon-chevron-down\': status.queryOpen, \'glyphicon-chevron-right\': !status.queryOpen}"></span> Abfrage</button> <button class="btn btn-primary pull-right" ui-sref="board.skipper.mail"><span class="glyphicon glyphicon-envelope"></span> <span class="hidden-xs-down" data-translate="askApp.skipper.mail.title">Send Mail</span></button><div uib-collapse="!status.filterOpen"><div class="panel panel-default" style="margin: 0"><div class="panel-body"><div class="row"><div class="col-xs-12 col-sm-4 col-md-4 col-lg-3"><div class="btn-group"><button type="submit" class="btn btn-default btn-md padding-half-sm" disabled="disabled"><span class="hidden-sm-down" style="font-weight: bold; color: black">Verkn\xFCpfung</span></button> <button type="submit" ng-click="vm.matchAny = false" class="btn btn-default btn-md padding-half-sm" ng-class="{active: vm.matchAny == false}"><span class="hidden-sm-down">Und</span></button> <button type="submit" ng-click="vm.matchAny = true" class="btn btn-default btn-md padding-half-sm" ng-class="{active: vm.matchAny == true}"><span class="hidden-sm-down">Oder</span></button></div></div><div class="col-xs-12 col-sm-4 col-md-5 col-lg-6 row-margin-top-xs no-padding-right"><div class="btn-group"><button type="submit" class="btn btn-default btn-md padding-reduced-sm" disabled="disabled"><span class="hidden-sm-down" style="font-weight: bold; color: black">Anzahl</span></button> <button type="submit" ng-click="vm.pageSize = 20" class="btn btn-default btn-md" ng-class="{active: vm.pageSize == 20}"><span class="hidden-sm-down">20</span></button> <button type="submit" ng-click="vm.pageSize = 50" class="btn btn-default btn-md" ng-class="{active: vm.pageSize == 50}"><span class="hidden-sm-down">50</span></button> <button type="submit" ng-click="vm.pageSize = vm.allItems" class="btn btn-default btn-md" ng-class="{active: vm.pageSize == vm.allItems}"><span class="hidden-sm-down">Alle</span></button></div></div><div class="col-xs-12 col-sm-4 col-md-3 no-padding-left row-margin-top-xs"><div class="btn-group pull-right"><button type="submit" ng-click="vm.transitionToLevels()" ng-disabled="!vm.anySelected()" class="btn btn-primary btn-md"><span class="glyphicon glyphicon-refresh"></span></button> <button type="submit" ng-click="vm.selectAll()" class="btn btn-primary btn-md"><span class="glyphicon glyphicon-globe"></span> <span class="hidden-xs-down">Alle</span></button> <button type="submit" ng-click="vm.selectNone()" class="btn btn-primary btn-md"><span class="glyphicon glyphicon-remove"></span> <span class="hidden-xs-down">Keine</span></button></div></div></div><div class="table-responsive row-margin-top-xs"><table class="jh-table table"><thead><tr><th ng-repeat="level in vm.skipperLevels"><span popover-trigger="mouseenter" uib-popover="{{\'askApp.EnumSkipperLevel.\' + level | translate}}" data-translate="{{\'askApp.EnumSkipperLevel.\' + level + \'.short\'}}"></span></th></tr></thead><tbody><tr><th ng-repeat="level in vm.skipperLevels"><switch ng-model="vm.skipperLevelsSelected[$index]" class="green small-switch"></switch></th></tr></tbody></table></div></div></div></div><button type="button" class="btn btn-default" ng-click="status.queryOpen = !status.queryOpen" ng-show="status.queryOpen && status.filterOpen"><span class="glyphicon" ng-class="{\'glyphicon-chevron-down\': status.queryOpen, \'glyphicon-chevron-right\': !status.queryOpen}"></span> Abfrage</button><div uib-collapse="!status.queryOpen"><div class="panel panel-default" style="margin: 0"><div class="panel-body"><div class="row"><div class="col-xs-12 col-sm-4 col-md-6 col-lg-6"><input type="text" class="form-control" name="query" ng-model="vm.query" ng-keydown="$event.keyCode === 13 && vm.transitionToQuery()"></div><div class="col-xs-12 col-sm-4 col-md-3 col-lg-3 row-margin-top-xs no-padding-right"><div class="btn-group"><button type="submit" class="btn btn-default btn-md padding-reduced-sm" disabled="disabled"><span class="hidden-sm-down" style="font-weight: bold; color: black">Anzahl</span></button> <button type="submit" ng-click="vm.pageSize = 20" class="btn btn-default btn-md" ng-class="{active: vm.pageSize == 20}"><span class="hidden-sm-down">20</span></button> <button type="submit" ng-click="vm.pageSize = 50" class="btn btn-default btn-md" ng-class="{active: vm.pageSize == 50}"><span class="hidden-sm-down">50</span></button> <button type="submit" ng-click="vm.pageSize = vm.allItems" class="btn btn-default btn-md" ng-class="{active: vm.pageSize == vm.allItems}"><span class="hidden-sm-down">Alle</span></button></div></div><div class="col-xs-12 col-sm-4 col-md-3 col-lg-3 no-padding-left row-margin-top-xs"><div class="btn-group pull-right"><button type="submit" ng-click="vm.transitionToQuery()" ng-disabled="!vm.anySelected()" class="btn btn-primary btn-md"><span class="glyphicon glyphicon-refresh"></span></button> <button type="submit" ng-click="vm.copyFilterToQuery()" ng-disabled="!vm.anySelected()" class="btn btn-primary btn-md"><span class="glyphicon glyphicon-arrow-down"></span> <span class="hidden-xs-down">Filter zu Abfrage</span></button></div></div><div class="col-xs-12"><span ng-if="vm.error"><span class="label label-danger">Fehler:</span> {{vm.error}} </span><span ng-if="!vm.error">Ausgef\xFChrte Abfrage<span ng-if="!vm.loadQuery"> (Filter)</span>: {{vm.resultingQuery}}<br>Abfrage als logische Aussage: <span ng-repeat="token in vm.resultingQuery.replaceAll(\'(\', \'( \').replaceAll(\')\', \' )\').replaceAll(\'!\', \'! \').split(\' \') track by $index"><span ng-if="token !== \'&\' &&  token !== \'|\' &&  token !== \'!\'"><span ng-if="vm.allLevels.includes(token)" class="label label-info" data-translate="{{\'askApp.EnumSkipperLevel.\' + token + \'.short\'}}"></span> <span ng-if="!vm.allLevels.includes(token)" class="label" ng-class="(token === \'(\' || token === \')\') ? \'label-success\' : \'label-info\'">{{token}}</span> </span><span ng-if="token === \'&\'" class="label label-warning">&wedge;</span> <span ng-if="token === \'|\'" class="label label-warning">&vee;</span> <span ng-if="token === \'!\'" class="label label-danger">&not;</span> <span ng-if="!$last">&#32;</span></span></span></div><div class="col-xs-12" style="margin-top: 10px"><button type="button" class="btn btn-default" ng-click="status.queryInfoOpen = !status.queryInfoOpen"><span class="glyphicon" ng-class="{\'glyphicon-chevron-down\': status.queryInfoOpen, \'glyphicon-chevron-right\': !status.queryInfoOpen}"></span> Abfragen Infos</button></div><div class="col-xs-12"><div uib-collapse="!status.queryInfoOpen"><div class="panel panel-default" style="margin: 0"><div class="panel-body"><div class="row"><div class="col-xs-12 col-sm-4 col-md-6 col-lg-6"><p>Unterst\xFCtzte Operatoren (<span class="label label-info">&</span> bindet st\xE4rker als <span class="label label-info">|</span>):<br><span ng-repeat="(operator, token_enum) in vm.supportedOperators"><span class="label label-info" popover-trigger="mouseenter" uib-popover="{{token_enum}}">{{operator}}</span><span ng-if="!$last">,&#32;</span></span></p><ul style="list-style-type: none; padding-left: 0">Dar\xFCber hinaus k&ouml;nnen folgende <b>Filter</b> genutzt werden (Gro\xDF- & Kleinschreibung nicht relevant):<li ng-repeat="(name, value) in vm.memberValues"><span style="float: left; width: 175px; font-weight: bold">{{name}}</span> <span class="glyphicon glyphicon-arrow-right"></span> {{value}}</li></ul><ul style="list-style-type: none; padding-left: 0">Folgende <b>Level</b> werden erkannt (Gro\xDF- & Kleinschreibung nicht relevant):<li><span style="float: left; width: 175px; font-weight: bold">all / alle</span> <span class="glyphicon glyphicon-arrow-right"></span> Alle Level (inklusive keiner Level)</li><li><span style="float: left; width: 175px; font-weight: bold">none / kein / keine</span> <span class="glyphicon glyphicon-arrow-right"></span> Keine Level</li><li ng-repeat="(name, level) in vm.skipperLevelValues"><span style="float: left; width: 175px; font-weight: bold">{{name}}</span> <span class="glyphicon glyphicon-arrow-right"></span> <span data-translate="{{\'askApp.EnumSkipperLevel.\' + level}}"></span></li></ul></div></div></div></div></div></div></div></div></div></div></div><div class="table-responsive"><table class="jh-table table table-striped"><thead><tr jh-sort="vm.predicate" ascending="vm.reverse" callback="vm.transition()"><th jh-sort-by="user.firstName"><span data-translate="askApp.memberManagement.firstName">Vorname</span> <span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="user.lastName"><span data-translate="askApp.memberManagement.lastName">Nachname</span> <span class="glyphicon glyphicon-sort"></span></th><th ng-repeat="level in vm.skipperLevels"><span popover-trigger="mouseenter" uib-popover="{{\'askApp.EnumSkipperLevel.\' + level | translate}}" data-translate="{{\'askApp.EnumSkipperLevel.\' + level + \'.short\'}}"></span></th><th></th></tr></thead><tbody><tr ng-repeat="skipper in vm.skippers track by skipper.id"><td><span ng-if="skipper.memberStatus === \'gast\'" class="label label-info" style="padding-left: 0.25em; padding-right: 0.25em">[G]</span> {{skipper.firstName}} <span ng-if="skipper.nickname" class="glyphicon glyphicon-info-sign" aria-hidden="true" popover-trigger="mouseenter" uib-popover="{{skipper.nickname}}" style="cursor: pointer"></span></td><td>{{skipper.lastName}}</td><td ng-repeat="level in vm.skipperLevels"><span ng-if="skipper.skipperLevels.includes(level)" class="label label-success" data-translate="askApp.skipper.hasLevel">Ja</span> <span ng-if="!skipper.skipperLevels.includes(level)" class="label label-danger" data-translate="askApp.skipper.hasNotLevel">Nein</span></td><td class="text-right"><div class="flex-btn-group-container" ng-class="{\'btn-group\': vm.isBoard}"><button type="submit" ui-sref="board.skipper.edit({id:skipper.id})" class="btn btn-primary btn-xs"><span class="glyphicon" ng-class="{\'glyphicon-pencil\': vm.isSkipperManager, \'glyphicon-eye-open\': !vm.isSkipperManager}"></span></button> <button type="submit" has-authority="ROLE_BOARD" ui-sref="member-management-detail({id:skipper.id})" class="btn btn-info btn-xs"><span class="glyphicon glyphicon-eye-open"></span></button> <button type="submit" ui-sref="board.skipper.edit({id:skipper.id})" class="btn btn-info btn-xs" ng-if="false" disabled="disabled"><span class="glyphicon glyphicon-boat"></span></button></div></td></tr></tbody></table></div></div></div><div class="text-center"><jhi-item-count page="vm.page" total="vm.queryCount" items-per-page="vm.itemsPerPage"></jhi-item-count><uib-pagination class="pagination-sm" total-items="vm.totalItems" items-per-page="vm.itemsPerPage" ng-model="vm.page" ng-change="vm.transition()"></uib-pagination></div></div></div></div>');
$templateCache.put('app/board/statistics/manager-project-overview.html','<!--\n  ~ Copyright (c) 2019 by Felix Heim, felix-heim@web.de\n  ~\n  ~ This product includes software developed at\n  ~ The Apache Software Foundation (http://www.apache.org/).\n  --><div class="panel panel-default"><div class="panel-heading"><h3 class="panel-title">Projekt\xFCbersicht</h3></div><div class="panel-body">Mitglied: <a ui-sref="member-management-detail({id:vm.profile.id})">{{vm.profile.user.firstName}} {{vm.profile.user.lastName}}</a><div class="table-responsive"><table class="jh-table table table-striped"><thead><tr><th><span data-translate="askApp.project.fromDate">From Date</span></th><th><span data-translate="askApp.project.untilDate">Until Date</span></th><th><span data-translate="askApp.project.name">Name</span></th><th><span data-translate="askApp.project.type">Type</span></th><th><span data-translate="askApp.project.active">Active</span></th><th><span data-translate="askApp.project.visible">Visible</span></th><th>Individuelle Freigabe</th><th></th></tr></thead><tbody><tr ng-repeat="project in vm.projects track by project.id"><td>{{project.fromDate | date:\'mediumDate\'}}</td><td>{{project.untilDate | date:\'mediumDate\'}}</td><td><a ui-sref="board.project-detail.home({id:project.id})">{{project.name}}</a></td><td><span class="label label-info" data-translate="{{\'askApp.EnumProjectType.\' + project.type}}">{{project.type}}</span></td><td><span class="label label-success" ng-show="project.active">Ja</span> <span class="label label-danger" ng-show="!project.active">Nein</span></td><td><span class="label label-success" ng-show="project.visible">Ja</span> <span class="label label-danger" ng-show="!project.visible">Nein</span></td><td><span class="label label-success" ng-show="project.individual">Ja</span> <span class="label label-danger" ng-show="!project.individual">Nein</span></td><td><div class="btn-group flex-btn-group-container"><button type="submit" ui-sref="board.project-detail.home({id:project.id})" class="btn btn-info btn-xs"><span class="glyphicon glyphicon-eye-open"></span></button></div></td></tr></tbody></table></div></div></div>');
$templateCache.put('app/board/statistics/statistics.html','<!--\n  ~ Copyright (c) 2019 by Felix Heim, felix-heim@web.de\n  ~\n  ~ This product includes software developed at\n  ~ The Apache Software Foundation (http://www.apache.org/).\n  --><div><jhi-alert></jhi-alert><div class="row row-no-padding"><div class="col-xs-12"><!-- <div class="panel panel-default">\n                <div class="panel-heading">\n                    <h3 class="panel-title" data-translate="askApp.memberManagement.statistics.title"></h3>\n                </div>\n                <div class="panel-body"> --><div class="panel panel-default"><div class="panel-heading"><h3 class="panel-title">Geburtstage</h3></div><div class="panel-body"><div class="row"><div class="col-xs-6"><h2>{{vm.calendarTitle}}</h2></div><div class="col-xs-6"><div class="btn-group" style="float: right"><button class="btn btn-primary" ng-click="vm.viewChanged()" mwl-date-modifier date="vm.birthdateDate" decrement="vm.birthdateView"><span class="glyphicon glyphicon-chevron-left"></span></button> <button class="btn btn-default" ng-click="vm.viewChanged()" mwl-date-modifier date="vm.birthdateDate" set-to-today>Heute</button> <button class="btn btn-primary" ng-click="vm.viewChanged()" mwl-date-modifier date="vm.birthdateDate" increment="vm.birthdateView"><span class="glyphicon glyphicon-chevron-right"></span></button></div></div></div><mwl-calendar view="vm.birthdateView" view-date="vm.birthdateDate" events="vm.birthdates" view-title="vm.calendarTitle" on-event-click="vm.birthdayClicked(calendarEvent)" on-view-change-click="false" on-event-times-changed="calendarEvent.startsAt = calendarNewEventStart; calendarEvent.endsAt = calendarNewEventEnd" cell-is-open="true"></mwl-calendar></div></div><!-- </div>\n            </div> --></div></div><div class="row row-no-padding"><div class="col-xs-12"><div class="panel panel-default"><div class="panel-heading"><h3 class="panel-title">Managerprojekte</h3></div><div class="panel-body"><div class="table-responsive"><table class="jh-table table table-striped"><thead><tr><th>Name</th><th>Freigegebene Projekte</th><th>Freigegebene Projekte (ohne Gruppenfreigabe)</th><th></th></tr></thead><tbody><tr ng-repeat="manager in vm.managerOverview"><td><a ui-sref="member-management-detail({id:manager.id})">{{manager.profile.user.firstName}} {{manager.profile.user.lastName}} <span ng-if="manager.profile.nickname">"{{manager.profile.nickname}}"</span></a> <a has-authority="ROLE_ADMIN" ui-sref="user-management.edit({login:manager.profile.user.login})">(admin)</a></td><td>{{manager.countProjects}}</td><td>{{manager.countIndividualProjects}}</td><td><div class="btn-group flex-btn-group-container"><button type="submit" ui-sref="manager-project-detail({id:manager.id})" class="btn btn-info btn-xs"><span class="glyphicon glyphicon-eye-open"></span></button></div></td></tr></tbody></table></div></div></div></div></div></div>');
$templateCache.put('app/components/login/login.html','<!--\n  ~ Copyright (c) 2017 by Julian Feder, julian.feder@yahoo.de\n  ~\n  ~ This product includes software developed at\n  ~ The Apache Software Foundation (http://www.apache.org/).\n  --><div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="vm.cancel()">&times;</button><h4 class="modal-title" data-translate="login.title">Sign in</h4></div><div class="modal-body"><div class="row"><div class="col-md-4 col-md-offset-2"><h1 data-translate="login.title">Sign in</h1></div><div class="col-md-8 col-md-offset-2"><div class="alert alert-danger" ng-show="vm.authenticationError" data-translate="login.messages.error.authentication"><strong>Failed to sign in!</strong> Please check your credentials and try again.</div></div><div class="col-md-8 col-md-offset-2"><form class="form" role="form" ng-submit="vm.login($event)"><div class="form-group"><label for="email" data-translate="global.form.login">Login</label><input type="text" class="form-control" id="email" placeholder="{{\'global.form.email.placeholder\' | translate}}" ng-model="vm.username"></div><div class="form-group"><label for="password" data-translate="login.form.password">Password</label><input type="password" class="form-control" id="password" placeholder="{{\'login.form.password.placeholder\' | translate}}" ng-model="vm.password"></div><div class="form-group"><label for="rememberMe"><input type="checkbox" id="rememberMe" ng-model="vm.rememberMe" checked="checked"> <span data-translate="login.form.rememberme">Remember me</span></label></div><button type="submit" class="btn btn-primary" data-translate="login.form.button">Sign in</button></form><p></p><div class="alert alert-warning"><a class="alert-link" href="" ng-click="vm.requestResetPassword()" data-translate="login.password.forgot">Did you forget your password?</a></div></div></div></div>');
$templateCache.put('app/components/util/multi-datepicker.tpl.html','<div class="uib-datepicker" ng-switch="datepickerMode" role="application" ng-keydown="keydown($event)"><uib-daypicker ng-switch-when="day" tabindex="0" template-url="app/components/util/multi-day.tpl.html"></uib-daypicker><uib-monthpicker ng-switch-when="month" tabindex="0"></uib-monthpicker><uib-yearpicker ng-switch-when="year" tabindex="0"></uib-yearpicker></div>');
$templateCache.put('app/components/util/multi-day.tpl.html','<table class="uib-daypicker" role="grid" aria-labelledby="{{::uniqueId}}-title" aria-activedescendant="{{activeDateId}}"><thead><tr><th><button type="button" class="btn btn-default btn-sm pull-left uib-left" ng-click="move(-1)" tabindex="-1"><i class="glyphicon glyphicon-chevron-left"></i></button></th><th colspan="{{::5 + showWeeks}}"><button id="{{::uniqueId}}-title" role="heading" aria-live="assertive" aria-atomic="true" type="button" class="btn btn-default btn-sm uib-title" ng-click="toggleMode()" ng-disabled="datepickerMode === maxMode" tabindex="-1"><strong>{{title}}</strong></button></th><th><button type="button" class="btn btn-default btn-sm pull-right uib-right" ng-click="move(1)" tabindex="-1"><i class="glyphicon glyphicon-chevron-right"></i></button></th></tr><tr><th ng-if="showWeeks" class="text-center"></th><th ng-repeat="label in ::labels track by $index" class="text-center"><small aria-label="{{::label.full}}">{{::label.abbr}}</small></th></tr></thead><tbody><tr class="uib-weeks" ng-repeat="row in rows track by $index"><td ng-if="showWeeks" class="text-center h6"><em>{{ weekNumbers[$index] }}</em></td><td ng-repeat="dt in row" class="uib-day text-center" role="gridcell" id="{{::dt.uid}}" ng-class="::dt.customClass"><button type="button" class="btn btn-default btn-sm" ng-class="{\'btn-info\': dt.selected, active:    isActive(dt)}" ng-click="select(dt.date)" ng-disabled="::dt.disabled" tabindex="-1"><span ng-class="::{\'text-muted\': dt.secondary, \'text-info\': dt.current}">{{::dt.label}}</span></button></td></tr></tbody></table>');
$templateCache.put('app/layouts/navbar/navbar.html','<!--\n  ~ Copyright (c) 2017 by Julian Feder, julian.feder@yahoo.de\n  ~\n  ~ This product includes software developed at\n  ~ The Apache Software Foundation (http://www.apache.org/).\n  --><nav class="navbar navbar-default" role="navigation"><div class="container"><div class="navbar-header"><button type="button" class="navbar-toggle" ng-click="vm.toggleNavbar()"><span class="sr-only">Toggle navigation</span> <span class="icon-bar"></span> <span class="icon-bar"></span> <span class="icon-bar"></span></button> <a class="navbar-brand logo" href="#/" ng-click="vm.collapseNavbar()"><img class="img-responsive" src="content/images/logo.png" srcset="content/images/logo.png, content/images/logo.png 2x" alt="logo" style="margin-top:-3px; width: 230px"><!--<span data-translate="global.title">Ask</span> <span class="navbar-version">v{{VERSION}}</span>--></a></div><div class="navbar-collapse" uib-collapse="vm.isNavbarCollapsed" ng-switch="vm.isAuthenticated()"><ul class="nav navbar-nav navbar-right"><li ui-sref-active="active"><a ui-sref="home" ng-click="vm.collapseNavbar()"><span class="glyphicon glyphicon-home"></span> <span class="hidden-sm" data-translate="global.menu.home">Home</span></a></li><li ng-class="{active: vm.$state.includes(\'member.projects\')}" ng-switch-when="true" uib-dropdown class="dropdown pointer"><a class="dropdown-toggle" uib-dropdown-toggle href="" id="member-project-menu"><span><span class="glyphicon glyphicon-pencil"></span> <span class="hidden-sm" data-translate="global.menu.register">Entities </span><b class="caret"></b></span></a><ul class="dropdown-menu" uib-dropdown-menu><li ng-class="{active: vm.$state.current.name.includes(\'member.projects\') && (vm.$state.params.type.includes(\'event\') || vm.$state.params.type.includes(\'interest\'))}"><a ui-sref="member.projects({type:\'event\'})" ng-click="vm.collapseNavbar()"><span class="glyphicon glyphicon-boat"></span> <span data-translate="global.menu.event">Events</span></a></li><li ng-class="{active: vm.$state.current.name.includes(\'member.projects\') && (vm.$state.params.type.includes(\'course\') || vm.$state.params.type.includes(\'sbfPractical\') || vm.$state.params.type.includes(\'sksTrip\'))}" ng-show="vm.profile.memberStatus == \'probe\' || vm.profile.memberStatus == \'voll\'"><a ui-sref="member.projects({type:\'course\'})" ng-click="vm.collapseNavbar()"><span class="glyphicon glyphicon-education"></span> <span data-translate="global.menu.course">Kurse</span></a></li><li ui-sref-active="active"><a ui-sref="member.dinghy-events" ng-click="vm.collapseNavbar()"><span class="glyphicon glyphicon-tree-deciduous"></span> <span data-translate="global.menu.dinghy">dinghy</span></a></li><li ui-sref-active="active" ng-show="vm.profile.memberStatus == \'probe\' || vm.profile.memberStatus == \'voll\'"><a ui-sref="member.projects({type:\'merchandise\'})" ng-click="vm.collapseNavbar()"><span class="glyphicon glyphicon-shopping-cart"></span> <span data-translate="global.menu.merchandise">Merchandise</span></a></li></ul></li><li ng-class="{active: vm.$state.includes(\'board\')}" ng-switch-when="true" has-any-authority="ROLE_BOARD,ROLE_BOAT,ROLE_MANAGER,ROLE_FINANCE,ROLE_DINGHY,ROLE_SKIPPER_MANAGER" uib-dropdown class="dropdown pointer"><a class="dropdown-toggle" uib-dropdown-toggle href="" id="board-menu"><span><span class="glyphicon glyphicon-tower"></span> <span class="hidden-sm" data-translate="global.menu.board.main">Entities </span><b class="caret"></b></span></a><ul class="dropdown-menu" uib-dropdown-menu><li ui-sref-active="active" has-authority="ROLE_BOARD"><a ui-sref="member-management" ng-click="vm.collapseNavbar()"><span class="glyphicon glyphicon-user"></span>&nbsp; <span data-translate="global.menu.board.memberManagement">Member management</span></a></li><li ng-class="{active: vm.$state.includes(\'board.project-detail\') || vm.$state.includes(\'board.project\')}" has-any-authority="ROLE_BOARD,ROLE_MANAGER"><a ui-sref="board.project" ng-click="vm.collapseNavbar()"><span class="glyphicon glyphicon-bullhorn"></span>&nbsp; <span data-translate="global.menu.board.project">Project</span></a></li><li ui-sref-active="active" has-authority="ROLE_BOARD"><a ui-sref="board.booking" ng-click="vm.collapseNavbar()"><span class="glyphicon glyphicon-ok"></span>&nbsp; <span data-translate="global.menu.board.booking">Booking</span></a></li><li ng-class="{active: vm.$state.includes(\'board.dinghy\')}" has-any-authority="ROLE_BOARD,ROLE_DINGHY"><a ui-sref="board.dinghy.event" ng-click="vm.collapseNavbar()"><span class="glyphicon glyphicon-tree-deciduous"></span>&nbsp; <span data-translate="global.menu.board.dinghy">Dinghy</span></a></li><li ui-sref-active="active" has-authority="ROLE_FINANCE"><a ui-sref="board.dept" ng-click="vm.collapseNavbar()"><span class="glyphicon glyphicon-euro"></span>&nbsp; <span data-translate="global.menu.board.dept">Dept</span></a></li><li ui-sref-active="active" has-authority="ROLE_FINANCE"><a ui-sref="board.payment" ng-click="vm.collapseNavbar()"><span class="glyphicon glyphicon-euro"></span>&nbsp; <span data-translate="global.menu.board.payment">Payment</span></a></li><li ui-sref-active="active" has-authority="ROLE_BOARD"><a ui-sref="board.content" ng-click="vm.collapseNavbar()"><span class="glyphicon glyphicon-pencil"></span>&nbsp; <span data-translate="global.menu.entities.content">Content</span></a></li><li ui-sref-active="active" has-any-authority="ROLE_SKIPPER_MANAGER,ROLE_BOARD,ROLE_BOAT"><a ui-sref="board.skipper" ng-click="vm.collapseNavbar()"><span class="glyphicon glyphicon-user"></span>&nbsp; <span data-translate="global.menu.board.skipper">Skipper</span></a></li><li ui-sref-active="active" has-authority="ROLE_BOARD"><a ui-sref="board.membership-fee" ng-click="vm.collapseNavbar()"><span class="glyphicon glyphicon-user"></span>&nbsp; <span data-translate="global.menu.board.membershipFee">Membership Fee</span></a></li><li ui-sref-active="active" has-authority="ROLE_BOARD"><a ui-sref="board.activities" ng-click="vm.collapseNavbar()"><span class="glyphicon glyphicon-euro"></span>&nbsp; <span data-translate="global.menu.board.activities">Activities</span></a></li><li ui-sref-active="active" has-authority="ROLE_BOARD"><a ui-sref="board.statistics" ng-click="vm.collapseNavbar()"><span class="glyphicon glyphicon-asterisk"></span>&nbsp; <span data-translate="global.menu.board.statistics">Statistics</span></a></li></ul></li><!-- jhipster-needle-add-element-to-menu - JHipster will add new menu items here --><li ng-class="{active: vm.$state.includes(\'entity\')}" ng-switch-when="true" has-authority="ROLE_ADMIN" uib-dropdown class="dropdown pointer"><a class="dropdown-toggle" uib-dropdown-toggle href="" id="entity-menu"><span><span class="glyphicon glyphicon-th-list"></span> <span class="hidden-sm" data-translate="global.menu.entities.main">Entities </span><b class="caret"></b></span></a><ul class="dropdown-menu" uib-dropdown-menu><li ui-sref-active="active"><a ui-sref="profile" ng-click="vm.collapseNavbar()"><span class="glyphicon glyphicon-asterisk"></span>&nbsp; <span data-translate="global.menu.entities.profile">Profile</span></a></li><li ui-sref-active="active"><a ui-sref="activities" ng-click="vm.collapseNavbar()"><span class="glyphicon glyphicon-asterisk"></span>&nbsp; <span data-translate="global.menu.entities.activities">Activities</span></a></li><li ui-sref-active="active"><a ui-sref="project" ng-click="vm.collapseNavbar()"><span class="glyphicon glyphicon-asterisk"></span>&nbsp; <span data-translate="global.menu.entities.project">Project</span></a></li><li ui-sref-active="active"><a ui-sref="booking" ng-click="vm.collapseNavbar()"><span class="glyphicon glyphicon-asterisk"></span>&nbsp; <span data-translate="global.menu.entities.booking">Booking</span></a></li><li ui-sref-active="active"><a ui-sref="dept" ng-click="vm.collapseNavbar()"><span class="glyphicon glyphicon-asterisk"></span>&nbsp; <span data-translate="global.menu.entities.dept">Dept</span></a></li><li ui-sref-active="active"><a ui-sref="payment" ng-click="vm.collapseNavbar()"><span class="glyphicon glyphicon-asterisk"></span>&nbsp; <span data-translate="global.menu.entities.payment">Payment</span></a></li><li ui-sref-active="active"><a ui-sref="membership-fee" ng-click="vm.collapseNavbar()"><span class="glyphicon glyphicon-asterisk"></span>&nbsp; <span data-translate="global.menu.entities.membershipFee">Membership Fee</span></a></li><li ui-sref-active="active"><a ui-sref="content" ng-click="vm.collapseNavbar()"><span class="glyphicon glyphicon-asterisk"></span>&nbsp; <span data-translate="global.menu.entities.content">Content</span></a></li><li ui-sref-active="active"><a ui-sref="sbf-time-slot" ng-click="vm.collapseNavbar()"><span class="glyphicon glyphicon-asterisk"></span>&nbsp; <span data-translate="global.menu.entities.sbfTimeSlot">Sbf Time Slot</span></a></li><li ui-sref-active="active"><a ui-sref="dinghy" ng-click="vm.collapseNavbar()"><span class="glyphicon glyphicon-asterisk"></span>&nbsp; <span data-translate="global.menu.entities.dinghy">Dinghy</span></a></li><li ui-sref-active="active"><a ui-sref="dinghy-event" ng-click="vm.collapseNavbar()"><span class="glyphicon glyphicon-asterisk"></span>&nbsp; <span data-translate="global.menu.entities.dinghyEvent">Dinghy Event</span></a></li><li ui-sref-active="active"><a ui-sref="dinghy-booking" ng-click="vm.collapseNavbar()"><span class="glyphicon glyphicon-asterisk"></span>&nbsp; <span data-translate="global.menu.entities.dinghyBooking">Dinghy Booking</span></a></li><li ui-sref-active="active"><a ui-sref="skipper-level-holder" ng-click="vm.collapseNavbar()"><span class="glyphicon glyphicon-asterisk"></span>&nbsp; <span data-translate="global.menu.entities.skipperLevelHolder">Skipper Level Holder</span></a></li><!-- jhipster-needle-add-entity-to-menu - JHipster will add entities to the menu here --></ul></li><li ng-class="{active: vm.$state.includes(\'admin\')}" ng-switch-when="true" has-authority="ROLE_ADMIN" uib-dropdown class="dropdown pointer"><a class="dropdown-toggle" uib-dropdown-toggle href="" id="admin-menu"><span><span class="glyphicon glyphicon-tower"></span> <span class="hidden-sm" data-translate="global.menu.admin.main">Administration</span> <b class="caret"></b></span></a><ul class="dropdown-menu" uib-dropdown-menu><li ui-sref-active="active"><a ui-sref="user-management" ng-click="vm.collapseNavbar()"><span class="glyphicon glyphicon-user"></span>&nbsp; <span data-translate="global.menu.admin.userManagement">User management</span></a></li><li ui-sref-active="active"><a ui-sref="jhi-tracker" ng-click="vm.collapseNavbar()"><span class="glyphicon glyphicon-eye-open"></span>&nbsp; <span data-translate="global.menu.admin.tracker">User tracker</span></a></li><li ui-sref-active="active"><a ui-sref="jhi-metrics" ng-click="vm.collapseNavbar()"><span class="glyphicon glyphicon-dashboard"></span>&nbsp; <span data-translate="global.menu.admin.metrics">Metrics</span></a></li><li ui-sref-active="active"><a ui-sref="jhi-health" ng-click="vm.collapseNavbar()"><span class="glyphicon glyphicon-heart"></span>&nbsp; <span data-translate="global.menu.admin.health">Health</span></a></li><li ui-sref-active="active"><a ui-sref="jhi-configuration" ng-click="vm.collapseNavbar()"><span class="glyphicon glyphicon-list-alt"></span>&nbsp; <span data-translate="global.menu.admin.configuration">Configuration</span></a></li><li ui-sref-active="active"><a ui-sref="audits" ng-click="vm.collapseNavbar()"><span class="glyphicon glyphicon-bell"></span>&nbsp; <span data-translate="global.menu.admin.audits">Audits</span></a></li><li ui-sref-active="active"><a ui-sref="logs" ng-click="vm.collapseNavbar()"><span class="glyphicon glyphicon-tasks"></span>&nbsp; <span data-translate="global.menu.admin.logs">Logs</span></a></li><li ng-show="vm.swaggerEnabled" ui-sref-active="active"><a ui-sref="docs" ng-click="vm.collapseNavbar()"><span class="glyphicon glyphicon-book"></span>&nbsp; <span data-translate="global.menu.admin.apidocs">API</span></a></li><li ui-sref-active="active"><a ui-sref="entity-audit" ng-click="vm.collapseNavbar()"><span class="glyphicon glyphicon-list-alt"></span>&nbsp; <span data-translate="global.menu.admin.entity-audit">Entity Audit</span></a></li><!-- jhipster-needle-add-element-to-admin-menu - JHipster will add entities to the admin menu here --><li ng-hide="vm.inProduction"><a href="/h2-console" target="_tab" ng-click="vm.collapseNavbar()"><span class="glyphicon glyphicon-hdd"></span>&nbsp; <span data-translate="global.menu.admin.database">Database</span></a></li><li ui-sref-active="active"><a ui-sref="elasticsearch-reindex" data-toggle="collapse" data-target=".navbar-collapse.in"><span class="glyphicon glyphicon-exclamation-sign"></span>&nbsp; <span translate="global.menu.admin.elasticsearch">Reindex Elasticsearch</span></a></li></ul></li><!--\n                <li ui-sref-active="active" uib-dropdown class="dropdown pointer" ng-controller="JhiLanguageController as languageVm">\n                    <a class="dropdown-toggle" uib-dropdown-toggle href="" ng-if="languageVm.languages.length > 1">\n                        <span>\n                            <span class="glyphicon glyphicon-flag"></span>\n                            <span class="hidden-sm" data-translate="global.menu.language">Language</span>\n                            <b class="caret"></b>\n                        </span>\n                    </a>\n                    <ul class="dropdown-menu" uib-dropdown-menu ng-if="languageVm.languages.length > 1">\n                        <li active-menu="{{language}}" ng-repeat="language in languageVm.languages">\n                            <a href="" ng-click="languageVm.changeLanguage(language);vm.collapseNavbar();">{{language | findLanguageFromKey}}</a>\n                        </li>\n                    </ul>\n                </li>--><li ui-sref-active="active" ng-switch-when="false"><a href="" ng-click="vm.login()" id="login"><span class="glyphicon glyphicon-log-in"></span>&nbsp; <span data-translate="global.menu.account.login">Sign in</span></a></li><li ui-sref-active="active" ng-switch-when="false"><a ui-sref="register" ng-click="vm.collapseNavbar()"><span class="glyphicon glyphicon-plus-sign"></span>&nbsp; <span data-translate="global.menu.account.register">Register</span></a></li><li ui-sref-active="active" ng-switch-when="true" ng-show="vm.profile.memberStatus == \'gast\'"><a href="" ng-click="vm.fullMember()"><span class="glyphicon glyphicon-plus-sign"></span> <span data-translate="global.menu.account.registerGuest">Register</span></a></li><li ng-class="{active: vm.$state.includes(\'member.activities\') || vm.$state.includes(\'member.personal\') || vm.$state.includes(\'member.booking\')}" ng-switch-when="true" uib-dropdown class="dropdown pointer"><a class="dropdown-toggle" uib-dropdown-toggle href="" id="settings-menu"><span><span class="glyphicon glyphicon-cog"></span> <span class="hidden-sm" data-translate="global.menu.settings">Entities </span><b class="caret"></b></span></a><ul class="dropdown-menu" uib-dropdown-menu><li ui-sref-active="active" ng-show="vm.profile.memberStatus == \'probe\' || vm.profile.memberStatus == \'voll\'"><a ui-sref="member.activities" ng-click="vm.collapseNavbar()"><span class="glyphicon glyphicon-euro"></span> <span data-translate="global.menu.activities">Activities</span></a></li><li ui-sref-active="active"><a ui-sref="member.booking" ng-click="vm.collapseNavbar()"><span class="glyphicon glyphicon-boat"></span> <span data-translate="global.menu.booking">Booking</span></a></li><li ui-sref-active="active"><a ui-sref="member.dinghy-booking" ng-click="vm.collapseNavbar()"><span class="glyphicon glyphicon-tree-deciduous"></span> <span data-translate="global.menu.dinghyBooking">Dinghy Booking</span></a></li><li ui-sref-active="{\'active\':\'member.personal\'}"><a ui-sref="member.personal.profile" ng-click="vm.collapseNavbar()"><span class="glyphicon glyphicon-user"></span> <span data-translate="global.menu.data">My Data</span></a></li><li ui-sref-active="active"><a href="" ng-click="vm.logout()" id="logout"><span class="glyphicon glyphicon-log-out"></span>&nbsp; <span data-translate="global.menu.account.logout">Sign out</span></a></li></ul></li></ul></div></div></nav>');
$templateCache.put('app/layouts/error/accessdenied.html','<!--\n  ~ Copyright (c) 2017 by Julian Feder, julian.feder@yahoo.de\n  ~\n  ~ This product includes software developed at\n  ~ The Apache Software Foundation (http://www.apache.org/).\n  --><div ng-cloak><div class="row"><div class="col-md-12"><h1 data-translate="error.title">Error Page!</h1><div class="alert alert-danger" data-translate="error.403">You are not authorized to access the page.</div></div></div></div>');
$templateCache.put('app/layouts/error/error.html','<!--\n  ~ Copyright (c) 2017 by Julian Feder, julian.feder@yahoo.de\n  ~\n  ~ This product includes software developed at\n  ~ The Apache Software Foundation (http://www.apache.org/).\n  --><div ng-cloak><div class="row"><div class="col-md-12"><h1 data-translate="error.title">Error Page!</h1><div ng-show="errorMessage"><div class="alert alert-danger">{{errorMessage}}</div></div></div></div></div>');
$templateCache.put('app/entities/activities/activities-delete-dialog.html','<!--\n  ~ Copyright (c) 2017 by Julian Feder, julian.feder@yahoo.de\n  ~\n  ~ This product includes software developed at\n  ~ The Apache Software Foundation (http://www.apache.org/).\n  --><form name="deleteForm" ng-submit="vm.confirmDelete(vm.activities.id)"><div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()">&times;</button><h4 class="modal-title" data-translate="entity.delete.title">Confirm delete operation</h4></div><div class="modal-body"><jhi-alert-error></jhi-alert-error><p data-translate="askApp.activities.delete.question" translate-values="{id: \'{{vm.activities.id}}\'}">Are you sure you want to delete this Activities?</p></div><div class="modal-footer"><button type="button" class="btn btn-default" data-dismiss="modal" ng-click="vm.clear()"><span class="glyphicon glyphicon-ban-circle"></span>&nbsp;<span data-translate="entity.action.cancel">Cancel</span></button> <button type="submit" ng-disabled="deleteForm.$invalid" class="btn btn-danger"><span class="glyphicon glyphicon-remove-circle"></span>&nbsp;<span data-translate="entity.action.delete">Delete</span></button></div></form>');
$templateCache.put('app/entities/activities/activities-detail.html','<!--\n  ~ Copyright (c) 2017 by Julian Feder, julian.feder@yahoo.de\n  ~\n  ~ This product includes software developed at\n  ~ The Apache Software Foundation (http://www.apache.org/).\n  --><div><h2><span data-translate="askApp.activities.detail.title">Activities</span> {{vm.activities.id}}</h2><hr><jhi-alert-error></jhi-alert-error><dl class="dl-horizontal jh-entity-details"><dt><span data-translate="askApp.activities.activitiesDate">Activities Date</span></dt><dd><span>{{vm.activities.activitiesDate | date:\'mediumDate\'}}</span></dd><dt><span data-translate="askApp.activities.validFrom">Valid From</span></dt><dd><span>{{vm.activities.validFrom | date:\'mediumDate\'}}</span></dd><dt><span data-translate="askApp.activities.category">Category</span></dt><dd><span data-translate="{{\'askApp.EnumCategoryActivity.\' + vm.activities.category}}">{{vm.activities.category}}</span></dd><dt><span data-translate="askApp.activities.profile">Profile</span></dt><dd><a ui-sref="profile-detail({id:vm.activities.profile.id})">{{vm.activities.profile.id}}</a></dd><dt><span data-translate="askApp.activities.booking">Booking</span></dt><dd><a ui-sref="booking-detail({id:vm.activities.booking.id})">{{vm.activities.booking.id}}</a></dd></dl><button type="submit" ui-sref="{{ vm.previousState }}" class="btn btn-info"><span class="glyphicon glyphicon-arrow-left"></span>&nbsp;<span data-translate="entity.action.back"> Back</span></button> <button type="button" ui-sref="activities-detail.edit({id:vm.activities.id})" class="btn btn-primary"><span class="glyphicon glyphicon-pencil"></span> <span class="hidden-sm-down" data-translate="entity.action.edit">Edit</span></button></div>');
$templateCache.put('app/entities/activities/activities-dialog.html','<!--\n  ~ Copyright (c) 2017 by Julian Feder, julian.feder@yahoo.de\n  ~\n  ~ This product includes software developed at\n  ~ The Apache Software Foundation (http://www.apache.org/).\n  --><form name="editForm" role="form" novalidate ng-submit="vm.save()" show-validation><div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()">&times;</button><h4 class="modal-title" id="myActivitiesLabel" data-translate="askApp.activities.home.createOrEditLabel">Create or edit a Activities</h4></div><div class="modal-body"><jhi-alert-error></jhi-alert-error><div class="form-group" ng-show="vm.activities.id"><label for="id" data-translate="global.field.id">ID</label><input type="text" class="form-control" id="id" name="id" ng-model="vm.activities.id" readonly="readonly"></div><div class="form-group"><label class="control-label" data-translate="askApp.activities.activitiesDate" for="field_activitiesDate">Activities Date</label><div class="input-group"><input id="field_activitiesDate" type="text" class="form-control" name="activitiesDate" uib-datepicker-popup="{{dateformat}}" ng-model="vm.activities.activitiesDate" is-open="vm.datePickerOpenStatus.activitiesDate" required> <span class="input-group-btn"><button type="button" class="btn btn-default" ng-click="vm.openCalendar(\'activitiesDate\')"><i class="glyphicon glyphicon-calendar"></i></button></span></div><div ng-show="editForm.activitiesDate.$invalid"><p class="help-block" ng-show="editForm.activitiesDate.$error.required" data-translate="entity.validation.required">This field is required.</p></div></div><div class="form-group"><label class="control-label" data-translate="askApp.activities.validFrom" for="field_validFrom">Valid From</label><div class="input-group"><input id="field_validFrom" type="text" class="form-control" name="validFrom" uib-datepicker-popup="{{dateformat}}" ng-model="vm.activities.validFrom" is-open="vm.datePickerOpenStatus.validFrom"> <span class="input-group-btn"><button type="button" class="btn btn-default" ng-click="vm.openCalendar(\'validFrom\')"><i class="glyphicon glyphicon-calendar"></i></button></span></div></div><div class="form-group"><label class="control-label" data-translate="askApp.activities.category" for="field_category">Category</label><select class="form-control" name="category" ng-model="vm.activities.category" id="field_category" required><option value="AMT" data-translate="askApp.EnumCategoryActivity.AMT">AMT</option><option value="AUSBILDUNG" data-translate="askApp.EnumCategoryActivity.AUSBILDUNG">AUSBILDUNG</option><option value="EVENT" data-translate="askApp.EnumCategoryActivity.EVENT">EVENT</option><option value="MARKETING" data-translate="askApp.EnumCategoryActivity.MARKETING">MARKETING</option><option value="SONSTIGES" data-translate="askApp.EnumCategoryActivity.SONSTIGES">SONSTIGES</option></select><div ng-show="editForm.category.$invalid"><p class="help-block" ng-show="editForm.category.$error.required" data-translate="entity.validation.required">This field is required.</p></div></div><div class="form-group"><label data-translate="askApp.activities.profile" for="field_profile">Profile</label><select class="form-control" id="field_profile" name="profile" ng-model="vm.activities.profile" ng-options="profile as profile.id for profile in vm.profiles track by profile.id" required></select></div><div ng-show="editForm.profile.$invalid"><p class="help-block" ng-show="editForm.profile.$error.required" data-translate="entity.validation.required">This field is required.</p></div><div class="form-group"><label data-translate="askApp.activities.booking" for="field_booking">Booking</label><select class="form-control" id="field_booking" name="booking" ng-model="vm.activities.booking" ng-options="booking as booking.id for booking in vm.bookings track by booking.id"><option value=""></option></select></div></div><div class="modal-footer"><button type="button" class="btn btn-default" data-dismiss="modal" ng-click="vm.clear()"><span class="glyphicon glyphicon-ban-circle"></span>&nbsp;<span data-translate="entity.action.cancel">Cancel</span></button> <button type="submit" ng-disabled="editForm.$invalid || vm.isSaving" class="btn btn-primary"><span class="glyphicon glyphicon-save"></span>&nbsp;<span data-translate="entity.action.save">Save</span></button></div></form>');
$templateCache.put('app/entities/activities/activities.html','<!--\n  ~ Copyright (c) 2017 by Julian Feder, julian.feder@yahoo.de\n  ~\n  ~ This product includes software developed at\n  ~ The Apache Software Foundation (http://www.apache.org/).\n  --><div><h2 data-translate="askApp.activities.home.title">Activities</h2><jhi-alert></jhi-alert><div class="container-fluid"><div class="row"><div class="col-xs-4 no-padding-left"><button class="btn btn-primary" ui-sref="activities.new"><span class="glyphicon glyphicon-plus"></span> <span class="hidden-xs-down" data-translate="askApp.activities.home.createLabel">Create new Activities</span></button></div><div class="col-xs-8 no-padding-right"><form name="searchForm" class="form-inline"><div class="input-group pull-right"><input type="text" class="form-control" ng-model="vm.searchQuery" id="searchQuery" placeholder="{{ \'askApp.activities.home.search\' | translate }}"> <span class="input-group-btn width-min"><button class="btn btn-info" ng-click="vm.search(vm.searchQuery)"><span class="glyphicon glyphicon-search"></span></button> </span><span class="input-group-btn width-min" ng-if="vm.currentSearch"><button class="btn btn-info" ng-click="vm.clear()"><span class="glyphicon glyphicon-trash"></span></button></span></div></form></div></div></div><br><div class="table-responsive"><table class="jh-table table table-striped"><thead><tr jh-sort="vm.predicate" ascending="vm.reverse" callback="vm.transition()"><th jh-sort-by="id"><span data-translate="global.field.id">ID</span> <span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="activitiesDate"><span data-translate="askApp.activities.activitiesDate">Activities Date</span> <span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="validFrom"><span data-translate="askApp.activities.validFrom">Valid From</span> <span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="category"><span data-translate="askApp.activities.category">Category</span> <span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="comment"><span data-translate="askApp.activities.comment">Comment</span> <span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="profile.id"><span data-translate="askApp.activities.profile">Profile</span> <span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="booking.id"><span data-translate="askApp.activities.booking">Booking</span> <span class="glyphicon glyphicon-sort"></span></th><th></th></tr></thead><tbody><tr ng-repeat="activities in vm.activities track by activities.id"><td><a ui-sref="activities-detail({id:activities.id})">{{activities.id}}</a></td><td>{{activities.activitiesDate | date:\'mediumDate\'}}</td><td>{{activities.validFrom | date:\'mediumDate\'}}</td><td data-translate="{{\'askApp.EnumCategoryActivity.\' + activities.category}}">{{activities.category}}</td><td>{{activities.comment}}</td><td><a ui-sref="profile-detail({id:activities.profile.id})">{{activities.profile.id}}</a></td><td><a ui-sref="booking-detail({id:activities.booking.id})">{{activities.booking.id}}</a></td><td class="text-right"><div class="btn-group flex-btn-group-container"><button type="submit" ui-sref="activities-detail({id:activities.id})" class="btn btn-info btn-sm"><span class="glyphicon glyphicon-eye-open"></span> <span class="hidden-sm-down" data-translate="entity.action.view"></span></button> <button type="submit" ui-sref="activities.edit({id:activities.id})" class="btn btn-primary btn-sm"><span class="glyphicon glyphicon-pencil"></span> <span class="hidden-sm-down" data-translate="entity.action.edit"></span></button> <button type="submit" ui-sref="activities.delete({id:activities.id})" class="btn btn-danger btn-sm"><span class="glyphicon glyphicon-remove-circle"></span> <span class="hidden-sm-down" data-translate="entity.action.delete"></span></button></div></td></tr></tbody></table></div><div class="text-center"><jhi-item-count page="vm.page" total="vm.queryCount" items-per-page="vm.itemsPerPage"></jhi-item-count><uib-pagination class="pagination-sm" total-items="vm.totalItems" items-per-page="vm.itemsPerPage" ng-model="vm.page" ng-change="vm.transition()"></uib-pagination></div></div>');
$templateCache.put('app/entities/booking/booking-delete-dialog.html','<!--\n  ~ Copyright (c) 2017 by Julian Feder, julian.feder@yahoo.de\n  ~\n  ~ This product includes software developed at\n  ~ The Apache Software Foundation (http://www.apache.org/).\n  --><form name="deleteForm" ng-submit="vm.confirmDelete(vm.booking.id)"><div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()">&times;</button><h4 class="modal-title" data-translate="entity.delete.title">Confirm delete operation</h4></div><div class="modal-body"><jhi-alert-error></jhi-alert-error><p data-translate="askApp.booking.delete.question" translate-values="{id: \'{{vm.booking.id}}\'}">Are you sure you want to delete this Booking?</p></div><div class="modal-footer"><button type="button" class="btn btn-default" data-dismiss="modal" ng-click="vm.clear()"><span class="glyphicon glyphicon-ban-circle"></span>&nbsp;<span data-translate="entity.action.cancel">Cancel</span></button> <button type="submit" ng-disabled="deleteForm.$invalid" class="btn btn-danger"><span class="glyphicon glyphicon-remove-circle"></span>&nbsp;<span data-translate="entity.action.delete">Delete</span></button></div></form>');
$templateCache.put('app/entities/booking/booking-detail.html','<!--\n  ~ Copyright (c) 2017 by Julian Feder, julian.feder@yahoo.de\n  ~\n  ~ This product includes software developed at\n  ~ The Apache Software Foundation (http://www.apache.org/).\n  --><div><h2><span data-translate="askApp.booking.detail.title">Booking</span> {{vm.booking.id}}</h2><hr><jhi-alert-error></jhi-alert-error><dl class="dl-horizontal jh-entity-details"><dt><span data-translate="askApp.booking.date">Date</span></dt><dd><span>{{vm.booking.date | date:\'mediumDate\'}}</span></dd><dt><span data-translate="askApp.booking.price">Price</span></dt><dd><span>{{vm.booking.price}}</span></dd><dt><span data-translate="askApp.booking.status">Status</span></dt><dd><span data-translate="{{\'askApp.EnumBookingStatusType.\' + vm.booking.status}}">{{vm.booking.status}}</span></dd><dt><span data-translate="askApp.booking.comment">Comment</span></dt><dd><span>{{vm.booking.comment}}</span></dd><dt><span data-translate="askApp.booking.individualField">Individual Field</span></dt><dd><span>{{vm.booking.individualField}}</span></dd><dt><span data-translate="askApp.booking.crewPosition">Crew Position</span></dt><dd><span>{{vm.booking.crewPosition}}</span></dd><dt><span data-translate="askApp.booking.sksTheoryAvailable">Sks Theory Available</span></dt><dd><span>{{vm.booking.sksTheoryAvailable}}</span></dd><dt><span data-translate="askApp.booking.sbfSlotsMax">Sbf Slots Max</span></dt><dd><span>{{vm.booking.sbfSlotsMax}}</span></dd><dt><span data-translate="askApp.booking.project">Project</span></dt><dd><a ui-sref="project-detail({id:vm.booking.project.id})">{{vm.booking.project.id}}</a></dd><dt><span data-translate="askApp.booking.profile">Profile</span></dt><dd><a ui-sref="profile-detail({id:vm.booking.profile.id})">{{vm.booking.profile.id}}</a></dd><dt><span data-translate="askApp.booking.dept">Dept</span></dt><dd><a ui-sref="dept-detail({id:vm.booking.dept.id})">{{vm.booking.dept.id}}</a></dd><dt><span data-translate="askApp.booking.crew">Crew</span></dt><dd><a ui-sref="crew-detail({id:vm.booking.crew.id})">{{vm.booking.crew.id}}</a></dd></dl><button type="submit" ui-sref="{{ vm.previousState }}" class="btn btn-info"><span class="glyphicon glyphicon-arrow-left"></span>&nbsp;<span data-translate="entity.action.back"> Back</span></button> <button type="button" ui-sref="booking-detail.edit({id:vm.booking.id})" class="btn btn-primary"><span class="glyphicon glyphicon-pencil"></span> <span class="hidden-sm-down" data-translate="entity.action.edit">Edit</span></button></div>');
$templateCache.put('app/entities/booking/booking-dialog.html','<!--\n  ~ Copyright (c) 2017 by Julian Feder, julian.feder@yahoo.de\n  ~\n  ~ This product includes software developed at\n  ~ The Apache Software Foundation (http://www.apache.org/).\n  --><form name="editForm" role="form" novalidate ng-submit="vm.save()" show-validation><div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()">&times;</button><h4 class="modal-title" id="myBookingLabel" data-translate="askApp.booking.home.createOrEditLabel">Create or edit a Booking</h4></div><div class="modal-body"><jhi-alert-error></jhi-alert-error><div class="form-group" ng-show="vm.booking.id"><label for="id" data-translate="global.field.id">ID</label><input type="text" class="form-control" id="id" name="id" ng-model="vm.booking.id" readonly="readonly"></div><div class="form-group"><label class="control-label" data-translate="askApp.booking.date" for="field_date">Date</label><div class="input-group"><input id="field_date" type="text" class="form-control" name="date" uib-datepicker-popup="{{dateformat}}" ng-model="vm.booking.date" is-open="vm.datePickerOpenStatus.date" required> <span class="input-group-btn"><button type="button" class="btn btn-default" ng-click="vm.openCalendar(\'date\')"><i class="glyphicon glyphicon-calendar"></i></button></span></div><div ng-show="editForm.date.$invalid"><p class="help-block" ng-show="editForm.date.$error.required" data-translate="entity.validation.required">This field is required.</p></div></div><div class="form-group"><label class="control-label" data-translate="askApp.booking.price" for="field_price">Price</label><input type="number" class="form-control" name="price" id="field_price" ng-model="vm.booking.price" required><div ng-show="editForm.price.$invalid"><p class="help-block" ng-show="editForm.price.$error.required" data-translate="entity.validation.required">This field is required.</p><p class="help-block" ng-show="editForm.price.$error.number" data-translate="entity.validation.number">This field should be a number.</p></div></div><div class="form-group"><label class="control-label" data-translate="askApp.booking.status" for="field_status">Status</label><select class="form-control" name="status" ng-model="vm.booking.status" id="field_status"><option value="angemeldet" data-translate="askApp.EnumBookingStatusType.angemeldet">angemeldet</option><option value="zurueckgetreten" data-translate="askApp.EnumBookingStatusType.zurueckgetreten">zurueckgetreten</option><option value="abgelehnt" data-translate="askApp.EnumBookingStatusType.abgelehnt">abgelehnt</option><option value="warteliste" data-translate="askApp.EnumBookingStatusType.warteliste">warteliste</option></select></div><div class="form-group"><label class="control-label" data-translate="askApp.booking.comment" for="field_comment">Comment</label><input type="text" class="form-control" name="comment" id="field_comment" ng-model="vm.booking.comment"></div><div class="form-group"><label class="control-label" data-translate="askApp.booking.individualField" for="field_individualField">Individual Field</label><input type="text" class="form-control" name="individualField" id="field_individualField" ng-model="vm.booking.individualField"></div><div class="form-group"><label class="control-label" data-translate="askApp.booking.crewPosition" for="field_crewPosition">Crew Position</label><input type="number" class="form-control" name="crewPosition" id="field_crewPosition" ng-model="vm.booking.crewPosition"></div><div class="form-group"><label class="control-label" data-translate="askApp.booking.sksTheoryAvailable" for="field_sksTheoryAvailable">Sks Theory Available</label><input type="checkbox" name="sksTheoryAvailable" id="field_sksTheoryAvailable" ng-model="vm.booking.sksTheoryAvailable"></div><div class="form-group"><label class="control-label" data-translate="askApp.booking.sbfSlotsMax" for="field_sbfSlotsMax">Sbf Slots Max</label><input type="number" class="form-control" name="sbfSlotsMax" id="field_sbfSlotsMax" ng-model="vm.booking.sbfSlotsMax"></div><div class="form-group"><label data-translate="askApp.booking.project" for="field_project">Project</label><select class="form-control" id="field_project" name="project" ng-model="vm.booking.project" ng-options="project as project.id for project in vm.projects track by project.id"><option value=""></option></select></div><div class="form-group"><label data-translate="askApp.booking.profile" for="field_profile">Profile</label><select class="form-control" id="field_profile" name="profile" ng-model="vm.booking.profile" ng-options="profile as profile.id for profile in vm.profiles track by profile.id"><option value=""></option></select></div><div class="form-group"><label data-translate="askApp.booking.dept" for="field_dept">Dept</label><select class="form-control" id="field_dept" name="dept" ng-model="vm.booking.dept" ng-options="dept as dept.id for dept in vm.depts | orderBy:\'id\' track by dept.id" required></select></div><div ng-show="editForm.dept.$invalid"><p class="help-block" ng-show="editForm.dept.$error.required" data-translate="entity.validation.required">This field is required.</p></div><div class="form-group"><label data-translate="askApp.booking.crew" for="field_crew">Crew</label><select class="form-control" id="field_crew" name="crew" ng-model="vm.booking.crew" ng-options="crew as crew.id for crew in vm.crews track by crew.id"><option value=""></option></select></div></div><div class="modal-footer"><button type="button" class="btn btn-default" data-dismiss="modal" ng-click="vm.clear()"><span class="glyphicon glyphicon-ban-circle"></span>&nbsp;<span data-translate="entity.action.cancel">Cancel</span></button> <button type="submit" ng-disabled="editForm.$invalid || vm.isSaving" class="btn btn-primary"><span class="glyphicon glyphicon-save"></span>&nbsp;<span data-translate="entity.action.save">Save</span></button></div></form>');
$templateCache.put('app/entities/booking/bookings.html','<!--\n  ~ Copyright (c) 2017 by Julian Feder, julian.feder@yahoo.de\n  ~\n  ~ This product includes software developed at\n  ~ The Apache Software Foundation (http://www.apache.org/).\n  --><div><h2 data-translate="askApp.booking.home.title">Bookings</h2><jhi-alert></jhi-alert><div class="container-fluid"><div class="row"><div class="col-xs-4 no-padding-left"><button class="btn btn-primary" ui-sref="booking.new"><span class="glyphicon glyphicon-plus"></span> <span class="hidden-xs-down" data-translate="askApp.booking.home.createLabel">Create new Booking</span></button></div><div class="col-xs-8 no-padding-right"><form name="searchForm" class="form-inline"><div class="input-group pull-right"><input type="text" class="form-control" ng-model="vm.searchQuery" id="searchQuery" placeholder="{{ \'askApp.booking.home.search\' | translate }}"> <span class="input-group-btn width-min"><button class="btn btn-info" ng-click="vm.search(vm.searchQuery)"><span class="glyphicon glyphicon-search"></span></button> </span><span class="input-group-btn width-min" ng-if="vm.currentSearch"><button class="btn btn-info" ng-click="vm.clear()"><span class="glyphicon glyphicon-trash"></span></button></span></div></form></div></div></div><br><div class="table-responsive"><table class="jh-table table table-striped"><thead><tr jh-sort="vm.predicate" ascending="vm.reverse" callback="vm.transition()"><th jh-sort-by="id"><span data-translate="global.field.id">ID</span> <span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="date"><span data-translate="askApp.booking.date">Date</span> <span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="price"><span data-translate="askApp.booking.price">Price</span> <span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="status"><span data-translate="askApp.booking.status">Status</span> <span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="comment"><span data-translate="askApp.booking.comment">Comment</span> <span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="individualField"><span data-translate="askApp.booking.individualField">Individual Field</span> <span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="crewPosition"><span data-translate="askApp.booking.crewPosition">Crew Position</span> <span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="sksTheoryAvailable"><span data-translate="askApp.booking.sksTheoryAvailable">Sks Theory Available</span> <span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="sbfSlotsMax"><span data-translate="askApp.booking.sbfSlotsMax">Sbf Slots Max</span> <span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="project.id"><span data-translate="askApp.booking.project">Project</span> <span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="profile.id"><span data-translate="askApp.booking.profile">Profile</span> <span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="dept.id"><span data-translate="askApp.booking.dept">Dept</span> <span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="crew.id"><span data-translate="askApp.booking.crew">Crew</span> <span class="glyphicon glyphicon-sort"></span></th><th></th></tr></thead><tbody><tr ng-repeat="booking in vm.bookings track by booking.id"><td><a ui-sref="booking-detail({id:booking.id})">{{booking.id}}</a></td><td>{{booking.date | date:\'mediumDate\'}}</td><td>{{booking.price}}</td><td data-translate="{{\'askApp.EnumBookingStatusType.\' + booking.status}}">{{booking.status}}</td><td>{{booking.comment}}</td><td>{{booking.individualField}}</td><td>{{booking.crewPosition}}</td><td>{{booking.sksTheoryAvailable}}</td><td>{{booking.sbfSlotsMax}}</td><td><a ui-sref="project-detail({id:booking.project.id})">{{booking.project.id}}</a></td><td><a ui-sref="profile-detail({id:booking.profile.id})">{{booking.profile.id}}</a></td><td><a ui-sref="dept-detail({id:booking.dept.id})">{{booking.dept.id}}</a></td><td><a ui-sref="crew-detail({id:booking.crew.id})">{{booking.crew.id}}</a></td><td class="text-right"><div class="btn-group flex-btn-group-container"><button type="submit" ui-sref="booking-detail({id:booking.id})" class="btn btn-info btn-sm"><span class="glyphicon glyphicon-eye-open"></span> <span class="hidden-sm-down" data-translate="entity.action.view"></span></button> <button type="submit" ui-sref="booking.edit({id:booking.id})" class="btn btn-primary btn-sm"><span class="glyphicon glyphicon-pencil"></span> <span class="hidden-sm-down" data-translate="entity.action.edit"></span></button> <button type="submit" ui-sref="booking.delete({id:booking.id})" class="btn btn-danger btn-sm"><span class="glyphicon glyphicon-remove-circle"></span> <span class="hidden-sm-down" data-translate="entity.action.delete"></span></button></div></td></tr></tbody></table></div><div class="text-center"><jhi-item-count page="vm.page" total="vm.queryCount" items-per-page="vm.itemsPerPage"></jhi-item-count><uib-pagination class="pagination-sm" total-items="vm.totalItems" items-per-page="vm.itemsPerPage" ng-model="vm.page" ng-change="vm.transition()"></uib-pagination></div></div>');
$templateCache.put('app/entities/content/content-delete-dialog.html','<form name="deleteForm" ng-submit="vm.confirmDelete(vm.content.id)"><div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()">&times;</button><h4 class="modal-title" data-translate="entity.delete.title">Confirm delete operation</h4></div><div class="modal-body"><jhi-alert-error></jhi-alert-error><p data-translate="askApp.content.delete.question" translate-values="{id: \'{{vm.content.id}}\'}">Are you sure you want to delete this Content?</p></div><div class="modal-footer"><button type="button" class="btn btn-default" data-dismiss="modal" ng-click="vm.clear()"><span class="glyphicon glyphicon-ban-circle"></span>&nbsp;<span data-translate="entity.action.cancel">Cancel</span></button> <button type="submit" ng-disabled="deleteForm.$invalid" class="btn btn-danger"><span class="glyphicon glyphicon-remove-circle"></span>&nbsp;<span data-translate="entity.action.delete">Delete</span></button></div></form>');
$templateCache.put('app/entities/content/content-detail.html','<div><h2><span data-translate="askApp.content.detail.title">Content</span> {{vm.content.id}}</h2><hr><jhi-alert-error></jhi-alert-error><dl class="dl-horizontal jh-entity-details"><dt><span data-translate="askApp.content.text">Text</span></dt><dd><span>{{vm.content.text}}</span></dd><dt><span data-translate="askApp.content.access">Access</span></dt><dd><span data-translate="{{\'askApp.EnumContentAccess.\' + vm.content.access}}">{{vm.content.access}}</span></dd></dl><button type="submit" ui-sref="{{ vm.previousState }}" class="btn btn-info"><span class="glyphicon glyphicon-arrow-left"></span>&nbsp;<span data-translate="entity.action.back"> Back</span></button> <button type="button" ui-sref="content-detail.edit({id:vm.content.id})" class="btn btn-primary"><span class="glyphicon glyphicon-pencil"></span> <span class="hidden-sm-down" data-translate="entity.action.edit">Edit</span></button></div>');
$templateCache.put('app/entities/content/content-dialog.html','<form name="editForm" role="form" novalidate ng-submit="vm.save()" show-validation><div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()">&times;</button><h4 class="modal-title" id="myContentLabel" data-translate="askApp.content.home.createOrEditLabel">Create or edit a Content</h4></div><div class="modal-body"><jhi-alert-error></jhi-alert-error><div class="form-group" ng-show="vm.content.id"><label for="id" data-translate="global.field.id">ID</label><input type="text" class="form-control" id="id" name="id" ng-model="vm.content.id" readonly="readonly"></div><div class="form-group"><label class="control-label" data-translate="askApp.content.text" for="field_text">Text</label><input type="text" class="form-control" name="text" id="field_text" ng-model="vm.content.text" required><div ng-show="editForm.text.$invalid"><p class="help-block" ng-show="editForm.text.$error.required" data-translate="entity.validation.required">This field is required.</p></div></div><div class="form-group"><label class="control-label" data-translate="askApp.content.access" for="field_access">Access</label><select class="form-control" name="access" ng-model="vm.content.access" id="field_access" required><option value="extern" data-translate="askApp.EnumContentAccess.extern">extern</option><option value="member" data-translate="askApp.EnumContentAccess.member">member</option><option value="board" data-translate="askApp.EnumContentAccess.board">board</option></select><div ng-show="editForm.access.$invalid"><p class="help-block" ng-show="editForm.access.$error.required" data-translate="entity.validation.required">This field is required.</p></div></div></div><div class="modal-footer"><button type="button" class="btn btn-default" data-dismiss="modal" ng-click="vm.clear()"><span class="glyphicon glyphicon-ban-circle"></span>&nbsp;<span data-translate="entity.action.cancel">Cancel</span></button> <button type="submit" ng-disabled="editForm.$invalid || vm.isSaving" class="btn btn-primary"><span class="glyphicon glyphicon-save"></span>&nbsp;<span data-translate="entity.action.save">Save</span></button></div></form>');
$templateCache.put('app/entities/content/contents.html','<div><h2 data-translate="askApp.content.home.title">Contents</h2><jhi-alert></jhi-alert><div class="container-fluid"><div class="row"><div class="col-xs-4 no-padding-left"><button class="btn btn-primary" ui-sref="content.new"><span class="glyphicon glyphicon-plus"></span> <span class="hidden-xs-down" data-translate="askApp.content.home.createLabel">Create new Content</span></button></div><div class="col-xs-8 no-padding-right"><form name="searchForm" class="form-inline"><div class="input-group pull-right"><input type="text" class="form-control" ng-model="vm.searchQuery" id="searchQuery" placeholder="{{ \'askApp.content.home.search\' | translate }}"> <span class="input-group-btn width-min"><button class="btn btn-info" ng-click="vm.search(vm.searchQuery)"><span class="glyphicon glyphicon-search"></span></button> </span><span class="input-group-btn width-min" ng-if="vm.currentSearch"><button class="btn btn-info" ng-click="vm.clear()"><span class="glyphicon glyphicon-trash"></span></button></span></div></form></div></div></div><br><div class="table-responsive"><table class="jh-table table table-striped"><thead><tr jh-sort="vm.predicate" ascending="vm.reverse" callback="vm.transition()"><th jh-sort-by="id"><span data-translate="global.field.id">ID</span> <span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="text"><span data-translate="askApp.content.text">Text</span> <span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="access"><span data-translate="askApp.content.access">Access</span> <span class="glyphicon glyphicon-sort"></span></th><th></th></tr></thead><tbody><tr ng-repeat="content in vm.contents track by content.id"><td><a ui-sref="content-detail({id:content.id})">{{content.id}}</a></td><td>{{content.text}}</td><td data-translate="{{\'askApp.EnumContentAccess.\' + content.access}}">{{content.access}}</td><td class="text-right"><div class="btn-group flex-btn-group-container"><button type="submit" ui-sref="content-detail({id:content.id})" class="btn btn-info btn-sm"><span class="glyphicon glyphicon-eye-open"></span> <span class="hidden-sm-down" data-translate="entity.action.view"></span></button> <button type="submit" ui-sref="content.edit({id:content.id})" class="btn btn-primary btn-sm"><span class="glyphicon glyphicon-pencil"></span> <span class="hidden-sm-down" data-translate="entity.action.edit"></span></button> <button type="submit" ui-sref="content.delete({id:content.id})" class="btn btn-danger btn-sm"><span class="glyphicon glyphicon-remove-circle"></span> <span class="hidden-sm-down" data-translate="entity.action.delete"></span></button></div></td></tr></tbody></table></div><div class="text-center"><jhi-item-count page="vm.page" total="vm.queryCount" items-per-page="vm.itemsPerPage"></jhi-item-count><uib-pagination class="pagination-sm" total-items="vm.totalItems" items-per-page="vm.itemsPerPage" ng-model="vm.page" ng-change="vm.transition()"></uib-pagination></div></div>');
$templateCache.put('app/entities/dept/dept-delete-dialog.html','<!--\n  ~ Copyright (c) 2017 by Julian Feder, julian.feder@yahoo.de\n  ~\n  ~ This product includes software developed at\n  ~ The Apache Software Foundation (http://www.apache.org/).\n  --><form name="deleteForm" ng-submit="vm.confirmDelete(vm.dept.id)"><div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()">&times;</button><h4 class="modal-title" data-translate="entity.delete.title">Confirm delete operation</h4></div><div class="modal-body"><jhi-alert-error></jhi-alert-error><p data-translate="askApp.dept.delete.question" translate-values="{id: \'{{vm.dept.id}}\'}">Are you sure you want to delete this Dept?</p></div><div class="modal-footer"><button type="button" class="btn btn-default" data-dismiss="modal" ng-click="vm.clear()"><span class="glyphicon glyphicon-ban-circle"></span>&nbsp;<span data-translate="entity.action.cancel">Cancel</span></button> <button type="submit" ng-disabled="deleteForm.$invalid" class="btn btn-danger"><span class="glyphicon glyphicon-remove-circle"></span>&nbsp;<span data-translate="entity.action.delete">Delete</span></button></div></form>');
$templateCache.put('app/entities/dept/dept-detail.html','<!--\n  ~ Copyright (c) 2017 by Julian Feder, julian.feder@yahoo.de\n  ~\n  ~ This product includes software developed at\n  ~ The Apache Software Foundation (http://www.apache.org/).\n  --><div><h2><span data-translate="askApp.dept.detail.title">Dept</span> {{vm.dept.id}}</h2><hr><jhi-alert-error></jhi-alert-error><dl class="dl-horizontal jh-entity-details"><dt><span data-translate="askApp.dept.reference">Reference</span></dt><dd><span>{{vm.dept.reference}}</span></dd><dt><span data-translate="askApp.dept.date">Date</span></dt><dd><span>{{vm.dept.date | date:\'mediumDate\'}}</span></dd><dt><span data-translate="askApp.dept.amount">Amount</span></dt><dd><span>{{vm.dept.amount}}</span></dd><dt><span data-translate="askApp.dept.comment">Comment</span></dt><dd><span>{{vm.dept.comment}}</span></dd><dt><span data-translate="askApp.dept.sepa">Sepa</span></dt><dd><span>{{vm.dept.sepa}}</span></dd><dt><span data-translate="askApp.dept.paymentStatus">Payment Status</span></dt><dd><span data-translate="{{\'askApp.EnumDeptStatus.\' + vm.dept.paymentStatus}}">{{vm.dept.paymentStatus}}</span></dd><dt><span data-translate="askApp.dept.profile">Profile</span></dt><dd><a ui-sref="profile-detail({id:vm.dept.profile.id})">{{vm.dept.profile.id}}</a></dd><dt><span data-translate="askApp.dept.project">Project</span></dt><dd><a ui-sref="project-detail({id:vm.dept.project.id})">{{vm.dept.project.id}}</a></dd><dt><span data-translate="askApp.dept.dinghyEvent">Dinghy Event</span></dt><dd><a ui-sref="dinghy-event-detail({id:vm.dept.dinghyEvent.id})">{{vm.dept.dinghyEvent.id}}</a></dd></dl><button type="submit" ui-sref="{{ vm.previousState }}" class="btn btn-info"><span class="glyphicon glyphicon-arrow-left"></span>&nbsp;<span data-translate="entity.action.back"> Back</span></button> <button type="button" ui-sref="dept-detail.edit({id:vm.dept.id})" class="btn btn-primary"><span class="glyphicon glyphicon-pencil"></span> <span class="hidden-sm-down" data-translate="entity.action.edit">Edit</span></button></div>');
$templateCache.put('app/entities/dept/dept-dialog.html','<!--\n  ~ Copyright (c) 2017 by Julian Feder, julian.feder@yahoo.de\n  ~\n  ~ This product includes software developed at\n  ~ The Apache Software Foundation (http://www.apache.org/).\n  --><form name="editForm" role="form" novalidate ng-submit="vm.save()" show-validation><div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()">&times;</button><h4 class="modal-title" id="myDeptLabel" data-translate="askApp.dept.home.createOrEditLabel">Create or edit a Dept</h4></div><div class="modal-body"><jhi-alert-error></jhi-alert-error><div class="form-group" ng-show="vm.dept.id"><label for="id" data-translate="global.field.id">ID</label><input type="text" class="form-control" id="id" name="id" ng-model="vm.dept.id" readonly="readonly"></div><div class="form-group"><label class="control-label" data-translate="askApp.dept.reference" for="field_reference">Reference</label><input type="text" class="form-control" name="reference" id="field_reference" ng-model="vm.dept.reference" required><div ng-show="editForm.reference.$invalid"><p class="help-block" ng-show="editForm.reference.$error.required" data-translate="entity.validation.required">This field is required.</p><p class="help-block" ng-show="editForm.reference.$error.number" data-translate="entity.validation.number">This field should be a number.</p></div></div><div class="form-group"><label class="control-label" data-translate="askApp.dept.date" for="field_date">Date</label><div class="input-group"><input id="field_date" type="text" class="form-control" name="date" uib-datepicker-popup="{{dateformat}}" ng-model="vm.dept.date" is-open="vm.datePickerOpenStatus.date" required> <span class="input-group-btn"><button type="button" class="btn btn-default" ng-click="vm.openCalendar(\'date\')"><i class="glyphicon glyphicon-calendar"></i></button></span></div><div ng-show="editForm.date.$invalid"><p class="help-block" ng-show="editForm.date.$error.required" data-translate="entity.validation.required">This field is required.</p></div></div><div class="form-group"><label class="control-label" data-translate="askApp.dept.amount" for="field_amount">Amount</label><input type="number" class="form-control" name="amount" id="field_amount" ng-model="vm.dept.amount" required><div ng-show="editForm.amount.$invalid"><p class="help-block" ng-show="editForm.amount.$error.required" data-translate="entity.validation.required">This field is required.</p><p class="help-block" ng-show="editForm.amount.$error.number" data-translate="entity.validation.number">This field should be a number.</p></div></div><div class="form-group"><label class="control-label" data-translate="askApp.dept.comment" for="field_comment">Comment</label><input type="text" class="form-control" name="comment" id="field_comment" ng-model="vm.dept.comment"></div><div class="form-group"><label class="control-label" data-translate="askApp.dept.sepa" for="field_sepa">Sepa</label><input type="checkbox" name="sepa" id="field_sepa" ng-model="vm.dept.sepa"></div><div class="form-group"><label class="control-label" data-translate="askApp.dept.paymentStatus" for="field_paymentStatus">Payment Status</label><select class="form-control" name="paymentStatus" ng-model="vm.dept.paymentStatus" id="field_paymentStatus"><option value="pending" data-translate="askApp.EnumDeptStatus.pending">pending</option><option value="payed" data-translate="askApp.EnumDeptStatus.payed">payed</option><option value="partial" data-translate="askApp.EnumDeptStatus.partial">partial</option><option value="payedToMuch" data-translate="askApp.EnumDeptStatus.payedToMuch">payedToMuch</option><option value="prePayed" data-translate="askApp.EnumDeptStatus.prePayed">prePayed</option></select></div><div class="form-group"><label data-translate="askApp.dept.profile" for="field_profile">Profile</label><select class="form-control" id="field_profile" name="profile" ng-model="vm.dept.profile" ng-options="profile as profile.id for profile in vm.profiles track by profile.id" required></select></div><div ng-show="editForm.profile.$invalid"><p class="help-block" ng-show="editForm.profile.$error.required" data-translate="entity.validation.required">This field is required.</p></div><div class="form-group"><label data-translate="askApp.dept.project" for="field_project">Project</label><select class="form-control" id="field_project" name="project" ng-model="vm.dept.project" ng-options="project as project.id for project in vm.projects track by project.id"><option value=""></option></select></div><div class="form-group"><label data-translate="askApp.dept.dinghyEvent" for="field_dinghyEvent">Dinghy Event</label><select class="form-control" id="field_dinghyEvent" name="dinghyEvent" ng-model="vm.dept.dinghyEvent" ng-options="dinghyEvent as dinghyEvent.id for dinghyEvent in vm.dinghyevents track by dinghyEvent.id"><option value=""></option></select></div></div><div class="modal-footer"><button type="button" class="btn btn-default" data-dismiss="modal" ng-click="vm.clear()"><span class="glyphicon glyphicon-ban-circle"></span>&nbsp;<span data-translate="entity.action.cancel">Cancel</span></button> <button type="submit" ng-disabled="editForm.$invalid || vm.isSaving" class="btn btn-primary"><span class="glyphicon glyphicon-save"></span>&nbsp;<span data-translate="entity.action.save">Save</span></button></div></form>');
$templateCache.put('app/entities/dept/depts.html','<!--\n  ~ Copyright (c) 2017 by Julian Feder, julian.feder@yahoo.de\n  ~\n  ~ This product includes software developed at\n  ~ The Apache Software Foundation (http://www.apache.org/).\n  --><div><h2 data-translate="askApp.dept.home.title">Depts</h2><jhi-alert></jhi-alert><div class="container-fluid"><div class="row"><div class="col-xs-4 no-padding-left"><button class="btn btn-primary" ui-sref="dept.new"><span class="glyphicon glyphicon-plus"></span> <span class="hidden-xs-down" data-translate="askApp.dept.home.createLabel">Create new Dept</span></button></div><div class="col-xs-8 no-padding-right"><form name="searchForm" class="form-inline"><div class="input-group pull-right"><input type="text" class="form-control" ng-model="vm.searchQuery" id="searchQuery" placeholder="{{ \'askApp.dept.home.search\' | translate }}"> <span class="input-group-btn width-min"><button class="btn btn-info" ng-click="vm.search(vm.searchQuery)"><span class="glyphicon glyphicon-search"></span></button> </span><span class="input-group-btn width-min" ng-if="vm.currentSearch"><button class="btn btn-info" ng-click="vm.clear()"><span class="glyphicon glyphicon-trash"></span></button></span></div></form></div></div></div><br><div class="table-responsive"><table class="jh-table table table-striped"><thead><tr jh-sort="vm.predicate" ascending="vm.reverse" callback="vm.transition()"><th jh-sort-by="id"><span data-translate="global.field.id">ID</span> <span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="reference"><span data-translate="askApp.dept.reference">Reference</span> <span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="date"><span data-translate="askApp.dept.date">Date</span> <span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="amount"><span data-translate="askApp.dept.amount">Amount</span> <span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="comment"><span data-translate="askApp.dept.comment">Comment</span> <span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="sepa"><span data-translate="askApp.dept.sepa">Sepa</span> <span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="paymentStatus"><span data-translate="askApp.dept.paymentStatus">Payment Status</span> <span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="payed">Bezahlt <span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="profile.id"><span data-translate="askApp.dept.profile">Profile</span> <span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="project.id"><span data-translate="askApp.dept.project">Project</span> <span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="dinghyEvent.id"><span data-translate="askApp.dept.dinghyEvent">Dinghy Event</span> <span class="glyphicon glyphicon-sort"></span></th><th></th></tr></thead><tbody><tr ng-repeat="dept in vm.depts track by dept.id"><td><a ui-sref="dept-detail({id:dept.id})">{{dept.id}}</a></td><td>{{dept.reference}}</td><td>{{dept.date | date:\'mediumDate\'}}</td><td>{{dept.amount}}\u20AC</td><td>{{dept.comment}}</td><td>{{dept.sepa}}</td><td data-translate="{{\'askApp.EnumDeptStatus.\' + dept.paymentStatus}}">{{dept.paymentStatus}}</td><td>{{dept.payed}}\u20AC</td><td><a ui-sref="profile-detail({id:dept.profile.id})">{{dept.profile.id}}</a></td><td><a ui-sref="project-detail({id:dept.project.id})">{{dept.project.id}}</a></td><td><a ui-sref="dinghy-event-detail({id:dept.dinghyEvent.id})">{{dept.dinghyEvent.id}}</a></td><td class="text-right"><div class="btn-group flex-btn-group-container"><button type="submit" ui-sref="dept-detail({id:dept.id})" class="btn btn-info btn-sm"><span class="glyphicon glyphicon-eye-open"></span> <span class="hidden-sm-down" data-translate="entity.action.view"></span></button> <button type="submit" ui-sref="dept.edit({id:dept.id})" class="btn btn-primary btn-sm"><span class="glyphicon glyphicon-pencil"></span> <span class="hidden-sm-down" data-translate="entity.action.edit"></span></button> <button type="submit" ui-sref="dept.delete({id:dept.id})" class="btn btn-danger btn-sm"><span class="glyphicon glyphicon-remove-circle"></span> <span class="hidden-sm-down" data-translate="entity.action.delete"></span></button></div></td></tr></tbody></table></div><div class="text-center"><jhi-item-count page="vm.page" total="vm.queryCount" items-per-page="vm.itemsPerPage"></jhi-item-count><uib-pagination class="pagination-sm" total-items="vm.totalItems" items-per-page="vm.itemsPerPage" ng-model="vm.page" ng-change="vm.transition()"></uib-pagination></div></div>');
$templateCache.put('app/entities/dinghy/dinghies.html','<div><h2 data-translate="askApp.dinghy.home.title">Dinghies</h2><jhi-alert></jhi-alert><div class="container-fluid"><div class="row"><div class="col-xs-4 no-padding-left"><button class="btn btn-primary" ui-sref="dinghy.new"><span class="glyphicon glyphicon-plus"></span> <span class="hidden-xs-down" data-translate="askApp.dinghy.home.createLabel">Create new Dinghy</span></button></div><div class="col-xs-8 no-padding-right"><form name="searchForm" class="form-inline"><div class="input-group pull-right"><input type="text" class="form-control" ng-model="vm.searchQuery" id="searchQuery" placeholder="{{ \'askApp.dinghy.home.search\' | translate }}"> <span class="input-group-btn width-min"><button class="btn btn-info" ng-click="vm.search(vm.searchQuery)"><span class="glyphicon glyphicon-search"></span></button> </span><span class="input-group-btn width-min" ng-if="vm.currentSearch"><button class="btn btn-info" ng-click="vm.clear()"><span class="glyphicon glyphicon-trash"></span></button></span></div></form></div></div></div><br><div class="table-responsive"><table class="jh-table table table-striped"><thead><tr jh-sort="vm.predicate" ascending="vm.reverse" callback="vm.transition()"><th jh-sort-by="id"><span data-translate="global.field.id">ID</span> <span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="name"><span data-translate="askApp.dinghy.name">Name</span> <span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="description"><span data-translate="askApp.dinghy.description">Description</span> <span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="comment"><span data-translate="askApp.dinghy.comment">Comment</span> <span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="available"><span data-translate="askApp.dinghy.available">Available</span> <span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="type"><span data-translate="askApp.dinghy.type">Type</span> <span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="active"><span data-translate="askApp.dinghy.active">Active</span> <span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="dateDeactivated"><span data-translate="askApp.dinghy.dateDeactivated">Date Deactivated</span> <span class="glyphicon glyphicon-sort"></span></th><th></th></tr></thead><tbody><tr ng-repeat="dinghy in vm.dinghies track by dinghy.id"><td><a ui-sref="dinghy-detail({id:dinghy.id})">{{dinghy.id}}</a></td><td>{{dinghy.name}}</td><td>{{dinghy.description}}</td><td>{{dinghy.comment}}</td><td>{{dinghy.available}}</td><td>{{dinghy.type}}</td><td>{{dinghy.active}}</td><td>{{dinghy.dateDeactivated | date:\'mediumDate\'}}</td><td class="text-right"><div class="btn-group flex-btn-group-container"><button type="submit" ui-sref="dinghy-detail({id:dinghy.id})" class="btn btn-info btn-sm"><span class="glyphicon glyphicon-eye-open"></span> <span class="hidden-sm-down" data-translate="entity.action.view"></span></button> <button type="submit" ui-sref="dinghy.edit({id:dinghy.id})" class="btn btn-primary btn-sm"><span class="glyphicon glyphicon-pencil"></span> <span class="hidden-sm-down" data-translate="entity.action.edit"></span></button> <button type="submit" ui-sref="dinghy.delete({id:dinghy.id})" class="btn btn-danger btn-sm"><span class="glyphicon glyphicon-remove-circle"></span> <span class="hidden-sm-down" data-translate="entity.action.delete"></span></button></div></td></tr></tbody></table></div><div class="text-center"><jhi-item-count page="vm.page" total="vm.queryCount" items-per-page="vm.itemsPerPage"></jhi-item-count><uib-pagination class="pagination-sm" total-items="vm.totalItems" items-per-page="vm.itemsPerPage" ng-model="vm.page" ng-change="vm.transition()"></uib-pagination></div></div>');
$templateCache.put('app/entities/dinghy/dinghy-delete-dialog.html','<form name="deleteForm" ng-submit="vm.confirmDelete(vm.dinghy.id)"><div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()">&times;</button><h4 class="modal-title" data-translate="entity.delete.title">Confirm delete operation</h4></div><div class="modal-body"><jhi-alert-error></jhi-alert-error><p data-translate="askApp.dinghy.delete.question" translate-values="{id: \'{{vm.dinghy.id}}\'}">Are you sure you want to delete this Dinghy?</p></div><div class="modal-footer"><button type="button" class="btn btn-default" data-dismiss="modal" ng-click="vm.clear()"><span class="glyphicon glyphicon-ban-circle"></span>&nbsp;<span data-translate="entity.action.cancel">Cancel</span></button> <button type="submit" ng-disabled="deleteForm.$invalid" class="btn btn-danger"><span class="glyphicon glyphicon-remove-circle"></span>&nbsp;<span data-translate="entity.action.delete">Delete</span></button></div></form>');
$templateCache.put('app/entities/dinghy/dinghy-detail.html','<div><h2><span data-translate="askApp.dinghy.detail.title">Dinghy</span> {{vm.dinghy.id}}</h2><hr><jhi-alert-error></jhi-alert-error><dl class="dl-horizontal jh-entity-details"><dt><span data-translate="askApp.dinghy.name">Name</span></dt><dd><span>{{vm.dinghy.name}}</span></dd><dt><span data-translate="askApp.dinghy.description">Description</span></dt><dd><span>{{vm.dinghy.description}}</span></dd><dt><span data-translate="askApp.dinghy.comment">Comment</span></dt><dd><span>{{vm.dinghy.comment}}</span></dd><dt><span data-translate="askApp.dinghy.available">Available</span></dt><dd><span>{{vm.dinghy.available}}</span></dd><dt><span data-translate="askApp.dinghy.type">Type</span></dt><dd><span>{{vm.dinghy.type}}</span></dd><dt><span data-translate="askApp.dinghy.active">Active</span></dt><dd><span>{{vm.dinghy.active}}</span></dd><dt><span data-translate="askApp.dinghy.dateDeactivated">Date Deactivated</span></dt><dd><span>{{vm.dinghy.dateDeactivated | date:\'mediumDate\'}}</span></dd></dl><button type="submit" ui-sref="{{ vm.previousState }}" class="btn btn-info"><span class="glyphicon glyphicon-arrow-left"></span>&nbsp;<span data-translate="entity.action.back"> Back</span></button> <button type="button" ui-sref="dinghy-detail.edit({id:vm.dinghy.id})" class="btn btn-primary"><span class="glyphicon glyphicon-pencil"></span> <span class="hidden-sm-down" data-translate="entity.action.edit">Edit</span></button></div>');
$templateCache.put('app/entities/dinghy/dinghy-dialog.html','<form name="editForm" role="form" novalidate ng-submit="vm.save()" show-validation><div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()">&times;</button><h4 class="modal-title" id="myDinghyLabel" data-translate="askApp.dinghy.home.createOrEditLabel">Create or edit a Dinghy</h4></div><div class="modal-body"><jhi-alert-error></jhi-alert-error><div class="form-group" ng-show="vm.dinghy.id"><label for="id" data-translate="global.field.id">ID</label><input type="text" class="form-control" id="id" name="id" ng-model="vm.dinghy.id" readonly="readonly"></div><div class="form-group"><label class="control-label" data-translate="askApp.dinghy.name" for="field_name">Name</label><input type="text" class="form-control" name="name" id="field_name" ng-model="vm.dinghy.name" required><div ng-show="editForm.name.$invalid"><p class="help-block" ng-show="editForm.name.$error.required" data-translate="entity.validation.required">This field is required.</p></div></div><div class="form-group"><label class="control-label" data-translate="askApp.dinghy.description" for="field_description">Description</label><input type="text" class="form-control" name="description" id="field_description" ng-model="vm.dinghy.description"></div><div class="form-group"><label class="control-label" data-translate="askApp.dinghy.comment" for="field_comment">Comment</label><input type="text" class="form-control" name="comment" id="field_comment" ng-model="vm.dinghy.comment"></div><div class="form-group"><label class="control-label" data-translate="askApp.dinghy.available" for="field_available">Available</label><input type="checkbox" name="available" id="field_available" ng-model="vm.dinghy.available"><div ng-show="editForm.available.$invalid"><p class="help-block" ng-show="editForm.available.$error.required" data-translate="entity.validation.required">This field is required.</p></div></div><div class="form-group"><label class="control-label" data-translate="askApp.dinghy.type" for="field_type">Type</label><input type="text" class="form-control" name="type" id="field_type" ng-model="vm.dinghy.type"></div><div class="form-group"><label class="control-label" data-translate="askApp.dinghy.active" for="field_active">Active</label><input type="checkbox" name="active" id="field_active" ng-model="vm.dinghy.active"><div ng-show="editForm.active.$invalid"><p class="help-block" ng-show="editForm.active.$error.required" data-translate="entity.validation.required">This field is required.</p></div></div><div class="form-group"><label class="control-label" data-translate="askApp.dinghy.dateDeactivated" for="field_dateDeactivated">Date Deactivated</label><div class="input-group"><input id="field_dateDeactivated" type="text" class="form-control" name="dateDeactivated" uib-datepicker-popup="{{dateformat}}" ng-model="vm.dinghy.dateDeactivated" is-open="vm.datePickerOpenStatus.dateDeactivated"> <span class="input-group-btn"><button type="button" class="btn btn-default" ng-click="vm.openCalendar(\'dateDeactivated\')"><i class="glyphicon glyphicon-calendar"></i></button></span></div></div></div><div class="modal-footer"><button type="button" class="btn btn-default" data-dismiss="modal" ng-click="vm.clear()"><span class="glyphicon glyphicon-ban-circle"></span>&nbsp;<span data-translate="entity.action.cancel">Cancel</span></button> <button type="submit" ng-disabled="editForm.$invalid || vm.isSaving" class="btn btn-primary"><span class="glyphicon glyphicon-save"></span>&nbsp;<span data-translate="entity.action.save">Save</span></button></div></form>');
$templateCache.put('app/entities/dinghy-booking/dinghy-booking-delete-dialog.html','<form name="deleteForm" ng-submit="vm.confirmDelete(vm.dinghyBooking.id)"><div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()">&times;</button><h4 class="modal-title" data-translate="entity.delete.title">Confirm delete operation</h4></div><div class="modal-body"><jhi-alert-error></jhi-alert-error><p data-translate="askApp.dinghyBooking.delete.question" translate-values="{id: \'{{vm.dinghyBooking.id}}\'}">Are you sure you want to delete this Dinghy Booking?</p></div><div class="modal-footer"><button type="button" class="btn btn-default" data-dismiss="modal" ng-click="vm.clear()"><span class="glyphicon glyphicon-ban-circle"></span>&nbsp;<span data-translate="entity.action.cancel">Cancel</span></button> <button type="submit" ng-disabled="deleteForm.$invalid" class="btn btn-danger"><span class="glyphicon glyphicon-remove-circle"></span>&nbsp;<span data-translate="entity.action.delete">Delete</span></button></div></form>');
$templateCache.put('app/entities/dinghy-booking/dinghy-booking-detail.html','<div><h2><span data-translate="askApp.dinghyBooking.detail.title">Dinghy Booking</span> {{vm.dinghyBooking.id}}</h2><hr><jhi-alert-error></jhi-alert-error><dl class="dl-horizontal jh-entity-details"><dt><span data-translate="askApp.dinghyBooking.bookingDate">Booking Date</span></dt><dd><span>{{vm.dinghyBooking.bookingDate | date:\'medium\'}}</span></dd><dt><span data-translate="askApp.dinghyBooking.price">Price</span></dt><dd><span>{{vm.dinghyBooking.price}}</span></dd><dt><span data-translate="askApp.dinghyBooking.bookingStatus">Booking Status</span></dt><dd><span data-translate="{{\'askApp.EnumBookingStatusType.\' + vm.dinghyBooking.bookingStatus}}">{{vm.dinghyBooking.bookingStatus}}</span></dd><dt><span data-translate="askApp.dinghyBooking.comment">Comment</span></dt><dd><span>{{vm.dinghyBooking.comment}}</span></dd><dt><span data-translate="askApp.dinghyBooking.individualQuestionAnswer">Individual Question Answer</span></dt><dd><span>{{vm.dinghyBooking.individualQuestionAnswer}}</span></dd><dt><span data-translate="askApp.dinghyBooking.commentDinghy">Comment Dinghy</span></dt><dd><span>{{vm.dinghyBooking.commentDinghy}}</span></dd><dt><span data-translate="askApp.dinghyBooking.firstName">First Name</span></dt><dd><span>{{vm.dinghyBooking.firstName}}</span></dd><dt><span data-translate="askApp.dinghyBooking.lastName">Last Name</span></dt><dd><span>{{vm.dinghyBooking.lastName}}</span></dd><dt><span data-translate="askApp.dinghyBooking.email">Email</span></dt><dd><span>{{vm.dinghyBooking.email}}</span></dd><dt><span data-translate="askApp.dinghyBooking.validationDate">Validation Date</span></dt><dd><span>{{vm.dinghyBooking.validationDate | date:\'medium\'}}</span></dd><dt><span data-translate="askApp.dinghyBooking.event">Event</span></dt><dd><a ui-sref="dinghy-event-detail({id:vm.dinghyBooking.event.id})">{{vm.dinghyBooking.event.id}}</a></dd><dt><span data-translate="askApp.dinghyBooking.profile">Profile</span></dt><dd><a ui-sref="profile-detail({id:vm.dinghyBooking.profile.id})">{{vm.dinghyBooking.profile.id}}</a></dd><dt><span data-translate="askApp.dinghyBooking.dept">Dept</span></dt><dd><a ui-sref="dept-detail({id:vm.dinghyBooking.dept.id})">{{vm.dinghyBooking.dept.id}}</a></dd><dt><span data-translate="askApp.dinghyBooking.dinghy">Dinghy</span></dt><dd><a ui-sref="dinghy-detail({id:vm.dinghyBooking.dinghy.id})">{{vm.dinghyBooking.dinghy.name}}</a></dd></dl><button type="submit" ui-sref="{{ vm.previousState }}" class="btn btn-info"><span class="glyphicon glyphicon-arrow-left"></span>&nbsp;<span data-translate="entity.action.back"> Back</span></button> <button type="button" ui-sref="dinghy-booking-detail.edit({id:vm.dinghyBooking.id})" class="btn btn-primary"><span class="glyphicon glyphicon-pencil"></span> <span class="hidden-sm-down" data-translate="entity.action.edit">Edit</span></button></div>');
$templateCache.put('app/entities/dinghy-booking/dinghy-booking-dialog.html','<form name="editForm" role="form" novalidate ng-submit="vm.save()" show-validation><div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()">&times;</button><h4 class="modal-title" id="myDinghyBookingLabel" data-translate="askApp.dinghyBooking.home.createOrEditLabel">Create or edit a Dinghy Booking</h4></div><div class="modal-body"><jhi-alert-error></jhi-alert-error><div class="form-group" ng-show="vm.dinghyBooking.id"><label for="id" data-translate="global.field.id">ID</label><input type="text" class="form-control" id="id" name="id" ng-model="vm.dinghyBooking.id" readonly="readonly"></div><div class="form-group"><label class="control-label" data-translate="askApp.dinghyBooking.bookingDate" for="field_bookingDate">Booking Date</label><div class="input-group"><input id="field_bookingDate" type="text" class="form-control" name="bookingDate" datetime-picker="{{dateformat}}" ng-model="vm.dinghyBooking.bookingDate" is-open="vm.datePickerOpenStatus.bookingDate" required> <span class="input-group-btn"><button type="button" class="btn btn-default" ng-click="vm.openCalendar(\'bookingDate\')"><i class="glyphicon glyphicon-calendar"></i></button></span></div><div ng-show="editForm.bookingDate.$invalid"><p class="help-block" ng-show="editForm.bookingDate.$error.required" data-translate="entity.validation.required">This field is required.</p><p class="help-block" ng-show="editForm.bookingDate.$error.ZonedDateTimelocal" data-translate="entity.validation.ZonedDateTimelocal">This field should be a date and time.</p></div></div><div class="form-group"><label class="control-label" data-translate="askApp.dinghyBooking.price" for="field_price">Price</label><input type="number" class="form-control" name="price" id="field_price" ng-model="vm.dinghyBooking.price"></div><div class="form-group"><label class="control-label" data-translate="askApp.dinghyBooking.bookingStatus" for="field_bookingStatus">Booking Status</label><select class="form-control" name="bookingStatus" ng-model="vm.dinghyBooking.bookingStatus" id="field_bookingStatus" required><option value="angemeldet" data-translate="askApp.EnumBookingStatusType.angemeldet">angemeldet</option><option value="zurueckgetreten" data-translate="askApp.EnumBookingStatusType.zurueckgetreten">zurueckgetreten</option><option value="abgelehnt" data-translate="askApp.EnumBookingStatusType.abgelehnt">abgelehnt</option><option value="warteliste" data-translate="askApp.EnumBookingStatusType.warteliste">warteliste</option></select><div ng-show="editForm.bookingStatus.$invalid"><p class="help-block" ng-show="editForm.bookingStatus.$error.required" data-translate="entity.validation.required">This field is required.</p></div></div><div class="form-group"><label class="control-label" data-translate="askApp.dinghyBooking.comment" for="field_comment">Comment</label><input type="text" class="form-control" name="comment" id="field_comment" ng-model="vm.dinghyBooking.comment"></div><div class="form-group"><label class="control-label" data-translate="askApp.dinghyBooking.individualQuestionAnswer" for="field_individualQuestionAnswer">Individual Question Answer</label><input type="text" class="form-control" name="individualQuestionAnswer" id="field_individualQuestionAnswer" ng-model="vm.dinghyBooking.individualQuestionAnswer"></div><div class="form-group"><label class="control-label" data-translate="askApp.dinghyBooking.commentDinghy" for="field_commentDinghy">Comment Dinghy</label><input type="text" class="form-control" name="commentDinghy" id="field_commentDinghy" ng-model="vm.dinghyBooking.commentDinghy"></div><div class="form-group"><label class="control-label" data-translate="askApp.dinghyBooking.firstName" for="field_firstName">First Name</label><input type="text" class="form-control" name="firstName" id="field_firstName" ng-model="vm.dinghyBooking.firstName" ng-maxlength="50"><div ng-show="editForm.firstName.$invalid"><p class="help-block" ng-show="editForm.firstName.$error.maxlength" data-translate="entity.validation.maxlength" translate-value-max="50">This field cannot be longer than 50 characters.</p></div></div><div class="form-group"><label class="control-label" data-translate="askApp.dinghyBooking.lastName" for="field_lastName">Last Name</label><input type="text" class="form-control" name="lastName" id="field_lastName" ng-model="vm.dinghyBooking.lastName" ng-maxlength="50"><div ng-show="editForm.lastName.$invalid"><p class="help-block" ng-show="editForm.lastName.$error.maxlength" data-translate="entity.validation.maxlength" translate-value-max="50">This field cannot be longer than 50 characters.</p></div></div><div class="form-group"><label class="control-label" data-translate="askApp.dinghyBooking.email" for="field_email">Email</label><input type="text" class="form-control" name="email" id="field_email" ng-model="vm.dinghyBooking.email" ng-minlength="5" ng-maxlength="100"><div ng-show="editForm.email.$invalid"><p class="help-block" ng-show="editForm.email.$error.minlength" data-translate="entity.validation.minlength" translate-value-min="5">This field is required to be at least 5 characters.</p><p class="help-block" ng-show="editForm.email.$error.maxlength" data-translate="entity.validation.maxlength" translate-value-max="100">This field cannot be longer than 100 characters.</p></div></div><div class="form-group"><label class="control-label" data-translate="askApp.dinghyBooking.validationDate" for="field_validationDate">Validation Date</label><div class="input-group"><input id="field_validationDate" type="text" class="form-control" name="validationDate" datetime-picker="{{dateformat}}" ng-model="vm.dinghyBooking.validationDate" is-open="vm.datePickerOpenStatus.validationDate" required> <span class="input-group-btn"><button type="button" class="btn btn-default" ng-click="vm.openCalendar(\'validationDate\')"><i class="glyphicon glyphicon-calendar"></i></button></span></div><div ng-show="editForm.validationDate.$invalid"><p class="help-block" ng-show="editForm.validationDate.$error.required" data-translate="entity.validation.required">This field is required.</p><p class="help-block" ng-show="editForm.validationDate.$error.ZonedDateTimelocal" data-translate="entity.validation.ZonedDateTimelocal">This field should be a date and time.</p></div></div><div class="form-group"><label data-translate="askApp.dinghyBooking.event" for="field_event">Event</label><select class="form-control" id="field_event" name="event" ng-model="vm.dinghyBooking.event" ng-options="dinghyEvent as dinghyEvent.id for dinghyEvent in vm.dinghyevents track by dinghyEvent.id" required></select></div><div ng-show="editForm.event.$invalid"><p class="help-block" ng-show="editForm.event.$error.required" data-translate="entity.validation.required">This field is required.</p></div><div class="form-group"><label data-translate="askApp.dinghyBooking.profile" for="field_profile">Profile</label><select class="form-control" id="field_profile" name="profile" ng-model="vm.dinghyBooking.profile" ng-options="profile as profile.id for profile in vm.profiles track by profile.id"><option value=""></option></select></div><div class="form-group"><label data-translate="askApp.dinghyBooking.dept" for="field_dept">Dept</label><select class="form-control" id="field_dept" name="dept" ng-model="vm.dinghyBooking.dept" ng-options="dept as dept.id for dept in vm.depts | orderBy:\'id\' track by dept.id"><option value=""></option></select></div><div class="form-group"><label data-translate="askApp.dinghyBooking.dinghy" for="field_dinghy">Dinghy</label><select class="form-control" id="field_dinghy" name="dinghy" ng-model="vm.dinghyBooking.dinghy" ng-options="dinghy as dinghy.name for dinghy in vm.dinghies track by dinghy.id"><option value=""></option></select></div></div><div class="modal-footer"><button type="button" class="btn btn-default" data-dismiss="modal" ng-click="vm.clear()"><span class="glyphicon glyphicon-ban-circle"></span>&nbsp;<span data-translate="entity.action.cancel">Cancel</span></button> <button type="submit" ng-disabled="editForm.$invalid || vm.isSaving" class="btn btn-primary"><span class="glyphicon glyphicon-save"></span>&nbsp;<span data-translate="entity.action.save">Save</span></button></div></form>');
$templateCache.put('app/entities/dinghy-booking/dinghy-bookings.html','<div><h2 data-translate="askApp.dinghyBooking.home.title">Dinghy Bookings</h2><jhi-alert></jhi-alert><div class="container-fluid"><div class="row"><div class="col-xs-4 no-padding-left"><button class="btn btn-primary" ui-sref="dinghy-booking.new"><span class="glyphicon glyphicon-plus"></span> <span class="hidden-xs-down" data-translate="askApp.dinghyBooking.home.createLabel">Create new Dinghy Booking</span></button></div><div class="col-xs-8 no-padding-right"><form name="searchForm" class="form-inline"><div class="input-group pull-right"><input type="text" class="form-control" ng-model="vm.searchQuery" id="searchQuery" placeholder="{{ \'askApp.dinghyBooking.home.search\' | translate }}"> <span class="input-group-btn width-min"><button class="btn btn-info" ng-click="vm.search(vm.searchQuery)"><span class="glyphicon glyphicon-search"></span></button> </span><span class="input-group-btn width-min" ng-if="vm.currentSearch"><button class="btn btn-info" ng-click="vm.clear()"><span class="glyphicon glyphicon-trash"></span></button></span></div></form></div></div></div><br><div class="table-responsive"><table class="jh-table table table-striped"><thead><tr jh-sort="vm.predicate" ascending="vm.reverse" callback="vm.transition()"><th jh-sort-by="id"><span data-translate="global.field.id">ID</span> <span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="bookingDate"><span data-translate="askApp.dinghyBooking.bookingDate">Booking Date</span> <span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="price"><span data-translate="askApp.dinghyBooking.price">Price</span> <span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="bookingStatus"><span data-translate="askApp.dinghyBooking.bookingStatus">Booking Status</span> <span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="comment"><span data-translate="askApp.dinghyBooking.comment">Comment</span> <span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="individualQuestionAnswer"><span data-translate="askApp.dinghyBooking.individualQuestionAnswer">Individual Question Answer</span> <span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="commentDinghy"><span data-translate="askApp.dinghyBooking.commentDinghy">Comment Dinghy</span> <span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="firstName"><span data-translate="askApp.dinghyBooking.firstName">First Name</span> <span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="lastName"><span data-translate="askApp.dinghyBooking.lastName">Last Name</span> <span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="email"><span data-translate="askApp.dinghyBooking.email">Email</span> <span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="validationDate"><span data-translate="askApp.dinghyBooking.validationDate">Validation Date</span> <span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="event.id"><span data-translate="askApp.dinghyBooking.event">Event</span> <span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="profile.id"><span data-translate="askApp.dinghyBooking.profile">Profile</span> <span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="dept.id"><span data-translate="askApp.dinghyBooking.dept">Dept</span> <span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="dinghy.name"><span data-translate="askApp.dinghyBooking.dinghy">Dinghy</span> <span class="glyphicon glyphicon-sort"></span></th><th></th></tr></thead><tbody><tr ng-repeat="dinghyBooking in vm.dinghyBookings track by dinghyBooking.id"><td><a ui-sref="dinghy-booking-detail({id:dinghyBooking.id})">{{dinghyBooking.id}}</a></td><td>{{dinghyBooking.bookingDate | date:\'medium\'}}</td><td>{{dinghyBooking.price}}</td><td data-translate="{{\'askApp.EnumBookingStatusType.\' + dinghyBooking.bookingStatus}}">{{dinghyBooking.bookingStatus}}</td><td>{{dinghyBooking.comment}}</td><td>{{dinghyBooking.individualQuestionAnswer}}</td><td>{{dinghyBooking.commentDinghy}}</td><td>{{dinghyBooking.firstName}}</td><td>{{dinghyBooking.lastName}}</td><td>{{dinghyBooking.email}}</td><td>{{dinghyBooking.validationDate | date:\'medium\'}}</td><td><a ui-sref="dinghy-event-detail({id:dinghyBooking.event.id})">{{dinghyBooking.event.id}}</a></td><td><a ui-sref="profile-detail({id:dinghyBooking.profile.id})">{{dinghyBooking.profile.id}}</a></td><td><a ui-sref="dept-detail({id:dinghyBooking.dept.id})">{{dinghyBooking.dept.id}}</a></td><td><a ui-sref="dinghy-detail({id:dinghyBooking.dinghy.id})">{{dinghyBooking.dinghy.name}}</a></td><td class="text-right"><div class="btn-group flex-btn-group-container"><button type="submit" ui-sref="dinghy-booking-detail({id:dinghyBooking.id})" class="btn btn-info btn-sm"><span class="glyphicon glyphicon-eye-open"></span> <span class="hidden-sm-down" data-translate="entity.action.view"></span></button> <button type="submit" ui-sref="dinghy-booking.edit({id:dinghyBooking.id})" class="btn btn-primary btn-sm"><span class="glyphicon glyphicon-pencil"></span> <span class="hidden-sm-down" data-translate="entity.action.edit"></span></button> <button type="submit" ui-sref="dinghy-booking.delete({id:dinghyBooking.id})" class="btn btn-danger btn-sm"><span class="glyphicon glyphicon-remove-circle"></span> <span class="hidden-sm-down" data-translate="entity.action.delete"></span></button></div></td></tr></tbody></table></div><div class="text-center"><jhi-item-count page="vm.page" total="vm.queryCount" items-per-page="vm.itemsPerPage"></jhi-item-count><uib-pagination class="pagination-sm" total-items="vm.totalItems" items-per-page="vm.itemsPerPage" ng-model="vm.page" ng-change="vm.transition()"></uib-pagination></div></div>');
$templateCache.put('app/entities/dinghy-event/dinghy-event-delete-dialog.html','<form name="deleteForm" ng-submit="vm.confirmDelete(vm.dinghyEvent.id)"><div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()">&times;</button><h4 class="modal-title" data-translate="entity.delete.title">Confirm delete operation</h4></div><div class="modal-body"><jhi-alert-error></jhi-alert-error><p data-translate="askApp.dinghyEvent.delete.question" translate-values="{id: \'{{vm.dinghyEvent.id}}\'}">Are you sure you want to delete this Dinghy Event?</p></div><div class="modal-footer"><button type="button" class="btn btn-default" data-dismiss="modal" ng-click="vm.clear()"><span class="glyphicon glyphicon-ban-circle"></span>&nbsp;<span data-translate="entity.action.cancel">Cancel</span></button> <button type="submit" ng-disabled="deleteForm.$invalid" class="btn btn-danger"><span class="glyphicon glyphicon-remove-circle"></span>&nbsp;<span data-translate="entity.action.delete">Delete</span></button></div></form>');
$templateCache.put('app/entities/dinghy-event/dinghy-event-detail.html','<div><h2><span data-translate="askApp.dinghyEvent.detail.title">Dinghy Event</span> {{vm.dinghyEvent.id}}</h2><hr><jhi-alert-error></jhi-alert-error><dl class="dl-horizontal jh-entity-details"><dt><span data-translate="askApp.dinghyEvent.name">Name</span></dt><dd><span>{{vm.dinghyEvent.name}}</span></dd><dt><span data-translate="askApp.dinghyEvent.type">Type</span></dt><dd><span data-translate="{{\'askApp.EnumDinghyEventType.\' + vm.dinghyEvent.type}}">{{vm.dinghyEvent.type}}</span></dd><dt><span data-translate="askApp.dinghyEvent.fromDate">From Date</span></dt><dd><span>{{vm.dinghyEvent.fromDate | date:\'medium\'}}</span></dd><dt><span data-translate="askApp.dinghyEvent.untilDate">Until Date</span></dt><dd><span>{{vm.dinghyEvent.untilDate | date:\'medium\'}}</span></dd><dt><span data-translate="askApp.dinghyEvent.contactEmail">Contact Email</span></dt><dd><span>{{vm.dinghyEvent.contactEmail}}</span></dd><dt><span data-translate="askApp.dinghyEvent.placeCount">Place Count</span></dt><dd><span>{{vm.dinghyEvent.placeCount}}</span></dd><dt><span data-translate="askApp.dinghyEvent.location">Location</span></dt><dd><span>{{vm.dinghyEvent.location}}</span></dd><dt><span data-translate="askApp.dinghyEvent.identifier">Identifier</span></dt><dd><span>{{vm.dinghyEvent.identifier}}</span></dd><dt><span data-translate="askApp.dinghyEvent.normalPrice">Normal Price</span></dt><dd><span>{{vm.dinghyEvent.normalPrice}}</span></dd><dt><span data-translate="askApp.dinghyEvent.studentPrice">Student Price</span></dt><dd><span>{{vm.dinghyEvent.studentPrice}}</span></dd><dt><span data-translate="askApp.dinghyEvent.guestPrice">Guest Price</span></dt><dd><span>{{vm.dinghyEvent.guestPrice}}</span></dd><dt><span data-translate="askApp.dinghyEvent.description">Description</span></dt><dd><span>{{vm.dinghyEvent.description}}</span></dd><dt><span data-translate="askApp.dinghyEvent.conditions">Conditions</span></dt><dd><span>{{vm.dinghyEvent.conditions}}</span></dd><dt><span data-translate="askApp.dinghyEvent.notes">Notes</span></dt><dd><span>{{vm.dinghyEvent.notes}}</span></dd><dt><span data-translate="askApp.dinghyEvent.visible">Visible</span></dt><dd><span>{{vm.dinghyEvent.visible}}</span></dd><dt><span data-translate="askApp.dinghyEvent.active">Active</span></dt><dd><span>{{vm.dinghyEvent.active}}</span></dd><dt><span data-translate="askApp.dinghyEvent.closed">Closed</span></dt><dd><span>{{vm.dinghyEvent.closed}}</span></dd><dt><span data-translate="askApp.dinghyEvent.canceled">Canceled</span></dt><dd><span>{{vm.dinghyEvent.canceled}}</span></dd><dt><span data-translate="askApp.dinghyEvent.allowGuests">Allow Guests</span></dt><dd><span>{{vm.dinghyEvent.allowGuests}}</span></dd><dt><span data-translate="askApp.dinghyEvent.allowQueue">Allow Queue</span></dt><dd><span>{{vm.dinghyEvent.allowQueue}}</span></dd><dt><span data-translate="askApp.dinghyEvent.individualQuestion">Individual Question</span></dt><dd><span>{{vm.dinghyEvent.individualQuestion}}</span></dd><dt><span data-translate="askApp.dinghyEvent.uid">Uid</span></dt><dd><span>{{vm.dinghyEvent.uid}}</span></dd><dt><span data-translate="askApp.dinghyEvent.version">Version</span></dt><dd><span>{{vm.dinghyEvent.version}}</span></dd><dt><span data-translate="askApp.dinghyEvent.godparent">Godparent</span></dt><dd><a ui-sref="profile-detail({id:vm.dinghyEvent.godparent.id})">{{vm.dinghyEvent.godparent.id}}</a></dd><dt><span data-translate="askApp.dinghyEvent.availableDinghies">Available Dinghies</span></dt><dd><span ng-repeat="availableDinghies in vm.dinghyEvent.availableDinghies"><a ui-sref="dinghy-detail({id: availableDinghies.id})">{{availableDinghies.name}}</a>{{$last ? \'\' : \', \'}}</span></dd></dl><button type="submit" ui-sref="{{ vm.previousState }}" class="btn btn-info"><span class="glyphicon glyphicon-arrow-left"></span>&nbsp;<span data-translate="entity.action.back"> Back</span></button> <button type="button" ui-sref="dinghy-event-detail.edit({id:vm.dinghyEvent.id})" class="btn btn-primary"><span class="glyphicon glyphicon-pencil"></span> <span class="hidden-sm-down" data-translate="entity.action.edit">Edit</span></button></div>');
$templateCache.put('app/entities/dinghy-event/dinghy-event-dialog.html','<form name="editForm" role="form" novalidate ng-submit="vm.save()" show-validation><div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()">&times;</button><h4 class="modal-title" id="myDinghyEventLabel" data-translate="askApp.dinghyEvent.home.createOrEditLabel">Create or edit a Dinghy Event</h4></div><div class="modal-body"><jhi-alert-error></jhi-alert-error><div class="form-group" ng-show="vm.dinghyEvent.id"><label for="id" data-translate="global.field.id">ID</label><input type="text" class="form-control" id="id" name="id" ng-model="vm.dinghyEvent.id" readonly="readonly"></div><div class="form-group"><label class="control-label" data-translate="askApp.dinghyEvent.name" for="field_name">Name</label><input type="text" class="form-control" name="name" id="field_name" ng-model="vm.dinghyEvent.name" required><div ng-show="editForm.name.$invalid"><p class="help-block" ng-show="editForm.name.$error.required" data-translate="entity.validation.required">This field is required.</p></div></div><div class="form-group"><label class="control-label" data-translate="askApp.dinghyEvent.type" for="field_type">Type</label><select class="form-control" name="type" ng-model="vm.dinghyEvent.type" id="field_type" required><option value="leisure" data-translate="askApp.EnumDinghyEventType.leisure">leisure</option><option value="regatta" data-translate="askApp.EnumDinghyEventType.regatta">regatta</option><option value="training" data-translate="askApp.EnumDinghyEventType.training">training</option><option value="engagement" data-translate="askApp.EnumDinghyEventType.engagement">engagement</option></select><div ng-show="editForm.type.$invalid"><p class="help-block" ng-show="editForm.type.$error.required" data-translate="entity.validation.required">This field is required.</p></div></div><div class="form-group"><label class="control-label" data-translate="askApp.dinghyEvent.fromDate" for="field_fromDate">From Date</label><div class="input-group"><input id="field_fromDate" type="text" class="form-control" name="fromDate" datetime-picker="{{dateformat}}" ng-model="vm.dinghyEvent.fromDate" is-open="vm.datePickerOpenStatus.fromDate" required> <span class="input-group-btn"><button type="button" class="btn btn-default" ng-click="vm.openCalendar(\'fromDate\')"><i class="glyphicon glyphicon-calendar"></i></button></span></div><div ng-show="editForm.fromDate.$invalid"><p class="help-block" ng-show="editForm.fromDate.$error.required" data-translate="entity.validation.required">This field is required.</p><p class="help-block" ng-show="editForm.fromDate.$error.ZonedDateTimelocal" data-translate="entity.validation.ZonedDateTimelocal">This field should be a date and time.</p></div></div><div class="form-group"><label class="control-label" data-translate="askApp.dinghyEvent.untilDate" for="field_untilDate">Until Date</label><div class="input-group"><input id="field_untilDate" type="text" class="form-control" name="untilDate" datetime-picker="{{dateformat}}" ng-model="vm.dinghyEvent.untilDate" is-open="vm.datePickerOpenStatus.untilDate" required> <span class="input-group-btn"><button type="button" class="btn btn-default" ng-click="vm.openCalendar(\'untilDate\')"><i class="glyphicon glyphicon-calendar"></i></button></span></div><div ng-show="editForm.untilDate.$invalid"><p class="help-block" ng-show="editForm.untilDate.$error.required" data-translate="entity.validation.required">This field is required.</p><p class="help-block" ng-show="editForm.untilDate.$error.ZonedDateTimelocal" data-translate="entity.validation.ZonedDateTimelocal">This field should be a date and time.</p></div></div><div class="form-group"><label class="control-label" data-translate="askApp.dinghyEvent.contactEmail" for="field_contactEmail">Contact Email</label><input type="text" class="form-control" name="contactEmail" id="field_contactEmail" ng-model="vm.dinghyEvent.contactEmail"></div><div class="form-group"><label class="control-label" data-translate="askApp.dinghyEvent.placeCount" for="field_placeCount">Place Count</label><input type="number" class="form-control" name="placeCount" id="field_placeCount" ng-model="vm.dinghyEvent.placeCount" required min="0"><div ng-show="editForm.placeCount.$invalid"><p class="help-block" ng-show="editForm.placeCount.$error.required" data-translate="entity.validation.required">This field is required.</p><p class="help-block" ng-show="editForm.placeCount.$error.min" data-translate="entity.validation.min" translate-value-min="0">This field should be at least 0.</p><p class="help-block" ng-show="editForm.placeCount.$error.number" data-translate="entity.validation.number">This field should be a number.</p></div></div><div class="form-group"><label class="control-label" data-translate="askApp.dinghyEvent.location" for="field_location">Location</label><input type="text" class="form-control" name="location" id="field_location" ng-model="vm.dinghyEvent.location" required><div ng-show="editForm.location.$invalid"><p class="help-block" ng-show="editForm.location.$error.required" data-translate="entity.validation.required">This field is required.</p></div></div><div class="form-group"><label class="control-label" data-translate="askApp.dinghyEvent.identifier" for="field_identifier">Identifier</label><input type="text" class="form-control" name="identifier" id="field_identifier" ng-model="vm.dinghyEvent.identifier" required><div ng-show="editForm.identifier.$invalid"><p class="help-block" ng-show="editForm.identifier.$error.required" data-translate="entity.validation.required">This field is required.</p></div></div><div class="form-group"><label class="control-label" data-translate="askApp.dinghyEvent.normalPrice" for="field_normalPrice">Normal Price</label><input type="number" class="form-control" name="normalPrice" id="field_normalPrice" ng-model="vm.dinghyEvent.normalPrice"></div><div class="form-group"><label class="control-label" data-translate="askApp.dinghyEvent.studentPrice" for="field_studentPrice">Student Price</label><input type="number" class="form-control" name="studentPrice" id="field_studentPrice" ng-model="vm.dinghyEvent.studentPrice"></div><div class="form-group"><label class="control-label" data-translate="askApp.dinghyEvent.guestPrice" for="field_guestPrice">Guest Price</label><input type="number" class="form-control" name="guestPrice" id="field_guestPrice" ng-model="vm.dinghyEvent.guestPrice"></div><div class="form-group"><label class="control-label" data-translate="askApp.dinghyEvent.description" for="field_description">Description</label><input type="text" class="form-control" name="description" id="field_description" ng-model="vm.dinghyEvent.description"></div><div class="form-group"><label class="control-label" data-translate="askApp.dinghyEvent.conditions" for="field_conditions">Conditions</label><input type="text" class="form-control" name="conditions" id="field_conditions" ng-model="vm.dinghyEvent.conditions"></div><div class="form-group"><label class="control-label" data-translate="askApp.dinghyEvent.notes" for="field_notes">Notes</label><input type="text" class="form-control" name="notes" id="field_notes" ng-model="vm.dinghyEvent.notes"></div><div class="form-group"><label class="control-label" data-translate="askApp.dinghyEvent.visible" for="field_visible">Visible</label><input type="checkbox" name="visible" id="field_visible" ng-model="vm.dinghyEvent.visible"><div ng-show="editForm.visible.$invalid"><p class="help-block" ng-show="editForm.visible.$error.required" data-translate="entity.validation.required">This field is required.</p></div></div><div class="form-group"><label class="control-label" data-translate="askApp.dinghyEvent.active" for="field_active">Active</label><input type="checkbox" name="active" id="field_active" ng-model="vm.dinghyEvent.active"><div ng-show="editForm.active.$invalid"><p class="help-block" ng-show="editForm.active.$error.required" data-translate="entity.validation.required">This field is required.</p></div></div><div class="form-group"><label class="control-label" data-translate="askApp.dinghyEvent.closed" for="field_closed">Closed</label><input type="checkbox" name="closed" id="field_closed" ng-model="vm.dinghyEvent.closed"><div ng-show="editForm.closed.$invalid"><p class="help-block" ng-show="editForm.closed.$error.required" data-translate="entity.validation.required">This field is required.</p></div></div><div class="form-group"><label class="control-label" data-translate="askApp.dinghyEvent.canceled" for="field_canceled">Canceled</label><input type="checkbox" name="canceled" id="field_canceled" ng-model="vm.dinghyEvent.canceled"><div ng-show="editForm.canceled.$invalid"><p class="help-block" ng-show="editForm.canceled.$error.required" data-translate="entity.validation.required">This field is required.</p></div></div><div class="form-group"><label class="control-label" data-translate="askApp.dinghyEvent.allowGuests" for="field_allowGuests">Allow Guests</label><input type="checkbox" name="allowGuests" id="field_allowGuests" ng-model="vm.dinghyEvent.allowGuests"><div ng-show="editForm.allowGuests.$invalid"><p class="help-block" ng-show="editForm.allowGuests.$error.required" data-translate="entity.validation.required">This field is required.</p></div></div><div class="form-group"><label class="control-label" data-translate="askApp.dinghyEvent.allowQueue" for="field_allowQueue">Allow Queue</label><input type="checkbox" name="allowQueue" id="field_allowQueue" ng-model="vm.dinghyEvent.allowQueue"><div ng-show="editForm.allowQueue.$invalid"><p class="help-block" ng-show="editForm.allowQueue.$error.required" data-translate="entity.validation.required">This field is required.</p></div></div><div class="form-group"><label class="control-label" data-translate="askApp.dinghyEvent.individualQuestion" for="field_individualQuestion">Individual Question</label><input type="text" class="form-control" name="individualQuestion" id="field_individualQuestion" ng-model="vm.dinghyEvent.individualQuestion"></div><div class="form-group"><label class="control-label" data-translate="askApp.dinghyEvent.uid" for="field_uid">Uid</label><input type="text" class="form-control" name="uid" id="field_uid" ng-model="vm.dinghyEvent.uid" ng-minlength="5" ng-maxlength="50"><div ng-show="editForm.uid.$invalid"><p class="help-block" ng-show="editForm.uid.$error.minlength" data-translate="entity.validation.minlength" translate-value-min="5">This field is required to be at least 5 characters.</p><p class="help-block" ng-show="editForm.uid.$error.maxlength" data-translate="entity.validation.maxlength" translate-value-max="50">This field cannot be longer than 50 characters.</p></div></div><div class="form-group"><label class="control-label" data-translate="askApp.dinghyEvent.version" for="field_version">Version</label><input type="number" class="form-control" name="version" id="field_version" ng-model="vm.dinghyEvent.version"></div><div class="form-group"><label data-translate="askApp.dinghyEvent.godparent" for="field_godparent">Godparent</label><select class="form-control" id="field_godparent" name="godparent" ng-model="vm.dinghyEvent.godparent" ng-options="profile as profile.id for profile in vm.profiles track by profile.id"><option value=""></option></select></div><div class="form-group"><label data-translate="askApp.dinghyEvent.availableDinghies" for="field_availableDinghies">Available Dinghies</label><select class="form-control" id="field_availableDinghies" multiple="multiple" name="availableDinghies" ng-model="vm.dinghyEvent.availableDinghies" ng-options="dinghy as dinghy.name for dinghy in vm.dinghies track by dinghy.id"></select></div></div><div class="modal-footer"><button type="button" class="btn btn-default" data-dismiss="modal" ng-click="vm.clear()"><span class="glyphicon glyphicon-ban-circle"></span>&nbsp;<span data-translate="entity.action.cancel">Cancel</span></button> <button type="submit" ng-disabled="editForm.$invalid || vm.isSaving" class="btn btn-primary"><span class="glyphicon glyphicon-save"></span>&nbsp;<span data-translate="entity.action.save">Save</span></button></div></form>');
$templateCache.put('app/entities/dinghy-event/dinghy-events.html','<div><h2 data-translate="askApp.dinghyEvent.home.title">Dinghy Events</h2><jhi-alert></jhi-alert><div class="container-fluid"><div class="row"><div class="col-xs-4 no-padding-left"><button class="btn btn-primary" ui-sref="dinghy-event.new"><span class="glyphicon glyphicon-plus"></span> <span class="hidden-xs-down" data-translate="askApp.dinghyEvent.home.createLabel">Create new Dinghy Event</span></button></div><div class="col-xs-8 no-padding-right"><form name="searchForm" class="form-inline"><div class="input-group pull-right"><input type="text" class="form-control" ng-model="vm.searchQuery" id="searchQuery" placeholder="{{ \'askApp.dinghyEvent.home.search\' | translate }}"> <span class="input-group-btn width-min"><button class="btn btn-info" ng-click="vm.search(vm.searchQuery)"><span class="glyphicon glyphicon-search"></span></button> </span><span class="input-group-btn width-min" ng-if="vm.currentSearch"><button class="btn btn-info" ng-click="vm.clear()"><span class="glyphicon glyphicon-trash"></span></button></span></div></form></div></div></div><br><div class="table-responsive"><table class="jh-table table table-striped"><thead><tr jh-sort="vm.predicate" ascending="vm.reverse" callback="vm.transition()"><th jh-sort-by="id"><span data-translate="global.field.id">ID</span> <span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="name"><span data-translate="askApp.dinghyEvent.name">Name</span> <span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="type"><span data-translate="askApp.dinghyEvent.type">Type</span> <span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="fromDate"><span data-translate="askApp.dinghyEvent.fromDate">From Date</span> <span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="untilDate"><span data-translate="askApp.dinghyEvent.untilDate">Until Date</span> <span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="contactEmail"><span data-translate="askApp.dinghyEvent.contactEmail">Contact Email</span> <span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="placeCount"><span data-translate="askApp.dinghyEvent.placeCount">Place Count</span> <span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="location"><span data-translate="askApp.dinghyEvent.location">Location</span> <span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="identifier"><span data-translate="askApp.dinghyEvent.identifier">Identifier</span> <span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="normalPrice"><span data-translate="askApp.dinghyEvent.normalPrice">Normal Price</span> <span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="studentPrice"><span data-translate="askApp.dinghyEvent.studentPrice">Student Price</span> <span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="guestPrice"><span data-translate="askApp.dinghyEvent.guestPrice">Guest Price</span> <span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="description"><span data-translate="askApp.dinghyEvent.description">Description</span> <span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="conditions"><span data-translate="askApp.dinghyEvent.conditions">Conditions</span> <span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="notes"><span data-translate="askApp.dinghyEvent.notes">Notes</span> <span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="visible"><span data-translate="askApp.dinghyEvent.visible">Visible</span> <span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="active"><span data-translate="askApp.dinghyEvent.active">Active</span> <span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="closed"><span data-translate="askApp.dinghyEvent.closed">Closed</span> <span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="canceled"><span data-translate="askApp.dinghyEvent.canceled">Canceled</span> <span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="allowGuests"><span data-translate="askApp.dinghyEvent.allowGuests">Allow Guests</span> <span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="allowQueue"><span data-translate="askApp.dinghyEvent.allowQueue">Allow Queue</span> <span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="individualQuestion"><span data-translate="askApp.dinghyEvent.individualQuestion">Individual Question</span> <span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="uid"><span data-translate="askApp.dinghyEvent.uid">Uid</span> <span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="version"><span data-translate="askApp.dinghyEvent.version">Version</span> <span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="godparent.id"><span data-translate="askApp.dinghyEvent.godparent">Godparent</span> <span class="glyphicon glyphicon-sort"></span></th><th></th></tr></thead><tbody><tr ng-repeat="dinghyEvent in vm.dinghyEvents track by dinghyEvent.id"><td><a ui-sref="dinghy-event-detail({id:dinghyEvent.id})">{{dinghyEvent.id}}</a></td><td>{{dinghyEvent.name}}</td><td data-translate="{{\'askApp.EnumDinghyEventType.\' + dinghyEvent.type}}">{{dinghyEvent.type}}</td><td>{{dinghyEvent.fromDate | date:\'medium\'}}</td><td>{{dinghyEvent.untilDate | date:\'medium\'}}</td><td>{{dinghyEvent.contactEmail}}</td><td>{{dinghyEvent.placeCount}}</td><td>{{dinghyEvent.location}}</td><td>{{dinghyEvent.identifier}}</td><td>{{dinghyEvent.normalPrice}}</td><td>{{dinghyEvent.studentPrice}}</td><td>{{dinghyEvent.guestPrice}}</td><td>{{dinghyEvent.description}}</td><td>{{dinghyEvent.conditions}}</td><td>{{dinghyEvent.notes}}</td><td>{{dinghyEvent.visible}}</td><td>{{dinghyEvent.active}}</td><td>{{dinghyEvent.closed}}</td><td>{{dinghyEvent.canceled}}</td><td>{{dinghyEvent.allowGuests}}</td><td>{{dinghyEvent.allowQueue}}</td><td>{{dinghyEvent.individualQuestion}}</td><td>{{dinghyEvent.uid}}</td><td>{{dinghyEvent.version}}</td><td><a ui-sref="profile-detail({id:dinghyEvent.godparent.id})">{{dinghyEvent.godparent.id}}</a></td><td class="text-right"><div class="btn-group flex-btn-group-container"><button type="submit" ui-sref="dinghy-event-detail({id:dinghyEvent.id})" class="btn btn-info btn-sm"><span class="glyphicon glyphicon-eye-open"></span> <span class="hidden-sm-down" data-translate="entity.action.view"></span></button> <button type="submit" ui-sref="dinghy-event.edit({id:dinghyEvent.id})" class="btn btn-primary btn-sm"><span class="glyphicon glyphicon-pencil"></span> <span class="hidden-sm-down" data-translate="entity.action.edit"></span></button> <button type="submit" ui-sref="dinghy-event.delete({id:dinghyEvent.id})" class="btn btn-danger btn-sm"><span class="glyphicon glyphicon-remove-circle"></span> <span class="hidden-sm-down" data-translate="entity.action.delete"></span></button></div></td></tr></tbody></table></div><div class="text-center"><jhi-item-count page="vm.page" total="vm.queryCount" items-per-page="vm.itemsPerPage"></jhi-item-count><uib-pagination class="pagination-sm" total-items="vm.totalItems" items-per-page="vm.itemsPerPage" ng-model="vm.page" ng-change="vm.transition()"></uib-pagination></div></div>');
$templateCache.put('app/entities/membership-fee/membership-fee-delete-dialog.html','<form name="deleteForm" ng-submit="vm.confirmDelete(vm.membershipFee.id)"><div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()">&times;</button><h4 class="modal-title" data-translate="entity.delete.title">Confirm delete operation</h4></div><div class="modal-body"><jhi-alert-error></jhi-alert-error><p data-translate="askApp.membershipFee.delete.question" translate-values="{id: \'{{vm.membershipFee.id}}\'}">Are you sure you want to delete this Membership Fee?</p></div><div class="modal-footer"><button type="button" class="btn btn-default" data-dismiss="modal" ng-click="vm.clear()"><span class="glyphicon glyphicon-ban-circle"></span>&nbsp;<span data-translate="entity.action.cancel">Cancel</span></button> <button type="submit" ng-disabled="deleteForm.$invalid" class="btn btn-danger"><span class="glyphicon glyphicon-remove-circle"></span>&nbsp;<span data-translate="entity.action.delete">Delete</span></button></div></form>');
$templateCache.put('app/entities/membership-fee/membership-fee-detail.html','<div><h2><span data-translate="askApp.membershipFee.detail.title">Membership Fee</span> {{vm.membershipFee.id}}</h2><hr><jhi-alert-error></jhi-alert-error><dl class="dl-horizontal jh-entity-details"><dt><span data-translate="askApp.membershipFee.year">Year</span></dt><dd><span>{{vm.membershipFee.year | date:\'mediumDate\'}}</span></dd><dt><span data-translate="askApp.membershipFee.price">Price</span></dt><dd><span>{{vm.membershipFee.price}}</span></dd><dt><span data-translate="askApp.membershipFee.type">Type</span></dt><dd><span data-translate="{{\'askApp.EnumMembershipFeeType.\' + vm.membershipFee.type}}">{{vm.membershipFee.type}}</span></dd><dt><span data-translate="askApp.membershipFee.profile">Profile</span></dt><dd><a ui-sref="profile-detail({id:vm.membershipFee.profile.id})">{{vm.membershipFee.profile.id}}</a></dd><dt><span data-translate="askApp.membershipFee.dept">Dept</span></dt><dd><a ui-sref="dept-detail({id:vm.membershipFee.dept.id})">{{vm.membershipFee.dept.id}}</a></dd></dl><button type="submit" ui-sref="{{ vm.previousState }}" class="btn btn-info"><span class="glyphicon glyphicon-arrow-left"></span>&nbsp;<span data-translate="entity.action.back"> Back</span></button> <button type="button" ui-sref="membership-fee-detail.edit({id:vm.membershipFee.id})" class="btn btn-primary"><span class="glyphicon glyphicon-pencil"></span> <span class="hidden-sm-down" data-translate="entity.action.edit">Edit</span></button></div>');
$templateCache.put('app/entities/membership-fee/membership-fee-dialog.html','<form name="editForm" role="form" novalidate ng-submit="vm.save()" show-validation><div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()">&times;</button><h4 class="modal-title" id="myMembershipFeeLabel" data-translate="askApp.membershipFee.home.createOrEditLabel">Create or edit a Membership Fee</h4></div><div class="modal-body"><jhi-alert-error></jhi-alert-error><div class="form-group" ng-show="vm.membershipFee.id"><label for="id" data-translate="global.field.id">ID</label><input type="text" class="form-control" id="id" name="id" ng-model="vm.membershipFee.id" readonly="readonly"></div><div class="form-group"><label class="control-label" data-translate="askApp.membershipFee.year" for="field_year">Year</label><div class="input-group"><input id="field_year" type="text" class="form-control" name="year" uib-datepicker-popup="{{dateformat}}" ng-model="vm.membershipFee.year" is-open="vm.datePickerOpenStatus.year" required> <span class="input-group-btn"><button type="button" class="btn btn-default" ng-click="vm.openCalendar(\'year\')"><i class="glyphicon glyphicon-calendar"></i></button></span></div><div ng-show="editForm.year.$invalid"><p class="help-block" ng-show="editForm.year.$error.required" data-translate="entity.validation.required">This field is required.</p></div></div><div class="form-group"><label class="control-label" data-translate="askApp.membershipFee.price" for="field_price">Price</label><input type="number" class="form-control" name="price" id="field_price" ng-model="vm.membershipFee.price" required><div ng-show="editForm.price.$invalid"><p class="help-block" ng-show="editForm.price.$error.required" data-translate="entity.validation.required">This field is required.</p><p class="help-block" ng-show="editForm.price.$error.number" data-translate="entity.validation.number">This field should be a number.</p></div></div><div class="form-group"><label class="control-label" data-translate="askApp.membershipFee.type" for="field_type">Type</label><select class="form-control" name="type" ng-model="vm.membershipFee.type" id="field_type" required><option value="anualFee" data-translate="askApp.EnumMembershipFeeType.anualFee">anualFee</option><option value="anualFeePlusWelcomeFee" data-translate="askApp.EnumMembershipFeeType.anualFeePlusWelcomeFee">anualFeePlusWelcomeFee</option></select><div ng-show="editForm.type.$invalid"><p class="help-block" ng-show="editForm.type.$error.required" data-translate="entity.validation.required">This field is required.</p></div></div><div class="form-group"><label data-translate="askApp.membershipFee.profile" for="field_profile">Profile</label><select class="form-control" id="field_profile" name="profile" ng-model="vm.membershipFee.profile" ng-options="profile as profile.id for profile in vm.profiles track by profile.id" required></select></div><div ng-show="editForm.profile.$invalid"><p class="help-block" ng-show="editForm.profile.$error.required" data-translate="entity.validation.required">This field is required.</p></div><div class="form-group"><label data-translate="askApp.membershipFee.dept" for="field_dept">Dept</label><select class="form-control" id="field_dept" name="dept" ng-model="vm.membershipFee.dept" ng-options="dept as dept.id for dept in vm.depts | orderBy:\'id\' track by dept.id" required></select></div><div ng-show="editForm.dept.$invalid"><p class="help-block" ng-show="editForm.dept.$error.required" data-translate="entity.validation.required">This field is required.</p></div></div><div class="modal-footer"><button type="button" class="btn btn-default" data-dismiss="modal" ng-click="vm.clear()"><span class="glyphicon glyphicon-ban-circle"></span>&nbsp;<span data-translate="entity.action.cancel">Cancel</span></button> <button type="submit" ng-disabled="editForm.$invalid || vm.isSaving" class="btn btn-primary"><span class="glyphicon glyphicon-save"></span>&nbsp;<span data-translate="entity.action.save">Save</span></button></div></form>');
$templateCache.put('app/entities/membership-fee/membership-fees.html','<div><h2 data-translate="askApp.membershipFee.home.title">Membership Fees</h2><jhi-alert></jhi-alert><div class="container-fluid"><div class="row"><div class="col-xs-4 no-padding-left"><button class="btn btn-primary" ui-sref="membership-fee.new"><span class="glyphicon glyphicon-plus"></span> <span class="hidden-xs-down" data-translate="askApp.membershipFee.home.createLabel">Create new Membership Fee</span></button></div><div class="col-xs-8 no-padding-right"><form name="searchForm" class="form-inline"><div class="input-group pull-right"><input type="text" class="form-control" ng-model="vm.searchQuery" id="searchQuery" placeholder="{{ \'askApp.membershipFee.home.search\' | translate }}"> <span class="input-group-btn width-min"><button class="btn btn-info" ng-click="vm.search(vm.searchQuery)"><span class="glyphicon glyphicon-search"></span></button> </span><span class="input-group-btn width-min" ng-if="vm.currentSearch"><button class="btn btn-info" ng-click="vm.clear()"><span class="glyphicon glyphicon-trash"></span></button></span></div></form></div></div></div><br><div class="table-responsive"><table class="jh-table table table-striped"><thead><tr jh-sort="vm.predicate" ascending="vm.reverse" callback="vm.transition()"><th jh-sort-by="id"><span data-translate="global.field.id">ID</span> <span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="year"><span data-translate="askApp.membershipFee.year">Year</span> <span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="price"><span data-translate="askApp.membershipFee.price">Price</span> <span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="type"><span data-translate="askApp.membershipFee.type">Type</span> <span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="profile.id"><span data-translate="askApp.membershipFee.profile">Profile</span> <span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="dept.id"><span data-translate="askApp.membershipFee.dept">Dept</span> <span class="glyphicon glyphicon-sort"></span></th><th></th></tr></thead><tbody><tr ng-repeat="membershipFee in vm.membershipFees track by membershipFee.id"><td><a ui-sref="membership-fee-detail({id:membershipFee.id})">{{membershipFee.id}}</a></td><td>{{membershipFee.year | date:\'mediumDate\'}}</td><td>{{membershipFee.price}}</td><td data-translate="{{\'askApp.EnumMembershipFeeType.\' + membershipFee.type}}">{{membershipFee.type}}</td><td><a ui-sref="profile-detail({id:membershipFee.profile.id})">{{membershipFee.profile.id}}</a></td><td><a ui-sref="dept-detail({id:membershipFee.dept.id})">{{membershipFee.dept.id}}</a></td><td class="text-right"><div class="btn-group flex-btn-group-container"><button type="submit" ui-sref="membership-fee-detail({id:membershipFee.id})" class="btn btn-info btn-sm"><span class="glyphicon glyphicon-eye-open"></span> <span class="hidden-sm-down" data-translate="entity.action.view"></span></button> <button type="submit" ui-sref="membership-fee.edit({id:membershipFee.id})" class="btn btn-primary btn-sm"><span class="glyphicon glyphicon-pencil"></span> <span class="hidden-sm-down" data-translate="entity.action.edit"></span></button> <button type="submit" ui-sref="membership-fee.delete({id:membershipFee.id})" class="btn btn-danger btn-sm"><span class="glyphicon glyphicon-remove-circle"></span> <span class="hidden-sm-down" data-translate="entity.action.delete"></span></button></div></td></tr></tbody></table></div><div class="text-center"><jhi-item-count page="vm.page" total="vm.queryCount" items-per-page="vm.itemsPerPage"></jhi-item-count><uib-pagination class="pagination-sm" total-items="vm.totalItems" items-per-page="vm.itemsPerPage" ng-model="vm.page" ng-change="vm.transition()"></uib-pagination></div></div>');
$templateCache.put('app/entities/payment/payment-delete-dialog.html','<!--\n  ~ Copyright (c) 2017 by Julian Feder, julian.feder@yahoo.de\n  ~\n  ~ This product includes software developed at\n  ~ The Apache Software Foundation (http://www.apache.org/).\n  --><form name="deleteForm" ng-submit="vm.confirmDelete(vm.payment.id)"><div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()">&times;</button><h4 class="modal-title" data-translate="entity.delete.title">Confirm delete operation</h4></div><div class="modal-body"><jhi-alert-error></jhi-alert-error><p data-translate="askApp.payment.delete.question" translate-values="{id: \'{{vm.payment.id}}\'}">Are you sure you want to delete this Payment?</p></div><div class="modal-footer"><button type="button" class="btn btn-default" data-dismiss="modal" ng-click="vm.clear()"><span class="glyphicon glyphicon-ban-circle"></span>&nbsp;<span data-translate="entity.action.cancel">Cancel</span></button> <button type="submit" ng-disabled="deleteForm.$invalid" class="btn btn-danger"><span class="glyphicon glyphicon-remove-circle"></span>&nbsp;<span data-translate="entity.action.delete">Delete</span></button></div></form>');
$templateCache.put('app/entities/payment/payment-detail.html','<!--\n  ~ Copyright (c) 2017 by Julian Feder, julian.feder@yahoo.de\n  ~\n  ~ This product includes software developed at\n  ~ The Apache Software Foundation (http://www.apache.org/).\n  --><div><h2><span data-translate="askApp.payment.detail.title">Payment</span> {{vm.payment.id}}</h2><hr><jhi-alert-error></jhi-alert-error><dl class="dl-horizontal jh-entity-details"><dt><span data-translate="askApp.payment.revenueID">Revenue ID</span></dt><dd><span>{{vm.payment.revenueID}}</span></dd><dt><span data-translate="askApp.payment.date">Date</span></dt><dd><span>{{vm.payment.date | date:\'mediumDate\'}}</span></dd><dt><span data-translate="askApp.payment.amount">Amount</span></dt><dd><span>{{vm.payment.amount}}</span></dd><dt><span data-translate="askApp.payment.name">Name</span></dt><dd><span>{{vm.payment.name}}</span></dd><dt><span data-translate="askApp.payment.type">Type</span></dt><dd><span data-translate="{{\'askApp.EnumPaymentType.\' + vm.payment.type}}">{{vm.payment.type}}</span></dd><dt><span data-translate="askApp.payment.reference">Reference</span></dt><dd><span>{{vm.payment.reference}}</span></dd><dt><span data-translate="askApp.payment.comment">Comment</span></dt><dd><span>{{vm.payment.comment}}</span></dd><dt><span data-translate="askApp.payment.matchReference">Match Reference</span></dt><dd><span>{{vm.payment.matchReference}}</span></dd><dt><span data-translate="askApp.payment.category">Category</span></dt><dd><span data-translate="{{\'askApp.EnumPaymentCategory.\' + vm.payment.category}}">{{vm.payment.category}}</span></dd><dt><span data-translate="askApp.payment.dept">Dept</span></dt><dd><a ui-sref="dept-detail({id:vm.payment.dept.id})">{{vm.payment.dept.id}}</a></dd><dt><span data-translate="askApp.payment.project">Project</span></dt><dd><a ui-sref="project-detail({id:vm.payment.project.id})">{{vm.payment.project.id}}</a></dd><dt><span data-translate="askApp.payment.dinghyEvent">Dinghy Event</span></dt><dd><a ui-sref="dinghy-event-detail({id:vm.payment.dinghyEvent.id})">{{vm.payment.dinghyEvent.id}}</a></dd><dt><span data-translate="askApp.payment.parent">Parent</span></dt><dd><a ui-sref="payment-detail({id:vm.payment.parent.id})">{{vm.payment.parent.id}}</a></dd></dl><button type="submit" ui-sref="{{ vm.previousState }}" class="btn btn-info"><span class="glyphicon glyphicon-arrow-left"></span>&nbsp;<span data-translate="entity.action.back"> Back</span></button> <button type="button" ui-sref="payment-detail.edit({id:vm.payment.id})" class="btn btn-primary"><span class="glyphicon glyphicon-pencil"></span> <span class="hidden-sm-down" data-translate="entity.action.edit">Edit</span></button></div>');
$templateCache.put('app/entities/payment/payment-dialog.html','<!--\n  ~ Copyright (c) 2017 by Julian Feder, julian.feder@yahoo.de\n  ~\n  ~ This product includes software developed at\n  ~ The Apache Software Foundation (http://www.apache.org/).\n  --><form name="editForm" role="form" novalidate ng-submit="vm.save()" show-validation><div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()">&times;</button><h4 class="modal-title" id="myPaymentLabel" data-translate="askApp.payment.home.createOrEditLabel">Create or edit a Payment</h4></div><div class="modal-body"><jhi-alert-error></jhi-alert-error><div class="form-group" ng-show="vm.payment.id"><label for="id" data-translate="global.field.id">ID</label><input type="text" class="form-control" id="id" name="id" ng-model="vm.payment.id" readonly="readonly"></div><div class="form-group"><label class="control-label" data-translate="askApp.payment.revenueID" for="field_revenueID">Revenue ID</label><input type="number" class="form-control" name="revenueID" id="field_revenueID" ng-model="vm.payment.revenueID" required><div ng-show="editForm.revenueID.$invalid"><p class="help-block" ng-show="editForm.revenueID.$error.required" data-translate="entity.validation.required">This field is required.</p><p class="help-block" ng-show="editForm.revenueID.$error.number" data-translate="entity.validation.number">This field should be a number.</p></div></div><div class="form-group"><label class="control-label" data-translate="askApp.payment.date" for="field_date">Date</label><div class="input-group"><input id="field_date" type="text" class="form-control" name="date" uib-datepicker-popup="{{dateformat}}" ng-model="vm.payment.date" is-open="vm.datePickerOpenStatus.date" required> <span class="input-group-btn"><button type="button" class="btn btn-default" ng-click="vm.openCalendar(\'date\')"><i class="glyphicon glyphicon-calendar"></i></button></span></div><div ng-show="editForm.date.$invalid"><p class="help-block" ng-show="editForm.date.$error.required" data-translate="entity.validation.required">This field is required.</p></div></div><div class="form-group"><label class="control-label" data-translate="askApp.payment.amount" for="field_amount">Amount</label><input type="number" class="form-control" name="amount" id="field_amount" ng-model="vm.payment.amount" required><div ng-show="editForm.amount.$invalid"><p class="help-block" ng-show="editForm.amount.$error.required" data-translate="entity.validation.required">This field is required.</p><p class="help-block" ng-show="editForm.amount.$error.number" data-translate="entity.validation.number">This field should be a number.</p></div></div><div class="form-group"><label class="control-label" data-translate="askApp.payment.name" for="field_name">Name</label><input type="text" class="form-control" name="name" id="field_name" ng-model="vm.payment.name" required><div ng-show="editForm.name.$invalid"><p class="help-block" ng-show="editForm.name.$error.required" data-translate="entity.validation.required">This field is required.</p></div></div><div class="form-group"><label class="control-label" data-translate="askApp.payment.type" for="field_type">Type</label><select class="form-control" name="type" ng-model="vm.payment.type" id="field_type" required><option value="ONLINEUEBERWEISUNG" data-translate="askApp.EnumPaymentType.ONLINEUEBERWEISUNG">ONLINEUEBERWEISUNG</option><option value="GUTSCHRIFT" data-translate="askApp.EnumPaymentType.GUTSCHRIFT">GUTSCHRIFT</option><option value="FOLGELASTSCHRIFT" data-translate="askApp.EnumPaymentType.FOLGELASTSCHRIFT">FOLGELASTSCHRIFT</option><option value="ENTGELTABSCHLUSS" data-translate="askApp.EnumPaymentType.ENTGELTABSCHLUSS">ENTGELTABSCHLUSS</option><option value="DAUERAUFTRAG" data-translate="askApp.EnumPaymentType.DAUERAUFTRAG">DAUERAUFTRAG</option><option value="KOPIE" data-translate="askApp.EnumPaymentType.KOPIE">KOPIE</option><option value="ANDERE" data-translate="askApp.EnumPaymentType.ANDERE">ANDERE</option></select><div ng-show="editForm.type.$invalid"><p class="help-block" ng-show="editForm.type.$error.required" data-translate="entity.validation.required">This field is required.</p></div></div><div class="form-group"><label class="control-label" data-translate="askApp.payment.reference" for="field_reference">Reference</label><input type="text" class="form-control" name="reference" id="field_reference" ng-model="vm.payment.reference" required><div ng-show="editForm.reference.$invalid"><p class="help-block" ng-show="editForm.reference.$error.required" data-translate="entity.validation.required">This field is required.</p></div></div><div class="form-group"><label class="control-label" data-translate="askApp.payment.comment" for="field_comment">Comment</label><input type="text" class="form-control" name="comment" id="field_comment" ng-model="vm.payment.comment"></div><div class="form-group"><label class="control-label" data-translate="askApp.payment.matchReference" for="field_matchReference">Match Reference</label><input type="text" class="form-control" name="matchReference" id="field_matchReference" ng-model="vm.payment.matchReference"></div><div class="form-group"><label class="control-label" data-translate="askApp.payment.category" for="field_category">Category</label><select class="form-control" name="category" ng-model="vm.payment.category" id="field_category"><option value="Teilnahmebeitrag" data-translate="askApp.EnumPaymentCategory.Teilnahmebeitrag">Teilnahmebeitrag</option><option value="Charter" data-translate="askApp.EnumPaymentCategory.Charter">Charter</option><option value="Meldegeld" data-translate="askApp.EnumPaymentCategory.Meldegeld">Meldegeld</option><option value="Pruefungsgebuehr" data-translate="askApp.EnumPaymentCategory.Pruefungsgebuehr">Pruefungsgebuehr</option><option value="Kautionversicherung" data-translate="askApp.EnumPaymentCategory.Kautionversicherung">Kautionversicherung</option><option value="Unterkunft" data-translate="askApp.EnumPaymentCategory.Unterkunft">Unterkunft</option><option value="Skipperhaftpflicht" data-translate="askApp.EnumPaymentCategory.Skipperhaftpflicht">Skipperhaftpflicht</option><option value="Uebungsleiterverguetung" data-translate="askApp.EnumPaymentCategory.Uebungsleiterverguetung">Uebungsleiterverguetung</option><option value="Bordkassenzuschuss" data-translate="askApp.EnumPaymentCategory.Bordkassenzuschuss">Bordkassenzuschuss</option><option value="Merch" data-translate="askApp.EnumPaymentCategory.Merch">Merch</option><option value="Verpflegung" data-translate="askApp.EnumPaymentCategory.Verpflegung">Verpflegung</option><option value="StadtmobilP" data-translate="askApp.EnumPaymentCategory.StadtmobilP">StadtmobilP</option><option value="StadtmobilTN" data-translate="askApp.EnumPaymentCategory.StadtmobilTN">StadtmobilTN</option><option value="Druckkosten" data-translate="askApp.EnumPaymentCategory.Druckkosten">Druckkosten</option><option value="Sonstiges" data-translate="askApp.EnumPaymentCategory.Sonstiges">Sonstiges</option></select></div><div class="form-group"><label data-translate="askApp.payment.dept" for="field_dept">Dept</label><select class="form-control" id="field_dept" name="dept" ng-model="vm.payment.dept" ng-options="dept as dept.id for dept in vm.depts track by dept.id"><option value=""></option></select></div><div class="form-group"><label data-translate="askApp.payment.project" for="field_project">Project</label><select class="form-control" id="field_project" name="project" ng-model="vm.payment.project" ng-options="project as project.id for project in vm.projects track by project.id"><option value=""></option></select></div><div class="form-group"><label data-translate="askApp.payment.dinghyEvent" for="field_dinghyEvent">Dinghy Event</label><select class="form-control" id="field_dinghyEvent" name="dinghyEvent" ng-model="vm.payment.dinghyEvent" ng-options="dinghyEvent as dinghyEvent.id for dinghyEvent in vm.dinghyevents track by dinghyEvent.id"><option value=""></option></select></div><div class="form-group"><label data-translate="askApp.payment.parent" for="field_parent">Parent</label><select class="form-control" id="field_parent" name="parent" ng-model="vm.payment.parent" ng-options="payment as payment.id for payment in vm.payments track by payment.id"><option value=""></option></select></div></div><div class="modal-footer"><button type="button" class="btn btn-default" data-dismiss="modal" ng-click="vm.clear()"><span class="glyphicon glyphicon-ban-circle"></span>&nbsp;<span data-translate="entity.action.cancel">Cancel</span></button> <button type="submit" ng-disabled="editForm.$invalid || vm.isSaving" class="btn btn-primary"><span class="glyphicon glyphicon-save"></span>&nbsp;<span data-translate="entity.action.save">Save</span></button></div></form>');
$templateCache.put('app/entities/payment/payments.html','<!--\n  ~ Copyright (c) 2017 by Julian Feder, julian.feder@yahoo.de\n  ~\n  ~ This product includes software developed at\n  ~ The Apache Software Foundation (http://www.apache.org/).\n  --><div><h2 data-translate="askApp.payment.home.title">Payments</h2><jhi-alert></jhi-alert><div class="container-fluid"><div class="row"><div class="col-xs-4 no-padding-left"><button class="btn btn-primary" ui-sref="payment.new"><span class="glyphicon glyphicon-plus"></span> <span class="hidden-xs-down" data-translate="askApp.payment.home.createLabel">Create new Payment</span></button></div><div class="col-xs-8 no-padding-right"><form name="searchForm" class="form-inline"><div class="input-group pull-right"><input type="text" class="form-control" ng-model="vm.searchQuery" id="searchQuery" placeholder="{{ \'askApp.payment.home.search\' | translate }}"> <span class="input-group-btn width-min"><button class="btn btn-info" ng-click="vm.search(vm.searchQuery)"><span class="glyphicon glyphicon-search"></span></button> </span><span class="input-group-btn width-min" ng-if="vm.currentSearch"><button class="btn btn-info" ng-click="vm.clear()"><span class="glyphicon glyphicon-trash"></span></button></span></div></form></div></div></div><br><div class="table-responsive"><table class="jh-table table table-striped"><thead><tr jh-sort="vm.predicate" ascending="vm.reverse" callback="vm.transition()"><th jh-sort-by="id"><span data-translate="global.field.id">ID</span> <span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="revenueID"><span data-translate="askApp.payment.revenueID">Revenue ID</span> <span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="date"><span data-translate="askApp.payment.date">Date</span> <span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="amount"><span data-translate="askApp.payment.amount">Amount</span> <span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="name"><span data-translate="askApp.payment.name">Name</span> <span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="type"><span data-translate="askApp.payment.type">Type</span> <span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="reference"><span data-translate="askApp.payment.reference">Reference</span> <span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="comment"><span data-translate="askApp.payment.comment">Comment</span> <span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="matchReference"><span data-translate="askApp.payment.matchReference">Match Reference</span> <span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="category"><span data-translate="askApp.payment.category">Category</span> <span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="dept.id"><span data-translate="askApp.payment.dept">Dept</span> <span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="project.id"><span data-translate="askApp.payment.project">Project</span> <span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="dinghyEvent.id"><span data-translate="askApp.payment.dinghyEvent">Dinghy Event</span> <span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="parent.id"><span data-translate="askApp.payment.parent">Parent</span> <span class="glyphicon glyphicon-sort"></span></th><th></th></tr></thead><tbody><tr ng-repeat="payment in vm.payments track by payment.id"><td><a ui-sref="payment-detail({id:payment.id})">{{payment.id}}</a></td><td>{{payment.revenueID}}</td><td>{{payment.date | date:\'mediumDate\'}}</td><td>{{payment.amount}}</td><td>{{payment.name}}</td><td data-translate="{{\'askApp.EnumPaymentType.\' + payment.type}}">{{payment.type}}</td><td>{{payment.reference}}</td><td>{{payment.comment}}</td><td>{{payment.matchReference}}</td><td data-translate="{{\'askApp.EnumPaymentCategory.\' + payment.category}}">{{payment.category}}</td><td><a ui-sref="dept-detail({id:payment.dept.id})">{{payment.dept.id}}</a></td><td><a ui-sref="project-detail({id:payment.project.id})">{{payment.project.id}}</a></td><td><a ui-sref="dinghy-event-detail({id:payment.dinghyEvent.id})">{{payment.dinghyEvent.id}}</a></td><td><a ui-sref="payment-detail({id:payment.parent.id})">{{payment.parent.id}}</a></td><td class="text-right"><div class="btn-group flex-btn-group-container"><button type="submit" ui-sref="payment-detail({id:payment.id})" class="btn btn-info btn-sm"><span class="glyphicon glyphicon-eye-open"></span> <span class="hidden-sm-down" data-translate="entity.action.view"></span></button> <button type="submit" ui-sref="payment.edit({id:payment.id})" class="btn btn-primary btn-sm"><span class="glyphicon glyphicon-pencil"></span> <span class="hidden-sm-down" data-translate="entity.action.edit"></span></button> <button type="submit" ui-sref="payment.delete({id:payment.id})" class="btn btn-danger btn-sm"><span class="glyphicon glyphicon-remove-circle"></span> <span class="hidden-sm-down" data-translate="entity.action.delete"></span></button></div></td></tr></tbody></table></div><div class="text-center"><jhi-item-count page="vm.page" total="vm.queryCount" items-per-page="vm.itemsPerPage"></jhi-item-count><uib-pagination class="pagination-sm" total-items="vm.totalItems" items-per-page="vm.itemsPerPage" ng-model="vm.page" ng-change="vm.transition()"></uib-pagination></div></div>');
$templateCache.put('app/entities/profile/profile-delete-dialog.html','<form name="deleteForm" ng-submit="vm.confirmDelete(vm.profile.id)"><div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()">&times;</button><h4 class="modal-title" data-translate="entity.delete.title">Confirm delete operation</h4></div><div class="modal-body"><jhi-alert-error></jhi-alert-error><p data-translate="askApp.profile.delete.question" translate-values="{id: \'{{vm.profile.id}}\'}">Are you sure you want to delete this Profile?</p></div><div class="modal-footer"><button type="button" class="btn btn-default" data-dismiss="modal" ng-click="vm.clear()"><span class="glyphicon glyphicon-ban-circle"></span>&nbsp;<span data-translate="entity.action.cancel">Cancel</span></button> <button type="submit" ng-disabled="deleteForm.$invalid" class="btn btn-danger"><span class="glyphicon glyphicon-remove-circle"></span>&nbsp;<span data-translate="entity.action.delete">Delete</span></button></div></form>');
$templateCache.put('app/entities/profile/profile-detail.html','<div><h2><span data-translate="askApp.profile.detail.title">Profile</span> {{vm.profile.id}}</h2><hr><jhi-alert-error></jhi-alert-error><dl class="dl-horizontal jh-entity-details"><dt><span data-translate="askApp.profile.nickname">Nickname</span></dt><dd><span>{{vm.profile.nickname}}</span></dd><dt><span data-translate="askApp.profile.street">Street</span></dt><dd><span>{{vm.profile.street}}</span></dd><dt><span data-translate="askApp.profile.city">City</span></dt><dd><span>{{vm.profile.city}}</span></dd><dt><span data-translate="askApp.profile.country">Country</span></dt><dd><span data-translate="{{\'askApp.EnumCountry.\' + vm.profile.country}}">{{vm.profile.country}}</span></dd><dt><span data-translate="askApp.profile.postcode">Postcode</span></dt><dd><span>{{vm.profile.postcode}}</span></dd><dt><span data-translate="askApp.profile.weight">Weight</span></dt><dd><span>{{vm.profile.weight}}</span></dd><dt><span data-translate="askApp.profile.clothingSize">Clothing Size</span></dt><dd><span data-translate="{{\'askApp.EnumClothingSize.\' + vm.profile.clothingSize}}">{{vm.profile.clothingSize}}</span></dd><dt><span data-translate="askApp.profile.shoeSize">Shoe Size</span></dt><dd><span>{{vm.profile.shoeSize}}</span></dd><dt><span data-translate="askApp.profile.nationality">Nationality</span></dt><dd><span data-translate="{{\'askApp.EnumCountry.\' + vm.profile.nationality}}">{{vm.profile.nationality}}</span></dd><dt><span data-translate="askApp.profile.birthplace">Birthplace</span></dt><dd><span>{{vm.profile.birthplace}}</span></dd><dt><span data-translate="askApp.profile.countryOfBirth">Country Of Birth</span></dt><dd><span data-translate="{{\'askApp.EnumCountry.\' + vm.profile.countryOfBirth}}">{{vm.profile.countryOfBirth}}</span></dd><dt><span data-translate="askApp.profile.phone">Phone</span></dt><dd><span>{{vm.profile.phone}}</span></dd><dt><span data-translate="askApp.profile.gender">Gender</span></dt><dd><span data-translate="{{\'askApp.EnumGender.\' + vm.profile.gender}}">{{vm.profile.gender}}</span></dd><dt><span data-translate="askApp.profile.birthdate">Birthdate</span></dt><dd><span>{{vm.profile.birthdate | date:\'mediumDate\'}}</span></dd><dt><span data-translate="askApp.profile.isStudent">Is Student</span></dt><dd><span>{{vm.profile.isStudent}}</span></dd><dt><span data-translate="askApp.profile.isVerified">Is Verified</span></dt><dd><span>{{vm.profile.isVerified}}</span></dd><dt><span data-translate="askApp.profile.memberStatus">Member Status</span></dt><dd><span data-translate="{{\'askApp.EnumMemberStatus.\' + vm.profile.memberStatus}}">{{vm.profile.memberStatus}}</span></dd><dt><span data-translate="askApp.profile.expelledDate">Expelled Date</span></dt><dd><span>{{vm.profile.expelledDate | date:\'mediumDate\'}}</span></dd><dt><span data-translate="askApp.profile.university">University</span></dt><dd><span>{{vm.profile.university}}</span></dd><dt><span data-translate="askApp.profile.matriculationCertificate">Matriculation Certificate</span></dt><dd><div ng-if="vm.profile.matriculationCertificate"><a ng-click="vm.openFile(vm.profile.matriculationCertificateContentType, vm.profile.matriculationCertificate)" data-translate="entity.action.open">open</a> {{vm.profile.matriculationCertificateContentType}}, {{vm.byteSize(vm.profile.matriculationCertificate)}}</div></dd><dt><span data-translate="askApp.profile.matriculationDate">Matriculation Date</span></dt><dd><span>{{vm.profile.matriculationDate | date:\'mediumDate\'}}</span></dd><dt><span data-translate="askApp.profile.isUsingSepa">Is Using Sepa</span></dt><dd><span>{{vm.profile.isUsingSepa}}</span></dd><dt><span data-translate="askApp.profile.bankAccountHolder">Bank Account Holder</span></dt><dd><span>{{vm.profile.bankAccountHolder}}</span></dd><dt><span data-translate="askApp.profile.iban">Iban</span></dt><dd><span>{{vm.profile.iban}}</span></dd><dt><span data-translate="askApp.profile.bic">Bic</span></dt><dd><span>{{vm.profile.bic}}</span></dd><dt><span data-translate="askApp.profile.isDeviatedHolder">Is Deviated Holder</span></dt><dd><span>{{vm.profile.isDeviatedHolder}}</span></dd><dt><span data-translate="askApp.profile.emailBackup">Email Backup</span></dt><dd><span>{{vm.profile.emailBackup}}</span></dd><dt><span data-translate="askApp.profile.idNumber">Id Number</span></dt><dd><span>{{vm.profile.idNumber}}</span></dd><dt><span data-translate="askApp.profile.idExpirationDate">Id Expiration Date</span></dt><dd><span>{{vm.profile.idExpirationDate | date:\'mediumDate\'}}</span></dd><dt><span data-translate="askApp.profile.idType">Id Type</span></dt><dd><span data-translate="{{\'askApp.EnumIDType.\' + vm.profile.idType}}">{{vm.profile.idType}}</span></dd><dt><span data-translate="askApp.profile.lastLogin">Last Login</span></dt><dd><span>{{vm.profile.lastLogin | date:\'mediumDate\'}}</span></dd><dt><span data-translate="askApp.profile.fullMemberDate">Full Member Date</span></dt><dd><span>{{vm.profile.fullMemberDate | date:\'mediumDate\'}}</span></dd><dt><span data-translate="askApp.profile.commentBoard">Comment Board</span></dt><dd><span>{{vm.profile.commentBoard}}</span></dd><dt><span data-translate="askApp.profile.commentSkipper">Comment Skipper</span></dt><dd><span>{{vm.profile.commentSkipper}}</span></dd><dt><span data-translate="askApp.profile.wantsMembershipTermination">Wants Membership Termination</span></dt><dd><span>{{vm.profile.wantsMembershipTermination}}</span></dd><dt><span data-translate="askApp.profile.wantsNewsletter">Wants Newsletter</span></dt><dd><span>{{vm.profile.wantsNewsletter}}</span></dd><dt><span data-translate="askApp.profile.sbfBinnen">Sbf Binnen</span></dt><dd><span>{{vm.profile.sbfBinnen}}</span></dd><dt><span data-translate="askApp.profile.sbfSee">Sbf See</span></dt><dd><span>{{vm.profile.sbfSee}}</span></dd><dt><span data-translate="askApp.profile.sks">Sks</span></dt><dd><span>{{vm.profile.sks}}</span></dd><dt><span data-translate="askApp.profile.sss">Sss</span></dt><dd><span>{{vm.profile.sss}}</span></dd><dt><span data-translate="askApp.profile.shs">Shs</span></dt><dd><span>{{vm.profile.shs}}</span></dd><dt><span data-translate="askApp.profile.ubi">Ubi</span></dt><dd><span>{{vm.profile.ubi}}</span></dd><dt><span data-translate="askApp.profile.src">Src</span></dt><dd><span>{{vm.profile.src}}</span></dd><dt><span data-translate="askApp.profile.lrc">Lrc</span></dt><dd><span>{{vm.profile.lrc}}</span></dd><dt><span data-translate="askApp.profile.bsp">Bsp</span></dt><dd><span>{{vm.profile.bsp}}</span></dd><dt><span data-translate="askApp.profile.fkn">Fkn</span></dt><dd><span>{{vm.profile.fkn}}</span></dd><dt><span data-translate="askApp.profile.isaf">Isaf</span></dt><dd><span>{{vm.profile.isaf}}</span></dd><dt><span data-translate="askApp.profile.isafDate">Isaf Date</span></dt><dd><span>{{vm.profile.isafDate | date:\'mediumDate\'}}</span></dd><dt><span data-translate="askApp.profile.image">Image</span></dt><dd><div ng-if="vm.profile.image"><a ng-click="vm.openFile(vm.profile.imageContentType, vm.profile.image)"><img data-ng-src="{{\'data:\' + vm.profile.imageContentType + \';base64,\' + vm.profile.image}}" style="max-width: 100%" alt="profile image"> </a>{{vm.profile.imageContentType}}, {{vm.byteSize(vm.profile.image)}}</div></dd><dt><span data-translate="askApp.profile.user">User</span></dt><dd>{{vm.profile.user.login}}</dd><dt><span data-translate="askApp.profile.skipperLevel">Skipper Level</span></dt><dd><span ng-repeat="skipperLevel in vm.profile.skipperLevels"><a ui-sref="skipper-level-holder-detail({id: skipperLevel.id})">{{skipperLevel.name}}</a>{{$last ? \'\' : \', \'}}</span></dd></dl><button type="submit" ui-sref="{{ vm.previousState }}" class="btn btn-info"><span class="glyphicon glyphicon-arrow-left"></span>&nbsp;<span data-translate="entity.action.back"> Back</span></button> <button type="button" ui-sref="profile-detail.edit({id:vm.profile.id})" class="btn btn-primary"><span class="glyphicon glyphicon-pencil"></span> <span class="hidden-sm-down" data-translate="entity.action.edit">Edit</span></button></div>');
$templateCache.put('app/entities/profile/profile-dialog.html','<form name="editForm" role="form" novalidate ng-submit="vm.save()" show-validation><div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()">&times;</button><h4 class="modal-title" id="myProfileLabel" data-translate="askApp.profile.home.createOrEditLabel">Create or edit a Profile</h4></div><div class="modal-body"><jhi-alert-error></jhi-alert-error><div class="form-group" ng-show="vm.profile.id"><label for="id" data-translate="global.field.id">ID</label><input type="text" class="form-control" id="id" name="id" ng-model="vm.profile.id" readonly="readonly"></div><div class="form-group"><label class="control-label" data-translate="askApp.profile.nickname" for="field_nickname">Nickname</label><input type="text" class="form-control" name="nickname" id="field_nickname" ng-model="vm.profile.nickname"></div><div class="form-group"><label class="control-label" data-translate="askApp.profile.street" for="field_street">Street</label><input type="text" class="form-control" name="street" id="field_street" ng-model="vm.profile.street" required><div ng-show="editForm.street.$invalid"><p class="help-block" ng-show="editForm.street.$error.required" data-translate="entity.validation.required">This field is required.</p></div></div><div class="form-group"><label class="control-label" data-translate="askApp.profile.city" for="field_city">City</label><input type="text" class="form-control" name="city" id="field_city" ng-model="vm.profile.city" required><div ng-show="editForm.city.$invalid"><p class="help-block" ng-show="editForm.city.$error.required" data-translate="entity.validation.required">This field is required.</p></div></div><div class="form-group"><label class="control-label" data-translate="askApp.profile.country" for="field_country">Country</label><select class="form-control" name="country" ng-model="vm.profile.country" id="field_country" required><option value="AF" data-translate="askApp.EnumCountry.AF">AF</option><option value="EG" data-translate="askApp.EnumCountry.EG">EG</option><option value="AL" data-translate="askApp.EnumCountry.AL">AL</option><option value="DZ" data-translate="askApp.EnumCountry.DZ">DZ</option><option value="AD" data-translate="askApp.EnumCountry.AD">AD</option><option value="AO" data-translate="askApp.EnumCountry.AO">AO</option><option value="AI" data-translate="askApp.EnumCountry.AI">AI</option><option value="AQ" data-translate="askApp.EnumCountry.AQ">AQ</option><option value="AG" data-translate="askApp.EnumCountry.AG">AG</option><option value="GQ" data-translate="askApp.EnumCountry.GQ">GQ</option><option value="AR" data-translate="askApp.EnumCountry.AR">AR</option><option value="AM" data-translate="askApp.EnumCountry.AM">AM</option><option value="AW" data-translate="askApp.EnumCountry.AW">AW</option><option value="AZ" data-translate="askApp.EnumCountry.AZ">AZ</option><option value="ET" data-translate="askApp.EnumCountry.ET">ET</option><option value="AU" data-translate="askApp.EnumCountry.AU">AU</option><option value="BS" data-translate="askApp.EnumCountry.BS">BS</option><option value="BH" data-translate="askApp.EnumCountry.BH">BH</option><option value="BD" data-translate="askApp.EnumCountry.BD">BD</option><option value="BB" data-translate="askApp.EnumCountry.BB">BB</option><option value="BE" data-translate="askApp.EnumCountry.BE">BE</option><option value="BZ" data-translate="askApp.EnumCountry.BZ">BZ</option><option value="BJ" data-translate="askApp.EnumCountry.BJ">BJ</option><option value="BM" data-translate="askApp.EnumCountry.BM">BM</option><option value="BT" data-translate="askApp.EnumCountry.BT">BT</option><option value="MM" data-translate="askApp.EnumCountry.MM">MM</option><option value="BO" data-translate="askApp.EnumCountry.BO">BO</option><option value="BA" data-translate="askApp.EnumCountry.BA">BA</option><option value="BW" data-translate="askApp.EnumCountry.BW">BW</option><option value="BV" data-translate="askApp.EnumCountry.BV">BV</option><option value="BR" data-translate="askApp.EnumCountry.BR">BR</option><option value="IO" data-translate="askApp.EnumCountry.IO">IO</option><option value="BN" data-translate="askApp.EnumCountry.BN">BN</option><option value="BG" data-translate="askApp.EnumCountry.BG">BG</option><option value="BF" data-translate="askApp.EnumCountry.BF">BF</option><option value="BI" data-translate="askApp.EnumCountry.BI">BI</option><option value="CL" data-translate="askApp.EnumCountry.CL">CL</option><option value="CN" data-translate="askApp.EnumCountry.CN">CN</option><option value="CX" data-translate="askApp.EnumCountry.CX">CX</option><option value="CK" data-translate="askApp.EnumCountry.CK">CK</option><option value="CR" data-translate="askApp.EnumCountry.CR">CR</option><option value="DK" data-translate="askApp.EnumCountry.DK">DK</option><option value="DE" data-translate="askApp.EnumCountry.DE">DE</option><option value="DJ" data-translate="askApp.EnumCountry.DJ">DJ</option><option value="DM" data-translate="askApp.EnumCountry.DM">DM</option><option value="DO" data-translate="askApp.EnumCountry.DO">DO</option><option value="EC" data-translate="askApp.EnumCountry.EC">EC</option><option value="SV" data-translate="askApp.EnumCountry.SV">SV</option><option value="CI" data-translate="askApp.EnumCountry.CI">CI</option><option value="ER" data-translate="askApp.EnumCountry.ER">ER</option><option value="EE" data-translate="askApp.EnumCountry.EE">EE</option><option value="FK" data-translate="askApp.EnumCountry.FK">FK</option><option value="FO" data-translate="askApp.EnumCountry.FO">FO</option><option value="FJ" data-translate="askApp.EnumCountry.FJ">FJ</option><option value="FI" data-translate="askApp.EnumCountry.FI">FI</option><option value="FR" data-translate="askApp.EnumCountry.FR">FR</option><option value="GF" data-translate="askApp.EnumCountry.GF">GF</option><option value="PF" data-translate="askApp.EnumCountry.PF">PF</option><option value="TF" data-translate="askApp.EnumCountry.TF">TF</option><option value="GA" data-translate="askApp.EnumCountry.GA">GA</option><option value="GM" data-translate="askApp.EnumCountry.GM">GM</option><option value="GE" data-translate="askApp.EnumCountry.GE">GE</option><option value="GH" data-translate="askApp.EnumCountry.GH">GH</option><option value="GI" data-translate="askApp.EnumCountry.GI">GI</option><option value="GD" data-translate="askApp.EnumCountry.GD">GD</option><option value="GR" data-translate="askApp.EnumCountry.GR">GR</option><option value="GL" data-translate="askApp.EnumCountry.GL">GL</option><option value="UK" data-translate="askApp.EnumCountry.UK">UK</option><option value="GB" data-translate="askApp.EnumCountry.GB">GB</option><option value="GP" data-translate="askApp.EnumCountry.GP">GP</option><option value="GU" data-translate="askApp.EnumCountry.GU">GU</option><option value="GT" data-translate="askApp.EnumCountry.GT">GT</option><option value="GN" data-translate="askApp.EnumCountry.GN">GN</option><option value="GW" data-translate="askApp.EnumCountry.GW">GW</option><option value="GY" data-translate="askApp.EnumCountry.GY">GY</option><option value="HT" data-translate="askApp.EnumCountry.HT">HT</option><option value="HM" data-translate="askApp.EnumCountry.HM">HM</option><option value="HN" data-translate="askApp.EnumCountry.HN">HN</option><option value="HK" data-translate="askApp.EnumCountry.HK">HK</option><option value="IN" data-translate="askApp.EnumCountry.IN">IN</option><option value="ID" data-translate="askApp.EnumCountry.ID">ID</option><option value="IQ" data-translate="askApp.EnumCountry.IQ">IQ</option><option value="IR" data-translate="askApp.EnumCountry.IR">IR</option><option value="IE" data-translate="askApp.EnumCountry.IE">IE</option><option value="IS" data-translate="askApp.EnumCountry.IS">IS</option><option value="IL" data-translate="askApp.EnumCountry.IL">IL</option><option value="IT" data-translate="askApp.EnumCountry.IT">IT</option><option value="JM" data-translate="askApp.EnumCountry.JM">JM</option><option value="JP" data-translate="askApp.EnumCountry.JP">JP</option><option value="YE" data-translate="askApp.EnumCountry.YE">YE</option><option value="JO" data-translate="askApp.EnumCountry.JO">JO</option><option value="YU" data-translate="askApp.EnumCountry.YU">YU</option><option value="KY" data-translate="askApp.EnumCountry.KY">KY</option><option value="KH" data-translate="askApp.EnumCountry.KH">KH</option><option value="CM" data-translate="askApp.EnumCountry.CM">CM</option><option value="CA" data-translate="askApp.EnumCountry.CA">CA</option><option value="CV" data-translate="askApp.EnumCountry.CV">CV</option><option value="KZ" data-translate="askApp.EnumCountry.KZ">KZ</option><option value="KE" data-translate="askApp.EnumCountry.KE">KE</option><option value="KG" data-translate="askApp.EnumCountry.KG">KG</option><option value="KI" data-translate="askApp.EnumCountry.KI">KI</option><option value="CC" data-translate="askApp.EnumCountry.CC">CC</option><option value="CO" data-translate="askApp.EnumCountry.CO">CO</option><option value="KM" data-translate="askApp.EnumCountry.KM">KM</option><option value="CG" data-translate="askApp.EnumCountry.CG">CG</option><option value="CD" data-translate="askApp.EnumCountry.CD">CD</option><option value="HR" data-translate="askApp.EnumCountry.HR">HR</option><option value="CU" data-translate="askApp.EnumCountry.CU">CU</option><option value="KW" data-translate="askApp.EnumCountry.KW">KW</option><option value="LA" data-translate="askApp.EnumCountry.LA">LA</option><option value="LS" data-translate="askApp.EnumCountry.LS">LS</option><option value="LV" data-translate="askApp.EnumCountry.LV">LV</option><option value="LB" data-translate="askApp.EnumCountry.LB">LB</option><option value="LR" data-translate="askApp.EnumCountry.LR">LR</option><option value="LY" data-translate="askApp.EnumCountry.LY">LY</option><option value="LI" data-translate="askApp.EnumCountry.LI">LI</option><option value="LT" data-translate="askApp.EnumCountry.LT">LT</option><option value="LU" data-translate="askApp.EnumCountry.LU">LU</option><option value="MO" data-translate="askApp.EnumCountry.MO">MO</option><option value="MG" data-translate="askApp.EnumCountry.MG">MG</option><option value="MW" data-translate="askApp.EnumCountry.MW">MW</option><option value="MY" data-translate="askApp.EnumCountry.MY">MY</option><option value="MV" data-translate="askApp.EnumCountry.MV">MV</option><option value="ML" data-translate="askApp.EnumCountry.ML">ML</option><option value="MT" data-translate="askApp.EnumCountry.MT">MT</option><option value="MP" data-translate="askApp.EnumCountry.MP">MP</option><option value="MA" data-translate="askApp.EnumCountry.MA">MA</option><option value="MH" data-translate="askApp.EnumCountry.MH">MH</option><option value="MQ" data-translate="askApp.EnumCountry.MQ">MQ</option><option value="MR" data-translate="askApp.EnumCountry.MR">MR</option><option value="MU" data-translate="askApp.EnumCountry.MU">MU</option><option value="YT" data-translate="askApp.EnumCountry.YT">YT</option><option value="MK" data-translate="askApp.EnumCountry.MK">MK</option><option value="MX" data-translate="askApp.EnumCountry.MX">MX</option><option value="FM" data-translate="askApp.EnumCountry.FM">FM</option><option value="MZ" data-translate="askApp.EnumCountry.MZ">MZ</option><option value="MD" data-translate="askApp.EnumCountry.MD">MD</option><option value="MC" data-translate="askApp.EnumCountry.MC">MC</option><option value="MN" data-translate="askApp.EnumCountry.MN">MN</option><option value="MS" data-translate="askApp.EnumCountry.MS">MS</option><option value="NA" data-translate="askApp.EnumCountry.NA">NA</option><option value="NR" data-translate="askApp.EnumCountry.NR">NR</option><option value="NP" data-translate="askApp.EnumCountry.NP">NP</option><option value="NC" data-translate="askApp.EnumCountry.NC">NC</option><option value="NZ" data-translate="askApp.EnumCountry.NZ">NZ</option><option value="NI" data-translate="askApp.EnumCountry.NI">NI</option><option value="NL" data-translate="askApp.EnumCountry.NL">NL</option><option value="AN" data-translate="askApp.EnumCountry.AN">AN</option><option value="NE" data-translate="askApp.EnumCountry.NE">NE</option><option value="NG" data-translate="askApp.EnumCountry.NG">NG</option><option value="NU" data-translate="askApp.EnumCountry.NU">NU</option><option value="KP" data-translate="askApp.EnumCountry.KP">KP</option><option value="NF" data-translate="askApp.EnumCountry.NF">NF</option><option value="NO" data-translate="askApp.EnumCountry.NO">NO</option><option value="OM" data-translate="askApp.EnumCountry.OM">OM</option><option value="AT" data-translate="askApp.EnumCountry.AT">AT</option><option value="PK" data-translate="askApp.EnumCountry.PK">PK</option><option value="PS" data-translate="askApp.EnumCountry.PS">PS</option><option value="PW" data-translate="askApp.EnumCountry.PW">PW</option><option value="PA" data-translate="askApp.EnumCountry.PA">PA</option><option value="PG" data-translate="askApp.EnumCountry.PG">PG</option><option value="PY" data-translate="askApp.EnumCountry.PY">PY</option><option value="PE" data-translate="askApp.EnumCountry.PE">PE</option><option value="PH" data-translate="askApp.EnumCountry.PH">PH</option><option value="PN" data-translate="askApp.EnumCountry.PN">PN</option><option value="PL" data-translate="askApp.EnumCountry.PL">PL</option><option value="PT" data-translate="askApp.EnumCountry.PT">PT</option><option value="PR" data-translate="askApp.EnumCountry.PR">PR</option><option value="QA" data-translate="askApp.EnumCountry.QA">QA</option><option value="RE" data-translate="askApp.EnumCountry.RE">RE</option><option value="RW" data-translate="askApp.EnumCountry.RW">RW</option><option value="RO" data-translate="askApp.EnumCountry.RO">RO</option><option value="RU" data-translate="askApp.EnumCountry.RU">RU</option><option value="LC" data-translate="askApp.EnumCountry.LC">LC</option><option value="ZM" data-translate="askApp.EnumCountry.ZM">ZM</option><option value="AS" data-translate="askApp.EnumCountry.AS">AS</option><option value="WS" data-translate="askApp.EnumCountry.WS">WS</option><option value="SM" data-translate="askApp.EnumCountry.SM">SM</option><option value="ST" data-translate="askApp.EnumCountry.ST">ST</option><option value="SA" data-translate="askApp.EnumCountry.SA">SA</option><option value="SE" data-translate="askApp.EnumCountry.SE">SE</option><option value="CH" data-translate="askApp.EnumCountry.CH">CH</option><option value="SN" data-translate="askApp.EnumCountry.SN">SN</option><option value="SC" data-translate="askApp.EnumCountry.SC">SC</option><option value="SL" data-translate="askApp.EnumCountry.SL">SL</option><option value="SG" data-translate="askApp.EnumCountry.SG">SG</option><option value="SK" data-translate="askApp.EnumCountry.SK">SK</option><option value="SI" data-translate="askApp.EnumCountry.SI">SI</option><option value="SB" data-translate="askApp.EnumCountry.SB">SB</option><option value="SO" data-translate="askApp.EnumCountry.SO">SO</option><option value="GS" data-translate="askApp.EnumCountry.GS">GS</option><option value="ES" data-translate="askApp.EnumCountry.ES">ES</option><option value="LK" data-translate="askApp.EnumCountry.LK">LK</option><option value="SH" data-translate="askApp.EnumCountry.SH">SH</option><option value="KN" data-translate="askApp.EnumCountry.KN">KN</option><option value="PM" data-translate="askApp.EnumCountry.PM">PM</option><option value="VC" data-translate="askApp.EnumCountry.VC">VC</option><option value="KR" data-translate="askApp.EnumCountry.KR">KR</option><option value="ZA" data-translate="askApp.EnumCountry.ZA">ZA</option><option value="SD" data-translate="askApp.EnumCountry.SD">SD</option><option value="SR" data-translate="askApp.EnumCountry.SR">SR</option><option value="SJ" data-translate="askApp.EnumCountry.SJ">SJ</option><option value="SZ" data-translate="askApp.EnumCountry.SZ">SZ</option><option value="SY" data-translate="askApp.EnumCountry.SY">SY</option><option value="TJ" data-translate="askApp.EnumCountry.TJ">TJ</option><option value="TW" data-translate="askApp.EnumCountry.TW">TW</option><option value="TZ" data-translate="askApp.EnumCountry.TZ">TZ</option><option value="TH" data-translate="askApp.EnumCountry.TH">TH</option><option value="TP" data-translate="askApp.EnumCountry.TP">TP</option><option value="TG" data-translate="askApp.EnumCountry.TG">TG</option><option value="TK" data-translate="askApp.EnumCountry.TK">TK</option><option value="TO" data-translate="askApp.EnumCountry.TO">TO</option><option value="TT" data-translate="askApp.EnumCountry.TT">TT</option><option value="TD" data-translate="askApp.EnumCountry.TD">TD</option><option value="CZ" data-translate="askApp.EnumCountry.CZ">CZ</option><option value="TN" data-translate="askApp.EnumCountry.TN">TN</option><option value="TR" data-translate="askApp.EnumCountry.TR">TR</option><option value="TM" data-translate="askApp.EnumCountry.TM">TM</option><option value="TC" data-translate="askApp.EnumCountry.TC">TC</option><option value="TV" data-translate="askApp.EnumCountry.TV">TV</option><option value="UG" data-translate="askApp.EnumCountry.UG">UG</option><option value="UA" data-translate="askApp.EnumCountry.UA">UA</option><option value="HU" data-translate="askApp.EnumCountry.HU">HU</option><option value="UY" data-translate="askApp.EnumCountry.UY">UY</option><option value="UZ" data-translate="askApp.EnumCountry.UZ">UZ</option><option value="VU" data-translate="askApp.EnumCountry.VU">VU</option><option value="VA" data-translate="askApp.EnumCountry.VA">VA</option><option value="VE" data-translate="askApp.EnumCountry.VE">VE</option><option value="AE" data-translate="askApp.EnumCountry.AE">AE</option><option value="US" data-translate="askApp.EnumCountry.US">US</option><option value="VN" data-translate="askApp.EnumCountry.VN">VN</option><option value="VG" data-translate="askApp.EnumCountry.VG">VG</option><option value="VI" data-translate="askApp.EnumCountry.VI">VI</option><option value="WF" data-translate="askApp.EnumCountry.WF">WF</option><option value="BY" data-translate="askApp.EnumCountry.BY">BY</option><option value="EH" data-translate="askApp.EnumCountry.EH">EH</option><option value="CF" data-translate="askApp.EnumCountry.CF">CF</option><option value="ZW" data-translate="askApp.EnumCountry.ZW">ZW</option><option value="CY" data-translate="askApp.EnumCountry.CY">CY</option></select><div ng-show="editForm.country.$invalid"><p class="help-block" ng-show="editForm.country.$error.required" data-translate="entity.validation.required">This field is required.</p></div></div><div class="form-group"><label class="control-label" data-translate="askApp.profile.postcode" for="field_postcode">Postcode</label><input type="text" class="form-control" name="postcode" id="field_postcode" ng-model="vm.profile.postcode" required><div ng-show="editForm.postcode.$invalid"><p class="help-block" ng-show="editForm.postcode.$error.required" data-translate="entity.validation.required">This field is required.</p></div></div><div class="form-group"><label class="control-label" data-translate="askApp.profile.weight" for="field_weight">Weight</label><input type="number" class="form-control" name="weight" id="field_weight" ng-model="vm.profile.weight" min="0" max="200"><div ng-show="editForm.weight.$invalid"><p class="help-block" ng-show="editForm.weight.$error.min" data-translate="entity.validation.min" translate-value-min="0">This field should be at least 0.</p><p class="help-block" ng-show="editForm.weight.$error.max" data-translate="entity.validation.max" translate-value-max="200">This field cannot be more than 200.</p><p class="help-block" ng-show="editForm.weight.$error.number" data-translate="entity.validation.number">This field should be a number.</p></div></div><div class="form-group"><label class="control-label" data-translate="askApp.profile.clothingSize" for="field_clothingSize">Clothing Size</label><select class="form-control" name="clothingSize" ng-model="vm.profile.clothingSize" id="field_clothingSize"><option value="XXS" data-translate="askApp.EnumClothingSize.XXS">XXS</option><option value="XS" data-translate="askApp.EnumClothingSize.XS">XS</option><option value="S" data-translate="askApp.EnumClothingSize.S">S</option><option value="M" data-translate="askApp.EnumClothingSize.M">M</option><option value="L" data-translate="askApp.EnumClothingSize.L">L</option><option value="XL" data-translate="askApp.EnumClothingSize.XL">XL</option><option value="XXL" data-translate="askApp.EnumClothingSize.XXL">XXL</option><option value="XXXL" data-translate="askApp.EnumClothingSize.XXXL">XXXL</option></select></div><div class="form-group"><label class="control-label" data-translate="askApp.profile.shoeSize" for="field_shoeSize">Show Size</label><input type="number" class="form-control" name="shoeSize" id="field_shoeSize" ng-model="vm.profile.shoeSize" step="0.5" placeholder="{{\'askApp.profile.shoeSize.placeholder\' | translate}}" min="20" max="60"><div ng-show="editForm.shoeSize.$invalid"><p class="help-block" ng-show="editForm.shoeSize.$error.min" data-translate="entity.validation.min" translate-value-min="20">This field should be at least 20.</p><p class="help-block" ng-show="editForm.shoeSize.$error.max" data-translate="entity.validation.max" translate-value-max="60">This field cannot be more than 60.</p><p class="help-block" ng-show="editForm.shoeSize.$error.number" data-translate="entity.validation.number">This field should be a number.</p></div></div><div class="form-group"><label class="control-label" data-translate="askApp.profile.nationality" for="field_nationality">Nationality</label><select class="form-control" name="nationality" ng-model="vm.profile.nationality" id="field_nationality"><option value="AF" data-translate="askApp.EnumCountry.AF">AF</option><option value="EG" data-translate="askApp.EnumCountry.EG">EG</option><option value="AL" data-translate="askApp.EnumCountry.AL">AL</option><option value="DZ" data-translate="askApp.EnumCountry.DZ">DZ</option><option value="AD" data-translate="askApp.EnumCountry.AD">AD</option><option value="AO" data-translate="askApp.EnumCountry.AO">AO</option><option value="AI" data-translate="askApp.EnumCountry.AI">AI</option><option value="AQ" data-translate="askApp.EnumCountry.AQ">AQ</option><option value="AG" data-translate="askApp.EnumCountry.AG">AG</option><option value="GQ" data-translate="askApp.EnumCountry.GQ">GQ</option><option value="AR" data-translate="askApp.EnumCountry.AR">AR</option><option value="AM" data-translate="askApp.EnumCountry.AM">AM</option><option value="AW" data-translate="askApp.EnumCountry.AW">AW</option><option value="AZ" data-translate="askApp.EnumCountry.AZ">AZ</option><option value="ET" data-translate="askApp.EnumCountry.ET">ET</option><option value="AU" data-translate="askApp.EnumCountry.AU">AU</option><option value="BS" data-translate="askApp.EnumCountry.BS">BS</option><option value="BH" data-translate="askApp.EnumCountry.BH">BH</option><option value="BD" data-translate="askApp.EnumCountry.BD">BD</option><option value="BB" data-translate="askApp.EnumCountry.BB">BB</option><option value="BE" data-translate="askApp.EnumCountry.BE">BE</option><option value="BZ" data-translate="askApp.EnumCountry.BZ">BZ</option><option value="BJ" data-translate="askApp.EnumCountry.BJ">BJ</option><option value="BM" data-translate="askApp.EnumCountry.BM">BM</option><option value="BT" data-translate="askApp.EnumCountry.BT">BT</option><option value="MM" data-translate="askApp.EnumCountry.MM">MM</option><option value="BO" data-translate="askApp.EnumCountry.BO">BO</option><option value="BA" data-translate="askApp.EnumCountry.BA">BA</option><option value="BW" data-translate="askApp.EnumCountry.BW">BW</option><option value="BV" data-translate="askApp.EnumCountry.BV">BV</option><option value="BR" data-translate="askApp.EnumCountry.BR">BR</option><option value="IO" data-translate="askApp.EnumCountry.IO">IO</option><option value="BN" data-translate="askApp.EnumCountry.BN">BN</option><option value="BG" data-translate="askApp.EnumCountry.BG">BG</option><option value="BF" data-translate="askApp.EnumCountry.BF">BF</option><option value="BI" data-translate="askApp.EnumCountry.BI">BI</option><option value="CL" data-translate="askApp.EnumCountry.CL">CL</option><option value="CN" data-translate="askApp.EnumCountry.CN">CN</option><option value="CX" data-translate="askApp.EnumCountry.CX">CX</option><option value="CK" data-translate="askApp.EnumCountry.CK">CK</option><option value="CR" data-translate="askApp.EnumCountry.CR">CR</option><option value="DK" data-translate="askApp.EnumCountry.DK">DK</option><option value="DE" data-translate="askApp.EnumCountry.DE">DE</option><option value="DJ" data-translate="askApp.EnumCountry.DJ">DJ</option><option value="DM" data-translate="askApp.EnumCountry.DM">DM</option><option value="DO" data-translate="askApp.EnumCountry.DO">DO</option><option value="EC" data-translate="askApp.EnumCountry.EC">EC</option><option value="SV" data-translate="askApp.EnumCountry.SV">SV</option><option value="CI" data-translate="askApp.EnumCountry.CI">CI</option><option value="ER" data-translate="askApp.EnumCountry.ER">ER</option><option value="EE" data-translate="askApp.EnumCountry.EE">EE</option><option value="FK" data-translate="askApp.EnumCountry.FK">FK</option><option value="FO" data-translate="askApp.EnumCountry.FO">FO</option><option value="FJ" data-translate="askApp.EnumCountry.FJ">FJ</option><option value="FI" data-translate="askApp.EnumCountry.FI">FI</option><option value="FR" data-translate="askApp.EnumCountry.FR">FR</option><option value="GF" data-translate="askApp.EnumCountry.GF">GF</option><option value="PF" data-translate="askApp.EnumCountry.PF">PF</option><option value="TF" data-translate="askApp.EnumCountry.TF">TF</option><option value="GA" data-translate="askApp.EnumCountry.GA">GA</option><option value="GM" data-translate="askApp.EnumCountry.GM">GM</option><option value="GE" data-translate="askApp.EnumCountry.GE">GE</option><option value="GH" data-translate="askApp.EnumCountry.GH">GH</option><option value="GI" data-translate="askApp.EnumCountry.GI">GI</option><option value="GD" data-translate="askApp.EnumCountry.GD">GD</option><option value="GR" data-translate="askApp.EnumCountry.GR">GR</option><option value="GL" data-translate="askApp.EnumCountry.GL">GL</option><option value="UK" data-translate="askApp.EnumCountry.UK">UK</option><option value="GB" data-translate="askApp.EnumCountry.GB">GB</option><option value="GP" data-translate="askApp.EnumCountry.GP">GP</option><option value="GU" data-translate="askApp.EnumCountry.GU">GU</option><option value="GT" data-translate="askApp.EnumCountry.GT">GT</option><option value="GN" data-translate="askApp.EnumCountry.GN">GN</option><option value="GW" data-translate="askApp.EnumCountry.GW">GW</option><option value="GY" data-translate="askApp.EnumCountry.GY">GY</option><option value="HT" data-translate="askApp.EnumCountry.HT">HT</option><option value="HM" data-translate="askApp.EnumCountry.HM">HM</option><option value="HN" data-translate="askApp.EnumCountry.HN">HN</option><option value="HK" data-translate="askApp.EnumCountry.HK">HK</option><option value="IN" data-translate="askApp.EnumCountry.IN">IN</option><option value="ID" data-translate="askApp.EnumCountry.ID">ID</option><option value="IQ" data-translate="askApp.EnumCountry.IQ">IQ</option><option value="IR" data-translate="askApp.EnumCountry.IR">IR</option><option value="IE" data-translate="askApp.EnumCountry.IE">IE</option><option value="IS" data-translate="askApp.EnumCountry.IS">IS</option><option value="IL" data-translate="askApp.EnumCountry.IL">IL</option><option value="IT" data-translate="askApp.EnumCountry.IT">IT</option><option value="JM" data-translate="askApp.EnumCountry.JM">JM</option><option value="JP" data-translate="askApp.EnumCountry.JP">JP</option><option value="YE" data-translate="askApp.EnumCountry.YE">YE</option><option value="JO" data-translate="askApp.EnumCountry.JO">JO</option><option value="YU" data-translate="askApp.EnumCountry.YU">YU</option><option value="KY" data-translate="askApp.EnumCountry.KY">KY</option><option value="KH" data-translate="askApp.EnumCountry.KH">KH</option><option value="CM" data-translate="askApp.EnumCountry.CM">CM</option><option value="CA" data-translate="askApp.EnumCountry.CA">CA</option><option value="CV" data-translate="askApp.EnumCountry.CV">CV</option><option value="KZ" data-translate="askApp.EnumCountry.KZ">KZ</option><option value="KE" data-translate="askApp.EnumCountry.KE">KE</option><option value="KG" data-translate="askApp.EnumCountry.KG">KG</option><option value="KI" data-translate="askApp.EnumCountry.KI">KI</option><option value="CC" data-translate="askApp.EnumCountry.CC">CC</option><option value="CO" data-translate="askApp.EnumCountry.CO">CO</option><option value="KM" data-translate="askApp.EnumCountry.KM">KM</option><option value="CG" data-translate="askApp.EnumCountry.CG">CG</option><option value="CD" data-translate="askApp.EnumCountry.CD">CD</option><option value="HR" data-translate="askApp.EnumCountry.HR">HR</option><option value="CU" data-translate="askApp.EnumCountry.CU">CU</option><option value="KW" data-translate="askApp.EnumCountry.KW">KW</option><option value="LA" data-translate="askApp.EnumCountry.LA">LA</option><option value="LS" data-translate="askApp.EnumCountry.LS">LS</option><option value="LV" data-translate="askApp.EnumCountry.LV">LV</option><option value="LB" data-translate="askApp.EnumCountry.LB">LB</option><option value="LR" data-translate="askApp.EnumCountry.LR">LR</option><option value="LY" data-translate="askApp.EnumCountry.LY">LY</option><option value="LI" data-translate="askApp.EnumCountry.LI">LI</option><option value="LT" data-translate="askApp.EnumCountry.LT">LT</option><option value="LU" data-translate="askApp.EnumCountry.LU">LU</option><option value="MO" data-translate="askApp.EnumCountry.MO">MO</option><option value="MG" data-translate="askApp.EnumCountry.MG">MG</option><option value="MW" data-translate="askApp.EnumCountry.MW">MW</option><option value="MY" data-translate="askApp.EnumCountry.MY">MY</option><option value="MV" data-translate="askApp.EnumCountry.MV">MV</option><option value="ML" data-translate="askApp.EnumCountry.ML">ML</option><option value="MT" data-translate="askApp.EnumCountry.MT">MT</option><option value="MP" data-translate="askApp.EnumCountry.MP">MP</option><option value="MA" data-translate="askApp.EnumCountry.MA">MA</option><option value="MH" data-translate="askApp.EnumCountry.MH">MH</option><option value="MQ" data-translate="askApp.EnumCountry.MQ">MQ</option><option value="MR" data-translate="askApp.EnumCountry.MR">MR</option><option value="MU" data-translate="askApp.EnumCountry.MU">MU</option><option value="YT" data-translate="askApp.EnumCountry.YT">YT</option><option value="MK" data-translate="askApp.EnumCountry.MK">MK</option><option value="MX" data-translate="askApp.EnumCountry.MX">MX</option><option value="FM" data-translate="askApp.EnumCountry.FM">FM</option><option value="MZ" data-translate="askApp.EnumCountry.MZ">MZ</option><option value="MD" data-translate="askApp.EnumCountry.MD">MD</option><option value="MC" data-translate="askApp.EnumCountry.MC">MC</option><option value="MN" data-translate="askApp.EnumCountry.MN">MN</option><option value="MS" data-translate="askApp.EnumCountry.MS">MS</option><option value="NA" data-translate="askApp.EnumCountry.NA">NA</option><option value="NR" data-translate="askApp.EnumCountry.NR">NR</option><option value="NP" data-translate="askApp.EnumCountry.NP">NP</option><option value="NC" data-translate="askApp.EnumCountry.NC">NC</option><option value="NZ" data-translate="askApp.EnumCountry.NZ">NZ</option><option value="NI" data-translate="askApp.EnumCountry.NI">NI</option><option value="NL" data-translate="askApp.EnumCountry.NL">NL</option><option value="AN" data-translate="askApp.EnumCountry.AN">AN</option><option value="NE" data-translate="askApp.EnumCountry.NE">NE</option><option value="NG" data-translate="askApp.EnumCountry.NG">NG</option><option value="NU" data-translate="askApp.EnumCountry.NU">NU</option><option value="KP" data-translate="askApp.EnumCountry.KP">KP</option><option value="NF" data-translate="askApp.EnumCountry.NF">NF</option><option value="NO" data-translate="askApp.EnumCountry.NO">NO</option><option value="OM" data-translate="askApp.EnumCountry.OM">OM</option><option value="AT" data-translate="askApp.EnumCountry.AT">AT</option><option value="PK" data-translate="askApp.EnumCountry.PK">PK</option><option value="PS" data-translate="askApp.EnumCountry.PS">PS</option><option value="PW" data-translate="askApp.EnumCountry.PW">PW</option><option value="PA" data-translate="askApp.EnumCountry.PA">PA</option><option value="PG" data-translate="askApp.EnumCountry.PG">PG</option><option value="PY" data-translate="askApp.EnumCountry.PY">PY</option><option value="PE" data-translate="askApp.EnumCountry.PE">PE</option><option value="PH" data-translate="askApp.EnumCountry.PH">PH</option><option value="PN" data-translate="askApp.EnumCountry.PN">PN</option><option value="PL" data-translate="askApp.EnumCountry.PL">PL</option><option value="PT" data-translate="askApp.EnumCountry.PT">PT</option><option value="PR" data-translate="askApp.EnumCountry.PR">PR</option><option value="QA" data-translate="askApp.EnumCountry.QA">QA</option><option value="RE" data-translate="askApp.EnumCountry.RE">RE</option><option value="RW" data-translate="askApp.EnumCountry.RW">RW</option><option value="RO" data-translate="askApp.EnumCountry.RO">RO</option><option value="RU" data-translate="askApp.EnumCountry.RU">RU</option><option value="LC" data-translate="askApp.EnumCountry.LC">LC</option><option value="ZM" data-translate="askApp.EnumCountry.ZM">ZM</option><option value="AS" data-translate="askApp.EnumCountry.AS">AS</option><option value="WS" data-translate="askApp.EnumCountry.WS">WS</option><option value="SM" data-translate="askApp.EnumCountry.SM">SM</option><option value="ST" data-translate="askApp.EnumCountry.ST">ST</option><option value="SA" data-translate="askApp.EnumCountry.SA">SA</option><option value="SE" data-translate="askApp.EnumCountry.SE">SE</option><option value="CH" data-translate="askApp.EnumCountry.CH">CH</option><option value="SN" data-translate="askApp.EnumCountry.SN">SN</option><option value="SC" data-translate="askApp.EnumCountry.SC">SC</option><option value="SL" data-translate="askApp.EnumCountry.SL">SL</option><option value="SG" data-translate="askApp.EnumCountry.SG">SG</option><option value="SK" data-translate="askApp.EnumCountry.SK">SK</option><option value="SI" data-translate="askApp.EnumCountry.SI">SI</option><option value="SB" data-translate="askApp.EnumCountry.SB">SB</option><option value="SO" data-translate="askApp.EnumCountry.SO">SO</option><option value="GS" data-translate="askApp.EnumCountry.GS">GS</option><option value="ES" data-translate="askApp.EnumCountry.ES">ES</option><option value="LK" data-translate="askApp.EnumCountry.LK">LK</option><option value="SH" data-translate="askApp.EnumCountry.SH">SH</option><option value="KN" data-translate="askApp.EnumCountry.KN">KN</option><option value="PM" data-translate="askApp.EnumCountry.PM">PM</option><option value="VC" data-translate="askApp.EnumCountry.VC">VC</option><option value="KR" data-translate="askApp.EnumCountry.KR">KR</option><option value="ZA" data-translate="askApp.EnumCountry.ZA">ZA</option><option value="SD" data-translate="askApp.EnumCountry.SD">SD</option><option value="SR" data-translate="askApp.EnumCountry.SR">SR</option><option value="SJ" data-translate="askApp.EnumCountry.SJ">SJ</option><option value="SZ" data-translate="askApp.EnumCountry.SZ">SZ</option><option value="SY" data-translate="askApp.EnumCountry.SY">SY</option><option value="TJ" data-translate="askApp.EnumCountry.TJ">TJ</option><option value="TW" data-translate="askApp.EnumCountry.TW">TW</option><option value="TZ" data-translate="askApp.EnumCountry.TZ">TZ</option><option value="TH" data-translate="askApp.EnumCountry.TH">TH</option><option value="TP" data-translate="askApp.EnumCountry.TP">TP</option><option value="TG" data-translate="askApp.EnumCountry.TG">TG</option><option value="TK" data-translate="askApp.EnumCountry.TK">TK</option><option value="TO" data-translate="askApp.EnumCountry.TO">TO</option><option value="TT" data-translate="askApp.EnumCountry.TT">TT</option><option value="TD" data-translate="askApp.EnumCountry.TD">TD</option><option value="CZ" data-translate="askApp.EnumCountry.CZ">CZ</option><option value="TN" data-translate="askApp.EnumCountry.TN">TN</option><option value="TR" data-translate="askApp.EnumCountry.TR">TR</option><option value="TM" data-translate="askApp.EnumCountry.TM">TM</option><option value="TC" data-translate="askApp.EnumCountry.TC">TC</option><option value="TV" data-translate="askApp.EnumCountry.TV">TV</option><option value="UG" data-translate="askApp.EnumCountry.UG">UG</option><option value="UA" data-translate="askApp.EnumCountry.UA">UA</option><option value="HU" data-translate="askApp.EnumCountry.HU">HU</option><option value="UY" data-translate="askApp.EnumCountry.UY">UY</option><option value="UZ" data-translate="askApp.EnumCountry.UZ">UZ</option><option value="VU" data-translate="askApp.EnumCountry.VU">VU</option><option value="VA" data-translate="askApp.EnumCountry.VA">VA</option><option value="VE" data-translate="askApp.EnumCountry.VE">VE</option><option value="AE" data-translate="askApp.EnumCountry.AE">AE</option><option value="US" data-translate="askApp.EnumCountry.US">US</option><option value="VN" data-translate="askApp.EnumCountry.VN">VN</option><option value="VG" data-translate="askApp.EnumCountry.VG">VG</option><option value="VI" data-translate="askApp.EnumCountry.VI">VI</option><option value="WF" data-translate="askApp.EnumCountry.WF">WF</option><option value="BY" data-translate="askApp.EnumCountry.BY">BY</option><option value="EH" data-translate="askApp.EnumCountry.EH">EH</option><option value="CF" data-translate="askApp.EnumCountry.CF">CF</option><option value="ZW" data-translate="askApp.EnumCountry.ZW">ZW</option><option value="CY" data-translate="askApp.EnumCountry.CY">CY</option></select></div><div class="form-group"><label class="control-label" data-translate="askApp.profile.birthplace" for="field_birthplace">Birthplace</label><input type="text" class="form-control" name="birthplace" id="field_birthplace" ng-model="vm.profile.birthplace" ng-minlength="2" ng-maxlength="50"><div ng-show="editForm.birthplace.$invalid"><p class="help-block" ng-show="editForm.birthplace.$error.minlength" data-translate="entity.validation.minlength" translate-value-min="2">This field is required to be at least 2 characters.</p><p class="help-block" ng-show="editForm.birthplace.$error.maxlength" data-translate="entity.validation.maxlength" translate-value-max="50">This field cannot be longer than 50 characters.</p></div></div><div class="form-group"><label class="control-label" data-translate="askApp.profile.countryOfBirth" for="field_countryOfBirth">Country Of Birth</label><select class="form-control" name="countryOfBirth" ng-model="vm.profile.countryOfBirth" id="field_countryOfBirth"><option value="AF" data-translate="askApp.EnumCountry.AF">AF</option><option value="EG" data-translate="askApp.EnumCountry.EG">EG</option><option value="AL" data-translate="askApp.EnumCountry.AL">AL</option><option value="DZ" data-translate="askApp.EnumCountry.DZ">DZ</option><option value="AD" data-translate="askApp.EnumCountry.AD">AD</option><option value="AO" data-translate="askApp.EnumCountry.AO">AO</option><option value="AI" data-translate="askApp.EnumCountry.AI">AI</option><option value="AQ" data-translate="askApp.EnumCountry.AQ">AQ</option><option value="AG" data-translate="askApp.EnumCountry.AG">AG</option><option value="GQ" data-translate="askApp.EnumCountry.GQ">GQ</option><option value="AR" data-translate="askApp.EnumCountry.AR">AR</option><option value="AM" data-translate="askApp.EnumCountry.AM">AM</option><option value="AW" data-translate="askApp.EnumCountry.AW">AW</option><option value="AZ" data-translate="askApp.EnumCountry.AZ">AZ</option><option value="ET" data-translate="askApp.EnumCountry.ET">ET</option><option value="AU" data-translate="askApp.EnumCountry.AU">AU</option><option value="BS" data-translate="askApp.EnumCountry.BS">BS</option><option value="BH" data-translate="askApp.EnumCountry.BH">BH</option><option value="BD" data-translate="askApp.EnumCountry.BD">BD</option><option value="BB" data-translate="askApp.EnumCountry.BB">BB</option><option value="BE" data-translate="askApp.EnumCountry.BE">BE</option><option value="BZ" data-translate="askApp.EnumCountry.BZ">BZ</option><option value="BJ" data-translate="askApp.EnumCountry.BJ">BJ</option><option value="BM" data-translate="askApp.EnumCountry.BM">BM</option><option value="BT" data-translate="askApp.EnumCountry.BT">BT</option><option value="MM" data-translate="askApp.EnumCountry.MM">MM</option><option value="BO" data-translate="askApp.EnumCountry.BO">BO</option><option value="BA" data-translate="askApp.EnumCountry.BA">BA</option><option value="BW" data-translate="askApp.EnumCountry.BW">BW</option><option value="BV" data-translate="askApp.EnumCountry.BV">BV</option><option value="BR" data-translate="askApp.EnumCountry.BR">BR</option><option value="IO" data-translate="askApp.EnumCountry.IO">IO</option><option value="BN" data-translate="askApp.EnumCountry.BN">BN</option><option value="BG" data-translate="askApp.EnumCountry.BG">BG</option><option value="BF" data-translate="askApp.EnumCountry.BF">BF</option><option value="BI" data-translate="askApp.EnumCountry.BI">BI</option><option value="CL" data-translate="askApp.EnumCountry.CL">CL</option><option value="CN" data-translate="askApp.EnumCountry.CN">CN</option><option value="CX" data-translate="askApp.EnumCountry.CX">CX</option><option value="CK" data-translate="askApp.EnumCountry.CK">CK</option><option value="CR" data-translate="askApp.EnumCountry.CR">CR</option><option value="DK" data-translate="askApp.EnumCountry.DK">DK</option><option value="DE" data-translate="askApp.EnumCountry.DE">DE</option><option value="DJ" data-translate="askApp.EnumCountry.DJ">DJ</option><option value="DM" data-translate="askApp.EnumCountry.DM">DM</option><option value="DO" data-translate="askApp.EnumCountry.DO">DO</option><option value="EC" data-translate="askApp.EnumCountry.EC">EC</option><option value="SV" data-translate="askApp.EnumCountry.SV">SV</option><option value="CI" data-translate="askApp.EnumCountry.CI">CI</option><option value="ER" data-translate="askApp.EnumCountry.ER">ER</option><option value="EE" data-translate="askApp.EnumCountry.EE">EE</option><option value="FK" data-translate="askApp.EnumCountry.FK">FK</option><option value="FO" data-translate="askApp.EnumCountry.FO">FO</option><option value="FJ" data-translate="askApp.EnumCountry.FJ">FJ</option><option value="FI" data-translate="askApp.EnumCountry.FI">FI</option><option value="FR" data-translate="askApp.EnumCountry.FR">FR</option><option value="GF" data-translate="askApp.EnumCountry.GF">GF</option><option value="PF" data-translate="askApp.EnumCountry.PF">PF</option><option value="TF" data-translate="askApp.EnumCountry.TF">TF</option><option value="GA" data-translate="askApp.EnumCountry.GA">GA</option><option value="GM" data-translate="askApp.EnumCountry.GM">GM</option><option value="GE" data-translate="askApp.EnumCountry.GE">GE</option><option value="GH" data-translate="askApp.EnumCountry.GH">GH</option><option value="GI" data-translate="askApp.EnumCountry.GI">GI</option><option value="GD" data-translate="askApp.EnumCountry.GD">GD</option><option value="GR" data-translate="askApp.EnumCountry.GR">GR</option><option value="GL" data-translate="askApp.EnumCountry.GL">GL</option><option value="UK" data-translate="askApp.EnumCountry.UK">UK</option><option value="GB" data-translate="askApp.EnumCountry.GB">GB</option><option value="GP" data-translate="askApp.EnumCountry.GP">GP</option><option value="GU" data-translate="askApp.EnumCountry.GU">GU</option><option value="GT" data-translate="askApp.EnumCountry.GT">GT</option><option value="GN" data-translate="askApp.EnumCountry.GN">GN</option><option value="GW" data-translate="askApp.EnumCountry.GW">GW</option><option value="GY" data-translate="askApp.EnumCountry.GY">GY</option><option value="HT" data-translate="askApp.EnumCountry.HT">HT</option><option value="HM" data-translate="askApp.EnumCountry.HM">HM</option><option value="HN" data-translate="askApp.EnumCountry.HN">HN</option><option value="HK" data-translate="askApp.EnumCountry.HK">HK</option><option value="IN" data-translate="askApp.EnumCountry.IN">IN</option><option value="ID" data-translate="askApp.EnumCountry.ID">ID</option><option value="IQ" data-translate="askApp.EnumCountry.IQ">IQ</option><option value="IR" data-translate="askApp.EnumCountry.IR">IR</option><option value="IE" data-translate="askApp.EnumCountry.IE">IE</option><option value="IS" data-translate="askApp.EnumCountry.IS">IS</option><option value="IL" data-translate="askApp.EnumCountry.IL">IL</option><option value="IT" data-translate="askApp.EnumCountry.IT">IT</option><option value="JM" data-translate="askApp.EnumCountry.JM">JM</option><option value="JP" data-translate="askApp.EnumCountry.JP">JP</option><option value="YE" data-translate="askApp.EnumCountry.YE">YE</option><option value="JO" data-translate="askApp.EnumCountry.JO">JO</option><option value="YU" data-translate="askApp.EnumCountry.YU">YU</option><option value="KY" data-translate="askApp.EnumCountry.KY">KY</option><option value="KH" data-translate="askApp.EnumCountry.KH">KH</option><option value="CM" data-translate="askApp.EnumCountry.CM">CM</option><option value="CA" data-translate="askApp.EnumCountry.CA">CA</option><option value="CV" data-translate="askApp.EnumCountry.CV">CV</option><option value="KZ" data-translate="askApp.EnumCountry.KZ">KZ</option><option value="KE" data-translate="askApp.EnumCountry.KE">KE</option><option value="KG" data-translate="askApp.EnumCountry.KG">KG</option><option value="KI" data-translate="askApp.EnumCountry.KI">KI</option><option value="CC" data-translate="askApp.EnumCountry.CC">CC</option><option value="CO" data-translate="askApp.EnumCountry.CO">CO</option><option value="KM" data-translate="askApp.EnumCountry.KM">KM</option><option value="CG" data-translate="askApp.EnumCountry.CG">CG</option><option value="CD" data-translate="askApp.EnumCountry.CD">CD</option><option value="HR" data-translate="askApp.EnumCountry.HR">HR</option><option value="CU" data-translate="askApp.EnumCountry.CU">CU</option><option value="KW" data-translate="askApp.EnumCountry.KW">KW</option><option value="LA" data-translate="askApp.EnumCountry.LA">LA</option><option value="LS" data-translate="askApp.EnumCountry.LS">LS</option><option value="LV" data-translate="askApp.EnumCountry.LV">LV</option><option value="LB" data-translate="askApp.EnumCountry.LB">LB</option><option value="LR" data-translate="askApp.EnumCountry.LR">LR</option><option value="LY" data-translate="askApp.EnumCountry.LY">LY</option><option value="LI" data-translate="askApp.EnumCountry.LI">LI</option><option value="LT" data-translate="askApp.EnumCountry.LT">LT</option><option value="LU" data-translate="askApp.EnumCountry.LU">LU</option><option value="MO" data-translate="askApp.EnumCountry.MO">MO</option><option value="MG" data-translate="askApp.EnumCountry.MG">MG</option><option value="MW" data-translate="askApp.EnumCountry.MW">MW</option><option value="MY" data-translate="askApp.EnumCountry.MY">MY</option><option value="MV" data-translate="askApp.EnumCountry.MV">MV</option><option value="ML" data-translate="askApp.EnumCountry.ML">ML</option><option value="MT" data-translate="askApp.EnumCountry.MT">MT</option><option value="MP" data-translate="askApp.EnumCountry.MP">MP</option><option value="MA" data-translate="askApp.EnumCountry.MA">MA</option><option value="MH" data-translate="askApp.EnumCountry.MH">MH</option><option value="MQ" data-translate="askApp.EnumCountry.MQ">MQ</option><option value="MR" data-translate="askApp.EnumCountry.MR">MR</option><option value="MU" data-translate="askApp.EnumCountry.MU">MU</option><option value="YT" data-translate="askApp.EnumCountry.YT">YT</option><option value="MK" data-translate="askApp.EnumCountry.MK">MK</option><option value="MX" data-translate="askApp.EnumCountry.MX">MX</option><option value="FM" data-translate="askApp.EnumCountry.FM">FM</option><option value="MZ" data-translate="askApp.EnumCountry.MZ">MZ</option><option value="MD" data-translate="askApp.EnumCountry.MD">MD</option><option value="MC" data-translate="askApp.EnumCountry.MC">MC</option><option value="MN" data-translate="askApp.EnumCountry.MN">MN</option><option value="MS" data-translate="askApp.EnumCountry.MS">MS</option><option value="NA" data-translate="askApp.EnumCountry.NA">NA</option><option value="NR" data-translate="askApp.EnumCountry.NR">NR</option><option value="NP" data-translate="askApp.EnumCountry.NP">NP</option><option value="NC" data-translate="askApp.EnumCountry.NC">NC</option><option value="NZ" data-translate="askApp.EnumCountry.NZ">NZ</option><option value="NI" data-translate="askApp.EnumCountry.NI">NI</option><option value="NL" data-translate="askApp.EnumCountry.NL">NL</option><option value="AN" data-translate="askApp.EnumCountry.AN">AN</option><option value="NE" data-translate="askApp.EnumCountry.NE">NE</option><option value="NG" data-translate="askApp.EnumCountry.NG">NG</option><option value="NU" data-translate="askApp.EnumCountry.NU">NU</option><option value="KP" data-translate="askApp.EnumCountry.KP">KP</option><option value="NF" data-translate="askApp.EnumCountry.NF">NF</option><option value="NO" data-translate="askApp.EnumCountry.NO">NO</option><option value="OM" data-translate="askApp.EnumCountry.OM">OM</option><option value="AT" data-translate="askApp.EnumCountry.AT">AT</option><option value="PK" data-translate="askApp.EnumCountry.PK">PK</option><option value="PS" data-translate="askApp.EnumCountry.PS">PS</option><option value="PW" data-translate="askApp.EnumCountry.PW">PW</option><option value="PA" data-translate="askApp.EnumCountry.PA">PA</option><option value="PG" data-translate="askApp.EnumCountry.PG">PG</option><option value="PY" data-translate="askApp.EnumCountry.PY">PY</option><option value="PE" data-translate="askApp.EnumCountry.PE">PE</option><option value="PH" data-translate="askApp.EnumCountry.PH">PH</option><option value="PN" data-translate="askApp.EnumCountry.PN">PN</option><option value="PL" data-translate="askApp.EnumCountry.PL">PL</option><option value="PT" data-translate="askApp.EnumCountry.PT">PT</option><option value="PR" data-translate="askApp.EnumCountry.PR">PR</option><option value="QA" data-translate="askApp.EnumCountry.QA">QA</option><option value="RE" data-translate="askApp.EnumCountry.RE">RE</option><option value="RW" data-translate="askApp.EnumCountry.RW">RW</option><option value="RO" data-translate="askApp.EnumCountry.RO">RO</option><option value="RU" data-translate="askApp.EnumCountry.RU">RU</option><option value="LC" data-translate="askApp.EnumCountry.LC">LC</option><option value="ZM" data-translate="askApp.EnumCountry.ZM">ZM</option><option value="AS" data-translate="askApp.EnumCountry.AS">AS</option><option value="WS" data-translate="askApp.EnumCountry.WS">WS</option><option value="SM" data-translate="askApp.EnumCountry.SM">SM</option><option value="ST" data-translate="askApp.EnumCountry.ST">ST</option><option value="SA" data-translate="askApp.EnumCountry.SA">SA</option><option value="SE" data-translate="askApp.EnumCountry.SE">SE</option><option value="CH" data-translate="askApp.EnumCountry.CH">CH</option><option value="SN" data-translate="askApp.EnumCountry.SN">SN</option><option value="SC" data-translate="askApp.EnumCountry.SC">SC</option><option value="SL" data-translate="askApp.EnumCountry.SL">SL</option><option value="SG" data-translate="askApp.EnumCountry.SG">SG</option><option value="SK" data-translate="askApp.EnumCountry.SK">SK</option><option value="SI" data-translate="askApp.EnumCountry.SI">SI</option><option value="SB" data-translate="askApp.EnumCountry.SB">SB</option><option value="SO" data-translate="askApp.EnumCountry.SO">SO</option><option value="GS" data-translate="askApp.EnumCountry.GS">GS</option><option value="ES" data-translate="askApp.EnumCountry.ES">ES</option><option value="LK" data-translate="askApp.EnumCountry.LK">LK</option><option value="SH" data-translate="askApp.EnumCountry.SH">SH</option><option value="KN" data-translate="askApp.EnumCountry.KN">KN</option><option value="PM" data-translate="askApp.EnumCountry.PM">PM</option><option value="VC" data-translate="askApp.EnumCountry.VC">VC</option><option value="KR" data-translate="askApp.EnumCountry.KR">KR</option><option value="ZA" data-translate="askApp.EnumCountry.ZA">ZA</option><option value="SD" data-translate="askApp.EnumCountry.SD">SD</option><option value="SR" data-translate="askApp.EnumCountry.SR">SR</option><option value="SJ" data-translate="askApp.EnumCountry.SJ">SJ</option><option value="SZ" data-translate="askApp.EnumCountry.SZ">SZ</option><option value="SY" data-translate="askApp.EnumCountry.SY">SY</option><option value="TJ" data-translate="askApp.EnumCountry.TJ">TJ</option><option value="TW" data-translate="askApp.EnumCountry.TW">TW</option><option value="TZ" data-translate="askApp.EnumCountry.TZ">TZ</option><option value="TH" data-translate="askApp.EnumCountry.TH">TH</option><option value="TP" data-translate="askApp.EnumCountry.TP">TP</option><option value="TG" data-translate="askApp.EnumCountry.TG">TG</option><option value="TK" data-translate="askApp.EnumCountry.TK">TK</option><option value="TO" data-translate="askApp.EnumCountry.TO">TO</option><option value="TT" data-translate="askApp.EnumCountry.TT">TT</option><option value="TD" data-translate="askApp.EnumCountry.TD">TD</option><option value="CZ" data-translate="askApp.EnumCountry.CZ">CZ</option><option value="TN" data-translate="askApp.EnumCountry.TN">TN</option><option value="TR" data-translate="askApp.EnumCountry.TR">TR</option><option value="TM" data-translate="askApp.EnumCountry.TM">TM</option><option value="TC" data-translate="askApp.EnumCountry.TC">TC</option><option value="TV" data-translate="askApp.EnumCountry.TV">TV</option><option value="UG" data-translate="askApp.EnumCountry.UG">UG</option><option value="UA" data-translate="askApp.EnumCountry.UA">UA</option><option value="HU" data-translate="askApp.EnumCountry.HU">HU</option><option value="UY" data-translate="askApp.EnumCountry.UY">UY</option><option value="UZ" data-translate="askApp.EnumCountry.UZ">UZ</option><option value="VU" data-translate="askApp.EnumCountry.VU">VU</option><option value="VA" data-translate="askApp.EnumCountry.VA">VA</option><option value="VE" data-translate="askApp.EnumCountry.VE">VE</option><option value="AE" data-translate="askApp.EnumCountry.AE">AE</option><option value="US" data-translate="askApp.EnumCountry.US">US</option><option value="VN" data-translate="askApp.EnumCountry.VN">VN</option><option value="VG" data-translate="askApp.EnumCountry.VG">VG</option><option value="VI" data-translate="askApp.EnumCountry.VI">VI</option><option value="WF" data-translate="askApp.EnumCountry.WF">WF</option><option value="BY" data-translate="askApp.EnumCountry.BY">BY</option><option value="EH" data-translate="askApp.EnumCountry.EH">EH</option><option value="CF" data-translate="askApp.EnumCountry.CF">CF</option><option value="ZW" data-translate="askApp.EnumCountry.ZW">ZW</option><option value="CY" data-translate="askApp.EnumCountry.CY">CY</option></select></div><div class="form-group"><label class="control-label" data-translate="askApp.profile.phone" for="field_phone">Phone</label><input type="text" class="form-control" name="phone" id="field_phone" ng-model="vm.profile.phone" required ng-minlength="5" ng-maxlength="16"><div ng-show="editForm.phone.$invalid"><p class="help-block" ng-show="editForm.phone.$error.required" data-translate="entity.validation.required">This field is required.</p><p class="help-block" ng-show="editForm.phone.$error.minlength" data-translate="entity.validation.minlength" translate-value-min="5">This field is required to be at least 5 characters.</p><p class="help-block" ng-show="editForm.phone.$error.maxlength" data-translate="entity.validation.maxlength" translate-value-max="16">This field cannot be longer than 16 characters.</p></div></div><div class="form-group"><label class="control-label" data-translate="askApp.profile.gender" for="field_gender">Gender</label><select class="form-control" name="gender" ng-model="vm.profile.gender" id="field_gender" required><option value="M" data-translate="askApp.EnumGender.M">M</option><option value="W" data-translate="askApp.EnumGender.W">W</option></select><div ng-show="editForm.gender.$invalid"><p class="help-block" ng-show="editForm.gender.$error.required" data-translate="entity.validation.required">This field is required.</p></div></div><div class="form-group"><label class="control-label" data-translate="askApp.profile.birthdate" for="field_birthdate">Birthdate</label><div class="input-group"><input id="field_birthdate" type="text" class="form-control" name="birthdate" uib-datepicker-popup="{{dateformat}}" ng-model="vm.profile.birthdate" is-open="vm.datePickerOpenStatus.birthdate" required> <span class="input-group-btn"><button type="button" class="btn btn-default" ng-click="vm.openCalendar(\'birthdate\')"><i class="glyphicon glyphicon-calendar"></i></button></span></div><div ng-show="editForm.birthdate.$invalid"><p class="help-block" ng-show="editForm.birthdate.$error.required" data-translate="entity.validation.required">This field is required.</p></div></div><div class="form-group"><label class="control-label" data-translate="askApp.profile.isStudent" for="field_isStudent">Is Student</label><input type="checkbox" name="isStudent" id="field_isStudent" ng-model="vm.profile.isStudent"></div><div class="form-group"><label class="control-label" data-translate="askApp.profile.isVerified" for="field_isVerified">Is Verified</label><input type="checkbox" name="isVerified" id="field_isVerified" ng-model="vm.profile.isVerified"></div><div class="form-group"><label class="control-label" data-translate="askApp.profile.memberStatus" for="field_memberStatus">Member Status</label><select class="form-control" name="memberStatus" ng-model="vm.profile.memberStatus" id="field_memberStatus" required><option value="gast" data-translate="askApp.EnumMemberStatus.gast">gast</option><option value="probe" data-translate="askApp.EnumMemberStatus.probe">probe</option><option value="voll" data-translate="askApp.EnumMemberStatus.voll">voll</option><option value="ausgeschlossen" data-translate="askApp.EnumMemberStatus.ausgeschlossen">ausgeschlossen</option><option value="ausgetreten" data-translate="askApp.EnumMemberStatus.ausgetreten">ausgetreten</option><option value="ex_gast" data-translate="askApp.EnumMemberStatus.ex_gast">ex_gast</option><option value="system" data-translate="askApp.EnumMemberStatus.system">system</option></select><div ng-show="editForm.memberStatus.$invalid"><p class="help-block" ng-show="editForm.memberStatus.$error.required" data-translate="entity.validation.required">This field is required.</p></div></div><div class="form-group"><label class="control-label" data-translate="askApp.profile.expelledDate" for="field_expelledDate">Expelled Date</label><div class="input-group"><input id="field_expelledDate" type="text" class="form-control" name="expelledDate" uib-datepicker-popup="{{dateformat}}" ng-model="vm.profile.expelledDate" is-open="vm.datePickerOpenStatus.expelledDate"> <span class="input-group-btn"><button type="button" class="btn btn-default" ng-click="vm.openCalendar(\'expelledDate\')"><i class="glyphicon glyphicon-calendar"></i></button></span></div></div><div class="form-group"><label class="control-label" data-translate="askApp.profile.university" for="field_university">University</label><input type="text" class="form-control" name="university" id="field_university" ng-model="vm.profile.university"></div><div class="form-group" ngf-drop ngf-change="vm.setMatriculationCertificate($file, vm.profile)"><label class="control-label" data-translate="askApp.profile.matriculationCertificate" for="field_matriculationCertificate">Matriculation Certificate</label><div><div ng-if="vm.profile.matriculationCertificate" class="help-block clearfix"><a class="pull-left" ng-click="vm.openFile(vm.profile.matriculationCertificateContentType, vm.profile.matriculationCertificate)" data-translate="entity.action.open">open</a><br><span class="pull-left">{{vm.profile.matriculationCertificateContentType}}, {{vm.byteSize(vm.profile.matriculationCertificate)}}</span> <button type="button" ng-click="vm.profile.matriculationCertificate=null;vm.profile.matriculationCertificateContentType=null;" class="btn btn-default btn-xs pull-right"><span class="glyphicon glyphicon-remove"></span></button></div><button type="button" ngf-select class="btn btn-default btn-block" ngf-change="vm.setMatriculationCertificate($file, vm.profile)" data-translate="entity.action.addblob">Add blob</button></div><input type="hidden" class="form-control" name="matriculationCertificate" id="field_matriculationCertificate" ng-model="vm.profile.matriculationCertificate"> <input type="hidden" class="form-control" name="matriculationCertificateContentType" id="field_matriculationCertificateContentType" ng-model="vm.profile.matriculationCertificateContentType"></div><div class="form-group"><label class="control-label" data-translate="askApp.profile.matriculationDate" for="field_matriculationDate">Matriculation Date</label><div class="input-group"><input id="field_matriculationDate" type="text" class="form-control" name="matriculationDate" uib-datepicker-popup="{{dateformat}}" ng-model="vm.profile.matriculationDate" is-open="vm.datePickerOpenStatus.matriculationDate"> <span class="input-group-btn"><button type="button" class="btn btn-default" ng-click="vm.openCalendar(\'matriculationDate\')"><i class="glyphicon glyphicon-calendar"></i></button></span></div></div><div class="form-group"><label class="control-label" data-translate="askApp.profile.isUsingSepa" for="field_isUsingSepa">Is Using Sepa</label><input type="checkbox" name="isUsingSepa" id="field_isUsingSepa" ng-model="vm.profile.isUsingSepa"></div><div class="form-group"><label class="control-label" data-translate="askApp.profile.bankAccountHolder" for="field_bankAccountHolder">Bank Account Holder</label><input type="text" class="form-control" name="bankAccountHolder" id="field_bankAccountHolder" ng-model="vm.profile.bankAccountHolder"></div><div class="form-group"><label class="control-label" data-translate="askApp.profile.iban" for="field_iban">Iban</label><input type="text" class="form-control" name="iban" id="field_iban" ng-model="vm.profile.iban" ng-minlength="18" ng-maxlength="30"><div ng-show="editForm.iban.$invalid"><p class="help-block" ng-show="editForm.iban.$error.minlength" data-translate="entity.validation.minlength" translate-value-min="18">This field is required to be at least 18 characters.</p><p class="help-block" ng-show="editForm.iban.$error.maxlength" data-translate="entity.validation.maxlength" translate-value-max="30">This field cannot be longer than 30 characters.</p></div></div><div class="form-group"><label class="control-label" data-translate="askApp.profile.bic" for="field_bic">Bic</label><input type="text" class="form-control" name="bic" id="field_bic" ng-model="vm.profile.bic" ng-minlength="8" ng-maxlength="11"><div ng-show="editForm.bic.$invalid"><p class="help-block" ng-show="editForm.bic.$error.minlength" data-translate="entity.validation.minlength" translate-value-min="8">This field is required to be at least 8 characters.</p><p class="help-block" ng-show="editForm.bic.$error.maxlength" data-translate="entity.validation.maxlength" translate-value-max="11">This field cannot be longer than 11 characters.</p></div></div><div class="form-group"><label class="control-label" data-translate="askApp.profile.isDeviatedHolder" for="field_isDeviatedHolder">Is Deviated Holder</label><input type="checkbox" name="isDeviatedHolder" id="field_isDeviatedHolder" ng-model="vm.profile.isDeviatedHolder"></div><div class="form-group"><label class="control-label" data-translate="askApp.profile.emailBackup" for="field_emailBackup">Email Backup</label><input type="text" class="form-control" name="emailBackup" id="field_emailBackup" ng-model="vm.profile.emailBackup"></div><div class="form-group"><label class="control-label" data-translate="askApp.profile.idNumber" for="field_idNumber">Id Number</label><input type="text" class="form-control" name="idNumber" id="field_idNumber" ng-model="vm.profile.idNumber"></div><div class="form-group"><label class="control-label" data-translate="askApp.profile.idExpirationDate" for="field_idExpirationDate">Id Expiration Date</label><div class="input-group"><input id="field_idExpirationDate" type="text" class="form-control" name="idExpirationDate" uib-datepicker-popup="{{dateformat}}" ng-model="vm.profile.idExpirationDate" is-open="vm.datePickerOpenStatus.idExpirationDate"> <span class="input-group-btn"><button type="button" class="btn btn-default" ng-click="vm.openCalendar(\'idExpirationDate\')"><i class="glyphicon glyphicon-calendar"></i></button></span></div></div><div class="form-group"><label class="control-label" data-translate="askApp.profile.idType" for="field_idType">Id Type</label><select class="form-control" name="idType" ng-model="vm.profile.idType" id="field_idType"><option value="idcard" data-translate="askApp.EnumIDType.idcard">idcard</option><option value="passport" data-translate="askApp.EnumIDType.passport">passport</option></select></div><div class="form-group"><label class="control-label" data-translate="askApp.profile.lastLogin" for="field_lastLogin">Last Login</label><div class="input-group"><input id="field_lastLogin" type="text" class="form-control" name="lastLogin" uib-datepicker-popup="{{dateformat}}" ng-model="vm.profile.lastLogin" is-open="vm.datePickerOpenStatus.lastLogin"> <span class="input-group-btn"><button type="button" class="btn btn-default" ng-click="vm.openCalendar(\'lastLogin\')"><i class="glyphicon glyphicon-calendar"></i></button></span></div></div><div class="form-group"><label class="control-label" data-translate="askApp.profile.fullMemberDate" for="field_fullMemberDate">Full Member Date</label><div class="input-group"><input id="field_fullMemberDate" type="text" class="form-control" name="fullMemberDate" uib-datepicker-popup="{{dateformat}}" ng-model="vm.profile.fullMemberDate" is-open="vm.datePickerOpenStatus.fullMemberDate"> <span class="input-group-btn"><button type="button" class="btn btn-default" ng-click="vm.openCalendar(\'fullMemberDate\')"><i class="glyphicon glyphicon-calendar"></i></button></span></div></div><div class="form-group"><label class="control-label" data-translate="askApp.profile.commentBoard" for="field_commentBoard">Comment Board</label><input type="text" class="form-control" name="commentBoard" id="field_commentBoard" ng-model="vm.profile.commentBoard"></div><div class="form-group"><label class="control-label" data-translate="askApp.profile.commentSkipper" for="field_commentSkipper">Comment Skipper</label><input type="text" class="form-control" name="commentSkipper" id="field_commentSkipper" ng-model="vm.profile.commentSkipper"></div><div class="form-group"><label class="control-label" data-translate="askApp.profile.wantsMembershipTermination" for="field_wantsMembershipTermination">Wants Membership Termination</label><input type="checkbox" name="wantsMembershipTermination" id="field_wantsMembershipTermination" ng-model="vm.profile.wantsMembershipTermination"></div><div class="form-group"><label class="control-label" data-translate="askApp.profile.wantsNewsletter" for="field_wantsNewsletter">Wants Newsletter</label><input type="checkbox" name="wantsNewsletter" id="field_wantsNewsletter" ng-model="vm.profile.wantsNewsletter"></div><div class="form-group"><label class="control-label" data-translate="askApp.profile.sbfBinnen" for="field_sbfBinnen">Sbf Binnen</label><input type="text" class="form-control" name="sbfBinnen" id="field_sbfBinnen" ng-model="vm.profile.sbfBinnen"></div><div class="form-group"><label class="control-label" data-translate="askApp.profile.sbfSee" for="field_sbfSee">Sbf See</label><input type="text" class="form-control" name="sbfSee" id="field_sbfSee" ng-model="vm.profile.sbfSee"></div><div class="form-group"><label class="control-label" data-translate="askApp.profile.sks" for="field_sks">Sks</label><input type="text" class="form-control" name="sks" id="field_sks" ng-model="vm.profile.sks"></div><div class="form-group"><label class="control-label" data-translate="askApp.profile.sss" for="field_sss">Sss</label><input type="text" class="form-control" name="sss" id="field_sss" ng-model="vm.profile.sss"></div><div class="form-group"><label class="control-label" data-translate="askApp.profile.shs" for="field_shs">Shs</label><input type="text" class="form-control" name="shs" id="field_shs" ng-model="vm.profile.shs"></div><div class="form-group"><label class="control-label" data-translate="askApp.profile.ubi" for="field_ubi">Ubi</label><input type="text" class="form-control" name="ubi" id="field_ubi" ng-model="vm.profile.ubi"></div><div class="form-group"><label class="control-label" data-translate="askApp.profile.src" for="field_src">Src</label><input type="text" class="form-control" name="src" id="field_src" ng-model="vm.profile.src"></div><div class="form-group"><label class="control-label" data-translate="askApp.profile.lrc" for="field_lrc">Lrc</label><input type="text" class="form-control" name="lrc" id="field_lrc" ng-model="vm.profile.lrc"></div><div class="form-group"><label class="control-label" data-translate="askApp.profile.bsp" for="field_bsp">Bsp</label><input type="text" class="form-control" name="bsp" id="field_bsp" ng-model="vm.profile.bsp"></div><div class="form-group"><label class="control-label" data-translate="askApp.profile.fkn" for="field_fkn">Fkn</label><input type="text" class="form-control" name="fkn" id="field_fkn" ng-model="vm.profile.fkn"></div><div class="form-group"><label class="control-label" data-translate="askApp.profile.isaf" for="field_isaf">Isaf</label><input type="text" class="form-control" name="isaf" id="field_isaf" ng-model="vm.profile.isaf"></div><div class="form-group"><label class="control-label" data-translate="askApp.profile.isafDate" for="field_isafDate">Isaf Date</label><div class="input-group"><input id="field_isafDate" type="text" class="form-control" name="isafDate" uib-datepicker-popup="{{dateformat}}" ng-model="vm.profile.isafDate" is-open="vm.datePickerOpenStatus.isafDate"> <span class="input-group-btn"><button type="button" class="btn btn-default" ng-click="vm.openCalendar(\'isafDate\')"><i class="glyphicon glyphicon-calendar"></i></button></span></div></div><div class="form-group" ngf-drop ngf-change="vm.setImage($file, vm.profile)" ngf-pattern="\'image/*\'"><label class="control-label" data-translate="askApp.profile.image" for="field_image">Image</label><div><img data-ng-src="{{\'data:\' + vm.profile.imageContentType + \';base64,\' + vm.profile.image}}" style="max-height: 100px" ng-if="vm.profile.image" alt="profile image"><div ng-if="vm.profile.image" class="help-block clearfix"><span class="pull-left">{{vm.profile.imageContentType}}, {{vm.byteSize(vm.profile.image)}}</span> <button type="button" ng-click="vm.profile.image=null;vm.profile.imageContentType=null;" class="btn btn-default btn-xs pull-right"><span class="glyphicon glyphicon-remove"></span></button></div><button type="button" ngf-select class="btn btn-default btn-block" ngf-change="vm.setImage($file, vm.profile)" accept="image/*" data-translate="entity.action.addimage">Add image</button></div><input type="hidden" class="form-control" name="image" id="field_image" ng-model="vm.profile.image"> <input type="hidden" class="form-control" name="imageContentType" id="field_imageContentType" ng-model="vm.profile.imageContentType"></div><div class="form-group"><label data-translate="askApp.profile.user" for="field_user">User</label><select class="form-control" id="field_user" name="user" ng-model="vm.profile.user" ng-options="user as user.login for user in vm.users track by user.id" required></select></div><div ng-show="editForm.user.$invalid"><p class="help-block" ng-show="editForm.user.$error.required" data-translate="entity.validation.required">This field is required.</p></div><div class="form-group"><label data-translate="askApp.profile.skipperLevel" for="field_skipperLevel">Skipper Level</label><select class="form-control" id="field_skipperLevel" multiple="multiple" name="skipperLevel" ng-model="vm.profile.skipperLevels" ng-options="skipperLevelHolder as skipperLevelHolder.name for skipperLevelHolder in vm.skipperlevelholders track by skipperLevelHolder.id"></select></div></div><div class="modal-footer"><button type="button" class="btn btn-default" data-dismiss="modal" ng-click="vm.clear()"><span class="glyphicon glyphicon-ban-circle"></span>&nbsp;<span data-translate="entity.action.cancel">Cancel</span></button> <button type="submit" ng-disabled="editForm.$invalid || vm.isSaving" class="btn btn-primary"><span class="glyphicon glyphicon-save"></span>&nbsp;<span data-translate="entity.action.save">Save</span></button></div></form>');
$templateCache.put('app/entities/profile/profiles.html','<div><h2 data-translate="askApp.profile.home.title">Profiles</h2><jhi-alert></jhi-alert><div class="container-fluid"><div class="row"><div class="col-xs-4 no-padding-left"><button class="btn btn-primary" ui-sref="profile.new"><span class="glyphicon glyphicon-plus"></span> <span class="hidden-xs-down" data-translate="askApp.profile.home.createLabel">Create new Profile</span></button></div><div class="col-xs-8 no-padding-right"><form name="searchForm" class="form-inline"><div class="input-group pull-right"><input type="text" class="form-control" ng-model="vm.searchQuery" id="searchQuery" placeholder="{{ \'askApp.profile.home.search\' | translate }}"> <span class="input-group-btn width-min"><button class="btn btn-info" ng-click="vm.search(vm.searchQuery)"><span class="glyphicon glyphicon-search"></span></button> </span><span class="input-group-btn width-min" ng-if="vm.currentSearch"><button class="btn btn-info" ng-click="vm.clear()"><span class="glyphicon glyphicon-trash"></span></button></span></div></form></div></div></div><br><div class="table-responsive"><table class="jh-table table table-striped"><thead><tr jh-sort="vm.predicate" ascending="vm.reverse" callback="vm.transition()"><th jh-sort-by="id"><span data-translate="global.field.id">ID</span> <span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="nickname"><span data-translate="askApp.profile.nickname">Nickname</span> <span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="street"><span data-translate="askApp.profile.street">Street</span> <span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="city"><span data-translate="askApp.profile.city">City</span> <span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="country"><span data-translate="askApp.profile.country">Country</span> <span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="postcode"><span data-translate="askApp.profile.postcode">Postcode</span> <span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="weight"><span data-translate="askApp.profile.weight">Weight</span> <span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="clothingSize"><span data-translate="askApp.profile.clothingSize">Clothing Size</span> <span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="shoeSize"><span data-translate="askApp.profile.shoeSize">Clothing Size</span> <span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="nationality"><span data-translate="askApp.profile.nationality">Nationality</span> <span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="birthplace"><span data-translate="askApp.profile.birthplace">Birthplace</span> <span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="countryOfBirth"><span data-translate="askApp.profile.countryOfBirth">Country Of Birth</span> <span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="phone"><span data-translate="askApp.profile.phone">Phone</span> <span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="gender"><span data-translate="askApp.profile.gender">Gender</span> <span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="birthdate"><span data-translate="askApp.profile.birthdate">Birthdate</span> <span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="isStudent"><span data-translate="askApp.profile.isStudent">Is Student</span> <span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="isVerified"><span data-translate="askApp.profile.isVerified">Is Verified</span> <span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="memberStatus"><span data-translate="askApp.profile.memberStatus">Member Status</span> <span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="expelledDate"><span data-translate="askApp.profile.expelledDate">Expelled Date</span> <span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="university"><span data-translate="askApp.profile.university">University</span> <span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="matriculationCertificate"><span data-translate="askApp.profile.matriculationCertificate">Matriculation Certificate</span> <span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="matriculationDate"><span data-translate="askApp.profile.matriculationDate">Matriculation Date</span> <span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="isUsingSepa"><span data-translate="askApp.profile.isUsingSepa">Is Using Sepa</span> <span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="bankAccountHolder"><span data-translate="askApp.profile.bankAccountHolder">Bank Account Holder</span> <span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="iban"><span data-translate="askApp.profile.iban">Iban</span> <span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="bic"><span data-translate="askApp.profile.bic">Bic</span> <span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="isDeviatedHolder"><span data-translate="askApp.profile.isDeviatedHolder">Is Deviated Holder</span> <span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="emailBackup"><span data-translate="askApp.profile.emailBackup">Email Backup</span> <span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="idNumber"><span data-translate="askApp.profile.idNumber">Id Number</span> <span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="idExpirationDate"><span data-translate="askApp.profile.idExpirationDate">Id Expiration Date</span> <span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="idType"><span data-translate="askApp.profile.idType">Id Type</span> <span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="lastLogin"><span data-translate="askApp.profile.lastLogin">Last Login</span> <span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="fullMemberDate"><span data-translate="askApp.profile.fullMemberDate">Full Member Date</span> <span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="commentBoard"><span data-translate="askApp.profile.commentBoard">Comment Board</span> <span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="commentSkipper"><span data-translate="askApp.profile.commentSkipper">Comment Skipper</span> <span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="wantsMembershipTermination"><span data-translate="askApp.profile.wantsMembershipTermination">Wants Membership Termination</span> <span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="wantsNewsletter"><span data-translate="askApp.profile.wantsNewsletter">Wants Newsletter</span> <span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="sbfBinnen"><span data-translate="askApp.profile.sbfBinnen">Sbf Binnen</span> <span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="sbfSee"><span data-translate="askApp.profile.sbfSee">Sbf See</span> <span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="sks"><span data-translate="askApp.profile.sks">Sks</span> <span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="sss"><span data-translate="askApp.profile.sss">Sss</span> <span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="shs"><span data-translate="askApp.profile.shs">Shs</span> <span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="ubi"><span data-translate="askApp.profile.ubi">Ubi</span> <span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="src"><span data-translate="askApp.profile.src">Src</span> <span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="lrc"><span data-translate="askApp.profile.lrc">Lrc</span> <span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="bsp"><span data-translate="askApp.profile.bsp">Bsp</span> <span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="fkn"><span data-translate="askApp.profile.fkn">Fkn</span> <span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="isaf"><span data-translate="askApp.profile.isaf">Isaf</span> <span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="isafDate"><span data-translate="askApp.profile.isafDate">Isaf Date</span> <span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="image"><span data-translate="askApp.profile.image">Image</span> <span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="user.login"><span data-translate="askApp.profile.user">User</span> <span class="glyphicon glyphicon-sort"></span></th><th></th></tr></thead><tbody><tr ng-repeat="profile in vm.profiles track by profile.id"><td><a ui-sref="profile-detail({id:profile.id})">{{profile.id}}</a></td><td>{{profile.nickname}}</td><td>{{profile.street}}</td><td>{{profile.city}}</td><td data-translate="{{\'askApp.EnumCountry.\' + profile.country}}">{{profile.country}}</td><td>{{profile.postcode}}</td><td>{{profile.weight}}</td><td data-translate="{{\'askApp.EnumClothingSize.\' + profile.clothingSize}}">{{profile.clothingSize}}</td><td>{{profile.shoeSize}}</td><td data-translate="{{\'askApp.EnumCountry.\' + profile.nationality}}">{{profile.nationality}}</td><td>{{profile.birthplace}}</td><td data-translate="{{\'askApp.EnumCountry.\' + profile.countryOfBirth}}">{{profile.countryOfBirth}}</td><td>{{profile.phone}}</td><td data-translate="{{\'askApp.EnumGender.\' + profile.gender}}">{{profile.gender}}</td><td>{{profile.birthdate | date:\'mediumDate\'}}</td><td>{{profile.isStudent}}</td><td>{{profile.isVerified}}</td><td data-translate="{{\'askApp.EnumMemberStatus.\' + profile.memberStatus}}">{{profile.memberStatus}}</td><td>{{profile.expelledDate | date:\'mediumDate\'}}</td><td>{{profile.university}}</td><td><a ng-if="profile.matriculationCertificate" ng-click="vm.openFile(profile.matriculationCertificateContentType, profile.matriculationCertificate)" data-translate="entity.action.open">open</a> <span ng-if="profile.matriculationCertificate">{{profile.matriculationCertificateContentType}}, {{vm.byteSize(profile.matriculationCertificate)}}</span></td><td>{{profile.matriculationDate | date:\'mediumDate\'}}</td><td>{{profile.isUsingSepa}}</td><td>{{profile.bankAccountHolder}}</td><td>{{profile.iban}}</td><td>{{profile.bic}}</td><td>{{profile.isDeviatedHolder}}</td><td>{{profile.emailBackup}}</td><td>{{profile.idNumber}}</td><td>{{profile.idExpirationDate | date:\'mediumDate\'}}</td><td data-translate="{{\'askApp.EnumIDType.\' + profile.idType}}">{{profile.idType}}</td><td>{{profile.lastLogin | date:\'mediumDate\'}}</td><td>{{profile.fullMemberDate | date:\'mediumDate\'}}</td><td>{{profile.commentBoard}}</td><td>{{profile.commentSkipper}}</td><td>{{profile.wantsMembershipTermination}}</td><td>{{profile.wantsNewsletter}}</td><td>{{profile.sbfBinnen}}</td><td>{{profile.sbfSee}}</td><td>{{profile.sks}}</td><td>{{profile.sss}}</td><td>{{profile.shs}}</td><td>{{profile.ubi}}</td><td>{{profile.src}}</td><td>{{profile.lrc}}</td><td>{{profile.bsp}}</td><td>{{profile.fkn}}</td><td>{{profile.isaf}}</td><td>{{profile.isafDate | date:\'mediumDate\'}}</td><td><a ng-if="profile.image" ng-click="vm.openFile(profile.imageContentType, profile.image)"><img data-ng-src="{{\'data:\' + profile.imageContentType + \';base64,\' + profile.image}}" style="max-height: 30px" alt="profile image"> </a><span ng-if="profile.image">{{profile.imageContentType}}, {{vm.byteSize(profile.image)}}</span></td><td>{{profile.user.login}}</td><td class="text-right"><div class="btn-group flex-btn-group-container"><button type="submit" ui-sref="profile-detail({id:profile.id})" class="btn btn-info btn-sm"><span class="glyphicon glyphicon-eye-open"></span> <span class="hidden-sm-down" data-translate="entity.action.view"></span></button> <button type="submit" ui-sref="profile.edit({id:profile.id})" class="btn btn-primary btn-sm"><span class="glyphicon glyphicon-pencil"></span> <span class="hidden-sm-down" data-translate="entity.action.edit"></span></button> <button type="submit" ui-sref="profile.delete({id:profile.id})" class="btn btn-danger btn-sm"><span class="glyphicon glyphicon-remove-circle"></span> <span class="hidden-sm-down" data-translate="entity.action.delete"></span></button></div></td></tr></tbody></table></div><div class="text-center"><jhi-item-count page="vm.page" total="vm.queryCount" items-per-page="vm.itemsPerPage"></jhi-item-count><uib-pagination class="pagination-sm" total-items="vm.totalItems" items-per-page="vm.itemsPerPage" ng-model="vm.page" ng-change="vm.transition()"></uib-pagination></div></div>');
$templateCache.put('app/entities/project/project-delete-dialog.html','<!--\n  ~ Copyright (c) 2017 by Julian Feder, julian.feder@yahoo.de\n  ~\n  ~ This product includes software developed at\n  ~ The Apache Software Foundation (http://www.apache.org/).\n  --><form name="deleteForm" ng-submit="vm.confirmDelete(vm.project.id)"><div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()">&times;</button><h4 class="modal-title" data-translate="entity.delete.title">Confirm delete operation</h4></div><div class="modal-body"><jhi-alert-error></jhi-alert-error><p data-translate="askApp.project.delete.question" translate-values="{id: \'{{vm.project.id}}\'}">Are you sure you want to delete this Project?</p></div><div class="modal-footer"><button type="button" class="btn btn-default" data-dismiss="modal" ng-click="vm.clear()"><span class="glyphicon glyphicon-ban-circle"></span>&nbsp;<span data-translate="entity.action.cancel">Cancel</span></button> <button type="submit" ng-disabled="deleteForm.$invalid" class="btn btn-danger"><span class="glyphicon glyphicon-remove-circle"></span>&nbsp;<span data-translate="entity.action.delete">Delete</span></button></div></form>');
$templateCache.put('app/entities/project/project-detail.html','<!--\n  ~ Copyright (c) 2017 by Julian Feder, julian.feder@yahoo.de\n  ~\n  ~ This product includes software developed at\n  ~ The Apache Software Foundation (http://www.apache.org/).\n  --><div><h2><span data-translate="askApp.project.detail.title">Project</span> {{vm.project.id}}</h2><hr><jhi-alert-error></jhi-alert-error><dl class="dl-horizontal jh-entity-details"><dt><span data-translate="askApp.project.name">Name</span></dt><dd><span>{{vm.project.name}}</span></dd><dt><span data-translate="askApp.project.fromDate">From Date</span></dt><dd><span>{{vm.project.fromDate | date:\'mediumDate\'}}</span></dd><dt><span data-translate="askApp.project.untilDate">Until Date</span></dt><dd><span>{{vm.project.untilDate | date:\'mediumDate\'}}</span></dd><dt><span data-translate="askApp.project.places">Places</span></dt><dd><span>{{vm.project.places}}</span></dd><dt><span data-translate="askApp.project.identifier">Identifier</span></dt><dd><span>{{vm.project.identifier}}</span></dd><dt><span data-translate="askApp.project.description">Description</span></dt><dd><span>{{vm.project.description}}</span></dd><dt><span data-translate="askApp.project.conditions">Conditions</span></dt><dd><span>{{vm.project.conditions}}</span></dd><dt><span data-translate="askApp.project.notes">Notes</span></dt><dd><span>{{vm.project.notes}}</span></dd><dt><span data-translate="askApp.project.normalPrice">Normal Price</span></dt><dd><span>{{vm.project.normalPrice}}</span></dd><dt><span data-translate="askApp.project.studentPrice">Student Price</span></dt><dd><span>{{vm.project.studentPrice}}</span></dd><dt><span data-translate="askApp.project.guestPrice">Guest Price</span></dt><dd><span>{{vm.project.guestPrice}}</span></dd><dt><span data-translate="askApp.project.individualPrice">Individual Price</span></dt><dd><span>{{vm.project.individualPrice}}</span></dd><dt><span data-translate="askApp.project.prepayment">Prepayment</span></dt><dd><span>{{vm.project.prepayment}}</span></dd><dt><span data-translate="askApp.project.type">Type</span></dt><dd><span data-translate="{{\'askApp.EnumProjectType.\' + vm.project.type}}">{{vm.project.type}}</span></dd><dt><span data-translate="askApp.project.sksPracticalLocation">Sks Practical Location</span></dt><dd><span data-translate="{{\'askApp.EnumSksPracticalLocation.\' + vm.project.sksPracticalLocation}}">{{vm.project.sksPracticalLocation}}</span></dd><dt><span data-translate="askApp.project.visible">Visible</span></dt><dd><span>{{vm.project.visible}}</span></dd><dt><span data-translate="askApp.project.closed">Closed</span></dt><dd><span>{{vm.project.closed}}</span></dd><dt><span data-translate="askApp.project.guest">Guest</span></dt><dd><span>{{vm.project.guest}}</span></dd><dt><span data-translate="askApp.project.image">Image</span></dt><dd><div ng-if="vm.project.image"><a ng-click="vm.openFile(vm.project.imageContentType, vm.project.image)"><img data-ng-src="{{\'data:\' + vm.project.imageContentType + \';base64,\' + vm.project.image}}" style="max-width: 100%" alt="project image"> </a>{{vm.project.imageContentType}}, {{vm.byteSize(vm.project.image)}}</div></dd><dt><span data-translate="askApp.project.weight">Weight</span></dt><dd><span>{{vm.project.weight}}</span></dd><dt><span data-translate="askApp.project.clothingSize">Clothing Size</span></dt><dd><span>{{vm.project.clothingSize}}</span></dd><dt><span data-translate="askApp.project.shoeSize">Shoe Size</span></dt><dd><span>{{vm.project.shoeSize}}</span></dd><dt><span data-translate="askApp.project.nationality">Nationality</span></dt><dd><span>{{vm.project.nationality}}</span></dd><dt><span data-translate="askApp.project.countryOfBirth">Country Of Birth</span></dt><dd><span>{{vm.project.countryOfBirth}}</span></dd><dt><span data-translate="askApp.project.birthplace">Birthplace</span></dt><dd><span>{{vm.project.birthplace}}</span></dd><dt><span data-translate="askApp.project.idNumber">Id Number</span></dt><dd><span>{{vm.project.idNumber}}</span></dd><dt><span data-translate="askApp.project.active">Active</span></dt><dd><span>{{vm.project.active}}</span></dd><dt><span data-translate="askApp.project.checkRegisterDate">Check Register Date</span></dt><dd><span>{{vm.project.checkRegisterDate}}</span></dd><dt><span data-translate="askApp.project.queue">Queue</span></dt><dd><span>{{vm.project.queue}}</span></dd><dt><span data-translate="askApp.project.activityPoints">Activity Points</span></dt><dd><span>{{vm.project.activityPoints}}</span></dd><dt><span data-translate="askApp.project.email">Email</span></dt><dd><span>{{vm.project.email}}</span></dd><dt><span data-translate="askApp.project.booked">Booked</span></dt><dd><span>{{vm.project.booked}}</span></dd><dt><span data-translate="askApp.project.individualField">Individual Field</span></dt><dd><span>{{vm.project.individualField}}</span></dd><dt><span data-translate="askApp.project.additionalBookable">Additional Bookable</span></dt><dd><span>{{vm.project.additionalBookable}}</span></dd><dt><span data-translate="askApp.project.sbfSlotsMax">Sbf Slots Max</span></dt><dd><span>{{vm.project.sbfSlotsMax}}</span></dd><dt><span data-translate="askApp.project.profile">Profile</span></dt><dd><a ui-sref="profile-detail({id:vm.project.profile.id})">{{vm.project.profile.id}}</a></dd><dt><span data-translate="askApp.project.skipper">Skipper</span></dt><dd><a ui-sref="profile-detail({id:vm.project.skipper.id})">{{vm.project.skipper.id}}</a></dd><dt><span data-translate="askApp.project.authorizedMembers">Authorized Members</span></dt><dd><span ng-repeat="authorizedMembers in vm.project.authorizedMembers"><a ui-sref="profile-detail({id: authorizedMembers.id})">{{authorizedMembers.id}}</a>{{$last ? \'\' : \', \'}}</span></dd><dt><span data-translate="askApp.project.authorizedGroups">Authorized Groups</span></dt><dd><span ng-repeat="authorizedGroups in vm.project.authorizedGroups"><a ui-sref="authority-detail({id: authorizedGroups.id})">{{authorizedGroups.id}}</a>{{$last ? \'\' : \', \'}}</span></dd></dl><button type="submit" ui-sref="{{ vm.previousState }}" class="btn btn-info"><span class="glyphicon glyphicon-arrow-left"></span>&nbsp;<span data-translate="entity.action.back"> Back</span></button> <button type="button" ui-sref="project-detail.edit({id:vm.project.id})" class="btn btn-primary"><span class="glyphicon glyphicon-pencil"></span> <span class="hidden-sm-down" data-translate="entity.action.edit">Edit</span></button></div>');
$templateCache.put('app/entities/project/project-dialog.html','<!--\n  ~ Copyright (c) 2017 by Julian Feder, julian.feder@yahoo.de\n  ~\n  ~ This product includes software developed at\n  ~ The Apache Software Foundation (http://www.apache.org/).\n  --><form name="editForm" role="form" novalidate ng-submit="vm.save()" show-validation><div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()">&times;</button><h4 class="modal-title" id="myProjectLabel" data-translate="askApp.project.home.createOrEditLabel">Create or edit a Project</h4></div><div class="modal-body"><jhi-alert-error></jhi-alert-error><div class="form-group" ng-show="vm.project.id"><label for="id" data-translate="global.field.id">ID</label><input type="text" class="form-control" id="id" name="id" ng-model="vm.project.id" readonly="readonly"></div><div class="form-group"><label class="control-label" data-translate="askApp.project.name" for="field_name">Name</label><input type="text" class="form-control" name="name" id="field_name" ng-model="vm.project.name" required ng-minlength="3" ng-maxlength="50"><div ng-show="editForm.name.$invalid"><p class="help-block" ng-show="editForm.name.$error.required" data-translate="entity.validation.required">This field is required.</p><p class="help-block" ng-show="editForm.name.$error.minlength" data-translate="entity.validation.minlength" translate-value-min="3">This field is required to be at least 3 characters.</p><p class="help-block" ng-show="editForm.name.$error.maxlength" data-translate="entity.validation.maxlength" translate-value-max="50">This field cannot be longer than 50 characters.</p></div></div><div class="form-group"><label class="control-label" data-translate="askApp.project.fromDate" for="field_fromDate">From Date</label><div class="input-group"><input id="field_fromDate" type="text" class="form-control" name="fromDate" uib-datepicker-popup="{{dateformat}}" ng-model="vm.project.fromDate" is-open="vm.datePickerOpenStatus.fromDate" required> <span class="input-group-btn"><button type="button" class="btn btn-default" ng-click="vm.openCalendar(\'fromDate\')"><i class="glyphicon glyphicon-calendar"></i></button></span></div><div ng-show="editForm.fromDate.$invalid"><p class="help-block" ng-show="editForm.fromDate.$error.required" data-translate="entity.validation.required">This field is required.</p></div></div><div class="form-group"><label class="control-label" data-translate="askApp.project.untilDate" for="field_untilDate">Until Date</label><div class="input-group"><input id="field_untilDate" type="text" class="form-control" name="untilDate" uib-datepicker-popup="{{dateformat}}" ng-model="vm.project.untilDate" is-open="vm.datePickerOpenStatus.untilDate" required> <span class="input-group-btn"><button type="button" class="btn btn-default" ng-click="vm.openCalendar(\'untilDate\')"><i class="glyphicon glyphicon-calendar"></i></button></span></div><div ng-show="editForm.untilDate.$invalid"><p class="help-block" ng-show="editForm.untilDate.$error.required" data-translate="entity.validation.required">This field is required.</p></div></div><div class="form-group"><label class="control-label" data-translate="askApp.project.places" for="field_places">Places</label><input type="number" class="form-control" name="places" id="field_places" ng-model="vm.project.places" required><div ng-show="editForm.places.$invalid"><p class="help-block" ng-show="editForm.places.$error.required" data-translate="entity.validation.required">This field is required.</p><p class="help-block" ng-show="editForm.places.$error.number" data-translate="entity.validation.number">This field should be a number.</p></div></div><div class="form-group"><label class="control-label" data-translate="askApp.project.identifier" for="field_identifier">Identifier</label><input type="text" class="form-control" name="identifier" id="field_identifier" ng-model="vm.project.identifier" required><div ng-show="editForm.identifier.$invalid"><p class="help-block" ng-show="editForm.identifier.$error.required" data-translate="entity.validation.required">This field is required.</p></div></div><div class="form-group"><label class="control-label" data-translate="askApp.project.description" for="field_description">Description</label><input type="text" class="form-control" name="description" id="field_description" ng-model="vm.project.description"></div><div class="form-group"><label class="control-label" data-translate="askApp.project.conditions" for="field_conditions">Conditions</label><input type="text" class="form-control" name="conditions" id="field_conditions" ng-model="vm.project.conditions"></div><div class="form-group"><label class="control-label" data-translate="askApp.project.notes" for="field_notes">Notes</label><input type="text" class="form-control" name="notes" id="field_notes" ng-model="vm.project.notes"></div><div class="form-group"><label class="control-label" data-translate="askApp.project.normalPrice" for="field_normalPrice">Normal Price</label><input type="number" class="form-control" name="normalPrice" id="field_normalPrice" ng-model="vm.project.normalPrice" required><div ng-show="editForm.normalPrice.$invalid"><p class="help-block" ng-show="editForm.normalPrice.$error.required" data-translate="entity.validation.required">This field is required.</p><p class="help-block" ng-show="editForm.normalPrice.$error.number" data-translate="entity.validation.number">This field should be a number.</p></div></div><div class="form-group"><label class="control-label" data-translate="askApp.project.studentPrice" for="field_studentPrice">Student Price</label><input type="number" class="form-control" name="studentPrice" id="field_studentPrice" ng-model="vm.project.studentPrice" required><div ng-show="editForm.studentPrice.$invalid"><p class="help-block" ng-show="editForm.studentPrice.$error.required" data-translate="entity.validation.required">This field is required.</p><p class="help-block" ng-show="editForm.studentPrice.$error.number" data-translate="entity.validation.number">This field should be a number.</p></div></div><div class="form-group"><label class="control-label" data-translate="askApp.project.guestPrice" for="field_guestPrice">Guest Price</label><input type="number" class="form-control" name="guestPrice" id="field_guestPrice" ng-model="vm.project.guestPrice"></div><div class="form-group"><label class="control-label" data-translate="askApp.project.individualPrice" for="field_individualPrice">Individual Price</label><input type="number" class="form-control" name="individualPrice" id="field_individualPrice" ng-model="vm.project.individualPrice"></div><div class="form-group"><label class="control-label" data-translate="askApp.project.prepayment" for="field_prepayment">Prepayment</label><input type="number" class="form-control" name="prepayment" id="field_prepayment" ng-model="vm.project.prepayment"></div><div class="form-group"><label class="control-label" data-translate="askApp.project.type" for="field_type">Type</label><select class="form-control" name="type" ng-model="vm.project.type" id="field_type" required><option value="course" data-translate="askApp.EnumProjectType.course">course</option><option value="event" data-translate="askApp.EnumProjectType.event">event</option><option value="sbfPractical" data-translate="askApp.EnumProjectType.sbfPractical">sbfPractical</option><option value="sksTrip" data-translate="askApp.EnumProjectType.sksTrip">sksTrip</option><option value="interest" data-translate="askApp.EnumProjectType.interest">interest</option><option value="merchandise" data-translate="askApp.EnumProjectType.merchandise">merchandise</option></select><div ng-show="editForm.type.$invalid"><p class="help-block" ng-show="editForm.type.$error.required" data-translate="entity.validation.required">This field is required.</p></div></div><div class="form-group"><label class="control-label" data-translate="askApp.project.sksPracticalLocation" for="field_sksPracticalLocation">Sks Practical Location</label><select class="form-control" name="sksPracticalLocation" ng-model="vm.project.sksPracticalLocation" id="field_sksPracticalLocation"><option value="elba" data-translate="askApp.EnumSksPracticalLocation.elba">elba</option><option value="mallorca" data-translate="askApp.EnumSksPracticalLocation.mallorca">mallorca</option><option value="portoroz" data-translate="askApp.EnumSksPracticalLocation.portoroz">portoroz</option><option value="izola" data-translate="askApp.EnumSksPracticalLocation.izola">izola</option><option value="suedfrankreich" data-translate="askApp.EnumSksPracticalLocation.suedfrankreich">suedfrankreich</option><option value="kroatienIstrien" data-translate="askApp.EnumSksPracticalLocation.kroatienIstrien">kroatienIstrien</option><option value="athen" data-translate="askApp.EnumSksPracticalLocation.athen">athen</option><option value="lavrio" data-translate="askApp.EnumSksPracticalLocation.lavrio">lavrio</option><option value="heiligenhafen" data-translate="askApp.EnumSksPracticalLocation.heiligenhafen">heiligenhafen</option><option value="gluecksburg" data-translate="askApp.EnumSksPracticalLocation.gluecksburg">gluecksburg</option><option value="kanaren" data-translate="askApp.EnumSksPracticalLocation.kanaren">kanaren</option></select></div><div class="form-group"><label class="control-label" data-translate="askApp.project.visible" for="field_visible">Visible</label><input type="checkbox" name="visible" id="field_visible" ng-model="vm.project.visible"></div><div class="form-group"><label class="control-label" data-translate="askApp.project.closed" for="field_closed">Closed</label><input type="checkbox" name="closed" id="field_closed" ng-model="vm.project.closed"></div><div class="form-group"><label class="control-label" data-translate="askApp.project.guest" for="field_guest">Guest</label><input type="checkbox" name="guest" id="field_guest" ng-model="vm.project.guest"></div><div class="form-group" ngf-drop ngf-change="vm.setImage($file, vm.project)" ngf-pattern="\'image/*\'"><label class="control-label" data-translate="askApp.project.image" for="field_image">Image</label><div><img data-ng-src="{{\'data:\' + vm.project.imageContentType + \';base64,\' + vm.project.image}}" style="max-height: 100px" ng-if="vm.project.image" alt="project image"><div ng-if="vm.project.image" class="help-block clearfix"><span class="pull-left">{{vm.project.imageContentType}}, {{vm.byteSize(vm.project.image)}}</span> <button type="button" ng-click="vm.project.image=null;vm.project.imageContentType=null;" class="btn btn-default btn-xs pull-right"><span class="glyphicon glyphicon-remove"></span></button></div><button type="button" ngf-select class="btn btn-default btn-block" ngf-change="vm.setImage($file, vm.project)" accept="image/*" data-translate="entity.action.addimage">Add image</button></div><input type="hidden" class="form-control" name="image" id="field_image" ng-model="vm.project.image"> <input type="hidden" class="form-control" name="imageContentType" id="field_imageContentType" ng-model="vm.project.imageContentType"></div><div class="form-group"><label class="control-label" data-translate="askApp.project.weight" for="field_weight">Weight</label><input type="checkbox" name="weight" id="field_weight" ng-model="vm.project.weight"></div><div class="form-group"><label class="control-label" data-translate="askApp.project.clothingSize" for="field_clothingSize">Clothing Size</label><input type="checkbox" name="clothingSize" id="field_clothingSize" ng-model="vm.project.clothingSize"><div class="form-group"><label class="control-label" data-translate="askApp.project.shoeSize" for="field_shoeSize">Clothing Size</label><input type="checkbox" name="shoeSize" id="field_shoeSize" ng-model="vm.project.shoeSize"></div><div class="form-group"><label class="control-label" data-translate="askApp.project.nationality" for="field_nationality">Nationality</label><input type="checkbox" name="nationality" id="field_nationality" ng-model="vm.project.nationality"></div><div class="form-group"><label class="control-label" data-translate="askApp.project.countryOfBirth" for="field_countryOfBirth">Country Of Birth</label><input type="checkbox" name="countryOfBirth" id="field_countryOfBirth" ng-model="vm.project.countryOfBirth"></div><div class="form-group"><label class="control-label" data-translate="askApp.project.birthplace" for="field_birthplace">Birthplace</label><input type="checkbox" name="birthplace" id="field_birthplace" ng-model="vm.project.birthplace"></div><div class="form-group"><label class="control-label" data-translate="askApp.project.idNumber" for="field_idNumber">Id Number</label><input type="checkbox" name="idNumber" id="field_idNumber" ng-model="vm.project.idNumber"></div><div class="form-group"><label class="control-label" data-translate="askApp.project.active" for="field_active">Active</label><input type="checkbox" name="active" id="field_active" ng-model="vm.project.active"></div><div class="form-group"><label class="control-label" data-translate="askApp.project.checkRegisterDate" for="field_checkRegisterDate">Check Register Date</label><input type="checkbox" name="checkRegisterDate" id="field_checkRegisterDate" ng-model="vm.project.checkRegisterDate"></div><div class="form-group"><label class="control-label" data-translate="askApp.project.queue" for="field_queue">Queue</label><input type="checkbox" name="queue" id="field_queue" ng-model="vm.project.queue"></div><div class="form-group"><label class="control-label" data-translate="askApp.project.activityPoints" for="field_activityPoints">Activity Points</label><input type="checkbox" name="activityPoints" id="field_activityPoints" ng-model="vm.project.activityPoints"></div><div class="form-group"><label class="control-label" data-translate="askApp.project.email" for="field_email">Email</label><input type="text" class="form-control" name="email" id="field_email" ng-model="vm.project.email"></div><div class="form-group"><label class="control-label" data-translate="askApp.project.booked" for="field_booked">Booked</label><input type="checkbox" name="booked" id="field_booked" ng-model="vm.project.booked"></div><div class="form-group"><label class="control-label" data-translate="askApp.project.individualField" for="field_individualField">Individual Field</label><input type="text" class="form-control" name="individualField" id="field_individualField" ng-model="vm.project.individualField"></div><div class="form-group"><label class="control-label" data-translate="askApp.project.additionalBookable" for="field_additionalBookable">Additional Bookable</label><input type="checkbox" name="additionalBookable" id="field_additionalBookable" ng-model="vm.project.additionalBookable"></div><div class="form-group"><label class="control-label" data-translate="askApp.project.sbfSlotsMax" for="field_sbfSlotsMax">Sbf Slots Max</label><input type="number" class="form-control" name="sbfSlotsMax" id="field_sbfSlotsMax" ng-model="vm.project.sbfSlotsMax"></div><div class="form-group"><label data-translate="askApp.project.profile" for="field_profile">Profile</label><select class="form-control" id="field_profile" name="profile" ng-model="vm.project.profile" ng-options="profile as profile.id for profile in vm.profiles track by profile.id" required></select></div><div ng-show="editForm.profile.$invalid"><p class="help-block" ng-show="editForm.profile.$error.required" data-translate="entity.validation.required">This field is required.</p></div><div class="form-group"><label data-translate="askApp.project.skipper" for="field_skipper">Skipper</label><select class="form-control" id="field_skipper" name="skipper" ng-model="vm.project.skipper" ng-options="profile as profile.id for profile in vm.profiles track by profile.id"><option value=""></option></select></div><div class="form-group"><label data-translate="askApp.project.authorizedMembers" for="field_authorizedMembers">Authorized Members</label><select class="form-control" id="field_authorizedMembers" multiple="multiple" name="authorizedMembers" ng-model="vm.project.authorizedMembers" ng-options="profile as profile.id for profile in vm.profiles track by profile.id"></select></div><div class="form-group"><label data-translate="askApp.project.authorizedGroups" for="field_authorizedGroups">Authorized Groups</label><select class="form-control" id="field_authorizedGroups" multiple="multiple" name="authorizedGroups" ng-model="vm.project.authorizedGroups" ng-options="authority as authority.id for authority in vm.authorities track by authority.id"></select></div></div><div class="modal-footer"><button type="button" class="btn btn-default" data-dismiss="modal" ng-click="vm.clear()"><span class="glyphicon glyphicon-ban-circle"></span>&nbsp;<span data-translate="entity.action.cancel">Cancel</span></button> <button type="submit" ng-disabled="editForm.$invalid || vm.isSaving" class="btn btn-primary"><span class="glyphicon glyphicon-save"></span>&nbsp;<span data-translate="entity.action.save">Save</span></button></div></div></form>');
$templateCache.put('app/entities/project/projects.html','<!--\n  ~ Copyright (c) 2017 by Julian Feder, julian.feder@yahoo.de\n  ~\n  ~ This product includes software developed at\n  ~ The Apache Software Foundation (http://www.apache.org/).\n  --><div><h2 data-translate="askApp.project.home.title">Projects</h2><jhi-alert></jhi-alert><div class="container-fluid"><div class="row"><div class="col-xs-4 no-padding-left"><button class="btn btn-primary" ui-sref="project.new"><span class="glyphicon glyphicon-plus"></span> <span class="hidden-xs-down" data-translate="askApp.project.home.createLabel">Create new Project</span></button></div><div class="col-xs-8 no-padding-right"><form name="searchForm" class="form-inline"><div class="input-group pull-right"><input type="text" class="form-control" ng-model="vm.searchQuery" id="searchQuery" placeholder="{{ \'askApp.project.home.search\' | translate }}"> <span class="input-group-btn width-min"><button class="btn btn-info" ng-click="vm.search(vm.searchQuery)"><span class="glyphicon glyphicon-search"></span></button> </span><span class="input-group-btn width-min" ng-if="vm.currentSearch"><button class="btn btn-info" ng-click="vm.clear()"><span class="glyphicon glyphicon-trash"></span></button></span></div></form></div></div></div><br><div class="table-responsive"><table class="jh-table table table-striped"><thead><tr jh-sort="vm.predicate" ascending="vm.reverse" callback="vm.transition()"><th jh-sort-by="id"><span data-translate="global.field.id">ID</span> <span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="name"><span data-translate="askApp.project.name">Name</span> <span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="fromDate"><span data-translate="askApp.project.fromDate">From Date</span> <span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="untilDate"><span data-translate="askApp.project.untilDate">Until Date</span> <span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="places"><span data-translate="askApp.project.places">Places</span> <span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="identifier"><span data-translate="askApp.project.identifier">Identifier</span> <span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="description"><span data-translate="askApp.project.description">Description</span> <span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="conditions"><span data-translate="askApp.project.conditions">Conditions</span> <span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="notes"><span data-translate="askApp.project.notes">Notes</span> <span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="normalPrice"><span data-translate="askApp.project.normalPrice">Normal Price</span> <span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="studentPrice"><span data-translate="askApp.project.studentPrice">Student Price</span> <span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="guestPrice"><span data-translate="askApp.project.guestPrice">Guest Price</span> <span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="individualPrice"><span data-translate="askApp.project.individualPrice">Individual Price</span> <span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="prepayment"><span data-translate="askApp.project.prepayment">Prepayment</span> <span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="type"><span data-translate="askApp.project.type">Type</span> <span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="sksPracticalLocation"><span data-translate="askApp.project.sksPracticalLocation">Sks Practical Location</span> <span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="visible"><span data-translate="askApp.project.visible">Visible</span> <span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="closed"><span data-translate="askApp.project.closed">Closed</span> <span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="guest"><span data-translate="askApp.project.guest">Guest</span> <span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="image"><span data-translate="askApp.project.image">Image</span> <span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="weight"><span data-translate="askApp.project.weight">Weight</span> <span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="clothingSize"><span data-translate="askApp.project.clothingSize">Clothing Size</span> <span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="shoeSize"><span data-translate="askApp.project.shoeSize">Clothing Size</span> <span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="nationality"><span data-translate="askApp.project.nationality">Nationality</span> <span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="countryOfBirth"><span data-translate="askApp.project.countryOfBirth">Country Of Birth</span> <span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="birthplace"><span data-translate="askApp.project.birthplace">Birthplace</span> <span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="idNumber"><span data-translate="askApp.project.idNumber">Id Number</span> <span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="active"><span data-translate="askApp.project.active">Active</span> <span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="checkRegisterDate"><span data-translate="askApp.project.checkRegisterDate">Check Register Date</span> <span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="queue"><span data-translate="askApp.project.queue">Queue</span> <span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="activityPoints"><span data-translate="askApp.project.activityPoints">Activity Points</span> <span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="email"><span data-translate="askApp.project.email">Email</span> <span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="booked"><span data-translate="askApp.project.booked">Booked</span> <span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="individualField"><span data-translate="askApp.project.individualField">Individual Field</span> <span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="additionalBookable"><span data-translate="askApp.project.additionalBookable">Additional Bookable</span> <span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="sbfSlotsMax"><span data-translate="askApp.project.sbfSlotsMax">Sbf Slots Max</span> <span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="profile.id"><span data-translate="askApp.project.profile">Profile</span> <span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="skipper.id"><span data-translate="askApp.project.skipper">Skipper</span> <span class="glyphicon glyphicon-sort"></span></th><th></th></tr></thead><tbody><tr ng-repeat="project in vm.projects track by project.id"><td><a ui-sref="project-detail({id:project.id})">{{project.id}}</a></td><td>{{project.name}}</td><td>{{project.fromDate | date:\'mediumDate\'}}</td><td>{{project.untilDate | date:\'mediumDate\'}}</td><td>{{project.places}}</td><td>{{project.identifier}}</td><td>{{project.description}}</td><td>{{project.conditions}}</td><td>{{project.notes}}</td><td>{{project.normalPrice}}</td><td>{{project.studentPrice}}</td><td>{{project.guestPrice}}</td><td>{{project.individualPrice}}</td><td>{{project.prepayment}}</td><td data-translate="{{\'askApp.EnumProjectType.\' + project.type}}">{{project.type}}</td><td data-translate="{{\'askApp.EnumSksPracticalLocation.\' + project.sksPracticalLocation}}">{{project.sksPracticalLocation}}</td><td>{{project.visible}}</td><td>{{project.closed}}</td><td>{{project.guest}}</td><td><a ng-if="project.image" ng-click="vm.openFile(project.imageContentType, project.image)"><img data-ng-src="{{\'data:\' + project.imageContentType + \';base64,\' + project.image}}" style="max-height: 30px" alt="project image"> </a><span ng-if="project.image">{{project.imageContentType}}, {{vm.byteSize(project.image)}}</span></td><td>{{project.weight}}</td><td>{{project.clothingSize}}</td><td>{{project.shoeSize}}</td><td>{{project.nationality}}</td><td>{{project.countryOfBirth}}</td><td>{{project.birthplace}}</td><td>{{project.idNumber}}</td><td>{{project.active}}</td><td>{{project.checkRegisterDate}}</td><td>{{project.queue}}</td><td>{{project.activityPoints}}</td><td>{{project.email}}</td><td>{{project.booked}}</td><td>{{project.individualField}}</td><td>{{project.additionalBookable}}</td><td>{{project.sbfSlotsMax}}</td><td><a ui-sref="profile-detail({id:project.profile.id})">{{project.profile.id}}</a></td><td><a ui-sref="profile-detail({id:project.skipper.id})">{{project.skipper.id}}</a></td><td class="text-right"><div class="btn-group flex-btn-group-container"><button type="submit" ui-sref="project-detail({id:project.id})" class="btn btn-info btn-sm"><span class="glyphicon glyphicon-eye-open"></span> <span class="hidden-sm-down" data-translate="entity.action.view"></span></button> <button type="submit" ui-sref="project.edit({id:project.id})" class="btn btn-primary btn-sm"><span class="glyphicon glyphicon-pencil"></span> <span class="hidden-sm-down" data-translate="entity.action.edit"></span></button> <button type="submit" ui-sref="project.delete({id:project.id})" class="btn btn-danger btn-sm"><span class="glyphicon glyphicon-remove-circle"></span> <span class="hidden-sm-down" data-translate="entity.action.delete"></span></button></div></td></tr></tbody></table></div><div class="text-center"><jhi-item-count page="vm.page" total="vm.queryCount" items-per-page="vm.itemsPerPage"></jhi-item-count><uib-pagination class="pagination-sm" total-items="vm.totalItems" items-per-page="vm.itemsPerPage" ng-model="vm.page" ng-change="vm.transition()"></uib-pagination></div></div>');
$templateCache.put('app/entities/skipper-level-holder/skipper-level-holder-delete-dialog.html','<form name="deleteForm" ng-submit="vm.confirmDelete(vm.skipperLevelHolder.id)"><div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()">&times;</button><h4 class="modal-title" data-translate="entity.delete.title">Confirm delete operation</h4></div><div class="modal-body"><jhi-alert-error></jhi-alert-error><p data-translate="askApp.skipperLevelHolder.delete.question" translate-values="{id: \'{{vm.skipperLevelHolder.id}}\'}">Are you sure you want to delete this Skipper Level Holder?</p></div><div class="modal-footer"><button type="button" class="btn btn-default" data-dismiss="modal" ng-click="vm.clear()"><span class="glyphicon glyphicon-ban-circle"></span>&nbsp;<span data-translate="entity.action.cancel">Cancel</span></button> <button type="submit" ng-disabled="deleteForm.$invalid" class="btn btn-danger"><span class="glyphicon glyphicon-remove-circle"></span>&nbsp;<span data-translate="entity.action.delete">Delete</span></button></div></form>');
$templateCache.put('app/entities/skipper-level-holder/skipper-level-holder-detail.html','<div><h2><span data-translate="askApp.skipperLevelHolder.detail.title">Skipper Level Holder</span> {{vm.skipperLevelHolder.id}}</h2><hr><jhi-alert-error></jhi-alert-error><dl class="dl-horizontal jh-entity-details"><dt><span data-translate="askApp.skipperLevelHolder.skipperLevel">Skipper Level</span></dt><dd><span data-translate="{{\'askApp.EnumSkipperLevel.\' + vm.skipperLevelHolder.skipperLevel}}">{{vm.skipperLevelHolder.skipperLevel}}</span></dd></dl><button type="submit" ui-sref="{{ vm.previousState }}" class="btn btn-info"><span class="glyphicon glyphicon-arrow-left"></span>&nbsp;<span data-translate="entity.action.back"> Back</span></button> <button type="button" ui-sref="skipper-level-holder-detail.edit({id:vm.skipperLevelHolder.id})" class="btn btn-primary"><span class="glyphicon glyphicon-pencil"></span> <span class="hidden-sm-down" data-translate="entity.action.edit">Edit</span></button></div>');
$templateCache.put('app/entities/skipper-level-holder/skipper-level-holder-dialog.html','<form name="editForm" role="form" novalidate ng-submit="vm.save()" show-validation><div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()">&times;</button><h4 class="modal-title" id="mySkipperLevelHolderLabel" data-translate="askApp.skipperLevelHolder.home.createOrEditLabel">Create or edit a Skipper Level Holder</h4></div><div class="modal-body"><jhi-alert-error></jhi-alert-error><div class="form-group" ng-show="vm.skipperLevelHolder.id"><label for="id" data-translate="global.field.id">ID</label><input type="text" class="form-control" id="id" name="id" ng-model="vm.skipperLevelHolder.id" readonly="readonly"></div><div class="form-group"><label class="control-label" data-translate="askApp.skipperLevelHolder.skipperLevel" for="field_skipperLevel">Skipper Level</label><select class="form-control" name="skipperLevel" ng-model="vm.skipperLevelHolder.skipperLevel" id="field_skipperLevel" required><option value="candidate" data-translate="askApp.EnumSkipperLevel.candidate">candidate</option><option value="flottille" data-translate="askApp.EnumSkipperLevel.flottille">flottille</option><option value="vacation" data-translate="askApp.EnumSkipperLevel.vacation">vacation</option><option value="askew" data-translate="askApp.EnumSkipperLevel.askew">askew</option><option value="sks_co" data-translate="askApp.EnumSkipperLevel.sks_co">sks_co</option><option value="sks" data-translate="askApp.EnumSkipperLevel.sks">sks</option><option value="sks_plus" data-translate="askApp.EnumSkipperLevel.sks_plus">sks_plus</option><option value="sss" data-translate="askApp.EnumSkipperLevel.sss">sss</option><option value="regatta_beginner" data-translate="askApp.EnumSkipperLevel.regatta_beginner">regatta_beginner</option><option value="regatta_normal" data-translate="askApp.EnumSkipperLevel.regatta_normal">regatta_normal</option><option value="regatta_advanced" data-translate="askApp.EnumSkipperLevel.regatta_advanced">regatta_advanced</option><option value="regatta_expert" data-translate="askApp.EnumSkipperLevel.regatta_expert">regatta_expert</option></select><div ng-show="editForm.skipperLevel.$invalid"><p class="help-block" ng-show="editForm.skipperLevel.$error.required" data-translate="entity.validation.required">This field is required.</p></div></div></div><div class="modal-footer"><button type="button" class="btn btn-default" data-dismiss="modal" ng-click="vm.clear()"><span class="glyphicon glyphicon-ban-circle"></span>&nbsp;<span data-translate="entity.action.cancel">Cancel</span></button> <button type="submit" ng-disabled="editForm.$invalid || vm.isSaving" class="btn btn-primary"><span class="glyphicon glyphicon-save"></span>&nbsp;<span data-translate="entity.action.save">Save</span></button></div></form>');
$templateCache.put('app/entities/skipper-level-holder/skipper-level-holders.html','<div><h2 data-translate="askApp.skipperLevelHolder.home.title">Skipper Level Holders</h2><jhi-alert></jhi-alert><div class="container-fluid"><div class="row"><div class="col-xs-4 no-padding-left"><button class="btn btn-primary" ui-sref="skipper-level-holder.new"><span class="glyphicon glyphicon-plus"></span> <span class="hidden-xs-down" data-translate="askApp.skipperLevelHolder.home.createLabel">Create new Skipper Level Holder</span></button></div><div class="col-xs-8 no-padding-right"><form name="searchForm" class="form-inline"><div class="input-group pull-right"><input type="text" class="form-control" ng-model="vm.searchQuery" id="searchQuery" placeholder="{{ \'askApp.skipperLevelHolder.home.search\' | translate }}"> <span class="input-group-btn width-min"><button class="btn btn-info" ng-click="vm.search(vm.searchQuery)"><span class="glyphicon glyphicon-search"></span></button> </span><span class="input-group-btn width-min" ng-if="vm.currentSearch"><button class="btn btn-info" ng-click="vm.clear()"><span class="glyphicon glyphicon-trash"></span></button></span></div></form></div></div></div><br><div class="table-responsive"><table class="jh-table table table-striped"><thead><tr><th><span data-translate="global.field.id">ID</span></th><th><span data-translate="askApp.skipperLevelHolder.skipperLevel">Skipper Level</span></th><th></th></tr></thead><tbody><tr ng-repeat="skipperLevelHolder in vm.skipperLevelHolders track by skipperLevelHolder.id"><td><a ui-sref="skipper-level-holder-detail({id:skipperLevelHolder.id})">{{skipperLevelHolder.id}}</a></td><td data-translate="{{\'askApp.EnumSkipperLevel.\' + skipperLevelHolder.skipperLevel}}">{{skipperLevelHolder.skipperLevel}}</td><td class="text-right"><div class="btn-group flex-btn-group-container"><button type="submit" ui-sref="skipper-level-holder-detail({id:skipperLevelHolder.id})" class="btn btn-info btn-sm"><span class="glyphicon glyphicon-eye-open"></span> <span class="hidden-sm-down" data-translate="entity.action.view"></span></button> <button type="submit" ui-sref="skipper-level-holder.edit({id:skipperLevelHolder.id})" class="btn btn-primary btn-sm"><span class="glyphicon glyphicon-pencil"></span> <span class="hidden-sm-down" data-translate="entity.action.edit"></span></button> <button type="submit" ui-sref="skipper-level-holder.delete({id:skipperLevelHolder.id})" class="btn btn-danger btn-sm"><span class="glyphicon glyphicon-remove-circle"></span> <span class="hidden-sm-down" data-translate="entity.action.delete"></span></button></div></td></tr></tbody></table></div></div>');
$templateCache.put('app/member/activities/activities.html','<!--\n  ~ Copyright (c) 2017 by Julian Feder, julian.feder@yahoo.de\n  ~\n  ~ This product includes software developed at\n  ~ The Apache Software Foundation (http://www.apache.org/).\n  --><div><div class="row row-no-padding"><div class="col-md-9"><div class="panel panel-default"><div class="panel-heading"><h3 class="panel-title" data-translate="askApp.activities.home.title">Activities</h3></div><div class="panel-body"><div class="container-fluid"><div class="row"><div class="col-xs-12 no-padding-left"><div class="btn-group"><button type="submit" ng-click="vm.currentSearch == null && vm.setQuery(\'useable\')" class="btn btn-default btn-md" ng-class="{active: vm.query == \'useable\'}"><span class="hidden-sm-down">G\xFCltig</span></button> <button type="submit" ng-click="vm.currentSearch == null && vm.setQuery(\'used\')" class="btn btn-default btn-md" ng-class="{active: vm.query == \'used\'}"><span class="hidden-sm-down">Eingel\xF6st</span></button> <button type="submit" ng-click="vm.currentSearch == null && vm.setQuery(\'unuseable\')" class="btn btn-default btn-md" ng-class="{active: vm.query == \'unuseable\'}"><span class="hidden-sm-down">Ung\xFCltig</span></button></div></div></div></div><br><div class="alert alert-info" role="alert" ng-show="vm.activities.length == 0">\xC4ndere die Auswahlkategorie oder du hast noch keine Aktivit\xE4tenpunkte gesammelt.</div><div class="table-responsive" ng-show="vm.activities.length != 0"><table class="jh-table table table-striped"><thead><tr jh-sort="vm.predicate" ascending="vm.reverse" callback="vm.transition()"><th jh-sort-by="activitiesDate"><span data-translate="askApp.activities.activitiesDate">Activities Date</span> <span class="glyphicon glyphicon-sort"></span></th><th ng-show="vm.query != \'used\'" jh-sort-by="validFrom"><span data-translate="askApp.activities.validFrom">Valid From</span> <span class="glyphicon glyphicon-sort"></span></th><th ng-show="vm.query != \'used\'" jh-sort-by="validUntil"><span data-translate="askApp.activities.validUntil">Valid Until</span> <span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="category"><span data-translate="askApp.activities.category">Category</span> <span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="comment"><span data-translate="askApp.activities.comment">Comment</span> <span class="glyphicon glyphicon-sort"></span></th><th ng-show="vm.query == \'used\'"><span data-translate="askApp.activities.redeemed">Eingel\xF6st f\xFCr</span></th><th ng-show="vm.query == \'used\'"><span data-translate="askApp.activities.redeemedDate">Eingel\xF6st am</span></th></tr></thead><tbody><tr ng-repeat="activities in vm.activities track by activities.id"><td>{{activities.activitiesDate | date:\'mediumDate\'}}</td><td ng-show="vm.query != \'used\'">{{activities.validFrom | date:\'mediumDate\'}}</td><td ng-show="vm.query != \'used\'">{{activities.validUntil | date:\'mediumDate\'}}</td><td><span class="label label-info" data-translate="{{\'askApp.EnumCategoryActivity.\' + activities.category}}">{{activities.category}}</span></td><td style="text-align: center"><span style="cursor: pointer" class="glyphicon glyphicon-comment" aria-hidden="true" uib-popover="{{activities.comment}}" popover-trigger="mouseenter" ng-show="activities.comment"></span> <span class="glyphicon glyphicon-remove" aria-hidden="true" ng-show="!activities.comment"></span></td><td ng-show="activities.redeemed && (vm.query == \'used\')">{{activities.redeemed}}</td><td ng-show="activities.redeemedDate && (vm.query == \'used\')">{{activities.redeemedDate | date:\'mediumDate\'}}</td></tr></tbody></table></div></div></div><div class="text-center" ng-show="vm.activities.length != 0"><jhi-item-count page="vm.page" total="vm.queryCount" items-per-page="vm.itemsPerPage"></jhi-item-count><uib-pagination class="pagination-sm" total-items="vm.totalItems" items-per-page="vm.itemsPerPage" ng-model="vm.page" ng-change="vm.transition()"></uib-pagination></div></div><div class="col-md-3"><div class="panel panel-default"><div class="panel-heading"><h3 class="panel-title">Info</h3></div><div class="panel-body"><content-cms identifier="5"></content-cms></div></div></div></div></div>');
$templateCache.put('app/member/booking/bookings.html','<!--\n  ~ Copyright (c) 2017 by Julian Feder, julian.feder@yahoo.de\n  ~\n  ~ This product includes software developed at\n  ~ The Apache Software Foundation (http://www.apache.org/).\n  --><div><div class="row row-no-padding"><div class="col-md-9"><div class="panel panel-default"><div class="panel-heading"><h3 class="panel-title">Buchungen</h3></div><div class="panel-body"><div class="alert alert-info" role="alert" ng-show="vm.bookings.length == 0"><b>Keine Buchungen vorhanden!</b> Du kannst <a ui-sref="member.projects({type:\'event\'})">hier</a> nachschauen ob es offene Anmeldungen f\xFCr Events gibt.</div><div class="table-responsive" ng-show="vm.bookings.length > 0"><table class="jh-table table table-striped"><thead><tr jh-sort="vm.predicate" ascending="vm.reverse" callback="vm.transition()"><th jh-sort-by="date"><span data-translate="askApp.booking.date">Date</span> <span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="project.name"><span>Name</span> <span class="glyphicon glyphicon-sort"></span></th><th><span>Preis</span></th><th jh-sort-by="dept.paymentStatus"><span>Bezahlstatus</span> <span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="dept.reference"><span>Verwendungszweck</span> <span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="status"><span>Status</span> <span class="glyphicon glyphicon-sort"></span></th></tr></thead><tbody><tr ng-repeat="booking in vm.bookings track by booking.id"><td>{{booking.date | date:\'mediumDate\'}}</td><td colspan="{{booking.type === \'interest\' ? \'4\' : \'1\'}}"><span ng-show="booking.type === \'interest\'" class="label label-info">Interessensbekundung</span> <span ng-show="booking.type === \'interest\'">{{booking.name}}</span> <span ng-hide="booking.type === \'interest\'">{{booking.name | limitTo:15}}{{booking.name.length > 15 ? \'...\' : \'\'}} <span class="glyphicon glyphicon-info-sign" aria-hidden="true" uib-popover="{{booking.name}}" popover-trigger="mouseenter" style="cursor: pointer" ng-show="booking.name.length > 15"></span> </span><button class="btn btn-danger btn-xs" ng-click="vm.updateBooking(booking.id, true)" ng-show="booking.priceCategory != \'individual\' && booking.type == \'sksTrip\' && !booking.sksTheoryAvailable" uib-popover="Du hast angegeben, dass du die SKS-Theoriepr\xFCfung noch nicht angetreten hast." popover-trigger="mouseenter"><span class="glyphicon glyphicon-edit" aria-hidden="true"></span> SKS-Theorie</button> <button class="btn btn-success btn-xs" ng-click="vm.updateBooking(booking.id, false)" ng-show="booking.priceCategory != \'individual\' && booking.type == \'sksTrip\' && booking.sksTheoryAvailable" uib-popover="Du hast angegeben, dass du die SKS-Theoriepr\xFCfung bereits angetreten hast." popover-trigger="mouseenter"><span class="glyphicon glyphicon-edit" aria-hidden="true"></span> SKS-Theorie</button></td><td ng-hide="booking.type === \'interest\'">{{booking.priceNet | number:2}}\u20AC</td><td ng-hide="booking.type === \'interest\'"><span class="label label-danger" data-translate="{{\'askApp.EnumDeptStatus.\' + booking.paymentStatus}}" ng-show="booking.paymentStatus == \'pending\'">{{booking.paymentStatus}}</span> <span class="label label-success" data-translate="{{\'askApp.EnumDeptStatus.\' + booking.paymentStatus}}" ng-show="booking.paymentStatus == \'payed\'">{{booking.paymentStatus}}</span> <span class="label label-warning" data-translate="{{\'askApp.EnumDeptStatus.\' + booking.paymentStatus}}" ng-show="booking.paymentStatus == \'partial\'">{{booking.paymentStatus}}</span> <span class="label label-warning" data-translate="{{\'askApp.EnumDeptStatus.\' + booking.paymentStatus}}" ng-show="booking.paymentStatus == \'prePayed\'">{{booking.paymentStatus}}</span> <span class="label label-danger" data-translate="{{\'askApp.EnumDeptStatus.\' + booking.paymentStatus}}" ng-show="booking.paymentStatus == \'payedToMuch\'">{{booking.paymentStatus}}</span> <span class="glyphicon glyphicon-info-sign" aria-hidden="true" popover-trigger="mouseenter" popover-placement="auto" popover-title="Forderung" uib-popover-template="\'popover-partial.html\'" style="cursor: pointer"></span></td><td ng-hide="booking.type === \'interest\'"><span class="label label-info">{{booking.reference}}</span></td><td><span class="label label-success" data-translate="{{\'askApp.EnumBookingStatusType.\' + booking.status}}" ng-show="booking.status == \'angemeldet\'">{{booking.status}}</span> <span class="label label-danger" data-translate="{{\'askApp.EnumBookingStatusType.\' + booking.status}}" ng-show="booking.status == \'zurueckgetreten\'">{{booking.status}}</span> <span class="label label-danger" data-translate="{{\'askApp.EnumBookingStatusType.\' + booking.status}}" ng-show="booking.status == \'abgelehnt\'">{{booking.status}}</span> <span class="label label-warning" data-translate="{{\'askApp.EnumBookingStatusType.\' + booking.status}}" ng-show="booking.status == \'warteliste\'">{{booking.status}}</span></td></tr></tbody></table></div></div></div><div class="text-center" ng-show="vm.bookings.length > 0"><jhi-item-count page="vm.page" total="vm.queryCount" items-per-page="vm.itemsPerPage"></jhi-item-count><uib-pagination class="pagination-sm" total-items="vm.totalItems" items-per-page="vm.itemsPerPage" ng-model="vm.page" ng-change="vm.transition()"></uib-pagination></div></div><div class="col-md-3"><div class="panel panel-default"><div class="panel-heading"><h3 class="panel-title">Info</h3></div><div class="panel-body"><content-cms identifier="6"></content-cms></div></div></div></div></div><script type="text/ng-template" id="popover-partial.html"><div class="form-group">\n        <table>\n            <tr>\n                <td>Betrag:</td>\n                <td>{{booking.amount | number:2}}\u20AC</td>\n            </tr>\n            <tr>\n                <td style="width: 150px;">Aktivit\xE4tenpunkte:</td>\n                <td>{{booking.apCount}}</td>\n            </tr>\n            <tr>\n                <td>Soll:</td>\n                <td>{{booking.priceNet | number:2}}\u20AC</td>\n            </tr>\n            <tr ng-repeat="payment in booking.payments">\n                <td>{{payment.date | date:\'dd.MM.yyyy\'}}:</td>\n                <td>{{payment.amount | number:2}}\u20AC</td>\n            </tr>\n            <tr>\n                <td>Ist:</td>\n                <td>{{booking.payed | number:2}}\u20AC</td>\n            </tr>\n            <tr>\n                <td colspan="2">\n                    <hr>\n                </td>\n            </tr>\n            <tr>\n                <td><span data-translate="askApp.dept.toPay">Saldo</span>:</td>\n                <td><b>{{booking.toPay | number:2}}\u20AC</b></td>\n            </tr>\n        </table>\n    </div></script>');
$templateCache.put('app/member/dinghy-booking/dinghy-bookings.html','<!--\n  ~ Copyright (c) 2020 by Felix Heim, felix-heim@web.de\n  ~\n  ~ This product includes software developed at\n  ~ The Apache Software Foundation (http://www.apache.org/).\n  --><div><div class="row row-no-padding"><div class="col-md-9"><div class="panel panel-default"><div class="panel-heading"><h3 class="panel-title" data-translate="global.menu.dinghyBooking"></h3></div><div class="panel-body"><div class="container-fluid"><div class="row"><div class="col-xs-12 no-padding-left"><div class="btn-group"><button type="submit" ng-click="vm.setArchive(\'false\')" class="btn btn-default btn-md" ng-class="{active: vm.archive == \'false\'}"><span class="hidden-sm-down">Aktive Events</span></button> <button type="submit" ng-click="vm.setArchive(\'true\')" class="btn btn-default btn-md" ng-class="{active: vm.archive == \'true\'}"><span class="hidden-sm-down">Abeschlossene Events</span></button></div></div></div><br></div><div class="alert alert-info" role="alert" ng-if="vm.bookings.length == 0 && vm.archive == \'true\'">Du hast noch keine abgeschlossenen Jollenbuchungen</div><div class="alert alert-info" role="alert" ng-if="vm.bookings.length == 0 && vm.archive == \'false\'"><b>Keine Jollenbuchungen vorhanden!</b> Du kannst <b><a ui-sref="member.dinghy-events">hier</a></b> nachschauen ob es offene Anmeldungen f\xFCr Events gibt.</div><div class="table-responsive" ng-show="vm.bookings.length > 0"><table class="jh-table table table-striped"><thead><tr><th><span data-translate="askApp.dinghyEvent.fromDate">Date</span></th><th><span>Event</span></th><th><span>Status</span></th><th><span>Bezahlt?</span></th><th><span>Jolle</span></th><th ng-if="vm.archive == \'false\'"><span>Verwendungszweck</span></th><th></th></tr></thead><tbody><tr ng-repeat="booking in vm.bookings track by booking.eventId"><td>{{booking.fromDate | date:\'shortDate\'}}</td><td><span ng-if="booking.selfGodparent" class="glyphicon glyphicon-tower"></span> <span>{{\'askApp.EnumDinghyEventType.\' + booking.eventType | translate}} <span class="glyphicon glyphicon-info-sign" aria-hidden="true" uib-popover="{{booking.eventName}}" popover-trigger="mouseenter" style="cursor: pointer"></span> </span><span class="dot" ng-class="{\'label-success\': vm.archive == \'false\' && booking.canceled == false && booking.hasGodparent == true, \'label-danger\': vm.archive == \'true\' || booking.canceled == true, \'label-warning\': vm.archive == \'false\' && booking.canceled == false && booking.hasGodparent == false}" aria-hidden="true" popover-trigger="mouseenter" uib-popover-template="\'popover-eventStatus.html\'" style="cursor: pointer"></span></td><td style="text-align: center"><span class="dot" ng-if="booking.bookingStatus" ng-class="{\'label-success\': booking.bookingStatus == \'angemeldet\', \'label-danger\': booking.bookingStatus == \'zurueckgetreten\' || booking.bookingStatus == \'abgelehnt\', \'label-warning\': booking.bookingStatus == \'warteliste\'}" aria-hidden="true" popover-trigger="mouseenter" uib-popover-template="\'popover-bookingStatus.html\'" style="cursor: pointer"></span> <span class="dot label-info" ng-if="!booking.bookingStatus" aria-hidden="true" popover-trigger="mouseenter" uib-popover-template="\'popover-godparent.html\'" style="cursor: pointer"></span></td><td><span class="dot" ng-hide="booking.amount === null || booking.amount === 0" ng-class="{\'label-success\': booking.paymentStatus == \'payed\', \'label-danger\': booking.paymentStatus == \'pending\' || booking.paymentStatus == \'payedToMuch\', \'label-warning\': booking.paymentStatus == \'partial\' || booking.paymentStatus == \'prePayed\'}" aria-hidden="true" popover-trigger="mouseenter" uib-popover-template="\'popover-paymentStatus.html\'" style="cursor: pointer"></span> <span class="glyphicon glyphicon-info-sign" ng-hide="booking.amount === null || booking.amount === 0" aria-hidden="true" popover-trigger="mouseenter" popover-title="Bezahlstatus" uib-popover-template="\'popover-partial.html\'" style="cursor: pointer"></span> <span ng-show="booking.amount === null || booking.amount === 0">0\u20AC</span></td><td><span ng-if="booking.dinghy">{{booking.dinghy.name}} ({{booking.dinghy.type}})</span> <span class="glyphicon glyphicon-remove" aria-hidden="true" ng-if="!booking.dinghy" popover-append-to-body="true"></span> <span style="cursor: pointer" class="glyphicon glyphicon-comment" aria-hidden="true" uib-popover="{{booking.commentDinghy}}" popover-trigger="mouseenter" ng-show="booking.commentDinghy"></span></td><td ng-if="vm.archive == \'false\'"><span ng-if="(booking.bookingStatus != null || booking.priceNet != -1) && !(booking.amount === null || booking.amount === 0)" class="label label-info">{{booking.reference}}</span> <span ng-if="(booking.bookingStatus != null || booking.priceNet != -1) && (booking.amount === null || booking.amount === 0)" class="label label-danger">Nein</span> <button type="submit" ng-if="booking.bookingStatus == null && booking.priceNet == -1" ui-sref="member.dinghy-booking.book({id: booking.eventId})" class="btn btn-xs btn-warning"><span class="hidden-sm-down" style="font-weight: bold">Anmelden!</span></button></td><td class="text-right"><div class="btn-group flex-btn-group-container"><button type="submit" ui-sref="member.dinghy-booking.detail({id: booking.eventId})" ng-disabled="booking.bookingStatus == null && vm.archive == \'false\'" class="btn btn-xs" ng-class="{\'btn-info\': vm.archive == \'true\', \'btn-primary\': vm.archive == \'false\'}"><!-- == \'true\'? Yeah, nobody *really* understands JS --> <span class="glyphicon" ng-class="{\'glyphicon-eye-open\': vm.archive == \'true\', \'glyphicon-pencil\': vm.archive == \'false\'}"></span></button></div></td></tr></tbody></table></div></div></div></div><div class="col-md-3"><div class="panel panel-default"><div class="panel-heading"><h3 class="panel-title">Info</h3></div><div class="panel-body"><content-cms identifier="28"></content-cms></div></div></div></div></div><script type="text/ng-template" id="popover-bookingStatus.html"><span class="label"\n          ng-class="{\'label-success\': booking.bookingStatus == \'angemeldet\', \'label-danger\': booking.bookingStatus == \'zurueckgetreten\' || booking.bookingStatus == \'abgelehnt\', \'label-warning\': booking.bookingStatus == \'warteliste\'}"\n          data-translate="{{\'askApp.EnumBookingStatusType.\' + booking.bookingStatus}}">\n    </span></script><script type="text/ng-template" id="popover-godparent.html"><span class="label label-info"\n          data-translate="askApp.dinghyEvent.godparent">\n    </span></script><script type="text/ng-template" id="popover-paymentStatus.html"><span class="label"\n          ng-class="{\'label-success\': booking.paymentStatus == \'payed\', \'label-danger\': booking.paymentStatus == \'pending\' || booking.paymentStatus == \'payedToMuch\', \'label-warning\': booking.paymentStatus == \'partial\' || booking.paymentStatus == \'prePayed\'}"\n          data-translate="{{\'askApp.EnumDeptStatus.\' + booking.paymentStatus}}">\n    </span></script><script type="text/ng-template" id="popover-eventStatus.html"><span ng-if="vm.archive == \'true\'" class="label label-danger">\n        Ageschlossen\n    </span>\n    <span ng-if="vm.archive == \'false\'">\n        <span ng-if="booking.canceled" class="label label-danger">Abgesagt</span>\n        <span ng-if="!booking.canceled && booking.hasGodparent" class="label label-success">Findet statt</span>\n        <span ng-if="!booking.canceled && !booking.hasGodparent" class="label label-warning">Jollenpate ben\xF6tigt</span>\n    </span></script><script type="text/ng-template" id="popover-partial.html"><div class="form-group">\n        <table>\n            <tr>\n                <td>Betrag:</td>\n                <td>{{booking.amount | number:2}}\u20AC</td>\n            </tr>\n            <tr>\n                <td style="width: 150px;">Aktivit\xE4tenpunkte:</td>\n                <td>{{booking.apCount}}</td>\n            </tr>\n            <tr>\n                <td>Soll:</td>\n                <td>{{booking.priceNet | number:2}}\u20AC</td>\n            </tr>\n            <tr ng-repeat="payment in booking.payments">\n                <td>{{payment.date | date:\'dd.MM.yyyy\'}}:</td>\n                <td>{{payment.amount | number:2}}\u20AC</td>\n            </tr>\n            <tr>\n                <td>Ist:</td>\n                <td>{{booking.payed | number:2}}\u20AC</td>\n            </tr>\n            <tr>\n                <td colspan="2">\n                    <hr>\n                </td>\n            </tr>\n            <tr>\n                <td><span data-translate="askApp.dept.toPay">Saldo</span>:</td>\n                <td><b>{{booking.toPay | number:2}}\u20AC</b></td>\n            </tr>\n        </table>\n    </div></script>');
$templateCache.put('app/member/dinghy-events/dinghy-booking-change-dialog.html','<!--\n  ~ Copyright (c) 2020 by Felix Heim, felix-heim@web.de\n  ~\n  ~ This product includes software developed at\n  ~ The Apache Software Foundation (http://www.apache.org/).\n  --><form name="deleteForm" ng-submit="vm.save()"><div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()">&times;</button><h4 class="modal-title" ng-if="vm.isCancel" data-translate="askApp.dinghyBooking.change.cancelTitle">Confirm operation</h4><h4 class="modal-title" ng-if="!vm.isCancel" data-translate="askApp.dinghyBooking.change.uncancelTitle">Confirm operation</h4></div><div class="modal-body"><jhi-alert-error></jhi-alert-error><p data-translate="askApp.dinghyBooking.change.cancelText" ng-if="vm.isCancel" translate-value-event-name="{{vm.dinghyEvent.name}}" translate-value-event-info="{{vm.dinghyEvent.fromDate | date:\'shortDate\'}} {{\'askApp.EnumDinghyEventType.\' + vm.dinghyEvent.type | translate}}"></p><p data-translate="askApp.dinghyBooking.change.uncancelText" ng-if="!vm.isCancel" translate-value-event-name="{{vm.dinghyEvent.name}}" translate-value-event-info="{{vm.dinghyEvent.fromDate | date:\'shortDate\'}} {{\'askApp.EnumDinghyEventType.\' + vm.dinghyEvent.type | translate}}"></p></div><div class="modal-footer"><button type="button" class="btn btn-default" data-dismiss="modal" ng-click="vm.clear()"><span class="glyphicon glyphicon-ban-circle"></span>&nbsp;<span data-translate="entity.action.cancel">Cancel</span></button> <button type="submit" ng-if="!vm.isCancel" class="btn btn-success">Wieder&nbsp;Anmelden</button> <button type="submit" ng-if="vm.isCancel" class="btn btn-danger">Abmelden</button></div></form>');
$templateCache.put('app/member/dinghy-events/dinghy-booking-detail-dialog.html','<!--\n  ~ Copyright (c) 2020 by Felix Heim, felix-heim@web.de\n  ~\n  ~ This product includes software developed at\n  ~ The Apache Software Foundation (http://www.apache.org/).\n  --><form name="editForm" role="form" novalidate ng-submit="vm.save()" show-validation><div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()">&times;</button><h4 class="modal-title" id="myBookingLabel">{{vm.dinghyEvent.name}} @ {{vm.dinghyEvent.location}} - Details</h4></div><div class="modal-body"><div ng-show="vm.dinghyEvent.description" style="margin-bottom: 10px"><button type="button" class="btn btn-default" ng-click="status.descriptionOpen = !status.descriptionOpen"><span class="glyphicon" ng-class="{\'glyphicon-chevron-down\': status.descriptionOpen, \'glyphicon-chevron-right\': !status.descriptionOpen}"></span> Beschreibung</button><div uib-collapse="!status.descriptionOpen"><div class="panel panel-default" style="margin: 0"><div class="panel-body"><div class="text-justify" ng-bind-html="renderHtml(vm.dinghyEvent.description)"></div></div></div></div></div><div><table><tr><td><b>Eventstatus:&nbsp;</b></td><td><span ng-if="vm.dinghyEvent.closed" class="label label-danger">Abgeschlossen </span><span ng-if="!vm.dinghyEvent.closed"><span ng-if="vm.dinghyEvent.canceled" class="label label-danger">Abgesagt</span> <span ng-if="!vm.dinghyEvent.canceled && vm.dinghyEvent.godparent" class="label label-success">Findet statt</span> <span ng-if="!vm.dinghyEvent.canceled && !vm.dinghyEvent.godparent" class="label label-warning">Jollenpate ben\xF6tigt</span></span></td></tr><tr><td ng-if="vm.booking.id"><b>Buchungsstatus:</b></td><td><span class="label" ng-class="{\'label-success\': vm.booking.bookingStatus == \'angemeldet\', \'label-danger\': vm.booking.bookingStatus == \'zurueckgetreten\' || vm.booking.bookingStatus == \'abgelehnt\', \'label-warning\': vm.booking.bookingStatus == \'warteliste\'}" data-translate="{{\'askApp.EnumBookingStatusType.\' + vm.booking.bookingStatus}}"></span></td></tr><tr><td><b><span data-translate="askApp.dinghyEvent.type">Typ</span>:</b></td><td><span class="label label-info" data-translate="{{\'askApp.EnumDinghyEventType.\' + vm.dinghyEvent.type}}"></span></td></tr><tr><td style="font-weight: bold; width: 130px">Zeitraum:&nbsp</td><td>{{vm.dinghyEvent.fromDate | date: \'EEE, dd.MM.yy HH:mm\'}}<span ng-show="vm.dinghyEvent.fromDate != vm.dinghyEvent.untilDate"> bis {{vm.dinghyEvent.untilDate | date: \'EEE, dd.MM.yy HH:mm\'}}</span></td></tr><tr ng-show="vm.dinghyEvent.normalPrice"><td style="font-weight: bold">Normalpreis:&nbsp</td><td><span>{{vm.dinghyEvent.normalPrice}}\u20AC</span></td></tr><tr ng-show="vm.dinghyEvent.studentPrice"><td style="font-weight: bold">Studentenpreis:&nbsp</td><td><span>{{vm.dinghyEvent.studentPrice}}\u20AC</span></td></tr><tr ng-show="vm.dinghyEvent.guestPrice"><td style="font-weight: bold">Gastpreis:&nbsp</td><td><span>{{vm.dinghyEvent.guestPrice}}\u20AC</span></td></tr><tr><td><b><span data-translate="askApp.dinghyEvent.godparent">Godparent</span>:</b></td><td><span ng-show="!vm.dinghyEvent.godparent" class="label label-danger">Noch niemand</span> <span ng-show="vm.dinghyEvent.godparent">{{vm.dinghyEvent.godparent.firstName}} {{vm.dinghyEvent.godparent.lastName}} <span ng-if="vm.dinghyEvent.godparent.nickname">"{{vm.dinghyEvent.godparent.nickname}}"</span></span></td></tr><tr ng-show="vm.dinghyEvent.godparent"><td><b>Handynummer:&nbsp;</b></td><td><a href="tel:{{vm.dinghyEvent.godparent.phone}}">{{vm.dinghyEvent.godparent.phone}}</a></td></tr><tr><td style="font-weight: bold">Kontaktmail:&nbsp</td><td><a href="mailto:{{vm.dinghyEvent.contactEmail}}?subject=Frage zu {{vm.dinghyEvent.name}} am {{vm.dinghyEvent.fromDate | date: \'EEE, dd.MM.yy HH:mm\'}}">{{vm.dinghyEvent.contactEmail}}</a></td></tr><tr ng-if="vm.dinghyEvent.individualQuestion != null && vm.dinghyEvent.individualQuestion != \'\'"><td style="font-weight: bold"><span data-translate="askApp.dinghyEvent.individualQuestion"></span>:&nbsp</td><td>{{vm.dinghyEvent.individualQuestion}}</td></tr><tr ng-show="vm.dinghyEvent.availableDinghies && vm.dinghyEvent.availableDinghies.length > 0"><td style="vertical-align: top; font-weight: bold"><span data-translate="askApp.dinghyEvent.availableDinghies">Available Dinghies</span>:&nbsp;</td><td><span ng-repeat="dinghy in vm.dinghyEvent.availableDinghies">{{dinghy.name}} ({{dinghy.type}}) <span style="cursor: pointer" class="glyphicon glyphicon-comment" aria-hidden="true" uib-popover-html="getPopoverContent(dinghy.description)" popover-trigger="mouseenter" ng-show="dinghy.description" popover-append-to-body="true"></span><br ng-hide="$last"></span></td></tr></table></div><div ng-if="!vm.dinghyEvent.closed && !vm.dinghyEvent.canceled && !vm.dinghyEvent.godparent" class="alert alert-warning" role="alert" style="margin-top: 5px"><b>Achtung!</b> Es hat sich f\xFCr diesen Termin noch kein Jollenpate gefunden!<br>Der Termin findet <b>nur dann statt,</b> wenn sich noch ein <b>Jollenpate findet.</b></div><hr><div><label class="control-label">Teilnehmer</label><div ng-show="vm.dinghyEvent.participants.length == 0"><span class="label label-danger">Bisher keine Anmeldungen</span></div><ul style="margin: 0"><li ng-repeat="participant in vm.dinghyEvent.participants"><a ng-show="participant.id" ng-click="$close()" ui-sref="member-management-detail({id:participant.id})">{{participant.firstName}} {{participant.lastName}}</a> <span ng-show="!participant.id">{{participant.firstName}} {{participant.lastName}}</span> <span ng-show="participant.email">| <a href="mailto:{{participant.email}}">{{participant.email}}</a></span> <span ng-show="participant.dinghy">| {{participant.dinghy.name}} ({{participant.dinghy.type}})</span> <span ng-show="participant.commentDinghy">| Jollenkommentar: {{participant.commentDinghy}}</span> <span ng-show="participant.bookingStatus !== \'angemeldet\'">&#32;(<span data-translate="{{\'askApp.EnumBookingStatusType.\' + participant.bookingStatus}}"></span>)</span></li></ul></div><hr><div><button type="button" class="btn btn-default" ng-click="status.conditionsOpen = !status.conditionsOpen"><span class="glyphicon" ng-class="{\'glyphicon-chevron-down\': status.conditionsOpen, \'glyphicon-chevron-right\': !status.conditionsOpen}"></span> Bedingungen & Vereinbarungen</button><div uib-collapse="!status.conditionsOpen"><div class="panel panel-default" style="margin: 0"><div class="panel-body"><div class="text-justify" ng-bind-html="renderHtml(vm.dinghyEvent.conditions)"></div></div></div></div></div><div style="margin-top: 10px" ng-if="!vm.dinghyEvent.closed && vm.booking.id && vm.dinghyEvent.availableDinghies && vm.dinghyEvent.availableDinghies.length > 0"><button type="button" class="btn btn-default" ng-click="status.editOpen = !status.editOpen"><span class="glyphicon" ng-class="{\'glyphicon-chevron-down\': status.editOpen, \'glyphicon-chevron-right\': !status.editOpen}"></span> Buchung bearbeiten</button><div uib-collapse="!status.editOpen"><div class="panel panel-default" style="margin: 0"><div class="panel-body"><div class="form-group" ng-show="vm.dinghyEvent.availableDinghies && vm.dinghyEvent.availableDinghies.length > 0"><label class="control-label" for="field_dinghy">Jolle w\xE4hlen <small>(leerlassen falls Privatboot und im Kommentar spezifizieren)</small></label><select class="form-control" id="field_dinghy" name="dinghy" ng-model="vm.booking.dinghy" ng-options="dinghy as (dinghy.name + \' (\' + dinghy.type + \')\') for dinghy in vm.dinghyEvent.availableDinghies track by dinghy.id" ng-disabled="vm.disableEdit"><option value=""></option></select></div><div class="form-group" ng-show="vm.dinghyEvent.availableDinghies && vm.dinghyEvent.availableDinghies.length > 0"><label class="control-label" for="field_commentDinghy">Kommentar zur Jollenwahl</label><input type="text" class="form-control" name="commentDinghy" id="field_commentDinghy" ng-model="vm.booking.commentDinghy" ng-maxlength="150" prevent-enter-submit ng-required="vm.dinghyEvent.availableDinghies && vm.dinghyEvent.availableDinghies.length > 0 && !vm.booking.dinghy" ng-disabled="vm.disableEdit"><div ng-show="editForm.commentDinghy.$invalid"><p class="help-block" ng-show="editForm.commentDinghy.$error.maxlength" data-translate="entity.validation.maxlength" translate-value-max="150">This field cannot be longer than 150 characters.</p><p class="help-block" ng-show="editForm.commentDinghy.$error.required" data-translate="entity.validation.required">This field is required.</p></div></div></div></div></div></div><div ng-if="vm.dinghyEvent.canceled && !vm.dinghyEvent.closed" class="alert alert-danger" style="margin-top: 10px">Dieses Event wurde leider <b>abgesagt!</b></div><div ng-if="vm.dinghyEvent.closed" class="alert alert-danger" style="margin-top: 10px">Dieses Event ist bereits <b>abgeschlossen.</b> Eine Bearbeitung deiner Buchung ist nicht mehr m\xF6glich.</div></div><div class="modal-footer"><button type="button" class="btn btn-default" data-dismiss="modal" ng-click="vm.clear()"><span class="glyphicon glyphicon-ban-circle"></span>&nbsp;<span data-translate="entity.action.cancel">Cancel</span></button> <button type="button" ng-if="vm.booking.id && vm.booking.bookingStatus === \'zurueckgetreten\'" class="btn btn-success" ng-disabled="vm.disableEdit" ui-sref="{{ getChangeState() }}" ng-click="$close()">Wieder&nbsp;Anmelden</button> <button type="button" ng-if="!vm.dinghyEvent.closed && vm.booking.id && (vm.booking.bookingStatus === \'angemeldet\' || vm.booking.bookingStatus === \'warteliste\')" ng-disabled="vm.disableEdit" class="btn btn-danger" ui-sref="{{ getChangeState() }}" ng-click="$close()">Abmelden</button> <button type="submit" ng-if="!vm.dinghyEvent.closed && vm.booking.id && vm.booking.bookingStatus !== \'abgelehnt\'" ng-disabled="editForm.$invalid || vm.isSaving || vm.disableEdit" class="btn btn-info"><span class="glyphicon glyphicon-check"></span>&nbsp;Best\xE4tigen</button> <button type="submit" ng-if="!vm.dinghyEvent.closed && !vm.booking.id" ng-disabled="!vm.dinghyEvent.active" class="btn btn-info" ui-sref="member.dinghy-events.book({id: vm.dinghyEvent.id})" ng-click="$close()">Zur&nbsp;Anmeldung</button></div></form>');
$templateCache.put('app/member/dinghy-events/dinghy-booking-dialog.html','<!--\n  ~ Copyright (c) 2020 by Felix Heim, felix-heim@web.de\n  ~\n  ~ This product includes software developed at\n  ~ The Apache Software Foundation (http://www.apache.org/).\n  --><form name="editForm" role="form" novalidate ng-submit="vm.save()" show-validation><div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()">&times;</button><h4 class="modal-title" id="myBookingLabel">{{vm.dinghyEvent.name}} @ {{vm.dinghyEvent.location}} - Anmeldung</h4></div><div class="modal-body"><!--<jhi-alert-error></jhi-alert-error>--><div ng-show="vm.dinghyEvent.description" style="margin-bottom: 10px"><button type="button" class="btn btn-default" ng-click="status.descriptionOpen = !status.descriptionOpen"><span class="glyphicon" ng-class="{\'glyphicon-chevron-down\': status.descriptionOpen, \'glyphicon-chevron-right\': !status.descriptionOpen}"></span> Beschreibung</button><div uib-collapse="!status.descriptionOpen"><div class="panel panel-default" style="margin: 0"><div class="panel-body"><div class="text-justify" ng-bind-html="renderHtml(vm.dinghyEvent.description)"></div></div></div></div></div><div><table><tr><td><b>Eventstatus:&nbsp;</b></td><td><span ng-if="vm.dinghyEvent.godparent" class="label label-success">Findet statt</span> <span ng-if="!vm.dinghyEvent.godparent" class="label label-warning">Jollenpate ben\xF6tigt</span></td></tr><tr><td><b><span data-translate="askApp.dinghyEvent.type">Typ</span>:</b></td><td><span class="label label-info" data-translate="{{\'askApp.EnumDinghyEventType.\' + vm.dinghyEvent.type}}"></span></td></tr><tr><td style="font-weight: bold; width: 130px">Zeitraum:&nbsp</td><td>{{vm.dinghyEvent.fromDate | date: \'EEE, dd.MM.yy HH:mm\'}}<span ng-show="vm.dinghyEvent.fromDate != vm.dinghyEvent.untilDate"> bis {{vm.dinghyEvent.untilDate | date: \'EEE, dd.MM.yy HH:mm\'}}</span></td></tr><tr ng-show="vm.dinghyEvent.normalPrice"><td style="font-weight: bold">Normalpreis:&nbsp</td><td><span>{{vm.dinghyEvent.normalPrice}}\u20AC</span></td></tr><tr ng-show="vm.dinghyEvent.studentPrice"><td style="font-weight: bold">Studentenpreis:&nbsp</td><td><span>{{vm.dinghyEvent.studentPrice}}\u20AC</span></td></tr><tr ng-show="vm.dinghyEvent.guestPrice"><td style="font-weight: bold">Gastpreis:&nbsp</td><td><span>{{vm.dinghyEvent.guestPrice}}\u20AC</span></td></tr><tr><td><b><span data-translate="askApp.dinghyEvent.godparent">Godparent</span>:</b></td><td><span ng-show="!vm.dinghyEvent.godparent" class="label label-danger">Noch niemand</span> <span ng-show="vm.dinghyEvent.godparent" class="label label-info">{{vm.dinghyEvent.godparent.firstName}} {{vm.dinghyEvent.godparent.lastName}} <span ng-if="vm.dinghyEvent.godparent.nickname">"{{vm.dinghyEvent.godparent.nickname}}"</span></span></td></tr><tr ng-show="vm.dinghyEvent.godparent"><td><b>Handynummer:&nbsp;</b></td><td><a href="tel:{{vm.dinghyEvent.godparent.phone}}">{{vm.dinghyEvent.godparent.phone}}</a></td></tr><tr><td style="font-weight: bold">Kontaktmail:&nbsp</td><td><a href="mailto:{{vm.dinghyEvent.contactEmail}}?subject=Frage zu {{vm.dinghyEvent.name}} am {{vm.dinghyEvent.fromDate | date: \'EEE, dd.MM.yy HH:mm\'}}">{{vm.dinghyEvent.contactEmail}}</a></td></tr><tr ng-show="vm.dinghyEvent.availableDinghies && vm.dinghyEvent.availableDinghies.length > 0"><td style="vertical-align: top; font-weight: bold"><span data-translate="askApp.dinghyEvent.availableDinghies">Available Dinghies</span>:&nbsp;</td><td><span ng-repeat="dinghy in vm.dinghyEvent.availableDinghies">{{dinghy.name}} ({{dinghy.type}})<!-- ToDo: Fix! Does not show on portal-test --> <span style="cursor: pointer" class="glyphicon glyphicon-comment" aria-hidden="true" uib-popover-html="getPopoverContent(dinghy.description)" popover-trigger="mouseenter" popover-append-to-body="true" ng-show="dinghy.description"></span><br ng-hide="$last"></span></td></tr></table></div><div ng-show="!vm.dinghyEvent.godparent" class="alert alert-warning" role="alert" style="margin-top: 5px"><b>Achtung!</b> Es hat sich f\xFCr diesen Termin noch kein Jollenpate gefunden!<br>Der Termin findet <b>nur dann statt,</b> wenn sich noch ein <b>Jollenpate findet.</b></div><hr><div><label class="control-label">Teilnehmer</label><div ng-show="vm.dinghyEvent.participants.length == 0"><span class="label label-danger">Bisher keine Anmeldungen</span></div><ul style="margin-left: 0"><li ng-repeat="participant in vm.dinghyEvent.participants"><a ng-show="participant.id" ng-click="$close()" ui-sref="member-management-detail({id:participant.id})">{{participant.firstName}} {{participant.lastName}}</a> <span ng-show="!participant.id">{{participant.firstName}} {{participant.lastName}}</span> <span ng-show="participant.email">| <a href="mailto:{{participant.email}}">{{participant.email}}</a></span> <span ng-show="participant.dinghy">| {{participant.dinghy.name}} ({{participant.dinghy.type}})</span> <span ng-show="participant.commentDinghy">| Jollenkommentar: {{participant.commentDinghy}}</span> <span ng-show="participant.bookingStatus !== \'angemeldet\'">&#32;(<span data-translate="{{\'askApp.EnumBookingStatusType.\' + participant.bookingStatus}}"></span>)</span></li></ul></div><hr><div class="form-group"><label class="control-label" data-translate="askApp.booking.comment" for="field_comment">Comment</label><input type="text" class="form-control" name="comment" id="field_comment" ng-model="vm.booking.comment" ng-maxlength="150" prevent-enter-submit><div ng-show="editForm.comment.$dirty && editForm.comment.$invalid"><p class="help-block" ng-show="editForm.comment.$error.maxlength" data-translate="entity.validation.maxlength" translate-value-max="150">This field cannot be longer than 150 characters.</p></div></div><div class="form-group" ng-hide="vm.dinghyEvent.individualQuestion == null || vm.dinghyEvent.individualQuestion == \'\'"><label class="control-label" for="field_individualQuestion">{{vm.dinghyEvent.individualQuestion}}</label><input type="text" class="form-control" name="individualQuestionAnswer" id="field_individualQuestion" ng-model="vm.booking.individualQuestionAnswer" ng-maxlength="150" prevent-enter-submit ng-required="vm.dinghyEvent.individualQuestion != null && vm.dinghyEvent.individualQuestion != \'\'"><div ng-show="editForm.individualQuestionAnswer.$invalid"><p class="help-block" ng-show="editForm.individualQuestionAnswer.$error.maxlength" data-translate="entity.validation.maxlength" translate-value-max="150">This field cannot be longer than 150 characters.</p><p class="help-block" ng-show="editForm.individualQuestionAnswer.$error.required" data-translate="entity.validation.required">This field is required.</p></div></div><hr ng-show="vm.dinghyEvent.availableDinghies && vm.dinghyEvent.availableDinghies.length > 0"><div class="form-group" ng-show="vm.dinghyEvent.availableDinghies && vm.dinghyEvent.availableDinghies.length > 0"><label class="control-label" for="field_dinghy">Jolle w\xE4hlen <small>(leerlassen falls Privatboot und im Kommentar spezifizieren)</small></label><select class="form-control" id="field_dinghy" name="dinghy" ng-model="vm.booking.dinghy" ng-options="dinghy as (dinghy.name + \' (\' + dinghy.type + \')\') for dinghy in vm.dinghyEvent.availableDinghies track by dinghy.id"><option value=""></option></select></div><div class="form-group" ng-show="vm.dinghyEvent.availableDinghies && vm.dinghyEvent.availableDinghies.length > 0"><label class="control-label" for="field_commentDinghy">Kommentar zur Jollenwahl</label><input type="text" class="form-control" name="commentDinghy" id="field_commentDinghy" ng-model="vm.booking.commentDinghy" ng-maxlength="150" prevent-enter-submit ng-required="vm.dinghyEvent.availableDinghies && vm.dinghyEvent.availableDinghies.length > 0 && !vm.booking.dinghy"><div ng-show="editForm.commentDinghy.$invalid"><p class="help-block" ng-show="editForm.commentDinghy.$error.maxlength" data-translate="entity.validation.maxlength" translate-value-max="150">This field cannot be longer than 150 characters.</p><p class="help-block" ng-show="editForm.commentDinghy.$error.required" data-translate="entity.validation.required">This field is required.</p></div></div><hr ng-show="vm.dinghyEvent.price"><div ng-show="vm.dinghyEvent.price"><div ng-show="vm.dinghyEvent.availableActivityPoints > 0 && maxPointCount > 0"><label class="control-label">Aktivit\xE4tenpunkte <span style="cursor: pointer" class="glyphicon glyphicon-exclamation-sign" aria-hidden="true" uib-popover="Dir stehen insgesamt {{vm.dinghyEvent.availableActivityPoints}} Aktivit\xE4tenpunkte zur Verf\xFCgung." popover-trigger="mouseenter"></span></label><div style="width: 100px"><h-number value="vm.booking.pointCount" min="0" max="{{maxPointCount}}" step="1" change="vm.pointsPicked()"></h-number></div></div><span style="font-size: 30px">Teilnahmebeitrag: {{vm.dinghyEvent.price}}\u20AC</span> <span style="font-size: 30px" ng-if="vm.dinghyEvent.price !== price"><br>Reduzierter Beitrag: {{price}}\u20AC</span> <span style="cursor: pointer" class="glyphicon glyphicon-exclamation-sign" aria-hidden="true" uib-popover="Du erh\xE4ltst die Studentenf\xF6rderung." popover-trigger="mouseenter" ng-show="vm.dinghyEvent.student"></span></div><hr><div><button type="button" class="btn btn-default" ng-click="status.conditionsOpen = !status.conditionsOpen"><span class="glyphicon" ng-class="{\'glyphicon-chevron-down\': status.conditionsOpen, \'glyphicon-chevron-right\': !status.conditionsOpen}"></span> Bedingungen & Vereinbarungen</button><div uib-collapse="!status.conditionsOpen"><div class="panel panel-default" style="margin: 0"><div class="panel-body"><div class="text-justify" ng-bind-html="renderHtml(vm.dinghyEvent.conditions)"></div></div></div></div></div><br><div class="alert alert-info" role="alert">F\xFCr die Anmeldung werden deine, im Profil angegebenen, <a ng-click="$close()" class="alert-link" ui-sref="member.personal.profile">Stammdaten</a> (inklusive der <a ng-click="$close()" class="alert-link" ui-sref="member.personal.address">Adresse</a>) gem&auml;&szlig; unserer <a href="https://ask-ev.de/admin/kcfinder/upload/files/Datenschutzrichtlinie.pdf" target="_blank" class="alert-link">Datenschutzrichtlinie</a> gespeichert und verarbeitet.</div><div class="row" style="margin-top: 10px"><div class="col-sm-10">Ich akzeptiere die <a href="https://ask-ev.de/admin/kcfinder/upload/files/AGB.pdf" target="_blank">Allgemeinen Gesch&auml;ftsbedingungen</a> und willige ein, dass meine oben aufgef\xFChrten Daten gespeichert und verarbeitet werden.</div><div class="col-sm-1"><switch ng-model="vm.agb" class="green"></switch></div></div></div><div class="modal-footer"><button type="button" class="btn btn-default" data-dismiss="modal" ng-click="vm.clear()"><span class="glyphicon glyphicon-ban-circle"></span>&nbsp;<span data-translate="entity.action.cancel">Cancel</span></button> <button type="submit" ng-disabled="editForm.$invalid || vm.isSaving || !vm.agb" class="btn btn-info"><span class="glyphicon glyphicon-plus"></span>&nbsp;<span ng-show="vm.dinghyEvent.price">Verbindlich anmelden</span><span ng-show="!vm.dinghyEvent.price">Anmelden</span></button></div></form>');
$templateCache.put('app/member/dinghy-events/dinghy-events.html','<!--\n  ~ Copyright (c) 2020 by Felix Heim, felix-heim@web.de\n  ~\n  ~ This product includes software developed at\n  ~ The Apache Software Foundation (http://www.apache.org/).\n  --><div><div class="row row-no-padding"><div class="col-md-9"><jhi-alert></jhi-alert><div><div class="panel panel-default"><div class="panel-heading"><h3 class="panel-title" data-translate="global.menu.dinghy">Info</h3></div><div class="panel-body"><content-cms identifier="26"></content-cms></div></div></div><div class="panel panel-default" ng-show="vm.calendarEvents.length > 0"><div class="panel-heading"><h3 class="panel-title" data-translate="askApp.dinghyEvent.member.bookTitle"></h3></div><div class="panel-body"><div class="row"><div class="col-xs-6"><h2>{{vm.calendarTitle}}</h2></div><div class="col-xs-6"><div class="btn-group" style="float: right"><button class="btn btn-primary" mwl-date-modifier date="vm.viewDate" decrement="vm.calendarView"><span class="glyphicon glyphicon-chevron-left"></span></button> <button class="btn btn-default" mwl-date-modifier date="vm.viewDate" set-to-today>Heute</button> <button class="btn btn-primary" mwl-date-modifier date="vm.viewDate" increment="vm.calendarView"><span class="glyphicon glyphicon-chevron-right"></span></button></div></div></div><mwl-calendar view="vm.calendarView" view-date="vm.viewDate" events="vm.calendarEvents" view-title="vm.calendarTitle" on-event-click="vm.calendarEventClicked(calendarEvent)" on-view-change-click="false" on-event-times-changed="calendarEvent.startsAt = calendarNewEventStart; calendarEvent.endsAt = calendarNewEventEnd" cell-is-open="true"></mwl-calendar></div></div><div class="alert alert-info" role="alert" ng-show="vm.calendarEvents.length == 0">Zur Zeit gibt es keine Events, f\xFCr die du dich anmelden kannst.</div><div ng-if="vm.dinghyEvents.length > 0"><h1>Angemeldete Events</h1></div><uib-accordion close-others="true" ng-if="vm.dinghyEvents.length > 0"><div ng-repeat="dinghyEvent in vm.dinghyEvents track by dinghyEvent.id"><div uib-accordion-group class="panel-default" style="margin-bottom: 10px" is-open="status.open"><div uib-accordion-heading><button type="submit" ui-sref="member.dinghy-events.book({id: dinghyEvent.id})" ng-click="$event.stopPropagation();" class="btn btn-sm pull-right btn-warning" ng-if="!dinghyEvent.bookingStatus && (dinghyEvent.studentPrice || dinghyEvent.normalPrice)" style="margin-top:-6px; margin-left: 6px"><span class="hidden-sm-down" style="font-weight: bold">Anmelden!</span></button> <button type="submit" ui-sref="member.dinghy-events.detail({id: dinghyEvent.id})" ng-click="$event.stopPropagation();" class="btn btn-sm pull-right" ng-class="{\'btn-success\': dinghyEvent.bookingStatus == \'angemeldet\' && !dinghyEvent.canceled && dinghyEvent.godparent,\n                                                \'btn-warning\': dinghyEvent.bookingStatus == \'warteliste\' || !dinghyEvent.godparent,\n                                                \'btn-danger\': dinghyEvent.bookingStatus == \'zurueckgetreten\'  || dinghyEvent.bookingStatus == \'abgelehnt\' || dinghyEvent.canceled,\n                                                \'btn-info\': dinghyEvent.bookingStatus == null}" ng-disabled="!dinghyEvent.bookingStatus" style="margin-top:-6px"><!-- bookingStatus == null -> Godparent without booking --> <span ng-if="dinghyEvent.bookingStatus == \'angemeldet\'" class="glyphicon glyphicon-ok"></span> <span ng-if="dinghyEvent.bookingStatus" class="hidden-sm-down" data-translate="{{\'askApp.EnumBookingStatusType.\' + dinghyEvent.bookingStatus}}"></span> <span ng-if="!dinghyEvent.bookingStatus" class="hidden-sm-down" data-translate="askApp.dinghyEvent.godparent"></span> <span ng-if="dinghyEvent.bookingStatus && dinghyEvent.bookingStatus !== \'abgelehnt\'" class="glyphicon glyphicon-pencil"></span></button> <span ng-show="dinghyEvent.freePlaces < 200 && dinghyEvent.visible"><span class="badge pull-right" style="margin-right: 10px" ng-show="dinghyEvent.freePlaces == 1">{{dinghyEvent.freePlaces}} freier Platz</span> <span class="badge pull-right" style="margin-right: 10px" ng-show="dinghyEvent.freePlaces > 1">{{dinghyEvent.freePlaces}} freie Pl\xE4tze</span> <span class="badge pull-right" style="margin-right: 10px" ng-show="dinghyEvent.freePlaces == -1">Warteliste</span> <span class="badge pull-right" style="margin-right: 10px" ng-show="dinghyEvent.freePlaces == 0">Kein Platz mehr verf\xFCgbar</span> </span><i class="glyphicon" ng-class="{\'glyphicon-chevron-down\': status.open, \'glyphicon-chevron-right\': !status.open}"></i> <span ng-if="!dinghyEvent.bookingStatus || (dinghyEvent.godparent && dinghyEvent.godparent.id === vm.currentProfile.id)" class="glyphicon glyphicon-tower"></span> {{dinghyEvent.name}} <small>{{dinghyEvent.fromDate | date: \'EEE, dd.MM.yy HH:mm\'}} - {{dinghyEvent.untilDate | date: \'EEE, dd.MM.yy HH:mm\'}}</small></div><div class="row"><div class="col-md-4 projectInfos"><table><tr><td style="font-weight: bold; width: 130px">Status:&nbsp</td><td><span ng-if="dinghyEvent.canceled" class="label label-danger">Abgesagt</span> <span ng-if="!dinghyEvent.canceled && dinghyEvent.godparent" class="label label-success">Findet statt</span> <span ng-if="!dinghyEvent.canceled && !dinghyEvent.godparent" class="label label-warning">Jollenpate ben\xF6tigt</span></td></tr><tr><td style="font-weight: bold"><span data-translate="askApp.dinghyEvent.type"></span>:&nbsp</td><td><span class="label label-info" data-translate="{{\'askApp.EnumDinghyEventType.\' + dinghyEvent.type}}"></span></td></tr><tr><td style="font-weight: bold; width: 130px">Start:&nbsp</td><td><span class="label label-info">{{dinghyEvent.fromDate | date: \'EEE, dd.MM.yy HH:mm\'}}</span></td></tr><tr><td style="font-weight: bold">Ende:&nbsp</td><td><span class="label label-info">{{dinghyEvent.untilDate | date: \'EEE, dd.MM.yy HH:mm\'}}</span></td></tr><tr><td style="font-weight: bold"><span data-translate="askApp.dinghyEvent.location"></span>:&nbsp</td><td><span class="label label-info">{{dinghyEvent.location}}</span></td></tr><tr ng-if="dinghyEvent.normalPrice"><td style="font-weight: bold">Normalpreis:&nbsp</td><td><span class="label label-info">{{dinghyEvent.normalPrice}}\u20AC</span></td></tr><tr ng-if="dinghyEvent.studentPrice"><td style="font-weight: bold">Studentenpreis:&nbsp</td><td><span class="label label-info">{{dinghyEvent.studentPrice}}\u20AC</span></td></tr><tr ng-if="dinghyEvent.guestPrice"><td style="font-weight: bold">Gastpreis:&nbsp</td><td><span class="label label-info">{{dinghyEvent.guestPrice}}\u20AC</span></td></tr><tr><td style="font-weight: bold"><span data-translate="askApp.dinghyEvent.godparent"></span>:&nbsp</td><td><span ng-show="!dinghyEvent.godparent" class="label label-danger">Noch niemand</span> <span ng-show="dinghyEvent.godparent" class="label label-info">{{dinghyEvent.godparent.firstName}} {{dinghyEvent.godparent.lastName}} <span ng-if="dinghyEvent.godparent.nickname">"{{dinghyEvent.godparent.nickname}}"</span></span></td></tr><tr ng-if="dinghyEvent.godparent"><td style="font-weight: bold">Handynummer:&nbsp</td><td><a href="tel:{{dinghyEvent.godparent.phone}}">{{dinghyEvent.godparent.phone}}</a></td></tr><tr><td style="font-weight: bold">Kontaktmail:&nbsp</td><td><a href="mailto:{{dinghyEvent.contactEmail}}?subject=Frage zu {{dinghyEvent.name}} am {{dinghyEvent.fromDate | date: \'EEE, dd.MM.yy HH:mm\'}}">{{dinghyEvent.contactEmail}}<a></a></td></tr><tr ng-if="dinghyEvent.individualQuestion != null && dinghyEvent.individualQuestion != \'\'"><td style="font-weight: bold"><span data-translate="askApp.dinghyEvent.individualQuestion"></span>:&nbsp</td><td>{{dinghyEvent.individualQuestion}}</td></tr><tr ng-show="dinghyEvent.availableDinghies && dinghyEvent.availableDinghies.length > 0"><td style="font-weight: bold"><span data-translate="askApp.dinghyEvent.availableDinghies"></span>:&nbsp</td><td><div ng-repeat="dinghy in dinghyEvent.availableDinghies"><span class="label label-info" style="cursor: pointer" aria-hidden="true" uib-popover-html="getPopoverContent(dinghy.description)" popover-trigger="mouseenter" popover-append-to-body="true" ng-if="dinghy.description">{{dinghy.name}} ({{dinghy.type}}) </span><span class="label label-info" ng-if="!dinghy.description">{{dinghy.name}} ({{dinghy.type}})</span></div></td></tr></table></div><div class="col-md-8"><h2 style="margin-top:0">{{dinghyEvent.name}}</h2><div class="text-justify" ng-bind-html="renderHtml(dinghyEvent.description)"></div><div style="margin-top: 10px"><label class="control-label">Teilnehmer</label><ul style="margin-left: 0"><li ng-repeat="participant in dinghyEvent.participants"><a ng-show="participant.id" ui-sref="member-management-detail({id:participant.id})">{{participant.firstName}} {{participant.lastName}}</a> <span ng-show="!participant.id">{{participant.firstName}} {{participant.lastName}}</span> <span ng-show="participant.email">| <a href="mailto:{{participant.email}}">{{participant.email}}</a></span> <span ng-show="participant.dinghy">| {{participant.dinghy.name}} ({{participant.dinghy.type}})</span> <span ng-show="participant.commentDinghy">| Jollenkommentar: {{participant.commentDinghy}}</span> <span ng-show="participant.bookingStatus !== \'angemeldet\'">&#32;(<span data-translate="{{\'askApp.EnumBookingStatusType.\' + participant.bookingStatus}}"></span>)</span></li></ul></div><div style="margin-top: 10px"><button type="button" class="btn btn-default" ng-click="status.conditionsOpen = !status.conditionsOpen"><span class="glyphicon" ng-class="{\'glyphicon-chevron-down\': status.conditionsOpen, \'glyphicon-chevron-right\': !status.conditionsOpen}"></span> Bedingungen & Vereinbarungen</button><div uib-collapse="!status.conditionsOpen"><div class="panel panel-default" style="margin: 0"><div class="panel-body"><div class="text-justify" ng-bind-html="renderHtml(dinghyEvent.conditions)"></div></div></div></div></div></div></div></div></div></uib-accordion></div><div class="col-md-3"><div class="panel panel-default"><div class="panel-heading"><h3 class="panel-title">Info</h3></div><div class="panel-body"><content-cms identifier="27"></content-cms></div></div></div></div></div>');
$templateCache.put('app/member/full_member/full-member-dialog.html','<!--\n  ~ Copyright (c) 2017 by Julian Feder, julian.feder@yahoo.de\n  ~\n  ~ This product includes software developed at\n  ~ The Apache Software Foundation (http://www.apache.org/).\n  --><form name="form" role="form" novalidate show-validation ng-submit="vm.becomeMember()"><div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()">&times;</button><h4 class="modal-title">Mitglied werden</h4></div><div class="modal-body"><div class="alert alert-danger" ng-show="vm.errorIban" data-translate="global.messages.error.iban">bic error</div><div class="alert alert-danger" ng-show="vm.errorBic" data-translate="global.messages.error.bic">iban error</div><p>Dir hat dein Segelt\xF6rn bei uns gefallen? Dann werde jetzt Mitglied der ASK e.V.! Gib einfach an, ob du noch Student bist oder nicht und falls der Mitgliedsbeitrag per SEPA eingezogen werden soll. Wenn du dann auf \u201EMitglied werden\u201C klickst, wird du automatisch Mitglied der ASK. Solltest du bereits f\xFCr ein Event angemeldet sein, wid der Preis automatisch angepasst.</p><div><div class="form-group" id="isStudent"><label class="control-label" for="isStudent" data-translate="global.form.isStudent">Student?</label><div class="btn-group btn-group-justified"><label class="btn btn-default" ng-model="vm.profile.isStudent" ng-click="vm.truncateUpload(); vm.calcToPay()" uib-btn-radio="false"><span data-translate="global.form.button.no">Nein</span></label><label class="btn btn-default" ng-model="vm.profile.isStudent" ng-click="vm.calcToPay()" uib-btn-radio="true"><span data-translate="global.form.button.yes">Ja</span></label></div></div><div class="alert alert-danger" ng-show="vm.profile.isStudent">Auf die Gew&auml;hrung der Studentischen Aufnahmegeb&uuml;hr ({{vm.welcomeFeeStudent}}\u20AC statt {{vm.welcomeFeeNormal}}\u20AC) haben nur <b>Vollzeitstudenten</b> mit g&uuml;ltiger Immatrikulationsbescheinigung bis zu einem Alter von <b>25 Jahren</b> Anspruch. &Uuml;ber studentische F&ouml;rderungen dar&uuml;ber hinaus entscheidet der Vorstand. Der Vorstand beh&auml;lt sich insbesondere das Recht vor, in diesem Fall den Studentenstatus nachtr&auml;glich abzuerkennen, wodurch auch die regul&auml;re Aufnahmegeb&uuml;hr f&auml;llig wird.</div><!---------------------><!-- Immatriculation --><!---------------------><div class="form-group" ng-show="vm.profile.isStudent == true"><div class="form-group" ngf-drop ngf-change="vm.setMatriculationCertificate($file, vm.profile)"><label class="control-label" data-translate="global.form.matriculationCertificate" for="field_matriculationCertificate">Matriculation Certificate</label><div><div ng-if="vm.profile.matriculationCertificate" class="help-block clearfix"><a ng-click="vm.openFile(vm.profile.matriculationCertificateContentType, vm.profile.matriculationCertificate)"><span class="glyphicon glyphicon-file" aria-hidden="true" style="font-size: 50px"></span><!--<i class="fa fa-file-pdf-o fa-3x" aria-hidden="true"></i>--></a> <button type="button" ng-click="vm.profile.matriculationCertificate=null;vm.profile.matriculationCertificateContentType=null;" class="btn btn-default btn-xs pull-right"><span class="glyphicon glyphicon-remove"></span></button></div><button type="button" ngf-select class="btn btn-default btn-block" ngf-change="vm.setMatriculationCertificate($file, vm.profile)" data-translate="global.form.addMatriculationCertificate">Add blob</button><div><p class="help-block" ng-show="vm.errorWrongFormat && vm.profile.isStudent == true" data-translate="register.messages.error.wrongformat" style="color:#a94442">This field is required.</p><p class="help-block" ng-show="vm.errorMaxUploadSize && vm.profile.isStudent == true" data-translate="register.messages.error.maxuploadsize" style="color:#a94442"><strong>Max. 2MB allowed!</strong> Please decrease file size.</p><p class="help-block" ng-show="!vm.profile.matriculationCertificate && vm.profile.isStudent == true" data-translate="register.messages.error.matriculationRequired" style="color:#a94442"><strong>Max. 2MB allowed!</strong> Please decrease file size.</p></div></div><input type="hidden" class="form-control" name="matriculationCertificate" id="field_matriculationCertificate" ng-required="vm.profile.isStudent == true" ng-model="vm.profile.matriculationCertificate"> <input type="hidden" class="form-control" name="matriculationCertificateContentType" id="field_matriculationCertificateContentType" ng-required="vm.profile.isStudent == true" ng-model="vm.profile.matriculationCertificateContentType"></div></div><!--------------------><!---- univeristy ----><!--------------------><div class="form-group" ng-show="!vm.profile.isStudent" ng-init="vm.profile.university = null"><label class="control-label" data-translate="askApp.profile.label.university">Warst du mal an einer Uni</label><div class="btn-group btn-group-justified"><label class="btn btn-default" ng-model="vm.university" uib-btn-radio="false" tabindex="0"><span data-translate="global.form.button.no">Nein</span></label><label class="btn btn-default" ng-model="vm.university" uib-btn-radio="true" tabindex="0"><span data-translate="global.form.button.yes">Ja</span></label></div></div><div class="form-group" ng-show="vm.university == true || vm.profile.isStudent"><label class="control-label" data-translate="askApp.profile.university.university" ng-show="!vm.profile.isStudent" for="field_university">Hochschule</label><label class="control-label" data-translate="askApp.profile.university.universityStudent" ng-show="vm.profile.isStudent" for="field_university">Hochschule</label><input type="text" class="form-control" name="university" id="field_university" ng-model="vm.profile.university" ng-required="vm.university || vm.profile.isStudent" placeholder="{{\'askApp.profile.university.placeholder\' | translate}}"><div ng-show="form.university.$invalid"><p class="help-block" ng-show="form.university.$error.required" data-translate="entity.validation.required">This field is required.</p></div></div><h3 data-translate="global.form.pay.heading">Zahlungsmittel</h3><!--------------------><!-- is using sepa ---><!--------------------><div class="form-group"><div class="btn-group btn-group-justified" ng-init="vm.profile.isUsingSepa = true"><label class="btn btn-default" ng-model="vm.profile.isUsingSepa" ng-click="vm.truncateBancAccount(); vm.calcToPay()" uib-btn-radio="false"><span data-translate="global.form.button.transfer">per \xDCberweisung</span></label><label class="btn btn-default" ng-model="vm.profile.isUsingSepa" ng-click="vm.calcToPay()" uib-btn-radio="true"><span data-translate="global.form.button.direct">per Lastschrift</span></label></div></div><div class="alert alert-info" ng-show="vm.profile.isUsingSepa == false">Die Aufnahmegeb\xFChr betr\xE4gt einmalig {{vm.welcomeFee}}\u20AC. Der j\xE4hrliche Mitgliedsbeitrag betr\xE4gt {{vm.anualFee}}\u20AC. Nach der Anmeldung erh\xE4lst du per E-Mail eine Zahlungsaufforderung in H\xF6he von <b>{{vm.toPay}}\u20AC</b>.</div><h3 ng-show="vm.profile.isUsingSepa == true" data-translate="global.form.account.heading">Kontodaten</h3><!--------------------><!------ iban --------><!--------------------><div class="form-group" ng-show="vm.profile.isUsingSepa == true"><label class="control-label" data-translate="askApp.profile.iban" for="field_iban">Iban</label><input type="text" class="form-control" name="iban" id="field_iban" ng-model="vm.profile.iban" ng-iban ng-minlength="18" ng-maxlength="30" maxlength="30" ng-required="vm.profile.isUsingSepa == true" placeholder="{{\'askApp.profile.iban.placeholder\' | translate}}"><div ng-show="form.iban.$dirty && form.iban.$invalid"><p class="help-block" ng-show="form.iban.$error.required" data-translate="entity.validation.required">This field is required.</p><p class="help-block" ng-show="form.iban.$error.ngIban" data-translate="entity.validation.invalid">Not a valid IBAN.</p><p class="help-block" ng-show="form.iban.$error.minlength" data-translate="entity.validation.minlength" translate-value-min="18">Your IBAN is required to be at least 18 characters.</p><p class="help-block" ng-show="form.iban.$error.maxlength" data-translate="entity.validation.maxlength" translate-value-max="30">Your IBAN cannot be longer than 30 characters.</p></div></div><!--------------------><!------ bic ---------><!--------------------><div class="form-group" ng-show="vm.profile.isUsingSepa == true"><label class="control-label" data-translate="askApp.profile.bic" for="field_bic">Bic</label><input type="text" class="form-control" name="bic" id="field_bic" ng-model="vm.profile.bic" ng-minlength="8" ng-maxlength="11" maxlength="11" ng-required="vm.profile.isUsingSepa == true" pattern="([a-zA-Z]{4}[a-zA-Z]{2}[a-zA-Z0-9]{2}([a-zA-Z0-9]{3})?)" placeholder="{{\'askApp.profile.bic.placeholder\' | translate}}"><div ng-show="form.bic.$dirty && form.bic.$invalid"><p class="help-block" ng-show="form.bic.$error.required" data-translate="entity.validation.required">This field is required.</p><p class="help-block" ng-show="form.bic.$error.pattern" data-translate="entity.validation.invalid">Not a valid IBAN.</p><p class="help-block" ng-show="form.bic.$error.minlength" data-translate="entity.validation.minlength" translate-value-min="8">Your IBAN is required to be at least 8 characters.</p><p class="help-block" ng-show="form.bic.$error.maxlength" data-translate="entity.validation.maxlength" translate-value-max="11">Your IBAN cannot be longer than 11 characters.</p></div></div><!----------------------><!-- banc account hol --><!----------------------><div class="form-group" ng-show="vm.profile.isUsingSepa == true"><label class="control-label" for="bankAccountHolder.deviated" data-translate="global.form.bankAccountHolder.deviated">Deviated</label><div class="btn-group btn-group-justified" ng-init="vm.profile.isDeviatedHolder = false" id="bankAccountHolder.deviated"><label class="btn btn-default" ng-model="vm.profile.isDeviatedHolder" ng-click="vm.truncateBancAccountHolder()" uib-btn-radio="false"><span data-translate="global.form.button.no">Nein</span></label><label class="btn btn-default" ng-model="vm.profile.isDeviatedHolder" ng-click="vm.truncateBancAccountHolder()" uib-btn-radio="true"><span data-translate="global.form.button.yes">Ja</span></label></div></div><div class="form-group" ng-show="vm.profile.isUsingSepa == true"><label class="control-label" data-translate="askApp.profile.bankAccountHolder" for="field_bankAccountHolder">Bank Account Holder</label><input type="text" class="form-control" name="bankAccountHolder" id="field_bankAccountHolder" ng-model="vm.profile.bankAccountHolder" placeholder="{{vm.account.firstName + \' \' + vm.account.lastName}}" ng-disabled="vm.profile.isDeviatedHolder == false" ng-required="vm.profile.isDeviatedHolder == true" ng-minlength="1" ng-maxlength="100" maxlength="100"><div ng-show="form.bankAccountHolder.$dirty && form.bankAccountHolder.$invalid"><p class="help-block" ng-show="form.bankAccountHolder.$error.required" data-translate="entity.validation.required">This field is required.</p><p class="help-block" ng-show="form.bankAccountHolder.$error.minlength" data-translate="entity.validation.minlength" translate-value-min="1">Your mobile phone is required to be at least 1 characters.</p><p class="help-block" ng-show="form.bankAccountHolder.$error.maxlength" data-translate="entity.validation.maxlength" translate-value-max="100">Your mobile phone cannot be longer than 100 characters.</p></div><br><div class="alert alert-info">Die Aufnahmegeb\xFChr betr\xE4gt einmalig {{vm.welcomeFee}}\u20AC. Der j\xE4hrliche Mitgliedsbeitrag betr\xE4gt {{vm.anualFee}}\u20AC. Insgesamt werden <b>{{vm.toPay}}\u20AC</b> von deinem Konto abgebucht. Der j\xE4hrliche Mitgliedsbeitrag wird immer zum Jahresende von deinem Konto eingezogen.</div></div><div class="alert alert-success" ng-show="vm.showFreeYear">Wenn du nach dem <b>1. November</b> des Jahres beitrittst, schenken wir dir den Mitgliedsbeitrag f\xFCr das Folgejahr.</div></div></div><div class="modal-footer"><button type="button" class="btn btn-default" data-dismiss="modal" ng-click="vm.clear()"><span class="glyphicon glyphicon-ban-circle"></span>&nbsp;<span data-translate="entity.action.cancel">Cancel</span></button> <button type="submit" ng-disabled="form.$invalid || vm.isSaving" class="btn btn-info"><span class="glyphicon glyphicon-plus-sign"></span>&nbsp;Mitglied werden</button></div></form>');
$templateCache.put('app/member/personal/personalNavbar.html','<!--\n  ~ Copyright (c) 2017 by Julian Feder, julian.feder@yahoo.de\n  ~\n  ~ This product includes software developed at\n  ~ The Apache Software Foundation (http://www.apache.org/).\n  --><div><div class="row row-no-padding"><div class="col-md-3"><div class="panel panel-default"><div class="panel-heading"><h3 class="panel-title">Meine Daten</h3></div><div class="panel-body"><ul class="nav nav-pills nav-stacked" style="margin: 0"><li role="presentation" ui-sref-active="active"><a ui-sref="member.personal.profile" data-translate="global.menu.personal">Pers\xF6nliche Daten</a></li><li role="presentation" ui-sref-active="active"><a ui-sref="member.personal.additional" data-translate="global.menu.additional">Zus\xE4tzliche Daten</a></li><li role="presentation" ui-sref-active="active"><a ui-sref="member.personal.address" data-translate="global.menu.address">Adresse</a></li><li role="presentation" ui-sref-active="active"><a ui-sref="member.personal.certificates" data-translate="global.menu.license">Scheine</a></li><li role="presentation" ui-sref-active="active" ng-show="vm.profile.memberStatus == \'probe\' || vm.profile.memberStatus == \'voll\'"><a ui-sref="member.personal.payment" data-translate="global.menu.payment">Zahlungsmittel</a></li><li role="presentation" ui-sref-active="active" ng-show="vm.profile.memberStatus == \'probe\' || vm.profile.memberStatus == \'voll\'"><a ui-sref="member.personal.student" data-translate="global.menu.student">Studentenstatus</a></li><li role="presentation" ui-sref-active="active"><a ui-sref="member.personal.password" data-translate="global.menu.password">Passwort</a></li></ul></div></div></div><div class="col-md-9" ui-view="personal"></div></div></div>');
$templateCache.put('app/member/projects/book-sbf-slot-dialog.html','<!--\n  ~ Copyright (c) 2017 by Julian Feder, julian.feder@yahoo.de\n  ~\n  ~ This product includes software developed at\n  ~ The Apache Software Foundation (http://www.apache.org/).\n  --><form name="editForm" role="form" novalidate ng-submit="vm.save()" show-validation><div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()">&times;</button><h4 class="modal-title" id="mySbfTimeSlotLabel">Terminbuchung {{vm.sbfTimeSlot.project}}</h4></div><div class="modal-body"><div class="form-group"><span>M\xF6chtest du den Termin am <b>{{vm.sbfTimeSlot.fromTime | date:\'dd.MM.yyyy\'}}</b> von <b>{{vm.sbfTimeSlot.fromTime | date:\'HH:mm\'}} Uhr</b> bis <b>{{vm.sbfTimeSlot.toTime | date:\'HH:mm\'}} Uhr</b> wirklich buchen?</span></div><!--<div class="form-group">\n            <label class="control-label" data-translate="askApp.booking.comment" for="field_comment">Comment</label>\n            <input type="text" class="form-control" name="comment" id="field_comment"\n                   ng-model="vm.booking.comment" ng-maxlength="50"\n            />\n            <div ng-show="editForm.comment.$dirty && editForm.comment.$invalid">\n                <p class="help-block"\n                   ng-show="editForm.comment.$error.maxlength" data-translate="entity.validation.maxlength" translate-value-max="50">\n                    This field cannot be longer than 50 characters.\n                </p>\n            </div>\n        </div>--></div><div class="modal-footer"><button type="button" class="btn btn-default" data-dismiss="modal" ng-click="vm.clear()"><span class="glyphicon glyphicon-ban-circle"></span>&nbsp;<span data-translate="entity.action.cancel">Cancel</span></button> <button type="submit" ng-disabled="editForm.$invalid || vm.isSaving" class="btn btn-primary"><span class="glyphicon glyphicon-save"></span>&nbsp;<span data-translate="askApp.sbfTimeSlot.book">Book</span></button></div></form>');
$templateCache.put('app/member/projects/booking-dialog.html','<!--\n  ~ Copyright (c) 2017 by Julian Feder, julian.feder@yahoo.de\n  ~\n  ~ This product includes software developed at\n  ~ The Apache Software Foundation (http://www.apache.org/).\n  --><form name="editForm" role="form" novalidate ng-submit="vm.save()" show-validation><div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()">&times;</button><h4 class="modal-title" id="myBookingLabel">{{vm.project.name}} Anmeldung</h4></div><div class="modal-body"><!--<jhi-alert-error></jhi-alert-error>--><div class="alert alert-info" role="alert">F\xFCr die Anmeldung werden deine, im Profil angegebenen, <a ng-click="$close()" class="alert-link" ui-sref="member.personal.profile">Stammdaten</a> (inklusive der <a ng-click="$close()" class="alert-link" ui-sref="member.personal.address">Adresse</a> und <a ng-click="$close()" class="alert-link" ui-sref="member.personal.certificates">Zertifikate</a>) gem&auml;&szlig; unserer <a href="https://ask-ev.de/admin/kcfinder/upload/files/Datenschutzrichtlinie.pdf" target="_blank" class="alert-link">Datenschutzrichtlinie</a> gespeichert und verarbeitet.<br>Bitte stelle sicher, dass <b>alle</b> Daten in deinem Profil aktuell sind.<br><b>Aktuelle Stammdaten:</b><ul><li>Handynummer: <a ng-click="$close()" ui-sref="member.personal.profile"><span class="alert-link">{{vm.project.phoneValue}}</span> <b>(\xC4ndern)</b></a></li><li>Adresse: <a ng-click="$close()" ui-sref="member.personal.address"><span class="alert-link">{{vm.project.streetValue}}, {{vm.project.countryValue}}-{{vm.project.postcodeValue}} {{vm.project.cityValue}}</span> <b>(\xC4ndern)</b></a></li></ul><div style="margin-top: 10px" ng-if="vm.project.weight || vm.project.clothingSize || vm.project.shoeSize || vm.project.nationality || vm.project.birthplace || vm.project.countryOfBirth || vm.project.idNumber">Folgende zus&auml;tzlichen Daten werden dar&uuml;ber hinaus f&uuml;r die Anmeldung zu diesem Event ben&ouml;tigt und verarbeitet.<br><b>Zusatzdaten: <span class="alert-danger" ng-if="!vm.dataValid">(Fehlende Daten sind rot)</span><span class="alert-success" ng-if="vm.dataValid">(Alle Daten angegeben)</span></b><ul><li ng-if="vm.project.weight">Gewicht: <a ng-click="$close()" ui-sref="member.personal.additional"><span ng-if="vm.project.checkWeight" class="alert-link">{{vm.project.weightValue}} kg</span> <b ng-if="!vm.project.checkWeight" class="alert-danger">Bitte im Profil angeben!</b> <b>(\xC4ndern)</b></a></li><li ng-if="vm.project.clothingSize">T-Shirt Gr\xF6&szlig;e: <a ng-click="$close()" ui-sref="member.personal.additional"><span ng-if="vm.project.checkClothingSize" class="alert-link">{{vm.project.clothingSizeValue}}</span> <b ng-if="!vm.project.checkClothingSize" class="alert-danger">Bitte im Profil angeben!</b> <b>(\xC4ndern)</b></a></li><li ng-if="vm.project.shoeSize">Schuhgr\xF6&szlig;e (EU): <a ng-click="$close()" ui-sref="member.personal.additional"><span ng-if="vm.project.checkShoeSize" class="alert-link">{{vm.project.shoeSizeValue}}</span> <b ng-if="!vm.project.checkShoeSize" class="alert-danger">Bitte im Profil angeben!</b> <b>(\xC4ndern)</b></a></li><li ng-if="vm.project.nationality">Nationalit&auml;t: <a ng-click="$close()" ui-sref="member.personal.additional"><span ng-if="vm.project.checkNationality" class="alert-link" data-translate="askApp.EnumCountry.{{vm.project.nationalityValue}}"></span> <b ng-if="!vm.project.checkNationality" class="alert-danger">Bitte im Profil angeben!</b> <b>(\xC4ndern)</b></a></li><li ng-if="vm.project.birthplace">Geburtsort: <a ng-click="$close()" ui-sref="member.personal.additional"><span ng-if="vm.project.checkBirthplace" class="alert-link">{{vm.project.birthplaceValue}}</span> <b ng-if="!vm.project.checkBirthplace" class="alert-danger">Bitte im Profil angeben!</b> <b>(\xC4ndern)</b></a></li><li ng-if="vm.project.countryOfBirth">Geburtsland: <a ng-click="$close()" ui-sref="member.personal.additional"><span ng-if="vm.project.checkCountryOfBirth" class="alert-link" data-translate="askApp.EnumCountry.{{vm.project.countryOfBirthValue}}"></span> <b ng-if="!vm.project.checkCountryOfBirth" class="alert-danger">Bitte im Profil angeben!</b> <b>(\xC4ndern)</b></a></li><li ng-if="vm.project.idNumber">Ausweisdokument: <a ng-click="$close()" ui-sref="member.personal.additional"><span ng-if="vm.project.idNumberValue !== null && vm.project.idNumberValue !== \'\'" class="alert-link">{{vm.project.idNumberValue}}</span> <b ng-if="!vm.project.checkIDNumberExpiration && (vm.project.idNumberValue !== null && vm.project.idNumberValue !== \'\')" class="alert-warning">L\xE4uft vor Ende ab. Muss rechtzeitig aktualisiert werden!</b> <b ng-if="!vm.project.checkIDNumberExpiration && !(vm.project.idNumberValue !== null && vm.project.idNumberValue !== \'\')" class="alert-danger">Bitte im Profil angeben!</b> <b>(\xC4ndern)</b></a></li></ul></div></div><!--<div class="form-group">\n            <label class="control-label" data-translate="askApp.booking.sepa" for="field_sepa">Sepa</label>\n            <input type="checkbox" name="sepa" id="field_sepa"\n                   ng-model="vm.booking.sepa"/>\n        </div>--><div class="form-group"><label class="control-label" data-translate="askApp.booking.comment" for="field_comment">Comment</label><input type="text" class="form-control" name="comment" id="field_comment" ng-model="vm.booking.comment" ng-maxlength="150" prevent-enter-submit><div ng-show="editForm.comment.$dirty && editForm.comment.$invalid"><p class="help-block" ng-show="editForm.comment.$error.maxlength" data-translate="entity.validation.maxlength" translate-value-max="150">This field cannot be longer than 150 characters.</p></div></div><div class="form-group" ng-hide="vm.project.individualField == null || vm.project.individualField == \'\'"><label class="control-label" for="field_individualField">{{vm.project.individualField}}</label><input type="text" class="form-control" name="individualField" id="field_individualField" ng-model="vm.booking.individualField" ng-maxlength="150" prevent-enter-submit ng-required="vm.project.individualField != null && vm.project.individualField != \'\'"><div ng-show="editForm.individualField.$invalid"><p class="help-block" ng-show="editForm.individualField.$error.maxlength" data-translate="entity.validation.maxlength" translate-value-max="150">This field cannot be longer than 150 characters.</p><p class="help-block" ng-show="editForm.individualField.$error.required" data-translate="entity.validation.required">This field is required.</p></div></div><div class="form-group" ng-if="vm.project.projectType == \'sksTrip\'"><label class="control-label" data-translate="askApp.booking.individualPrice">individualPrice</label><br><switch ng-model="vm.booking.individualPrice" class="green" ng-change="vm.setIndividualPrice()"></switch></div><div class="form-group" ng-if="vm.project.projectType == \'sksTrip\' && !vm.booking.individualPrice"><label class="control-label">Wirst du deine SKS-Theoriepr\xFCfung<br>bis zum SKS-T\xF6rn angetreten haben? <span style="cursor: pointer" class="glyphicon glyphicon-exclamation-sign" aria-hidden="true" uib-popover="Falls du dich doch noch umentscheiden m\xF6chtest, kannst du dies nachtr\xE4glich unter Account/Buchungen \xE4ndern." popover-trigger="mouseenter" popover-placement="auto"></span></label><br><switch ng-model="vm.booking.sksTheoryAvailable" class="green"></switch></div><hr ng-if="vm.project.projectType !== \'interest\'"><div ng-if="vm.project.projectType !== \'interest\'"><div ng-if="vm.project.activityPoints && vm.project.availableActivityPoints > 0 && maxPoints > 0"><label class="control-label">Aktivit\xE4tenpunkte <span style="cursor: pointer" class="glyphicon glyphicon-exclamation-sign" aria-hidden="true" uib-popover="Dir stehen insgesamt {{vm.project.availableActivityPoints}} Aktivit\xE4tenpunkte zur Verf\xFCgung." popover-trigger="mouseenter"></span></label><div style="width: 100px"><h-number value="vm.booking.points" min="0" max="{{maxPoints}}" step="1" change="vm.pointsPicked()"></h-number></div></div><span style="font-size: 30px" ng-if="vm.project.projectType !== \'merchandise\'">Teilnahmebeitrag: {{vm.project.price}}\u20AC</span> <span style="font-size: 30px" ng-if="vm.project.projectType == \'merchandise\'">Kosten: {{vm.project.price}}\u20AC</span> <span style="font-size: 30px" ng-if="vm.project.projectType !== \'merchandise\' && vm.project.price !== price"><br>Reduzierter Beitrag: {{price}}\u20AC</span> <span style="font-size: 30px" ng-if="vm.project.projectType == \'merchandise\' && vm.project.price !== price"><br>Reduzierte Kosten: {{price}}\u20AC</span> <span style="cursor: pointer" class="glyphicon glyphicon-exclamation-sign" aria-hidden="true" uib-popover="Du musst mindestens 9 Monate Mitglied sein um die Studentenf\xF6rderung zu erhalten." popover-trigger="mouseenter" ng-if="!vm.project.checkRegisterDate && vm.project.student"></span> <span style="cursor: pointer" class="glyphicon glyphicon-exclamation-sign" aria-hidden="true" uib-popover="Du erh\xE4ltst die Studentenf\xF6rderung." popover-trigger="mouseenter" ng-if="vm.project.checkRegisterDate && vm.project.student && vm.project.projectType !== \'merchandise\'"></span> <span style="font-size: 20px" ng-if="vm.project.prepayment !== null && vm.project.prepayment > 0"><br>Anzahlung: {{vm.project.prepayment}}\u20AC</span> <span style="cursor: pointer" ng-if="vm.project.prepayment !== null && vm.project.prepayment > 0" class="glyphicon glyphicon-exclamation-sign" aria-hidden="true" uib-popover="Nur bis 8 Wochen vor dem Event" popover-trigger="mouseenter"></span> <span style="font-size: 20px" ng-if="vm.project.prepayment !== null && vm.project.prepayment > 0  && vm.project.price !== price"><br>Reduzierte Anzahlung: {{prepayment}}\u20AC</span></div><hr><div><table><tr><td style="font-weight: bold; width: 130px">Zeitraum:&nbsp</td><td>{{vm.project.fromDate | date:\'mediumDate\'}}<span ng-if="vm.project.fromDate != vm.project.untilDate"> bis {{vm.project.untilDate | date:\'mediumDate\'}}</span></td></tr><tr ng-if="vm.project.projectType != \'sksTrip\'"><td style="font-weight: bold">Projektleiter:&nbsp</td><td>{{vm.project.managerName}}</td></tr><tr ng-if="vm.project.projectType != \'sksTrip\'"><td style="font-weight: bold">Kontaktmail:&nbsp</td><td><a href="mailto:{{vm.project.managerMail}}?subject=Frage zu {{vm.project.name}}">{{vm.project.managerMail}}</a></td></tr><tr ng-if="vm.project.projectType == \'sksTrip\'"><td style="font-weight: bold">Skipper:&nbsp</td><td>{{vm.project.skipperName}}</td></tr></table></div><br><div><button type="button" class="btn btn-default" ng-click="status.descriptionOpen = !status.descriptionOpen"><span class="glyphicon" ng-class="{\'glyphicon-chevron-down\': status.descriptionOpen, \'glyphicon-chevron-right\': !status.descriptionOpen}"></span> Beschreibung</button><div uib-collapse="!status.descriptionOpen"><div class="panel panel-default" style="margin: 0"><div class="panel-body"><div class="text-justify" ng-bind-html="renderHtml(vm.project.description)"></div></div></div></div></div><div style="margin-top: 10px"><button type="button" class="btn btn-default" ng-click="status.conditionsOpen = !status.conditionsOpen"><span class="glyphicon" ng-class="{\'glyphicon-chevron-down\': status.conditionsOpen, \'glyphicon-chevron-right\': !status.conditionsOpen}"></span> Bedingungen & Vereinbarungen</button><div uib-collapse="!status.conditionsOpen"><div class="panel panel-default" style="margin: 0"><div class="panel-body"><div class="text-justify" ng-bind-html="renderHtml(vm.project.conditions)"></div></div></div></div></div><hr><div class="row"><div class="col-sm-10">Ich akzeptiere die <a href="https://ask-ev.de/admin/kcfinder/upload/files/AGB.pdf" target="_blank">Allgemeinen Gesch&auml;ftsbedingungen</a> und willige ein, dass meine oben aufgef\xFChrten Daten gespeichert und verarbeitet werden.</div><div class="col-sm-1"><switch ng-model="vm.agb" class="green"></switch></div></div></div><div class="modal-footer"><div ng-if="!vm.project.bookingValid" class="alert alert-danger" role="alert" style="text-align: left">Deine <b>Daten</b> (siehe oben) sind <b>nicht aktuell.</b> Bitte aktualisiere sie zuerst in Deinem Profil, bevor Du Dich anmeldest.</div><div ng-if="vm.project.idNumber && !vm.project.checkIDNumberExpiration && (vm.project.idNumberValue !== null && vm.project.idNumberValue !== \'\')" class="alert alert-warning" role="alert" style="text-align: left">Dein angegebener <b>Ausweis l\xE4uft</b> vor Ende des Events <b>ab.</b> Du musst ihn daher bis <b>sp\xE4testens zwei Monate vor Beginn des Events aktualisieren.</b></div><button type="button" class="btn btn-default" data-dismiss="modal" ng-click="vm.clear()"><span class="glyphicon glyphicon-ban-circle"></span>&nbsp;<span data-translate="entity.action.cancel">Cancel</span></button> <button type="submit" ng-disabled="editForm.$invalid || vm.isSaving || !vm.project.bookingValid || !vm.agb" class="btn btn-info"><span class="glyphicon glyphicon-plus"></span>&nbsp;Verbindlich anmelden</button></div></form>');
$templateCache.put('app/member/projects/projects.html','<!--\n  ~ Copyright (c) 2017 by Julian Feder, julian.feder@yahoo.de\n  ~\n  ~ This product includes software developed at\n  ~ The Apache Software Foundation (http://www.apache.org/).\n  --><div><div class="row row-no-padding"><div class="col-md-9"><jhi-alert></jhi-alert><div ng-show="vm.type == \'event\' || vm.type == \'interest\'"><div class="panel panel-default"><div class="panel-heading"><h3 class="panel-title" data-translate="global.menu.event">Info</h3></div><div class="panel-body"><content-cms identifier="1"></content-cms></div></div></div><div ng-show="vm.type == \'course\' || vm.type == \'sbfPractical\' || vm.type == \'sksTrip\'"><div class="panel panel-default"><div class="panel-heading"><h3 class="panel-title" data-translate="global.menu.course">Info</h3></div><div class="panel-body"><content-cms identifier="2"></content-cms></div></div></div><div ng-show="vm.type == \'merchandise\'"><div class="panel panel-default"><div class="panel-heading"><h3 class="panel-title" data-translate="global.menu.merchandise">Info</h3></div><div class="panel-body"><content-cms identifier="15"></content-cms></div></div></div><div class="panel panel-default" ng-show="vm.overview.length > 0 && (vm.type == \'course\' || vm.type == \'sbfPractical\' || vm.type == \'sksTrip\')"><div class="panel-heading"><h3 class="panel-title">Termin\xFCbersicht</h3></div><div class="panel-body"><div ng-repeat="event in vm.overview track by event.name"><h4>{{event.name}}</h4><h5 ng-show="event.slots.length > 0"><span class="glyphicon glyphicon-calendar" aria-hidden="true"></span> Deine gebuchten Termine</h5><div ng-repeat="slot in event.slots"><ul style="margin-left: 0"><li><b ng-if="slot.fromTime > event.untilDate">Pr\xFCfung:</b> {{slot.fromTime | date:"EEEE, dd.MM.yyyy HH:mm"}} Uhr - {{slot.toTime | date:"HH:mm"}} Uhr</li></ul></div><span ng-show="event.placesToBook > 0" class="glyphicon glyphicon-exclamation-sign" aria-hidden="true"></span> <span ng-show="event.placesToBook == 1">Es muss noch {{event.placesToBook}} Termin von dir gebucht werden.</span> <span ng-show="event.placesToBook > 1">Es m\xFCssen noch {{event.placesToBook}} Termine von dir gebucht werden.</span><hr></div><div class="alert alert-info" role="alert" style="margin-bottom: 0">Gebuchte Termine sind verbindlich. Bei dringenden \xC4nderungen schreibe eine E-Mail an <a href="mailto:sbf@ask-ev.de">sbf@ask-ev.de</a>.</div></div></div><div class="panel panel-default" ng-show="vm.placesToBook && (vm.type == \'course\' || vm.type == \'sbfPractical\' || vm.type == \'sksTrip\')"><div class="panel-heading"><h3 class="panel-title">Terminbuchung</h3></div><div class="panel-body" ng-show="vm.events.length == 0"><div class="alert alert-danger" role="alert" style="margin-bottom: 0">Es gibt aktuell (noch) keine zu buchenden Termine. Bei dringenden Fragen schreibe eine E-Mail an <a href="mailto:sbf@ask-ev.de">sbf@ask-ev.de</a>.</div></div><div class="panel-body" ng-show="vm.events.length > 0"><div class="row"><div class="col-xs-6"><h2>{{vm.calendarTitle}}</h2></div><div class="col-xs-6"><div class="btn-group" style="float: right"><button class="btn btn-primary" mwl-date-modifier date="vm.viewDate" decrement="vm.calendarView"><span class="glyphicon glyphicon-chevron-left"></span></button> <button class="btn btn-default" mwl-date-modifier date="vm.viewDate" set-to-today>Heute</button> <button class="btn btn-primary" mwl-date-modifier date="vm.viewDate" increment="vm.calendarView"><span class="glyphicon glyphicon-chevron-right"></span></button></div></div></div><mwl-calendar view="vm.calendarView" view-date="vm.viewDate" events="vm.events" view-title="vm.calendarTitle" on-event-click="vm.sbfClicked(calendarEvent)" on-view-change-click="false" on-event-times-changed="calendarEvent.startsAt = calendarNewEventStart; calendarEvent.endsAt = calendarNewEventEnd" cell-is-open="true"></mwl-calendar></div></div><div class="btn-group" style="margin-bottom: 20px" ng-show="vm.type == \'course\' || vm.type == \'sbfPractical\' || vm.type == \'sksTrip\'"><!--<button type="submit"\n                        ng-click="vm.currentSearch == null && vm.setType(\'all\')"\n                        class="btn btn-default btn-md"\n                        ng-class="{active: vm.type == \'all\' && vm.currentSearch == null}"\n                        ng-disabled="vm.currentSearch != null || vm.select">\n                    <span class="hidden-sm-down">Alle</span>\n                </button>--> <button type="submit" ng-click="vm.currentSearch == null && vm.setType(\'course\')" class="btn btn-default btn-md" ng-class="{active: vm.type == \'course\' && vm.currentSearch == null}" ng-disabled="vm.currentSearch != null || vm.select"><span class="hidden-sm-down">Kurse</span></button> <button type="submit" ng-click="vm.currentSearch == null && vm.setType(\'sbfPractical\')" class="btn btn-default btn-md" ng-class="{active: vm.type == \'sbfPractical\' && vm.currentSearch == null}" ng-disabled="vm.currentSearch != null || vm.select"><span class="hidden-sm-down">SBF-See Praxisausbildung</span></button> <button type="submit" ng-click="vm.currentSearch == null && vm.setType(\'sksTrip\')" class="btn btn-default btn-md" ng-class="{active: vm.type == \'sksTrip\' && vm.currentSearch == null}" ng-disabled="vm.currentSearch != null || vm.select"><span class="hidden-sm-down">SKS Praxisausbildung</span></button></div><div class="btn-group" style="margin-bottom: 20px" ng-show="vm.type == \'event\' || vm.type == \'interest\'"><button type="submit" ng-click="vm.currentSearch == null && vm.setType(\'event\')" class="btn btn-default btn-md" ng-class="{active: vm.type == \'event\' && vm.currentSearch == null}" ng-disabled="vm.currentSearch != null || vm.select"><span class="hidden-sm-down">Events</span></button> <button type="submit" ng-click="vm.currentSearch == null && vm.setType(\'interest\')" class="btn btn-default btn-md" ng-class="{active: vm.type == \'interest\' && vm.currentSearch == null}" ng-disabled="vm.currentSearch != null || vm.select"><span class="hidden-sm-down">Interessensbekundungen</span></button></div><div class="alert alert-info" role="alert" ng-show="vm.projects.length == 0 && vm.type == \'event\'">Zur Zeit gibt es keine Events, f\xFCr die du dich anmelden kannst.</div><div class="alert alert-info" role="alert" ng-show="vm.projects.length == 0 && vm.type == \'course\'">Zur Zeit gibt es keine Kurse, f\xFCr die du dich anmelden kannst.</div><div class="alert alert-info" role="alert" ng-show="vm.projects.length == 0 && vm.type == \'sbfPractical\'">Zur Zeit gibt es keine SBF-See Praxisausbildung, f\xFCr die du dich anmelden kannst.</div><div class="alert alert-info" role="alert" ng-show="vm.projects.length == 0 && vm.type == \'sksTrip\'">Zur Zeit gibt es keine SKS-T\xF6rns, f\xFCr die du dich anmelden kannst.</div><div class="alert alert-info" role="alert" ng-show="vm.projects.length == 0 && vm.type == \'interest\'">Zur Zeit gibt es keine Interessensbekundungen, f\xFCr die du dich anmelden kannst.</div><div class="alert alert-info" role="alert" ng-show="vm.projects.length == 0 && vm.type == \'merchandise\'">Zur Zeit gibt es keinen Merchandise zu kaufen.</div><uib-accordion close-others="true" ng-show="vm.projects.length >= 1"><div ng-repeat="project in vm.projects track by project.id"><div uib-accordion-group class="panel-default" style="margin-bottom: 10px" is-open="status.open"><div uib-accordion-heading><button type="submit" ui-sref="project.book({id:project.id})" ng-disabled="project.remainingPlaces == 0" ng-click="$event.stopPropagation();" class="btn btn-info btn-sm pull-right" style="margin-top:-6px" ng-show="project.status == null"><span class="glyphicon glyphicon-plus"></span> <span class="hidden-sm-down">Anmelden</span></button> <button type="submit" ui-sref="member.booking" ng-click="$event.stopPropagation();" class="btn btn-sm pull-right" ng-class="{\'btn-success\': project.status == \'angemeldet\', \'btn-warning\': project.status == \'warteliste\', \'btn-danger\': project.status == \'zurueckgetreten\' || project.status == \'abgelehnt\'}" style="margin-top:-6px" ng-show="project.status != null"><span class="glyphicon glyphicon-ok" ng-show="project.status == \'angemeldet\'"></span> <span class="hidden-sm-down" data-translate="{{\'askApp.EnumBookingStatusType.\' + project.status}}"></span></button><!-- ng-hide: project.remainingPlaces >= 200 || (project.fromDate < vm.today && project.status != null) --><!-- ng-hide: project.remainingPlaces >= 200 || !project.visible --> <span ng-show="project.remainingPlaces < 200 && project.visible"><span class="badge pull-right" style="margin-right: 10px" ng-show="project.remainingPlaces == 1">{{project.remainingPlaces}} freier Platz</span> <span class="badge pull-right" style="margin-right: 10px" ng-show="project.remainingPlaces > 1">{{project.remainingPlaces}} freie Pl\xE4tze</span> <span class="badge pull-right" style="margin-right: 10px" ng-show="project.remainingPlaces == -1">Warteliste</span> <span class="badge pull-right" style="margin-right: 10px" ng-show="project.remainingPlaces == 0">Kein Platz mehr verf\xFCgbar</span> </span><i class="glyphicon" ng-class="{\'glyphicon-chevron-down\': status.open, \'glyphicon-chevron-right\': !status.open}"></i> {{project.name}} <small>{{project.fromDate | date:\'mediumDate\'}} - {{project.untilDate | date:\'mediumDate\'}}</small></div><div class="row"><div class="col-md-4 projectInfos"><a ng-click="openLightboxModal(0, \'data:\' + project.imageContentType + \';base64,\' + project.image)" class="thumbnail" ng-show="project.image != null"><img data-ng-src="{{\'data:\' + project.imageContentType + \';base64,\' + project.image}}" alt="project image"></a><table><tr><td style="font-weight: bold; width: 130px">Start:&nbsp</td><td><span class="label label-info">{{project.fromDate | date:\'mediumDate\'}}</span></td></tr><tr><td style="font-weight: bold">Ende:&nbsp</td><td><span class="label label-info">{{project.untilDate | date:\'mediumDate\'}}</span></td></tr><tr ng-show="project.type != \'interest\'"><td style="font-weight: bold">Normalpreis:&nbsp</td><td><span class="label label-info">{{project.normalPrice}}\u20AC</span></td></tr><tr ng-show="project.type != \'interest\'"><td style="font-weight: bold">Studentenpreis:&nbsp</td><td><span class="label label-info">{{project.studentPrice}}\u20AC</span></td></tr><tr ng-show="project.guest"><td style="font-weight: bold">Gastpreis:&nbsp</td><td><span class="label label-info">{{project.guestPrice}}\u20AC</span></td></tr><tr ng-show="project.type != \'sksTrip\'"><td style="font-weight: bold">Projektleiter:&nbsp</td><td><span class="label label-info">{{project.managerName}}</span></td></tr><tr ng-show="project.type != \'sksTrip\'"><td style="font-weight: bold">Kontaktmail:&nbsp</td><td><a href="mailto:{{project.managerMail}}?subject=Frage zu {{project.name}}">{{project.managerMail}}<a></a></td></tr><tr ng-show="project.type == \'sksTrip\'"><td style="font-weight: bold">Pr\xFCfungsort:&nbsp</td><td><span class="label label-info" data-translate="{{\'askApp.EnumSksPracticalLocation.\' + project.sksPracticalLocation}}"></span></td></tr><tr ng-show="project.type == \'sksTrip\'"><td style="font-weight: bold">Skipper:&nbsp</td><td><span class="label label-info">{{project.skipperName}}</span></td></tr><tr ng-show="project.type == \'sksTrip\'"><td style="font-weight: bold">T\xF6rn findet statt:&nbsp</td><td><span class="label label-success" ng-show="project.booked">Ja</span> <span class="label label-danger" ng-show="!project.booked">Nein</span> <span style="cursor: pointer" class="glyphicon glyphicon-exclamation-sign" aria-hidden="true" uib-popover="Es fehlen noch Anmeldungen damit der T\xF6rn stattfinden kann." popover-trigger="mouseenter" popover-placement="auto" popover-append-to-body="true" ng-show="!project.booked"></span></td></tr><tr ng-show="project.type == \'sksTrip\' && project.participantNames.length > 0"><td style="font-weight: bold">Teilnehmer:&nbsp</td><td><span class="label label-info" style="margin-right: 3px; display: inline-block" ng-repeat="participant in project.participantNames track by $index">{{participant}}</span></td></tr></table></div><div class="col-md-8"><h2 style="margin-top:0">{{project.name}}</h2><div class="text-justify" ng-bind-html="renderHtml(project.description)"></div><div style="margin-top: 10px"><button type="button" class="btn btn-default" ng-click="status.conditionsOpen = !status.conditionsOpen"><span class="glyphicon" ng-class="{\'glyphicon-chevron-down\': status.conditionsOpen, \'glyphicon-chevron-right\': !status.conditionsOpen}"></span> Bedingungen & Vereinbarungen</button><div uib-collapse="!status.conditionsOpen"><div class="panel panel-default" style="margin: 0"><div class="panel-body"><div class="text-justify" ng-bind-html="renderHtml(project.conditions)"></div></div></div></div></div></div></div></div></div></uib-accordion></div><div class="col-md-3"><div class="panel panel-default"><div class="panel-heading"><h3 class="panel-title">Info</h3></div><div class="panel-body" ng-show="vm.type == \'event\' || vm.type == \'interest\'"><content-cms identifier="3"></content-cms></div><div class="panel-body" ng-show="vm.type == \'course\' || vm.type == \'sbfPractical\' || vm.type == \'sksTrip\' || vm.type == \'merchandise\'"><content-cms identifier="13"></content-cms></div></div></div></div></div>');
$templateCache.put('app/account/reset/finish/reset.finish.html','<!--\n  ~ Copyright (c) 2017 by Julian Feder, julian.feder@yahoo.de\n  ~\n  ~ This product includes software developed at\n  ~ The Apache Software Foundation (http://www.apache.org/).\n  --><div><div class="row row-no-padding"><div class="col-md-6 col-md-offset-3"><div class="panel panel-default"><div class="panel-heading"><h3 class="panel-title" data-translate="reset.finish.title">Reset password</h3></div><div class="panel-body"><div class="alert alert-danger" data-translate="reset.finish.messages.keymissing" ng-show="vm.keyMissing"><strong>The password reset key is missing.</strong></div><div class="alert alert-warning" ng-hide="vm.success || vm.keyMissing"><p data-translate="reset.finish.messages.info">Choose a new password</p></div><div class="alert alert-danger" ng-show="vm.error"><p data-translate="reset.finish.messages.error">Your password couldn\'t be reset. Remember a password request is only valid for 24 hours.</p></div><div class="alert alert-success" ng-show="vm.success"><p data-translate="reset.finish.messages.success" translate-compile><strong>Your password has been reset.</strong> Please <a class="alert-link" href="" ng-click="vm.login()">sign in</a>.</p></div><div class="alert alert-danger" ng-show="vm.doNotMatch" data-translate="global.messages.error.dontmatch">The password and its confirmation do not match!</div><div ng-hide="vm.keyMissing"><form ng-show="!vm.success" name="form" role="form" novalidate ng-submit="vm.finishReset()" show-validation><div class="form-group"><label class="control-label" for="password" data-translate="global.form.newpassword">New password</label><input type="password" class="form-control" id="password" name="password" placeholder="{{\'global.form.newpassword.placeholder\' | translate}}" ng-model="vm.resetAccount.password" ng-minlength="4" ng-maxlength="50" required><div ng-show="form.password.$dirty && form.password.$invalid"><p class="help-block" ng-show="form.password.$error.required" data-translate="global.messages.validate.newpassword.required">Your password is required.</p><p class="help-block" ng-show="form.password.$error.minlength" data-translate="global.messages.validate.newpassword.minlength">Your password is required to be at least 4 characters.</p><p class="help-block" ng-show="form.password.$error.maxlength" data-translate="global.messages.validate.newpassword.maxlength">Your password cannot be longer than 50 characters.</p></div><password-strength-bar password-to-check="vm.resetAccount.password"></password-strength-bar></div><div class="form-group"><label class="control-label" for="confirmPassword" data-translate="global.form.confirmpassword">New password confirmation</label><input type="password" class="form-control" id="confirmPassword" name="confirmPassword" placeholder="{{\'global.form.confirmpassword.placeholder\' | translate}}" ng-model="vm.confirmPassword" ng-minlength="4" ng-maxlength="50" required><div ng-show="form.confirmPassword.$dirty && form.confirmPassword.$invalid"><p class="help-block" ng-show="form.confirmPassword.$error.required" data-translate="global.messages.validate.confirmpassword.required">Your password confirmation is required.</p><p class="help-block" ng-show="form.confirmPassword.$error.minlength" data-translate="global.messages.validate.confirmpassword.minlength">Your password confirmation is required to be at least 4 characters.</p><p class="help-block" ng-show="form.confirmPassword.$error.maxlength" data-translate="global.messages.validate.confirmpassword.maxlength">Your password confirmation cannot be longer than 50 characters.</p></div></div><button type="submit" ng-disabled="form.$invalid" class="btn btn-primary" data-translate="reset.finish.form.button">Reset Password</button></form></div></div></div></div></div></div>');
$templateCache.put('app/account/reset/request/reset.request.html','<!--\n  ~ Copyright (c) 2017 by Julian Feder, julian.feder@yahoo.de\n  ~\n  ~ This product includes software developed at\n  ~ The Apache Software Foundation (http://www.apache.org/).\n  --><div><div class="row row-no-padding"><div class="col-md-6 col-md-offset-3"><div class="panel panel-default"><div class="panel-heading"><h3 class="panel-title" data-translate="reset.request.title">Reset your password</h3></div><div class="panel-body"><div class="alert alert-danger" data-translate="reset.request.messages.notfound" ng-show="vm.errorEmailNotExists"><strong>Email address isn\'t registered!</strong> Please check and try again.</div><div class="alert alert-warning" ng-hide="vm.success"><p data-translate="reset.request.messages.info">Enter the email address you used to register.</p></div><div class="alert alert-success" ng-show="vm.success == \'OK\'"><p data-translate="reset.request.messages.success">Check your emails for details on how to reset your password.</p></div><form ng-show="!vm.success" name="form" role="form" novalidate ng-submit="vm.requestReset()" show-validation><div class="form-group"><label class="control-label" for="email" data-translate="global.form.email">Email</label><input type="email" class="form-control" id="email" name="email" placeholder="{{\'global.form.email.placeholder\' | translate}}" ng-model="vm.resetAccount.email" ng-minlength="5" ng-maxlength="100" required><div ng-show="form.email.$dirty && form.email.$invalid"><p class="help-block" ng-show="form.email.$error.required" data-translate="global.messages.validate.email.required">Your email is required.</p><p class="help-block" ng-show="form.email.$error.email" data-translate="global.messages.validate.email.invalid">Your email is invalid.</p><p class="help-block" ng-show="form.email.$error.minlength" data-translate="global.messages.validate.email.minlength">Your email is required to be at least 5 characters.</p><p class="help-block" ng-show="form.email.$error.maxlength" data-translate="global.messages.validate.email.maxlength">Your email cannot be longer than 100 characters.</p></div></div><button type="submit" ng-disabled="form.$invalid" class="btn btn-primary" data-translate="reset.request.form.button">Reset</button></form></div></div></div></div></div>');
$templateCache.put('app/board/dinghy/bookings/dinghy-booking-delete-dialog.html','<!--\n  ~ Copyright (c) 2020 by Felix Heim, felix-heim@web.de\n  ~\n  ~ This product includes software developed at\n  ~ The Apache Software Foundation (http://www.apache.org/).\n  --><form name="deleteForm" ng-submit="vm.confirmDelete(vm.booking.id)"><div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()">&times;</button><h4 class="modal-title" data-translate="entity.delete.title">Confirm delete operation</h4></div><div class="modal-body"><jhi-alert-error></jhi-alert-error><p data-translate="askApp.dinghyBooking.delete.question" translate-value-id="{{vm.booking.id}}" translate-value-first-name="{{vm.booking.profile.firstName}}" translate-value-last-name="{{vm.booking.profile.lastName}}" translate-value-nickname="{{vm.nickname}}" translate-value-event-name="{{vm.booking.eventName}}" translate-value-event-info="{{vm.booking.fromDate | date:\'shortDate\'}} {{\'askApp.EnumDinghyEventType.\' + vm.booking.eventType | translate}}">Are you sure you want to delete this Booking?</p><p ng-if="vm.booking.profile.id" data-translate="askApp.dinghyBooking.delete.warning"></p></div><div class="modal-footer"><button type="button" class="btn btn-default" data-dismiss="modal" ng-click="vm.clear()"><span class="glyphicon glyphicon-ban-circle"></span>&nbsp;<span data-translate="entity.action.cancel">Cancel</span></button> <button type="submit" ng-disabled="deleteForm.$invalid" class="btn btn-danger"><span class="glyphicon glyphicon-remove-circle"></span>&nbsp;<span data-translate="entity.action.delete">Delete</span></button></div></form>');
$templateCache.put('app/board/dinghy/bookings/dinghy-booking-dialog.html','<!--\n  ~ Copyright (c) 2020 by Felix Heim, felix-heim@web.de\n  ~\n  ~ This product includes software developed at\n  ~ The Apache Software Foundation (http://www.apache.org/).\n  --><form name="editForm" role="form" novalidate ng-submit="vm.save()" show-validation><div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()">&times;</button><h4 class="modal-title" id="myBookingLabelEdit" data-translate="askApp.dinghyBooking.home.editLabel" translate-value-first-name="{{vm.booking.profile.firstName}}" translate-value-last-name="{{vm.booking.profile.lastName}}" translate-value-event-name="{{vm.booking.eventName}}" translate-value-nickname="{{vm.nickname}}">Create or edit a Booking</h4></div><div class="modal-body"><jhi-alert-error></jhi-alert-error><div ng-if="!vm.booking.profile.id"><!--------------------><!----- Firstname ----><!--------------------><div class="form-group"><label class="control-label" for="firstName" data-translate="settings.form.firstname">First Name</label><input type="text" class="form-control" id="firstName" name="firstName" placeholder="{{\'settings.form.firstname\' | translate}}" ng-model="vm.booking.profile.firstName" ng-minlength="1" ng-maxlength="50" required maxlength="50" prevent-enter-submit><div ng-show="(vm.isNewBooking || editForm.firstName.$dirty) && editForm.firstName.$invalid"><p class="help-block" ng-show="editForm.firstName.$error.required" data-translate="entity.validation.required">This field is required.</p><p class="help-block" ng-show="editForm.firstName.$error.minlength" data-translate="entity.validation.minlength" translate-value-min="1">Your mobile phone is required to be at least 1 characters.</p><p class="help-block" ng-show="v.firstName.$error.maxlength" data-translate="entity.validation.maxlength" translate-value-max="50">Your mobile phone cannot be longer than 50 characters.</p></div></div><!--------------------><!----- Lastname -----><!--------------------><div class="form-group"><label class="control-label" for="lastName" data-translate="settings.form.lastname">Last Name</label><input type="text" class="form-control" id="lastName" name="lastName" placeholder="{{\'settings.form.lastname\' | translate}}" ng-model="vm.booking.profile.lastName" ng-minlength="1" ng-maxlength="50" required maxlength="50" prevent-enter-submit><div ng-show="(vm.isNewBooking || editForm.lastName.$dirty) && editForm.lastName.$invalid"><p class="help-block" ng-show="editForm.lastName.$error.required" data-translate="entity.validation.required">This field is required.</p><p class="help-block" ng-show="editForm.lastName.$error.minlength" data-translate="entity.validation.minlength" translate-value-min="1">Your mobile phone is required to be at least 1 characters.</p><p class="help-block" ng-show="editForm.lastName.$error.maxlength" data-translate="entity.validation.maxlength" translate-value-max="50">Your mobile phone cannot be longer than 50 characters.</p></div></div><!--------------------><!-------- Mail ------><!--------------------><div class="form-group"><label class="control-label" for="field_mail" data-translate="global.form.email">Email</label><input type="email" class="form-control" id="field_mail" name="mail" placeholder="{{\'global.form.email\' | translate}}" ng-model="vm.booking.profile.mail" ng-minlength="5" ng-maxlength="50" required maxlength="50" prevent-enter-submit><div ng-show="(vm.isNewBooking || editForm.mail.$dirty) && editForm.mail.$invalid"><p class="help-block" ng-show="editForm.mail.$error.required" data-translate="entity.validation.required">This field is required.</p><p class="help-block" ng-show="editForm.mail.$error.email" data-translate="entity.validation.invalid">Your mobile phone does not math the E.164 format for phone numbers.</p><p class="help-block" ng-show="editForm.mail.$error.minlength" data-translate="entity.validation.minlength" translate-value-min="5">Your mobile phone is required to be at least 5 characters.</p><p class="help-block" ng-show="editForm.mail.$error.maxlength" data-translate="entity.validation.maxlength" translate-value-min="50">Your mobile phone cannot be longer than 15 characters.</p></div></div></div><!--------------------><!-- Booking Status --><!--------------------><hr ng-if="!vm.isNewBooking && !vm.booking.profile.id"><div class="form-group" ng-if="!vm.isNewBooking"><label class="control-label" data-translate="askApp.booking.status" for="field_status">Status</label><select class="form-control" name="bookingStatus" ng-model="vm.booking.bookingStatus" id="field_status"><option value="angemeldet" data-translate="askApp.EnumBookingStatusType.angemeldet">angemeldet</option><option value="warteliste" data-translate="askApp.EnumBookingStatusType.warteliste">warteliste</option><option value="abgelehnt" data-translate="askApp.EnumBookingStatusType.abgelehnt">abgelehnt</option><option value="zurueckgetreten" data-translate="askApp.EnumBookingStatusType.zurueckgetreten">zurueckgetreten</option></select></div><!--------------------><!---- Send Mail -----><!--------------------><div ng-show="vm.booking.bookingStatus != vm.oldBookingStatus && !vm.isNewBooking"><label class="control-label"><span ng-if="vm.booking.profile.id">Mitglied</span><span ng-if="!vm.booking.profile.id">Person</span> per E-Mail &uuml;ber die Status&auml;nderung informieren</label><br><switch ng-model="vm.booking.sendNotificationMail" class="green"></switch><div class="form-group" ng-show="vm.booking.sendNotificationMail"><label class="control-label" data-translate="askApp.booking.managerComment" for="field_managerComment">Comment</label><input type="text" class="form-control" name="managerComment" id="field_managerComment" ng-model="vm.booking.managerComment" ng-maxlength="250" prevent-enter-submit><div ng-show="editForm.managerComment.$dirty && editForm.managerComment.$invalid"><p class="help-block" ng-show="editForm.managerComment.$error.maxlength" data-translate="entity.validation.maxlength" translate-value-max="250">This field cannot be longer than 250 characters.</p></div></div></div><!--------------------><!--- Change Info  ---><!--------------------><div ng-if="!vm.isNewBooking && vm.booking.profile.id && vm.booking.price && vm.booking.price > 0" class="alert alert-info" data-translate="askApp.dinghyBooking.infoStatusChangeMemberPayed"></div><div ng-if="!vm.isNewBooking && vm.booking.profile.id && (!vm.booking.price || vm.booking.price == 0)" class="alert alert-info" data-translate="askApp.dinghyBooking.infoStatusChangeMemberFree"></div><!--------------------><!----- Comment  -----><!--------------------><hr ng-if="vm.isNewBooking || !vm.booking.profile.id"><div class="form-group"><label class="control-label" data-translate="askApp.booking.comment" for="field_comment">Comment</label><input type="text" class="form-control" name="comment" id="field_comment" ng-model="vm.booking.comment" ng-maxlength="250" prevent-enter-submit><div ng-show="editForm.comment.$dirty && editForm.comment.$invalid"><p class="help-block" ng-show="editForm.comment.$error.maxlength" data-translate="entity.validation.maxlength" translate-value-max="250">This field cannot be longer than 250 characters.</p></div></div><!--------------------><!-- individ. Ques. --><!--------------------><div class="form-group" ng-show="vm.booking.individualQuestion !== null"><label class="control-label" for="field_individualQuestionAnswer">{{vm.booking.individualQuestion}}</label><input type="text" class="form-control" name="individualQuestionAnswer" id="field_individualQuestionAnswer" ng-model="vm.booking.individualQuestionAnswer" ng-maxlength="250" prevent-enter-submit ng-required="vm.booking.individualQuestion != null && vm.booking.individualQuestion != \'\'"><div ng-show="(vm.isNewBooking || editForm.individualQuestionAnswer.$dirty) && editForm.individualQuestionAnswer.$invalid"><p class="help-block" ng-show="editForm.individualQuestionAnswer.$error.maxlength" data-translate="entity.validation.maxlength" translate-value-max="250">This field cannot be longer than 150 characters.</p><p class="help-block" ng-show="editForm.individualQuestionAnswer.$error.required" data-translate="entity.validation.required">This field is required.</p></div></div><!--------------------><!----- dinghies -----><!--------------------><hr ng-show="vm.booking.availableDinghies && vm.booking.availableDinghies.length > 0"><div class="form-group" ng-show="vm.booking.availableDinghies && vm.booking.availableDinghies.length > 0"><label class="control-label" for="field_dinghy">Jolle w\xE4hlen <small>(leerlassen falls Privatboot und im Kommentar spezifizieren)</small></label><select class="form-control" id="field_dinghy" name="dinghy" ng-model="vm.booking.dinghy" ng-options="dinghy as (dinghy.name + \' (\' + dinghy.type + \')\') for dinghy in vm.booking.availableDinghies track by dinghy.id" ng-disabled="vm.disableEdit"><option value=""></option></select></div><!--------------------><!-- dinghy comment --><!--------------------><div class="form-group" ng-show="vm.booking.availableDinghies && vm.booking.availableDinghies.length > 0"><label class="control-label" for="field_commentDinghy">Kommentar zur Jollenwahl</label><input type="text" class="form-control" name="commentDinghy" id="field_commentDinghy" ng-model="vm.booking.commentDinghy" ng-maxlength="150" prevent-enter-submit ng-required="vm.booking.availableDinghies && vm.booking.availableDinghies.length > 0 && !vm.booking.dinghy" ng-disabled="vm.disableEdit"><div ng-show="editForm.commentDinghy.$invalid"><p class="help-block" ng-show="editForm.commentDinghy.$error.maxlength" data-translate="entity.validation.maxlength" translate-value-max="150">This field cannot be longer than 150 characters.</p><p class="help-block" ng-show="editForm.commentDinghy.$error.required" data-translate="entity.validation.required">This field is required.</p></div></div></div><div class="modal-footer"><button type="button" class="btn btn-default" data-dismiss="modal" ng-click="vm.clear()"><span class="glyphicon glyphicon-ban-circle"></span>&nbsp;<span data-translate="entity.action.cancel">Cancel</span></button> <button type="submit" ng-disabled="editForm.$invalid || vm.isSaving" class="btn btn-primary"><span class="glyphicon glyphicon-save"></span>&nbsp;<span data-translate="entity.action.save">Save</span></button></div></form>');
$templateCache.put('app/board/dinghy/bookings/dinghy-bookings.html','<!--\n  ~ Copyright (c) 2020 by Felix Heim, felix-heim@web.de\n  ~\n  ~ This product includes software developed at\n  ~ The Apache Software Foundation (http://www.apache.org/).\n  --><div><div class="row row-no-padding"><div class="col-xs-12"><div class="panel panel-default"><div class="panel-heading"><h3 class="panel-title" data-translate="askApp.dinghyBooking.home.title">DinghyBookings</h3></div><div class="panel-body"><jhi-alert></jhi-alert><div class="container-fluid"><div class="row"><div class="col-xs-12 col-sm-6 no-padding-left"><button class="btn btn-primary" ng-click="vm.refresh()" ng-disabled="vm.isSaving"><span class="glyphicon glyphicon-refresh"></span> <span class="hidden-xs-down">Neu laden</span></button></div><div class="col-xs-12 col-sm-3 no-padding-right no-padding-left"><input type="text" ng-model="vm.selected" placeholder="Suche Mitglied" uib-typeahead="profile as (profile.user.firstName + \' \' + profile.user.lastName + (profile.nickname ? (\' &quot;\' + profile.nickname + \'&quot;\') : (\'\'))) for profile in vm.getUser($viewValue)" typeahead-loading="loadingLocations" typeahead-no-results="noResults" typeahead-on-select="vm.selectUser($item, $model, $label, $event)" ng-disabled="vm.currentSearch != null" class="form-control" autocomplete="off"></div><div class="col-xs-12 col-sm-3 no-padding-right no-padding-left-xs"><form name="searchForm" class="form-inline"><div class="input-group pull-right"><input type="text" class="form-control" ng-model="vm.searchQuery" id="searchQuery" placeholder="{{ \'askApp.booking.home.search\' | translate }}"> <span class="input-group-btn width-min"><button class="btn btn-info" ng-click="vm.search(vm.searchQuery)"><span class="glyphicon glyphicon-search"></span></button> </span><span class="input-group-btn width-min" ng-if="vm.currentSearch || vm.select"><button class="btn btn-info" ng-click="vm.clear()"><span class="glyphicon glyphicon-trash"></span></button></span></div></form></div></div></div><br><div class="alert alert-info" role="alert" ng-show="vm.bookings.length == 0"><b>Keine Daten vorhanden!</b> F\xFCr diese Auswahl existieren keine Buchungen.</div><div class="table-responsive" ng-show="vm.bookings.length > 0"><table class="jh-table table table-striped"><thead><tr jh-sort="vm.predicate" ascending="vm.reverse" callback="vm.transition()"><th jh-sort-by="validationDate"><span data-translate="askApp.booking.date">Date</span> <span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="profile.user.firstName"><span>Mitglied</span> <span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="bookingStatus"><span>Status</span> <span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="dept.paymentStatus"><span>Bezahlt?</span> <span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="comment"><span>Kommentar</span> <span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="dinghy"><span>Jolle</span> <span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="event.fromDate"><span data-translate="askApp.dinghyBooking.event">Event</span> <span class="glyphicon glyphicon-sort"></span></th><th></th></tr></thead><tbody><tr ng-repeat="booking in vm.bookings track by booking.id"><td><span aria-hidden="true" popover-trigger="mouseenter" uib-popover-template="\'popover-fromDate.html\'" style="cursor: pointer">{{booking.bookingDate | date:\'dd.MM.\'}}</span></td><td><span ng-show="vm.isBoard && booking.profile.id"><a ui-sref="member-management-detail({id:booking.profile.id})">{{booking.profile.firstName}} {{booking.profile.lastName}}</a></span> <span ng-show="!vm.isBoard || !booking.profile.id">{{booking.profile.firstName}} {{booking.profile.lastName}}</span> <span ng-if="booking.profile.nickname" class="glyphicon glyphicon-info-sign" aria-hidden="true" popover-trigger="mouseenter" uib-popover="{{booking.profile.nickname}}" style="cursor: pointer"></span> <a href="mailto:{{booking.profile.mail}}"><span class="glyphicon glyphicon glyphicon glyphicon-envelope" uib-popover="{{booking.profile.mail}}" popover-trigger="mouseenter"></span> </a><a href="tel:{{booking.profile.phone}}" ng-if="booking.profile.phone"><span class="glyphicon glyphicon glyphicon-phone" style="cursor: pointer" uib-popover="{{booking.profile.phone}}" popover-trigger="mouseenter"></span></a></td><td style="text-align: center"><span class="dot" ng-class="{\'label-success\': booking.bookingStatus == \'angemeldet\', \'label-danger\': booking.bookingStatus == \'zurueckgetreten\' || booking.bookingStatus == \'abgelehnt\', \'label-warning\': booking.bookingStatus == \'warteliste\'}" aria-hidden="true" popover-trigger="mouseenter" uib-popover-template="\'popover-bookingStatus.html\'" style="cursor: pointer"></span></td><td ng-if="booking.deptId"><span class="dot" ng-class="{\'label-success\': booking.paymentStatus == \'payed\', \'label-danger\': booking.paymentStatus == \'pending\' || booking.paymentStatus == \'payedToMuch\', \'label-warning\': booking.paymentStatus == \'partial\' || booking.paymentStatus == \'prePayed\'}" aria-hidden="true" popover-trigger="mouseenter" uib-popover-template="\'popover-paymentStatus.html\'" style="cursor: pointer"></span> <span class="glyphicon glyphicon-info-sign" aria-hidden="true" popover-trigger="mouseenter" popover-title="Bezahlstatus" uib-popover-template="\'popover-partial.html\'" style="cursor: pointer"></span> <a ui-sref="board.dinghy.booking.edit-dept({deptId: booking.deptId})" has-authority="ROLE_FINANCE"><span class="glyphicon glyphicon-pencil"></span></a> <a ui-sref="board.dinghy.booking.new-dept({eventId: booking.eventId, userId: booking.profile.id})" has-authority="ROLE_FINANCE" ng-if="!booking.eventClosed"><span class="glyphicon glyphicon-plus"></span></a></td><td ng-if="!booking.deptId"><span class="label label-info">Extern</span></td><td style="text-align: center"><span style="cursor: pointer" class="glyphicon glyphicon-comment" aria-hidden="true" uib-popover="{{booking.comment}}" popover-trigger="mouseenter" ng-show="booking.comment"></span> <span class="glyphicon glyphicon-remove" aria-hidden="true" ng-show="!booking.comment" popover-append-to-body="true"></span> <span class="glyphicon glyphicon-comment" ng-show="booking.individualQuestionAnswer" aria-hidden="true" popover-trigger="mouseenter" popover-title="{{booking.individualQuestion}}" uib-popover-template="\'popover-individualQuestion.html\'" style="cursor: pointer" popover-append-to-body="true"></span> <span class="glyphicon glyphicon-remove" aria-hidden="true" ng-show="!booking.individualQuestionAnswer && booking.individualQuestion"></span></td><td><a ng-if="booking.dinghy" ui-sref="board.dinghy.dinghy.edit({id: booking.dinghy.id})">{{booking.dinghy.name}}</a> <span class="glyphicon glyphicon-remove" aria-hidden="true" ng-if="!booking.dinghy" popover-append-to-body="true"></span> <span style="cursor: pointer" class="glyphicon glyphicon-comment" aria-hidden="true" uib-popover="{{booking.commentDinghy}}" popover-trigger="mouseenter" ng-show="booking.commentDinghy"></span></td><td><a ui-sref="board.dinghy.event.detail.overview({id: booking.eventId})">{{booking.fromDate | date:\'shortDate\'}} {{\'askApp.EnumDinghyEventType.\' + booking.eventType | translate}}</a> <span class="glyphicon glyphicon-info-sign" aria-hidden="true" uib-popover="{{booking.eventName}}" popover-trigger="mouseenter" style="cursor: pointer"></span></td><td class="text-right"><div class="btn-group flex-btn-group-container"><button type="submit" ui-sref="board.dinghy.booking.edit({id:booking.id})" class="btn btn-primary btn-xs"><span class="glyphicon glyphicon-pencil"></span></button> <button type="submit" ui-sref="board.dinghy.booking.delete({id:booking.id})" ng-disabled="booking.payments.length > 0" class="btn btn-danger btn-xs"><span class="glyphicon glyphicon-remove-circle"></span></button></div></td></tr></tbody></table></div></div></div><div class="text-center" ng-show="vm.bookings.length > 0"><jhi-item-count page="vm.page" total="vm.queryCount" items-per-page="vm.itemsPerPage"></jhi-item-count><uib-pagination class="pagination-sm" total-items="vm.totalItems" items-per-page="vm.itemsPerPage" ng-model="vm.page" ng-change="vm.transition()"></uib-pagination></div></div></div></div><script type="text/ng-template" id="popover-individualQuestion.html"><span>\n        {{booking.individualQuestionAnswer}}\n    </span></script><script type="text/ng-template" id="popover-partial.html"><div class="form-group">\n        <table>\n            <tr>\n                <td>Originalpreis:</td>\n                <td>{{booking.price | number:2}}\u20AC</td>\n            </tr>\n            <tr>\n                <td>Forderungsbetrag:</td>\n                <td>{{booking.amount | number:2}}\u20AC</td>\n            </tr>\n            <tr>\n                <td style="width: 150px;">Aktivit\xE4tenpunkte:</td>\n                <td>{{booking.apCount}}</td>\n            </tr>\n            <tr>\n                <td>Soll:</td>\n                <td>{{booking.priceNet | number:2}}\u20AC</td>\n            </tr>\n            <tr ng-repeat="payment in booking.payments">\n                <td>{{payment.date | date:\'dd.MM.yyyy\'}}:</td>\n                <td>{{payment.amount | number:2}}\u20AC</td>\n            </tr>\n            <tr>\n                <td>Ist:</td>\n                <td>{{booking.payed | number:2}}\u20AC</td>\n            </tr>\n            <tr>\n                <td colspan="2">\n                    <hr>\n                </td>\n            </tr>\n            <tr>\n                <td><span data-translate="askApp.dept.toPay">Saldo</span>:</td>\n                <td><b>{{booking.toPay | number:2}}\u20AC</b></td>\n            </tr>\n        </table>\n    </div></script><script type="text/ng-template" id="popover-fromDate.html"><span>{{booking.bookingDate | date:\'short\'}}</span></script><script type="text/ng-template" id="popover-bookingStatus.html"><span class="label"\n          ng-class="{\'label-success\': booking.bookingStatus == \'angemeldet\', \'label-danger\': booking.bookingStatus == \'zurueckgetreten\' || booking.bookingStatus == \'abgelehnt\', \'label-warning\': booking.bookingStatus == \'warteliste\'}"\n          data-translate="{{\'askApp.EnumBookingStatusType.\' + booking.bookingStatus}}">\n    </span></script><script type="text/ng-template" id="popover-paymentStatus.html"><span class="label"\n          ng-class="{\'label-success\': booking.paymentStatus == \'payed\', \'label-danger\': booking.paymentStatus == \'pending\' || booking.paymentStatus == \'payedToMuch\', \'label-warning\': booking.paymentStatus == \'partial\' || booking.paymentStatus == \'prePayed\'}"\n          data-translate="{{\'askApp.EnumDeptStatus.\' + booking.paymentStatus}}">\n    </span></script>');
$templateCache.put('app/board/dinghy/dinghy/dinghies.html','<!--\n  ~ Copyright (c) 2020 by Felix Heim, felix-heim@web.de\n  ~\n  ~ This product includes software developed at\n  ~ The Apache Software Foundation (http://www.apache.org/).\n  --><div><div class="row row-no-padding"><div class="col-md-8"><jhi-alert></jhi-alert><div class="table-responsive"><table class="jh-table table table-striped"><thead><tr jh-sort="vm.predicate" ascending="vm.reverse" callback="vm.transition()"><th jh-sort-by="name"><span data-translate="askApp.dinghy.name">Name</span> <span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="available"><span data-translate="askApp.dinghy.available_short">Available</span> <span class="glyphicon glyphicon-sort"></span></th><th><span data-translate="askApp.dinghy.comment_short">Comment</span></th><th><span data-translate="askApp.dinghy.description_short">Description</span></th><th jh-sort-by="type"><span data-translate="askApp.dinghy.type">Type</span> <span class="glyphicon glyphicon-sort"></span></th><th></th></tr></thead><tbody><tr ng-repeat="dinghy in vm.dinghies track by dinghy.id"><td><a ui-sref="board.dinghy.dinghy.edit({id:dinghy.id})">{{dinghy.name}}</a></td><td style="text-align: center"><span class="label label-success" ng-show="dinghy.available">Ja</span> <span class="label label-danger" ng-show="!dinghy.available">Nein</span></td><td style="text-align: center"><span style="cursor: pointer" class="glyphicon glyphicon-comment" aria-hidden="true" uib-popover-html="getPopoverContent(dinghy.comment)" popover-trigger="mouseenter" popover-append-to-body="true" ng-show="dinghy.comment"></span> <span class="glyphicon glyphicon-remove" aria-hidden="true" ng-show="!dinghy.comment" popover-append-to-body="true"></span></td><td style="text-align: center"><span style="cursor: pointer" class="glyphicon glyphicon-comment" aria-hidden="true" uib-popover-html="getPopoverContent(dinghy.description)" popover-trigger="mouseenter" popover-append-to-body="true" ng-show="dinghy.description"></span> <span class="glyphicon glyphicon-remove" aria-hidden="true" ng-show="!dinghy.description"></span></td><td>{{dinghy.type}}</td><td class="text-right"><div class="btn-group flex-btn-group-container"><button type="submit" ui-sref="board.dinghy.dinghy.edit({id:dinghy.id})" class="btn btn-primary btn-xs"><span class="glyphicon glyphicon-pencil"></span></button></div></td></tr></tbody></table></div><div uib-accordion close-others="true" style="padding-bottom: 20px"><div has-authority="ROLE_BOARD"><br><uib-accordion-group is-open="status.open"><uib-accordion-heading><i class="glyphicon" ng-class="{\'glyphicon-chevron-down\': status.open, \'glyphicon-chevron-right\': !status.open}"></i> <span data-translate="askApp.dinghy.detail.non_active"></span> <button class="btn btn-primary btn-sm pull-right" ui-sref="board.dinghy.dinghy.new" style="margin-top: -6px" ng-click="$event.stopPropagation();"><span class="glyphicon glyphicon-plus"></span> <span class="hidden-sm-down" data-translate="askApp.dinghy.home.createLabel">Create new Dinghy</span></button></uib-accordion-heading><div class="alert alert-info" role="alert" ng-show="vm.dinghies_inactive.length == 0"><b>Keine Daten vorhanden!</b> Es existieren keine deaktivierten Jollen.</div><div class="table-responsive" ng-show="vm.dinghies_inactive.length > 0"><table class="jh-table table table-striped"><thead><tr jh-sort="vm.predicate" ascending="vm.reverse" callback="vm.transition()"><th><span data-translate="askApp.dinghy.name">Name</span></th><th><span data-translate="askApp.dinghy.comment_short">Comment</span></th><th><span data-translate="askApp.dinghy.description_short">Description</span></th><th><span data-translate="askApp.dinghy.type">Type</span></th><th></th></tr></thead><tbody><tr ng-repeat="dinghy in vm.dinghies_inactive track by dinghy.id"><td><a ui-sref="board.dinghy.dinghy.edit({id:dinghy.id})">{{dinghy.name}}</a></td><td style="text-align: center"><span style="cursor: pointer" class="glyphicon glyphicon-comment" aria-hidden="true" uib-popover-html="getPopoverContent(dinghy.comment)" popover-trigger="mouseenter" popover-append-to-body="true" ng-show="dinghy.comment"></span> <span class="glyphicon glyphicon-remove" aria-hidden="true" ng-show="!dinghy.comment"></span></td><td style="text-align: center"><span style="cursor: pointer" class="glyphicon glyphicon-comment" aria-hidden="true" uib-popover-html="getPopoverContent(dinghy.description)" popover-trigger="mouseenter" popover-append-to-body="true" ng-show="dinghy.description"></span> <span class="glyphicon glyphicon-remove" aria-hidden="true" ng-show="!dinghy.description"></span></td><td>{{dinghy.type}}</td><td class="text-right"><div class="btn-group flex-btn-group-container"><button type="submit" ui-sref="board.dinghy.dinghy.edit({id:dinghy.id})" class="btn btn-primary btn-xs"><span class="glyphicon glyphicon-pencil"></span></button></div></td></tr></tbody></table></div></uib-accordion-group></div></div></div><div class="col-md-4" ui-view="dinghyDetail"></div></div></div>');
$templateCache.put('app/board/dinghy/dinghy/dinghy-detail.html','<!--\n  ~ Copyright (c) 2020 by Felix Heim, felix-heim@web.de\n  ~\n  ~ This product includes software developed at\n  ~ The Apache Software Foundation (http://www.apache.org/).\n  --><form name="editForm" role="form" novalidate ng-submit="vm.save()" show-validation><h4 ng-show="!vm.dinghy.id" class="modal-title" id="myDinghyLabelNew" data-translate="askApp.dinghy.home.createLabel">Create or edit a Dinghy</h4><h4 ng-show="vm.dinghy.id" class="modal-title" id="myDinghyLabelEdit" data-translate="askApp.dinghy.detail.editLabel" translate-value-name="{{vm.dinghyName}}">Create or edit a Dinghy</h4><div style="margin-top: 10px"><jhi-alert-error></jhi-alert-error><div class="form-group"><label class="control-label" data-translate="askApp.dinghy.name" for="field_name">Name</label><input type="text" class="form-control" name="name" id="field_name" ng-model="vm.dinghy.name" ng-disabled="!vm.isBoard" required><div ng-show="editForm.name.$invalid"><p class="help-block" ng-show="editForm.name.$error.required" data-translate="entity.validation.required">This field is required.</p></div></div><div class="form-group"><label class="control-label" data-translate="askApp.dinghy.comment" for="field_comment">Comment</label><summernote config="vm.options" ng-model="vm.dinghy.comment" id="field_comment"></summernote></div><div class="form-group"><label class="control-label" data-translate="askApp.dinghy.available" for="field_available">Available</label><br><switch name="available" id="field_available" ng-model="vm.dinghy.available" class="green"></switch><div ng-show="editForm.available.$invalid"><p class="help-block" ng-show="editForm.available.$error.required" data-translate="entity.validation.required">This field is required.</p></div></div><div class="form-group"><label class="control-label" data-translate="askApp.dinghy.description" for="field_description">Description</label><summernote config="vm.options" ng-model="vm.dinghy.description" id="field_description"></summernote></div><div class="form-group"><label class="control-label" data-translate="askApp.dinghy.type" for="field_type">Type</label><input type="text" class="form-control" name="type" id="field_type" ng-disabled="!vm.isBoard" ng-model="vm.dinghy.type"></div><div class="form-group" ng-if="vm.isBoard && vm.dinghy.id !== null"><label class="control-label" data-translate="askApp.dinghy.active" for="field_active">Active</label><br><switch name="active" id="field_active" ng-model="vm.dinghy.active" class="green"></switch><div ng-show="editForm.active.$invalid"><p class="help-block" ng-show="editForm.active.$error.required" data-translate="entity.validation.required">This field is required.</p></div><div ng-show="!vm.dinghy.active && vm.dinghy.active != vm.wasActive"><div class="alert alert-danger" role="alert"><span data-translate="askApp.dinghy.detail.active_warning"></span></div></div><div ng-show="vm.dinghy.active && vm.dinghy.active != vm.wasActive"><div class="alert alert-danger" role="alert"><span data-translate="askApp.dinghy.detail.inactive_warning"></span></div></div></div></div><div style="text-align: right"><button type="button" class="btn btn-default" data-dismiss="modal" ng-click="vm.clear()"><span class="glyphicon glyphicon-ban-circle"></span>&nbsp;<span data-translate="entity.action.cancel">Cancel</span></button> <button type="submit" ng-disabled="editForm.$invalid || vm.isSaving" class="btn btn-primary"><span class="glyphicon glyphicon-save"></span>&nbsp;<span ng-show="!vm.dinghy.id" data-translate="entity.action.create">Create</span><span ng-show="vm.dinghy.id" data-translate="entity.action.save">Save</span></button></div></form>');
$templateCache.put('app/board/dinghy/event/dinghy-event-assign-dialog.html','<!--\n  ~ Copyright (c) 2020 by Felix Heim, felix-heim@web.de\n  ~\n  ~ This product includes software developed at\n  ~ The Apache Software Foundation (http://www.apache.org/).\n  --><form name="editForm" role="form" show-validation ng-submit="vm.confirmAssign()"><div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()">&times;</button><h4 class="modal-title" data-translate="askApp.dinghyEvent.confirmSelfAssignTitle">Confirm self assign</h4></div><div class="modal-body"><jhi-alert-error></jhi-alert-error><p data-translate="askApp.dinghyEvent.confirmSelfAssignText" translate-value-name="{{vm.dinghyEvent.name}}" translate-value-start="{{vm.dinghyEvent.fromDate | date:\'dd.MM.yyyy HH:mm\'}}">Confirm self assign?</p><div class="alert alert-info" ng-if="!vm.initialGodparent" role="alert"><span data-translate="askApp.dinghyEvent.assignInfo"></span></div><div class="alert alert-danger" ng-if="vm.initialGodparent" role="alert"><span data-translate="askApp.dinghyEvent.godparentPresent" translate-value-first-name="{{ vm.initialGodparent.user.firstName }}" translate-value-last-name="{{  vm.initialGodparent.user.lastName }}"></span></div><div class="alert alert-danger" ng-if="vm.dinghyEvent.canceled || vm.dinghyEvent.closed"><span ng-if="vm.dinghyEvent.canceled && !vm.dinghyEvent.closed" data-translate="askApp.dinghyEvent.warning.canceled"></span> <span ng-if="vm.dinghyEvent.closed" data-translate="askApp.dinghyEvent.warning.closed"></span></div><div class="form-group" ng-if="!vm.initialGodparent && !vm.dinghyEvent.canceled && !vm.dinghyEvent.closed"><label class="control-label" data-translate="askApp.dinghyEvent.contactEmailNew" for="field_contactEmail">Contact Email</label><input type="email" class="form-control" name="contactEmail" id="field_contactEmail" placeholder="{{vm.currentProfile.user.email}}" ng-model="vm.dinghyEvent.contactEmail" ng-minlength="5" ng-maxlength="50" maxlength="50"><div ng-show="editForm.contactEmail.$dirty && editForm.contactEmail.$invalid"><p class="help-block" ng-show="editForm.contactEmail.$error.email" data-translate="entity.validation.invalid">Your email is invalid.</p><p class="help-block" ng-show="editForm.contactEmail.$error.required" data-translate="entity.validation.required">This field is required.</p><p class="help-block" ng-show="editForm.contactEmail.$error.minlength" data-translate="entity.validation.minlength" translate-value-min="5">This field is required to be at least 3 characters.</p><p class="help-block" ng-show="editForm.contactEmail.$error.maxlength" data-translate="entity.validation.maxlength" translate-value-max="50">This field cannot be longer than 50 characters.</p></div></div><div class="form-group"><label class="control-label" data-translate="askApp.dinghyEvent.managerComment" for="field_managerComment">Comment</label><input type="text" class="form-control" name="managerComment" id="field_managerComment" ng-model="vm.managerComment" prevent-enter-submit></div></div><div class="modal-footer"><button type="button" class="btn btn-default" data-dismiss="modal" ng-click="vm.clear()"><span class="glyphicon glyphicon-ban-circle"></span>&nbsp;<span data-translate="entity.action.cancel">Cancel</span></button> <button type="submit" ng-disabled="vm.dinghyEvent.godparent || editForm.$invalid" class="btn btn-success"><span class="glyphicon glyphicon-remove-circle"></span>&nbsp;<span data-translate="entity.action.confirm">Confirm</span></button></div></form>');
$templateCache.put('app/board/dinghy/event/dinghy-event-cancel-dialog.html','<!--\n  ~ Copyright (c) 2020 by Felix Heim, felix-heim@web.de\n  ~\n  ~ This product includes software developed at\n  ~ The Apache Software Foundation (http://www.apache.org/).\n  --><div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()">&times;</button><h4 class="modal-title" data-translate="askApp.dinghyEvent.cancelTitle">Confirm delete operation</h4></div><div class="modal-body"><jhi-alert-error></jhi-alert-error><p data-translate="askApp.dinghyEvent.cancelQuestion" translate-values="{name: \'{{vm.dinghyEvent.name}}\', start:\'{{vm.dinghyEvent.fromDate | date:\'dd.MM.yyyy HH:mm\'}}\'}">Are you sure you want to cancel this Dinghy Event?</p><div class="form-group"><label class="control-label" data-translate="askApp.dinghyEvent.managerComment" for="field_managerComment">Comment</label><input type="text" class="form-control" name="managerComment" id="field_managerComment" ng-model="vm.managerComment" prevent-enter-submit></div></div><div class="modal-footer"><button type="button" class="btn btn-default" data-dismiss="modal" ng-click="vm.clear()"><span class="glyphicon glyphicon-ban-circle"></span>&nbsp;<span data-translate="entity.action.cancel">Cancel</span></button> <button type="submit" class="btn btn-warning" ng-click="vm.confirmCancel()"><span class="glyphicon glyphicon-remove-circle"></span>&nbsp;<span data-translate="askApp.dinghyEvent.cancel">Cancel</span></button></div>');
$templateCache.put('app/board/dinghy/event/dinghy-event-delete-dialog.html','<!--\n  ~ Copyright (c) 2020 by Felix Heim, felix-heim@web.de\n  ~\n  ~ This product includes software developed at\n  ~ The Apache Software Foundation (http://www.apache.org/).\n  --><div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()">&times;</button><h4 class="modal-title" data-translate="entity.delete.title">Confirm delete operation</h4></div><div class="modal-body"><jhi-alert-error></jhi-alert-error><p data-translate="askApp.dinghyEvent.delete.question" translate-values="{name: \'{{vm.dinghyEvent.name}}\', start:\'{{vm.dinghyEvent.fromDate | date:\'dd.MM.yyyy HH:mm\'}}\'}">Are you sure you want to delete this Dinghy Event?</p></div><div class="modal-footer"><button type="button" class="btn btn-default" data-dismiss="modal" ng-click="vm.clear()"><span class="glyphicon glyphicon-ban-circle"></span>&nbsp;<span data-translate="entity.action.cancel">Cancel</span></button> <button type="submit" ng-disabled="vm.dinghyEvent.hasRelations" class="btn btn-danger" ng-click="vm.confirmDelete(vm.dinghyEvent.id)"><span class="glyphicon glyphicon-remove-circle"></span>&nbsp;<span data-translate="entity.action.delete">Delete</span></button></div>');
$templateCache.put('app/board/dinghy/event/dinghy-event-dialog.html','<!--\n  ~ Copyright (c) 2020 by Felix Heim, felix-heim@web.de\n  ~\n  ~ This product includes software developed at\n  ~ The Apache Software Foundation (http://www.apache.org/).\n  --><form name="editForm" role="form" novalidate ng-submit="vm.save()" show-validation><div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()">&times;</button><h4 class="modal-title" id="myDinghyEventLabelNew" ng-show="!vm.dinghyEvent.id" data-translate="askApp.dinghyEvent.home.createLabel">Create or edit a Dinghy Event</h4><h4 class="modal-title" id="myDinghyEventLabelEdit" ng-show="vm.dinghyEvent.id" data-translate="askApp.dinghyEvent.home.editLabel">Create or edit a Dinghy Event</h4></div><div class="modal-body"><jhi-alert-error></jhi-alert-error><div class="alert alert-danger" ng-show="vm.dinghyEvent.id && vm.dinghyEvent.canceled && vm.oldCanceled"><span data-translate="askApp.dinghyEvent.warning.canceled"></span></div><div class="form-group"><label class="control-label" data-translate="askApp.dinghyEvent.type" for="field_type">Type</label><select class="form-control" name="type" ng-model="vm.dinghyEvent.type" id="field_type" required ng-disabled="vm.dinghyEvent.id" ng-change="vm.typeChanged()"><option value="leisure" data-translate="askApp.EnumDinghyEventType.leisure">leisure</option><option value="regatta" data-translate="askApp.EnumDinghyEventType.regatta">regatta</option><option value="training" data-translate="askApp.EnumDinghyEventType.training">training</option><option value="engagement" data-translate="askApp.EnumDinghyEventType.engagement">engagement</option></select><div ng-show="editForm.type.$invalid"><p class="help-block" ng-show="editForm.type.$error.required" data-translate="entity.validation.required">This field is required.</p></div></div><div class="form-group"><label class="control-label" data-translate="askApp.dinghyEvent.name" for="field_name">Name</label><input type="text" class="form-control" name="name" id="field_name" ng-model="vm.dinghyEvent.name" placeholder="{{ \'askApp.dinghyEvent.namePlaceholder.\' + vm.dinghyEvent.type | translate}}" required><div ng-show="editForm.name.$invalid"><p class="help-block" ng-show="editForm.name.$error.required" data-translate="entity.validation.required">This field is required.</p></div><div class="alert alert-warning" ng-show="vm.dinghyEvent.id && vm.dinghyEvent.name !== vm.oldName && !(vm.oldCanceled && vm.dinghyEvent.canceled)"><span data-translate="askApp.dinghyEvent.warning.general"></span></div></div><div class="form-group"><label class="control-label" data-translate="askApp.dinghyEvent.fromDate" for="field_fromDate">From Date</label><div class="input-group"><input id="field_fromDate" type="text" class="form-control" name="fromDate" datetime-picker="{{\'dd.MM.yyyy HH:mm\'}}" ng-model="vm.dinghyEvent.fromDate" is-open="vm.datePickerOpenStatus.fromDate" ng-change="vm.dateChanged()" required> <span class="input-group-btn"><button type="button" class="btn btn-default" ng-click="vm.openCalendar(\'fromDate\')"><i class="glyphicon glyphicon-calendar"></i></button></span></div><div ng-show="editForm.fromDate.$invalid"><p class="help-block" ng-show="editForm.fromDate.$error.required" data-translate="entity.validation.required">This field is required.</p><p class="help-block" ng-show="editForm.fromDate.$error.ZonedDateTimelocal" data-translate="entity.validation.ZonedDateTimelocal">This field should be a date and time.</p></div><div class="alert alert-warning" ng-show="!vm.checkFromDate()"><span data-translate="askApp.dinghyEvent.warning.general"></span></div></div><div class="form-group"><label class="control-label" data-translate="askApp.dinghyEvent.untilDate" for="field_untilDate">Until Date</label><div class="input-group"><input id="field_untilDate" type="text" class="form-control" name="untilDate" datetime-picker="{{\'dd.MM.yyyy HH:mm\'}}" ng-model="vm.dinghyEvent.untilDate" is-open="vm.datePickerOpenStatus.untilDate" ng-change="vm.loadAvailableDinghies()" datepicker-options="untilDateOptions" required> <span class="input-group-btn"><button type="button" class="btn btn-default" ng-click="vm.openCalendar(\'untilDate\')"><i class="glyphicon glyphicon-calendar"></i></button></span></div><div ng-show="editForm.untilDate.$invalid"><p class="help-block" ng-show="editForm.untilDate.$error.required" data-translate="entity.validation.required">This field is required.</p><p class="help-block" ng-show="editForm.untilDate.$error.ZonedDateTimelocal" data-translate="entity.validation.ZonedDateTimelocal">This field should be a date and time.</p></div><div class="alert alert-warning" ng-show="!vm.checkUntilDate()"><span data-translate="askApp.dinghyEvent.warning.general"></span></div></div><div class="form-group"><label class="control-label" data-translate="askApp.dinghyEvent.placeCount" for="field_placeCount">Place Count</label><input type="number" class="form-control" name="placeCount" id="field_placeCount" ng-model="vm.dinghyEvent.placeCount" required min="0"><div ng-show="editForm.placeCount.$invalid"><p class="help-block" ng-show="editForm.placeCount.$error.required" data-translate="entity.validation.required">This field is required.</p><p class="help-block" ng-show="editForm.placeCount.$error.min" data-translate="entity.validation.min" translate-value-min="0">This field should be at least 0.</p><p class="help-block" ng-show="editForm.placeCount.$error.number" data-translate="entity.validation.number">This field should be a number.</p></div></div><div class="form-group"><label class="control-label" data-translate="askApp.dinghyEvent.location" for="field_location">Location</label><input type="text" class="form-control" name="location" id="field_location" ng-model="vm.dinghyEvent.location" required><div ng-show="editForm.location.$invalid"><p class="help-block" ng-show="editForm.location.$error.required" data-translate="entity.validation.required">This field is required.</p></div><div class="alert alert-warning" ng-show="vm.dinghyEvent.id && vm.dinghyEvent.location !== vm.oldLocation && !(vm.oldCanceled && vm.dinghyEvent.canceled)"><span data-translate="askApp.dinghyEvent.warning.general"></span></div></div><div class="form-group"><label data-translate="askApp.dinghyEvent.availableDinghies" for="field_availableDinghies">Available Dinghies</label><select class="form-control" id="field_availableDinghies" multiple="multiple" size="6" name="availableDinghies" ng-model="vm.dinghyEvent.availableDinghies" ng-options="dinghy as (dinghy.name + \' (\' + dinghy.type + \')\') for dinghy in vm.dinghies track by dinghy.id"></select></div><div class="form-group"><label class="control-label" data-translate="askApp.dinghyEvent.identifier" for="field_identifier">Identifier</label><input type="text" class="form-control" name="identifier" id="field_identifier" ng-model="vm.dinghyEvent.identifier" ng-pattern="/^[a-zA-Z0-9\\+\\-\\.\\(\\)]+$/" ng-change="vm.replaceYear()" required><div ng-show="editForm.identifier.$invalid"><p class="help-block" ng-show="editForm.identifier.$error.required" data-translate="entity.validation.required">This field is required.</p><p class="help-block" ng-show="editForm.identifier.$error.pattern">Ung&uuml;ltige Zeichen. Erlaubt: Buchstaben, Zahlen, +, -, ., ( und )</p></div></div><div class="form-group" ng-show="vm.hasPrices() && !vm.dinghyEvent.hasExternalBookings"><label class="control-label" data-translate="askApp.dinghyEvent.normalPrice" for="field_normalPrice">Normal Price</label><input type="number" class="form-control" name="normalPrice" id="field_normalPrice" ng-model="vm.dinghyEvent.normalPrice"><div ng-show="editForm.normalPrice.$invalid"><p class="help-block" ng-show="editForm.normalPrice.$error.number" data-translate="entity.validation.number">This field should be a number.</p></div></div><div class="form-group" ng-show="vm.hasPrices() && !vm.dinghyEvent.hasExternalBookings"><label class="control-label" data-translate="askApp.dinghyEvent.studentPrice" for="field_studentPrice">Student Price</label><input type="number" class="form-control" name="studentPrice" id="field_studentPrice" min="0" max="{{vm.dinghyEvent.normalPrice}}" ng-model="vm.dinghyEvent.studentPrice"><div ng-show="editForm.studentPrice.$invalid"><p class="help-block" ng-show="editForm.studentPrice.$error.number" data-translate="entity.validation.number">This field should be a number.</p><p class="help-block" ng-show="editForm.studentPrice.$error.min" data-translate="entity.validation.min" translate-value-min="0">This field should be at least 0.</p><p class="help-block" ng-show="editForm.studentPrice.$error.max" data-translate="entity.validation.max" translate-value-max="{{vm.project.normalPrice}}">This field cannot be more than 200.</p></div></div><div class="form-group"><label class="control-label" data-translate="askApp.dinghyEvent.allowGuests" for="field_allowGuests">Allow Guests</label><br><switch name="allowGuests" id="field_allowGuests" ng-model="vm.dinghyEvent.allowGuests" class="green" ng-disabled="vm.dinghyEvent.hasExternalBookings"></switch><div ng-show="editForm.allowGuests.$invalid"><p class="help-block" ng-show="editForm.allowGuests.$error.required" data-translate="entity.validation.required">This field is required.</p></div></div><div class="form-group" ng-show="vm.hasPrices() && vm.dinghyEvent.allowGuests && !vm.dinghyEvent.hasExternalBookings"><label class="control-label" data-translate="askApp.dinghyEvent.guestPrice" for="field_guestPrice">Guest Price</label><input type="number" class="form-control" name="guestPrice" id="field_guestPrice" ng-model="vm.dinghyEvent.guestPrice"></div><div class="form-group"><label data-translate="askApp.dinghyEvent.godparent" for="field_godparent">Godparent</label><select class="form-control" id="field_godparent" name="godparent" ng-model="vm.dinghyEvent.godparent" ng-options="profile as (profile.user.firstName + \' \' + profile.user.lastName + (profile.nickname ? (\' &quot;\' + profile.nickname + \'&quot;\') : (\'\'))) for profile in vm.allGodparents track by profile.id"><option value=""></option></select><div class="alert alert-danger" ng-show="!vm.dinghyEvent.godparent && vm.dinghyEvent.id && vm.hadGodparent && !(vm.oldCanceled && vm.dinghyEvent.canceled)"><span data-translate="askApp.dinghyEvent.warning.godparentRemove"></span></div><div class="alert alert-warning" ng-show="!vm.dinghyEvent.godparent"><span data-translate="askApp.dinghyEvent.warning.noGodparent"></span></div><div class="alert alert-danger" ng-show="vm.dinghyEvent.godparent && vm.dinghyEvent.id && !vm.hadGodparent && !(vm.oldCanceled && vm.dinghyEvent.canceled)"><span data-translate="askApp.dinghyEvent.warning.godparentAdd"></span></div><div class="alert alert-warning" ng-show="vm.dinghyEvent.id && vm.hadGodparent && vm.dinghyEvent.godparent && vm.oldGodparent.id !== vm.dinghyEvent.godparent.id"><span data-translate="askApp.dinghyEvent.warning.general"></span></div></div><div class="form-group"><label class="control-label" data-translate="askApp.dinghyEvent.contactEmail" for="field_contactEmail">Contact Email</label><input type="email" class="form-control" name="contactEmail" id="field_contactEmail" placeholder="{{vm.dinghyEvent.godparent.user.email || vm.defaultMail}}" ng-model="vm.dinghyEvent.contactEmail" ng-minlength="5" ng-maxlength="50" maxlength="50"><div ng-show="editForm.contactEmail.$dirty && editForm.contactEmail.$invalid"><p class="help-block" ng-show="editForm.contactEmail.$error.email" data-translate="entity.validation.invalid">Your email is invalid.</p><p class="help-block" ng-show="editForm.contactEmail.$error.required" data-translate="entity.validation.required">This field is required.</p><p class="help-block" ng-show="editForm.contactEmail.$error.minlength" data-translate="entity.validation.minlength" translate-value-min="5">This field is required to be at least 3 characters.</p><p class="help-block" ng-show="editForm.contactEmail.$error.maxlength" data-translate="entity.validation.maxlength" translate-value-max="50">This field cannot be longer than 50 characters.</p></div></div><div class="form-group" ng-hide="vm.dinghyEvent.canceled || vm.dinghyEvent.closed"><label class="control-label" data-translate="askApp.dinghyEvent.active" for="field_active">Active</label><br><switch name="active" id="field_active" ng-model="vm.dinghyEvent.active" class="green"></switch><div ng-show="editForm.active.$invalid"><p class="help-block" ng-show="editForm.active.$error.required" data-translate="entity.validation.required">This field is required.</p></div></div><div class="form-group" ng-hide="vm.dinghyEvent.canceled || vm.dinghyEvent.closed"><label class="control-label" data-translate="askApp.dinghyEvent.visible" for="field_visible">Visible</label><br><switch name="visible" id="field_visible" ng-model="vm.dinghyEvent.visible" class="green"></switch><div ng-show="editForm.visible.$invalid"><p class="help-block" ng-show="editForm.visible.$error.required" data-translate="entity.validation.required">This field is required.</p></div></div><div class="form-group" ng-show="vm.dinghyEvent.id"><label class="control-label" data-translate="askApp.dinghyEvent.closed" for="field_closed">Closed</label><br><switch name="closed" id="field_closed" ng-model="vm.dinghyEvent.closed" class="green"></switch><div ng-show="editForm.closed.$invalid"><p class="help-block" ng-show="editForm.closed.$error.required" data-translate="entity.validation.required">This field is required.</p></div></div><div class="form-group" ng-show="vm.dinghyEvent.id"><label class="control-label" data-translate="askApp.dinghyEvent.canceled" for="field_canceled">Canceled</label><br><switch name="canceled" id="field_canceled" ng-model="vm.dinghyEvent.canceled" class="green"></switch><div ng-show="editForm.canceled.$invalid"><p class="help-block" ng-show="editForm.canceled.$error.required" data-translate="entity.validation.required">This field is required.</p></div><div class="alert alert-danger" ng-show="vm.dinghyEvent.id && vm.dinghyEvent.canceled !== vm.oldCanceled && vm.dinghyEvent.canceled"><span data-translate="askApp.dinghyEvent.warning.cancel"></span></div><div class="alert alert-warning" ng-show="vm.dinghyEvent.id && vm.dinghyEvent.canceled !== vm.oldCanceled && !vm.dinghyEvent.canceled"><span data-translate="askApp.dinghyEvent.warning.uncancel"></span></div></div><div class="form-group"><label class="control-label" data-translate="askApp.dinghyEvent.allowQueue" for="field_allowQueue">Allow Queue</label><br><switch name="allowQueue" id="field_allowQueue" ng-model="vm.dinghyEvent.allowQueue" class="green"></switch><div ng-show="editForm.allowQueue.$invalid"><p class="help-block" ng-show="editForm.allowQueue.$error.required" data-translate="entity.validation.required">This field is required.</p></div></div><div class="form-group"><label class="control-label" data-translate="askApp.dinghyEvent.individualQuestion" for="field_individualQuestion">Individual Question</label><input type="text" class="form-control" name="individualQuestion" id="field_individualQuestion" ng-model="vm.dinghyEvent.individualQuestion"></div><div class="form-group"><label class="control-label" data-translate="askApp.dinghyEvent.description" for="field_description">Description</label><summernote config="vm.options" ng-model="vm.dinghyEvent.description" id="field_description"></summernote><div class="alert alert-warning" ng-show="vm.dinghyEvent.id && vm.dinghyEvent.description !== vm.oldDescription && !(vm.oldCanceled && vm.dinghyEvent.canceled)"><span data-translate="askApp.dinghyEvent.warning.general"></span></div></div><div class="form-group"><label class="control-label" data-translate="askApp.dinghyEvent.conditions" for="field_conditions">Conditions</label><summernote config="vm.options" ng-model="vm.dinghyEvent.conditions" id="field_conditions"></summernote></div><div class="form-group" ng-if="vm.formIsDirty()"><label class="control-label" data-translate="askApp.dinghyEvent.managerComment" for="field_managerComment">Comment</label><input type="text" class="form-control" name="managerComment" id="field_managerComment" ng-model="vm.dinghyEvent.managerComment" prevent-enter-submit><div class="alert alert-info"><span data-translate="askApp.dinghyEvent.warning.commentHint"></span></div></div><button ng-show="!vm.dinghyEvent.id && !vm.showBulkCreateOptions" type="button" ng-disabled="vm.isSaving || !vm.dinghyEvent.fromDate" class="btn btn-warning" ng-click="vm.initBulkCreate()"><span class="glyphicon glyphicon-save"></span>&nbsp;<span data-translate="askApp.dinghyEvent.showBulkCreateOptions">show bulk options</span></button><div class="form-group" ng-show="vm.showBulkCreateOptions"><label class="control-label">Weitere Daten</label><div class="row row-no-padding-nested"><div class="col-sm-6" style="margin-bottom: 15px"><div class="alert alert-info">Das oben ausgew\xE4hlte Startdatum wird automatisch erstellt, auch wenn es hier abgew\xE4hlt wird.</div><uib-datepicker ng-model="vm.activeFromDate" multi-select="vm.additionalFromDates" template-url="app/components/util/multi-datepicker.tpl.html"></uib-datepicker></div><div class="col-sm-6"><b>Ausgew\xE4hlte Daten</b><div class="well well-sm"><div ng-repeat="date in vm.additionalFromDates | orderBy">{{date | date : \'EEE, dd.MM.yyyy\'}} <button class="btn btn-xs btn-warning" style="margin:5px" ng-click="vm.removeSelectedDate(date)">Entfernen</button></div></div></div></div></div></div><div class="modal-footer"><button type="button" class="btn btn-default" data-dismiss="modal" ng-click="vm.clear()"><span class="glyphicon glyphicon-ban-circle"></span>&nbsp;<span data-translate="entity.action.cancel">Cancel</span></button> <button type="submit" ng-disabled="editForm.$invalid || vm.isSaving" class="btn btn-primary"><span class="glyphicon glyphicon-save"></span>&nbsp;<span data-translate="entity.action.save">Save</span></button></div></form>');
$templateCache.put('app/board/dinghy/event/dinghy-events.html','<!--\n  ~ Copyright (c) 2020 by Felix Heim, felix-heim@web.de\n  ~\n  ~ This product includes software developed at\n  ~ The Apache Software Foundation (http://www.apache.org/).\n  --><div><div class="row row-no-padding"><div class="col-xs-12"><jhi-alert></jhi-alert><div class="container-fluid"><div class="row"><div class="col-xs-12 col-sm-3 no-padding-left"><div class="btn-group"><button type="submit" ng-click="vm.currentSearch == null && vm.setArchive(\'false\')" class="btn btn-default btn-md" ng-class="{active: vm.archive == \'false\' && vm.currentSearch == null}" ng-disabled="vm.currentSearch != null || vm.select"><span class="hidden-sm-down">Aktive Events</span></button> <button type="submit" ng-click="vm.currentSearch == null && vm.setArchive(\'true\')" class="btn btn-default btn-md" ng-class="{active: vm.archive == \'true\' && vm.currentSearch == null}" ng-disabled="vm.currentSearch != null || vm.select"><span class="hidden-sm-down">Archiv</span></button></div></div><div class="col-xs-12 col-sm-9 no-padding-left row-margin-top-xs no-padding-right"><div class="btn-group pull-right"><button ng-repeat="eventType in vm.dinghyEventTypes" type="submit" ng-click="vm.currentSearch == null && vm.setType(eventType)" class="btn btn-default btn-md" ng-class="{active: vm.type == eventType && vm.currentSearch == null}" ng-disabled="vm.currentSearch != null || vm.select"><span class="hidden-sm-down" data-translate="{{\'askApp.EnumDinghyEventType.\' + eventType}}">Event</span></button></div></div></div><div class="row"><br><div class="col-xs-12 col-sm-3 col-md-8 no-padding-left"><button class="btn btn-primary" ui-sref="board.dinghy.event.new"><span class="glyphicon glyphicon-plus"></span> <span class="hidden-xs-down" data-translate="askApp.dinghyEvent.home.createLabel">Create new Dingy Event</span></button></div><div class="col-xs-12 col-sm-9 col-md-4 no-padding-right no-padding-left row-margin-top-xs" ng-show="vm.isBoard"><form name="searchForm" class="form-inline"><div class="input-group pull-right"><input type="text" class="form-control" ng-model="vm.searchQuery" id="searchQuery" placeholder="{{ \'askApp.project.home.search\' | translate }}"> <span class="input-group-btn width-min"><button class="btn btn-info" ng-click="vm.search(vm.searchQuery)"><span class="glyphicon glyphicon-search"></span></button> </span><span class="input-group-btn width-min" ng-if="vm.currentSearch"><button class="btn btn-info" ng-click="vm.clear()"><span class="glyphicon glyphicon-trash"></span></button></span></div></form></div></div><br></div><div class="alert alert-info" role="alert" ng-show="vm.events.length == 0"><b>Keine Daten vorhanden!</b> Es existieren keine Jollenevents in dieser Auswahl.</div><div class="table-responsive" ng-show="vm.events.length > 0" style="margin-bottom: 15px"><table class="jh-table table table-striped"><thead><tr jh-sort="vm.predicate" ascending="vm.reverse" callback="vm.transition()"><th jh-sort-by="fromDate"><span data-translate="askApp.dinghyEvent.fromDate">From Date</span> <span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="name"><span data-translate="askApp.dinghyEvent.name">Name</span> <span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="type"><span data-translate="askApp.dinghyEvent.type">Type</span> <span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="godparent.user.firstName"><span data-translate="askApp.dinghyEvent.godparent">Until Date</span> <span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="active"><span data-translate="askApp.dinghyEvent.active">Active</span> <span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="visible"><span data-translate="askApp.dinghyEvent.visible">Visible</span> <span class="glyphicon glyphicon-sort"></span></th><th><span data-translate="askApp.project.status"></span></th><th></th></tr></thead><tbody><tr ng-repeat="dinghyEvent in vm.events track by dinghyEvent.id"><td><span aria-hidden="true" popover-trigger="mouseenter" uib-popover="{{dinghyEvent.fromDate | date:\'dd.MM.yyyy HH:mm\'}}" style="cursor: pointer">{{dinghyEvent.fromDate | date:\'dd.MM.\'}}</span></td><td><a ui-sref="board.dinghy.event.detail.overview({id:dinghyEvent.id})">{{dinghyEvent.name}}</a></td><td><span class="label label-info" data-translate="{{\'askApp.EnumDinghyEventType.\' + dinghyEvent.type}}">{{dinghyEvent.type}}</span></td><td><a ng-show="vm.isBoard && dinghyEvent.godparent" ui-sref="member-management-detail({id:dinghyEvent.godparent.id})">{{dinghyEvent.godparent.user.firstName}} {{dinghyEvent.godparent.user.lastName}}</a> <span ng-show="!vm.isBoard && vm.isDinghy && dinghyEvent.godparent">{{dinghyEvent.godparent.user.firstName}} {{dinghyEvent.godparent.user.lastName}}</span> <span ng-if="dinghyEvent.godparent && dinghyEvent.godparent.nickname" class="glyphicon glyphicon-info-sign" aria-hidden="true" popover-trigger="mouseenter" uib-popover="{{dinghyEvent.godparent.nickname}}" style="cursor: pointer"></span> <span ng-show="!dinghyEvent.godparent"><button type="submit" ui-sref="board.dinghy.event.self-assign({id:dinghyEvent.id})" class="btn btn-success btn-xs" ng-disabled="!vm.isDinghy || dinghyEvent.canceled || dinghyEvent.closed"><span data-translate="askApp.dinghyEvent.selfAssign"></span></button></span></td><td ng-if="!dinghyEvent.canceled"><span class="label label-success" ng-show="dinghyEvent.active" ng-class="{transparencyReduction: dinghyEvent.closed}">Ja</span> <span class="label label-danger" ng-show="!dinghyEvent.active" ng-class="{transparencyReduction: dinghyEvent.closed}">Nein</span></td><td ng-if="!dinghyEvent.canceled"><span class="label label-success" ng-show="dinghyEvent.visible" ng-class="{transparencyReduction: dinghyEvent.closed}">Ja</span> <span class="label label-danger" ng-show="!dinghyEvent.visible" ng-class="{transparencyReduction: dinghyEvent.closed}">Nein</span></td><td ng-if="dinghyEvent.canceled" colspan="2"><span class="label label-warning" data-translate="askApp.dinghyEvent.canceled" ng-class="{transparencyReduction: dinghyEvent.closed}"></span></td><td><span class="label label-info">{{dinghyEvent.bookedPlaces.countAngemeldet + dinghyEvent.bookedPlaces.countWarteliste}} / {{dinghyEvent.placeCount}}</span> <span class="glyphicon glyphicon-info-sign" aria-hidden="true" popover-trigger="mouseenter" popover-title="Buchungsstatus" uib-popover-template="\'popover-partial.html\'" style="cursor: pointer"></span></td><td class="text-right"><div class="btn-group flex-btn-group-container"><button type="submit" ui-sref="board.dinghy.event.detail.overview({id:dinghyEvent.id})" class="btn btn-info btn-xs"><span class="glyphicon glyphicon-eye-open"></span></button> <button type="submit" ui-sref="board.dinghy.event.cancel({id: dinghyEvent.id})" class="btn btn-warning btn-xs" ng-disabled="dinghyEvent.canceled == true || dinghyEvent.closed == true"><span class="glyphicon glyphicon-remove-circle"></span></button> <button type="submit" ui-sref="board.dinghy.event.delete({id:dinghyEvent.id})" class="btn btn-danger btn-xs" ng-disabled="dinghyEvent.hasRelations == true"><span class="glyphicon glyphicon-remove-circle"></span></button></div></td></tr></tbody></table></div><div class="text-center" ng-show="vm.events.length !== 0"><jhi-item-count page="vm.page" total="vm.queryCount" items-per-page="vm.itemsPerPage"></jhi-item-count><uib-pagination class="pagination-sm" total-items="vm.totalItems" items-per-page="vm.itemsPerPage" ng-model="vm.page" ng-change="vm.transition()"></uib-pagination></div><!--<uib-pager total-items="vm.totalItems" ng-model="vm.page" ng-change="vm.transition()"></uib-pager>--></div></div></div><script type="text/ng-template" id="popover-partial.html"><div>\n        <span class="label label-success" style="width: 100%;"><span data-translate="askApp.EnumBookingStatusType.angemeldet"></span>:&nbsp;{{dinghyEvent.bookedPlaces.countAngemeldet}}</span>\n        <br>\n        <span class="label label-danger"><span data-translate="askApp.EnumBookingStatusType.zurueckgetreten"></span>:&nbsp;{{dinghyEvent.bookedPlaces.countZurueckgetreten}}</span>\n        <br>\n        <span class="label label-danger"><span data-translate="askApp.EnumBookingStatusType.abgelehnt"></span>:&nbsp;{{dinghyEvent.bookedPlaces.countAbgelehnt}}</span>\n        <br>\n        <span class="label label-warning"><span data-translate="askApp.EnumBookingStatusType.warteliste"></span>:&nbsp;{{dinghyEvent.bookedPlaces.countWarteliste}}</span>\n        <br>\n        <span class="label label-info">Pl\xE4tze:&nbsp;{{dinghyEvent.placeCount}}</span>\n        <br>\n        <span class="label label-info">G\xFCltige&nbsp;Anmeldungen:&nbsp;{{dinghyEvent.bookedPlaces.countAngemeldet + dinghyEvent.bookedPlaces.countWarteliste}}</span>\n        <br>\n        <span class="label label-info" ng-show="dinghyEvent.freePlaces >= 0">Freie&nbsp;Pl\xE4tze:&nbsp;{{dinghyEvent.freePlaces}}</span>\n        <span class="label label-info" ng-show="dinghyEvent.freePlaces < 0">&Uuml;berbuchte&nbsp;Pl\xE4tze:&nbsp;{{-dinghyEvent.freePlaces}}</span>\n    </div></script>');
$templateCache.put('app/board/dinghy/newsletter/dinghy-newsletter.html','<!--\n  ~ Copyright (c) 2023 by Felix Heim, felix-heim@web.de\n  ~\n  ~ This product includes software developed at\n  ~ The Apache Software Foundation (http://www.apache.org/).\n  --><div class="notes"><div class="panel panel-default"><div class="panel-heading"><h3 class="panel-title" data-translate="askApp.dinghy.newsletter.detailTitle"></h3></div><div class="panel-body"><div class="row"><div class="member-management-detail-table"><div class="col-md-12"><form name="editForm" role="form" novalidate show-validation><jhi-alert></jhi-alert><!-- levels used [all, last_year, current_year (reused member from skipper send mail) --><div class="form-group" ng-init="vm.sendMail.levels = \'all\'"><label class="control-label" data-translate="askApp.dinghy.newsletter.selection">Description</label>&nbsp;<span class="glyphicon glyphicon-info-sign" aria-hidden="true" uib-popover="{{ \'askApp.dinghy.newsletter.selectionDetail\' | translate}}" popover-trigger="mouseenter" style="cursor: pointer"></span><div class="btn-group btn-group-justified"><label class="btn btn-default" ng-model="vm.sendMail.levels" uib-btn-radio="\'all\'"><span data-translate="askApp.dinghy.newsletter.all" translate-value-from-year="{{ vm.year - 1 }}" translate-value-to-year="{{ vm.year }}"></span></label><label class="btn btn-default" ng-model="vm.sendMail.levels" uib-btn-radio="\'last_year\'"><span data-translate="askApp.dinghy.newsletter.selectSingleYear" translate-value-year="{{ vm.year - 1 }}"></span></label><label class="btn btn-default" ng-model="vm.sendMail.levels" uib-btn-radio="\'current_year\'"><span data-translate="askApp.dinghy.newsletter.selectSingleYear" translate-value-year="{{ vm.year }}"></span></label></div></div><!-- matchAny used for guests yes/no (reused member from skipper send mail) --><div class="form-group" ng-init="vm.sendMail.matchAny = \'false\'"><label class="control-label" data-translate="askApp.dinghy.newsletter.guest">Description</label>&nbsp;<span class="glyphicon glyphicon-info-sign" aria-hidden="true" uib-popover="{{ \'askApp.dinghy.newsletter.guestDetail\' | translate}}" popover-trigger="mouseenter" style="cursor: pointer"></span><div class="btn-group btn-group-justified"><label class="btn btn-default" ng-model="vm.sendMail.matchAny" uib-btn-radio="\'true\'"><span data-translate="askApp.dinghy.newsletter.withGuests"></span></label><label class="btn btn-default" ng-model="vm.sendMail.matchAny" uib-btn-radio="\'false\'"><span data-translate="askApp.dinghy.newsletter.withoutGuests"></span></label></div></div><div class="form-group"><label class="control-label" data-translate="askApp.memberManagement.mail.replyToName">Description</label><input type="text" class="form-control" ng-model="vm.sendMail.replyToName" name="replyToName" placeholder="{{vm.currentAccount.firstName}} {{vm.currentAccount.lastName}}"></div><div class="form-group"><label class="control-label" data-translate="askApp.memberManagement.mail.replyToMail">Description</label><input type="email" class="form-control" ng-model="vm.sendMail.replyToMail" name="replyToMail" placeholder="{{vm.currentAccount.email}}"><div ng-show="editForm.replyToMail.$dirty && editForm.replyToMail.$invalid"><p class="help-block" ng-show="editForm.replyToMail.$error.email" data-translate="entity.validation.invalid">Your email is invalid.</p></div></div><div class="form-group"><label class="control-label" data-translate="askApp.memberManagement.mail.subject">Description</label><input type="text" class="form-control" ng-model="vm.sendMail.subject" name="subject" required><div ng-show="editForm.subject.$invalid"><p class="help-block" ng-show="editForm.subject.$error.required" data-translate="entity.validation.required">This field is required.</p></div></div><div class="alert alert-info" role="alert">Die <b>Mail</b> wird <b>individuell</b> an alle Adressaten verschickt. Eine <b>Begr&uuml;&szlig;ung</b> ist daher <b>nicht n\xF6tig.</b><br>Au&szlig;erdem kannst Du die <b>E-Mail</b> in der <b>Du-Form</b> verfassen.<br>Du kannst &uuml;ber den Button <b>"Test E-Mail"</b> auch eine <b>Probemail an Dich</b> selbst senden.</div><div class="form-group"><label class="control-label" data-translate="askApp.memberManagement.mail.text">Description</label><summernote config="vm.options" ng-model="vm.sendMail.text" id="field_description"></summernote></div><div class="modal-footer" style="padding:0; border: 0"><button type="submit" ng-disabled="vm.isSaving || editForm.$invalid" class="btn btn-danger" ng-click="vm.action(\'send\')"><span data-translate="askApp.memberManagement.mail.sendMail">Ausschlie\xDFen</span></button> <button type="submit" ng-disabled="vm.isSaving || editForm.$invalid" class="btn btn-info" ng-click="vm.action(\'test\')"><span data-translate="askApp.memberManagement.mail.testMail">Ausschlie\xDFen</span></button></div></form></div></div></div></div></div></div>');
$templateCache.put('app/board/dinghy/plan/dinghy-plan.html','<!--\n  ~ Copyright (c) 2020 by Felix Heim, felix-heim@web.de\n  ~\n  ~ This product includes software developed at\n  ~ The Apache Software Foundation (http://www.apache.org/).\n  --><div><div class="row row-no-padding"><div class="col-md-3"><table class="table table-striped"><thead><th><span data-translate="askApp.dinghy.name">Name</span></th><th><span data-translate="askApp.dinghy.show">Show</span></th></thead><tbody><tr ng-repeat="dinghy in vm.dinghies track by dinghy.id"><td><a ui-sref="board.dinghy.dinghy.edit({id:dinghy.id})">{{dinghy.name}}</a></td><td><switch ng-model="dinghy.isSelected" class="green small-switch"></switch></td></tr></tbody></table><div class="btn-group" style="margin-top: 10px; margin-bottom: 20px"><button type="submit" ng-click="vm.transition()" ng-disabled="!vm.anySelected()" class="btn btn-primary btn-md"><span class="glyphicon glyphicon-refresh"></span></button> <button type="submit" ng-click="vm.selectAll()" class="btn btn-primary btn-md"><span class="glyphicon glyphicon-globe"></span> <span class="hidden-xs-down">Alle</span></button> <button type="submit" ng-click="vm.selectNone()" class="btn btn-primary btn-md"><span class="glyphicon glyphicon-remove"></span> <span class="hidden-xs-down">Keine</span></button></div></div><div class="col-md-9"><jhi-alert></jhi-alert><div class="container-fluid" style="margin-bottom: 10px"><div class="row"><div class="col-xs-12 col-sm-6 no-padding-left row-margin-top-xs no-padding-right"><label class="control-label">Jahr:</label><select class="form-control" ng-model="vm.year" ng-options="year for year in vm.availableYears" ng-click="vm.setFilter(vm.year)"><option value=""></option></select></div><div class="col-xs-12 col-sm-6 no-padding-left"><label class="control-label">&nbsp;</label><div class="btn-group" style="display: block"><button type="submit" ng-click="vm.setFilter(\'active\')" class="btn btn-default btn-md" ng-class="{active: vm.timeFilter == \'active\'}"><span class="hidden-sm-down">Bevorstehende</span></button> <button type="submit" ng-click="vm.setFilter(\'archive\')" class="btn btn-default btn-md" ng-class="{active: vm.timeFilter == \'archive\'}"><span class="hidden-sm-down">Vergangene</span></button></div></div></div></div><div class="alert alert-info" role="alert" ng-show="vm.dinghyEvents.length == 0"><b>Keine Daten vorhanden!</b> Es existieren keine Jollen in dieser Auswahl.</div><div class="table-responsive"><table class="jh-table table table-striped"><thead><tr><th><span data-translate="askApp.dinghyEvent.fromDate">From Date</span></th><th><span data-translate="askApp.dinghyEvent.untilDate">Until Date</span></th><th><span>Event</span></th><th><span data-translate="askApp.dinghy.detail.title">Dinghies</span></th></tr></thead><tbody><tr ng-repeat="dinghyEvent in vm.dinghyEvents track by dinghyEvent.id" ng-class="{\'strike-through\': dinghyEvent.canceled == true}"><td><span aria-hidden="true" popover-trigger="mouseenter" uib-popover="{{dinghyEvent.fromDate | date:\'dd.MM.yyyy HH:mm\'}}" style="cursor: pointer">{{dinghyEvent.fromDate | date:\'dd.MM.\'}}</span></td><td><span aria-hidden="true" popover-trigger="mouseenter" uib-popover="{{dinghyEvent.untilDate | date:\'dd.MM.yyyy HH:mm\'}}" style="cursor: pointer">{{dinghyEvent.untilDate | date:\'dd.MM.\'}}</span></td><td><span ng-if="dinghyEvent.godparentId == vm.currentProfile.id" class="glyphicon glyphicon-tower"></span> <span><a ui-sref="board.dinghy.event.detail.overview({id: dinghyEvent.id})">{{\'askApp.EnumDinghyEventType.\' + dinghyEvent.type | translate}} </a><span class="glyphicon glyphicon-info-sign" aria-hidden="true" uib-popover="{{dinghyEvent.name}}" popover-trigger="mouseenter" style="cursor: pointer"></span></span></td><td><span ng-repeat="dinghy in dinghyEvent.availableDinghies track by dinghy.id"><a ui-sref="board.dinghy.dinghy.edit({id:dinghy.id})">{{dinghy.name}}</a><span ng-hide="$last">,&#32;</span></span></td></tr></tbody></table></div></div></div></div>');
$templateCache.put('app/board/dinghy/presence/presence.html','<!--\n  ~ Copyright (c) 2020 by Felix Heim, felix-heim@web.de\n  ~\n  ~ This product includes software developed at\n  ~ The Apache Software Foundation (http://www.apache.org/).\n  --><div><div class="row row-no-padding"><div class="col-xs-12"><div class="panel panel-default"><div class="panel-heading"><h3 class="panel-title" data-translate="askApp.dinghy.presence.title">Dinghy Presence</h3></div><div class="panel-body"><jhi-alert></jhi-alert><div class="container-fluid" style="margin-bottom: 10px"><div class="row"><form name="editForm" role="form" novalidate show-validation><div class="col-xs-12 col-sm-3 no-padding-left no-padding-right"><label class="control-label" data-translate="askApp.dinghyEvent.fromDate" for="field_fromDate">From Date</label><div class="input-group"><input id="field_fromDate" type="text" class="form-control" name="fromDate" uib-datepicker-popup="{{\'dd.MM.yyyy\'}}" ng-model="vm.fromDate" is-open="vm.datePickerOpenStatus.fromDate" ng-change="vm.updateDateSelection()" required> <span class="input-group-btn"><button type="button" class="btn btn-default" ng-click="vm.openCalendar(\'fromDate\')"><i class="glyphicon glyphicon-calendar"></i></button></span></div><div ng-show="editForm.fromDate.$invalid"><p class="help-block" ng-show="editForm.fromDate.$error.required" data-translate="entity.validation.required">This field is required.</p><p class="help-block" ng-show="editForm.fromDate.$error.date" data-translate="entity.validation.date">Not a valid date!</p></div></div><div class="col-xs-12 col-sm-3 no-padding-left no-padding-right"><label class="control-label" data-translate="askApp.dinghyEvent.untilDate" for="field_untilDate">Until Date</label><div class="input-group"><input id="field_untilDate" type="text" class="form-control" name="untilDate" uib-datepicker-popup="{{\'dd.MM.yyyy\'}}" ng-model="vm.untilDate" is-open="vm.datePickerOpenStatus.untilDate" ng-change="vm.updateDateSelection()" datepicker-options="options" required> <span class="input-group-btn"><button type="button" class="btn btn-default" ng-click="vm.openCalendar(\'untilDate\')"><i class="glyphicon glyphicon-calendar"></i></button></span></div><div ng-show="editForm.untilDate.$invalid"><p class="help-block" ng-show="editForm.untilDate.$error.required" data-translate="entity.validation.required">This field is required.</p><p class="help-block" ng-show="editForm.untilDate.$error.date" data-translate="entity.validation.date">Not a valid date!</p></div></div><div class="col-xs-12 col-sm-6 no-padding-left"><label class="control-label">&nbsp;</label><div class="btn-group" style="display: block"><button type="submit" ng-click="vm.transition()" class="btn btn-primary btn-md"><span class="glyphicon glyphicon-refresh"></span></button> <button type="submit" ng-click="vm.selectDateRange(\'year\')" ng-class="{active: vm.dateSelection == \'year\'}" class="btn btn-default btn-md"><span class="hidden-sm-down">{{ vm.year }}</span></button> <button type="submit" ng-click="vm.selectDateRange(\'future\')" ng-class="{active: vm.dateSelection == \'future\'}" class="btn btn-default btn-md"><span class="hidden-sm-down">Bevorstehende</span></button> <button type="submit" ng-click="vm.selectDateRange(\'passed\')" ng-class="{active: vm.dateSelection == \'passed\'}" class="btn btn-default btn-md"><span class="hidden-sm-down">Vergangene</span></button> <button type="submit" ng-click="vm.reverseOrder()" class="btn btn-primary btn-md"><span ng-if="!vm.reversed" class="glyphicon glyphicon-sort-by-attributes"></span> <span ng-if="vm.reversed" class="glyphicon glyphicon-sort-by-attributes-alt"></span></button></div></div></form></div></div><hr><div class="alert alert-info" role="alert" ng-show="vm.dinghyEvents.length == 0"><b>Keine Daten vorhanden!</b> Es existieren keine Anwesenden am See in dieser Auswahl.</div><div ng-repeat="dinghyEvent in vm.dinghyEvents track by dinghyEvent.id" ng-show="vm.dinghyEvents.length > 0"><h5><a ui-sref="board.dinghy.event.detail.overview({id: dinghyEvent.id})">{{dinghyEvent.fromDate | date:\'dd.MM.yy HH:mm\'}} Uhr ({{dinghyEvent.fromDate | date:\'EEEE\'}}) - {{dinghyEvent.untilDate | date:"dd.MM.yy HH:mm"}} Uhr, {{\'askApp.EnumDinghyEventType.\' + dinghyEvent.type| translate}} </a><span class="glyphicon glyphicon-info-sign" aria-hidden="true" uib-popover="{{dinghyEvent.name}}" popover-trigger="mouseenter" style="cursor: pointer"></span></h5><span ng-show="dinghyEvent.participants.length == 0 && !dinghyEvent.godparent" class="label label-danger">Keine Anmeldungen</span><ul style="margin-left: 0"><li ng-if="dinghyEvent.godparent"><span ng-if="vm.isBoard"><a ui-sref="member-management-detail({id: dinghyEvent.godparent.id})">{{dinghyEvent.godparent.firstName}} {{dinghyEvent.godparent.lastName}}</a></span> <span ng-if="!vm.isBoard">{{dinghyEvent.godparent.firstName}} {{dinghyEvent.godparent.lastName}}</span> <span ng-if="dinghyEvent.godparent.nickname" class="glyphicon glyphicon-info-sign" aria-hidden="true" popover-trigger="mouseenter" uib-popover="{{dinghyEvent.godparent.nickname}}" style="cursor: pointer"></span> | <a href="mailto:{{dinghyEvent.godparent.mail}}">{{dinghyEvent.godparent.mail}} </a><span ng-if="dinghyEvent.contactEmail !== dinghyEvent.godparent.mail">| <span data-translate="askApp.dinghyEvent.contactEmail"></span>: <a href="mailto:{{dinghyEvent.contactEmail}}">{{dinghyEvent.contactEmail}} </a></span>(<span data-translate="askApp.dinghyEvent.godparent"></span>)</li><li ng-repeat="participant in dinghyEvent.participants"><span ng-if="vm.isBoard && participant.id"><a ui-sref="member-management-detail({id: participant.id})">{{participant.firstName}} {{participant.lastName}}</a></span> <span ng-if="!vm.isBoard || !participant.id">{{participant.firstName}} {{participant.lastName}}</span> <span ng-if="participant.nickname" class="glyphicon glyphicon-info-sign" aria-hidden="true" popover-trigger="mouseenter" uib-popover="{{participant.nickname}}" style="cursor: pointer"></span> | <a href="mailto:{{participant.mail}}">{{participant.mail}} </a><span ng-if="!participant.id">(Extern)</span></li></ul></div></div></div></div></div></div>');
$templateCache.put('app/board/project/detail/projectDetailNavbar.html','<!--\n  ~ Copyright (c) 2017 by Julian Feder, julian.feder@yahoo.de\n  ~\n  ~ This product includes software developed at\n  ~ The Apache Software Foundation (http://www.apache.org/).\n  --><div><div class="row row-no-padding"><div class="col-md-12"><ol class="breadcrumb"><li><a ui-sref="board.project">Projektverwaltung</a></li><li class="active">{{vm.project.name}}</li></ol></div></div><div class="row row-no-padding"><div class="col-md-3"><div class="panel panel-default"><div class="panel-heading"><h3 class="panel-title">Funktionen</h3></div><div class="panel-body"><ul class="nav nav-pills nav-stacked" style="margin: 0"><li role="presentation" ui-sref-active="active"><a ui-sref="board.project-detail.home({id:vm.id})">\xDCbersicht</a></li><li role="presentation" ui-sref-active="active"><a ui-sref="board.project-detail.booking({id:vm.id})">Buchungen</a></li><li role="presentation" ui-sref-active="active" ng-show="vm.project.type == \'event\'"><a ui-sref="board.project-detail.crew({id:vm.id})">Crewliste</a></li><li role="presentation" ui-sref-active="active"><a ui-sref="board.project-detail.depts({id:vm.id})">Forderungen</a></li><li role="presentation" ui-sref-active="active"><a ui-sref="board.project-detail.payments({id:vm.id})">Zahlungen</a></li><li role="presentation" ui-sref-active="active" ng-show="vm.project.type == \'sbfPractical\'"><a ui-sref="board.project-detail.sbf-time-slot({id:vm.id})">SBF-See Planer</a></li><li role="presentation" ui-sref-active="active" ng-show="vm.project.type == \'sbfPractical\'"><a ui-sref="board.project-detail.sbf-overview({id:vm.id})">SBF-See \xDCbersicht</a></li><li role="presentation" ui-sref-active="active" ng-show="vm.project.type == \'sksTrip\'"><a ui-sref="board.project-detail.sks-overview({id:vm.id})">SKS \xDCbersicht</a></li><li role="presentation" ui-sref-active="active"><a ui-sref="board.project-detail.newsletter({id:vm.id})">Rundmail</a></li><li role="presentation" ui-sref-active="active"><a ui-sref="board.project-detail.notes({id:vm.id})">Notizen</a></li></ul></div></div></div><div class="col-md-9" ui-view="projectDetail"></div></div></div>');
$templateCache.put('app/member/personal/additional/additional.html','<!--\n  ~ Copyright (c) 2017 by Julian Feder, julian.feder@yahoo.de\n  ~\n  ~ This product includes software developed at\n  ~ The Apache Software Foundation (http://www.apache.org/).\n  --><div><div class="row row-no-padding-nested"><div class="col-md-8"><div class="panel panel-default"><div class="panel-heading"><h3 class="panel-title" data-translate="global.menu.additional">Meine Daten</h3></div><div class="panel-body"><jhi-alert></jhi-alert><form name="editForm" role="form" novalidate ng-submit="vm.save()" show-validation><!--------------------><!----- Gewicht ------><!--------------------><div class="form-group"><label class="control-label" data-translate="askApp.profile.weight" for="field_weight">Weight</label><input type="number" class="form-control" name="weight" id="field_weight" ng-model="vm.profile.weight" placeholder="{{\'askApp.profile.weight.placeholder\' | translate}}" min="0" max="200"><div ng-show="editForm.weight.$invalid"><p class="help-block" ng-show="editForm.weight.$error.min" data-translate="entity.validation.min" translate-value-min="0">This field should be at least 0.</p><p class="help-block" ng-show="editForm.weight.$error.max" data-translate="entity.validation.max" translate-value-max="200">This field cannot be more than 200.</p><p class="help-block" ng-show="editForm.weight.$error.number" data-translate="entity.validation.number">This field should be a number.</p></div></div><!--------------------><!-- clothing size ---><!--------------------><div class="form-group"><label class="control-label" data-translate="askApp.profile.clothingSize" for="field_clothingSize">Clothing Size</label><select class="form-control" name="clothingSize" ng-model="vm.profile.clothingSize" id="field_clothingSize"><option value=""></option><option value="XXS" data-translate="askApp.EnumClothingSize.XXS">XXS</option><option value="XS" data-translate="askApp.EnumClothingSize.XS">XS</option><option value="S" data-translate="askApp.EnumClothingSize.S">S</option><option value="M" data-translate="askApp.EnumClothingSize.M">M</option><option value="L" data-translate="askApp.EnumClothingSize.L">L</option><option value="XL" data-translate="askApp.EnumClothingSize.XL">XL</option><option value="XXL" data-translate="askApp.EnumClothingSize.XXL">XXL</option><option value="XXXL" data-translate="askApp.EnumClothingSize.XXXL">3XL</option></select></div><!--------------------><!---- shoe size -----><!--------------------><div class="form-group"><label class="control-label" data-translate="askApp.profile.shoeSize" for="field_shoeSize">Show Size</label><input type="number" class="form-control" name="shoeSize" id="field_shoeSize" ng-model="vm.profile.shoeSize" step="0.5" placeholder="{{\'askApp.profile.shoeSize.placeholder\' | translate}}" min="20" max="60"><div ng-show="editForm.shoeSize.$invalid"><p class="help-block" ng-show="editForm.shoeSize.$error.min" data-translate="entity.validation.min" translate-value-min="20">This field should be at least 20.</p><p class="help-block" ng-show="editForm.shoeSize.$error.max" data-translate="entity.validation.max" translate-value-max="60">This field cannot be more than 60.</p><p class="help-block" ng-show="editForm.shoeSize.$error.number" data-translate="entity.validation.number">This field should be a number.</p></div></div><div class="form-group"><label class="control-label" data-translate="askApp.profile.nationality" for="field_nationality">Nationality</label><select class="form-control" name="nationality" ng-model="vm.profile.nationality" id="field_nationality"><option value=""></option><option value="AF" data-translate="askApp.EnumCountry.AF">AF</option><option value="EG" data-translate="askApp.EnumCountry.EG">EG</option><option value="AL" data-translate="askApp.EnumCountry.AL">AL</option><option value="DZ" data-translate="askApp.EnumCountry.DZ">DZ</option><option value="AD" data-translate="askApp.EnumCountry.AD">AD</option><option value="AO" data-translate="askApp.EnumCountry.AO">AO</option><option value="AI" data-translate="askApp.EnumCountry.AI">AI</option><option value="AQ" data-translate="askApp.EnumCountry.AQ">AQ</option><option value="AG" data-translate="askApp.EnumCountry.AG">AG</option><option value="GQ" data-translate="askApp.EnumCountry.GQ">GQ</option><option value="AR" data-translate="askApp.EnumCountry.AR">AR</option><option value="AM" data-translate="askApp.EnumCountry.AM">AM</option><option value="AW" data-translate="askApp.EnumCountry.AW">AW</option><option value="AZ" data-translate="askApp.EnumCountry.AZ">AZ</option><option value="ET" data-translate="askApp.EnumCountry.ET">ET</option><option value="AU" data-translate="askApp.EnumCountry.AU">AU</option><option value="BS" data-translate="askApp.EnumCountry.BS">BS</option><option value="BH" data-translate="askApp.EnumCountry.BH">BH</option><option value="BD" data-translate="askApp.EnumCountry.BD">BD</option><option value="BB" data-translate="askApp.EnumCountry.BB">BB</option><option value="BE" data-translate="askApp.EnumCountry.BE">BE</option><option value="BZ" data-translate="askApp.EnumCountry.BZ">BZ</option><option value="BJ" data-translate="askApp.EnumCountry.BJ">BJ</option><option value="BM" data-translate="askApp.EnumCountry.BM">BM</option><option value="BT" data-translate="askApp.EnumCountry.BT">BT</option><option value="MM" data-translate="askApp.EnumCountry.MM">MM</option><option value="BO" data-translate="askApp.EnumCountry.BO">BO</option><option value="BA" data-translate="askApp.EnumCountry.BA">BA</option><option value="BW" data-translate="askApp.EnumCountry.BW">BW</option><option value="BV" data-translate="askApp.EnumCountry.BV">BV</option><option value="BR" data-translate="askApp.EnumCountry.BR">BR</option><option value="IO" data-translate="askApp.EnumCountry.IO">IO</option><option value="BN" data-translate="askApp.EnumCountry.BN">BN</option><option value="BG" data-translate="askApp.EnumCountry.BG">BG</option><option value="BF" data-translate="askApp.EnumCountry.BF">BF</option><option value="BI" data-translate="askApp.EnumCountry.BI">BI</option><option value="CL" data-translate="askApp.EnumCountry.CL">CL</option><option value="CN" data-translate="askApp.EnumCountry.CN">CN</option><option value="CX" data-translate="askApp.EnumCountry.CX">CX</option><option value="CK" data-translate="askApp.EnumCountry.CK">CK</option><option value="CR" data-translate="askApp.EnumCountry.CR">CR</option><option value="DK" data-translate="askApp.EnumCountry.DK">DK</option><option value="DE" data-translate="askApp.EnumCountry.DE">DE</option><option value="DJ" data-translate="askApp.EnumCountry.DJ">DJ</option><option value="DM" data-translate="askApp.EnumCountry.DM">DM</option><option value="DO" data-translate="askApp.EnumCountry.DO">DO</option><option value="EC" data-translate="askApp.EnumCountry.EC">EC</option><option value="SV" data-translate="askApp.EnumCountry.SV">SV</option><option value="CI" data-translate="askApp.EnumCountry.CI">CI</option><option value="ER" data-translate="askApp.EnumCountry.ER">ER</option><option value="EE" data-translate="askApp.EnumCountry.EE">EE</option><option value="FK" data-translate="askApp.EnumCountry.FK">FK</option><option value="FO" data-translate="askApp.EnumCountry.FO">FO</option><option value="FJ" data-translate="askApp.EnumCountry.FJ">FJ</option><option value="FI" data-translate="askApp.EnumCountry.FI">FI</option><option value="FR" data-translate="askApp.EnumCountry.FR">FR</option><option value="GF" data-translate="askApp.EnumCountry.GF">GF</option><option value="PF" data-translate="askApp.EnumCountry.PF">PF</option><option value="TF" data-translate="askApp.EnumCountry.TF">TF</option><option value="GA" data-translate="askApp.EnumCountry.GA">GA</option><option value="GM" data-translate="askApp.EnumCountry.GM">GM</option><option value="GE" data-translate="askApp.EnumCountry.GE">GE</option><option value="GH" data-translate="askApp.EnumCountry.GH">GH</option><option value="GI" data-translate="askApp.EnumCountry.GI">GI</option><option value="GD" data-translate="askApp.EnumCountry.GD">GD</option><option value="GR" data-translate="askApp.EnumCountry.GR">GR</option><option value="GL" data-translate="askApp.EnumCountry.GL">GL</option><option value="UK" data-translate="askApp.EnumCountry.UK">UK</option><option value="GB" data-translate="askApp.EnumCountry.GB">GB</option><option value="GP" data-translate="askApp.EnumCountry.GP">GP</option><option value="GU" data-translate="askApp.EnumCountry.GU">GU</option><option value="GT" data-translate="askApp.EnumCountry.GT">GT</option><option value="GN" data-translate="askApp.EnumCountry.GN">GN</option><option value="GW" data-translate="askApp.EnumCountry.GW">GW</option><option value="GY" data-translate="askApp.EnumCountry.GY">GY</option><option value="HT" data-translate="askApp.EnumCountry.HT">HT</option><option value="HM" data-translate="askApp.EnumCountry.HM">HM</option><option value="HN" data-translate="askApp.EnumCountry.HN">HN</option><option value="HK" data-translate="askApp.EnumCountry.HK">HK</option><option value="IN" data-translate="askApp.EnumCountry.IN">IN</option><option value="ID" data-translate="askApp.EnumCountry.ID">ID</option><option value="IQ" data-translate="askApp.EnumCountry.IQ">IQ</option><option value="IR" data-translate="askApp.EnumCountry.IR">IR</option><option value="IE" data-translate="askApp.EnumCountry.IE">IE</option><option value="IS" data-translate="askApp.EnumCountry.IS">IS</option><option value="IL" data-translate="askApp.EnumCountry.IL">IL</option><option value="IT" data-translate="askApp.EnumCountry.IT">IT</option><option value="JM" data-translate="askApp.EnumCountry.JM">JM</option><option value="JP" data-translate="askApp.EnumCountry.JP">JP</option><option value="YE" data-translate="askApp.EnumCountry.YE">YE</option><option value="JO" data-translate="askApp.EnumCountry.JO">JO</option><option value="YU" data-translate="askApp.EnumCountry.YU">YU</option><option value="KY" data-translate="askApp.EnumCountry.KY">KY</option><option value="KH" data-translate="askApp.EnumCountry.KH">KH</option><option value="CM" data-translate="askApp.EnumCountry.CM">CM</option><option value="CA" data-translate="askApp.EnumCountry.CA">CA</option><option value="CV" data-translate="askApp.EnumCountry.CV">CV</option><option value="KZ" data-translate="askApp.EnumCountry.KZ">KZ</option><option value="KE" data-translate="askApp.EnumCountry.KE">KE</option><option value="KG" data-translate="askApp.EnumCountry.KG">KG</option><option value="KI" data-translate="askApp.EnumCountry.KI">KI</option><option value="CC" data-translate="askApp.EnumCountry.CC">CC</option><option value="CO" data-translate="askApp.EnumCountry.CO">CO</option><option value="KM" data-translate="askApp.EnumCountry.KM">KM</option><option value="CG" data-translate="askApp.EnumCountry.CG">CG</option><option value="CD" data-translate="askApp.EnumCountry.CD">CD</option><option value="HR" data-translate="askApp.EnumCountry.HR">HR</option><option value="CU" data-translate="askApp.EnumCountry.CU">CU</option><option value="KW" data-translate="askApp.EnumCountry.KW">KW</option><option value="LA" data-translate="askApp.EnumCountry.LA">LA</option><option value="LS" data-translate="askApp.EnumCountry.LS">LS</option><option value="LV" data-translate="askApp.EnumCountry.LV">LV</option><option value="LB" data-translate="askApp.EnumCountry.LB">LB</option><option value="LR" data-translate="askApp.EnumCountry.LR">LR</option><option value="LY" data-translate="askApp.EnumCountry.LY">LY</option><option value="LI" data-translate="askApp.EnumCountry.LI">LI</option><option value="LT" data-translate="askApp.EnumCountry.LT">LT</option><option value="LU" data-translate="askApp.EnumCountry.LU">LU</option><option value="MO" data-translate="askApp.EnumCountry.MO">MO</option><option value="MG" data-translate="askApp.EnumCountry.MG">MG</option><option value="MW" data-translate="askApp.EnumCountry.MW">MW</option><option value="MY" data-translate="askApp.EnumCountry.MY">MY</option><option value="MV" data-translate="askApp.EnumCountry.MV">MV</option><option value="ML" data-translate="askApp.EnumCountry.ML">ML</option><option value="MT" data-translate="askApp.EnumCountry.MT">MT</option><option value="MP" data-translate="askApp.EnumCountry.MP">MP</option><option value="MA" data-translate="askApp.EnumCountry.MA">MA</option><option value="MH" data-translate="askApp.EnumCountry.MH">MH</option><option value="MQ" data-translate="askApp.EnumCountry.MQ">MQ</option><option value="MR" data-translate="askApp.EnumCountry.MR">MR</option><option value="MU" data-translate="askApp.EnumCountry.MU">MU</option><option value="YT" data-translate="askApp.EnumCountry.YT">YT</option><option value="MK" data-translate="askApp.EnumCountry.MK">MK</option><option value="MX" data-translate="askApp.EnumCountry.MX">MX</option><option value="FM" data-translate="askApp.EnumCountry.FM">FM</option><option value="MZ" data-translate="askApp.EnumCountry.MZ">MZ</option><option value="MD" data-translate="askApp.EnumCountry.MD">MD</option><option value="MC" data-translate="askApp.EnumCountry.MC">MC</option><option value="MN" data-translate="askApp.EnumCountry.MN">MN</option><option value="MS" data-translate="askApp.EnumCountry.MS">MS</option><option value="NA" data-translate="askApp.EnumCountry.NA">NA</option><option value="NR" data-translate="askApp.EnumCountry.NR">NR</option><option value="NP" data-translate="askApp.EnumCountry.NP">NP</option><option value="NC" data-translate="askApp.EnumCountry.NC">NC</option><option value="NZ" data-translate="askApp.EnumCountry.NZ">NZ</option><option value="NI" data-translate="askApp.EnumCountry.NI">NI</option><option value="NL" data-translate="askApp.EnumCountry.NL">NL</option><option value="AN" data-translate="askApp.EnumCountry.AN">AN</option><option value="NE" data-translate="askApp.EnumCountry.NE">NE</option><option value="NG" data-translate="askApp.EnumCountry.NG">NG</option><option value="NU" data-translate="askApp.EnumCountry.NU">NU</option><option value="KP" data-translate="askApp.EnumCountry.KP">KP</option><option value="NF" data-translate="askApp.EnumCountry.NF">NF</option><option value="NO" data-translate="askApp.EnumCountry.NO">NO</option><option value="OM" data-translate="askApp.EnumCountry.OM">OM</option><option value="AT" data-translate="askApp.EnumCountry.AT">AT</option><option value="PK" data-translate="askApp.EnumCountry.PK">PK</option><option value="PS" data-translate="askApp.EnumCountry.PS">PS</option><option value="PW" data-translate="askApp.EnumCountry.PW">PW</option><option value="PA" data-translate="askApp.EnumCountry.PA">PA</option><option value="PG" data-translate="askApp.EnumCountry.PG">PG</option><option value="PY" data-translate="askApp.EnumCountry.PY">PY</option><option value="PE" data-translate="askApp.EnumCountry.PE">PE</option><option value="PH" data-translate="askApp.EnumCountry.PH">PH</option><option value="PN" data-translate="askApp.EnumCountry.PN">PN</option><option value="PL" data-translate="askApp.EnumCountry.PL">PL</option><option value="PT" data-translate="askApp.EnumCountry.PT">PT</option><option value="PR" data-translate="askApp.EnumCountry.PR">PR</option><option value="QA" data-translate="askApp.EnumCountry.QA">QA</option><option value="RE" data-translate="askApp.EnumCountry.RE">RE</option><option value="RW" data-translate="askApp.EnumCountry.RW">RW</option><option value="RO" data-translate="askApp.EnumCountry.RO">RO</option><option value="RU" data-translate="askApp.EnumCountry.RU">RU</option><option value="LC" data-translate="askApp.EnumCountry.LC">LC</option><option value="ZM" data-translate="askApp.EnumCountry.ZM">ZM</option><option value="AS" data-translate="askApp.EnumCountry.AS">AS</option><option value="WS" data-translate="askApp.EnumCountry.WS">WS</option><option value="SM" data-translate="askApp.EnumCountry.SM">SM</option><option value="ST" data-translate="askApp.EnumCountry.ST">ST</option><option value="SA" data-translate="askApp.EnumCountry.SA">SA</option><option value="SE" data-translate="askApp.EnumCountry.SE">SE</option><option value="CH" data-translate="askApp.EnumCountry.CH">CH</option><option value="SN" data-translate="askApp.EnumCountry.SN">SN</option><option value="SC" data-translate="askApp.EnumCountry.SC">SC</option><option value="SL" data-translate="askApp.EnumCountry.SL">SL</option><option value="SG" data-translate="askApp.EnumCountry.SG">SG</option><option value="SK" data-translate="askApp.EnumCountry.SK">SK</option><option value="SI" data-translate="askApp.EnumCountry.SI">SI</option><option value="SB" data-translate="askApp.EnumCountry.SB">SB</option><option value="SO" data-translate="askApp.EnumCountry.SO">SO</option><option value="GS" data-translate="askApp.EnumCountry.GS">GS</option><option value="ES" data-translate="askApp.EnumCountry.ES">ES</option><option value="LK" data-translate="askApp.EnumCountry.LK">LK</option><option value="SH" data-translate="askApp.EnumCountry.SH">SH</option><option value="KN" data-translate="askApp.EnumCountry.KN">KN</option><option value="PM" data-translate="askApp.EnumCountry.PM">PM</option><option value="VC" data-translate="askApp.EnumCountry.VC">VC</option><option value="KR" data-translate="askApp.EnumCountry.KR">KR</option><option value="ZA" data-translate="askApp.EnumCountry.ZA">ZA</option><option value="SD" data-translate="askApp.EnumCountry.SD">SD</option><option value="SR" data-translate="askApp.EnumCountry.SR">SR</option><option value="SJ" data-translate="askApp.EnumCountry.SJ">SJ</option><option value="SZ" data-translate="askApp.EnumCountry.SZ">SZ</option><option value="SY" data-translate="askApp.EnumCountry.SY">SY</option><option value="TJ" data-translate="askApp.EnumCountry.TJ">TJ</option><option value="TW" data-translate="askApp.EnumCountry.TW">TW</option><option value="TZ" data-translate="askApp.EnumCountry.TZ">TZ</option><option value="TH" data-translate="askApp.EnumCountry.TH">TH</option><option value="TP" data-translate="askApp.EnumCountry.TP">TP</option><option value="TG" data-translate="askApp.EnumCountry.TG">TG</option><option value="TK" data-translate="askApp.EnumCountry.TK">TK</option><option value="TO" data-translate="askApp.EnumCountry.TO">TO</option><option value="TT" data-translate="askApp.EnumCountry.TT">TT</option><option value="TD" data-translate="askApp.EnumCountry.TD">TD</option><option value="CZ" data-translate="askApp.EnumCountry.CZ">CZ</option><option value="TN" data-translate="askApp.EnumCountry.TN">TN</option><option value="TR" data-translate="askApp.EnumCountry.TR">TR</option><option value="TM" data-translate="askApp.EnumCountry.TM">TM</option><option value="TC" data-translate="askApp.EnumCountry.TC">TC</option><option value="TV" data-translate="askApp.EnumCountry.TV">TV</option><option value="UG" data-translate="askApp.EnumCountry.UG">UG</option><option value="UA" data-translate="askApp.EnumCountry.UA">UA</option><option value="HU" data-translate="askApp.EnumCountry.HU">HU</option><option value="UY" data-translate="askApp.EnumCountry.UY">UY</option><option value="UZ" data-translate="askApp.EnumCountry.UZ">UZ</option><option value="VU" data-translate="askApp.EnumCountry.VU">VU</option><option value="VA" data-translate="askApp.EnumCountry.VA">VA</option><option value="VE" data-translate="askApp.EnumCountry.VE">VE</option><option value="AE" data-translate="askApp.EnumCountry.AE">AE</option><option value="US" data-translate="askApp.EnumCountry.US">US</option><option value="VN" data-translate="askApp.EnumCountry.VN">VN</option><option value="VG" data-translate="askApp.EnumCountry.VG">VG</option><option value="VI" data-translate="askApp.EnumCountry.VI">VI</option><option value="WF" data-translate="askApp.EnumCountry.WF">WF</option><option value="BY" data-translate="askApp.EnumCountry.BY">BY</option><option value="EH" data-translate="askApp.EnumCountry.EH">EH</option><option value="CF" data-translate="askApp.EnumCountry.CF">CF</option><option value="ZW" data-translate="askApp.EnumCountry.ZW">ZW</option><option value="CY" data-translate="askApp.EnumCountry.CY">CY</option></select></div><div class="form-group"><label class="control-label" data-translate="askApp.profile.birthplace" for="field_birthplace">Birthplace</label><input type="text" class="form-control" name="birthplace" id="field_birthplace" ng-model="vm.profile.birthplace" placeholder="{{\'askApp.profile.birthplace\' | translate}}" ng-minlength="3" ng-maxlength="50" maxlength="50"><div ng-show="editForm.birthplace.$invalid"><p class="help-block" ng-show="editForm.birthplace.$error.minlength" data-translate="entity.validation.minlength" translate-value-min="3">This field is required to be at least 1 characters.</p><p class="help-block" ng-show="editForm.birthplace.$error.maxlength" data-translate="entity.validation.maxlength" translate-value-max="50">This field cannot be longer than 50 characters.</p></div></div><div class="form-group"><label class="control-label" data-translate="askApp.profile.countryOfBirth" for="field_countryOfBirth">Country Of Birth</label><select class="form-control" name="countryOfBirth" ng-model="vm.profile.countryOfBirth" id="field_countryOfBirth"><option value=""></option><option value="AF" data-translate="askApp.EnumCountry.AF">AF</option><option value="EG" data-translate="askApp.EnumCountry.EG">EG</option><option value="AL" data-translate="askApp.EnumCountry.AL">AL</option><option value="DZ" data-translate="askApp.EnumCountry.DZ">DZ</option><option value="AD" data-translate="askApp.EnumCountry.AD">AD</option><option value="AO" data-translate="askApp.EnumCountry.AO">AO</option><option value="AI" data-translate="askApp.EnumCountry.AI">AI</option><option value="AQ" data-translate="askApp.EnumCountry.AQ">AQ</option><option value="AG" data-translate="askApp.EnumCountry.AG">AG</option><option value="GQ" data-translate="askApp.EnumCountry.GQ">GQ</option><option value="AR" data-translate="askApp.EnumCountry.AR">AR</option><option value="AM" data-translate="askApp.EnumCountry.AM">AM</option><option value="AW" data-translate="askApp.EnumCountry.AW">AW</option><option value="AZ" data-translate="askApp.EnumCountry.AZ">AZ</option><option value="ET" data-translate="askApp.EnumCountry.ET">ET</option><option value="AU" data-translate="askApp.EnumCountry.AU">AU</option><option value="BS" data-translate="askApp.EnumCountry.BS">BS</option><option value="BH" data-translate="askApp.EnumCountry.BH">BH</option><option value="BD" data-translate="askApp.EnumCountry.BD">BD</option><option value="BB" data-translate="askApp.EnumCountry.BB">BB</option><option value="BE" data-translate="askApp.EnumCountry.BE">BE</option><option value="BZ" data-translate="askApp.EnumCountry.BZ">BZ</option><option value="BJ" data-translate="askApp.EnumCountry.BJ">BJ</option><option value="BM" data-translate="askApp.EnumCountry.BM">BM</option><option value="BT" data-translate="askApp.EnumCountry.BT">BT</option><option value="MM" data-translate="askApp.EnumCountry.MM">MM</option><option value="BO" data-translate="askApp.EnumCountry.BO">BO</option><option value="BA" data-translate="askApp.EnumCountry.BA">BA</option><option value="BW" data-translate="askApp.EnumCountry.BW">BW</option><option value="BV" data-translate="askApp.EnumCountry.BV">BV</option><option value="BR" data-translate="askApp.EnumCountry.BR">BR</option><option value="IO" data-translate="askApp.EnumCountry.IO">IO</option><option value="BN" data-translate="askApp.EnumCountry.BN">BN</option><option value="BG" data-translate="askApp.EnumCountry.BG">BG</option><option value="BF" data-translate="askApp.EnumCountry.BF">BF</option><option value="BI" data-translate="askApp.EnumCountry.BI">BI</option><option value="CL" data-translate="askApp.EnumCountry.CL">CL</option><option value="CN" data-translate="askApp.EnumCountry.CN">CN</option><option value="CX" data-translate="askApp.EnumCountry.CX">CX</option><option value="CK" data-translate="askApp.EnumCountry.CK">CK</option><option value="CR" data-translate="askApp.EnumCountry.CR">CR</option><option value="DK" data-translate="askApp.EnumCountry.DK">DK</option><option value="DE" data-translate="askApp.EnumCountry.DE">DE</option><option value="DJ" data-translate="askApp.EnumCountry.DJ">DJ</option><option value="DM" data-translate="askApp.EnumCountry.DM">DM</option><option value="DO" data-translate="askApp.EnumCountry.DO">DO</option><option value="EC" data-translate="askApp.EnumCountry.EC">EC</option><option value="SV" data-translate="askApp.EnumCountry.SV">SV</option><option value="CI" data-translate="askApp.EnumCountry.CI">CI</option><option value="ER" data-translate="askApp.EnumCountry.ER">ER</option><option value="EE" data-translate="askApp.EnumCountry.EE">EE</option><option value="FK" data-translate="askApp.EnumCountry.FK">FK</option><option value="FO" data-translate="askApp.EnumCountry.FO">FO</option><option value="FJ" data-translate="askApp.EnumCountry.FJ">FJ</option><option value="FI" data-translate="askApp.EnumCountry.FI">FI</option><option value="FR" data-translate="askApp.EnumCountry.FR">FR</option><option value="GF" data-translate="askApp.EnumCountry.GF">GF</option><option value="PF" data-translate="askApp.EnumCountry.PF">PF</option><option value="TF" data-translate="askApp.EnumCountry.TF">TF</option><option value="GA" data-translate="askApp.EnumCountry.GA">GA</option><option value="GM" data-translate="askApp.EnumCountry.GM">GM</option><option value="GE" data-translate="askApp.EnumCountry.GE">GE</option><option value="GH" data-translate="askApp.EnumCountry.GH">GH</option><option value="GI" data-translate="askApp.EnumCountry.GI">GI</option><option value="GD" data-translate="askApp.EnumCountry.GD">GD</option><option value="GR" data-translate="askApp.EnumCountry.GR">GR</option><option value="GL" data-translate="askApp.EnumCountry.GL">GL</option><option value="UK" data-translate="askApp.EnumCountry.UK">UK</option><option value="GB" data-translate="askApp.EnumCountry.GB">GB</option><option value="GP" data-translate="askApp.EnumCountry.GP">GP</option><option value="GU" data-translate="askApp.EnumCountry.GU">GU</option><option value="GT" data-translate="askApp.EnumCountry.GT">GT</option><option value="GN" data-translate="askApp.EnumCountry.GN">GN</option><option value="GW" data-translate="askApp.EnumCountry.GW">GW</option><option value="GY" data-translate="askApp.EnumCountry.GY">GY</option><option value="HT" data-translate="askApp.EnumCountry.HT">HT</option><option value="HM" data-translate="askApp.EnumCountry.HM">HM</option><option value="HN" data-translate="askApp.EnumCountry.HN">HN</option><option value="HK" data-translate="askApp.EnumCountry.HK">HK</option><option value="IN" data-translate="askApp.EnumCountry.IN">IN</option><option value="ID" data-translate="askApp.EnumCountry.ID">ID</option><option value="IQ" data-translate="askApp.EnumCountry.IQ">IQ</option><option value="IR" data-translate="askApp.EnumCountry.IR">IR</option><option value="IE" data-translate="askApp.EnumCountry.IE">IE</option><option value="IS" data-translate="askApp.EnumCountry.IS">IS</option><option value="IL" data-translate="askApp.EnumCountry.IL">IL</option><option value="IT" data-translate="askApp.EnumCountry.IT">IT</option><option value="JM" data-translate="askApp.EnumCountry.JM">JM</option><option value="JP" data-translate="askApp.EnumCountry.JP">JP</option><option value="YE" data-translate="askApp.EnumCountry.YE">YE</option><option value="JO" data-translate="askApp.EnumCountry.JO">JO</option><option value="YU" data-translate="askApp.EnumCountry.YU">YU</option><option value="KY" data-translate="askApp.EnumCountry.KY">KY</option><option value="KH" data-translate="askApp.EnumCountry.KH">KH</option><option value="CM" data-translate="askApp.EnumCountry.CM">CM</option><option value="CA" data-translate="askApp.EnumCountry.CA">CA</option><option value="CV" data-translate="askApp.EnumCountry.CV">CV</option><option value="KZ" data-translate="askApp.EnumCountry.KZ">KZ</option><option value="KE" data-translate="askApp.EnumCountry.KE">KE</option><option value="KG" data-translate="askApp.EnumCountry.KG">KG</option><option value="KI" data-translate="askApp.EnumCountry.KI">KI</option><option value="CC" data-translate="askApp.EnumCountry.CC">CC</option><option value="CO" data-translate="askApp.EnumCountry.CO">CO</option><option value="KM" data-translate="askApp.EnumCountry.KM">KM</option><option value="CG" data-translate="askApp.EnumCountry.CG">CG</option><option value="CD" data-translate="askApp.EnumCountry.CD">CD</option><option value="HR" data-translate="askApp.EnumCountry.HR">HR</option><option value="CU" data-translate="askApp.EnumCountry.CU">CU</option><option value="KW" data-translate="askApp.EnumCountry.KW">KW</option><option value="LA" data-translate="askApp.EnumCountry.LA">LA</option><option value="LS" data-translate="askApp.EnumCountry.LS">LS</option><option value="LV" data-translate="askApp.EnumCountry.LV">LV</option><option value="LB" data-translate="askApp.EnumCountry.LB">LB</option><option value="LR" data-translate="askApp.EnumCountry.LR">LR</option><option value="LY" data-translate="askApp.EnumCountry.LY">LY</option><option value="LI" data-translate="askApp.EnumCountry.LI">LI</option><option value="LT" data-translate="askApp.EnumCountry.LT">LT</option><option value="LU" data-translate="askApp.EnumCountry.LU">LU</option><option value="MO" data-translate="askApp.EnumCountry.MO">MO</option><option value="MG" data-translate="askApp.EnumCountry.MG">MG</option><option value="MW" data-translate="askApp.EnumCountry.MW">MW</option><option value="MY" data-translate="askApp.EnumCountry.MY">MY</option><option value="MV" data-translate="askApp.EnumCountry.MV">MV</option><option value="ML" data-translate="askApp.EnumCountry.ML">ML</option><option value="MT" data-translate="askApp.EnumCountry.MT">MT</option><option value="MP" data-translate="askApp.EnumCountry.MP">MP</option><option value="MA" data-translate="askApp.EnumCountry.MA">MA</option><option value="MH" data-translate="askApp.EnumCountry.MH">MH</option><option value="MQ" data-translate="askApp.EnumCountry.MQ">MQ</option><option value="MR" data-translate="askApp.EnumCountry.MR">MR</option><option value="MU" data-translate="askApp.EnumCountry.MU">MU</option><option value="YT" data-translate="askApp.EnumCountry.YT">YT</option><option value="MK" data-translate="askApp.EnumCountry.MK">MK</option><option value="MX" data-translate="askApp.EnumCountry.MX">MX</option><option value="FM" data-translate="askApp.EnumCountry.FM">FM</option><option value="MZ" data-translate="askApp.EnumCountry.MZ">MZ</option><option value="MD" data-translate="askApp.EnumCountry.MD">MD</option><option value="MC" data-translate="askApp.EnumCountry.MC">MC</option><option value="MN" data-translate="askApp.EnumCountry.MN">MN</option><option value="MS" data-translate="askApp.EnumCountry.MS">MS</option><option value="NA" data-translate="askApp.EnumCountry.NA">NA</option><option value="NR" data-translate="askApp.EnumCountry.NR">NR</option><option value="NP" data-translate="askApp.EnumCountry.NP">NP</option><option value="NC" data-translate="askApp.EnumCountry.NC">NC</option><option value="NZ" data-translate="askApp.EnumCountry.NZ">NZ</option><option value="NI" data-translate="askApp.EnumCountry.NI">NI</option><option value="NL" data-translate="askApp.EnumCountry.NL">NL</option><option value="AN" data-translate="askApp.EnumCountry.AN">AN</option><option value="NE" data-translate="askApp.EnumCountry.NE">NE</option><option value="NG" data-translate="askApp.EnumCountry.NG">NG</option><option value="NU" data-translate="askApp.EnumCountry.NU">NU</option><option value="KP" data-translate="askApp.EnumCountry.KP">KP</option><option value="NF" data-translate="askApp.EnumCountry.NF">NF</option><option value="NO" data-translate="askApp.EnumCountry.NO">NO</option><option value="OM" data-translate="askApp.EnumCountry.OM">OM</option><option value="AT" data-translate="askApp.EnumCountry.AT">AT</option><option value="PK" data-translate="askApp.EnumCountry.PK">PK</option><option value="PS" data-translate="askApp.EnumCountry.PS">PS</option><option value="PW" data-translate="askApp.EnumCountry.PW">PW</option><option value="PA" data-translate="askApp.EnumCountry.PA">PA</option><option value="PG" data-translate="askApp.EnumCountry.PG">PG</option><option value="PY" data-translate="askApp.EnumCountry.PY">PY</option><option value="PE" data-translate="askApp.EnumCountry.PE">PE</option><option value="PH" data-translate="askApp.EnumCountry.PH">PH</option><option value="PN" data-translate="askApp.EnumCountry.PN">PN</option><option value="PL" data-translate="askApp.EnumCountry.PL">PL</option><option value="PT" data-translate="askApp.EnumCountry.PT">PT</option><option value="PR" data-translate="askApp.EnumCountry.PR">PR</option><option value="QA" data-translate="askApp.EnumCountry.QA">QA</option><option value="RE" data-translate="askApp.EnumCountry.RE">RE</option><option value="RW" data-translate="askApp.EnumCountry.RW">RW</option><option value="RO" data-translate="askApp.EnumCountry.RO">RO</option><option value="RU" data-translate="askApp.EnumCountry.RU">RU</option><option value="LC" data-translate="askApp.EnumCountry.LC">LC</option><option value="ZM" data-translate="askApp.EnumCountry.ZM">ZM</option><option value="AS" data-translate="askApp.EnumCountry.AS">AS</option><option value="WS" data-translate="askApp.EnumCountry.WS">WS</option><option value="SM" data-translate="askApp.EnumCountry.SM">SM</option><option value="ST" data-translate="askApp.EnumCountry.ST">ST</option><option value="SA" data-translate="askApp.EnumCountry.SA">SA</option><option value="SE" data-translate="askApp.EnumCountry.SE">SE</option><option value="CH" data-translate="askApp.EnumCountry.CH">CH</option><option value="SN" data-translate="askApp.EnumCountry.SN">SN</option><option value="SC" data-translate="askApp.EnumCountry.SC">SC</option><option value="SL" data-translate="askApp.EnumCountry.SL">SL</option><option value="SG" data-translate="askApp.EnumCountry.SG">SG</option><option value="SK" data-translate="askApp.EnumCountry.SK">SK</option><option value="SI" data-translate="askApp.EnumCountry.SI">SI</option><option value="SB" data-translate="askApp.EnumCountry.SB">SB</option><option value="SO" data-translate="askApp.EnumCountry.SO">SO</option><option value="GS" data-translate="askApp.EnumCountry.GS">GS</option><option value="ES" data-translate="askApp.EnumCountry.ES">ES</option><option value="LK" data-translate="askApp.EnumCountry.LK">LK</option><option value="SH" data-translate="askApp.EnumCountry.SH">SH</option><option value="KN" data-translate="askApp.EnumCountry.KN">KN</option><option value="PM" data-translate="askApp.EnumCountry.PM">PM</option><option value="VC" data-translate="askApp.EnumCountry.VC">VC</option><option value="KR" data-translate="askApp.EnumCountry.KR">KR</option><option value="ZA" data-translate="askApp.EnumCountry.ZA">ZA</option><option value="SD" data-translate="askApp.EnumCountry.SD">SD</option><option value="SR" data-translate="askApp.EnumCountry.SR">SR</option><option value="SJ" data-translate="askApp.EnumCountry.SJ">SJ</option><option value="SZ" data-translate="askApp.EnumCountry.SZ">SZ</option><option value="SY" data-translate="askApp.EnumCountry.SY">SY</option><option value="TJ" data-translate="askApp.EnumCountry.TJ">TJ</option><option value="TW" data-translate="askApp.EnumCountry.TW">TW</option><option value="TZ" data-translate="askApp.EnumCountry.TZ">TZ</option><option value="TH" data-translate="askApp.EnumCountry.TH">TH</option><option value="TP" data-translate="askApp.EnumCountry.TP">TP</option><option value="TG" data-translate="askApp.EnumCountry.TG">TG</option><option value="TK" data-translate="askApp.EnumCountry.TK">TK</option><option value="TO" data-translate="askApp.EnumCountry.TO">TO</option><option value="TT" data-translate="askApp.EnumCountry.TT">TT</option><option value="TD" data-translate="askApp.EnumCountry.TD">TD</option><option value="CZ" data-translate="askApp.EnumCountry.CZ">CZ</option><option value="TN" data-translate="askApp.EnumCountry.TN">TN</option><option value="TR" data-translate="askApp.EnumCountry.TR">TR</option><option value="TM" data-translate="askApp.EnumCountry.TM">TM</option><option value="TC" data-translate="askApp.EnumCountry.TC">TC</option><option value="TV" data-translate="askApp.EnumCountry.TV">TV</option><option value="UG" data-translate="askApp.EnumCountry.UG">UG</option><option value="UA" data-translate="askApp.EnumCountry.UA">UA</option><option value="HU" data-translate="askApp.EnumCountry.HU">HU</option><option value="UY" data-translate="askApp.EnumCountry.UY">UY</option><option value="UZ" data-translate="askApp.EnumCountry.UZ">UZ</option><option value="VU" data-translate="askApp.EnumCountry.VU">VU</option><option value="VA" data-translate="askApp.EnumCountry.VA">VA</option><option value="VE" data-translate="askApp.EnumCountry.VE">VE</option><option value="AE" data-translate="askApp.EnumCountry.AE">AE</option><option value="US" data-translate="askApp.EnumCountry.US">US</option><option value="VN" data-translate="askApp.EnumCountry.VN">VN</option><option value="VG" data-translate="askApp.EnumCountry.VG">VG</option><option value="VI" data-translate="askApp.EnumCountry.VI">VI</option><option value="WF" data-translate="askApp.EnumCountry.WF">WF</option><option value="BY" data-translate="askApp.EnumCountry.BY">BY</option><option value="EH" data-translate="askApp.EnumCountry.EH">EH</option><option value="CF" data-translate="askApp.EnumCountry.CF">CF</option><option value="ZW" data-translate="askApp.EnumCountry.ZW">ZW</option><option value="CY" data-translate="askApp.EnumCountry.CY">CY</option></select></div><!--------------------><!-- id type ---><!--------------------><div class="form-group"><label class="control-label" data-translate="askApp.profile.idType" for="field_idType">idType</label><select class="form-control" name="idType" ng-model="vm.profile.idType" id="field_idType" ng-change="vm.idTypeChange()"><option value=""></option><option value="idcard" data-translate="askApp.EnumIDType.idcard">idcard</option><option value="passport" data-translate="askApp.EnumIDType.passport">passport</option></select></div><!--------------------><!----- ID number------><!--------------------><div class="form-group" ng-show="vm.profile.idType"><label class="control-label" data-translate="askApp.profile.idcardNumber" for="field_idNumberidcard" ng-show="vm.profile.idType == \'idcard\'">idcard</label><label class="control-label" data-translate="askApp.profile.passportNumber" for="field_idNumberpassport" ng-show="vm.profile.idType == \'passport\'">passport</label><input type="text" class="form-control" name="idcardNumber" id="field_idNumberidcard" ng-show="vm.profile.idType == \'idcard\'" placeholder="{{\'askApp.profile.idcardNumber\' | translate}}" ng-model="vm.profile.idNumber" ng-required="vm.profile.idType == \'idcard\'" ng-minlength="3" ng-maxlength="10" maxlength="10"> <input type="text" class="form-control" name="passportNumber" id="field_idNumberpassport" ng-show="vm.profile.idType == \'passport\'" placeholder="{{\'askApp.profile.passportNumber\' | translate}}" ng-model="vm.profile.idNumber" ng-required="vm.profile.idType == \'passport\'" ng-minlength="3" ng-maxlength="10" maxlength="10"><div ng-show="editForm.idcardNumber.$dirty && editForm.idcardNumber.$invalid"><p class="help-block" ng-show="editForm.idcardNumber.$error.required" data-translate="entity.validation.required">This field is required.</p><p class="help-block" ng-show="editForm.idcardNumber.$error.minlength" data-translate="entity.validation.minlength" translate-value-min="3">This field is required to be at least 2 characters.</p><p class="help-block" ng-show="editForm.idcardNumber.$error.maxlength" data-translate="entity.validation.maxlength" translate-value-max="10">This field cannot be longer than 10 characters.</p></div><div ng-show="editForm.passportNumber.$dirty && editForm.passportNumber.$invalid"><p class="help-block" ng-show="editForm.passportNumber.$error.required" data-translate="entity.validation.required">This field is required.</p><p class="help-block" ng-show="editForm.passportNumber.$error.minlength" data-translate="entity.validation.minlength" translate-value-min="3">This field is required to be at least 2 characters.</p><p class="help-block" ng-show="editForm.passportNumber.$error.maxlength" data-translate="entity.validation.maxlength" translate-value-max="10">This field cannot be longer than 10 characters.</p></div></div><div class="form-group" ng-show="vm.profile.idType"><label class="control-label" data-translate="askApp.profile.idExpirationDate" for="field_idExpirationDate">Birthdate</label><div class="input-group"><input id="field_idExpirationDate" type="text" class="form-control" name="idExpirationDate" uib-datepicker-popup="{{\'dd.MM.yyyy\'}}" ng-model="vm.profile.idExpirationDate" datepicker-options="vm.idDateOptions" is-open="vm.datePickerOpenStatus.idExpirationDate" placeholder="{{\'askApp.profile.idExpirationDate.placeholder\' | translate}}" ng-required="vm.profile.idType"> <span class="input-group-btn"><button type="button" class="btn btn-default" ng-click="vm.openCalendar(\'idExpirationDate\')"><i class="glyphicon glyphicon-calendar"></i></button></span></div><div ng-show="editForm.idExpirationDate.$dirty && editForm.idExpirationDate.$invalid"><p class="help-block" ng-show="editForm.idExpirationDate.$error.required" data-translate="entity.validation.required">This field is required.</p></div></div><button type="submit" ng-disabled="editForm.$invalid || vm.isSaving" class="btn btn-primary" analytics-on analytics-event="Zusatzdaten aktualisiert"><span data-translate="entity.action.save">Save</span></button></form></div></div></div><div class="col-md-4"><div class="panel panel-default"><div class="panel-heading"><h3 class="panel-title">Info</h3></div><div class="panel-body"><content-cms identifier="8"></content-cms></div></div></div></div></div>');
$templateCache.put('app/member/personal/address/address.html','<!--\n  ~ Copyright (c) 2017 by Julian Feder, julian.feder@yahoo.de\n  ~\n  ~ This product includes software developed at\n  ~ The Apache Software Foundation (http://www.apache.org/).\n  --><div><div class="row row-no-padding-nested"><div class="col-md-8"><div class="panel panel-default"><div class="panel-heading"><h3 class="panel-title" data-translate="global.menu.address">Info</h3></div><div class="panel-body"><jhi-alert></jhi-alert><form name="editForm" role="form" novalidate ng-submit="vm.save()" show-validation><div class="form-group"><label class="control-label" data-translate="askApp.profile.street" for="field_street">Street</label><input type="text" class="form-control" name="street" id="field_street" ng-model="vm.profile.street" placeholder="{{\'askApp.profile.street.placeholder\' | translate}}" ng-minlength="1" ng-maxlength="50" required maxlength="50"><div ng-show="editForm.street.$invalid"><p class="help-block" ng-show="editForm.street.$error.required" data-translate="entity.validation.required">This field is required.</p><p class="help-block" ng-show="editForm.street.$error.minlength" data-translate="entity.validation.minlength" translate-value-min="1">Your mobile phone is required to be at least 1 characters.</p><p class="help-block" ng-show="editForm.street.$error.maxlength" data-translate="entity.validation.maxlength" translate-value-max="50">Your mobile phone cannot be longer than 50 characters.</p></div></div><div class="form-group"><label class="control-label" data-translate="askApp.profile.postcode" for="field_postcode">Postcode</label><input type="text" class="form-control" name="postcode" id="field_postcode" ng-model="vm.profile.postcode" placeholder="{{\'askApp.profile.postcode.placeholder\' | translate}}" ng-minlength="3" ng-maxlength="6" required maxlength="6" pattern="\\d{3,6}"><div ng-show="editForm.postcode.$invalid"><p class="help-block" ng-show="editForm.postcode.$error.required" data-translate="entity.validation.required">This field is required.</p><p class="help-block" ng-show="editForm.postcode.$error.pattern" data-translate="entity.validation.invalid">Not a valid postcode.</p><p class="help-block" ng-show="editForm.postcode.$error.minlength" data-translate="entity.validation.minlength" translate-value-min="3">Your mobile phone is required to be at least 1 characters.</p><p class="help-block" ng-show="editForm.postcode.$error.maxlength" data-translate="entity.validation.maxlength" translate-value-max="6">Your mobile phone cannot be longer than 50 characters.</p></div></div><div class="form-group"><label class="control-label" data-translate="askApp.profile.city" for="field_city">City</label><input type="text" class="form-control" name="city" id="field_city" ng-model="vm.profile.city" placeholder="{{\'askApp.profile.city.placeholder\' | translate}}" ng-minlength="1" ng-maxlength="50" maxlength="50" required><div ng-show="editForm.city.$invalid"><p class="help-block" ng-show="editForm.city.$error.required" data-translate="entity.validation.required">This field is required.</p><p class="help-block" ng-show="editForm.city.$error.minlength" data-translate="entity.validation.minlength" translate-value-min="1">This field is required to be at least 1 characters.</p><p class="help-block" ng-show="editForm.city.$error.maxlength" data-translate="entity.validation.maxlength" translate-value-max="50">This field cannot be longer than 50 characters.</p></div></div><div class="form-group"><label class="control-label" data-translate="askApp.profile.country" for="field_country">Country</label><select class="form-control" name="country" ng-model="vm.profile.country" id="field_country" required><option value="AF" data-translate="askApp.EnumCountry.AF">AF</option><option value="EG" data-translate="askApp.EnumCountry.EG">EG</option><option value="AL" data-translate="askApp.EnumCountry.AL">AL</option><option value="DZ" data-translate="askApp.EnumCountry.DZ">DZ</option><option value="AD" data-translate="askApp.EnumCountry.AD">AD</option><option value="AO" data-translate="askApp.EnumCountry.AO">AO</option><option value="AI" data-translate="askApp.EnumCountry.AI">AI</option><option value="AQ" data-translate="askApp.EnumCountry.AQ">AQ</option><option value="AG" data-translate="askApp.EnumCountry.AG">AG</option><option value="GQ" data-translate="askApp.EnumCountry.GQ">GQ</option><option value="AR" data-translate="askApp.EnumCountry.AR">AR</option><option value="AM" data-translate="askApp.EnumCountry.AM">AM</option><option value="AW" data-translate="askApp.EnumCountry.AW">AW</option><option value="AZ" data-translate="askApp.EnumCountry.AZ">AZ</option><option value="ET" data-translate="askApp.EnumCountry.ET">ET</option><option value="AU" data-translate="askApp.EnumCountry.AU">AU</option><option value="BS" data-translate="askApp.EnumCountry.BS">BS</option><option value="BH" data-translate="askApp.EnumCountry.BH">BH</option><option value="BD" data-translate="askApp.EnumCountry.BD">BD</option><option value="BB" data-translate="askApp.EnumCountry.BB">BB</option><option value="BE" data-translate="askApp.EnumCountry.BE">BE</option><option value="BZ" data-translate="askApp.EnumCountry.BZ">BZ</option><option value="BJ" data-translate="askApp.EnumCountry.BJ">BJ</option><option value="BM" data-translate="askApp.EnumCountry.BM">BM</option><option value="BT" data-translate="askApp.EnumCountry.BT">BT</option><option value="MM" data-translate="askApp.EnumCountry.MM">MM</option><option value="BO" data-translate="askApp.EnumCountry.BO">BO</option><option value="BA" data-translate="askApp.EnumCountry.BA">BA</option><option value="BW" data-translate="askApp.EnumCountry.BW">BW</option><option value="BV" data-translate="askApp.EnumCountry.BV">BV</option><option value="BR" data-translate="askApp.EnumCountry.BR">BR</option><option value="IO" data-translate="askApp.EnumCountry.IO">IO</option><option value="BN" data-translate="askApp.EnumCountry.BN">BN</option><option value="BG" data-translate="askApp.EnumCountry.BG">BG</option><option value="BF" data-translate="askApp.EnumCountry.BF">BF</option><option value="BI" data-translate="askApp.EnumCountry.BI">BI</option><option value="CL" data-translate="askApp.EnumCountry.CL">CL</option><option value="CN" data-translate="askApp.EnumCountry.CN">CN</option><option value="CX" data-translate="askApp.EnumCountry.CX">CX</option><option value="CK" data-translate="askApp.EnumCountry.CK">CK</option><option value="CR" data-translate="askApp.EnumCountry.CR">CR</option><option value="DK" data-translate="askApp.EnumCountry.DK">DK</option><option value="DE" data-translate="askApp.EnumCountry.DE">DE</option><option value="DJ" data-translate="askApp.EnumCountry.DJ">DJ</option><option value="DM" data-translate="askApp.EnumCountry.DM">DM</option><option value="DO" data-translate="askApp.EnumCountry.DO">DO</option><option value="EC" data-translate="askApp.EnumCountry.EC">EC</option><option value="SV" data-translate="askApp.EnumCountry.SV">SV</option><option value="CI" data-translate="askApp.EnumCountry.CI">CI</option><option value="ER" data-translate="askApp.EnumCountry.ER">ER</option><option value="EE" data-translate="askApp.EnumCountry.EE">EE</option><option value="FK" data-translate="askApp.EnumCountry.FK">FK</option><option value="FO" data-translate="askApp.EnumCountry.FO">FO</option><option value="FJ" data-translate="askApp.EnumCountry.FJ">FJ</option><option value="FI" data-translate="askApp.EnumCountry.FI">FI</option><option value="FR" data-translate="askApp.EnumCountry.FR">FR</option><option value="GF" data-translate="askApp.EnumCountry.GF">GF</option><option value="PF" data-translate="askApp.EnumCountry.PF">PF</option><option value="TF" data-translate="askApp.EnumCountry.TF">TF</option><option value="GA" data-translate="askApp.EnumCountry.GA">GA</option><option value="GM" data-translate="askApp.EnumCountry.GM">GM</option><option value="GE" data-translate="askApp.EnumCountry.GE">GE</option><option value="GH" data-translate="askApp.EnumCountry.GH">GH</option><option value="GI" data-translate="askApp.EnumCountry.GI">GI</option><option value="GD" data-translate="askApp.EnumCountry.GD">GD</option><option value="GR" data-translate="askApp.EnumCountry.GR">GR</option><option value="GL" data-translate="askApp.EnumCountry.GL">GL</option><option value="UK" data-translate="askApp.EnumCountry.UK">UK</option><option value="GB" data-translate="askApp.EnumCountry.GB">GB</option><option value="GP" data-translate="askApp.EnumCountry.GP">GP</option><option value="GU" data-translate="askApp.EnumCountry.GU">GU</option><option value="GT" data-translate="askApp.EnumCountry.GT">GT</option><option value="GN" data-translate="askApp.EnumCountry.GN">GN</option><option value="GW" data-translate="askApp.EnumCountry.GW">GW</option><option value="GY" data-translate="askApp.EnumCountry.GY">GY</option><option value="HT" data-translate="askApp.EnumCountry.HT">HT</option><option value="HM" data-translate="askApp.EnumCountry.HM">HM</option><option value="HN" data-translate="askApp.EnumCountry.HN">HN</option><option value="HK" data-translate="askApp.EnumCountry.HK">HK</option><option value="IN" data-translate="askApp.EnumCountry.IN">IN</option><option value="ID" data-translate="askApp.EnumCountry.ID">ID</option><option value="IQ" data-translate="askApp.EnumCountry.IQ">IQ</option><option value="IR" data-translate="askApp.EnumCountry.IR">IR</option><option value="IE" data-translate="askApp.EnumCountry.IE">IE</option><option value="IS" data-translate="askApp.EnumCountry.IS">IS</option><option value="IL" data-translate="askApp.EnumCountry.IL">IL</option><option value="IT" data-translate="askApp.EnumCountry.IT">IT</option><option value="JM" data-translate="askApp.EnumCountry.JM">JM</option><option value="JP" data-translate="askApp.EnumCountry.JP">JP</option><option value="YE" data-translate="askApp.EnumCountry.YE">YE</option><option value="JO" data-translate="askApp.EnumCountry.JO">JO</option><option value="YU" data-translate="askApp.EnumCountry.YU">YU</option><option value="KY" data-translate="askApp.EnumCountry.KY">KY</option><option value="KH" data-translate="askApp.EnumCountry.KH">KH</option><option value="CM" data-translate="askApp.EnumCountry.CM">CM</option><option value="CA" data-translate="askApp.EnumCountry.CA">CA</option><option value="CV" data-translate="askApp.EnumCountry.CV">CV</option><option value="KZ" data-translate="askApp.EnumCountry.KZ">KZ</option><option value="KE" data-translate="askApp.EnumCountry.KE">KE</option><option value="KG" data-translate="askApp.EnumCountry.KG">KG</option><option value="KI" data-translate="askApp.EnumCountry.KI">KI</option><option value="CC" data-translate="askApp.EnumCountry.CC">CC</option><option value="CO" data-translate="askApp.EnumCountry.CO">CO</option><option value="KM" data-translate="askApp.EnumCountry.KM">KM</option><option value="CG" data-translate="askApp.EnumCountry.CG">CG</option><option value="CD" data-translate="askApp.EnumCountry.CD">CD</option><option value="HR" data-translate="askApp.EnumCountry.HR">HR</option><option value="CU" data-translate="askApp.EnumCountry.CU">CU</option><option value="KW" data-translate="askApp.EnumCountry.KW">KW</option><option value="LA" data-translate="askApp.EnumCountry.LA">LA</option><option value="LS" data-translate="askApp.EnumCountry.LS">LS</option><option value="LV" data-translate="askApp.EnumCountry.LV">LV</option><option value="LB" data-translate="askApp.EnumCountry.LB">LB</option><option value="LR" data-translate="askApp.EnumCountry.LR">LR</option><option value="LY" data-translate="askApp.EnumCountry.LY">LY</option><option value="LI" data-translate="askApp.EnumCountry.LI">LI</option><option value="LT" data-translate="askApp.EnumCountry.LT">LT</option><option value="LU" data-translate="askApp.EnumCountry.LU">LU</option><option value="MO" data-translate="askApp.EnumCountry.MO">MO</option><option value="MG" data-translate="askApp.EnumCountry.MG">MG</option><option value="MW" data-translate="askApp.EnumCountry.MW">MW</option><option value="MY" data-translate="askApp.EnumCountry.MY">MY</option><option value="MV" data-translate="askApp.EnumCountry.MV">MV</option><option value="ML" data-translate="askApp.EnumCountry.ML">ML</option><option value="MT" data-translate="askApp.EnumCountry.MT">MT</option><option value="MP" data-translate="askApp.EnumCountry.MP">MP</option><option value="MA" data-translate="askApp.EnumCountry.MA">MA</option><option value="MH" data-translate="askApp.EnumCountry.MH">MH</option><option value="MQ" data-translate="askApp.EnumCountry.MQ">MQ</option><option value="MR" data-translate="askApp.EnumCountry.MR">MR</option><option value="MU" data-translate="askApp.EnumCountry.MU">MU</option><option value="YT" data-translate="askApp.EnumCountry.YT">YT</option><option value="MK" data-translate="askApp.EnumCountry.MK">MK</option><option value="MX" data-translate="askApp.EnumCountry.MX">MX</option><option value="FM" data-translate="askApp.EnumCountry.FM">FM</option><option value="MZ" data-translate="askApp.EnumCountry.MZ">MZ</option><option value="MD" data-translate="askApp.EnumCountry.MD">MD</option><option value="MC" data-translate="askApp.EnumCountry.MC">MC</option><option value="MN" data-translate="askApp.EnumCountry.MN">MN</option><option value="MS" data-translate="askApp.EnumCountry.MS">MS</option><option value="NA" data-translate="askApp.EnumCountry.NA">NA</option><option value="NR" data-translate="askApp.EnumCountry.NR">NR</option><option value="NP" data-translate="askApp.EnumCountry.NP">NP</option><option value="NC" data-translate="askApp.EnumCountry.NC">NC</option><option value="NZ" data-translate="askApp.EnumCountry.NZ">NZ</option><option value="NI" data-translate="askApp.EnumCountry.NI">NI</option><option value="NL" data-translate="askApp.EnumCountry.NL">NL</option><option value="AN" data-translate="askApp.EnumCountry.AN">AN</option><option value="NE" data-translate="askApp.EnumCountry.NE">NE</option><option value="NG" data-translate="askApp.EnumCountry.NG">NG</option><option value="NU" data-translate="askApp.EnumCountry.NU">NU</option><option value="KP" data-translate="askApp.EnumCountry.KP">KP</option><option value="NF" data-translate="askApp.EnumCountry.NF">NF</option><option value="NO" data-translate="askApp.EnumCountry.NO">NO</option><option value="OM" data-translate="askApp.EnumCountry.OM">OM</option><option value="AT" data-translate="askApp.EnumCountry.AT">AT</option><option value="PK" data-translate="askApp.EnumCountry.PK">PK</option><option value="PS" data-translate="askApp.EnumCountry.PS">PS</option><option value="PW" data-translate="askApp.EnumCountry.PW">PW</option><option value="PA" data-translate="askApp.EnumCountry.PA">PA</option><option value="PG" data-translate="askApp.EnumCountry.PG">PG</option><option value="PY" data-translate="askApp.EnumCountry.PY">PY</option><option value="PE" data-translate="askApp.EnumCountry.PE">PE</option><option value="PH" data-translate="askApp.EnumCountry.PH">PH</option><option value="PN" data-translate="askApp.EnumCountry.PN">PN</option><option value="PL" data-translate="askApp.EnumCountry.PL">PL</option><option value="PT" data-translate="askApp.EnumCountry.PT">PT</option><option value="PR" data-translate="askApp.EnumCountry.PR">PR</option><option value="QA" data-translate="askApp.EnumCountry.QA">QA</option><option value="RE" data-translate="askApp.EnumCountry.RE">RE</option><option value="RW" data-translate="askApp.EnumCountry.RW">RW</option><option value="RO" data-translate="askApp.EnumCountry.RO">RO</option><option value="RU" data-translate="askApp.EnumCountry.RU">RU</option><option value="LC" data-translate="askApp.EnumCountry.LC">LC</option><option value="ZM" data-translate="askApp.EnumCountry.ZM">ZM</option><option value="AS" data-translate="askApp.EnumCountry.AS">AS</option><option value="WS" data-translate="askApp.EnumCountry.WS">WS</option><option value="SM" data-translate="askApp.EnumCountry.SM">SM</option><option value="ST" data-translate="askApp.EnumCountry.ST">ST</option><option value="SA" data-translate="askApp.EnumCountry.SA">SA</option><option value="SE" data-translate="askApp.EnumCountry.SE">SE</option><option value="CH" data-translate="askApp.EnumCountry.CH">CH</option><option value="SN" data-translate="askApp.EnumCountry.SN">SN</option><option value="SC" data-translate="askApp.EnumCountry.SC">SC</option><option value="SL" data-translate="askApp.EnumCountry.SL">SL</option><option value="SG" data-translate="askApp.EnumCountry.SG">SG</option><option value="SK" data-translate="askApp.EnumCountry.SK">SK</option><option value="SI" data-translate="askApp.EnumCountry.SI">SI</option><option value="SB" data-translate="askApp.EnumCountry.SB">SB</option><option value="SO" data-translate="askApp.EnumCountry.SO">SO</option><option value="GS" data-translate="askApp.EnumCountry.GS">GS</option><option value="ES" data-translate="askApp.EnumCountry.ES">ES</option><option value="LK" data-translate="askApp.EnumCountry.LK">LK</option><option value="SH" data-translate="askApp.EnumCountry.SH">SH</option><option value="KN" data-translate="askApp.EnumCountry.KN">KN</option><option value="PM" data-translate="askApp.EnumCountry.PM">PM</option><option value="VC" data-translate="askApp.EnumCountry.VC">VC</option><option value="KR" data-translate="askApp.EnumCountry.KR">KR</option><option value="ZA" data-translate="askApp.EnumCountry.ZA">ZA</option><option value="SD" data-translate="askApp.EnumCountry.SD">SD</option><option value="SR" data-translate="askApp.EnumCountry.SR">SR</option><option value="SJ" data-translate="askApp.EnumCountry.SJ">SJ</option><option value="SZ" data-translate="askApp.EnumCountry.SZ">SZ</option><option value="SY" data-translate="askApp.EnumCountry.SY">SY</option><option value="TJ" data-translate="askApp.EnumCountry.TJ">TJ</option><option value="TW" data-translate="askApp.EnumCountry.TW">TW</option><option value="TZ" data-translate="askApp.EnumCountry.TZ">TZ</option><option value="TH" data-translate="askApp.EnumCountry.TH">TH</option><option value="TP" data-translate="askApp.EnumCountry.TP">TP</option><option value="TG" data-translate="askApp.EnumCountry.TG">TG</option><option value="TK" data-translate="askApp.EnumCountry.TK">TK</option><option value="TO" data-translate="askApp.EnumCountry.TO">TO</option><option value="TT" data-translate="askApp.EnumCountry.TT">TT</option><option value="TD" data-translate="askApp.EnumCountry.TD">TD</option><option value="CZ" data-translate="askApp.EnumCountry.CZ">CZ</option><option value="TN" data-translate="askApp.EnumCountry.TN">TN</option><option value="TR" data-translate="askApp.EnumCountry.TR">TR</option><option value="TM" data-translate="askApp.EnumCountry.TM">TM</option><option value="TC" data-translate="askApp.EnumCountry.TC">TC</option><option value="TV" data-translate="askApp.EnumCountry.TV">TV</option><option value="UG" data-translate="askApp.EnumCountry.UG">UG</option><option value="UA" data-translate="askApp.EnumCountry.UA">UA</option><option value="HU" data-translate="askApp.EnumCountry.HU">HU</option><option value="UY" data-translate="askApp.EnumCountry.UY">UY</option><option value="UZ" data-translate="askApp.EnumCountry.UZ">UZ</option><option value="VU" data-translate="askApp.EnumCountry.VU">VU</option><option value="VA" data-translate="askApp.EnumCountry.VA">VA</option><option value="VE" data-translate="askApp.EnumCountry.VE">VE</option><option value="AE" data-translate="askApp.EnumCountry.AE">AE</option><option value="US" data-translate="askApp.EnumCountry.US">US</option><option value="VN" data-translate="askApp.EnumCountry.VN">VN</option><option value="VG" data-translate="askApp.EnumCountry.VG">VG</option><option value="VI" data-translate="askApp.EnumCountry.VI">VI</option><option value="WF" data-translate="askApp.EnumCountry.WF">WF</option><option value="BY" data-translate="askApp.EnumCountry.BY">BY</option><option value="EH" data-translate="askApp.EnumCountry.EH">EH</option><option value="CF" data-translate="askApp.EnumCountry.CF">CF</option><option value="ZW" data-translate="askApp.EnumCountry.ZW">ZW</option><option value="CY" data-translate="askApp.EnumCountry.CY">CY</option></select><div ng-show="editForm.country.$invalid"><p class="help-block" ng-show="editForm.country.$error.required" data-translate="entity.validation.required">This field is required.</p></div></div><button type="submit" ng-disabled="editForm.$invalid || vm.isSaving" class="btn btn-primary"><span data-translate="entity.action.save">Save</span></button></form></div></div></div><div class="col-md-4"><div class="panel panel-default"><div class="panel-heading"><h3 class="panel-title">Info</h3></div><div class="panel-body"><content-cms identifier="9"></content-cms></div></div></div></div></div>');
$templateCache.put('app/member/personal/password/password.html','<!--\n  ~ Copyright (c) 2017 by Julian Feder, julian.feder@yahoo.de\n  ~\n  ~ This product includes software developed at\n  ~ The Apache Software Foundation (http://www.apache.org/).\n  --><div><div class="row row-no-padding-nested"><div class="col-md-8"><div class="panel panel-default"><div class="panel-heading"><h3 class="panel-title" data-translate="global.menu.password">Meine Daten</h3></div><div class="panel-body"><div class="alert alert-success" ng-show="vm.success" data-translate="password.messages.success"><strong>Password changed!</strong></div><div class="alert alert-danger" ng-show="vm.error" data-translate="password.messages.error"><strong>An error has occurred!</strong> The password could not be changed.</div><div class="alert alert-danger" ng-show="vm.doNotMatch" data-translate="global.messages.error.dontmatch">The password and its confirmation do not match!</div><form name="form" role="form" novalidate ng-submit="vm.changePassword()" show-validation><div class="form-group"><label class="control-label" for="password" data-translate="global.form.newpassword">New password</label><input type="password" class="form-control" id="password" name="password" placeholder="{{\'global.form.newpassword.placeholder\' | translate}}" ng-model="vm.password" ng-minlength="4" ng-maxlength="50" required><div ng-show="form.password.$dirty && form.password.$invalid"><p class="help-block" ng-show="form.password.$error.required" data-translate="global.messages.validate.newpassword.required">Your password is required.</p><p class="help-block" ng-show="form.password.$error.minlength" data-translate="global.messages.validate.newpassword.minlength">Your password is required to be at least 4 characters.</p><p class="help-block" ng-show="form.password.$error.maxlength" data-translate="global.messages.validate.newpassword.maxlength">Your password cannot be longer than 50 characters.</p></div><password-strength-bar password-to-check="vm.password"></password-strength-bar></div><div class="form-group"><label class="control-label" for="confirmPassword" data-translate="global.form.confirmpassword">New password confirmation</label><input type="password" class="form-control" id="confirmPassword" name="confirmPassword" placeholder="{{\'global.form.confirmpassword.placeholder\' | translate}}" ng-model="vm.confirmPassword" ng-minlength="4" ng-maxlength="50" required><div ng-show="form.confirmPassword.$dirty && form.confirmPassword.$invalid"><p class="help-block" ng-show="form.confirmPassword.$error.required" data-translate="global.messages.validate.confirmpassword.required">Your confirmation password is required.</p><p class="help-block" ng-show="form.confirmPassword.$error.minlength" data-translate="global.messages.validate.confirmpassword.minlength">Your confirmation password is required to be at least 4 characters.</p><p class="help-block" ng-show="form.confirmPassword.$error.maxlength" data-translate="global.messages.validate.confirmpassword.maxlength">Your confirmation password cannot be longer than 50 characters.</p></div></div><button type="submit" ng-disabled="form.$invalid" class="btn btn-primary" data-translate="password.form.button">Save</button></form></div></div></div><div class="col-md-4"><div class="panel panel-default"><div class="panel-heading"><h3 class="panel-title">Info</h3></div><div class="panel-body"><content-cms identifier="11"></content-cms></div></div></div></div></div>');
$templateCache.put('app/member/personal/payment/payment.html','<!--\n  ~ Copyright (c) 2017 by Julian Feder, julian.feder@yahoo.de\n  ~\n  ~ This product includes software developed at\n  ~ The Apache Software Foundation (http://www.apache.org/).\n  --><div><div class="row row-no-padding-nested"><div class="col-md-8"><div class="panel panel-default"><div class="panel-heading"><h3 class="panel-title" data-translate="global.menu.payment">Meine Daten</h3></div><div class="panel-body"><jhi-alert></jhi-alert><form name="form" role="form" novalidate ng-submit="vm.save()" show-validation><!--------------------><!-- is using sepa ---><!--------------------><div class="form-group"><div class="btn-group btn-group-justified"><label class="btn btn-default" ng-model="vm.profile.isUsingSepa" uib-btn-radio="false"><span data-translate="global.form.button.transfer">per \xDCberweisung</span></label><label class="btn btn-default" ng-model="vm.profile.isUsingSepa" uib-btn-radio="true"><span data-translate="global.form.button.direct">per Lastschrift</span></label></div></div><!--<h3 ng-show="vm.profile.isUsingSepa == true" data-translate="global.form.account.heading">Kontodaten</h3>--><!--------------------><!------ iban --------><!--------------------><div class="form-group" ng-show="vm.profile.isUsingSepa == true"><label class="control-label" data-translate="askApp.profile.iban" for="field_iban">Iban</label><div class="input-group" ng-if="vm.profile.ibanHidden"><span class="input-group-addon">{{vm.profile.ibanHidden}} </span><input type="text" class="form-control" name="iban" id="field_iban" ng-model="vm.ibanInput" ng-iban ng-minlength="18" ng-maxlength="30" maxlength="30" ng-required="vm.profile.isUsingSepa == true" placeholder="{{\'askApp.profile.iban.change.placeholder\' | translate}}" required></div><div ng-if="!vm.profile.ibanHidden"><input type="text" class="form-control" name="iban" id="field_iban2" ng-model="vm.ibanInput" ng-iban ng-minlength="18" ng-maxlength="30" maxlength="30" ng-required="vm.profile.isUsingSepa == true" placeholder="{{\'askApp.profile.iban.placeholder\' | translate}}" required></div><div ng-show="form.iban.$dirty && form.iban.$invalid"><p class="help-block" ng-show="form.iban.$error.required" data-translate="entity.validation.required">This field is required.</p><p class="help-block" ng-show="form.iban.$error.ngIban" data-translate="entity.validation.invalid">Not a valid IBAN.</p><p class="help-block" ng-show="form.iban.$error.minlength" data-translate="entity.validation.minlength" translate-value-min="18">Your IBAN is required to be at least 18 characters.</p><p class="help-block" ng-show="form.iban.$error.maxlength" data-translate="entity.validation.maxlength" translate-value-max="30">Your IBAN cannot be longer than 30 characters.</p></div></div><!--------------------><!------ bic ---------><!--------------------><div class="form-group" ng-show="vm.profile.isUsingSepa == true"><label class="control-label" data-translate="askApp.profile.bic" for="field_bic">Bic</label><div class="input-group" ng-if="vm.profile.bicHidden"><span class="input-group-addon">{{vm.profile.bicHidden}} </span><input type="text" class="form-control" name="bic" id="field_bic" ng-model="vm.bicInput" ng-minlength="8" ng-maxlength="11" maxlength="11" ng-required="vm.profile.isUsingSepa == true" pattern="([a-zA-Z]{4}[a-zA-Z]{2}[a-zA-Z0-9]{2}([a-zA-Z0-9]{3})?)" placeholder="{{\'askApp.profile.bic.change.placeholder\' | translate}}"></div><div ng-if="!vm.profile.bicHidden"><input type="text" class="form-control" name="bic" id="field_bic" ng-model="vm.bicInput" ng-minlength="8" ng-maxlength="11" maxlength="11" ng-required="vm.profile.isUsingSepa == true" pattern="([a-zA-Z]{4}[a-zA-Z]{2}[a-zA-Z0-9]{2}([a-zA-Z0-9]{3})?)" placeholder="{{\'askApp.profile.bic.placeholder\' | translate}}"></div><div ng-show="form.bic.$dirty && form.bic.$invalid"><p class="help-block" ng-show="form.bic.$error.required" data-translate="entity.validation.required">This field is required.</p><p class="help-block" ng-show="form.bic.$error.pattern" data-translate="entity.validation.invalid">Not a valid IBAN.</p><p class="help-block" ng-show="form.bic.$error.minlength" data-translate="entity.validation.minlength" translate-value-min="8">Your IBAN is required to be at least 8 characters.</p><p class="help-block" ng-show="form.bic.$error.maxlength" data-translate="entity.validation.maxlength" translate-value-max="11">Your IBAN cannot be longer than 11 characters.</p></div></div><!--------------------><!-- banc account hol->\n                        <!--------------------><div class="form-group" ng-show="vm.profile.isUsingSepa == true"><label class="control-label" for="bankAccountHolder.deviated" data-translate="global.form.bankAccountHolder.deviated">Deviated</label><div class="btn-group btn-group-justified" id="bankAccountHolder.deviated"><label class="btn btn-default" ng-model="vm.profile.isDeviatedHolder" ng-click="vm.truncateBancAccountHolder()" uib-btn-radio="false"><span data-translate="global.form.button.no">Nein</span></label><label class="btn btn-default" ng-model="vm.profile.isDeviatedHolder" ng-click="vm.truncateBancAccountHolder()" uib-btn-radio="true"><span data-translate="global.form.button.yes">Ja</span></label></div></div><div class="form-group" ng-show="vm.profile.isUsingSepa == true"><label class="control-label" data-translate="askApp.profile.bankAccountHolder" for="field_bankAccountHolder">Bank Account Holder</label><input type="text" class="form-control" name="bankAccountHolder" id="field_bankAccountHolder" ng-model="vm.profile.bankAccountHolder" placeholder="{{vm.profile.user.firstName + \' \' + vm.profile.user.lastName}}" ng-disabled="vm.profile.isDeviatedHolder == false" ng-required="vm.profile.isDeviatedHolder == true" ng-minlength="1" ng-maxlength="100" maxlength="100"><div ng-show="form.bankAccountHolder.$dirty && form.bankAccountHolder.$invalid"><p class="help-block" ng-show="form.bankAccountHolder.$error.required" data-translate="entity.validation.required">This field is required.</p><p class="help-block" ng-show="form.bankAccountHolder.$error.minlength" data-translate="entity.validation.minlength" translate-value-min="1">Your mobile phone is required to be at least 1 characters.</p><p class="help-block" ng-show="form.bankAccountHolder.$error.maxlength" data-translate="entity.validation.maxlength" translate-value-max="100">Your mobile phone cannot be longer than 100 characters.</p></div></div><button type="submit" ng-disabled="form.$invalid || vm.isSaving" class="btn btn-primary"><span data-translate="entity.action.save">Save</span></button></form></div></div></div><div class="col-md-4"><div class="panel panel-default"><div class="panel-heading"><h3 class="panel-title">Info</h3></div><div class="panel-body"><content-cms identifier="10"></content-cms></div></div></div></div></div>');
$templateCache.put('app/member/personal/profile/profile.html','<!--\n  ~ Copyright (c) 2017 by Julian Feder, julian.feder@yahoo.de\n  ~\n  ~ This product includes software developed at\n  ~ The Apache Software Foundation (http://www.apache.org/).\n  --><div><div class="row row-no-padding-nested"><div class="col-md-8"><div class="panel panel-default"><div class="panel-heading"><h3 class="panel-title" data-translate="global.menu.personal">Meine Daten</h3></div><div class="panel-body"><jhi-alert></jhi-alert><form name="editForm" role="form" novalidate ng-submit="vm.save()" show-validation><div class="form-group"><label class="control-label" for="memberStatus">Status</label><br><span class="label label-info" id="memberStatus" data-translate="{{\'askApp.EnumMemberStatus.long.\' + vm.profile.memberStatus}}">Ja</span></div><!--------------------><!----- Member No. ---><!--------------------><div class="form-group"><label class="control-label" ng-show="vm.profile.memberStatus == \'voll\' || vm.profile.memberStatus == \'probe\'" for="memberNumber" data-translate="settings.form.memberNumber">Member umber</label><label class="control-label" ng-show="vm.profile.memberStatus == \'gast\'" for="memberNumber" data-translate="settings.form.memberNumberGuest">Member umber</label><input type="text" class="form-control" id="memberNumber" name="firstName" placeholder="{{\'settings.form.memberNumber.placeholder\' | translate}}" ng-model="vm.profile.user.login" disabled="disabled"></div><!--------------------><!----- Firstname ----><!--------------------><div class="form-group"><label class="control-label" for="firstName" data-translate="settings.form.firstname">First Name</label><input type="text" class="form-control" id="firstName" name="firstName" placeholder="{{\'settings.form.firstname.placeholder\' | translate}}" ng-model="vm.profile.user.firstName" disabled="disabled"></div><!--------------------><!----- Nickname ----><!--------------------><div class="form-group"><label class="control-label" for="nickname" data-translate="askApp.profile.nickname.hint">Nickname</label><input type="text" class="form-control" id="nickname" name="nickname" placeholder="{{\'askApp.profile.nickname.placeholder\' | translate: {nickname: vm.profile.user.firstName} }}" ng-model="vm.profile.nickname"></div><!--------------------><!----- Lastname -----><!--------------------><div class="form-group"><label class="control-label" for="lastName" data-translate="settings.form.lastname">Last Name</label><input type="text" class="form-control" id="lastName" name="lastName" placeholder="{{\'settings.form.lastname.placeholder\' | translate}}" ng-model="vm.profile.user.lastName" disabled="disabled"></div><!--------------------><!----- Birthdate ----><!--------------------><div class="form-group"><label class="control-label" data-translate="askApp.profile.birthdate" for="field_birthdate">Birthdate</label><input id="field_birthdate" type="text" class="form-control" name="birthdate" ng-value="vm.profile.birthdate | date:\'mediumDate\'" disabled="disabled"></div><!--------------------><!------- Phone ------><!--------------------><div class="form-group"><label class="control-label" data-translate="askApp.profile.phone" for="field_phone">Phone</label><input type="text" class="form-control" name="phone" id="field_phone" ng-model="vm.profile.phone" required ng-minlength="5" ng-maxlength="16" maxlength="16" placeholder="{{\'askApp.profile.phone.placeholder\' | translate}}" pattern="^\\+[1-9]\\d{1,16}$"><div ng-show="editForm.phone.$dirty && editForm.phone.$invalid"><p class="help-block" ng-show="editForm.phone.$error.required" data-translate="entity.validation.required">This field is required.</p><p class="help-block" ng-show="editForm.phone.$error.pattern" data-translate="entity.validation.invalid">Your mobile phone does not math the E.164 format for phone numbers.</p><p class="help-block" ng-show="editForm.phone.$error.minlength" data-translate="entity.validation.minlength" translate-value-min="5">Your mobile phone is required to be at least 5 characters.</p><p class="help-block" ng-show="editForm.phone.$error.maxlength" data-translate="entity.validation.maxlength" translate-value-min="15">Your mobile phone cannot be longer than 15 characters.</p></div></div><!--------------------><!-------- Mail ------><!--------------------><div class="form-group"><label class="control-label" for="email" data-translate="global.form.email">Email</label><input type="email" class="form-control" id="email" name="email" placeholder="{{\'global.form.email.placeholder\' | translate}}" ng-model="vm.profile.user.email" ng-minlength="5" ng-maxlength="50" required disabled="disabled" maxlength="50"><div ng-show="form.email.$dirty && form.email.$invalid"><p class="help-block" ng-show="form.email.$error.required" data-translate="global.messages.validate.email.required">Your email is required.</p><p class="help-block" ng-show="form.email.$error.email" data-translate="global.messages.validate.email.invalid">Your email is invalid.</p><p class="help-block" ng-show="form.email.$error.minlength" data-translate="global.messages.validate.email.minlength">Your email is required to be at least 5 characters.</p><p class="help-block" ng-show="form.email.$error.maxlength" data-translate="global.messages.validate.email.maxlength">Your email cannot be longer than 50 characters.</p></div></div><!--------------------><!----- Language -----><!--------------------><!--<div class="form-group">\n                            <label for="langKey" data-translate="settings.form.language">Language</label>\n                            <select id="langKey" name="langKey" class="form-control" ng-model="vm.profile.user.langKey" ng-controller="JhiLanguageController as languageVm" ng-options="code as (code | findLanguageFromKey) for code in languageVm.languages"></select>\n                        </div>--> <button type="submit" ng-disabled="editForm.$invalid || vm.isSaving" class="btn btn-primary"><span data-translate="entity.action.save">Save</span></button></form></div></div></div><div class="col-md-4"><div class="panel panel-default"><div class="panel-heading"><h3 class="panel-title">Info</h3></div><div class="panel-body"><content-cms identifier="7"></content-cms></div></div></div></div></div>');
$templateCache.put('app/member/personal/certificates/certificates.html','<!--\n  ~ Copyright (c) 2017 by Julian Feder, julian.feder@yahoo.de\n  ~\n  ~ This product includes software developed at\n  ~ The Apache Software Foundation (http://www.apache.org/).\n  --><div><div class="row row-no-padding-nested"><div class="col-md-8"><div class="panel panel-default"><div class="panel-heading"><h3 class="panel-title" data-translate="global.menu.license">Meine Daten</h3></div><div class="panel-body"><jhi-alert></jhi-alert><form name="editForm" role="form" novalidate ng-submit="vm.save()" show-validation><div class="form-group"><label class="control-label" data-translate="askApp.profile.sbfBinnen" for="field_sbfBinnen">sbfBinnen</label><input type="text" class="form-control" name="sbfBinnen" id="field_sbfBinnen" ng-model="vm.profile.sbfBinnen" placeholder="{{\'askApp.profile.sbfBinnen.placeholder\' | translate}}" ng-minlength="3" ng-maxlength="15" maxlength="15"><div ng-show="editForm.sbfBinnen.$invalid"><p class="help-block" ng-show="editForm.sbfBinnen.$error.minlength" data-translate="entity.validation.minlength" translate-value-min="3">This field is required to be at least 1 characters.</p><p class="help-block" ng-show="editForm.sbfBinnen.$error.maxlength" data-translate="entity.validation.maxlength" translate-value-max="15">This field cannot be longer than 50 characters.</p></div></div><div class="form-group"><label class="control-label" data-translate="askApp.profile.bsp" for="field_bsp">bsp</label><input type="text" class="form-control" name="bsp" id="field_bsp" ng-model="vm.profile.bsp" placeholder="{{\'askApp.profile.bsp.placeholder\' | translate}}" ng-minlength="3" ng-maxlength="15" maxlength="15"><div ng-show="editForm.bsp.$invalid"><p class="help-block" ng-show="editForm.bsp.$error.minlength" data-translate="entity.validation.minlength" translate-value-min="3">This field is required to be at least 1 characters.</p><p class="help-block" ng-show="editForm.bsp.$error.maxlength" data-translate="entity.validation.maxlength" translate-value-max="15">This field cannot be longer than 50 characters.</p></div></div><div class="form-group"><label class="control-label" data-translate="askApp.profile.sbfSee" for="field_sbfSee">sbfSee</label><input type="text" class="form-control" name="sbfSee" id="field_sbfSee" ng-model="vm.profile.sbfSee" placeholder="{{\'askApp.profile.sbfSee.placeholder\' | translate}}" ng-minlength="3" ng-maxlength="15" maxlength="15"><div ng-show="editForm.sbfSee.$invalid"><p class="help-block" ng-show="editForm.sbfSee.$error.minlength" data-translate="entity.validation.minlength" translate-value-min="3">This field is required to be at least 1 characters.</p><p class="help-block" ng-show="editForm.sbfSee.$error.maxlength" data-translate="entity.validation.maxlength" translate-value-max="15">This field cannot be longer than 50 characters.</p></div></div><div class="form-group"><label class="control-label" data-translate="askApp.profile.sks" for="field_sks">sks</label><input type="text" class="form-control" name="sks" id="field_sks" ng-model="vm.profile.sks" placeholder="{{\'askApp.profile.sks.placeholder\' | translate}}" ng-minlength="3" ng-maxlength="15" maxlength="15"><div ng-show="editForm.sks.$invalid"><p class="help-block" ng-show="editForm.sks.$error.minlength" data-translate="entity.validation.minlength" translate-value-min="3">This field is required to be at least 1 characters.</p><p class="help-block" ng-show="editForm.sks.$error.maxlength" data-translate="entity.validation.maxlength" translate-value-max="15">This field cannot be longer than 50 characters.</p></div></div><div class="form-group"><label class="control-label" data-translate="askApp.profile.sss" for="field_sss">sss</label><input type="text" class="form-control" name="sss" id="field_sss" ng-model="vm.profile.sss" placeholder="{{\'askApp.profile.sss.placeholder\' | translate}}" ng-minlength="3" ng-maxlength="15" maxlength="15"><div ng-show="editForm.sss.$invalid"><p class="help-block" ng-show="editForm.sss.$error.minlength" data-translate="entity.validation.minlength" translate-value-min="3">This field is required to be at least 1 characters.</p><p class="help-block" ng-show="editForm.sss.$error.maxlength" data-translate="entity.validation.maxlength" translate-value-max="15">This field cannot be longer than 50 characters.</p></div></div><div class="form-group"><label class="control-label" data-translate="askApp.profile.shs" for="field_shs">shs</label><input type="text" class="form-control" name="shs" id="field_shs" ng-model="vm.profile.shs" placeholder="{{\'askApp.profile.shs.placeholder\' | translate}}" ng-minlength="3" ng-maxlength="15" maxlength="15"><div ng-show="editForm.shs.$invalid"><p class="help-block" ng-show="editForm.shs.$error.minlength" data-translate="entity.validation.minlength" translate-value-min="3">This field is required to be at least 1 characters.</p><p class="help-block" ng-show="editForm.shs.$error.maxlength" data-translate="entity.validation.maxlength" translate-value-max="15">This field cannot be longer than 50 characters.</p></div></div><div class="form-group"><label class="control-label" data-translate="askApp.profile.ubi" for="field_ubi">ubi</label><input type="text" class="form-control" name="ubi" id="field_ubi" ng-model="vm.profile.ubi" placeholder="{{\'askApp.profile.ubi.placeholder\' | translate}}" ng-minlength="3" ng-maxlength="15" maxlength="15"><div ng-show="editForm.ubi.$invalid"><p class="help-block" ng-show="editForm.ubi.$error.minlength" data-translate="entity.validation.minlength" translate-value-min="3">This field is required to be at least 1 characters.</p><p class="help-block" ng-show="editForm.ubi.$error.maxlength" data-translate="entity.validation.maxlength" translate-value-max="15">This field cannot be longer than 50 characters.</p></div></div><div class="form-group"><label class="control-label" data-translate="askApp.profile.src" for="field_src">src</label><input type="text" class="form-control" name="src" id="field_src" ng-model="vm.profile.src" placeholder="{{\'askApp.profile.src.placeholder\' | translate}}" ng-minlength="3" ng-maxlength="15" maxlength="15"><div ng-show="editForm.src.$invalid"><p class="help-block" ng-show="editForm.src.$error.minlength" data-translate="entity.validation.minlength" translate-value-min="3">This field is required to be at least 1 characters.</p><p class="help-block" ng-show="editForm.src.$error.maxlength" data-translate="entity.validation.maxlength" translate-value-max="15">This field cannot be longer than 50 characters.</p></div></div><div class="form-group"><label class="control-label" data-translate="askApp.profile.lrc" for="field_lrc">lrc</label><input type="text" class="form-control" name="lrc" id="field_lrc" ng-model="vm.profile.lrc" placeholder="{{\'askApp.profile.lrc.placeholder\' | translate}}" ng-minlength="3" ng-maxlength="15" maxlength="15"><div ng-show="editForm.lrc.$invalid"><p class="help-block" ng-show="editForm.lrc.$error.minlength" data-translate="entity.validation.minlength" translate-value-min="3">This field is required to be at least 1 characters.</p><p class="help-block" ng-show="editForm.lrc.$error.maxlength" data-translate="entity.validation.maxlength" translate-value-max="15">This field cannot be longer than 50 characters.</p></div></div><div class="form-group"><label class="control-label" data-translate="askApp.profile.fkn" for="field_fkn">fkn</label><input type="text" class="form-control" name="fkn" id="field_fkn" ng-model="vm.profile.fkn" placeholder="{{\'askApp.profile.fkn.placeholder\' | translate}}" ng-minlength="3" ng-maxlength="15" maxlength="15"><div ng-show="editForm.fkn.$invalid"><p class="help-block" ng-show="editForm.fkn.$error.minlength" data-translate="entity.validation.minlength" translate-value-min="3">This field is required to be at least 1 characters.</p><p class="help-block" ng-show="editForm.fkn.$error.maxlength" data-translate="entity.validation.maxlength" translate-value-max="15">This field cannot be longer than 50 characters.</p></div></div><div class="form-group"><label class="control-label" data-translate="askApp.profile.isaf" for="field_isaf">isaf</label><input type="text" class="form-control" name="isaf" id="field_isaf" ng-model="vm.profile.isaf" ng-change="vm.isafChange()" placeholder="{{\'askApp.profile.isaf.placeholder\' | translate}}" ng-minlength="3" ng-maxlength="15" maxlength="15"><div ng-show="editForm.isaf.$invalid"><p class="help-block" ng-show="editForm.isaf.$error.minlength" data-translate="entity.validation.minlength" translate-value-min="3">This field is required to be at least 1 characters.</p><p class="help-block" ng-show="editForm.isaf.$error.maxlength" data-translate="entity.validation.maxlength" translate-value-max="15">This field cannot be longer than 50 characters.</p></div></div><div class="form-group" ng-show="vm.profile.isaf"><label class="control-label" data-translate="askApp.profile.isafDate" for="field_isafDate">isafDate</label><div class="input-group"><input type="text" class="form-control" name="isafDate" id="field_isafDate" uib-datepicker-popup="{{\'dd.MM.yyyy\'}}" ng-model="vm.profile.isafDate" is-open="vm.datePickerOpenStatus.isafDate" ng-required="vm.profile.isaf" placeholder="{{\'askApp.profile.isafDate.placeholder\' | translate}}"> <span class="input-group-btn"><button type="button" class="btn btn-default" ng-click="vm.openCalendar(\'isafDate\')"><i class="glyphicon glyphicon-calendar"></i></button></span></div><div ng-show="editForm.isafDate.$dirty && editForm.isafDate.$invalid"><p class="help-block" ng-show="editForm.isafDate.$error.required" data-translate="entity.validation.required">This field is required.</p></div></div><button type="submit" ng-disabled="editForm.$invalid || vm.isSaving" class="btn btn-primary" analytics-on analytics-event="Zusatzdaten aktualisiert"><span data-translate="entity.action.save">Save</span></button></form></div></div></div><div class="col-md-4"><div class="panel panel-default"><div class="panel-heading"><h3 class="panel-title">Info</h3></div><div class="panel-body"><content-cms identifier="24"></content-cms></div></div></div></div></div>');
$templateCache.put('app/member/personal/student/student.html','<!--\n  ~ Copyright (c) 2017 by Julian Feder, julian.feder@yahoo.de\n  ~\n  ~ This product includes software developed at\n  ~ The Apache Software Foundation (http://www.apache.org/).\n  --><div><div class="row row-no-padding-nested"><div class="col-md-8"><div class="panel panel-default"><div class="panel-heading"><h3 class="panel-title" data-translate="global.menu.student">Meine Daten</h3></div><div class="panel-body"><jhi-alert></jhi-alert><form name="form" role="form" novalidate ng-submit="vm.save()" show-validation><!--------------------><!---- Student -------><!--------------------><label class="control-label" data-translate="askApp.profile.label.student">Bist du aktuell Student</label><div class="form-group"><div class="btn-group btn-group-justified" id="isStudent"><label class="btn btn-default" ng-model="vm.profile.isStudent" uib-btn-radio="false" tabindex="0"><span data-translate="global.form.button.no">Nein</span></label><label class="btn btn-default" ng-model="vm.profile.isStudent" uib-btn-radio="true" tabindex="0"><span data-translate="global.form.button.yes">Ja</span></label></div></div><!---------------------><!-- Immatriculation --><!---------------------><div class="form-group" ng-show="vm.profile.isStudent == true"><div ng-show="vm.profile.matriculationDate"><div class="alert alert-info" ng-if="vm.daysLeft > 1">Dein Studentenstatus l\xE4uft in <b>{{vm.daysLeft}}</b> Tagen ab. <span ng-if="vm.daysLeft <= 14">Lade eine aktuelle Immatrikulationsbescheinigung hoch um deinen Studentenstatus zu behalten.</span></div><div class="alert alert-info" ng-if="vm.daysLeft == 1">Dein Studentenstatus l\xE4uft <b>morgen</b> ab. <span ng-if="vm.daysLeft <= 14">Lade eine aktuelle Immatrikulationsbescheinigung hoch um deinen Studentenstatus zu behalten.</span></div><div class="alert alert-info" ng-if="vm.daysLeft == 0">Dein Studentenstatus l\xE4uft <b>heute</b> ab. <span ng-if="vm.daysLeft <= 14">Lade eine aktuelle Immatrikulationsbescheinigung hoch um deinen Studentenstatus zu behalten.</span></div></div><div class="form-group" ngf-drop ngf-change="vm.setMatriculationCertificate($file, vm.profile)"><label class="control-label" data-translate="global.form.matriculationCertificate" for="field_matriculationCertificate">Matriculation Certificate</label><div><div ng-if="vm.profile.matriculationCertificate" class="help-block clearfix"><a ng-click="vm.openFile(vm.profile.matriculationCertificateContentType, vm.profile.matriculationCertificate)"><span class="glyphicon glyphicon-file" aria-hidden="true" style="font-size: 50px"></span><!--<i class="fa fa-file-pdf-o fa-3x" aria-hidden="true"></i>--></a><!--<span class="pull-left">{{vm.profile.matriculationCertificateContentType}}, {{vm.byteSize(vm.profile.matriculationCertificate)}}</span>--> <button type="button" ng-click="vm.profile.matriculationCertificate=null;vm.profile.matriculationCertificateContentType=null;" class="btn btn-default btn-xs pull-right"><span class="glyphicon glyphicon-remove"></span></button></div><button type="button" ngf-select class="btn btn-default btn-block" ngf-change="vm.setMatriculationCertificate($file, vm.profile)" data-translate="global.form.addMatriculationCertificate" tabindex="0">Add blob</button><div><p class="help-block" ng-show="vm.errorWrongFormat && vm.profile.isStudent == true" data-translate="register.messages.error.wrongformat" style="color:#a94442">This field is required.</p><p class="help-block" ng-show="vm.errorMaxUploadSize && vm.profile.isStudent == true" data-translate="register.messages.error.maxuploadsize" style="color:#a94442"><strong>Max. 2MB allowed!</strong> Please decrease file size.</p><p class="help-block" ng-show="!vm.profile.matriculationCertificate && vm.profile.isStudent == true" data-translate="register.messages.error.matriculationRequired" style="color:#a94442"><strong>Max. 2MB allowed!</strong> Please decrease file size.</p></div></div><input type="hidden" class="form-control" name="matriculationCertificate" id="field_matriculationCertificate" ng-required="vm.profile.isStudent == true" ng-model="vm.profile.matriculationCertificate"> <input type="hidden" class="form-control" name="matriculationCertificateContentType" id="field_matriculationCertificateContentType" ng-required="vm.profile.isStudent == true" ng-model="vm.profile.matriculationCertificateContentType"></div></div><!--------------------><!---- university ----><!--------------------><div class="form-group" ng-show="!vm.profile.isStudent"><label class="control-label" data-translate="askApp.profile.label.university">Warst du mal an einer Uni</label><div class="btn-group btn-group-justified"><label class="btn btn-default" ng-model="vm.university" uib-btn-radio="false" tabindex="0"><span data-translate="global.form.button.no">Nein</span></label><label class="btn btn-default" ng-model="vm.university" uib-btn-radio="true" tabindex="0"><span data-translate="global.form.button.yes">Ja</span></label></div></div><div class="form-group" ng-show="vm.university || vm.profile.isStudent"><label class="control-label" data-translate="askApp.profile.university.university" ng-show="!vm.profile.isStudent" for="field_university">Hochschule</label><label class="control-label" data-translate="askApp.profile.university.universityStudent" ng-show="vm.profile.isStudent" for="field_university">Hochschule</label><input type="text" class="form-control" name="university" id="field_university" ng-model="vm.profile.university" ng-required="vm.university || vm.profile.isStudent" placeholder="{{\'askApp.profile.university.placeholder\' | translate}}" tabindex="0"><div ng-show="editForm.university.$invalid"><p class="help-block" ng-show="editForm.university.$error.required" data-translate="entity.validation.required">This field is required.</p></div></div><button type="submit" ng-disabled="form.$invalid || vm.isSaving || (!vm.fileIsNew && vm.oldUniversity == vm.profile.university && vm.profile.matriculationCertificate && vm.profile.isStudent)" class="btn btn-primary"><span data-translate="entity.action.save">Save</span></button></form></div></div></div><div class="col-md-4"><div class="panel panel-default"><div class="panel-heading"><h3 class="panel-title">Info</h3></div><div class="panel-body"><content-cms identifier="12"></content-cms></div></div></div></div></div>');
$templateCache.put('app/board/dinghy/event/detail/dinghyEventNavbar.html','<!--\n  ~ Copyright (c) 2020 by Felix Heim, felix-heim@web.de\n  ~\n  ~ This product includes software developed at\n  ~ The Apache Software Foundation (http://www.apache.org/).\n  --><div><div class="row row-no-padding"><div class="col-md-12"><ol class="breadcrumb"><li><span data-translate="global.menu.board.dinghy">Dingy</span></li><li><a ui-sref="board.dinghy.event" data-translate="askApp.dinghyEvent.detail.title">Dingy</a></li><li class="active">{{vm.dinghyEvent.name}}</li></ol></div></div><div class="row row-no-padding"><div class="col-md-2"><div class="panel panel-default"><ul class="nav nav-pills nav-stacked" style="margin: 0"><li role="presentation" ui-sref-active="active"><a ui-sref="board.dinghy.event.detail.overview({id:vm.id})" data-translate="askApp.dinghyEvent.detail.homeTitle">\xDCbersicht</a></li><li role="presentation" ui-sref-active="active"><a ui-sref="board.dinghy.event.detail.booking({id:vm.id})" data-translate="askApp.dinghyEvent.detail.bookingTitle">Buchungen</a></li><li role="presentation" ui-sref-active="active"><a ui-sref="board.dinghy.event.detail.depts({id:vm.id})">Forderungen</a></li><li role="presentation" ui-sref-active="active"><a ui-sref="board.dinghy.event.detail.payments({id:vm.id})">Zahlungen</a></li><li role="presentation" ui-sref-active="active"><a ui-sref="board.dinghy.event.detail.newsletter({id:vm.id})" data-translate="askApp.dinghyEvent.detail.newsletterTitle">Rundmail</a></li><li role="presentation" ui-sref-active="active"><a ui-sref="board.dinghy.event.detail.notes({id:vm.id})" data-translate="askApp.dinghyEvent.detail.notesTitle">Notizen</a></li></ul></div></div><div class="col-md-10" ui-view="dinghyDetail"></div></div></div>');
$templateCache.put('app/board/project/detail/crew/crew.html','<!--\n  ~ Copyright (c) 2018 by Felix Heim, felix.heim@web.de\n  ~\n  ~ This product includes software developed at\n  ~ The Apache Software Foundation (http://www.apache.org/).\n  --><div><div class="container-fluid"><div class="row row-no-padding-nested crewPanel"><button class="btn btn-default" ng-click="vm.toggleAccordion()"><span class="hidden-xs-down">{{vm.isCollapsed ? \'Aufklappen\' : \'Zuklappen\'}}</span></button> <button class="btn btn-primary" ng-click="vm.createNew()" ng-disabled="vm.project.type === \'sksTrip\' && vm.crews.length >= 1" style="float:right"><span class="glyphicon glyphicon-plus"></span> <span class="hidden-xs-down" data-translate="askApp.crew.home.createLabel">Create new Crew</span></button> <button class="btn btn-primary" ng-click="vm.dataExport()" ng-disabled="vm.crews.length == 0 || vm.isSaving" analytics-on analytics-event="Crew exportiert" style="float:right; margin-right: 10px"><span class="glyphicon glyphicon-export"></span> <span class="hidden-xs-down">Daten exportieren</span></button></div></div><div class="row row-no-padding-nested crewList"><div class="col-md-8"><div class="alert alert-info" role="alert" ng-show="vm.crews.length == 0"><b>Keine Daten vorhanden!</b> F\xFCge eine neue Crew hinzu.</div><div ng-repeat="crew in vm.crews" ng-show="vm.crews.length > 0" class="panel panel-default crewPanel"><div class="panel-heading crewPanel"><div class="input-group" style="margin-bottom: 20px" ng-show="vm.type === \'nausys\' || vm.type === \'bm\'"><input type="text" name="url_{{$index}}" id="url_{{$index}}" class="form-control" ng-model="crew.nausysId" ng-change="vm.saveNausys(crew)" ng-minlength="20" ng-maxlength="255" maxlength="255"> <span class="input-group-btn"><button class="btn btn-primary" type="submit" ng-click="vm.exportToOnlineCrewlist(crew)" ng-disabled="vm.isSaving"><span class="glyphicon glyphicon-transfer" aria-hidden="true"></span></button> <button class="btn btn-primary" type="submit" ng-click="vm.goTo(crew.nausysId)"><span class="glyphicon glyphicon-eye-open" aria-hidden="true"></span></button></span></div><button class="btn btn-danger btn-xs pull-right" ng-show="crew.members.length == 0" ng-click="vm.deleteCrew(crew.id, $index)"><span class="glyphicon glyphicon-remove-circle"></span> <span class="hidden-xs-down" data-translate="entity.action.delete">Delete</span></button> <span class="badge pull-right" ng-show="crew.members.length > 0">{{crew.members.length}}</span><h3 ng-click="vm.crews[$index].isCollapsed = !vm.crews[$index].isCollapsed" class="panel-title collapse-toggle"><i class="glyphicon" ng-class="{\'glyphicon-chevron-down\': !vm.crews[$index].isCollapsed, \'glyphicon-chevron-right\': vm.crews[$index].isCollapsed}"></i> Crew {{$index + 1}} <span ng-if="vm.project.type !== \'sksTrip\'" ng-show="crew.members.length > 0">- {{crew.members[0].firstName}} {{crew.members[0].lastName}}<span ng-if="crew.members[0].nickname"> "{{crew.members[0].nickname}}"</span></span> <span ng-if="vm.project.type === \'sksTrip\' && vm.project.skipper">- {{vm.project.skipper.user.firstName}} {{vm.project.skipper.user.lastName}}<span ng-if="vm.project.skipper.nickname"> "{{vm.project.skipper.nickname}}"</span></span></h3></div><div class="panel-body crewPanel" uib-collapse="vm.crews[$index].isCollapsed"><!--<div ng-show="crew.members.length == 0">\n                        <span class="label label-danger">Bisher keine Crewmitglieder</span>\n                    </div>--><ul dnd-list="crew.members" dnd-inserted="vm.insertedInCrew(index, $index)" dnd-dragover="dragoverCallback(event, index, external, type)"><li ng-repeat="member in crew.members" dnd-draggable="member" dnd-moved="vm.deleteFromCrew($index, $parent.$index)"><dnd-nodrag><div dnd-handle class="handle"><span has-authority="ROLE_BOARD"><a ui-sref="member-management-detail({id:member.profileId})">{{member.firstName}} {{member.lastName}} <span ng-if="member.nickname">"{{member.nickname}}"</span></a></span> <span has-authority="ROLE_MANAGER">{{member.firstName}} {{member.lastName}} <span ng-if="member.nickname">"{{member.nickname}}"</span></span> | {{member.birthdate | date:\'mediumDate\'}} | <a href="tel:{{member.phone}}"><span class="glyphicon glyphicon glyphicon-phone" style="cursor: pointer" uib-popover="{{member.phone}}" popover-trigger="mouseenter"></span> </a><a href="mailto:{{member.email}}"><span class="glyphicon glyphicon glyphicon glyphicon-envelope" uib-popover="{{member.email}}" popover-trigger="mouseenter"></span> </a><span class="pull-right"><span style="cursor: pointer" class="glyphicon glyphicon-comment" aria-hidden="true" uib-popover="{{member.comment}}" popover-trigger="mouseenter" popover-placement="auto" popover-append-to-body="true" ng-show="member.comment"></span> <span class="glyphicon glyphicon-remove" aria-hidden="true" ng-show="!member.comment"></span> <span style="cursor: pointer" class="glyphicon glyphicon-comment" ng-show="member.individualField" aria-hidden="true" popover-trigger="mouseenter" popover-placement="auto" popover-append-to-body="true" popover-title="{{vm.project.individualField}}" uib-popover-template="\'popover-individualQuestion.html\'"></span> <span class="glyphicon glyphicon-remove" aria-hidden="true" ng-show="!member.individualField && vm.project.individualField"></span><div class="btn-group"><button type="submit" ui-sref="board.project-detail.crew.edit-booking({bookingId:member.id})" class="btn btn-primary btn-xs"><span class="glyphicon glyphicon-pencil"></span></button></div></span></div></dnd-nodrag></li><li class="dndPlaceholder" data-translate="askApp.crew.insertHere">hier einfuegen....</li><!--<li class="dndPlaceholder2" data-translate="askApp.crew.insertHere" ng-show="crew.members.length == 0">\n                            hier einfuegen....\n                        </li>--></ul></div></div></div><div class="col-md-4"><div class="panel panel-default sticky-scroll-box"><div class="panel-heading crewPanel"><h3 class="panel-title"><span data-translate="askApp.crew.without"></span> <span class="badge pull-right">{{vm.bookingsWithoutCrew.length}}</span></h3></div><div class="panel-body sticky-height crewPanel"><input class="form-control" ng-model="searchText" placeholder="Suche Crewmitglied" style="margin-bottom: 10px"><ul dnd-list="vm.bookingsWithoutCrew" dnd-inserted="vm.insertedIntoWithout(index)"><li ng-repeat="member in vm.bookingsWithoutCrew | filter:searchText" dnd-draggable="member" dnd-moved="vm.deleteFromWithoutCrew(member)"><dnd-nodrag><div dnd-handle class="handle"><span has-authority="ROLE_BOARD"><a ui-sref="member-management-detail({id:member.profileId})">{{member.firstName}} {{member.lastName}}</a></span> <span has-authority="ROLE_MANAGER">{{member.firstName}} {{member.lastName}}</span> <span ng-if="member.nickname" class="glyphicon glyphicon-info-sign" aria-hidden="true" popover-trigger="mouseenter" uib-popover="{{member.nickname}}" style="cursor: pointer"></span> | {{member.birthdate | date:\'yyyy\'}} <span class="pull-right"><span style="cursor: pointer" class="glyphicon glyphicon-comment" aria-hidden="true" uib-popover="{{member.comment}}" popover-trigger="mouseenter" popover-placement="auto" popover-append-to-body="true" ng-show="member.comment"></span> <span class="glyphicon glyphicon-remove" aria-hidden="true" ng-show="!member.comment"></span> <span style="cursor: pointer" class="glyphicon glyphicon-comment" ng-show="member.individualField" aria-hidden="true" popover-trigger="mouseenter" popover-placement="auto" popover-append-to-body="true" popover-title="{{vm.project.individualField}}" uib-popover-template="\'popover-individualQuestion.html\'"></span> <span class="glyphicon glyphicon-remove" aria-hidden="true" ng-show="!member.individualField && vm.project.individualField"></span><div class="btn-group"><button type="submit" ui-sref="board.project-detail.crew.edit-booking({bookingId:member.id})" class="btn btn-primary btn-xs"><span class="glyphicon glyphicon-pencil"></span></button></div></span></div></dnd-nodrag></li><li class="dndPlaceholder" data-translate="askApp.crew.insertHere">hier einfuegen....</li></ul></div></div></div></div></div><script type="text/ng-template" id="popover-individualQuestion.html"><span>\n        {{member.individualField}}\n    </span></script><script type="text/javascript">$(document).ready(function () {\n        var top = $(\'.sticky-scroll-box\').offset().top;\n        $( window ).resize(function() {\n            sticky();\n        });\n        $(window).scroll(function (event) {\n            sticky();\n        });\n\n        function sticky() {\n            var y = $(this).scrollTop() + 10;\n            var width = $(window).width();\n            if (y >= top && width > 992) {\n                $(\'.sticky-scroll-box\').removeClass(\'fixed\');\n                $(\'.sticky-scroll-box\').width($(\'.sticky-scroll-box\').parent().width());\n                $(\'.sticky-scroll-box\').addClass(\'fixed\');\n            } else {\n                $(\'.sticky-scroll-box\').removeClass(\'fixed\');\n                $(\'.sticky-scroll-box\').width($(\'.sticky-scroll-box\').parent().width());\n            }\n        }\n    });</script>');
$templateCache.put('app/board/project/detail/bookings/booking-dialog.html','<!--\n  ~ Copyright (c) 2017 by Julian Feder, julian.feder@yahoo.de\n  ~\n  ~ This product includes software developed at\n  ~ The Apache Software Foundation (http://www.apache.org/).\n  --><form name="editForm" role="form" novalidate ng-submit="vm.save()" show-validation><div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()">&times;</button><h4 class="modal-title" id="myBookingLabel" data-translate="askApp.booking.home.editLabel" translate-value-first-name="{{vm.booking.firstName}}" translate-value-last-name="{{vm.booking.lastName}}" translate-value-project-name="{{vm.project.name}}" translate-value-nickname="{{vm.nickname}}">Create or edit a Booking</h4></div><div class="modal-body"><jhi-alert-error></jhi-alert-error><div class="form-group" ng-init="vm.booking.sendNotificationMail = true"><label class="control-label" data-translate="askApp.booking.status" for="field_status">Status</label><select class="form-control" name="status" ng-model="vm.booking.status" id="field_status"><option value="angemeldet" data-translate="askApp.EnumBookingStatusType.angemeldet">angemeldet</option><option value="warteliste" data-translate="askApp.EnumBookingStatusType.warteliste">warteliste</option><option value="abgelehnt" data-translate="askApp.EnumBookingStatusType.abgelehnt">abgelehnt</option><option value="zurueckgetreten" data-translate="askApp.EnumBookingStatusType.zurueckgetreten">zurueckgetreten</option></select></div><div ng-show="vm.project.type == \'sksTrip\' && (vm.booking.status === \'angemeldet\' || vm.booking.status === \'warteliste\')"><label class="control-label">Teilnahme an SKS-Pr\xFCfung? (&Auml;ndert auch den zugeh&ouml;rigen Preis!)</label><br><switch ng-model="vm.booking.nonIndividual" class="green"></switch></div><div ng-show="vm.booking.status != vm.booking.oldStatus || vm.booking.nonIndividual === vm.booking.oldIndividualPrice"><label class="control-label">Mitglied per E-Mail &uuml;ber die Status&auml;nderung informieren</label><br><switch ng-model="vm.booking.sendNotificationMail" class="green"></switch><div class="form-group" ng-show="vm.booking.sendNotificationMail"><label class="control-label" data-translate="askApp.booking.managerComment" for="field_managerComment">Comment</label><input type="text" class="form-control" name="managerComment" id="field_managerComment" ng-model="vm.booking.managerComment" ng-maxlength="250"><div ng-show="editForm.managerComment.$dirty && editForm.managerComment.$invalid"><p class="help-block" ng-show="editForm.managerComment.$error.maxlength" data-translate="entity.validation.maxlength" translate-value-max="250">This field cannot be longer than 250 characters.</p></div></div></div><div class="alert alert-info" data-translate="askApp.booking.infoStatusChange"></div><div class="form-group" ng-if="vm.project.type == \'sbfPractical\'"><label class="control-label" data-translate="askApp.booking.sbfSlotsMax" for="field_sbfSlotsMax">Sbf Slot Count</label><input type="number" class="form-control" name="sbfSlotsMax" id="field_sbfSlotsMax" ng-model="vm.booking.sbfSlotsMax" ng-required="vm.project.type == \'sbfPractical\'" min="0" max="10"><div ng-show="editForm.sbfSlotsMax.$invalid"><p class="help-block" ng-show="editForm.sbfSlotsMax.$error.required" data-translate="entity.validation.required">This field is required.</p><p class="help-block" ng-show="editForm.sbfSlotsMax.$error.number" data-translate="entity.validation.number">This field should be a number.</p><p class="help-block" ng-show="editForm.sbfSlotsMax.$error.min" data-translate="entity.validation.min" translate-value-min="0">This field should be at least 1.</p><p class="help-block" ng-show="editForm.sbfSlotsMax.$error.max" data-translate="entity.validation.max" translate-value-max="10">This field cannot be more than 30.</p></div></div><div class="form-group"><label class="control-label" data-translate="askApp.booking.comment" for="field_comment">Comment</label><input type="text" class="form-control" name="comment" id="field_comment" ng-model="vm.booking.comment" ng-maxlength="250"><div ng-show="editForm.comment.$dirty && editForm.comment.$invalid"><p class="help-block" ng-show="editForm.comment.$error.maxlength" data-translate="entity.validation.maxlength" translate-value-max="250">This field cannot be longer than 250 characters.</p></div></div><div class="form-group" ng-show="vm.project.individualField !== null"><label class="control-label" for="field_individualField">{{vm.project.individualField}}</label><input type="text" class="form-control" name="individualField" id="field_individualField" ng-model="vm.booking.individualField" ng-maxlength="250"><div ng-show="editForm.individualField.$dirty && editForm.individualField.$invalid"><p class="help-block" ng-show="editForm.individualField.$error.maxlength" data-translate="entity.validation.maxlength" translate-value-max="250">This field cannot be longer than 250 characters.</p></div></div></div><div class="modal-footer"><button type="button" class="btn btn-default" data-dismiss="modal" ng-click="vm.clear()"><span class="glyphicon glyphicon-ban-circle"></span>&nbsp;<span data-translate="entity.action.cancel">Cancel</span></button> <button type="submit" ng-disabled="editForm.$invalid || vm.isSaving" class="btn btn-primary"><span class="glyphicon glyphicon-save"></span>&nbsp;<span data-translate="entity.action.save">Save</span></button></div></form>');
$templateCache.put('app/board/project/detail/bookings/bookings.html','<!--\n  ~ Copyright (c) 2017 by Julian Feder, julian.feder@yahoo.de\n  ~\n  ~ This product includes software developed at\n  ~ The Apache Software Foundation (http://www.apache.org/).\n  --><div><div class="panel panel-default"><div class="panel-heading"><h3 class="panel-title">Buchungen</h3></div><div class="panel-body"><jhi-alert></jhi-alert><div class="container-fluid"><div class="row"><div class="col-xs-12 col-md-6 no-padding-left"><button class="btn btn-primary" ng-click="vm.dataExport()" ng-disabled="vm.bookings.length == 0 || vm.isSaving" analytics-on analytics-event="Projektteilnehmer exportiert"><span class="glyphicon glyphicon-export"></span> <span class="hidden-xs-down">Daten exportieren</span></button></div><div class="col-xs-12 col-md-6 no-padding-right no-padding-left row-margin-top" ng-show="vm.status"><span class="label label-success"><span data-translate="askApp.EnumBookingStatusType.angemeldet"></span>:&nbsp;{{vm.status.countAngemeldet}}</span> <span class="label label-danger"><span data-translate="askApp.EnumBookingStatusType.zurueckgetreten"></span>:&nbsp;{{vm.status.countZurueckgetreten}}</span> <span class="label label-danger"><span data-translate="askApp.EnumBookingStatusType.abgelehnt"></span>:&nbsp;{{vm.status.countAbgelehnt}}</span> <span class="label label-warning"><span data-translate="askApp.EnumBookingStatusType.warteliste"></span>:&nbsp;{{vm.status.countWarteliste}}</span><br><span class="label label-info">Pl\xE4tze:&nbsp;{{vm.project.places}}</span> <span class="label label-info">G\xFCltige&nbsp;Anmeldungen:&nbsp;{{vm.validPlaces}}</span> <span class="label label-info" ng-show="vm.freePlaces >= 0">Freie&nbsp;Pl\xE4tze:&nbsp;{{vm.freePlaces}}</span> <span class="label label-info" ng-show="vm.freePlaces < 0">&Uuml;berbuchte&nbsp;Pl\xE4tze:&nbsp;{{-vm.freePlaces}}</span></div></div></div><br><div class="alert alert-info" role="alert" ng-show="vm.bookings.length == 0"><b>Keine Daten vorhanden!</b> Bisher existieren keine Buchungen f\xFCr dieses Projekt.</div><div class="table-responsive" ng-show="vm.bookings.length > 0"><table class="jh-table table table-striped"><thead><tr jh-sort="vm.predicate" ascending="vm.reverse" callback="vm.transition()"><th jh-sort-by="id"><span data-translate="askApp.booking.date">Date</span> <span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="profile.user.firstName"><span>Mitglied</span> <span class="glyphicon glyphicon-sort"></span></th><th><span>E-Mail</span></th><th><span>Handy</span></th><th jh-sort-by="status"><span>Status</span> <span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="dept.paymentStatus"><span>Bezahlstatus</span> <span class="glyphicon glyphicon-sort"></span></th><th ng-show="vm.project.type == \'sbfPractical\'"><span>Termine</span></th><th jh-sort-by="comment"><span>Kommentar</span> <span class="glyphicon glyphicon-sort"></span></th><th></th></tr></thead><tbody><tr ng-repeat="booking in vm.bookings track by booking.id"><td>{{booking.date | date:\'mediumDate\'}}</td><td><span has-authority="ROLE_BOARD"><a ui-sref="member-management-detail({id:booking.profileId})">{{booking.firstName}} {{booking.lastName}}</a></span> <span has-authority="ROLE_MANAGER">{{booking.firstName}} {{booking.lastName}}</span> <span ng-if="booking.nickname" class="glyphicon glyphicon-info-sign" aria-hidden="true" popover-trigger="mouseenter" uib-popover="{{booking.nickname}}" style="cursor: pointer"></span></td><td style="text-align: center"><a href="mailto:{{booking.eMail}}"><span class="glyphicon glyphicon glyphicon glyphicon-envelope" uib-popover="{{booking.eMail}}" popover-trigger="mouseenter"></span></a></td><td style="text-align: center"><a href="tel:{{booking.phone}}"><span class="glyphicon glyphicon glyphicon-phone" style="cursor: pointer" uib-popover="{{booking.phone}}" popover-trigger="mouseenter"></span></a></td><td><span class="label label-success" data-translate="{{\'askApp.EnumBookingStatusType.\' + booking.status}}" ng-show="booking.status == \'angemeldet\'">{{booking.status}}</span> <span class="label label-danger" data-translate="{{\'askApp.EnumBookingStatusType.\' + booking.status}}" ng-show="booking.status == \'zurueckgetreten\'">{{booking.status}}</span> <span class="label label-danger" data-translate="{{\'askApp.EnumBookingStatusType.\' + booking.status}}" ng-show="booking.status == \'abgelehnt\'">{{booking.status}}</span> <span class="label label-warning" data-translate="{{\'askApp.EnumBookingStatusType.\' + booking.status}}" ng-show="booking.status == \'warteliste\'">{{booking.status}}</span></td><td ng-show="vm.project.type === \'interest\'"><span class="label label-info">Interessensbekundung</span></td><td ng-hide="vm.project.type === \'interest\'"><span class="label label-danger" data-translate="{{\'askApp.EnumDeptStatus.\' + booking.paymentStatus}}" ng-show="booking.paymentStatus == \'pending\'">{{booking.paymentStatus}}</span> <span class="label label-success" data-translate="{{\'askApp.EnumDeptStatus.\' + booking.paymentStatus}}" ng-show="booking.paymentStatus == \'payed\'">{{booking.paymentStatus}}</span> <span class="label label-warning" data-translate="{{\'askApp.EnumDeptStatus.\' + booking.paymentStatus}}" ng-show="booking.paymentStatus == \'partial\'">{{booking.paymentStatus}}</span> <span class="label label-warning" data-translate="{{\'askApp.EnumDeptStatus.\' + booking.paymentStatus}}" ng-show="booking.paymentStatus == \'prePayed\'">{{booking.paymentStatus}}</span> <span class="label label-danger" data-translate="{{\'askApp.EnumDeptStatus.\' + booking.paymentStatus}}" ng-show="booking.paymentStatus == \'payedToMuch\'">{{booking.paymentStatus}}</span> <span class="glyphicon glyphicon-info-sign" aria-hidden="true" popover-trigger="mouseenter" popover-title="Bezahlstatus" uib-popover-template="\'popover-partial.html\'" style="cursor: pointer"></span> <a ui-sref="board.project-detail.booking.edit-dept({deptId: booking.deptId})" has-authority="ROLE_FINANCE"><span class="glyphicon glyphicon-pencil"></span></a> <a ui-sref="board.project-detail.booking.new-dept({userId: booking.profileId})" has-authority="ROLE_FINANCE" ng-if="!vm.project.closed"><span class="glyphicon glyphicon-plus"></span></a></td><td ng-show="vm.project.type == \'sbfPractical\'"><span class="label" ng-class="{\'label-success\': booking.sbfSlotsLeft == 0, \'label-warning\': booking.sbfSlotsBooked >= 1 && booking.sbfSlotsLeft != 0, \'label-danger\': booking.sbfSlotsBooked == 0 && booking.sbfSlotsLeft > 0}">{{booking.sbfSlotsBooked}}/{{booking.sbfSlotsMax}}</span> <span class="glyphicon glyphicon-info-sign" ng-show="booking.sbfSlotsBooked > 0" aria-hidden="true" popover-trigger="mouseenter" popover-title="Termine" uib-popover-template="\'popover-partial2.html\'" style="cursor: pointer"></span></td><td style="text-align: center"><span style="cursor: pointer" class="glyphicon glyphicon-comment" aria-hidden="true" uib-popover="{{booking.comment}}" popover-trigger="mouseenter" ng-show="booking.comment"></span> <span class="glyphicon glyphicon-remove" aria-hidden="true" ng-show="!booking.comment"></span> <span class="glyphicon glyphicon-comment" ng-show="booking.individualField" aria-hidden="true" popover-trigger="mouseenter" popover-title="{{vm.project.individualField}}" uib-popover-template="\'popover-individualQuestion.html\'" style="cursor: pointer" popover-append-to-body="true"></span> <span class="glyphicon glyphicon-remove" aria-hidden="true" ng-show="!booking.individualField && vm.project.individualField"></span></td><td class="text-right"><div class="btn-group flex-btn-group-container"><button type="submit" ui-sref="board.project-detail.booking.edit({id2:booking.id})" class="btn btn-primary btn-xs"><span class="glyphicon glyphicon-pencil"></span></button></div></td></tr></tbody></table></div></div></div><div class="text-center" ng-show="vm.bookings.length > 0"><jhi-item-count page="vm.page" total="vm.queryCount" items-per-page="vm.itemsPerPage"></jhi-item-count><uib-pagination class="pagination-sm" total-items="vm.totalItems" items-per-page="vm.itemsPerPage" ng-model="vm.page" ng-change="vm.transition()"></uib-pagination></div></div><script type="text/ng-template" id="popover-individualQuestion.html"><span>\n        {{booking.individualField}}\n    </span></script><script type="text/ng-template" id="popover-partial2.html"><ul style="padding-left:20px;">\n        <li ng-repeat="slot in booking.sbfTimeSlots | orderBy: \'fromTime\' track by $index">\n            <b ng-if="slot.fromTime > vm.project.untilDate">Pr\xFCfung:</b>\n            {{slot.fromTime | date:"EEEE, dd.MM.yyyy HH:mm"}} Uhr - {{slot.toTime | date:"HH:mm"}} Uhr\n        </li>\n    </ul></script><script type="text/ng-template" id="popover-partial.html"><div class="form-group">\n        <table>\n            <tr>\n                <td>Originalpreis:</td>\n                <td>{{booking.price | number:2}}\u20AC</td>\n            </tr>\n            <tr>\n                <td>Forderungsbetrag:</td>\n                <td>{{booking.amount | number:2}}\u20AC</td>\n            </tr>\n            <tr>\n                <td style="width: 150px;">Aktivit\xE4tenpunkte:</td>\n                <td>{{booking.apCount}}</td>\n            </tr>\n            <tr>\n                <td>Soll:</td>\n                <td>{{booking.priceNet | number:2}}\u20AC</td>\n            </tr>\n            <tr ng-repeat="payment in booking.payments">\n                <td>{{payment.date | date:\'dd.MM.yyyy\'}}:</td>\n                <td>{{payment.amount | number:2}}\u20AC</td>\n            </tr>\n            <tr>\n                <td>Ist:</td>\n                <td>{{booking.payed | number:2}}\u20AC</td>\n            </tr>\n            <tr>\n                <td colspan="2">\n                    <hr>\n                </td>\n            </tr>\n            <tr>\n                <td><span data-translate="askApp.dept.toPay">Saldo</span>:</td>\n                <td><b>{{booking.toPay | number:2}}\u20AC</b></td>\n            </tr>\n        </table>\n    </div></script>');
$templateCache.put('app/board/project/detail/home/project-detail-home.html','<!--\n  ~ Copyright (c) 2017 by Julian Feder, julian.feder@yahoo.de\n  ~\n  ~ This product includes software developed at\n  ~ The Apache Software Foundation (http://www.apache.org/).\n  --><div><div class="row row-no-padding-nested"><div class="col-xs-12"><jhi-alert></jhi-alert><div class="input-group" style="margin-bottom: 20px"><span class="input-group-addon" id="basic-addon1">Anmeldelink</span> <input type="text" id="bookUrlText" class="form-control" value="{{vm.bookUrl}}" readonly="readonly"> <span class="input-group-btn"><button id="copyUrlButton" class="btn btn-primary" type="submit" data-clipboard-target="#bookUrlText"><span class="glyphicon glyphicon-copy" aria-hidden="true"></span></button> <button class="btn btn-primary" type="submit" ng-click="vm.goTo(vm.bookUrl)"><span class="glyphicon glyphicon-new-window" aria-hidden="true"></span></button></span></div></div></div><div class="member-management-detail-table"><div class="row row-no-padding-nested"><div class="col-md-6"><div class="panel panel-default"><div class="panel-heading"><h3 class="panel-title">Daten</h3></div><div class="panel-body"><table class="table no-border"><tr><td><b>Name</b></td><td><span>{{vm.project.name}}</span></td></tr><tr><td><b>Typ</b></td><td><span class="label label-info" data-translate="{{\'askApp.EnumProjectType.\' + vm.project.type}}"></span></td></tr><tr ng-show="vm.project.type == \'sksTrip\'"><td><b>Pr\xFCfungsort</b></td><td><span class="label label-info" data-translate="{{\'askApp.EnumSksPracticalLocation.\' + vm.project.sksPracticalLocation}}"></span></td></tr><tr><td><b>Von</b></td><td>{{vm.project.fromDate | date:\'mediumDate\'}}</td></tr><tr><td><b>Bis</b></td><td>{{vm.project.untilDate | date:\'mediumDate\'}}</td></tr><tr><td><b>Pl\xE4tze</b></td><td>{{vm.project.places}} <span class="glyphicon glyphicon-info-sign" aria-hidden="true" popover-trigger="mouseenter" popover-title="Buchungsstatus" uib-popover-template="\'popover-partial.html\'" style="cursor: pointer"></span></td></tr><tr ng-show="vm.project.type === \'sbfPractical\'"><td><b>Buchbare Fahrstunden</b></td><td>{{vm.project.sbfSlotsMax}}</td></tr><tr ng-show="vm.project.type !== \'interest\'"><td><b>Identifier</b></td><td><span class="label label-info">{{vm.project.identifier}}</span></td></tr><tr ng-show="vm.project.type !== \'interest\'"><td><b>Normalpreis</b></td><td>{{vm.project.normalPrice | number:2}}\u20AC</td></tr><tr ng-show="vm.project.type !== \'interest\'"><td><b>Studentenpreis</b></td><td>{{vm.project.studentPrice | number:2}}\u20AC</td></tr><tr ng-show="vm.project.type == \'sksTrip\'"><td><b>Preis ohne Pr\xFCfung</b></td><td>{{vm.project.individualPrice | number:2}}\u20AC</td></tr><tr ng-show="vm.project.guest"><td><b>Gastpreis</b></td><td>{{vm.project.guestPrice | number:2}}\u20AC</td></tr><tr ng-show="vm.project.prepayment"><td><b>Anzahlung</b></td><td>{{vm.project.prepayment | number:2}}\u20AC</td></tr><tr ng-show="vm.project.dependingProject"><td><b>Nur sichtbar wenn Projektbuchung existiert & bezahlt wurde</b></td><td>{{vm.project.dependingProject.name}}</td></tr><tr><td><b>Projektleiter</b></td><td has-authority="ROLE_BOARD"><a ui-sref="member-management-detail({id:vm.project.profile.id})">{{vm.project.profile.user.firstName}} {{vm.project.profile.user.lastName}}<span ng-if="vm.project.profile.nickname"> "{{vm.project.profile.nickname}}"</span></a></td><td has-authority="ROLE_MANAGER">{{vm.project.profile.user.firstName}} {{vm.project.profile.user.lastName}}<span ng-if="vm.project.profile.nickname"> "{{vm.project.profile.nickname}}"</span></td></tr><tr ng-show="vm.project.authorizedMembers.length > 0"><td><b>Moderatoren</b></td><td><span ng-repeat="moderator in vm.project.authorizedMembers"><p has-authority="ROLE_BOARD" style="margin:0;padding:0"><a ui-sref="member-management-detail({id:moderator.id})">{{moderator.user.firstName}} {{moderator.user.lastName}}<span ng-if="moderator.nickname"> "{{moderator.nickname}}"</span></a></p><p has-authority="ROLE_MANAGER" style="margin:0;padding:0">{{moderator.user.firstName}} {{moderator.user.lastName}}<span ng-if="moderator.nickname"> "{{moderator.nickname}}"</span></p></span></td></tr><tr ng-show="vm.project.authorizedGroupsString.length > 0"><td><b>Moderatorgruppen</b></td><td><div ng-repeat="group in vm.project.authorizedGroupsString"><span class="label label-info">{{\'global.authority.\' + group | translate}}</span></div></td></tr><tr ng-show="vm.project.email"><td><b>Kontakt E-Mail</b></td><td><a href="mailto:{{vm.project.email}}">{{vm.project.email}}</a></td></tr><tr ng-show="vm.project.type == \'sksTrip\'"><td><b>Skipper</b></td><td has-authority="ROLE_BOARD"><a ui-sref="member-management-detail({id:vm.project.skipper.id})">{{vm.project.skipper.user.firstName}} {{vm.project.skipper.user.lastName}}<span ng-if="vm.project.skipper.nickname"> "{{vm.project.skipper.nickname}}"</span></a></td><td has-authority="ROLE_MANAGER">{{vm.project.skipper.user.firstName}} {{vm.project.skipper.user.lastName}}<span ng-if="vm.project.skipper.nickname"> "{{vm.project.skipper.nickname}}"</span></td></tr><tr ng-show="vm.project.image"><td><b>Foto</b></td><td><a ng-click="openLightboxModal(0, \'data:\' + vm.project.imageContentType + \';base64,\' + vm.project.image)"><span class="glyphicon glyphicon-picture" style="font-size: 50px"></span></a></td></tr></table></div></div></div><div class="col-md-6"><div class="panel panel-default"><div class="panel-heading"><h3 class="panel-title">Zusatzfelder</h3></div><div class="panel-body"><table class="table no-border"><tr><td><b>Individuelle Frage</b></td><td><span ng-show="vm.project.individualField != null && vm.project.individualField != \'\'">{{vm.project.individualField}}</span> <span class="label label-danger" ng-hide="vm.project.individualField != null && vm.project.individualField != \'\'">Nein</span></td></tr><tr><td><b>Gewicht</b></td><td><span class="label label-success" ng-show="vm.project.weight">Ja</span> <span class="label label-danger" ng-show="!vm.project.weight">Nein</span></td></tr><tr><td><b>T-Shirt Gr\xF6\xDFe</b></td><td><span class="label label-success" ng-show="vm.project.clothingSize">Ja</span> <span class="label label-danger" ng-show="!vm.project.clothingSize">Nein</span></td></tr><tr><td><b>Schuhgr\xF6\xDFe (EU)</b></td><td><span class="label label-success" ng-show="vm.project.shoeSize">Ja</span> <span class="label label-danger" ng-show="!vm.project.shoeSize">Nein</span></td></tr><tr><td><b>Nationalit\xE4t</b></td><td><span class="label label-success" ng-show="vm.project.nationality">Ja</span> <span class="label label-danger" ng-show="!vm.project.nationality">Nein</span></td></tr><tr><td><b>Geburtsort</b></td><td><span class="label label-success" ng-show="vm.project.birthplace">Ja</span> <span class="label label-danger" ng-show="!vm.project.birthplace">Nein</span></td></tr><tr><td><b>Geburtsland</b></td><td><span class="label label-success" ng-show="vm.project.countryOfBirth">Ja</span> <span class="label label-danger" ng-show="!vm.project.countryOfBirth">Nein</span></td></tr><tr><td><b>Ausweisdokument</b></td><td><span class="label label-success" ng-show="vm.project.idNumber">Ja</span> <span class="label label-danger" ng-show="!vm.project.idNumber">Nein</span></td></tr></table></div></div><div class="panel panel-default"><div class="panel-heading"><h3 class="panel-title">Einstellungen</h3></div><div class="panel-body"><table class="table no-border"><tr><td><b>Aktiv</b></td><td><span class="label label-success" ng-show="vm.project.active">Ja</span> <span class="label label-danger" ng-show="!vm.project.active">Nein</span></td></tr><tr><td><b>Sichtbar</b></td><td><span class="label label-success" ng-show="vm.project.visible">Ja</span> <span class="label label-danger" ng-show="!vm.project.visible">Nein</span></td></tr><tr ng-show="vm.project.type === \'sbfPractical\'"><td><b>Fahrstunden buchbar</b></td><td><span class="label label-success" ng-show="vm.project.additionalBookable">Ja</span> <span class="label label-danger" ng-show="!vm.project.additionalBookable">Nein</span></td></tr><tr ng-show="vm.project.type !== \'merchandise\' && vm.project.type !== \'interest\'"><td><b>9 Monate</b></td><td><span class="label label-success" ng-show="vm.project.checkRegisterDate">Ja</span> <span class="label label-danger" ng-show="!vm.project.checkRegisterDate">Nein</span></td></tr><tr><td><b>Warteliste</b></td><td><span class="label label-success" ng-show="vm.project.queue">Ja</span> <span class="label label-danger" ng-show="!vm.project.queue">Nein</span></td></tr><tr ng-show="vm.project.type !== \'merchandise\' && vm.project.type !== \'interest\'"><td><b>Aktivit\xE4tenpunkte</b></td><td><span class="label label-success" ng-show="vm.project.activityPoints">Ja</span> <span class="label label-danger" ng-show="!vm.project.activityPoints">Nein</span></td></tr><tr ng-show="vm.project.type == \'event\'"><td><b>Gastmitglieder</b></td><td><span class="label label-success" ng-show="vm.project.guest">Ja</span> <span class="label label-danger" ng-show="!vm.project.guest">Nein</span></td></tr><tr ng-show="vm.project.type == \'sksTrip\'"><td><b>T\xF6rn findet statt</b></td><td><span class="label label-success" ng-show="vm.project.booked">Ja</span> <span class="label label-danger" ng-show="!vm.project.booked">Nein</span></td></tr><tr><td><b>Abgeschlossen</b></td><td><span class="label label-success" ng-show="vm.project.closed">Ja</span> <span class="label label-danger" ng-show="!vm.project.closed">Nein</span></td></tr></table></div></div></div></div></div><div class="row row-no-padding-nested" ng-hide="!vm.project.description && !vm.project.conditions"><div class="col-md-12"><div class="panel panel-default" ng-show="vm.project.description"><div class="panel-heading"><h3 class="panel-title">Beschreibung</h3></div><div class="panel-body"><div ng-bind-html="renderHtml(vm.project.description)" style="text-align: justify"></div></div></div><div class="panel panel-default" ng-show="vm.project.conditions"><div class="panel-heading"><h3 class="panel-title">Bedingungen</h3></div><div class="panel-body"><div ng-bind-html="renderHtml(vm.project.conditions)" style="text-align: justify"></div></div></div></div></div><!--<button type="submit"\n            ui-sref="{{ vm.previousState }}"\n            class="btn btn-info">\n        <span class="glyphicon glyphicon-arrow-left"></span>&nbsp;<span data-translate="entity.action.back"> Back</span>\n    </button>--> <button type="button" ui-sref="board.project-detail.edit({id:vm.project.id})" class="btn btn-primary"><span class="glyphicon glyphicon-pencil"></span> <span class="hidden-sm-down" data-translate="entity.action.edit">Edit</span></button></div><script type="text/ng-template" id="popover-partial.html"><div>\n        <span class="label label-success" style="width: 100%;"><span data-translate="askApp.EnumBookingStatusType.angemeldet"></span>:&nbsp;{{vm.project.bookedPlaces.countAngemeldet}}</span>\n        <br>\n        <span class="label label-danger"><span data-translate="askApp.EnumBookingStatusType.zurueckgetreten"></span>:&nbsp;{{vm.project.bookedPlaces.countZurueckgetreten}}</span>\n        <br>\n        <span class="label label-danger"><span data-translate="askApp.EnumBookingStatusType.abgelehnt"></span>:&nbsp;{{vm.project.bookedPlaces.countAbgelehnt}}</span>\n        <br>\n        <span class="label label-warning"><span data-translate="askApp.EnumBookingStatusType.warteliste"></span>:&nbsp;{{vm.project.bookedPlaces.countWarteliste}}</span>\n        <br>\n        <span class="label label-info">Pl\xE4tze:&nbsp;{{vm.project.places}}</span>\n        <br>\n        <span class="label label-info">G\xFCltige&nbsp;Anmeldungen:&nbsp;{{vm.validPlaces}}</span>\n        <br>\n        <span class="label label-info" ng-show="vm.freePlaces >= 0">Freie&nbsp;Pl\xE4tze:&nbsp;{{vm.freePlaces}}</span>\n        <span class="label label-info" ng-show="vm.freePlaces < 0">&Uuml;berbuchte&nbsp;Pl\xE4tze:&nbsp;{{-vm.freePlaces}}</span>\n    </div></script>');
$templateCache.put('app/board/project/detail/newsletter/project-detail-newsletter.html','<!--\n  ~ Copyright (c) 2017 by Julian Feder, julian.feder@yahoo.de\n  ~\n  ~ This product includes software developed at\n  ~ The Apache Software Foundation (http://www.apache.org/).\n  --><div class="notes"><div class="panel panel-default"><div class="panel-heading"><h3 class="panel-title">Rundmail</h3></div><div class="panel-body"><div class="row"><div class="member-management-detail-table"><div class="col-md-12"><form name="editForm" role="form" novalidate show-validation><jhi-alert></jhi-alert><div class="form-group" ng-init="vm.sendMail.selection = \'alle\'"><label class="control-label" data-translate="askApp.memberManagement.mail.selection">Description</label><div class="btn-group btn-group-justified"><label class="btn btn-default" ng-model="vm.sendMail.selection" uib-btn-radio="\'alle\'"><span data-translate="askApp.project.mail.alle">normal</span></label><label class="btn btn-default" ng-model="vm.sendMail.selection" uib-btn-radio="\'project_angemeldet\'"><span data-translate="askApp.project.mail.angemeldet">guest</span></label><label class="btn btn-default" ng-model="vm.sendMail.selection" uib-btn-radio="\'project_warteliste\'"><span data-translate="askApp.project.mail.warteliste">guest</span></label><label class="btn btn-default" ng-model="vm.sendMail.selection" uib-btn-radio="\'project_skipper\'" ng-show="vm.projectType == \'event\'"><span data-translate="askApp.project.mail.skipper">guest</span></label><label class="btn btn-default" ng-model="vm.sendMail.selection" uib-btn-radio="\'project_crew\'" ng-show="vm.projectType == \'sksTrip\'"><span data-translate="askApp.project.mail.crew">guest</span></label></div></div><div class="form-group"><label class="control-label" data-translate="askApp.memberManagement.mail.replyToName">Description</label><input type="text" class="form-control" ng-model="vm.sendMail.replyToName" name="replyToName" placeholder="{{vm.currentAccount.firstName}} {{vm.currentAccount.lastName}}"></div><div class="form-group"><label class="control-label" data-translate="askApp.memberManagement.mail.replyToMail">Description</label><input type="email" class="form-control" ng-model="vm.sendMail.replyToMail" name="replyToMail" placeholder="{{vm.contactMail}}"><div ng-show="editForm.replyToMail.$dirty && editForm.replyToMail.$invalid"><p class="help-block" ng-show="editForm.replyToMail.$error.email" data-translate="entity.validation.invalid">Your email is invalid.</p></div></div><div class="form-group"><label class="control-label" data-translate="askApp.memberManagement.mail.subject">Description</label><input type="text" class="form-control" ng-model="vm.sendMail.subject" name="subject" required><div ng-show="editForm.subject.$invalid"><p class="help-block" ng-show="editForm.subject.$error.required" data-translate="entity.validation.required">This field is required.</p></div></div><div class="alert alert-info" role="alert">Die <b>Mail</b> wird <b>individuell</b> an alle Adressaten verschickt. Eine <b>Begr&uuml;&szlig;ung</b> ist daher <b>nicht n\xF6tig.</b><br>Au&szlig;erdem kannst Du die <b>E-Mail</b> in der <b>Du-Form</b> verfassen.<br>Du kannst &uuml;ber den Button <b>"Test E-Mail"</b> auch eine <b>Probemail an Dich</b> selbst senden.</div><div class="form-group"><label class="control-label" data-translate="askApp.memberManagement.mail.text">Description</label><summernote config="vm.options" ng-model="vm.sendMail.text" id="field_description"></summernote></div><div class="modal-footer" style="padding:0; border: 0"><button type="submit" ng-disabled="vm.isSaving || editForm.$invalid" class="btn btn-danger" ng-click="vm.action(\'send\')"><span data-translate="askApp.memberManagement.mail.sendMail">Ausschlie\xDFen</span></button> <button type="submit" ng-disabled="vm.isSaving || editForm.$invalid" class="btn btn-info" ng-click="vm.action(\'test\')"><span data-translate="askApp.memberManagement.mail.testMail">Ausschlie\xDFen</span></button></div></form></div></div></div></div></div></div>');
$templateCache.put('app/board/project/detail/depts/depts.html','<!--\n  ~ Copyright (c) 2021 by Felix Heim, felix-heim@web.de\n  ~\n  ~ This product includes software developed at\n  ~ The Apache Software Foundation (http://www.apache.org/).\n  --><div><div class="panel panel-default"><div class="panel-heading"><h3 class="panel-title" data-translate="askApp.project.dept.titleDetail" translate-value-reference="{{vm.project.identifierWithYear}}"></h3></div><div class="panel-body"><jhi-alert></jhi-alert><div class="container-fluid"><div class="row"><div class="col-xs-12 col-md-6 no-padding-left"><button class="btn btn-primary" ng-click="vm.dataExport()" ng-disabled="vm.isSaving" analytics-on analytics-event="Projektbogen exportiert"><span class="glyphicon glyphicon-export"></span> <span class="hidden-xs-down">Projektbogen exportieren</span></button> <button class="btn btn-primary" ui-sref="board.project-detail.depts.new-dept-project" has-authority="ROLE_FINANCE" ng-disabled="(vm.status.countAngemeldet == 0 && vm.status.countZurueckgetreten == 0 && vm.status.countAbgelehnt == 0 && vm.status.countWarteliste == 0) || vm.project.closed"><span class="glyphicon glyphicon-plus"></span></button></div><div class="col-xs-12 col-md-6 no-padding-right no-padding-left row-margin-top" ng-show="vm.status"><span class="label label-success"><span data-translate="askApp.EnumBookingStatusType.angemeldet"></span>:&nbsp;{{vm.status.countAngemeldet}}</span> <span class="label label-danger"><span data-translate="askApp.EnumBookingStatusType.zurueckgetreten"></span>:&nbsp;{{vm.status.countZurueckgetreten}}</span> <span class="label label-danger"><span data-translate="askApp.EnumBookingStatusType.abgelehnt"></span>:&nbsp;{{vm.status.countAbgelehnt}}</span> <span class="label label-warning"><span data-translate="askApp.EnumBookingStatusType.warteliste"></span>:&nbsp;{{vm.status.countWarteliste}}</span><br><span class="label label-info">Pl\xE4tze:&nbsp;{{vm.project.places}}</span> <span class="label label-info">G\xFCltige&nbsp;Anmeldungen:&nbsp;{{vm.validPlaces}}</span> <span class="label label-info" ng-show="vm.freePlaces >= 0">Freie&nbsp;Pl\xE4tze:&nbsp;{{vm.freePlaces}}</span> <span class="label label-info" ng-show="vm.freePlaces < 0">&Uuml;berbuchte&nbsp;Pl\xE4tze:&nbsp;{{-vm.freePlaces}}</span></div></div></div><br><div class="alert alert-info" role="alert" ng-show="vm.depts.length == 0"><b>Keine Daten vorhanden!</b> Bisher existieren keine individuellen Forderungen f&uuml;r dieses Projekt.</div><div class="table-responsive" ng-show="vm.depts.length > 0"><table class="jh-table table"><thead><tr><th><span data-translate="askApp.dept.date">Date</span></th><th><span>Mitglied</span></th><th><span data-translate="askApp.dept.reference">Reference</span></th><th><span data-translate="askApp.dept.amount">Amount</span></th><th><span data-translate="askApp.dept.paymentStatus">Payment Status</span></th><th has-authority="ROLE_FINANCE"></th></tr></thead><tbody><tr ng-repeat="dept in vm.depts track by dept.id"><td>{{dept.date | date:\'mediumDate\'}}</td><td><span has-authority="ROLE_MANAGER">{{dept.profile.user.firstName}} {{dept.profile.user.lastName}}</span> <span has-authority="ROLE_BOARD"><a ui-sref="member-management-detail({id:dept.profile.id})">{{dept.profile.user.firstName}} {{dept.profile.user.lastName}}</a></span> <span ng-if="dept.profile.nickname" class="glyphicon glyphicon-info-sign" aria-hidden="true" popover-trigger="mouseenter" uib-popover="{{dept.profile.nickname}}" style="cursor: pointer"></span></td><td>{{dept.reference}}</td><td>{{dept.amount | number:2}}\u20AC</td><td><span class="label label-danger" data-translate="{{\'askApp.EnumDeptStatus.\' + dept.paymentStatus}}" ng-show="dept.paymentStatus == \'pending\'">{{dept.paymentStatus}}</span> <span class="label label-success" data-translate="{{\'askApp.EnumDeptStatus.\' + dept.paymentStatus}}" ng-show="dept.paymentStatus == \'payed\'">{{dept.paymentStatus}}</span> <span class="label label-warning" data-translate="{{\'askApp.EnumDeptStatus.\' + dept.paymentStatus}}" ng-show="dept.paymentStatus == \'partial\'">{{dept.paymentStatus}}</span> <span class="label label-warning" data-translate="{{\'askApp.EnumDeptStatus.\' + dept.paymentStatus}}" ng-show="dept.paymentStatus == \'prePayed\'">{{dept.paymentStatus}}</span> <span class="label label-danger" data-translate="{{\'askApp.EnumDeptStatus.\' + dept.paymentStatus}}" ng-show="dept.paymentStatus == \'payedToMuch\'">{{dept.paymentStatus}}</span> <span class="glyphicon glyphicon-info-sign" aria-hidden="true" popover-trigger="mouseenter" popover-title="Forderung" uib-popover-template="\'popover-partial.html\'" style="cursor: pointer"></span></td><td class="text-right" has-authority="ROLE_FINANCE"><div class="btn-group flex-btn-group-container"><button type="submit" ui-sref="board.project-detail.depts.edit-dept({deptId: dept.id})" class="btn btn-primary btn-xs"><span class="glyphicon glyphicon-pencil"></span></button> <button type="submit" ui-sref="board.project-detail.depts.new-dept({userId: dept.profile.id})" class="btn btn-primary btn-xs"><span class="glyphicon glyphicon-plus"></span></button></div></td></tr></tbody></table></div></div></div></div><script type="text/ng-template" id="popover-partial.html"><div class="form-group">\n        <table>\n            <tr>\n                <td>Betrag:</td>\n                <td>{{dept.amount | number:2}}\u20AC</td>\n            </tr>\n            <tr>\n                <td style="width: 150px;">Aktivit\xE4tenpunkte:</td>\n                <td>{{dept.apCount}}</td>\n            </tr>\n            <tr>\n                <td>Soll:</td>\n                <td>{{dept.priceNet | number:2}}\u20AC</td>\n            </tr>\n            <tr ng-repeat="payment in dept.payments">\n                <td>{{payment.date | date:\'dd.MM.yyyy\'}}:</td>\n                <td>{{payment.amount | number:2}}\u20AC</td>\n            </tr>\n            <tr>\n                <td>Ist:</td>\n                <td>{{dept.payed | number:2}}\u20AC</td>\n            </tr>\n            <tr>\n                <td colspan="2">\n                    <hr>\n                </td>\n            </tr>\n            <tr>\n                <td><span data-translate="askApp.dept.toPay">Saldo</span>:</td>\n                <td><b>{{dept.toPay | number:2}}\u20AC</b></td>\n            </tr>\n        </table>\n    </div></script>');
$templateCache.put('app/board/project/detail/payments/payment-dialog.html','<!--\n  ~ Copyright (c) 2021 by Felix Heim, felix-heim@web.de\n  ~\n  ~ This product includes software developed at\n  ~ The Apache Software Foundation (http://www.apache.org/).\n  --><form name="editForm" role="form" novalidate ng-submit="vm.save()" show-validation><div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()">&times;</button><h4 class="modal-title" id="myPaymentLabel" data-translate="askApp.payment.home.editLabel" translate-value-name="{{vm.payment.name}}" translate-value-date="{{vm.payment.date | date:\'dd.MM.yyyy\'}}">Create or edit a Payment</h4></div><div class="modal-body"><jhi-alert-error></jhi-alert-error><div class="form-group"><label class="control-label" data-translate="askApp.payment.revenueID" for="field_revenueID">Revenue ID</label><input type="text" class="form-control" name="revenueID" id="field_revenueID" ng-model="vm.payment.id" required readonly="readonly"></div><div class="form-group" ng-if="vm.payment.parent !== null"><label class="control-label" data-translate="askApp.payment.parent">Parent</label><div><a ui-sref="board.project-detail.payments.edit({paymentId:vm.payment.parent.id})" ng-click="$close()"><span data-translate="askApp.payment.home.parentLabel" translate-value-name="{{vm.payment.parent.name}}" translate-value-date="{{vm.payment.parent.date | date:\'dd.MM.yyyy\'}}"></span>,&nbsp;<span data-translate="askApp.payment.amount"></span>:&nbsp;{{vm.payment.parent.amount | number: 2}}&nbsp;&euro;</a></div></div><div class="form-group"><label class="control-label" data-translate="askApp.payment.amount" for="field_amount">Amount</label><input type="number" class="form-control" name="amount" id="field_amount" ng-model="vm.payment.amount" ng-disabled="!vm.amountEditable"><!--min="-{{vm.maxAmount}}"\n                   max="{{vm.maxAmount}}"--><div ng-show="editForm.amount.$invalid"><p class="help-block" ng-show="editForm.amount.$error.required" data-translate="entity.validation.required">This field is required.</p><p class="help-block" ng-show="editForm.amount.$error.number" data-translate="entity.validation.number">This field should be a number.</p><p class="help-block" ng-show="editForm.amount.$error.max" data-translate="entity.validation.max" translate-value-max="{{vm.maxAmount}}">This field should be at least 0.</p></div></div><div class="form-group" ng-if="vm.payment.parent !== null"><label class="control-label" data-translate="askApp.payment.amountEditable" for="field_closed">Amount Editable</label><br><switch id="field_closed" ng-model="vm.amountEditable" class="green"></switch></div><div class="form-group"><label class="control-label" data-translate="askApp.payment.reference" for="field_reference">reference</label><input type="text" class="form-control" name="reference" id="field_reference" ng-model="vm.payment.reference" readonly="readonly"></div><div class="form-group"><label class="control-label" data-translate="askApp.payment.category" for="field_category">Category</label><select class="form-control" name="category" ng-model="vm.payment.category" id="field_category"><option value=""></option><option value="Teilnahmebeitrag" data-translate="askApp.EnumPaymentCategory.Teilnahmebeitrag">Teilnahmebeitrag</option><option value="Charter" data-translate="askApp.EnumPaymentCategory.Charter">Charter</option><option value="Meldegeld" data-translate="askApp.EnumPaymentCategory.Meldegeld">Meldegeld</option><option value="Pruefungsgebuehr" data-translate="askApp.EnumPaymentCategory.Pruefungsgebuehr">Pruefungsgebuehr</option><option value="Kautionversicherung" data-translate="askApp.EnumPaymentCategory.Kautionversicherung">Kautionversicherung</option><option value="Unterkunft" data-translate="askApp.EnumPaymentCategory.Unterkunft">Unterkunft</option><option value="Skipperhaftpflicht" data-translate="askApp.EnumPaymentCategory.Skipperhaftpflicht">Skipperhaftpflicht</option><option value="Uebungsleiterverguetung" data-translate="askApp.EnumPaymentCategory.Uebungsleiterverguetung">Uebungsleiterverguetung</option><option value="Bordkassenzuschuss" data-translate="askApp.EnumPaymentCategory.Bordkassenzuschuss">Bordkassenzuschuss</option><option value="Merch" data-translate="askApp.EnumPaymentCategory.Merch">Merch</option><option value="Verpflegung" data-translate="askApp.EnumPaymentCategory.Verpflegung">Verpflegung</option><option value="StadtmobilP" data-translate="askApp.EnumPaymentCategory.StadtmobilP">StadtmobilP</option><option value="StadtmobilTN" data-translate="askApp.EnumPaymentCategory.StadtmobilTN">StadtmobilTN</option><option value="Druckkosten" data-translate="askApp.EnumPaymentCategory.Druckkosten">Druckkosten</option><option value="Sonstiges" data-translate="askApp.EnumPaymentCategory.Sonstiges">Sonstiges</option></select></div><div class="form-group"><label class="control-label" data-translate="askApp.payment.comment" for="field_comment">Comment</label><input type="text" class="form-control" name="comment" id="field_comment" ng-model="vm.payment.comment"></div><div class="form-group"><label class="control-label" data-translate="askApp.payment.dept" for="field_dept">Dept</label><input type="text" ng-model="vm.payment.dept" placeholder="Suche Forderung" id="field_dept" uib-typeahead="dept as (dept.reference + \' // \' + dept.profile.user.firstName + \' \' + dept.profile.user.lastName + (dept.profile.nickname ? (\' &quot;\' + dept.profile.nickname + \'&quot;\') : (\'\')) + \' // \' + dept.relation + \' // \' + (dept.amount | number:2) + \'\u20AC\' + \' // \' + (dept.date | date:mediumDate)) for dept in vm.getDept($viewValue)" typeahead-loading="loadingLocations" typeahead-no-results="noResults" class="form-control" autocomplete="off"></div></div><div class="modal-footer"><button type="button" class="btn btn-default" data-dismiss="modal" ng-click="vm.clear()"><span class="glyphicon glyphicon-ban-circle"></span>&nbsp;<span data-translate="entity.action.cancel">Cancel</span></button> <button type="button" ng-disabled="vm.isSaving" ng-if="vm.payment.type !== \'KOPIE\'" class="btn btn-warning" ng-click="vm.copyPayment()"><span class="glyphicon glyphicon-copy"></span>&nbsp;Kopieren</button> <button type="submit" ng-disabled="editForm.$invalid || vm.isSaving" class="btn btn-primary"><span class="glyphicon glyphicon-save"></span>&nbsp;<span data-translate="entity.action.save">Save</span></button></div></form>');
$templateCache.put('app/board/project/detail/payments/payments.html','<!--\n  ~ Copyright (c) 2021 by Felix Heim, felix-heim@web.de\n  ~\n  ~ This product includes software developed at\n  ~ The Apache Software Foundation (http://www.apache.org/).\n  --><div><div class="panel panel-default"><div class="panel-heading"><h3 class="panel-title" data-translate="askApp.project.payment.titleDetail" translate-value-reference="{{vm.project.identifierWithYear}}"></h3></div><div class="panel-body"><jhi-alert></jhi-alert><div class="container-fluid"><div class="row"><div class="col-xs-12 col-md-6 no-padding-left"><button class="btn btn-primary" ng-click="vm.dataExport()" ng-disabled="vm.bookings.length == 0 || vm.isSaving" analytics-on analytics-event="Projektbogen exportiert"><span class="glyphicon glyphicon-export"></span> <span class="hidden-xs-down">Projektbogen exportieren</span></button> &nbsp;<div class="btn-group"><button type="submit" ng-click="vm.setType(\'all\')" class="btn btn-default btn-md" ng-class="{active: vm.type === \'all\'}"><span class="hidden-sm-down">Alle</span></button> <button type="submit" ng-click="vm.setType(\'no_fees\')" class="btn btn-default btn-md" ng-class="{active: vm.type == \'no_fees\'}"><span class="hidden-sm-down">Ohne Beitr\xE4ge</span></button></div></div><div class="col-xs-12 col-md-6 no-padding-right no-padding-left row-margin-top" ng-show="vm.status"><span class="label label-success"><span data-translate="askApp.EnumBookingStatusType.angemeldet"></span>:&nbsp;{{vm.status.countAngemeldet}}</span> <span class="label label-danger"><span data-translate="askApp.EnumBookingStatusType.zurueckgetreten"></span>:&nbsp;{{vm.status.countZurueckgetreten}}</span> <span class="label label-danger"><span data-translate="askApp.EnumBookingStatusType.abgelehnt"></span>:&nbsp;{{vm.status.countAbgelehnt}}</span> <span class="label label-warning"><span data-translate="askApp.EnumBookingStatusType.warteliste"></span>:&nbsp;{{vm.status.countWarteliste}}</span><br><span class="label label-info">Pl\xE4tze:&nbsp;{{vm.project.places}}</span> <span class="label label-info">G\xFCltige&nbsp;Anmeldungen:&nbsp;{{vm.validPlaces}}</span> <span class="label label-info" ng-show="vm.freePlaces >= 0">Freie&nbsp;Pl\xE4tze:&nbsp;{{vm.freePlaces}}</span> <span class="label label-info" ng-show="vm.freePlaces < 0">&Uuml;berbuchte&nbsp;Pl\xE4tze:&nbsp;{{-vm.freePlaces}}</span></div></div></div><br><div class="alert alert-info" role="alert" ng-show="vm.payments.length == 0"><b>Keine Daten vorhanden!</b> Bisher existieren keine zugeordneten Zahlungen f&uuml;r dieses Projekt.</div><div class="table-responsive" ng-show="vm.payments.length > 0"><table class="jh-table table"><thead><tr><th><span data-translate="askApp.payment.date">Date</span></th><th colspan="2"><span data-translate="askApp.payment.amount">Amount</span></th><th><span data-translate="askApp.payment.reference">Reference</span></th><th><span data-translate="askApp.payment.category">Category</span></th><th>Mitglied</th><th has-authority="ROLE_FINANCE"></th></tr></thead><tbody><tr ng-repeat="payment in vm.payments track by payment.id"><td>{{payment.date | date:\'dd.MM.yyyy\'}}</td><td ng-if="payment.amount < 0" style="text-align: right; color: darkred">-&nbsp;{{vm.abs(payment.amount) | number: 2}}&nbsp;&euro;</td><td></td><td ng-if="payment.amount >= 0" style="text-align: left; color: darkgreen">+&nbsp;{{payment.amount | number: 2}}&nbsp;&euro;</td><td>{{payment.reference | limitTo:15}}{{payment.reference.length > 15 ? \'...\' : \'\'}} <span class="glyphicon glyphicon-info-sign" aria-hidden="true" uib-popover="{{payment.reference}}" popover-trigger="mouseenter" style="cursor: pointer" ng-show="payment.reference.length > 15"></span></td><td><span data-translate="{{\'askApp.EnumPaymentCategory.\' + payment.category}}"></span></td><td><a ng-if="payment.user" ui-sref="member-management-detail({id:payment.user.id})">{{payment.user.firstName}} {{payment.user.lastName}} </a><span ng-if="payment.user.nickname" class="glyphicon glyphicon-info-sign" aria-hidden="true" popover-trigger="mouseenter" uib-popover="{{payment.user.nickname}}" style="cursor: pointer"></span></td><td has-authority="ROLE_FINANCE"><button type="submit" ui-sref="board.project-detail.payments.edit({paymentId:payment.id})" ng-disabled="vm.project.closed" class="btn btn-primary btn-xs"><span class="glyphicon glyphicon-pencil"></span></button></td></tr><tr><td>Summen:</td><td style="text-align: right; color: darkred">-&nbsp;{{-vm.sumNegative | number: 2}}&nbsp;&euro;</td><td style="text-align: left; color: darkgreen">+&nbsp;{{vm.sumPositive | number: 2}}&nbsp;&euro;</td><td ng-if="vm.totalSum < 0" style="text-align: left; color: darkred">=&nbsp;-{{vm.abs(vm.totalSum) | number: 2}}&nbsp;&euro;</td><td ng-if="vm.totalSum >= 0" style="text-align: left; color: darkgreen">=&nbsp;+{{vm.totalSum | number: 2}}&nbsp;&euro;</td><td></td><td></td><td has-authority="ROLE_FINANCE"></td></tr></tbody></table></div></div></div></div>');
$templateCache.put('app/board/project/detail/notes/project-detail-notes.html','<!--\n  ~ Copyright (c) 2017 by Julian Feder, julian.feder@yahoo.de\n  ~\n  ~ This product includes software developed at\n  ~ The Apache Software Foundation (http://www.apache.org/).\n  --><div class="notes"><div class="panel panel-default"><div class="panel-heading"><h3 class="panel-title">Notizen</h3></div><div class="panel-body"><div class="row"><div class="member-management-detail-table"><div class="col-md-12"><summernote config="vm.options" ng-model="vm.project.notes" ng-change="vm.save()"></summernote></div></div></div></div></div></div>');
$templateCache.put('app/board/project/detail/sbf-overview/sbf-overview.html','<!--\n  ~ Copyright (c) 2017 by Julian Feder, julian.feder@yahoo.de\n  ~\n  ~ This product includes software developed at\n  ~ The Apache Software Foundation (http://www.apache.org/).\n  --><div><div class="panel panel-default"><div class="panel-heading"><h3 class="panel-title">SBF-See \xDCbersicht</h3></div><div class="panel-body"><div class="btn-group"><button type="submit" ng-click="vm.toggle()" class="btn btn-default btn-md" ng-class="{active: !vm.selectAll}"><span class="hidden-sm-down">Bevorstehende</span></button> <button type="submit" ng-click="vm.toggle()" class="btn btn-default btn-md" ng-class="{active: vm.selectAll}"><span class="hidden-sm-down">Alle</span></button></div><button class="btn btn-primary" ng-click="vm.dataExport()" analytics-on analytics-event="SBF Stunden exportiert" style="float:right; margin-right: 10px"><span class="glyphicon glyphicon-export"></span> <span class="hidden-xs-down">Daten exportieren</span></button><hr><div class="alert alert-info" role="alert" ng-show="vm.sbfOverview.length == 0"><b>Keine Daten vorhanden!</b> F\xFCge Termine hinzu oder \xE4ndere die Auswahlkategorie.</div><div ng-repeat="slot in vm.sbfOverview track by $index" ng-show="vm.sbfOverview.length > 0"><h5><span class="glyphicon glyphicon-calendar" aria-hidden="true"></span> <b ng-if="slot.fromTime > vm.project.untilDate">Pr\xFCfung: </b>{{slot.fromTime | date:"EEEE, dd.MM.yyyy HH:mm"}} Uhr - {{slot.toTime | date:"HH:mm"}} Uhr, {{slot.instructorName}}</h5><span ng-show="slot.participants.length == 0" class="label label-danger">Bisher keine Anmeldungen</span><div ng-repeat="participant in slot.participants"><ul style="margin-left: 0"><li><span has-authority="ROLE_BOARD"><a ui-sref="member-management-detail({id:participant.id})">{{participant.firstName}} {{participant.lastName}}<span ng-if="participant.nickname"> "{{participant.nickname}}"</span></a></span> <span has-authority="ROLE_MANAGER">{{participant.firstName}} {{participant.lastName}} <span ng-if="participant.nickname">"{{participant.nickname}}"</span></span> | <a href="tel:{{participant.phone}}">{{participant.phone}}</a> | <a href="mailto:{{participant.mail}}">{{participant.mail}}</a></li></ul></div><hr ng-hide="$last"></div></div></div></div>');
$templateCache.put('app/board/project/detail/sbf-time-slot/sbf-time-slot-delete-dialog.html','<form name="deleteForm" ng-submit="vm.confirmDelete(vm.sbfTimeSlot.id)" show-validation><div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()">&times;</button><h4 class="modal-title" data-translate="entity.delete.title">Confirm delete operation</h4></div><div class="modal-body"><jhi-alert-error></jhi-alert-error><p data-translate="askApp.sbfTimeSlot.delete.question" translate-values="{id: \'{{vm.sbfTimeSlot.id}}\',\n           firstName: \'{{vm.sbfTimeSlot.instructor.user.firstName}}\',\n           lastName: \'{{vm.sbfTimeSlot.instructor.user.lastName}}\',\n           nickname: \'{{vm.nickname}}\',\n           fromTime: \'{{vm.sbfTimeSlot.fromTime |  date: \'dd.MM.yyyy HH:mm\'}}\',\n           toTime: \'{{vm.sbfTimeSlot.toTime |  date: \'dd.MM.yyyy HH:mm\'}}\'}">Are you sure you want to delete this Sbf Time Slot?</p><div class="form-group"><label class="control-label"><span ng-if="vm.sbfTimeSlot.amount == 1 || !vm.sbfTimeSlot.amount" data-translate="askApp.sbfTimeSlot.delete.freeParticipantsSingle"></span> <span ng-if="vm.sbfTimeSlot.amount > 1" data-translate="askApp.sbfTimeSlot.delete.freeParticipantsMultiple"></span></label><br><switch ng-model="vm.sbfTimeSlot.freeParticipants" class="green"></switch></div><div class="form-group"><label class="control-label" data-translate="askApp.sbfTimeSlot.amountDelete" for="field_weight">Amount</label><input type="number" class="form-control" name="weight" id="field_weight" ng-model="vm.sbfTimeSlot.amount" placeholder="{{\'askApp.sbfTimeSlot.amount\' | translate}}" min="1" max="30" ng-init="vm.sbfTimeSlot.amount = 1"><div ng-show="deleteForm.weight.$invalid"><p class="help-block" ng-show="deleteForm.weight.$error.min" data-translate="entity.validation.min" translate-value-min="1">This field should be at least 0.</p><p class="help-block" ng-show="deleteForm.weight.$error.max" data-translate="entity.validation.max" translate-value-max="30">This field cannot be more than 200.</p><p class="help-block" ng-show="deleteForm.weight.$error.number" data-translate="entity.validation.number">This field should be a number.</p></div></div></div><div class="modal-footer"><button type="button" class="btn btn-default" data-dismiss="modal" ng-click="vm.clear()"><span class="glyphicon glyphicon-ban-circle"></span>&nbsp;<span data-translate="entity.action.cancel">Cancel</span></button> <button type="submit" ng-disabled="deleteForm.$invalid" class="btn btn-danger"><span class="glyphicon glyphicon-remove-circle"></span>&nbsp;<span data-translate="entity.action.delete">Delete</span></button></div></form>');
$templateCache.put('app/board/project/detail/sbf-time-slot/sbf-time-slot-dialog.html','<form name="editForm" role="form" novalidate ng-submit="vm.save()" show-validation><div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()">&times;</button><h4 class="modal-title" id="mySbfTimeSlotLabelEdit" data-translate="askApp.sbfTimeSlot.home.createOrEditLabel" ng-show="vm.sbfTimeSlot.id">Create or edit a Sbf Time Slot</h4><h4 class="modal-title" id="mySbfTimeSlotLabelNew" data-translate="askApp.sbfTimeSlot.home.createLabel" ng-show="!vm.sbfTimeSlot.id">Create or edit a Sbf Time Slot</h4></div><div class="modal-body"><jhi-alert-error></jhi-alert-error><!--<div class="form-group" ng-show="vm.sbfTimeSlot.id">\n            <label for="id" data-translate="global.field.id">ID</label>\n            <input type="text" class="form-control" id="id" name="id"\n                    ng-model="vm.sbfTimeSlot.id" readonly />\n        </div>--><div class="form-group" ng-show="vm.isExam"><b>Pr\xFCfung!</b></div><div class="form-group"><label class="control-label" data-translate="askApp.sbfTimeSlot.fromTime" for="field_fromTime">From Time</label><div class="input-group"><input id="field_fromTime" type="text" class="form-control" name="fromTime" datetime-picker="{{\'dd.MM.yyyy HH:mm\'}}" ng-model="vm.sbfTimeSlot.fromTime" is-open="vm.datePickerOpenStatus.fromTime" ng-change="selectFromDate()" required> <span class="input-group-btn"><button type="button" class="btn btn-default" ng-click="vm.openCalendar(\'fromTime\')"><i class="glyphicon glyphicon-calendar"></i></button></span></div><div ng-show="editForm.fromTime.$invalid"><p class="help-block" ng-show="editForm.fromTime.$error.required" data-translate="entity.validation.required">This field is required.</p><p class="help-block" ng-show="editForm.fromTime.$error.ZonedDateTimelocal" data-translate="entity.validation.ZonedDateTimelocal">This field should be a date and time.</p></div></div><div class="form-group"><label class="control-label" data-translate="askApp.sbfTimeSlot.toTime" for="field_toTime">To Time</label><div class="input-group"><input id="field_toTime" type="text" class="form-control" name="toTime" datetime-picker="{{\'dd.MM.yyyy HH:mm\'}}" datepicker-options="options" ng-model="vm.sbfTimeSlot.toTime" is-open="vm.datePickerOpenStatus.toTime" required> <span class="input-group-btn"><button type="button" class="btn btn-default" ng-click="vm.openCalendar(\'toTime\')"><i class="glyphicon glyphicon-calendar"></i></button></span></div><div ng-show="editForm.toTime.$invalid"><p class="help-block" ng-show="editForm.toTime.$error.required" data-translate="entity.validation.required">This field is required.</p><p class="help-block" ng-show="editForm.toTime.$error.ZonedDateTimelocal" data-translate="entity.validation.ZonedDateTimelocal">This field should be a date and time.</p></div></div><div class="form-group"><label class="control-label" data-translate="askApp.sbfTimeSlot.maxParticipants" for="field_maxParticipants">Max Participants</label><input type="number" class="form-control" name="maxParticipants" id="field_maxParticipants" ng-model="vm.sbfTimeSlot.maxParticipants" required min="1" max="30"><div ng-show="editForm.maxParticipants.$invalid"><p class="help-block" ng-show="editForm.maxParticipants.$error.required" data-translate="entity.validation.required">This field is required.</p><p class="help-block" ng-show="editForm.maxParticipants.$error.min" data-translate="entity.validation.min" translate-value-min="1">This field should be at least 1.</p><p class="help-block" ng-show="editForm.maxParticipants.$error.max" data-translate="entity.validation.max" translate-value-max="30">This field cannot be more than 30.</p><p class="help-block" ng-show="editForm.maxParticipants.$error.number" data-translate="entity.validation.number">This field should be a number.</p></div></div><div class="form-group"><label class="control-label" for="field_profile">Ausbilder</label><input type="text" ng-model="vm.sbfTimeSlot.instructor" placeholder="Suche Mitglied" uib-typeahead="profile as (profile.user.firstName + \' \' + profile.user.lastName + (profile.nickname ? (\' &quot;\' + profile.nickname + \'&quot;\') : (\'\'))) for profile in vm.getUser($viewValue)" typeahead-loading="loadingLocations" typeahead-no-results="noResults" name="instructor" id="field_profile" required autocomplete="off" class="form-control"><div ng-show="editForm.instructor.$invalid"><p class="help-block" ng-show="editForm.instructor.$error.required" data-translate="entity.validation.required">This field is required.</p></div></div><div class="form-group" ng-show="vm.sbfTimeSlot.id == null"><label class="control-label" data-translate="askApp.sbfTimeSlot.amount" for="field_weight">Amount</label><input type="number" class="form-control" name="weight" id="field_weight" ng-model="vm.sbfTimeSlot.amount" placeholder="{{\'askApp.sbfTimeSlot.amount\' | translate}}" min="1" max="30" ng-init="vm.sbfTimeSlot.amount = 1"><div ng-show="editForm.weight.$invalid"><p class="help-block" ng-show="editForm.weight.$error.min" data-translate="entity.validation.min" translate-value-min="1">This field should be at least 0.</p><p class="help-block" ng-show="editForm.weight.$error.max" data-translate="entity.validation.max" translate-value-max="30">This field cannot be more than 200.</p><p class="help-block" ng-show="editForm.weight.$error.number" data-translate="entity.validation.number">This field should be a number.</p></div></div><div class="form-group"><label data-translate="askApp.sbfTimeSlot.participants" for="field_participants">Participants</label><select class="form-control" id="field_participants" multiple="multiple" size="10" name="participants" ng-model="vm.sbfTimeSlot.participants" ng-options="profile as (profile.firstName + \' \' + profile.lastName + (profile.nickname ? (\' &quot;\' + profile.nickname + \'&quot;\') : (\'\'))) for profile in vm.profiles track by profile.id"></select></div></div><div class="modal-footer"><button type="button" class="btn btn-default" data-dismiss="modal" ng-click="vm.clear()"><span class="glyphicon glyphicon-ban-circle"></span>&nbsp;<span data-translate="entity.action.cancel">Cancel</span></button> <button type="submit" ng-disabled="editForm.$invalid || vm.isSaving" class="btn btn-primary"><span class="glyphicon glyphicon-save"></span>&nbsp;<span data-translate="entity.action.save">Save</span></button></div></form>');
$templateCache.put('app/board/project/detail/sbf-time-slot/sbf-time-slots.html','<!--\n  ~ Copyright (c) 2017 by Julian Feder, julian.feder@yahoo.de\n  ~\n  ~ This product includes software developed at\n  ~ The Apache Software Foundation (http://www.apache.org/).\n  --><div><div class="panel panel-default"><div class="panel-heading"><h3 class="panel-title">SBF-See Planer</h3></div><div class="panel-body"><jhi-alert></jhi-alert><div class="container-fluid"><div class="row"><div class="col-xs-12 col-md-8 no-padding-left"><button class="btn btn-primary" ui-sref="board.project-detail.sbf-time-slot.new"><span class="glyphicon glyphicon-plus"></span> <span class="hidden-xs-down" data-translate="askApp.sbfTimeSlot.home.createLabel">Create new Sbf Time Slot</span></button></div><div class="col-xs-12 col-md-4 no-padding-right no-padding-left row-margin-top"><form name="searchForm" class="form-inline"><div class="input-group pull-right"><input type="text" class="form-control" ng-model="vm.searchQuery" id="searchQuery" placeholder="{{ \'askApp.sbfTimeSlot.home.search\' | translate }}"> <span class="input-group-btn width-min"><button class="btn btn-info" ng-click="vm.search(vm.searchQuery)"><span class="glyphicon glyphicon-search"></span></button> </span><span class="input-group-btn width-min" ng-if="vm.currentSearch"><button class="btn btn-info" ng-click="vm.clear()"><span class="glyphicon glyphicon-trash"></span></button></span></div></form></div></div></div><br><div class="alert alert-info" role="alert" ng-show="vm.sbfTimeSlots.length == 0"><b>Keine Daten vorhanden!</b> Bisher existieren keine Termine f\xFCr diesen Kurs.</div><div class="table-responsive" ng-show="vm.sbfTimeSlots.length > 0"><table class="jh-table table table-striped"><thead><tr jh-sort="vm.predicate" ascending="vm.reverse" callback="vm.transition()"><!--<th jh-sort-by="id"><span data-translate="global.field.id">ID</span> <span class="glyphicon glyphicon-sort"></span></th>--><th jh-sort-by="fromTime"><span data-translate="askApp.sbfTimeSlot.fromTime">From Time</span> <span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="toTime"><span data-translate="askApp.sbfTimeSlot.toTime">To Time</span> <span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="maxParticipants"><span data-translate="askApp.sbfTimeSlot.participants">Participants</span> <span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="instructor.id"><span data-translate="askApp.sbfTimeSlot.instructor">Instructor</span> <span class="glyphicon glyphicon-sort"></span></th><th></th></tr></thead><tbody><tr ng-repeat="sbfTimeSlot in vm.sbfTimeSlots track by sbfTimeSlot.id"><td>{{sbfTimeSlot.fromTime | date:\'dd.MM.yyyy HH:mm\'}}</td><td>{{sbfTimeSlot.toTime | date:\'dd.MM.yyyy HH:mm\'}}</td><td><b ng-if="sbfTimeSlot.fromTime > vm.project.untilDate">P: </b><span class="label" ng-class="{\'label-success\': sbfTimeSlot.bookedPlaces == 0, \'label-warning\': sbfTimeSlot.bookedPlaces >= 1 && sbfTimeSlot.freePlaces > 0, \'label-danger\': sbfTimeSlot.freePlaces <= 0}">{{sbfTimeSlot.bookedPlaces}}/{{sbfTimeSlot.maxParticipants}}</span> <span class="glyphicon glyphicon-info-sign" ng-show="sbfTimeSlot.bookedPlaces > 0" aria-hidden="true" popover-trigger="mouseenter" popover-title="Teilnehmer" uib-popover-template="\'popover-partial2.html\'" style="cursor: pointer"></span></td><td><span has-authority="ROLE_BOARD"><a ui-sref="member-management-detail({id:sbfTimeSlot.instructor.id})">{{sbfTimeSlot.instructor.user.firstName}} {{sbfTimeSlot.instructor.user.lastName}}</a></span> <span has-authority="ROLE_MANAGER">{{sbfTimeSlot.instructor.user.firstName}} {{sbfTimeSlot.instructor.user.lastName}}</span> <span ng-if="sbfTimeSlot.instructor.nickname" class="glyphicon glyphicon-info-sign" aria-hidden="true" popover-trigger="mouseenter" uib-popover="{{sbfTimeSlot.instructor.nickname}}" style="cursor: pointer"></span></td><td class="text-right"><div class="btn-group flex-btn-group-container"><button type="submit" ui-sref="board.project-detail.sbf-time-slot.edit({sbfId:sbfTimeSlot.id})" class="btn btn-primary btn-xs"><span class="glyphicon glyphicon-pencil"></span></button> <button type="submit" ui-sref="board.project-detail.sbf-time-slot.delete({sbfId:sbfTimeSlot.id})" class="btn btn-danger btn-xs"><span class="glyphicon glyphicon-remove-circle"></span></button></div></td></tr></tbody></table></div></div></div><div class="text-center" ng-show="vm.sbfTimeSlots.length > 0"><jhi-item-count page="vm.page" total="vm.queryCount" items-per-page="vm.itemsPerPage"></jhi-item-count><uib-pagination class="pagination-sm" total-items="vm.totalItems" items-per-page="vm.itemsPerPage" ng-model="vm.page" ng-change="vm.transition()"></uib-pagination></div></div><script type="text/ng-template" id="popover-partial2.html"><ul style="padding-left:20px;">\n        <li ng-repeat="participant in sbfTimeSlot.participants track by $index">\n            {{participant.firstName}} {{participant.lastName}}<span ng-if="participant.nickname"> "{{participant.nickname}}"</span>\n        </li>\n    </ul></script>');
$templateCache.put('app/board/project/detail/sks-overview/sks-overview.html','<!--\n  ~ Copyright (c) 2017 by Julian Feder, julian.feder@yahoo.de\n  ~\n  ~ This product includes software developed at\n  ~ The Apache Software Foundation (http://www.apache.org/).\n  --><div><div class="panel panel-default"><div class="panel-heading"><h3 class="panel-title">SKS \xDCbersicht</h3></div><div class="panel-body"><button type="submit" ng-click="vm.toggleAccordion()" class="btn btn-default btn-md" style="margin-bottom: 20px"><span class="hidden-sm-down">{{vm.toggled ? \'Zuklappen\' : \'Aufklappen\'}}</span></button> <button class="btn btn-primary" ng-click="vm.dataExport()" ng-disabled="vm.accordionArray.length == 0 || vm.isSaving" analytics-on analytics-event="SKS exportiert" style="float:right; margin-right: 10px"><span class="glyphicon glyphicon-export"></span> <span class="hidden-xs-down">Daten exportieren</span></button><uib-accordion close-others="false" ng-show="vm.sksOverview.length >= 1"><div ng-repeat="sks in vm.sksOverview track by $index"><div uib-accordion-group class="panel-default" style="margin-bottom: 10px" is-open="vm.accordionArray[$index]"><div uib-accordion-heading><i class="glyphicon" ng-class="{\'glyphicon-chevron-down\': vm.accordionArray[$index], \'glyphicon-chevron-right\': !vm.accordionArray[$index]}"></i> {{sks.name}} | {{sks.fromDate | date:\'mediumDate\'}} - {{sks.untilDate | date:\'mediumDate\'}} | {{sks.skipper.user.firstName}} {{sks.skipper.user.lastName}}<span ng-if="sks.skipper.nickname"> "{{sks.skipper.nickname}}"</span> <span class="glyphicon glyphicon-eye-open pull-right" ng-show="sks.id != vm.project.id" aria-hidden="true" style="margin-left: 5px" ng-click="vm.goTo(sks.id);"></span> <span class="glyphicon glyphicon-ok pull-right" aria-hidden="true" ng-show="sks.booked"></span> <span class="glyphicon glyphicon-remove pull-right" aria-hidden="true" ng-show="!sks.booked"></span></div><div class="alert alert-info" role="alert" ng-show="sks.bookings.length == 0"><b>Keine Daten vorhanden!</b> Bisher existieren keine Buchungen f\xFCr dieses Projekt.</div><div class="table-responsive" ng-show="sks.bookings.length > 0"><table class="jh-table table table-striped"><thead><tr jh-sort="vm.predicate" ascending="vm.reverse" callback="vm.transition()"><th><span data-translate="askApp.booking.date">Date</span></th><th><span>Mitglied</span></th><th><span>E-Mail</span></th><th><span>Handy</span></th><th><span>Bezahlstatus</span></th><th><span>SBF-See</span></th><th><span>Theorie</span></th><th><span>Kommentar</span></th></tr></thead><tbody><tr ng-repeat="booking in sks.bookings track by booking.id"><td>{{booking.date | date:\'mediumDate\'}}</td><td><span has-authority="ROLE_BOARD"><a ui-sref="member-management-detail({id:booking.profileId})">{{booking.firstName}} {{booking.lastName}}</a></span> <span has-authority="ROLE_MANAGER">{{booking.firstName}} {{booking.lastName}}</span> <span ng-if="booking.nickname" class="glyphicon glyphicon-info-sign" aria-hidden="true" popover-trigger="mouseenter" uib-popover="{{booking.nickname}}" style="cursor: pointer"></span></td><td style="text-align: center"><a href="mailto:{{booking.eMail}}"><span class="glyphicon glyphicon glyphicon glyphicon-envelope" uib-popover="{{booking.eMail}}" popover-trigger="mouseenter"></span></a></td><td style="text-align: center"><a href="tel:{{booking.phone}}"><span class="glyphicon glyphicon glyphicon-phone" style="cursor: pointer" uib-popover="{{booking.phone}}" popover-trigger="mouseenter"></span></a></td><td><span class="label label-danger" data-translate="{{\'askApp.EnumDeptStatus.\' + booking.paymentStatus}}" ng-show="booking.paymentStatus == \'pending\'">{{booking.paymentStatus}}</span> <span class="label label-success" data-translate="{{\'askApp.EnumDeptStatus.\' + booking.paymentStatus}}" ng-show="booking.paymentStatus == \'payed\'">{{booking.paymentStatus}}</span> <span class="label label-warning" data-translate="{{\'askApp.EnumDeptStatus.\' + booking.paymentStatus}}" ng-show="booking.paymentStatus == \'partial\'">{{booking.paymentStatus}}</span> <span class="label label-warning" data-translate="{{\'askApp.EnumDeptStatus.\' + booking.paymentStatus}}" ng-show="booking.paymentStatus == \'prePayed\'">{{booking.paymentStatus}}</span> <span class="label label-danger" data-translate="{{\'askApp.EnumDeptStatus.\' + booking.paymentStatus}}" ng-show="booking.paymentStatus == \'payedToMuch\'">{{booking.paymentStatus}}</span> <span class="glyphicon glyphicon-info-sign" aria-hidden="true" popover-trigger="mouseenter" popover-title="Bezahlstatus" uib-popover-template="\'popover-partial.html\'" style="cursor: pointer"></span> <a ui-sref="board.dept.edit({id:booking.deptId})" has-authority="ROLE_FINANCE"><span class="glyphicon glyphicon-pencil"></span></a></td><td style="text-align: center"><span style="cursor: pointer" class="glyphicon glyphicon-ok" aria-hidden="true" uib-popover="{{booking.sbfSee}}" popover-trigger="mouseenter" ng-if="booking.sbfSee"></span> <span class="glyphicon glyphicon-remove" aria-hidden="true" ng-if="!booking.sbfSee"></span></td><td style="text-align: center"><span class="glyphicon glyphicon-ok" aria-hidden="true" ng-if="booking.sksTheoryAvailable"></span> <span class="glyphicon glyphicon-remove" aria-hidden="true" ng-if="!booking.sksTheoryAvailable"></span></td><td style="text-align: center"><span style="cursor: pointer" class="glyphicon glyphicon-comment" aria-hidden="true" uib-popover="{{booking.comment}}" popover-trigger="mouseenter" ng-if="booking.comment" popover-append-to-body="true"></span> <span class="glyphicon glyphicon-remove" aria-hidden="true" ng-if="!booking.comment"></span> <span style="cursor: pointer" class="glyphicon glyphicon-comment" ng-if="booking.individualField" aria-hidden="true" popover-trigger="mouseenter" popover-title="{{sks.individualField}}" uib-popover-template="\'popover-individualQuestion.html\'" popover-append-to-body="true"></span></td></tr></tbody></table></div></div></div></uib-accordion></div></div></div><script type="text/ng-template" id="popover-individualQuestion.html"><span>\n        {{booking.individualField}}\n    </span></script><script type="text/ng-template" id="popover-partial.html"><div class="form-group">\n        <table>\n            <tr>\n                <td>Originalpreis:</td>\n                <td>{{booking.price | number:2}}\u20AC</td>\n            </tr>\n            <tr>\n                <td>Forderungsbetrag:</td>\n                <td>{{booking.amount | number:2}}\u20AC</td>\n            </tr>\n            <tr>\n                <td style="width: 150px;">Aktivit\xE4tenpunkte:</td>\n                <td>{{booking.apCount}}</td>\n            </tr>\n            <tr>\n                <td>Soll:</td>\n                <td>{{booking.priceNet | number:2}}\u20AC</td>\n            </tr>\n            <tr ng-repeat="payment in booking.payments">\n                <td>{{payment.date | date:\'dd.MM.yyyy\'}}:</td>\n                <td>{{payment.amount | number:2}}\u20AC</td>\n            </tr>\n            <tr>\n                <td>Ist:</td>\n                <td>{{booking.payed | number:2}}\u20AC</td>\n            </tr>\n            <tr>\n                <td colspan="2">\n                    <hr>\n                </td>\n            </tr>\n            <tr>\n                <td><span data-translate="askApp.dept.toPay">Saldo</span>:</td>\n                <td><b>{{booking.toPay | number:2}}\u20AC</b></td>\n            </tr>\n        </table>\n    </div></script>');
$templateCache.put('app/board/dinghy/event/detail/bookings/dinghy-booking-dialog.html','<!--\n  ~ Copyright (c) 2020 by Felix Heim, felix-heim@web.de\n  ~\n  ~ This product includes software developed at\n  ~ The Apache Software Foundation (http://www.apache.org/).\n  --><form name="editForm" role="form" novalidate ng-submit="vm.save()" show-validation><div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()">&times;</button><h4 ng-if="vm.isNewBooking" class="modal-title" id="myBookingLabelNew" data-translate="askApp.dinghyBooking.home.createLabel" translate-value-event-name="{{vm.dinghyEvent.name}}">Create or edit a Booking</h4><h4 ng-if="!vm.isNewBooking" class="modal-title" id="myBookingLabelEdit" data-translate="askApp.dinghyBooking.home.editLabel" translate-value-first-name="{{vm.booking.profile.firstName}}" translate-value-last-name="{{vm.booking.profile.lastName}}" translate-value-event-name="{{vm.dinghyEvent.name}}" translate-value-nickname="{{vm.nickname}}">Create or edit a Booking</h4></div><div class="modal-body"><jhi-alert-error></jhi-alert-error><div ng-if="!vm.booking.profile.id"><!--------------------><!----- Firstname ----><!--------------------><div class="form-group"><label class="control-label" for="firstName" data-translate="settings.form.firstname">First Name</label><input type="text" class="form-control" id="firstName" name="firstName" placeholder="{{\'settings.form.firstname\' | translate}}" ng-model="vm.booking.profile.firstName" ng-minlength="1" ng-maxlength="50" required maxlength="50" prevent-enter-submit><div ng-show="(vm.isNewBooking || editForm.firstName.$dirty) && editForm.firstName.$invalid"><p class="help-block" ng-show="editForm.firstName.$error.required" data-translate="entity.validation.required">This field is required.</p><p class="help-block" ng-show="editForm.firstName.$error.minlength" data-translate="entity.validation.minlength" translate-value-min="1">Your mobile phone is required to be at least 1 characters.</p><p class="help-block" ng-show="v.firstName.$error.maxlength" data-translate="entity.validation.maxlength" translate-value-max="50">Your mobile phone cannot be longer than 50 characters.</p></div></div><!--------------------><!----- Lastname -----><!--------------------><div class="form-group"><label class="control-label" for="lastName" data-translate="settings.form.lastname">Last Name</label><input type="text" class="form-control" id="lastName" name="lastName" placeholder="{{\'settings.form.lastname\' | translate}}" ng-model="vm.booking.profile.lastName" ng-minlength="1" ng-maxlength="50" required maxlength="50" prevent-enter-submit><div ng-show="(vm.isNewBooking || editForm.lastName.$dirty) && editForm.lastName.$invalid"><p class="help-block" ng-show="editForm.lastName.$error.required" data-translate="entity.validation.required">This field is required.</p><p class="help-block" ng-show="editForm.lastName.$error.minlength" data-translate="entity.validation.minlength" translate-value-min="1">Your mobile phone is required to be at least 1 characters.</p><p class="help-block" ng-show="editForm.lastName.$error.maxlength" data-translate="entity.validation.maxlength" translate-value-max="50">Your mobile phone cannot be longer than 50 characters.</p></div></div><!--------------------><!-------- Mail ------><!--------------------><div class="form-group"><label class="control-label" for="field_mail" data-translate="global.form.email">Email</label><input type="email" class="form-control" id="field_mail" name="mail" placeholder="{{\'global.form.email\' | translate}}" ng-model="vm.booking.profile.mail" ng-minlength="5" ng-maxlength="50" required maxlength="50" prevent-enter-submit><div ng-show="(vm.isNewBooking || editForm.mail.$dirty) && editForm.mail.$invalid"><p class="help-block" ng-show="editForm.mail.$error.required" data-translate="entity.validation.required">This field is required.</p><p class="help-block" ng-show="editForm.mail.$error.email" data-translate="entity.validation.invalid">Your mobile phone does not math the E.164 format for phone numbers.</p><p class="help-block" ng-show="editForm.mail.$error.minlength" data-translate="entity.validation.minlength" translate-value-min="5">Your mobile phone is required to be at least 5 characters.</p><p class="help-block" ng-show="editForm.mail.$error.maxlength" data-translate="entity.validation.maxlength" translate-value-min="50">Your mobile phone cannot be longer than 15 characters.</p></div></div></div><!--------------------><!-- Booking Status --><!--------------------><hr ng-if="!vm.isNewBooking && !vm.booking.profile.id"><div class="form-group" ng-if="!vm.isNewBooking"><label class="control-label" data-translate="askApp.booking.status" for="field_status">Status</label><select class="form-control" name="bookingStatus" ng-model="vm.booking.bookingStatus" id="field_status"><option value="angemeldet" data-translate="askApp.EnumBookingStatusType.angemeldet">angemeldet</option><option value="warteliste" data-translate="askApp.EnumBookingStatusType.warteliste">warteliste</option><option value="abgelehnt" data-translate="askApp.EnumBookingStatusType.abgelehnt">abgelehnt</option><option value="zurueckgetreten" data-translate="askApp.EnumBookingStatusType.zurueckgetreten">zurueckgetreten</option></select></div><!--------------------><!---- Send Mail -----><!--------------------><div ng-show="vm.booking.bookingStatus != vm.oldBookingStatus && !vm.isNewBooking"><label class="control-label">Mitglied per E-Mail &uuml;ber die Status&auml;nderung informieren</label><br><switch ng-model="vm.booking.sendNotificationMail" class="green"></switch><div class="form-group" ng-show="vm.booking.sendNotificationMail"><label class="control-label" data-translate="askApp.booking.managerComment" for="field_managerComment">Comment</label><input type="text" class="form-control" name="managerComment" id="field_managerComment" ng-model="vm.booking.managerComment" ng-maxlength="250" prevent-enter-submit><div ng-show="editForm.managerComment.$dirty && editForm.managerComment.$invalid"><p class="help-block" ng-show="editForm.managerComment.$error.maxlength" data-translate="entity.validation.maxlength" translate-value-max="250">This field cannot be longer than 250 characters.</p></div></div></div><!--------------------><!--- Change Info  ---><!--------------------><div ng-if="!vm.isNewBooking && vm.booking.profile.id && vm.booking.price && vm.booking.price > 0" class="alert alert-info" data-translate="askApp.dinghyBooking.infoStatusChangeMemberPayed"></div><div ng-if="!vm.isNewBooking && vm.booking.profile.id && (!vm.booking.price || vm.booking.price == 0)" class="alert alert-info" data-translate="askApp.dinghyBooking.infoStatusChangeMemberFree"></div><!--------------------><!----- Comment  -----><!--------------------><hr ng-if="vm.isNewBooking || !vm.booking.profile.id"><div class="form-group"><label class="control-label" data-translate="askApp.booking.comment" for="field_comment">Comment</label><input type="text" class="form-control" name="comment" id="field_comment" ng-model="vm.booking.comment" ng-maxlength="250" prevent-enter-submit><div ng-show="editForm.comment.$dirty && editForm.comment.$invalid"><p class="help-block" ng-show="editForm.comment.$error.maxlength" data-translate="entity.validation.maxlength" translate-value-max="250">This field cannot be longer than 250 characters.</p></div></div><!--------------------><!-- individ. Ques. --><!--------------------><div class="form-group" ng-show="vm.dinghyEvent.individualQuestion !== null"><label class="control-label" for="field_individualQuestionAnswer">{{vm.dinghyEvent.individualQuestion}}</label><input type="text" class="form-control" name="individualQuestionAnswer" id="field_individualQuestionAnswer" ng-model="vm.booking.individualQuestionAnswer" ng-maxlength="250" prevent-enter-submit ng-required="vm.dinghyEvent.individualQuestion != null && vm.dinghyEvent.individualQuestion != \'\'"><div ng-show="(vm.isNewBooking || editForm.individualQuestionAnswer.$dirty) && editForm.individualQuestionAnswer.$invalid"><p class="help-block" ng-show="editForm.individualQuestionAnswer.$error.maxlength" data-translate="entity.validation.maxlength" translate-value-max="250">This field cannot be longer than 150 characters.</p><p class="help-block" ng-show="editForm.individualQuestionAnswer.$error.required" data-translate="entity.validation.required">This field is required.</p></div></div><!--------------------><!----- dinghies -----><!--------------------><hr ng-show="vm.dinghyEvent.availableDinghies && vm.dinghyEvent.availableDinghies.length > 0"><div class="form-group" ng-show="vm.dinghyEvent.availableDinghies && vm.dinghyEvent.availableDinghies.length > 0"><label class="control-label" for="field_dinghy">Jolle w\xE4hlen <small>(leerlassen falls Privatboot und im Kommentar spezifizieren)</small></label><select class="form-control" id="field_dinghy" name="dinghy" ng-model="vm.booking.dinghy" ng-options="dinghy as (dinghy.name + \' (\' + dinghy.type + \')\') for dinghy in vm.dinghyEvent.availableDinghies track by dinghy.id" ng-disabled="vm.disableEdit"><option value=""></option></select></div><!--------------------><!-- dinghy comment --><!--------------------><div class="form-group" ng-show="vm.dinghyEvent.availableDinghies && vm.dinghyEvent.availableDinghies.length > 0"><label class="control-label" for="field_commentDinghy">Kommentar zur Jollenwahl</label><input type="text" class="form-control" name="commentDinghy" id="field_commentDinghy" ng-model="vm.booking.commentDinghy" ng-maxlength="150" prevent-enter-submit ng-required="vm.dinghyEvent.availableDinghies && vm.dinghyEvent.availableDinghies.length > 0 && !vm.booking.dinghy" ng-disabled="vm.disableEdit"><div ng-show="editForm.commentDinghy.$invalid"><p class="help-block" ng-show="editForm.commentDinghy.$error.maxlength" data-translate="entity.validation.maxlength" translate-value-max="150">This field cannot be longer than 150 characters.</p><p class="help-block" ng-show="editForm.commentDinghy.$error.required" data-translate="entity.validation.required">This field is required.</p></div></div></div><div class="modal-footer"><button type="button" class="btn btn-default" data-dismiss="modal" ng-click="vm.clear()"><span class="glyphicon glyphicon-ban-circle"></span>&nbsp;<span data-translate="entity.action.cancel">Cancel</span></button> <button type="submit" ng-disabled="editForm.$invalid || vm.isSaving" class="btn btn-primary"><span class="glyphicon glyphicon-save"></span>&nbsp;<span data-translate="entity.action.save">Save</span></button></div></form>');
$templateCache.put('app/board/dinghy/event/detail/bookings/dinghy-bookings.html','<!--\n  ~ Copyright (c) 2020 by Felix Heim, felix-heim@web.de\n  ~\n  ~ This product includes software developed at\n  ~ The Apache Software Foundation (http://www.apache.org/).\n  --><div><div class="panel panel-default"><div class="panel-heading"><h3 class="panel-title" data-translate="askApp.dinghyBooking.home.title">DinghyBookings</h3></div><div class="panel-body"><jhi-alert></jhi-alert><div class="container-fluid"><div class="row"><div class="col-xs-12 col-md-6 no-padding-left"><div class="btn-group"><button type="submit" ui-sref="board.dinghy.event.detail.booking.new" ng-if="vm.dinghyEvent.allowGuests && (!vm.dinghyEvent.guestPrice || vm.dinghyEvent.guestPrice == 0)" ng-disabled="vm.isSaving || vm.dinghyEvent.canceled || vm.dinghyEvent.closed || !vm.dinghyEvent.active" class="btn btn-primary"><span class="glyphicon glyphicon-plus"></span> <span class="hidden-xs-down">Neu</span></button> <button class="btn btn-primary" ng-click="vm.refresh()" ng-disabled="vm.isSaving"><span class="glyphicon glyphicon-refresh"></span> <span class="hidden-xs-down">Neu laden</span></button> <button class="btn btn-primary" ng-click="vm.dataExport()" ng-disabled="vm.bookings.length == 0 || vm.isSaving" analytics-on analytics-event="Projektteilnehmer exportiert"><span class="glyphicon glyphicon-export"></span> <span class="hidden-xs-down">Daten exportieren</span></button></div></div><div class="col-xs-12 col-md-6 no-padding-right no-padding-left row-margin-top-sm" ng-show="vm.status"><span class="label label-success"><span data-translate="askApp.EnumBookingStatusType.angemeldet"></span>:&nbsp;{{vm.status.countAngemeldet}}</span> <span class="label label-danger"><span data-translate="askApp.EnumBookingStatusType.zurueckgetreten"></span>:&nbsp;{{vm.status.countZurueckgetreten}}</span> <span class="label label-danger"><span data-translate="askApp.EnumBookingStatusType.abgelehnt"></span>:&nbsp;{{vm.status.countAbgelehnt}}</span> <span class="label label-warning"><span data-translate="askApp.EnumBookingStatusType.warteliste"></span>:&nbsp;{{vm.status.countWarteliste}}</span><br><span class="label label-info">Pl\xE4tze:&nbsp;{{vm.dinghyEvent.placeCount}}</span> <span class="label label-info">G\xFCltige&nbsp;Anmeldungen:&nbsp;{{vm.validPlaces}}</span> <span class="label label-info" ng-show="vm.freePlaces >= 0">Freie&nbsp;Pl\xE4tze:&nbsp;{{vm.freePlaces}}</span> <span class="label label-info" ng-show="vm.freePlaces < 0">&Uuml;berbuchte&nbsp;Pl\xE4tze:&nbsp;{{-vm.freePlaces}}</span></div></div></div><br><div class="alert alert-info" role="alert" ng-show="vm.bookings.length == 0"><b>Keine Daten vorhanden!</b> Bisher existieren keine Buchungen f\xFCr dieses Projekt.</div><div class="table-responsive" ng-show="vm.bookings.length > 0"><table class="jh-table table table-striped"><thead><tr jh-sort="vm.predicate" ascending="vm.reverse" callback="vm.transition()"><th jh-sort-by="validationDate"><span data-translate="askApp.booking.date">Date</span> <span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="profile.user.firstName"><span>Mitglied</span> <span class="glyphicon glyphicon-sort"></span></th><th><span>Kontakt</span></th><th jh-sort-by="status"><span>Status</span> <span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="dept.paymentStatus"><span>Bezahlstatus</span> <span class="glyphicon glyphicon-sort"></span></th><th><span>Kommentar</span></th><th jh-sort-by="dinghy" ng-if="vm.dinghyEvent.availableDinghies && vm.dinghyEvent.availableDinghies.length > 0"><span>Jolle</span> <span class="glyphicon glyphicon-sort"></span></th><th></th></tr></thead><tbody><tr ng-repeat="booking in vm.bookings track by booking.id"><td>{{booking.bookingDate | date:\'short\'}}</td><td><span ng-show="vm.isBoard && booking.profile.id"><a ui-sref="member-management-detail({id:booking.profile.id})">{{booking.profile.firstName}} {{booking.profile.lastName}}</a></span> <span ng-show="!vm.isBoard || !booking.profile.id">{{booking.profile.firstName}} {{booking.profile.lastName}}</span> <span ng-if="booking.profile.nickname" class="glyphicon glyphicon-info-sign" aria-hidden="true" popover-trigger="mouseenter" uib-popover="{{booking.profile.nickname}}" style="cursor: pointer"></span></td><td style="text-align: center"><a href="mailto:{{booking.profile.mail}}"><span class="glyphicon glyphicon glyphicon glyphicon-envelope" uib-popover="{{booking.profile.mail}}" popover-trigger="mouseenter"></span> </a><a href="tel:{{booking.profile.phone}}" ng-if="booking.profile.phone"><span class="glyphicon glyphicon glyphicon-phone" style="cursor: pointer" uib-popover="{{booking.profile.phone}}" popover-trigger="mouseenter"></span></a></td><td><span class="label label-success" data-translate="{{\'askApp.EnumBookingStatusType.\' + booking.bookingStatus}}" ng-show="booking.bookingStatus == \'angemeldet\'">{{booking.bookingStatus}}</span> <span class="label label-danger" data-translate="{{\'askApp.EnumBookingStatusType.\' + booking.bookingStatus}}" ng-show="booking.bookingStatus == \'zurueckgetreten\'">{{booking.bookingStatus}}</span> <span class="label label-danger" data-translate="{{\'askApp.EnumBookingStatusType.\' + booking.bookingStatus}}" ng-show="booking.bookingStatus == \'abgelehnt\'">{{booking.bookingStatus}}</span> <span class="label label-warning" data-translate="{{\'askApp.EnumBookingStatusType.\' + booking.bookingStatus}}" ng-show="booking.bookingStatus == \'warteliste\'">{{booking.bookingStatus}}</span></td><td ng-if="booking.deptId"><span class="label label-danger" data-translate="{{\'askApp.EnumDeptStatus.\' + booking.paymentStatus}}" ng-show="booking.paymentStatus == \'pending\'">{{booking.paymentStatus}}</span> <span class="label label-success" data-translate="{{\'askApp.EnumDeptStatus.\' + booking.paymentStatus}}" ng-show="booking.paymentStatus == \'payed\'">{{booking.paymentStatus}}</span> <span class="label label-warning" data-translate="{{\'askApp.EnumDeptStatus.\' + booking.paymentStatus}}" ng-show="booking.paymentStatus == \'partial\'">{{booking.paymentStatus}}</span> <span class="label label-warning" data-translate="{{\'askApp.EnumDeptStatus.\' + booking.paymentStatus}}" ng-show="booking.paymentStatus == \'prePayed\'">{{booking.paymentStatus}}</span> <span class="label label-danger" data-translate="{{\'askApp.EnumDeptStatus.\' + booking.paymentStatus}}" ng-show="booking.paymentStatus == \'payedToMuch\'">{{booking.paymentStatus}}</span> <span class="glyphicon glyphicon-info-sign" aria-hidden="true" popover-trigger="mouseenter" popover-title="Bezahlstatus" uib-popover-template="\'popover-partial.html\'" style="cursor: pointer"></span> <a ui-sref="board.dinghy.event.detail.booking.edit-dept({deptId: booking.deptId})" has-authority="ROLE_FINANCE"><span class="glyphicon glyphicon-pencil"></span></a> <a ui-sref="board.dinghy.event.detail.booking.new-dept({userId: booking.profile.id})" has-authority="ROLE_FINANCE" ng-if="!vm.dinghyEvent.closed"><span class="glyphicon glyphicon-plus"></span></a></td><td ng-if="!booking.deptId"><span class="label label-info">Extern</span></td><td style="text-align: center"><span style="cursor: pointer" class="glyphicon glyphicon-comment" aria-hidden="true" uib-popover="{{booking.comment}}" popover-trigger="mouseenter" ng-show="booking.comment"></span> <span class="glyphicon glyphicon-remove" aria-hidden="true" ng-show="!booking.comment" popover-append-to-body="true"></span> <span class="glyphicon glyphicon-comment" ng-show="booking.individualQuestionAnswer" aria-hidden="true" popover-trigger="mouseenter" popover-title="{{vm.dinghyEvent.individualQuestion}}" uib-popover-template="\'popover-individualQuestion.html\'" style="cursor: pointer" popover-append-to-body="true"></span> <span class="glyphicon glyphicon-remove" aria-hidden="true" ng-show="!booking.individualQuestionAnswer && vm.dinghyEvent.individualQuestion"></span></td><td ng-if="vm.dinghyEvent.availableDinghies && vm.dinghyEvent.availableDinghies.length > 0"><a ng-if="booking.dinghy" ui-sref="board.dinghy.dinghy.edit({id: booking.dinghy.id})">{{booking.dinghy.name}}</a> <span class="glyphicon glyphicon-remove" aria-hidden="true" ng-if="!booking.dinghy" popover-append-to-body="true"></span> <span style="cursor: pointer" class="glyphicon glyphicon-comment" aria-hidden="true" uib-popover="{{booking.commentDinghy}}" popover-trigger="mouseenter" ng-show="booking.commentDinghy"></span></td><td class="text-right"><div class="btn-group flex-btn-group-container"><button type="submit" ui-sref="board.dinghy.event.detail.booking.edit({idBooking: booking.id})" class="btn btn-primary btn-xs"><span class="glyphicon glyphicon-pencil"></span></button> <button type="submit" ui-sref="board.dinghy.event.detail.booking.delete({idBooking: booking.id})" ng-disabled="booking.payments.length > 0" class="btn btn-danger btn-xs"><span class="glyphicon glyphicon-remove-circle"></span></button></div></td></tr></tbody></table></div></div></div><div class="text-center" ng-show="vm.bookings.length > 0"><jhi-item-count page="vm.page" total="vm.queryCount" items-per-page="vm.itemsPerPage"></jhi-item-count><uib-pagination class="pagination-sm" total-items="vm.totalItems" items-per-page="vm.itemsPerPage" ng-model="vm.page" ng-change="vm.transition()"></uib-pagination></div></div><script type="text/ng-template" id="popover-individualQuestion.html"><span>\n        {{booking.individualQuestionAnswer}}\n    </span></script><script type="text/ng-template" id="popover-partial.html"><div class="form-group">\n        <table>\n            <tr>\n                <td>Originalpreis:</td>\n                <td>{{booking.price | number:2}}\u20AC</td>\n            </tr>\n            <tr>\n                <td>Forderungsbetrag:</td>\n                <td>{{booking.amount | number:2}}\u20AC</td>\n            </tr>\n            <tr>\n                <td style="width: 150px;">Aktivit\xE4tenpunkte:</td>\n                <td>{{booking.apCount}}</td>\n            </tr>\n            <tr>\n                <td>Soll:</td>\n                <td>{{booking.priceNet | number:2}}\u20AC</td>\n            </tr>\n            <tr ng-repeat="payment in booking.payments">\n                <td>{{payment.date | date:\'dd.MM.yyyy\'}}:</td>\n                <td>{{payment.amount | number:2}}\u20AC</td>\n            </tr>\n            <tr>\n                <td>Ist:</td>\n                <td>{{booking.payed | number:2}}\u20AC</td>\n            </tr>\n            <tr>\n                <td colspan="2">\n                    <hr>\n                </td>\n            </tr>\n            <tr>\n                <td><span data-translate="askApp.dept.toPay">Saldo</span>:</td>\n                <td><b>{{booking.toPay | number:2}}\u20AC</b></td>\n            </tr>\n        </table>\n    </div></script>');
$templateCache.put('app/board/dinghy/event/detail/notes/dinghy-event-notes.html','<!--\n  ~ Copyright (c) 2017 by Julian Feder, julian.feder@yahoo.de\n  ~\n  ~ This product includes software developed at\n  ~ The Apache Software Foundation (http://www.apache.org/).\n  --><div class="notes"><div class="panel panel-default"><div class="panel-heading"><h3 class="panel-title" data-translate="askApp.dinghyEvent.detail.notesTitle"></h3></div><div class="panel-body"><div class="row"><div class="member-management-detail-table"><div class="col-md-12"><summernote config="vm.options" ng-model="vm.dinghyEvent.notes" ng-change="vm.save()"></summernote></div></div></div></div></div></div>');
$templateCache.put('app/board/dinghy/event/detail/depts/depts.html','<!--\n  ~ Copyright (c) 2021 by Felix Heim, felix-heim@web.de\n  ~\n  ~ This product includes software developed at\n  ~ The Apache Software Foundation (http://www.apache.org/).\n  --><div><div class="panel panel-default"><div class="panel-heading"><h3 class="panel-title" data-translate="askApp.dinghyEvent.detail.deptTitleDetail" translate-value-reference="{{vm.dinghyEvent.identifierFormatted}}"></h3></div><div class="panel-body"><jhi-alert></jhi-alert><div class="container-fluid"><div class="row"><div class="col-xs-12 col-md-6 no-padding-left"><button class="btn btn-primary" ng-click="vm.dataExport()" ng-disabled="vm.bookings.length == 0 || vm.isSaving" analytics-on analytics-event="Projektbogen exportiert"><span class="glyphicon glyphicon-export"></span> <span class="hidden-xs-down">Projektbogen exportieren</span></button> <button class="btn btn-primary" ui-sref="board.dinghy.event.detail.depts.new-dept-event" has-authority="ROLE_FINANCE" ng-disabled="(vm.status.countAngemeldet == 0 && vm.status.countZurueckgetreten == 0 && vm.status.countAbgelehnt == 0 && vm.status.countWarteliste == 0) || vm.dinghyEvent.closed"><span class="glyphicon glyphicon-plus"></span></button></div><div class="col-xs-12 col-md-6 no-padding-right no-padding-left row-margin-top" ng-show="vm.status"><span class="label label-success"><span data-translate="askApp.EnumBookingStatusType.angemeldet"></span>:&nbsp;{{vm.status.countAngemeldet}}</span> <span class="label label-danger"><span data-translate="askApp.EnumBookingStatusType.zurueckgetreten"></span>:&nbsp;{{vm.status.countZurueckgetreten}}</span> <span class="label label-danger"><span data-translate="askApp.EnumBookingStatusType.abgelehnt"></span>:&nbsp;{{vm.status.countAbgelehnt}}</span> <span class="label label-warning"><span data-translate="askApp.EnumBookingStatusType.warteliste"></span>:&nbsp;{{vm.status.countWarteliste}}</span><br><span class="label label-info">Pl\xE4tze:&nbsp;{{vm.dinghyEvent.placeCount}}</span> <span class="label label-info">G\xFCltige&nbsp;Anmeldungen:&nbsp;{{vm.validPlaces}}</span> <span class="label label-info" ng-show="vm.freePlaces >= 0">Freie&nbsp;Pl\xE4tze:&nbsp;{{vm.freePlaces}}</span> <span class="label label-info" ng-show="vm.freePlaces < 0">&Uuml;berbuchte&nbsp;Pl\xE4tze:&nbsp;{{-vm.freePlaces}}</span></div></div></div><br><div class="alert alert-info" role="alert" ng-show="vm.depts.length == 0"><b>Keine Daten vorhanden!</b> Bisher existieren keine individuellen Forderungen f&uuml;r dieses Jollenevent.</div><div class="table-responsive" ng-show="vm.depts.length > 0"><table class="jh-table table"><thead><tr><th><span data-translate="askApp.dept.date">Date</span></th><th><span>Mitglied</span></th><th><span data-translate="askApp.dept.reference">Reference</span></th><th><span data-translate="askApp.dept.amount">Amount</span></th><th><span data-translate="askApp.dept.paymentStatus">Payment Status</span></th><th has-authority="ROLE_FINANCE"></th></tr></thead><tbody><tr ng-repeat="dept in vm.depts track by dept.id"><td>{{dept.date | date:\'mediumDate\'}}</td><td><span has-authority="ROLE_MANAGER">{{dept.profile.user.firstName}} {{dept.profile.user.lastName}}</span> <span has-authority="ROLE_BOARD"><a ui-sref="member-management-detail({id:dept.profile.id})">{{dept.profile.user.firstName}} {{dept.profile.user.lastName}}</a></span> <span ng-if="dept.profile.nickname" class="glyphicon glyphicon-info-sign" aria-hidden="true" popover-trigger="mouseenter" uib-popover="{{dept.profile.nickname}}" style="cursor: pointer"></span></td><td>{{dept.reference}}</td><td>{{dept.amount | number:2}}\u20AC</td><td><span class="label label-danger" data-translate="{{\'askApp.EnumDeptStatus.\' + dept.paymentStatus}}" ng-show="dept.paymentStatus == \'pending\'">{{dept.paymentStatus}}</span> <span class="label label-success" data-translate="{{\'askApp.EnumDeptStatus.\' + dept.paymentStatus}}" ng-show="dept.paymentStatus == \'payed\'">{{dept.paymentStatus}}</span> <span class="label label-warning" data-translate="{{\'askApp.EnumDeptStatus.\' + dept.paymentStatus}}" ng-show="dept.paymentStatus == \'partial\'">{{dept.paymentStatus}}</span> <span class="label label-warning" data-translate="{{\'askApp.EnumDeptStatus.\' + dept.paymentStatus}}" ng-show="dept.paymentStatus == \'prePayed\'">{{dept.paymentStatus}}</span> <span class="label label-danger" data-translate="{{\'askApp.EnumDeptStatus.\' + dept.paymentStatus}}" ng-show="dept.paymentStatus == \'payedToMuch\'">{{dept.paymentStatus}}</span> <span class="glyphicon glyphicon-info-sign" aria-hidden="true" popover-trigger="mouseenter" popover-title="Forderung" uib-popover-template="\'popover-partial.html\'" style="cursor: pointer"></span></td><td class="text-right" has-authority="ROLE_FINANCE"><div class="btn-group flex-btn-group-container"><button type="submit" ui-sref="board.dinghy.event.detail.depts.edit-dept({deptId: dept.id})" class="btn btn-primary btn-xs"><span class="glyphicon glyphicon-pencil"></span></button> <button type="submit" ui-sref="board.dinghy.event.detail.depts.new-dept({userId: dept.profile.id})" class="btn btn-primary btn-xs"><span class="glyphicon glyphicon-plus"></span></button></div></td></tr></tbody></table></div></div></div></div><script type="text/ng-template" id="popover-partial.html"><div class="form-group">\n        <table>\n            <tr>\n                <td>Betrag:</td>\n                <td>{{dept.amount | number:2}}\u20AC</td>\n            </tr>\n            <tr>\n                <td style="width: 150px;">Aktivit\xE4tenpunkte:</td>\n                <td>{{dept.apCount}}</td>\n            </tr>\n            <tr>\n                <td>Soll:</td>\n                <td>{{dept.priceNet | number:2}}\u20AC</td>\n            </tr>\n            <tr ng-repeat="payment in dept.payments">\n                <td>{{payment.date | date:\'dd.MM.yyyy\'}}:</td>\n                <td>{{payment.amount | number:2}}\u20AC</td>\n            </tr>\n            <tr>\n                <td>Ist:</td>\n                <td>{{dept.payed | number:2}}\u20AC</td>\n            </tr>\n            <tr>\n                <td colspan="2">\n                    <hr>\n                </td>\n            </tr>\n            <tr>\n                <td><span data-translate="askApp.dept.toPay">Saldo</span>:</td>\n                <td><b>{{dept.toPay | number:2}}\u20AC</b></td>\n            </tr>\n        </table>\n    </div></script>');
$templateCache.put('app/board/dinghy/event/detail/overview/dinghy-event-overview.html','<!--\n  ~ Copyright (c) 2020 by Felix Heim, felix-heim@web.de\n  ~\n  ~ This product includes software developed at\n  ~ The Apache Software Foundation (http://www.apache.org/).\n  --><div><div class="row row-no-padding-nested"><div class="alert alert-warning alert-margin-nested" ng-show="vm.isDinghy && !vm.dinghyEvent.godparent && !vm.dinghyEvent.canceled"><span data-translate="askApp.dinghyEvent.noGodparentInfo"></span> <span ng-show="!vm.dinghyEvent.godparent"><button type="submit" ui-sref="board.dinghy.event.detail.self-assign({id:vm.dinghyEvent.id})" class="btn btn-success btn-sm" ng-disabled="!vm.isDinghy || vm.dinghyEvent.canceled"><span data-translate="askApp.dinghyEvent.selfAssign"></span></button></span></div><jhi-alert></jhi-alert><div class="col-xs-12"><div class="input-group" style="margin-bottom: 20px"><span class="input-group-addon" id="basic-addon1">Anmeldelink</span> <input type="text" id="bookUrlText" class="form-control" value="{{vm.bookUrl}}" readonly="readonly"> <span class="input-group-btn"><button id="copyUrlButton" class="btn btn-primary" type="submit" data-clipboard-target="#bookUrlText"><span class="glyphicon glyphicon-copy" aria-hidden="true"></span></button> <button class="btn btn-primary" type="submit" ng-click="vm.goTo(vm.bookUrl)"><span class="glyphicon glyphicon-new-window" aria-hidden="true"></span></button></span></div></div></div><div class="member-management-detail-table"><div class="row row-no-padding-nested"><div class="col-md-6"><div class="panel panel-default"><div class="panel-heading"><h3 class="panel-title">Daten</h3></div><div class="panel-body"><table class="table no-border"><tr><td><b data-translate="askApp.dinghyEvent.name">Name</b></td><td><span>{{vm.dinghyEvent.name}}</span></td></tr><tr><td><b data-translate="askApp.dinghyEvent.type">Typ</b></td><td><span class="label label-info" data-translate="{{\'askApp.EnumDinghyEventType.\' + vm.dinghyEvent.type}}"></span></td></tr><tr><td><b data-translate="askApp.dinghyEvent.fromDate">Von</b></td><td>{{vm.dinghyEvent.fromDate | date: \'dd.MM.yyyy HH:mm\'}}</td></tr><tr><td><b data-translate="askApp.dinghyEvent.untilDate">Bis</b></td><td>{{vm.dinghyEvent.untilDate | date: \'dd.MM.yyyy HH:mm\'}}</td></tr><tr><td><b data-translate="askApp.dinghyEvent.placeCount">Pl\xE4tze</b></td><td>{{vm.dinghyEvent.placeCount}} <span class="glyphicon glyphicon-info-sign" aria-hidden="true" popover-trigger="mouseenter" popover-title="Buchungsstatus" uib-popover-template="\'popover-partial.html\'" style="cursor: pointer"></span></td></tr><tr ng-show="vm.dinghyEvent.location"><td><b data-translate="askApp.dinghyEvent.location">Ort</b></td><td>{{vm.dinghyEvent.location}}</td></tr><tr ng-show="vm.dinghyEvent.availableDinghies && vm.dinghyEvent.availableDinghies.length > 0"><td><b data-translate="askApp.dinghyEvent.availableDinghies">Available Dinghies</b></td><td><div ng-repeat="dinghy in vm.dinghyEvent.availableDinghies"><a ui-sref="board.dinghy.dinghy.edit({id: dinghy.id})">{{dinghy.name}}</a></div></td></tr><tr ng-show="vm.dinghyEvent.identifier"><td><b data-translate="askApp.dinghyEvent.identifier">Identifier</b></td><td><span class="label label-info">{{vm.dinghyEvent.identifier}}</span></td></tr><tr ng-show="vm.dinghyEvent.normalPrice"><td><b data-translate="askApp.dinghyEvent.normalPrice">Normalpreis</b></td><td>{{vm.dinghyEvent.normalPrice | number:2}}\u20AC</td></tr><tr ng-show="vm.dinghyEvent.normalPrice"><td><b data-translate="askApp.dinghyEvent.studentPrice">Studentenpreis</b></td><td>{{vm.dinghyEvent.studentPrice | number:2}}\u20AC</td></tr><tr ng-show="vm.dinghyEvent.allowGuests && vm.dinghyEvent.normalPrice"><td><b data-translate="askApp.dinghyEvent.guestPrice">Gastpreis</b></td><td>{{vm.dinghyEvent.guestPrice | number:2}}\u20AC</td></tr><tr><td><b data-translate="askApp.dinghyEvent.godparent">Jollenpate</b></td><td><a ng-show="vm.isBoard && vm.dinghyEvent.godparent" ui-sref="member-management-detail({id:vm.dinghyEvent.godparent.id})">{{vm.dinghyEvent.godparent.user.firstName}} {{vm.dinghyEvent.godparent.user.lastName}}<span ng-if="vm.dinghyEvent.godparent.nickname"> "{{vm.dinghyEvent.godparent.nickname}}"</span></a> <span ng-show="!vm.isBoard && vm.dinghyEvent.godparent">{{vm.dinghyEvent.godparent.user.firstName}} {{vm.dinghyEvent.godparent.user.lastName}}<span ng-if="vm.dinghyEvent.godparent.nickname"> "{{vm.dinghyEvent.godparent.nickname}}"</span></span> <span ng-show="!vm.dinghyEvent.godparent"><button type="submit" ui-sref="board.dinghy.event.detail.self-assign({id:vm.dinghyEvent.id})" class="btn btn-success btn-sm" ng-disabled="!vm.isDinghy || vm.dinghyEvent.canceled"><span data-translate="askApp.dinghyEvent.selfAssign"></span></button></span></td></tr><tr ng-show="vm.dinghyEvent.contactEmail"><td><b data-translate="askApp.dinghyEvent.contactEmail">Kontakt E-Mail</b></td><td><a href="mailto:{{vm.dinghyEvent.contactEmail}}">{{vm.dinghyEvent.contactEmail}}</a></td></tr><tr><td><b data-translate="askApp.dinghyEvent.individualQuestion">Individuelle Frage</b></td><td><span ng-show="vm.dinghyEvent.individualQuestion != null && vm.dinghyEvent.individualQuestion != \'\'">{{vm.dinghyEvent.individualQuestion}}</span> <span class="label label-danger" ng-hide="vm.dinghyEvent.individualQuestion != null && vm.dinghyEvent.individualQuestion != \'\'">Nein</span></td></tr></table></div></div></div><div class="col-md-6"><div class="panel panel-default"><div class="panel-heading"><h3 class="panel-title">Einstellungen</h3></div><div class="panel-body"><table class="table no-border"><tr><td><b>Aktiv</b></td><td><span class="label label-success" ng-show="vm.dinghyEvent.active">Ja</span> <span class="label label-danger" ng-show="!vm.dinghyEvent.active">Nein</span></td></tr><tr><td><b>Sichtbar</b></td><td><span class="label label-success" ng-show="vm.dinghyEvent.visible">Ja</span> <span class="label label-danger" ng-show="!vm.dinghyEvent.visible">Nein</span></td></tr><tr><td><b>Warteliste</b></td><td><span class="label label-success" ng-show="vm.dinghyEvent.allowQueue">Ja</span> <span class="label label-danger" ng-show="!vm.dinghyEvent.allowQueue">Nein</span></td></tr><tr><td><b>Gastmitglieder</b></td><td><span class="label label-success" ng-show="vm.dinghyEvent.allowGuests">Ja</span> <span class="label label-danger" ng-show="!vm.dinghyEvent.allowGuests">Nein</span></td></tr><tr><td><b>Abgeschlossen</b></td><td><span class="label label-success" ng-show="vm.dinghyEvent.closed">Ja</span> <span class="label label-danger" ng-show="!vm.dinghyEvent.closed">Nein</span></td></tr><tr><td><b>Abgesagt</b></td><td><span class="label label-success" ng-show="vm.dinghyEvent.canceled">Ja</span> <span class="label label-danger" ng-show="!vm.dinghyEvent.canceled">Nein</span></td></tr></table></div></div><div style="margin-bottom: 20px"><button type="button" ui-sref="board.dinghy.event.detail.edit({id: vm.dinghyEvent.id})" class="btn btn-md btn-primary"><span class="glyphicon glyphicon-pencil"></span> <span class="hidden-sm-down" data-translate="entity.action.edit">Edit</span></button> <button type="submit" ui-sref="board.dinghy.event.detail.cancel({id: vm.dinghyEvent.id})" class="btn btn-md btn-warning" ng-disabled="vm.dinghyEvent.canceled == true || vm.dinghyEvent.closed == true"><span class="glyphicon glyphicon-remove-circle"></span>&nbsp;<span data-translate="askApp.dinghyEvent.cancel">Cancel</span></button> <button type="submit" ui-sref="board.dinghy.event.detail.delete({id: vm.dinghyEvent.id})" class="btn btn-md btn-danger" ng-disabled="vm.dinghyEvent.hasRelations == true"><span class="glyphicon glyphicon-remove-circle"></span>&nbsp;<span data-translate="entity.action.delete">Delete</span></button></div></div></div></div><div class="row row-no-padding-nested" ng-hide="!vm.dinghyEvent.description && !vm.dinghyEvent.conditions"><div class="col-md-12"><div class="panel panel-default" ng-show="vm.dinghyEvent.description"><div class="panel-heading"><h3 class="panel-title">Beschreibung</h3></div><div class="panel-body"><div ng-bind-html="renderHtml(vm.dinghyEvent.description)" style="text-align: justify"></div></div></div><div class="panel panel-default" ng-show="vm.dinghyEvent.conditions"><div class="panel-heading"><h3 class="panel-title">Bedingungen</h3></div><div class="panel-body"><div ng-bind-html="renderHtml(vm.dinghyEvent.conditions)" style="text-align: justify"></div></div></div></div></div><!--<button type="submit"\n            ui-sref="{{ vm.previousState }}"\n            class="btn btn-info">\n        <span class="glyphicon glyphicon-arrow-left"></span>&nbsp;<span data-translate="entity.action.back"> Back</span>\n    </button>--></div><script type="text/ng-template" id="popover-partial.html"><div>\n        <span class="label label-success" style="width: 100%;"><span data-translate="askApp.EnumBookingStatusType.angemeldet"></span>:&nbsp;{{vm.dinghyEvent.bookedPlaces.countAngemeldet}}</span>\n        <br>\n        <span class="label label-danger"><span data-translate="askApp.EnumBookingStatusType.zurueckgetreten"></span>:&nbsp;{{vm.dinghyEvent.bookedPlaces.countZurueckgetreten}}</span>\n        <br>\n        <span class="label label-danger"><span data-translate="askApp.EnumBookingStatusType.abgelehnt"></span>:&nbsp;{{vm.dinghyEvent.bookedPlaces.countAbgelehnt}}</span>\n        <br>\n        <span class="label label-warning"><span data-translate="askApp.EnumBookingStatusType.warteliste"></span>:&nbsp;{{vm.dinghyEvent.bookedPlaces.countWarteliste}}</span>\n        <br>\n        <span class="label label-info">Pl\xE4tze:&nbsp;{{vm.dinghyEvent.placeCount}}</span>\n        <br>\n        <span class="label label-info">G\xFCltige&nbsp;Anmeldungen:&nbsp;{{vm.validPlaces}}</span>\n        <br>\n        <span class="label label-info" ng-show="vm.dinghyEvent.freePlaces >= 0">Freie&nbsp;Pl\xE4tze:&nbsp;{{vm.dinghyEvent.freePlaces}}</span>\n        <span class="label label-info" ng-show="vm.dinghyEvent.freePlaces < 0">&Uuml;berbuchte&nbsp;Pl\xE4tze:&nbsp;{{-vm.dinghyEvent.freePlaces}}</span>\n    </div></script>');
$templateCache.put('app/board/dinghy/event/detail/newsletter/dinghy-event-newsletter.html','<!--\n  ~ Copyright (c) 2017 by Julian Feder, julian.feder@yahoo.de\n  ~\n  ~ This product includes software developed at\n  ~ The Apache Software Foundation (http://www.apache.org/).\n  --><div class="notes"><div class="panel panel-default"><div class="panel-heading"><h3 class="panel-title" data-translate="askApp.dinghyEvent.detail.newsletterTitle"></h3></div><div class="panel-body"><div class="row"><div class="member-management-detail-table"><div class="col-md-12"><form name="editForm" role="form" novalidate show-validation><jhi-alert></jhi-alert><div class="form-group" ng-init="vm.sendMail.selection = \'alle\'"><label class="control-label" data-translate="askApp.memberManagement.mail.selection">Description</label><div class="btn-group btn-group-justified"><label class="btn btn-default" ng-model="vm.sendMail.selection" uib-btn-radio="\'alle\'"><span data-translate="askApp.project.mail.alle">normal</span></label><label class="btn btn-default" ng-model="vm.sendMail.selection" uib-btn-radio="\'project_angemeldet\'"><span data-translate="askApp.project.mail.angemeldet">guest</span></label><label class="btn btn-default" ng-model="vm.sendMail.selection" uib-btn-radio="\'project_warteliste\'"><span data-translate="askApp.project.mail.warteliste">guest</span></label></div></div><div class="form-group"><label class="control-label" data-translate="askApp.memberManagement.mail.replyToName">Description</label><input type="text" class="form-control" ng-model="vm.sendMail.replyToName" name="replyToName" placeholder="{{vm.currentAccount.firstName}} {{vm.currentAccount.lastName}}"></div><div class="form-group"><label class="control-label" data-translate="askApp.memberManagement.mail.replyToMail">Description</label><input type="email" class="form-control" ng-model="vm.sendMail.replyToMail" name="replyToMail" placeholder="{{vm.contactMail}}"><div ng-show="editForm.replyToMail.$dirty && editForm.replyToMail.$invalid"><p class="help-block" ng-show="editForm.replyToMail.$error.email" data-translate="entity.validation.invalid">Your email is invalid.</p></div></div><div class="form-group"><label class="control-label" data-translate="askApp.memberManagement.mail.subject">Description</label><input type="text" class="form-control" ng-model="vm.sendMail.subject" name="subject" required><div ng-show="editForm.subject.$invalid"><p class="help-block" ng-show="editForm.subject.$error.required" data-translate="entity.validation.required">This field is required.</p></div></div><div class="alert alert-info" role="alert">Die <b>Mail</b> wird <b>individuell</b> an alle Adressaten verschickt. Eine <b>Begr&uuml;&szlig;ung</b> ist daher <b>nicht n\xF6tig.</b><br>Au&szlig;erdem kannst Du die <b>E-Mail</b> in der <b>Du-Form</b> verfassen.<br>Du kannst &uuml;ber den Button <b>"Test E-Mail"</b> auch eine <b>Probemail an Dich</b> selbst senden.</div><div class="form-group"><label class="control-label" data-translate="askApp.memberManagement.mail.text">Description</label><summernote config="vm.options" ng-model="vm.sendMail.text" id="field_description"></summernote></div><div class="modal-footer" style="padding:0; border: 0"><button type="submit" ng-disabled="vm.isSaving || editForm.$invalid" class="btn btn-danger" ng-click="vm.action(\'send\')"><span data-translate="askApp.memberManagement.mail.sendMail">Ausschlie\xDFen</span></button> <button type="submit" ng-disabled="vm.isSaving || editForm.$invalid" class="btn btn-info" ng-click="vm.action(\'test\')"><span data-translate="askApp.memberManagement.mail.testMail">Ausschlie\xDFen</span></button></div></form></div></div></div></div></div></div>');
$templateCache.put('app/board/dinghy/event/detail/payments/payment-dialog.html','<!--\n  ~ Copyright (c) 2021 by Felix Heim, felix-heim@web.de\n  ~\n  ~ This product includes software developed at\n  ~ The Apache Software Foundation (http://www.apache.org/).\n  --><form name="editForm" role="form" novalidate ng-submit="vm.save()" show-validation><div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()">&times;</button><h4 class="modal-title" id="myPaymentLabel" data-translate="askApp.payment.home.editLabel" translate-value-name="{{vm.payment.name}}" translate-value-date="{{vm.payment.date | date:\'dd.MM.yyyy\'}}">Create or edit a Payment</h4></div><div class="modal-body"><jhi-alert-error></jhi-alert-error><div class="form-group"><label class="control-label" data-translate="askApp.payment.revenueID" for="field_revenueID">Revenue ID</label><input type="text" class="form-control" name="revenueID" id="field_revenueID" ng-model="vm.payment.id" required readonly="readonly"></div><div class="form-group" ng-if="vm.payment.parent !== null"><label class="control-label" data-translate="askApp.payment.parent">Parent</label><div><a ui-sref="board.dinghy.event.detail.payments.edit({paymentId:vm.payment.parent.id})" ng-click="$close()"><span data-translate="askApp.payment.home.parentLabel" translate-value-name="{{vm.payment.parent.name}}" translate-value-date="{{vm.payment.parent.date | date:\'dd.MM.yyyy\'}}"></span>,&nbsp;<span data-translate="askApp.payment.amount"></span>:&nbsp;{{vm.payment.parent.amount | number: 2}}&nbsp;&euro;</a></div></div><div class="form-group"><label class="control-label" data-translate="askApp.payment.amount" for="field_amount">Amount</label><input type="number" class="form-control" name="amount" id="field_amount" ng-model="vm.payment.amount" ng-disabled="!vm.amountEditable"><!--min="-{{vm.maxAmount}}"\n                   max="{{vm.maxAmount}}"--><div ng-show="editForm.amount.$invalid"><p class="help-block" ng-show="editForm.amount.$error.required" data-translate="entity.validation.required">This field is required.</p><p class="help-block" ng-show="editForm.amount.$error.number" data-translate="entity.validation.number">This field should be a number.</p><p class="help-block" ng-show="editForm.amount.$error.max" data-translate="entity.validation.max" translate-value-max="{{vm.maxAmount}}">This field should be at least 0.</p></div></div><div class="form-group" ng-if="vm.payment.parent !== null"><label class="control-label" data-translate="askApp.payment.amountEditable" for="field_closed">Amount Editable</label><br><switch id="field_closed" ng-model="vm.amountEditable" class="green"></switch></div><div class="form-group"><label class="control-label" data-translate="askApp.payment.reference" for="field_reference">reference</label><input type="text" class="form-control" name="reference" id="field_reference" ng-model="vm.payment.reference" readonly="readonly"></div><div class="form-group"><label class="control-label" data-translate="askApp.payment.category" for="field_category">Category</label><select class="form-control" name="category" ng-model="vm.payment.category" id="field_category"><option value=""></option><option value="Teilnahmebeitrag" data-translate="askApp.EnumPaymentCategory.Teilnahmebeitrag">Teilnahmebeitrag</option><option value="Charter" data-translate="askApp.EnumPaymentCategory.Charter">Charter</option><option value="Meldegeld" data-translate="askApp.EnumPaymentCategory.Meldegeld">Meldegeld</option><option value="Pruefungsgebuehr" data-translate="askApp.EnumPaymentCategory.Pruefungsgebuehr">Pruefungsgebuehr</option><option value="Kautionversicherung" data-translate="askApp.EnumPaymentCategory.Kautionversicherung">Kautionversicherung</option><option value="Unterkunft" data-translate="askApp.EnumPaymentCategory.Unterkunft">Unterkunft</option><option value="Skipperhaftpflicht" data-translate="askApp.EnumPaymentCategory.Skipperhaftpflicht">Skipperhaftpflicht</option><option value="Uebungsleiterverguetung" data-translate="askApp.EnumPaymentCategory.Uebungsleiterverguetung">Uebungsleiterverguetung</option><option value="Bordkassenzuschuss" data-translate="askApp.EnumPaymentCategory.Bordkassenzuschuss">Bordkassenzuschuss</option><option value="Merch" data-translate="askApp.EnumPaymentCategory.Merch">Merch</option><option value="Verpflegung" data-translate="askApp.EnumPaymentCategory.Verpflegung">Verpflegung</option><option value="StadtmobilP" data-translate="askApp.EnumPaymentCategory.StadtmobilP">StadtmobilP</option><option value="StadtmobilTN" data-translate="askApp.EnumPaymentCategory.StadtmobilTN">StadtmobilTN</option><option value="Druckkosten" data-translate="askApp.EnumPaymentCategory.Druckkosten">Druckkosten</option><option value="Sonstiges" data-translate="askApp.EnumPaymentCategory.Sonstiges">Sonstiges</option></select></div><div class="form-group"><label class="control-label" data-translate="askApp.payment.comment" for="field_comment">Comment</label><input type="text" class="form-control" name="comment" id="field_comment" ng-model="vm.payment.comment"></div><div class="form-group"><label class="control-label" data-translate="askApp.payment.dept" for="field_dept">Dept</label><input type="text" ng-model="vm.payment.dept" placeholder="Suche Forderung" id="field_dept" uib-typeahead="dept as (dept.reference + \' // \' + dept.profile.user.firstName + \' \' + dept.profile.user.lastName + (dept.profile.nickname ? (\' &quot;\' + dept.profile.nickname + \'&quot;\') : (\'\')) + \' // \' + dept.relation + \' // \' + (dept.amount | number:2) + \'\u20AC\' + \' // \' + (dept.date | date:mediumDate)) for dept in vm.getDept($viewValue)" typeahead-loading="loadingLocations" typeahead-no-results="noResults" class="form-control" autocomplete="off"></div></div><div class="modal-footer"><button type="button" class="btn btn-default" data-dismiss="modal" ng-click="vm.clear()"><span class="glyphicon glyphicon-ban-circle"></span>&nbsp;<span data-translate="entity.action.cancel">Cancel</span></button> <button type="button" ng-disabled="vm.isSaving" ng-if="vm.payment.type !== \'KOPIE\'" class="btn btn-warning" ng-click="vm.copyPayment()"><span class="glyphicon glyphicon-copy"></span>&nbsp;Kopieren</button> <button type="submit" ng-disabled="editForm.$invalid || vm.isSaving" class="btn btn-primary"><span class="glyphicon glyphicon-save"></span>&nbsp;<span data-translate="entity.action.save">Save</span></button></div></form>');
$templateCache.put('app/board/dinghy/event/detail/payments/payments.html','<!--\n  ~ Copyright (c) 2021 by Felix Heim, felix-heim@web.de\n  ~\n  ~ This product includes software developed at\n  ~ The Apache Software Foundation (http://www.apache.org/).\n  --><div><div class="panel panel-default"><div class="panel-heading"><h3 class="panel-title" data-translate="askApp.dinghyEvent.detail.paymentsTitleDetail" translate-value-reference="{{vm.dinghyEvent.identifierFormatted}}"></h3></div><div class="panel-body"><jhi-alert></jhi-alert><div class="container-fluid"><div class="row"><div class="col-xs-12 col-md-6 no-padding-left"><button class="btn btn-primary" ng-click="vm.dataExport()" ng-disabled="vm.bookings.length == 0 || vm.isSaving" analytics-on analytics-event="Projektbogen exportiert"><span class="glyphicon glyphicon-export"></span> <span class="hidden-xs-down">Projektbogen exportieren</span></button> &nbsp;<div class="btn-group"><button type="submit" ng-click="vm.setType(\'all\')" class="btn btn-default btn-md" ng-class="{active: vm.type === \'all\'}"><span class="hidden-sm-down">Alle</span></button> <button type="submit" ng-click="vm.setType(\'no_fees\')" class="btn btn-default btn-md" ng-class="{active: vm.type == \'no_fees\'}"><span class="hidden-sm-down">Ohne Beitr\xE4ge</span></button></div></div><div class="col-xs-12 col-md-6 no-padding-right no-padding-left row-margin-top" ng-show="vm.status"><span class="label label-success"><span data-translate="askApp.EnumBookingStatusType.angemeldet"></span>:&nbsp;{{vm.status.countAngemeldet}}</span> <span class="label label-danger"><span data-translate="askApp.EnumBookingStatusType.zurueckgetreten"></span>:&nbsp;{{vm.status.countZurueckgetreten}}</span> <span class="label label-danger"><span data-translate="askApp.EnumBookingStatusType.abgelehnt"></span>:&nbsp;{{vm.status.countAbgelehnt}}</span> <span class="label label-warning"><span data-translate="askApp.EnumBookingStatusType.warteliste"></span>:&nbsp;{{vm.status.countWarteliste}}</span><br><span class="label label-info">Pl\xE4tze:&nbsp;{{vm.dinghyEvent.placeCount}}</span> <span class="label label-info">G\xFCltige&nbsp;Anmeldungen:&nbsp;{{vm.validPlaces}}</span> <span class="label label-info" ng-show="vm.freePlaces >= 0">Freie&nbsp;Pl\xE4tze:&nbsp;{{vm.freePlaces}}</span> <span class="label label-info" ng-show="vm.freePlaces < 0">&Uuml;berbuchte&nbsp;Pl\xE4tze:&nbsp;{{-vm.freePlaces}}</span></div></div></div><br><div class="alert alert-info" role="alert" ng-show="vm.payments.length == 0"><b>Keine Daten vorhanden!</b> Bisher existieren keine zugeordneten Zahlungen f&uuml;r dieses Jollenevent.</div><div class="table-responsive" ng-show="vm.payments.length > 0"><table class="jh-table table"><thead><tr><th><span data-translate="askApp.payment.date">Date</span></th><th colspan="2"><span data-translate="askApp.payment.amount">Amount</span></th><th><span data-translate="askApp.payment.reference">Reference</span></th><th><span data-translate="askApp.payment.category">Category</span></th><th>Mitglied</th><th has-authority="ROLE_FINANCE"></th></tr></thead><tbody><tr ng-repeat="payment in vm.payments track by payment.id"><td>{{payment.date | date:\'dd.MM.yyyy\'}}</td><td ng-if="payment.amount < 0" style="text-align: right; color: darkred">-&nbsp;{{vm.abs(payment.amount) | number: 2}}&nbsp;&euro;</td><td></td><td ng-if="payment.amount >= 0" style="text-align: left; color: darkgreen">+&nbsp;{{payment.amount | number: 2}}&nbsp;&euro;</td><td>{{payment.reference | limitTo:15}}{{payment.reference.length > 15 ? \'...\' : \'\'}} <span class="glyphicon glyphicon-info-sign" aria-hidden="true" uib-popover="{{payment.reference}}" popover-trigger="mouseenter" style="cursor: pointer" ng-show="payment.reference.length > 15"></span></td><td><span data-translate="{{\'askApp.EnumPaymentCategory.\' + payment.category}}"></span></td><td><a ng-if="payment.user" ui-sref="member-management-detail({id:payment.user.id})">{{payment.user.firstName}} {{payment.user.lastName}} </a><span ng-if="payment.user.nickname" class="glyphicon glyphicon-info-sign" aria-hidden="true" popover-trigger="mouseenter" uib-popover="{{payment.user.nickname}}" style="cursor: pointer"></span></td><td has-authority="ROLE_FINANCE"><button type="submit" ui-sref="board.dinghy.event.detail.payments.edit({paymentId:payment.id})" ng-disabled="vm.dinghyEvent.closed" class="btn btn-primary btn-xs"><span class="glyphicon glyphicon-pencil"></span></button></td></tr><tr><td>Summen:</td><td style="text-align: right; color: darkred">-&nbsp;{{-vm.sumNegative | number: 2}}&nbsp;&euro;</td><td style="text-align: left; color: darkgreen">+&nbsp;{{vm.sumPositive | number: 2}}&nbsp;&euro;</td><td ng-if="vm.totalSum < 0" style="text-align: left; color: darkred">=&nbsp;-{{vm.abs(vm.totalSum) | number: 2}}&nbsp;&euro;</td><td ng-if="vm.totalSum >= 0" style="text-align: left; color: darkgreen">=&nbsp;+{{vm.totalSum | number: 2}}&nbsp;&euro;</td><td></td><td></td><td has-authority="ROLE_FINANCE"></td></tr></tbody></table></div></div></div></div>');}]);})();